(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefeb0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefeb0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4n6uQ", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $32ee597964276f0d$export$ffb0004e005737fa; }, function (v) { return $32ee597964276f0d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $32ee597964276f0d$export$34b9dba7ce09269b; }, function (v) { return $32ee597964276f0d$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $32ee597964276f0d$export$25062201e9e25d76; }, function (v) { return $32ee597964276f0d$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $32ee597964276f0d$export$ffb0004e005737fa;
var $32ee597964276f0d$export$34b9dba7ce09269b;
var $32ee597964276f0d$export$25062201e9e25d76;
"use strict";
parcelRequire("lgnl8");

var $17VE6 = parcelRequire("17VE6");
var $32ee597964276f0d$var$g = 60103;
$32ee597964276f0d$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $32ee597964276f0d$var$h = Symbol.for;
    $32ee597964276f0d$var$g = $32ee597964276f0d$var$h("react.element");
    $32ee597964276f0d$export$ffb0004e005737fa = $32ee597964276f0d$var$h("react.fragment");
}
var $32ee597964276f0d$var$m = $17VE6.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $32ee597964276f0d$var$n = Object.prototype.hasOwnProperty, $32ee597964276f0d$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $32ee597964276f0d$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$32ee597964276f0d$var$n.call(a, b) && !$32ee597964276f0d$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $32ee597964276f0d$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $32ee597964276f0d$var$m.current
    };
}
$32ee597964276f0d$export$34b9dba7ce09269b = $32ee597964276f0d$var$q;
$32ee597964276f0d$export$25062201e9e25d76 = $32ee597964276f0d$var$q;

});
parcelRegister("lgnl8", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $f7ad32673dc7a8e6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f7ad32673dc7a8e6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f7ad32673dc7a8e6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $f7ad32673dc7a8e6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $f7ad32673dc7a8e6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $f7ad32673dc7a8e6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $f7ad32673dc7a8e6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($f7ad32673dc7a8e6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($f7ad32673dc7a8e6$var$getOwnPropertySymbols) {
            symbols = $f7ad32673dc7a8e6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($f7ad32673dc7a8e6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("17VE6", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lcm82"));

});
parcelRegister("lcm82", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $03fb8be85ea30716$export$ffb0004e005737fa; }, function (v) { return $03fb8be85ea30716$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $03fb8be85ea30716$export$5f8d39834fd61797; }, function (v) { return $03fb8be85ea30716$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $03fb8be85ea30716$export$e2c29f18771995cb; }, function (v) { return $03fb8be85ea30716$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $03fb8be85ea30716$export$74bf444e3cd11ea5; }, function (v) { return $03fb8be85ea30716$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $03fb8be85ea30716$export$dca3b0875bd9a954; }, function (v) { return $03fb8be85ea30716$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $03fb8be85ea30716$export$16fa2f45be04daa8; }, function (v) { return $03fb8be85ea30716$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $03fb8be85ea30716$export$221d75b3f55bb0bd; }, function (v) { return $03fb8be85ea30716$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $03fb8be85ea30716$export$ae55be85d98224ed; }, function (v) { return $03fb8be85ea30716$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $03fb8be85ea30716$export$e530037191fcd5d7; }, function (v) { return $03fb8be85ea30716$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $03fb8be85ea30716$export$fd42f52fd3ae1109; }, function (v) { return $03fb8be85ea30716$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $03fb8be85ea30716$export$c8a8987d4410bf2d; }, function (v) { return $03fb8be85ea30716$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $03fb8be85ea30716$export$d38cd72104c1f0e9; }, function (v) { return $03fb8be85ea30716$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $03fb8be85ea30716$export$7d1e3a5e95ceca43; }, function (v) { return $03fb8be85ea30716$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $03fb8be85ea30716$export$257a8862b851cb5b; }, function (v) { return $03fb8be85ea30716$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $03fb8be85ea30716$export$a8257692ac88316c; }, function (v) { return $03fb8be85ea30716$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $03fb8be85ea30716$export$488013bae63b21da; }, function (v) { return $03fb8be85ea30716$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $03fb8be85ea30716$export$7c73462e0d25e514; }, function (v) { return $03fb8be85ea30716$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $03fb8be85ea30716$export$35808ee640e87ca7; }, function (v) { return $03fb8be85ea30716$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $03fb8be85ea30716$export$fae74005e78b1a27; }, function (v) { return $03fb8be85ea30716$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $03fb8be85ea30716$export$dc8fbce3eb94dc1e; }, function (v) { return $03fb8be85ea30716$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $03fb8be85ea30716$export$6d9c69b0de29b591; }, function (v) { return $03fb8be85ea30716$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $03fb8be85ea30716$export$d5a552a76deda3c2; }, function (v) { return $03fb8be85ea30716$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $03fb8be85ea30716$export$e5c5a5f917a5871c; }, function (v) { return $03fb8be85ea30716$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $03fb8be85ea30716$export$1538c33de8887b59; }, function (v) { return $03fb8be85ea30716$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $03fb8be85ea30716$export$13e3392192263954; }, function (v) { return $03fb8be85ea30716$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $03fb8be85ea30716$export$b8f5890fc79d6aca; }, function (v) { return $03fb8be85ea30716$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $03fb8be85ea30716$export$60241385465d0a34; }, function (v) { return $03fb8be85ea30716$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $03fb8be85ea30716$export$83d89fbfd8236492; }, function (v) { return $03fb8be85ea30716$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $l6pW7 = parcelRequire("l6pW7");
var $03fb8be85ea30716$export$ffb0004e005737fa;
var $03fb8be85ea30716$export$5f8d39834fd61797;
var $03fb8be85ea30716$export$e2c29f18771995cb;
var $03fb8be85ea30716$export$74bf444e3cd11ea5;
var $03fb8be85ea30716$export$dca3b0875bd9a954;
var $03fb8be85ea30716$export$16fa2f45be04daa8;
var $03fb8be85ea30716$export$221d75b3f55bb0bd;
var $03fb8be85ea30716$export$ae55be85d98224ed;
var $03fb8be85ea30716$export$e530037191fcd5d7;
var $03fb8be85ea30716$export$fd42f52fd3ae1109;
var $03fb8be85ea30716$export$c8a8987d4410bf2d;
var $03fb8be85ea30716$export$d38cd72104c1f0e9;
var $03fb8be85ea30716$export$7d1e3a5e95ceca43;
var $03fb8be85ea30716$export$257a8862b851cb5b;
var $03fb8be85ea30716$export$a8257692ac88316c;
var $03fb8be85ea30716$export$488013bae63b21da;
var $03fb8be85ea30716$export$7c73462e0d25e514;
var $03fb8be85ea30716$export$35808ee640e87ca7;
var $03fb8be85ea30716$export$fae74005e78b1a27;
var $03fb8be85ea30716$export$dc8fbce3eb94dc1e;
var $03fb8be85ea30716$export$6d9c69b0de29b591;
var $03fb8be85ea30716$export$d5a552a76deda3c2;
var $03fb8be85ea30716$export$e5c5a5f917a5871c;
var $03fb8be85ea30716$export$1538c33de8887b59;
var $03fb8be85ea30716$export$13e3392192263954;
var $03fb8be85ea30716$export$b8f5890fc79d6aca;
var $03fb8be85ea30716$export$60241385465d0a34;
var $03fb8be85ea30716$export$83d89fbfd8236492;
"use strict";

var $lgnl8 = parcelRequire("lgnl8");
var $03fb8be85ea30716$var$n = 60103, $03fb8be85ea30716$var$p = 60106;
$03fb8be85ea30716$export$ffb0004e005737fa = 60107;
$03fb8be85ea30716$export$5f8d39834fd61797 = 60108;
$03fb8be85ea30716$export$e2c29f18771995cb = 60114;
var $03fb8be85ea30716$var$q = 60109, $03fb8be85ea30716$var$r = 60110, $03fb8be85ea30716$var$t = 60112;
$03fb8be85ea30716$export$74bf444e3cd11ea5 = 60113;
var $03fb8be85ea30716$var$u = 60115, $03fb8be85ea30716$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $03fb8be85ea30716$var$w = Symbol.for;
    $03fb8be85ea30716$var$n = $03fb8be85ea30716$var$w("react.element");
    $03fb8be85ea30716$var$p = $03fb8be85ea30716$var$w("react.portal");
    $03fb8be85ea30716$export$ffb0004e005737fa = $03fb8be85ea30716$var$w("react.fragment");
    $03fb8be85ea30716$export$5f8d39834fd61797 = $03fb8be85ea30716$var$w("react.strict_mode");
    $03fb8be85ea30716$export$e2c29f18771995cb = $03fb8be85ea30716$var$w("react.profiler");
    $03fb8be85ea30716$var$q = $03fb8be85ea30716$var$w("react.provider");
    $03fb8be85ea30716$var$r = $03fb8be85ea30716$var$w("react.context");
    $03fb8be85ea30716$var$t = $03fb8be85ea30716$var$w("react.forward_ref");
    $03fb8be85ea30716$export$74bf444e3cd11ea5 = $03fb8be85ea30716$var$w("react.suspense");
    $03fb8be85ea30716$var$u = $03fb8be85ea30716$var$w("react.memo");
    $03fb8be85ea30716$var$v = $03fb8be85ea30716$var$w("react.lazy");
}
var $03fb8be85ea30716$var$x = "function" === typeof Symbol && Symbol.iterator;
function $03fb8be85ea30716$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $03fb8be85ea30716$var$x && a[$03fb8be85ea30716$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $03fb8be85ea30716$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $03fb8be85ea30716$var$A = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $03fb8be85ea30716$var$B = {};
function $03fb8be85ea30716$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $03fb8be85ea30716$var$B;
    this.updater = c || $03fb8be85ea30716$var$A;
}
$03fb8be85ea30716$var$C.prototype.isReactComponent = {};
$03fb8be85ea30716$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($03fb8be85ea30716$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$03fb8be85ea30716$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $03fb8be85ea30716$var$D() {}
$03fb8be85ea30716$var$D.prototype = $03fb8be85ea30716$var$C.prototype;
function $03fb8be85ea30716$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $03fb8be85ea30716$var$B;
    this.updater = c || $03fb8be85ea30716$var$A;
}
var $03fb8be85ea30716$var$F = $03fb8be85ea30716$var$E.prototype = new $03fb8be85ea30716$var$D;
$03fb8be85ea30716$var$F.constructor = $03fb8be85ea30716$var$E;
$lgnl8($03fb8be85ea30716$var$F, $03fb8be85ea30716$var$C.prototype);
$03fb8be85ea30716$var$F.isPureReactComponent = !0;
var $03fb8be85ea30716$var$G = {
    current: null
}, $03fb8be85ea30716$var$H = Object.prototype.hasOwnProperty, $03fb8be85ea30716$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $03fb8be85ea30716$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$03fb8be85ea30716$var$H.call(b, e) && !$03fb8be85ea30716$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $03fb8be85ea30716$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $03fb8be85ea30716$var$G.current
    };
}
function $03fb8be85ea30716$var$K(a, b) {
    return {
        $$typeof: $03fb8be85ea30716$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $03fb8be85ea30716$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $03fb8be85ea30716$var$n;
}
function $03fb8be85ea30716$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $03fb8be85ea30716$var$M = /\/+/g;
function $03fb8be85ea30716$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $03fb8be85ea30716$var$escape("" + a.key) : b.toString(36);
}
function $03fb8be85ea30716$var$O(a, b, c, e, d) {
    var k = typeof a === "undefined" ? "undefined" : (0, $l6pW7._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $03fb8be85ea30716$var$n:
                case $03fb8be85ea30716$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $03fb8be85ea30716$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($03fb8be85ea30716$var$M, "$&/") + "/"), $03fb8be85ea30716$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($03fb8be85ea30716$var$L(d) && (d = $03fb8be85ea30716$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($03fb8be85ea30716$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $03fb8be85ea30716$var$N(k, g);
        h += $03fb8be85ea30716$var$O(k, b, c, f, d);
    }
    else if (f = $03fb8be85ea30716$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $03fb8be85ea30716$var$N(k, g++), h += $03fb8be85ea30716$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($03fb8be85ea30716$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $03fb8be85ea30716$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $03fb8be85ea30716$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $03fb8be85ea30716$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $03fb8be85ea30716$var$R = {
    current: null
};
function $03fb8be85ea30716$var$S() {
    var a = $03fb8be85ea30716$var$R.current;
    if (null === a) throw Error($03fb8be85ea30716$var$z(321));
    return a;
}
var $03fb8be85ea30716$var$T = {
    ReactCurrentDispatcher: $03fb8be85ea30716$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $03fb8be85ea30716$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $lgnl8
};
$03fb8be85ea30716$export$dca3b0875bd9a954 = {
    map: $03fb8be85ea30716$var$P,
    forEach: function forEach(a, b, c) {
        $03fb8be85ea30716$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function count(a) {
        var b = 0;
        $03fb8be85ea30716$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $03fb8be85ea30716$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$03fb8be85ea30716$var$L(a)) throw Error($03fb8be85ea30716$var$z(143));
        return a;
    }
};
$03fb8be85ea30716$export$16fa2f45be04daa8 = $03fb8be85ea30716$var$C;
$03fb8be85ea30716$export$221d75b3f55bb0bd = $03fb8be85ea30716$var$E;
$03fb8be85ea30716$export$ae55be85d98224ed = $03fb8be85ea30716$var$T;
$03fb8be85ea30716$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($03fb8be85ea30716$var$z(267, a));
    var e = $lgnl8({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $03fb8be85ea30716$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$03fb8be85ea30716$var$H.call(b, f) && !$03fb8be85ea30716$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $03fb8be85ea30716$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$03fb8be85ea30716$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $03fb8be85ea30716$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $03fb8be85ea30716$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$03fb8be85ea30716$export$c8a8987d4410bf2d = $03fb8be85ea30716$var$J;
$03fb8be85ea30716$export$d38cd72104c1f0e9 = function(a) {
    var b = $03fb8be85ea30716$var$J.bind(null, a);
    b.type = a;
    return b;
};
$03fb8be85ea30716$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$03fb8be85ea30716$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $03fb8be85ea30716$var$t,
        render: a
    };
};
$03fb8be85ea30716$export$a8257692ac88316c = $03fb8be85ea30716$var$L;
$03fb8be85ea30716$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $03fb8be85ea30716$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $03fb8be85ea30716$var$Q
    };
};
$03fb8be85ea30716$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $03fb8be85ea30716$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$03fb8be85ea30716$export$35808ee640e87ca7 = function(a, b) {
    return $03fb8be85ea30716$var$S().useCallback(a, b);
};
$03fb8be85ea30716$export$fae74005e78b1a27 = function(a, b) {
    return $03fb8be85ea30716$var$S().useContext(a, b);
};
$03fb8be85ea30716$export$dc8fbce3eb94dc1e = function() {};
$03fb8be85ea30716$export$6d9c69b0de29b591 = function(a, b) {
    return $03fb8be85ea30716$var$S().useEffect(a, b);
};
$03fb8be85ea30716$export$d5a552a76deda3c2 = function(a, b, c) {
    return $03fb8be85ea30716$var$S().useImperativeHandle(a, b, c);
};
$03fb8be85ea30716$export$e5c5a5f917a5871c = function(a, b) {
    return $03fb8be85ea30716$var$S().useLayoutEffect(a, b);
};
$03fb8be85ea30716$export$1538c33de8887b59 = function(a, b) {
    return $03fb8be85ea30716$var$S().useMemo(a, b);
};
$03fb8be85ea30716$export$13e3392192263954 = function(a, b, c) {
    return $03fb8be85ea30716$var$S().useReducer(a, b, c);
};
$03fb8be85ea30716$export$b8f5890fc79d6aca = function(a) {
    return $03fb8be85ea30716$var$S().useRef(a);
};
$03fb8be85ea30716$export$60241385465d0a34 = function(a) {
    return $03fb8be85ea30716$var$S().useState(a);
};
$03fb8be85ea30716$export$83d89fbfd8236492 = "17.0.2";

});
parcelRegister("l6pW7", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $f5ce46eaa7d11e55$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $f5ce46eaa7d11e55$export$5f0017c582d45a2d; });
function $f5ce46eaa7d11e55$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRegister("62qDs", function(module, exports) {
"use strict";
function $4657973e2584a643$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($4657973e2584a643$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$4657973e2584a643$var$checkDCE();

module.exports = (parcelRequire("gS5Hh"));

});
parcelRegister("gS5Hh", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $l6pW7 = parcelRequire("l6pW7");
"use strict";

var $17VE6 = parcelRequire("17VE6");

var $lgnl8 = parcelRequire("lgnl8");

var $27Hvw = parcelRequire("27Hvw");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$17VE6) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $l6pW7._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $17VE6.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $l6pW7._)(a)){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $lgnl8({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $17VE6.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $lgnl8({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $lgnl8({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $lgnl8({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c === "undefined" ? "undefined" : (0, $l6pW7._)(c)));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function get() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function onError(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $27Hvw.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $27Hvw.unstable_scheduleCallback($27Hvw.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $27Hvw.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $27Hvw.unstable_UserBlockingPriority, ed = $27Hvw.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $lgnl8(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $l6pW7._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $l6pW7._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function persist() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $lgnl8({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $lgnl8({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $lgnl8({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $lgnl8({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $lgnl8({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $lgnl8({}, sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $lgnl8({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $lgnl8({}, ud, {
    key: function key(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $lgnl8({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $lgnl8({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $lgnl8({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $lgnl8({}, Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var _$d = f, _$e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = _$d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, _$e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = _$d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = _$d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, _$e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(_$e) === _$d && (w = new w(u, t + "enter", x, c, _$e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = _$d ? ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, _$d))) {
                    ne(g, J, c, _$e);
                    break a;
                }
                K && K(a, h, _$d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = _$d ? ue(_$d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = _$d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, _$e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = _$e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(_$d, L), 0 < K.length && (L = new Ld(L, a, null, c, _$e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) _$d = oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $lgnl8({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $27Hvw.unstable_runWithPriority, Of = $27Hvw.unstable_scheduleCallback, Pf = $27Hvw.unstable_cancelCallback, Qf = $27Hvw.unstable_shouldYield, Rf = $27Hvw.unstable_requestPaint, Sf = $27Hvw.unstable_now, Tf = $27Hvw.unstable_getCurrentPriorityLevel, Uf = $27Hvw.unstable_ImmediatePriority, Vf = $27Hvw.unstable_UserBlockingPriority, Wf = $27Hvw.unstable_NormalPriority, Xf = $27Hvw.unstable_LowPriority, Yf = $27Hvw.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function $f() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function O() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var _$c = b[a];
                    do _$c = _$c(!0);
                    while (null !== _$c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $lgnl8({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $lgnl8({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $17VE6.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $lgnl8({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function b(a) {
                var _$b = d.refs;
                _$b === Fg && (_$b = d.refs = {});
                null === a ? delete _$b[e] : _$b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var _$a = f(b._source);
        if (!He(g, _$a)) {
            _$a = c(b._source);
            He(n, _$a) || (l(_$a), _$a = Ig(w), e.mutableReadLanes |= _$a & e.pendingLanes);
            _$a = e.mutableReadLanes;
            e.entangledLanes |= _$a;
            for(var _$d = e.entanglements, h = _$a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                _$d[k] |= _$a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var _$a = p.getSnapshot, _$c = p.setSnapshot;
            try {
                _$c(_$a(b._source));
                var _$d = Ig(w);
                e.mutableReadLanes |= _$d & e.pendingLanes;
            } catch (q) {
                _$c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function useCallback(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function useTransition() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function useMutableSource(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function useOpaqueIdentifier() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function useState() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function useTransition() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function useOpaqueIdentifier() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function useState() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function useTransition() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function useOpaqueIdentifier() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function Bi(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function Ci() {};
Di = function Di(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $lgnl8({}, e, {
                    value: void 0
                });
                d = $lgnl8({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function Ei(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $lgnl8({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function ck(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $l6pW7._)(a), ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = mk(g);
                h.call(_$a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function e() {
                var _$a = mk(g);
                k.call(_$a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function ec(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function fc(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function gc(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function hc(a, b) {
    return b();
};
yb = function yb(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function Hb(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function Ib() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function Jb(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("27Hvw", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1FKbH"));

});
parcelRegister("1FKbH", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $137d72b57483143e$export$c4744153514ff05d; }, function (v) { return $137d72b57483143e$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $137d72b57483143e$export$b5836b71941fa3ed; }, function (v) { return $137d72b57483143e$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $137d72b57483143e$export$d66a1c1c77bd778b; }, function (v) { return $137d72b57483143e$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $137d72b57483143e$export$3e506c1ccc9cc1a7; }, function (v) { return $137d72b57483143e$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $137d72b57483143e$export$e26fe2ed2fa76875; }, function (v) { return $137d72b57483143e$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $137d72b57483143e$export$502329bbf4b505b1; }, function (v) { return $137d72b57483143e$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $137d72b57483143e$export$6e3807111c4874c4; }, function (v) { return $137d72b57483143e$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $137d72b57483143e$export$c27134553091fb3a; }, function (v) { return $137d72b57483143e$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $137d72b57483143e$export$33ee1acdc04fd2a2; }, function (v) { return $137d72b57483143e$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $137d72b57483143e$export$b00a404bbd5edef2; }, function (v) { return $137d72b57483143e$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $137d72b57483143e$export$8352ce38b91d0c62; }, function (v) { return $137d72b57483143e$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $137d72b57483143e$export$d3dfb8e4810cb555; }, function (v) { return $137d72b57483143e$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $137d72b57483143e$export$839f9183b0465a69; }, function (v) { return $137d72b57483143e$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $137d72b57483143e$export$72fdf0e06517287b; }, function (v) { return $137d72b57483143e$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $137d72b57483143e$export$4b844e58a3e414b4; }, function (v) { return $137d72b57483143e$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $137d72b57483143e$export$816d2913ae6b83b1; }, function (v) { return $137d72b57483143e$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $137d72b57483143e$export$61bcfe829111a1d0; }, function (v) { return $137d72b57483143e$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $137d72b57483143e$export$7ee8c9beb337bc3f; }, function (v) { return $137d72b57483143e$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $137d72b57483143e$export$cf845f2c119da08a; }, function (v) { return $137d72b57483143e$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $137d72b57483143e$export$c4744153514ff05d;
var $137d72b57483143e$export$b5836b71941fa3ed;
var $137d72b57483143e$export$d66a1c1c77bd778b;
var $137d72b57483143e$export$3e506c1ccc9cc1a7;
var $137d72b57483143e$export$e26fe2ed2fa76875;
var $137d72b57483143e$export$502329bbf4b505b1;
var $137d72b57483143e$export$6e3807111c4874c4;
var $137d72b57483143e$export$c27134553091fb3a;
var $137d72b57483143e$export$33ee1acdc04fd2a2;
var $137d72b57483143e$export$b00a404bbd5edef2;
var $137d72b57483143e$export$8352ce38b91d0c62;
var $137d72b57483143e$export$d3dfb8e4810cb555;
var $137d72b57483143e$export$839f9183b0465a69;
var $137d72b57483143e$export$72fdf0e06517287b;
var $137d72b57483143e$export$4b844e58a3e414b4;
var $137d72b57483143e$export$816d2913ae6b83b1;
var $137d72b57483143e$export$61bcfe829111a1d0;
var $137d72b57483143e$export$7ee8c9beb337bc3f;
var $137d72b57483143e$export$cf845f2c119da08a;
"use strict";
var $137d72b57483143e$var$f, $137d72b57483143e$var$g, $137d72b57483143e$var$h, $137d72b57483143e$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $137d72b57483143e$var$l = performance;
    $137d72b57483143e$export$c4744153514ff05d = function() {
        return $137d72b57483143e$var$l.now();
    };
} else {
    var $137d72b57483143e$var$p = Date, $137d72b57483143e$var$q = $137d72b57483143e$var$p.now();
    $137d72b57483143e$export$c4744153514ff05d = function() {
        return $137d72b57483143e$var$p.now() - $137d72b57483143e$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $137d72b57483143e$var$t = null, $137d72b57483143e$var$u = null, $137d72b57483143e$var$w = function w1() {
        if (null !== $137d72b57483143e$var$t) try {
            var a = $137d72b57483143e$export$c4744153514ff05d();
            $137d72b57483143e$var$t(!0, a);
            $137d72b57483143e$var$t = null;
        } catch (b) {
            throw setTimeout($137d72b57483143e$var$w, 0), b;
        }
    };
    $137d72b57483143e$var$f = function(a) {
        null !== $137d72b57483143e$var$t ? setTimeout($137d72b57483143e$var$f, 0, a) : ($137d72b57483143e$var$t = a, setTimeout($137d72b57483143e$var$w, 0));
    };
    $137d72b57483143e$var$g = function g(a, b) {
        $137d72b57483143e$var$u = setTimeout(a, b);
    };
    $137d72b57483143e$var$h = function h() {
        clearTimeout($137d72b57483143e$var$u);
    };
    $137d72b57483143e$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $137d72b57483143e$var$k = $137d72b57483143e$export$d66a1c1c77bd778b = function k() {};
} else {
    var $137d72b57483143e$var$x = window.setTimeout, $137d72b57483143e$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $137d72b57483143e$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $137d72b57483143e$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $137d72b57483143e$var$A = !1, $137d72b57483143e$var$B = null, $137d72b57483143e$var$C = -1, $137d72b57483143e$var$D = 5, $137d72b57483143e$var$E = 0;
    $137d72b57483143e$export$b5836b71941fa3ed = function() {
        return $137d72b57483143e$export$c4744153514ff05d() >= $137d72b57483143e$var$E;
    };
    $137d72b57483143e$var$k = function k() {};
    $137d72b57483143e$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $137d72b57483143e$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $137d72b57483143e$var$F = new MessageChannel, $137d72b57483143e$var$G = $137d72b57483143e$var$F.port2;
    $137d72b57483143e$var$F.port1.onmessage = function() {
        if (null !== $137d72b57483143e$var$B) {
            var a = $137d72b57483143e$export$c4744153514ff05d();
            $137d72b57483143e$var$E = a + $137d72b57483143e$var$D;
            try {
                $137d72b57483143e$var$B(!0, a) ? $137d72b57483143e$var$G.postMessage(null) : ($137d72b57483143e$var$A = !1, $137d72b57483143e$var$B = null);
            } catch (b) {
                throw $137d72b57483143e$var$G.postMessage(null), b;
            }
        } else $137d72b57483143e$var$A = !1;
    };
    $137d72b57483143e$var$f = function f(a) {
        $137d72b57483143e$var$B = a;
        $137d72b57483143e$var$A || ($137d72b57483143e$var$A = !0, $137d72b57483143e$var$G.postMessage(null));
    };
    $137d72b57483143e$var$g = function g(a, b) {
        $137d72b57483143e$var$C = $137d72b57483143e$var$x(function() {
            a($137d72b57483143e$export$c4744153514ff05d());
        }, b);
    };
    $137d72b57483143e$var$h = function h() {
        $137d72b57483143e$var$y($137d72b57483143e$var$C);
        $137d72b57483143e$var$C = -1;
    };
}
function $137d72b57483143e$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $137d72b57483143e$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $137d72b57483143e$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $137d72b57483143e$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $137d72b57483143e$var$I(n, c)) void 0 !== r && 0 > $137d72b57483143e$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $137d72b57483143e$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $137d72b57483143e$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $137d72b57483143e$var$L = [], $137d72b57483143e$var$M = [], $137d72b57483143e$var$N = 1, $137d72b57483143e$var$O = null, $137d72b57483143e$var$P = 3, $137d72b57483143e$var$Q = !1, $137d72b57483143e$var$R = !1, $137d72b57483143e$var$S = !1;
function $137d72b57483143e$var$T(a) {
    for(var b = $137d72b57483143e$var$J($137d72b57483143e$var$M); null !== b;){
        if (null === b.callback) $137d72b57483143e$var$K($137d72b57483143e$var$M);
        else if (b.startTime <= a) $137d72b57483143e$var$K($137d72b57483143e$var$M), b.sortIndex = b.expirationTime, $137d72b57483143e$var$H($137d72b57483143e$var$L, b);
        else break;
        b = $137d72b57483143e$var$J($137d72b57483143e$var$M);
    }
}
function $137d72b57483143e$var$U(a) {
    $137d72b57483143e$var$S = !1;
    $137d72b57483143e$var$T(a);
    if (!$137d72b57483143e$var$R) {
        if (null !== $137d72b57483143e$var$J($137d72b57483143e$var$L)) $137d72b57483143e$var$R = !0, $137d72b57483143e$var$f($137d72b57483143e$var$V);
        else {
            var b = $137d72b57483143e$var$J($137d72b57483143e$var$M);
            null !== b && $137d72b57483143e$var$g($137d72b57483143e$var$U, b.startTime - a);
        }
    }
}
function $137d72b57483143e$var$V(a, b) {
    $137d72b57483143e$var$R = !1;
    $137d72b57483143e$var$S && ($137d72b57483143e$var$S = !1, $137d72b57483143e$var$h());
    $137d72b57483143e$var$Q = !0;
    var c = $137d72b57483143e$var$P;
    try {
        $137d72b57483143e$var$T(b);
        for($137d72b57483143e$var$O = $137d72b57483143e$var$J($137d72b57483143e$var$L); null !== $137d72b57483143e$var$O && (!($137d72b57483143e$var$O.expirationTime > b) || a && !$137d72b57483143e$export$b5836b71941fa3ed());){
            var d = $137d72b57483143e$var$O.callback;
            if ("function" === typeof d) {
                $137d72b57483143e$var$O.callback = null;
                $137d72b57483143e$var$P = $137d72b57483143e$var$O.priorityLevel;
                var e = d($137d72b57483143e$var$O.expirationTime <= b);
                b = $137d72b57483143e$export$c4744153514ff05d();
                "function" === typeof e ? $137d72b57483143e$var$O.callback = e : $137d72b57483143e$var$O === $137d72b57483143e$var$J($137d72b57483143e$var$L) && $137d72b57483143e$var$K($137d72b57483143e$var$L);
                $137d72b57483143e$var$T(b);
            } else $137d72b57483143e$var$K($137d72b57483143e$var$L);
            $137d72b57483143e$var$O = $137d72b57483143e$var$J($137d72b57483143e$var$L);
        }
        if (null !== $137d72b57483143e$var$O) var m = !0;
        else {
            var n = $137d72b57483143e$var$J($137d72b57483143e$var$M);
            null !== n && $137d72b57483143e$var$g($137d72b57483143e$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $137d72b57483143e$var$O = null, $137d72b57483143e$var$P = c, $137d72b57483143e$var$Q = !1;
    }
}
var $137d72b57483143e$var$W = $137d72b57483143e$var$k;
$137d72b57483143e$export$3e506c1ccc9cc1a7 = 5;
$137d72b57483143e$export$e26fe2ed2fa76875 = 1;
$137d72b57483143e$export$502329bbf4b505b1 = 4;
$137d72b57483143e$export$6e3807111c4874c4 = 3;
$137d72b57483143e$export$c27134553091fb3a = null;
$137d72b57483143e$export$33ee1acdc04fd2a2 = 2;
$137d72b57483143e$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$137d72b57483143e$export$8352ce38b91d0c62 = function() {
    $137d72b57483143e$var$R || $137d72b57483143e$var$Q || ($137d72b57483143e$var$R = !0, $137d72b57483143e$var$f($137d72b57483143e$var$V));
};
$137d72b57483143e$export$d3dfb8e4810cb555 = function() {
    return $137d72b57483143e$var$P;
};
$137d72b57483143e$export$839f9183b0465a69 = function() {
    return $137d72b57483143e$var$J($137d72b57483143e$var$L);
};
$137d72b57483143e$export$72fdf0e06517287b = function(a) {
    switch($137d72b57483143e$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $137d72b57483143e$var$P;
    }
    var c = $137d72b57483143e$var$P;
    $137d72b57483143e$var$P = b;
    try {
        return a();
    } finally{
        $137d72b57483143e$var$P = c;
    }
};
$137d72b57483143e$export$4b844e58a3e414b4 = function() {};
$137d72b57483143e$export$816d2913ae6b83b1 = $137d72b57483143e$var$W;
$137d72b57483143e$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $137d72b57483143e$var$P;
    $137d72b57483143e$var$P = a;
    try {
        return b();
    } finally{
        $137d72b57483143e$var$P = c;
    }
};
$137d72b57483143e$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $137d72b57483143e$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $137d72b57483143e$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $137d72b57483143e$var$H($137d72b57483143e$var$M, a), null === $137d72b57483143e$var$J($137d72b57483143e$var$L) && a === $137d72b57483143e$var$J($137d72b57483143e$var$M) && ($137d72b57483143e$var$S ? $137d72b57483143e$var$h() : $137d72b57483143e$var$S = !0, $137d72b57483143e$var$g($137d72b57483143e$var$U, c - d))) : (a.sortIndex = e, $137d72b57483143e$var$H($137d72b57483143e$var$L, a), $137d72b57483143e$var$R || $137d72b57483143e$var$Q || ($137d72b57483143e$var$R = !0, $137d72b57483143e$var$f($137d72b57483143e$var$V)));
    return a;
};
$137d72b57483143e$export$cf845f2c119da08a = function(a) {
    var b = $137d72b57483143e$var$P;
    return function() {
        var c = $137d72b57483143e$var$P;
        $137d72b57483143e$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $137d72b57483143e$var$P = c;
        }
    };
};

});




parcelRegister("7hBys", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $54d7408bde05df7f$export$7c398597f8905a1; });
function $54d7408bde05df7f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $54d7408bde05df7f$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $54d7408bde05df7f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $54d7408bde05df7f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("iCQyW", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $d8f48c73be7235e1$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $d8f48c73be7235e1$export$1e71eb4bef00f6b0; });
function $d8f48c73be7235e1$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("52tJv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3ab434014bf97dcd$export$fdf2a89c76341bbf; });

var $km0OT = parcelRequire("km0OT");

var $holP6 = parcelRequire("holP6");

var $8PKT5 = parcelRequire("8PKT5");

var $ayuXN = parcelRequire("ayuXN");
function $3ab434014bf97dcd$export$fdf2a89c76341bbf(arr, i) {
    return (0, $km0OT._array_with_holes)(arr) || (0, $holP6._iterable_to_array_limit)(arr, i) || (0, $ayuXN._unsupported_iterable_to_array)(arr, i) || (0, $8PKT5._non_iterable_rest)();
}

});
parcelRegister("km0OT", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $ed167f82792fd0c4$export$e6256bf45c68d561; });
function $ed167f82792fd0c4$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("holP6", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $ca959b32573a749c$export$2fd15edff6687200; });
function $ca959b32573a749c$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("8PKT5", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $66e77502a3dcc0c5$export$60dbc22abd7da546; });
function $66e77502a3dcc0c5$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ayuXN", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $7af5190d3308f79c$export$a5be06335b3a083c; });

var $b0fRq = parcelRequire("b0fRq");
function $7af5190d3308f79c$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $b0fRq._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $b0fRq._array_like_to_array)(o, minLen);
}

});
parcelRegister("b0fRq", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $802bff6cd21a9bd2$export$79e617b1955a2616; });
function $802bff6cd21a9bd2$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("ajhIL", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $78196cc1bb3a5835$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $78196cc1bb3a5835$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $l6pW7 = parcelRequire("l6pW7");
var $78196cc1bb3a5835$var$extendStatics = function extendStatics1(d, b) {
    $78196cc1bb3a5835$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $78196cc1bb3a5835$var$extendStatics(d, b);
};
function $78196cc1bb3a5835$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $78196cc1bb3a5835$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $78196cc1bb3a5835$export$18ce0697a983be9b = function __assign1() {
    $78196cc1bb3a5835$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $78196cc1bb3a5835$export$18ce0697a983be9b.apply(this, arguments);
};
function $78196cc1bb3a5835$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $78196cc1bb3a5835$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $78196cc1bb3a5835$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $78196cc1bb3a5835$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $78196cc1bb3a5835$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $78196cc1bb3a5835$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $l6pW7._)(x)) === "symbol" ? x : "".concat(x);
}
function $78196cc1bb3a5835$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $l6pW7._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $78196cc1bb3a5835$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $78196cc1bb3a5835$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $78196cc1bb3a5835$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $78196cc1bb3a5835$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $78196cc1bb3a5835$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $78196cc1bb3a5835$export$45d3717a4c69092e(o, m, p);
}
function $78196cc1bb3a5835$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $78196cc1bb3a5835$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $78196cc1bb3a5835$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($78196cc1bb3a5835$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $78196cc1bb3a5835$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $78196cc1bb3a5835$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $78196cc1bb3a5835$export$10c90e4f7922046c(v) {
    return this instanceof $78196cc1bb3a5835$export$10c90e4f7922046c ? (this.v = v, this) : new $78196cc1bb3a5835$export$10c90e4f7922046c(v);
}
function $78196cc1bb3a5835$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $78196cc1bb3a5835$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $78196cc1bb3a5835$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $78196cc1bb3a5835$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $78196cc1bb3a5835$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $78196cc1bb3a5835$export$19a8beecd37a4c45 === "function" ? $78196cc1bb3a5835$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $78196cc1bb3a5835$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $78196cc1bb3a5835$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $78196cc1bb3a5835$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $78196cc1bb3a5835$export$45d3717a4c69092e(result, mod, k);
    }
    $78196cc1bb3a5835$var$__setModuleDefault(result, mod);
    return result;
}
function $78196cc1bb3a5835$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $78196cc1bb3a5835$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $78196cc1bb3a5835$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $78196cc1bb3a5835$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $78196cc1bb3a5835$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $78196cc1bb3a5835$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $78196cc1bb3a5835$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $78196cc1bb3a5835$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $78196cc1bb3a5835$export$2e2bcd8739ae039 = {
    __extends: $78196cc1bb3a5835$export$a8ba968b8961cb8a,
    __assign: $78196cc1bb3a5835$export$18ce0697a983be9b,
    __rest: $78196cc1bb3a5835$export$3c9a16f847548506,
    __decorate: $78196cc1bb3a5835$export$29e00dfd3077644b,
    __param: $78196cc1bb3a5835$export$d5ad3fd78186038f,
    __metadata: $78196cc1bb3a5835$export$f1db080c865becb9,
    __awaiter: $78196cc1bb3a5835$export$1050f835b63b671e,
    __generator: $78196cc1bb3a5835$export$67ebef60e6f28a6,
    __createBinding: $78196cc1bb3a5835$export$45d3717a4c69092e,
    __exportStar: $78196cc1bb3a5835$export$f33643c0debef087,
    __values: $78196cc1bb3a5835$export$19a8beecd37a4c45,
    __read: $78196cc1bb3a5835$export$8d051b38c9118094,
    __spread: $78196cc1bb3a5835$export$afc72e2116322959,
    __spreadArrays: $78196cc1bb3a5835$export$6388937ca91ccae8,
    __spreadArray: $78196cc1bb3a5835$export$1216008129fb82ed,
    __await: $78196cc1bb3a5835$export$10c90e4f7922046c,
    __asyncGenerator: $78196cc1bb3a5835$export$e427f37a30a4de9b,
    __asyncDelegator: $78196cc1bb3a5835$export$bbd80228419bb833,
    __asyncValues: $78196cc1bb3a5835$export$e3b29a3d6162315f,
    __makeTemplateObject: $78196cc1bb3a5835$export$4fb47efe1390b86f,
    __importStar: $78196cc1bb3a5835$export$c21735bcef00d192,
    __importDefault: $78196cc1bb3a5835$export$da59b14a69baef04,
    __classPrivateFieldGet: $78196cc1bb3a5835$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $78196cc1bb3a5835$export$d40a35129aaff81f,
    __classPrivateFieldIn: $78196cc1bb3a5835$export$81fdc39f203e4e04,
    __addDisposableResource: $78196cc1bb3a5835$export$88ac25d8e944e405,
    __disposeResources: $78196cc1bb3a5835$export$8f076105dc360e92
};

});

parcelRegister("5sFFs", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3f9fe396f95d6bd1$export$2996f80ef42b8419; });
function $3f9fe396f95d6bd1$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("8O2fV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6694be3a54a1613e$export$d60067ff2358eee8; });
function $6694be3a54a1613e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6694be3a54a1613e$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $6694be3a54a1613e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6694be3a54a1613e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("fyztb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b5358b88e8832525$export$1b5e630bc3aea29f; });

var $gLsav = parcelRequire("gLsav");

var $iBN6B = parcelRequire("iBN6B");

var $2D5N1 = parcelRequire("2D5N1");

var $ayuXN = parcelRequire("ayuXN");
function $b5358b88e8832525$export$1b5e630bc3aea29f(arr) {
    return (0, $gLsav._array_without_holes)(arr) || (0, $iBN6B._iterable_to_array)(arr) || (0, $ayuXN._unsupported_iterable_to_array)(arr) || (0, $2D5N1._non_iterable_spread)();
}

});
parcelRegister("gLsav", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $c346e2c6948667cb$export$7e0947b5ad3404e2; });

var $b0fRq = parcelRequire("b0fRq");
function $c346e2c6948667cb$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $b0fRq._array_like_to_array)(arr);
}

});

parcelRegister("iBN6B", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $d8c1c60a00fd7b05$export$1eb58a6e75231000; });
function $d8c1c60a00fd7b05$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("2D5N1", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $1ea3b6fa3b933d9e$export$e6f3c4780d19eb2b; });
function $1ea3b6fa3b933d9e$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("lyFcw", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $fb1cbb95527cc4a2$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $fb1cbb95527cc4a2$export$f3b8ed2e4a5d10b8; });
function $fb1cbb95527cc4a2$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("404BM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2e9abc9edbdfa370$export$afb3516d9d608401; });

var $eru9P = parcelRequire("eru9P");
function $2e9abc9edbdfa370$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $2e9abc9edbdfa370$export$afb3516d9d608401 = Reflect.get;
    else $2e9abc9edbdfa370$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $eru9P._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $2e9abc9edbdfa370$export$afb3516d9d608401(target, property, receiver || target);
}

});
parcelRegister("eru9P", function(module, exports) {

$parcel$export(module.exports, "_super_prop_base", function () { return $a83afaf7399456d3$export$e4187255aefbc259; });

var $cEF31 = parcelRequire("cEF31");
function $a83afaf7399456d3$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $cEF31._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

});
parcelRegister("cEF31", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $93690fb472359f41$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $93690fb472359f41$export$f09211a7d3c496a1; });
function $93690fb472359f41$export$f09211a7d3c496a1(o) {
    $93690fb472359f41$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $93690fb472359f41$export$f09211a7d3c496a1(o);
}

});



parcelRegister("kcqLc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $eb49afaa84c2192e$export$7e4530ad35d3bb8; });

var $e0tMp = parcelRequire("e0tMp");
function $eb49afaa84c2192e$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $e0tMp._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("e0tMp", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $a3282a6ef5be0b0d$export$c2c98ac76e997b63; });
function $a3282a6ef5be0b0d$export$c2c98ac76e997b63(o, p) {
    $a3282a6ef5be0b0d$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a3282a6ef5be0b0d$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("4jYWU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $325837043ccabee7$export$8dd05c13f5255580; });

var $cEF31 = parcelRequire("cEF31");

var $8N1lA = parcelRequire("8N1lA");

var $fSdUO = parcelRequire("fSdUO");
function $325837043ccabee7$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $8N1lA._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $cEF31._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $cEF31._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $fSdUO._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("8N1lA", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $6663f1dd825967c1$export$685354647fba1516; });
function $6663f1dd825967c1$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("fSdUO", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $b8e6b16e5d2e6c93$export$ef97c660ca164e52; });
$parcel$export(module.exports, "_", function () { return $b8e6b16e5d2e6c93$export$ef97c660ca164e52; });

var $lyFcw = parcelRequire("lyFcw");

var $l6pW7 = parcelRequire("l6pW7");
function $b8e6b16e5d2e6c93$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $l6pW7._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $lyFcw._assert_this_initialized)(self);
}

});


parcelRegister("9NSsB", function(module, exports) {

$parcel$export(module.exports, "DateTimeException", function () { return $7232ef576ffbaa3c$export$6058f27c7f907fb; });
$parcel$export(module.exports, "DateTimeParseException", function () { return $7232ef576ffbaa3c$export$ce8a206818942248; });
$parcel$export(module.exports, "UnsupportedTemporalTypeException", function () { return $7232ef576ffbaa3c$export$8fe6dec993229f58; });
$parcel$export(module.exports, "ArithmeticException", function () { return $7232ef576ffbaa3c$export$5891bcae38b5fd67; });
$parcel$export(module.exports, "IllegalArgumentException", function () { return $7232ef576ffbaa3c$export$86eb44ed3377dd8f; });
$parcel$export(module.exports, "IllegalStateException", function () { return $7232ef576ffbaa3c$export$f79c4ffdc088dc0e; });
$parcel$export(module.exports, "NullPointerException", function () { return $7232ef576ffbaa3c$export$b6ad7a1de4697efd; });
$parcel$export(module.exports, "TemporalAmount", function () { return $7232ef576ffbaa3c$export$f8b2fcf02a6656ff; });
$parcel$export(module.exports, "TemporalUnit", function () { return $7232ef576ffbaa3c$export$5d412a4bb789788e; });
$parcel$export(module.exports, "Duration", function () { return $7232ef576ffbaa3c$export$3b11bc38611c5941; });
$parcel$export(module.exports, "LocalTime", function () { return $7232ef576ffbaa3c$export$bf1071e344bea1d; });
$parcel$export(module.exports, "ChronoUnit", function () { return $7232ef576ffbaa3c$export$e61e212a4109fb8a; });
$parcel$export(module.exports, "ChronoField", function () { return $7232ef576ffbaa3c$export$7f55a40756153c3e; });
$parcel$export(module.exports, "YearConstants", function () { return $7232ef576ffbaa3c$export$c04b60057299af61; });
$parcel$export(module.exports, "TemporalField", function () { return $7232ef576ffbaa3c$export$d879d8cdc7b5c1c9; });
$parcel$export(module.exports, "ValueRange", function () { return $7232ef576ffbaa3c$export$177e5e64bab4dec5; });
$parcel$export(module.exports, "TemporalQueries", function () { return $7232ef576ffbaa3c$export$d6cc568434dfd9dc; });
$parcel$export(module.exports, "TemporalAccessor", function () { return $7232ef576ffbaa3c$export$e5100310ee9cc158; });
$parcel$export(module.exports, "Temporal", function () { return $7232ef576ffbaa3c$export$336849d529cb05e5; });
$parcel$export(module.exports, "TemporalQuery", function () { return $7232ef576ffbaa3c$export$3164c6c8dc6c80ff; });
$parcel$export(module.exports, "DayOfWeek", function () { return $7232ef576ffbaa3c$export$7ed5ca4f8b987938; });
$parcel$export(module.exports, "Month", function () { return $7232ef576ffbaa3c$export$951c8378cdfec6e6; });
$parcel$export(module.exports, "IsoChronology", function () { return $7232ef576ffbaa3c$export$f47ae290cf4e4958; });
$parcel$export(module.exports, "Period", function () { return $7232ef576ffbaa3c$export$67186dcd8fa4f92f; });
$parcel$export(module.exports, "LocalDate", function () { return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6; });
$parcel$export(module.exports, "ResolverStyle", function () { return $7232ef576ffbaa3c$export$2a833e4d13229d66; });
$parcel$export(module.exports, "ChronoLocalDate", function () { return $7232ef576ffbaa3c$export$2a07e3472bc98879; });
$parcel$export(module.exports, "DateTimeFormatter", function () { return $7232ef576ffbaa3c$export$3245e15bf4cbdd6c; });
$parcel$export(module.exports, "ZoneId", function () { return $7232ef576ffbaa3c$export$a514a0be1f00ef62; });
$parcel$export(module.exports, "Instant", function () { return $7232ef576ffbaa3c$export$fecec53969739358; });
$parcel$export(module.exports, "ZoneRules", function () { return $7232ef576ffbaa3c$export$cbd9bcf3fad97817; });
$parcel$export(module.exports, "ZoneOffset", function () { return $7232ef576ffbaa3c$export$47ce5d56ab10eaa3; });
$parcel$export(module.exports, "IsoFields", function () { return $7232ef576ffbaa3c$export$2091a0730eb3b2d2; });
$parcel$export(module.exports, "DecimalStyle", function () { return $7232ef576ffbaa3c$export$c1929c59b9e7d355; });
$parcel$export(module.exports, "SignStyle", function () { return $7232ef576ffbaa3c$export$b2e3a42c433c0b35; });
$parcel$export(module.exports, "TextStyle", function () { return $7232ef576ffbaa3c$export$1df879243bf2e42d; });
$parcel$export(module.exports, "ZoneRulesProvider", function () { return $7232ef576ffbaa3c$export$79d73e02cd645302; });
$parcel$export(module.exports, "ZoneRegion", function () { return $7232ef576ffbaa3c$export$9caa52e4e516e67d; });
$parcel$export(module.exports, "DateTimeFormatterBuilder", function () { return $7232ef576ffbaa3c$export$81529fd372517959; });
$parcel$export(module.exports, "LocalDateTime", function () { return $7232ef576ffbaa3c$export$7dda5dc5c6c448ff; });
$parcel$export(module.exports, "MonthDay", function () { return $7232ef576ffbaa3c$export$30964d9b15071608; });
$parcel$export(module.exports, "Clock", function () { return $7232ef576ffbaa3c$export$9735c82c4bae3302; });
$parcel$export(module.exports, "Year", function () { return $7232ef576ffbaa3c$export$6ce2f08d515512; });
$parcel$export(module.exports, "YearMonth", function () { return $7232ef576ffbaa3c$export$b707805e12671f51; });
$parcel$export(module.exports, "TemporalAdjuster", function () { return $7232ef576ffbaa3c$export$841f8bd48996924f; });
$parcel$export(module.exports, "TemporalAdjusters", function () { return $7232ef576ffbaa3c$export$d922854d56f8a965; });
$parcel$export(module.exports, "ChronoZonedDateTime", function () { return $7232ef576ffbaa3c$export$e69f60c5a83f5572; });
$parcel$export(module.exports, "ZonedDateTime", function () { return $7232ef576ffbaa3c$export$d3b7288e7994edea; });
$parcel$export(module.exports, "ChronoLocalDateTime", function () { return $7232ef576ffbaa3c$export$94e985176fb19d17; });
$parcel$export(module.exports, "ZoneOffsetTransition", function () { return $7232ef576ffbaa3c$export$993d982a5ca9c76d; });
$parcel$export(module.exports, "convert", function () { return $7232ef576ffbaa3c$export$9c68d69a4c5bbcf9; });
$parcel$export(module.exports, "nativeJs", function () { return $7232ef576ffbaa3c$export$1f878d3ea5c30765; });
$parcel$export(module.exports, "_", function () { return $7232ef576ffbaa3c$export$71511d61b312f219; });
$parcel$export(module.exports, "use", function () { return $7232ef576ffbaa3c$export$1f96ae73734a86cc; });
//! @version @js-joda/core - 1.12.0
//! @copyright (c) 2015-present, Philipp Thürwächter, Pattrick Hüper & js-joda contributors
//! @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
//! @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ 
var $l6pW7 = parcelRequire("l6pW7");
function $7232ef576ffbaa3c$var$createErrorType(name1, init, superErrorClass) {
    if (superErrorClass === void 0) superErrorClass = Error;
    function E(message) {
        if (!Error.captureStackTrace) this.stack = new Error().stack;
        else Error.captureStackTrace(this, this.constructor);
        this.message = message;
        init && init.apply(this, arguments);
        this.toString = function() {
            return this.name + ": " + this.message;
        };
    }
    E.prototype = new superErrorClass();
    E.prototype.name = name1;
    E.prototype.constructor = E;
    return E;
}
var $7232ef576ffbaa3c$export$6058f27c7f907fb = $7232ef576ffbaa3c$var$createErrorType("DateTimeException", $7232ef576ffbaa3c$var$messageWithCause);
var $7232ef576ffbaa3c$export$ce8a206818942248 = $7232ef576ffbaa3c$var$createErrorType("DateTimeParseException", $7232ef576ffbaa3c$var$messageForDateTimeParseException);
var $7232ef576ffbaa3c$export$8fe6dec993229f58 = $7232ef576ffbaa3c$var$createErrorType("UnsupportedTemporalTypeException", null, $7232ef576ffbaa3c$export$6058f27c7f907fb);
var $7232ef576ffbaa3c$export$5891bcae38b5fd67 = $7232ef576ffbaa3c$var$createErrorType("ArithmeticException");
var $7232ef576ffbaa3c$export$86eb44ed3377dd8f = $7232ef576ffbaa3c$var$createErrorType("IllegalArgumentException");
var $7232ef576ffbaa3c$export$f79c4ffdc088dc0e = $7232ef576ffbaa3c$var$createErrorType("IllegalStateException");
var $7232ef576ffbaa3c$export$b6ad7a1de4697efd = $7232ef576ffbaa3c$var$createErrorType("NullPointerException");
function $7232ef576ffbaa3c$var$messageWithCause(message, cause) {
    if (cause === void 0) cause = null;
    var msg = message || this.name;
    if (cause !== null && cause instanceof Error) msg += "\n-------\nCaused by: " + cause.stack + "\n-------\n";
    this.message = msg;
}
function $7232ef576ffbaa3c$var$messageForDateTimeParseException(message, text, index, cause) {
    if (text === void 0) text = "";
    if (index === void 0) index = 0;
    if (cause === void 0) cause = null;
    var msg = message || this.name;
    msg += ": " + text + ", at index: " + index;
    if (cause !== null && cause instanceof Error) msg += "\n-------\nCaused by: " + cause.stack + "\n-------\n";
    this.message = msg;
    this.parsedString = function() {
        return text;
    };
    this.errorIndex = function() {
        return index;
    };
}
function $7232ef576ffbaa3c$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $7232ef576ffbaa3c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ function $7232ef576ffbaa3c$var$assert(assertion, msg, error) {
    if (!assertion) {
        if (error) throw new error(msg);
        else throw new Error(msg);
    }
}
function $7232ef576ffbaa3c$var$requireNonNull(value, parameterName) {
    if (value == null) throw new $7232ef576ffbaa3c$export$b6ad7a1de4697efd(parameterName + " must not be null");
    return value;
}
function $7232ef576ffbaa3c$var$requireInstance(value, _class, parameterName) {
    if (!(value instanceof _class)) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f(parameterName + " must be an instance of " + (_class.name ? _class.name : _class) + (value && value.constructor && value.constructor.name ? ", but is " + value.constructor.name : ""));
    return value;
}
function $7232ef576ffbaa3c$var$abstractMethodFail(methodName) {
    throw new TypeError('abstract method "' + methodName + '" is not implemented');
}
var $7232ef576ffbaa3c$var$assert$1 = /*#__PURE__*/ Object.freeze({
    assert: $7232ef576ffbaa3c$var$assert,
    requireNonNull: $7232ef576ffbaa3c$var$requireNonNull,
    requireInstance: $7232ef576ffbaa3c$var$requireInstance,
    abstractMethodFail: $7232ef576ffbaa3c$var$abstractMethodFail
});
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$MAX_SAFE_INTEGER = 9007199254740991;
var $7232ef576ffbaa3c$var$MIN_SAFE_INTEGER = -9007199254740991;
var $7232ef576ffbaa3c$var$MathUtil = function() {
    function MathUtil() {}
    MathUtil.intDiv = function intDiv(x, y) {
        var r = x / y;
        r = MathUtil.roundDown(r);
        return MathUtil.safeZero(r);
    };
    MathUtil.intMod = function intMod(x, y) {
        var r = x - MathUtil.intDiv(x, y) * y;
        r = MathUtil.roundDown(r);
        return MathUtil.safeZero(r);
    };
    MathUtil.roundDown = function roundDown(r) {
        if (r < 0) return Math.ceil(r);
        else return Math.floor(r);
    };
    MathUtil.floorDiv = function floorDiv(x, y) {
        var r = Math.floor(x / y);
        return MathUtil.safeZero(r);
    };
    MathUtil.floorMod = function floorMod(x, y) {
        var r = x - MathUtil.floorDiv(x, y) * y;
        return MathUtil.safeZero(r);
    };
    MathUtil.safeAdd = function safeAdd(x, y) {
        MathUtil.verifyInt(x);
        MathUtil.verifyInt(y);
        if (x === 0) return MathUtil.safeZero(y);
        if (y === 0) return MathUtil.safeZero(x);
        var r = MathUtil.safeToInt(x + y);
        if (r === x || r === y) throw new $7232ef576ffbaa3c$export$5891bcae38b5fd67("Invalid addition beyond MAX_SAFE_INTEGER!");
        return r;
    };
    MathUtil.safeSubtract = function safeSubtract(x, y) {
        MathUtil.verifyInt(x);
        MathUtil.verifyInt(y);
        if (x === 0 && y === 0) return 0;
        else if (x === 0) return MathUtil.safeZero(-1 * y);
        else if (y === 0) return MathUtil.safeZero(x);
        return MathUtil.safeToInt(x - y);
    };
    MathUtil.safeMultiply = function safeMultiply(x, y) {
        MathUtil.verifyInt(x);
        MathUtil.verifyInt(y);
        if (x === 1) return MathUtil.safeZero(y);
        if (y === 1) return MathUtil.safeZero(x);
        if (x === 0 || y === 0) return 0;
        var r = MathUtil.safeToInt(x * y);
        if (r / y !== x || x === $7232ef576ffbaa3c$var$MIN_SAFE_INTEGER && y === -1 || y === $7232ef576ffbaa3c$var$MIN_SAFE_INTEGER && x === -1) throw new $7232ef576ffbaa3c$export$5891bcae38b5fd67("Multiplication overflows: " + x + " * " + y);
        return r;
    };
    MathUtil.parseInt = function(_parseInt) {
        function parseInt1(_x) {
            return _parseInt.apply(this, arguments);
        }
        parseInt1.toString = function() {
            return _parseInt.toString();
        };
        return parseInt1;
    }(function(value) {
        var r = parseInt(value);
        return MathUtil.safeToInt(r);
    });
    MathUtil.safeToInt = function safeToInt(value) {
        MathUtil.verifyInt(value);
        return MathUtil.safeZero(value);
    };
    MathUtil.verifyInt = function verifyInt(value) {
        if (value == null) throw new $7232ef576ffbaa3c$export$5891bcae38b5fd67("Invalid value: '" + value + "', using null or undefined as argument");
        if (isNaN(value)) throw new $7232ef576ffbaa3c$export$5891bcae38b5fd67("Invalid int value, using NaN as argument");
        if (value % 1 !== 0) throw new $7232ef576ffbaa3c$export$5891bcae38b5fd67("Invalid value: '" + value + "' is a float");
        if (value > $7232ef576ffbaa3c$var$MAX_SAFE_INTEGER || value < $7232ef576ffbaa3c$var$MIN_SAFE_INTEGER) throw new $7232ef576ffbaa3c$export$5891bcae38b5fd67("Calculation overflows an int: " + value);
    };
    MathUtil.safeZero = function safeZero(value) {
        return value === 0 ? 0 : +value;
    };
    MathUtil.compareNumbers = function compareNumbers(a, b) {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    };
    MathUtil.smi = function smi(int) {
        return int >>> 1 & 0x40000000 | int & 0xBFFFFFFF;
    };
    MathUtil.hash = function hash(number) {
        if (number !== number || number === Infinity) return 0;
        var result = number;
        while(number > 0xFFFFFFFF){
            number /= 0xFFFFFFFF;
            result ^= number;
        }
        return MathUtil.smi(result);
    };
    MathUtil.hashCode = function hashCode() {
        var result = 17;
        for(var _len = arguments.length, numbers = new Array(_len), _key = 0; _key < _len; _key++)numbers[_key] = arguments[_key];
        for(var _i = 0, _numbers = numbers; _i < _numbers.length; _i++){
            var n = _numbers[_i];
            result = (result << 5) - result + MathUtil.hash(n);
        }
        return MathUtil.hash(result);
    };
    return MathUtil;
}();
$7232ef576ffbaa3c$var$MathUtil.MAX_SAFE_INTEGER = $7232ef576ffbaa3c$var$MAX_SAFE_INTEGER;
$7232ef576ffbaa3c$var$MathUtil.MIN_SAFE_INTEGER = $7232ef576ffbaa3c$var$MIN_SAFE_INTEGER;
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$Enum = function() {
    function Enum(name1) {
        this._name = name1;
    }
    var _proto = Enum.prototype;
    _proto.equals = function equals(other) {
        return this === other;
    };
    _proto.toString = function toString() {
        return this._name;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return Enum;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$export$f8b2fcf02a6656ff = function() {
    function TemporalAmount() {}
    var _proto = TemporalAmount.prototype;
    _proto.get = function get(unit) {
        $7232ef576ffbaa3c$var$abstractMethodFail("get");
    };
    _proto.units = function units() {
        $7232ef576ffbaa3c$var$abstractMethodFail("units");
    };
    _proto.addTo = function addTo(temporal) {
        $7232ef576ffbaa3c$var$abstractMethodFail("addTo");
    };
    _proto.subtractFrom = function subtractFrom(temporal) {
        $7232ef576ffbaa3c$var$abstractMethodFail("subtractFrom");
    };
    return TemporalAmount;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$export$5d412a4bb789788e = function() {
    function TemporalUnit() {}
    var _proto = TemporalUnit.prototype;
    _proto.duration = function duration() {
        $7232ef576ffbaa3c$var$abstractMethodFail("duration");
    };
    _proto.isDurationEstimated = function isDurationEstimated() {
        $7232ef576ffbaa3c$var$abstractMethodFail("isDurationEstimated");
    };
    _proto.isDateBased = function isDateBased() {
        $7232ef576ffbaa3c$var$abstractMethodFail("isDateBased");
    };
    _proto.isTimeBased = function isTimeBased() {
        $7232ef576ffbaa3c$var$abstractMethodFail("isTimeBased");
    };
    _proto.isSupportedBy = function isSupportedBy(temporal) {
        $7232ef576ffbaa3c$var$abstractMethodFail("isSupportedBy");
    };
    _proto.addTo = function addTo(dateTime, periodToAdd) {
        $7232ef576ffbaa3c$var$abstractMethodFail("addTo");
    };
    _proto.between = function between(temporal1, temporal2) {
        $7232ef576ffbaa3c$var$abstractMethodFail("between");
    };
    return TemporalUnit;
}();
var $7232ef576ffbaa3c$export$3b11bc38611c5941 = function(_TemporalAmount) {
    $7232ef576ffbaa3c$var$_inheritsLoose(Duration, _TemporalAmount);
    function Duration(seconds, nanos) {
        var _this;
        _this = _TemporalAmount.call(this) || this;
        _this._seconds = $7232ef576ffbaa3c$var$MathUtil.safeToInt(seconds);
        _this._nanos = $7232ef576ffbaa3c$var$MathUtil.safeToInt(nanos);
        return _this;
    }
    Duration.ofDays = function ofDays(days) {
        return Duration._create($7232ef576ffbaa3c$var$MathUtil.safeMultiply(days, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY), 0);
    };
    Duration.ofHours = function ofHours(hours) {
        return Duration._create($7232ef576ffbaa3c$var$MathUtil.safeMultiply(hours, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_HOUR), 0);
    };
    Duration.ofMinutes = function ofMinutes(minutes) {
        return Duration._create($7232ef576ffbaa3c$var$MathUtil.safeMultiply(minutes, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE), 0);
    };
    Duration.ofSeconds = function ofSeconds(seconds, nanoAdjustment) {
        if (nanoAdjustment === void 0) nanoAdjustment = 0;
        var secs = $7232ef576ffbaa3c$var$MathUtil.safeAdd(seconds, $7232ef576ffbaa3c$var$MathUtil.floorDiv(nanoAdjustment, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND));
        var nos = $7232ef576ffbaa3c$var$MathUtil.floorMod(nanoAdjustment, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND);
        return Duration._create(secs, nos);
    };
    Duration.ofMillis = function ofMillis(millis) {
        var secs = $7232ef576ffbaa3c$var$MathUtil.intDiv(millis, 1000);
        var mos = $7232ef576ffbaa3c$var$MathUtil.intMod(millis, 1000);
        if (mos < 0) {
            mos += 1000;
            secs--;
        }
        return Duration._create(secs, mos * 1000000);
    };
    Duration.ofNanos = function ofNanos(nanos) {
        var secs = $7232ef576ffbaa3c$var$MathUtil.intDiv(nanos, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nos = $7232ef576ffbaa3c$var$MathUtil.intMod(nanos, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND);
        if (nos < 0) {
            nos += $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND;
            secs--;
        }
        return this._create(secs, nos);
    };
    Duration.of = function of(amount, unit) {
        return Duration.ZERO.plus(amount, unit);
    };
    Duration.from = function from(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        $7232ef576ffbaa3c$var$requireInstance(amount, $7232ef576ffbaa3c$export$f8b2fcf02a6656ff);
        var duration = Duration.ZERO;
        amount.units().forEach(function(unit) {
            duration = duration.plus(amount.get(unit), unit);
        });
        return duration;
    };
    Duration.between = function between(startInclusive, endExclusive) {
        $7232ef576ffbaa3c$var$requireNonNull(startInclusive, "startInclusive");
        $7232ef576ffbaa3c$var$requireNonNull(endExclusive, "endExclusive");
        var secs = startInclusive.until(endExclusive, $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS);
        var nanos = 0;
        if (startInclusive.isSupported($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND) && endExclusive.isSupported($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND)) try {
            var startNos = startInclusive.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND);
            nanos = endExclusive.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND) - startNos;
            if (secs > 0 && nanos < 0) nanos += $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND;
            else if (secs < 0 && nanos > 0) nanos -= $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND;
            else if (secs === 0 && nanos !== 0) {
                var adjustedEnd = endExclusive.with($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND, startNos);
                secs = startInclusive.until(adjustedEnd, $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS);
            }
        } catch (e) {}
        return this.ofSeconds(secs, nanos);
    };
    Duration.parse = function parse(text) {
        $7232ef576ffbaa3c$var$requireNonNull(text, "text");
        var PATTERN = new RegExp("([-+]?)P(?:([-+]?[0-9]+)D)?(T(?:([-+]?[0-9]+)H)?(?:([-+]?[0-9]+)M)?(?:([-+]?[0-9]+)(?:[.,]([0-9]{0,9}))?S)?)?", "i");
        var matches = PATTERN.exec(text);
        if (matches !== null) {
            if ("T" === matches[3] === false) {
                var negate = "-" === matches[1];
                var dayMatch = matches[2];
                var hourMatch = matches[4];
                var minuteMatch = matches[5];
                var secondMatch = matches[6];
                var fractionMatch = matches[7];
                if (dayMatch != null || hourMatch != null || minuteMatch != null || secondMatch != null) {
                    var daysAsSecs = Duration._parseNumber(text, dayMatch, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY, "days");
                    var hoursAsSecs = Duration._parseNumber(text, hourMatch, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_HOUR, "hours");
                    var minsAsSecs = Duration._parseNumber(text, minuteMatch, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE, "minutes");
                    var seconds = Duration._parseNumber(text, secondMatch, 1, "seconds");
                    var negativeSecs = secondMatch != null && secondMatch.charAt(0) === "-";
                    var nanos = Duration._parseFraction(text, fractionMatch, negativeSecs ? -1 : 1);
                    try {
                        return Duration._create(negate, daysAsSecs, hoursAsSecs, minsAsSecs, seconds, nanos);
                    } catch (ex) {
                        throw new $7232ef576ffbaa3c$export$ce8a206818942248("Text cannot be parsed to a Duration: overflow", text, 0, ex);
                    }
                }
            }
        }
        throw new $7232ef576ffbaa3c$export$ce8a206818942248("Text cannot be parsed to a Duration", text, 0);
    };
    Duration._parseNumber = function _parseNumber(text, parsed, multiplier, errorText) {
        if (parsed == null) return 0;
        try {
            if (parsed[0] === "+") parsed = parsed.substring(1);
            return $7232ef576ffbaa3c$var$MathUtil.safeMultiply(parseFloat(parsed), multiplier);
        } catch (ex) {
            throw new $7232ef576ffbaa3c$export$ce8a206818942248("Text cannot be parsed to a Duration: " + errorText, text, 0, ex);
        }
    };
    Duration._parseFraction = function _parseFraction(text, parsed, negate) {
        if (parsed == null || parsed.length === 0) return 0;
        parsed = (parsed + "000000000").substring(0, 9);
        return parseFloat(parsed) * negate;
    };
    Duration._create = function _create() {
        if (arguments.length <= 2) return Duration._createSecondsNanos(arguments[0], arguments[1]);
        else return Duration._createNegateDaysHoursMinutesSecondsNanos(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
    };
    Duration._createNegateDaysHoursMinutesSecondsNanos = function _createNegateDaysHoursMinutesSecondsNanos(negate, daysAsSecs, hoursAsSecs, minsAsSecs, secs, nanos) {
        var seconds = $7232ef576ffbaa3c$var$MathUtil.safeAdd(daysAsSecs, $7232ef576ffbaa3c$var$MathUtil.safeAdd(hoursAsSecs, $7232ef576ffbaa3c$var$MathUtil.safeAdd(minsAsSecs, secs)));
        if (negate) return Duration.ofSeconds(seconds, nanos).negated();
        return Duration.ofSeconds(seconds, nanos);
    };
    Duration._createSecondsNanos = function _createSecondsNanos(seconds, nanoAdjustment) {
        if (seconds === void 0) seconds = 0;
        if (nanoAdjustment === void 0) nanoAdjustment = 0;
        if ((seconds | nanoAdjustment) === 0) return Duration.ZERO;
        return new Duration(seconds, nanoAdjustment);
    };
    var _proto = Duration.prototype;
    _proto.get = function get(unit) {
        if (unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS) return this._seconds;
        else if (unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS) return this._nanos;
        else throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported unit: " + unit);
    };
    _proto.units = function units() {
        return [
            $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS,
            $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS
        ];
    };
    _proto.isZero = function isZero() {
        return (this._seconds | this._nanos) === 0;
    };
    _proto.isNegative = function isNegative() {
        return this._seconds < 0;
    };
    _proto.seconds = function seconds() {
        return this._seconds;
    };
    _proto.nano = function nano() {
        return this._nanos;
    };
    _proto.withSeconds = function withSeconds(seconds) {
        return Duration._create(seconds, this._nanos);
    };
    _proto.withNanos = function withNanos(nanoOfSecond) {
        $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidIntValue(nanoOfSecond);
        return Duration._create(this._seconds, nanoOfSecond);
    };
    _proto.plusDuration = function plusDuration(duration) {
        $7232ef576ffbaa3c$var$requireNonNull(duration, "duration");
        return this.plus(duration.seconds(), duration.nano());
    };
    _proto.plus = function plus(durationOrNumber, unitOrNumber) {
        if (arguments.length === 1) return this.plusDuration(durationOrNumber);
        else if (arguments.length === 2 && unitOrNumber instanceof $7232ef576ffbaa3c$export$5d412a4bb789788e) return this.plusAmountUnit(durationOrNumber, unitOrNumber);
        else return this.plusSecondsNanos(durationOrNumber, unitOrNumber);
    };
    _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(amountToAdd, "amountToAdd");
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        if (unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS) return this.plusSecondsNanos($7232ef576ffbaa3c$var$MathUtil.safeMultiply(amountToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY), 0);
        if (unit.isDurationEstimated()) throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unit must not have an estimated duration");
        if (amountToAdd === 0) return this;
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) {
            switch(unit){
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS:
                    return this.plusNanos(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MICROS:
                    return this.plusSecondsNanos($7232ef576ffbaa3c$var$MathUtil.intDiv(amountToAdd, 1000000000) * 1000, $7232ef576ffbaa3c$var$MathUtil.intMod(amountToAdd, 1000000000) * 1000);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLIS:
                    return this.plusMillis(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS:
                    return this.plusSeconds(amountToAdd);
            }
            return this.plusSecondsNanos($7232ef576ffbaa3c$var$MathUtil.safeMultiply(unit.duration().seconds(), amountToAdd), 0);
        }
        var duration = unit.duration().multipliedBy(amountToAdd);
        return this.plusSecondsNanos(duration.seconds(), duration.nano());
    };
    _proto.plusDays = function plusDays(daysToAdd) {
        return this.plusSecondsNanos($7232ef576ffbaa3c$var$MathUtil.safeMultiply(daysToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY), 0);
    };
    _proto.plusHours = function plusHours(hoursToAdd) {
        return this.plusSecondsNanos($7232ef576ffbaa3c$var$MathUtil.safeMultiply(hoursToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_HOUR), 0);
    };
    _proto.plusMinutes = function plusMinutes(minutesToAdd) {
        return this.plusSecondsNanos($7232ef576ffbaa3c$var$MathUtil.safeMultiply(minutesToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE), 0);
    };
    _proto.plusSeconds = function plusSeconds(secondsToAdd) {
        return this.plusSecondsNanos(secondsToAdd, 0);
    };
    _proto.plusMillis = function plusMillis(millisToAdd) {
        return this.plusSecondsNanos($7232ef576ffbaa3c$var$MathUtil.intDiv(millisToAdd, 1000), $7232ef576ffbaa3c$var$MathUtil.intMod(millisToAdd, 1000) * 1000000);
    };
    _proto.plusNanos = function plusNanos(nanosToAdd) {
        return this.plusSecondsNanos(0, nanosToAdd);
    };
    _proto.plusSecondsNanos = function plusSecondsNanos(secondsToAdd, nanosToAdd) {
        $7232ef576ffbaa3c$var$requireNonNull(secondsToAdd, "secondsToAdd");
        $7232ef576ffbaa3c$var$requireNonNull(nanosToAdd, "nanosToAdd");
        if ((secondsToAdd | nanosToAdd) === 0) return this;
        var epochSec = $7232ef576ffbaa3c$var$MathUtil.safeAdd(this._seconds, secondsToAdd);
        epochSec = $7232ef576ffbaa3c$var$MathUtil.safeAdd(epochSec, $7232ef576ffbaa3c$var$MathUtil.intDiv(nanosToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND));
        nanosToAdd = $7232ef576ffbaa3c$var$MathUtil.intMod(nanosToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nanoAdjustment = $7232ef576ffbaa3c$var$MathUtil.safeAdd(this._nanos, nanosToAdd);
        return Duration.ofSeconds(epochSec, nanoAdjustment);
    };
    _proto.minus = function minus(durationOrNumber, unit) {
        if (arguments.length === 1) return this.minusDuration(durationOrNumber);
        else return this.minusAmountUnit(durationOrNumber, unit);
    };
    _proto.minusDuration = function minusDuration(duration) {
        $7232ef576ffbaa3c$var$requireNonNull(duration, "duration");
        var secsToSubtract = duration.seconds();
        var nanosToSubtract = duration.nano();
        if (secsToSubtract === $7232ef576ffbaa3c$var$MIN_SAFE_INTEGER) return this.plus($7232ef576ffbaa3c$var$MAX_SAFE_INTEGER, -nanosToSubtract);
        return this.plus(-secsToSubtract, -nanosToSubtract);
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(amountToSubtract, "amountToSubtract");
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        return amountToSubtract === $7232ef576ffbaa3c$var$MIN_SAFE_INTEGER ? this.plusAmountUnit($7232ef576ffbaa3c$var$MAX_SAFE_INTEGER, unit) : this.plusAmountUnit(-amountToSubtract, unit);
    };
    _proto.minusDays = function minusDays(daysToSubtract) {
        return daysToSubtract === $7232ef576ffbaa3c$var$MIN_SAFE_INTEGER ? this.plusDays($7232ef576ffbaa3c$var$MAX_SAFE_INTEGER) : this.plusDays(-daysToSubtract);
    };
    _proto.minusHours = function minusHours(hoursToSubtract) {
        return hoursToSubtract === $7232ef576ffbaa3c$var$MIN_SAFE_INTEGER ? this.plusHours($7232ef576ffbaa3c$var$MAX_SAFE_INTEGER) : this.plusHours(-hoursToSubtract);
    };
    _proto.minusMinutes = function minusMinutes(minutesToSubtract) {
        return minutesToSubtract === $7232ef576ffbaa3c$var$MIN_SAFE_INTEGER ? this.plusMinutes($7232ef576ffbaa3c$var$MAX_SAFE_INTEGER) : this.plusMinutes(-minutesToSubtract);
    };
    _proto.minusSeconds = function minusSeconds(secondsToSubtract) {
        return secondsToSubtract === $7232ef576ffbaa3c$var$MIN_SAFE_INTEGER ? this.plusSeconds($7232ef576ffbaa3c$var$MAX_SAFE_INTEGER) : this.plusSeconds(-secondsToSubtract);
    };
    _proto.minusMillis = function minusMillis(millisToSubtract) {
        return millisToSubtract === $7232ef576ffbaa3c$var$MIN_SAFE_INTEGER ? this.plusMillis($7232ef576ffbaa3c$var$MAX_SAFE_INTEGER) : this.plusMillis(-millisToSubtract);
    };
    _proto.minusNanos = function minusNanos(nanosToSubtract) {
        return nanosToSubtract === $7232ef576ffbaa3c$var$MIN_SAFE_INTEGER ? this.plusNanos($7232ef576ffbaa3c$var$MAX_SAFE_INTEGER) : this.plusNanos(-nanosToSubtract);
    };
    _proto.multipliedBy = function multipliedBy(multiplicand) {
        if (multiplicand === 0) return Duration.ZERO;
        if (multiplicand === 1) return this;
        var secs = $7232ef576ffbaa3c$var$MathUtil.safeMultiply(this._seconds, multiplicand);
        var nos = $7232ef576ffbaa3c$var$MathUtil.safeMultiply(this._nanos, multiplicand);
        secs = secs + $7232ef576ffbaa3c$var$MathUtil.intDiv(nos, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND);
        nos = $7232ef576ffbaa3c$var$MathUtil.intMod(nos, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND);
        return Duration.ofSeconds(secs, nos);
    };
    _proto.dividedBy = function dividedBy(divisor) {
        if (divisor === 0) throw new $7232ef576ffbaa3c$export$5891bcae38b5fd67("Cannot divide by zero");
        if (divisor === 1) return this;
        var secs = $7232ef576ffbaa3c$var$MathUtil.intDiv(this._seconds, divisor);
        var secsMod = $7232ef576ffbaa3c$var$MathUtil.roundDown((this._seconds / divisor - secs) * $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nos = $7232ef576ffbaa3c$var$MathUtil.intDiv(this._nanos, divisor);
        nos = secsMod + nos;
        return Duration.ofSeconds(secs, nos);
    };
    _proto.negated = function negated() {
        return this.multipliedBy(-1);
    };
    _proto.abs = function abs() {
        return this.isNegative() ? this.negated() : this;
    };
    _proto.addTo = function addTo(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        if (this._seconds !== 0) temporal = temporal.plus(this._seconds, $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS);
        if (this._nanos !== 0) temporal = temporal.plus(this._nanos, $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS);
        return temporal;
    };
    _proto.subtractFrom = function subtractFrom(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        if (this._seconds !== 0) temporal = temporal.minus(this._seconds, $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS);
        if (this._nanos !== 0) temporal = temporal.minus(this._nanos, $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS);
        return temporal;
    };
    _proto.toDays = function toDays() {
        return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._seconds, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY);
    };
    _proto.toHours = function toHours() {
        return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._seconds, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_HOUR);
    };
    _proto.toMinutes = function toMinutes() {
        return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._seconds, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
    };
    _proto.toMillis = function toMillis() {
        var millis = Math.round($7232ef576ffbaa3c$var$MathUtil.safeMultiply(this._seconds, 1000));
        millis = $7232ef576ffbaa3c$var$MathUtil.safeAdd(millis, $7232ef576ffbaa3c$var$MathUtil.intDiv(this._nanos, 1000000));
        return millis;
    };
    _proto.toNanos = function toNanos() {
        var totalNanos = $7232ef576ffbaa3c$var$MathUtil.safeMultiply(this._seconds, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND);
        totalNanos = $7232ef576ffbaa3c$var$MathUtil.safeAdd(totalNanos, this._nanos);
        return totalNanos;
    };
    _proto.compareTo = function compareTo(otherDuration) {
        $7232ef576ffbaa3c$var$requireNonNull(otherDuration, "otherDuration");
        $7232ef576ffbaa3c$var$requireInstance(otherDuration, Duration, "otherDuration");
        var cmp = $7232ef576ffbaa3c$var$MathUtil.compareNumbers(this._seconds, otherDuration.seconds());
        if (cmp !== 0) return cmp;
        return this._nanos - otherDuration.nano();
    };
    _proto.equals = function equals(otherDuration) {
        if (this === otherDuration) return true;
        if (otherDuration instanceof Duration) return this.seconds() === otherDuration.seconds() && this.nano() === otherDuration.nano();
        return false;
    };
    _proto.toString = function toString() {
        if (this === Duration.ZERO) return "PT0S";
        var hours = $7232ef576ffbaa3c$var$MathUtil.intDiv(this._seconds, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_HOUR);
        var minutes = $7232ef576ffbaa3c$var$MathUtil.intDiv($7232ef576ffbaa3c$var$MathUtil.intMod(this._seconds, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_HOUR), $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
        var secs = $7232ef576ffbaa3c$var$MathUtil.intMod(this._seconds, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
        var rval = "PT";
        if (hours !== 0) rval += hours + "H";
        if (minutes !== 0) rval += minutes + "M";
        if (secs === 0 && this._nanos === 0 && rval.length > 2) return rval;
        if (secs < 0 && this._nanos > 0) {
            if (secs === -1) rval += "-0";
            else rval += secs + 1;
        } else rval += secs;
        if (this._nanos > 0) {
            rval += ".";
            var nanoString;
            if (secs < 0) nanoString = "" + (2 * $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND - this._nanos);
            else nanoString = "" + ($7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND + this._nanos);
            nanoString = nanoString.slice(1, nanoString.length);
            rval += nanoString;
            while(rval.charAt(rval.length - 1) === "0")rval = rval.slice(0, rval.length - 1);
        }
        rval += "S";
        return rval;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return Duration;
}($7232ef576ffbaa3c$export$f8b2fcf02a6656ff);
function $7232ef576ffbaa3c$var$_init() {
    $7232ef576ffbaa3c$export$3b11bc38611c5941.ZERO = new $7232ef576ffbaa3c$export$3b11bc38611c5941(0, 0);
}
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE.md in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$export$c04b60057299af61 = function YearConstants() {};
function $7232ef576ffbaa3c$var$_init$1() {
    $7232ef576ffbaa3c$export$c04b60057299af61.MIN_VALUE = -999999;
    $7232ef576ffbaa3c$export$c04b60057299af61.MAX_VALUE = 999999;
}
var $7232ef576ffbaa3c$export$e61e212a4109fb8a = function(_TemporalUnit) {
    $7232ef576ffbaa3c$var$_inheritsLoose(ChronoUnit, _TemporalUnit);
    function ChronoUnit(name1, estimatedDuration) {
        var _this;
        _this = _TemporalUnit.call(this) || this;
        _this._name = name1;
        _this._duration = estimatedDuration;
        return _this;
    }
    var _proto = ChronoUnit.prototype;
    _proto.duration = function duration() {
        return this._duration;
    };
    _proto.isDurationEstimated = function isDurationEstimated() {
        return this.isDateBased() || this === ChronoUnit.FOREVER;
    };
    _proto.isDateBased = function isDateBased() {
        return this.compareTo(ChronoUnit.DAYS) >= 0 && this !== ChronoUnit.FOREVER;
    };
    _proto.isTimeBased = function isTimeBased() {
        return this.compareTo(ChronoUnit.DAYS) < 0;
    };
    _proto.isSupportedBy = function isSupportedBy(temporal) {
        if (this === ChronoUnit.FOREVER) return false;
        try {
            temporal.plus(1, this);
            return true;
        } catch (e) {
            try {
                temporal.plus(-1, this);
                return true;
            } catch (e2) {
                return false;
            }
        }
    };
    _proto.addTo = function addTo(temporal, amount) {
        return temporal.plus(amount, this);
    };
    _proto.between = function between(temporal1, temporal2) {
        return temporal1.until(temporal2, this);
    };
    _proto.toString = function toString() {
        return this._name;
    };
    _proto.compareTo = function compareTo(other) {
        return this.duration().compareTo(other.duration());
    };
    return ChronoUnit;
}($7232ef576ffbaa3c$export$5d412a4bb789788e);
function $7232ef576ffbaa3c$var$_init$2() {
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Nanos", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofNanos(1));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.MICROS = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Micros", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofNanos(1000));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLIS = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Millis", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofNanos(1000000));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Seconds", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(1));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.MINUTES = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Minutes", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(60));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.HOURS = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Hours", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(3600));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.HALF_DAYS = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("HalfDays", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(43200));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Days", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(86400));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.WEEKS = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Weeks", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(604800));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Months", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(2629746));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Years", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(31556952));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.DECADES = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Decades", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(315569520));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.CENTURIES = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Centuries", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(3155695200));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLENNIA = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Millennia", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(31556952000));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.ERAS = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Eras", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(31556952 * ($7232ef576ffbaa3c$export$c04b60057299af61.MAX_VALUE + 1)));
    $7232ef576ffbaa3c$export$e61e212a4109fb8a.FOREVER = new $7232ef576ffbaa3c$export$e61e212a4109fb8a("Forever", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds($7232ef576ffbaa3c$var$MathUtil.MAX_SAFE_INTEGER, 999999999));
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$export$d879d8cdc7b5c1c9 = function TemporalField() {};
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$export$177e5e64bab4dec5 = function() {
    function ValueRange(minSmallest, minLargest, maxSmallest, maxLargest) {
        $7232ef576ffbaa3c$var$assert(!(minSmallest > minLargest), "Smallest minimum value '" + minSmallest + "' must be less than largest minimum value '" + minLargest + "'", $7232ef576ffbaa3c$export$86eb44ed3377dd8f);
        $7232ef576ffbaa3c$var$assert(!(maxSmallest > maxLargest), "Smallest maximum value '" + maxSmallest + "' must be less than largest maximum value '" + maxLargest + "'", $7232ef576ffbaa3c$export$86eb44ed3377dd8f);
        $7232ef576ffbaa3c$var$assert(!(minLargest > maxLargest), "Minimum value '" + minLargest + "' must be less than maximum value '" + maxLargest + "'", $7232ef576ffbaa3c$export$86eb44ed3377dd8f);
        this._minSmallest = minSmallest;
        this._minLargest = minLargest;
        this._maxLargest = maxLargest;
        this._maxSmallest = maxSmallest;
    }
    var _proto = ValueRange.prototype;
    _proto.isFixed = function isFixed() {
        return this._minSmallest === this._minLargest && this._maxSmallest === this._maxLargest;
    };
    _proto.minimum = function minimum() {
        return this._minSmallest;
    };
    _proto.largestMinimum = function largestMinimum() {
        return this._minLargest;
    };
    _proto.maximum = function maximum() {
        return this._maxLargest;
    };
    _proto.smallestMaximum = function smallestMaximum() {
        return this._maxSmallest;
    };
    _proto.isValidValue = function isValidValue(value) {
        return this.minimum() <= value && value <= this.maximum();
    };
    _proto.checkValidValue = function checkValidValue(value, field) {
        var msg;
        if (!this.isValidValue(value)) {
            if (field != null) msg = "Invalid value for " + field + " (valid values " + this.toString() + "): " + value;
            else msg = "Invalid value (valid values " + this.toString() + "): " + value;
            return $7232ef576ffbaa3c$var$assert(false, msg, $7232ef576ffbaa3c$export$6058f27c7f907fb);
        }
    };
    _proto.checkValidIntValue = function checkValidIntValue(value, field) {
        if (this.isValidIntValue(value) === false) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Invalid int value for " + field + ": " + value);
        return value;
    };
    _proto.isValidIntValue = function isValidIntValue(value) {
        return this.isIntValue() && this.isValidValue(value);
    };
    _proto.isIntValue = function isIntValue() {
        return this.minimum() >= $7232ef576ffbaa3c$var$MathUtil.MIN_SAFE_INTEGER && this.maximum() <= $7232ef576ffbaa3c$var$MathUtil.MAX_SAFE_INTEGER;
    };
    _proto.equals = function equals(other) {
        if (other === this) return true;
        if (other instanceof ValueRange) return this._minSmallest === other._minSmallest && this._minLargest === other._minLargest && this._maxSmallest === other._maxSmallest && this._maxLargest === other._maxLargest;
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $7232ef576ffbaa3c$var$MathUtil.hashCode(this._minSmallest, this._minLargest, this._maxSmallest, this._maxLargest);
    };
    _proto.toString = function toString() {
        var str = this.minimum() + (this.minimum() !== this.largestMinimum() ? "/" + this.largestMinimum() : "");
        str += " - ";
        str += this.smallestMaximum() + (this.smallestMaximum() !== this.maximum() ? "/" + this.maximum() : "");
        return str;
    };
    ValueRange.of = function of() {
        if (arguments.length === 2) return new ValueRange(arguments[0], arguments[0], arguments[1], arguments[1]);
        else if (arguments.length === 3) return new ValueRange(arguments[0], arguments[0], arguments[1], arguments[2]);
        else if (arguments.length === 4) return new ValueRange(arguments[0], arguments[1], arguments[2], arguments[3]);
        else return $7232ef576ffbaa3c$var$assert(false, "Invalid number of arguments " + arguments.length, $7232ef576ffbaa3c$export$86eb44ed3377dd8f);
    };
    return ValueRange;
}();
var $7232ef576ffbaa3c$export$7f55a40756153c3e = function(_TemporalField) {
    $7232ef576ffbaa3c$var$_inheritsLoose(ChronoField, _TemporalField);
    ChronoField.byName = function byName(fieldName) {
        for(var prop in ChronoField)if (ChronoField[prop]) {
            if (ChronoField[prop] instanceof ChronoField && ChronoField[prop].name() === fieldName) return ChronoField[prop];
        }
    };
    function ChronoField(name1, baseUnit, rangeUnit, range) {
        var _this;
        _this = _TemporalField.call(this) || this;
        _this._name = name1;
        _this._baseUnit = baseUnit;
        _this._rangeUnit = rangeUnit;
        _this._range = range;
        return _this;
    }
    var _proto = ChronoField.prototype;
    _proto.name = function name1() {
        return this._name;
    };
    _proto.baseUnit = function baseUnit() {
        return this._baseUnit;
    };
    _proto.rangeUnit = function rangeUnit() {
        return this._rangeUnit;
    };
    _proto.range = function range() {
        return this._range;
    };
    _proto.displayName = function displayName() {
        return this.toString();
    };
    _proto.checkValidValue = function checkValidValue(value) {
        return this.range().checkValidValue(value, this.name());
    };
    _proto.isDateBased = function isDateBased() {
        var dateBased = this === ChronoField.DAY_OF_WEEK || this === ChronoField.ALIGNED_DAY_OF_WEEK_IN_MONTH || this === ChronoField.ALIGNED_DAY_OF_WEEK_IN_YEAR || this === ChronoField.DAY_OF_MONTH || this === ChronoField.DAY_OF_YEAR || this === ChronoField.EPOCH_DAY || this === ChronoField.ALIGNED_WEEK_OF_MONTH || this === ChronoField.ALIGNED_WEEK_OF_YEAR || this === ChronoField.MONTH_OF_YEAR || this === ChronoField.YEAR_OF_ERA || this === ChronoField.YEAR || this === ChronoField.ERA;
        return dateBased;
    };
    _proto.isTimeBased = function isTimeBased() {
        var timeBased = this === ChronoField.NANO_OF_SECOND || this === ChronoField.NANO_OF_DAY || this === ChronoField.MICRO_OF_SECOND || this === ChronoField.MICRO_OF_DAY || this === ChronoField.MILLI_OF_SECOND || this === ChronoField.MILLI_OF_DAY || this === ChronoField.SECOND_OF_MINUTE || this === ChronoField.SECOND_OF_DAY || this === ChronoField.MINUTE_OF_HOUR || this === ChronoField.MINUTE_OF_DAY || this === ChronoField.HOUR_OF_AMPM || this === ChronoField.CLOCK_HOUR_OF_AMPM || this === ChronoField.HOUR_OF_DAY || this === ChronoField.CLOCK_HOUR_OF_DAY || this === ChronoField.AMPM_OF_DAY;
        return timeBased;
    };
    _proto.rangeRefinedBy = function rangeRefinedBy(temporal) {
        return temporal.range(this);
    };
    _proto.checkValidIntValue = function checkValidIntValue(value) {
        return this.range().checkValidIntValue(value, this);
    };
    _proto.getFrom = function getFrom(temporal) {
        return temporal.getLong(this);
    };
    _proto.toString = function toString() {
        return this.name();
    };
    _proto.equals = function equals(other) {
        return this === other;
    };
    return ChronoField;
}($7232ef576ffbaa3c$export$d879d8cdc7b5c1c9);
function $7232ef576ffbaa3c$var$_init$3() {
    $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND = new $7232ef576ffbaa3c$export$7f55a40756153c3e("NanoOfSecond", $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(0, 999999999));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_DAY = new $7232ef576ffbaa3c$export$7f55a40756153c3e("NanoOfDay", $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(0, 86399999999999));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND = new $7232ef576ffbaa3c$export$7f55a40756153c3e("MicroOfSecond", $7232ef576ffbaa3c$export$e61e212a4109fb8a.MICROS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(0, 999999));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_DAY = new $7232ef576ffbaa3c$export$7f55a40756153c3e("MicroOfDay", $7232ef576ffbaa3c$export$e61e212a4109fb8a.MICROS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(0, 86399999999));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND = new $7232ef576ffbaa3c$export$7f55a40756153c3e("MilliOfSecond", $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLIS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(0, 999));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_DAY = new $7232ef576ffbaa3c$export$7f55a40756153c3e("MilliOfDay", $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLIS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(0, 86399999));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_MINUTE = new $7232ef576ffbaa3c$export$7f55a40756153c3e("SecondOfMinute", $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.MINUTES, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(0, 59));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_DAY = new $7232ef576ffbaa3c$export$7f55a40756153c3e("SecondOfDay", $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(0, 86399));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_HOUR = new $7232ef576ffbaa3c$export$7f55a40756153c3e("MinuteOfHour", $7232ef576ffbaa3c$export$e61e212a4109fb8a.MINUTES, $7232ef576ffbaa3c$export$e61e212a4109fb8a.HOURS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(0, 59));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_DAY = new $7232ef576ffbaa3c$export$7f55a40756153c3e("MinuteOfDay", $7232ef576ffbaa3c$export$e61e212a4109fb8a.MINUTES, $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(0, 1439));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_AMPM = new $7232ef576ffbaa3c$export$7f55a40756153c3e("HourOfAmPm", $7232ef576ffbaa3c$export$e61e212a4109fb8a.HOURS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.HALF_DAYS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(0, 11));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM = new $7232ef576ffbaa3c$export$7f55a40756153c3e("ClockHourOfAmPm", $7232ef576ffbaa3c$export$e61e212a4109fb8a.HOURS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.HALF_DAYS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 12));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY = new $7232ef576ffbaa3c$export$7f55a40756153c3e("HourOfDay", $7232ef576ffbaa3c$export$e61e212a4109fb8a.HOURS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(0, 23));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY = new $7232ef576ffbaa3c$export$7f55a40756153c3e("ClockHourOfDay", $7232ef576ffbaa3c$export$e61e212a4109fb8a.HOURS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 24));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.AMPM_OF_DAY = new $7232ef576ffbaa3c$export$7f55a40756153c3e("AmPmOfDay", $7232ef576ffbaa3c$export$e61e212a4109fb8a.HALF_DAYS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(0, 1));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK = new $7232ef576ffbaa3c$export$7f55a40756153c3e("DayOfWeek", $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.WEEKS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 7));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH = new $7232ef576ffbaa3c$export$7f55a40756153c3e("AlignedDayOfWeekInMonth", $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.WEEKS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 7));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR = new $7232ef576ffbaa3c$export$7f55a40756153c3e("AlignedDayOfWeekInYear", $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.WEEKS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 7));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH = new $7232ef576ffbaa3c$export$7f55a40756153c3e("DayOfMonth", $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 28, 31), "day");
    $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR = new $7232ef576ffbaa3c$export$7f55a40756153c3e("DayOfYear", $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 365, 366));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.EPOCH_DAY = new $7232ef576ffbaa3c$export$7f55a40756153c3e("EpochDay", $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.FOREVER, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(Math.floor($7232ef576ffbaa3c$export$c04b60057299af61.MIN_VALUE * 365.25), Math.floor($7232ef576ffbaa3c$export$c04b60057299af61.MAX_VALUE * 365.25)));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH = new $7232ef576ffbaa3c$export$7f55a40756153c3e("AlignedWeekOfMonth", $7232ef576ffbaa3c$export$e61e212a4109fb8a.WEEKS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 4, 5));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR = new $7232ef576ffbaa3c$export$7f55a40756153c3e("AlignedWeekOfYear", $7232ef576ffbaa3c$export$e61e212a4109fb8a.WEEKS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 53));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR = new $7232ef576ffbaa3c$export$7f55a40756153c3e("MonthOfYear", $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 12), "month");
    $7232ef576ffbaa3c$export$7f55a40756153c3e.PROLEPTIC_MONTH = new $7232ef576ffbaa3c$export$7f55a40756153c3e("ProlepticMonth", $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.FOREVER, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of($7232ef576ffbaa3c$export$c04b60057299af61.MIN_VALUE * 12, $7232ef576ffbaa3c$export$c04b60057299af61.MAX_VALUE * 12 + 11));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA = new $7232ef576ffbaa3c$export$7f55a40756153c3e("YearOfEra", $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.FOREVER, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, $7232ef576ffbaa3c$export$c04b60057299af61.MAX_VALUE, $7232ef576ffbaa3c$export$c04b60057299af61.MAX_VALUE + 1));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR = new $7232ef576ffbaa3c$export$7f55a40756153c3e("Year", $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.FOREVER, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of($7232ef576ffbaa3c$export$c04b60057299af61.MIN_VALUE, $7232ef576ffbaa3c$export$c04b60057299af61.MAX_VALUE), "year");
    $7232ef576ffbaa3c$export$7f55a40756153c3e.ERA = new $7232ef576ffbaa3c$export$7f55a40756153c3e("Era", $7232ef576ffbaa3c$export$e61e212a4109fb8a.ERAS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.FOREVER, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(0, 1));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS = new $7232ef576ffbaa3c$export$7f55a40756153c3e("InstantSeconds", $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.FOREVER, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of($7232ef576ffbaa3c$var$MIN_SAFE_INTEGER, $7232ef576ffbaa3c$var$MAX_SAFE_INTEGER));
    $7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS = new $7232ef576ffbaa3c$export$7f55a40756153c3e("OffsetSeconds", $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS, $7232ef576ffbaa3c$export$e61e212a4109fb8a.FOREVER, $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(-64800, 64800));
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$export$d6cc568434dfd9dc = function() {
    function TemporalQueries() {}
    TemporalQueries.zoneId = function zoneId() {
        return TemporalQueries.ZONE_ID;
    };
    TemporalQueries.chronology = function chronology() {
        return TemporalQueries.CHRONO;
    };
    TemporalQueries.precision = function precision() {
        return TemporalQueries.PRECISION;
    };
    TemporalQueries.zone = function zone() {
        return TemporalQueries.ZONE;
    };
    TemporalQueries.offset = function offset() {
        return TemporalQueries.OFFSET;
    };
    TemporalQueries.localDate = function localDate() {
        return TemporalQueries.LOCAL_DATE;
    };
    TemporalQueries.localTime = function localTime() {
        return TemporalQueries.LOCAL_TIME;
    };
    return TemporalQueries;
}();
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$export$e5100310ee9cc158 = function() {
    function TemporalAccessor() {}
    var _proto = TemporalAccessor.prototype;
    _proto.query = function query(_query) {
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zoneId() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.chronology() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.precision()) return null;
        return _query.queryFrom(this);
    };
    _proto.get = function get(field) {
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.range = function range(field) {
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            if (this.isSupported(field)) return field.range();
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.rangeRefinedBy(this);
    };
    return TemporalAccessor;
}();
var $7232ef576ffbaa3c$export$336849d529cb05e5 = function(_TemporalAccessor) {
    $7232ef576ffbaa3c$var$_inheritsLoose(Temporal, _TemporalAccessor);
    function Temporal() {
        return _TemporalAccessor.apply(this, arguments) || this;
    }
    return Temporal;
}($7232ef576ffbaa3c$export$e5100310ee9cc158);
var $7232ef576ffbaa3c$export$3164c6c8dc6c80ff = function(_Enum) {
    $7232ef576ffbaa3c$var$_inheritsLoose(TemporalQuery, _Enum);
    function TemporalQuery() {
        return _Enum.apply(this, arguments) || this;
    }
    var _proto = TemporalQuery.prototype;
    _proto.queryFrom = function queryFrom(temporal) {
        $7232ef576ffbaa3c$var$abstractMethodFail("queryFrom");
    };
    return TemporalQuery;
}($7232ef576ffbaa3c$var$Enum);
function $7232ef576ffbaa3c$var$createTemporalQuery(name1, queryFromFunction) {
    var ExtendedTemporalQuery = function(_TemporalQuery) {
        $7232ef576ffbaa3c$var$_inheritsLoose(ExtendedTemporalQuery, _TemporalQuery);
        function ExtendedTemporalQuery() {
            return _TemporalQuery.apply(this, arguments) || this;
        }
        return ExtendedTemporalQuery;
    }($7232ef576ffbaa3c$export$3164c6c8dc6c80ff);
    ExtendedTemporalQuery.prototype.queryFrom = queryFromFunction;
    return new ExtendedTemporalQuery(name1);
}
var $7232ef576ffbaa3c$export$7ed5ca4f8b987938 = function(_Temporal) {
    $7232ef576ffbaa3c$var$_inheritsLoose(DayOfWeek, _Temporal);
    function DayOfWeek(ordinal, name1) {
        var _this;
        _this = _Temporal.call(this) || this;
        _this._ordinal = ordinal;
        _this._name = name1;
        return _this;
    }
    var _proto = DayOfWeek.prototype;
    _proto.ordinal = function ordinal() {
        return this._ordinal;
    };
    _proto.name = function name1() {
        return this._name;
    };
    DayOfWeek.values = function values() {
        return $7232ef576ffbaa3c$var$ENUMS.slice();
    };
    DayOfWeek.valueOf = function valueOf(name1) {
        var ordinal = 0;
        for(ordinal; ordinal < $7232ef576ffbaa3c$var$ENUMS.length; ordinal++){
            if ($7232ef576ffbaa3c$var$ENUMS[ordinal].name() === name1) break;
        }
        return DayOfWeek.of(ordinal + 1);
    };
    DayOfWeek.of = function of(dayOfWeek) {
        if (dayOfWeek < 1 || dayOfWeek > 7) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Invalid value for DayOfWeek: " + dayOfWeek);
        return $7232ef576ffbaa3c$var$ENUMS[dayOfWeek - 1];
    };
    DayOfWeek.from = function from(temporal) {
        $7232ef576ffbaa3c$var$assert(temporal != null, "temporal", $7232ef576ffbaa3c$export$b6ad7a1de4697efd);
        if (temporal instanceof DayOfWeek) return temporal;
        try {
            return DayOfWeek.of(temporal.get($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK));
        } catch (ex) {
            if (ex instanceof $7232ef576ffbaa3c$export$6058f27c7f907fb) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unable to obtain DayOfWeek from TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ""), ex);
            else throw ex;
        }
    };
    _proto.value = function value() {
        return this._ordinal + 1;
    };
    _proto.getDisplayName = function getDisplayName(style, locale) {
        throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Pattern using (localized) text not implemented yet!");
    };
    _proto.isSupported = function isSupported(field) {
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return field === $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK;
        return field != null && field.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field === $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK) return field.range();
        else if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        return field.rangeRefinedBy(this);
    };
    _proto.get = function get(field) {
        if (field === $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK) return this.value();
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        if (field === $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK) return this.value();
        else if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        return field.getFrom(this);
    };
    _proto.plus = function plus(days) {
        var amount = $7232ef576ffbaa3c$var$MathUtil.floorMod(days, 7);
        return $7232ef576ffbaa3c$var$ENUMS[$7232ef576ffbaa3c$var$MathUtil.floorMod(this._ordinal + (amount + 7), 7)];
    };
    _proto.minus = function minus(days) {
        return this.plus(-1 * $7232ef576ffbaa3c$var$MathUtil.floorMod(days, 7));
    };
    _proto.query = function query(_query) {
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.precision()) return $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localTime() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.chronology() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zone() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zoneId() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.offset()) return null;
        $7232ef576ffbaa3c$var$assert(_query != null, "query", $7232ef576ffbaa3c$export$b6ad7a1de4697efd);
        return _query.queryFrom(this);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK, this.value());
    };
    _proto.equals = function equals(other) {
        return this === other;
    };
    _proto.toString = function toString() {
        return this._name;
    };
    _proto.compareTo = function compareTo(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        $7232ef576ffbaa3c$var$requireInstance(other, DayOfWeek, "other");
        return this._ordinal - other._ordinal;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return DayOfWeek;
}($7232ef576ffbaa3c$export$336849d529cb05e5);
var $7232ef576ffbaa3c$var$ENUMS;
function $7232ef576ffbaa3c$var$_init$4() {
    $7232ef576ffbaa3c$export$7ed5ca4f8b987938.MONDAY = new $7232ef576ffbaa3c$export$7ed5ca4f8b987938(0, "MONDAY");
    $7232ef576ffbaa3c$export$7ed5ca4f8b987938.TUESDAY = new $7232ef576ffbaa3c$export$7ed5ca4f8b987938(1, "TUESDAY");
    $7232ef576ffbaa3c$export$7ed5ca4f8b987938.WEDNESDAY = new $7232ef576ffbaa3c$export$7ed5ca4f8b987938(2, "WEDNESDAY");
    $7232ef576ffbaa3c$export$7ed5ca4f8b987938.THURSDAY = new $7232ef576ffbaa3c$export$7ed5ca4f8b987938(3, "THURSDAY");
    $7232ef576ffbaa3c$export$7ed5ca4f8b987938.FRIDAY = new $7232ef576ffbaa3c$export$7ed5ca4f8b987938(4, "FRIDAY");
    $7232ef576ffbaa3c$export$7ed5ca4f8b987938.SATURDAY = new $7232ef576ffbaa3c$export$7ed5ca4f8b987938(5, "SATURDAY");
    $7232ef576ffbaa3c$export$7ed5ca4f8b987938.SUNDAY = new $7232ef576ffbaa3c$export$7ed5ca4f8b987938(6, "SUNDAY");
    $7232ef576ffbaa3c$export$7ed5ca4f8b987938.FROM = $7232ef576ffbaa3c$var$createTemporalQuery("DayOfWeek.FROM", function(temporal) {
        return $7232ef576ffbaa3c$export$7ed5ca4f8b987938.from(temporal);
    });
    $7232ef576ffbaa3c$var$ENUMS = [
        $7232ef576ffbaa3c$export$7ed5ca4f8b987938.MONDAY,
        $7232ef576ffbaa3c$export$7ed5ca4f8b987938.TUESDAY,
        $7232ef576ffbaa3c$export$7ed5ca4f8b987938.WEDNESDAY,
        $7232ef576ffbaa3c$export$7ed5ca4f8b987938.THURSDAY,
        $7232ef576ffbaa3c$export$7ed5ca4f8b987938.FRIDAY,
        $7232ef576ffbaa3c$export$7ed5ca4f8b987938.SATURDAY,
        $7232ef576ffbaa3c$export$7ed5ca4f8b987938.SUNDAY
    ];
}
var $7232ef576ffbaa3c$export$951c8378cdfec6e6 = function(_Temporal) {
    $7232ef576ffbaa3c$var$_inheritsLoose(Month, _Temporal);
    function Month(value, name1) {
        var _this;
        _this = _Temporal.call(this) || this;
        _this._value = $7232ef576ffbaa3c$var$MathUtil.safeToInt(value);
        _this._name = name1;
        return _this;
    }
    var _proto = Month.prototype;
    _proto.value = function value() {
        return this._value;
    };
    _proto.ordinal = function ordinal() {
        return this._value - 1;
    };
    _proto.name = function name1() {
        return this._name;
    };
    _proto.getDisplayName = function getDisplayName(style, locale) {
        throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Pattern using (localized) text not implemented yet!");
    };
    _proto.isSupported = function isSupported(field) {
        if (null === field) return false;
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return field === $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR;
        return field != null && field.isSupportedBy(this);
    };
    _proto.get = function get(field) {
        if (field === $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR) return this.value();
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        if (field === $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR) return this.value();
        else if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        return field.getFrom(this);
    };
    _proto.plus = function plus(months) {
        var amount = $7232ef576ffbaa3c$var$MathUtil.intMod(months, 12) + 12;
        var newMonthVal = $7232ef576ffbaa3c$var$MathUtil.intMod(this.value() + amount, 12);
        newMonthVal = newMonthVal === 0 ? 12 : newMonthVal;
        return Month.of(newMonthVal);
    };
    _proto.minus = function minus(months) {
        return this.plus(-1 * $7232ef576ffbaa3c$var$MathUtil.intMod(months, 12));
    };
    _proto.length = function length(leapYear) {
        switch(this){
            case Month.FEBRUARY:
                return leapYear ? 29 : 28;
            case Month.APRIL:
            case Month.JUNE:
            case Month.SEPTEMBER:
            case Month.NOVEMBER:
                return 30;
            default:
                return 31;
        }
    };
    _proto.minLength = function minLength() {
        switch(this){
            case Month.FEBRUARY:
                return 28;
            case Month.APRIL:
            case Month.JUNE:
            case Month.SEPTEMBER:
            case Month.NOVEMBER:
                return 30;
            default:
                return 31;
        }
    };
    _proto.maxLength = function maxLength() {
        switch(this){
            case Month.FEBRUARY:
                return 29;
            case Month.APRIL:
            case Month.JUNE:
            case Month.SEPTEMBER:
            case Month.NOVEMBER:
                return 30;
            default:
                return 31;
        }
    };
    _proto.firstDayOfYear = function firstDayOfYear(leapYear) {
        var leap = leapYear ? 1 : 0;
        switch(this){
            case Month.JANUARY:
                return 1;
            case Month.FEBRUARY:
                return 32;
            case Month.MARCH:
                return 60 + leap;
            case Month.APRIL:
                return 91 + leap;
            case Month.MAY:
                return 121 + leap;
            case Month.JUNE:
                return 152 + leap;
            case Month.JULY:
                return 182 + leap;
            case Month.AUGUST:
                return 213 + leap;
            case Month.SEPTEMBER:
                return 244 + leap;
            case Month.OCTOBER:
                return 274 + leap;
            case Month.NOVEMBER:
                return 305 + leap;
            case Month.DECEMBER:
            default:
                return 335 + leap;
        }
    };
    _proto.firstMonthOfQuarter = function firstMonthOfQuarter() {
        switch(this){
            case Month.JANUARY:
            case Month.FEBRUARY:
            case Month.MARCH:
                return Month.JANUARY;
            case Month.APRIL:
            case Month.MAY:
            case Month.JUNE:
                return Month.APRIL;
            case Month.JULY:
            case Month.AUGUST:
            case Month.SEPTEMBER:
                return Month.JULY;
            case Month.OCTOBER:
            case Month.NOVEMBER:
            case Month.DECEMBER:
            default:
                return Month.OCTOBER;
        }
    };
    _proto.query = function query(_query) {
        $7232ef576ffbaa3c$var$assert(_query != null, "query() parameter must not be null", $7232ef576ffbaa3c$export$6058f27c7f907fb);
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.chronology()) return $7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.precision()) return $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.toString = function toString() {
        switch(this){
            case Month.JANUARY:
                return "JANUARY";
            case Month.FEBRUARY:
                return "FEBRUARY";
            case Month.MARCH:
                return "MARCH";
            case Month.APRIL:
                return "APRIL";
            case Month.MAY:
                return "MAY";
            case Month.JUNE:
                return "JUNE";
            case Month.JULY:
                return "JULY";
            case Month.AUGUST:
                return "AUGUST";
            case Month.SEPTEMBER:
                return "SEPTEMBER";
            case Month.OCTOBER:
                return "OCTOBER";
            case Month.NOVEMBER:
                return "NOVEMBER";
            case Month.DECEMBER:
                return "DECEMBER";
            default:
                return "unknown Month, value: " + this.value();
        }
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR, this.value());
    };
    _proto.compareTo = function compareTo(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        $7232ef576ffbaa3c$var$requireInstance(other, Month, "other");
        return this._value - other._value;
    };
    _proto.equals = function equals(other) {
        return this === other;
    };
    Month.valueOf = function valueOf(name1) {
        var ordinal = 0;
        for(ordinal; ordinal < $7232ef576ffbaa3c$var$MONTHS.length; ordinal++){
            if ($7232ef576ffbaa3c$var$MONTHS[ordinal].name() === name1) break;
        }
        return Month.of(ordinal + 1);
    };
    Month.values = function values() {
        return $7232ef576ffbaa3c$var$MONTHS.slice();
    };
    Month.of = function of(month) {
        if (month < 1 || month > 12) $7232ef576ffbaa3c$var$assert(false, "Invalid value for MonthOfYear: " + month, $7232ef576ffbaa3c$export$6058f27c7f907fb);
        return $7232ef576ffbaa3c$var$MONTHS[month - 1];
    };
    Month.from = function from(temporal) {
        if (temporal instanceof Month) return temporal;
        try {
            return Month.of(temporal.get($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR));
        } catch (ex) {
            throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unable to obtain Month from TemporalAccessor: " + temporal + " of type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ""), ex);
        }
    };
    return Month;
}($7232ef576ffbaa3c$export$336849d529cb05e5);
var $7232ef576ffbaa3c$var$MONTHS;
function $7232ef576ffbaa3c$var$_init$5() {
    $7232ef576ffbaa3c$export$951c8378cdfec6e6.JANUARY = new $7232ef576ffbaa3c$export$951c8378cdfec6e6(1, "JANUARY");
    $7232ef576ffbaa3c$export$951c8378cdfec6e6.FEBRUARY = new $7232ef576ffbaa3c$export$951c8378cdfec6e6(2, "FEBRUARY");
    $7232ef576ffbaa3c$export$951c8378cdfec6e6.MARCH = new $7232ef576ffbaa3c$export$951c8378cdfec6e6(3, "MARCH");
    $7232ef576ffbaa3c$export$951c8378cdfec6e6.APRIL = new $7232ef576ffbaa3c$export$951c8378cdfec6e6(4, "APRIL");
    $7232ef576ffbaa3c$export$951c8378cdfec6e6.MAY = new $7232ef576ffbaa3c$export$951c8378cdfec6e6(5, "MAY");
    $7232ef576ffbaa3c$export$951c8378cdfec6e6.JUNE = new $7232ef576ffbaa3c$export$951c8378cdfec6e6(6, "JUNE");
    $7232ef576ffbaa3c$export$951c8378cdfec6e6.JULY = new $7232ef576ffbaa3c$export$951c8378cdfec6e6(7, "JULY");
    $7232ef576ffbaa3c$export$951c8378cdfec6e6.AUGUST = new $7232ef576ffbaa3c$export$951c8378cdfec6e6(8, "AUGUST");
    $7232ef576ffbaa3c$export$951c8378cdfec6e6.SEPTEMBER = new $7232ef576ffbaa3c$export$951c8378cdfec6e6(9, "SEPTEMBER");
    $7232ef576ffbaa3c$export$951c8378cdfec6e6.OCTOBER = new $7232ef576ffbaa3c$export$951c8378cdfec6e6(10, "OCTOBER");
    $7232ef576ffbaa3c$export$951c8378cdfec6e6.NOVEMBER = new $7232ef576ffbaa3c$export$951c8378cdfec6e6(11, "NOVEMBER");
    $7232ef576ffbaa3c$export$951c8378cdfec6e6.DECEMBER = new $7232ef576ffbaa3c$export$951c8378cdfec6e6(12, "DECEMBER");
    $7232ef576ffbaa3c$var$MONTHS = [
        $7232ef576ffbaa3c$export$951c8378cdfec6e6.JANUARY,
        $7232ef576ffbaa3c$export$951c8378cdfec6e6.FEBRUARY,
        $7232ef576ffbaa3c$export$951c8378cdfec6e6.MARCH,
        $7232ef576ffbaa3c$export$951c8378cdfec6e6.APRIL,
        $7232ef576ffbaa3c$export$951c8378cdfec6e6.MAY,
        $7232ef576ffbaa3c$export$951c8378cdfec6e6.JUNE,
        $7232ef576ffbaa3c$export$951c8378cdfec6e6.JULY,
        $7232ef576ffbaa3c$export$951c8378cdfec6e6.AUGUST,
        $7232ef576ffbaa3c$export$951c8378cdfec6e6.SEPTEMBER,
        $7232ef576ffbaa3c$export$951c8378cdfec6e6.OCTOBER,
        $7232ef576ffbaa3c$export$951c8378cdfec6e6.NOVEMBER,
        $7232ef576ffbaa3c$export$951c8378cdfec6e6.DECEMBER
    ];
}
var $7232ef576ffbaa3c$var$PATTERN = /([-+]?)P(?:([-+]?[0-9]+)Y)?(?:([-+]?[0-9]+)M)?(?:([-+]?[0-9]+)W)?(?:([-+]?[0-9]+)D)?/;
var $7232ef576ffbaa3c$export$67186dcd8fa4f92f = function(_TemporalAmount) {
    $7232ef576ffbaa3c$var$_inheritsLoose(Period, _TemporalAmount);
    function Period(years, months, days) {
        var _this;
        _this = _TemporalAmount.call(this) || this;
        var _years = $7232ef576ffbaa3c$var$MathUtil.safeToInt(years);
        var _months = $7232ef576ffbaa3c$var$MathUtil.safeToInt(months);
        var _days = $7232ef576ffbaa3c$var$MathUtil.safeToInt(days);
        if ((_years | _months | _days) === 0) {
            if (!Period.ZERO) {
                _this._years = _years;
                _this._months = _months;
                _this._days = _days;
                Period.ZERO = $7232ef576ffbaa3c$var$_assertThisInitialized(_this);
            }
            return Period.ZERO || $7232ef576ffbaa3c$var$_assertThisInitialized(_this);
        }
        _this._years = _years;
        _this._months = _months;
        _this._days = _days;
        return _this;
    }
    Period.ofYears = function ofYears(years) {
        return Period.create(years, 0, 0);
    };
    Period.ofMonths = function ofMonths(months) {
        return Period.create(0, months, 0);
    };
    Period.ofWeeks = function ofWeeks(weeks) {
        return Period.create(0, 0, $7232ef576ffbaa3c$var$MathUtil.safeMultiply(weeks, 7));
    };
    Period.ofDays = function ofDays(days) {
        return Period.create(0, 0, days);
    };
    Period.of = function of(years, months, days) {
        return Period.create(years, months, days);
    };
    Period.from = function from(amount) {
        if (amount instanceof Period) return amount;
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        var years = 0;
        var months = 0;
        var days = 0;
        var units = amount.units();
        for(var i = 0; i < units.length; i++){
            var unit = units[i];
            var unitAmount = amount.get(unit);
            if (unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS) years = $7232ef576ffbaa3c$var$MathUtil.safeToInt(unitAmount);
            else if (unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS) months = $7232ef576ffbaa3c$var$MathUtil.safeToInt(unitAmount);
            else if (unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS) days = $7232ef576ffbaa3c$var$MathUtil.safeToInt(unitAmount);
            else throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unit must be Years, Months or Days, but was " + unit);
        }
        return Period.create(years, months, days);
    };
    Period.between = function between(startDate, endDate) {
        $7232ef576ffbaa3c$var$requireNonNull(startDate, "startDate");
        $7232ef576ffbaa3c$var$requireNonNull(endDate, "endDate");
        $7232ef576ffbaa3c$var$requireInstance(startDate, $7232ef576ffbaa3c$export$6397c6cbb8fe96b6, "startDate");
        $7232ef576ffbaa3c$var$requireInstance(endDate, $7232ef576ffbaa3c$export$6397c6cbb8fe96b6, "endDate");
        return startDate.until(endDate);
    };
    Period.parse = function parse(text) {
        $7232ef576ffbaa3c$var$requireNonNull(text, "text");
        try {
            return Period._parse(text);
        } catch (ex) {
            if (ex instanceof $7232ef576ffbaa3c$export$5891bcae38b5fd67) throw new $7232ef576ffbaa3c$export$ce8a206818942248("Text cannot be parsed to a Period", text, 0, ex);
            else throw ex;
        }
    };
    Period._parse = function _parse(text) {
        var matches = $7232ef576ffbaa3c$var$PATTERN.exec(text);
        if (matches != null) {
            var negate = "-" === matches[1] ? -1 : 1;
            var yearMatch = matches[2];
            var monthMatch = matches[3];
            var weekMatch = matches[4];
            var dayMatch = matches[5];
            if (yearMatch != null || monthMatch != null || weekMatch != null || dayMatch != null) {
                var years = Period._parseNumber(text, yearMatch, negate);
                var months = Period._parseNumber(text, monthMatch, negate);
                var weeks = Period._parseNumber(text, weekMatch, negate);
                var days = Period._parseNumber(text, dayMatch, negate);
                days = $7232ef576ffbaa3c$var$MathUtil.safeAdd(days, $7232ef576ffbaa3c$var$MathUtil.safeMultiply(weeks, 7));
                return Period.create(years, months, days);
            }
        }
        throw new $7232ef576ffbaa3c$export$ce8a206818942248("Text cannot be parsed to a Period", text, 0);
    };
    Period._parseNumber = function _parseNumber(text, str, negate) {
        if (str == null) return 0;
        var val = $7232ef576ffbaa3c$var$MathUtil.parseInt(str);
        return $7232ef576ffbaa3c$var$MathUtil.safeMultiply(val, negate);
    };
    Period.create = function create(years, months, days) {
        return new Period(years, months, days);
    };
    var _proto = Period.prototype;
    _proto.units = function units() {
        return [
            $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS,
            $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS,
            $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS
        ];
    };
    _proto.chronology = function chronology() {
        return $7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE;
    };
    _proto.get = function get(unit) {
        if (unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS) return this._years;
        if (unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS) return this._months;
        if (unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS) return this._days;
        throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported unit: " + unit);
    };
    _proto.isZero = function isZero() {
        return this === Period.ZERO;
    };
    _proto.isNegative = function isNegative() {
        return this._years < 0 || this._months < 0 || this._days < 0;
    };
    _proto.years = function years() {
        return this._years;
    };
    _proto.months = function months() {
        return this._months;
    };
    _proto.days = function days() {
        return this._days;
    };
    _proto.withYears = function withYears(years) {
        if (years === this._years) return this;
        return Period.create(years, this._months, this._days);
    };
    _proto.withMonths = function withMonths(months) {
        if (months === this._months) return this;
        return Period.create(this._years, months, this._days);
    };
    _proto.withDays = function withDays(days) {
        if (days === this._days) return this;
        return Period.create(this._years, this._months, days);
    };
    _proto.plus = function plus(amountToAdd) {
        var amount = Period.from(amountToAdd);
        return Period.create($7232ef576ffbaa3c$var$MathUtil.safeAdd(this._years, amount._years), $7232ef576ffbaa3c$var$MathUtil.safeAdd(this._months, amount._months), $7232ef576ffbaa3c$var$MathUtil.safeAdd(this._days, amount._days));
    };
    _proto.plusYears = function plusYears(yearsToAdd) {
        if (yearsToAdd === 0) return this;
        return Period.create($7232ef576ffbaa3c$var$MathUtil.safeToInt($7232ef576ffbaa3c$var$MathUtil.safeAdd(this._years, yearsToAdd)), this._months, this._days);
    };
    _proto.plusMonths = function plusMonths(monthsToAdd) {
        if (monthsToAdd === 0) return this;
        return Period.create(this._years, $7232ef576ffbaa3c$var$MathUtil.safeToInt($7232ef576ffbaa3c$var$MathUtil.safeAdd(this._months, monthsToAdd)), this._days);
    };
    _proto.plusDays = function plusDays(daysToAdd) {
        if (daysToAdd === 0) return this;
        return Period.create(this._years, this._months, $7232ef576ffbaa3c$var$MathUtil.safeToInt($7232ef576ffbaa3c$var$MathUtil.safeAdd(this._days, daysToAdd)));
    };
    _proto.minus = function minus(amountToSubtract) {
        var amount = Period.from(amountToSubtract);
        return Period.create($7232ef576ffbaa3c$var$MathUtil.safeSubtract(this._years, amount._years), $7232ef576ffbaa3c$var$MathUtil.safeSubtract(this._months, amount._months), $7232ef576ffbaa3c$var$MathUtil.safeSubtract(this._days, amount._days));
    };
    _proto.minusYears = function minusYears(yearsToSubtract) {
        return this.plusYears(-1 * yearsToSubtract);
    };
    _proto.minusMonths = function minusMonths(monthsToSubtract) {
        return this.plusMonths(-1 * monthsToSubtract);
    };
    _proto.minusDays = function minusDays(daysToSubtract) {
        return this.plusDays(-1 * daysToSubtract);
    };
    _proto.multipliedBy = function multipliedBy(scalar) {
        if (this === Period.ZERO || scalar === 1) return this;
        return Period.create($7232ef576ffbaa3c$var$MathUtil.safeMultiply(this._years, scalar), $7232ef576ffbaa3c$var$MathUtil.safeMultiply(this._months, scalar), $7232ef576ffbaa3c$var$MathUtil.safeMultiply(this._days, scalar));
    };
    _proto.negated = function negated() {
        return this.multipliedBy(-1);
    };
    _proto.normalized = function normalized() {
        var totalMonths = this.toTotalMonths();
        var splitYears = $7232ef576ffbaa3c$var$MathUtil.intDiv(totalMonths, 12);
        var splitMonths = $7232ef576ffbaa3c$var$MathUtil.intMod(totalMonths, 12);
        if (splitYears === this._years && splitMonths === this._months) return this;
        return Period.create($7232ef576ffbaa3c$var$MathUtil.safeToInt(splitYears), splitMonths, this._days);
    };
    _proto.toTotalMonths = function toTotalMonths() {
        return this._years * 12 + this._months;
    };
    _proto.addTo = function addTo(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        if (this._years !== 0) {
            if (this._months !== 0) temporal = temporal.plus(this.toTotalMonths(), $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS);
            else temporal = temporal.plus(this._years, $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS);
        } else if (this._months !== 0) temporal = temporal.plus(this._months, $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS);
        if (this._days !== 0) temporal = temporal.plus(this._days, $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS);
        return temporal;
    };
    _proto.subtractFrom = function subtractFrom(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        if (this._years !== 0) {
            if (this._months !== 0) temporal = temporal.minus(this.toTotalMonths(), $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS);
            else temporal = temporal.minus(this._years, $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS);
        } else if (this._months !== 0) temporal = temporal.minus(this._months, $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS);
        if (this._days !== 0) temporal = temporal.minus(this._days, $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS);
        return temporal;
    };
    _proto.equals = function equals(obj) {
        if (this === obj) return true;
        if (obj instanceof Period) {
            var other = obj;
            return this._years === other._years && this._months === other._months && this._days === other._days;
        }
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $7232ef576ffbaa3c$var$MathUtil.hashCode(this._years, this._months, this._days);
    };
    _proto.toString = function toString() {
        if (this === Period.ZERO) return "P0D";
        else {
            var buf = "P";
            if (this._years !== 0) buf += "" + this._years + "Y";
            if (this._months !== 0) buf += "" + this._months + "M";
            if (this._days !== 0) buf += "" + this._days + "D";
            return buf;
        }
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return Period;
}($7232ef576ffbaa3c$export$f8b2fcf02a6656ff);
function $7232ef576ffbaa3c$var$_init$6() {
    $7232ef576ffbaa3c$export$67186dcd8fa4f92f.ofDays(0);
}
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$ParsePosition = function() {
    function ParsePosition(index) {
        this._index = index;
        this._errorIndex = -1;
    }
    var _proto = ParsePosition.prototype;
    _proto.getIndex = function getIndex() {
        return this._index;
    };
    _proto.setIndex = function setIndex(index) {
        this._index = index;
    };
    _proto.getErrorIndex = function getErrorIndex() {
        return this._errorIndex;
    };
    _proto.setErrorIndex = function setErrorIndex(errorIndex) {
        this._errorIndex = errorIndex;
    };
    return ParsePosition;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$EnumMap = function() {
    function EnumMap() {
        this._map = {};
    }
    var _proto = EnumMap.prototype;
    _proto.putAll = function putAll(otherMap) {
        for(var key in otherMap._map)this._map[key] = otherMap._map[key];
        return this;
    };
    _proto.containsKey = function containsKey(key) {
        return this._map.hasOwnProperty(key.name()) && this.get(key) !== undefined;
    };
    _proto.get = function get(key) {
        return this._map[key.name()];
    };
    _proto.put = function put(key, val) {
        return this.set(key, val);
    };
    _proto.set = function set(key, val) {
        this._map[key.name()] = val;
        return this;
    };
    _proto.retainAll = function retainAll(keyList) {
        var map = {};
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i].name();
            map[key] = this._map[key];
        }
        this._map = map;
        return this;
    };
    _proto.remove = function remove(key) {
        var keyName = key.name();
        var val = this._map[keyName];
        this._map[keyName] = undefined;
        return val;
    };
    _proto.keySet = function keySet() {
        return this._map;
    };
    _proto.clear = function clear() {
        this._map = {};
    };
    return EnumMap;
}();
var $7232ef576ffbaa3c$export$2a833e4d13229d66 = function(_Enum) {
    $7232ef576ffbaa3c$var$_inheritsLoose(ResolverStyle, _Enum);
    function ResolverStyle() {
        return _Enum.apply(this, arguments) || this;
    }
    return ResolverStyle;
}($7232ef576ffbaa3c$var$Enum);
$7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT = new $7232ef576ffbaa3c$export$2a833e4d13229d66("STRICT");
$7232ef576ffbaa3c$export$2a833e4d13229d66.SMART = new $7232ef576ffbaa3c$export$2a833e4d13229d66("SMART");
$7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT = new $7232ef576ffbaa3c$export$2a833e4d13229d66("LENIENT");
var $7232ef576ffbaa3c$export$2a07e3472bc98879 = function(_Temporal) {
    $7232ef576ffbaa3c$var$_inheritsLoose(ChronoLocalDate, _Temporal);
    function ChronoLocalDate() {
        return _Temporal.apply(this, arguments) || this;
    }
    var _proto = ChronoLocalDate.prototype;
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return fieldOrUnit.isDateBased();
        else if (fieldOrUnit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) return fieldOrUnit.isDateBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.query = function query(_query) {
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.chronology()) return this.chronology();
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.precision()) return $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate()) return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.ofEpochDay(this.toEpochDay());
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localTime() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zone() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zoneId() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.offset()) return null;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.EPOCH_DAY, this.toEpochDay());
    };
    _proto.format = function format(formatter) {
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        $7232ef576ffbaa3c$var$requireInstance(formatter, $7232ef576ffbaa3c$export$3245e15bf4cbdd6c, "formatter");
        return formatter.format(this);
    };
    return ChronoLocalDate;
}($7232ef576ffbaa3c$export$336849d529cb05e5);
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$StringUtil = function() {
    function StringUtil() {}
    StringUtil.startsWith = function startsWith(text, pattern) {
        return text.indexOf(pattern) === 0;
    };
    StringUtil.hashCode = function hashCode(text) {
        var len = text.length;
        if (len === 0) return 0;
        var hash = 0;
        for(var i = 0; i < len; i++){
            var chr = text.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0;
        }
        return $7232ef576ffbaa3c$var$MathUtil.smi(hash);
    };
    return StringUtil;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$export$a514a0be1f00ef62 = function() {
    function ZoneId() {}
    ZoneId.systemDefault = function systemDefault() {
        throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("not supported operation");
    };
    ZoneId.getAvailableZoneIds = function getAvailableZoneIds() {
        throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("not supported operation");
    };
    ZoneId.of = function of(zoneId) {
        throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("not supported operation" + zoneId);
    };
    ZoneId.ofOffset = function ofOffset(prefix, offset) {
        throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("not supported operation" + prefix + offset);
    };
    ZoneId.from = function from(temporal) {
        throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("not supported operation" + temporal);
    };
    var _proto = ZoneId.prototype;
    _proto.id = function id() {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneId.id");
    };
    _proto.rules = function rules() {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneId.rules");
    };
    _proto.normalized = function normalized() {
        var rules = this.rules();
        if (rules.isFixedOffset()) return rules.offset($7232ef576ffbaa3c$export$fecec53969739358.EPOCH);
        return this;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof ZoneId) return this.id() === other.id();
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $7232ef576ffbaa3c$var$StringUtil.hashCode(this.id());
    };
    _proto.toString = function toString() {
        return this.id();
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return ZoneId;
}();
var $7232ef576ffbaa3c$export$cbd9bcf3fad97817 = function() {
    function ZoneRules() {}
    ZoneRules.of = function of(offset) {
        $7232ef576ffbaa3c$var$requireNonNull(offset, "offset");
        return new $7232ef576ffbaa3c$var$Fixed(offset);
    };
    var _proto = ZoneRules.prototype;
    _proto.isFixedOffset = function isFixedOffset() {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.isFixedOffset");
    };
    _proto.offset = function offset(instantOrLocalDateTime) {
        if (instantOrLocalDateTime instanceof $7232ef576ffbaa3c$export$fecec53969739358) return this.offsetOfInstant(instantOrLocalDateTime);
        else return this.offsetOfLocalDateTime(instantOrLocalDateTime);
    };
    _proto.offsetOfInstant = function offsetOfInstant(instant) {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.offsetInstant");
    };
    _proto.offsetOfEpochMilli = function offsetOfEpochMilli(epochMilli) {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.offsetOfEpochMilli");
    };
    _proto.offsetOfLocalDateTime = function offsetOfLocalDateTime(localDateTime) {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.offsetLocalDateTime");
    };
    _proto.validOffsets = function validOffsets(localDateTime) {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.validOffsets");
    };
    _proto.transition = function transition(localDateTime) {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.transition");
    };
    _proto.standardOffset = function standardOffset(instant) {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.standardOffset");
    };
    _proto.daylightSavings = function daylightSavings(instant) {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.daylightSavings");
    };
    _proto.isDaylightSavings = function isDaylightSavings(instant) {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.isDaylightSavings");
    };
    _proto.isValidOffset = function isValidOffset(localDateTime, offset) {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.isValidOffset");
    };
    _proto.nextTransition = function nextTransition(instant) {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.nextTransition");
    };
    _proto.previousTransition = function previousTransition(instant) {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.previousTransition");
    };
    _proto.transitions = function transitions() {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.transitions");
    };
    _proto.transitionRules = function transitionRules() {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.transitionRules");
    };
    _proto.toString = function toString() {
        $7232ef576ffbaa3c$var$abstractMethodFail("ZoneRules.toString");
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return ZoneRules;
}();
var $7232ef576ffbaa3c$var$Fixed = function(_ZoneRules) {
    $7232ef576ffbaa3c$var$_inheritsLoose(Fixed, _ZoneRules);
    function Fixed(offset) {
        var _this;
        _this = _ZoneRules.call(this) || this;
        _this._offset = offset;
        return _this;
    }
    var _proto2 = Fixed.prototype;
    _proto2.isFixedOffset = function isFixedOffset() {
        return true;
    };
    _proto2.offsetOfInstant = function offsetOfInstant() {
        return this._offset;
    };
    _proto2.offsetOfEpochMilli = function offsetOfEpochMilli() {
        return this._offset;
    };
    _proto2.offsetOfLocalDateTime = function offsetOfLocalDateTime() {
        return this._offset;
    };
    _proto2.validOffsets = function validOffsets() {
        return [
            this._offset
        ];
    };
    _proto2.transition = function transition() {
        return null;
    };
    _proto2.standardOffset = function standardOffset() {
        return this._offset;
    };
    _proto2.daylightSavings = function daylightSavings() {
        return $7232ef576ffbaa3c$export$3b11bc38611c5941.ZERO;
    };
    _proto2.isDaylightSavings = function isDaylightSavings() {
        return false;
    };
    _proto2.isValidOffset = function isValidOffset(localDateTime, offset) {
        return this._offset.equals(offset);
    };
    _proto2.nextTransition = function nextTransition() {
        return null;
    };
    _proto2.previousTransition = function previousTransition() {
        return null;
    };
    _proto2.transitions = function transitions() {
        return [];
    };
    _proto2.transitionRules = function transitionRules() {
        return [];
    };
    _proto2.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof Fixed) return this._offset.equals(other._offset);
        return false;
    };
    _proto2.toString = function toString() {
        return "FixedRules:" + this._offset.toString();
    };
    return Fixed;
}($7232ef576ffbaa3c$export$cbd9bcf3fad97817);
var $7232ef576ffbaa3c$var$SECONDS_CACHE = {};
var $7232ef576ffbaa3c$var$ID_CACHE = {};
var $7232ef576ffbaa3c$export$47ce5d56ab10eaa3 = function(_ZoneId) {
    $7232ef576ffbaa3c$var$_inheritsLoose(ZoneOffset, _ZoneId);
    function ZoneOffset(totalSeconds) {
        var _this;
        _this = _ZoneId.call(this) || this;
        ZoneOffset._validateTotalSeconds(totalSeconds);
        _this._totalSeconds = $7232ef576ffbaa3c$var$MathUtil.safeToInt(totalSeconds);
        _this._rules = $7232ef576ffbaa3c$export$cbd9bcf3fad97817.of($7232ef576ffbaa3c$var$_assertThisInitialized(_this));
        _this._id = ZoneOffset._buildId(totalSeconds);
        return _this;
    }
    var _proto = ZoneOffset.prototype;
    _proto.totalSeconds = function totalSeconds() {
        return this._totalSeconds;
    };
    _proto.id = function id() {
        return this._id;
    };
    ZoneOffset._buildId = function _buildId(totalSeconds) {
        if (totalSeconds === 0) return "Z";
        else {
            var absTotalSeconds = Math.abs(totalSeconds);
            var absHours = $7232ef576ffbaa3c$var$MathUtil.intDiv(absTotalSeconds, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_HOUR);
            var absMinutes = $7232ef576ffbaa3c$var$MathUtil.intMod($7232ef576ffbaa3c$var$MathUtil.intDiv(absTotalSeconds, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE), $7232ef576ffbaa3c$export$bf1071e344bea1d.MINUTES_PER_HOUR);
            var buf = "" + (totalSeconds < 0 ? "-" : "+") + (absHours < 10 ? "0" : "") + absHours + (absMinutes < 10 ? ":0" : ":") + absMinutes;
            var absSeconds = $7232ef576ffbaa3c$var$MathUtil.intMod(absTotalSeconds, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
            if (absSeconds !== 0) buf += (absSeconds < 10 ? ":0" : ":") + absSeconds;
            return buf;
        }
    };
    ZoneOffset._validateTotalSeconds = function _validateTotalSeconds(totalSeconds) {
        if (Math.abs(totalSeconds) > ZoneOffset.MAX_SECONDS) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Zone offset not in valid range: -18:00 to +18:00");
    };
    ZoneOffset._validate = function _validate(hours, minutes, seconds) {
        if (hours < -18 || hours > 18) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Zone offset hours not in valid range: value " + hours + " is not in the range -18 to 18");
        if (hours > 0) {
            if (minutes < 0 || seconds < 0) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Zone offset minutes and seconds must be positive because hours is positive");
        } else if (hours < 0) {
            if (minutes > 0 || seconds > 0) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Zone offset minutes and seconds must be negative because hours is negative");
        } else if (minutes > 0 && seconds < 0 || minutes < 0 && seconds > 0) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Zone offset minutes and seconds must have the same sign");
        if (Math.abs(minutes) > 59) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Zone offset minutes not in valid range: abs(value) " + Math.abs(minutes) + " is not in the range 0 to 59");
        if (Math.abs(seconds) > 59) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Zone offset seconds not in valid range: abs(value) " + Math.abs(seconds) + " is not in the range 0 to 59");
        if (Math.abs(hours) === 18 && (Math.abs(minutes) > 0 || Math.abs(seconds) > 0)) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Zone offset not in valid range: -18:00 to +18:00");
    };
    ZoneOffset.of = function of(offsetId) {
        $7232ef576ffbaa3c$var$requireNonNull(offsetId, "offsetId");
        var offset = $7232ef576ffbaa3c$var$ID_CACHE[offsetId];
        if (offset != null) return offset;
        var hours, minutes, seconds;
        switch(offsetId.length){
            case 2:
                offsetId = offsetId[0] + "0" + offsetId[1];
            case 3:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = 0;
                seconds = 0;
                break;
            case 5:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = ZoneOffset._parseNumber(offsetId, 3, false);
                seconds = 0;
                break;
            case 6:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = ZoneOffset._parseNumber(offsetId, 4, true);
                seconds = 0;
                break;
            case 7:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = ZoneOffset._parseNumber(offsetId, 3, false);
                seconds = ZoneOffset._parseNumber(offsetId, 5, false);
                break;
            case 9:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = ZoneOffset._parseNumber(offsetId, 4, true);
                seconds = ZoneOffset._parseNumber(offsetId, 7, true);
                break;
            default:
                throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Invalid ID for ZoneOffset, invalid format: " + offsetId);
        }
        var first = offsetId[0];
        if (first !== "+" && first !== "-") throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Invalid ID for ZoneOffset, plus/minus not found when expected: " + offsetId);
        if (first === "-") return ZoneOffset.ofHoursMinutesSeconds(-hours, -minutes, -seconds);
        else return ZoneOffset.ofHoursMinutesSeconds(hours, minutes, seconds);
    };
    ZoneOffset._parseNumber = function _parseNumber(offsetId, pos, precededByColon) {
        if (precededByColon && offsetId[pos - 1] !== ":") throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Invalid ID for ZoneOffset, colon not found when expected: " + offsetId);
        var ch1 = offsetId[pos];
        var ch2 = offsetId[pos + 1];
        if (ch1 < "0" || ch1 > "9" || ch2 < "0" || ch2 > "9") throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Invalid ID for ZoneOffset, non numeric characters found: " + offsetId);
        return (ch1.charCodeAt(0) - 48) * 10 + (ch2.charCodeAt(0) - 48);
    };
    ZoneOffset.ofHours = function ofHours(hours) {
        return ZoneOffset.ofHoursMinutesSeconds(hours, 0, 0);
    };
    ZoneOffset.ofHoursMinutes = function ofHoursMinutes(hours, minutes) {
        return ZoneOffset.ofHoursMinutesSeconds(hours, minutes, 0);
    };
    ZoneOffset.ofHoursMinutesSeconds = function ofHoursMinutesSeconds(hours, minutes, seconds) {
        ZoneOffset._validate(hours, minutes, seconds);
        var totalSeconds = hours * $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_HOUR + minutes * $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE + seconds;
        return ZoneOffset.ofTotalSeconds(totalSeconds);
    };
    ZoneOffset.ofTotalMinutes = function ofTotalMinutes(totalMinutes) {
        var totalSeconds = totalMinutes * $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE;
        return ZoneOffset.ofTotalSeconds(totalSeconds);
    };
    ZoneOffset.ofTotalSeconds = function ofTotalSeconds(totalSeconds) {
        if (totalSeconds % (15 * $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE) === 0) {
            var totalSecs = totalSeconds;
            var result = $7232ef576ffbaa3c$var$SECONDS_CACHE[totalSecs];
            if (result == null) {
                result = new ZoneOffset(totalSeconds);
                $7232ef576ffbaa3c$var$SECONDS_CACHE[totalSecs] = result;
                $7232ef576ffbaa3c$var$ID_CACHE[result.id()] = result;
            }
            return result;
        } else return new ZoneOffset(totalSeconds);
    };
    _proto.rules = function rules() {
        return this._rules;
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        if (field === $7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS) return this._totalSeconds;
        else if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unsupported field: " + field);
        return field.getFrom(this);
    };
    _proto.query = function query(_query) {
        $7232ef576ffbaa3c$var$requireNonNull(_query, "query");
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.offset() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zone()) return this;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localTime() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.precision() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.chronology() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zoneId()) return null;
        return _query.queryFrom(this);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS, this._totalSeconds);
    };
    _proto.compareTo = function compareTo(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        return other._totalSeconds - this._totalSeconds;
    };
    _proto.equals = function equals(obj) {
        if (this === obj) return true;
        if (obj instanceof ZoneOffset) return this._totalSeconds === obj._totalSeconds;
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._totalSeconds;
    };
    _proto.toString = function toString() {
        return this._id;
    };
    return ZoneOffset;
}($7232ef576ffbaa3c$export$a514a0be1f00ef62);
function $7232ef576ffbaa3c$var$_init$7() {
    $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.MAX_SECONDS = 18 * $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_HOUR;
    $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.UTC = $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.ofTotalSeconds(0);
    $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.MIN = $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.ofTotalSeconds(-$7232ef576ffbaa3c$export$47ce5d56ab10eaa3.MAX_SECONDS);
    $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.MAX = $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.ofTotalSeconds($7232ef576ffbaa3c$export$47ce5d56ab10eaa3.MAX_SECONDS);
}
var $7232ef576ffbaa3c$var$DateTimeBuilder = function(_Temporal) {
    $7232ef576ffbaa3c$var$_inheritsLoose(DateTimeBuilder, _Temporal);
    DateTimeBuilder.create = function create(field, value) {
        var dtb = new DateTimeBuilder();
        dtb._addFieldValue(field, value);
        return dtb;
    };
    function DateTimeBuilder() {
        var _this;
        _this = _Temporal.call(this) || this;
        _this.fieldValues = new $7232ef576ffbaa3c$var$EnumMap();
        _this.chrono = null;
        _this.zone = null;
        _this.date = null;
        _this.time = null;
        _this.leapSecond = false;
        _this.excessDays = null;
        return _this;
    }
    var _proto = DateTimeBuilder.prototype;
    _proto.getFieldValue0 = function getFieldValue0(field) {
        return this.fieldValues.get(field);
    };
    _proto._addFieldValue = function _addFieldValue(field, value) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        var old = this.getFieldValue0(field);
        if (old != null && old !== value) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Conflict found: " + field + " " + old + " differs from " + field + " " + value + ": " + this);
        return this._putFieldValue0(field, value);
    };
    _proto._putFieldValue0 = function _putFieldValue0(field, value) {
        this.fieldValues.put(field, value);
        return this;
    };
    _proto.resolve = function resolve(resolverStyle, resolverFields) {
        if (resolverFields != null) this.fieldValues.retainAll(resolverFields);
        this._mergeDate(resolverStyle);
        this._mergeTime(resolverStyle);
        this._resolveTimeInferZeroes(resolverStyle);
        if (this.excessDays != null && this.excessDays.isZero() === false && this.date != null && this.time != null) {
            this.date = this.date.plus(this.excessDays);
            this.excessDays = $7232ef576ffbaa3c$export$67186dcd8fa4f92f.ZERO;
        }
        this._resolveInstant();
        return this;
    };
    _proto._mergeDate = function _mergeDate(resolverStyle) {
        this._checkDate($7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE.resolveDate(this.fieldValues, resolverStyle));
    };
    _proto._checkDate = function _checkDate(date) {
        if (date != null) {
            this._addObject(date);
            for(var fieldName in this.fieldValues.keySet()){
                var field = $7232ef576ffbaa3c$export$7f55a40756153c3e.byName(fieldName);
                if (field) {
                    if (this.fieldValues.get(field) !== undefined) {
                        if (field.isDateBased()) {
                            var val1 = void 0;
                            try {
                                val1 = date.getLong(field);
                            } catch (ex) {
                                if (ex instanceof $7232ef576ffbaa3c$export$6058f27c7f907fb) continue;
                                else throw ex;
                            }
                            var val2 = this.fieldValues.get(field);
                            if (val1 !== val2) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Conflict found: Field " + field + " " + val1 + " differs from " + field + " " + val2 + " derived from " + date);
                        }
                    }
                }
            }
        }
    };
    _proto._mergeTime = function _mergeTime(resolverStyle) {
        if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY)) {
            var ch = this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY);
            if (resolverStyle !== $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) {
                if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.SMART && ch === 0) ;
                else $7232ef576ffbaa3c$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY.checkValidValue(ch);
            }
            this._addFieldValue($7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY, ch === 24 ? 0 : ch);
        }
        if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM)) {
            var _ch = this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM);
            if (resolverStyle !== $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) {
                if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.SMART && _ch === 0) ;
                else $7232ef576ffbaa3c$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM.checkValidValue(_ch);
            }
            this._addFieldValue($7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_AMPM, _ch === 12 ? 0 : _ch);
        }
        if (resolverStyle !== $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) {
            if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.AMPM_OF_DAY)) $7232ef576ffbaa3c$export$7f55a40756153c3e.AMPM_OF_DAY.checkValidValue(this.fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.AMPM_OF_DAY));
            if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_AMPM)) $7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_AMPM.checkValidValue(this.fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_AMPM));
        }
        if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.AMPM_OF_DAY) && this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_AMPM)) {
            var ap = this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.AMPM_OF_DAY);
            var hap = this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_AMPM);
            this._addFieldValue($7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY, ap * 12 + hap);
        }
        if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_DAY)) {
            var nod = this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_DAY);
            if (resolverStyle !== $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_DAY.checkValidValue(nod);
            this._addFieldValue($7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_DAY, $7232ef576ffbaa3c$var$MathUtil.intDiv(nod, 1000000000));
            this._addFieldValue($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND, $7232ef576ffbaa3c$var$MathUtil.intMod(nod, 1000000000));
        }
        if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_DAY)) {
            var cod = this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_DAY);
            if (resolverStyle !== $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) $7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_DAY.checkValidValue(cod);
            this._addFieldValue($7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_DAY, $7232ef576ffbaa3c$var$MathUtil.intDiv(cod, 1000000));
            this._addFieldValue($7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND, $7232ef576ffbaa3c$var$MathUtil.intMod(cod, 1000000));
        }
        if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_DAY)) {
            var lod = this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_DAY);
            if (resolverStyle !== $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) $7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_DAY.checkValidValue(lod);
            this._addFieldValue($7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_DAY, $7232ef576ffbaa3c$var$MathUtil.intDiv(lod, 1000));
            this._addFieldValue($7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND, $7232ef576ffbaa3c$var$MathUtil.intMod(lod, 1000));
        }
        if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_DAY)) {
            var sod = this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_DAY);
            if (resolverStyle !== $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) $7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_DAY.checkValidValue(sod);
            this._addFieldValue($7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY, $7232ef576ffbaa3c$var$MathUtil.intDiv(sod, 3600));
            this._addFieldValue($7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_HOUR, $7232ef576ffbaa3c$var$MathUtil.intMod($7232ef576ffbaa3c$var$MathUtil.intDiv(sod, 60), 60));
            this._addFieldValue($7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_MINUTE, $7232ef576ffbaa3c$var$MathUtil.intMod(sod, 60));
        }
        if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_DAY)) {
            var mod = this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_DAY);
            if (resolverStyle !== $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) $7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_DAY.checkValidValue(mod);
            this._addFieldValue($7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY, $7232ef576ffbaa3c$var$MathUtil.intDiv(mod, 60));
            this._addFieldValue($7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_HOUR, $7232ef576ffbaa3c$var$MathUtil.intMod(mod, 60));
        }
        if (resolverStyle !== $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) {
            if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND)) $7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND.checkValidValue(this.fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND));
            if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND)) $7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND.checkValidValue(this.fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND));
        }
        if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND) && this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND)) {
            var los = this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND);
            var cos = this.fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND);
            this._putFieldValue0($7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND, los * 1000 + $7232ef576ffbaa3c$var$MathUtil.intMod(cos, 1000));
        }
        if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND) && this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND)) {
            var nos = this.fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND);
            this._putFieldValue0($7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND, $7232ef576ffbaa3c$var$MathUtil.intDiv(nos, 1000));
            this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND);
        }
        if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND) && this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND)) {
            var _nos = this.fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND);
            this._putFieldValue0($7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND, $7232ef576ffbaa3c$var$MathUtil.intDiv(_nos, 1000000));
            this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND);
        }
        if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND)) {
            var _cos = this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND);
            this._putFieldValue0($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND, _cos * 1000);
        } else if (this.fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND)) {
            var _los = this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND);
            this._putFieldValue0($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND, _los * 1000000);
        }
    };
    _proto._resolveTimeInferZeroes = function _resolveTimeInferZeroes(resolverStyle) {
        var hod = this.fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY);
        var moh = this.fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_HOUR);
        var som = this.fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_MINUTE);
        var nos = this.fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND);
        if (hod == null) return;
        if (moh == null && (som != null || nos != null)) return;
        if (moh != null && som == null && nos != null) return;
        if (resolverStyle !== $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) {
            if (hod != null) {
                if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.SMART && hod === 24 && (moh == null || moh === 0) && (som == null || som === 0) && (nos == null || nos === 0)) {
                    hod = 0;
                    this.excessDays = $7232ef576ffbaa3c$export$67186dcd8fa4f92f.ofDays(1);
                }
                var hodVal = $7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY.checkValidIntValue(hod);
                if (moh != null) {
                    var mohVal = $7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_HOUR.checkValidIntValue(moh);
                    if (som != null) {
                        var somVal = $7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_MINUTE.checkValidIntValue(som);
                        if (nos != null) {
                            var nosVal = $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidIntValue(nos);
                            this._addObject($7232ef576ffbaa3c$export$bf1071e344bea1d.of(hodVal, mohVal, somVal, nosVal));
                        } else this._addObject($7232ef576ffbaa3c$export$bf1071e344bea1d.of(hodVal, mohVal, somVal));
                    } else if (nos == null) this._addObject($7232ef576ffbaa3c$export$bf1071e344bea1d.of(hodVal, mohVal));
                } else if (som == null && nos == null) this._addObject($7232ef576ffbaa3c$export$bf1071e344bea1d.of(hodVal, 0));
            }
        } else if (hod != null) {
            var _hodVal = hod;
            if (moh != null) {
                if (som != null) {
                    if (nos == null) nos = 0;
                    var totalNanos = $7232ef576ffbaa3c$var$MathUtil.safeMultiply(_hodVal, 3600000000000);
                    totalNanos = $7232ef576ffbaa3c$var$MathUtil.safeAdd(totalNanos, $7232ef576ffbaa3c$var$MathUtil.safeMultiply(moh, 60000000000));
                    totalNanos = $7232ef576ffbaa3c$var$MathUtil.safeAdd(totalNanos, $7232ef576ffbaa3c$var$MathUtil.safeMultiply(som, 1000000000));
                    totalNanos = $7232ef576ffbaa3c$var$MathUtil.safeAdd(totalNanos, nos);
                    var excessDays = $7232ef576ffbaa3c$var$MathUtil.floorDiv(totalNanos, 86400000000000);
                    var nod = $7232ef576ffbaa3c$var$MathUtil.floorMod(totalNanos, 86400000000000);
                    this._addObject($7232ef576ffbaa3c$export$bf1071e344bea1d.ofNanoOfDay(nod));
                    this.excessDays = $7232ef576ffbaa3c$export$67186dcd8fa4f92f.ofDays(excessDays);
                } else {
                    var totalSecs = $7232ef576ffbaa3c$var$MathUtil.safeMultiply(_hodVal, 3600);
                    totalSecs = $7232ef576ffbaa3c$var$MathUtil.safeAdd(totalSecs, $7232ef576ffbaa3c$var$MathUtil.safeMultiply(moh, 60));
                    var _excessDays = $7232ef576ffbaa3c$var$MathUtil.floorDiv(totalSecs, 86400);
                    var sod = $7232ef576ffbaa3c$var$MathUtil.floorMod(totalSecs, 86400);
                    this._addObject($7232ef576ffbaa3c$export$bf1071e344bea1d.ofSecondOfDay(sod));
                    this.excessDays = $7232ef576ffbaa3c$export$67186dcd8fa4f92f.ofDays(_excessDays);
                }
            } else {
                var _excessDays2 = $7232ef576ffbaa3c$var$MathUtil.safeToInt($7232ef576ffbaa3c$var$MathUtil.floorDiv(_hodVal, 24));
                _hodVal = $7232ef576ffbaa3c$var$MathUtil.floorMod(_hodVal, 24);
                this._addObject($7232ef576ffbaa3c$export$bf1071e344bea1d.of(_hodVal, 0));
                this.excessDays = $7232ef576ffbaa3c$export$67186dcd8fa4f92f.ofDays(_excessDays2);
            }
        }
        this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY);
        this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_HOUR);
        this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_MINUTE);
        this.fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND);
    };
    _proto._addObject = function _addObject(dateOrTime) {
        if (dateOrTime instanceof $7232ef576ffbaa3c$export$2a07e3472bc98879) this.date = dateOrTime;
        else if (dateOrTime instanceof $7232ef576ffbaa3c$export$bf1071e344bea1d) this.time = dateOrTime;
    };
    _proto._resolveInstant = function _resolveInstant() {
        if (this.date != null && this.time != null) {
            var offsetSecs = this.fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS);
            if (offsetSecs != null) {
                var offset = $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.ofTotalSeconds(offsetSecs);
                var instant = this.date.atTime(this.time).atZone(offset).getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS);
                this.fieldValues.put($7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS, instant);
            } else if (this.zone != null) {
                var _instant = this.date.atTime(this.time).atZone(this.zone).getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS);
                this.fieldValues.put($7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS, _instant);
            }
        }
    };
    _proto.build = function build(type) {
        return type.queryFrom(this);
    };
    _proto.isSupported = function isSupported(field) {
        if (field == null) return false;
        return this.fieldValues.containsKey(field) && this.fieldValues.get(field) !== undefined || this.date != null && this.date.isSupported(field) || this.time != null && this.time.isSupported(field);
    };
    _proto.getLong = function getLong(field) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        var value = this.getFieldValue0(field);
        if (value == null) {
            if (this.date != null && this.date.isSupported(field)) return this.date.getLong(field);
            if (this.time != null && this.time.isSupported(field)) return this.time.getLong(field);
            throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Field not found: " + field);
        }
        return value;
    };
    _proto.query = function query(_query) {
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zoneId()) return this.zone;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.chronology()) return this.chrono;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate()) return this.date != null ? $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.from(this.date) : null;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localTime()) return this.time;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zone() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.offset()) return _query.queryFrom(this);
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.precision()) return null;
        return _query.queryFrom(this);
    };
    return DateTimeBuilder;
}($7232ef576ffbaa3c$export$336849d529cb05e5);
var $7232ef576ffbaa3c$var$DateTimeParseContext = function() {
    function DateTimeParseContext() {
        if (arguments.length === 1) {
            if (arguments[0] instanceof DateTimeParseContext) {
                this._constructorSelf.apply(this, arguments);
                return;
            } else this._constructorFormatter.apply(this, arguments);
        } else this._constructorParam.apply(this, arguments);
        this._caseSensitive = true;
        this._strict = true;
        this._parsed = [
            new $7232ef576ffbaa3c$var$Parsed(this)
        ];
    }
    var _proto = DateTimeParseContext.prototype;
    _proto._constructorParam = function _constructorParam(locale, symbols, chronology) {
        this._locale = locale;
        this._symbols = symbols;
        this._overrideChronology = chronology;
    };
    _proto._constructorFormatter = function _constructorFormatter(formatter) {
        this._locale = formatter.locale();
        this._symbols = formatter.decimalStyle();
        this._overrideChronology = formatter.chronology();
    };
    _proto._constructorSelf = function _constructorSelf(other) {
        this._locale = other._locale;
        this._symbols = other._symbols;
        this._overrideChronology = other._overrideChronology;
        this._overrideZone = other._overrideZone;
        this._caseSensitive = other._caseSensitive;
        this._strict = other._strict;
        this._parsed = [
            new $7232ef576ffbaa3c$var$Parsed(this)
        ];
    };
    _proto.copy = function copy() {
        return new DateTimeParseContext(this);
    };
    _proto.symbols = function symbols() {
        return this._symbols;
    };
    _proto.isStrict = function isStrict() {
        return this._strict;
    };
    _proto.setStrict = function setStrict(strict) {
        this._strict = strict;
    };
    _proto.locale = function locale() {
        return this._locale;
    };
    _proto.setLocale = function setLocale(locale) {
        this._locale = locale;
    };
    _proto.startOptional = function startOptional() {
        this._parsed.push(this.currentParsed().copy());
    };
    _proto.endOptional = function endOptional(successful) {
        if (successful) this._parsed.splice(this._parsed.length - 2, 1);
        else this._parsed.splice(this._parsed.length - 1, 1);
    };
    _proto.isCaseSensitive = function isCaseSensitive() {
        return this._caseSensitive;
    };
    _proto.setCaseSensitive = function setCaseSensitive(caseSensitive) {
        this._caseSensitive = caseSensitive;
    };
    _proto.subSequenceEquals = function subSequenceEquals(cs1, offset1, cs2, offset2, length) {
        if (offset1 + length > cs1.length || offset2 + length > cs2.length) return false;
        if (!this.isCaseSensitive()) {
            cs1 = cs1.toLowerCase();
            cs2 = cs2.toLowerCase();
        }
        for(var i = 0; i < length; i++){
            var ch1 = cs1[offset1 + i];
            var ch2 = cs2[offset2 + i];
            if (ch1 !== ch2) return false;
        }
        return true;
    };
    _proto.charEquals = function charEquals(ch1, ch2) {
        if (this.isCaseSensitive()) return ch1 === ch2;
        return this.charEqualsIgnoreCase(ch1, ch2);
    };
    _proto.charEqualsIgnoreCase = function charEqualsIgnoreCase(c1, c2) {
        return c1 === c2 || c1.toLowerCase() === c2.toLowerCase();
    };
    _proto.setParsedField = function setParsedField(field, value, errorPos, successPos) {
        var currentParsedFieldValues = this.currentParsed().fieldValues;
        var old = currentParsedFieldValues.get(field);
        currentParsedFieldValues.set(field, value);
        return old != null && old !== value ? ~errorPos : successPos;
    };
    _proto.setParsedZone = function setParsedZone(zone) {
        $7232ef576ffbaa3c$var$requireNonNull(zone, "zone");
        this.currentParsed().zone = zone;
    };
    _proto.getParsed = function getParsed(field) {
        return this.currentParsed().fieldValues.get(field);
    };
    _proto.toParsed = function toParsed() {
        return this.currentParsed();
    };
    _proto.currentParsed = function currentParsed() {
        return this._parsed[this._parsed.length - 1];
    };
    _proto.setParsedLeapSecond = function setParsedLeapSecond() {
        this.currentParsed().leapSecond = true;
    };
    _proto.getEffectiveChronology = function getEffectiveChronology() {
        var chrono = this.currentParsed().chrono;
        if (chrono == null) {
            chrono = this._overrideChronology;
            if (chrono == null) chrono = $7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE;
        }
        return chrono;
    };
    return DateTimeParseContext;
}();
var $7232ef576ffbaa3c$var$Parsed = function(_Temporal) {
    $7232ef576ffbaa3c$var$_inheritsLoose(Parsed, _Temporal);
    function Parsed(dateTimeParseContext) {
        var _this;
        _this = _Temporal.call(this) || this;
        _this.chrono = null;
        _this.zone = null;
        _this.fieldValues = new $7232ef576ffbaa3c$var$EnumMap();
        _this.leapSecond = false;
        _this.dateTimeParseContext = dateTimeParseContext;
        return _this;
    }
    var _proto2 = Parsed.prototype;
    _proto2.copy = function copy() {
        var cloned = new Parsed();
        cloned.chrono = this.chrono;
        cloned.zone = this.zone;
        cloned.fieldValues.putAll(this.fieldValues);
        cloned.leapSecond = this.leapSecond;
        cloned.dateTimeParseContext = this.dateTimeParseContext;
        return cloned;
    };
    _proto2.toString = function toString() {
        return this.fieldValues + ", " + this.chrono + ", " + this.zone;
    };
    _proto2.isSupported = function isSupported(field) {
        return this.fieldValues.containsKey(field);
    };
    _proto2.get = function get(field) {
        var val = this.fieldValues.get(field);
        $7232ef576ffbaa3c$var$assert(val != null);
        return val;
    };
    _proto2.query = function query(_query) {
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.chronology()) return this.chrono;
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zoneId() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zone()) return this.zone;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto2.toBuilder = function toBuilder() {
        var builder = new $7232ef576ffbaa3c$var$DateTimeBuilder();
        builder.fieldValues.putAll(this.fieldValues);
        builder.chrono = this.dateTimeParseContext.getEffectiveChronology();
        if (this.zone != null) builder.zone = this.zone;
        else builder.zone = this.overrideZone;
        builder.leapSecond = this.leapSecond;
        builder.excessDays = this.excessDays;
        return builder;
    };
    return Parsed;
}($7232ef576ffbaa3c$export$336849d529cb05e5);
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$DateTimePrintContext = function() {
    function DateTimePrintContext(temporal, localeOrFormatter, symbols) {
        if (arguments.length === 2 && arguments[1] instanceof $7232ef576ffbaa3c$export$3245e15bf4cbdd6c) {
            this._temporal = DateTimePrintContext.adjust(temporal, localeOrFormatter);
            this._locale = localeOrFormatter.locale();
            this._symbols = localeOrFormatter.decimalStyle();
        } else {
            this._temporal = temporal;
            this._locale = localeOrFormatter;
            this._symbols = symbols;
        }
        this._optional = 0;
    }
    DateTimePrintContext.adjust = function adjust(temporal, formatter) {
        return temporal;
    };
    var _proto = DateTimePrintContext.prototype;
    _proto.symbols = function symbols() {
        return this._symbols;
    };
    _proto.startOptional = function startOptional() {
        this._optional++;
    };
    _proto.endOptional = function endOptional() {
        this._optional--;
    };
    _proto.getValueQuery = function getValueQuery(query) {
        var result = this._temporal.query(query);
        if (result == null && this._optional === 0) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unable to extract value: " + this._temporal);
        return result;
    };
    _proto.getValue = function getValue(field) {
        try {
            return this._temporal.getLong(field);
        } catch (ex) {
            if (ex instanceof $7232ef576ffbaa3c$export$6058f27c7f907fb && this._optional > 0) return null;
            throw ex;
        }
    };
    _proto.temporal = function temporal() {
        return this._temporal;
    };
    _proto.locale = function locale() {
        return this._locale;
    };
    _proto.setDateTime = function setDateTime(temporal) {
        this._temporal = temporal;
    };
    _proto.setLocale = function setLocale(locale) {
        this._locale = locale;
    };
    return DateTimePrintContext;
}();
var $7232ef576ffbaa3c$export$2091a0730eb3b2d2 = function IsoFields() {};
var $7232ef576ffbaa3c$var$QUARTER_DAYS = [
    0,
    90,
    181,
    273,
    0,
    91,
    182,
    274
];
var $7232ef576ffbaa3c$var$Field = function(_TemporalField) {
    $7232ef576ffbaa3c$var$_inheritsLoose(Field, _TemporalField);
    function Field() {
        return _TemporalField.apply(this, arguments) || this;
    }
    var _proto = Field.prototype;
    _proto.isDateBased = function isDateBased() {
        return true;
    };
    _proto.isTimeBased = function isTimeBased() {
        return false;
    };
    _proto._isIso = function _isIso() {
        return true;
    };
    Field._getWeekRangeByLocalDate = function _getWeekRangeByLocalDate(date) {
        var wby = Field._getWeekBasedYear(date);
        return $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, Field._getWeekRangeByYear(wby));
    };
    Field._getWeekRangeByYear = function _getWeekRangeByYear(wby) {
        var date = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(wby, 1, 1);
        if (date.dayOfWeek() === $7232ef576ffbaa3c$export$7ed5ca4f8b987938.THURSDAY || date.dayOfWeek() === $7232ef576ffbaa3c$export$7ed5ca4f8b987938.WEDNESDAY && date.isLeapYear()) return 53;
        return 52;
    };
    Field._getWeek = function _getWeek(date) {
        var dow0 = date.dayOfWeek().ordinal();
        var doy0 = date.dayOfYear() - 1;
        var doyThu0 = doy0 + (3 - dow0);
        var alignedWeek = $7232ef576ffbaa3c$var$MathUtil.intDiv(doyThu0, 7);
        var firstThuDoy0 = doyThu0 - alignedWeek * 7;
        var firstMonDoy0 = firstThuDoy0 - 3;
        if (firstMonDoy0 < -3) firstMonDoy0 += 7;
        if (doy0 < firstMonDoy0) return Field._getWeekRangeByLocalDate(date.withDayOfYear(180).minusYears(1)).maximum();
        var week = $7232ef576ffbaa3c$var$MathUtil.intDiv(doy0 - firstMonDoy0, 7) + 1;
        if (week === 53) {
            if ((firstMonDoy0 === -3 || firstMonDoy0 === -2 && date.isLeapYear()) === false) week = 1;
        }
        return week;
    };
    Field._getWeekBasedYear = function _getWeekBasedYear(date) {
        var year = date.year();
        var doy = date.dayOfYear();
        if (doy <= 3) {
            var dow = date.dayOfWeek().ordinal();
            if (doy - dow < -2) year--;
        } else if (doy >= 363) {
            var _dow = date.dayOfWeek().ordinal();
            doy = doy - 363 - (date.isLeapYear() ? 1 : 0);
            if (doy - _dow >= 0) year++;
        }
        return year;
    };
    _proto.getDisplayName = function getDisplayName() {
        return this.toString();
    };
    _proto.resolve = function resolve() {
        return null;
    };
    _proto.name = function name1() {
        return this.toString();
    };
    return Field;
}($7232ef576ffbaa3c$export$d879d8cdc7b5c1c9);
var $7232ef576ffbaa3c$var$DAY_OF_QUARTER_FIELD = function(_Field) {
    $7232ef576ffbaa3c$var$_inheritsLoose(DAY_OF_QUARTER_FIELD, _Field);
    function DAY_OF_QUARTER_FIELD() {
        return _Field.apply(this, arguments) || this;
    }
    var _proto2 = DAY_OF_QUARTER_FIELD.prototype;
    _proto2.toString = function toString() {
        return "DayOfQuarter";
    };
    _proto2.baseUnit = function baseUnit() {
        return $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS;
    };
    _proto2.rangeUnit = function rangeUnit() {
        return $7232ef576ffbaa3c$var$QUARTER_YEARS;
    };
    _proto2.range = function range() {
        return $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 90, 92);
    };
    _proto2.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR) && temporal.isSupported($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR) && temporal.isSupported($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR) && this._isIso(temporal);
    };
    _proto2.rangeRefinedBy = function rangeRefinedBy(temporal) {
        if (temporal.isSupported(this) === false) throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: DayOfQuarter");
        var qoy = temporal.getLong($7232ef576ffbaa3c$var$QUARTER_OF_YEAR);
        if (qoy === 1) {
            var year = temporal.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR);
            return $7232ef576ffbaa3c$export$f47ae290cf4e4958.isLeapYear(year) ? $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 91) : $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 90);
        } else if (qoy === 2) return $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 91);
        else if (qoy === 3 || qoy === 4) return $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 92);
        return this.range();
    };
    _proto2.getFrom = function getFrom(temporal) {
        if (temporal.isSupported(this) === false) throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: DayOfQuarter");
        var doy = temporal.get($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR);
        var moy = temporal.get($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR);
        var year = temporal.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR);
        return doy - $7232ef576ffbaa3c$var$QUARTER_DAYS[$7232ef576ffbaa3c$var$MathUtil.intDiv(moy - 1, 3) + ($7232ef576ffbaa3c$export$f47ae290cf4e4958.isLeapYear(year) ? 4 : 0)];
    };
    _proto2.adjustInto = function adjustInto(temporal, newValue) {
        var curValue = this.getFrom(temporal);
        this.range().checkValidValue(newValue, this);
        return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR, temporal.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR) + (newValue - curValue));
    };
    _proto2.resolve = function resolve(fieldValues, partialTemporal, resolverStyle) {
        var yearLong = fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR);
        var qoyLong = fieldValues.get($7232ef576ffbaa3c$var$QUARTER_OF_YEAR);
        if (yearLong == null || qoyLong == null) return null;
        var y = $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidIntValue(yearLong);
        var doq = fieldValues.get($7232ef576ffbaa3c$var$DAY_OF_QUARTER);
        var date;
        if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) {
            var qoy = qoyLong;
            date = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(y, 1, 1);
            date = date.plusMonths($7232ef576ffbaa3c$var$MathUtil.safeMultiply($7232ef576ffbaa3c$var$MathUtil.safeSubtract(qoy, 1), 3));
            date = date.plusDays($7232ef576ffbaa3c$var$MathUtil.safeSubtract(doq, 1));
        } else {
            var _qoy = $7232ef576ffbaa3c$var$QUARTER_OF_YEAR.range().checkValidIntValue(qoyLong, $7232ef576ffbaa3c$var$QUARTER_OF_YEAR);
            if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT) {
                var max = 92;
                if (_qoy === 1) max = $7232ef576ffbaa3c$export$f47ae290cf4e4958.isLeapYear(y) ? 91 : 90;
                else if (_qoy === 2) max = 91;
                $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, max).checkValidValue(doq, this);
            } else this.range().checkValidValue(doq, this);
            date = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(y, (_qoy - 1) * 3 + 1, 1).plusDays(doq - 1);
        }
        fieldValues.remove(this);
        fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR);
        fieldValues.remove($7232ef576ffbaa3c$var$QUARTER_OF_YEAR);
        return date;
    };
    return DAY_OF_QUARTER_FIELD;
}($7232ef576ffbaa3c$var$Field);
var $7232ef576ffbaa3c$var$QUARTER_OF_YEAR_FIELD = function(_Field2) {
    $7232ef576ffbaa3c$var$_inheritsLoose(QUARTER_OF_YEAR_FIELD, _Field2);
    function QUARTER_OF_YEAR_FIELD() {
        return _Field2.apply(this, arguments) || this;
    }
    var _proto3 = QUARTER_OF_YEAR_FIELD.prototype;
    _proto3.toString = function toString() {
        return "QuarterOfYear";
    };
    _proto3.baseUnit = function baseUnit() {
        return $7232ef576ffbaa3c$var$QUARTER_YEARS;
    };
    _proto3.rangeUnit = function rangeUnit() {
        return $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS;
    };
    _proto3.range = function range() {
        return $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 4);
    };
    _proto3.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR) && this._isIso(temporal);
    };
    _proto3.rangeRefinedBy = function rangeRefinedBy(temporal) {
        return this.range();
    };
    _proto3.getFrom = function getFrom(temporal) {
        if (temporal.isSupported(this) === false) throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: QuarterOfYear");
        var moy = temporal.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR);
        return $7232ef576ffbaa3c$var$MathUtil.intDiv(moy + 2, 3);
    };
    _proto3.adjustInto = function adjustInto(temporal, newValue) {
        var curValue = this.getFrom(temporal);
        this.range().checkValidValue(newValue, this);
        return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR, temporal.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR) + (newValue - curValue) * 3);
    };
    return QUARTER_OF_YEAR_FIELD;
}($7232ef576ffbaa3c$var$Field);
var $7232ef576ffbaa3c$var$WEEK_OF_WEEK_BASED_YEAR_FIELD = function(_Field3) {
    $7232ef576ffbaa3c$var$_inheritsLoose(WEEK_OF_WEEK_BASED_YEAR_FIELD, _Field3);
    function WEEK_OF_WEEK_BASED_YEAR_FIELD() {
        return _Field3.apply(this, arguments) || this;
    }
    var _proto4 = WEEK_OF_WEEK_BASED_YEAR_FIELD.prototype;
    _proto4.toString = function toString() {
        return "WeekOfWeekBasedYear";
    };
    _proto4.baseUnit = function baseUnit() {
        return $7232ef576ffbaa3c$export$e61e212a4109fb8a.WEEKS;
    };
    _proto4.rangeUnit = function rangeUnit() {
        return $7232ef576ffbaa3c$var$WEEK_BASED_YEARS;
    };
    _proto4.range = function range() {
        return $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, 52, 53);
    };
    _proto4.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($7232ef576ffbaa3c$export$7f55a40756153c3e.EPOCH_DAY) && this._isIso(temporal);
    };
    _proto4.rangeRefinedBy = function rangeRefinedBy(temporal) {
        if (temporal.isSupported(this) === false) throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: WeekOfWeekBasedYear");
        return $7232ef576ffbaa3c$var$Field._getWeekRangeByLocalDate($7232ef576ffbaa3c$export$6397c6cbb8fe96b6.from(temporal));
    };
    _proto4.getFrom = function getFrom(temporal) {
        if (temporal.isSupported(this) === false) throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: WeekOfWeekBasedYear");
        return $7232ef576ffbaa3c$var$Field._getWeek($7232ef576ffbaa3c$export$6397c6cbb8fe96b6.from(temporal));
    };
    _proto4.adjustInto = function adjustInto(temporal, newValue) {
        this.range().checkValidValue(newValue, this);
        return temporal.plus($7232ef576ffbaa3c$var$MathUtil.safeSubtract(newValue, this.getFrom(temporal)), $7232ef576ffbaa3c$export$e61e212a4109fb8a.WEEKS);
    };
    _proto4.resolve = function resolve(fieldValues, partialTemporal, resolverStyle) {
        var wbyLong = fieldValues.get($7232ef576ffbaa3c$var$WEEK_BASED_YEAR);
        var dowLong = fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK);
        if (wbyLong == null || dowLong == null) return null;
        var wby = $7232ef576ffbaa3c$var$WEEK_BASED_YEAR.range().checkValidIntValue(wbyLong, $7232ef576ffbaa3c$var$WEEK_BASED_YEAR);
        var wowby = fieldValues.get($7232ef576ffbaa3c$var$WEEK_OF_WEEK_BASED_YEAR);
        var date;
        if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) {
            var dow = dowLong;
            var weeks = 0;
            if (dow > 7) {
                weeks = $7232ef576ffbaa3c$var$MathUtil.intDiv(dow - 1, 7);
                dow = $7232ef576ffbaa3c$var$MathUtil.intMod(dow - 1, 7) + 1;
            } else if (dow < 1) {
                weeks = $7232ef576ffbaa3c$var$MathUtil.intDiv(dow, 7) - 1;
                dow = $7232ef576ffbaa3c$var$MathUtil.intMod(dow, 7) + 7;
            }
            date = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(wby, 1, 4).plusWeeks(wowby - 1).plusWeeks(weeks).with($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK, dow);
        } else {
            var _dow2 = $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK.checkValidIntValue(dowLong);
            if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT) {
                var temp = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(wby, 1, 4);
                var range = $7232ef576ffbaa3c$var$Field._getWeekRangeByLocalDate(temp);
                range.checkValidValue(wowby, this);
            } else this.range().checkValidValue(wowby, this);
            date = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(wby, 1, 4).plusWeeks(wowby - 1).with($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK, _dow2);
        }
        fieldValues.remove(this);
        fieldValues.remove($7232ef576ffbaa3c$var$WEEK_BASED_YEAR);
        fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK);
        return date;
    };
    _proto4.getDisplayName = function getDisplayName() {
        return "Week";
    };
    return WEEK_OF_WEEK_BASED_YEAR_FIELD;
}($7232ef576ffbaa3c$var$Field);
var $7232ef576ffbaa3c$var$WEEK_BASED_YEAR_FIELD = function(_Field4) {
    $7232ef576ffbaa3c$var$_inheritsLoose(WEEK_BASED_YEAR_FIELD, _Field4);
    function WEEK_BASED_YEAR_FIELD() {
        return _Field4.apply(this, arguments) || this;
    }
    var _proto5 = WEEK_BASED_YEAR_FIELD.prototype;
    _proto5.toString = function toString() {
        return "WeekBasedYear";
    };
    _proto5.baseUnit = function baseUnit() {
        return $7232ef576ffbaa3c$var$WEEK_BASED_YEARS;
    };
    _proto5.rangeUnit = function rangeUnit() {
        return $7232ef576ffbaa3c$export$e61e212a4109fb8a.FOREVER;
    };
    _proto5.range = function range() {
        return $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.range();
    };
    _proto5.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($7232ef576ffbaa3c$export$7f55a40756153c3e.EPOCH_DAY) && this._isIso(temporal);
    };
    _proto5.rangeRefinedBy = function rangeRefinedBy(temporal) {
        return $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.range();
    };
    _proto5.getFrom = function getFrom(temporal) {
        if (temporal.isSupported(this) === false) throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: WeekBasedYear");
        return $7232ef576ffbaa3c$var$Field._getWeekBasedYear($7232ef576ffbaa3c$export$6397c6cbb8fe96b6.from(temporal));
    };
    _proto5.adjustInto = function adjustInto(temporal, newValue) {
        if (this.isSupportedBy(temporal) === false) throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: WeekBasedYear");
        var newWby = this.range().checkValidIntValue(newValue, $7232ef576ffbaa3c$var$WEEK_BASED_YEAR);
        var date = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.from(temporal);
        var dow = date.get($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK);
        var week = $7232ef576ffbaa3c$var$Field._getWeek(date);
        if (week === 53 && $7232ef576ffbaa3c$var$Field._getWeekRangeByYear(newWby) === 52) week = 52;
        var resolved = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(newWby, 1, 4);
        var days = dow - resolved.get($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK) + (week - 1) * 7;
        resolved = resolved.plusDays(days);
        return temporal.with(resolved);
    };
    return WEEK_BASED_YEAR_FIELD;
}($7232ef576ffbaa3c$var$Field);
var $7232ef576ffbaa3c$var$Unit = function(_TemporalUnit) {
    $7232ef576ffbaa3c$var$_inheritsLoose(Unit, _TemporalUnit);
    function Unit(name1, estimatedDuration) {
        var _this;
        _this = _TemporalUnit.call(this) || this;
        _this._name = name1;
        _this._duration = estimatedDuration;
        return _this;
    }
    var _proto6 = Unit.prototype;
    _proto6.duration = function duration() {
        return this._duration;
    };
    _proto6.isDurationEstimated = function isDurationEstimated() {
        return true;
    };
    _proto6.isDateBased = function isDateBased() {
        return true;
    };
    _proto6.isTimeBased = function isTimeBased() {
        return false;
    };
    _proto6.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($7232ef576ffbaa3c$export$7f55a40756153c3e.EPOCH_DAY);
    };
    _proto6.addTo = function addTo(temporal, periodToAdd) {
        switch(this){
            case $7232ef576ffbaa3c$var$WEEK_BASED_YEARS:
                var added = $7232ef576ffbaa3c$var$MathUtil.safeAdd(temporal.get($7232ef576ffbaa3c$var$WEEK_BASED_YEAR), periodToAdd);
                return temporal.with($7232ef576ffbaa3c$var$WEEK_BASED_YEAR, added);
            case $7232ef576ffbaa3c$var$QUARTER_YEARS:
                return temporal.plus($7232ef576ffbaa3c$var$MathUtil.intDiv(periodToAdd, 256), $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS).plus($7232ef576ffbaa3c$var$MathUtil.intMod(periodToAdd, 256) * 3, $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS);
            default:
                throw new $7232ef576ffbaa3c$export$f79c4ffdc088dc0e("Unreachable");
        }
    };
    _proto6.between = function between(temporal1, temporal2) {
        switch(this){
            case $7232ef576ffbaa3c$var$WEEK_BASED_YEARS:
                return $7232ef576ffbaa3c$var$MathUtil.safeSubtract(temporal2.getLong($7232ef576ffbaa3c$var$WEEK_BASED_YEAR), temporal1.getLong($7232ef576ffbaa3c$var$WEEK_BASED_YEAR));
            case $7232ef576ffbaa3c$var$QUARTER_YEARS:
                return $7232ef576ffbaa3c$var$MathUtil.intDiv(temporal1.until(temporal2, $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS), 3);
            default:
                throw new $7232ef576ffbaa3c$export$f79c4ffdc088dc0e("Unreachable");
        }
    };
    _proto6.toString = function toString() {
        return name;
    };
    return Unit;
}($7232ef576ffbaa3c$export$5d412a4bb789788e);
var $7232ef576ffbaa3c$var$DAY_OF_QUARTER = null;
var $7232ef576ffbaa3c$var$QUARTER_OF_YEAR = null;
var $7232ef576ffbaa3c$var$WEEK_OF_WEEK_BASED_YEAR = null;
var $7232ef576ffbaa3c$var$WEEK_BASED_YEAR = null;
var $7232ef576ffbaa3c$var$WEEK_BASED_YEARS = null;
var $7232ef576ffbaa3c$var$QUARTER_YEARS = null;
function $7232ef576ffbaa3c$var$_init$8() {
    $7232ef576ffbaa3c$var$DAY_OF_QUARTER = new $7232ef576ffbaa3c$var$DAY_OF_QUARTER_FIELD();
    $7232ef576ffbaa3c$var$QUARTER_OF_YEAR = new $7232ef576ffbaa3c$var$QUARTER_OF_YEAR_FIELD();
    $7232ef576ffbaa3c$var$WEEK_OF_WEEK_BASED_YEAR = new $7232ef576ffbaa3c$var$WEEK_OF_WEEK_BASED_YEAR_FIELD();
    $7232ef576ffbaa3c$var$WEEK_BASED_YEAR = new $7232ef576ffbaa3c$var$WEEK_BASED_YEAR_FIELD();
    $7232ef576ffbaa3c$var$WEEK_BASED_YEARS = new $7232ef576ffbaa3c$var$Unit("WeekBasedYears", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(31556952));
    $7232ef576ffbaa3c$var$QUARTER_YEARS = new $7232ef576ffbaa3c$var$Unit("QuarterYears", $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(7889238));
    $7232ef576ffbaa3c$export$2091a0730eb3b2d2.DAY_OF_QUARTER = $7232ef576ffbaa3c$var$DAY_OF_QUARTER;
    $7232ef576ffbaa3c$export$2091a0730eb3b2d2.QUARTER_OF_YEAR = $7232ef576ffbaa3c$var$QUARTER_OF_YEAR;
    $7232ef576ffbaa3c$export$2091a0730eb3b2d2.WEEK_OF_WEEK_BASED_YEAR = $7232ef576ffbaa3c$var$WEEK_OF_WEEK_BASED_YEAR;
    $7232ef576ffbaa3c$export$2091a0730eb3b2d2.WEEK_BASED_YEAR = $7232ef576ffbaa3c$var$WEEK_BASED_YEAR;
    $7232ef576ffbaa3c$export$2091a0730eb3b2d2.WEEK_BASED_YEARS = $7232ef576ffbaa3c$var$WEEK_BASED_YEARS;
    $7232ef576ffbaa3c$export$2091a0730eb3b2d2.QUARTER_YEARS = $7232ef576ffbaa3c$var$QUARTER_YEARS;
    $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.prototype.isoWeekOfWeekyear = function() {
        return this.get($7232ef576ffbaa3c$export$2091a0730eb3b2d2.WEEK_OF_WEEK_BASED_YEAR);
    };
    $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.prototype.isoWeekyear = function() {
        return this.get($7232ef576ffbaa3c$export$2091a0730eb3b2d2.WEEK_BASED_YEAR);
    };
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$export$c1929c59b9e7d355 = function() {
    function DecimalStyle(zeroChar, positiveSignChar, negativeSignChar, decimalPointChar) {
        this._zeroDigit = zeroChar;
        this._zeroDigitCharCode = zeroChar.charCodeAt(0);
        this._positiveSign = positiveSignChar;
        this._negativeSign = negativeSignChar;
        this._decimalSeparator = decimalPointChar;
    }
    var _proto = DecimalStyle.prototype;
    _proto.positiveSign = function positiveSign() {
        return this._positiveSign;
    };
    _proto.withPositiveSign = function withPositiveSign(positiveSign) {
        if (positiveSign === this._positiveSign) return this;
        return new DecimalStyle(this._zeroDigit, positiveSign, this._negativeSign, this._decimalSeparator);
    };
    _proto.negativeSign = function negativeSign() {
        return this._negativeSign;
    };
    _proto.withNegativeSign = function withNegativeSign(negativeSign) {
        if (negativeSign === this._negativeSign) return this;
        return new DecimalStyle(this._zeroDigit, this._positiveSign, negativeSign, this._decimalSeparator);
    };
    _proto.zeroDigit = function zeroDigit() {
        return this._zeroDigit;
    };
    _proto.withZeroDigit = function withZeroDigit(zeroDigit) {
        if (zeroDigit === this._zeroDigit) return this;
        return new DecimalStyle(zeroDigit, this._positiveSign, this._negativeSign, this._decimalSeparator);
    };
    _proto.decimalSeparator = function decimalSeparator() {
        return this._decimalSeparator;
    };
    _proto.withDecimalSeparator = function withDecimalSeparator(decimalSeparator) {
        if (decimalSeparator === this._decimalSeparator) return this;
        return new DecimalStyle(this._zeroDigit, this._positiveSign, this._negativeSign, decimalSeparator);
    };
    _proto.convertToDigit = function convertToDigit(char) {
        var val = char.charCodeAt(0) - this._zeroDigitCharCode;
        return val >= 0 && val <= 9 ? val : -1;
    };
    _proto.convertNumberToI18N = function convertNumberToI18N(numericText) {
        if (this._zeroDigit === "0") return numericText;
        var diff = this._zeroDigitCharCode - "0".charCodeAt(0);
        var convertedText = "";
        for(var i = 0; i < numericText.length; i++)convertedText += String.fromCharCode(numericText.charCodeAt(i) + diff);
        return convertedText;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof DecimalStyle) return this._zeroDigit === other._zeroDigit && this._positiveSign === other._positiveSign && this._negativeSign === other._negativeSign && this._decimalSeparator === other._decimalSeparator;
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._zeroDigit + this._positiveSign + this._negativeSign + this._decimalSeparator;
    };
    _proto.toString = function toString() {
        return "DecimalStyle[" + this._zeroDigit + this._positiveSign + this._negativeSign + this._decimalSeparator + "]";
    };
    DecimalStyle.of = function of() {
        throw new Error("not yet supported");
    };
    DecimalStyle.availableLocales = function availableLocales() {
        throw new Error("not yet supported");
    };
    return DecimalStyle;
}();
$7232ef576ffbaa3c$export$c1929c59b9e7d355.STANDARD = new $7232ef576ffbaa3c$export$c1929c59b9e7d355("0", "+", "-", ".");
var $7232ef576ffbaa3c$export$b2e3a42c433c0b35 = function(_Enum) {
    $7232ef576ffbaa3c$var$_inheritsLoose(SignStyle, _Enum);
    function SignStyle() {
        return _Enum.apply(this, arguments) || this;
    }
    var _proto = SignStyle.prototype;
    _proto.parse = function parse(positive, strict, fixedWidth) {
        switch(this){
            case SignStyle.NORMAL:
                return !positive || !strict;
            case SignStyle.ALWAYS:
            case SignStyle.EXCEEDS_PAD:
                return true;
            default:
                return !strict && !fixedWidth;
        }
    };
    return SignStyle;
}($7232ef576ffbaa3c$var$Enum);
$7232ef576ffbaa3c$export$b2e3a42c433c0b35.NORMAL = new $7232ef576ffbaa3c$export$b2e3a42c433c0b35("NORMAL");
$7232ef576ffbaa3c$export$b2e3a42c433c0b35.NEVER = new $7232ef576ffbaa3c$export$b2e3a42c433c0b35("NEVER");
$7232ef576ffbaa3c$export$b2e3a42c433c0b35.ALWAYS = new $7232ef576ffbaa3c$export$b2e3a42c433c0b35("ALWAYS");
$7232ef576ffbaa3c$export$b2e3a42c433c0b35.EXCEEDS_PAD = new $7232ef576ffbaa3c$export$b2e3a42c433c0b35("EXCEEDS_PAD");
$7232ef576ffbaa3c$export$b2e3a42c433c0b35.NOT_NEGATIVE = new $7232ef576ffbaa3c$export$b2e3a42c433c0b35("NOT_NEGATIVE");
var $7232ef576ffbaa3c$export$1df879243bf2e42d = function(_Enum) {
    $7232ef576ffbaa3c$var$_inheritsLoose(TextStyle, _Enum);
    function TextStyle() {
        return _Enum.apply(this, arguments) || this;
    }
    var _proto = TextStyle.prototype;
    _proto.isStandalone = function isStandalone() {
        switch(this){
            case TextStyle.FULL_STANDALONE:
            case TextStyle.SHORT_STANDALONE:
            case TextStyle.NARROW_STANDALONE:
                return true;
            default:
                return false;
        }
    };
    _proto.asStandalone = function asStandalone() {
        switch(this){
            case TextStyle.FULL:
                return TextStyle.FULL_STANDALONE;
            case TextStyle.SHORT:
                return TextStyle.SHORT_STANDALONE;
            case TextStyle.NARROW:
                return TextStyle.NARROW_STANDALONE;
            default:
                return this;
        }
    };
    _proto.asNormal = function asNormal() {
        switch(this){
            case TextStyle.FULL_STANDALONE:
                return TextStyle.FULL;
            case TextStyle.SHORT_STANDALONE:
                return TextStyle.SHORT;
            case TextStyle.NARROW_STANDALONE:
                return TextStyle.NARROW;
            default:
                return this;
        }
    };
    return TextStyle;
}($7232ef576ffbaa3c$var$Enum);
$7232ef576ffbaa3c$export$1df879243bf2e42d.FULL = new $7232ef576ffbaa3c$export$1df879243bf2e42d("FULL");
$7232ef576ffbaa3c$export$1df879243bf2e42d.FULL_STANDALONE = new $7232ef576ffbaa3c$export$1df879243bf2e42d("FULL_STANDALONE");
$7232ef576ffbaa3c$export$1df879243bf2e42d.SHORT = new $7232ef576ffbaa3c$export$1df879243bf2e42d("SHORT");
$7232ef576ffbaa3c$export$1df879243bf2e42d.SHORT_STANDALONE = new $7232ef576ffbaa3c$export$1df879243bf2e42d("SHORT_STANDALONE");
$7232ef576ffbaa3c$export$1df879243bf2e42d.NARROW = new $7232ef576ffbaa3c$export$1df879243bf2e42d("NARROW");
$7232ef576ffbaa3c$export$1df879243bf2e42d.NARROW_STANDALONE = new $7232ef576ffbaa3c$export$1df879243bf2e42d("NARROW_STANDALONE");
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$CharLiteralPrinterParser = function() {
    function CharLiteralPrinterParser(literal) {
        if (literal.length > 1) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f('invalid literal, too long: "' + literal + '"');
        this._literal = literal;
    }
    var _proto = CharLiteralPrinterParser.prototype;
    _proto.print = function print(context, buf) {
        buf.append(this._literal);
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        if (position === length) return ~position;
        var ch = text.charAt(position);
        if (context.charEquals(this._literal, ch) === false) return ~position;
        return position + this._literal.length;
    };
    _proto.toString = function toString() {
        if (this._literal === "'") return "''";
        return "'" + this._literal + "'";
    };
    return CharLiteralPrinterParser;
}();
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$CompositePrinterParser = function() {
    function CompositePrinterParser(printerParsers, optional) {
        this._printerParsers = printerParsers;
        this._optional = optional;
    }
    var _proto = CompositePrinterParser.prototype;
    _proto.withOptional = function withOptional(optional) {
        if (optional === this._optional) return this;
        return new CompositePrinterParser(this._printerParsers, optional);
    };
    _proto.print = function print(context, buf) {
        var length = buf.length();
        if (this._optional) context.startOptional();
        try {
            for(var i = 0; i < this._printerParsers.length; i++){
                var pp = this._printerParsers[i];
                if (pp.print(context, buf) === false) {
                    buf.setLength(length);
                    return true;
                }
            }
        } finally{
            if (this._optional) context.endOptional();
        }
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        if (this._optional) {
            context.startOptional();
            var pos = position;
            for(var i = 0; i < this._printerParsers.length; i++){
                var pp = this._printerParsers[i];
                pos = pp.parse(context, text, pos);
                if (pos < 0) {
                    context.endOptional(false);
                    return position;
                }
            }
            context.endOptional(true);
            return pos;
        } else {
            for(var _i = 0; _i < this._printerParsers.length; _i++){
                var _pp = this._printerParsers[_i];
                position = _pp.parse(context, text, position);
                if (position < 0) break;
            }
            return position;
        }
    };
    _proto.toString = function toString() {
        var buf = "";
        if (this._printerParsers != null) {
            buf += this._optional ? "[" : "(";
            for(var i = 0; i < this._printerParsers.length; i++){
                var pp = this._printerParsers[i];
                buf += pp.toString();
            }
            buf += this._optional ? "]" : ")";
        }
        return buf;
    };
    return CompositePrinterParser;
}();
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$FractionPrinterParser = function() {
    function FractionPrinterParser(field, minWidth, maxWidth, decimalPoint) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        if (field.range().isFixed() === false) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Field must have a fixed set of values: " + field);
        if (minWidth < 0 || minWidth > 9) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Minimum width must be from 0 to 9 inclusive but was " + minWidth);
        if (maxWidth < 1 || maxWidth > 9) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Maximum width must be from 1 to 9 inclusive but was " + maxWidth);
        if (maxWidth < minWidth) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Maximum width must exceed or equal the minimum width but " + maxWidth + " < " + minWidth);
        this.field = field;
        this.minWidth = minWidth;
        this.maxWidth = maxWidth;
        this.decimalPoint = decimalPoint;
    }
    var _proto = FractionPrinterParser.prototype;
    _proto.print = function print(context, buf) {
        var value = context.getValue(this.field);
        if (value === null) return false;
        var symbols = context.symbols();
        if (value === 0) {
            if (this.minWidth > 0) {
                if (this.decimalPoint) buf.append(symbols.decimalSeparator());
                for(var i = 0; i < this.minWidth; i++)buf.append(symbols.zeroDigit());
            }
        } else {
            var fraction = this.convertToFraction(value, symbols.zeroDigit());
            var outputScale = Math.min(Math.max(fraction.length, this.minWidth), this.maxWidth);
            fraction = fraction.substr(0, outputScale);
            if (fraction * 1 > 0) while(fraction.length > this.minWidth && fraction[fraction.length - 1] === "0")fraction = fraction.substr(0, fraction.length - 1);
            var str = fraction;
            str = symbols.convertNumberToI18N(str);
            if (this.decimalPoint) buf.append(symbols.decimalSeparator());
            buf.append(str);
        }
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var effectiveMin = context.isStrict() ? this.minWidth : 0;
        var effectiveMax = context.isStrict() ? this.maxWidth : 9;
        var length = text.length;
        if (position === length) return effectiveMin > 0 ? ~position : position;
        if (this.decimalPoint) {
            if (text[position] !== context.symbols().decimalSeparator()) return effectiveMin > 0 ? ~position : position;
            position++;
        }
        var minEndPos = position + effectiveMin;
        if (minEndPos > length) return ~position;
        var maxEndPos = Math.min(position + effectiveMax, length);
        var total = 0;
        var pos = position;
        while(pos < maxEndPos){
            var ch = text.charAt(pos++);
            var digit = context.symbols().convertToDigit(ch);
            if (digit < 0) {
                if (pos < minEndPos) return ~position;
                pos--;
                break;
            }
            total = total * 10 + digit;
        }
        var moveLeft = pos - position;
        var scale = Math.pow(10, moveLeft);
        var value = this.convertFromFraction(total, scale);
        return context.setParsedField(this.field, value, position, pos);
    };
    _proto.convertToFraction = function convertToFraction(value, zeroDigit) {
        var range = this.field.range();
        range.checkValidValue(value, this.field);
        var _min = range.minimum();
        var _range = range.maximum() - _min + 1;
        var _value = value - _min;
        var _scaled = $7232ef576ffbaa3c$var$MathUtil.intDiv(_value * 1000000000, _range);
        var fraction = "" + _scaled;
        while(fraction.length < 9)fraction = zeroDigit + fraction;
        return fraction;
    };
    _proto.convertFromFraction = function convertFromFraction(total, scale) {
        var range = this.field.range();
        var _min = range.minimum();
        var _range = range.maximum() - _min + 1;
        var _value = $7232ef576ffbaa3c$var$MathUtil.intDiv(total * _range, scale);
        return _value;
    };
    _proto.toString = function toString() {
        var decimal = this.decimalPoint ? ",DecimalPoint" : "";
        return "Fraction(" + this.field + "," + this.minWidth + "," + this.maxWidth + decimal + ")";
    };
    return FractionPrinterParser;
}();
var $7232ef576ffbaa3c$var$MAX_WIDTH = 15;
var $7232ef576ffbaa3c$var$EXCEED_POINTS = [
    0,
    10,
    100,
    1000,
    10000,
    100000,
    1000000,
    10000000,
    100000000,
    1000000000
];
var $7232ef576ffbaa3c$var$NumberPrinterParser = function() {
    function NumberPrinterParser(field, minWidth, maxWidth, signStyle, subsequentWidth) {
        if (subsequentWidth === void 0) subsequentWidth = 0;
        this._field = field;
        this._minWidth = minWidth;
        this._maxWidth = maxWidth;
        this._signStyle = signStyle;
        this._subsequentWidth = subsequentWidth;
    }
    var _proto = NumberPrinterParser.prototype;
    _proto.field = function field() {
        return this._field;
    };
    _proto.minWidth = function minWidth() {
        return this._minWidth;
    };
    _proto.maxWidth = function maxWidth() {
        return this._maxWidth;
    };
    _proto.signStyle = function signStyle() {
        return this._signStyle;
    };
    _proto.withFixedWidth = function withFixedWidth() {
        if (this._subsequentWidth === -1) return this;
        return new NumberPrinterParser(this._field, this._minWidth, this._maxWidth, this._signStyle, -1);
    };
    _proto.withSubsequentWidth = function withSubsequentWidth(subsequentWidth) {
        return new NumberPrinterParser(this._field, this._minWidth, this._maxWidth, this._signStyle, this._subsequentWidth + subsequentWidth);
    };
    _proto._isFixedWidth = function _isFixedWidth() {
        return this._subsequentWidth === -1 || this._subsequentWidth > 0 && this._minWidth === this._maxWidth && this._signStyle === $7232ef576ffbaa3c$export$b2e3a42c433c0b35.NOT_NEGATIVE;
    };
    _proto.print = function print(context, buf) {
        var contextValue = context.getValue(this._field);
        if (contextValue == null) return false;
        var value = this._getValue(context, contextValue);
        var symbols = context.symbols();
        var str = "" + Math.abs(value);
        if (str.length > this._maxWidth) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Field " + this._field + " cannot be printed as the value " + value + " exceeds the maximum print width of " + this._maxWidth);
        str = symbols.convertNumberToI18N(str);
        if (value >= 0) switch(this._signStyle){
            case $7232ef576ffbaa3c$export$b2e3a42c433c0b35.EXCEEDS_PAD:
                if (this._minWidth < $7232ef576ffbaa3c$var$MAX_WIDTH && value >= $7232ef576ffbaa3c$var$EXCEED_POINTS[this._minWidth]) buf.append(symbols.positiveSign());
                break;
            case $7232ef576ffbaa3c$export$b2e3a42c433c0b35.ALWAYS:
                buf.append(symbols.positiveSign());
                break;
        }
        else switch(this._signStyle){
            case $7232ef576ffbaa3c$export$b2e3a42c433c0b35.NORMAL:
            case $7232ef576ffbaa3c$export$b2e3a42c433c0b35.EXCEEDS_PAD:
            case $7232ef576ffbaa3c$export$b2e3a42c433c0b35.ALWAYS:
                buf.append(symbols.negativeSign());
                break;
            case $7232ef576ffbaa3c$export$b2e3a42c433c0b35.NOT_NEGATIVE:
                throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Field " + this._field + " cannot be printed as the value " + value + " cannot be negative according to the SignStyle");
        }
        for(var i = 0; i < this._minWidth - str.length; i++)buf.append(symbols.zeroDigit());
        buf.append(str);
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        if (position === length) return ~position;
        $7232ef576ffbaa3c$var$assert(position >= 0 && position < length);
        var sign = text.charAt(position);
        var negative = false;
        var positive = false;
        if (sign === context.symbols().positiveSign()) {
            if (this._signStyle.parse(true, context.isStrict(), this._minWidth === this._maxWidth) === false) return ~position;
            positive = true;
            position++;
        } else if (sign === context.symbols().negativeSign()) {
            if (this._signStyle.parse(false, context.isStrict(), this._minWidth === this._maxWidth) === false) return ~position;
            negative = true;
            position++;
        } else {
            if (this._signStyle === $7232ef576ffbaa3c$export$b2e3a42c433c0b35.ALWAYS && context.isStrict()) return ~position;
        }
        var effMinWidth = context.isStrict() || this._isFixedWidth() ? this._minWidth : 1;
        var minEndPos = position + effMinWidth;
        if (minEndPos > length) return ~position;
        var effMaxWidth = (context.isStrict() || this._isFixedWidth() ? this._maxWidth : 9) + Math.max(this._subsequentWidth, 0);
        var total = 0;
        var pos = position;
        for(var pass = 0; pass < 2; pass++){
            var maxEndPos = Math.min(pos + effMaxWidth, length);
            while(pos < maxEndPos){
                var ch = text.charAt(pos++);
                var digit = context.symbols().convertToDigit(ch);
                if (digit < 0) {
                    pos--;
                    if (pos < minEndPos) return ~position;
                    break;
                }
                if (pos - position > $7232ef576ffbaa3c$var$MAX_WIDTH) throw new $7232ef576ffbaa3c$export$5891bcae38b5fd67("number text exceeds length");
                else total = total * 10 + digit;
            }
            if (this._subsequentWidth > 0 && pass === 0) {
                var parseLen = pos - position;
                effMaxWidth = Math.max(effMinWidth, parseLen - this._subsequentWidth);
                pos = position;
                total = 0;
            } else break;
        }
        if (negative) {
            if (total === 0 && context.isStrict()) return ~(position - 1);
            if (total !== 0) total = -total;
        } else if (this._signStyle === $7232ef576ffbaa3c$export$b2e3a42c433c0b35.EXCEEDS_PAD && context.isStrict()) {
            var _parseLen = pos - position;
            if (positive) {
                if (_parseLen <= this._minWidth) return ~(position - 1);
            } else {
                if (_parseLen > this._minWidth) return ~position;
            }
        }
        return this._setValue(context, total, position, pos);
    };
    _proto._getValue = function _getValue(context, value) {
        return value;
    };
    _proto._setValue = function _setValue(context, value, errorPos, successPos) {
        return context.setParsedField(this._field, value, errorPos, successPos);
    };
    _proto.toString = function toString() {
        if (this._minWidth === 1 && this._maxWidth === $7232ef576ffbaa3c$var$MAX_WIDTH && this._signStyle === $7232ef576ffbaa3c$export$b2e3a42c433c0b35.NORMAL) return "Value(" + this._field + ")";
        if (this._minWidth === this._maxWidth && this._signStyle === $7232ef576ffbaa3c$export$b2e3a42c433c0b35.NOT_NEGATIVE) return "Value(" + this._field + "," + this._minWidth + ")";
        return "Value(" + this._field + "," + this._minWidth + "," + this._maxWidth + "," + this._signStyle + ")";
    };
    return NumberPrinterParser;
}();
var $7232ef576ffbaa3c$var$ReducedPrinterParser = function(_NumberPrinterParser) {
    $7232ef576ffbaa3c$var$_inheritsLoose(ReducedPrinterParser, _NumberPrinterParser);
    function ReducedPrinterParser(field, width, maxWidth, baseValue, baseDate) {
        var _this;
        _this = _NumberPrinterParser.call(this, field, width, maxWidth, $7232ef576ffbaa3c$export$b2e3a42c433c0b35.NOT_NEGATIVE) || this;
        if (width < 1 || width > 10) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("The width must be from 1 to 10 inclusive but was " + width);
        if (maxWidth < 1 || maxWidth > 10) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("The maxWidth must be from 1 to 10 inclusive but was " + maxWidth);
        if (maxWidth < width) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("The maxWidth must be greater than the width");
        if (baseDate === null) {
            if (field.range().isValidValue(baseValue) === false) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("The base value must be within the range of the field");
            if (baseValue + $7232ef576ffbaa3c$var$EXCEED_POINTS[width] > $7232ef576ffbaa3c$var$MathUtil.MAX_SAFE_INTEGER) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unable to add printer-parser as the range exceeds the capacity of an int");
        }
        _this._baseValue = baseValue;
        _this._baseDate = baseDate;
        return _this;
    }
    var _proto2 = ReducedPrinterParser.prototype;
    _proto2._getValue = function _getValue(context, value) {
        var absValue = Math.abs(value);
        var baseValue = this._baseValue;
        if (this._baseDate !== null) {
            context.temporal();
            var chrono = $7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE;
            baseValue = chrono.date(this._baseDate).get(this._field);
        }
        if (value >= baseValue && value < baseValue + $7232ef576ffbaa3c$var$EXCEED_POINTS[this._minWidth]) return absValue % $7232ef576ffbaa3c$var$EXCEED_POINTS[this._minWidth];
        return absValue % $7232ef576ffbaa3c$var$EXCEED_POINTS[this._maxWidth];
    };
    _proto2._setValue = function _setValue(context, value, errorPos, successPos) {
        var baseValue = this._baseValue;
        if (this._baseDate != null) {
            var chrono = context.getEffectiveChronology();
            baseValue = chrono.date(this._baseDate).get(this._field);
        }
        var parseLen = successPos - errorPos;
        if (parseLen === this._minWidth && value >= 0) {
            var range = $7232ef576ffbaa3c$var$EXCEED_POINTS[this._minWidth];
            var lastPart = baseValue % range;
            var basePart = baseValue - lastPart;
            if (baseValue > 0) value = basePart + value;
            else value = basePart - value;
            if (value < baseValue) value += range;
        }
        return context.setParsedField(this._field, value, errorPos, successPos);
    };
    _proto2.withFixedWidth = function withFixedWidth() {
        if (this._subsequentWidth === -1) return this;
        return new ReducedPrinterParser(this._field, this._minWidth, this._maxWidth, this._baseValue, this._baseDate, -1);
    };
    _proto2.withSubsequentWidth = function withSubsequentWidth(subsequentWidth) {
        return new ReducedPrinterParser(this._field, this._minWidth, this._maxWidth, this._baseValue, this._baseDate, this._subsequentWidth + subsequentWidth);
    };
    _proto2.isFixedWidth = function isFixedWidth(context) {
        if (context.isStrict() === false) return false;
        return _NumberPrinterParser.prototype.isFixedWidth.call(this, context);
    };
    _proto2.toString = function toString() {
        return "ReducedValue(" + this._field + "," + this._minWidth + "," + this._maxWidth + "," + (this._baseDate != null ? this._baseDate : this._baseValue) + ")";
    };
    return ReducedPrinterParser;
}($7232ef576ffbaa3c$var$NumberPrinterParser);
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$PATTERNS = [
    "+HH",
    "+HHmm",
    "+HH:mm",
    "+HHMM",
    "+HH:MM",
    "+HHMMss",
    "+HH:MM:ss",
    "+HHMMSS",
    "+HH:MM:SS"
];
var $7232ef576ffbaa3c$var$OffsetIdPrinterParser = function() {
    function OffsetIdPrinterParser(noOffsetText, pattern) {
        $7232ef576ffbaa3c$var$requireNonNull(noOffsetText, "noOffsetText");
        $7232ef576ffbaa3c$var$requireNonNull(pattern, "pattern");
        this.noOffsetText = noOffsetText;
        this.type = this._checkPattern(pattern);
    }
    var _proto = OffsetIdPrinterParser.prototype;
    _proto._checkPattern = function _checkPattern(pattern) {
        for(var i = 0; i < $7232ef576ffbaa3c$var$PATTERNS.length; i++){
            if ($7232ef576ffbaa3c$var$PATTERNS[i] === pattern) return i;
        }
        throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Invalid zone offset pattern: " + pattern);
    };
    _proto.print = function print(context, buf) {
        var offsetSecs = context.getValue($7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS);
        if (offsetSecs == null) return false;
        var totalSecs = $7232ef576ffbaa3c$var$MathUtil.safeToInt(offsetSecs);
        if (totalSecs === 0) buf.append(this.noOffsetText);
        else {
            var absHours = Math.abs($7232ef576ffbaa3c$var$MathUtil.intMod($7232ef576ffbaa3c$var$MathUtil.intDiv(totalSecs, 3600), 100));
            var absMinutes = Math.abs($7232ef576ffbaa3c$var$MathUtil.intMod($7232ef576ffbaa3c$var$MathUtil.intDiv(totalSecs, 60), 60));
            var absSeconds = Math.abs($7232ef576ffbaa3c$var$MathUtil.intMod(totalSecs, 60));
            var bufPos = buf.length();
            var output = absHours;
            buf.append(totalSecs < 0 ? "-" : "+").appendChar($7232ef576ffbaa3c$var$MathUtil.intDiv(absHours, 10) + "0").appendChar($7232ef576ffbaa3c$var$MathUtil.intMod(absHours, 10) + "0");
            if (this.type >= 3 || this.type >= 1 && absMinutes > 0) {
                buf.append(this.type % 2 === 0 ? ":" : "").appendChar($7232ef576ffbaa3c$var$MathUtil.intDiv(absMinutes, 10) + "0").appendChar(absMinutes % 10 + "0");
                output += absMinutes;
                if (this.type >= 7 || this.type >= 5 && absSeconds > 0) {
                    buf.append(this.type % 2 === 0 ? ":" : "").appendChar($7232ef576ffbaa3c$var$MathUtil.intDiv(absSeconds, 10) + "0").appendChar(absSeconds % 10 + "0");
                    output += absSeconds;
                }
            }
            if (output === 0) {
                buf.setLength(bufPos);
                buf.append(this.noOffsetText);
            }
        }
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        var noOffsetLen = this.noOffsetText.length;
        if (noOffsetLen === 0) {
            if (position === length) return context.setParsedField($7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS, 0, position, position);
        } else {
            if (position === length) return ~position;
            if (context.subSequenceEquals(text, position, this.noOffsetText, 0, noOffsetLen)) return context.setParsedField($7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS, 0, position, position + noOffsetLen);
        }
        var sign = text[position];
        if (sign === "+" || sign === "-") {
            var negative = sign === "-" ? -1 : 1;
            var array = [
                0,
                0,
                0,
                0
            ];
            array[0] = position + 1;
            if ((this._parseNumber(array, 1, text, true) || this._parseNumber(array, 2, text, this.type >= 3) || this._parseNumber(array, 3, text, false)) === false) {
                var offsetSecs = $7232ef576ffbaa3c$var$MathUtil.safeZero(negative * (array[1] * 3600 + array[2] * 60 + array[3]));
                return context.setParsedField($7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS, offsetSecs, position, array[0]);
            }
        }
        if (noOffsetLen === 0) return context.setParsedField($7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS, 0, position, position + noOffsetLen);
        return ~position;
    };
    _proto._parseNumber = function _parseNumber(array, arrayIndex, parseText, required) {
        if ((this.type + 3) / 2 < arrayIndex) return false;
        var pos = array[0];
        if (this.type % 2 === 0 && arrayIndex > 1) {
            if (pos + 1 > parseText.length || parseText[pos] !== ":") return required;
            pos++;
        }
        if (pos + 2 > parseText.length) return required;
        var ch1 = parseText[pos++];
        var ch2 = parseText[pos++];
        if (ch1 < "0" || ch1 > "9" || ch2 < "0" || ch2 > "9") return required;
        var value = (ch1.charCodeAt(0) - 48) * 10 + (ch2.charCodeAt(0) - 48);
        if (value < 0 || value > 59) return required;
        array[arrayIndex] = value;
        array[0] = pos;
        return false;
    };
    _proto.toString = function toString() {
        var converted = this.noOffsetText.replace("'", "''");
        return "Offset(" + $7232ef576ffbaa3c$var$PATTERNS[this.type] + ",'" + converted + "')";
    };
    return OffsetIdPrinterParser;
}();
$7232ef576ffbaa3c$var$OffsetIdPrinterParser.INSTANCE_ID = new $7232ef576ffbaa3c$var$OffsetIdPrinterParser("Z", "+HH:MM:ss");
$7232ef576ffbaa3c$var$OffsetIdPrinterParser.PATTERNS = $7232ef576ffbaa3c$var$PATTERNS;
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$PadPrinterParserDecorator = function() {
    function PadPrinterParserDecorator(printerParser, padWidth, padChar) {
        this._printerParser = printerParser;
        this._padWidth = padWidth;
        this._padChar = padChar;
    }
    var _proto = PadPrinterParserDecorator.prototype;
    _proto.print = function print(context, buf) {
        var preLen = buf.length();
        if (this._printerParser.print(context, buf) === false) return false;
        var len = buf.length() - preLen;
        if (len > this._padWidth) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Cannot print as output of " + len + " characters exceeds pad width of " + this._padWidth);
        for(var i = 0; i < this._padWidth - len; i++)buf.insert(preLen, this._padChar);
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var strict = context.isStrict();
        var caseSensitive = context.isCaseSensitive();
        $7232ef576ffbaa3c$var$assert(!(position > text.length));
        $7232ef576ffbaa3c$var$assert(position >= 0);
        if (position === text.length) return ~position;
        var endPos = position + this._padWidth;
        if (endPos > text.length) {
            if (strict) return ~position;
            endPos = text.length;
        }
        var pos = position;
        while(pos < endPos && (caseSensitive ? text[pos] === this._padChar : context.charEquals(text[pos], this._padChar)))pos++;
        text = text.substring(0, endPos);
        var resultPos = this._printerParser.parse(context, text, pos);
        if (resultPos !== endPos && strict) return ~(position + pos);
        return resultPos;
    };
    _proto.toString = function toString() {
        return "Pad(" + this._printerParser + "," + this._padWidth + (this._padChar === " " ? ")" : ",'" + this._padChar + "')");
    };
    return PadPrinterParserDecorator;
}();
var $7232ef576ffbaa3c$var$SettingsParser = function(_Enum) {
    $7232ef576ffbaa3c$var$_inheritsLoose(SettingsParser, _Enum);
    function SettingsParser() {
        return _Enum.apply(this, arguments) || this;
    }
    var _proto = SettingsParser.prototype;
    _proto.print = function print() {
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        switch(this){
            case SettingsParser.SENSITIVE:
                context.setCaseSensitive(true);
                break;
            case SettingsParser.INSENSITIVE:
                context.setCaseSensitive(false);
                break;
            case SettingsParser.STRICT:
                context.setStrict(true);
                break;
            case SettingsParser.LENIENT:
                context.setStrict(false);
                break;
        }
        return position;
    };
    _proto.toString = function toString() {
        switch(this){
            case SettingsParser.SENSITIVE:
                return "ParseCaseSensitive(true)";
            case SettingsParser.INSENSITIVE:
                return "ParseCaseSensitive(false)";
            case SettingsParser.STRICT:
                return "ParseStrict(true)";
            case SettingsParser.LENIENT:
                return "ParseStrict(false)";
        }
    };
    return SettingsParser;
}($7232ef576ffbaa3c$var$Enum);
$7232ef576ffbaa3c$var$SettingsParser.SENSITIVE = new $7232ef576ffbaa3c$var$SettingsParser("SENSITIVE");
$7232ef576ffbaa3c$var$SettingsParser.INSENSITIVE = new $7232ef576ffbaa3c$var$SettingsParser("INSENSITIVE");
$7232ef576ffbaa3c$var$SettingsParser.STRICT = new $7232ef576ffbaa3c$var$SettingsParser("STRICT");
$7232ef576ffbaa3c$var$SettingsParser.LENIENT = new $7232ef576ffbaa3c$var$SettingsParser("LENIENT");
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$StringLiteralPrinterParser = function() {
    function StringLiteralPrinterParser(literal) {
        this._literal = literal;
    }
    var _proto = StringLiteralPrinterParser.prototype;
    _proto.print = function print(context, buf) {
        buf.append(this._literal);
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        $7232ef576ffbaa3c$var$assert(!(position > length || position < 0));
        if (context.subSequenceEquals(text, position, this._literal, 0, this._literal.length) === false) return ~position;
        return position + this._literal.length;
    };
    _proto.toString = function toString() {
        var converted = this._literal.replace("'", "''");
        return "'" + converted + "'";
    };
    return StringLiteralPrinterParser;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter, Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$export$79d73e02cd645302 = function() {
    function ZoneRulesProvider() {}
    ZoneRulesProvider.getRules = function getRules(zoneId) {
        throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("unsupported ZoneId:" + zoneId);
    };
    ZoneRulesProvider.getAvailableZoneIds = function getAvailableZoneIds() {
        return [];
    };
    return ZoneRulesProvider;
}();
var $7232ef576ffbaa3c$export$9caa52e4e516e67d = function(_ZoneId) {
    $7232ef576ffbaa3c$var$_inheritsLoose(ZoneRegion, _ZoneId);
    ZoneRegion.ofId = function ofId(zoneId) {
        var rules = $7232ef576ffbaa3c$export$79d73e02cd645302.getRules(zoneId);
        return new ZoneRegion(zoneId, rules);
    };
    function ZoneRegion(id, rules) {
        var _this;
        _this = _ZoneId.call(this) || this;
        _this._id = id;
        _this._rules = rules;
        return _this;
    }
    var _proto = ZoneRegion.prototype;
    _proto.id = function id() {
        return this._id;
    };
    _proto.rules = function rules() {
        return this._rules;
    };
    return ZoneRegion;
}($7232ef576ffbaa3c$export$a514a0be1f00ef62);
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$ZoneIdPrinterParser = function() {
    function ZoneIdPrinterParser(query, description) {
        this.query = query;
        this.description = description;
    }
    var _proto = ZoneIdPrinterParser.prototype;
    _proto.print = function print(context, buf) {
        var zone = context.getValueQuery(this.query);
        if (zone == null) return false;
        buf.append(zone.id());
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        if (position > length) return ~position;
        if (position === length) return ~position;
        var nextChar = text.charAt(position);
        if (nextChar === "+" || nextChar === "-") {
            var newContext = context.copy();
            var endPos = $7232ef576ffbaa3c$var$OffsetIdPrinterParser.INSTANCE_ID.parse(newContext, text, position);
            if (endPos < 0) return endPos;
            var offset = newContext.getParsed($7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS);
            var zone = $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.ofTotalSeconds(offset);
            context.setParsedZone(zone);
            return endPos;
        } else if (length >= position + 2) {
            var nextNextChar = text.charAt(position + 1);
            if (context.charEquals(nextChar, "U") && context.charEquals(nextNextChar, "T")) {
                if (length >= position + 3 && context.charEquals(text.charAt(position + 2), "C")) return this._parsePrefixedOffset(context, text, position, position + 3);
                return this._parsePrefixedOffset(context, text, position, position + 2);
            } else if (context.charEquals(nextChar, "G") && length >= position + 3 && context.charEquals(nextNextChar, "M") && context.charEquals(text.charAt(position + 2), "T")) return this._parsePrefixedOffset(context, text, position, position + 3);
        }
        if (text.substr(position, 6) === "SYSTEM") {
            context.setParsedZone($7232ef576ffbaa3c$export$a514a0be1f00ef62.systemDefault());
            return position + 6;
        }
        if (context.charEquals(nextChar, "Z")) {
            context.setParsedZone($7232ef576ffbaa3c$export$47ce5d56ab10eaa3.UTC);
            return position + 1;
        }
        var availableZoneIds = $7232ef576ffbaa3c$export$79d73e02cd645302.getAvailableZoneIds();
        if ($7232ef576ffbaa3c$var$zoneIdTree.size !== availableZoneIds.length) $7232ef576ffbaa3c$var$zoneIdTree = $7232ef576ffbaa3c$var$ZoneIdTree.createTreeMap(availableZoneIds);
        var maxParseLength = length - position;
        var treeMap = $7232ef576ffbaa3c$var$zoneIdTree.treeMap;
        var parsedZoneId = null;
        var parseLength = 0;
        while(treeMap != null){
            var parsedSubZoneId = text.substr(position, Math.min(treeMap.length, maxParseLength));
            treeMap = treeMap.get(parsedSubZoneId);
            if (treeMap != null && treeMap.isLeaf) {
                parsedZoneId = parsedSubZoneId;
                parseLength = treeMap.length;
            }
        }
        if (parsedZoneId != null) {
            context.setParsedZone($7232ef576ffbaa3c$export$9caa52e4e516e67d.ofId(parsedZoneId));
            return position + parseLength;
        }
        return ~position;
    };
    _proto._parsePrefixedOffset = function _parsePrefixedOffset(context, text, prefixPos, position) {
        var prefix = text.substring(prefixPos, position).toUpperCase();
        var newContext = context.copy();
        if (position < text.length && context.charEquals(text.charAt(position), "Z")) {
            context.setParsedZone($7232ef576ffbaa3c$export$a514a0be1f00ef62.ofOffset(prefix, $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.UTC));
            return position;
        }
        var endPos = $7232ef576ffbaa3c$var$OffsetIdPrinterParser.INSTANCE_ID.parse(newContext, text, position);
        if (endPos < 0) {
            context.setParsedZone($7232ef576ffbaa3c$export$a514a0be1f00ef62.ofOffset(prefix, $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.UTC));
            return position;
        }
        var offsetSecs = newContext.getParsed($7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS);
        var offset = $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.ofTotalSeconds(offsetSecs);
        context.setParsedZone($7232ef576ffbaa3c$export$a514a0be1f00ef62.ofOffset(prefix, offset));
        return endPos;
    };
    _proto.toString = function toString() {
        return this.description;
    };
    return ZoneIdPrinterParser;
}();
var $7232ef576ffbaa3c$var$ZoneIdTree = function() {
    ZoneIdTree.createTreeMap = function createTreeMap(availableZoneIds) {
        var sortedZoneIds = availableZoneIds.sort(function(a, b) {
            return a.length - b.length;
        });
        var treeMap = new $7232ef576ffbaa3c$var$ZoneIdTreeMap(sortedZoneIds[0].length, false);
        for(var i = 0; i < sortedZoneIds.length; i++)treeMap.add(sortedZoneIds[i]);
        return new ZoneIdTree(sortedZoneIds.length, treeMap);
    };
    function ZoneIdTree(size, treeMap) {
        this.size = size;
        this.treeMap = treeMap;
    }
    return ZoneIdTree;
}();
var $7232ef576ffbaa3c$var$ZoneIdTreeMap = function() {
    function ZoneIdTreeMap(length, isLeaf) {
        if (length === void 0) length = 0;
        if (isLeaf === void 0) isLeaf = false;
        this.length = length;
        this.isLeaf = isLeaf;
        this._treeMap = {};
    }
    var _proto2 = ZoneIdTreeMap.prototype;
    _proto2.add = function add(zoneId) {
        var idLength = zoneId.length;
        if (idLength === this.length) this._treeMap[zoneId] = new ZoneIdTreeMap(idLength, true);
        else if (idLength > this.length) {
            var subZoneId = zoneId.substr(0, this.length);
            var subTreeMap = this._treeMap[subZoneId];
            if (subTreeMap == null) {
                subTreeMap = new ZoneIdTreeMap(idLength, false);
                this._treeMap[subZoneId] = subTreeMap;
            }
            subTreeMap.add(zoneId);
        }
    };
    _proto2.get = function get(zoneId) {
        return this._treeMap[zoneId];
    };
    return ZoneIdTreeMap;
}();
var $7232ef576ffbaa3c$var$zoneIdTree = new $7232ef576ffbaa3c$var$ZoneIdTree([]);
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$MAX_WIDTH$1 = 15;
var $7232ef576ffbaa3c$export$81529fd372517959 = function() {
    function DateTimeFormatterBuilder() {
        this._active = this;
        this._parent = null;
        this._printerParsers = [];
        this._optional = false;
        this._padNextWidth = 0;
        this._padNextChar = null;
        this._valueParserIndex = -1;
    }
    DateTimeFormatterBuilder._of = function _of(parent, optional) {
        $7232ef576ffbaa3c$var$requireNonNull(parent, "parent");
        $7232ef576ffbaa3c$var$requireNonNull(optional, "optional");
        var dtFormatterBuilder = new DateTimeFormatterBuilder();
        dtFormatterBuilder._parent = parent;
        dtFormatterBuilder._optional = optional;
        return dtFormatterBuilder;
    };
    var _proto = DateTimeFormatterBuilder.prototype;
    _proto.parseCaseSensitive = function parseCaseSensitive() {
        this._appendInternalPrinterParser($7232ef576ffbaa3c$var$SettingsParser.SENSITIVE);
        return this;
    };
    _proto.parseCaseInsensitive = function parseCaseInsensitive() {
        this._appendInternalPrinterParser($7232ef576ffbaa3c$var$SettingsParser.INSENSITIVE);
        return this;
    };
    _proto.parseStrict = function parseStrict() {
        this._appendInternalPrinterParser($7232ef576ffbaa3c$var$SettingsParser.STRICT);
        return this;
    };
    _proto.parseLenient = function parseLenient() {
        this._appendInternalPrinterParser($7232ef576ffbaa3c$var$SettingsParser.LENIENT);
        return this;
    };
    _proto.appendValue = function appendValue() {
        if (arguments.length === 1) return this._appendValue1.apply(this, arguments);
        else if (arguments.length === 2) return this._appendValue2.apply(this, arguments);
        else return this._appendValue4.apply(this, arguments);
    };
    _proto._appendValue1 = function _appendValue1(field) {
        $7232ef576ffbaa3c$var$requireNonNull(field);
        this._appendValuePrinterParser(new $7232ef576ffbaa3c$var$NumberPrinterParser(field, 1, $7232ef576ffbaa3c$var$MAX_WIDTH$1, $7232ef576ffbaa3c$export$b2e3a42c433c0b35.NORMAL));
        return this;
    };
    _proto._appendValue2 = function _appendValue2(field, width) {
        $7232ef576ffbaa3c$var$requireNonNull(field);
        if (width < 1 || width > $7232ef576ffbaa3c$var$MAX_WIDTH$1) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("The width must be from 1 to " + $7232ef576ffbaa3c$var$MAX_WIDTH$1 + " inclusive but was " + width);
        var pp = new $7232ef576ffbaa3c$var$NumberPrinterParser(field, width, width, $7232ef576ffbaa3c$export$b2e3a42c433c0b35.NOT_NEGATIVE);
        this._appendValuePrinterParser(pp);
        return this;
    };
    _proto._appendValue4 = function _appendValue4(field, minWidth, maxWidth, signStyle) {
        $7232ef576ffbaa3c$var$requireNonNull(field);
        $7232ef576ffbaa3c$var$requireNonNull(signStyle);
        if (minWidth === maxWidth && signStyle === $7232ef576ffbaa3c$export$b2e3a42c433c0b35.NOT_NEGATIVE) return this._appendValue2(field, maxWidth);
        if (minWidth < 1 || minWidth > $7232ef576ffbaa3c$var$MAX_WIDTH$1) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("The minimum width must be from 1 to " + $7232ef576ffbaa3c$var$MAX_WIDTH$1 + " inclusive but was " + minWidth);
        if (maxWidth < 1 || maxWidth > $7232ef576ffbaa3c$var$MAX_WIDTH$1) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("The minimum width must be from 1 to " + $7232ef576ffbaa3c$var$MAX_WIDTH$1 + " inclusive but was " + maxWidth);
        if (maxWidth < minWidth) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("The maximum width must exceed or equal the minimum width but " + maxWidth + " < " + minWidth);
        var pp = new $7232ef576ffbaa3c$var$NumberPrinterParser(field, minWidth, maxWidth, signStyle);
        this._appendValuePrinterParser(pp);
        return this;
    };
    _proto.appendValueReduced = function appendValueReduced() {
        if (arguments.length === 4 && arguments[3] instanceof $7232ef576ffbaa3c$export$2a07e3472bc98879) return this._appendValueReducedFieldWidthMaxWidthBaseDate.apply(this, arguments);
        else return this._appendValueReducedFieldWidthMaxWidthBaseValue.apply(this, arguments);
    };
    _proto._appendValueReducedFieldWidthMaxWidthBaseValue = function _appendValueReducedFieldWidthMaxWidthBaseValue(field, width, maxWidth, baseValue) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        var pp = new $7232ef576ffbaa3c$var$ReducedPrinterParser(field, width, maxWidth, baseValue, null);
        this._appendValuePrinterParser(pp);
        return this;
    };
    _proto._appendValueReducedFieldWidthMaxWidthBaseDate = function _appendValueReducedFieldWidthMaxWidthBaseDate(field, width, maxWidth, baseDate) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        $7232ef576ffbaa3c$var$requireNonNull(baseDate, "baseDate");
        $7232ef576ffbaa3c$var$requireInstance(baseDate, $7232ef576ffbaa3c$export$2a07e3472bc98879, "baseDate");
        var pp = new $7232ef576ffbaa3c$var$ReducedPrinterParser(field, width, maxWidth, 0, baseDate);
        this._appendValuePrinterParser(pp);
        return this;
    };
    _proto._appendValuePrinterParser = function _appendValuePrinterParser(pp) {
        $7232ef576ffbaa3c$var$assert(pp != null);
        if (this._active._valueParserIndex >= 0 && this._active._printerParsers[this._active._valueParserIndex] instanceof $7232ef576ffbaa3c$var$NumberPrinterParser) {
            var activeValueParser = this._active._valueParserIndex;
            var basePP = this._active._printerParsers[activeValueParser];
            if (pp.minWidth() === pp.maxWidth() && pp.signStyle() === $7232ef576ffbaa3c$export$b2e3a42c433c0b35.NOT_NEGATIVE) {
                basePP = basePP.withSubsequentWidth(pp.maxWidth());
                this._appendInternal(pp.withFixedWidth());
                this._active._valueParserIndex = activeValueParser;
            } else {
                basePP = basePP.withFixedWidth();
                this._active._valueParserIndex = this._appendInternal(pp);
            }
            this._active._printerParsers[activeValueParser] = basePP;
        } else this._active._valueParserIndex = this._appendInternal(pp);
        return this;
    };
    _proto.appendFraction = function appendFraction(field, minWidth, maxWidth, decimalPoint) {
        this._appendInternal(new $7232ef576ffbaa3c$var$FractionPrinterParser(field, minWidth, maxWidth, decimalPoint));
        return this;
    };
    _proto.appendInstant = function appendInstant(fractionalDigits) {
        if (fractionalDigits === void 0) fractionalDigits = -2;
        if (fractionalDigits < -2 || fractionalDigits > 9) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Invalid fractional digits: " + fractionalDigits);
        this._appendInternal(new $7232ef576ffbaa3c$var$InstantPrinterParser(fractionalDigits));
        return this;
    };
    _proto.appendOffsetId = function appendOffsetId() {
        this._appendInternal($7232ef576ffbaa3c$var$OffsetIdPrinterParser.INSTANCE_ID);
        return this;
    };
    _proto.appendOffset = function appendOffset(pattern, noOffsetText) {
        this._appendInternalPrinterParser(new $7232ef576ffbaa3c$var$OffsetIdPrinterParser(noOffsetText, pattern));
        return this;
    };
    _proto.appendZoneId = function appendZoneId() {
        this._appendInternal(new $7232ef576ffbaa3c$var$ZoneIdPrinterParser($7232ef576ffbaa3c$export$d6cc568434dfd9dc.zoneId(), "ZoneId()"));
        return this;
    };
    _proto.appendPattern = function appendPattern(pattern) {
        $7232ef576ffbaa3c$var$requireNonNull(pattern, "pattern");
        this._parsePattern(pattern);
        return this;
    };
    _proto.appendZoneText = function appendZoneText() {
        throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Pattern using (localized) text not implemented, use js-joda-locale plugin!");
    };
    _proto.appendText = function appendText() {
        throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Pattern using (localized) text not implemented, use js-joda-locale plugin!");
    };
    _proto.appendLocalizedOffset = function appendLocalizedOffset() {
        throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Pattern using (localized) text not implemented, use js-joda-locale plugin!");
    };
    _proto.appendWeekField = function appendWeekField() {
        throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Pattern using (localized) text not implemented, use js-joda-locale plugin!");
    };
    _proto._parsePattern = function _parsePattern(pattern) {
        var FIELD_MAP = {
            "G": $7232ef576ffbaa3c$export$7f55a40756153c3e.ERA,
            "y": $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA,
            "u": $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR,
            "Q": $7232ef576ffbaa3c$export$2091a0730eb3b2d2.QUARTER_OF_YEAR,
            "q": $7232ef576ffbaa3c$export$2091a0730eb3b2d2.QUARTER_OF_YEAR,
            "M": $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR,
            "L": $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR,
            "D": $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR,
            "d": $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH,
            "F": $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH,
            "E": $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK,
            "c": $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK,
            "e": $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK,
            "a": $7232ef576ffbaa3c$export$7f55a40756153c3e.AMPM_OF_DAY,
            "H": $7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY,
            "k": $7232ef576ffbaa3c$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY,
            "K": $7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_AMPM,
            "h": $7232ef576ffbaa3c$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM,
            "m": $7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_HOUR,
            "s": $7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_MINUTE,
            "S": $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND,
            "A": $7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_DAY,
            "n": $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND,
            "N": $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_DAY
        };
        for(var pos = 0; pos < pattern.length; pos++){
            var cur = pattern.charAt(pos);
            if (cur >= "A" && cur <= "Z" || cur >= "a" && cur <= "z") {
                var start = pos++;
                for(; pos < pattern.length && pattern.charAt(pos) === cur; pos++);
                var count = pos - start;
                if (cur === "p") {
                    var pad = 0;
                    if (pos < pattern.length) {
                        cur = pattern.charAt(pos);
                        if (cur >= "A" && cur <= "Z" || cur >= "a" && cur <= "z") {
                            pad = count;
                            start = pos++;
                            for(; pos < pattern.length && pattern.charAt(pos) === cur; pos++);
                            count = pos - start;
                        }
                    }
                    if (pad === 0) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Pad letter 'p' must be followed by valid pad pattern: " + pattern);
                    this.padNext(pad);
                }
                var field = FIELD_MAP[cur];
                if (field != null) this._parseField(cur, count, field);
                else if (cur === "z") {
                    if (count > 4) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    else if (count === 4) this.appendZoneText($7232ef576ffbaa3c$export$1df879243bf2e42d.FULL);
                    else this.appendZoneText($7232ef576ffbaa3c$export$1df879243bf2e42d.SHORT);
                } else if (cur === "V") {
                    if (count !== 2) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Pattern letter count must be 2: " + cur);
                    this.appendZoneId();
                } else if (cur === "Z") {
                    if (count < 4) this.appendOffset("+HHMM", "+0000");
                    else if (count === 4) this.appendLocalizedOffset($7232ef576ffbaa3c$export$1df879243bf2e42d.FULL);
                    else if (count === 5) this.appendOffset("+HH:MM:ss", "Z");
                    else throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                } else if (cur === "O") {
                    if (count === 1) this.appendLocalizedOffset($7232ef576ffbaa3c$export$1df879243bf2e42d.SHORT);
                    else if (count === 4) this.appendLocalizedOffset($7232ef576ffbaa3c$export$1df879243bf2e42d.FULL);
                    else throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Pattern letter count must be 1 or 4: " + cur);
                } else if (cur === "X") {
                    if (count > 5) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    this.appendOffset($7232ef576ffbaa3c$var$OffsetIdPrinterParser.PATTERNS[count + (count === 1 ? 0 : 1)], "Z");
                } else if (cur === "x") {
                    if (count > 5) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    var zero = count === 1 ? "+00" : count % 2 === 0 ? "+0000" : "+00:00";
                    this.appendOffset($7232ef576ffbaa3c$var$OffsetIdPrinterParser.PATTERNS[count + (count === 1 ? 0 : 1)], zero);
                } else if (cur === "W") {
                    if (count > 1) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    this.appendWeekField("W", count);
                } else if (cur === "w") {
                    if (count > 2) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    this.appendWeekField("w", count);
                } else if (cur === "Y") this.appendWeekField("Y", count);
                else throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Unknown pattern letter: " + cur);
                pos--;
            } else if (cur === "'") {
                var _start = pos++;
                for(; pos < pattern.length; pos++)if (pattern.charAt(pos) === "'") {
                    if (pos + 1 < pattern.length && pattern.charAt(pos + 1) === "'") pos++;
                    else break;
                }
                if (pos >= pattern.length) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Pattern ends with an incomplete string literal: " + pattern);
                var str = pattern.substring(_start + 1, pos);
                if (str.length === 0) this.appendLiteral("'");
                else this.appendLiteral(str.replace("''", "'"));
            } else if (cur === "[") this.optionalStart();
            else if (cur === "]") {
                if (this._active._parent === null) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Pattern invalid as it contains ] without previous [");
                this.optionalEnd();
            } else if (cur === "{" || cur === "}" || cur === "#") throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Pattern includes reserved character: '" + cur + "'");
            else this.appendLiteral(cur);
        }
    };
    _proto._parseField = function _parseField(cur, count, field) {
        switch(cur){
            case "u":
            case "y":
                if (count === 2) this.appendValueReduced(field, 2, 2, $7232ef576ffbaa3c$var$ReducedPrinterParser.BASE_DATE);
                else if (count < 4) this.appendValue(field, count, $7232ef576ffbaa3c$var$MAX_WIDTH$1, $7232ef576ffbaa3c$export$b2e3a42c433c0b35.NORMAL);
                else this.appendValue(field, count, $7232ef576ffbaa3c$var$MAX_WIDTH$1, $7232ef576ffbaa3c$export$b2e3a42c433c0b35.EXCEEDS_PAD);
                break;
            case "M":
            case "Q":
                switch(count){
                    case 1:
                        this.appendValue(field);
                        break;
                    case 2:
                        this.appendValue(field, 2);
                        break;
                    case 3:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.SHORT);
                        break;
                    case 4:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.FULL);
                        break;
                    case 5:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.NARROW);
                        break;
                    default:
                        throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case "L":
            case "q":
                switch(count){
                    case 1:
                        this.appendValue(field);
                        break;
                    case 2:
                        this.appendValue(field, 2);
                        break;
                    case 3:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.SHORT_STANDALONE);
                        break;
                    case 4:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.FULL_STANDALONE);
                        break;
                    case 5:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.NARROW_STANDALONE);
                        break;
                    default:
                        throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case "e":
                switch(count){
                    case 1:
                    case 2:
                        this.appendWeekField("e", count);
                        break;
                    case 3:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.SHORT);
                        break;
                    case 4:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.FULL);
                        break;
                    case 5:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.NARROW);
                        break;
                    default:
                        throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case "c":
                switch(count){
                    case 1:
                        this.appendWeekField("c", count);
                        break;
                    case 2:
                        throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Invalid number of pattern letters: " + cur);
                    case 3:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.SHORT_STANDALONE);
                        break;
                    case 4:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.FULL_STANDALONE);
                        break;
                    case 5:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.NARROW_STANDALONE);
                        break;
                    default:
                        throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case "a":
                if (count === 1) this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.SHORT);
                else throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                break;
            case "E":
            case "G":
                switch(count){
                    case 1:
                    case 2:
                    case 3:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.SHORT);
                        break;
                    case 4:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.FULL);
                        break;
                    case 5:
                        this.appendText(field, $7232ef576ffbaa3c$export$1df879243bf2e42d.NARROW);
                        break;
                    default:
                        throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case "S":
                this.appendFraction($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND, count, count, false);
                break;
            case "F":
                if (count === 1) this.appendValue(field);
                else throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                break;
            case "d":
            case "h":
            case "H":
            case "k":
            case "K":
            case "m":
            case "s":
                if (count === 1) this.appendValue(field);
                else if (count === 2) this.appendValue(field, count);
                else throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                break;
            case "D":
                if (count === 1) this.appendValue(field);
                else if (count <= 3) this.appendValue(field, count);
                else throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                break;
            default:
                if (count === 1) this.appendValue(field);
                else this.appendValue(field, count);
                break;
        }
    };
    _proto.padNext = function padNext() {
        if (arguments.length === 1) return this._padNext1.apply(this, arguments);
        else return this._padNext2.apply(this, arguments);
    };
    _proto._padNext1 = function _padNext1(padWidth) {
        return this._padNext2(padWidth, " ");
    };
    _proto._padNext2 = function _padNext2(padWidth, padChar) {
        if (padWidth < 1) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("The pad width must be at least one but was " + padWidth);
        this._active._padNextWidth = padWidth;
        this._active._padNextChar = padChar;
        this._active._valueParserIndex = -1;
        return this;
    };
    _proto.optionalStart = function optionalStart() {
        this._active._valueParserIndex = -1;
        this._active = DateTimeFormatterBuilder._of(this._active, true);
        return this;
    };
    _proto.optionalEnd = function optionalEnd() {
        if (this._active._parent == null) throw new $7232ef576ffbaa3c$export$f79c4ffdc088dc0e("Cannot call optionalEnd() as there was no previous call to optionalStart()");
        if (this._active._printerParsers.length > 0) {
            var cpp = new $7232ef576ffbaa3c$var$CompositePrinterParser(this._active._printerParsers, this._active._optional);
            this._active = this._active._parent;
            this._appendInternal(cpp);
        } else this._active = this._active._parent;
        return this;
    };
    _proto._appendInternal = function _appendInternal(pp) {
        $7232ef576ffbaa3c$var$assert(pp != null);
        if (this._active._padNextWidth > 0) {
            if (pp != null) pp = new $7232ef576ffbaa3c$var$PadPrinterParserDecorator(pp, this._active._padNextWidth, this._active._padNextChar);
            this._active._padNextWidth = 0;
            this._active._padNextChar = 0;
        }
        this._active._printerParsers.push(pp);
        this._active._valueParserIndex = -1;
        return this._active._printerParsers.length - 1;
    };
    _proto.appendLiteral = function appendLiteral(literal) {
        $7232ef576ffbaa3c$var$assert(literal != null);
        if (literal.length > 0) {
            if (literal.length === 1) this._appendInternalPrinterParser(new $7232ef576ffbaa3c$var$CharLiteralPrinterParser(literal.charAt(0)));
            else this._appendInternalPrinterParser(new $7232ef576ffbaa3c$var$StringLiteralPrinterParser(literal));
        }
        return this;
    };
    _proto._appendInternalPrinterParser = function _appendInternalPrinterParser(pp) {
        $7232ef576ffbaa3c$var$assert(pp != null);
        if (this._active._padNextWidth > 0) {
            if (pp != null) pp = new $7232ef576ffbaa3c$var$PadPrinterParserDecorator(pp, this._active._padNextWidth, this._active._padNextChar);
            this._active._padNextWidth = 0;
            this._active._padNextChar = 0;
        }
        this._active._printerParsers.push(pp);
        this._active._valueParserIndex = -1;
        return this._active._printerParsers.length - 1;
    };
    _proto.append = function append(formatter) {
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        this._appendInternal(formatter._toPrinterParser(false));
        return this;
    };
    _proto.toFormatter = function toFormatter(resolverStyle) {
        if (resolverStyle === void 0) resolverStyle = $7232ef576ffbaa3c$export$2a833e4d13229d66.SMART;
        while(this._active._parent != null)this.optionalEnd();
        var pp = new $7232ef576ffbaa3c$var$CompositePrinterParser(this._printerParsers, false);
        return new $7232ef576ffbaa3c$export$3245e15bf4cbdd6c(pp, null, $7232ef576ffbaa3c$export$c1929c59b9e7d355.STANDARD, resolverStyle, null, null, null);
    };
    return DateTimeFormatterBuilder;
}();
var $7232ef576ffbaa3c$var$SECONDS_PER_10000_YEARS = 315569520000;
var $7232ef576ffbaa3c$var$SECONDS_0000_TO_1970 = 62167219200;
var $7232ef576ffbaa3c$var$InstantPrinterParser = function() {
    function InstantPrinterParser(fractionalDigits) {
        this.fractionalDigits = fractionalDigits;
    }
    var _proto2 = InstantPrinterParser.prototype;
    _proto2.print = function print(context, buf) {
        var inSecs = context.getValue($7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS);
        var inNanos = 0;
        if (context.temporal().isSupported($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND)) inNanos = context.temporal().getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND);
        if (inSecs == null) return false;
        var inSec = inSecs;
        var inNano = $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidIntValue(inNanos);
        if (inSec >= -$7232ef576ffbaa3c$var$SECONDS_0000_TO_1970) {
            var zeroSecs = inSec - $7232ef576ffbaa3c$var$SECONDS_PER_10000_YEARS + $7232ef576ffbaa3c$var$SECONDS_0000_TO_1970;
            var hi = $7232ef576ffbaa3c$var$MathUtil.floorDiv(zeroSecs, $7232ef576ffbaa3c$var$SECONDS_PER_10000_YEARS) + 1;
            var lo = $7232ef576ffbaa3c$var$MathUtil.floorMod(zeroSecs, $7232ef576ffbaa3c$var$SECONDS_PER_10000_YEARS);
            var ldt = $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.ofEpochSecond(lo - $7232ef576ffbaa3c$var$SECONDS_0000_TO_1970, 0, $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.UTC);
            if (hi > 0) buf.append("+").append(hi);
            buf.append(ldt);
            if (ldt.second() === 0) buf.append(":00");
        } else {
            var _zeroSecs = inSec + $7232ef576ffbaa3c$var$SECONDS_0000_TO_1970;
            var _hi = $7232ef576ffbaa3c$var$MathUtil.intDiv(_zeroSecs, $7232ef576ffbaa3c$var$SECONDS_PER_10000_YEARS);
            var _lo = $7232ef576ffbaa3c$var$MathUtil.intMod(_zeroSecs, $7232ef576ffbaa3c$var$SECONDS_PER_10000_YEARS);
            var _ldt = $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.ofEpochSecond(_lo - $7232ef576ffbaa3c$var$SECONDS_0000_TO_1970, 0, $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.UTC);
            var pos = buf.length();
            buf.append(_ldt);
            if (_ldt.second() === 0) buf.append(":00");
            if (_hi < 0) {
                if (_ldt.year() === -10000) buf.replace(pos, pos + 2, "" + (_hi - 1));
                else if (_lo === 0) buf.insert(pos, _hi);
                else buf.insert(pos + 1, Math.abs(_hi));
            }
        }
        if (this.fractionalDigits === -2) {
            if (inNano !== 0) {
                buf.append(".");
                if ($7232ef576ffbaa3c$var$MathUtil.intMod(inNano, 1000000) === 0) buf.append(("" + ($7232ef576ffbaa3c$var$MathUtil.intDiv(inNano, 1000000) + 1000)).substring(1));
                else if ($7232ef576ffbaa3c$var$MathUtil.intMod(inNano, 1000) === 0) buf.append(("" + ($7232ef576ffbaa3c$var$MathUtil.intDiv(inNano, 1000) + 1000000)).substring(1));
                else buf.append(("" + (inNano + 1000000000)).substring(1));
            }
        } else if (this.fractionalDigits > 0 || this.fractionalDigits === -1 && inNano > 0) {
            buf.append(".");
            var div = 100000000;
            for(var i = 0; this.fractionalDigits === -1 && inNano > 0 || i < this.fractionalDigits; i++){
                var digit = $7232ef576ffbaa3c$var$MathUtil.intDiv(inNano, div);
                buf.append(digit);
                inNano = inNano - digit * div;
                div = $7232ef576ffbaa3c$var$MathUtil.intDiv(div, 10);
            }
        }
        buf.append("Z");
        return true;
    };
    _proto2.parse = function parse(context, text, position) {
        var newContext = context.copy();
        var minDigits = this.fractionalDigits < 0 ? 0 : this.fractionalDigits;
        var maxDigits = this.fractionalDigits < 0 ? 9 : this.fractionalDigits;
        var parser = new $7232ef576ffbaa3c$export$81529fd372517959().append($7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE).appendLiteral("T").appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY, 2).appendLiteral(":").appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_HOUR, 2).appendLiteral(":").appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_MINUTE, 2).appendFraction($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND, minDigits, maxDigits, true).appendLiteral("Z").toFormatter()._toPrinterParser(false);
        var pos = parser.parse(newContext, text, position);
        if (pos < 0) return pos;
        var yearParsed = newContext.getParsed($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR);
        var month = newContext.getParsed($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR);
        var day = newContext.getParsed($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH);
        var hour = newContext.getParsed($7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY);
        var min = newContext.getParsed($7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_HOUR);
        var secVal = newContext.getParsed($7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_MINUTE);
        var nanoVal = newContext.getParsed($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND);
        var sec = secVal != null ? secVal : 0;
        var nano = nanoVal != null ? nanoVal : 0;
        var year = $7232ef576ffbaa3c$var$MathUtil.intMod(yearParsed, 10000);
        var days = 0;
        if (hour === 24 && min === 0 && sec === 0 && nano === 0) {
            hour = 0;
            days = 1;
        } else if (hour === 23 && min === 59 && sec === 60) {
            context.setParsedLeapSecond();
            sec = 59;
        }
        var instantSecs;
        try {
            var ldt = $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.of(year, month, day, hour, min, sec, 0).plusDays(days);
            instantSecs = ldt.toEpochSecond($7232ef576ffbaa3c$export$47ce5d56ab10eaa3.UTC);
            instantSecs += $7232ef576ffbaa3c$var$MathUtil.safeMultiply($7232ef576ffbaa3c$var$MathUtil.intDiv(yearParsed, 10000), $7232ef576ffbaa3c$var$SECONDS_PER_10000_YEARS);
        } catch (ex) {
            return ~position;
        }
        var successPos = pos;
        successPos = context.setParsedField($7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS, instantSecs, position, successPos);
        return context.setParsedField($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND, nano, position, successPos);
    };
    _proto2.toString = function toString() {
        return "Instant()";
    };
    return InstantPrinterParser;
}();
function $7232ef576ffbaa3c$var$_init$9() {
    $7232ef576ffbaa3c$var$ReducedPrinterParser.BASE_DATE = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(2000, 1, 1);
    $7232ef576ffbaa3c$export$81529fd372517959.CompositePrinterParser = $7232ef576ffbaa3c$var$CompositePrinterParser;
    $7232ef576ffbaa3c$export$81529fd372517959.PadPrinterParserDecorator = $7232ef576ffbaa3c$var$PadPrinterParserDecorator;
    $7232ef576ffbaa3c$export$81529fd372517959.SettingsParser = $7232ef576ffbaa3c$var$SettingsParser;
    $7232ef576ffbaa3c$export$81529fd372517959.CharLiteralPrinterParser = $7232ef576ffbaa3c$var$StringLiteralPrinterParser;
    $7232ef576ffbaa3c$export$81529fd372517959.StringLiteralPrinterParser = $7232ef576ffbaa3c$var$StringLiteralPrinterParser;
    $7232ef576ffbaa3c$export$81529fd372517959.CharLiteralPrinterParser = $7232ef576ffbaa3c$var$CharLiteralPrinterParser;
    $7232ef576ffbaa3c$export$81529fd372517959.NumberPrinterParser = $7232ef576ffbaa3c$var$NumberPrinterParser;
    $7232ef576ffbaa3c$export$81529fd372517959.ReducedPrinterParser = $7232ef576ffbaa3c$var$ReducedPrinterParser;
    $7232ef576ffbaa3c$export$81529fd372517959.FractionPrinterParser = $7232ef576ffbaa3c$var$FractionPrinterParser;
    $7232ef576ffbaa3c$export$81529fd372517959.OffsetIdPrinterParser = $7232ef576ffbaa3c$var$OffsetIdPrinterParser;
    $7232ef576ffbaa3c$export$81529fd372517959.ZoneIdPrinterParser = $7232ef576ffbaa3c$var$ZoneIdPrinterParser;
}
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$StringBuilder = function() {
    function StringBuilder() {
        this._str = "";
    }
    var _proto = StringBuilder.prototype;
    _proto.append = function append(str) {
        this._str += str;
        return this;
    };
    _proto.appendChar = function appendChar(str) {
        this._str += str[0];
        return this;
    };
    _proto.insert = function insert(offset, str) {
        this._str = this._str.slice(0, offset) + str + this._str.slice(offset);
        return this;
    };
    _proto.replace = function replace(start, end, str) {
        this._str = this._str.slice(0, start) + str + this._str.slice(end);
        return this;
    };
    _proto.length = function length() {
        return this._str.length;
    };
    _proto.setLength = function setLength(length) {
        this._str = this._str.slice(0, length);
        return this;
    };
    _proto.toString = function toString() {
        return this._str;
    };
    return StringBuilder;
}();
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$export$3245e15bf4cbdd6c = function() {
    DateTimeFormatter.parsedExcessDays = function parsedExcessDays() {
        return DateTimeFormatter.PARSED_EXCESS_DAYS;
    };
    DateTimeFormatter.parsedLeapSecond = function parsedLeapSecond() {
        return DateTimeFormatter.PARSED_LEAP_SECOND;
    };
    DateTimeFormatter.ofPattern = function ofPattern(pattern) {
        return new $7232ef576ffbaa3c$export$81529fd372517959().appendPattern(pattern).toFormatter();
    };
    function DateTimeFormatter(printerParser, locale, decimalStyle, resolverStyle, resolverFields, chrono, zone) {
        if (chrono === void 0) chrono = $7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE;
        $7232ef576ffbaa3c$var$assert(printerParser != null);
        $7232ef576ffbaa3c$var$assert(decimalStyle != null);
        $7232ef576ffbaa3c$var$assert(resolverStyle != null);
        this._printerParser = printerParser;
        this._locale = locale;
        this._decimalStyle = decimalStyle;
        this._resolverStyle = resolverStyle;
        this._resolverFields = resolverFields;
        this._chrono = chrono;
        this._zone = zone;
    }
    var _proto = DateTimeFormatter.prototype;
    _proto.locale = function locale() {
        return this._locale;
    };
    _proto.decimalStyle = function decimalStyle() {
        return this._decimalStyle;
    };
    _proto.chronology = function chronology() {
        return this._chrono;
    };
    _proto.withChronology = function withChronology(chrono) {
        if (this._chrono != null && this._chrono.equals(chrono)) return this;
        return new DateTimeFormatter(this._printerParser, this._locale, this._decimalStyle, this._resolverStyle, this._resolverFields, chrono, this._zone);
    };
    _proto.withLocale = function withLocale() {
        return this;
    };
    _proto.withResolverStyle = function withResolverStyle(resolverStyle) {
        $7232ef576ffbaa3c$var$requireNonNull(resolverStyle, "resolverStyle");
        if (resolverStyle.equals(this._resolverStyle)) return this;
        return new DateTimeFormatter(this._printerParser, this._locale, this._decimalStyle, resolverStyle, this._resolverFields, this._chrono, this._zone);
    };
    _proto.format = function format(temporal) {
        var buf = new $7232ef576ffbaa3c$var$StringBuilder(32);
        this._formatTo(temporal, buf);
        return buf.toString();
    };
    _proto._formatTo = function _formatTo(temporal, appendable) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        $7232ef576ffbaa3c$var$requireNonNull(appendable, "appendable");
        var context = new $7232ef576ffbaa3c$var$DateTimePrintContext(temporal, this);
        this._printerParser.print(context, appendable);
    };
    _proto.parse = function parse(text, type) {
        if (arguments.length === 1) return this.parse1(text);
        else return this.parse2(text, type);
    };
    _proto.parse1 = function parse1(text) {
        $7232ef576ffbaa3c$var$requireNonNull(text, "text");
        try {
            return this._parseToBuilder(text, null).resolve(this._resolverStyle, this._resolverFields);
        } catch (ex) {
            if (ex instanceof $7232ef576ffbaa3c$export$ce8a206818942248) throw ex;
            else throw this._createError(text, ex);
        }
    };
    _proto.parse2 = function parse2(text, type) {
        $7232ef576ffbaa3c$var$requireNonNull(text, "text");
        $7232ef576ffbaa3c$var$requireNonNull(type, "type");
        try {
            var builder = this._parseToBuilder(text, null).resolve(this._resolverStyle, this._resolverFields);
            return builder.build(type);
        } catch (ex) {
            if (ex instanceof $7232ef576ffbaa3c$export$ce8a206818942248) throw ex;
            else throw this._createError(text, ex);
        }
    };
    _proto._createError = function _createError(text, ex) {
        var abbr = "";
        if (text.length > 64) abbr = text.substring(0, 64) + "...";
        else abbr = text;
        return new $7232ef576ffbaa3c$export$ce8a206818942248("Text '" + abbr + "' could not be parsed: " + ex.message, text, 0, ex);
    };
    _proto._parseToBuilder = function _parseToBuilder(text, position) {
        var pos = position != null ? position : new $7232ef576ffbaa3c$var$ParsePosition(0);
        var result = this._parseUnresolved0(text, pos);
        if (result == null || pos.getErrorIndex() >= 0 || position == null && pos.getIndex() < text.length) {
            var abbr = "";
            if (text.length > 64) abbr = text.substr(0, 64).toString() + "...";
            else abbr = text;
            if (pos.getErrorIndex() >= 0) throw new $7232ef576ffbaa3c$export$ce8a206818942248("Text '" + abbr + "' could not be parsed at index " + pos.getErrorIndex(), text, pos.getErrorIndex());
            else throw new $7232ef576ffbaa3c$export$ce8a206818942248("Text '" + abbr + "' could not be parsed, unparsed text found at index " + pos.getIndex(), text, pos.getIndex());
        }
        return result.toBuilder();
    };
    _proto.parseUnresolved = function parseUnresolved(text, position) {
        return this._parseUnresolved0(text, position);
    };
    _proto._parseUnresolved0 = function _parseUnresolved0(text, position) {
        $7232ef576ffbaa3c$var$assert(text != null, "text", $7232ef576ffbaa3c$export$b6ad7a1de4697efd);
        $7232ef576ffbaa3c$var$assert(position != null, "position", $7232ef576ffbaa3c$export$b6ad7a1de4697efd);
        var context = new $7232ef576ffbaa3c$var$DateTimeParseContext(this);
        var pos = position.getIndex();
        pos = this._printerParser.parse(context, text, pos);
        if (pos < 0) {
            position.setErrorIndex(~pos);
            return null;
        }
        position.setIndex(pos);
        return context.toParsed();
    };
    _proto._toPrinterParser = function _toPrinterParser(optional) {
        return this._printerParser.withOptional(optional);
    };
    _proto.toString = function toString() {
        var pattern = this._printerParser.toString();
        return pattern.indexOf("[") === 0 ? pattern : pattern.substring(1, pattern.length - 1);
    };
    return DateTimeFormatter;
}();
function $7232ef576ffbaa3c$var$_init$a() {
    $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE = new $7232ef576ffbaa3c$export$81529fd372517959().appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR, 4, 10, $7232ef576ffbaa3c$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendLiteral("-").appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR, 2).appendLiteral("-").appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH, 2).toFormatter($7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT).withChronology($7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE);
    $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_LOCAL_TIME = new $7232ef576ffbaa3c$export$81529fd372517959().appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY, 2).appendLiteral(":").appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_HOUR, 2).optionalStart().appendLiteral(":").appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_MINUTE, 2).optionalStart().appendFraction($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND, 0, 9, true).toFormatter($7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT);
    $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE_TIME = new $7232ef576ffbaa3c$export$81529fd372517959().parseCaseInsensitive().append($7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE).appendLiteral("T").append($7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_LOCAL_TIME).toFormatter($7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT).withChronology($7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE);
    $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_INSTANT = new $7232ef576ffbaa3c$export$81529fd372517959().parseCaseInsensitive().appendInstant().toFormatter($7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT);
    $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_OFFSET_DATE_TIME = new $7232ef576ffbaa3c$export$81529fd372517959().parseCaseInsensitive().append($7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE_TIME).appendOffsetId().toFormatter($7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT).withChronology($7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE);
    $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_ZONED_DATE_TIME = new $7232ef576ffbaa3c$export$81529fd372517959().append($7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_OFFSET_DATE_TIME).optionalStart().appendLiteral("[").parseCaseSensitive().appendZoneId().appendLiteral("]").toFormatter($7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT).withChronology($7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE);
    $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.BASIC_ISO_DATE = new $7232ef576ffbaa3c$export$81529fd372517959().appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR, 4, 10, $7232ef576ffbaa3c$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR, 2).appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH, 2).toFormatter($7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT).withChronology($7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE);
    $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_OFFSET_DATE = new $7232ef576ffbaa3c$export$81529fd372517959().parseCaseInsensitive().append($7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE).appendOffsetId().toFormatter($7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT).withChronology($7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE);
    $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_OFFSET_TIME = new $7232ef576ffbaa3c$export$81529fd372517959().parseCaseInsensitive().append($7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_LOCAL_TIME).appendOffsetId().toFormatter($7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT).withChronology($7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE);
    $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_ORDINAL_DATE = new $7232ef576ffbaa3c$export$81529fd372517959().appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR, 4, 10, $7232ef576ffbaa3c$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendLiteral("-").appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR).toFormatter($7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT);
    $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_WEEK_DATE = new $7232ef576ffbaa3c$export$81529fd372517959().appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR, 4, 10, $7232ef576ffbaa3c$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendLiteral("-W").appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR).appendLiteral("-").appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK).toFormatter($7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT);
    $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.PARSED_EXCESS_DAYS = $7232ef576ffbaa3c$var$createTemporalQuery("PARSED_EXCESS_DAYS", function(temporal) {
        if (temporal instanceof $7232ef576ffbaa3c$var$DateTimeBuilder) return temporal.excessDays;
        else return $7232ef576ffbaa3c$export$67186dcd8fa4f92f.ZERO;
    });
    $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.PARSED_LEAP_SECOND = $7232ef576ffbaa3c$var$createTemporalQuery("PARSED_LEAP_SECOND", function(temporal) {
        if (temporal instanceof $7232ef576ffbaa3c$var$DateTimeBuilder) return temporal.leapSecond;
        else return false;
    });
}
var $7232ef576ffbaa3c$export$30964d9b15071608 = function(_Temporal) {
    $7232ef576ffbaa3c$var$_inheritsLoose(MonthDay, _Temporal);
    MonthDay.now = function now(zoneIdOrClock) {
        if (arguments.length === 0) return MonthDay.now0();
        else if (arguments.length === 1 && zoneIdOrClock instanceof $7232ef576ffbaa3c$export$a514a0be1f00ef62) return MonthDay.nowZoneId(zoneIdOrClock);
        else return MonthDay.nowClock(zoneIdOrClock);
    };
    MonthDay.now0 = function now0() {
        return this.nowClock($7232ef576ffbaa3c$export$9735c82c4bae3302.systemDefaultZone());
    };
    MonthDay.nowZoneId = function nowZoneId(zone) {
        $7232ef576ffbaa3c$var$requireNonNull(zone, "zone");
        return this.nowClock($7232ef576ffbaa3c$export$9735c82c4bae3302.system(zone));
    };
    MonthDay.nowClock = function nowClock(clock) {
        $7232ef576ffbaa3c$var$requireNonNull(clock, "clock");
        var now = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.now(clock);
        return MonthDay.of(now.month(), now.dayOfMonth());
    };
    MonthDay.of = function of(monthOrNumber, number) {
        if (arguments.length === 2 && monthOrNumber instanceof $7232ef576ffbaa3c$export$951c8378cdfec6e6) return MonthDay.ofMonthNumber(monthOrNumber, number);
        else return MonthDay.ofNumberNumber(monthOrNumber, number);
    };
    MonthDay.ofMonthNumber = function ofMonthNumber(month, dayOfMonth) {
        $7232ef576ffbaa3c$var$requireNonNull(month, "month");
        $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH.checkValidValue(dayOfMonth);
        if (dayOfMonth > month.maxLength()) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Illegal value for DayOfMonth field, value " + dayOfMonth + " is not valid for month " + month.toString());
        return new MonthDay(month.value(), dayOfMonth);
    };
    MonthDay.ofNumberNumber = function ofNumberNumber(month, dayOfMonth) {
        $7232ef576ffbaa3c$var$requireNonNull(month, "month");
        $7232ef576ffbaa3c$var$requireNonNull(dayOfMonth, "dayOfMonth");
        return MonthDay.of($7232ef576ffbaa3c$export$951c8378cdfec6e6.of(month), dayOfMonth);
    };
    MonthDay.from = function from(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        $7232ef576ffbaa3c$var$requireInstance(temporal, $7232ef576ffbaa3c$export$e5100310ee9cc158, "temporal");
        if (temporal instanceof MonthDay) return temporal;
        try {
            return MonthDay.of(temporal.get($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR), temporal.get($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH));
        } catch (ex) {
            throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unable to obtain MonthDay from TemporalAccessor: " + temporal + ", type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ""));
        }
    };
    MonthDay.parse = function parse(text, formatter) {
        if (arguments.length === 1) return MonthDay.parseString(text);
        else return MonthDay.parseStringFormatter(text, formatter);
    };
    MonthDay.parseString = function parseString(text) {
        return MonthDay.parseStringFormatter(text, $7232ef576ffbaa3c$var$PARSER);
    };
    MonthDay.parseStringFormatter = function parseStringFormatter(text, formatter) {
        $7232ef576ffbaa3c$var$requireNonNull(text, "text");
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        $7232ef576ffbaa3c$var$requireInstance(formatter, $7232ef576ffbaa3c$export$3245e15bf4cbdd6c, "formatter");
        return formatter.parse(text, MonthDay.FROM);
    };
    function MonthDay(month, dayOfMonth) {
        var _this;
        _this = _Temporal.call(this) || this;
        _this._month = $7232ef576ffbaa3c$var$MathUtil.safeToInt(month);
        _this._day = $7232ef576ffbaa3c$var$MathUtil.safeToInt(dayOfMonth);
        return _this;
    }
    var _proto = MonthDay.prototype;
    _proto.monthValue = function monthValue() {
        return this._month;
    };
    _proto.month = function month() {
        return $7232ef576ffbaa3c$export$951c8378cdfec6e6.of(this._month);
    };
    _proto.dayOfMonth = function dayOfMonth() {
        return this._day;
    };
    _proto.isSupported = function isSupported(field) {
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return field === $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR || field === $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH;
        return field != null && field.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field === $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR) return field.range();
        else if (field === $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH) return $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, this.month().minLength(), this.month().maxLength());
        return _Temporal.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            switch(field){
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH:
                    return this._day;
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR:
                    return this._month;
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.getFrom(this);
    };
    _proto.isValidYear = function isValidYear(year) {
        return (this._day === 29 && this._month === 2 && $7232ef576ffbaa3c$export$6ce2f08d515512.isLeap(year) === false) === false;
    };
    _proto.withMonth = function withMonth(month) {
        return this.with($7232ef576ffbaa3c$export$951c8378cdfec6e6.of(month));
    };
    _proto.with = function _with(month) {
        $7232ef576ffbaa3c$var$requireNonNull(month, "month");
        if (month.value() === this._month) return this;
        var day = Math.min(this._day, month.maxLength());
        return new MonthDay(month.value(), day);
    };
    _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
        if (dayOfMonth === this._day) return this;
        return MonthDay.of(this._month, dayOfMonth);
    };
    _proto.query = function query(_query) {
        $7232ef576ffbaa3c$var$requireNonNull(_query, "query");
        $7232ef576ffbaa3c$var$requireInstance(_query, $7232ef576ffbaa3c$export$3164c6c8dc6c80ff, "query");
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.chronology()) return $7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        temporal = temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR, this._month);
        return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH, Math.min(temporal.range($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH).maximum(), this._day));
    };
    _proto.atYear = function atYear(year) {
        return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(year, this._month, this.isValidYear(year) ? this._day : 28);
    };
    _proto.compareTo = function compareTo(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        $7232ef576ffbaa3c$var$requireInstance(other, MonthDay, "other");
        var cmp = this._month - other.monthValue();
        if (cmp === 0) cmp = this._day - other.dayOfMonth();
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        $7232ef576ffbaa3c$var$requireInstance(other, MonthDay, "other");
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        $7232ef576ffbaa3c$var$requireInstance(other, MonthDay, "other");
        return this.compareTo(other) < 0;
    };
    _proto.equals = function equals(obj) {
        if (this === obj) return true;
        if (obj instanceof MonthDay) {
            var other = obj;
            return this.monthValue() === other.monthValue() && this.dayOfMonth() === other.dayOfMonth();
        }
        return false;
    };
    _proto.toString = function toString() {
        return "--" + (this._month < 10 ? "0" : "") + this._month + (this._day < 10 ? "-0" : "-") + this._day;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        $7232ef576ffbaa3c$var$requireInstance(formatter, $7232ef576ffbaa3c$export$3245e15bf4cbdd6c, "formatter");
        return formatter.format(this);
    };
    return MonthDay;
}($7232ef576ffbaa3c$export$336849d529cb05e5);
var $7232ef576ffbaa3c$var$PARSER;
function $7232ef576ffbaa3c$var$_init$b() {
    $7232ef576ffbaa3c$var$PARSER = new $7232ef576ffbaa3c$export$81529fd372517959().appendLiteral("--").appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR, 2).appendLiteral("-").appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH, 2).toFormatter();
    $7232ef576ffbaa3c$export$30964d9b15071608.FROM = $7232ef576ffbaa3c$var$createTemporalQuery("MonthDay.FROM", function(temporal) {
        return $7232ef576ffbaa3c$export$30964d9b15071608.from(temporal);
    });
}
var $7232ef576ffbaa3c$export$b707805e12671f51 = function(_Temporal) {
    $7232ef576ffbaa3c$var$_inheritsLoose(YearMonth, _Temporal);
    YearMonth.now = function now(zoneIdOrClock) {
        if (arguments.length === 0) return YearMonth.now0();
        else if (arguments.length === 1 && zoneIdOrClock instanceof $7232ef576ffbaa3c$export$a514a0be1f00ef62) return YearMonth.nowZoneId(zoneIdOrClock);
        else return YearMonth.nowClock(zoneIdOrClock);
    };
    YearMonth.now0 = function now0() {
        return YearMonth.nowClock($7232ef576ffbaa3c$export$9735c82c4bae3302.systemDefaultZone());
    };
    YearMonth.nowZoneId = function nowZoneId(zone) {
        return YearMonth.nowClock($7232ef576ffbaa3c$export$9735c82c4bae3302.system(zone));
    };
    YearMonth.nowClock = function nowClock(clock) {
        var now = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.now(clock);
        return YearMonth.of(now.year(), now.month());
    };
    YearMonth.of = function of(year, monthOrNumber) {
        if (arguments.length === 2 && monthOrNumber instanceof $7232ef576ffbaa3c$export$951c8378cdfec6e6) return YearMonth.ofNumberMonth(year, monthOrNumber);
        else return YearMonth.ofNumberNumber(year, monthOrNumber);
    };
    YearMonth.ofNumberMonth = function ofNumberMonth(year, month) {
        $7232ef576ffbaa3c$var$requireNonNull(month, "month");
        $7232ef576ffbaa3c$var$requireInstance(month, $7232ef576ffbaa3c$export$951c8378cdfec6e6, "month");
        return YearMonth.ofNumberNumber(year, month.value());
    };
    YearMonth.ofNumberNumber = function ofNumberNumber(year, month) {
        $7232ef576ffbaa3c$var$requireNonNull(year, "year");
        $7232ef576ffbaa3c$var$requireNonNull(month, "month");
        $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR.checkValidValue(month);
        return new YearMonth(year, month);
    };
    YearMonth.from = function from(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        if (temporal instanceof YearMonth) return temporal;
        try {
            return YearMonth.of(temporal.get($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR), temporal.get($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR));
        } catch (ex) {
            throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unable to obtain YearMonth from TemporalAccessor: " + temporal + ", type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ""));
        }
    };
    YearMonth.parse = function parse(text, formatter) {
        if (arguments.length === 1) return YearMonth.parseString(text);
        else return YearMonth.parseStringFormatter(text, formatter);
    };
    YearMonth.parseString = function parseString(text) {
        return YearMonth.parseStringFormatter(text, $7232ef576ffbaa3c$var$PARSER$1);
    };
    YearMonth.parseStringFormatter = function parseStringFormatter(text, formatter) {
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        return formatter.parse(text, YearMonth.FROM);
    };
    function YearMonth(year, month) {
        var _this;
        _this = _Temporal.call(this) || this;
        _this._year = $7232ef576ffbaa3c$var$MathUtil.safeToInt(year);
        _this._month = $7232ef576ffbaa3c$var$MathUtil.safeToInt(month);
        return _this;
    }
    var _proto = YearMonth.prototype;
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (arguments.length === 1 && fieldOrUnit instanceof $7232ef576ffbaa3c$export$d879d8cdc7b5c1c9) return this.isSupportedField(fieldOrUnit);
        else return this.isSupportedUnit(fieldOrUnit);
    };
    _proto.isSupportedField = function isSupportedField(field) {
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return field === $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR || field === $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR || field === $7232ef576ffbaa3c$export$7f55a40756153c3e.PROLEPTIC_MONTH || field === $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA || field === $7232ef576ffbaa3c$export$7f55a40756153c3e.ERA;
        return field != null && field.isSupportedBy(this);
    };
    _proto.isSupportedUnit = function isSupportedUnit(unit) {
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) return unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS || unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS || unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.DECADES || unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.CENTURIES || unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLENNIA || unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.ERAS;
        return unit != null && unit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field === $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA) return this.year() <= 0 ? $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, $7232ef576ffbaa3c$export$6ce2f08d515512.MAX_VALUE + 1) : $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, $7232ef576ffbaa3c$export$6ce2f08d515512.MAX_VALUE);
        return _Temporal.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        $7232ef576ffbaa3c$var$requireInstance(field, $7232ef576ffbaa3c$export$d879d8cdc7b5c1c9, "field");
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        $7232ef576ffbaa3c$var$requireInstance(field, $7232ef576ffbaa3c$export$d879d8cdc7b5c1c9, "field");
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            switch(field){
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR:
                    return this._month;
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.PROLEPTIC_MONTH:
                    return this._getProlepticMonth();
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return this._year < 1 ? 1 - this._year : this._year;
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR:
                    return this._year;
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.ERA:
                    return this._year < 1 ? 0 : 1;
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.getFrom(this);
    };
    _proto._getProlepticMonth = function _getProlepticMonth() {
        return $7232ef576ffbaa3c$var$MathUtil.safeAdd($7232ef576ffbaa3c$var$MathUtil.safeMultiply(this._year, 12), this._month - 1);
    };
    _proto.year = function year() {
        return this._year;
    };
    _proto.monthValue = function monthValue() {
        return this._month;
    };
    _proto.month = function month() {
        return $7232ef576ffbaa3c$export$951c8378cdfec6e6.of(this._month);
    };
    _proto.isLeapYear = function isLeapYear() {
        return $7232ef576ffbaa3c$export$f47ae290cf4e4958.isLeapYear(this._year);
    };
    _proto.isValidDay = function isValidDay(dayOfMonth) {
        return dayOfMonth >= 1 && dayOfMonth <= this.lengthOfMonth();
    };
    _proto.lengthOfMonth = function lengthOfMonth() {
        return this.month().length(this.isLeapYear());
    };
    _proto.lengthOfYear = function lengthOfYear() {
        return this.isLeapYear() ? 366 : 365;
    };
    _proto.with = function _with(adjusterOrFieldOrNumber, value) {
        if (arguments.length === 1) return this.withAdjuster(adjusterOrFieldOrNumber);
        else if (arguments.length === 2 && adjusterOrFieldOrNumber instanceof $7232ef576ffbaa3c$export$d879d8cdc7b5c1c9) return this.withFieldValue(adjusterOrFieldOrNumber, value);
        else return this.withYearMonth(adjusterOrFieldOrNumber, value);
    };
    _proto.withYearMonth = function withYearMonth(newYear, newMonth) {
        $7232ef576ffbaa3c$var$requireNonNull(newYear);
        $7232ef576ffbaa3c$var$requireNonNull(newMonth);
        if (this._year === newYear && this._month === newMonth) return this;
        return new YearMonth(newYear, newMonth);
    };
    _proto.withAdjuster = function withAdjuster(adjuster) {
        $7232ef576ffbaa3c$var$requireNonNull(adjuster, "adjuster");
        return adjuster.adjustInto(this);
    };
    _proto.withFieldValue = function withFieldValue(field, newValue) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        $7232ef576ffbaa3c$var$requireInstance(field, $7232ef576ffbaa3c$export$d879d8cdc7b5c1c9, "field");
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            var f = field;
            f.checkValidValue(newValue);
            switch(f){
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR:
                    return this.withMonth(newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.PROLEPTIC_MONTH:
                    return this.plusMonths(newValue - this.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.PROLEPTIC_MONTH));
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return this.withYear(this._year < 1 ? 1 - newValue : newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR:
                    return this.withYear(newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.ERA:
                    return this.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA) === newValue ? this : this.withYear(1 - this._year);
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withYear = function withYear(year) {
        $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        return this.withYearMonth(year, this._month);
    };
    _proto.withMonth = function withMonth(month) {
        $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR.checkValidValue(month);
        return this.withYearMonth(this._year, month);
    };
    _proto.plus = function plus(amountOrNumber, unit) {
        if (arguments.length === 1) return this.plusAmount(amountOrNumber);
        else return this.plusAmountUnit(amountOrNumber, unit);
    };
    _proto.plusAmount = function plusAmount(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        $7232ef576ffbaa3c$var$requireInstance(amount, $7232ef576ffbaa3c$export$f8b2fcf02a6656ff, "amount");
        return amount.addTo(this);
    };
    _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        $7232ef576ffbaa3c$var$requireInstance(unit, $7232ef576ffbaa3c$export$5d412a4bb789788e, "unit");
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) {
            switch(unit){
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS:
                    return this.plusMonths(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS:
                    return this.plusYears(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.DECADES:
                    return this.plusYears($7232ef576ffbaa3c$var$MathUtil.safeMultiply(amountToAdd, 10));
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.CENTURIES:
                    return this.plusYears($7232ef576ffbaa3c$var$MathUtil.safeMultiply(amountToAdd, 100));
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLENNIA:
                    return this.plusYears($7232ef576ffbaa3c$var$MathUtil.safeMultiply(amountToAdd, 1000));
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.ERAS:
                    return this.with($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA, $7232ef576ffbaa3c$var$MathUtil.safeAdd(this.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA), amountToAdd));
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(yearsToAdd) {
        if (yearsToAdd === 0) return this;
        var newYear = $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidIntValue(this._year + yearsToAdd);
        return this.withYearMonth(newYear, this._month);
    };
    _proto.plusMonths = function plusMonths(monthsToAdd) {
        if (monthsToAdd === 0) return this;
        var monthCount = this._year * 12 + (this._month - 1);
        var calcMonths = monthCount + monthsToAdd;
        var newYear = $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidIntValue($7232ef576ffbaa3c$var$MathUtil.floorDiv(calcMonths, 12));
        var newMonth = $7232ef576ffbaa3c$var$MathUtil.floorMod(calcMonths, 12) + 1;
        return this.withYearMonth(newYear, newMonth);
    };
    _proto.minus = function minus(amountOrNumber, unit) {
        if (arguments.length === 1) return this.minusAmount(amountOrNumber);
        else return this.minusAmountUnit(amountOrNumber, unit);
    };
    _proto.minusAmount = function minusAmount(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        return amountToSubtract === $7232ef576ffbaa3c$var$MathUtil.MIN_SAFE_INTEGER ? this.plusAmountUnit($7232ef576ffbaa3c$var$MathUtil.MAX_SAFE_INTEGER, unit).plusAmountUnit(1, unit) : this.plusAmountUnit(-amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(yearsToSubtract) {
        return yearsToSubtract === $7232ef576ffbaa3c$var$MathUtil.MIN_SAFE_INTEGER ? this.plusYears($7232ef576ffbaa3c$var$MathUtil.MIN_SAFE_INTEGER).plusYears(1) : this.plusYears(-yearsToSubtract);
    };
    _proto.minusMonths = function minusMonths(monthsToSubtract) {
        return monthsToSubtract === $7232ef576ffbaa3c$var$MathUtil.MIN_SAFE_INTEGER ? this.plusMonths(Math.MAX_SAFE_INTEGER).plusMonths(1) : this.plusMonths(-monthsToSubtract);
    };
    _proto.query = function query(_query) {
        $7232ef576ffbaa3c$var$requireNonNull(_query, "query");
        $7232ef576ffbaa3c$var$requireInstance(_query, $7232ef576ffbaa3c$export$3164c6c8dc6c80ff, "query");
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.chronology()) return $7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.precision()) return $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localTime() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zone() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zoneId() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.offset()) return null;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        $7232ef576ffbaa3c$var$requireInstance(temporal, $7232ef576ffbaa3c$export$336849d529cb05e5, "temporal");
        return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.PROLEPTIC_MONTH, this._getProlepticMonth());
    };
    _proto.until = function until(endExclusive, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(endExclusive, "endExclusive");
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        $7232ef576ffbaa3c$var$requireInstance(endExclusive, $7232ef576ffbaa3c$export$336849d529cb05e5, "endExclusive");
        $7232ef576ffbaa3c$var$requireInstance(unit, $7232ef576ffbaa3c$export$5d412a4bb789788e, "unit");
        var end = YearMonth.from(endExclusive);
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) {
            var monthsUntil = end._getProlepticMonth() - this._getProlepticMonth();
            switch(unit){
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS:
                    return monthsUntil;
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS:
                    return monthsUntil / 12;
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.DECADES:
                    return monthsUntil / 120;
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.CENTURIES:
                    return monthsUntil / 1200;
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLENNIA:
                    return monthsUntil / 12000;
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.ERAS:
                    return end.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA) - this.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA);
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    _proto.atDay = function atDay(dayOfMonth) {
        return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(this._year, this._month, dayOfMonth);
    };
    _proto.atEndOfMonth = function atEndOfMonth() {
        return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(this._year, this._month, this.lengthOfMonth());
    };
    _proto.compareTo = function compareTo(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        $7232ef576ffbaa3c$var$requireInstance(other, YearMonth, "other");
        var cmp = this._year - other.year();
        if (cmp === 0) cmp = this._month - other.monthValue();
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        return this.compareTo(other) < 0;
    };
    _proto.equals = function equals(obj) {
        if (this === obj) return true;
        if (obj instanceof YearMonth) {
            var other = obj;
            return this.year() === other.year() && this.monthValue() === other.monthValue();
        }
        return false;
    };
    _proto.toString = function toString() {
        return $7232ef576ffbaa3c$var$PARSER$1.format(this);
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        return formatter.format(this);
    };
    return YearMonth;
}($7232ef576ffbaa3c$export$336849d529cb05e5);
var $7232ef576ffbaa3c$var$PARSER$1;
function $7232ef576ffbaa3c$var$_init$c() {
    $7232ef576ffbaa3c$var$PARSER$1 = new $7232ef576ffbaa3c$export$81529fd372517959().appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR, 4, 10, $7232ef576ffbaa3c$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendLiteral("-").appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR, 2).toFormatter();
    $7232ef576ffbaa3c$export$b707805e12671f51.FROM = $7232ef576ffbaa3c$var$createTemporalQuery("YearMonth.FROM", function(temporal) {
        return $7232ef576ffbaa3c$export$b707805e12671f51.from(temporal);
    });
}
var $7232ef576ffbaa3c$export$6ce2f08d515512 = function(_Temporal) {
    $7232ef576ffbaa3c$var$_inheritsLoose(Year, _Temporal);
    function Year(value) {
        var _this;
        _this = _Temporal.call(this) || this;
        _this._year = $7232ef576ffbaa3c$var$MathUtil.safeToInt(value);
        return _this;
    }
    var _proto = Year.prototype;
    _proto.value = function value() {
        return this._year;
    };
    Year.now = function now(zoneIdOrClock) {
        if (zoneIdOrClock === void 0) zoneIdOrClock = undefined;
        if (zoneIdOrClock === undefined) return Year.now0();
        else if (zoneIdOrClock instanceof $7232ef576ffbaa3c$export$a514a0be1f00ef62) return Year.nowZoneId(zoneIdOrClock);
        else return Year.nowClock(zoneIdOrClock);
    };
    Year.now0 = function now0() {
        return Year.nowClock($7232ef576ffbaa3c$export$9735c82c4bae3302.systemDefaultZone());
    };
    Year.nowZoneId = function nowZoneId(zone) {
        $7232ef576ffbaa3c$var$requireNonNull(zone, "zone");
        $7232ef576ffbaa3c$var$requireInstance(zone, $7232ef576ffbaa3c$export$a514a0be1f00ef62, "zone");
        return Year.nowClock($7232ef576ffbaa3c$export$9735c82c4bae3302.system(zone));
    };
    Year.nowClock = function nowClock(clock) {
        $7232ef576ffbaa3c$var$requireNonNull(clock, "clock");
        $7232ef576ffbaa3c$var$requireInstance(clock, $7232ef576ffbaa3c$export$9735c82c4bae3302, "clock");
        var now = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.now(clock);
        return Year.of(now.year());
    };
    Year.of = function of(isoYear) {
        $7232ef576ffbaa3c$var$requireNonNull(isoYear, "isoYear");
        $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidValue(isoYear);
        return new Year(isoYear);
    };
    Year.from = function from(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        $7232ef576ffbaa3c$var$requireInstance(temporal, $7232ef576ffbaa3c$export$e5100310ee9cc158, "temporal");
        if (temporal instanceof Year) return temporal;
        try {
            return Year.of(temporal.get($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR));
        } catch (ex) {
            throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unable to obtain Year from TemporalAccessor: " + temporal + ", type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ""));
        }
    };
    Year.parse = function parse(text, formatter) {
        if (arguments.length <= 1) return Year.parseText(text);
        else return Year.parseTextFormatter(text, formatter);
    };
    Year.parseText = function parseText(text) {
        $7232ef576ffbaa3c$var$requireNonNull(text, "text");
        return Year.parse(text, $7232ef576ffbaa3c$var$PARSER$2);
    };
    Year.parseTextFormatter = function parseTextFormatter(text, formatter) {
        if (formatter === void 0) formatter = $7232ef576ffbaa3c$var$PARSER$2;
        $7232ef576ffbaa3c$var$requireNonNull(text, "text");
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        $7232ef576ffbaa3c$var$requireInstance(formatter, $7232ef576ffbaa3c$export$3245e15bf4cbdd6c, "formatter");
        return formatter.parse(text, Year.FROM);
    };
    Year.isLeap = function isLeap(year) {
        return $7232ef576ffbaa3c$var$MathUtil.intMod(year, 4) === 0 && ($7232ef576ffbaa3c$var$MathUtil.intMod(year, 100) !== 0 || $7232ef576ffbaa3c$var$MathUtil.intMod(year, 400) === 0);
    };
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (arguments.length === 1 && fieldOrUnit instanceof $7232ef576ffbaa3c$export$d879d8cdc7b5c1c9) return this.isSupportedField(fieldOrUnit);
        else return this.isSupportedUnit(fieldOrUnit);
    };
    _proto.isSupportedField = function isSupportedField(field) {
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return field === $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR || field === $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA || field === $7232ef576ffbaa3c$export$7f55a40756153c3e.ERA;
        return field != null && field.isSupportedBy(this);
    };
    _proto.isSupportedUnit = function isSupportedUnit(unit) {
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) return unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS || unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.DECADES || unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.CENTURIES || unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLENNIA || unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.ERAS;
        return unit != null && unit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (this.isSupported(field)) return field.range();
        else if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        return _Temporal.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            switch(field){
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return this._year < 1 ? 1 - this._year : this._year;
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR:
                    return this._year;
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.ERA:
                    return this._year < 1 ? 0 : 1;
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.getFrom(this);
    };
    _proto.isLeap = function isLeap() {
        return Year.isLeap(this._year);
    };
    _proto.with = function _with(adjusterOrFieldOrNumber, value) {
        if (arguments.length === 2 && adjusterOrFieldOrNumber instanceof $7232ef576ffbaa3c$export$d879d8cdc7b5c1c9) return this.withFieldValue(adjusterOrFieldOrNumber, value);
        else return this.withAdjuster(adjusterOrFieldOrNumber);
    };
    _proto.withAdjuster = function withAdjuster(adjuster) {
        $7232ef576ffbaa3c$var$requireNonNull(adjuster, "adjuster");
        return adjuster.adjustInto(this);
    };
    _proto.withFieldValue = function withFieldValue(field, newValue) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        $7232ef576ffbaa3c$var$requireInstance(field, $7232ef576ffbaa3c$export$d879d8cdc7b5c1c9, "field");
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            field.checkValidValue(newValue);
            switch(field){
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return Year.of(this._year < 1 ? 1 - newValue : newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR:
                    return Year.of(newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.ERA:
                    return this.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA) === newValue ? this : Year.of(1 - this._year);
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.plus = function plus(amountOrNumber, unit) {
        if (arguments.length === 1) return this.plusAmount(amountOrNumber);
        else return this.plusAmountToAddUnit(amountOrNumber, unit);
    };
    _proto.plusAmount = function plusAmount(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        $7232ef576ffbaa3c$var$requireInstance(amount, $7232ef576ffbaa3c$export$f8b2fcf02a6656ff, "amount");
        return amount.addTo(this);
    };
    _proto.plusAmountToAddUnit = function plusAmountToAddUnit(amountToAdd, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(amountToAdd, "amountToAdd");
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        $7232ef576ffbaa3c$var$requireInstance(unit, $7232ef576ffbaa3c$export$5d412a4bb789788e, "unit");
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) {
            switch(unit){
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS:
                    return this.plusYears(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.DECADES:
                    return this.plusYears($7232ef576ffbaa3c$var$MathUtil.safeMultiply(amountToAdd, 10));
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.CENTURIES:
                    return this.plusYears($7232ef576ffbaa3c$var$MathUtil.safeMultiply(amountToAdd, 100));
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLENNIA:
                    return this.plusYears($7232ef576ffbaa3c$var$MathUtil.safeMultiply(amountToAdd, 1000));
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.ERAS:
                    return this.with($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA, $7232ef576ffbaa3c$var$MathUtil.safeAdd(this.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA), amountToAdd));
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(yearsToAdd) {
        if (yearsToAdd === 0) return this;
        return Year.of($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidIntValue($7232ef576ffbaa3c$var$MathUtil.safeAdd(this._year, yearsToAdd)));
    };
    _proto.minus = function minus(amountOrNumber, unit) {
        if (arguments.length === 1) return this.minusAmount(amountOrNumber);
        else return this.minusAmountToSubtractUnit(amountOrNumber, unit);
    };
    _proto.minusAmount = function minusAmount(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        $7232ef576ffbaa3c$var$requireInstance(amount, $7232ef576ffbaa3c$export$f8b2fcf02a6656ff, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minusAmountToSubtractUnit = function minusAmountToSubtractUnit(amountToSubtract, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(amountToSubtract, "amountToSubtract");
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        $7232ef576ffbaa3c$var$requireInstance(unit, $7232ef576ffbaa3c$export$5d412a4bb789788e, "unit");
        return amountToSubtract === $7232ef576ffbaa3c$var$MathUtil.MIN_SAFE_INTEGER ? this.plus($7232ef576ffbaa3c$var$MathUtil.MAX_SAFE_INTEGER, unit).plus(1, unit) : this.plus(-amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(yearsToSubtract) {
        return yearsToSubtract === $7232ef576ffbaa3c$var$MathUtil.MIN_SAFE_INTEGER ? this.plusYears($7232ef576ffbaa3c$var$MathUtil.MAX_SAFE_INTEGER).plusYears(1) : this.plusYears(-yearsToSubtract);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR, this._year);
    };
    _proto.isValidMonthDay = function isValidMonthDay(monthDay) {
        return monthDay != null && monthDay.isValidYear(this._year);
    };
    _proto.length = function length() {
        return this.isLeap() ? 366 : 365;
    };
    _proto.atDay = function atDay(dayOfYear) {
        return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.ofYearDay(this._year, dayOfYear);
    };
    _proto.atMonth = function atMonth(monthOrNumber) {
        if (arguments.length === 1 && monthOrNumber instanceof $7232ef576ffbaa3c$export$951c8378cdfec6e6) return this.atMonthMonth(monthOrNumber);
        else return this.atMonthNumber(monthOrNumber);
    };
    _proto.atMonthMonth = function atMonthMonth(month) {
        $7232ef576ffbaa3c$var$requireNonNull(month, "month");
        $7232ef576ffbaa3c$var$requireInstance(month, $7232ef576ffbaa3c$export$951c8378cdfec6e6, "month");
        return $7232ef576ffbaa3c$export$b707805e12671f51.of(this._year, month);
    };
    _proto.atMonthNumber = function atMonthNumber(month) {
        $7232ef576ffbaa3c$var$requireNonNull(month, "month");
        return $7232ef576ffbaa3c$export$b707805e12671f51.of(this._year, month);
    };
    _proto.atMonthDay = function atMonthDay(monthDay) {
        $7232ef576ffbaa3c$var$requireNonNull(monthDay, "monthDay");
        $7232ef576ffbaa3c$var$requireInstance(monthDay, $7232ef576ffbaa3c$export$30964d9b15071608, "monthDay");
        return monthDay.atYear(this._year);
    };
    _proto.query = function query(_query) {
        $7232ef576ffbaa3c$var$requireNonNull(_query, "query()");
        $7232ef576ffbaa3c$var$requireInstance(_query, $7232ef576ffbaa3c$export$3164c6c8dc6c80ff, "query()");
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.chronology()) return $7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.precision()) return $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localTime() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zone() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zoneId() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.offset()) return null;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.compareTo = function compareTo(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        $7232ef576ffbaa3c$var$requireInstance(other, Year, "other");
        return this._year - other._year;
    };
    _proto.isAfter = function isAfter(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        $7232ef576ffbaa3c$var$requireInstance(other, Year, "other");
        return this._year > other._year;
    };
    _proto.isBefore = function isBefore(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        $7232ef576ffbaa3c$var$requireInstance(other, Year, "other");
        return this._year < other._year;
    };
    _proto.format = function format(formatter) {
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        $7232ef576ffbaa3c$var$requireInstance(formatter, $7232ef576ffbaa3c$export$3245e15bf4cbdd6c, "formatter");
        return formatter.format(this);
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof Year) return this.value() === other.value();
        return false;
    };
    _proto.toString = function toString() {
        return "" + this._year;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return Year;
}($7232ef576ffbaa3c$export$336849d529cb05e5);
var $7232ef576ffbaa3c$var$PARSER$2;
function $7232ef576ffbaa3c$var$_init$d() {
    $7232ef576ffbaa3c$export$6ce2f08d515512.MIN_VALUE = $7232ef576ffbaa3c$export$c04b60057299af61.MIN_VALUE;
    $7232ef576ffbaa3c$export$6ce2f08d515512.MAX_VALUE = $7232ef576ffbaa3c$export$c04b60057299af61.MAX_VALUE;
    $7232ef576ffbaa3c$var$PARSER$2 = new $7232ef576ffbaa3c$export$81529fd372517959().appendValue($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR, 4, 10, $7232ef576ffbaa3c$export$b2e3a42c433c0b35.EXCEEDS_PAD).toFormatter();
    $7232ef576ffbaa3c$export$6ce2f08d515512.FROM = $7232ef576ffbaa3c$var$createTemporalQuery("Year.FROM", function(temporal) {
        return $7232ef576ffbaa3c$export$6ce2f08d515512.from(temporal);
    });
}
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$export$841f8bd48996924f = function() {
    function TemporalAdjuster() {}
    var _proto = TemporalAdjuster.prototype;
    _proto.adjustInto = function adjustInto(temporal) {
        $7232ef576ffbaa3c$var$abstractMethodFail("adjustInto");
    };
    return TemporalAdjuster;
}();
var $7232ef576ffbaa3c$export$d922854d56f8a965 = function() {
    function TemporalAdjusters() {}
    TemporalAdjusters.firstDayOfMonth = function firstDayOfMonth() {
        return $7232ef576ffbaa3c$var$Impl.FIRST_DAY_OF_MONTH;
    };
    TemporalAdjusters.lastDayOfMonth = function lastDayOfMonth() {
        return $7232ef576ffbaa3c$var$Impl.LAST_DAY_OF_MONTH;
    };
    TemporalAdjusters.firstDayOfNextMonth = function firstDayOfNextMonth() {
        return $7232ef576ffbaa3c$var$Impl.FIRST_DAY_OF_NEXT_MONTH;
    };
    TemporalAdjusters.firstDayOfYear = function firstDayOfYear() {
        return $7232ef576ffbaa3c$var$Impl.FIRST_DAY_OF_YEAR;
    };
    TemporalAdjusters.lastDayOfYear = function lastDayOfYear() {
        return $7232ef576ffbaa3c$var$Impl.LAST_DAY_OF_YEAR;
    };
    TemporalAdjusters.firstDayOfNextYear = function firstDayOfNextYear() {
        return $7232ef576ffbaa3c$var$Impl.FIRST_DAY_OF_NEXT_YEAR;
    };
    TemporalAdjusters.firstInMonth = function firstInMonth(dayOfWeek) {
        $7232ef576ffbaa3c$var$requireNonNull(dayOfWeek, "dayOfWeek");
        return new $7232ef576ffbaa3c$var$DayOfWeekInMonth(1, dayOfWeek);
    };
    TemporalAdjusters.lastInMonth = function lastInMonth(dayOfWeek) {
        $7232ef576ffbaa3c$var$requireNonNull(dayOfWeek, "dayOfWeek");
        return new $7232ef576ffbaa3c$var$DayOfWeekInMonth(-1, dayOfWeek);
    };
    TemporalAdjusters.dayOfWeekInMonth = function dayOfWeekInMonth(ordinal, dayOfWeek) {
        $7232ef576ffbaa3c$var$requireNonNull(dayOfWeek, "dayOfWeek");
        return new $7232ef576ffbaa3c$var$DayOfWeekInMonth(ordinal, dayOfWeek);
    };
    TemporalAdjusters.next = function next(dayOfWeek) {
        return new $7232ef576ffbaa3c$var$RelativeDayOfWeek(2, dayOfWeek);
    };
    TemporalAdjusters.nextOrSame = function nextOrSame(dayOfWeek) {
        return new $7232ef576ffbaa3c$var$RelativeDayOfWeek(0, dayOfWeek);
    };
    TemporalAdjusters.previous = function previous(dayOfWeek) {
        return new $7232ef576ffbaa3c$var$RelativeDayOfWeek(3, dayOfWeek);
    };
    TemporalAdjusters.previousOrSame = function previousOrSame(dayOfWeek) {
        return new $7232ef576ffbaa3c$var$RelativeDayOfWeek(1, dayOfWeek);
    };
    return TemporalAdjusters;
}();
var $7232ef576ffbaa3c$var$Impl = function(_TemporalAdjuster) {
    $7232ef576ffbaa3c$var$_inheritsLoose(Impl, _TemporalAdjuster);
    function Impl(ordinal) {
        var _this;
        _this = _TemporalAdjuster.call(this) || this;
        _this._ordinal = ordinal;
        return _this;
    }
    var _proto = Impl.prototype;
    _proto.adjustInto = function adjustInto(temporal) {
        switch(this._ordinal){
            case 0:
                return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH, 1);
            case 1:
                return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH, temporal.range($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH).maximum());
            case 2:
                return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH, 1).plus(1, $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS);
            case 3:
                return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR, 1);
            case 4:
                return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR, temporal.range($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR).maximum());
            case 5:
                return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR, 1).plus(1, $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS);
        }
        throw new $7232ef576ffbaa3c$export$f79c4ffdc088dc0e("Unreachable");
    };
    return Impl;
}($7232ef576ffbaa3c$export$841f8bd48996924f);
$7232ef576ffbaa3c$var$Impl.FIRST_DAY_OF_MONTH = new $7232ef576ffbaa3c$var$Impl(0);
$7232ef576ffbaa3c$var$Impl.LAST_DAY_OF_MONTH = new $7232ef576ffbaa3c$var$Impl(1);
$7232ef576ffbaa3c$var$Impl.FIRST_DAY_OF_NEXT_MONTH = new $7232ef576ffbaa3c$var$Impl(2);
$7232ef576ffbaa3c$var$Impl.FIRST_DAY_OF_YEAR = new $7232ef576ffbaa3c$var$Impl(3);
$7232ef576ffbaa3c$var$Impl.LAST_DAY_OF_YEAR = new $7232ef576ffbaa3c$var$Impl(4);
$7232ef576ffbaa3c$var$Impl.FIRST_DAY_OF_NEXT_YEAR = new $7232ef576ffbaa3c$var$Impl(5);
var $7232ef576ffbaa3c$var$DayOfWeekInMonth = function(_TemporalAdjuster2) {
    $7232ef576ffbaa3c$var$_inheritsLoose(DayOfWeekInMonth, _TemporalAdjuster2);
    function DayOfWeekInMonth(ordinal, dow) {
        var _this2;
        _this2 = _TemporalAdjuster2.call(this) || this;
        _this2._ordinal = ordinal;
        _this2._dowValue = dow.value();
        return _this2;
    }
    var _proto2 = DayOfWeekInMonth.prototype;
    _proto2.adjustInto = function adjustInto(temporal) {
        if (this._ordinal >= 0) {
            var temp = temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH, 1);
            var curDow = temp.get($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK);
            var dowDiff = $7232ef576ffbaa3c$var$MathUtil.intMod(this._dowValue - curDow + 7, 7);
            dowDiff += (this._ordinal - 1) * 7;
            return temp.plus(dowDiff, $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS);
        } else {
            var _temp = temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH, temporal.range($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH).maximum());
            var _curDow = _temp.get($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK);
            var daysDiff = this._dowValue - _curDow;
            daysDiff = daysDiff === 0 ? 0 : daysDiff > 0 ? daysDiff - 7 : daysDiff;
            daysDiff -= (-this._ordinal - 1) * 7;
            return _temp.plus(daysDiff, $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS);
        }
    };
    return DayOfWeekInMonth;
}($7232ef576ffbaa3c$export$841f8bd48996924f);
var $7232ef576ffbaa3c$var$RelativeDayOfWeek = function(_TemporalAdjuster3) {
    $7232ef576ffbaa3c$var$_inheritsLoose(RelativeDayOfWeek, _TemporalAdjuster3);
    function RelativeDayOfWeek(relative, dayOfWeek) {
        var _this3;
        _this3 = _TemporalAdjuster3.call(this) || this;
        $7232ef576ffbaa3c$var$requireNonNull(dayOfWeek, "dayOfWeek");
        _this3._relative = relative;
        _this3._dowValue = dayOfWeek.value();
        return _this3;
    }
    var _proto3 = RelativeDayOfWeek.prototype;
    _proto3.adjustInto = function adjustInto(temporal) {
        var calDow = temporal.get($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK);
        if (this._relative < 2 && calDow === this._dowValue) return temporal;
        if ((this._relative & 1) === 0) {
            var daysDiff = calDow - this._dowValue;
            return temporal.plus(daysDiff >= 0 ? 7 - daysDiff : -daysDiff, $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS);
        } else {
            var _daysDiff = this._dowValue - calDow;
            return temporal.minus(_daysDiff >= 0 ? 7 - _daysDiff : -_daysDiff, $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS);
        }
    };
    return RelativeDayOfWeek;
}($7232ef576ffbaa3c$export$841f8bd48996924f);
var $7232ef576ffbaa3c$export$f47ae290cf4e4958 = function(_Enum) {
    $7232ef576ffbaa3c$var$_inheritsLoose(IsoChronology, _Enum);
    function IsoChronology() {
        return _Enum.apply(this, arguments) || this;
    }
    IsoChronology.isLeapYear = function isLeapYear(prolepticYear) {
        return (prolepticYear & 3) === 0 && (prolepticYear % 100 !== 0 || prolepticYear % 400 === 0);
    };
    var _proto = IsoChronology.prototype;
    _proto._updateResolveMap = function _updateResolveMap(fieldValues, field, value) {
        $7232ef576ffbaa3c$var$requireNonNull(fieldValues, "fieldValues");
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        var current = fieldValues.get(field);
        if (current != null && current !== value) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Invalid state, field: " + field + " " + current + " conflicts with " + field + " " + value);
        fieldValues.put(field, value);
    };
    _proto.resolveDate = function resolveDate(fieldValues, resolverStyle) {
        if (fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.EPOCH_DAY)) return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.ofEpochDay(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.EPOCH_DAY));
        var prolepticMonth = fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.PROLEPTIC_MONTH);
        if (prolepticMonth != null) {
            if (resolverStyle !== $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) $7232ef576ffbaa3c$export$7f55a40756153c3e.PROLEPTIC_MONTH.checkValidValue(prolepticMonth);
            this._updateResolveMap(fieldValues, $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR, $7232ef576ffbaa3c$var$MathUtil.floorMod(prolepticMonth, 12) + 1);
            this._updateResolveMap(fieldValues, $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR, $7232ef576ffbaa3c$var$MathUtil.floorDiv(prolepticMonth, 12));
        }
        var yoeLong = fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA);
        if (yoeLong != null) {
            if (resolverStyle !== $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA.checkValidValue(yoeLong);
            var era = fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA);
            if (era == null) {
                var year = fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR);
                if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT) {
                    if (year != null) this._updateResolveMap(fieldValues, $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR, year > 0 ? yoeLong : $7232ef576ffbaa3c$var$MathUtil.safeSubtract(1, yoeLong));
                    else fieldValues.put($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA, yoeLong);
                } else this._updateResolveMap(fieldValues, $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR, year == null || year > 0 ? yoeLong : $7232ef576ffbaa3c$var$MathUtil.safeSubtract(1, yoeLong));
            } else if (era === 1) this._updateResolveMap(fieldValues, $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR, yoeLong);
            else if (era === 0) this._updateResolveMap(fieldValues, $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR, $7232ef576ffbaa3c$var$MathUtil.safeSubtract(1, yoeLong));
            else throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Invalid value for era: " + era);
        } else if (fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA)) $7232ef576ffbaa3c$export$7f55a40756153c3e.ERA.checkValidValue(fieldValues.get($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA));
        if (fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR)) {
            if (fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR)) {
                if (fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH)) {
                    var y = $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidIntValue(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR));
                    var moy = fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR);
                    var dom = fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH);
                    if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) {
                        var months = moy - 1;
                        var days = dom - 1;
                        return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(y, 1, 1).plusMonths(months).plusDays(days);
                    } else if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.SMART) {
                        $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH.checkValidValue(dom);
                        if (moy === 4 || moy === 6 || moy === 9 || moy === 11) dom = Math.min(dom, 30);
                        else if (moy === 2) dom = Math.min(dom, $7232ef576ffbaa3c$export$951c8378cdfec6e6.FEBRUARY.length($7232ef576ffbaa3c$export$6ce2f08d515512.isLeap(y)));
                        return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(y, moy, dom);
                    } else return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(y, moy, dom);
                }
            }
            if (fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR)) {
                var _y = $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidIntValue(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR));
                if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) {
                    var _days = $7232ef576ffbaa3c$var$MathUtil.safeSubtract(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR), 1);
                    return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.ofYearDay(_y, 1).plusDays(_days);
                }
                var doy = $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR.checkValidIntValue(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR));
                return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.ofYearDay(_y, doy);
            }
            if (fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR)) {
                if (fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR)) {
                    var _y2 = $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidIntValue(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR));
                    if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) {
                        var weeks = $7232ef576ffbaa3c$var$MathUtil.safeSubtract(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR), 1);
                        var _days2 = $7232ef576ffbaa3c$var$MathUtil.safeSubtract(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR), 1);
                        return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(_y2, 1, 1).plusWeeks(weeks).plusDays(_days2);
                    }
                    var aw = $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR.checkValidIntValue(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR));
                    var ad = $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR.checkValidIntValue(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR));
                    var date = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(_y2, 1, 1).plusDays((aw - 1) * 7 + (ad - 1));
                    if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT && date.get($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR) !== _y2) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Strict mode rejected date parsed to a different year");
                    return date;
                }
                if (fieldValues.containsKey($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK)) {
                    var _y3 = $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidIntValue(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR));
                    if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.LENIENT) {
                        var _weeks = $7232ef576ffbaa3c$var$MathUtil.safeSubtract(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR), 1);
                        var _days3 = $7232ef576ffbaa3c$var$MathUtil.safeSubtract(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK), 1);
                        return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(_y3, 1, 1).plusWeeks(_weeks).plusDays(_days3);
                    }
                    var _aw = $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR.checkValidIntValue(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR));
                    var dow = $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK.checkValidIntValue(fieldValues.remove($7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK));
                    var _date = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(_y3, 1, 1).plusWeeks(_aw - 1).with($7232ef576ffbaa3c$export$d922854d56f8a965.nextOrSame($7232ef576ffbaa3c$export$7ed5ca4f8b987938.of(dow)));
                    if (resolverStyle === $7232ef576ffbaa3c$export$2a833e4d13229d66.STRICT && _date.get($7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR) !== _y3) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Strict mode rejected date parsed to a different month");
                    return _date;
                }
            }
        }
        return null;
    };
    _proto.date = function date(temporal) {
        return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.from(temporal);
    };
    return IsoChronology;
}($7232ef576ffbaa3c$var$Enum);
function $7232ef576ffbaa3c$var$_init$e() {
    $7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE = new $7232ef576ffbaa3c$export$f47ae290cf4e4958("IsoChronology");
}
var $7232ef576ffbaa3c$export$e69f60c5a83f5572 = function(_Temporal) {
    $7232ef576ffbaa3c$var$_inheritsLoose(ChronoZonedDateTime, _Temporal);
    function ChronoZonedDateTime() {
        return _Temporal.apply(this, arguments) || this;
    }
    var _proto = ChronoZonedDateTime.prototype;
    _proto.query = function query(_query) {
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zoneId() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zone()) return this.zone();
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.chronology()) return this.toLocalDate().chronology();
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.precision()) return $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.offset()) return this.offset();
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate()) return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.ofEpochDay(this.toLocalDate().toEpochDay());
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localTime()) return this.toLocalTime();
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.format = function format(formatter) {
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        return formatter.format(this);
    };
    _proto.toInstant = function toInstant() {
        return $7232ef576ffbaa3c$export$fecec53969739358.ofEpochSecond(this.toEpochSecond(), this.toLocalTime().nano());
    };
    _proto.toEpochSecond = function toEpochSecond() {
        var epochDay = this.toLocalDate().toEpochDay();
        var secs = epochDay * 86400 + this.toLocalTime().toSecondOfDay();
        secs -= this.offset().totalSeconds();
        return secs;
    };
    _proto.compareTo = function compareTo(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        var cmp = $7232ef576ffbaa3c$var$MathUtil.compareNumbers(this.toEpochSecond(), other.toEpochSecond());
        if (cmp === 0) {
            cmp = this.toLocalTime().nano() - other.toLocalTime().nano();
            if (cmp === 0) {
                cmp = this.toLocalDateTime().compareTo(other.toLocalDateTime());
                if (cmp === 0) cmp = $7232ef576ffbaa3c$var$strcmp(this.zone().id(), other.zone().id());
            }
        }
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        var thisEpochSec = this.toEpochSecond();
        var otherEpochSec = other.toEpochSecond();
        return thisEpochSec > otherEpochSec || thisEpochSec === otherEpochSec && this.toLocalTime().nano() > other.toLocalTime().nano();
    };
    _proto.isBefore = function isBefore(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        var thisEpochSec = this.toEpochSecond();
        var otherEpochSec = other.toEpochSecond();
        return thisEpochSec < otherEpochSec || thisEpochSec === otherEpochSec && this.toLocalTime().nano() < other.toLocalTime().nano();
    };
    _proto.isEqual = function isEqual(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        return this.toEpochSecond() === other.toEpochSecond() && this.toLocalTime().nano() === other.toLocalTime().nano();
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof ChronoZonedDateTime) return this.compareTo(other) === 0;
        return false;
    };
    return ChronoZonedDateTime;
}($7232ef576ffbaa3c$export$336849d529cb05e5);
function $7232ef576ffbaa3c$var$strcmp(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
var $7232ef576ffbaa3c$export$d3b7288e7994edea = function(_ChronoZonedDateTime) {
    $7232ef576ffbaa3c$var$_inheritsLoose(ZonedDateTime, _ChronoZonedDateTime);
    ZonedDateTime.now = function now(clockOrZone) {
        var clock;
        if (clockOrZone instanceof $7232ef576ffbaa3c$export$a514a0be1f00ef62) clock = $7232ef576ffbaa3c$export$9735c82c4bae3302.system(clockOrZone);
        else clock = clockOrZone == null ? $7232ef576ffbaa3c$export$9735c82c4bae3302.systemDefaultZone() : clockOrZone;
        return ZonedDateTime.ofInstant(clock.instant(), clock.zone());
    };
    ZonedDateTime.of = function of() {
        if (arguments.length <= 2) return ZonedDateTime.of2.apply(this, arguments);
        else if (arguments.length === 3 && arguments[0] instanceof $7232ef576ffbaa3c$export$6397c6cbb8fe96b6) return ZonedDateTime.of3.apply(this, arguments);
        else return ZonedDateTime.of8.apply(this, arguments);
    };
    ZonedDateTime.of3 = function of3(date, time, zone) {
        return ZonedDateTime.of2($7232ef576ffbaa3c$export$7dda5dc5c6c448ff.of(date, time), zone);
    };
    ZonedDateTime.of2 = function of2(localDateTime, zone) {
        return ZonedDateTime.ofLocal(localDateTime, zone, null);
    };
    ZonedDateTime.of8 = function of8(year, month, dayOfMonth, hour, minute, second, nanoOfSecond, zone) {
        var dt = $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.of(year, month, dayOfMonth, hour, minute, second, nanoOfSecond);
        return ZonedDateTime.ofLocal(dt, zone, null);
    };
    ZonedDateTime.ofLocal = function ofLocal(localDateTime, zone, preferredOffset) {
        $7232ef576ffbaa3c$var$requireNonNull(localDateTime, "localDateTime");
        $7232ef576ffbaa3c$var$requireNonNull(zone, "zone");
        if (zone instanceof $7232ef576ffbaa3c$export$47ce5d56ab10eaa3) return new ZonedDateTime(localDateTime, zone, zone);
        var offset = null;
        var rules = zone.rules();
        var validOffsets = rules.validOffsets(localDateTime);
        if (validOffsets.length === 1) offset = validOffsets[0];
        else if (validOffsets.length === 0) {
            var trans = rules.transition(localDateTime);
            localDateTime = localDateTime.plusSeconds(trans.duration().seconds());
            offset = trans.offsetAfter();
        } else if (preferredOffset != null && validOffsets.some(function(validOffset) {
            return validOffset.equals(preferredOffset);
        })) offset = preferredOffset;
        else offset = $7232ef576ffbaa3c$var$requireNonNull(validOffsets[0], "offset");
        return new ZonedDateTime(localDateTime, offset, zone);
    };
    ZonedDateTime.ofInstant = function ofInstant() {
        if (arguments.length === 2) return ZonedDateTime.ofInstant2.apply(this, arguments);
        else return ZonedDateTime.ofInstant3.apply(this, arguments);
    };
    ZonedDateTime.ofInstant2 = function ofInstant2(instant, zone) {
        $7232ef576ffbaa3c$var$requireNonNull(instant, "instant");
        $7232ef576ffbaa3c$var$requireNonNull(zone, "zone");
        return ZonedDateTime._create(instant.epochSecond(), instant.nano(), zone);
    };
    ZonedDateTime.ofInstant3 = function ofInstant3(localDateTime, offset, zone) {
        $7232ef576ffbaa3c$var$requireNonNull(localDateTime, "localDateTime");
        $7232ef576ffbaa3c$var$requireNonNull(offset, "offset");
        $7232ef576ffbaa3c$var$requireNonNull(zone, "zone");
        return ZonedDateTime._create(localDateTime.toEpochSecond(offset), localDateTime.nano(), zone);
    };
    ZonedDateTime._create = function _create(epochSecond, nanoOfSecond, zone) {
        var rules = zone.rules();
        var instant = $7232ef576ffbaa3c$export$fecec53969739358.ofEpochSecond(epochSecond, nanoOfSecond);
        var offset = rules.offset(instant);
        var ldt = $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.ofEpochSecond(epochSecond, nanoOfSecond, offset);
        return new ZonedDateTime(ldt, offset, zone);
    };
    ZonedDateTime.ofStrict = function ofStrict(localDateTime, offset, zone) {
        $7232ef576ffbaa3c$var$requireNonNull(localDateTime, "localDateTime");
        $7232ef576ffbaa3c$var$requireNonNull(offset, "offset");
        $7232ef576ffbaa3c$var$requireNonNull(zone, "zone");
        var rules = zone.rules();
        if (rules.isValidOffset(localDateTime, offset) === false) {
            var trans = rules.transition(localDateTime);
            if (trans != null && trans.isGap()) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("LocalDateTime " + localDateTime + " does not exist in zone " + zone + " due to a gap in the local time-line, typically caused by daylight savings");
            throw new $7232ef576ffbaa3c$export$6058f27c7f907fb('ZoneOffset "' + offset + '" is not valid for LocalDateTime "' + localDateTime + '" in zone "' + zone + '"');
        }
        return new ZonedDateTime(localDateTime, offset, zone);
    };
    ZonedDateTime.ofLenient = function ofLenient(localDateTime, offset, zone) {
        $7232ef576ffbaa3c$var$requireNonNull(localDateTime, "localDateTime");
        $7232ef576ffbaa3c$var$requireNonNull(offset, "offset");
        $7232ef576ffbaa3c$var$requireNonNull(zone, "zone");
        if (zone instanceof $7232ef576ffbaa3c$export$47ce5d56ab10eaa3 && offset.equals(zone) === false) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("ZoneId must match ZoneOffset");
        return new ZonedDateTime(localDateTime, offset, zone);
    };
    ZonedDateTime.from = function from(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        if (temporal instanceof ZonedDateTime) return temporal;
        var zone = $7232ef576ffbaa3c$export$a514a0be1f00ef62.from(temporal);
        if (temporal.isSupported($7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS)) {
            var zdt = ZonedDateTime._from(temporal, zone);
            if (zdt != null) return zdt;
        }
        var ldt = $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.from(temporal);
        return ZonedDateTime.of2(ldt, zone);
    };
    ZonedDateTime._from = function _from(temporal, zone) {
        try {
            return ZonedDateTime.__from(temporal, zone);
        } catch (ex) {
            if (!(ex instanceof $7232ef576ffbaa3c$export$6058f27c7f907fb)) throw ex;
        }
    };
    ZonedDateTime.__from = function __from(temporal, zone) {
        var epochSecond = temporal.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS);
        var nanoOfSecond = temporal.get($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND);
        return ZonedDateTime._create(epochSecond, nanoOfSecond, zone);
    };
    ZonedDateTime.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_ZONED_DATE_TIME;
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        return formatter.parse(text, ZonedDateTime.FROM);
    };
    function ZonedDateTime(dateTime, offset, zone) {
        var _this;
        $7232ef576ffbaa3c$var$requireNonNull(dateTime, "dateTime");
        $7232ef576ffbaa3c$var$requireNonNull(offset, "offset");
        $7232ef576ffbaa3c$var$requireNonNull(zone, "zone");
        _this = _ChronoZonedDateTime.call(this) || this;
        _this._dateTime = dateTime;
        _this._offset = offset;
        _this._zone = zone;
        return _this;
    }
    var _proto = ZonedDateTime.prototype;
    _proto._resolveLocal = function _resolveLocal(newDateTime) {
        $7232ef576ffbaa3c$var$requireNonNull(newDateTime, "newDateTime");
        return ZonedDateTime.ofLocal(newDateTime, this._zone, this._offset);
    };
    _proto._resolveInstant = function _resolveInstant(newDateTime) {
        return ZonedDateTime.ofInstant3(newDateTime, this._offset, this._zone);
    };
    _proto._resolveOffset = function _resolveOffset(offset) {
        if (offset.equals(this._offset) === false && this._zone.rules().isValidOffset(this._dateTime, offset)) return new ZonedDateTime(this._dateTime, offset, this._zone);
        return this;
    };
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return true;
        else if (fieldOrUnit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            if (field === $7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS || field === $7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS) return field.range();
            return this._dateTime.range(field);
        }
        return field.rangeRefinedBy(this);
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            switch(field){
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return this.toEpochSecond();
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS:
                    return this._offset.totalSeconds();
            }
            return this._dateTime.getLong(field);
        }
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        return field.getFrom(this);
    };
    _proto.offset = function offset() {
        return this._offset;
    };
    _proto.withEarlierOffsetAtOverlap = function withEarlierOffsetAtOverlap() {
        var trans = this._zone.rules().transition(this._dateTime);
        if (trans != null && trans.isOverlap()) {
            var earlierOffset = trans.offsetBefore();
            if (earlierOffset.equals(this._offset) === false) return new ZonedDateTime(this._dateTime, earlierOffset, this._zone);
        }
        return this;
    };
    _proto.withLaterOffsetAtOverlap = function withLaterOffsetAtOverlap() {
        var trans = this._zone.rules().transition(this.toLocalDateTime());
        if (trans != null) {
            var laterOffset = trans.offsetAfter();
            if (laterOffset.equals(this._offset) === false) return new ZonedDateTime(this._dateTime, laterOffset, this._zone);
        }
        return this;
    };
    _proto.zone = function zone() {
        return this._zone;
    };
    _proto.withZoneSameLocal = function withZoneSameLocal(zone) {
        $7232ef576ffbaa3c$var$requireNonNull(zone, "zone");
        return this._zone.equals(zone) ? this : ZonedDateTime.ofLocal(this._dateTime, zone, this._offset);
    };
    _proto.withZoneSameInstant = function withZoneSameInstant(zone) {
        $7232ef576ffbaa3c$var$requireNonNull(zone, "zone");
        return this._zone.equals(zone) ? this : ZonedDateTime._create(this._dateTime.toEpochSecond(this._offset), this._dateTime.nano(), zone);
    };
    _proto.withFixedOffsetZone = function withFixedOffsetZone() {
        return this._zone.equals(this._offset) ? this : new ZonedDateTime(this._dateTime, this._offset, this._offset);
    };
    _proto.year = function year() {
        return this._dateTime.year();
    };
    _proto.monthValue = function monthValue() {
        return this._dateTime.monthValue();
    };
    _proto.month = function month() {
        return this._dateTime.month();
    };
    _proto.dayOfMonth = function dayOfMonth() {
        return this._dateTime.dayOfMonth();
    };
    _proto.dayOfYear = function dayOfYear() {
        return this._dateTime.dayOfYear();
    };
    _proto.dayOfWeek = function dayOfWeek() {
        return this._dateTime.dayOfWeek();
    };
    _proto.hour = function hour() {
        return this._dateTime.hour();
    };
    _proto.minute = function minute() {
        return this._dateTime.minute();
    };
    _proto.second = function second() {
        return this._dateTime.second();
    };
    _proto.nano = function nano() {
        return this._dateTime.nano();
    };
    _proto.with = function _with() {
        if (arguments.length === 1) return this.withTemporalAdjuster.apply(this, arguments);
        else return this.with2.apply(this, arguments);
    };
    _proto.withTemporalAdjuster = function withTemporalAdjuster(adjuster) {
        if (adjuster instanceof $7232ef576ffbaa3c$export$6397c6cbb8fe96b6) return this._resolveLocal($7232ef576ffbaa3c$export$7dda5dc5c6c448ff.of(adjuster, this._dateTime.toLocalTime()));
        else if (adjuster instanceof $7232ef576ffbaa3c$export$bf1071e344bea1d) return this._resolveLocal($7232ef576ffbaa3c$export$7dda5dc5c6c448ff.of(this._dateTime.toLocalDate(), adjuster));
        else if (adjuster instanceof $7232ef576ffbaa3c$export$7dda5dc5c6c448ff) return this._resolveLocal(adjuster);
        else if (adjuster instanceof $7232ef576ffbaa3c$export$fecec53969739358) {
            var instant = adjuster;
            return ZonedDateTime._create(instant.epochSecond(), instant.nano(), this._zone);
        } else if (adjuster instanceof $7232ef576ffbaa3c$export$47ce5d56ab10eaa3) return this._resolveOffset(adjuster);
        $7232ef576ffbaa3c$var$requireNonNull(adjuster, "adjuster");
        return adjuster.adjustInto(this);
    };
    _proto.with2 = function with2(field, newValue) {
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            switch(field){
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return ZonedDateTime._create(newValue, this.nano(), this._zone);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS:
                    var offset = $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.ofTotalSeconds(field.checkValidIntValue(newValue));
                    return this._resolveOffset(offset);
            }
            return this._resolveLocal(this._dateTime.with(field, newValue));
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withYear = function withYear(year) {
        return this._resolveLocal(this._dateTime.withYear(year));
    };
    _proto.withMonth = function withMonth(month) {
        return this._resolveLocal(this._dateTime.withMonth(month));
    };
    _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
        return this._resolveLocal(this._dateTime.withDayOfMonth(dayOfMonth));
    };
    _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
        return this._resolveLocal(this._dateTime.withDayOfYear(dayOfYear));
    };
    _proto.withHour = function withHour(hour) {
        return this._resolveLocal(this._dateTime.withHour(hour));
    };
    _proto.withMinute = function withMinute(minute) {
        return this._resolveLocal(this._dateTime.withMinute(minute));
    };
    _proto.withSecond = function withSecond(second) {
        return this._resolveLocal(this._dateTime.withSecond(second));
    };
    _proto.withNano = function withNano(nanoOfSecond) {
        return this._resolveLocal(this._dateTime.withNano(nanoOfSecond));
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        return this._resolveLocal(this._dateTime.truncatedTo(unit));
    };
    _proto.plus = function plus() {
        if (arguments.length === 1) return this.plusTemporalAmount.apply(this, arguments);
        else return this.plus2.apply(this, arguments);
    };
    _proto.plusTemporalAmount = function plusTemporalAmount(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount);
        return amount.addTo(this);
    };
    _proto.plus2 = function plus2(amountToAdd, unit) {
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) {
            if (unit.isDateBased()) return this._resolveLocal(this._dateTime.plus(amountToAdd, unit));
            else return this._resolveInstant(this._dateTime.plus(amountToAdd, unit));
        }
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(years) {
        return this._resolveLocal(this._dateTime.plusYears(years));
    };
    _proto.plusMonths = function plusMonths(months) {
        return this._resolveLocal(this._dateTime.plusMonths(months));
    };
    _proto.plusWeeks = function plusWeeks(weeks) {
        return this._resolveLocal(this._dateTime.plusWeeks(weeks));
    };
    _proto.plusDays = function plusDays(days) {
        return this._resolveLocal(this._dateTime.plusDays(days));
    };
    _proto.plusHours = function plusHours(hours) {
        return this._resolveInstant(this._dateTime.plusHours(hours));
    };
    _proto.plusMinutes = function plusMinutes(minutes) {
        return this._resolveInstant(this._dateTime.plusMinutes(minutes));
    };
    _proto.plusSeconds = function plusSeconds(seconds) {
        return this._resolveInstant(this._dateTime.plusSeconds(seconds));
    };
    _proto.plusNanos = function plusNanos(nanos) {
        return this._resolveInstant(this._dateTime.plusNanos(nanos));
    };
    _proto.minus = function minus() {
        if (arguments.length === 1) return this.minusTemporalAmount.apply(this, arguments);
        else return this.minus2.apply(this, arguments);
    };
    _proto.minusTemporalAmount = function minusTemporalAmount(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minus2 = function minus2(amountToSubtract, unit) {
        return this.plus2(-1 * amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(years) {
        return this.plusYears(-1 * years);
    };
    _proto.minusMonths = function minusMonths(months) {
        return this.plusMonths(-1 * months);
    };
    _proto.minusWeeks = function minusWeeks(weeks) {
        return this.plusWeeks(-1 * weeks);
    };
    _proto.minusDays = function minusDays(days) {
        return this.plusDays(-1 * days);
    };
    _proto.minusHours = function minusHours(hours) {
        return this.plusHours(-1 * hours);
    };
    _proto.minusMinutes = function minusMinutes(minutes) {
        return this.plusMinutes(-1 * minutes);
    };
    _proto.minusSeconds = function minusSeconds(seconds) {
        return this.plusSeconds(-1 * seconds);
    };
    _proto.minusNanos = function minusNanos(nanos) {
        return this.plusNanos(-1 * nanos);
    };
    _proto.query = function query(_query) {
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate()) return this.toLocalDate();
        $7232ef576ffbaa3c$var$requireNonNull(_query, "query");
        return _ChronoZonedDateTime.prototype.query.call(this, _query);
    };
    _proto.until = function until(endExclusive, unit) {
        var end = ZonedDateTime.from(endExclusive);
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) {
            end = end.withZoneSameInstant(this._zone);
            if (unit.isDateBased()) return this._dateTime.until(end._dateTime, unit);
            else {
                var difference = this._offset.totalSeconds() - end._offset.totalSeconds();
                var adjustedEnd = end._dateTime.plusSeconds(difference);
                return this._dateTime.until(adjustedEnd, unit);
            }
        }
        return unit.between(this, end);
    };
    _proto.toLocalDateTime = function toLocalDateTime() {
        return this._dateTime;
    };
    _proto.toLocalDate = function toLocalDate() {
        return this._dateTime.toLocalDate();
    };
    _proto.toLocalTime = function toLocalTime() {
        return this._dateTime.toLocalTime();
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof ZonedDateTime) return this._dateTime.equals(other._dateTime) && this._offset.equals(other._offset) && this._zone.equals(other._zone);
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $7232ef576ffbaa3c$var$MathUtil.hashCode(this._dateTime.hashCode(), this._offset.hashCode(), this._zone.hashCode());
    };
    _proto.toString = function toString() {
        var str = this._dateTime.toString() + this._offset.toString();
        if (this._offset !== this._zone) str += "[" + this._zone.toString() + "]";
        return str;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        return _ChronoZonedDateTime.prototype.format.call(this, formatter);
    };
    return ZonedDateTime;
}($7232ef576ffbaa3c$export$e69f60c5a83f5572);
function $7232ef576ffbaa3c$var$_init$f() {
    $7232ef576ffbaa3c$export$d3b7288e7994edea.FROM = $7232ef576ffbaa3c$var$createTemporalQuery("ZonedDateTime.FROM", function(temporal) {
        return $7232ef576ffbaa3c$export$d3b7288e7994edea.from(temporal);
    });
}
var $7232ef576ffbaa3c$var$DAYS_PER_CYCLE = 146097;
var $7232ef576ffbaa3c$var$DAYS_0000_TO_1970 = $7232ef576ffbaa3c$var$DAYS_PER_CYCLE * 5 - 10957;
var $7232ef576ffbaa3c$export$6397c6cbb8fe96b6 = function(_ChronoLocalDate) {
    $7232ef576ffbaa3c$var$_inheritsLoose(LocalDate, _ChronoLocalDate);
    LocalDate.now = function now(clockOrZone) {
        var clock;
        if (clockOrZone == null) clock = $7232ef576ffbaa3c$export$9735c82c4bae3302.systemDefaultZone();
        else if (clockOrZone instanceof $7232ef576ffbaa3c$export$a514a0be1f00ef62) clock = $7232ef576ffbaa3c$export$9735c82c4bae3302.system(clockOrZone);
        else clock = clockOrZone;
        return LocalDate.ofInstant(clock.instant(), clock.zone());
    };
    LocalDate.ofInstant = function ofInstant(instant, zone) {
        if (zone === void 0) zone = $7232ef576ffbaa3c$export$a514a0be1f00ef62.systemDefault();
        $7232ef576ffbaa3c$var$requireNonNull(instant, "instant");
        var offset = zone.rules().offset(instant);
        var epochSec = instant.epochSecond() + offset.totalSeconds();
        var epochDay = $7232ef576ffbaa3c$var$MathUtil.floorDiv(epochSec, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY);
        return LocalDate.ofEpochDay(epochDay);
    };
    LocalDate.of = function of(year, month, dayOfMonth) {
        return new LocalDate(year, month, dayOfMonth);
    };
    LocalDate.ofYearDay = function ofYearDay(year, dayOfYear) {
        $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        var leap = $7232ef576ffbaa3c$export$f47ae290cf4e4958.isLeapYear(year);
        if (dayOfYear === 366 && leap === false) $7232ef576ffbaa3c$var$assert(false, "Invalid date 'DayOfYear 366' as '" + year + "' is not a leap year", $7232ef576ffbaa3c$export$6058f27c7f907fb);
        var moy = $7232ef576ffbaa3c$export$951c8378cdfec6e6.of(Math.floor((dayOfYear - 1) / 31 + 1));
        var monthEnd = moy.firstDayOfYear(leap) + moy.length(leap) - 1;
        if (dayOfYear > monthEnd) moy = moy.plus(1);
        var dom = dayOfYear - moy.firstDayOfYear(leap) + 1;
        return new LocalDate(year, moy.value(), dom);
    };
    LocalDate.ofEpochDay = function ofEpochDay(epochDay) {
        if (epochDay === void 0) epochDay = 0;
        var adjust, adjustCycles, doyEst, yearEst, zeroDay;
        zeroDay = epochDay + $7232ef576ffbaa3c$var$DAYS_0000_TO_1970;
        zeroDay -= 60;
        adjust = 0;
        if (zeroDay < 0) {
            adjustCycles = $7232ef576ffbaa3c$var$MathUtil.intDiv(zeroDay + 1, $7232ef576ffbaa3c$var$DAYS_PER_CYCLE) - 1;
            adjust = adjustCycles * 400;
            zeroDay += -adjustCycles * $7232ef576ffbaa3c$var$DAYS_PER_CYCLE;
        }
        yearEst = $7232ef576ffbaa3c$var$MathUtil.intDiv(400 * zeroDay + 591, $7232ef576ffbaa3c$var$DAYS_PER_CYCLE);
        doyEst = zeroDay - (365 * yearEst + $7232ef576ffbaa3c$var$MathUtil.intDiv(yearEst, 4) - $7232ef576ffbaa3c$var$MathUtil.intDiv(yearEst, 100) + $7232ef576ffbaa3c$var$MathUtil.intDiv(yearEst, 400));
        if (doyEst < 0) {
            yearEst--;
            doyEst = zeroDay - (365 * yearEst + $7232ef576ffbaa3c$var$MathUtil.intDiv(yearEst, 4) - $7232ef576ffbaa3c$var$MathUtil.intDiv(yearEst, 100) + $7232ef576ffbaa3c$var$MathUtil.intDiv(yearEst, 400));
        }
        yearEst += adjust;
        var marchDoy0 = doyEst;
        var marchMonth0 = $7232ef576ffbaa3c$var$MathUtil.intDiv(marchDoy0 * 5 + 2, 153);
        var month = (marchMonth0 + 2) % 12 + 1;
        var dom = marchDoy0 - $7232ef576ffbaa3c$var$MathUtil.intDiv(marchMonth0 * 306 + 5, 10) + 1;
        yearEst += $7232ef576ffbaa3c$var$MathUtil.intDiv(marchMonth0, 10);
        var year = yearEst;
        return new LocalDate(year, month, dom);
    };
    LocalDate.from = function from(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        var date = temporal.query($7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate());
        if (date == null) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unable to obtain LocalDate from TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ""));
        return date;
    };
    LocalDate.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE;
        $7232ef576ffbaa3c$var$assert(formatter != null, "formatter", $7232ef576ffbaa3c$export$b6ad7a1de4697efd);
        return formatter.parse(text, LocalDate.FROM);
    };
    LocalDate._resolvePreviousValid = function _resolvePreviousValid(year, month, day) {
        switch(month){
            case 2:
                day = Math.min(day, $7232ef576ffbaa3c$export$f47ae290cf4e4958.isLeapYear(year) ? 29 : 28);
                break;
            case 4:
            case 6:
            case 9:
            case 11:
                day = Math.min(day, 30);
                break;
        }
        return LocalDate.of(year, month, day);
    };
    function LocalDate(year, month, dayOfMonth) {
        var _this;
        _this = _ChronoLocalDate.call(this) || this;
        if (month instanceof $7232ef576ffbaa3c$export$951c8378cdfec6e6) month = month.value();
        _this._year = $7232ef576ffbaa3c$var$MathUtil.safeToInt(year);
        _this._month = $7232ef576ffbaa3c$var$MathUtil.safeToInt(month);
        _this._day = $7232ef576ffbaa3c$var$MathUtil.safeToInt(dayOfMonth);
        LocalDate._validate(_this._year, _this._month, _this._day);
        return _this;
    }
    LocalDate._validate = function _validate(year, month, dayOfMonth) {
        var dom;
        $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR.checkValidValue(month);
        $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH.checkValidValue(dayOfMonth);
        if (dayOfMonth > 28) {
            dom = 31;
            switch(month){
                case 2:
                    dom = $7232ef576ffbaa3c$export$f47ae290cf4e4958.isLeapYear(year) ? 29 : 28;
                    break;
                case 4:
                case 6:
                case 9:
                case 11:
                    dom = 30;
            }
            if (dayOfMonth > dom) {
                if (dayOfMonth === 29) $7232ef576ffbaa3c$var$assert(false, "Invalid date 'February 29' as '" + year + "' is not a leap year", $7232ef576ffbaa3c$export$6058f27c7f907fb);
                else $7232ef576ffbaa3c$var$assert(false, "Invalid date '" + year + "' '" + month + "' '" + dayOfMonth + "'", $7232ef576ffbaa3c$export$6058f27c7f907fb);
            }
        }
    };
    var _proto = LocalDate.prototype;
    _proto.isSupported = function isSupported(field) {
        return _ChronoLocalDate.prototype.isSupported.call(this, field);
    };
    _proto.range = function range(field) {
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            if (field.isDateBased()) {
                switch(field){
                    case $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH:
                        return $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, this.lengthOfMonth());
                    case $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR:
                        return $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, this.lengthOfYear());
                    case $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH:
                        return $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, this.month() === $7232ef576ffbaa3c$export$951c8378cdfec6e6.FEBRUARY && this.isLeapYear() === false ? 4 : 5);
                    case $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA:
                        return this._year <= 0 ? $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, $7232ef576ffbaa3c$export$6ce2f08d515512.MAX_VALUE + 1) : $7232ef576ffbaa3c$export$177e5e64bab4dec5.of(1, $7232ef576ffbaa3c$export$6ce2f08d515512.MAX_VALUE);
                }
                return field.range();
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.rangeRefinedBy(this);
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        $7232ef576ffbaa3c$var$assert(field != null, "", $7232ef576ffbaa3c$export$b6ad7a1de4697efd);
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return this._get0(field);
        return field.getFrom(this);
    };
    _proto._get0 = function _get0(field) {
        switch(field){
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK:
                return this.dayOfWeek().value();
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH:
                return $7232ef576ffbaa3c$var$MathUtil.intMod(this._day - 1, 7) + 1;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR:
                return $7232ef576ffbaa3c$var$MathUtil.intMod(this.dayOfYear() - 1, 7) + 1;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH:
                return this._day;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR:
                return this.dayOfYear();
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.EPOCH_DAY:
                return this.toEpochDay();
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH:
                return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._day - 1, 7) + 1;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR:
                return $7232ef576ffbaa3c$var$MathUtil.intDiv(this.dayOfYear() - 1, 7) + 1;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR:
                return this._month;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.PROLEPTIC_MONTH:
                return this._prolepticMonth();
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA:
                return this._year >= 1 ? this._year : 1 - this._year;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR:
                return this._year;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.ERA:
                return this._year >= 1 ? 1 : 0;
        }
        throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
    };
    _proto._prolepticMonth = function _prolepticMonth() {
        return this._year * 12 + (this._month - 1);
    };
    _proto.chronology = function chronology() {
        return $7232ef576ffbaa3c$export$f47ae290cf4e4958.INSTANCE;
    };
    _proto.year = function year() {
        return this._year;
    };
    _proto.monthValue = function monthValue() {
        return this._month;
    };
    _proto.month = function month() {
        return $7232ef576ffbaa3c$export$951c8378cdfec6e6.of(this._month);
    };
    _proto.dayOfMonth = function dayOfMonth() {
        return this._day;
    };
    _proto.dayOfYear = function dayOfYear() {
        return this.month().firstDayOfYear(this.isLeapYear()) + this._day - 1;
    };
    _proto.dayOfWeek = function dayOfWeek() {
        var dow0 = $7232ef576ffbaa3c$var$MathUtil.floorMod(this.toEpochDay() + 3, 7);
        return $7232ef576ffbaa3c$export$7ed5ca4f8b987938.of(dow0 + 1);
    };
    _proto.isLeapYear = function isLeapYear() {
        return $7232ef576ffbaa3c$export$f47ae290cf4e4958.isLeapYear(this._year);
    };
    _proto.lengthOfMonth = function lengthOfMonth() {
        switch(this._month){
            case 2:
                return this.isLeapYear() ? 29 : 28;
            case 4:
            case 6:
            case 9:
            case 11:
                return 30;
            default:
                return 31;
        }
    };
    _proto.lengthOfYear = function lengthOfYear() {
        return this.isLeapYear() ? 366 : 365;
    };
    _proto.with = function _with(fieldOrAdjuster, newValue) {
        if (arguments.length < 2) return this.withTemporalAdjuster(fieldOrAdjuster);
        else return this.withFieldAndValue(fieldOrAdjuster, newValue);
    };
    _proto.withTemporalAdjuster = function withTemporalAdjuster(adjuster) {
        $7232ef576ffbaa3c$var$requireNonNull(adjuster, "adjuster");
        if (adjuster instanceof LocalDate) return adjuster;
        $7232ef576ffbaa3c$var$assert(typeof adjuster.adjustInto === "function", "adjuster", $7232ef576ffbaa3c$export$86eb44ed3377dd8f);
        return adjuster.adjustInto(this);
    };
    _proto.withFieldAndValue = function withFieldAndValue(field, newValue) {
        $7232ef576ffbaa3c$var$assert(field != null, "field", $7232ef576ffbaa3c$export$b6ad7a1de4697efd);
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            var f = field;
            f.checkValidValue(newValue);
            switch(f){
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_WEEK:
                    return this.plusDays(newValue - this.dayOfWeek().value());
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH:
                    return this.plusDays(newValue - this.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH));
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR:
                    return this.plusDays(newValue - this.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR));
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_MONTH:
                    return this.withDayOfMonth(newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.DAY_OF_YEAR:
                    return this.withDayOfYear(newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.EPOCH_DAY:
                    return LocalDate.ofEpochDay(newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH:
                    return this.plusWeeks(newValue - this.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH));
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR:
                    return this.plusWeeks(newValue - this.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR));
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR:
                    return this.withMonth(newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.PROLEPTIC_MONTH:
                    return this.plusMonths(newValue - this.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.PROLEPTIC_MONTH));
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return this.withYear(this._year >= 1 ? newValue : 1 - newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR:
                    return this.withYear(newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.ERA:
                    return this.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA) === newValue ? this : this.withYear(1 - this._year);
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withYear = function withYear(year) {
        if (this._year === year) return this;
        $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        return LocalDate._resolvePreviousValid(year, this._month, this._day);
    };
    _proto.withMonth = function withMonth(month) {
        var m = month instanceof $7232ef576ffbaa3c$export$951c8378cdfec6e6 ? month.value() : month;
        if (this._month === m) return this;
        $7232ef576ffbaa3c$export$7f55a40756153c3e.MONTH_OF_YEAR.checkValidValue(m);
        return LocalDate._resolvePreviousValid(this._year, m, this._day);
    };
    _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
        if (this._day === dayOfMonth) return this;
        return LocalDate.of(this._year, this._month, dayOfMonth);
    };
    _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
        if (this.dayOfYear() === dayOfYear) return this;
        return LocalDate.ofYearDay(this._year, dayOfYear);
    };
    _proto.plus = function plus(p1, p2) {
        if (arguments.length < 2) return this.plus1(p1);
        else return this.plus2(p1, p2);
    };
    _proto.plus1 = function plus1(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        return amount.addTo(this);
    };
    _proto.plus2 = function plus2(amountToAdd, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(amountToAdd, "amountToAdd");
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) {
            switch(unit){
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS:
                    return this.plusDays(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.WEEKS:
                    return this.plusWeeks(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS:
                    return this.plusMonths(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS:
                    return this.plusYears(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.DECADES:
                    return this.plusYears($7232ef576ffbaa3c$var$MathUtil.safeMultiply(amountToAdd, 10));
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.CENTURIES:
                    return this.plusYears($7232ef576ffbaa3c$var$MathUtil.safeMultiply(amountToAdd, 100));
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLENNIA:
                    return this.plusYears($7232ef576ffbaa3c$var$MathUtil.safeMultiply(amountToAdd, 1000));
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.ERAS:
                    return this.with($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA, $7232ef576ffbaa3c$var$MathUtil.safeAdd(this.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA), amountToAdd));
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(yearsToAdd) {
        if (yearsToAdd === 0) return this;
        var newYear = $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidIntValue(this._year + yearsToAdd);
        return LocalDate._resolvePreviousValid(newYear, this._month, this._day);
    };
    _proto.plusMonths = function plusMonths(monthsToAdd) {
        if (monthsToAdd === 0) return this;
        var monthCount = this._year * 12 + (this._month - 1);
        var calcMonths = monthCount + monthsToAdd;
        var newYear = $7232ef576ffbaa3c$export$7f55a40756153c3e.YEAR.checkValidIntValue($7232ef576ffbaa3c$var$MathUtil.floorDiv(calcMonths, 12));
        var newMonth = $7232ef576ffbaa3c$var$MathUtil.floorMod(calcMonths, 12) + 1;
        return LocalDate._resolvePreviousValid(newYear, newMonth, this._day);
    };
    _proto.plusWeeks = function plusWeeks(weeksToAdd) {
        return this.plusDays($7232ef576ffbaa3c$var$MathUtil.safeMultiply(weeksToAdd, 7));
    };
    _proto.plusDays = function plusDays(daysToAdd) {
        if (daysToAdd === 0) return this;
        var mjDay = $7232ef576ffbaa3c$var$MathUtil.safeAdd(this.toEpochDay(), daysToAdd);
        return LocalDate.ofEpochDay(mjDay);
    };
    _proto.minus = function minus(p1, p2) {
        if (arguments.length < 2) return this.minus1(p1);
        else return this.minus2(p1, p2);
    };
    _proto.minus1 = function minus1(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minus2 = function minus2(amountToSubtract, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(amountToSubtract, "amountToSubtract");
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        return this.plus2(-1 * amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(yearsToSubtract) {
        return this.plusYears(yearsToSubtract * -1);
    };
    _proto.minusMonths = function minusMonths(monthsToSubtract) {
        return this.plusMonths(monthsToSubtract * -1);
    };
    _proto.minusWeeks = function minusWeeks(weeksToSubtract) {
        return this.plusWeeks(weeksToSubtract * -1);
    };
    _proto.minusDays = function minusDays(daysToSubtract) {
        return this.plusDays(daysToSubtract * -1);
    };
    _proto.query = function query(_query) {
        $7232ef576ffbaa3c$var$requireNonNull(_query, "query");
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate()) return this;
        return _ChronoLocalDate.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return _ChronoLocalDate.prototype.adjustInto.call(this, temporal);
    };
    _proto.until = function until(p1, p2) {
        if (arguments.length < 2) return this.until1(p1);
        else return this.until2(p1, p2);
    };
    _proto.until2 = function until2(endExclusive, unit) {
        var end = LocalDate.from(endExclusive);
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) {
            switch(unit){
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS:
                    return this.daysUntil(end);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.WEEKS:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(this.daysUntil(end), 7);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MONTHS:
                    return this._monthsUntil(end);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.YEARS:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._monthsUntil(end), 12);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.DECADES:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._monthsUntil(end), 120);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.CENTURIES:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._monthsUntil(end), 1200);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLENNIA:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._monthsUntil(end), 12000);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.ERAS:
                    return end.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA) - this.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.ERA);
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    _proto.daysUntil = function daysUntil(end) {
        return end.toEpochDay() - this.toEpochDay();
    };
    _proto._monthsUntil = function _monthsUntil(end) {
        var packed1 = this._prolepticMonth() * 32 + this.dayOfMonth();
        var packed2 = end._prolepticMonth() * 32 + end.dayOfMonth();
        return $7232ef576ffbaa3c$var$MathUtil.intDiv(packed2 - packed1, 32);
    };
    _proto.until1 = function until1(endDate) {
        var end = LocalDate.from(endDate);
        var totalMonths = end._prolepticMonth() - this._prolepticMonth();
        var days = end._day - this._day;
        if (totalMonths > 0 && days < 0) {
            totalMonths--;
            var calcDate = this.plusMonths(totalMonths);
            days = end.toEpochDay() - calcDate.toEpochDay();
        } else if (totalMonths < 0 && days > 0) {
            totalMonths++;
            days -= end.lengthOfMonth();
        }
        var years = $7232ef576ffbaa3c$var$MathUtil.intDiv(totalMonths, 12);
        var months = $7232ef576ffbaa3c$var$MathUtil.intMod(totalMonths, 12);
        return $7232ef576ffbaa3c$export$67186dcd8fa4f92f.of(years, months, days);
    };
    _proto.atTime = function atTime() {
        if (arguments.length === 1) return this.atTime1.apply(this, arguments);
        else return this.atTime4.apply(this, arguments);
    };
    _proto.atTime1 = function atTime1(time) {
        return $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.of(this, time);
    };
    _proto.atTime4 = function atTime4(hour, minute, second, nanoOfSecond) {
        if (second === void 0) second = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        return this.atTime1($7232ef576ffbaa3c$export$bf1071e344bea1d.of(hour, minute, second, nanoOfSecond));
    };
    _proto.atStartOfDay = function atStartOfDay(zone) {
        if (zone != null) return this.atStartOfDayWithZone(zone);
        else return $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.of(this, $7232ef576ffbaa3c$export$bf1071e344bea1d.MIDNIGHT);
    };
    _proto.atStartOfDayWithZone = function atStartOfDayWithZone(zone) {
        $7232ef576ffbaa3c$var$requireNonNull(zone, "zone");
        var ldt = this.atTime($7232ef576ffbaa3c$export$bf1071e344bea1d.MIDNIGHT);
        if (zone instanceof $7232ef576ffbaa3c$export$47ce5d56ab10eaa3 === false) {
            var trans = zone.rules().transition(ldt);
            if (trans != null && trans.isGap()) ldt = trans.dateTimeAfter();
        }
        return $7232ef576ffbaa3c$export$d3b7288e7994edea.of(ldt, zone);
    };
    _proto.toEpochDay = function toEpochDay() {
        var y = this._year;
        var m = this._month;
        var total = 0;
        total += 365 * y;
        if (y >= 0) total += $7232ef576ffbaa3c$var$MathUtil.intDiv(y + 3, 4) - $7232ef576ffbaa3c$var$MathUtil.intDiv(y + 99, 100) + $7232ef576ffbaa3c$var$MathUtil.intDiv(y + 399, 400);
        else total -= $7232ef576ffbaa3c$var$MathUtil.intDiv(y, -4) - $7232ef576ffbaa3c$var$MathUtil.intDiv(y, -100) + $7232ef576ffbaa3c$var$MathUtil.intDiv(y, -400);
        total += $7232ef576ffbaa3c$var$MathUtil.intDiv(367 * m - 362, 12);
        total += this.dayOfMonth() - 1;
        if (m > 2) {
            total--;
            if (!$7232ef576ffbaa3c$export$f47ae290cf4e4958.isLeapYear(y)) total--;
        }
        return total - $7232ef576ffbaa3c$var$DAYS_0000_TO_1970;
    };
    _proto.compareTo = function compareTo(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        $7232ef576ffbaa3c$var$requireInstance(other, LocalDate, "other");
        return this._compareTo0(other);
    };
    _proto._compareTo0 = function _compareTo0(otherDate) {
        var cmp = this._year - otherDate._year;
        if (cmp === 0) {
            cmp = this._month - otherDate._month;
            if (cmp === 0) cmp = this._day - otherDate._day;
        }
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        return this.compareTo(other) < 0;
    };
    _proto.isEqual = function isEqual(other) {
        return this.compareTo(other) === 0;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof LocalDate) return this._compareTo0(other) === 0;
        return false;
    };
    _proto.hashCode = function hashCode() {
        var yearValue = this._year;
        var monthValue = this._month;
        var dayValue = this._day;
        return $7232ef576ffbaa3c$var$MathUtil.hash(yearValue & 0xFFFFF800 ^ (yearValue << 11) + (monthValue << 6) + dayValue);
    };
    _proto.toString = function toString() {
        var dayString, monthString, yearString;
        var yearValue = this._year;
        var monthValue = this._month;
        var dayValue = this._day;
        var absYear = Math.abs(yearValue);
        if (absYear < 1000) {
            if (yearValue < 0) yearString = "-" + ("" + (yearValue - 10000)).slice(-4);
            else yearString = ("" + (yearValue + 10000)).slice(-4);
        } else if (yearValue > 9999) yearString = "+" + yearValue;
        else yearString = "" + yearValue;
        if (monthValue < 10) monthString = "-0" + monthValue;
        else monthString = "-" + monthValue;
        if (dayValue < 10) dayString = "-0" + dayValue;
        else dayString = "-" + dayValue;
        return yearString + monthString + dayString;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        $7232ef576ffbaa3c$var$requireInstance(formatter, $7232ef576ffbaa3c$export$3245e15bf4cbdd6c, "formatter");
        return _ChronoLocalDate.prototype.format.call(this, formatter);
    };
    return LocalDate;
}($7232ef576ffbaa3c$export$2a07e3472bc98879);
function $7232ef576ffbaa3c$var$_init$g() {
    $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.MIN = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of($7232ef576ffbaa3c$export$c04b60057299af61.MIN_VALUE, 1, 1);
    $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.MAX = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of($7232ef576ffbaa3c$export$c04b60057299af61.MAX_VALUE, 12, 31);
    $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.EPOCH_0 = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.ofEpochDay(0);
    $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.FROM = $7232ef576ffbaa3c$var$createTemporalQuery("LocalDate.FROM", function(temporal) {
        return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.from(temporal);
    });
}
var $7232ef576ffbaa3c$export$94e985176fb19d17 = function(_Temporal) {
    $7232ef576ffbaa3c$var$_inheritsLoose(ChronoLocalDateTime, _Temporal);
    function ChronoLocalDateTime() {
        return _Temporal.apply(this, arguments) || this;
    }
    var _proto = ChronoLocalDateTime.prototype;
    _proto.chronology = function chronology() {
        return this.toLocalDate().chronology();
    };
    _proto.query = function query(_query) {
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.chronology()) return this.chronology();
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.precision()) return $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate()) return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.ofEpochDay(this.toLocalDate().toEpochDay());
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localTime()) return this.toLocalTime();
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zone() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zoneId() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.offset()) return null;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.EPOCH_DAY, this.toLocalDate().toEpochDay()).with($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_DAY, this.toLocalTime().toNanoOfDay());
    };
    _proto.toInstant = function toInstant(offset) {
        $7232ef576ffbaa3c$var$requireInstance(offset, $7232ef576ffbaa3c$export$47ce5d56ab10eaa3, "zoneId");
        return $7232ef576ffbaa3c$export$fecec53969739358.ofEpochSecond(this.toEpochSecond(offset), this.toLocalTime().nano());
    };
    _proto.toEpochSecond = function toEpochSecond(offset) {
        $7232ef576ffbaa3c$var$requireNonNull(offset, "offset");
        var epochDay = this.toLocalDate().toEpochDay();
        var secs = epochDay * 86400 + this.toLocalTime().toSecondOfDay();
        secs -= offset.totalSeconds();
        return $7232ef576ffbaa3c$var$MathUtil.safeToInt(secs);
    };
    return ChronoLocalDateTime;
}($7232ef576ffbaa3c$export$336849d529cb05e5);
var $7232ef576ffbaa3c$export$7dda5dc5c6c448ff = function(_ChronoLocalDateTime) {
    $7232ef576ffbaa3c$var$_inheritsLoose(LocalDateTime, _ChronoLocalDateTime);
    LocalDateTime.now = function now(clockOrZone) {
        if (clockOrZone == null) return LocalDateTime._now($7232ef576ffbaa3c$export$9735c82c4bae3302.systemDefaultZone());
        else if (clockOrZone instanceof $7232ef576ffbaa3c$export$9735c82c4bae3302) return LocalDateTime._now(clockOrZone);
        else return LocalDateTime._now($7232ef576ffbaa3c$export$9735c82c4bae3302.system(clockOrZone));
    };
    LocalDateTime._now = function _now(clock) {
        $7232ef576ffbaa3c$var$requireNonNull(clock, "clock");
        return LocalDateTime.ofInstant(clock.instant(), clock.zone());
    };
    LocalDateTime._ofEpochMillis = function _ofEpochMillis(epochMilli, offset) {
        var localSecond = $7232ef576ffbaa3c$var$MathUtil.floorDiv(epochMilli, 1000) + offset.totalSeconds();
        var localEpochDay = $7232ef576ffbaa3c$var$MathUtil.floorDiv(localSecond, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY);
        var secsOfDay = $7232ef576ffbaa3c$var$MathUtil.floorMod(localSecond, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY);
        var nanoOfSecond = $7232ef576ffbaa3c$var$MathUtil.floorMod(epochMilli, 1000) * 1000000;
        var date = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.ofEpochDay(localEpochDay);
        var time = $7232ef576ffbaa3c$export$bf1071e344bea1d.ofSecondOfDay(secsOfDay, nanoOfSecond);
        return new LocalDateTime(date, time);
    };
    LocalDateTime.of = function of() {
        if (arguments.length <= 2) return LocalDateTime.ofDateAndTime.apply(this, arguments);
        else return LocalDateTime.ofNumbers.apply(this, arguments);
    };
    LocalDateTime.ofNumbers = function ofNumbers(year, month, dayOfMonth, hour, minute, second, nanoOfSecond) {
        if (hour === void 0) hour = 0;
        if (minute === void 0) minute = 0;
        if (second === void 0) second = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        var date = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.of(year, month, dayOfMonth);
        var time = $7232ef576ffbaa3c$export$bf1071e344bea1d.of(hour, minute, second, nanoOfSecond);
        return new LocalDateTime(date, time);
    };
    LocalDateTime.ofDateAndTime = function ofDateAndTime(date, time) {
        $7232ef576ffbaa3c$var$requireNonNull(date, "date");
        $7232ef576ffbaa3c$var$requireNonNull(time, "time");
        return new LocalDateTime(date, time);
    };
    LocalDateTime.ofInstant = function ofInstant(instant, zone) {
        if (zone === void 0) zone = $7232ef576ffbaa3c$export$a514a0be1f00ef62.systemDefault();
        $7232ef576ffbaa3c$var$requireNonNull(instant, "instant");
        $7232ef576ffbaa3c$var$requireInstance(instant, $7232ef576ffbaa3c$export$fecec53969739358, "instant");
        $7232ef576ffbaa3c$var$requireNonNull(zone, "zone");
        var offset = zone.rules().offset(instant);
        return LocalDateTime.ofEpochSecond(instant.epochSecond(), instant.nano(), offset);
    };
    LocalDateTime.ofEpochSecond = function ofEpochSecond(epochSecond, nanoOfSecond, offset) {
        if (epochSecond === void 0) epochSecond = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        if (arguments.length === 2 && nanoOfSecond instanceof $7232ef576ffbaa3c$export$47ce5d56ab10eaa3) {
            offset = nanoOfSecond;
            nanoOfSecond = 0;
        }
        $7232ef576ffbaa3c$var$requireNonNull(offset, "offset");
        var localSecond = epochSecond + offset.totalSeconds();
        var localEpochDay = $7232ef576ffbaa3c$var$MathUtil.floorDiv(localSecond, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY);
        var secsOfDay = $7232ef576ffbaa3c$var$MathUtil.floorMod(localSecond, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY);
        var date = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.ofEpochDay(localEpochDay);
        var time = $7232ef576ffbaa3c$export$bf1071e344bea1d.ofSecondOfDay(secsOfDay, nanoOfSecond);
        return new LocalDateTime(date, time);
    };
    LocalDateTime.from = function from(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        if (temporal instanceof LocalDateTime) return temporal;
        else if (temporal instanceof $7232ef576ffbaa3c$export$d3b7288e7994edea) return temporal.toLocalDateTime();
        try {
            var date = $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.from(temporal);
            var time = $7232ef576ffbaa3c$export$bf1071e344bea1d.from(temporal);
            return new LocalDateTime(date, time);
        } catch (ex) {
            throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unable to obtain LocalDateTime TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ""));
        }
    };
    LocalDateTime.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE_TIME;
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        return formatter.parse(text, LocalDateTime.FROM);
    };
    function LocalDateTime(date, time) {
        var _this;
        _this = _ChronoLocalDateTime.call(this) || this;
        $7232ef576ffbaa3c$var$requireInstance(date, $7232ef576ffbaa3c$export$6397c6cbb8fe96b6, "date");
        $7232ef576ffbaa3c$var$requireInstance(time, $7232ef576ffbaa3c$export$bf1071e344bea1d, "time");
        _this._date = date;
        _this._time = time;
        return _this;
    }
    var _proto = LocalDateTime.prototype;
    _proto._withDateTime = function _withDateTime(newDate, newTime) {
        if (this._date === newDate && this._time === newTime) return this;
        return new LocalDateTime(newDate, newTime);
    };
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
        else if (fieldOrUnit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return field.isTimeBased() ? this._time.range(field) : this._date.range(field);
        return field.rangeRefinedBy(this);
    };
    _proto.get = function get(field) {
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return field.isTimeBased() ? this._time.get(field) : this._date.get(field);
        return _ChronoLocalDateTime.prototype.get.call(this, field);
    };
    _proto.getLong = function getLong(field) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return field.isTimeBased() ? this._time.getLong(field) : this._date.getLong(field);
        return field.getFrom(this);
    };
    _proto.year = function year() {
        return this._date.year();
    };
    _proto.monthValue = function monthValue() {
        return this._date.monthValue();
    };
    _proto.month = function month() {
        return this._date.month();
    };
    _proto.dayOfMonth = function dayOfMonth() {
        return this._date.dayOfMonth();
    };
    _proto.dayOfYear = function dayOfYear() {
        return this._date.dayOfYear();
    };
    _proto.dayOfWeek = function dayOfWeek() {
        return this._date.dayOfWeek();
    };
    _proto.hour = function hour() {
        return this._time.hour();
    };
    _proto.minute = function minute() {
        return this._time.minute();
    };
    _proto.second = function second() {
        return this._time.second();
    };
    _proto.nano = function nano() {
        return this._time.nano();
    };
    _proto.with = function _with(adjusterOrField, newValue) {
        if (arguments.length === 1) return this.withTemporalAdjuster(adjusterOrField);
        else return this.with2(adjusterOrField, newValue);
    };
    _proto.withTemporalAdjuster = function withTemporalAdjuster(adjuster) {
        $7232ef576ffbaa3c$var$requireNonNull(adjuster, "adjuster");
        if (adjuster instanceof $7232ef576ffbaa3c$export$6397c6cbb8fe96b6) return this._withDateTime(adjuster, this._time);
        else if (adjuster instanceof $7232ef576ffbaa3c$export$bf1071e344bea1d) return this._withDateTime(this._date, adjuster);
        else if (adjuster instanceof LocalDateTime) return adjuster;
        $7232ef576ffbaa3c$var$assert(typeof adjuster.adjustInto === "function", "adjuster", $7232ef576ffbaa3c$export$86eb44ed3377dd8f);
        return adjuster.adjustInto(this);
    };
    _proto.with2 = function with2(field, newValue) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            if (field.isTimeBased()) return this._withDateTime(this._date, this._time.with(field, newValue));
            else return this._withDateTime(this._date.with(field, newValue), this._time);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withYear = function withYear(year) {
        return this._withDateTime(this._date.withYear(year), this._time);
    };
    _proto.withMonth = function withMonth(month) {
        return this._withDateTime(this._date.withMonth(month), this._time);
    };
    _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
        return this._withDateTime(this._date.withDayOfMonth(dayOfMonth), this._time);
    };
    _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
        return this._withDateTime(this._date.withDayOfYear(dayOfYear), this._time);
    };
    _proto.withHour = function withHour(hour) {
        var newTime = this._time.withHour(hour);
        return this._withDateTime(this._date, newTime);
    };
    _proto.withMinute = function withMinute(minute) {
        var newTime = this._time.withMinute(minute);
        return this._withDateTime(this._date, newTime);
    };
    _proto.withSecond = function withSecond(second) {
        var newTime = this._time.withSecond(second);
        return this._withDateTime(this._date, newTime);
    };
    _proto.withNano = function withNano(nanoOfSecond) {
        var newTime = this._time.withNano(nanoOfSecond);
        return this._withDateTime(this._date, newTime);
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        return this._withDateTime(this._date, this._time.truncatedTo(unit));
    };
    _proto.plus = function plus(amount, unit) {
        if (arguments.length === 1) return this.plusTemporalAmount(amount);
        else return this.plus2(amount, unit);
    };
    _proto.plusTemporalAmount = function plusTemporalAmount(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        return amount.addTo(this);
    };
    _proto.plus2 = function plus2(amountToAdd, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) {
            switch(unit){
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS:
                    return this.plusNanos(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MICROS:
                    return this.plusDays($7232ef576ffbaa3c$var$MathUtil.intDiv(amountToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.MICROS_PER_DAY)).plusNanos($7232ef576ffbaa3c$var$MathUtil.intMod(amountToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.MICROS_PER_DAY) * 1000);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLIS:
                    return this.plusDays($7232ef576ffbaa3c$var$MathUtil.intDiv(amountToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.MILLIS_PER_DAY)).plusNanos($7232ef576ffbaa3c$var$MathUtil.intMod(amountToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.MILLIS_PER_DAY) * 1000000);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS:
                    return this.plusSeconds(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MINUTES:
                    return this.plusMinutes(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.HOURS:
                    return this.plusHours(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.HALF_DAYS:
                    return this.plusDays($7232ef576ffbaa3c$var$MathUtil.intDiv(amountToAdd, 256)).plusHours($7232ef576ffbaa3c$var$MathUtil.intMod(amountToAdd, 256) * 12);
            }
            return this._withDateTime(this._date.plus(amountToAdd, unit), this._time);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(years) {
        var newDate = this._date.plusYears(years);
        return this._withDateTime(newDate, this._time);
    };
    _proto.plusMonths = function plusMonths(months) {
        var newDate = this._date.plusMonths(months);
        return this._withDateTime(newDate, this._time);
    };
    _proto.plusWeeks = function plusWeeks(weeks) {
        var newDate = this._date.plusWeeks(weeks);
        return this._withDateTime(newDate, this._time);
    };
    _proto.plusDays = function plusDays(days) {
        var newDate = this._date.plusDays(days);
        return this._withDateTime(newDate, this._time);
    };
    _proto.plusHours = function plusHours(hours) {
        return this._plusWithOverflow(this._date, hours, 0, 0, 0, 1);
    };
    _proto.plusMinutes = function plusMinutes(minutes) {
        return this._plusWithOverflow(this._date, 0, minutes, 0, 0, 1);
    };
    _proto.plusSeconds = function plusSeconds(seconds) {
        return this._plusWithOverflow(this._date, 0, 0, seconds, 0, 1);
    };
    _proto.plusNanos = function plusNanos(nanos) {
        return this._plusWithOverflow(this._date, 0, 0, 0, nanos, 1);
    };
    _proto.minus = function minus(amount, unit) {
        if (arguments.length === 1) return this.minusTemporalAmount(amount);
        else return this.minus2(amount, unit);
    };
    _proto.minusTemporalAmount = function minusTemporalAmount(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minus2 = function minus2(amountToSubtract, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        return this.plus2(-1 * amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(years) {
        return this.plusYears(-1 * years);
    };
    _proto.minusMonths = function minusMonths(months) {
        return this.plusMonths(-1 * months);
    };
    _proto.minusWeeks = function minusWeeks(weeks) {
        return this.plusWeeks(-1 * weeks);
    };
    _proto.minusDays = function minusDays(days) {
        return this.plusDays(-1 * days);
    };
    _proto.minusHours = function minusHours(hours) {
        return this._plusWithOverflow(this._date, hours, 0, 0, 0, -1);
    };
    _proto.minusMinutes = function minusMinutes(minutes) {
        return this._plusWithOverflow(this._date, 0, minutes, 0, 0, -1);
    };
    _proto.minusSeconds = function minusSeconds(seconds) {
        return this._plusWithOverflow(this._date, 0, 0, seconds, 0, -1);
    };
    _proto.minusNanos = function minusNanos(nanos) {
        return this._plusWithOverflow(this._date, 0, 0, 0, nanos, -1);
    };
    _proto._plusWithOverflow = function _plusWithOverflow(newDate, hours, minutes, seconds, nanos, sign) {
        if ((hours | minutes | seconds | nanos) === 0) return this._withDateTime(newDate, this._time);
        var totDays = $7232ef576ffbaa3c$var$MathUtil.intDiv(nanos, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_DAY) + $7232ef576ffbaa3c$var$MathUtil.intDiv(seconds, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY) + $7232ef576ffbaa3c$var$MathUtil.intDiv(minutes, $7232ef576ffbaa3c$export$bf1071e344bea1d.MINUTES_PER_DAY) + $7232ef576ffbaa3c$var$MathUtil.intDiv(hours, $7232ef576ffbaa3c$export$bf1071e344bea1d.HOURS_PER_DAY);
        totDays *= sign;
        var totNanos = $7232ef576ffbaa3c$var$MathUtil.intMod(nanos, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_DAY) + $7232ef576ffbaa3c$var$MathUtil.intMod(seconds, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY) * $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND + $7232ef576ffbaa3c$var$MathUtil.intMod(minutes, $7232ef576ffbaa3c$export$bf1071e344bea1d.MINUTES_PER_DAY) * $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_MINUTE + $7232ef576ffbaa3c$var$MathUtil.intMod(hours, $7232ef576ffbaa3c$export$bf1071e344bea1d.HOURS_PER_DAY) * $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_HOUR;
        var curNoD = this._time.toNanoOfDay();
        totNanos = totNanos * sign + curNoD;
        totDays += $7232ef576ffbaa3c$var$MathUtil.floorDiv(totNanos, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_DAY);
        var newNoD = $7232ef576ffbaa3c$var$MathUtil.floorMod(totNanos, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_DAY);
        var newTime = newNoD === curNoD ? this._time : $7232ef576ffbaa3c$export$bf1071e344bea1d.ofNanoOfDay(newNoD);
        return this._withDateTime(newDate.plusDays(totDays), newTime);
    };
    _proto.query = function query(_query) {
        $7232ef576ffbaa3c$var$requireNonNull(_query, "query");
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate()) return this.toLocalDate();
        return _ChronoLocalDateTime.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return _ChronoLocalDateTime.prototype.adjustInto.call(this, temporal);
    };
    _proto.until = function until(endExclusive, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(endExclusive, "endExclusive");
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        var end = LocalDateTime.from(endExclusive);
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) {
            if (unit.isTimeBased()) {
                var daysUntil = this._date.daysUntil(end._date);
                var timeUntil = end._time.toNanoOfDay() - this._time.toNanoOfDay();
                if (daysUntil > 0 && timeUntil < 0) {
                    daysUntil--;
                    timeUntil += $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_DAY;
                } else if (daysUntil < 0 && timeUntil > 0) {
                    daysUntil++;
                    timeUntil -= $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_DAY;
                }
                var amount = daysUntil;
                switch(unit){
                    case $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS:
                        amount = $7232ef576ffbaa3c$var$MathUtil.safeMultiply(amount, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_DAY);
                        return $7232ef576ffbaa3c$var$MathUtil.safeAdd(amount, timeUntil);
                    case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MICROS:
                        amount = $7232ef576ffbaa3c$var$MathUtil.safeMultiply(amount, $7232ef576ffbaa3c$export$bf1071e344bea1d.MICROS_PER_DAY);
                        return $7232ef576ffbaa3c$var$MathUtil.safeAdd(amount, $7232ef576ffbaa3c$var$MathUtil.intDiv(timeUntil, 1000));
                    case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLIS:
                        amount = $7232ef576ffbaa3c$var$MathUtil.safeMultiply(amount, $7232ef576ffbaa3c$export$bf1071e344bea1d.MILLIS_PER_DAY);
                        return $7232ef576ffbaa3c$var$MathUtil.safeAdd(amount, $7232ef576ffbaa3c$var$MathUtil.intDiv(timeUntil, 1000000));
                    case $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS:
                        amount = $7232ef576ffbaa3c$var$MathUtil.safeMultiply(amount, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY);
                        return $7232ef576ffbaa3c$var$MathUtil.safeAdd(amount, $7232ef576ffbaa3c$var$MathUtil.intDiv(timeUntil, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND));
                    case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MINUTES:
                        amount = $7232ef576ffbaa3c$var$MathUtil.safeMultiply(amount, $7232ef576ffbaa3c$export$bf1071e344bea1d.MINUTES_PER_DAY);
                        return $7232ef576ffbaa3c$var$MathUtil.safeAdd(amount, $7232ef576ffbaa3c$var$MathUtil.intDiv(timeUntil, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_MINUTE));
                    case $7232ef576ffbaa3c$export$e61e212a4109fb8a.HOURS:
                        amount = $7232ef576ffbaa3c$var$MathUtil.safeMultiply(amount, $7232ef576ffbaa3c$export$bf1071e344bea1d.HOURS_PER_DAY);
                        return $7232ef576ffbaa3c$var$MathUtil.safeAdd(amount, $7232ef576ffbaa3c$var$MathUtil.intDiv(timeUntil, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_HOUR));
                    case $7232ef576ffbaa3c$export$e61e212a4109fb8a.HALF_DAYS:
                        amount = $7232ef576ffbaa3c$var$MathUtil.safeMultiply(amount, 2);
                        return $7232ef576ffbaa3c$var$MathUtil.safeAdd(amount, $7232ef576ffbaa3c$var$MathUtil.intDiv(timeUntil, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_HOUR * 12));
                }
                throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported unit: " + unit);
            }
            var endDate = end._date;
            var endTime = end._time;
            if (endDate.isAfter(this._date) && endTime.isBefore(this._time)) endDate = endDate.minusDays(1);
            else if (endDate.isBefore(this._date) && endTime.isAfter(this._time)) endDate = endDate.plusDays(1);
            return this._date.until(endDate, unit);
        }
        return unit.between(this, end);
    };
    _proto.atZone = function atZone(zone) {
        return $7232ef576ffbaa3c$export$d3b7288e7994edea.of(this, zone);
    };
    _proto.toLocalDate = function toLocalDate() {
        return this._date;
    };
    _proto.toLocalTime = function toLocalTime() {
        return this._time;
    };
    _proto.compareTo = function compareTo(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        $7232ef576ffbaa3c$var$requireInstance(other, LocalDateTime, "other");
        return this._compareTo0(other);
    };
    _proto._compareTo0 = function _compareTo0(other) {
        var cmp = this._date.compareTo(other.toLocalDate());
        if (cmp === 0) cmp = this._time.compareTo(other.toLocalTime());
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        return this.compareTo(other) < 0;
    };
    _proto.isEqual = function isEqual(other) {
        return this.compareTo(other) === 0;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof LocalDateTime) return this._date.equals(other._date) && this._time.equals(other._time);
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._date.hashCode() ^ this._time.hashCode();
    };
    _proto.toString = function toString() {
        return this._date.toString() + "T" + this._time.toString();
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        return formatter.format(this);
    };
    return LocalDateTime;
}($7232ef576ffbaa3c$export$94e985176fb19d17);
function $7232ef576ffbaa3c$var$_init$h() {
    $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.MIN = $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.of($7232ef576ffbaa3c$export$6397c6cbb8fe96b6.MIN, $7232ef576ffbaa3c$export$bf1071e344bea1d.MIN);
    $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.MAX = $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.of($7232ef576ffbaa3c$export$6397c6cbb8fe96b6.MAX, $7232ef576ffbaa3c$export$bf1071e344bea1d.MAX);
    $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.FROM = $7232ef576ffbaa3c$var$createTemporalQuery("LocalDateTime.FROM", function(temporal) {
        return $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.from(temporal);
    });
}
var $7232ef576ffbaa3c$export$bf1071e344bea1d = function(_Temporal) {
    $7232ef576ffbaa3c$var$_inheritsLoose(LocalTime, _Temporal);
    LocalTime.now = function now(clockOrZone) {
        if (clockOrZone == null) return LocalTime._now($7232ef576ffbaa3c$export$9735c82c4bae3302.systemDefaultZone());
        else if (clockOrZone instanceof $7232ef576ffbaa3c$export$9735c82c4bae3302) return LocalTime._now(clockOrZone);
        else return LocalTime._now($7232ef576ffbaa3c$export$9735c82c4bae3302.system(clockOrZone));
    };
    LocalTime._now = function _now(clock) {
        if (clock === void 0) clock = $7232ef576ffbaa3c$export$9735c82c4bae3302.systemDefaultZone();
        $7232ef576ffbaa3c$var$requireNonNull(clock, "clock");
        return LocalTime.ofInstant(clock.instant(), clock.zone());
    };
    LocalTime.ofInstant = function ofInstant(instant, zone) {
        if (zone === void 0) zone = $7232ef576ffbaa3c$export$a514a0be1f00ef62.systemDefault();
        var offset = zone.rules().offset(instant);
        var secsOfDay = $7232ef576ffbaa3c$var$MathUtil.intMod(instant.epochSecond(), LocalTime.SECONDS_PER_DAY);
        secsOfDay = $7232ef576ffbaa3c$var$MathUtil.intMod(secsOfDay + offset.totalSeconds(), LocalTime.SECONDS_PER_DAY);
        if (secsOfDay < 0) secsOfDay += LocalTime.SECONDS_PER_DAY;
        return LocalTime.ofSecondOfDay(secsOfDay, instant.nano());
    };
    LocalTime.of = function of(hour, minute, second, nanoOfSecond) {
        return new LocalTime(hour, minute, second, nanoOfSecond);
    };
    LocalTime.ofSecondOfDay = function ofSecondOfDay(secondOfDay, nanoOfSecond) {
        if (secondOfDay === void 0) secondOfDay = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        $7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_DAY.checkValidValue(secondOfDay);
        $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidValue(nanoOfSecond);
        var hours = $7232ef576ffbaa3c$var$MathUtil.intDiv(secondOfDay, LocalTime.SECONDS_PER_HOUR);
        secondOfDay -= hours * LocalTime.SECONDS_PER_HOUR;
        var minutes = $7232ef576ffbaa3c$var$MathUtil.intDiv(secondOfDay, LocalTime.SECONDS_PER_MINUTE);
        secondOfDay -= minutes * LocalTime.SECONDS_PER_MINUTE;
        return new LocalTime(hours, minutes, secondOfDay, nanoOfSecond);
    };
    LocalTime.ofNanoOfDay = function ofNanoOfDay(nanoOfDay) {
        if (nanoOfDay === void 0) nanoOfDay = 0;
        $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_DAY.checkValidValue(nanoOfDay);
        var hours = $7232ef576ffbaa3c$var$MathUtil.intDiv(nanoOfDay, LocalTime.NANOS_PER_HOUR);
        nanoOfDay -= hours * LocalTime.NANOS_PER_HOUR;
        var minutes = $7232ef576ffbaa3c$var$MathUtil.intDiv(nanoOfDay, LocalTime.NANOS_PER_MINUTE);
        nanoOfDay -= minutes * LocalTime.NANOS_PER_MINUTE;
        var seconds = $7232ef576ffbaa3c$var$MathUtil.intDiv(nanoOfDay, LocalTime.NANOS_PER_SECOND);
        nanoOfDay -= seconds * LocalTime.NANOS_PER_SECOND;
        return new LocalTime(hours, minutes, seconds, nanoOfDay);
    };
    LocalTime.from = function from(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        var time = temporal.query($7232ef576ffbaa3c$export$d6cc568434dfd9dc.localTime());
        if (time == null) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unable to obtain LocalTime TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ""));
        return time;
    };
    LocalTime.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_LOCAL_TIME;
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        return formatter.parse(text, LocalTime.FROM);
    };
    function LocalTime(hour, minute, second, nanoOfSecond) {
        var _this;
        if (hour === void 0) hour = 0;
        if (minute === void 0) minute = 0;
        if (second === void 0) second = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        _this = _Temporal.call(this) || this;
        var _hour = $7232ef576ffbaa3c$var$MathUtil.safeToInt(hour);
        var _minute = $7232ef576ffbaa3c$var$MathUtil.safeToInt(minute);
        var _second = $7232ef576ffbaa3c$var$MathUtil.safeToInt(second);
        var _nanoOfSecond = $7232ef576ffbaa3c$var$MathUtil.safeToInt(nanoOfSecond);
        LocalTime._validate(_hour, _minute, _second, _nanoOfSecond);
        if ((_minute | _second | _nanoOfSecond) === 0) {
            if (!LocalTime.HOURS[_hour]) {
                _this._hour = _hour;
                _this._minute = _minute;
                _this._second = _second;
                _this._nano = _nanoOfSecond;
                LocalTime.HOURS[_hour] = $7232ef576ffbaa3c$var$_assertThisInitialized(_this);
            }
            return LocalTime.HOURS[_hour] || $7232ef576ffbaa3c$var$_assertThisInitialized(_this);
        }
        _this._hour = _hour;
        _this._minute = _minute;
        _this._second = _second;
        _this._nano = _nanoOfSecond;
        return _this;
    }
    LocalTime._validate = function _validate(hour, minute, second, nanoOfSecond) {
        $7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY.checkValidValue(hour);
        $7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_HOUR.checkValidValue(minute);
        $7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_MINUTE.checkValidValue(second);
        $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidValue(nanoOfSecond);
    };
    var _proto = LocalTime.prototype;
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return fieldOrUnit.isTimeBased();
        else if (fieldOrUnit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) return fieldOrUnit.isTimeBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        $7232ef576ffbaa3c$var$requireNonNull(field);
        return _Temporal.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return this._get0(field);
        return field.getFrom(this);
    };
    _proto._get0 = function _get0(field) {
        switch(field){
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND:
                return this._nano;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_DAY:
                return this.toNanoOfDay();
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND:
                return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._nano, 1000);
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_DAY:
                return $7232ef576ffbaa3c$var$MathUtil.intDiv(this.toNanoOfDay(), 1000);
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND:
                return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._nano, 1000000);
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_DAY:
                return $7232ef576ffbaa3c$var$MathUtil.intDiv(this.toNanoOfDay(), 1000000);
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_MINUTE:
                return this._second;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_DAY:
                return this.toSecondOfDay();
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_HOUR:
                return this._minute;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_DAY:
                return this._hour * 60 + this._minute;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_AMPM:
                return $7232ef576ffbaa3c$var$MathUtil.intMod(this._hour, 12);
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM:
                var ham = $7232ef576ffbaa3c$var$MathUtil.intMod(this._hour, 12);
                return ham % 12 === 0 ? 12 : ham;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY:
                return this._hour;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY:
                return this._hour === 0 ? 24 : this._hour;
            case $7232ef576ffbaa3c$export$7f55a40756153c3e.AMPM_OF_DAY:
                return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._hour, 12);
        }
        throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
    };
    _proto.hour = function hour() {
        return this._hour;
    };
    _proto.minute = function minute() {
        return this._minute;
    };
    _proto.second = function second() {
        return this._second;
    };
    _proto.nano = function nano() {
        return this._nano;
    };
    _proto.with = function _with(adjusterOrField, newValue) {
        if (arguments.length < 2) return this.withTemporalAdjuster(adjusterOrField);
        else return this.with2(adjusterOrField, newValue);
    };
    _proto.withTemporalAdjuster = function withTemporalAdjuster(adjuster) {
        $7232ef576ffbaa3c$var$requireNonNull(adjuster, "adjuster");
        if (adjuster instanceof LocalTime) return adjuster;
        $7232ef576ffbaa3c$var$assert(typeof adjuster.adjustInto === "function", "adjuster", $7232ef576ffbaa3c$export$86eb44ed3377dd8f);
        return adjuster.adjustInto(this);
    };
    _proto.with2 = function with2(field, newValue) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        $7232ef576ffbaa3c$var$requireInstance(field, $7232ef576ffbaa3c$export$d879d8cdc7b5c1c9, "field");
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            field.checkValidValue(newValue);
            switch(field){
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND:
                    return this.withNano(newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_DAY:
                    return LocalTime.ofNanoOfDay(newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND:
                    return this.withNano(newValue * 1000);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_DAY:
                    return LocalTime.ofNanoOfDay(newValue * 1000);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND:
                    return this.withNano(newValue * 1000000);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_DAY:
                    return LocalTime.ofNanoOfDay(newValue * 1000000);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_MINUTE:
                    return this.withSecond(newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.SECOND_OF_DAY:
                    return this.plusSeconds(newValue - this.toSecondOfDay());
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_HOUR:
                    return this.withMinute(newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.MINUTE_OF_DAY:
                    return this.plusMinutes(newValue - (this._hour * 60 + this._minute));
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_AMPM:
                    return this.plusHours(newValue - $7232ef576ffbaa3c$var$MathUtil.intMod(this._hour, 12));
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM:
                    return this.plusHours((newValue === 12 ? 0 : newValue) - $7232ef576ffbaa3c$var$MathUtil.intMod(this._hour, 12));
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.HOUR_OF_DAY:
                    return this.withHour(newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY:
                    return this.withHour(newValue === 24 ? 0 : newValue);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.AMPM_OF_DAY:
                    return this.plusHours((newValue - $7232ef576ffbaa3c$var$MathUtil.intDiv(this._hour, 12)) * 12);
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withHour = function withHour(hour) {
        if (hour === void 0) hour = 0;
        if (this._hour === hour) return this;
        return new LocalTime(hour, this._minute, this._second, this._nano);
    };
    _proto.withMinute = function withMinute(minute) {
        if (minute === void 0) minute = 0;
        if (this._minute === minute) return this;
        return new LocalTime(this._hour, minute, this._second, this._nano);
    };
    _proto.withSecond = function withSecond(second) {
        if (second === void 0) second = 0;
        if (this._second === second) return this;
        return new LocalTime(this._hour, this._minute, second, this._nano);
    };
    _proto.withNano = function withNano(nanoOfSecond) {
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        if (this._nano === nanoOfSecond) return this;
        return new LocalTime(this._hour, this._minute, this._second, nanoOfSecond);
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        if (unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS) return this;
        var unitDur = unit.duration();
        if (unitDur.seconds() > LocalTime.SECONDS_PER_DAY) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unit is too large to be used for truncation");
        var dur = unitDur.toNanos();
        if ($7232ef576ffbaa3c$var$MathUtil.intMod(LocalTime.NANOS_PER_DAY, dur) !== 0) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unit must divide into a standard day without remainder");
        var nod = this.toNanoOfDay();
        return LocalTime.ofNanoOfDay($7232ef576ffbaa3c$var$MathUtil.intDiv(nod, dur) * dur);
    };
    _proto.plus = function plus(amount, unit) {
        if (arguments.length < 2) return this.plus1(amount);
        else return this.plus2(amount, unit);
    };
    _proto.plus1 = function plus1(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        return amount.addTo(this);
    };
    _proto.plus2 = function plus2(amountToAdd, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) {
            switch(unit){
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS:
                    return this.plusNanos(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MICROS:
                    return this.plusNanos($7232ef576ffbaa3c$var$MathUtil.intMod(amountToAdd, LocalTime.MICROS_PER_DAY) * 1000);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLIS:
                    return this.plusNanos($7232ef576ffbaa3c$var$MathUtil.intMod(amountToAdd, LocalTime.MILLIS_PER_DAY) * 1000000);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS:
                    return this.plusSeconds(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MINUTES:
                    return this.plusMinutes(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.HOURS:
                    return this.plusHours(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.HALF_DAYS:
                    return this.plusHours($7232ef576ffbaa3c$var$MathUtil.intMod(amountToAdd, 2) * 12);
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusHours = function plusHours(hoursToAdd) {
        if (hoursToAdd === 0) return this;
        var newHour = $7232ef576ffbaa3c$var$MathUtil.intMod($7232ef576ffbaa3c$var$MathUtil.intMod(hoursToAdd, LocalTime.HOURS_PER_DAY) + this._hour + LocalTime.HOURS_PER_DAY, LocalTime.HOURS_PER_DAY);
        return new LocalTime(newHour, this._minute, this._second, this._nano);
    };
    _proto.plusMinutes = function plusMinutes(minutesToAdd) {
        if (minutesToAdd === 0) return this;
        var mofd = this._hour * LocalTime.MINUTES_PER_HOUR + this._minute;
        var newMofd = $7232ef576ffbaa3c$var$MathUtil.intMod($7232ef576ffbaa3c$var$MathUtil.intMod(minutesToAdd, LocalTime.MINUTES_PER_DAY) + mofd + LocalTime.MINUTES_PER_DAY, LocalTime.MINUTES_PER_DAY);
        if (mofd === newMofd) return this;
        var newHour = $7232ef576ffbaa3c$var$MathUtil.intDiv(newMofd, LocalTime.MINUTES_PER_HOUR);
        var newMinute = $7232ef576ffbaa3c$var$MathUtil.intMod(newMofd, LocalTime.MINUTES_PER_HOUR);
        return new LocalTime(newHour, newMinute, this._second, this._nano);
    };
    _proto.plusSeconds = function plusSeconds(secondsToAdd) {
        if (secondsToAdd === 0) return this;
        var sofd = this._hour * LocalTime.SECONDS_PER_HOUR + this._minute * LocalTime.SECONDS_PER_MINUTE + this._second;
        var newSofd = $7232ef576ffbaa3c$var$MathUtil.intMod($7232ef576ffbaa3c$var$MathUtil.intMod(secondsToAdd, LocalTime.SECONDS_PER_DAY) + sofd + LocalTime.SECONDS_PER_DAY, LocalTime.SECONDS_PER_DAY);
        if (sofd === newSofd) return this;
        var newHour = $7232ef576ffbaa3c$var$MathUtil.intDiv(newSofd, LocalTime.SECONDS_PER_HOUR);
        var newMinute = $7232ef576ffbaa3c$var$MathUtil.intMod($7232ef576ffbaa3c$var$MathUtil.intDiv(newSofd, LocalTime.SECONDS_PER_MINUTE), LocalTime.MINUTES_PER_HOUR);
        var newSecond = $7232ef576ffbaa3c$var$MathUtil.intMod(newSofd, LocalTime.SECONDS_PER_MINUTE);
        return new LocalTime(newHour, newMinute, newSecond, this._nano);
    };
    _proto.plusNanos = function plusNanos(nanosToAdd) {
        if (nanosToAdd === 0) return this;
        var nofd = this.toNanoOfDay();
        var newNofd = $7232ef576ffbaa3c$var$MathUtil.intMod($7232ef576ffbaa3c$var$MathUtil.intMod(nanosToAdd, LocalTime.NANOS_PER_DAY) + nofd + LocalTime.NANOS_PER_DAY, LocalTime.NANOS_PER_DAY);
        if (nofd === newNofd) return this;
        var newHour = $7232ef576ffbaa3c$var$MathUtil.intDiv(newNofd, LocalTime.NANOS_PER_HOUR);
        var newMinute = $7232ef576ffbaa3c$var$MathUtil.intMod($7232ef576ffbaa3c$var$MathUtil.intDiv(newNofd, LocalTime.NANOS_PER_MINUTE), LocalTime.MINUTES_PER_HOUR);
        var newSecond = $7232ef576ffbaa3c$var$MathUtil.intMod($7232ef576ffbaa3c$var$MathUtil.intDiv(newNofd, LocalTime.NANOS_PER_SECOND), LocalTime.SECONDS_PER_MINUTE);
        var newNano = $7232ef576ffbaa3c$var$MathUtil.intMod(newNofd, LocalTime.NANOS_PER_SECOND);
        return new LocalTime(newHour, newMinute, newSecond, newNano);
    };
    _proto.minus = function minus(amount, unit) {
        if (arguments.length < 2) return this.minus1(amount);
        else return this.minus2(amount, unit);
    };
    _proto.minus1 = function minus1(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minus2 = function minus2(amountToSubtract, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        return this.plus2(-1 * amountToSubtract, unit);
    };
    _proto.minusHours = function minusHours(hoursToSubtract) {
        return this.plusHours(-1 * $7232ef576ffbaa3c$var$MathUtil.intMod(hoursToSubtract, LocalTime.HOURS_PER_DAY));
    };
    _proto.minusMinutes = function minusMinutes(minutesToSubtract) {
        return this.plusMinutes(-1 * $7232ef576ffbaa3c$var$MathUtil.intMod(minutesToSubtract, LocalTime.MINUTES_PER_DAY));
    };
    _proto.minusSeconds = function minusSeconds(secondsToSubtract) {
        return this.plusSeconds(-1 * $7232ef576ffbaa3c$var$MathUtil.intMod(secondsToSubtract, LocalTime.SECONDS_PER_DAY));
    };
    _proto.minusNanos = function minusNanos(nanosToSubtract) {
        return this.plusNanos(-1 * $7232ef576ffbaa3c$var$MathUtil.intMod(nanosToSubtract, LocalTime.NANOS_PER_DAY));
    };
    _proto.query = function query(_query) {
        $7232ef576ffbaa3c$var$requireNonNull(_query, "query");
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.precision()) return $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS;
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localTime()) return this;
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.chronology() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zoneId() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zone() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.offset() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate()) return null;
        return _query.queryFrom(this);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with(LocalTime.NANO_OF_DAY, this.toNanoOfDay());
    };
    _proto.until = function until(endExclusive, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(endExclusive, "endExclusive");
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        var end = LocalTime.from(endExclusive);
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) {
            var nanosUntil = end.toNanoOfDay() - this.toNanoOfDay();
            switch(unit){
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS:
                    return nanosUntil;
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MICROS:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(nanosUntil, 1000);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLIS:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(nanosUntil, 1000000);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_SECOND);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MINUTES:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_MINUTE);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.HOURS:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_HOUR);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.HALF_DAYS:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(nanosUntil, 12 * LocalTime.NANOS_PER_HOUR);
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    _proto.atDate = function atDate(date) {
        return $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.of(date, this);
    };
    _proto.toSecondOfDay = function toSecondOfDay() {
        var total = this._hour * LocalTime.SECONDS_PER_HOUR;
        total += this._minute * LocalTime.SECONDS_PER_MINUTE;
        total += this._second;
        return total;
    };
    _proto.toNanoOfDay = function toNanoOfDay() {
        var total = this._hour * LocalTime.NANOS_PER_HOUR;
        total += this._minute * LocalTime.NANOS_PER_MINUTE;
        total += this._second * LocalTime.NANOS_PER_SECOND;
        total += this._nano;
        return total;
    };
    _proto.compareTo = function compareTo(other) {
        $7232ef576ffbaa3c$var$requireNonNull(other, "other");
        $7232ef576ffbaa3c$var$requireInstance(other, LocalTime, "other");
        var cmp = $7232ef576ffbaa3c$var$MathUtil.compareNumbers(this._hour, other._hour);
        if (cmp === 0) {
            cmp = $7232ef576ffbaa3c$var$MathUtil.compareNumbers(this._minute, other._minute);
            if (cmp === 0) {
                cmp = $7232ef576ffbaa3c$var$MathUtil.compareNumbers(this._second, other._second);
                if (cmp === 0) cmp = $7232ef576ffbaa3c$var$MathUtil.compareNumbers(this._nano, other._nano);
            }
        }
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        return this.compareTo(other) < 0;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof LocalTime) return this._hour === other._hour && this._minute === other._minute && this._second === other._second && this._nano === other._nano;
        return false;
    };
    _proto.hashCode = function hashCode() {
        var nod = this.toNanoOfDay();
        return $7232ef576ffbaa3c$var$MathUtil.hash(nod);
    };
    _proto.toString = function toString() {
        var buf = "";
        var hourValue = this._hour;
        var minuteValue = this._minute;
        var secondValue = this._second;
        var nanoValue = this._nano;
        buf += hourValue < 10 ? "0" : "";
        buf += hourValue;
        buf += minuteValue < 10 ? ":0" : ":";
        buf += minuteValue;
        if (secondValue > 0 || nanoValue > 0) {
            buf += secondValue < 10 ? ":0" : ":";
            buf += secondValue;
            if (nanoValue > 0) {
                buf += ".";
                if ($7232ef576ffbaa3c$var$MathUtil.intMod(nanoValue, 1000000) === 0) buf += ("" + ($7232ef576ffbaa3c$var$MathUtil.intDiv(nanoValue, 1000000) + 1000)).substring(1);
                else if ($7232ef576ffbaa3c$var$MathUtil.intMod(nanoValue, 1000) === 0) buf += ("" + ($7232ef576ffbaa3c$var$MathUtil.intDiv(nanoValue, 1000) + 1000000)).substring(1);
                else buf += ("" + (nanoValue + 1000000000)).substring(1);
            }
        }
        return buf;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $7232ef576ffbaa3c$var$requireNonNull(formatter, "formatter");
        return formatter.format(this);
    };
    return LocalTime;
}($7232ef576ffbaa3c$export$336849d529cb05e5);
function $7232ef576ffbaa3c$var$_init$i() {
    $7232ef576ffbaa3c$export$bf1071e344bea1d.HOURS = [];
    for(var hour = 0; hour < 24; hour++)$7232ef576ffbaa3c$export$bf1071e344bea1d.of(hour, 0, 0, 0);
    $7232ef576ffbaa3c$export$bf1071e344bea1d.MIN = $7232ef576ffbaa3c$export$bf1071e344bea1d.HOURS[0];
    $7232ef576ffbaa3c$export$bf1071e344bea1d.MAX = new $7232ef576ffbaa3c$export$bf1071e344bea1d(23, 59, 59, 999999999);
    $7232ef576ffbaa3c$export$bf1071e344bea1d.MIDNIGHT = $7232ef576ffbaa3c$export$bf1071e344bea1d.HOURS[0];
    $7232ef576ffbaa3c$export$bf1071e344bea1d.NOON = $7232ef576ffbaa3c$export$bf1071e344bea1d.HOURS[12];
    $7232ef576ffbaa3c$export$bf1071e344bea1d.FROM = $7232ef576ffbaa3c$var$createTemporalQuery("LocalTime.FROM", function(temporal) {
        return $7232ef576ffbaa3c$export$bf1071e344bea1d.from(temporal);
    });
}
$7232ef576ffbaa3c$export$bf1071e344bea1d.HOURS_PER_DAY = 24;
$7232ef576ffbaa3c$export$bf1071e344bea1d.MINUTES_PER_HOUR = 60;
$7232ef576ffbaa3c$export$bf1071e344bea1d.MINUTES_PER_DAY = $7232ef576ffbaa3c$export$bf1071e344bea1d.MINUTES_PER_HOUR * $7232ef576ffbaa3c$export$bf1071e344bea1d.HOURS_PER_DAY;
$7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE = 60;
$7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_HOUR = $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE * $7232ef576ffbaa3c$export$bf1071e344bea1d.MINUTES_PER_HOUR;
$7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY = $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_HOUR * $7232ef576ffbaa3c$export$bf1071e344bea1d.HOURS_PER_DAY;
$7232ef576ffbaa3c$export$bf1071e344bea1d.MILLIS_PER_DAY = $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY * 1000;
$7232ef576ffbaa3c$export$bf1071e344bea1d.MICROS_PER_DAY = $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY * 1000000;
$7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND = 1000000000;
$7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_MINUTE = $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND * $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE;
$7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_HOUR = $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_MINUTE * $7232ef576ffbaa3c$export$bf1071e344bea1d.MINUTES_PER_HOUR;
$7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_DAY = $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_HOUR * $7232ef576ffbaa3c$export$bf1071e344bea1d.HOURS_PER_DAY;
var $7232ef576ffbaa3c$var$NANOS_PER_MILLI = 1000000;
var $7232ef576ffbaa3c$export$fecec53969739358 = function(_Temporal) {
    $7232ef576ffbaa3c$var$_inheritsLoose(Instant, _Temporal);
    Instant.now = function now(clock) {
        if (clock === void 0) clock = $7232ef576ffbaa3c$export$9735c82c4bae3302.systemUTC();
        return clock.instant();
    };
    Instant.ofEpochSecond = function ofEpochSecond(epochSecond, nanoAdjustment) {
        if (nanoAdjustment === void 0) nanoAdjustment = 0;
        var secs = epochSecond + $7232ef576ffbaa3c$var$MathUtil.floorDiv(nanoAdjustment, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nos = $7232ef576ffbaa3c$var$MathUtil.floorMod(nanoAdjustment, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND);
        return Instant._create(secs, nos);
    };
    Instant.ofEpochMilli = function ofEpochMilli(epochMilli) {
        var secs = $7232ef576ffbaa3c$var$MathUtil.floorDiv(epochMilli, 1000);
        var mos = $7232ef576ffbaa3c$var$MathUtil.floorMod(epochMilli, 1000);
        return Instant._create(secs, mos * 1000000);
    };
    Instant.from = function from(temporal) {
        try {
            var instantSecs = temporal.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS);
            var nanoOfSecond = temporal.get($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND);
            return Instant.ofEpochSecond(instantSecs, nanoOfSecond);
        } catch (ex) {
            throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unable to obtain Instant from TemporalAccessor: " + temporal + ", type " + (typeof temporal === "undefined" ? "undefined" : (0, $l6pW7._)(temporal)), ex);
        }
    };
    Instant.parse = function parse(text) {
        return $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_INSTANT.parse(text, Instant.FROM);
    };
    Instant._create = function _create(seconds, nanoOfSecond) {
        if (seconds === 0 && nanoOfSecond === 0) return Instant.EPOCH;
        return new Instant(seconds, nanoOfSecond);
    };
    Instant._validate = function _validate(seconds, nanoOfSecond) {
        if (seconds < Instant.MIN_SECONDS || seconds > Instant.MAX_SECONDS) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Instant exceeds minimum or maximum instant");
        if (nanoOfSecond < 0 || nanoOfSecond > $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Instant exceeds minimum or maximum instant");
    };
    function Instant(seconds, nanoOfSecond) {
        var _this;
        _this = _Temporal.call(this) || this;
        Instant._validate(seconds, nanoOfSecond);
        _this._seconds = $7232ef576ffbaa3c$var$MathUtil.safeToInt(seconds);
        _this._nanos = $7232ef576ffbaa3c$var$MathUtil.safeToInt(nanoOfSecond);
        return _this;
    }
    var _proto = Instant.prototype;
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) return fieldOrUnit === $7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS || fieldOrUnit === $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND || fieldOrUnit === $7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND || fieldOrUnit === $7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND;
        if (fieldOrUnit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) return fieldOrUnit.isTimeBased() || fieldOrUnit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS;
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        return _Temporal.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            switch(field){
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND:
                    return this._nanos;
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._nanos, 1000);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._nanos, $7232ef576ffbaa3c$var$NANOS_PER_MILLI);
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return this._seconds;
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.getFrom(this);
    };
    _proto.epochSecond = function epochSecond() {
        return this._seconds;
    };
    _proto.nano = function nano() {
        return this._nanos;
    };
    _proto.with = function _with(adjusterOrField, newValue) {
        if (arguments.length === 1) return this.withTemporalAdjuster(adjusterOrField);
        else return this.with2(adjusterOrField, newValue);
    };
    _proto.withTemporalAdjuster = function withTemporalAdjuster(adjuster) {
        $7232ef576ffbaa3c$var$requireNonNull(adjuster, "adjuster");
        return adjuster.adjustInto(this);
    };
    _proto.with2 = function with2(field, newValue) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            field.checkValidValue(newValue);
            switch(field){
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.MILLI_OF_SECOND:
                    var nval = newValue * $7232ef576ffbaa3c$var$NANOS_PER_MILLI;
                    return nval !== this._nanos ? Instant._create(this._seconds, nval) : this;
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.MICRO_OF_SECOND:
                    var _nval = newValue * 1000;
                    return _nval !== this._nanos ? Instant._create(this._seconds, _nval) : this;
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND:
                    return newValue !== this._nanos ? Instant._create(this._seconds, newValue) : this;
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return newValue !== this._seconds ? Instant._create(newValue, this._nanos) : this;
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        if (unit === $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS) return this;
        var unitDur = unit.duration();
        if (unitDur.seconds() > $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unit is too large to be used for truncation");
        var dur = unitDur.toNanos();
        if ($7232ef576ffbaa3c$var$MathUtil.intMod($7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_DAY, dur) !== 0) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unit must divide into a standard day without remainder");
        var nod = $7232ef576ffbaa3c$var$MathUtil.intMod(this._seconds, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY) * $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND + this._nanos;
        var result = $7232ef576ffbaa3c$var$MathUtil.intDiv(nod, dur) * dur;
        return this.plusNanos(result - nod);
    };
    _proto.plus = function plus(amount, unit) {
        if (arguments.length === 1) return this.plus1(amount);
        else return this.plus2(amount, unit);
    };
    _proto.plus1 = function plus1(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        return amount.addTo(this);
    };
    _proto.plus2 = function plus2(amountToAdd, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(amountToAdd, "amountToAdd");
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        $7232ef576ffbaa3c$var$requireInstance(unit, $7232ef576ffbaa3c$export$5d412a4bb789788e);
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) {
            switch(unit){
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS:
                    return this.plusNanos(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MICROS:
                    return this._plus($7232ef576ffbaa3c$var$MathUtil.intDiv(amountToAdd, 1000000), $7232ef576ffbaa3c$var$MathUtil.intMod(amountToAdd, 1000000) * 1000);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLIS:
                    return this.plusMillis(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS:
                    return this.plusSeconds(amountToAdd);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MINUTES:
                    return this.plusSeconds($7232ef576ffbaa3c$var$MathUtil.safeMultiply(amountToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE));
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.HOURS:
                    return this.plusSeconds($7232ef576ffbaa3c$var$MathUtil.safeMultiply(amountToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_HOUR));
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.HALF_DAYS:
                    return this.plusSeconds($7232ef576ffbaa3c$var$MathUtil.safeMultiply(amountToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY / 2));
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS:
                    return this.plusSeconds($7232ef576ffbaa3c$var$MathUtil.safeMultiply(amountToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY));
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusSeconds = function plusSeconds(secondsToAdd) {
        return this._plus(secondsToAdd, 0);
    };
    _proto.plusMillis = function plusMillis(millisToAdd) {
        return this._plus($7232ef576ffbaa3c$var$MathUtil.intDiv(millisToAdd, 1000), $7232ef576ffbaa3c$var$MathUtil.intMod(millisToAdd, 1000) * $7232ef576ffbaa3c$var$NANOS_PER_MILLI);
    };
    _proto.plusNanos = function plusNanos(nanosToAdd) {
        return this._plus(0, nanosToAdd);
    };
    _proto._plus = function _plus(secondsToAdd, nanosToAdd) {
        if ((secondsToAdd | nanosToAdd) === 0) return this;
        var epochSec = this._seconds + secondsToAdd;
        epochSec = epochSec + $7232ef576ffbaa3c$var$MathUtil.intDiv(nanosToAdd, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nanoAdjustment = this._nanos + nanosToAdd % $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND;
        return Instant.ofEpochSecond(epochSec, nanoAdjustment);
    };
    _proto.minus = function minus(amount, unit) {
        if (arguments.length === 1) return this.minus1(amount);
        else return this.minus2(amount, unit);
    };
    _proto.minus1 = function minus1(amount) {
        $7232ef576ffbaa3c$var$requireNonNull(amount, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minus2 = function minus2(amountToSubtract, unit) {
        return this.plus2(-1 * amountToSubtract, unit);
    };
    _proto.minusSeconds = function minusSeconds(secondsToSubtract) {
        return this.plusSeconds(secondsToSubtract * -1);
    };
    _proto.minusMillis = function minusMillis(millisToSubtract) {
        return this.plusMillis(-1 * millisToSubtract);
    };
    _proto.minusNanos = function minusNanos(nanosToSubtract) {
        return this.plusNanos(-1 * nanosToSubtract);
    };
    _proto.query = function query(_query) {
        $7232ef576ffbaa3c$var$requireNonNull(_query, "query");
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.precision()) return $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS;
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localTime() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.chronology() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zoneId() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zone() || _query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.offset()) return null;
        return _query.queryFrom(this);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        return temporal.with($7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS, this._seconds).with($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND, this._nanos);
    };
    _proto.until = function until(endExclusive, unit) {
        $7232ef576ffbaa3c$var$requireNonNull(endExclusive, "endExclusive");
        $7232ef576ffbaa3c$var$requireNonNull(unit, "unit");
        var end = Instant.from(endExclusive);
        if (unit instanceof $7232ef576ffbaa3c$export$e61e212a4109fb8a) {
            switch(unit){
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.NANOS:
                    return this._nanosUntil(end);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MICROS:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._nanosUntil(end), 1000);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MILLIS:
                    return $7232ef576ffbaa3c$var$MathUtil.safeSubtract(end.toEpochMilli(), this.toEpochMilli());
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.SECONDS:
                    return this._secondsUntil(end);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.MINUTES:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._secondsUntil(end), $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.HOURS:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._secondsUntil(end), $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_HOUR);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.HALF_DAYS:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._secondsUntil(end), 12 * $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_HOUR);
                case $7232ef576ffbaa3c$export$e61e212a4109fb8a.DAYS:
                    return $7232ef576ffbaa3c$var$MathUtil.intDiv(this._secondsUntil(end), $7232ef576ffbaa3c$export$bf1071e344bea1d.SECONDS_PER_DAY);
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    _proto._nanosUntil = function _nanosUntil(end) {
        var secsDiff = $7232ef576ffbaa3c$var$MathUtil.safeSubtract(end.epochSecond(), this.epochSecond());
        var totalNanos = $7232ef576ffbaa3c$var$MathUtil.safeMultiply(secsDiff, $7232ef576ffbaa3c$export$bf1071e344bea1d.NANOS_PER_SECOND);
        return $7232ef576ffbaa3c$var$MathUtil.safeAdd(totalNanos, end.nano() - this.nano());
    };
    _proto._secondsUntil = function _secondsUntil(end) {
        var secsDiff = $7232ef576ffbaa3c$var$MathUtil.safeSubtract(end.epochSecond(), this.epochSecond());
        var nanosDiff = end.nano() - this.nano();
        if (secsDiff > 0 && nanosDiff < 0) secsDiff--;
        else if (secsDiff < 0 && nanosDiff > 0) secsDiff++;
        return secsDiff;
    };
    _proto.atZone = function atZone(zone) {
        return $7232ef576ffbaa3c$export$d3b7288e7994edea.ofInstant(this, zone);
    };
    _proto.toEpochMilli = function toEpochMilli() {
        var millis = $7232ef576ffbaa3c$var$MathUtil.safeMultiply(this._seconds, 1000);
        return millis + $7232ef576ffbaa3c$var$MathUtil.intDiv(this._nanos, $7232ef576ffbaa3c$var$NANOS_PER_MILLI);
    };
    _proto.compareTo = function compareTo(otherInstant) {
        $7232ef576ffbaa3c$var$requireNonNull(otherInstant, "otherInstant");
        $7232ef576ffbaa3c$var$requireInstance(otherInstant, Instant, "otherInstant");
        var cmp = $7232ef576ffbaa3c$var$MathUtil.compareNumbers(this._seconds, otherInstant._seconds);
        if (cmp !== 0) return cmp;
        return this._nanos - otherInstant._nanos;
    };
    _proto.isAfter = function isAfter(otherInstant) {
        return this.compareTo(otherInstant) > 0;
    };
    _proto.isBefore = function isBefore(otherInstant) {
        return this.compareTo(otherInstant) < 0;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof Instant) return this.epochSecond() === other.epochSecond() && this.nano() === other.nano();
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $7232ef576ffbaa3c$var$MathUtil.hashCode(this._seconds, this._nanos);
    };
    _proto.toString = function toString() {
        return $7232ef576ffbaa3c$export$3245e15bf4cbdd6c.ISO_INSTANT.format(this);
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return Instant;
}($7232ef576ffbaa3c$export$336849d529cb05e5);
function $7232ef576ffbaa3c$var$_init$j() {
    $7232ef576ffbaa3c$export$fecec53969739358.MIN_SECONDS = -31619119219200;
    $7232ef576ffbaa3c$export$fecec53969739358.MAX_SECONDS = 31494816403199;
    $7232ef576ffbaa3c$export$fecec53969739358.EPOCH = new $7232ef576ffbaa3c$export$fecec53969739358(0, 0);
    $7232ef576ffbaa3c$export$fecec53969739358.MIN = $7232ef576ffbaa3c$export$fecec53969739358.ofEpochSecond($7232ef576ffbaa3c$export$fecec53969739358.MIN_SECONDS, 0);
    $7232ef576ffbaa3c$export$fecec53969739358.MAX = $7232ef576ffbaa3c$export$fecec53969739358.ofEpochSecond($7232ef576ffbaa3c$export$fecec53969739358.MAX_SECONDS, 999999999);
    $7232ef576ffbaa3c$export$fecec53969739358.FROM = $7232ef576ffbaa3c$var$createTemporalQuery("Instant.FROM", function(temporal) {
        return $7232ef576ffbaa3c$export$fecec53969739358.from(temporal);
    });
}
var $7232ef576ffbaa3c$export$9735c82c4bae3302 = function() {
    function Clock() {}
    Clock.systemUTC = function systemUTC() {
        return new $7232ef576ffbaa3c$var$SystemClock($7232ef576ffbaa3c$export$47ce5d56ab10eaa3.UTC);
    };
    Clock.systemDefaultZone = function systemDefaultZone() {
        return new $7232ef576ffbaa3c$var$SystemClock($7232ef576ffbaa3c$export$a514a0be1f00ef62.systemDefault());
    };
    Clock.system = function system(zone) {
        return new $7232ef576ffbaa3c$var$SystemClock(zone);
    };
    Clock.fixed = function fixed(fixedInstant, zoneId) {
        return new $7232ef576ffbaa3c$var$FixedClock(fixedInstant, zoneId);
    };
    Clock.offset = function offset(baseClock, duration) {
        return new $7232ef576ffbaa3c$var$OffsetClock(baseClock, duration);
    };
    var _proto = Clock.prototype;
    _proto.millis = function millis() {
        $7232ef576ffbaa3c$var$abstractMethodFail("Clock.millis");
    };
    _proto.instant = function instant() {
        $7232ef576ffbaa3c$var$abstractMethodFail("Clock.instant");
    };
    _proto.zone = function zone() {
        $7232ef576ffbaa3c$var$abstractMethodFail("Clock.zone");
    };
    _proto.withZone = function withZone() {
        $7232ef576ffbaa3c$var$abstractMethodFail("Clock.withZone");
    };
    return Clock;
}();
var $7232ef576ffbaa3c$var$SystemClock = function(_Clock) {
    $7232ef576ffbaa3c$var$_inheritsLoose(SystemClock, _Clock);
    function SystemClock(zone) {
        var _this;
        $7232ef576ffbaa3c$var$requireNonNull(zone, "zone");
        _this = _Clock.call(this) || this;
        _this._zone = zone;
        return _this;
    }
    var _proto2 = SystemClock.prototype;
    _proto2.zone = function zone() {
        return this._zone;
    };
    _proto2.millis = function millis() {
        return new Date().getTime();
    };
    _proto2.instant = function instant() {
        return $7232ef576ffbaa3c$export$fecec53969739358.ofEpochMilli(this.millis());
    };
    _proto2.equals = function equals(obj) {
        if (obj instanceof SystemClock) return this._zone.equals(obj._zone);
        return false;
    };
    _proto2.withZone = function withZone(zone) {
        if (zone.equals(this._zone)) return this;
        return new SystemClock(zone);
    };
    _proto2.toString = function toString() {
        return "SystemClock[" + this._zone.toString() + "]";
    };
    return SystemClock;
}($7232ef576ffbaa3c$export$9735c82c4bae3302);
var $7232ef576ffbaa3c$var$FixedClock = function(_Clock2) {
    $7232ef576ffbaa3c$var$_inheritsLoose(FixedClock, _Clock2);
    function FixedClock(fixedInstant, zoneId) {
        var _this2;
        _this2 = _Clock2.call(this) || this;
        _this2._instant = fixedInstant;
        _this2._zoneId = zoneId;
        return _this2;
    }
    var _proto3 = FixedClock.prototype;
    _proto3.instant = function instant() {
        return this._instant;
    };
    _proto3.millis = function millis() {
        return this._instant.toEpochMilli();
    };
    _proto3.zone = function zone() {
        return this._zoneId;
    };
    _proto3.toString = function toString() {
        return "FixedClock[]";
    };
    _proto3.equals = function equals(obj) {
        if (obj instanceof FixedClock) return this._instant.equals(obj._instant) && this._zoneId.equals(obj._zoneId);
        return false;
    };
    _proto3.withZone = function withZone(zone) {
        if (zone.equals(this._zoneId)) return this;
        return new FixedClock(this._instant, zone);
    };
    return FixedClock;
}($7232ef576ffbaa3c$export$9735c82c4bae3302);
var $7232ef576ffbaa3c$var$OffsetClock = function(_Clock3) {
    $7232ef576ffbaa3c$var$_inheritsLoose(OffsetClock, _Clock3);
    function OffsetClock(baseClock, offset) {
        var _this3;
        _this3 = _Clock3.call(this) || this;
        _this3._baseClock = baseClock;
        _this3._offset = offset;
        return _this3;
    }
    var _proto4 = OffsetClock.prototype;
    _proto4.zone = function zone() {
        return this._baseClock.zone();
    };
    _proto4.withZone = function withZone(zone) {
        if (zone.equals(this._baseClock.zone())) return this;
        return new OffsetClock(this._baseClock.withZone(zone), this._offset);
    };
    _proto4.millis = function millis() {
        return this._baseClock.millis() + this._offset.toMillis();
    };
    _proto4.instant = function instant() {
        return this._baseClock.instant().plus(this._offset);
    };
    _proto4.equals = function equals(obj) {
        if (obj instanceof OffsetClock) return this._baseClock.equals(obj._baseClock) && this._offset.equals(obj._offset);
        return false;
    };
    _proto4.toString = function toString() {
        return "OffsetClock[" + this._baseClock + "," + this._offset + "]";
    };
    return OffsetClock;
}($7232ef576ffbaa3c$export$9735c82c4bae3302);
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$export$993d982a5ca9c76d = function() {
    ZoneOffsetTransition.of = function of(transition, offsetBefore, offsetAfter) {
        return new ZoneOffsetTransition(transition, offsetBefore, offsetAfter);
    };
    function ZoneOffsetTransition(transition, offsetBefore, offsetAfter) {
        $7232ef576ffbaa3c$var$requireNonNull(transition, "transition");
        $7232ef576ffbaa3c$var$requireNonNull(offsetBefore, "offsetBefore");
        $7232ef576ffbaa3c$var$requireNonNull(offsetAfter, "offsetAfter");
        if (offsetBefore.equals(offsetAfter)) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Offsets must not be equal");
        if (transition.nano() !== 0) throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Nano-of-second must be zero");
        if (transition instanceof $7232ef576ffbaa3c$export$7dda5dc5c6c448ff) this._transition = transition;
        else this._transition = $7232ef576ffbaa3c$export$7dda5dc5c6c448ff.ofEpochSecond(transition, 0, offsetBefore);
        this._offsetBefore = offsetBefore;
        this._offsetAfter = offsetAfter;
    }
    var _proto = ZoneOffsetTransition.prototype;
    _proto.instant = function instant() {
        return this._transition.toInstant(this._offsetBefore);
    };
    _proto.toEpochSecond = function toEpochSecond() {
        return this._transition.toEpochSecond(this._offsetBefore);
    };
    _proto.dateTimeBefore = function dateTimeBefore() {
        return this._transition;
    };
    _proto.dateTimeAfter = function dateTimeAfter() {
        return this._transition.plusSeconds(this.durationSeconds());
    };
    _proto.offsetBefore = function offsetBefore() {
        return this._offsetBefore;
    };
    _proto.offsetAfter = function offsetAfter() {
        return this._offsetAfter;
    };
    _proto.duration = function duration() {
        return $7232ef576ffbaa3c$export$3b11bc38611c5941.ofSeconds(this.durationSeconds());
    };
    _proto.durationSeconds = function durationSeconds() {
        return this._offsetAfter.totalSeconds() - this._offsetBefore.totalSeconds();
    };
    _proto.isGap = function isGap() {
        return this._offsetAfter.totalSeconds() > this._offsetBefore.totalSeconds();
    };
    _proto.isOverlap = function isOverlap() {
        return this._offsetAfter.totalSeconds() < this._offsetBefore.totalSeconds();
    };
    _proto.isValidOffset = function isValidOffset(offset) {
        return this.isGap() ? false : this._offsetBefore.equals(offset) || this._offsetAfter.equals(offset);
    };
    _proto.validOffsets = function validOffsets() {
        if (this.isGap()) return [];
        else return [
            this._offsetBefore,
            this._offsetAfter
        ];
    };
    _proto.compareTo = function compareTo(transition) {
        return this.instant().compareTo(transition.instant());
    };
    _proto.equals = function equals(other) {
        if (other === this) return true;
        if (other instanceof ZoneOffsetTransition) {
            var d = other;
            return this._transition.equals(d._transition) && this._offsetBefore.equals(d.offsetBefore()) && this._offsetAfter.equals(d.offsetAfter());
        }
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._transition.hashCode() ^ this._offsetBefore.hashCode() ^ this._offsetAfter.hashCode() >>> 16;
    };
    _proto.toString = function toString() {
        return "Transition[" + (this.isGap() ? "Gap" : "Overlap") + " at " + this._transition.toString() + this._offsetBefore.toString() + " to " + this._offsetAfter + "]";
    };
    return ZoneOffsetTransition;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ function $7232ef576ffbaa3c$var$_init$k() {
    $7232ef576ffbaa3c$export$d6cc568434dfd9dc.ZONE_ID = $7232ef576ffbaa3c$var$createTemporalQuery("ZONE_ID", function(temporal) {
        return temporal.query($7232ef576ffbaa3c$export$d6cc568434dfd9dc.ZONE_ID);
    });
    $7232ef576ffbaa3c$export$d6cc568434dfd9dc.CHRONO = $7232ef576ffbaa3c$var$createTemporalQuery("CHRONO", function(temporal) {
        return temporal.query($7232ef576ffbaa3c$export$d6cc568434dfd9dc.CHRONO);
    });
    $7232ef576ffbaa3c$export$d6cc568434dfd9dc.PRECISION = $7232ef576ffbaa3c$var$createTemporalQuery("PRECISION", function(temporal) {
        return temporal.query($7232ef576ffbaa3c$export$d6cc568434dfd9dc.PRECISION);
    });
    $7232ef576ffbaa3c$export$d6cc568434dfd9dc.OFFSET = $7232ef576ffbaa3c$var$createTemporalQuery("OFFSET", function(temporal) {
        if (temporal.isSupported($7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS)) return $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.ofTotalSeconds(temporal.get($7232ef576ffbaa3c$export$7f55a40756153c3e.OFFSET_SECONDS));
        return null;
    });
    $7232ef576ffbaa3c$export$d6cc568434dfd9dc.ZONE = $7232ef576ffbaa3c$var$createTemporalQuery("ZONE", function(temporal) {
        var zone = temporal.query($7232ef576ffbaa3c$export$d6cc568434dfd9dc.ZONE_ID);
        return zone != null ? zone : temporal.query($7232ef576ffbaa3c$export$d6cc568434dfd9dc.OFFSET);
    });
    $7232ef576ffbaa3c$export$d6cc568434dfd9dc.LOCAL_DATE = $7232ef576ffbaa3c$var$createTemporalQuery("LOCAL_DATE", function(temporal) {
        if (temporal.isSupported($7232ef576ffbaa3c$export$7f55a40756153c3e.EPOCH_DAY)) return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.ofEpochDay(temporal.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.EPOCH_DAY));
        return null;
    });
    $7232ef576ffbaa3c$export$d6cc568434dfd9dc.LOCAL_TIME = $7232ef576ffbaa3c$var$createTemporalQuery("LOCAL_TIME", function(temporal) {
        if (temporal.isSupported($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_DAY)) return $7232ef576ffbaa3c$export$bf1071e344bea1d.ofNanoOfDay(temporal.getLong($7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_DAY));
        return null;
    });
}
var $7232ef576ffbaa3c$var$SystemDefaultZoneRules = function(_ZoneRules) {
    $7232ef576ffbaa3c$var$_inheritsLoose(SystemDefaultZoneRules, _ZoneRules);
    function SystemDefaultZoneRules() {
        return _ZoneRules.apply(this, arguments) || this;
    }
    var _proto = SystemDefaultZoneRules.prototype;
    _proto.isFixedOffset = function isFixedOffset() {
        return false;
    };
    _proto.offsetOfInstant = function offsetOfInstant(instant) {
        var offsetInMinutes = new Date(instant.toEpochMilli()).getTimezoneOffset();
        return $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.ofTotalMinutes(offsetInMinutes * -1);
    };
    _proto.offsetOfEpochMilli = function offsetOfEpochMilli(epochMilli) {
        var offsetInMinutes = new Date(epochMilli).getTimezoneOffset();
        return $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.ofTotalMinutes(offsetInMinutes * -1);
    };
    _proto.offsetOfLocalDateTime = function offsetOfLocalDateTime(localDateTime) {
        var epochMilli = localDateTime.toEpochSecond($7232ef576ffbaa3c$export$47ce5d56ab10eaa3.UTC) * 1000;
        var offsetInMinutesBeforePossibleTransition = new Date(epochMilli).getTimezoneOffset();
        var epochMilliSystemZone = epochMilli + offsetInMinutesBeforePossibleTransition * 60000;
        var offsetInMinutesAfterPossibleTransition = new Date(epochMilliSystemZone).getTimezoneOffset();
        return $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.ofTotalMinutes(offsetInMinutesAfterPossibleTransition * -1);
    };
    _proto.validOffsets = function validOffsets(localDateTime) {
        return [
            this.offsetOfLocalDateTime(localDateTime)
        ];
    };
    _proto.transition = function transition() {
        return null;
    };
    _proto.standardOffset = function standardOffset(instant) {
        return this.offsetOfInstant(instant);
    };
    _proto.daylightSavings = function daylightSavings() {
        this._throwNotSupported();
    };
    _proto.isDaylightSavings = function isDaylightSavings() {
        this._throwNotSupported();
    };
    _proto.isValidOffset = function isValidOffset(dateTime, offset) {
        return this.offsetOfLocalDateTime(dateTime).equals(offset);
    };
    _proto.nextTransition = function nextTransition() {
        this._throwNotSupported();
    };
    _proto.previousTransition = function previousTransition() {
        this._throwNotSupported();
    };
    _proto.transitions = function transitions() {
        this._throwNotSupported();
    };
    _proto.transitionRules = function transitionRules() {
        this._throwNotSupported();
    };
    _proto._throwNotSupported = function _throwNotSupported() {
        throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("not supported operation");
    };
    _proto.equals = function equals(other) {
        if (this === other || other instanceof SystemDefaultZoneRules) return true;
        else return false;
    };
    _proto.toString = function toString() {
        return "SYSTEM";
    };
    return SystemDefaultZoneRules;
}($7232ef576ffbaa3c$export$cbd9bcf3fad97817);
var $7232ef576ffbaa3c$var$SystemDefaultZoneId = function(_ZoneId) {
    $7232ef576ffbaa3c$var$_inheritsLoose(SystemDefaultZoneId, _ZoneId);
    function SystemDefaultZoneId() {
        var _this;
        _this = _ZoneId.call(this) || this;
        _this._rules = new $7232ef576ffbaa3c$var$SystemDefaultZoneRules();
        return _this;
    }
    var _proto = SystemDefaultZoneId.prototype;
    _proto.rules = function rules() {
        return this._rules;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        return false;
    };
    _proto.id = function id() {
        return "SYSTEM";
    };
    return SystemDefaultZoneId;
}($7232ef576ffbaa3c$export$a514a0be1f00ef62);
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$ZoneIdFactory = function() {
    function ZoneIdFactory() {}
    ZoneIdFactory.systemDefault = function systemDefault() {
        return $7232ef576ffbaa3c$var$SYSTEM_DEFAULT_ZONE_ID_INSTANCE;
    };
    ZoneIdFactory.getAvailableZoneIds = function getAvailableZoneIds() {
        return $7232ef576ffbaa3c$export$79d73e02cd645302.getAvailableZoneIds();
    };
    ZoneIdFactory.of = function of(zoneId) {
        $7232ef576ffbaa3c$var$requireNonNull(zoneId, "zoneId");
        if (zoneId === "Z") return $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.UTC;
        if (zoneId.length === 1) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Invalid zone: " + zoneId);
        if ($7232ef576ffbaa3c$var$StringUtil.startsWith(zoneId, "+") || $7232ef576ffbaa3c$var$StringUtil.startsWith(zoneId, "-")) return $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.of(zoneId);
        if (zoneId === "UTC" || zoneId === "GMT" || zoneId === "GMT0" || zoneId === "UT") return new $7232ef576ffbaa3c$export$9caa52e4e516e67d(zoneId, $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.UTC.rules());
        if ($7232ef576ffbaa3c$var$StringUtil.startsWith(zoneId, "UTC+") || $7232ef576ffbaa3c$var$StringUtil.startsWith(zoneId, "GMT+") || $7232ef576ffbaa3c$var$StringUtil.startsWith(zoneId, "UTC-") || $7232ef576ffbaa3c$var$StringUtil.startsWith(zoneId, "GMT-")) {
            var offset = $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.of(zoneId.substring(3));
            if (offset.totalSeconds() === 0) return new $7232ef576ffbaa3c$export$9caa52e4e516e67d(zoneId.substring(0, 3), offset.rules());
            return new $7232ef576ffbaa3c$export$9caa52e4e516e67d(zoneId.substring(0, 3) + offset.id(), offset.rules());
        }
        if ($7232ef576ffbaa3c$var$StringUtil.startsWith(zoneId, "UT+") || $7232ef576ffbaa3c$var$StringUtil.startsWith(zoneId, "UT-")) {
            var _offset = $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.of(zoneId.substring(2));
            if (_offset.totalSeconds() === 0) return new $7232ef576ffbaa3c$export$9caa52e4e516e67d("UT", _offset.rules());
            return new $7232ef576ffbaa3c$export$9caa52e4e516e67d("UT" + _offset.id(), _offset.rules());
        }
        if (zoneId === "SYSTEM") return $7232ef576ffbaa3c$export$a514a0be1f00ef62.systemDefault();
        return $7232ef576ffbaa3c$export$9caa52e4e516e67d.ofId(zoneId);
    };
    ZoneIdFactory.ofOffset = function ofOffset(prefix, offset) {
        $7232ef576ffbaa3c$var$requireNonNull(prefix, "prefix");
        $7232ef576ffbaa3c$var$requireNonNull(offset, "offset");
        if (prefix.length === 0) return offset;
        if (prefix === "GMT" || prefix === "UTC" || prefix === "UT") {
            if (offset.totalSeconds() === 0) return new $7232ef576ffbaa3c$export$9caa52e4e516e67d(prefix, offset.rules());
            return new $7232ef576ffbaa3c$export$9caa52e4e516e67d(prefix + offset.id(), offset.rules());
        }
        throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("Invalid prefix, must be GMT, UTC or UT: " + prefix);
    };
    ZoneIdFactory.from = function from(temporal) {
        $7232ef576ffbaa3c$var$requireNonNull(temporal, "temporal");
        var obj = temporal.query($7232ef576ffbaa3c$export$d6cc568434dfd9dc.zone());
        if (obj == null) throw new $7232ef576ffbaa3c$export$6058f27c7f907fb("Unable to obtain ZoneId from TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ""));
        return obj;
    };
    return ZoneIdFactory;
}();
var $7232ef576ffbaa3c$var$SYSTEM_DEFAULT_ZONE_ID_INSTANCE = null;
function $7232ef576ffbaa3c$var$_init$l() {
    $7232ef576ffbaa3c$var$SYSTEM_DEFAULT_ZONE_ID_INSTANCE = new $7232ef576ffbaa3c$var$SystemDefaultZoneId();
    $7232ef576ffbaa3c$export$a514a0be1f00ef62.systemDefault = $7232ef576ffbaa3c$var$ZoneIdFactory.systemDefault;
    $7232ef576ffbaa3c$export$a514a0be1f00ef62.getAvailableZoneIds = $7232ef576ffbaa3c$var$ZoneIdFactory.getAvailableZoneIds;
    $7232ef576ffbaa3c$export$a514a0be1f00ef62.of = $7232ef576ffbaa3c$var$ZoneIdFactory.of;
    $7232ef576ffbaa3c$export$a514a0be1f00ef62.ofOffset = $7232ef576ffbaa3c$var$ZoneIdFactory.ofOffset;
    $7232ef576ffbaa3c$export$a514a0be1f00ef62.from = $7232ef576ffbaa3c$var$ZoneIdFactory.from;
    $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.from = $7232ef576ffbaa3c$var$ZoneIdFactory.from;
    $7232ef576ffbaa3c$export$a514a0be1f00ef62.SYSTEM = $7232ef576ffbaa3c$var$SYSTEM_DEFAULT_ZONE_ID_INSTANCE;
    $7232ef576ffbaa3c$export$a514a0be1f00ef62.UTC = $7232ef576ffbaa3c$export$47ce5d56ab10eaa3.ofTotalSeconds(0);
}
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$isInit = false;
function $7232ef576ffbaa3c$var$init() {
    if ($7232ef576ffbaa3c$var$isInit) return;
    $7232ef576ffbaa3c$var$isInit = true;
    $7232ef576ffbaa3c$var$_init$1();
    $7232ef576ffbaa3c$var$_init();
    $7232ef576ffbaa3c$var$_init$2();
    $7232ef576ffbaa3c$var$_init$3();
    $7232ef576ffbaa3c$var$_init$i();
    $7232ef576ffbaa3c$var$_init$8();
    $7232ef576ffbaa3c$var$_init$k();
    $7232ef576ffbaa3c$var$_init$4();
    $7232ef576ffbaa3c$var$_init$j();
    $7232ef576ffbaa3c$var$_init$g();
    $7232ef576ffbaa3c$var$_init$h();
    $7232ef576ffbaa3c$var$_init$d();
    $7232ef576ffbaa3c$var$_init$5();
    $7232ef576ffbaa3c$var$_init$c();
    $7232ef576ffbaa3c$var$_init$b();
    $7232ef576ffbaa3c$var$_init$6();
    $7232ef576ffbaa3c$var$_init$7();
    $7232ef576ffbaa3c$var$_init$f();
    $7232ef576ffbaa3c$var$_init$l();
    $7232ef576ffbaa3c$var$_init$e();
    $7232ef576ffbaa3c$var$_init$a();
    $7232ef576ffbaa3c$var$_init$9();
}
$7232ef576ffbaa3c$var$init();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$var$ToNativeJsConverter = function() {
    function ToNativeJsConverter(temporal, zone) {
        var zonedDateTime;
        if (temporal instanceof $7232ef576ffbaa3c$export$6397c6cbb8fe96b6) {
            zone = zone == null ? $7232ef576ffbaa3c$export$a514a0be1f00ef62.systemDefault() : zone;
            zonedDateTime = temporal.atStartOfDay(zone);
        } else if (temporal instanceof $7232ef576ffbaa3c$export$7dda5dc5c6c448ff) {
            zone = zone == null ? $7232ef576ffbaa3c$export$a514a0be1f00ef62.systemDefault() : zone;
            zonedDateTime = temporal.atZone(zone);
        } else if (temporal instanceof $7232ef576ffbaa3c$export$d3b7288e7994edea) {
            if (zone == null) zonedDateTime = temporal;
            else zonedDateTime = temporal.withZoneSameInstant(zone);
        } else throw new $7232ef576ffbaa3c$export$86eb44ed3377dd8f("unsupported instance for convert operation:" + temporal);
        this.instant = zonedDateTime.toInstant();
    }
    var _proto = ToNativeJsConverter.prototype;
    _proto.toDate = function toDate() {
        return new Date(this.instant.toEpochMilli());
    };
    _proto.toEpochMilli = function toEpochMilli() {
        return this.instant.toEpochMilli();
    };
    return ToNativeJsConverter;
}();
function $7232ef576ffbaa3c$export$9c68d69a4c5bbcf9(temporal, zone) {
    return new $7232ef576ffbaa3c$var$ToNativeJsConverter(temporal, zone);
}
var $7232ef576ffbaa3c$var$NativeJsTemporal = function(_TemporalAccessor) {
    $7232ef576ffbaa3c$var$_inheritsLoose(NativeJsTemporal, _TemporalAccessor);
    function NativeJsTemporal(date, zone) {
        var _this;
        if (zone === void 0) zone = $7232ef576ffbaa3c$export$a514a0be1f00ef62.systemDefault();
        _this = _TemporalAccessor.call(this) || this;
        _this._zone = zone;
        if (date instanceof Date) {
            _this._epochMilli = date.getTime();
            return $7232ef576ffbaa3c$var$_assertThisInitialized(_this);
        } else if (typeof date.toDate === "function" && date.toDate() instanceof Date) {
            _this._epochMilli = date.toDate().getTime();
            return $7232ef576ffbaa3c$var$_assertThisInitialized(_this);
        }
        $7232ef576ffbaa3c$var$assert(false, "date must be either a javascript date or a moment");
        return _this;
    }
    var _proto = NativeJsTemporal.prototype;
    _proto.query = function query(_query) {
        $7232ef576ffbaa3c$var$requireNonNull(_query, "query");
        if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localDate()) return $7232ef576ffbaa3c$export$6397c6cbb8fe96b6.ofInstant($7232ef576ffbaa3c$export$fecec53969739358.ofEpochMilli(this._epochMilli), this._zone);
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.localTime()) return $7232ef576ffbaa3c$export$bf1071e344bea1d.ofInstant($7232ef576ffbaa3c$export$fecec53969739358.ofEpochMilli(this._epochMilli), this._zone);
        else if (_query === $7232ef576ffbaa3c$export$d6cc568434dfd9dc.zone()) return this._zone;
        return _TemporalAccessor.prototype.query.call(this, _query);
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        $7232ef576ffbaa3c$var$requireNonNull(field, "field");
        if (field instanceof $7232ef576ffbaa3c$export$7f55a40756153c3e) {
            switch(field){
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND:
                    return $7232ef576ffbaa3c$var$MathUtil.floorMod(this._epochMilli, 1000) * 1000000;
                case $7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return $7232ef576ffbaa3c$var$MathUtil.floorDiv(this._epochMilli, 1000);
            }
            throw new $7232ef576ffbaa3c$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.getFrom(this);
    };
    _proto.isSupported = function isSupported(field) {
        return field === $7232ef576ffbaa3c$export$7f55a40756153c3e.INSTANT_SECONDS || field === $7232ef576ffbaa3c$export$7f55a40756153c3e.NANO_OF_SECOND;
    };
    return NativeJsTemporal;
}($7232ef576ffbaa3c$export$e5100310ee9cc158);
function $7232ef576ffbaa3c$export$1f878d3ea5c30765(date, zone) {
    return new $7232ef576ffbaa3c$var$NativeJsTemporal(date, zone);
}
function $7232ef576ffbaa3c$var$bindUse(jsJoda) {
    var used = [];
    return function use(fn) {
        if (!~used.indexOf(fn)) {
            fn(jsJoda);
            used.push(fn);
        }
        return jsJoda;
    };
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $7232ef576ffbaa3c$export$71511d61b312f219 = {
    assert: $7232ef576ffbaa3c$var$assert$1,
    DateTimeBuilder: $7232ef576ffbaa3c$var$DateTimeBuilder,
    DateTimeParseContext: $7232ef576ffbaa3c$var$DateTimeParseContext,
    DateTimePrintContext: $7232ef576ffbaa3c$var$DateTimePrintContext,
    MathUtil: $7232ef576ffbaa3c$var$MathUtil,
    StringUtil: $7232ef576ffbaa3c$var$StringUtil,
    StringBuilder: $7232ef576ffbaa3c$var$StringBuilder
};
var $7232ef576ffbaa3c$var$jsJodaExports = {
    _: $7232ef576ffbaa3c$export$71511d61b312f219,
    convert: $7232ef576ffbaa3c$export$9c68d69a4c5bbcf9,
    nativeJs: $7232ef576ffbaa3c$export$1f878d3ea5c30765,
    ArithmeticException: $7232ef576ffbaa3c$export$5891bcae38b5fd67,
    DateTimeException: $7232ef576ffbaa3c$export$6058f27c7f907fb,
    DateTimeParseException: $7232ef576ffbaa3c$export$ce8a206818942248,
    IllegalArgumentException: $7232ef576ffbaa3c$export$86eb44ed3377dd8f,
    IllegalStateException: $7232ef576ffbaa3c$export$f79c4ffdc088dc0e,
    UnsupportedTemporalTypeException: $7232ef576ffbaa3c$export$8fe6dec993229f58,
    NullPointerException: $7232ef576ffbaa3c$export$b6ad7a1de4697efd,
    Clock: $7232ef576ffbaa3c$export$9735c82c4bae3302,
    DayOfWeek: $7232ef576ffbaa3c$export$7ed5ca4f8b987938,
    Duration: $7232ef576ffbaa3c$export$3b11bc38611c5941,
    Instant: $7232ef576ffbaa3c$export$fecec53969739358,
    LocalDate: $7232ef576ffbaa3c$export$6397c6cbb8fe96b6,
    LocalTime: $7232ef576ffbaa3c$export$bf1071e344bea1d,
    LocalDateTime: $7232ef576ffbaa3c$export$7dda5dc5c6c448ff,
    Month: $7232ef576ffbaa3c$export$951c8378cdfec6e6,
    MonthDay: $7232ef576ffbaa3c$export$30964d9b15071608,
    Period: $7232ef576ffbaa3c$export$67186dcd8fa4f92f,
    Year: $7232ef576ffbaa3c$export$6ce2f08d515512,
    YearConstants: $7232ef576ffbaa3c$export$c04b60057299af61,
    YearMonth: $7232ef576ffbaa3c$export$b707805e12671f51,
    ZonedDateTime: $7232ef576ffbaa3c$export$d3b7288e7994edea,
    ZoneOffset: $7232ef576ffbaa3c$export$47ce5d56ab10eaa3,
    ZoneId: $7232ef576ffbaa3c$export$a514a0be1f00ef62,
    ZoneRegion: $7232ef576ffbaa3c$export$9caa52e4e516e67d,
    ZoneOffsetTransition: $7232ef576ffbaa3c$export$993d982a5ca9c76d,
    ZoneRules: $7232ef576ffbaa3c$export$cbd9bcf3fad97817,
    ZoneRulesProvider: $7232ef576ffbaa3c$export$79d73e02cd645302,
    ChronoLocalDate: $7232ef576ffbaa3c$export$2a07e3472bc98879,
    ChronoLocalDateTime: $7232ef576ffbaa3c$export$94e985176fb19d17,
    ChronoZonedDateTime: $7232ef576ffbaa3c$export$e69f60c5a83f5572,
    IsoChronology: $7232ef576ffbaa3c$export$f47ae290cf4e4958,
    ChronoField: $7232ef576ffbaa3c$export$7f55a40756153c3e,
    ChronoUnit: $7232ef576ffbaa3c$export$e61e212a4109fb8a,
    IsoFields: $7232ef576ffbaa3c$export$2091a0730eb3b2d2,
    Temporal: $7232ef576ffbaa3c$export$336849d529cb05e5,
    TemporalAccessor: $7232ef576ffbaa3c$export$e5100310ee9cc158,
    TemporalAdjuster: $7232ef576ffbaa3c$export$841f8bd48996924f,
    TemporalAdjusters: $7232ef576ffbaa3c$export$d922854d56f8a965,
    TemporalAmount: $7232ef576ffbaa3c$export$f8b2fcf02a6656ff,
    TemporalField: $7232ef576ffbaa3c$export$d879d8cdc7b5c1c9,
    TemporalQueries: $7232ef576ffbaa3c$export$d6cc568434dfd9dc,
    TemporalQuery: $7232ef576ffbaa3c$export$3164c6c8dc6c80ff,
    TemporalUnit: $7232ef576ffbaa3c$export$5d412a4bb789788e,
    ValueRange: $7232ef576ffbaa3c$export$177e5e64bab4dec5,
    DateTimeFormatter: $7232ef576ffbaa3c$export$3245e15bf4cbdd6c,
    DateTimeFormatterBuilder: $7232ef576ffbaa3c$export$81529fd372517959,
    DecimalStyle: $7232ef576ffbaa3c$export$c1929c59b9e7d355,
    ResolverStyle: $7232ef576ffbaa3c$export$2a833e4d13229d66,
    SignStyle: $7232ef576ffbaa3c$export$b2e3a42c433c0b35,
    TextStyle: $7232ef576ffbaa3c$export$1df879243bf2e42d
};
var $7232ef576ffbaa3c$export$1f96ae73734a86cc = $7232ef576ffbaa3c$var$bindUse($7232ef576ffbaa3c$var$jsJodaExports);
$7232ef576ffbaa3c$var$jsJodaExports.use = $7232ef576ffbaa3c$export$1f96ae73734a86cc;

});

parcelRegister("51RYA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3a96ea514fef15bc$var$ReactIs, $3a96ea514fef15bc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("jMD2I"))();

});
parcelRegister("jMD2I", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $fxogM = parcelRequire("fxogM");
function $e670c91ad81c6bde$var$emptyFunction() {}
function $e670c91ad81c6bde$var$emptyFunctionWithReset() {}
$e670c91ad81c6bde$var$emptyFunctionWithReset.resetWarningCache = $e670c91ad81c6bde$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $fxogM) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $e670c91ad81c6bde$var$emptyFunctionWithReset,
        resetWarningCache: $e670c91ad81c6bde$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("fxogM", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $b4fcc38a25c610d4$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $b4fcc38a25c610d4$var$ReactPropTypesSecret;

});



parcelRegister("jJQsa", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $e5eae87208344c8c$var$PropTypes = $e5eae87208344c8c$var$_interopRequireWildcard((parcelRequire("51RYA")));

var $e5eae87208344c8c$var$_addClass = $e5eae87208344c8c$var$_interopRequireDefault((parcelRequire("9OL8e")));

var $e5eae87208344c8c$var$_removeClass = $e5eae87208344c8c$var$_interopRequireDefault((parcelRequire("1kGQF")));

var $e5eae87208344c8c$var$_react = $e5eae87208344c8c$var$_interopRequireDefault((parcelRequire("17VE6")));

var $e5eae87208344c8c$var$_Transition = $e5eae87208344c8c$var$_interopRequireDefault((parcelRequire("gTgWg")));

function $e5eae87208344c8c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e5eae87208344c8c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $e5eae87208344c8c$var$_extends() {
    $e5eae87208344c8c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e5eae87208344c8c$var$_extends.apply(this, arguments);
}
function $e5eae87208344c8c$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $e5eae87208344c8c$var$addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $e5eae87208344c8c$var$_addClass.default)(node, c);
    });
};
var $e5eae87208344c8c$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $e5eae87208344c8c$var$_removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var $e5eae87208344c8c$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    $e5eae87208344c8c$var$_inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? "appear" : "enter"), className = _this$getClassNames.className;
            _this.removeClasses(node, "exit");
            $e5eae87208344c8c$var$addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? "appear" : "enter"), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames("appear").doneClassName;
            var enterClassName = _this.getClassNames("enter").doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? "appear" : "enter");
            $e5eae87208344c8c$var$addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames("exit"), className = _this$getClassNames3.className;
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            $e5eae87208344c8c$var$addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames("exit"), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames("exit"), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, "exit");
            $e5eae87208344c8c$var$addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? className + "-done" : classNames[type + "Done"];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && $e5eae87208344c8c$var$removeClass(node, className);
        activeClassName && $e5eae87208344c8c$var$removeClass(node, activeClassName);
        doneClassName && $e5eae87208344c8c$var$removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ $e5eae87208344c8c$var$addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = $e5eae87208344c8c$var$_extends({}, this.props);
        delete props.classNames;
        return $e5eae87208344c8c$var$_react.default.createElement($e5eae87208344c8c$var$_Transition.default, $e5eae87208344c8c$var$_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}($e5eae87208344c8c$var$_react.default.Component);
$e5eae87208344c8c$var$CSSTransition.defaultProps = {
    classNames: ""
};
$e5eae87208344c8c$var$CSSTransition.propTypes = {};
var $e5eae87208344c8c$var$_default = $e5eae87208344c8c$var$CSSTransition;
module.exports.default = $e5eae87208344c8c$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("9OL8e", function(module, exports) {
"use strict";

var $1BZRn = parcelRequire("1BZRn");
module.exports.__esModule = true;
module.exports.default = $725d57f3586b8796$var$addClass;

var $725d57f3586b8796$var$_hasClass = $1BZRn((parcelRequire("euOEx")));
function $725d57f3586b8796$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $725d57f3586b8796$var$_hasClass.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}
module.exports = module.exports["default"];

});
parcelRegister("1BZRn", function(module, exports) {
function $12c93b3b3cc5d178$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $12c93b3b3cc5d178$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("euOEx", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $a8db289b96600b04$var$hasClass;
function $a8db289b96600b04$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = module.exports["default"];

});


parcelRegister("1kGQF", function(module, exports) {
"use strict";
function $0f88e586ed3f1f50$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $0f88e586ed3f1f50$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $0f88e586ed3f1f50$var$replaceClassName(element.className && element.className.baseVal || "", className));
};

});

parcelRegister("gTgWg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $c4beec16c036a918$export$1e511d4a378977f5; }, function (v) { return $c4beec16c036a918$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $c4beec16c036a918$export$2e2bcd8739ae039; }, function (v) { return $c4beec16c036a918$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "EXITING", function () { return $c4beec16c036a918$export$4aacc83d4d59139f; }, function (v) { return $c4beec16c036a918$export$4aacc83d4d59139f = v; });
$parcel$export(module.exports, "ENTERED", function () { return $c4beec16c036a918$export$78e9e6e3e014d60a; }, function (v) { return $c4beec16c036a918$export$78e9e6e3e014d60a = v; });
$parcel$export(module.exports, "ENTERING", function () { return $c4beec16c036a918$export$df38205c966be359; }, function (v) { return $c4beec16c036a918$export$df38205c966be359 = v; });
$parcel$export(module.exports, "EXITED", function () { return $c4beec16c036a918$export$84cbff306f539230; }, function (v) { return $c4beec16c036a918$export$84cbff306f539230 = v; });
$parcel$export(module.exports, "UNMOUNTED", function () { return $c4beec16c036a918$export$bb38bb9a1161268; }, function (v) { return $c4beec16c036a918$export$bb38bb9a1161268 = v; });
var $c4beec16c036a918$export$1e511d4a378977f5;
var $c4beec16c036a918$export$2e2bcd8739ae039;
var $c4beec16c036a918$export$4aacc83d4d59139f;
var $c4beec16c036a918$export$78e9e6e3e014d60a;
var $c4beec16c036a918$export$df38205c966be359;
var $c4beec16c036a918$export$84cbff306f539230;
var $c4beec16c036a918$export$bb38bb9a1161268;
"use strict";
$c4beec16c036a918$export$1e511d4a378977f5 = true;
$c4beec16c036a918$export$2e2bcd8739ae039 = $c4beec16c036a918$export$4aacc83d4d59139f = $c4beec16c036a918$export$78e9e6e3e014d60a = $c4beec16c036a918$export$df38205c966be359 = $c4beec16c036a918$export$84cbff306f539230 = $c4beec16c036a918$export$bb38bb9a1161268 = void 0;

var $c4beec16c036a918$var$PropTypes = $c4beec16c036a918$var$_interopRequireWildcard((parcelRequire("51RYA")));

var $c4beec16c036a918$var$_react = $c4beec16c036a918$var$_interopRequireDefault((parcelRequire("17VE6")));

var $c4beec16c036a918$var$_reactDom = $c4beec16c036a918$var$_interopRequireDefault((parcelRequire("62qDs")));

var $8gltA = parcelRequire("8gltA");

function $c4beec16c036a918$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c4beec16c036a918$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $c4beec16c036a918$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c4beec16c036a918$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $c4beec16c036a918$var$UNMOUNTED = "unmounted";
$c4beec16c036a918$export$bb38bb9a1161268 = $c4beec16c036a918$var$UNMOUNTED;
var $c4beec16c036a918$var$EXITED = "exited";
$c4beec16c036a918$export$84cbff306f539230 = $c4beec16c036a918$var$EXITED;
var $c4beec16c036a918$var$ENTERING = "entering";
$c4beec16c036a918$export$df38205c966be359 = $c4beec16c036a918$var$ENTERING;
var $c4beec16c036a918$var$ENTERED = "entered";
$c4beec16c036a918$export$78e9e6e3e014d60a = $c4beec16c036a918$var$ENTERED;
var $c4beec16c036a918$var$EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $c4beec16c036a918$export$4aacc83d4d59139f = $c4beec16c036a918$var$EXITING;
var $c4beec16c036a918$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $c4beec16c036a918$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $c4beec16c036a918$var$EXITED;
                _this.appearStatus = $c4beec16c036a918$var$ENTERING;
            } else initialStatus = $c4beec16c036a918$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $c4beec16c036a918$var$UNMOUNTED;
        else initialStatus = $c4beec16c036a918$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $c4beec16c036a918$var$UNMOUNTED) return {
            status: $c4beec16c036a918$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $c4beec16c036a918$var$ENTERING && status !== $c4beec16c036a918$var$ENTERED) nextStatus = $c4beec16c036a918$var$ENTERING;
            } else if (status === $c4beec16c036a918$var$ENTERING || status === $c4beec16c036a918$var$ENTERED) nextStatus = $c4beec16c036a918$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $c4beec16c036a918$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $c4beec16c036a918$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $c4beec16c036a918$var$EXITED) this.setState({
            status: $c4beec16c036a918$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $c4beec16c036a918$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $c4beec16c036a918$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $c4beec16c036a918$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $c4beec16c036a918$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $c4beec16c036a918$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $c4beec16c036a918$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $c4beec16c036a918$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $c4beec16c036a918$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === "function") return children(status, childProps);
        var child = $c4beec16c036a918$var$_react.default.Children.only(children);
        return $c4beec16c036a918$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($c4beec16c036a918$var$_react.default.Component);
$c4beec16c036a918$var$Transition.contextTypes = {
    transitionGroup: $c4beec16c036a918$var$PropTypes.object
};
$c4beec16c036a918$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$c4beec16c036a918$var$Transition.propTypes = {};
function $c4beec16c036a918$var$noop() {}
$c4beec16c036a918$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $c4beec16c036a918$var$noop,
    onEntering: $c4beec16c036a918$var$noop,
    onEntered: $c4beec16c036a918$var$noop,
    onExit: $c4beec16c036a918$var$noop,
    onExiting: $c4beec16c036a918$var$noop,
    onExited: $c4beec16c036a918$var$noop
};
$c4beec16c036a918$var$Transition.UNMOUNTED = 0;
$c4beec16c036a918$var$Transition.EXITED = 1;
$c4beec16c036a918$var$Transition.ENTERING = 2;
$c4beec16c036a918$var$Transition.ENTERED = 3;
$c4beec16c036a918$var$Transition.EXITING = 4;
var $c4beec16c036a918$var$_default = (0, $8gltA.polyfill)($c4beec16c036a918$var$Transition);
$c4beec16c036a918$export$2e2bcd8739ae039 = $c4beec16c036a918$var$_default;

});
parcelRegister("8gltA", function(module, exports) {

$parcel$export(module.exports, "polyfill", function () { return $60407a12642f0af1$export$cea1c58a6db52bca; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $60407a12642f0af1$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $60407a12642f0af1$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $60407a12642f0af1$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$60407a12642f0af1$var$componentWillMount.__suppressDeprecationWarning = true;
$60407a12642f0af1$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$60407a12642f0af1$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $60407a12642f0af1$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $60407a12642f0af1$var$componentWillMount;
        prototype.componentWillReceiveProps = $60407a12642f0af1$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $60407a12642f0af1$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRegister("5aUss", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $3c49ae4fcbd15530$var$_propTypes = $3c49ae4fcbd15530$var$_interopRequireDefault((parcelRequire("51RYA")));

var $3c49ae4fcbd15530$var$_react = $3c49ae4fcbd15530$var$_interopRequireDefault((parcelRequire("17VE6")));

var $62qDs = parcelRequire("62qDs");

var $3c49ae4fcbd15530$var$_TransitionGroup = $3c49ae4fcbd15530$var$_interopRequireDefault((parcelRequire("1UgPG")));
function $3c49ae4fcbd15530$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3c49ae4fcbd15530$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3c49ae4fcbd15530$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var $3c49ae4fcbd15530$var$ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    $3c49ae4fcbd15530$var$_inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle("onEnter", 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle("onEntering", 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle("onEntered", 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle("onExit", 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle("onExiting", 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle("onExited", 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = $3c49ae4fcbd15530$var$_react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, $62qDs.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = $3c49ae4fcbd15530$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = $3c49ae4fcbd15530$var$_react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return $3c49ae4fcbd15530$var$_react.default.createElement($3c49ae4fcbd15530$var$_TransitionGroup.default, props, inProp ? $3c49ae4fcbd15530$var$_react.default.cloneElement(first, {
            key: "first",
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : $3c49ae4fcbd15530$var$_react.default.cloneElement(second, {
            key: "second",
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}($3c49ae4fcbd15530$var$_react.default.Component);
$3c49ae4fcbd15530$var$ReplaceTransition.propTypes = {};
var $3c49ae4fcbd15530$var$_default = $3c49ae4fcbd15530$var$ReplaceTransition;
module.exports.default = $3c49ae4fcbd15530$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("1UgPG", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $163814080038f452$var$_propTypes = $163814080038f452$var$_interopRequireDefault((parcelRequire("51RYA")));

var $163814080038f452$var$_react = $163814080038f452$var$_interopRequireDefault((parcelRequire("17VE6")));

var $8gltA = parcelRequire("8gltA");

var $1wquH = parcelRequire("1wquH");
function $163814080038f452$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $163814080038f452$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $163814080038f452$var$_extends() {
    $163814080038f452$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $163814080038f452$var$_extends.apply(this, arguments);
}
function $163814080038f452$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $163814080038f452$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $163814080038f452$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $163814080038f452$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
var $163814080038f452$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    $163814080038f452$var$_inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind($163814080038f452$var$_assertThisInitialized($163814080038f452$var$_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: {
                isMounting: !this.appeared
            }
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $1wquH.getInitialChildMapping)(nextProps, handleExited) : (0, $1wquH.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $1wquH.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = $163814080038f452$var$_extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = $163814080038f452$var$_objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var children = $163814080038f452$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return children;
        return $163814080038f452$var$_react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
}($163814080038f452$var$_react.default.Component);
$163814080038f452$var$TransitionGroup.childContextTypes = {
    transitionGroup: $163814080038f452$var$_propTypes.default.object.isRequired
};
$163814080038f452$var$TransitionGroup.propTypes = {};
$163814080038f452$var$TransitionGroup.defaultProps = $163814080038f452$var$defaultProps;
var $163814080038f452$var$_default = (0, $8gltA.polyfill)($163814080038f452$var$TransitionGroup);
module.exports.default = $163814080038f452$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("1wquH", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $11bd54c6c1203111$export$bbc8a025727ea824; }, function (v) { return $11bd54c6c1203111$export$bbc8a025727ea824 = v; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $11bd54c6c1203111$export$fa71e2345c31d7a2; }, function (v) { return $11bd54c6c1203111$export$fa71e2345c31d7a2 = v; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $11bd54c6c1203111$export$36fd1af28d383ec0; }, function (v) { return $11bd54c6c1203111$export$36fd1af28d383ec0 = v; });
var $11bd54c6c1203111$export$1e511d4a378977f5;
var $11bd54c6c1203111$export$bbc8a025727ea824;
var $11bd54c6c1203111$export$7a874f95ccf533dd;
var $11bd54c6c1203111$export$fa71e2345c31d7a2;
var $11bd54c6c1203111$export$36fd1af28d383ec0;
"use strict";
$11bd54c6c1203111$export$1e511d4a378977f5 = true;
$11bd54c6c1203111$export$bbc8a025727ea824 = $11bd54c6c1203111$var$getChildMapping;
$11bd54c6c1203111$export$7a874f95ccf533dd = $11bd54c6c1203111$var$mergeChildMappings;
$11bd54c6c1203111$export$fa71e2345c31d7a2 = $11bd54c6c1203111$var$getInitialChildMapping;
$11bd54c6c1203111$export$36fd1af28d383ec0 = $11bd54c6c1203111$var$getNextChildMapping;

var $17VE6 = parcelRequire("17VE6");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function $11bd54c6c1203111$var$getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $17VE6.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) $17VE6.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function $11bd54c6c1203111$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $11bd54c6c1203111$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $11bd54c6c1203111$var$getInitialChildMapping(props, onExited) {
    return $11bd54c6c1203111$var$getChildMapping(props.children, function(child) {
        return (0, $17VE6.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $11bd54c6c1203111$var$getProp(child, "appear", props),
            enter: $11bd54c6c1203111$var$getProp(child, "enter", props),
            exit: $11bd54c6c1203111$var$getProp(child, "exit", props)
        });
    });
}
function $11bd54c6c1203111$var$getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $11bd54c6c1203111$var$getChildMapping(nextProps.children);
    var children = $11bd54c6c1203111$var$mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $17VE6.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $17VE6.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $17VE6.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $11bd54c6c1203111$var$getProp(child, "exit", nextProps),
            enter: $11bd54c6c1203111$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $17VE6.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $17VE6.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $17VE6.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $11bd54c6c1203111$var$getProp(child, "exit", nextProps),
            enter: $11bd54c6c1203111$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});



parcelRegister("ACrt1", function(module, exports) {

var $lOsGe = parcelRequire("lOsGe");

var $Z9xhm = parcelRequire("Z9xhm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $lOsGe.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $Z9xhm;
module.exports = isBuffer;

});
parcelRegister("lOsGe", function(module, exports) {

var $7rvNu = parcelRequire("7rvNu");
/** Detect free variable `self`. */ var $fe1483ca07001bf9$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $fe1483ca07001bf9$var$root = $7rvNu || $fe1483ca07001bf9$var$freeSelf || Function("return this")();
module.exports = $fe1483ca07001bf9$var$root;

});
parcelRegister("7rvNu", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $56b3b84a65171059$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $56b3b84a65171059$var$freeGlobal;

});


parcelRegister("Z9xhm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $0b7d183908846eea$var$stubFalse() {
    return false;
}
module.exports = $0b7d183908846eea$var$stubFalse;

});


parcelRegister("lvXVP", function(module, exports) {

var $7rvNu = parcelRequire("7rvNu");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $7rvNu.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("8ZUGY", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("umBnH"));

});
parcelRegister("umBnH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function get() {
        return $g3Dpm.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function get() {
        return $g3Dpm.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function get() {
        return $5iCM5.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function get() {
        return $5iCM5.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function get() {
        return $3ph4f.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function get() {
        return $3ph4f.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function get() {
        return $3ph4f.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function get() {
        return $3ph4f.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function get() {
        return $05b455ba666ac078$var$_symbol.symbolsStroke;
    }
});

var $05b455ba666ac078$var$_arc = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("3z10P")));

var $05b455ba666ac078$var$_area = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("82LCL")));

var $05b455ba666ac078$var$_line = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("bUY2L")));

var $05b455ba666ac078$var$_pie = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("4oh7v")));

var $05b455ba666ac078$var$_areaRadial = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("6xqpI")));

var $05b455ba666ac078$var$_lineRadial = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("5Jv3Q")));

var $05b455ba666ac078$var$_pointRadial = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("cLBS2")));

var $3ph4f = parcelRequire("3ph4f");

var $05b455ba666ac078$var$_symbol = $05b455ba666ac078$var$_interopRequireWildcard((parcelRequire("g2329")));

var $05b455ba666ac078$var$_asterisk = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("lw9jG")));

var $05b455ba666ac078$var$_circle = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("e9GGe")));

var $05b455ba666ac078$var$_cross = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("bawW4")));

var $05b455ba666ac078$var$_diamond = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("3L0QJ")));

var $05b455ba666ac078$var$_diamond2 = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("5mtuV")));

var $05b455ba666ac078$var$_plus = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("2iOrm")));

var $05b455ba666ac078$var$_square = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("e1iV5")));

var $05b455ba666ac078$var$_square2 = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("fElhB")));

var $05b455ba666ac078$var$_star = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("e9PRV")));

var $05b455ba666ac078$var$_triangle = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("dVGtB")));

var $05b455ba666ac078$var$_triangle2 = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("cZDu1")));

var $05b455ba666ac078$var$_wye = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("eiTDE")));

var $05b455ba666ac078$var$_x = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("csc6D")));

var $05b455ba666ac078$var$_basisClosed = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("lysOo")));

var $05b455ba666ac078$var$_basisOpen = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("2Z68d")));

var $05b455ba666ac078$var$_basis = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("6GOcp")));

var $g3Dpm = parcelRequire("g3Dpm");

var $05b455ba666ac078$var$_bundle = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("fdyG2")));

var $05b455ba666ac078$var$_cardinalClosed = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("eEpxA")));

var $05b455ba666ac078$var$_cardinalOpen = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("9lSbn")));

var $05b455ba666ac078$var$_cardinal = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("fjdt0")));

var $05b455ba666ac078$var$_catmullRomClosed = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("bPWcK")));

var $05b455ba666ac078$var$_catmullRomOpen = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("dfKLc")));

var $05b455ba666ac078$var$_catmullRom = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("cEJkg")));

var $05b455ba666ac078$var$_linearClosed = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("eGsXk")));

var $05b455ba666ac078$var$_linear = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("dNCFJ")));

var $5iCM5 = parcelRequire("5iCM5");

var $05b455ba666ac078$var$_natural = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("aCFgt")));

var $05b455ba666ac078$var$_step = $05b455ba666ac078$var$_interopRequireWildcard((parcelRequire("a4VFn")));

var $05b455ba666ac078$var$_stack = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("7Q4a1")));

var $05b455ba666ac078$var$_expand = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("fSo87")));

var $05b455ba666ac078$var$_diverging = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("3twnr")));

var $05b455ba666ac078$var$_none = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("biP2R")));

var $05b455ba666ac078$var$_silhouette = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("cTnNM")));

var $05b455ba666ac078$var$_wiggle = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("lU1IY")));

var $05b455ba666ac078$var$_appearance = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("4ykVD")));

var $05b455ba666ac078$var$_ascending = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("21GUU")));

var $05b455ba666ac078$var$_descending = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("7FQdd")));

var $05b455ba666ac078$var$_insideOut = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("aPXBH")));

var $05b455ba666ac078$var$_none2 = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("18H9z")));

var $05b455ba666ac078$var$_reverse = $05b455ba666ac078$var$_interopRequireDefault((parcelRequire("et1xb")));
function $05b455ba666ac078$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($05b455ba666ac078$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $05b455ba666ac078$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $05b455ba666ac078$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $05b455ba666ac078$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("3z10P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $29856cfe3b52dc6f$var$_default;

var $fsn3b = parcelRequire("fsn3b");

var $29856cfe3b52dc6f$var$_constant = $29856cfe3b52dc6f$var$_interopRequireDefault((parcelRequire("i12nO")));

var $f0NPB = parcelRequire("f0NPB");
function $29856cfe3b52dc6f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $29856cfe3b52dc6f$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $29856cfe3b52dc6f$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $29856cfe3b52dc6f$var$arcStartAngle(d) {
    return d.startAngle;
}
function $29856cfe3b52dc6f$var$arcEndAngle(d) {
    return d.endAngle;
}
function $29856cfe3b52dc6f$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $29856cfe3b52dc6f$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $f0NPB.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $29856cfe3b52dc6f$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $f0NPB.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $f0NPB.sqrt)((0, $f0NPB.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $29856cfe3b52dc6f$var$_default() {
    var innerRadius = $29856cfe3b52dc6f$var$arcInnerRadius, outerRadius = $29856cfe3b52dc6f$var$arcOuterRadius, cornerRadius = (0, $29856cfe3b52dc6f$var$_constant.default)(0), padRadius = null, startAngle = $29856cfe3b52dc6f$var$arcStartAngle, endAngle = $29856cfe3b52dc6f$var$arcEndAngle, padAngle = $29856cfe3b52dc6f$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $f0NPB.halfPi, a1 = endAngle.apply(this, arguments) - $f0NPB.halfPi, da = (0, $f0NPB.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $fsn3b.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $f0NPB.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $f0NPB.tau - $f0NPB.epsilon) {
            context.moveTo(r1 * (0, $f0NPB.cos)(a0), r1 * (0, $f0NPB.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $f0NPB.epsilon) {
                context.moveTo(r0 * (0, $f0NPB.cos)(a1), r0 * (0, $f0NPB.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $f0NPB.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $f0NPB.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $f0NPB.min)((0, $f0NPB.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $f0NPB.epsilon) {
                var p0 = (0, $f0NPB.asin)(rp / r0 * (0, $f0NPB.sin)(ap)), p1 = (0, $f0NPB.asin)(rp / r1 * (0, $f0NPB.sin)(ap));
                if ((da0 -= p0 * 2) > $f0NPB.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $f0NPB.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $f0NPB.cos)(a01), y01 = r1 * (0, $f0NPB.sin)(a01), x10 = r0 * (0, $f0NPB.cos)(a10), y10 = r0 * (0, $f0NPB.sin)(a10); // Apply rounded corners?
            if (rc > $f0NPB.epsilon) {
                var x11 = r1 * (0, $f0NPB.cos)(a11), y11 = r1 * (0, $f0NPB.sin)(a11), x00 = r0 * (0, $f0NPB.cos)(a00), y00 = r0 * (0, $f0NPB.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $f0NPB.pi && (oc = $29856cfe3b52dc6f$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $f0NPB.sin)((0, $f0NPB.acos)((ax * bx + ay * by) / ((0, $f0NPB.sqrt)(ax * ax + ay * ay) * (0, $f0NPB.sqrt)(bx * bx + by * by))) / 2), lc = (0, $f0NPB.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $f0NPB.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $f0NPB.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $f0NPB.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $f0NPB.epsilon) {
                t0 = $29856cfe3b52dc6f$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $29856cfe3b52dc6f$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $f0NPB.atan2)(t0.y01, t0.x01), (0, $f0NPB.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $f0NPB.atan2)(t0.y01, t0.x01), (0, $f0NPB.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $f0NPB.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $f0NPB.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $f0NPB.atan2)(t1.y11, t1.x11), (0, $f0NPB.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $f0NPB.epsilon) || !(da0 > $f0NPB.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $f0NPB.epsilon) {
                t0 = $29856cfe3b52dc6f$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $29856cfe3b52dc6f$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $f0NPB.atan2)(t0.y01, t0.x01), (0, $f0NPB.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $f0NPB.atan2)(t0.y01, t0.x01), (0, $f0NPB.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $f0NPB.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $f0NPB.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $f0NPB.atan2)(t1.y11, t1.x11), (0, $f0NPB.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $f0NPB.pi / 2;
        return [
            (0, $f0NPB.cos)(a) * r,
            (0, $f0NPB.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $29856cfe3b52dc6f$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $29856cfe3b52dc6f$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $29856cfe3b52dc6f$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $29856cfe3b52dc6f$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $29856cfe3b52dc6f$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $29856cfe3b52dc6f$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $29856cfe3b52dc6f$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("fsn3b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function get() {
        return $b40b59e0a42913d5$var$_path.default;
    }
});

var $b40b59e0a42913d5$var$_path = $b40b59e0a42913d5$var$_interopRequireDefault((parcelRequire("ayi59")));
function $b40b59e0a42913d5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("ayi59", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $7aeb1b17af4eb486$var$pi = Math.PI, $7aeb1b17af4eb486$var$tau = 2 * $7aeb1b17af4eb486$var$pi, $7aeb1b17af4eb486$var$epsilon = 1e-6, $7aeb1b17af4eb486$var$tauEpsilon = $7aeb1b17af4eb486$var$tau - $7aeb1b17af4eb486$var$epsilon;
function $7aeb1b17af4eb486$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $7aeb1b17af4eb486$var$path() {
    return new $7aeb1b17af4eb486$var$Path();
}
$7aeb1b17af4eb486$var$Path.prototype = $7aeb1b17af4eb486$var$path.prototype = {
    constructor: $7aeb1b17af4eb486$var$Path,
    moveTo: function moveTo(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function lineTo(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function quadraticCurveTo(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $7aeb1b17af4eb486$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $7aeb1b17af4eb486$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($7aeb1b17af4eb486$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $7aeb1b17af4eb486$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $7aeb1b17af4eb486$var$epsilon || Math.abs(this._y1 - y0) > $7aeb1b17af4eb486$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $7aeb1b17af4eb486$var$tau + $7aeb1b17af4eb486$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $7aeb1b17af4eb486$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $7aeb1b17af4eb486$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $7aeb1b17af4eb486$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function rect(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function toString() {
        return this._;
    }
};
var $7aeb1b17af4eb486$var$_default = $7aeb1b17af4eb486$var$path;
module.exports.default = $7aeb1b17af4eb486$var$_default;

});


parcelRegister("i12nO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d1da2b359bc0cf6b$var$_default;
function $d1da2b359bc0cf6b$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("f0NPB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $aedd828e6d2e2a37$var$acos;
module.exports.asin = $aedd828e6d2e2a37$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
var $aedd828e6d2e2a37$var$abs = Math.abs;
module.exports.abs = $aedd828e6d2e2a37$var$abs;
var $aedd828e6d2e2a37$var$atan2 = Math.atan2;
module.exports.atan2 = $aedd828e6d2e2a37$var$atan2;
var $aedd828e6d2e2a37$var$cos = Math.cos;
module.exports.cos = $aedd828e6d2e2a37$var$cos;
var $aedd828e6d2e2a37$var$max = Math.max;
module.exports.max = $aedd828e6d2e2a37$var$max;
var $aedd828e6d2e2a37$var$min = Math.min;
module.exports.min = $aedd828e6d2e2a37$var$min;
var $aedd828e6d2e2a37$var$sin = Math.sin;
module.exports.sin = $aedd828e6d2e2a37$var$sin;
var $aedd828e6d2e2a37$var$sqrt = Math.sqrt;
module.exports.sqrt = $aedd828e6d2e2a37$var$sqrt;
var $aedd828e6d2e2a37$var$epsilon = 1e-12;
module.exports.epsilon = $aedd828e6d2e2a37$var$epsilon;
var $aedd828e6d2e2a37$var$pi = Math.PI;
module.exports.pi = $aedd828e6d2e2a37$var$pi;
var $aedd828e6d2e2a37$var$halfPi = $aedd828e6d2e2a37$var$pi / 2;
module.exports.halfPi = $aedd828e6d2e2a37$var$halfPi;
var $aedd828e6d2e2a37$var$tau = 2 * $aedd828e6d2e2a37$var$pi;
module.exports.tau = $aedd828e6d2e2a37$var$tau;
function $aedd828e6d2e2a37$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $aedd828e6d2e2a37$var$pi : Math.acos(x);
}
function $aedd828e6d2e2a37$var$asin(x) {
    return x >= 1 ? $aedd828e6d2e2a37$var$halfPi : x <= -1 ? -$aedd828e6d2e2a37$var$halfPi : Math.asin(x);
}

});


parcelRegister("82LCL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5db373cfd7843489$var$_default;

var $fsn3b = parcelRequire("fsn3b");

var $5db373cfd7843489$var$_array = $5db373cfd7843489$var$_interopRequireDefault((parcelRequire("ORiSs")));

var $5db373cfd7843489$var$_constant = $5db373cfd7843489$var$_interopRequireDefault((parcelRequire("i12nO")));

var $5db373cfd7843489$var$_linear = $5db373cfd7843489$var$_interopRequireDefault((parcelRequire("dNCFJ")));

var $5db373cfd7843489$var$_line = $5db373cfd7843489$var$_interopRequireDefault((parcelRequire("bUY2L")));

var $9LN3p = parcelRequire("9LN3p");
function $5db373cfd7843489$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5db373cfd7843489$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $5db373cfd7843489$var$_constant.default)(true), context = null, curve = $5db373cfd7843489$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $9LN3p.x : (0, $5db373cfd7843489$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $5db373cfd7843489$var$_constant.default)(0) : (0, $5db373cfd7843489$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $9LN3p.y : (0, $5db373cfd7843489$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $5db373cfd7843489$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $fsn3b.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $5db373cfd7843489$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $5db373cfd7843489$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $5db373cfd7843489$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $5db373cfd7843489$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $5db373cfd7843489$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $5db373cfd7843489$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $5db373cfd7843489$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $5db373cfd7843489$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("ORiSs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $098e04960cea0e4e$var$_default;
module.exports.slice = void 0;
var $098e04960cea0e4e$var$slice = Array.prototype.slice;
module.exports.slice = $098e04960cea0e4e$var$slice;
function $098e04960cea0e4e$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("dNCFJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a0bdd970534f71b6$var$_default;
function $a0bdd970534f71b6$var$Linear(context) {
    this._context = context;
}
$a0bdd970534f71b6$var$Linear.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $a0bdd970534f71b6$var$_default(context) {
    return new $a0bdd970534f71b6$var$Linear(context);
}

});

parcelRegister("bUY2L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8ad38018b184b5b2$var$_default;

var $fsn3b = parcelRequire("fsn3b");

var $8ad38018b184b5b2$var$_array = $8ad38018b184b5b2$var$_interopRequireDefault((parcelRequire("ORiSs")));

var $8ad38018b184b5b2$var$_constant = $8ad38018b184b5b2$var$_interopRequireDefault((parcelRequire("i12nO")));

var $8ad38018b184b5b2$var$_linear = $8ad38018b184b5b2$var$_interopRequireDefault((parcelRequire("dNCFJ")));

var $9LN3p = parcelRequire("9LN3p");
function $8ad38018b184b5b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8ad38018b184b5b2$var$_default(x, y) {
    var defined = (0, $8ad38018b184b5b2$var$_constant.default)(true), context = null, curve = $8ad38018b184b5b2$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $9LN3p.x : (0, $8ad38018b184b5b2$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $9LN3p.y : (0, $8ad38018b184b5b2$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $8ad38018b184b5b2$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $fsn3b.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $8ad38018b184b5b2$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $8ad38018b184b5b2$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $8ad38018b184b5b2$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("9LN3p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $71ce8df06eb1d27b$var$x;
module.exports.y = $71ce8df06eb1d27b$var$y;
function $71ce8df06eb1d27b$var$x(p) {
    return p[0];
}
function $71ce8df06eb1d27b$var$y(p) {
    return p[1];
}

});



parcelRegister("4oh7v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3326af0496833b99$var$_default;

var $3326af0496833b99$var$_array = $3326af0496833b99$var$_interopRequireDefault((parcelRequire("ORiSs")));

var $3326af0496833b99$var$_constant = $3326af0496833b99$var$_interopRequireDefault((parcelRequire("i12nO")));

var $3326af0496833b99$var$_descending = $3326af0496833b99$var$_interopRequireDefault((parcelRequire("uvbKL")));

var $3326af0496833b99$var$_identity = $3326af0496833b99$var$_interopRequireDefault((parcelRequire("9fYrX")));

var $f0NPB = parcelRequire("f0NPB");
function $3326af0496833b99$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3326af0496833b99$var$_default() {
    var value = $3326af0496833b99$var$_identity.default, sortValues = $3326af0496833b99$var$_descending.default, sort = null, startAngle = (0, $3326af0496833b99$var$_constant.default)(0), endAngle = (0, $3326af0496833b99$var$_constant.default)($f0NPB.tau), padAngle = (0, $3326af0496833b99$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $3326af0496833b99$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($f0NPB.tau, Math.max(-$f0NPB.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $3326af0496833b99$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $3326af0496833b99$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $3326af0496833b99$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $3326af0496833b99$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("uvbKL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $05bafedb4f9693a1$var$_default;
function $05bafedb4f9693a1$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("9fYrX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6bd467e073b4128a$var$_default;
function $6bd467e073b4128a$var$_default(d) {
    return d;
}

});


parcelRegister("6xqpI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4c2a505a450995ef$var$_default;

var $4c2a505a450995ef$var$_radial = $4c2a505a450995ef$var$_interopRequireWildcard((parcelRequire("dx26D")));

var $4c2a505a450995ef$var$_area = $4c2a505a450995ef$var$_interopRequireDefault((parcelRequire("82LCL")));

var $5Jv3Q = parcelRequire("5Jv3Q");
function $4c2a505a450995ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4c2a505a450995ef$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4c2a505a450995ef$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4c2a505a450995ef$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4c2a505a450995ef$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4c2a505a450995ef$var$_default() {
    var a = (0, $4c2a505a450995ef$var$_area.default)().curve($4c2a505a450995ef$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $5Jv3Q.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $5Jv3Q.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $5Jv3Q.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $5Jv3Q.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $4c2a505a450995ef$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("dx26D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $9d9ffda3a8635908$var$curveRadial;

var $9d9ffda3a8635908$var$_linear = $9d9ffda3a8635908$var$_interopRequireDefault((parcelRequire("dNCFJ")));
function $9d9ffda3a8635908$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9d9ffda3a8635908$var$curveRadialLinear = $9d9ffda3a8635908$var$curveRadial($9d9ffda3a8635908$var$_linear.default);
module.exports.curveRadialLinear = $9d9ffda3a8635908$var$curveRadialLinear;
function $9d9ffda3a8635908$var$Radial(curve) {
    this._curve = curve;
}
$9d9ffda3a8635908$var$Radial.prototype = {
    areaStart: function areaStart() {
        this._curve.areaStart();
    },
    areaEnd: function areaEnd() {
        this._curve.areaEnd();
    },
    lineStart: function lineStart() {
        this._curve.lineStart();
    },
    lineEnd: function lineEnd() {
        this._curve.lineEnd();
    },
    point: function point(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $9d9ffda3a8635908$var$curveRadial(curve) {
    function radial(context) {
        return new $9d9ffda3a8635908$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("5Jv3Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $42c93fc4ac80baab$var$_default;
module.exports.lineRadial = $42c93fc4ac80baab$var$lineRadial;

var $42c93fc4ac80baab$var$_radial = $42c93fc4ac80baab$var$_interopRequireWildcard((parcelRequire("dx26D")));

var $42c93fc4ac80baab$var$_line = $42c93fc4ac80baab$var$_interopRequireDefault((parcelRequire("bUY2L")));
function $42c93fc4ac80baab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $42c93fc4ac80baab$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($42c93fc4ac80baab$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $42c93fc4ac80baab$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $42c93fc4ac80baab$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $42c93fc4ac80baab$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $42c93fc4ac80baab$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $42c93fc4ac80baab$var$_default() {
    return $42c93fc4ac80baab$var$lineRadial((0, $42c93fc4ac80baab$var$_line.default)().curve($42c93fc4ac80baab$var$_radial.curveRadialLinear));
}

});


parcelRegister("cLBS2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $94b74020670a9fc0$var$_default;
function $94b74020670a9fc0$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("3ph4f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $27b0f22aa2df7db9$var$link;
module.exports.linkHorizontal = $27b0f22aa2df7db9$var$linkHorizontal;
module.exports.linkRadial = $27b0f22aa2df7db9$var$linkRadial;
module.exports.linkVertical = $27b0f22aa2df7db9$var$linkVertical;

var $fsn3b = parcelRequire("fsn3b");

var $ORiSs = parcelRequire("ORiSs");

var $27b0f22aa2df7db9$var$_constant = $27b0f22aa2df7db9$var$_interopRequireDefault((parcelRequire("i12nO")));

var $g3Dpm = parcelRequire("g3Dpm");

var $9LN3p = parcelRequire("9LN3p");
function $27b0f22aa2df7db9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $27b0f22aa2df7db9$var$linkSource(d) {
    return d.source;
}
function $27b0f22aa2df7db9$var$linkTarget(d) {
    return d.target;
}
function $27b0f22aa2df7db9$var$link(curve) {
    var source = $27b0f22aa2df7db9$var$linkSource;
    var target = $27b0f22aa2df7db9$var$linkTarget;
    var x = $9LN3p.x;
    var y = $9LN3p.y;
    var context = null;
    var output = null;
    function link() {
        var buffer;
        var argv = $ORiSs.slice.call(arguments);
        var s = source.apply(this, argv);
        var t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $fsn3b.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $27b0f22aa2df7db9$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $27b0f22aa2df7db9$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $27b0f22aa2df7db9$var$linkHorizontal() {
    return $27b0f22aa2df7db9$var$link($g3Dpm.bumpX);
}
function $27b0f22aa2df7db9$var$linkVertical() {
    return $27b0f22aa2df7db9$var$link($g3Dpm.bumpY);
}
function $27b0f22aa2df7db9$var$linkRadial() {
    var l = $27b0f22aa2df7db9$var$link($g3Dpm.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("g3Dpm", function(module, exports) {

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $fyztb = parcelRequire("fyztb");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $bb0b7ec3526ec56b$var$bumpRadial;
module.exports.bumpX = $bb0b7ec3526ec56b$var$bumpX;
module.exports.bumpY = $bb0b7ec3526ec56b$var$bumpY;

var $bb0b7ec3526ec56b$var$_pointRadial = $bb0b7ec3526ec56b$var$_interopRequireDefault((parcelRequire("cLBS2")));
function $bb0b7ec3526ec56b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bb0b7ec3526ec56b$var$Bump = /*#__PURE__*/ function() {
    function Bump(context, x) {
        (0, $5sFFs._)(this, Bump);
        this._context = context;
        this._x = x;
    }
    (0, $8O2fV._)(Bump, [
        {
            key: "areaStart",
            value: function areaStart() {
                this._line = 0;
            }
        },
        {
            key: "areaEnd",
            value: function areaEnd() {
                this._line = NaN;
            }
        },
        {
            key: "lineStart",
            value: function lineStart() {
                this._point = 0;
            }
        },
        {
            key: "lineEnd",
            value: function lineEnd() {
                if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
                this._line = 1 - this._line;
            }
        },
        {
            key: "point",
            value: function point(x, y) {
                x = +x, y = +y;
                switch(this._point){
                    case 0:
                        this._point = 1;
                        if (this._line) this._context.lineTo(x, y);
                        else this._context.moveTo(x, y);
                        break;
                    case 1:
                        this._point = 2;
                    // falls through
                    default:
                        if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                        else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                        break;
                }
                this._x0 = x, this._y0 = y;
            }
        }
    ]);
    return Bump;
}();
var $bb0b7ec3526ec56b$var$BumpRadial = /*#__PURE__*/ function() {
    function BumpRadial(context) {
        (0, $5sFFs._)(this, BumpRadial);
        this._context = context;
    }
    (0, $8O2fV._)(BumpRadial, [
        {
            key: "lineStart",
            value: function lineStart() {
                this._point = 0;
            }
        },
        {
            key: "lineEnd",
            value: function lineEnd() {}
        },
        {
            key: "point",
            value: function point(x, y) {
                x = +x, y = +y;
                if (this._point++ === 0) this._x0 = x, this._y0 = y;
                else {
                    var _this__context, _this__context1;
                    var p0 = (0, $bb0b7ec3526ec56b$var$_pointRadial.default)(this._x0, this._y0);
                    var p1 = (0, $bb0b7ec3526ec56b$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
                    var p2 = (0, $bb0b7ec3526ec56b$var$_pointRadial.default)(x, this._y0);
                    var p3 = (0, $bb0b7ec3526ec56b$var$_pointRadial.default)(x, y);
                    (_this__context = this._context).moveTo.apply(_this__context, (0, $fyztb._)(p0));
                    (_this__context1 = this._context).bezierCurveTo.apply(_this__context1, (0, $fyztb._)(p1).concat((0, $fyztb._)(p2), (0, $fyztb._)(p3)));
                }
            }
        }
    ]);
    return BumpRadial;
}();
function $bb0b7ec3526ec56b$var$bumpX(context) {
    return new $bb0b7ec3526ec56b$var$Bump(context, true);
}
function $bb0b7ec3526ec56b$var$bumpY(context) {
    return new $bb0b7ec3526ec56b$var$Bump(context, false);
}
function $bb0b7ec3526ec56b$var$bumpRadial(context) {
    return new $bb0b7ec3526ec56b$var$BumpRadial(context);
}

});


parcelRegister("g2329", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $babf2fac9395be93$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $fsn3b = parcelRequire("fsn3b");

var $babf2fac9395be93$var$_constant = $babf2fac9395be93$var$_interopRequireDefault((parcelRequire("i12nO")));

var $babf2fac9395be93$var$_asterisk = $babf2fac9395be93$var$_interopRequireDefault((parcelRequire("lw9jG")));

var $babf2fac9395be93$var$_circle = $babf2fac9395be93$var$_interopRequireDefault((parcelRequire("e9GGe")));

var $babf2fac9395be93$var$_cross = $babf2fac9395be93$var$_interopRequireDefault((parcelRequire("bawW4")));

var $babf2fac9395be93$var$_diamond = $babf2fac9395be93$var$_interopRequireDefault((parcelRequire("3L0QJ")));

var $babf2fac9395be93$var$_diamond2 = $babf2fac9395be93$var$_interopRequireDefault((parcelRequire("5mtuV")));

var $babf2fac9395be93$var$_plus = $babf2fac9395be93$var$_interopRequireDefault((parcelRequire("2iOrm")));

var $babf2fac9395be93$var$_square = $babf2fac9395be93$var$_interopRequireDefault((parcelRequire("e1iV5")));

var $babf2fac9395be93$var$_square2 = $babf2fac9395be93$var$_interopRequireDefault((parcelRequire("fElhB")));

var $babf2fac9395be93$var$_star = $babf2fac9395be93$var$_interopRequireDefault((parcelRequire("e9PRV")));

var $babf2fac9395be93$var$_triangle = $babf2fac9395be93$var$_interopRequireDefault((parcelRequire("dVGtB")));

var $babf2fac9395be93$var$_triangle2 = $babf2fac9395be93$var$_interopRequireDefault((parcelRequire("cZDu1")));

var $babf2fac9395be93$var$_wye = $babf2fac9395be93$var$_interopRequireDefault((parcelRequire("eiTDE")));

var $babf2fac9395be93$var$_x = $babf2fac9395be93$var$_interopRequireDefault((parcelRequire("csc6D")));
function $babf2fac9395be93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
var $babf2fac9395be93$var$symbolsFill = [
    $babf2fac9395be93$var$_circle.default,
    $babf2fac9395be93$var$_cross.default,
    $babf2fac9395be93$var$_diamond.default,
    $babf2fac9395be93$var$_square.default,
    $babf2fac9395be93$var$_star.default,
    $babf2fac9395be93$var$_triangle.default,
    $babf2fac9395be93$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $babf2fac9395be93$var$symbolsFill;
var $babf2fac9395be93$var$symbolsStroke = [
    $babf2fac9395be93$var$_circle.default,
    $babf2fac9395be93$var$_plus.default,
    $babf2fac9395be93$var$_x.default,
    $babf2fac9395be93$var$_triangle2.default,
    $babf2fac9395be93$var$_asterisk.default,
    $babf2fac9395be93$var$_square2.default,
    $babf2fac9395be93$var$_diamond2.default
];
module.exports.symbolsStroke = $babf2fac9395be93$var$symbolsStroke;
function $babf2fac9395be93$var$Symbol(type, size) {
    var context = null;
    type = typeof type === "function" ? type : (0, $babf2fac9395be93$var$_constant.default)(type || $babf2fac9395be93$var$_circle.default);
    size = typeof size === "function" ? size : (0, $babf2fac9395be93$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        var buffer;
        if (!context) context = buffer = (0, $fsn3b.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $babf2fac9395be93$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $babf2fac9395be93$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("lw9jG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0NPB = parcelRequire("f0NPB");
var $faa3d031d5cedf8b$var$sqrt3 = (0, $f0NPB.sqrt)(3);
var $faa3d031d5cedf8b$var$_default = {
    draw: function(context, size) {
        var r = (0, $f0NPB.sqrt)(size + (0, $f0NPB.min)(size / 28, 0.75)) * 0.59436;
        var t = r / 2;
        var u = t * $faa3d031d5cedf8b$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $faa3d031d5cedf8b$var$_default;

});

parcelRegister("e9GGe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0NPB = parcelRequire("f0NPB");
var $a4e3035364bb4da5$var$_default = {
    draw: function(context, size) {
        var r = (0, $f0NPB.sqrt)(size / $f0NPB.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $f0NPB.tau);
    }
};
module.exports.default = $a4e3035364bb4da5$var$_default;

});

parcelRegister("bawW4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0NPB = parcelRequire("f0NPB");
var $821a2d320c286fdc$var$_default = {
    draw: function(context, size) {
        var r = (0, $f0NPB.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $821a2d320c286fdc$var$_default;

});

parcelRegister("3L0QJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0NPB = parcelRequire("f0NPB");
var $2bc66b9aa93eb3ab$var$tan30 = (0, $f0NPB.sqrt)(1 / 3);
var $2bc66b9aa93eb3ab$var$tan30_2 = $2bc66b9aa93eb3ab$var$tan30 * 2;
var $2bc66b9aa93eb3ab$var$_default = {
    draw: function(context, size) {
        var y = (0, $f0NPB.sqrt)(size / $2bc66b9aa93eb3ab$var$tan30_2);
        var x = y * $2bc66b9aa93eb3ab$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $2bc66b9aa93eb3ab$var$_default;

});

parcelRegister("5mtuV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0NPB = parcelRequire("f0NPB");
var $3e75e3747d87c0d5$var$_default = {
    draw: function(context, size) {
        var r = (0, $f0NPB.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $3e75e3747d87c0d5$var$_default;

});

parcelRegister("2iOrm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0NPB = parcelRequire("f0NPB");
var $1ad463957f2fc944$var$_default = {
    draw: function(context, size) {
        var r = (0, $f0NPB.sqrt)(size - (0, $f0NPB.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $1ad463957f2fc944$var$_default;

});

parcelRegister("e1iV5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0NPB = parcelRequire("f0NPB");
var $a34fd5bc3e6df6f3$var$_default = {
    draw: function(context, size) {
        var w = (0, $f0NPB.sqrt)(size);
        var x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $a34fd5bc3e6df6f3$var$_default;

});

parcelRegister("fElhB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0NPB = parcelRequire("f0NPB");
var $b64b19c4d7a28105$var$_default = {
    draw: function(context, size) {
        var r = (0, $f0NPB.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $b64b19c4d7a28105$var$_default;

});

parcelRegister("e9PRV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0NPB = parcelRequire("f0NPB");
var $a4ea23fedfbbf844$var$ka = 0.89081309152928522810;
var $a4ea23fedfbbf844$var$kr = (0, $f0NPB.sin)($f0NPB.pi / 10) / (0, $f0NPB.sin)(7 * $f0NPB.pi / 10);
var $a4ea23fedfbbf844$var$kx = (0, $f0NPB.sin)($f0NPB.tau / 10) * $a4ea23fedfbbf844$var$kr;
var $a4ea23fedfbbf844$var$ky = -(0, $f0NPB.cos)($f0NPB.tau / 10) * $a4ea23fedfbbf844$var$kr;
var $a4ea23fedfbbf844$var$_default = {
    draw: function(context, size) {
        var r = (0, $f0NPB.sqrt)(size * $a4ea23fedfbbf844$var$ka);
        var x = $a4ea23fedfbbf844$var$kx * r;
        var y = $a4ea23fedfbbf844$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(var i = 1; i < 5; ++i){
            var a = $f0NPB.tau * i / 5;
            var c = (0, $f0NPB.cos)(a);
            var s = (0, $f0NPB.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $a4ea23fedfbbf844$var$_default;

});

parcelRegister("dVGtB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0NPB = parcelRequire("f0NPB");
var $a2418c2f4dd86757$var$sqrt3 = (0, $f0NPB.sqrt)(3);
var $a2418c2f4dd86757$var$_default = {
    draw: function(context, size) {
        var y = -(0, $f0NPB.sqrt)(size / ($a2418c2f4dd86757$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$a2418c2f4dd86757$var$sqrt3 * y, -y);
        context.lineTo($a2418c2f4dd86757$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $a2418c2f4dd86757$var$_default;

});

parcelRegister("cZDu1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0NPB = parcelRequire("f0NPB");
var $9759cf1141e5d8e2$var$sqrt3 = (0, $f0NPB.sqrt)(3);
var $9759cf1141e5d8e2$var$_default = {
    draw: function(context, size) {
        var s = (0, $f0NPB.sqrt)(size) * 0.6824;
        var t = s / 2;
        var u = s * $9759cf1141e5d8e2$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $9759cf1141e5d8e2$var$_default;

});

parcelRegister("eiTDE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0NPB = parcelRequire("f0NPB");
var $a69de7c7d21aeaf6$var$c = -0.5;
var $a69de7c7d21aeaf6$var$s = (0, $f0NPB.sqrt)(3) / 2;
var $a69de7c7d21aeaf6$var$k = 1 / (0, $f0NPB.sqrt)(12);
var $a69de7c7d21aeaf6$var$a = ($a69de7c7d21aeaf6$var$k / 2 + 1) * 3;
var $a69de7c7d21aeaf6$var$_default = {
    draw: function(context, size) {
        var r = (0, $f0NPB.sqrt)(size / $a69de7c7d21aeaf6$var$a);
        var x0 = r / 2, y0 = r * $a69de7c7d21aeaf6$var$k;
        var x1 = x0, y1 = r * $a69de7c7d21aeaf6$var$k + r;
        var x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($a69de7c7d21aeaf6$var$c * x0 - $a69de7c7d21aeaf6$var$s * y0, $a69de7c7d21aeaf6$var$s * x0 + $a69de7c7d21aeaf6$var$c * y0);
        context.lineTo($a69de7c7d21aeaf6$var$c * x1 - $a69de7c7d21aeaf6$var$s * y1, $a69de7c7d21aeaf6$var$s * x1 + $a69de7c7d21aeaf6$var$c * y1);
        context.lineTo($a69de7c7d21aeaf6$var$c * x2 - $a69de7c7d21aeaf6$var$s * y2, $a69de7c7d21aeaf6$var$s * x2 + $a69de7c7d21aeaf6$var$c * y2);
        context.lineTo($a69de7c7d21aeaf6$var$c * x0 + $a69de7c7d21aeaf6$var$s * y0, $a69de7c7d21aeaf6$var$c * y0 - $a69de7c7d21aeaf6$var$s * x0);
        context.lineTo($a69de7c7d21aeaf6$var$c * x1 + $a69de7c7d21aeaf6$var$s * y1, $a69de7c7d21aeaf6$var$c * y1 - $a69de7c7d21aeaf6$var$s * x1);
        context.lineTo($a69de7c7d21aeaf6$var$c * x2 + $a69de7c7d21aeaf6$var$s * y2, $a69de7c7d21aeaf6$var$c * y2 - $a69de7c7d21aeaf6$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $a69de7c7d21aeaf6$var$_default;

});

parcelRegister("csc6D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0NPB = parcelRequire("f0NPB");
var $91117d95166ce3a5$var$_default = {
    draw: function(context, size) {
        var r = (0, $f0NPB.sqrt)(size - (0, $f0NPB.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $91117d95166ce3a5$var$_default;

});


parcelRegister("lysOo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fb131f58a7aa17b6$var$_default;

var $fb131f58a7aa17b6$var$_noop = $fb131f58a7aa17b6$var$_interopRequireDefault((parcelRequire("jzzen")));

var $6GOcp = parcelRequire("6GOcp");
function $fb131f58a7aa17b6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fb131f58a7aa17b6$var$BasisClosed(context) {
    this._context = context;
}
$fb131f58a7aa17b6$var$BasisClosed.prototype = {
    areaStart: $fb131f58a7aa17b6$var$_noop.default,
    areaEnd: $fb131f58a7aa17b6$var$_noop.default,
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $6GOcp.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $fb131f58a7aa17b6$var$_default(context) {
    return new $fb131f58a7aa17b6$var$BasisClosed(context);
}

});
parcelRegister("jzzen", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e3fc9d5163bac653$var$_default;
function $e3fc9d5163bac653$var$_default() {}

});

parcelRegister("6GOcp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $4ded9ad7727081e3$var$Basis;
module.exports.default = $4ded9ad7727081e3$var$_default;
module.exports.point = $4ded9ad7727081e3$var$point;
function $4ded9ad7727081e3$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $4ded9ad7727081e3$var$Basis(context) {
    this._context = context;
}
$4ded9ad7727081e3$var$Basis.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 3:
                $4ded9ad7727081e3$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point1(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $4ded9ad7727081e3$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $4ded9ad7727081e3$var$_default(context) {
    return new $4ded9ad7727081e3$var$Basis(context);
}

});


parcelRegister("2Z68d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22c608d75e848963$var$_default;

var $6GOcp = parcelRequire("6GOcp");
function $22c608d75e848963$var$BasisOpen(context) {
    this._context = context;
}
$22c608d75e848963$var$BasisOpen.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $6GOcp.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $22c608d75e848963$var$_default(context) {
    return new $22c608d75e848963$var$BasisOpen(context);
}

});

parcelRegister("fdyG2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6GOcp = parcelRequire("6GOcp");
function $b142f80fcd6dff0a$var$Bundle(context, beta) {
    this._basis = new $6GOcp.Basis(context);
    this._beta = beta;
}
$b142f80fcd6dff0a$var$Bundle.prototype = {
    lineStart: function lineStart() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function lineEnd() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function point(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $b142f80fcd6dff0a$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $6GOcp.Basis(context) : new $b142f80fcd6dff0a$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $b142f80fcd6dff0a$var$_default;

});

parcelRegister("eEpxA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $aaa89cf3d1b14ca0$var$CardinalClosed;
module.exports.default = void 0;

var $aaa89cf3d1b14ca0$var$_noop = $aaa89cf3d1b14ca0$var$_interopRequireDefault((parcelRequire("jzzen")));

var $fjdt0 = parcelRequire("fjdt0");
function $aaa89cf3d1b14ca0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aaa89cf3d1b14ca0$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$aaa89cf3d1b14ca0$var$CardinalClosed.prototype = {
    areaStart: $aaa89cf3d1b14ca0$var$_noop.default,
    areaEnd: $aaa89cf3d1b14ca0$var$_noop.default,
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $fjdt0.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $aaa89cf3d1b14ca0$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $aaa89cf3d1b14ca0$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $aaa89cf3d1b14ca0$var$_default;

});
parcelRegister("fjdt0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $b25313982a1ddf31$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $b25313982a1ddf31$var$point;
function $b25313982a1ddf31$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $b25313982a1ddf31$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$b25313982a1ddf31$var$Cardinal.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $b25313982a1ddf31$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point1(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $b25313982a1ddf31$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $b25313982a1ddf31$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $b25313982a1ddf31$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $b25313982a1ddf31$var$_default;

});


parcelRegister("9lSbn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $6cf01ab6f4b02ab1$var$CardinalOpen;
module.exports.default = void 0;

var $fjdt0 = parcelRequire("fjdt0");
function $6cf01ab6f4b02ab1$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$6cf01ab6f4b02ab1$var$CardinalOpen.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $fjdt0.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $6cf01ab6f4b02ab1$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $6cf01ab6f4b02ab1$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $6cf01ab6f4b02ab1$var$_default;

});

parcelRegister("bPWcK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eEpxA = parcelRequire("eEpxA");

var $89e19b55f46a270d$var$_noop = $89e19b55f46a270d$var$_interopRequireDefault((parcelRequire("jzzen")));

var $cEJkg = parcelRequire("cEJkg");
function $89e19b55f46a270d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $89e19b55f46a270d$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$89e19b55f46a270d$var$CatmullRomClosed.prototype = {
    areaStart: $89e19b55f46a270d$var$_noop.default,
    areaEnd: $89e19b55f46a270d$var$_noop.default,
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function point(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $cEJkg.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $89e19b55f46a270d$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $89e19b55f46a270d$var$CatmullRomClosed(context, alpha) : new $eEpxA.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $89e19b55f46a270d$var$_default;

});
parcelRegister("cEJkg", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $f0NPB = parcelRequire("f0NPB");

var $fjdt0 = parcelRequire("fjdt0");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $f0NPB.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $f0NPB.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point1(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $fjdt0.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("dfKLc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9lSbn = parcelRequire("9lSbn");

var $cEJkg = parcelRequire("cEJkg");
function $9a60f2b74e46a414$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$9a60f2b74e46a414$var$CatmullRomOpen.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $cEJkg.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $9a60f2b74e46a414$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $9a60f2b74e46a414$var$CatmullRomOpen(context, alpha) : new $9lSbn.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $9a60f2b74e46a414$var$_default;

});

parcelRegister("eGsXk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ab0b72f825e4d9cd$var$_default;

var $ab0b72f825e4d9cd$var$_noop = $ab0b72f825e4d9cd$var$_interopRequireDefault((parcelRequire("jzzen")));
function $ab0b72f825e4d9cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ab0b72f825e4d9cd$var$LinearClosed(context) {
    this._context = context;
}
$ab0b72f825e4d9cd$var$LinearClosed.prototype = {
    areaStart: $ab0b72f825e4d9cd$var$_noop.default,
    areaEnd: $ab0b72f825e4d9cd$var$_noop.default,
    lineStart: function lineStart() {
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._point) this._context.closePath();
    },
    point: function point(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $ab0b72f825e4d9cd$var$_default(context) {
    return new $ab0b72f825e4d9cd$var$LinearClosed(context);
}

});

parcelRegister("5iCM5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $3dbcb607aa3c03e8$var$monotoneX;
module.exports.monotoneY = $3dbcb607aa3c03e8$var$monotoneY;
function $3dbcb607aa3c03e8$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $3dbcb607aa3c03e8$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($3dbcb607aa3c03e8$var$sign(s0) + $3dbcb607aa3c03e8$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $3dbcb607aa3c03e8$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $3dbcb607aa3c03e8$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $3dbcb607aa3c03e8$var$MonotoneX(context) {
    this._context = context;
}
$3dbcb607aa3c03e8$var$MonotoneX.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $3dbcb607aa3c03e8$var$point(this, this._t0, $3dbcb607aa3c03e8$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point1(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $3dbcb607aa3c03e8$var$point(this, $3dbcb607aa3c03e8$var$slope2(this, t1 = $3dbcb607aa3c03e8$var$slope3(this, x, y)), t1);
                break;
            default:
                $3dbcb607aa3c03e8$var$point(this, this._t0, t1 = $3dbcb607aa3c03e8$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $3dbcb607aa3c03e8$var$MonotoneY(context) {
    this._context = new $3dbcb607aa3c03e8$var$ReflectContext(context);
}
($3dbcb607aa3c03e8$var$MonotoneY.prototype = Object.create($3dbcb607aa3c03e8$var$MonotoneX.prototype)).point = function(x, y) {
    $3dbcb607aa3c03e8$var$MonotoneX.prototype.point.call(this, y, x);
};
function $3dbcb607aa3c03e8$var$ReflectContext(context) {
    this._context = context;
}
$3dbcb607aa3c03e8$var$ReflectContext.prototype = {
    moveTo: function moveTo(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function closePath() {
        this._context.closePath();
    },
    lineTo: function lineTo(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $3dbcb607aa3c03e8$var$monotoneX(context) {
    return new $3dbcb607aa3c03e8$var$MonotoneX(context);
}
function $3dbcb607aa3c03e8$var$monotoneY(context) {
    return new $3dbcb607aa3c03e8$var$MonotoneY(context);
}

});

parcelRegister("aCFgt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $01feed433eaafc07$var$_default;
function $01feed433eaafc07$var$Natural(context) {
    this._context = context;
}
$01feed433eaafc07$var$Natural.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function lineEnd() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $01feed433eaafc07$var$controlPoints(x), py = $01feed433eaafc07$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function point(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $01feed433eaafc07$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $01feed433eaafc07$var$_default(context) {
    return new $01feed433eaafc07$var$Natural(context);
}

});

parcelRegister("a4VFn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7567026e28841fe3$var$_default;
module.exports.stepAfter = $7567026e28841fe3$var$stepAfter;
module.exports.stepBefore = $7567026e28841fe3$var$stepBefore;
function $7567026e28841fe3$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$7567026e28841fe3$var$Step.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $7567026e28841fe3$var$_default(context) {
    return new $7567026e28841fe3$var$Step(context, 0.5);
}
function $7567026e28841fe3$var$stepBefore(context) {
    return new $7567026e28841fe3$var$Step(context, 0);
}
function $7567026e28841fe3$var$stepAfter(context) {
    return new $7567026e28841fe3$var$Step(context, 1);
}

});

parcelRegister("7Q4a1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $01790ace24c43118$var$_default;

var $01790ace24c43118$var$_array = $01790ace24c43118$var$_interopRequireDefault((parcelRequire("ORiSs")));

var $01790ace24c43118$var$_constant = $01790ace24c43118$var$_interopRequireDefault((parcelRequire("i12nO")));

var $01790ace24c43118$var$_none = $01790ace24c43118$var$_interopRequireDefault((parcelRequire("biP2R")));

var $01790ace24c43118$var$_none2 = $01790ace24c43118$var$_interopRequireDefault((parcelRequire("18H9z")));
function $01790ace24c43118$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $01790ace24c43118$var$stackValue(d, key) {
    return d[key];
}
function $01790ace24c43118$var$stackSeries(key) {
    var series = [];
    series.key = key;
    return series;
}
function $01790ace24c43118$var$_default() {
    var keys = (0, $01790ace24c43118$var$_constant.default)([]), order = $01790ace24c43118$var$_none2.default, offset = $01790ace24c43118$var$_none.default, value = $01790ace24c43118$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $01790ace24c43118$var$stackSeries), i, n = sz.length, j = -1, oz;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
                    0,
                    +value(d, sz[i].key, j, data)
                ]).data = d;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        for(i = 0, oz = (0, $01790ace24c43118$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $01790ace24c43118$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $01790ace24c43118$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $01790ace24c43118$var$_none2.default : typeof _ === "function" ? _ : (0, $01790ace24c43118$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $01790ace24c43118$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("biP2R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $83a8f8a6ddd064cb$var$_default;
function $83a8f8a6ddd064cb$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("18H9z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0d48032e7e03d093$var$_default;
function $0d48032e7e03d093$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("fSo87", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b8ee9dd76ace04bb$var$_default;

var $b8ee9dd76ace04bb$var$_none = $b8ee9dd76ace04bb$var$_interopRequireDefault((parcelRequire("biP2R")));
function $b8ee9dd76ace04bb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b8ee9dd76ace04bb$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $b8ee9dd76ace04bb$var$_none.default)(series, order);
}

});

parcelRegister("3twnr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $287d31f5744d2032$var$_default;
function $287d31f5744d2032$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("cTnNM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $962d15ad2cfc8e81$var$_default;

var $962d15ad2cfc8e81$var$_none = $962d15ad2cfc8e81$var$_interopRequireDefault((parcelRequire("biP2R")));
function $962d15ad2cfc8e81$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $962d15ad2cfc8e81$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $962d15ad2cfc8e81$var$_none.default)(series, order);
}

});

parcelRegister("lU1IY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ff202a5be5d4938a$var$_default;

var $ff202a5be5d4938a$var$_none = $ff202a5be5d4938a$var$_interopRequireDefault((parcelRequire("biP2R")));
function $ff202a5be5d4938a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ff202a5be5d4938a$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $ff202a5be5d4938a$var$_none.default)(series, order);
}

});

parcelRegister("4ykVD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $350a9262f7374f1c$var$_default;

var $350a9262f7374f1c$var$_none = $350a9262f7374f1c$var$_interopRequireDefault((parcelRequire("18H9z")));
function $350a9262f7374f1c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $350a9262f7374f1c$var$_default(series) {
    var peaks = series.map($350a9262f7374f1c$var$peak);
    return (0, $350a9262f7374f1c$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $350a9262f7374f1c$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("21GUU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $179cf72bc17d46c9$var$_default;
module.exports.sum = $179cf72bc17d46c9$var$sum;

var $179cf72bc17d46c9$var$_none = $179cf72bc17d46c9$var$_interopRequireDefault((parcelRequire("18H9z")));
function $179cf72bc17d46c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $179cf72bc17d46c9$var$_default(series) {
    var sums = series.map($179cf72bc17d46c9$var$sum);
    return (0, $179cf72bc17d46c9$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $179cf72bc17d46c9$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("7FQdd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5964dcfc0d81c632$var$_default;

var $5964dcfc0d81c632$var$_ascending = $5964dcfc0d81c632$var$_interopRequireDefault((parcelRequire("21GUU")));
function $5964dcfc0d81c632$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5964dcfc0d81c632$var$_default(series) {
    return (0, $5964dcfc0d81c632$var$_ascending.default)(series).reverse();
}

});

parcelRegister("aPXBH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e3ce78950056127$var$_default;

var $7e3ce78950056127$var$_appearance = $7e3ce78950056127$var$_interopRequireDefault((parcelRequire("4ykVD")));

var $21GUU = parcelRequire("21GUU");
function $7e3ce78950056127$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7e3ce78950056127$var$_default(series) {
    var n = series.length, i, j, sums = series.map($21GUU.sum), order = (0, $7e3ce78950056127$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("et1xb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a884f6c82c98c7ec$var$_default;

var $a884f6c82c98c7ec$var$_none = $a884f6c82c98c7ec$var$_interopRequireDefault((parcelRequire("18H9z")));
function $a884f6c82c98c7ec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a884f6c82c98c7ec$var$_default(series) {
    return (0, $a884f6c82c98c7ec$var$_none.default)(series).reverse();
}

});



parcelRegister("d6uHB", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $98a3a6bf966aecb6$export$2b8d127b894957b9; }, function (v) { return $98a3a6bf966aecb6$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $98a3a6bf966aecb6$export$cea3a54a6425200c; }, function (v) { return $98a3a6bf966aecb6$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $98a3a6bf966aecb6$export$a7c73072b1a182ae; }, function (v) { return $98a3a6bf966aecb6$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $98a3a6bf966aecb6$export$9f27bc3417b4524d; }, function (v) { return $98a3a6bf966aecb6$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $98a3a6bf966aecb6$export$db77ccec0bb4ccac; }, function (v) { return $98a3a6bf966aecb6$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $98a3a6bf966aecb6$export$8392c0c9d3dcbd35; }, function (v) { return $98a3a6bf966aecb6$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $98a3a6bf966aecb6$export$ffb0004e005737fa; }, function (v) { return $98a3a6bf966aecb6$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $98a3a6bf966aecb6$export$b624eff549462981; }, function (v) { return $98a3a6bf966aecb6$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $98a3a6bf966aecb6$export$7897aa7841a5380c; }, function (v) { return $98a3a6bf966aecb6$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $98a3a6bf966aecb6$export$602eac185826482c; }, function (v) { return $98a3a6bf966aecb6$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $98a3a6bf966aecb6$export$e2c29f18771995cb; }, function (v) { return $98a3a6bf966aecb6$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $98a3a6bf966aecb6$export$5f8d39834fd61797; }, function (v) { return $98a3a6bf966aecb6$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $98a3a6bf966aecb6$export$74bf444e3cd11ea5; }, function (v) { return $98a3a6bf966aecb6$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $98a3a6bf966aecb6$export$92387174baf9b227; }, function (v) { return $98a3a6bf966aecb6$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $98a3a6bf966aecb6$export$ec112efeb987d9c6; }, function (v) { return $98a3a6bf966aecb6$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $98a3a6bf966aecb6$export$b706b080d889d2c9; }, function (v) { return $98a3a6bf966aecb6$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $98a3a6bf966aecb6$export$5be5a87408f70ddc; }, function (v) { return $98a3a6bf966aecb6$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $98a3a6bf966aecb6$export$45a5e7f76e0caa8d; }, function (v) { return $98a3a6bf966aecb6$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $98a3a6bf966aecb6$export$455c2e768291efa6; }, function (v) { return $98a3a6bf966aecb6$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $98a3a6bf966aecb6$export$9522e17588c12572; }, function (v) { return $98a3a6bf966aecb6$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $98a3a6bf966aecb6$export$2110ac352bb060b9; }, function (v) { return $98a3a6bf966aecb6$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $98a3a6bf966aecb6$export$56885ab8b9c456ab; }, function (v) { return $98a3a6bf966aecb6$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $98a3a6bf966aecb6$export$d927fcb6adf8f9de; }, function (v) { return $98a3a6bf966aecb6$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $98a3a6bf966aecb6$export$b82d16f27459e05a; }, function (v) { return $98a3a6bf966aecb6$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $98a3a6bf966aecb6$export$522c17b4f5e123e8; }, function (v) { return $98a3a6bf966aecb6$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $98a3a6bf966aecb6$export$1aabd8a0274ecfd6; }, function (v) { return $98a3a6bf966aecb6$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $98a3a6bf966aecb6$export$9b621391a187a31a; }, function (v) { return $98a3a6bf966aecb6$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $98a3a6bf966aecb6$export$f5bbd400c2f4426f; }, function (v) { return $98a3a6bf966aecb6$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $98a3a6bf966aecb6$export$2b8d127b894957b9;
var $98a3a6bf966aecb6$export$cea3a54a6425200c;
var $98a3a6bf966aecb6$export$a7c73072b1a182ae;
var $98a3a6bf966aecb6$export$9f27bc3417b4524d;
var $98a3a6bf966aecb6$export$db77ccec0bb4ccac;
var $98a3a6bf966aecb6$export$8392c0c9d3dcbd35;
var $98a3a6bf966aecb6$export$ffb0004e005737fa;
var $98a3a6bf966aecb6$export$b624eff549462981;
var $98a3a6bf966aecb6$export$7897aa7841a5380c;
var $98a3a6bf966aecb6$export$602eac185826482c;
var $98a3a6bf966aecb6$export$e2c29f18771995cb;
var $98a3a6bf966aecb6$export$5f8d39834fd61797;
var $98a3a6bf966aecb6$export$74bf444e3cd11ea5;
var $98a3a6bf966aecb6$export$92387174baf9b227;
var $98a3a6bf966aecb6$export$ec112efeb987d9c6;
var $98a3a6bf966aecb6$export$b706b080d889d2c9;
var $98a3a6bf966aecb6$export$5be5a87408f70ddc;
var $98a3a6bf966aecb6$export$45a5e7f76e0caa8d;
var $98a3a6bf966aecb6$export$455c2e768291efa6;
var $98a3a6bf966aecb6$export$9522e17588c12572;
var $98a3a6bf966aecb6$export$2110ac352bb060b9;
var $98a3a6bf966aecb6$export$56885ab8b9c456ab;
var $98a3a6bf966aecb6$export$d927fcb6adf8f9de;
var $98a3a6bf966aecb6$export$b82d16f27459e05a;
var $98a3a6bf966aecb6$export$522c17b4f5e123e8;
var $98a3a6bf966aecb6$export$1aabd8a0274ecfd6;
var $98a3a6bf966aecb6$export$9b621391a187a31a;
var $98a3a6bf966aecb6$export$f5bbd400c2f4426f;
"use strict";
var $98a3a6bf966aecb6$var$b = "function" === typeof Symbol && Symbol.for, $98a3a6bf966aecb6$var$c = $98a3a6bf966aecb6$var$b ? Symbol.for("react.element") : 60103, $98a3a6bf966aecb6$var$d = $98a3a6bf966aecb6$var$b ? Symbol.for("react.portal") : 60106, $98a3a6bf966aecb6$var$e = $98a3a6bf966aecb6$var$b ? Symbol.for("react.fragment") : 60107, $98a3a6bf966aecb6$var$f = $98a3a6bf966aecb6$var$b ? Symbol.for("react.strict_mode") : 60108, $98a3a6bf966aecb6$var$g = $98a3a6bf966aecb6$var$b ? Symbol.for("react.profiler") : 60114, $98a3a6bf966aecb6$var$h = $98a3a6bf966aecb6$var$b ? Symbol.for("react.provider") : 60109, $98a3a6bf966aecb6$var$k = $98a3a6bf966aecb6$var$b ? Symbol.for("react.context") : 60110, $98a3a6bf966aecb6$var$l = $98a3a6bf966aecb6$var$b ? Symbol.for("react.async_mode") : 60111, $98a3a6bf966aecb6$var$m = $98a3a6bf966aecb6$var$b ? Symbol.for("react.concurrent_mode") : 60111, $98a3a6bf966aecb6$var$n = $98a3a6bf966aecb6$var$b ? Symbol.for("react.forward_ref") : 60112, $98a3a6bf966aecb6$var$p = $98a3a6bf966aecb6$var$b ? Symbol.for("react.suspense") : 60113, $98a3a6bf966aecb6$var$q = $98a3a6bf966aecb6$var$b ? Symbol.for("react.suspense_list") : 60120, $98a3a6bf966aecb6$var$r = $98a3a6bf966aecb6$var$b ? Symbol.for("react.memo") : 60115, $98a3a6bf966aecb6$var$t = $98a3a6bf966aecb6$var$b ? Symbol.for("react.lazy") : 60116, $98a3a6bf966aecb6$var$v = $98a3a6bf966aecb6$var$b ? Symbol.for("react.block") : 60121, $98a3a6bf966aecb6$var$w = $98a3a6bf966aecb6$var$b ? Symbol.for("react.fundamental") : 60117, $98a3a6bf966aecb6$var$x = $98a3a6bf966aecb6$var$b ? Symbol.for("react.responder") : 60118, $98a3a6bf966aecb6$var$y = $98a3a6bf966aecb6$var$b ? Symbol.for("react.scope") : 60119;
function $98a3a6bf966aecb6$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $98a3a6bf966aecb6$var$c:
                switch(a = a.type, a){
                    case $98a3a6bf966aecb6$var$l:
                    case $98a3a6bf966aecb6$var$m:
                    case $98a3a6bf966aecb6$var$e:
                    case $98a3a6bf966aecb6$var$g:
                    case $98a3a6bf966aecb6$var$f:
                    case $98a3a6bf966aecb6$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $98a3a6bf966aecb6$var$k:
                            case $98a3a6bf966aecb6$var$n:
                            case $98a3a6bf966aecb6$var$t:
                            case $98a3a6bf966aecb6$var$r:
                            case $98a3a6bf966aecb6$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $98a3a6bf966aecb6$var$d:
                return u;
        }
    }
}
function $98a3a6bf966aecb6$var$A(a) {
    return $98a3a6bf966aecb6$var$z(a) === $98a3a6bf966aecb6$var$m;
}
$98a3a6bf966aecb6$export$2b8d127b894957b9 = $98a3a6bf966aecb6$var$l;
$98a3a6bf966aecb6$export$cea3a54a6425200c = $98a3a6bf966aecb6$var$m;
$98a3a6bf966aecb6$export$a7c73072b1a182ae = $98a3a6bf966aecb6$var$k;
$98a3a6bf966aecb6$export$9f27bc3417b4524d = $98a3a6bf966aecb6$var$h;
$98a3a6bf966aecb6$export$db77ccec0bb4ccac = $98a3a6bf966aecb6$var$c;
$98a3a6bf966aecb6$export$8392c0c9d3dcbd35 = $98a3a6bf966aecb6$var$n;
$98a3a6bf966aecb6$export$ffb0004e005737fa = $98a3a6bf966aecb6$var$e;
$98a3a6bf966aecb6$export$b624eff549462981 = $98a3a6bf966aecb6$var$t;
$98a3a6bf966aecb6$export$7897aa7841a5380c = $98a3a6bf966aecb6$var$r;
$98a3a6bf966aecb6$export$602eac185826482c = $98a3a6bf966aecb6$var$d;
$98a3a6bf966aecb6$export$e2c29f18771995cb = $98a3a6bf966aecb6$var$g;
$98a3a6bf966aecb6$export$5f8d39834fd61797 = $98a3a6bf966aecb6$var$f;
$98a3a6bf966aecb6$export$74bf444e3cd11ea5 = $98a3a6bf966aecb6$var$p;
$98a3a6bf966aecb6$export$92387174baf9b227 = function(a) {
    return $98a3a6bf966aecb6$var$A(a) || $98a3a6bf966aecb6$var$z(a) === $98a3a6bf966aecb6$var$l;
};
$98a3a6bf966aecb6$export$ec112efeb987d9c6 = $98a3a6bf966aecb6$var$A;
$98a3a6bf966aecb6$export$b706b080d889d2c9 = function(a) {
    return $98a3a6bf966aecb6$var$z(a) === $98a3a6bf966aecb6$var$k;
};
$98a3a6bf966aecb6$export$5be5a87408f70ddc = function(a) {
    return $98a3a6bf966aecb6$var$z(a) === $98a3a6bf966aecb6$var$h;
};
$98a3a6bf966aecb6$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $98a3a6bf966aecb6$var$c;
};
$98a3a6bf966aecb6$export$455c2e768291efa6 = function(a) {
    return $98a3a6bf966aecb6$var$z(a) === $98a3a6bf966aecb6$var$n;
};
$98a3a6bf966aecb6$export$9522e17588c12572 = function(a) {
    return $98a3a6bf966aecb6$var$z(a) === $98a3a6bf966aecb6$var$e;
};
$98a3a6bf966aecb6$export$2110ac352bb060b9 = function(a) {
    return $98a3a6bf966aecb6$var$z(a) === $98a3a6bf966aecb6$var$t;
};
$98a3a6bf966aecb6$export$56885ab8b9c456ab = function(a) {
    return $98a3a6bf966aecb6$var$z(a) === $98a3a6bf966aecb6$var$r;
};
$98a3a6bf966aecb6$export$d927fcb6adf8f9de = function(a) {
    return $98a3a6bf966aecb6$var$z(a) === $98a3a6bf966aecb6$var$d;
};
$98a3a6bf966aecb6$export$b82d16f27459e05a = function(a) {
    return $98a3a6bf966aecb6$var$z(a) === $98a3a6bf966aecb6$var$g;
};
$98a3a6bf966aecb6$export$522c17b4f5e123e8 = function(a) {
    return $98a3a6bf966aecb6$var$z(a) === $98a3a6bf966aecb6$var$f;
};
$98a3a6bf966aecb6$export$1aabd8a0274ecfd6 = function(a) {
    return $98a3a6bf966aecb6$var$z(a) === $98a3a6bf966aecb6$var$p;
};
$98a3a6bf966aecb6$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $98a3a6bf966aecb6$var$e || a === $98a3a6bf966aecb6$var$m || a === $98a3a6bf966aecb6$var$g || a === $98a3a6bf966aecb6$var$f || a === $98a3a6bf966aecb6$var$p || a === $98a3a6bf966aecb6$var$q || "object" === typeof a && null !== a && (a.$$typeof === $98a3a6bf966aecb6$var$t || a.$$typeof === $98a3a6bf966aecb6$var$r || a.$$typeof === $98a3a6bf966aecb6$var$h || a.$$typeof === $98a3a6bf966aecb6$var$k || a.$$typeof === $98a3a6bf966aecb6$var$n || a.$$typeof === $98a3a6bf966aecb6$var$w || a.$$typeof === $98a3a6bf966aecb6$var$x || a.$$typeof === $98a3a6bf966aecb6$var$y || a.$$typeof === $98a3a6bf966aecb6$var$v);
};
$98a3a6bf966aecb6$export$f5bbd400c2f4426f = $98a3a6bf966aecb6$var$z;

});

parcelRegister("594Hr", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("gmb7d"));

});
parcelRegister("gmb7d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function get() {
        return $be8752b2ec728912$var$_tickFormat.default;
    }
});

var $be8752b2ec728912$var$_band = $be8752b2ec728912$var$_interopRequireWildcard((parcelRequire("1bH18")));

var $be8752b2ec728912$var$_identity = $be8752b2ec728912$var$_interopRequireDefault((parcelRequire("eZ3Rm")));

var $be8752b2ec728912$var$_linear = $be8752b2ec728912$var$_interopRequireDefault((parcelRequire("1SvFl")));

var $be8752b2ec728912$var$_log = $be8752b2ec728912$var$_interopRequireDefault((parcelRequire("eBnvE")));

var $be8752b2ec728912$var$_symlog = $be8752b2ec728912$var$_interopRequireDefault((parcelRequire("4ICux")));

var $be8752b2ec728912$var$_ordinal = $be8752b2ec728912$var$_interopRequireWildcard((parcelRequire("6imYJ")));

var $be8752b2ec728912$var$_pow = $be8752b2ec728912$var$_interopRequireWildcard((parcelRequire("lI3XK")));

var $be8752b2ec728912$var$_radial = $be8752b2ec728912$var$_interopRequireDefault((parcelRequire("gcJ4Q")));

var $be8752b2ec728912$var$_quantile = $be8752b2ec728912$var$_interopRequireDefault((parcelRequire("gTbYn")));

var $be8752b2ec728912$var$_quantize = $be8752b2ec728912$var$_interopRequireDefault((parcelRequire("lrF6Z")));

var $be8752b2ec728912$var$_threshold = $be8752b2ec728912$var$_interopRequireDefault((parcelRequire("e1zMZ")));

var $be8752b2ec728912$var$_time = $be8752b2ec728912$var$_interopRequireDefault((parcelRequire("haq1g")));

var $be8752b2ec728912$var$_utcTime = $be8752b2ec728912$var$_interopRequireDefault((parcelRequire("ekxRg")));

var $be8752b2ec728912$var$_sequential = $be8752b2ec728912$var$_interopRequireWildcard((parcelRequire("fTMSh")));

var $be8752b2ec728912$var$_sequentialQuantile = $be8752b2ec728912$var$_interopRequireDefault((parcelRequire("ka59Q")));

var $be8752b2ec728912$var$_diverging = $be8752b2ec728912$var$_interopRequireWildcard((parcelRequire("bqYJr")));

var $be8752b2ec728912$var$_tickFormat = $be8752b2ec728912$var$_interopRequireDefault((parcelRequire("2JZui")));
function $be8752b2ec728912$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $be8752b2ec728912$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($be8752b2ec728912$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $be8752b2ec728912$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $be8752b2ec728912$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("1bH18", function(module, exports) {

var $52tJv = parcelRequire("52tJv");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0dd82fd93ac73d35$var$band;
module.exports.point = $0dd82fd93ac73d35$var$point;

var $72vjU = parcelRequire("72vjU");

var $8hPfX = parcelRequire("8hPfX");

var $0dd82fd93ac73d35$var$_ordinal = $0dd82fd93ac73d35$var$_interopRequireDefault((parcelRequire("6imYJ")));
function $0dd82fd93ac73d35$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0dd82fd93ac73d35$var$band() {
    var scale = (0, $0dd82fd93ac73d35$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $72vjU.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        var ref;
        return arguments.length ? (ref = (0, $52tJv._)(_, 2), r0 = ref[0], r1 = ref[1], ref, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        var ref;
        return ref = (0, $52tJv._)(_, 2), r0 = ref[0], r1 = ref[1], ref, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $0dd82fd93ac73d35$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $8hPfX.initRange.apply(rescale(), arguments);
}
function $0dd82fd93ac73d35$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $0dd82fd93ac73d35$var$pointish(copy());
    };
    return scale;
}
function $0dd82fd93ac73d35$var$point() {
    return $0dd82fd93ac73d35$var$pointish($0dd82fd93ac73d35$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("72vjU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function get() {
        return $7z6ny.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function get() {
        return $81BTs.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function get() {
        return $81BTs.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function get() {
        return $7z6ny.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function get() {
        return $7z6ny.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function get() {
        return $520103d7f763900f$var$_zip.default;
    }
});

var $520103d7f763900f$var$_bisect = $520103d7f763900f$var$_interopRequireWildcard((parcelRequire("7Ia9v")));

var $520103d7f763900f$var$_ascending = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("aQaec")));

var $520103d7f763900f$var$_bisector = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("gCJVr")));

var $520103d7f763900f$var$_count = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("5WJxK")));

var $520103d7f763900f$var$_cross = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("58CwD")));

var $520103d7f763900f$var$_cumsum = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("6MI0C")));

var $520103d7f763900f$var$_descending = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("3u2Cp")));

var $520103d7f763900f$var$_deviation = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("1smaL")));

var $520103d7f763900f$var$_extent = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("a8PeL")));

var $7z6ny = parcelRequire("7z6ny");

var $520103d7f763900f$var$_group = $520103d7f763900f$var$_interopRequireWildcard((parcelRequire("5fSQ7")));

var $520103d7f763900f$var$_groupSort = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("4XorV")));

var $520103d7f763900f$var$_bin = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("h46ew")));

var $520103d7f763900f$var$_freedmanDiaconis = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("816GN")));

var $520103d7f763900f$var$_scott = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("dvggK")));

var $520103d7f763900f$var$_sturges = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("7dPr1")));

var $520103d7f763900f$var$_max = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("anCyz")));

var $520103d7f763900f$var$_maxIndex = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("hKr2x")));

var $520103d7f763900f$var$_mean = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("bTlSY")));

var $520103d7f763900f$var$_median = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("fDqWQ")));

var $520103d7f763900f$var$_merge = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("cs4Il")));

var $520103d7f763900f$var$_min = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("2n3sL")));

var $520103d7f763900f$var$_minIndex = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("dJtdn")));

var $520103d7f763900f$var$_mode = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("gbecX")));

var $520103d7f763900f$var$_nice = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("trPC2")));

var $520103d7f763900f$var$_pairs = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("3NNdD")));

var $520103d7f763900f$var$_permute = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("ViilF")));

var $520103d7f763900f$var$_quantile = $520103d7f763900f$var$_interopRequireWildcard((parcelRequire("af26y")));

var $520103d7f763900f$var$_quickselect = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("gpJDL")));

var $520103d7f763900f$var$_range = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("fgzYn")));

var $520103d7f763900f$var$_rank = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("kDa8Y")));

var $520103d7f763900f$var$_least = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("lTZjQ")));

var $520103d7f763900f$var$_leastIndex = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("8jimV")));

var $520103d7f763900f$var$_greatest = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("2cNLv")));

var $520103d7f763900f$var$_greatestIndex = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("k5ugZ")));

var $520103d7f763900f$var$_scan = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("9RxpX")));

var $520103d7f763900f$var$_shuffle = $520103d7f763900f$var$_interopRequireWildcard((parcelRequire("lMuaT")));

var $520103d7f763900f$var$_sum = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("ce6q4")));

var $520103d7f763900f$var$_ticks = $520103d7f763900f$var$_interopRequireWildcard((parcelRequire("k9n6n")));

var $520103d7f763900f$var$_transpose = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("8Dkte")));

var $520103d7f763900f$var$_variance = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("2xScS")));

var $520103d7f763900f$var$_zip = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("kJU1u")));

var $520103d7f763900f$var$_every = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("jiVWa")));

var $520103d7f763900f$var$_some = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("5qFpg")));

var $520103d7f763900f$var$_filter = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("dAu7f")));

var $520103d7f763900f$var$_map = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("ad67u")));

var $520103d7f763900f$var$_reduce = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("jJwz1")));

var $520103d7f763900f$var$_reverse = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("b921N")));

var $520103d7f763900f$var$_sort = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("kAuUN")));

var $520103d7f763900f$var$_difference = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("fMu0j")));

var $520103d7f763900f$var$_disjoint = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("gaoam")));

var $520103d7f763900f$var$_intersection = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("76gij")));

var $520103d7f763900f$var$_subset = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("8kN2B")));

var $520103d7f763900f$var$_superset = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("aU4yc")));

var $520103d7f763900f$var$_union = $520103d7f763900f$var$_interopRequireDefault((parcelRequire("7jwqO")));

var $81BTs = parcelRequire("81BTs");
function $520103d7f763900f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $520103d7f763900f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($520103d7f763900f$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $520103d7f763900f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $520103d7f763900f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("7Ia9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $59d4847c6a3fc0f7$var$_ascending = $59d4847c6a3fc0f7$var$_interopRequireDefault((parcelRequire("aQaec")));

var $59d4847c6a3fc0f7$var$_bisector = $59d4847c6a3fc0f7$var$_interopRequireDefault((parcelRequire("gCJVr")));

var $59d4847c6a3fc0f7$var$_number = $59d4847c6a3fc0f7$var$_interopRequireDefault((parcelRequire("8NAqG")));
function $59d4847c6a3fc0f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $59d4847c6a3fc0f7$var$ascendingBisect = (0, $59d4847c6a3fc0f7$var$_bisector.default)($59d4847c6a3fc0f7$var$_ascending.default);
var $59d4847c6a3fc0f7$var$bisectRight = $59d4847c6a3fc0f7$var$ascendingBisect.right;
module.exports.bisectRight = $59d4847c6a3fc0f7$var$bisectRight;
var $59d4847c6a3fc0f7$var$bisectLeft = $59d4847c6a3fc0f7$var$ascendingBisect.left;
module.exports.bisectLeft = $59d4847c6a3fc0f7$var$bisectLeft;
var $59d4847c6a3fc0f7$var$bisectCenter = (0, $59d4847c6a3fc0f7$var$_bisector.default)($59d4847c6a3fc0f7$var$_number.default).center;
module.exports.bisectCenter = $59d4847c6a3fc0f7$var$bisectCenter;
var $59d4847c6a3fc0f7$var$_default = $59d4847c6a3fc0f7$var$bisectRight;
module.exports.default = $59d4847c6a3fc0f7$var$_default;

});
parcelRegister("aQaec", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e46b1c94c657483$var$ascending;
function $7e46b1c94c657483$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("gCJVr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c1a3d1cee225cdd9$var$bisector;

var $c1a3d1cee225cdd9$var$_ascending = $c1a3d1cee225cdd9$var$_interopRequireDefault((parcelRequire("aQaec")));

var $c1a3d1cee225cdd9$var$_descending = $c1a3d1cee225cdd9$var$_interopRequireDefault((parcelRequire("3u2Cp")));
function $c1a3d1cee225cdd9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c1a3d1cee225cdd9$var$bisector(f) {
    var compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $c1a3d1cee225cdd9$var$_ascending.default;
        compare2 = function(d, x) {
            return (0, $c1a3d1cee225cdd9$var$_ascending.default)(f(d), x);
        };
        delta = function(d, x) {
            return f(d) - x;
        };
    } else {
        compare1 = f === $c1a3d1cee225cdd9$var$_ascending.default || f === $c1a3d1cee225cdd9$var$_descending.default ? f : $c1a3d1cee225cdd9$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x) {
        var lo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, hi = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : a.length;
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                var mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x) {
        var lo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, hi = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : a.length;
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                var mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x) {
        var lo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, hi = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : a.length;
        var i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $c1a3d1cee225cdd9$var$zero() {
    return 0;
}

});
parcelRegister("3u2Cp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2896346cc00b6708$var$descending;
function $2896346cc00b6708$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("8NAqG", function(module, exports) {

var $ajhIL = parcelRequire("ajhIL");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $667f287373fda7dd$var$number;
module.exports.numbers = $667f287373fda7dd$var$numbers;
function $667f287373fda7dd$var$number(x) {
    return x === null ? NaN : +x;
}
function $667f287373fda7dd$var$numbers(values, valueof) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, value, err, index, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, value1, err;
    return (0, $ajhIL.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!(valueof === undefined)) return [
                    3,
                    9
                ];
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = values[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                value = _step.value;
                if (!(value != null && (value = +value) >= value)) return [
                    3,
                    4
                ];
                return [
                    4,
                    value
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                return [
                    3,
                    17
                ];
            case 9:
                index = -1;
                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                _state.label = 10;
            case 10:
                _state.trys.push([
                    10,
                    15,
                    16,
                    17
                ]);
                _iterator1 = values[Symbol.iterator]();
                _state.label = 11;
            case 11:
                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                    3,
                    14
                ];
                value1 = _step1.value;
                if (!((value1 = valueof(value1, ++index, values)) != null && (value1 = +value1) >= value1)) return [
                    3,
                    13
                ];
                return [
                    4,
                    value1
                ];
            case 12:
                _state.sent();
                _state.label = 13;
            case 13:
                _iteratorNormalCompletion1 = true;
                return [
                    3,
                    11
                ];
            case 14:
                return [
                    3,
                    17
                ];
            case 15:
                err = _state.sent();
                _didIteratorError1 = true;
                _iteratorError1 = err;
                return [
                    3,
                    17
                ];
            case 16:
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
                return [
                    7
                ];
            case 17:
                return [
                    2
                ];
        }
    });
}

});


parcelRegister("5WJxK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4545b27ec2c47f67$var$count;
function $4545b27ec2c47f67$var$count(values, valueof) {
    var _$count = 0;
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value != null && (value = +value) >= value) ++_$count;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && (value1 = +value1) >= value1) ++_$count;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return _$count;
}

});

parcelRegister("58CwD", function(module, exports) {

var $fyztb = parcelRequire("fyztb");

var $l6pW7 = parcelRequire("l6pW7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3bdb956df737eb2d$var$cross;
function $3bdb956df737eb2d$var$length(array) {
    return array.length | 0;
}
function $3bdb956df737eb2d$var$empty(length) {
    return !(length > 0);
}
function $3bdb956df737eb2d$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $3bdb956df737eb2d$var$reducer(reduce) {
    return function(values) {
        return reduce.apply(void 0, (0, $fyztb._)(values));
    };
}
function $3bdb956df737eb2d$var$cross() {
    var _loop = function() {
        product.push(index.map(function(j, i) {
            return values[i][j];
        }));
        var i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return {
                v: reduce ? product.map(reduce) : product
            };
            index[i--] = 0;
        }
    };
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++){
        values[_key] = arguments[_key];
    }
    var reduce = typeof values[values.length - 1] === "function" && $3bdb956df737eb2d$var$reducer(values.pop());
    values = values.map($3bdb956df737eb2d$var$arrayify);
    var lengths = values.map($3bdb956df737eb2d$var$length);
    var j = values.length - 1;
    var index = new Array(j + 1).fill(0);
    var product = [];
    if (j < 0 || lengths.some($3bdb956df737eb2d$var$empty)) return product;
    while(true){
        var _ret = _loop();
        if ((0, $l6pW7._)(_ret) === "object") return _ret.v;
    }
}

});

parcelRegister("6MI0C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4f095d05446355a0$var$cumsum;
function $4f095d05446355a0$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? function(v) {
        return sum += +v || 0;
    } : function(v) {
        return sum += +valueof(v, index++, values) || 0;
    });
}

});

parcelRegister("1smaL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $10f99aff8ee6b2f4$var$deviation;

var $10f99aff8ee6b2f4$var$_variance = $10f99aff8ee6b2f4$var$_interopRequireDefault((parcelRequire("2xScS")));
function $10f99aff8ee6b2f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $10f99aff8ee6b2f4$var$deviation(values, valueof) {
    var v = (0, $10f99aff8ee6b2f4$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("2xScS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1da8b6262f54fde1$var$variance;
function $1da8b6262f54fde1$var$variance(values, valueof) {
    var count = 0;
    var delta;
    var mean = 0;
    var sum = 0;
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value != null && (value = +value) >= value) {
                    delta = value - mean;
                    mean += delta / ++count;
                    sum += delta * (value - mean);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && (value1 = +value1) >= value1) {
                    delta = value1 - mean;
                    mean += delta / ++count;
                    sum += delta * (value1 - mean);
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("a8PeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7622655f6081b9a2$var$extent;
function $7622655f6081b9a2$var$extent(values, valueof) {
    var min;
    var max;
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value != null) {
                    if (min === undefined) {
                        if (value >= value) min = max = value;
                    } else {
                        if (min > value) min = value;
                        if (max < value) max = value;
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null) {
                    if (min === undefined) {
                        if (value1 >= value1) min = max = value1;
                    } else {
                        if (min > value1) min = value1;
                        if (max < value1) max = value1;
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("7z6ny", function(module, exports) {

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $5820c0062034c44f$var$fcumsum;
module.exports.fsum = $5820c0062034c44f$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
var $5820c0062034c44f$var$Adder = /*#__PURE__*/ function() {
    function Adder() {
        (0, $5sFFs._)(this, Adder);
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    (0, $8O2fV._)(Adder, [
        {
            key: "add",
            value: function add(x) {
                var p = this._partials;
                var i = 0;
                for(var j = 0; j < this._n && j < 32; j++){
                    var y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
                    if (lo) p[i++] = lo;
                    x = hi;
                }
                p[i] = x;
                this._n = i + 1;
                return this;
            }
        },
        {
            key: "valueOf",
            value: function valueOf() {
                var p = this._partials;
                var n = this._n, x, y, lo, hi = 0;
                if (n > 0) {
                    hi = p[--n];
                    while(n > 0){
                        x = hi;
                        y = p[--n];
                        hi = x + y;
                        lo = y - (hi - x);
                        if (lo) break;
                    }
                    if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                        y = lo * 2;
                        x = hi + y;
                        if (y == x - hi) hi = x;
                    }
                }
                return hi;
            }
        }
    ]);
    return Adder;
}();
module.exports.Adder = $5820c0062034c44f$var$Adder;
function $5820c0062034c44f$var$fsum(values, valueof) {
    var adder = new $5820c0062034c44f$var$Adder();
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value = +value) adder.add(value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if (value1 = +valueof(value1, ++index, values)) adder.add(value1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return +adder;
}
function $5820c0062034c44f$var$fcumsum(values, valueof) {
    var adder = new $5820c0062034c44f$var$Adder();
    var index = -1;
    return Float64Array.from(values, valueof === undefined ? function(v) {
        return adder.add(+v || 0);
    } : function(v) {
        return adder.add(+valueof(v, ++index, values) || 0);
    });
}

});

parcelRegister("5fSQ7", function(module, exports) {

var $52tJv = parcelRequire("52tJv");

var $fyztb = parcelRequire("fyztb");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3d38e47e146f01d4$var$group;
module.exports.flatGroup = $3d38e47e146f01d4$var$flatGroup;
module.exports.flatRollup = $3d38e47e146f01d4$var$flatRollup;
module.exports.groups = $3d38e47e146f01d4$var$groups;
module.exports.index = $3d38e47e146f01d4$var$index;
module.exports.indexes = $3d38e47e146f01d4$var$indexes;
module.exports.rollup = $3d38e47e146f01d4$var$rollup;
module.exports.rollups = $3d38e47e146f01d4$var$rollups;

var $81BTs = parcelRequire("81BTs");

var $3d38e47e146f01d4$var$_identity = $3d38e47e146f01d4$var$_interopRequireDefault((parcelRequire("8pqxw")));
function $3d38e47e146f01d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3d38e47e146f01d4$var$group(values) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    return $3d38e47e146f01d4$var$nest(values, $3d38e47e146f01d4$var$_identity.default, $3d38e47e146f01d4$var$_identity.default, keys);
}
function $3d38e47e146f01d4$var$groups(values) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    return $3d38e47e146f01d4$var$nest(values, Array.from, $3d38e47e146f01d4$var$_identity.default, keys);
}
function $3d38e47e146f01d4$var$flatten(groups, keys) {
    for(var i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap(function(g) {
        return g.pop().map(function(param) {
            var _param = (0, $52tJv._)(param, 2), key = _param[0], value = _param[1];
            return (0, $fyztb._)(g).concat([
                key,
                value
            ]);
        });
    });
    return groups;
}
function $3d38e47e146f01d4$var$flatGroup(values) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    return $3d38e47e146f01d4$var$flatten($3d38e47e146f01d4$var$groups.apply(void 0, [
        values
    ].concat((0, $fyztb._)(keys))), keys);
}
function $3d38e47e146f01d4$var$flatRollup(values, reduce) {
    for(var _len = arguments.length, keys = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        keys[_key - 2] = arguments[_key];
    }
    return $3d38e47e146f01d4$var$flatten($3d38e47e146f01d4$var$rollups.apply(void 0, [
        values,
        reduce
    ].concat((0, $fyztb._)(keys))), keys);
}
function $3d38e47e146f01d4$var$rollup(values, reduce) {
    for(var _len = arguments.length, keys = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        keys[_key - 2] = arguments[_key];
    }
    return $3d38e47e146f01d4$var$nest(values, $3d38e47e146f01d4$var$_identity.default, reduce, keys);
}
function $3d38e47e146f01d4$var$rollups(values, reduce) {
    for(var _len = arguments.length, keys = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        keys[_key - 2] = arguments[_key];
    }
    return $3d38e47e146f01d4$var$nest(values, Array.from, reduce, keys);
}
function $3d38e47e146f01d4$var$index(values) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    return $3d38e47e146f01d4$var$nest(values, $3d38e47e146f01d4$var$_identity.default, $3d38e47e146f01d4$var$unique, keys);
}
function $3d38e47e146f01d4$var$indexes(values) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    return $3d38e47e146f01d4$var$nest(values, Array.from, $3d38e47e146f01d4$var$unique, keys);
}
function $3d38e47e146f01d4$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $3d38e47e146f01d4$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        var _$groups = new $81BTs.InternMap();
        var keyof = keys[i++];
        var _$index = -1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                var key = keyof(value, ++_$index, values);
                var _$group = _$groups.get(key);
                if (_$group) _$group.push(value);
                else _$groups.set(key, [
                    value
                ]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = _$groups[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value = (0, $52tJv._)(_step1.value, 2), key1 = _step_value[0], _$values = _step_value[1];
                _$groups.set(key1, regroup(_$values, i));
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return map(_$groups);
    }(values, 0);
}

});
parcelRegister("81BTs", function(module, exports) {

var $lyFcw = parcelRequire("lyFcw");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $52tJv = parcelRequire("52tJv");

var $aBSBL = parcelRequire("aBSBL");

var $4jYWU = parcelRequire("4jYWU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
var $5d7bcf9084db6503$var$InternMap = /*#__PURE__*/ function(Map1) {
    (0, $kcqLc._)(InternMap, Map1);
    var _super = (0, $4jYWU._)(InternMap);
    function InternMap(entries) {
        var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5d7bcf9084db6503$var$keyof;
        (0, $5sFFs._)(this, InternMap);
        var _this;
        _this = _super.call(this);
        Object.defineProperties((0, $lyFcw._)(_this), {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (entries != null) try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $52tJv._)(_step.value, 2), key1 = _step_value[0], value = _step_value[1];
                _this.set(key1, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    (0, $8O2fV._)(InternMap, [
        {
            key: "get",
            value: function get(key) {
                return (0, $404BM._)((0, $cEF31._)(InternMap.prototype), "get", this).call(this, $5d7bcf9084db6503$var$intern_get(this, key));
            }
        },
        {
            key: "has",
            value: function has(key) {
                return (0, $404BM._)((0, $cEF31._)(InternMap.prototype), "has", this).call(this, $5d7bcf9084db6503$var$intern_get(this, key));
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                return (0, $404BM._)((0, $cEF31._)(InternMap.prototype), "set", this).call(this, $5d7bcf9084db6503$var$intern_set(this, key), value);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                return (0, $404BM._)((0, $cEF31._)(InternMap.prototype), "delete", this).call(this, $5d7bcf9084db6503$var$intern_delete(this, key));
            }
        }
    ]);
    return InternMap;
}((0, $aBSBL._)(Map));
module.exports.InternMap = $5d7bcf9084db6503$var$InternMap;
var $5d7bcf9084db6503$var$InternSet = /*#__PURE__*/ function(Set1) {
    (0, $kcqLc._)(InternSet, Set1);
    var _super = (0, $4jYWU._)(InternSet);
    function InternSet(values) {
        var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5d7bcf9084db6503$var$keyof;
        (0, $5sFFs._)(this, InternSet);
        var _this;
        _this = _super.call(this);
        Object.defineProperties((0, $lyFcw._)(_this), {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (values != null) try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                _this.add(value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    (0, $8O2fV._)(InternSet, [
        {
            key: "has",
            value: function has(value) {
                return (0, $404BM._)((0, $cEF31._)(InternSet.prototype), "has", this).call(this, $5d7bcf9084db6503$var$intern_get(this, value));
            }
        },
        {
            key: "add",
            value: function add(value) {
                return (0, $404BM._)((0, $cEF31._)(InternSet.prototype), "add", this).call(this, $5d7bcf9084db6503$var$intern_set(this, value));
            }
        },
        {
            key: "delete",
            value: function _delete(value) {
                return (0, $404BM._)((0, $cEF31._)(InternSet.prototype), "delete", this).call(this, $5d7bcf9084db6503$var$intern_delete(this, value));
            }
        }
    ]);
    return InternSet;
}((0, $aBSBL._)(Set));
module.exports.InternSet = $5d7bcf9084db6503$var$InternSet;
function $5d7bcf9084db6503$var$intern_get(param, value) {
    var _intern = param._intern, _key = param._key;
    var key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $5d7bcf9084db6503$var$intern_set(param, value) {
    var _intern = param._intern, _key = param._key;
    var key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $5d7bcf9084db6503$var$intern_delete(param, value) {
    var _intern = param._intern, _key = param._key;
    var key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $5d7bcf9084db6503$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});
parcelRegister("aBSBL", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7b97b81a34abf055$export$2466d533fda16e33; });

var $amGNX = parcelRequire("amGNX");

var $cEF31 = parcelRequire("cEF31");

var $jhn2J = parcelRequire("jhn2J");

var $e0tMp = parcelRequire("e0tMp");
function $7b97b81a34abf055$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $7b97b81a34abf055$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $jhn2J._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $amGNX._construct)(Class, arguments, (0, $cEF31._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $e0tMp._set_prototype_of)(Wrapper, Class);
    };
    return $7b97b81a34abf055$export$2466d533fda16e33(Class);
}

});
parcelRegister("amGNX", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $78bd2990fbc66772$export$2d841144c5f8c4ab; });
$parcel$export(module.exports, "_", function () { return $78bd2990fbc66772$export$2d841144c5f8c4ab; });

var $8N1lA = parcelRequire("8N1lA");

var $e0tMp = parcelRequire("e0tMp");
function $78bd2990fbc66772$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $8N1lA._is_native_reflect_construct)()) $78bd2990fbc66772$export$2d841144c5f8c4ab = Reflect.construct;
    else $78bd2990fbc66772$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $e0tMp._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $78bd2990fbc66772$export$2d841144c5f8c4ab.apply(null, arguments);
}

});

parcelRegister("jhn2J", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $e0917ab586116de8$export$514eda94019f4334; });
function $e0917ab586116de8$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});



parcelRegister("8pqxw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $61f53ec5ae363d4a$var$identity;
function $61f53ec5ae363d4a$var$identity(x) {
    return x;
}

});


parcelRegister("4XorV", function(module, exports) {

var $52tJv = parcelRequire("52tJv");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $39bfa346f83b89b2$var$groupSort;

var $39bfa346f83b89b2$var$_ascending = $39bfa346f83b89b2$var$_interopRequireDefault((parcelRequire("aQaec")));

var $39bfa346f83b89b2$var$_group = $39bfa346f83b89b2$var$_interopRequireWildcard((parcelRequire("5fSQ7")));

var $39bfa346f83b89b2$var$_sort = $39bfa346f83b89b2$var$_interopRequireDefault((parcelRequire("kAuUN")));
function $39bfa346f83b89b2$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($39bfa346f83b89b2$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $39bfa346f83b89b2$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $39bfa346f83b89b2$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $39bfa346f83b89b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $39bfa346f83b89b2$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $39bfa346f83b89b2$var$_sort.default)((0, $39bfa346f83b89b2$var$_group.rollup)(values, reduce, key), function(param, param1) {
        var _param = (0, $52tJv._)(param, 2), ak = _param[0], av = _param[1], _param1 = (0, $52tJv._)(param1, 2), bk = _param1[0], bv = _param1[1];
        return (0, $39bfa346f83b89b2$var$_ascending.default)(av, bv) || (0, $39bfa346f83b89b2$var$_ascending.default)(ak, bk);
    }) : (0, $39bfa346f83b89b2$var$_sort.default)((0, $39bfa346f83b89b2$var$_group.default)(values, key), function(param, param1) {
        var _param = (0, $52tJv._)(param, 2), ak = _param[0], av = _param[1], _param1 = (0, $52tJv._)(param1, 2), bk = _param1[0], bv = _param1[1];
        return reduce(av, bv) || (0, $39bfa346f83b89b2$var$_ascending.default)(ak, bk);
    })).map(function(param) {
        var _param = (0, $52tJv._)(param, 1), _$key = _param[0];
        return _$key;
    });
}

});
parcelRegister("kAuUN", function(module, exports) {

var $52tJv = parcelRequire("52tJv");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $efcf2684c9fa084c$var$ascendingDefined;
module.exports.compareDefined = $efcf2684c9fa084c$var$compareDefined;
module.exports.default = $efcf2684c9fa084c$var$sort;

var $efcf2684c9fa084c$var$_ascending = $efcf2684c9fa084c$var$_interopRequireDefault((parcelRequire("aQaec")));

var $efcf2684c9fa084c$var$_permute = $efcf2684c9fa084c$var$_interopRequireDefault((parcelRequire("ViilF")));
function $efcf2684c9fa084c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $efcf2684c9fa084c$var$sort(values) {
    for(var _len = arguments.length, F = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        F[_key - 1] = arguments[_key];
    }
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    var _F = (0, $52tJv._)(F, 1), f = _F[0];
    if (f && f.length !== 2 || F.length > 1) {
        var index = Uint32Array.from(values, function(d, i) {
            return i;
        });
        if (F.length > 1) {
            F = F.map(function(f) {
                return values.map(f);
            });
            index.sort(function(i, j) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = F[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var f = _step.value;
                        var c = $efcf2684c9fa084c$var$ascendingDefined(f[i], f[j]);
                        if (c) return c;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        } else {
            f = values.map(f);
            index.sort(function(i, j) {
                return $efcf2684c9fa084c$var$ascendingDefined(f[i], f[j]);
            });
        }
        return (0, $efcf2684c9fa084c$var$_permute.default)(values, index);
    }
    return values.sort($efcf2684c9fa084c$var$compareDefined(f));
}
function $efcf2684c9fa084c$var$compareDefined() {
    var compare = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $efcf2684c9fa084c$var$_ascending.default;
    if (compare === $efcf2684c9fa084c$var$_ascending.default) return $efcf2684c9fa084c$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return function(a, b) {
        var x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $efcf2684c9fa084c$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("ViilF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0ac383fb13cd4df7$var$permute;
function $0ac383fb13cd4df7$var$permute(source, keys) {
    return Array.from(keys, function(key) {
        return source[key];
    });
}

});



parcelRegister("h46ew", function(module, exports) {

var $52tJv = parcelRequire("52tJv");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c6c7a5301f11e8fe$var$bin;

var $g1ZJ5 = parcelRequire("g1ZJ5");

var $c6c7a5301f11e8fe$var$_bisect = $c6c7a5301f11e8fe$var$_interopRequireDefault((parcelRequire("7Ia9v")));

var $c6c7a5301f11e8fe$var$_constant = $c6c7a5301f11e8fe$var$_interopRequireDefault((parcelRequire("ikZTq")));

var $c6c7a5301f11e8fe$var$_extent = $c6c7a5301f11e8fe$var$_interopRequireDefault((parcelRequire("a8PeL")));

var $c6c7a5301f11e8fe$var$_identity = $c6c7a5301f11e8fe$var$_interopRequireDefault((parcelRequire("8pqxw")));

var $c6c7a5301f11e8fe$var$_nice = $c6c7a5301f11e8fe$var$_interopRequireDefault((parcelRequire("trPC2")));

var $c6c7a5301f11e8fe$var$_ticks = $c6c7a5301f11e8fe$var$_interopRequireWildcard((parcelRequire("k9n6n")));

var $c6c7a5301f11e8fe$var$_sturges = $c6c7a5301f11e8fe$var$_interopRequireDefault((parcelRequire("7dPr1")));
function $c6c7a5301f11e8fe$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c6c7a5301f11e8fe$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c6c7a5301f11e8fe$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c6c7a5301f11e8fe$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c6c7a5301f11e8fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c6c7a5301f11e8fe$var$bin() {
    var value = $c6c7a5301f11e8fe$var$_identity.default, domain = $c6c7a5301f11e8fe$var$_extent.default, threshold = $c6c7a5301f11e8fe$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            var max = x1, tn = +tz;
            var ref;
            if (domain === $c6c7a5301f11e8fe$var$_extent.default) ref = (0, $52tJv._)((0, $c6c7a5301f11e8fe$var$_nice.default)(x0, x1, tn), 2), x0 = ref[0], x1 = ref[1], ref;
            tz = (0, $c6c7a5301f11e8fe$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $c6c7a5301f11e8fe$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $c6c7a5301f11e8fe$var$_extent.default) {
                    var step1 = (0, $c6c7a5301f11e8fe$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step1)) {
                        if (step1 > 0) x1 = (Math.floor(x1 / step1) + 1) * step1;
                        else if (step1 < 0) x1 = (Math.ceil(x1 * -step1) + 1) / -step1;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), _$bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            _$bin = bins[i] = [];
            _$bin.x0 = i > 0 ? tz[i - 1] : x0;
            _$bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    var j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $c6c7a5301f11e8fe$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $c6c7a5301f11e8fe$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $c6c7a5301f11e8fe$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $c6c7a5301f11e8fe$var$_constant.default)($g1ZJ5.slice.call(_)) : (0, $c6c7a5301f11e8fe$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("g1ZJ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $babc9edd415b971f$var$array = Array.prototype;
var $babc9edd415b971f$var$slice = $babc9edd415b971f$var$array.slice;
module.exports.slice = $babc9edd415b971f$var$slice;
var $babc9edd415b971f$var$map = $babc9edd415b971f$var$array.map;
module.exports.map = $babc9edd415b971f$var$map;

});

parcelRegister("ikZTq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d59a1aecaf93722f$var$constant;
function $d59a1aecaf93722f$var$constant(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("trPC2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $05884c4bdfc0ccd7$var$nice;

var $k9n6n = parcelRequire("k9n6n");
function $05884c4bdfc0ccd7$var$nice(start, stop, count) {
    var prestep;
    while(true){
        var step = (0, $k9n6n.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("k9n6n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eab69172e8a0d709$var$ticks;
module.exports.tickIncrement = $eab69172e8a0d709$var$tickIncrement;
module.exports.tickStep = $eab69172e8a0d709$var$tickStep;
var $eab69172e8a0d709$var$e10 = Math.sqrt(50), $eab69172e8a0d709$var$e5 = Math.sqrt(10), $eab69172e8a0d709$var$e2 = Math.sqrt(2);
function $eab69172e8a0d709$var$ticks(start, stop, count) {
    var reverse, i = -1, n, _$ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $eab69172e8a0d709$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        var r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        _$ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)_$ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        var r01 = Math.round(start * step), r11 = Math.round(stop * step);
        if (r01 / step < start) ++r01;
        if (r11 / step > stop) --r11;
        _$ticks = new Array(n = r11 - r01 + 1);
        while(++i < n)_$ticks[i] = (r01 + i) / step;
    }
    if (reverse) _$ticks.reverse();
    return _$ticks;
}
function $eab69172e8a0d709$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $eab69172e8a0d709$var$e10 ? 10 : error >= $eab69172e8a0d709$var$e5 ? 5 : error >= $eab69172e8a0d709$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $eab69172e8a0d709$var$e10 ? 10 : error >= $eab69172e8a0d709$var$e5 ? 5 : error >= $eab69172e8a0d709$var$e2 ? 2 : 1);
}
function $eab69172e8a0d709$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $eab69172e8a0d709$var$e10) step1 *= 10;
    else if (error >= $eab69172e8a0d709$var$e5) step1 *= 5;
    else if (error >= $eab69172e8a0d709$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("7dPr1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5421a52e08d9d19d$var$thresholdSturges;

var $5421a52e08d9d19d$var$_count = $5421a52e08d9d19d$var$_interopRequireDefault((parcelRequire("5WJxK")));
function $5421a52e08d9d19d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5421a52e08d9d19d$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $5421a52e08d9d19d$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("816GN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d639b0c9d38ece3$var$thresholdFreedmanDiaconis;

var $5d639b0c9d38ece3$var$_count = $5d639b0c9d38ece3$var$_interopRequireDefault((parcelRequire("5WJxK")));

var $5d639b0c9d38ece3$var$_quantile = $5d639b0c9d38ece3$var$_interopRequireDefault((parcelRequire("af26y")));
function $5d639b0c9d38ece3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5d639b0c9d38ece3$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $5d639b0c9d38ece3$var$_quantile.default)(values, 0.75) - (0, $5d639b0c9d38ece3$var$_quantile.default)(values, 0.25)) * Math.pow((0, $5d639b0c9d38ece3$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("af26y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $774cf00ed2266740$var$quantile;
module.exports.quantileSorted = $774cf00ed2266740$var$quantileSorted;

var $774cf00ed2266740$var$_max = $774cf00ed2266740$var$_interopRequireDefault((parcelRequire("anCyz")));

var $774cf00ed2266740$var$_min = $774cf00ed2266740$var$_interopRequireDefault((parcelRequire("2n3sL")));

var $774cf00ed2266740$var$_quickselect = $774cf00ed2266740$var$_interopRequireDefault((parcelRequire("gpJDL")));

var $774cf00ed2266740$var$_number = $774cf00ed2266740$var$_interopRequireWildcard((parcelRequire("8NAqG")));
function $774cf00ed2266740$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($774cf00ed2266740$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $774cf00ed2266740$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $774cf00ed2266740$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $774cf00ed2266740$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $774cf00ed2266740$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $774cf00ed2266740$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $774cf00ed2266740$var$_min.default)(values);
    if (p >= 1) return (0, $774cf00ed2266740$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $774cf00ed2266740$var$_max.default)((0, $774cf00ed2266740$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $774cf00ed2266740$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $774cf00ed2266740$var$quantileSorted(values, p) {
    var valueof = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $774cf00ed2266740$var$_number.default;
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("anCyz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $78e9f5ec2852a3b0$var$max;
function $78e9f5ec2852a3b0$var$max(values, valueof) {
    var _$max;
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value != null && (_$max < value || _$max === undefined && value >= value)) _$max = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && (_$max < value1 || _$max === undefined && value1 >= value1)) _$max = value1;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return _$max;
}

});

parcelRegister("2n3sL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1ba06a6726aaeeb6$var$min;
function $1ba06a6726aaeeb6$var$min(values, valueof) {
    var _$min;
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value != null && (_$min > value || _$min === undefined && value >= value)) _$min = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && (_$min > value1 || _$min === undefined && value1 >= value1)) _$min = value1;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return _$min;
}

});

parcelRegister("gpJDL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf32625850f6f462$var$quickselect;

var $kAuUN = parcelRequire("kAuUN");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $bf32625850f6f462$var$quickselect(array, k) {
    var left = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, right = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : array.length - 1, compare = arguments.length > 4 ? arguments[4] : void 0;
    compare = compare === undefined ? $kAuUN.ascendingDefined : (0, $kAuUN.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            var n = right - left + 1;
            var m = k - left + 1;
            var z = Math.log(n);
            var s = 0.5 * Math.exp(2 * z / 3);
            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $bf32625850f6f462$var$quickselect(array, k, newLeft, newRight, compare);
        }
        var t = array[k];
        var i = left;
        var j = right;
        $bf32625850f6f462$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $bf32625850f6f462$var$swap(array, left, right);
        while(i < j){
            $bf32625850f6f462$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $bf32625850f6f462$var$swap(array, left, j);
        else ++j, $bf32625850f6f462$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $bf32625850f6f462$var$swap(array, i, j) {
    var t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("dvggK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9d4aca555363cb90$var$thresholdScott;

var $9d4aca555363cb90$var$_count = $9d4aca555363cb90$var$_interopRequireDefault((parcelRequire("5WJxK")));

var $9d4aca555363cb90$var$_deviation = $9d4aca555363cb90$var$_interopRequireDefault((parcelRequire("1smaL")));
function $9d4aca555363cb90$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9d4aca555363cb90$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $9d4aca555363cb90$var$_count.default)(values)) / (3.49 * (0, $9d4aca555363cb90$var$_deviation.default)(values)));
}

});

parcelRegister("hKr2x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cebbb52005d77ff2$var$maxIndex;
function $cebbb52005d77ff2$var$maxIndex(values, valueof) {
    var max;
    var _$maxIndex = -1;
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (valueof === undefined) try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            ++index;
            if (value != null && (max < value || max === undefined && value >= value)) max = value, _$maxIndex = index;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && (max < value1 || max === undefined && value1 >= value1)) max = value1, _$maxIndex = index;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return _$maxIndex;
}

});

parcelRegister("bTlSY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a85cecca5729dca$var$mean;
function $8a85cecca5729dca$var$mean(values, valueof) {
    var count = 0;
    var sum = 0;
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value != null && (value = +value) >= value) ++count, sum += value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && (value1 = +value1) >= value1) ++count, sum += value1;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    if (count) return sum / count;
}

});

parcelRegister("fDqWQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b61f66e20d54e1cd$var$median;

var $b61f66e20d54e1cd$var$_quantile = $b61f66e20d54e1cd$var$_interopRequireDefault((parcelRequire("af26y")));
function $b61f66e20d54e1cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b61f66e20d54e1cd$var$median(values, valueof) {
    return (0, $b61f66e20d54e1cd$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("cs4Il", function(module, exports) {

var $ajhIL = parcelRequire("ajhIL");

var $ajhIL = parcelRequire("ajhIL");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $910bc1b36f11ac59$var$merge;
function $910bc1b36f11ac59$var$flatten(arrays) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, array, err;
    return (0, $ajhIL.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = arrays[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                array = _step.value;
                return [
                    5,
                    (0, $ajhIL.__values)(array)
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
function $910bc1b36f11ac59$var$merge(arrays) {
    return Array.from($910bc1b36f11ac59$var$flatten(arrays));
}

});

parcelRegister("dJtdn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9ff623c24fe92969$var$minIndex;
function $9ff623c24fe92969$var$minIndex(values, valueof) {
    var min;
    var _$minIndex = -1;
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (valueof === undefined) try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            ++index;
            if (value != null && (min > value || min === undefined && value >= value)) min = value, _$minIndex = index;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && (min > value1 || min === undefined && value1 >= value1)) min = value1, _$minIndex = index;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return _$minIndex;
}

});

parcelRegister("gbecX", function(module, exports) {

var $52tJv = parcelRequire("52tJv");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc78b1d39b18c4c0$var$mode;

var $81BTs = parcelRequire("81BTs");
function $bc78b1d39b18c4c0$var$mode(values, valueof) {
    var counts = new $81BTs.InternMap();
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && value1 >= value1) counts.set(value1, (counts.get(value1) || 0) + 1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    var modeValue;
    var modeCount = 0;
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = counts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var _step_value = (0, $52tJv._)(_step2.value, 2), value2 = _step_value[0], count = _step_value[1];
            if (count > modeCount) {
                modeCount = count;
                modeValue = value2;
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    return modeValue;
}

});

parcelRegister("3NNdD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2c4c208824568c1a$var$pairs;
module.exports.pair = $2c4c208824568c1a$var$pair;
function $2c4c208824568c1a$var$pairs(values) {
    var pairof = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2c4c208824568c1a$var$pair;
    var _$pairs = [];
    var previous;
    var first = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            if (first) _$pairs.push(pairof(previous, value));
            previous = value;
            first = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return _$pairs;
}
function $2c4c208824568c1a$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("fgzYn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $02de431d36fca71c$var$range;
function $02de431d36fca71c$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, _$range = new Array(n);
    while(++i < n)_$range[i] = start + i * step;
    return _$range;
}

});

parcelRegister("kDa8Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f04f5184cb2f0b83$var$rank;

var $f04f5184cb2f0b83$var$_ascending = $f04f5184cb2f0b83$var$_interopRequireDefault((parcelRequire("aQaec")));

var $kAuUN = parcelRequire("kAuUN");
function $f04f5184cb2f0b83$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f04f5184cb2f0b83$var$rank(values) {
    var valueof = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f04f5184cb2f0b83$var$_ascending.default;
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    var V = Array.from(values);
    var R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $f04f5184cb2f0b83$var$_ascending.default;
    var compareIndex = function(i, j) {
        return valueof(V[i], V[j]);
    };
    var k, r;
    Uint32Array.from(V, function(_, i) {
        return i;
    }).sort(valueof === $f04f5184cb2f0b83$var$_ascending.default ? function(i, j) {
        return (0, $kAuUN.ascendingDefined)(V[i], V[j]);
    } : (0, $kAuUN.compareDefined)(compareIndex)).forEach(function(j, i) {
        var c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("lTZjQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ff1e4cb52be62d26$var$least;

var $ff1e4cb52be62d26$var$_ascending = $ff1e4cb52be62d26$var$_interopRequireDefault((parcelRequire("aQaec")));
function $ff1e4cb52be62d26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ff1e4cb52be62d26$var$least(values) {
    var compare = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ff1e4cb52be62d26$var$_ascending.default;
    var min;
    var defined = false;
    if (compare.length === 1) {
        var minValue;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                var value = compare(element);
                if (defined ? (0, $ff1e4cb52be62d26$var$_ascending.default)(value, minValue) < 0 : (0, $ff1e4cb52be62d26$var$_ascending.default)(value, value) === 0) {
                    min = element;
                    minValue = value;
                    defined = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if (defined ? compare(value1, min) < 0 : compare(value1, value1) === 0) {
                    min = value1;
                    defined = true;
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return min;
}

});

parcelRegister("8jimV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $60ce58b5ffa84fb4$var$leastIndex;

var $60ce58b5ffa84fb4$var$_ascending = $60ce58b5ffa84fb4$var$_interopRequireDefault((parcelRequire("aQaec")));

var $60ce58b5ffa84fb4$var$_minIndex = $60ce58b5ffa84fb4$var$_interopRequireDefault((parcelRequire("dJtdn")));
function $60ce58b5ffa84fb4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $60ce58b5ffa84fb4$var$leastIndex(values) {
    var compare = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60ce58b5ffa84fb4$var$_ascending.default;
    if (compare.length === 1) return (0, $60ce58b5ffa84fb4$var$_minIndex.default)(values, compare);
    var minValue;
    var min = -1;
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            ++index;
            if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
                minValue = value;
                min = index;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return min;
}

});

parcelRegister("2cNLv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19b34e13359febe9$var$greatest;

var $19b34e13359febe9$var$_ascending = $19b34e13359febe9$var$_interopRequireDefault((parcelRequire("aQaec")));
function $19b34e13359febe9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $19b34e13359febe9$var$greatest(values) {
    var compare = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $19b34e13359febe9$var$_ascending.default;
    var max;
    var defined = false;
    if (compare.length === 1) {
        var maxValue;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                var value = compare(element);
                if (defined ? (0, $19b34e13359febe9$var$_ascending.default)(value, maxValue) > 0 : (0, $19b34e13359febe9$var$_ascending.default)(value, value) === 0) {
                    max = element;
                    maxValue = value;
                    defined = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if (defined ? compare(value1, max) > 0 : compare(value1, value1) === 0) {
                    max = value1;
                    defined = true;
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return max;
}

});

parcelRegister("k5ugZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9fbc1da7209b4b5$var$greatestIndex;

var $e9fbc1da7209b4b5$var$_ascending = $e9fbc1da7209b4b5$var$_interopRequireDefault((parcelRequire("aQaec")));

var $e9fbc1da7209b4b5$var$_maxIndex = $e9fbc1da7209b4b5$var$_interopRequireDefault((parcelRequire("hKr2x")));
function $e9fbc1da7209b4b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e9fbc1da7209b4b5$var$greatestIndex(values) {
    var compare = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $e9fbc1da7209b4b5$var$_ascending.default;
    if (compare.length === 1) return (0, $e9fbc1da7209b4b5$var$_maxIndex.default)(values, compare);
    var maxValue;
    var max = -1;
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            ++index;
            if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
                maxValue = value;
                max = index;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return max;
}

});

parcelRegister("9RxpX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72e2fc54d2083782$var$scan;

var $72e2fc54d2083782$var$_leastIndex = $72e2fc54d2083782$var$_interopRequireDefault((parcelRequire("8jimV")));
function $72e2fc54d2083782$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $72e2fc54d2083782$var$scan(values, compare) {
    var index = (0, $72e2fc54d2083782$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("lMuaT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $fdb57cbfeb0faf6d$var$shuffler;
var $fdb57cbfeb0faf6d$var$_default = $fdb57cbfeb0faf6d$var$shuffler(Math.random);
module.exports.default = $fdb57cbfeb0faf6d$var$_default;
function $fdb57cbfeb0faf6d$var$shuffler(random) {
    return function shuffle(array) {
        var i0 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : array.length;
        var m = i1 - (i0 = +i0);
        while(m){
            var i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("ce6q4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8e6bc59f0abd3807$var$sum;
function $8e6bc59f0abd3807$var$sum(values, valueof) {
    var _$sum = 0;
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value = +value) _$sum += value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if (value1 = +valueof(value1, ++index, values)) _$sum += value1;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return _$sum;
}

});

parcelRegister("8Dkte", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6491d844a5eb4c6a$var$transpose;

var $6491d844a5eb4c6a$var$_min = $6491d844a5eb4c6a$var$_interopRequireDefault((parcelRequire("2n3sL")));
function $6491d844a5eb4c6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6491d844a5eb4c6a$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $6491d844a5eb4c6a$var$_min.default)(matrix, $6491d844a5eb4c6a$var$length), _$transpose = new Array(m); ++i < m;)for(var j = -1, n, row = _$transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return _$transpose;
}
function $6491d844a5eb4c6a$var$length(d) {
    return d.length;
}

});

parcelRegister("kJU1u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f193779e3bde55f6$var$zip;

var $f193779e3bde55f6$var$_transpose = $f193779e3bde55f6$var$_interopRequireDefault((parcelRequire("8Dkte")));
function $f193779e3bde55f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f193779e3bde55f6$var$zip() {
    return (0, $f193779e3bde55f6$var$_transpose.default)(arguments);
}

});

parcelRegister("jiVWa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e0dca3e721404660$var$every;
function $e0dca3e721404660$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            if (!test(value, ++index, values)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}

});

parcelRegister("5qFpg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f3f7fefecca4684$var$some;
function $3f3f7fefecca4684$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            if (test(value, ++index, values)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}

});

parcelRegister("dAu7f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9e45ff8df266fc1c$var$filter;
function $9e45ff8df266fc1c$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    var array = [];
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            if (test(value, ++index, values)) array.push(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return array;
}

});

parcelRegister("ad67u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $76efdd88304db035$var$map;
function $76efdd88304db035$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, function(value, index) {
        return mapper(value, index, values);
    });
}

});

parcelRegister("jJwz1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e5db7acf753447f7$var$reduce;
function $e5db7acf753447f7$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    var iterator = values[Symbol.iterator]();
    var done, next, index = -1;
    if (arguments.length < 3) {
        var ref;
        ref = iterator.next(), done = ref.done, value = ref.value, ref;
        if (done) return;
        ++index;
    }
    var ref1;
    while(ref1 = iterator.next(), done = ref1.done, next = ref1.value, ref1, !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("b921N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81d21bb1b38aa008$var$reverse;
function $81d21bb1b38aa008$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("fMu0j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7d29cdd0fdd075e$var$difference;

var $81BTs = parcelRequire("81BTs");
function $b7d29cdd0fdd075e$var$difference(values) {
    for(var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        others[_key - 1] = arguments[_key];
    }
    values = new $81BTs.InternSet(values);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = others[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var other = _step.value;
            try {
                for(var _iterator1 = other[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var value = _step1.value;
                    values.delete(value);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return values;
}

});

parcelRegister("gaoam", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $03098dbb8c7fb2a5$var$disjoint;

var $81BTs = parcelRequire("81BTs");
function $03098dbb8c7fb2a5$var$disjoint(values, other) {
    var iterator = other[Symbol.iterator](), set = new $81BTs.InternSet();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var v = _step.value;
            if (set.has(v)) return false;
            var value = void 0, done = void 0;
            var ref;
            while(ref = iterator.next(), value = ref.value, done = ref.done, ref){
                if (done) break;
                if (Object.is(v, value)) return false;
                set.add(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}

});

parcelRegister("76gij", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $52b5bba5c8b3f729$var$intersection;

var $81BTs = parcelRequire("81BTs");
function $52b5bba5c8b3f729$var$intersection(values) {
    for(var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        others[_key - 1] = arguments[_key];
    }
    values = new $81BTs.InternSet(values);
    others = others.map($52b5bba5c8b3f729$var$set);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        out: for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = others[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var other = _step1.value;
                    if (!other.has(value)) {
                        values.delete(value);
                        continue out;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return values;
}
function $52b5bba5c8b3f729$var$set(values) {
    return values instanceof $81BTs.InternSet ? values : new $81BTs.InternSet(values);
}

});

parcelRegister("8kN2B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $61163b87664a8f96$var$subset;

var $61163b87664a8f96$var$_superset = $61163b87664a8f96$var$_interopRequireDefault((parcelRequire("aU4yc")));
function $61163b87664a8f96$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $61163b87664a8f96$var$subset(values, other) {
    return (0, $61163b87664a8f96$var$_superset.default)(other, values);
}

});
parcelRegister("aU4yc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7f02a9fa376d0abd$var$superset;
function $7f02a9fa376d0abd$var$superset(values, other) {
    var iterator = values[Symbol.iterator](), set = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = other[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var o = _step.value;
            var io = $7f02a9fa376d0abd$var$intern(o);
            if (set.has(io)) continue;
            var value = void 0, done = void 0;
            var ref;
            while(ref = iterator.next(), value = ref.value, done = ref.done, ref){
                if (done) return false;
                var ivalue = $7f02a9fa376d0abd$var$intern(value);
                set.add(ivalue);
                if (Object.is(io, ivalue)) break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $7f02a9fa376d0abd$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("7jwqO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $553376f75e5a7907$var$union;

var $81BTs = parcelRequire("81BTs");
function $553376f75e5a7907$var$union() {
    for(var _len = arguments.length, others = new Array(_len), _key = 0; _key < _len; _key++){
        others[_key] = arguments[_key];
    }
    var set = new $81BTs.InternSet();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = others[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var other = _step.value;
            try {
                for(var _iterator1 = other[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var o = _step1.value;
                    set.add(o);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return set;
}

});


parcelRegister("8hPfX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $6087abb26323dc52$var$initInterpolator;
module.exports.initRange = $6087abb26323dc52$var$initRange;
function $6087abb26323dc52$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $6087abb26323dc52$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("6imYJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49563f90b73eaa76$var$ordinal;
module.exports.implicit = void 0;

var $72vjU = parcelRequire("72vjU");

var $8hPfX = parcelRequire("8hPfX");
var $49563f90b73eaa76$var$implicit = Symbol("implicit");
module.exports.implicit = $49563f90b73eaa76$var$implicit;
function $49563f90b73eaa76$var$ordinal() {
    var index = new $72vjU.InternMap(), domain = [], range = [], unknown = $49563f90b73eaa76$var$implicit;
    function scale(d) {
        var i = index.get(d);
        if (i === undefined) {
            if (unknown !== $49563f90b73eaa76$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $72vjU.InternMap();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (index.has(value)) continue;
                index.set(value, domain.push(value) - 1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $49563f90b73eaa76$var$ordinal(domain, range).unknown(unknown);
    };
    $8hPfX.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("eZ3Rm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae89c1a8fb981443$var$identity;

var $1SvFl = parcelRequire("1SvFl");

var $ae89c1a8fb981443$var$_number = $ae89c1a8fb981443$var$_interopRequireDefault((parcelRequire("884va")));
function $ae89c1a8fb981443$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ae89c1a8fb981443$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $ae89c1a8fb981443$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $ae89c1a8fb981443$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $ae89c1a8fb981443$var$_number.default) : [
        0,
        1
    ];
    return (0, $1SvFl.linearish)(scale);
}

});
parcelRegister("1SvFl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $15e365c022dfc44e$var$linear;
module.exports.linearish = $15e365c022dfc44e$var$linearish;

var $72vjU = parcelRequire("72vjU");

var $15e365c022dfc44e$var$_continuous = $15e365c022dfc44e$var$_interopRequireWildcard((parcelRequire("1Vqet")));

var $8hPfX = parcelRequire("8hPfX");

var $15e365c022dfc44e$var$_tickFormat = $15e365c022dfc44e$var$_interopRequireDefault((parcelRequire("2JZui")));
function $15e365c022dfc44e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $15e365c022dfc44e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($15e365c022dfc44e$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $15e365c022dfc44e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $15e365c022dfc44e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $15e365c022dfc44e$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $72vjU.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $15e365c022dfc44e$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $72vjU.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $15e365c022dfc44e$var$linear() {
    var scale = (0, $15e365c022dfc44e$var$_continuous.default)();
    scale.copy = function() {
        return (0, $15e365c022dfc44e$var$_continuous.copy)(scale, $15e365c022dfc44e$var$linear());
    };
    $8hPfX.initRange.apply(scale, arguments);
    return $15e365c022dfc44e$var$linearish(scale);
}

});
parcelRegister("1Vqet", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $166f768c87cf5a8d$var$copy;
module.exports.default = $166f768c87cf5a8d$var$continuous;
module.exports.identity = $166f768c87cf5a8d$var$identity;
module.exports.transformer = $166f768c87cf5a8d$var$transformer;

var $72vjU = parcelRequire("72vjU");

var $7HpsE = parcelRequire("7HpsE");

var $166f768c87cf5a8d$var$_constant = $166f768c87cf5a8d$var$_interopRequireDefault((parcelRequire("hSVrj")));

var $166f768c87cf5a8d$var$_number = $166f768c87cf5a8d$var$_interopRequireDefault((parcelRequire("884va")));
function $166f768c87cf5a8d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $166f768c87cf5a8d$var$unit = [
    0,
    1
];
function $166f768c87cf5a8d$var$identity(x) {
    return x;
}
function $166f768c87cf5a8d$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $166f768c87cf5a8d$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $166f768c87cf5a8d$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $166f768c87cf5a8d$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $166f768c87cf5a8d$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $166f768c87cf5a8d$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $166f768c87cf5a8d$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $166f768c87cf5a8d$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $72vjU.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $166f768c87cf5a8d$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $166f768c87cf5a8d$var$transformer() {
    var domain = $166f768c87cf5a8d$var$unit, range = $166f768c87cf5a8d$var$unit, interpolate = $7HpsE.interpolate, transform, untransform, unknown, clamp = $166f768c87cf5a8d$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $166f768c87cf5a8d$var$identity) clamp = $166f768c87cf5a8d$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $166f768c87cf5a8d$var$polymap : $166f768c87cf5a8d$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $7HpsE.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $166f768c87cf5a8d$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $7HpsE.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $166f768c87cf5a8d$var$identity, rescale()) : clamp !== $166f768c87cf5a8d$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $166f768c87cf5a8d$var$continuous() {
    return $166f768c87cf5a8d$var$transformer()($166f768c87cf5a8d$var$identity, $166f768c87cf5a8d$var$identity);
}

});
parcelRegister("7HpsE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function get() {
        return $4hOQL.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function get() {
        return $4hOQL.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function get() {
        return $59b04c9825e23783$var$_quantize.default;
    }
});

var $59b04c9825e23783$var$_value = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("2fzD6")));

var $59b04c9825e23783$var$_array = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("fql19")));

var $59b04c9825e23783$var$_basis = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("btMUA")));

var $59b04c9825e23783$var$_basisClosed = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("X0cUt")));

var $59b04c9825e23783$var$_date = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("34qNn")));

var $59b04c9825e23783$var$_discrete = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("jGbuz")));

var $59b04c9825e23783$var$_hue = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("jfXAA")));

var $59b04c9825e23783$var$_number = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("jlv6c")));

var $59b04c9825e23783$var$_numberArray = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("7mHc6")));

var $59b04c9825e23783$var$_object = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("02kej")));

var $59b04c9825e23783$var$_round = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("fkuvF")));

var $59b04c9825e23783$var$_string = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("wibzB")));

var $4hOQL = parcelRequire("4hOQL");

var $59b04c9825e23783$var$_zoom = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("8tarN")));

var $59b04c9825e23783$var$_rgb = $59b04c9825e23783$var$_interopRequireWildcard((parcelRequire("52EdS")));

var $59b04c9825e23783$var$_hsl = $59b04c9825e23783$var$_interopRequireWildcard((parcelRequire("f4dCq")));

var $59b04c9825e23783$var$_lab = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("cqj6H")));

var $59b04c9825e23783$var$_hcl = $59b04c9825e23783$var$_interopRequireWildcard((parcelRequire("epBC8")));

var $59b04c9825e23783$var$_cubehelix = $59b04c9825e23783$var$_interopRequireWildcard((parcelRequire("hzOy6")));

var $59b04c9825e23783$var$_piecewise = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("g1hqe")));

var $59b04c9825e23783$var$_quantize = $59b04c9825e23783$var$_interopRequireDefault((parcelRequire("iEvi2")));
function $59b04c9825e23783$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($59b04c9825e23783$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $59b04c9825e23783$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $59b04c9825e23783$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $59b04c9825e23783$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("2fzD6", function(module, exports) {

var $l6pW7 = parcelRequire("l6pW7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a389ecf1f176879$var$_default;

var $ajCsP = parcelRequire("ajCsP");

var $1a389ecf1f176879$var$_rgb = $1a389ecf1f176879$var$_interopRequireDefault((parcelRequire("52EdS")));

var $fql19 = parcelRequire("fql19");

var $1a389ecf1f176879$var$_date = $1a389ecf1f176879$var$_interopRequireDefault((parcelRequire("34qNn")));

var $1a389ecf1f176879$var$_number = $1a389ecf1f176879$var$_interopRequireDefault((parcelRequire("jlv6c")));

var $1a389ecf1f176879$var$_object = $1a389ecf1f176879$var$_interopRequireDefault((parcelRequire("02kej")));

var $1a389ecf1f176879$var$_string = $1a389ecf1f176879$var$_interopRequireDefault((parcelRequire("wibzB")));

var $1a389ecf1f176879$var$_constant = $1a389ecf1f176879$var$_interopRequireDefault((parcelRequire("2dhkB")));

var $1a389ecf1f176879$var$_numberArray = $1a389ecf1f176879$var$_interopRequireWildcard((parcelRequire("7mHc6")));
function $1a389ecf1f176879$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1a389ecf1f176879$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1a389ecf1f176879$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1a389ecf1f176879$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $1a389ecf1f176879$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1a389ecf1f176879$var$_default(a, b) {
    var t = typeof b === "undefined" ? "undefined" : (0, $l6pW7._)(b), c;
    return b == null || t === "boolean" ? (0, $1a389ecf1f176879$var$_constant.default)(b) : (t === "number" ? $1a389ecf1f176879$var$_number.default : t === "string" ? (c = (0, $ajCsP.color)(b)) ? (b = c, $1a389ecf1f176879$var$_rgb.default) : $1a389ecf1f176879$var$_string.default : b instanceof $ajCsP.color ? $1a389ecf1f176879$var$_rgb.default : b instanceof Date ? $1a389ecf1f176879$var$_date.default : (0, $1a389ecf1f176879$var$_numberArray.isNumberArray)(b) ? $1a389ecf1f176879$var$_numberArray.default : Array.isArray(b) ? $fql19.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $1a389ecf1f176879$var$_object.default : $1a389ecf1f176879$var$_number.default)(a, b);
}

});
parcelRegister("ajCsP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function get() {
        return $782983e32195d207$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function get() {
        return $782983e32195d207$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function get() {
        return $782983e32195d207$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function get() {
        return $782983e32195d207$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function get() {
        return $782983e32195d207$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function get() {
        return $782983e32195d207$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function get() {
        return $782983e32195d207$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function get() {
        return $782983e32195d207$var$_color.rgb;
    }
});

var $782983e32195d207$var$_color = $782983e32195d207$var$_interopRequireWildcard((parcelRequire("IPvoa")));

var $782983e32195d207$var$_lab = $782983e32195d207$var$_interopRequireWildcard((parcelRequire("4lQuZ")));

var $782983e32195d207$var$_cubehelix = $782983e32195d207$var$_interopRequireDefault((parcelRequire("k6U1x")));
function $782983e32195d207$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $782983e32195d207$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($782983e32195d207$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $782983e32195d207$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $782983e32195d207$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("IPvoa", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("hQe3s")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(".concat(reI, ",").concat(reI, ",").concat(reI, "\\)$")), reRgbPercent = new RegExp("^rgb\\(".concat(reP, ",").concat(reP, ",").concat(reP, "\\)$")), reRgbaInteger = new RegExp("^rgba\\(".concat(reI, ",").concat(reI, ",").concat(reI, ",").concat(reN, "\\)$")), reRgbaPercent = new RegExp("^rgba\\(".concat(reP, ",").concat(reP, ",").concat(reP, ",").concat(reN, "\\)$")), reHslPercent = new RegExp("^hsl\\(".concat(reN, ",").concat(reP, ",").concat(reP, "\\)$")), reHslaPercent = new RegExp("^hsla\\(".concat(reN, ",").concat(reP, ",").concat(reP, ",").concat(reN, "\\)$"));
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    clamp: function() {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#".concat(hex(this.r)).concat(hex(this.g)).concat(hex(this.b));
}
function rgb_formatHex8() {
    return "#".concat(hex(this.r)).concat(hex(this.g)).concat(hex(this.b)).concat(hex((isNaN(this.opacity) ? 1 : this.opacity) * 255));
}
function rgb_formatRgb() {
    var a = clampa(this.opacity);
    return "".concat(a === 1 ? "rgb(" : "rgba(").concat(clampi(this.r), ", ").concat(clampi(this.g), ", ").concat(clampi(this.b)).concat(a === 1 ? ")" : ", ".concat(a, ")"));
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp: function() {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = clampa(this.opacity);
        return "".concat(a === 1 ? "hsl(" : "hsla(").concat(clamph(this.h), ", ").concat(clampt(this.s) * 100, "%, ").concat(clampt(this.l) * 100, "%").concat(a === 1 ? ")" : ", ".concat(a, ")"));
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("hQe3s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cfd231f5ec3b809b$var$_default;
module.exports.extend = $cfd231f5ec3b809b$var$extend;
function $cfd231f5ec3b809b$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $cfd231f5ec3b809b$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("4lQuZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $32b1d8bd45535ef7$var$Hcl;
module.exports.Lab = $32b1d8bd45535ef7$var$Lab;
module.exports.default = $32b1d8bd45535ef7$var$lab;
module.exports.gray = $32b1d8bd45535ef7$var$gray;
module.exports.hcl = $32b1d8bd45535ef7$var$hcl;
module.exports.lch = $32b1d8bd45535ef7$var$lch;

var $32b1d8bd45535ef7$var$_define = $32b1d8bd45535ef7$var$_interopRequireWildcard((parcelRequire("hQe3s")));

var $IPvoa = parcelRequire("IPvoa");

var $7SmNB = parcelRequire("7SmNB");
function $32b1d8bd45535ef7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($32b1d8bd45535ef7$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $32b1d8bd45535ef7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $32b1d8bd45535ef7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
var $32b1d8bd45535ef7$var$K = 18, $32b1d8bd45535ef7$var$Xn = 0.96422, $32b1d8bd45535ef7$var$Yn = 1, $32b1d8bd45535ef7$var$Zn = 0.82521, $32b1d8bd45535ef7$var$t0 = 4 / 29, $32b1d8bd45535ef7$var$t1 = 6 / 29, $32b1d8bd45535ef7$var$t2 = 3 * $32b1d8bd45535ef7$var$t1 * $32b1d8bd45535ef7$var$t1, $32b1d8bd45535ef7$var$t3 = $32b1d8bd45535ef7$var$t1 * $32b1d8bd45535ef7$var$t1 * $32b1d8bd45535ef7$var$t1;
function $32b1d8bd45535ef7$var$labConvert(o) {
    if (o instanceof $32b1d8bd45535ef7$var$Lab) return new $32b1d8bd45535ef7$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $32b1d8bd45535ef7$var$Hcl) return $32b1d8bd45535ef7$var$hcl2lab(o);
    if (!(o instanceof $IPvoa.Rgb)) o = (0, $IPvoa.rgbConvert)(o);
    var r = $32b1d8bd45535ef7$var$rgb2lrgb(o.r), g = $32b1d8bd45535ef7$var$rgb2lrgb(o.g), b = $32b1d8bd45535ef7$var$rgb2lrgb(o.b), y = $32b1d8bd45535ef7$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $32b1d8bd45535ef7$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $32b1d8bd45535ef7$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $32b1d8bd45535ef7$var$Xn);
        z = $32b1d8bd45535ef7$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $32b1d8bd45535ef7$var$Zn);
    }
    return new $32b1d8bd45535ef7$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $32b1d8bd45535ef7$var$gray(l, opacity) {
    return new $32b1d8bd45535ef7$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $32b1d8bd45535ef7$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $32b1d8bd45535ef7$var$labConvert(l) : new $32b1d8bd45535ef7$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $32b1d8bd45535ef7$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $32b1d8bd45535ef7$var$_define.default)($32b1d8bd45535ef7$var$Lab, $32b1d8bd45535ef7$var$lab, (0, $32b1d8bd45535ef7$var$_define.extend)($IPvoa.Color, {
    brighter: function(k) {
        return new $32b1d8bd45535ef7$var$Lab(this.l + $32b1d8bd45535ef7$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
        return new $32b1d8bd45535ef7$var$Lab(this.l - $32b1d8bd45535ef7$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $32b1d8bd45535ef7$var$Xn * $32b1d8bd45535ef7$var$lab2xyz(x);
        y = $32b1d8bd45535ef7$var$Yn * $32b1d8bd45535ef7$var$lab2xyz(y);
        z = $32b1d8bd45535ef7$var$Zn * $32b1d8bd45535ef7$var$lab2xyz(z);
        return new $IPvoa.Rgb($32b1d8bd45535ef7$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $32b1d8bd45535ef7$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $32b1d8bd45535ef7$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $32b1d8bd45535ef7$var$xyz2lab(t) {
    return t > $32b1d8bd45535ef7$var$t3 ? Math.pow(t, 1 / 3) : t / $32b1d8bd45535ef7$var$t2 + $32b1d8bd45535ef7$var$t0;
}
function $32b1d8bd45535ef7$var$lab2xyz(t) {
    return t > $32b1d8bd45535ef7$var$t1 ? t * t * t : $32b1d8bd45535ef7$var$t2 * (t - $32b1d8bd45535ef7$var$t0);
}
function $32b1d8bd45535ef7$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $32b1d8bd45535ef7$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $32b1d8bd45535ef7$var$hclConvert(o) {
    if (o instanceof $32b1d8bd45535ef7$var$Hcl) return new $32b1d8bd45535ef7$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $32b1d8bd45535ef7$var$Lab)) o = $32b1d8bd45535ef7$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $32b1d8bd45535ef7$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $7SmNB.degrees;
    return new $32b1d8bd45535ef7$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $32b1d8bd45535ef7$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $32b1d8bd45535ef7$var$hclConvert(l) : new $32b1d8bd45535ef7$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $32b1d8bd45535ef7$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $32b1d8bd45535ef7$var$hclConvert(h) : new $32b1d8bd45535ef7$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $32b1d8bd45535ef7$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $32b1d8bd45535ef7$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $32b1d8bd45535ef7$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $7SmNB.radians;
    return new $32b1d8bd45535ef7$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $32b1d8bd45535ef7$var$_define.default)($32b1d8bd45535ef7$var$Hcl, $32b1d8bd45535ef7$var$hcl, (0, $32b1d8bd45535ef7$var$_define.extend)($IPvoa.Color, {
    brighter: function(k) {
        return new $32b1d8bd45535ef7$var$Hcl(this.h, this.c, this.l + $32b1d8bd45535ef7$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
        return new $32b1d8bd45535ef7$var$Hcl(this.h, this.c, this.l - $32b1d8bd45535ef7$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
        return $32b1d8bd45535ef7$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("7SmNB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
var $5bbf42f395205bfd$var$radians = Math.PI / 180;
module.exports.radians = $5bbf42f395205bfd$var$radians;
var $5bbf42f395205bfd$var$degrees = 180 / Math.PI;
module.exports.degrees = $5bbf42f395205bfd$var$degrees;

});


parcelRegister("k6U1x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $ea3fd3575c7a23d1$var$Cubehelix;
module.exports.default = $ea3fd3575c7a23d1$var$cubehelix;

var $ea3fd3575c7a23d1$var$_define = $ea3fd3575c7a23d1$var$_interopRequireWildcard((parcelRequire("hQe3s")));

var $IPvoa = parcelRequire("IPvoa");

var $7SmNB = parcelRequire("7SmNB");
function $ea3fd3575c7a23d1$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ea3fd3575c7a23d1$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ea3fd3575c7a23d1$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ea3fd3575c7a23d1$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $ea3fd3575c7a23d1$var$A = -0.14861, $ea3fd3575c7a23d1$var$B = 1.78277, $ea3fd3575c7a23d1$var$C = -0.29227, $ea3fd3575c7a23d1$var$D = -0.90649, $ea3fd3575c7a23d1$var$E = 1.97294, $ea3fd3575c7a23d1$var$ED = $ea3fd3575c7a23d1$var$E * $ea3fd3575c7a23d1$var$D, $ea3fd3575c7a23d1$var$EB = $ea3fd3575c7a23d1$var$E * $ea3fd3575c7a23d1$var$B, $ea3fd3575c7a23d1$var$BC_DA = $ea3fd3575c7a23d1$var$B * $ea3fd3575c7a23d1$var$C - $ea3fd3575c7a23d1$var$D * $ea3fd3575c7a23d1$var$A;
function $ea3fd3575c7a23d1$var$cubehelixConvert(o) {
    if (o instanceof $ea3fd3575c7a23d1$var$Cubehelix) return new $ea3fd3575c7a23d1$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $IPvoa.Rgb)) o = (0, $IPvoa.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($ea3fd3575c7a23d1$var$BC_DA * b + $ea3fd3575c7a23d1$var$ED * r - $ea3fd3575c7a23d1$var$EB * g) / ($ea3fd3575c7a23d1$var$BC_DA + $ea3fd3575c7a23d1$var$ED - $ea3fd3575c7a23d1$var$EB), bl = b - l, k = ($ea3fd3575c7a23d1$var$E * (g - l) - $ea3fd3575c7a23d1$var$C * bl) / $ea3fd3575c7a23d1$var$D, s = Math.sqrt(k * k + bl * bl) / ($ea3fd3575c7a23d1$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $7SmNB.degrees - 120 : NaN;
    return new $ea3fd3575c7a23d1$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $ea3fd3575c7a23d1$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $ea3fd3575c7a23d1$var$cubehelixConvert(h) : new $ea3fd3575c7a23d1$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $ea3fd3575c7a23d1$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $ea3fd3575c7a23d1$var$_define.default)($ea3fd3575c7a23d1$var$Cubehelix, $ea3fd3575c7a23d1$var$cubehelix, (0, $ea3fd3575c7a23d1$var$_define.extend)($IPvoa.Color, {
    brighter: function(k) {
        k = k == null ? $IPvoa.brighter : Math.pow($IPvoa.brighter, k);
        return new $ea3fd3575c7a23d1$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? $IPvoa.darker : Math.pow($IPvoa.darker, k);
        return new $ea3fd3575c7a23d1$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $7SmNB.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $IPvoa.Rgb(255 * (l + a * ($ea3fd3575c7a23d1$var$A * cosh + $ea3fd3575c7a23d1$var$B * sinh)), 255 * (l + a * ($ea3fd3575c7a23d1$var$C * cosh + $ea3fd3575c7a23d1$var$D * sinh)), 255 * (l + a * ($ea3fd3575c7a23d1$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("52EdS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $ajCsP = parcelRequire("ajCsP");

var $3abc570c9b69fe2c$var$_basis = $3abc570c9b69fe2c$var$_interopRequireDefault((parcelRequire("btMUA")));

var $3abc570c9b69fe2c$var$_basisClosed = $3abc570c9b69fe2c$var$_interopRequireDefault((parcelRequire("X0cUt")));

var $3abc570c9b69fe2c$var$_color = $3abc570c9b69fe2c$var$_interopRequireWildcard((parcelRequire("8eEL8")));
function $3abc570c9b69fe2c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3abc570c9b69fe2c$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3abc570c9b69fe2c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3abc570c9b69fe2c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3abc570c9b69fe2c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3abc570c9b69fe2c$var$_default = function rgbGamma(y) {
    var color = (0, $3abc570c9b69fe2c$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $ajCsP.rgb)(start)).r, (end = (0, $ajCsP.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $3abc570c9b69fe2c$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $3abc570c9b69fe2c$var$_default;
function $3abc570c9b69fe2c$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $ajCsP.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $3abc570c9b69fe2c$var$rgbBasis = $3abc570c9b69fe2c$var$rgbSpline($3abc570c9b69fe2c$var$_basis.default);
module.exports.rgbBasis = $3abc570c9b69fe2c$var$rgbBasis;
var $3abc570c9b69fe2c$var$rgbBasisClosed = $3abc570c9b69fe2c$var$rgbSpline($3abc570c9b69fe2c$var$_basisClosed.default);
module.exports.rgbBasisClosed = $3abc570c9b69fe2c$var$rgbBasisClosed;

});
parcelRegister("btMUA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $85b857fb6e07c3e0$var$basis;
module.exports.default = $85b857fb6e07c3e0$var$_default;
function $85b857fb6e07c3e0$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $85b857fb6e07c3e0$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $85b857fb6e07c3e0$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("X0cUt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b15abf4159cc700$var$_default;

var $btMUA = parcelRequire("btMUA");
function $0b15abf4159cc700$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $btMUA.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("8eEL8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5fef3f7c28cb4c86$var$nogamma;
module.exports.gamma = $5fef3f7c28cb4c86$var$gamma;
module.exports.hue = $5fef3f7c28cb4c86$var$hue;

var $5fef3f7c28cb4c86$var$_constant = $5fef3f7c28cb4c86$var$_interopRequireDefault((parcelRequire("2dhkB")));
function $5fef3f7c28cb4c86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5fef3f7c28cb4c86$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $5fef3f7c28cb4c86$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $5fef3f7c28cb4c86$var$hue(a, b) {
    var d = b - a;
    return d ? $5fef3f7c28cb4c86$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $5fef3f7c28cb4c86$var$_constant.default)(isNaN(a) ? b : a);
}
function $5fef3f7c28cb4c86$var$gamma(y) {
    return (y = +y) === 1 ? $5fef3f7c28cb4c86$var$nogamma : function(a, b) {
        return b - a ? $5fef3f7c28cb4c86$var$exponential(a, b, y) : (0, $5fef3f7c28cb4c86$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $5fef3f7c28cb4c86$var$nogamma(a, b) {
    var d = b - a;
    return d ? $5fef3f7c28cb4c86$var$linear(a, d) : (0, $5fef3f7c28cb4c86$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("2dhkB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $19ca3d4c1db314bc$var$_default = function(x) {
    return function() {
        return x;
    };
};
module.exports.default = $19ca3d4c1db314bc$var$_default;

});



parcelRegister("fql19", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b3a9965d20f33690$var$_default;
module.exports.genericArray = $b3a9965d20f33690$var$genericArray;

var $b3a9965d20f33690$var$_value = $b3a9965d20f33690$var$_interopRequireDefault((parcelRequire("2fzD6")));

var $b3a9965d20f33690$var$_numberArray = $b3a9965d20f33690$var$_interopRequireWildcard((parcelRequire("7mHc6")));
function $b3a9965d20f33690$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b3a9965d20f33690$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b3a9965d20f33690$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b3a9965d20f33690$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b3a9965d20f33690$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b3a9965d20f33690$var$_default(a, b) {
    return ((0, $b3a9965d20f33690$var$_numberArray.isNumberArray)(b) ? $b3a9965d20f33690$var$_numberArray.default : $b3a9965d20f33690$var$genericArray)(a, b);
}
function $b3a9965d20f33690$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $b3a9965d20f33690$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("7mHc6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $55cc17f05ed76ba0$var$_default;
module.exports.isNumberArray = $55cc17f05ed76ba0$var$isNumberArray;
function $55cc17f05ed76ba0$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $55cc17f05ed76ba0$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("34qNn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $23c687d10af65d42$var$_default;
function $23c687d10af65d42$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("jlv6c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e1581a1f0205db8b$var$_default;
function $e1581a1f0205db8b$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("02kej", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $006fe13e066718eb$var$_default;

var $006fe13e066718eb$var$_value = $006fe13e066718eb$var$_interopRequireDefault((parcelRequire("2fzD6")));
function $006fe13e066718eb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $006fe13e066718eb$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $006fe13e066718eb$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("wibzB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0611189175e11b43$var$_default;

var $0611189175e11b43$var$_number = $0611189175e11b43$var$_interopRequireDefault((parcelRequire("jlv6c")));
function $0611189175e11b43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0611189175e11b43$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $0611189175e11b43$var$reB = new RegExp($0611189175e11b43$var$reA.source, "g");
function $0611189175e11b43$var$zero(b) {
    return function() {
        return b;
    };
}
function $0611189175e11b43$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $0611189175e11b43$var$_default(a, b) {
    var bi = $0611189175e11b43$var$reA.lastIndex = $0611189175e11b43$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $0611189175e11b43$var$reA.exec(a)) && (bm = $0611189175e11b43$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $0611189175e11b43$var$_number.default)(am, bm)
            });
        }
        bi = $0611189175e11b43$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $0611189175e11b43$var$one(q[0].x) : $0611189175e11b43$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("jGbuz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e53adaa271798443$var$_default;
function $e53adaa271798443$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("jfXAA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e04da43494e88735$var$_default;

var $8eEL8 = parcelRequire("8eEL8");
function $e04da43494e88735$var$_default(a, b) {
    var i = (0, $8eEL8.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("fkuvF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b29063dc537c3f44$var$_default;
function $b29063dc537c3f44$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("4hOQL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $31f031b35993f6c6$var$_number = $31f031b35993f6c6$var$_interopRequireDefault((parcelRequire("jlv6c")));

var $59Fp0 = parcelRequire("59Fp0");
function $31f031b35993f6c6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $31f031b35993f6c6$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $31f031b35993f6c6$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $31f031b35993f6c6$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $31f031b35993f6c6$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $31f031b35993f6c6$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $31f031b35993f6c6$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $31f031b35993f6c6$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $31f031b35993f6c6$var$interpolateTransformCss = $31f031b35993f6c6$var$interpolateTransform($59Fp0.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $31f031b35993f6c6$var$interpolateTransformCss;
var $31f031b35993f6c6$var$interpolateTransformSvg = $31f031b35993f6c6$var$interpolateTransform($59Fp0.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $31f031b35993f6c6$var$interpolateTransformSvg;

});
parcelRegister("59Fp0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $3c0de8a21dc90a7a$var$parseCss;
module.exports.parseSvg = $3c0de8a21dc90a7a$var$parseSvg;

var $3c0de8a21dc90a7a$var$_decompose = $3c0de8a21dc90a7a$var$_interopRequireWildcard((parcelRequire("actML")));
function $3c0de8a21dc90a7a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3c0de8a21dc90a7a$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3c0de8a21dc90a7a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3c0de8a21dc90a7a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $3c0de8a21dc90a7a$var$svgNode;
/* eslint-disable no-undef */ function $3c0de8a21dc90a7a$var$parseCss(value) {
    var m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $3c0de8a21dc90a7a$var$_decompose.identity : (0, $3c0de8a21dc90a7a$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $3c0de8a21dc90a7a$var$parseSvg(value) {
    if (value == null) return $3c0de8a21dc90a7a$var$_decompose.identity;
    if (!$3c0de8a21dc90a7a$var$svgNode) $3c0de8a21dc90a7a$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $3c0de8a21dc90a7a$var$svgNode.setAttribute("transform", value);
    if (!(value = $3c0de8a21dc90a7a$var$svgNode.transform.baseVal.consolidate())) return $3c0de8a21dc90a7a$var$_decompose.identity;
    value = value.matrix;
    return (0, $3c0de8a21dc90a7a$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("actML", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $76d2212447c8e406$var$_default;
module.exports.identity = void 0;
var $76d2212447c8e406$var$degrees = 180 / Math.PI;
var $76d2212447c8e406$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $76d2212447c8e406$var$identity;
function $76d2212447c8e406$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $76d2212447c8e406$var$degrees,
        skewX: Math.atan(skewX) * $76d2212447c8e406$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("8tarN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $62a922c89adcf53e$var$epsilon2 = 1e-12;
function $62a922c89adcf53e$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $62a922c89adcf53e$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $62a922c89adcf53e$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $62a922c89adcf53e$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $62a922c89adcf53e$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function i(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function i(t) {
                var s = t * S, coshr0 = $62a922c89adcf53e$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $62a922c89adcf53e$var$tanh(rho * s + r0) - $62a922c89adcf53e$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $62a922c89adcf53e$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $62a922c89adcf53e$var$_default;

});

parcelRegister("f4dCq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $ajCsP = parcelRequire("ajCsP");

var $af81cb2895648c14$var$_color = $af81cb2895648c14$var$_interopRequireWildcard((parcelRequire("8eEL8")));
function $af81cb2895648c14$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($af81cb2895648c14$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $af81cb2895648c14$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $af81cb2895648c14$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $af81cb2895648c14$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $ajCsP.hsl)(start)).h, (end = (0, $ajCsP.hsl)(end)).h), s = (0, $af81cb2895648c14$var$_color.default)(start.s, end.s), l = (0, $af81cb2895648c14$var$_color.default)(start.l, end.l), opacity = (0, $af81cb2895648c14$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $af81cb2895648c14$var$_default = $af81cb2895648c14$var$hsl($af81cb2895648c14$var$_color.hue);
module.exports.default = $af81cb2895648c14$var$_default;
var $af81cb2895648c14$var$hslLong = $af81cb2895648c14$var$hsl($af81cb2895648c14$var$_color.default);
module.exports.hslLong = $af81cb2895648c14$var$hslLong;

});

parcelRegister("cqj6H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90b6bc037d322c47$var$lab;

var $ajCsP = parcelRequire("ajCsP");

var $90b6bc037d322c47$var$_color = $90b6bc037d322c47$var$_interopRequireDefault((parcelRequire("8eEL8")));
function $90b6bc037d322c47$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $90b6bc037d322c47$var$lab(start, end) {
    var l = (0, $90b6bc037d322c47$var$_color.default)((start = (0, $ajCsP.lab)(start)).l, (end = (0, $ajCsP.lab)(end)).l), a = (0, $90b6bc037d322c47$var$_color.default)(start.a, end.a), b = (0, $90b6bc037d322c47$var$_color.default)(start.b, end.b), opacity = (0, $90b6bc037d322c47$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("epBC8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $ajCsP = parcelRequire("ajCsP");

var $a7e093e1866cd280$var$_color = $a7e093e1866cd280$var$_interopRequireWildcard((parcelRequire("8eEL8")));
function $a7e093e1866cd280$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a7e093e1866cd280$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a7e093e1866cd280$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a7e093e1866cd280$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $a7e093e1866cd280$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $ajCsP.hcl)(start)).h, (end = (0, $ajCsP.hcl)(end)).h), c = (0, $a7e093e1866cd280$var$_color.default)(start.c, end.c), l = (0, $a7e093e1866cd280$var$_color.default)(start.l, end.l), opacity = (0, $a7e093e1866cd280$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $a7e093e1866cd280$var$_default = $a7e093e1866cd280$var$hcl($a7e093e1866cd280$var$_color.hue);
module.exports.default = $a7e093e1866cd280$var$_default;
var $a7e093e1866cd280$var$hclLong = $a7e093e1866cd280$var$hcl($a7e093e1866cd280$var$_color.default);
module.exports.hclLong = $a7e093e1866cd280$var$hclLong;

});

parcelRegister("hzOy6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $ajCsP = parcelRequire("ajCsP");

var $ccbcea88d7c4ed63$var$_color = $ccbcea88d7c4ed63$var$_interopRequireWildcard((parcelRequire("8eEL8")));
function $ccbcea88d7c4ed63$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ccbcea88d7c4ed63$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ccbcea88d7c4ed63$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ccbcea88d7c4ed63$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ccbcea88d7c4ed63$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $ajCsP.cubehelix)(start)).h, (end = (0, $ajCsP.cubehelix)(end)).h), s = (0, $ccbcea88d7c4ed63$var$_color.default)(start.s, end.s), l = (0, $ccbcea88d7c4ed63$var$_color.default)(start.l, end.l), opacity = (0, $ccbcea88d7c4ed63$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $ccbcea88d7c4ed63$var$_default = $ccbcea88d7c4ed63$var$cubehelix($ccbcea88d7c4ed63$var$_color.hue);
module.exports.default = $ccbcea88d7c4ed63$var$_default;
var $ccbcea88d7c4ed63$var$cubehelixLong = $ccbcea88d7c4ed63$var$cubehelix($ccbcea88d7c4ed63$var$_color.default);
module.exports.cubehelixLong = $ccbcea88d7c4ed63$var$cubehelixLong;

});

parcelRegister("g1hqe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ba9a4100d26ebba7$var$piecewise;

var $ba9a4100d26ebba7$var$_value = $ba9a4100d26ebba7$var$_interopRequireDefault((parcelRequire("2fzD6")));
function $ba9a4100d26ebba7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ba9a4100d26ebba7$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $ba9a4100d26ebba7$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("iEvi2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d9443bedf2af86f6$var$_default;
function $d9443bedf2af86f6$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("hSVrj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d054091b2364d0dc$var$constants;
function $d054091b2364d0dc$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("884va", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5eb29009337545ca$var$number;
function $5eb29009337545ca$var$number(x) {
    return +x;
}

});


parcelRegister("2JZui", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1fef7ae47a0e90e5$var$tickFormat;

var $72vjU = parcelRequire("72vjU");

var $7ppRH = parcelRequire("7ppRH");
function $1fef7ae47a0e90e5$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $72vjU.tickStep)(start, stop, count), precision;
    specifier = (0, $7ppRH.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $7ppRH.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $7ppRH.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $7ppRH.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $7ppRH.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $7ppRH.format)(specifier);
}

});
parcelRegister("7ppRH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function get() {
        return $564eee7a7dd83890$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function get() {
        return $564eee7a7dd83890$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function get() {
        return $564eee7a7dd83890$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function get() {
        return $564eee7a7dd83890$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function get() {
        return $564eee7a7dd83890$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function get() {
        return $564eee7a7dd83890$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function get() {
        return $564eee7a7dd83890$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function get() {
        return $564eee7a7dd83890$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function get() {
        return $564eee7a7dd83890$var$_precisionRound.default;
    }
});

var $564eee7a7dd83890$var$_defaultLocale = $564eee7a7dd83890$var$_interopRequireWildcard((parcelRequire("80VtC")));

var $564eee7a7dd83890$var$_locale = $564eee7a7dd83890$var$_interopRequireDefault((parcelRequire("30AIV")));

var $564eee7a7dd83890$var$_formatSpecifier = $564eee7a7dd83890$var$_interopRequireWildcard((parcelRequire("bi4jL")));

var $564eee7a7dd83890$var$_precisionFixed = $564eee7a7dd83890$var$_interopRequireDefault((parcelRequire("k8kVu")));

var $564eee7a7dd83890$var$_precisionPrefix = $564eee7a7dd83890$var$_interopRequireDefault((parcelRequire("2ybUX")));

var $564eee7a7dd83890$var$_precisionRound = $564eee7a7dd83890$var$_interopRequireDefault((parcelRequire("dEJ98")));
function $564eee7a7dd83890$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $564eee7a7dd83890$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($564eee7a7dd83890$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $564eee7a7dd83890$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $564eee7a7dd83890$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("80VtC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d5ae8796a1cae42$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $5d5ae8796a1cae42$var$_locale = $5d5ae8796a1cae42$var$_interopRequireDefault((parcelRequire("30AIV")));
function $5d5ae8796a1cae42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5d5ae8796a1cae42$var$locale;
var $5d5ae8796a1cae42$var$format;
module.exports.format = $5d5ae8796a1cae42$var$format;
var $5d5ae8796a1cae42$var$formatPrefix;
module.exports.formatPrefix = $5d5ae8796a1cae42$var$formatPrefix;
$5d5ae8796a1cae42$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $5d5ae8796a1cae42$var$defaultLocale(definition) {
    $5d5ae8796a1cae42$var$locale = (0, $5d5ae8796a1cae42$var$_locale.default)(definition);
    module.exports.format = $5d5ae8796a1cae42$var$format = $5d5ae8796a1cae42$var$locale.format;
    module.exports.formatPrefix = $5d5ae8796a1cae42$var$formatPrefix = $5d5ae8796a1cae42$var$locale.formatPrefix;
    return $5d5ae8796a1cae42$var$locale;
}

});
parcelRegister("30AIV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $230ddbbc4fad7636$var$_default;

var $230ddbbc4fad7636$var$_exponent = $230ddbbc4fad7636$var$_interopRequireDefault((parcelRequire("bdaOO")));

var $230ddbbc4fad7636$var$_formatGroup = $230ddbbc4fad7636$var$_interopRequireDefault((parcelRequire("lcaES")));

var $230ddbbc4fad7636$var$_formatNumerals = $230ddbbc4fad7636$var$_interopRequireDefault((parcelRequire("2nXTD")));

var $230ddbbc4fad7636$var$_formatSpecifier = $230ddbbc4fad7636$var$_interopRequireDefault((parcelRequire("bi4jL")));

var $230ddbbc4fad7636$var$_formatTrim = $230ddbbc4fad7636$var$_interopRequireDefault((parcelRequire("eFYgh")));

var $230ddbbc4fad7636$var$_formatTypes = $230ddbbc4fad7636$var$_interopRequireDefault((parcelRequire("8PgMe")));

var $klVYz = parcelRequire("klVYz");

var $230ddbbc4fad7636$var$_identity = $230ddbbc4fad7636$var$_interopRequireDefault((parcelRequire("bh1Pa")));
function $230ddbbc4fad7636$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $230ddbbc4fad7636$var$map = Array.prototype.map, $230ddbbc4fad7636$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $230ddbbc4fad7636$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $230ddbbc4fad7636$var$_identity.default : (0, $230ddbbc4fad7636$var$_formatGroup.default)($230ddbbc4fad7636$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $230ddbbc4fad7636$var$_identity.default : (0, $230ddbbc4fad7636$var$_formatNumerals.default)($230ddbbc4fad7636$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $230ddbbc4fad7636$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$230ddbbc4fad7636$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $230ddbbc4fad7636$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $230ddbbc4fad7636$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $230ddbbc4fad7636$var$prefixes[8 + $klVYz.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $230ddbbc4fad7636$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $230ddbbc4fad7636$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $230ddbbc4fad7636$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("bdaOO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $82994cf6c8f534fd$var$_default;

var $lSeJ5 = parcelRequire("lSeJ5");
function $82994cf6c8f534fd$var$_default(x) {
    return x = (0, $lSeJ5.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("lSeJ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $feca1072afcd0eb1$var$_default;
module.exports.formatDecimalParts = $feca1072afcd0eb1$var$formatDecimalParts;
function $feca1072afcd0eb1$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $feca1072afcd0eb1$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("lcaES", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f6e2fc7707237db8$var$_default;
function $f6e2fc7707237db8$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("2nXTD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1bcc30ea5a335d4c$var$_default;
function $1bcc30ea5a335d4c$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("bi4jL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $8384b997c74ff89c$var$FormatSpecifier;
module.exports.default = $8384b997c74ff89c$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $8384b997c74ff89c$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $8384b997c74ff89c$var$formatSpecifier(specifier) {
    if (!(match = $8384b997c74ff89c$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $8384b997c74ff89c$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$8384b997c74ff89c$var$formatSpecifier.prototype = $8384b997c74ff89c$var$FormatSpecifier.prototype; // instanceof
function $8384b997c74ff89c$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$8384b997c74ff89c$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("eFYgh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aaf3a3bcb938e826$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $aaf3a3bcb938e826$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("8PgMe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66d019aca31b3300$var$_formatDecimal = $66d019aca31b3300$var$_interopRequireDefault((parcelRequire("lSeJ5")));

var $66d019aca31b3300$var$_formatPrefixAuto = $66d019aca31b3300$var$_interopRequireDefault((parcelRequire("klVYz")));

var $66d019aca31b3300$var$_formatRounded = $66d019aca31b3300$var$_interopRequireDefault((parcelRequire("kovYV")));
function $66d019aca31b3300$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $66d019aca31b3300$var$_default = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": $66d019aca31b3300$var$_formatDecimal.default,
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $66d019aca31b3300$var$_formatRounded.default)(x * 100, p);
    },
    "r": $66d019aca31b3300$var$_formatRounded.default,
    "s": $66d019aca31b3300$var$_formatPrefixAuto.default,
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};
module.exports.default = $66d019aca31b3300$var$_default;

});
parcelRegister("klVYz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ed12bda5f56c0523$var$_default;
module.exports.prefixExponent = void 0;

var $lSeJ5 = parcelRequire("lSeJ5");
var $ed12bda5f56c0523$var$prefixExponent;
module.exports.prefixExponent = $ed12bda5f56c0523$var$prefixExponent;
function $ed12bda5f56c0523$var$_default(x, p) {
    var d = (0, $lSeJ5.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $ed12bda5f56c0523$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $lSeJ5.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("kovYV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ed8edb6d15969755$var$_default;

var $lSeJ5 = parcelRequire("lSeJ5");
function $ed8edb6d15969755$var$_default(x, p) {
    var d = (0, $lSeJ5.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("bh1Pa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8352b28529ed5472$var$_default;
function $8352b28529ed5472$var$_default(x) {
    return x;
}

});



parcelRegister("k8kVu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ea84c98428705499$var$_default;

var $ea84c98428705499$var$_exponent = $ea84c98428705499$var$_interopRequireDefault((parcelRequire("bdaOO")));
function $ea84c98428705499$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ea84c98428705499$var$_default(step) {
    return Math.max(0, -(0, $ea84c98428705499$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("2ybUX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1db800527db0aa6e$var$_default;

var $1db800527db0aa6e$var$_exponent = $1db800527db0aa6e$var$_interopRequireDefault((parcelRequire("bdaOO")));
function $1db800527db0aa6e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1db800527db0aa6e$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $1db800527db0aa6e$var$_exponent.default)(value) / 3))) * 3 - (0, $1db800527db0aa6e$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("dEJ98", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9f1207ed8be24780$var$_default;

var $9f1207ed8be24780$var$_exponent = $9f1207ed8be24780$var$_interopRequireDefault((parcelRequire("bdaOO")));
function $9f1207ed8be24780$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9f1207ed8be24780$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $9f1207ed8be24780$var$_exponent.default)(max) - (0, $9f1207ed8be24780$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("eBnvE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aa16c1dca1bd5f97$var$log;
module.exports.loggish = $aa16c1dca1bd5f97$var$loggish;

var $72vjU = parcelRequire("72vjU");

var $7ppRH = parcelRequire("7ppRH");

var $aa16c1dca1bd5f97$var$_nice = $aa16c1dca1bd5f97$var$_interopRequireDefault((parcelRequire("aE9Wh")));

var $1Vqet = parcelRequire("1Vqet");

var $8hPfX = parcelRequire("8hPfX");
function $aa16c1dca1bd5f97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aa16c1dca1bd5f97$var$transformLog(x) {
    return Math.log(x);
}
function $aa16c1dca1bd5f97$var$transformExp(x) {
    return Math.exp(x);
}
function $aa16c1dca1bd5f97$var$transformLogn(x) {
    return -Math.log(-x);
}
function $aa16c1dca1bd5f97$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $aa16c1dca1bd5f97$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $aa16c1dca1bd5f97$var$powp(base) {
    return base === 10 ? $aa16c1dca1bd5f97$var$pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function $aa16c1dca1bd5f97$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function $aa16c1dca1bd5f97$var$reflect(f) {
    return function(x, k) {
        return -f(-x, k);
    };
}
function $aa16c1dca1bd5f97$var$loggish(transform) {
    var scale = transform($aa16c1dca1bd5f97$var$transformLog, $aa16c1dca1bd5f97$var$transformExp);
    var domain = scale.domain;
    var base = 10;
    var logs;
    var pows;
    function rescale() {
        logs = $aa16c1dca1bd5f97$var$logp(base), pows = $aa16c1dca1bd5f97$var$powp(base);
        if (domain()[0] < 0) {
            logs = $aa16c1dca1bd5f97$var$reflect(logs), pows = $aa16c1dca1bd5f97$var$reflect(pows);
            transform($aa16c1dca1bd5f97$var$transformLogn, $aa16c1dca1bd5f97$var$transformExpn);
        } else transform($aa16c1dca1bd5f97$var$transformLog, $aa16c1dca1bd5f97$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain();
        var u = d[0];
        var v = d[d.length - 1];
        var r = v < u;
        var ref;
        if (r) ref = [
            v,
            u
        ], u = ref[0], v = ref[1], ref;
        var i = logs(u);
        var j = logs(v);
        var k;
        var t;
        var n = count == null ? 10 : +count;
        var z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $72vjU.ticks)(u, v, n);
        } else z = (0, $72vjU.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $7ppRH.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $7ppRH.format)(specifier);
        }
        if (count === Infinity) return specifier;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, $aa16c1dca1bd5f97$var$_nice.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function $aa16c1dca1bd5f97$var$log() {
    var scale = $aa16c1dca1bd5f97$var$loggish((0, $1Vqet.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $1Vqet.copy)(scale, $aa16c1dca1bd5f97$var$log()).base(scale.base());
    };
    $8hPfX.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("aE9Wh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c05597dfba0b234$var$nice;
function $7c05597dfba0b234$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("4ICux", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36f9211dcfeb5aee$var$symlog;
module.exports.symlogish = $36f9211dcfeb5aee$var$symlogish;

var $1SvFl = parcelRequire("1SvFl");

var $1Vqet = parcelRequire("1Vqet");

var $8hPfX = parcelRequire("8hPfX");
function $36f9211dcfeb5aee$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $36f9211dcfeb5aee$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $36f9211dcfeb5aee$var$symlogish(transform) {
    var c = 1, scale = transform($36f9211dcfeb5aee$var$transformSymlog(c), $36f9211dcfeb5aee$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($36f9211dcfeb5aee$var$transformSymlog(c = +_), $36f9211dcfeb5aee$var$transformSymexp(c)) : c;
    };
    return (0, $1SvFl.linearish)(scale);
}
function $36f9211dcfeb5aee$var$symlog() {
    var scale = $36f9211dcfeb5aee$var$symlogish((0, $1Vqet.transformer)());
    scale.copy = function() {
        return (0, $1Vqet.copy)(scale, $36f9211dcfeb5aee$var$symlog()).constant(scale.constant());
    };
    return $8hPfX.initRange.apply(scale, arguments);
}

});

parcelRegister("lI3XK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fce0c7f0d8ef5de6$var$pow;
module.exports.powish = $fce0c7f0d8ef5de6$var$powish;
module.exports.sqrt = $fce0c7f0d8ef5de6$var$sqrt;

var $1SvFl = parcelRequire("1SvFl");

var $1Vqet = parcelRequire("1Vqet");

var $8hPfX = parcelRequire("8hPfX");
function $fce0c7f0d8ef5de6$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $fce0c7f0d8ef5de6$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $fce0c7f0d8ef5de6$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $fce0c7f0d8ef5de6$var$powish(transform) {
    var scale = transform($1Vqet.identity, $1Vqet.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($1Vqet.identity, $1Vqet.identity) : exponent === 0.5 ? transform($fce0c7f0d8ef5de6$var$transformSqrt, $fce0c7f0d8ef5de6$var$transformSquare) : transform($fce0c7f0d8ef5de6$var$transformPow(exponent), $fce0c7f0d8ef5de6$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $1SvFl.linearish)(scale);
}
function $fce0c7f0d8ef5de6$var$pow() {
    var scale = $fce0c7f0d8ef5de6$var$powish((0, $1Vqet.transformer)());
    scale.copy = function() {
        return (0, $1Vqet.copy)(scale, $fce0c7f0d8ef5de6$var$pow()).exponent(scale.exponent());
    };
    $8hPfX.initRange.apply(scale, arguments);
    return scale;
}
function $fce0c7f0d8ef5de6$var$sqrt() {
    return $fce0c7f0d8ef5de6$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("gcJ4Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $030b5dddbf6cc524$var$radial;

var $030b5dddbf6cc524$var$_continuous = $030b5dddbf6cc524$var$_interopRequireDefault((parcelRequire("1Vqet")));

var $8hPfX = parcelRequire("8hPfX");

var $1SvFl = parcelRequire("1SvFl");

var $030b5dddbf6cc524$var$_number = $030b5dddbf6cc524$var$_interopRequireDefault((parcelRequire("884va")));
function $030b5dddbf6cc524$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $030b5dddbf6cc524$var$square(x) {
    return Math.sign(x) * x * x;
}
function $030b5dddbf6cc524$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $030b5dddbf6cc524$var$radial() {
    var squared = (0, $030b5dddbf6cc524$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $030b5dddbf6cc524$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($030b5dddbf6cc524$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $030b5dddbf6cc524$var$_number.default)).map($030b5dddbf6cc524$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $030b5dddbf6cc524$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $8hPfX.initRange.apply(scale, arguments);
    return (0, $1SvFl.linearish)(scale);
}

});

parcelRegister("gTbYn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4bb11f79e544a4c$var$quantile;

var $72vjU = parcelRequire("72vjU");

var $8hPfX = parcelRequire("8hPfX");
function $c4bb11f79e544a4c$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $72vjU.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $72vjU.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                if (d != null && !isNaN(d = +d)) domain.push(d);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        domain.sort($72vjU.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $c4bb11f79e544a4c$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $8hPfX.initRange.apply(scale, arguments);
}

});

parcelRegister("lrF6Z", function(module, exports) {

var $52tJv = parcelRequire("52tJv");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f9cc028b2d59d0b2$var$quantize;

var $72vjU = parcelRequire("72vjU");

var $1SvFl = parcelRequire("1SvFl");

var $8hPfX = parcelRequire("8hPfX");
function $f9cc028b2d59d0b2$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $72vjU.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        var ref;
        return arguments.length ? (ref = (0, $52tJv._)(_, 2), x0 = ref[0], x1 = ref[1], ref, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $f9cc028b2d59d0b2$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $8hPfX.initRange.apply((0, $1SvFl.linearish)(scale), arguments);
}

});

parcelRegister("e1zMZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a35ceba6b705e333$var$threshold;

var $72vjU = parcelRequire("72vjU");

var $8hPfX = parcelRequire("8hPfX");
function $a35ceba6b705e333$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $72vjU.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $a35ceba6b705e333$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $8hPfX.initRange.apply(scale, arguments);
}

});

parcelRegister("haq1g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $c7f78dc36f326efc$var$calendar;
module.exports.default = $c7f78dc36f326efc$var$time;

var $8B7rL = parcelRequire("8B7rL");

var $5Pmfr = parcelRequire("5Pmfr");

var $c7f78dc36f326efc$var$_continuous = $c7f78dc36f326efc$var$_interopRequireWildcard((parcelRequire("1Vqet")));

var $8hPfX = parcelRequire("8hPfX");

var $c7f78dc36f326efc$var$_nice = $c7f78dc36f326efc$var$_interopRequireDefault((parcelRequire("aE9Wh")));
function $c7f78dc36f326efc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c7f78dc36f326efc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c7f78dc36f326efc$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c7f78dc36f326efc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c7f78dc36f326efc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c7f78dc36f326efc$var$date(t) {
    return new Date(t);
}
function $c7f78dc36f326efc$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $c7f78dc36f326efc$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $c7f78dc36f326efc$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $c7f78dc36f326efc$var$number)) : domain().map($c7f78dc36f326efc$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $c7f78dc36f326efc$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $c7f78dc36f326efc$var$_continuous.copy)(scale, $c7f78dc36f326efc$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $c7f78dc36f326efc$var$time() {
    return $8hPfX.initRange.apply($c7f78dc36f326efc$var$calendar($8B7rL.timeTicks, $8B7rL.timeTickInterval, $8B7rL.timeYear, $8B7rL.timeMonth, $8B7rL.timeWeek, $8B7rL.timeDay, $8B7rL.timeHour, $8B7rL.timeMinute, $8B7rL.timeSecond, $5Pmfr.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("8B7rL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function get() {
        return $5gByY.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function get() {
        return $5gByY.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function get() {
        return $5gByY.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function get() {
        return $5gByY.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function get() {
        return $5gByY.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function get() {
        return $5gByY.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function get() {
        return $5gByY.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function get() {
        return $5gByY.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function get() {
        return $5gByY.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function get() {
        return $5gByY.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function get() {
        return $7NpsY.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function get() {
        return $7NpsY.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function get() {
        return $5gByY.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function get() {
        return $5gByY.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function get() {
        return $5gByY.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function get() {
        return $5gByY.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function get() {
        return $5gByY.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function get() {
        return $5gByY.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function get() {
        return $7NpsY.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function get() {
        return $7NpsY.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function get() {
        return $eoXfq.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function get() {
        return $64278e3587e87f3e$var$_utcYear.utcYears;
    }
});

var $64278e3587e87f3e$var$_interval = $64278e3587e87f3e$var$_interopRequireDefault((parcelRequire("015gM")));

var $64278e3587e87f3e$var$_millisecond = $64278e3587e87f3e$var$_interopRequireWildcard((parcelRequire("5PbDH")));

var $64278e3587e87f3e$var$_second = $64278e3587e87f3e$var$_interopRequireWildcard((parcelRequire("b3KDa")));

var $64278e3587e87f3e$var$_minute = $64278e3587e87f3e$var$_interopRequireWildcard((parcelRequire("4cZmZ")));

var $64278e3587e87f3e$var$_hour = $64278e3587e87f3e$var$_interopRequireWildcard((parcelRequire("iImCL")));

var $64278e3587e87f3e$var$_day = $64278e3587e87f3e$var$_interopRequireWildcard((parcelRequire("bdwKk")));

var $5gByY = parcelRequire("5gByY");

var $64278e3587e87f3e$var$_month = $64278e3587e87f3e$var$_interopRequireWildcard((parcelRequire("ljVbJ")));

var $64278e3587e87f3e$var$_year = $64278e3587e87f3e$var$_interopRequireWildcard((parcelRequire("eHi9a")));

var $64278e3587e87f3e$var$_utcMinute = $64278e3587e87f3e$var$_interopRequireWildcard((parcelRequire("6VFf0")));

var $64278e3587e87f3e$var$_utcHour = $64278e3587e87f3e$var$_interopRequireWildcard((parcelRequire("7miWt")));

var $64278e3587e87f3e$var$_utcDay = $64278e3587e87f3e$var$_interopRequireWildcard((parcelRequire("f8rPQ")));

var $eoXfq = parcelRequire("eoXfq");

var $64278e3587e87f3e$var$_utcMonth = $64278e3587e87f3e$var$_interopRequireWildcard((parcelRequire("f1MPw")));

var $64278e3587e87f3e$var$_utcYear = $64278e3587e87f3e$var$_interopRequireWildcard((parcelRequire("3wHZ5")));

var $7NpsY = parcelRequire("7NpsY");
function $64278e3587e87f3e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($64278e3587e87f3e$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $64278e3587e87f3e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $64278e3587e87f3e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $64278e3587e87f3e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("015gM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $00342e89886546e4$var$newInterval;
var $00342e89886546e4$var$t0 = new Date(), $00342e89886546e4$var$t1 = new Date();
function $00342e89886546e4$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $00342e89886546e4$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $00342e89886546e4$var$t0.setTime(+start), $00342e89886546e4$var$t1.setTime(+end);
            floori($00342e89886546e4$var$t0), floori($00342e89886546e4$var$t1);
            return Math.floor(count($00342e89886546e4$var$t0, $00342e89886546e4$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("5PbDH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $43dabe7fc07b4fb8$var$_interval = $43dabe7fc07b4fb8$var$_interopRequireDefault((parcelRequire("015gM")));
function $43dabe7fc07b4fb8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $43dabe7fc07b4fb8$var$millisecond = (0, $43dabe7fc07b4fb8$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$43dabe7fc07b4fb8$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $43dabe7fc07b4fb8$var$millisecond;
    return (0, $43dabe7fc07b4fb8$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $43dabe7fc07b4fb8$var$_default = $43dabe7fc07b4fb8$var$millisecond;
module.exports.default = $43dabe7fc07b4fb8$var$_default;
var $43dabe7fc07b4fb8$var$milliseconds = $43dabe7fc07b4fb8$var$millisecond.range;
module.exports.milliseconds = $43dabe7fc07b4fb8$var$milliseconds;

});

parcelRegister("b3KDa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $80d4256b18609c16$var$_interval = $80d4256b18609c16$var$_interopRequireDefault((parcelRequire("015gM")));

var $6p6jy = parcelRequire("6p6jy");
function $80d4256b18609c16$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $80d4256b18609c16$var$second = (0, $80d4256b18609c16$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $6p6jy.durationSecond);
}, function(start, end) {
    return (end - start) / $6p6jy.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $80d4256b18609c16$var$_default = $80d4256b18609c16$var$second;
module.exports.default = $80d4256b18609c16$var$_default;
var $80d4256b18609c16$var$seconds = $80d4256b18609c16$var$second.range;
module.exports.seconds = $80d4256b18609c16$var$seconds;

});
parcelRegister("6p6jy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
var $4a99f9c5f0d1b6d8$var$durationSecond = 1000;
module.exports.durationSecond = $4a99f9c5f0d1b6d8$var$durationSecond;
var $4a99f9c5f0d1b6d8$var$durationMinute = $4a99f9c5f0d1b6d8$var$durationSecond * 60;
module.exports.durationMinute = $4a99f9c5f0d1b6d8$var$durationMinute;
var $4a99f9c5f0d1b6d8$var$durationHour = $4a99f9c5f0d1b6d8$var$durationMinute * 60;
module.exports.durationHour = $4a99f9c5f0d1b6d8$var$durationHour;
var $4a99f9c5f0d1b6d8$var$durationDay = $4a99f9c5f0d1b6d8$var$durationHour * 24;
module.exports.durationDay = $4a99f9c5f0d1b6d8$var$durationDay;
var $4a99f9c5f0d1b6d8$var$durationWeek = $4a99f9c5f0d1b6d8$var$durationDay * 7;
module.exports.durationWeek = $4a99f9c5f0d1b6d8$var$durationWeek;
var $4a99f9c5f0d1b6d8$var$durationMonth = $4a99f9c5f0d1b6d8$var$durationDay * 30;
module.exports.durationMonth = $4a99f9c5f0d1b6d8$var$durationMonth;
var $4a99f9c5f0d1b6d8$var$durationYear = $4a99f9c5f0d1b6d8$var$durationDay * 365;
module.exports.durationYear = $4a99f9c5f0d1b6d8$var$durationYear;

});


parcelRegister("4cZmZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $3107e32d729e3c8e$var$_interval = $3107e32d729e3c8e$var$_interopRequireDefault((parcelRequire("015gM")));

var $6p6jy = parcelRequire("6p6jy");
function $3107e32d729e3c8e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3107e32d729e3c8e$var$minute = (0, $3107e32d729e3c8e$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $6p6jy.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $6p6jy.durationMinute);
}, function(start, end) {
    return (end - start) / $6p6jy.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $3107e32d729e3c8e$var$_default = $3107e32d729e3c8e$var$minute;
module.exports.default = $3107e32d729e3c8e$var$_default;
var $3107e32d729e3c8e$var$minutes = $3107e32d729e3c8e$var$minute.range;
module.exports.minutes = $3107e32d729e3c8e$var$minutes;

});

parcelRegister("iImCL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $d9fde2bb2428ade4$var$_interval = $d9fde2bb2428ade4$var$_interopRequireDefault((parcelRequire("015gM")));

var $6p6jy = parcelRequire("6p6jy");
function $d9fde2bb2428ade4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d9fde2bb2428ade4$var$hour = (0, $d9fde2bb2428ade4$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $6p6jy.durationSecond - date.getMinutes() * $6p6jy.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $6p6jy.durationHour);
}, function(start, end) {
    return (end - start) / $6p6jy.durationHour;
}, function(date) {
    return date.getHours();
});
var $d9fde2bb2428ade4$var$_default = $d9fde2bb2428ade4$var$hour;
module.exports.default = $d9fde2bb2428ade4$var$_default;
var $d9fde2bb2428ade4$var$hours = $d9fde2bb2428ade4$var$hour.range;
module.exports.hours = $d9fde2bb2428ade4$var$hours;

});

parcelRegister("bdwKk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $82aa4f5221205814$var$_interval = $82aa4f5221205814$var$_interopRequireDefault((parcelRequire("015gM")));

var $6p6jy = parcelRequire("6p6jy");
function $82aa4f5221205814$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $82aa4f5221205814$var$day = (0, $82aa4f5221205814$var$_interval.default)(function(date) {
    return date.setHours(0, 0, 0, 0);
}, function(date, step) {
    return date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $6p6jy.durationMinute) / $6p6jy.durationDay;
}, function(date) {
    return date.getDate() - 1;
});
var $82aa4f5221205814$var$_default = $82aa4f5221205814$var$day;
module.exports.default = $82aa4f5221205814$var$_default;
var $82aa4f5221205814$var$days = $82aa4f5221205814$var$day.range;
module.exports.days = $82aa4f5221205814$var$days;

});

parcelRegister("5gByY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $3d5b959c6f19cfd4$var$_interval = $3d5b959c6f19cfd4$var$_interopRequireDefault((parcelRequire("015gM")));

var $6p6jy = parcelRequire("6p6jy");
function $3d5b959c6f19cfd4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3d5b959c6f19cfd4$var$weekday(i) {
    return (0, $3d5b959c6f19cfd4$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $6p6jy.durationMinute) / $6p6jy.durationWeek;
    });
}
var $3d5b959c6f19cfd4$var$sunday = $3d5b959c6f19cfd4$var$weekday(0);
module.exports.sunday = $3d5b959c6f19cfd4$var$sunday;
var $3d5b959c6f19cfd4$var$monday = $3d5b959c6f19cfd4$var$weekday(1);
module.exports.monday = $3d5b959c6f19cfd4$var$monday;
var $3d5b959c6f19cfd4$var$tuesday = $3d5b959c6f19cfd4$var$weekday(2);
module.exports.tuesday = $3d5b959c6f19cfd4$var$tuesday;
var $3d5b959c6f19cfd4$var$wednesday = $3d5b959c6f19cfd4$var$weekday(3);
module.exports.wednesday = $3d5b959c6f19cfd4$var$wednesday;
var $3d5b959c6f19cfd4$var$thursday = $3d5b959c6f19cfd4$var$weekday(4);
module.exports.thursday = $3d5b959c6f19cfd4$var$thursday;
var $3d5b959c6f19cfd4$var$friday = $3d5b959c6f19cfd4$var$weekday(5);
module.exports.friday = $3d5b959c6f19cfd4$var$friday;
var $3d5b959c6f19cfd4$var$saturday = $3d5b959c6f19cfd4$var$weekday(6);
module.exports.saturday = $3d5b959c6f19cfd4$var$saturday;
var $3d5b959c6f19cfd4$var$sundays = $3d5b959c6f19cfd4$var$sunday.range;
module.exports.sundays = $3d5b959c6f19cfd4$var$sundays;
var $3d5b959c6f19cfd4$var$mondays = $3d5b959c6f19cfd4$var$monday.range;
module.exports.mondays = $3d5b959c6f19cfd4$var$mondays;
var $3d5b959c6f19cfd4$var$tuesdays = $3d5b959c6f19cfd4$var$tuesday.range;
module.exports.tuesdays = $3d5b959c6f19cfd4$var$tuesdays;
var $3d5b959c6f19cfd4$var$wednesdays = $3d5b959c6f19cfd4$var$wednesday.range;
module.exports.wednesdays = $3d5b959c6f19cfd4$var$wednesdays;
var $3d5b959c6f19cfd4$var$thursdays = $3d5b959c6f19cfd4$var$thursday.range;
module.exports.thursdays = $3d5b959c6f19cfd4$var$thursdays;
var $3d5b959c6f19cfd4$var$fridays = $3d5b959c6f19cfd4$var$friday.range;
module.exports.fridays = $3d5b959c6f19cfd4$var$fridays;
var $3d5b959c6f19cfd4$var$saturdays = $3d5b959c6f19cfd4$var$saturday.range;
module.exports.saturdays = $3d5b959c6f19cfd4$var$saturdays;

});

parcelRegister("ljVbJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $f857bbb52d4b9285$var$_interval = $f857bbb52d4b9285$var$_interopRequireDefault((parcelRequire("015gM")));
function $f857bbb52d4b9285$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f857bbb52d4b9285$var$month = (0, $f857bbb52d4b9285$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $f857bbb52d4b9285$var$_default = $f857bbb52d4b9285$var$month;
module.exports.default = $f857bbb52d4b9285$var$_default;
var $f857bbb52d4b9285$var$months = $f857bbb52d4b9285$var$month.range;
module.exports.months = $f857bbb52d4b9285$var$months;

});

parcelRegister("eHi9a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $ab33286b778a3c21$var$_interval = $ab33286b778a3c21$var$_interopRequireDefault((parcelRequire("015gM")));
function $ab33286b778a3c21$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ab33286b778a3c21$var$year = (0, $ab33286b778a3c21$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$ab33286b778a3c21$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $ab33286b778a3c21$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $ab33286b778a3c21$var$_default = $ab33286b778a3c21$var$year;
module.exports.default = $ab33286b778a3c21$var$_default;
var $ab33286b778a3c21$var$years = $ab33286b778a3c21$var$year.range;
module.exports.years = $ab33286b778a3c21$var$years;

});

parcelRegister("6VFf0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $50b80e8ccb73c7f4$var$_interval = $50b80e8ccb73c7f4$var$_interopRequireDefault((parcelRequire("015gM")));

var $6p6jy = parcelRequire("6p6jy");
function $50b80e8ccb73c7f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $50b80e8ccb73c7f4$var$utcMinute = (0, $50b80e8ccb73c7f4$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $6p6jy.durationMinute);
}, function(start, end) {
    return (end - start) / $6p6jy.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $50b80e8ccb73c7f4$var$_default = $50b80e8ccb73c7f4$var$utcMinute;
module.exports.default = $50b80e8ccb73c7f4$var$_default;
var $50b80e8ccb73c7f4$var$utcMinutes = $50b80e8ccb73c7f4$var$utcMinute.range;
module.exports.utcMinutes = $50b80e8ccb73c7f4$var$utcMinutes;

});

parcelRegister("7miWt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $55b947feff7670a6$var$_interval = $55b947feff7670a6$var$_interopRequireDefault((parcelRequire("015gM")));

var $6p6jy = parcelRequire("6p6jy");
function $55b947feff7670a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $55b947feff7670a6$var$utcHour = (0, $55b947feff7670a6$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $6p6jy.durationHour);
}, function(start, end) {
    return (end - start) / $6p6jy.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $55b947feff7670a6$var$_default = $55b947feff7670a6$var$utcHour;
module.exports.default = $55b947feff7670a6$var$_default;
var $55b947feff7670a6$var$utcHours = $55b947feff7670a6$var$utcHour.range;
module.exports.utcHours = $55b947feff7670a6$var$utcHours;

});

parcelRegister("f8rPQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $02d7f46ac1ba5485$var$_interval = $02d7f46ac1ba5485$var$_interopRequireDefault((parcelRequire("015gM")));

var $6p6jy = parcelRequire("6p6jy");
function $02d7f46ac1ba5485$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $02d7f46ac1ba5485$var$utcDay = (0, $02d7f46ac1ba5485$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $6p6jy.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $02d7f46ac1ba5485$var$_default = $02d7f46ac1ba5485$var$utcDay;
module.exports.default = $02d7f46ac1ba5485$var$_default;
var $02d7f46ac1ba5485$var$utcDays = $02d7f46ac1ba5485$var$utcDay.range;
module.exports.utcDays = $02d7f46ac1ba5485$var$utcDays;

});

parcelRegister("eoXfq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $a7c143fb431e4910$var$_interval = $a7c143fb431e4910$var$_interopRequireDefault((parcelRequire("015gM")));

var $6p6jy = parcelRequire("6p6jy");
function $a7c143fb431e4910$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a7c143fb431e4910$var$utcWeekday(i) {
    return (0, $a7c143fb431e4910$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $6p6jy.durationWeek;
    });
}
var $a7c143fb431e4910$var$utcSunday = $a7c143fb431e4910$var$utcWeekday(0);
module.exports.utcSunday = $a7c143fb431e4910$var$utcSunday;
var $a7c143fb431e4910$var$utcMonday = $a7c143fb431e4910$var$utcWeekday(1);
module.exports.utcMonday = $a7c143fb431e4910$var$utcMonday;
var $a7c143fb431e4910$var$utcTuesday = $a7c143fb431e4910$var$utcWeekday(2);
module.exports.utcTuesday = $a7c143fb431e4910$var$utcTuesday;
var $a7c143fb431e4910$var$utcWednesday = $a7c143fb431e4910$var$utcWeekday(3);
module.exports.utcWednesday = $a7c143fb431e4910$var$utcWednesday;
var $a7c143fb431e4910$var$utcThursday = $a7c143fb431e4910$var$utcWeekday(4);
module.exports.utcThursday = $a7c143fb431e4910$var$utcThursday;
var $a7c143fb431e4910$var$utcFriday = $a7c143fb431e4910$var$utcWeekday(5);
module.exports.utcFriday = $a7c143fb431e4910$var$utcFriday;
var $a7c143fb431e4910$var$utcSaturday = $a7c143fb431e4910$var$utcWeekday(6);
module.exports.utcSaturday = $a7c143fb431e4910$var$utcSaturday;
var $a7c143fb431e4910$var$utcSundays = $a7c143fb431e4910$var$utcSunday.range;
module.exports.utcSundays = $a7c143fb431e4910$var$utcSundays;
var $a7c143fb431e4910$var$utcMondays = $a7c143fb431e4910$var$utcMonday.range;
module.exports.utcMondays = $a7c143fb431e4910$var$utcMondays;
var $a7c143fb431e4910$var$utcTuesdays = $a7c143fb431e4910$var$utcTuesday.range;
module.exports.utcTuesdays = $a7c143fb431e4910$var$utcTuesdays;
var $a7c143fb431e4910$var$utcWednesdays = $a7c143fb431e4910$var$utcWednesday.range;
module.exports.utcWednesdays = $a7c143fb431e4910$var$utcWednesdays;
var $a7c143fb431e4910$var$utcThursdays = $a7c143fb431e4910$var$utcThursday.range;
module.exports.utcThursdays = $a7c143fb431e4910$var$utcThursdays;
var $a7c143fb431e4910$var$utcFridays = $a7c143fb431e4910$var$utcFriday.range;
module.exports.utcFridays = $a7c143fb431e4910$var$utcFridays;
var $a7c143fb431e4910$var$utcSaturdays = $a7c143fb431e4910$var$utcSaturday.range;
module.exports.utcSaturdays = $a7c143fb431e4910$var$utcSaturdays;

});

parcelRegister("f1MPw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $af0cd39ea3b51a24$var$_interval = $af0cd39ea3b51a24$var$_interopRequireDefault((parcelRequire("015gM")));
function $af0cd39ea3b51a24$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $af0cd39ea3b51a24$var$utcMonth = (0, $af0cd39ea3b51a24$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $af0cd39ea3b51a24$var$_default = $af0cd39ea3b51a24$var$utcMonth;
module.exports.default = $af0cd39ea3b51a24$var$_default;
var $af0cd39ea3b51a24$var$utcMonths = $af0cd39ea3b51a24$var$utcMonth.range;
module.exports.utcMonths = $af0cd39ea3b51a24$var$utcMonths;

});

parcelRegister("3wHZ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $29167a9bacd7d3df$var$_interval = $29167a9bacd7d3df$var$_interopRequireDefault((parcelRequire("015gM")));
function $29167a9bacd7d3df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $29167a9bacd7d3df$var$utcYear = (0, $29167a9bacd7d3df$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$29167a9bacd7d3df$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $29167a9bacd7d3df$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $29167a9bacd7d3df$var$_default = $29167a9bacd7d3df$var$utcYear;
module.exports.default = $29167a9bacd7d3df$var$_default;
var $29167a9bacd7d3df$var$utcYears = $29167a9bacd7d3df$var$utcYear.range;
module.exports.utcYears = $29167a9bacd7d3df$var$utcYears;

});

parcelRegister("7NpsY", function(module, exports) {

var $52tJv = parcelRequire("52tJv");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $72vjU = parcelRequire("72vjU");

var $6p6jy = parcelRequire("6p6jy");

var $5ad0dd1bf237fb37$var$_millisecond = $5ad0dd1bf237fb37$var$_interopRequireDefault((parcelRequire("5PbDH")));

var $5ad0dd1bf237fb37$var$_second = $5ad0dd1bf237fb37$var$_interopRequireDefault((parcelRequire("b3KDa")));

var $5ad0dd1bf237fb37$var$_minute = $5ad0dd1bf237fb37$var$_interopRequireDefault((parcelRequire("4cZmZ")));

var $5ad0dd1bf237fb37$var$_hour = $5ad0dd1bf237fb37$var$_interopRequireDefault((parcelRequire("iImCL")));

var $5ad0dd1bf237fb37$var$_day = $5ad0dd1bf237fb37$var$_interopRequireDefault((parcelRequire("bdwKk")));

var $5gByY = parcelRequire("5gByY");

var $5ad0dd1bf237fb37$var$_month = $5ad0dd1bf237fb37$var$_interopRequireDefault((parcelRequire("ljVbJ")));

var $5ad0dd1bf237fb37$var$_year = $5ad0dd1bf237fb37$var$_interopRequireDefault((parcelRequire("eHi9a")));

var $5ad0dd1bf237fb37$var$_utcMinute = $5ad0dd1bf237fb37$var$_interopRequireDefault((parcelRequire("6VFf0")));

var $5ad0dd1bf237fb37$var$_utcHour = $5ad0dd1bf237fb37$var$_interopRequireDefault((parcelRequire("7miWt")));

var $5ad0dd1bf237fb37$var$_utcDay = $5ad0dd1bf237fb37$var$_interopRequireDefault((parcelRequire("f8rPQ")));

var $eoXfq = parcelRequire("eoXfq");

var $5ad0dd1bf237fb37$var$_utcMonth = $5ad0dd1bf237fb37$var$_interopRequireDefault((parcelRequire("f1MPw")));

var $5ad0dd1bf237fb37$var$_utcYear = $5ad0dd1bf237fb37$var$_interopRequireDefault((parcelRequire("3wHZ5")));
function $5ad0dd1bf237fb37$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5ad0dd1bf237fb37$var$ticker(year, month, week, day, hour, minute) {
    var tickIntervals = [
        [
            $5ad0dd1bf237fb37$var$_second.default,
            1,
            $6p6jy.durationSecond
        ],
        [
            $5ad0dd1bf237fb37$var$_second.default,
            5,
            5 * $6p6jy.durationSecond
        ],
        [
            $5ad0dd1bf237fb37$var$_second.default,
            15,
            15 * $6p6jy.durationSecond
        ],
        [
            $5ad0dd1bf237fb37$var$_second.default,
            30,
            30 * $6p6jy.durationSecond
        ],
        [
            minute,
            1,
            $6p6jy.durationMinute
        ],
        [
            minute,
            5,
            5 * $6p6jy.durationMinute
        ],
        [
            minute,
            15,
            15 * $6p6jy.durationMinute
        ],
        [
            minute,
            30,
            30 * $6p6jy.durationMinute
        ],
        [
            hour,
            1,
            $6p6jy.durationHour
        ],
        [
            hour,
            3,
            3 * $6p6jy.durationHour
        ],
        [
            hour,
            6,
            6 * $6p6jy.durationHour
        ],
        [
            hour,
            12,
            12 * $6p6jy.durationHour
        ],
        [
            day,
            1,
            $6p6jy.durationDay
        ],
        [
            day,
            2,
            2 * $6p6jy.durationDay
        ],
        [
            week,
            1,
            $6p6jy.durationWeek
        ],
        [
            month,
            1,
            $6p6jy.durationMonth
        ],
        [
            month,
            3,
            3 * $6p6jy.durationMonth
        ],
        [
            year,
            1,
            $6p6jy.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        var reverse = stop < start;
        var ref;
        if (reverse) ref = [
            stop,
            start
        ], start = ref[0], stop = ref[1], ref;
        var interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        var _$ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? _$ticks.reverse() : _$ticks;
    }
    function tickInterval(start, stop, count) {
        var target = Math.abs(stop - start) / count;
        var i = (0, $72vjU.bisector)(function(param) {
            var _param = (0, $52tJv._)(param, 3), step = _param[2];
            return step;
        }).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $72vjU.tickStep)(start / $6p6jy.durationYear, stop / $6p6jy.durationYear, count));
        if (i === 0) return $5ad0dd1bf237fb37$var$_millisecond.default.every(Math.max((0, $72vjU.tickStep)(start, stop, count), 1));
        var _tickIntervals_ = (0, $52tJv._)(tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i], 2), t = _tickIntervals_[0], step = _tickIntervals_[1];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
var $5ad0dd1bf237fb37$var$_ticker = (0, $52tJv._)($5ad0dd1bf237fb37$var$ticker($5ad0dd1bf237fb37$var$_utcYear.default, $5ad0dd1bf237fb37$var$_utcMonth.default, $eoXfq.utcSunday, $5ad0dd1bf237fb37$var$_utcDay.default, $5ad0dd1bf237fb37$var$_utcHour.default, $5ad0dd1bf237fb37$var$_utcMinute.default), 2), $5ad0dd1bf237fb37$var$utcTicks = $5ad0dd1bf237fb37$var$_ticker[0], $5ad0dd1bf237fb37$var$utcTickInterval = $5ad0dd1bf237fb37$var$_ticker[1];
module.exports.utcTickInterval = $5ad0dd1bf237fb37$var$utcTickInterval;
module.exports.utcTicks = $5ad0dd1bf237fb37$var$utcTicks;
var $5ad0dd1bf237fb37$var$_ticker1 = (0, $52tJv._)($5ad0dd1bf237fb37$var$ticker($5ad0dd1bf237fb37$var$_year.default, $5ad0dd1bf237fb37$var$_month.default, $5gByY.sunday, $5ad0dd1bf237fb37$var$_day.default, $5ad0dd1bf237fb37$var$_hour.default, $5ad0dd1bf237fb37$var$_minute.default), 2), $5ad0dd1bf237fb37$var$timeTicks = $5ad0dd1bf237fb37$var$_ticker1[0], $5ad0dd1bf237fb37$var$timeTickInterval = $5ad0dd1bf237fb37$var$_ticker1[1];
module.exports.timeTickInterval = $5ad0dd1bf237fb37$var$timeTickInterval;
module.exports.timeTicks = $5ad0dd1bf237fb37$var$timeTicks;

});


parcelRegister("5Pmfr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function get() {
        return $43e2f92f03e3155e$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function get() {
        return $43e2f92f03e3155e$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function get() {
        return $43e2f92f03e3155e$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function get() {
        return $43e2f92f03e3155e$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function get() {
        return $43e2f92f03e3155e$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function get() {
        return $43e2f92f03e3155e$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function get() {
        return $43e2f92f03e3155e$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function get() {
        return $43e2f92f03e3155e$var$_defaultLocale.utcParse;
    }
});

var $43e2f92f03e3155e$var$_defaultLocale = $43e2f92f03e3155e$var$_interopRequireWildcard((parcelRequire("dzrFH")));

var $43e2f92f03e3155e$var$_locale = $43e2f92f03e3155e$var$_interopRequireDefault((parcelRequire("eGt8U")));

var $43e2f92f03e3155e$var$_isoFormat = $43e2f92f03e3155e$var$_interopRequireDefault((parcelRequire("5iklm")));

var $43e2f92f03e3155e$var$_isoParse = $43e2f92f03e3155e$var$_interopRequireDefault((parcelRequire("7JgFm")));
function $43e2f92f03e3155e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $43e2f92f03e3155e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($43e2f92f03e3155e$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $43e2f92f03e3155e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $43e2f92f03e3155e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("dzrFH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9e140240ed26bf7b$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $9e140240ed26bf7b$var$_locale = $9e140240ed26bf7b$var$_interopRequireDefault((parcelRequire("eGt8U")));
function $9e140240ed26bf7b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9e140240ed26bf7b$var$locale;
var $9e140240ed26bf7b$var$timeFormat;
module.exports.timeFormat = $9e140240ed26bf7b$var$timeFormat;
var $9e140240ed26bf7b$var$timeParse;
module.exports.timeParse = $9e140240ed26bf7b$var$timeParse;
var $9e140240ed26bf7b$var$utcFormat;
module.exports.utcFormat = $9e140240ed26bf7b$var$utcFormat;
var $9e140240ed26bf7b$var$utcParse;
module.exports.utcParse = $9e140240ed26bf7b$var$utcParse;
$9e140240ed26bf7b$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $9e140240ed26bf7b$var$defaultLocale(definition) {
    $9e140240ed26bf7b$var$locale = (0, $9e140240ed26bf7b$var$_locale.default)(definition);
    module.exports.timeFormat = $9e140240ed26bf7b$var$timeFormat = $9e140240ed26bf7b$var$locale.format;
    module.exports.timeParse = $9e140240ed26bf7b$var$timeParse = $9e140240ed26bf7b$var$locale.parse;
    module.exports.utcFormat = $9e140240ed26bf7b$var$utcFormat = $9e140240ed26bf7b$var$locale.utcFormat;
    module.exports.utcParse = $9e140240ed26bf7b$var$utcParse = $9e140240ed26bf7b$var$locale.utcParse;
    return $9e140240ed26bf7b$var$locale;
}

});
parcelRegister("eGt8U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ab0b980d128d9274$var$formatLocale;

var $8B7rL = parcelRequire("8B7rL");
function $ab0b980d128d9274$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $ab0b980d128d9274$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $ab0b980d128d9274$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $ab0b980d128d9274$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $ab0b980d128d9274$var$formatRe(locale_periods), periodLookup = $ab0b980d128d9274$var$formatLookup(locale_periods), weekdayRe = $ab0b980d128d9274$var$formatRe(locale_weekdays), weekdayLookup = $ab0b980d128d9274$var$formatLookup(locale_weekdays), shortWeekdayRe = $ab0b980d128d9274$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $ab0b980d128d9274$var$formatLookup(locale_shortWeekdays), monthRe = $ab0b980d128d9274$var$formatRe(locale_months), monthLookup = $ab0b980d128d9274$var$formatLookup(locale_months), shortMonthRe = $ab0b980d128d9274$var$formatRe(locale_shortMonths), shortMonthLookup = $ab0b980d128d9274$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $ab0b980d128d9274$var$formatDayOfMonth,
        "e": $ab0b980d128d9274$var$formatDayOfMonth,
        "f": $ab0b980d128d9274$var$formatMicroseconds,
        "g": $ab0b980d128d9274$var$formatYearISO,
        "G": $ab0b980d128d9274$var$formatFullYearISO,
        "H": $ab0b980d128d9274$var$formatHour24,
        "I": $ab0b980d128d9274$var$formatHour12,
        "j": $ab0b980d128d9274$var$formatDayOfYear,
        "L": $ab0b980d128d9274$var$formatMilliseconds,
        "m": $ab0b980d128d9274$var$formatMonthNumber,
        "M": $ab0b980d128d9274$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $ab0b980d128d9274$var$formatUnixTimestamp,
        "s": $ab0b980d128d9274$var$formatUnixTimestampSeconds,
        "S": $ab0b980d128d9274$var$formatSeconds,
        "u": $ab0b980d128d9274$var$formatWeekdayNumberMonday,
        "U": $ab0b980d128d9274$var$formatWeekNumberSunday,
        "V": $ab0b980d128d9274$var$formatWeekNumberISO,
        "w": $ab0b980d128d9274$var$formatWeekdayNumberSunday,
        "W": $ab0b980d128d9274$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $ab0b980d128d9274$var$formatYear,
        "Y": $ab0b980d128d9274$var$formatFullYear,
        "Z": $ab0b980d128d9274$var$formatZone,
        "%": $ab0b980d128d9274$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $ab0b980d128d9274$var$formatUTCDayOfMonth,
        "e": $ab0b980d128d9274$var$formatUTCDayOfMonth,
        "f": $ab0b980d128d9274$var$formatUTCMicroseconds,
        "g": $ab0b980d128d9274$var$formatUTCYearISO,
        "G": $ab0b980d128d9274$var$formatUTCFullYearISO,
        "H": $ab0b980d128d9274$var$formatUTCHour24,
        "I": $ab0b980d128d9274$var$formatUTCHour12,
        "j": $ab0b980d128d9274$var$formatUTCDayOfYear,
        "L": $ab0b980d128d9274$var$formatUTCMilliseconds,
        "m": $ab0b980d128d9274$var$formatUTCMonthNumber,
        "M": $ab0b980d128d9274$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $ab0b980d128d9274$var$formatUnixTimestamp,
        "s": $ab0b980d128d9274$var$formatUnixTimestampSeconds,
        "S": $ab0b980d128d9274$var$formatUTCSeconds,
        "u": $ab0b980d128d9274$var$formatUTCWeekdayNumberMonday,
        "U": $ab0b980d128d9274$var$formatUTCWeekNumberSunday,
        "V": $ab0b980d128d9274$var$formatUTCWeekNumberISO,
        "w": $ab0b980d128d9274$var$formatUTCWeekdayNumberSunday,
        "W": $ab0b980d128d9274$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $ab0b980d128d9274$var$formatUTCYear,
        "Y": $ab0b980d128d9274$var$formatUTCFullYear,
        "Z": $ab0b980d128d9274$var$formatUTCZone,
        "%": $ab0b980d128d9274$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $ab0b980d128d9274$var$parseDayOfMonth,
        "e": $ab0b980d128d9274$var$parseDayOfMonth,
        "f": $ab0b980d128d9274$var$parseMicroseconds,
        "g": $ab0b980d128d9274$var$parseYear,
        "G": $ab0b980d128d9274$var$parseFullYear,
        "H": $ab0b980d128d9274$var$parseHour24,
        "I": $ab0b980d128d9274$var$parseHour24,
        "j": $ab0b980d128d9274$var$parseDayOfYear,
        "L": $ab0b980d128d9274$var$parseMilliseconds,
        "m": $ab0b980d128d9274$var$parseMonthNumber,
        "M": $ab0b980d128d9274$var$parseMinutes,
        "p": parsePeriod,
        "q": $ab0b980d128d9274$var$parseQuarter,
        "Q": $ab0b980d128d9274$var$parseUnixTimestamp,
        "s": $ab0b980d128d9274$var$parseUnixTimestampSeconds,
        "S": $ab0b980d128d9274$var$parseSeconds,
        "u": $ab0b980d128d9274$var$parseWeekdayNumberMonday,
        "U": $ab0b980d128d9274$var$parseWeekNumberSunday,
        "V": $ab0b980d128d9274$var$parseWeekNumberISO,
        "w": $ab0b980d128d9274$var$parseWeekdayNumberSunday,
        "W": $ab0b980d128d9274$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $ab0b980d128d9274$var$parseYear,
        "Y": $ab0b980d128d9274$var$parseFullYear,
        "Z": $ab0b980d128d9274$var$parseZone,
        "%": $ab0b980d128d9274$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $ab0b980d128d9274$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $ab0b980d128d9274$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $ab0b980d128d9274$var$utcDate($ab0b980d128d9274$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $8B7rL.utcMonday.ceil(week) : (0, $8B7rL.utcMonday)(week);
                    week = $8B7rL.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $ab0b980d128d9274$var$localDate($ab0b980d128d9274$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $8B7rL.timeMonday.ceil(week) : (0, $8B7rL.timeMonday)(week);
                    week = $8B7rL.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $ab0b980d128d9274$var$utcDate($ab0b980d128d9274$var$newDate(d.y, 0, 1)).getUTCDay() : $ab0b980d128d9274$var$localDate($ab0b980d128d9274$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $ab0b980d128d9274$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $ab0b980d128d9274$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $ab0b980d128d9274$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function format(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function parse(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function utcFormat(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function utcParse(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $ab0b980d128d9274$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $ab0b980d128d9274$var$numberRe = /^\s*\d+/, // note: ignores next directive
$ab0b980d128d9274$var$percentRe = /^%/, $ab0b980d128d9274$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $ab0b980d128d9274$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $ab0b980d128d9274$var$requote(s) {
    return s.replace($ab0b980d128d9274$var$requoteRe, "\\$&");
}
function $ab0b980d128d9274$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($ab0b980d128d9274$var$requote).join("|") + ")", "i");
}
function $ab0b980d128d9274$var$formatLookup(names) {
    return new Map(names.map(function(name, i) {
        return [
            name.toLowerCase(),
            i
        ];
    }));
}
function $ab0b980d128d9274$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseWeekNumberSunday(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseWeekNumberISO(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseWeekNumberMonday(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseFullYear(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseYear(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseQuarter(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseMonthNumber(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseDayOfMonth(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseDayOfYear(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseHour24(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseMinutes(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseSeconds(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseMilliseconds(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseMicroseconds(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseLiteralPercent(d, string, i) {
    var n = $ab0b980d128d9274$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $ab0b980d128d9274$var$parseUnixTimestamp(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $ab0b980d128d9274$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $ab0b980d128d9274$var$formatDayOfMonth(d, p) {
    return $ab0b980d128d9274$var$pad(d.getDate(), p, 2);
}
function $ab0b980d128d9274$var$formatHour24(d, p) {
    return $ab0b980d128d9274$var$pad(d.getHours(), p, 2);
}
function $ab0b980d128d9274$var$formatHour12(d, p) {
    return $ab0b980d128d9274$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $ab0b980d128d9274$var$formatDayOfYear(d, p) {
    return $ab0b980d128d9274$var$pad(1 + $8B7rL.timeDay.count((0, $8B7rL.timeYear)(d), d), p, 3);
}
function $ab0b980d128d9274$var$formatMilliseconds(d, p) {
    return $ab0b980d128d9274$var$pad(d.getMilliseconds(), p, 3);
}
function $ab0b980d128d9274$var$formatMicroseconds(d, p) {
    return $ab0b980d128d9274$var$formatMilliseconds(d, p) + "000";
}
function $ab0b980d128d9274$var$formatMonthNumber(d, p) {
    return $ab0b980d128d9274$var$pad(d.getMonth() + 1, p, 2);
}
function $ab0b980d128d9274$var$formatMinutes(d, p) {
    return $ab0b980d128d9274$var$pad(d.getMinutes(), p, 2);
}
function $ab0b980d128d9274$var$formatSeconds(d, p) {
    return $ab0b980d128d9274$var$pad(d.getSeconds(), p, 2);
}
function $ab0b980d128d9274$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $ab0b980d128d9274$var$formatWeekNumberSunday(d, p) {
    return $ab0b980d128d9274$var$pad($8B7rL.timeSunday.count((0, $8B7rL.timeYear)(d) - 1, d), p, 2);
}
function $ab0b980d128d9274$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $8B7rL.timeThursday)(d) : $8B7rL.timeThursday.ceil(d);
}
function $ab0b980d128d9274$var$formatWeekNumberISO(d, p) {
    d = $ab0b980d128d9274$var$dISO(d);
    return $ab0b980d128d9274$var$pad($8B7rL.timeThursday.count((0, $8B7rL.timeYear)(d), d) + ((0, $8B7rL.timeYear)(d).getDay() === 4), p, 2);
}
function $ab0b980d128d9274$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $ab0b980d128d9274$var$formatWeekNumberMonday(d, p) {
    return $ab0b980d128d9274$var$pad($8B7rL.timeMonday.count((0, $8B7rL.timeYear)(d) - 1, d), p, 2);
}
function $ab0b980d128d9274$var$formatYear(d, p) {
    return $ab0b980d128d9274$var$pad(d.getFullYear() % 100, p, 2);
}
function $ab0b980d128d9274$var$formatYearISO(d, p) {
    d = $ab0b980d128d9274$var$dISO(d);
    return $ab0b980d128d9274$var$pad(d.getFullYear() % 100, p, 2);
}
function $ab0b980d128d9274$var$formatFullYear(d, p) {
    return $ab0b980d128d9274$var$pad(d.getFullYear() % 10000, p, 4);
}
function $ab0b980d128d9274$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $8B7rL.timeThursday)(d) : $8B7rL.timeThursday.ceil(d);
    return $ab0b980d128d9274$var$pad(d.getFullYear() % 10000, p, 4);
}
function $ab0b980d128d9274$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $ab0b980d128d9274$var$pad(z / 60 | 0, "0", 2) + $ab0b980d128d9274$var$pad(z % 60, "0", 2);
}
function $ab0b980d128d9274$var$formatUTCDayOfMonth(d, p) {
    return $ab0b980d128d9274$var$pad(d.getUTCDate(), p, 2);
}
function $ab0b980d128d9274$var$formatUTCHour24(d, p) {
    return $ab0b980d128d9274$var$pad(d.getUTCHours(), p, 2);
}
function $ab0b980d128d9274$var$formatUTCHour12(d, p) {
    return $ab0b980d128d9274$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $ab0b980d128d9274$var$formatUTCDayOfYear(d, p) {
    return $ab0b980d128d9274$var$pad(1 + $8B7rL.utcDay.count((0, $8B7rL.utcYear)(d), d), p, 3);
}
function $ab0b980d128d9274$var$formatUTCMilliseconds(d, p) {
    return $ab0b980d128d9274$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $ab0b980d128d9274$var$formatUTCMicroseconds(d, p) {
    return $ab0b980d128d9274$var$formatUTCMilliseconds(d, p) + "000";
}
function $ab0b980d128d9274$var$formatUTCMonthNumber(d, p) {
    return $ab0b980d128d9274$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $ab0b980d128d9274$var$formatUTCMinutes(d, p) {
    return $ab0b980d128d9274$var$pad(d.getUTCMinutes(), p, 2);
}
function $ab0b980d128d9274$var$formatUTCSeconds(d, p) {
    return $ab0b980d128d9274$var$pad(d.getUTCSeconds(), p, 2);
}
function $ab0b980d128d9274$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $ab0b980d128d9274$var$formatUTCWeekNumberSunday(d, p) {
    return $ab0b980d128d9274$var$pad($8B7rL.utcSunday.count((0, $8B7rL.utcYear)(d) - 1, d), p, 2);
}
function $ab0b980d128d9274$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $8B7rL.utcThursday)(d) : $8B7rL.utcThursday.ceil(d);
}
function $ab0b980d128d9274$var$formatUTCWeekNumberISO(d, p) {
    d = $ab0b980d128d9274$var$UTCdISO(d);
    return $ab0b980d128d9274$var$pad($8B7rL.utcThursday.count((0, $8B7rL.utcYear)(d), d) + ((0, $8B7rL.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $ab0b980d128d9274$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $ab0b980d128d9274$var$formatUTCWeekNumberMonday(d, p) {
    return $ab0b980d128d9274$var$pad($8B7rL.utcMonday.count((0, $8B7rL.utcYear)(d) - 1, d), p, 2);
}
function $ab0b980d128d9274$var$formatUTCYear(d, p) {
    return $ab0b980d128d9274$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $ab0b980d128d9274$var$formatUTCYearISO(d, p) {
    d = $ab0b980d128d9274$var$UTCdISO(d);
    return $ab0b980d128d9274$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $ab0b980d128d9274$var$formatUTCFullYear(d, p) {
    return $ab0b980d128d9274$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $ab0b980d128d9274$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $8B7rL.utcThursday)(d) : $8B7rL.utcThursday.ceil(d);
    return $ab0b980d128d9274$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $ab0b980d128d9274$var$formatUTCZone() {
    return "+0000";
}
function $ab0b980d128d9274$var$formatLiteralPercent() {
    return "%";
}
function $ab0b980d128d9274$var$formatUnixTimestamp(d) {
    return +d;
}
function $ab0b980d128d9274$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("5iklm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $dzrFH = parcelRequire("dzrFH");
var $3dae6a036c4ecb90$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $3dae6a036c4ecb90$var$isoSpecifier;
function $3dae6a036c4ecb90$var$formatIsoNative(date) {
    return date.toISOString();
}
var $3dae6a036c4ecb90$var$formatIso = Date.prototype.toISOString ? $3dae6a036c4ecb90$var$formatIsoNative : (0, $dzrFH.utcFormat)($3dae6a036c4ecb90$var$isoSpecifier);
var $3dae6a036c4ecb90$var$_default = $3dae6a036c4ecb90$var$formatIso;
module.exports.default = $3dae6a036c4ecb90$var$_default;

});

parcelRegister("7JgFm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5iklm = parcelRequire("5iklm");

var $dzrFH = parcelRequire("dzrFH");
function $5a09a9e96c361f20$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $5a09a9e96c361f20$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $5a09a9e96c361f20$var$parseIsoNative : (0, $dzrFH.utcParse)($5iklm.isoSpecifier);
var $5a09a9e96c361f20$var$_default = $5a09a9e96c361f20$var$parseIso;
module.exports.default = $5a09a9e96c361f20$var$_default;

});



parcelRegister("ekxRg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6ed327374d86dcc$var$utcTime;

var $8B7rL = parcelRequire("8B7rL");

var $5Pmfr = parcelRequire("5Pmfr");

var $haq1g = parcelRequire("haq1g");

var $8hPfX = parcelRequire("8hPfX");
function $a6ed327374d86dcc$var$utcTime() {
    return $8hPfX.initRange.apply((0, $haq1g.calendar)($8B7rL.utcTicks, $8B7rL.utcTickInterval, $8B7rL.utcYear, $8B7rL.utcMonth, $8B7rL.utcWeek, $8B7rL.utcDay, $8B7rL.utcHour, $8B7rL.utcMinute, $8B7rL.utcSecond, $5Pmfr.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("fTMSh", function(module, exports) {

var $52tJv = parcelRequire("52tJv");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $b931e78acfc3f0e6$var$copy;
module.exports.default = $b931e78acfc3f0e6$var$sequential;
module.exports.sequentialLog = $b931e78acfc3f0e6$var$sequentialLog;
module.exports.sequentialPow = $b931e78acfc3f0e6$var$sequentialPow;
module.exports.sequentialSqrt = $b931e78acfc3f0e6$var$sequentialSqrt;
module.exports.sequentialSymlog = $b931e78acfc3f0e6$var$sequentialSymlog;

var $7HpsE = parcelRequire("7HpsE");

var $1Vqet = parcelRequire("1Vqet");

var $8hPfX = parcelRequire("8hPfX");

var $1SvFl = parcelRequire("1SvFl");

var $eBnvE = parcelRequire("eBnvE");

var $4ICux = parcelRequire("4ICux");

var $lI3XK = parcelRequire("lI3XK");
function $b931e78acfc3f0e6$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $1Vqet.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        var ref;
        return arguments.length ? (ref = (0, $52tJv._)(_, 2), x0 = ref[0], x1 = ref[1], ref, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            var ref;
            return arguments.length ? (ref = (0, $52tJv._)(_, 2), r0 = ref[0], r1 = ref[1], ref, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($7HpsE.interpolate);
    scale.rangeRound = range($7HpsE.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $b931e78acfc3f0e6$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $b931e78acfc3f0e6$var$sequential() {
    var scale = (0, $1SvFl.linearish)($b931e78acfc3f0e6$var$transformer()($1Vqet.identity));
    scale.copy = function() {
        return $b931e78acfc3f0e6$var$copy(scale, $b931e78acfc3f0e6$var$sequential());
    };
    return $8hPfX.initInterpolator.apply(scale, arguments);
}
function $b931e78acfc3f0e6$var$sequentialLog() {
    var scale = (0, $eBnvE.loggish)($b931e78acfc3f0e6$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $b931e78acfc3f0e6$var$copy(scale, $b931e78acfc3f0e6$var$sequentialLog()).base(scale.base());
    };
    return $8hPfX.initInterpolator.apply(scale, arguments);
}
function $b931e78acfc3f0e6$var$sequentialSymlog() {
    var scale = (0, $4ICux.symlogish)($b931e78acfc3f0e6$var$transformer());
    scale.copy = function() {
        return $b931e78acfc3f0e6$var$copy(scale, $b931e78acfc3f0e6$var$sequentialSymlog()).constant(scale.constant());
    };
    return $8hPfX.initInterpolator.apply(scale, arguments);
}
function $b931e78acfc3f0e6$var$sequentialPow() {
    var scale = (0, $lI3XK.powish)($b931e78acfc3f0e6$var$transformer());
    scale.copy = function() {
        return $b931e78acfc3f0e6$var$copy(scale, $b931e78acfc3f0e6$var$sequentialPow()).exponent(scale.exponent());
    };
    return $8hPfX.initInterpolator.apply(scale, arguments);
}
function $b931e78acfc3f0e6$var$sequentialSqrt() {
    return $b931e78acfc3f0e6$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("ka59Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ead8be0fbf841e7d$var$sequentialQuantile;

var $72vjU = parcelRequire("72vjU");

var $1Vqet = parcelRequire("1Vqet");

var $8hPfX = parcelRequire("8hPfX");
function $ead8be0fbf841e7d$var$sequentialQuantile() {
    var domain = [], interpolator = $1Vqet.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $72vjU.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                if (d != null && !isNaN(d = +d)) domain.push(d);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        domain.sort($72vjU.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map(function(d, i) {
            return interpolator(i / (domain.length - 1));
        });
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, function(_, i) {
            return (0, $72vjU.quantile)(domain, i / n);
        });
    };
    scale.copy = function() {
        return $ead8be0fbf841e7d$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $8hPfX.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("bqYJr", function(module, exports) {

var $52tJv = parcelRequire("52tJv");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $85313b8849d34b7e$var$diverging;
module.exports.divergingLog = $85313b8849d34b7e$var$divergingLog;
module.exports.divergingPow = $85313b8849d34b7e$var$divergingPow;
module.exports.divergingSqrt = $85313b8849d34b7e$var$divergingSqrt;
module.exports.divergingSymlog = $85313b8849d34b7e$var$divergingSymlog;

var $7HpsE = parcelRequire("7HpsE");

var $1Vqet = parcelRequire("1Vqet");

var $8hPfX = parcelRequire("8hPfX");

var $1SvFl = parcelRequire("1SvFl");

var $eBnvE = parcelRequire("eBnvE");

var $fTMSh = parcelRequire("fTMSh");

var $4ICux = parcelRequire("4ICux");

var $lI3XK = parcelRequire("lI3XK");
function $85313b8849d34b7e$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $1Vqet.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        var ref;
        return arguments.length ? (ref = (0, $52tJv._)(_, 3), x0 = ref[0], x1 = ref[1], x2 = ref[2], ref, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            var ref;
            return arguments.length ? (ref = (0, $52tJv._)(_, 3), r0 = ref[0], r1 = ref[1], r2 = ref[2], ref, interpolator = (0, $7HpsE.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($7HpsE.interpolate);
    scale.rangeRound = range($7HpsE.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $85313b8849d34b7e$var$diverging() {
    var scale = (0, $1SvFl.linearish)($85313b8849d34b7e$var$transformer()($1Vqet.identity));
    scale.copy = function() {
        return (0, $fTMSh.copy)(scale, $85313b8849d34b7e$var$diverging());
    };
    return $8hPfX.initInterpolator.apply(scale, arguments);
}
function $85313b8849d34b7e$var$divergingLog() {
    var scale = (0, $eBnvE.loggish)($85313b8849d34b7e$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $fTMSh.copy)(scale, $85313b8849d34b7e$var$divergingLog()).base(scale.base());
    };
    return $8hPfX.initInterpolator.apply(scale, arguments);
}
function $85313b8849d34b7e$var$divergingSymlog() {
    var scale = (0, $4ICux.symlogish)($85313b8849d34b7e$var$transformer());
    scale.copy = function() {
        return (0, $fTMSh.copy)(scale, $85313b8849d34b7e$var$divergingSymlog()).constant(scale.constant());
    };
    return $8hPfX.initInterpolator.apply(scale, arguments);
}
function $85313b8849d34b7e$var$divergingPow() {
    var scale = (0, $lI3XK.powish)($85313b8849d34b7e$var$transformer());
    scale.copy = function() {
        return (0, $fTMSh.copy)(scale, $85313b8849d34b7e$var$divergingPow()).exponent(scale.exponent());
    };
    return $8hPfX.initInterpolator.apply(scale, arguments);
}
function $85313b8849d34b7e$var$divergingSqrt() {
    return $85313b8849d34b7e$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("9t9wG", function(module, exports) {

var $lyFcw = parcelRequire("lyFcw");

var $7hBys = parcelRequire("7hBys");

var $5sFFs = parcelRequire("5sFFs");

var $057QZ = parcelRequire("057QZ");

var $g12Hy = parcelRequire("g12Hy");

var $4LHB0 = parcelRequire("4LHB0");

var $l0C3h = parcelRequire("l0C3h");

var $lNbhr = parcelRequire("lNbhr");

var $iB2CV = parcelRequire("iB2CV");

var $cZGNE = parcelRequire("cZGNE");

var $3CqVU = parcelRequire("3CqVU");

var $fC5Fv = parcelRequire("fC5Fv");

var $8O2fV = parcelRequire("8O2fV");

var $iCQyW = parcelRequire("iCQyW");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");

var $fyztb = parcelRequire("fyztb");

var $9hJkT = parcelRequire("9hJkT");

var $4jYWU = parcelRequire("4jYWU");

var $ajhIL = parcelRequire("ajhIL");

var $kTBk6 = parcelRequire("kTBk6");

var $cUP0b = parcelRequire("cUP0b");
var $6e4e36316ba04d62$require$Buffer = $cUP0b.Buffer;










/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = root.pdfjsLib = factory();
})(globalThis, function() {
    return /******/ function() {
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VerbosityLevel = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.RenderingIntentFlag = exports.PromiseCapability = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.PageActionEventType = exports.OPS = exports.MissingPDFException = exports.MAX_IMAGE_SIZE_TO_CACHE = exports.LINE_FACTOR = exports.LINE_DESCENT_FACTOR = exports.InvalidPDFException = exports.ImageKind = exports.IDENTITY_MATRIX = exports.FormatError = exports.FeatureTest = exports.FONT_IDENTITY_MATRIX = exports.DocumentActionEventType = exports.CMapCompressionType = exports.BaseException = exports.BASELINE_FACTOR = exports.AnnotationType = exports.AnnotationReplyType = exports.AnnotationPrefix = exports.AnnotationMode = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationEditorType = exports.AnnotationEditorPrefix = exports.AnnotationEditorParamsType = exports.AnnotationBorderStyleType = exports.AnnotationActionEventType = exports.AbortException = void 0;
                exports.assert = assert;
                exports.bytesToString = bytesToString;
                exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
                exports.getModificationDate = getModificationDate;
                exports.getUuid = getUuid;
                exports.getVerbosityLevel = getVerbosityLevel;
                exports.info = info;
                exports.isArrayBuffer = isArrayBuffer;
                exports.isArrayEqual = isArrayEqual;
                exports.isNodeJS = void 0;
                exports.normalizeUnicode = normalizeUnicode;
                exports.objectFromMap = objectFromMap;
                exports.objectSize = objectSize;
                exports.setVerbosityLevel = setVerbosityLevel;
                exports.shadow = shadow;
                exports.string32 = string32;
                exports.stringToBytes = stringToBytes;
                exports.stringToPDFString = stringToPDFString;
                exports.stringToUTF8String = stringToUTF8String;
                exports.unreachable = unreachable;
                exports.utf8StringToString = utf8StringToString;
                exports.warn = warn;
                var isNodeJS = typeof $kTBk6 === "object" && $kTBk6 + "" === "[object process]" && !$kTBk6.versions.nw && !($kTBk6.versions.electron && $kTBk6.type && $kTBk6.type !== "browser");
                exports.isNodeJS = isNodeJS;
                var IDENTITY_MATRIX = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
                var FONT_IDENTITY_MATRIX = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
                var MAX_IMAGE_SIZE_TO_CACHE = 10e6;
                exports.MAX_IMAGE_SIZE_TO_CACHE = MAX_IMAGE_SIZE_TO_CACHE;
                var LINE_FACTOR = 1.35;
                exports.LINE_FACTOR = LINE_FACTOR;
                var LINE_DESCENT_FACTOR = 0.35;
                exports.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR;
                var BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
                exports.BASELINE_FACTOR = BASELINE_FACTOR;
                var RenderingIntentFlag = {
                    ANY: 0x01,
                    DISPLAY: 0x02,
                    PRINT: 0x04,
                    SAVE: 0x08,
                    ANNOTATIONS_FORMS: 0x10,
                    ANNOTATIONS_STORAGE: 0x20,
                    ANNOTATIONS_DISABLE: 0x40,
                    OPLIST: 0x100
                };
                exports.RenderingIntentFlag = RenderingIntentFlag;
                var AnnotationMode = {
                    DISABLE: 0,
                    ENABLE: 1,
                    ENABLE_FORMS: 2,
                    ENABLE_STORAGE: 3
                };
                exports.AnnotationMode = AnnotationMode;
                var AnnotationEditorPrefix = "pdfjs_internal_editor_";
                exports.AnnotationEditorPrefix = AnnotationEditorPrefix;
                var AnnotationEditorType = {
                    DISABLE: -1,
                    NONE: 0,
                    FREETEXT: 3,
                    STAMP: 13,
                    INK: 15
                };
                exports.AnnotationEditorType = AnnotationEditorType;
                var AnnotationEditorParamsType = {
                    RESIZE: 1,
                    CREATE: 2,
                    FREETEXT_SIZE: 11,
                    FREETEXT_COLOR: 12,
                    FREETEXT_OPACITY: 13,
                    INK_COLOR: 21,
                    INK_THICKNESS: 22,
                    INK_OPACITY: 23
                };
                exports.AnnotationEditorParamsType = AnnotationEditorParamsType;
                var PermissionFlag = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports.PermissionFlag = PermissionFlag;
                var TextRenderingMode = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports.TextRenderingMode = TextRenderingMode;
                var ImageKind = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports.ImageKind = ImageKind;
                var AnnotationType = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports.AnnotationType = AnnotationType;
                var AnnotationReplyType = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports.AnnotationReplyType = AnnotationReplyType;
                var AnnotationFlag = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports.AnnotationFlag = AnnotationFlag;
                var AnnotationFieldFlag = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports.AnnotationFieldFlag = AnnotationFieldFlag;
                var AnnotationBorderStyleType = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
                var AnnotationActionEventType = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports.AnnotationActionEventType = AnnotationActionEventType;
                var DocumentActionEventType = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports.DocumentActionEventType = DocumentActionEventType;
                var PageActionEventType = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports.PageActionEventType = PageActionEventType;
                var VerbosityLevel = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports.VerbosityLevel = VerbosityLevel;
                var CMapCompressionType = {
                    NONE: 0,
                    BINARY: 1
                };
                exports.CMapCompressionType = CMapCompressionType;
                var OPS = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports.OPS = OPS;
                var PasswordResponses = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports.PasswordResponses = PasswordResponses;
                var verbosity = VerbosityLevel.WARNINGS;
                function setVerbosityLevel(level) {
                    if (Number.isInteger(level)) verbosity = level;
                }
                function getVerbosityLevel() {
                    return verbosity;
                }
                function info(msg) {
                    if (verbosity >= VerbosityLevel.INFOS) console.log("Info: ".concat(msg));
                }
                function warn(msg) {
                    if (verbosity >= VerbosityLevel.WARNINGS) console.log("Warning: ".concat(msg));
                }
                function unreachable(msg) {
                    throw new Error(msg);
                }
                function assert(cond, msg) {
                    if (!cond) unreachable(msg);
                }
                function _isValidProtocol(url) {
                    switch(url === null || url === void 0 ? void 0 : url.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl(url) {
                    var baseUrl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                    if (!url) return null;
                    try {
                        if (options && typeof url === "string") {
                            if (options.addDefaultProtocol && url.startsWith("www.")) {
                                var dots = url.match(/\./g);
                                if ((dots === null || dots === void 0 ? void 0 : dots.length) >= 2) url = "http://".concat(url);
                            }
                            if (options.tryConvertEncoding) try {
                                url = stringToUTF8String(url);
                            } catch (e) {}
                        }
                        var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        if (_isValidProtocol(absoluteUrl)) return absoluteUrl;
                    } catch (e) {}
                    return null;
                }
                function shadow(obj, prop, value) {
                    var nonSerializable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                    Object.defineProperty(obj, prop, {
                        value: value,
                        enumerable: !nonSerializable,
                        configurable: true,
                        writable: false
                    });
                    return value;
                }
                var BaseException = function BaseExceptionClosure() {
                    function BaseException(message, name) {
                        if (this.constructor === BaseException) unreachable("Cannot initialize BaseException.");
                        this.message = message;
                        this.name = name;
                    }
                    BaseException.prototype = new Error();
                    BaseException.constructor = BaseException;
                    return BaseException;
                }();
                exports.BaseException = BaseException;
                var PasswordException = /*#__PURE__*/ function(BaseException) {
                    (0, $kcqLc._)(PasswordException, BaseException);
                    var _super = (0, $4jYWU._)(PasswordException);
                    function PasswordException(msg, code) {
                        (0, $5sFFs._)(this, PasswordException);
                        var _this;
                        _this = _super.call(this, msg, "PasswordException");
                        _this.code = code;
                        return _this;
                    }
                    return PasswordException;
                }(BaseException);
                exports.PasswordException = PasswordException;
                var UnknownErrorException = /*#__PURE__*/ function(BaseException) {
                    (0, $kcqLc._)(UnknownErrorException, BaseException);
                    var _super = (0, $4jYWU._)(UnknownErrorException);
                    function UnknownErrorException(msg, details) {
                        (0, $5sFFs._)(this, UnknownErrorException);
                        var _this;
                        _this = _super.call(this, msg, "UnknownErrorException");
                        _this.details = details;
                        return _this;
                    }
                    return UnknownErrorException;
                }(BaseException);
                exports.UnknownErrorException = UnknownErrorException;
                var InvalidPDFException = /*#__PURE__*/ function(BaseException) {
                    (0, $kcqLc._)(InvalidPDFException, BaseException);
                    var _super = (0, $4jYWU._)(InvalidPDFException);
                    function InvalidPDFException(msg) {
                        (0, $5sFFs._)(this, InvalidPDFException);
                        return _super.call(this, msg, "InvalidPDFException");
                    }
                    return InvalidPDFException;
                }(BaseException);
                exports.InvalidPDFException = InvalidPDFException;
                var MissingPDFException = /*#__PURE__*/ function(BaseException) {
                    (0, $kcqLc._)(MissingPDFException, BaseException);
                    var _super = (0, $4jYWU._)(MissingPDFException);
                    function MissingPDFException(msg) {
                        (0, $5sFFs._)(this, MissingPDFException);
                        return _super.call(this, msg, "MissingPDFException");
                    }
                    return MissingPDFException;
                }(BaseException);
                exports.MissingPDFException = MissingPDFException;
                var UnexpectedResponseException = /*#__PURE__*/ function(BaseException) {
                    (0, $kcqLc._)(UnexpectedResponseException, BaseException);
                    var _super = (0, $4jYWU._)(UnexpectedResponseException);
                    function UnexpectedResponseException(msg, status) {
                        (0, $5sFFs._)(this, UnexpectedResponseException);
                        var _this;
                        _this = _super.call(this, msg, "UnexpectedResponseException");
                        _this.status = status;
                        return _this;
                    }
                    return UnexpectedResponseException;
                }(BaseException);
                exports.UnexpectedResponseException = UnexpectedResponseException;
                var FormatError = /*#__PURE__*/ function(BaseException) {
                    (0, $kcqLc._)(FormatError, BaseException);
                    var _super = (0, $4jYWU._)(FormatError);
                    function FormatError(msg) {
                        (0, $5sFFs._)(this, FormatError);
                        return _super.call(this, msg, "FormatError");
                    }
                    return FormatError;
                }(BaseException);
                exports.FormatError = FormatError;
                var AbortException = /*#__PURE__*/ function(BaseException) {
                    (0, $kcqLc._)(AbortException, BaseException);
                    var _super = (0, $4jYWU._)(AbortException);
                    function AbortException(msg) {
                        (0, $5sFFs._)(this, AbortException);
                        return _super.call(this, msg, "AbortException");
                    }
                    return AbortException;
                }(BaseException);
                exports.AbortException = AbortException;
                function bytesToString(bytes) {
                    if (typeof bytes !== "object" || (bytes === null || bytes === void 0 ? void 0 : bytes.length) === undefined) unreachable("Invalid argument for bytesToString");
                    var length = bytes.length;
                    var MAX_ARGUMENT_COUNT = 8192;
                    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
                    var strBuf = [];
                    for(var i = 0; i < length; i += MAX_ARGUMENT_COUNT){
                        var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
                        var chunk = bytes.subarray(i, chunkEnd);
                        strBuf.push(String.fromCharCode.apply(null, chunk));
                    }
                    return strBuf.join("");
                }
                function stringToBytes(str) {
                    if (typeof str !== "string") unreachable("Invalid argument for stringToBytes");
                    var length = str.length;
                    var bytes = new Uint8Array(length);
                    for(var i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
                    return bytes;
                }
                function string32(value) {
                    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                }
                function objectSize(obj) {
                    return Object.keys(obj).length;
                }
                function objectFromMap(map) {
                    var obj = Object.create(null);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = map[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $52tJv._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                            obj[key] = value;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return obj;
                }
                function isLittleEndian() {
                    var buffer8 = new Uint8Array(4);
                    buffer8[0] = 1;
                    var view32 = new Uint32Array(buffer8.buffer, 0, 1);
                    return view32[0] === 1;
                }
                function isEvalSupported() {
                    try {
                        new Function("");
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                var FeatureTest = /*#__PURE__*/ function() {
                    function FeatureTest() {
                        (0, $5sFFs._)(this, FeatureTest);
                    }
                    (0, $8O2fV._)(FeatureTest, null, [
                        {
                            key: "isLittleEndian",
                            get: function get() {
                                return shadow(this, "isLittleEndian", isLittleEndian());
                            }
                        },
                        {
                            key: "isEvalSupported",
                            get: function get() {
                                return shadow(this, "isEvalSupported", isEvalSupported());
                            }
                        },
                        {
                            key: "isOffscreenCanvasSupported",
                            get: function get() {
                                return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
                            }
                        },
                        {
                            key: "platform",
                            get: function get() {
                                if (typeof navigator === "undefined") return shadow(this, "platform", {
                                    isWin: false,
                                    isMac: false
                                });
                                return shadow(this, "platform", {
                                    isWin: navigator.platform.includes("Win"),
                                    isMac: navigator.platform.includes("Mac")
                                });
                            }
                        },
                        {
                            key: "isCSSRoundSupported",
                            get: function get() {
                                var _globalThis_CSS_supports, _globalThis_CSS;
                                return shadow(this, "isCSSRoundSupported", (_globalThis_CSS = globalThis.CSS) === null || _globalThis_CSS === void 0 ? void 0 : (_globalThis_CSS_supports = _globalThis_CSS.supports) === null || _globalThis_CSS_supports === void 0 ? void 0 : _globalThis_CSS_supports.call(_globalThis_CSS, "width: round(1.5px, 1px)"));
                            }
                        }
                    ]);
                    return FeatureTest;
                }();
                exports.FeatureTest = FeatureTest;
                var hexNumbers = (0, $fyztb._)(Array(256).keys()).map(function(n) {
                    return n.toString(16).padStart(2, "0");
                });
                var Util = /*#__PURE__*/ function() {
                    function Util() {
                        (0, $5sFFs._)(this, Util);
                    }
                    (0, $8O2fV._)(Util, null, [
                        {
                            key: "makeHexColor",
                            value: function makeHexColor(r, g, b) {
                                return "#".concat(hexNumbers[r]).concat(hexNumbers[g]).concat(hexNumbers[b]);
                            }
                        },
                        {
                            key: "scaleMinMax",
                            value: function scaleMinMax(transform, minMax) {
                                var temp;
                                if (transform[0]) {
                                    if (transform[0] < 0) {
                                        temp = minMax[0];
                                        minMax[0] = minMax[1];
                                        minMax[1] = temp;
                                    }
                                    minMax[0] *= transform[0];
                                    minMax[1] *= transform[0];
                                    if (transform[3] < 0) {
                                        temp = minMax[2];
                                        minMax[2] = minMax[3];
                                        minMax[3] = temp;
                                    }
                                    minMax[2] *= transform[3];
                                    minMax[3] *= transform[3];
                                } else {
                                    temp = minMax[0];
                                    minMax[0] = minMax[2];
                                    minMax[2] = temp;
                                    temp = minMax[1];
                                    minMax[1] = minMax[3];
                                    minMax[3] = temp;
                                    if (transform[1] < 0) {
                                        temp = minMax[2];
                                        minMax[2] = minMax[3];
                                        minMax[3] = temp;
                                    }
                                    minMax[2] *= transform[1];
                                    minMax[3] *= transform[1];
                                    if (transform[2] < 0) {
                                        temp = minMax[0];
                                        minMax[0] = minMax[1];
                                        minMax[1] = temp;
                                    }
                                    minMax[0] *= transform[2];
                                    minMax[1] *= transform[2];
                                }
                                minMax[0] += transform[4];
                                minMax[1] += transform[4];
                                minMax[2] += transform[5];
                                minMax[3] += transform[5];
                            }
                        },
                        {
                            key: "transform",
                            value: function transform(m1, m2) {
                                return [
                                    m1[0] * m2[0] + m1[2] * m2[1],
                                    m1[1] * m2[0] + m1[3] * m2[1],
                                    m1[0] * m2[2] + m1[2] * m2[3],
                                    m1[1] * m2[2] + m1[3] * m2[3],
                                    m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
                                    m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
                                ];
                            }
                        },
                        {
                            key: "applyTransform",
                            value: function applyTransform(p, m) {
                                var xt = p[0] * m[0] + p[1] * m[2] + m[4];
                                var yt = p[0] * m[1] + p[1] * m[3] + m[5];
                                return [
                                    xt,
                                    yt
                                ];
                            }
                        },
                        {
                            key: "applyInverseTransform",
                            value: function applyInverseTransform(p, m) {
                                var d = m[0] * m[3] - m[1] * m[2];
                                var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
                                var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
                                return [
                                    xt,
                                    yt
                                ];
                            }
                        },
                        {
                            key: "getAxialAlignedBoundingBox",
                            value: function getAxialAlignedBoundingBox(r, m) {
                                var p1 = this.applyTransform(r, m);
                                var p2 = this.applyTransform(r.slice(2, 4), m);
                                var p3 = this.applyTransform([
                                    r[0],
                                    r[3]
                                ], m);
                                var p4 = this.applyTransform([
                                    r[2],
                                    r[1]
                                ], m);
                                return [
                                    Math.min(p1[0], p2[0], p3[0], p4[0]),
                                    Math.min(p1[1], p2[1], p3[1], p4[1]),
                                    Math.max(p1[0], p2[0], p3[0], p4[0]),
                                    Math.max(p1[1], p2[1], p3[1], p4[1])
                                ];
                            }
                        },
                        {
                            key: "inverseTransform",
                            value: function inverseTransform(m) {
                                var d = m[0] * m[3] - m[1] * m[2];
                                return [
                                    m[3] / d,
                                    -m[1] / d,
                                    -m[2] / d,
                                    m[0] / d,
                                    (m[2] * m[5] - m[4] * m[3]) / d,
                                    (m[4] * m[1] - m[5] * m[0]) / d
                                ];
                            }
                        },
                        {
                            key: "singularValueDecompose2dScale",
                            value: function singularValueDecompose2dScale(m) {
                                var transpose = [
                                    m[0],
                                    m[2],
                                    m[1],
                                    m[3]
                                ];
                                var a = m[0] * transpose[0] + m[1] * transpose[2];
                                var b = m[0] * transpose[1] + m[1] * transpose[3];
                                var c = m[2] * transpose[0] + m[3] * transpose[2];
                                var d = m[2] * transpose[1] + m[3] * transpose[3];
                                var first = (a + d) / 2;
                                var second = Math.sqrt(Math.pow(a + d, 2) - 4 * (a * d - c * b)) / 2;
                                var sx = first + second || 1;
                                var sy = first - second || 1;
                                return [
                                    Math.sqrt(sx),
                                    Math.sqrt(sy)
                                ];
                            }
                        },
                        {
                            key: "normalizeRect",
                            value: function normalizeRect(rect) {
                                var r = rect.slice(0);
                                if (rect[0] > rect[2]) {
                                    r[0] = rect[2];
                                    r[2] = rect[0];
                                }
                                if (rect[1] > rect[3]) {
                                    r[1] = rect[3];
                                    r[3] = rect[1];
                                }
                                return r;
                            }
                        },
                        {
                            key: "intersect",
                            value: function intersect(rect1, rect2) {
                                var xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
                                var xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
                                if (xLow > xHigh) return null;
                                var yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
                                var yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
                                if (yLow > yHigh) return null;
                                return [
                                    xLow,
                                    yLow,
                                    xHigh,
                                    yHigh
                                ];
                            }
                        },
                        {
                            key: "bezierBoundingBox",
                            value: function bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
                                var _Math, _Math1, _Math2, _Math3;
                                var tvalues = [], bounds = [
                                    [],
                                    []
                                ];
                                var a, b, c, t, t1, t2, b2ac, sqrtb2ac;
                                for(var i = 0; i < 2; ++i){
                                    if (i === 0) {
                                        b = 6 * x0 - 12 * x1 + 6 * x2;
                                        a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                                        c = 3 * x1 - 3 * x0;
                                    } else {
                                        b = 6 * y0 - 12 * y1 + 6 * y2;
                                        a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                                        c = 3 * y1 - 3 * y0;
                                    }
                                    if (Math.abs(a) < 1e-12) {
                                        if (Math.abs(b) < 1e-12) continue;
                                        t = -c / b;
                                        if (0 < t && t < 1) tvalues.push(t);
                                        continue;
                                    }
                                    b2ac = b * b - 4 * c * a;
                                    sqrtb2ac = Math.sqrt(b2ac);
                                    if (b2ac < 0) continue;
                                    t1 = (-b + sqrtb2ac) / (2 * a);
                                    if (0 < t1 && t1 < 1) tvalues.push(t1);
                                    t2 = (-b - sqrtb2ac) / (2 * a);
                                    if (0 < t2 && t2 < 1) tvalues.push(t2);
                                }
                                var j = tvalues.length, mt;
                                var jlen = j;
                                while(j--){
                                    t = tvalues[j];
                                    mt = 1 - t;
                                    bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
                                    bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
                                }
                                bounds[0][jlen] = x0;
                                bounds[1][jlen] = y0;
                                bounds[0][jlen + 1] = x3;
                                bounds[1][jlen + 1] = y3;
                                bounds[0].length = bounds[1].length = jlen + 2;
                                return [
                                    (_Math = Math).min.apply(_Math, (0, $fyztb._)(bounds[0])),
                                    (_Math1 = Math).min.apply(_Math1, (0, $fyztb._)(bounds[1])),
                                    (_Math2 = Math).max.apply(_Math2, (0, $fyztb._)(bounds[0])),
                                    (_Math3 = Math).max.apply(_Math3, (0, $fyztb._)(bounds[1]))
                                ];
                            }
                        }
                    ]);
                    return Util;
                }();
                exports.Util = Util;
                var PDFStringTranslateTable = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString(str) {
                    if (str[0] >= "\xef") {
                        var encoding;
                        if (str[0] === "\xfe" && str[1] === "\xff") encoding = "utf-16be";
                        else if (str[0] === "\xff" && str[1] === "\xfe") encoding = "utf-16le";
                        else if (str[0] === "\xef" && str[1] === "\xbb" && str[2] === "\xbf") encoding = "utf-8";
                        if (encoding) try {
                            var decoder = new TextDecoder(encoding, {
                                fatal: true
                            });
                            var buffer = stringToBytes(str);
                            return decoder.decode(buffer);
                        } catch (ex) {
                            warn('stringToPDFString: "'.concat(ex, '".'));
                        }
                    }
                    var strBuf = [];
                    for(var i = 0, ii = str.length; i < ii; i++){
                        var code = PDFStringTranslateTable[str.charCodeAt(i)];
                        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
                    }
                    return strBuf.join("");
                }
                function stringToUTF8String(str) {
                    return decodeURIComponent(escape(str));
                }
                function utf8StringToString(str) {
                    return unescape(encodeURIComponent(str));
                }
                function isArrayBuffer(v) {
                    return typeof v === "object" && (v === null || v === void 0 ? void 0 : v.byteLength) !== undefined;
                }
                function isArrayEqual(arr1, arr2) {
                    if (arr1.length !== arr2.length) return false;
                    for(var i = 0, ii = arr1.length; i < ii; i++){
                        if (arr1[i] !== arr2[i]) return false;
                    }
                    return true;
                }
                function getModificationDate() {
                    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date();
                    var buffer = [
                        date.getUTCFullYear().toString(),
                        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date.getUTCDate().toString().padStart(2, "0"),
                        date.getUTCHours().toString().padStart(2, "0"),
                        date.getUTCMinutes().toString().padStart(2, "0"),
                        date.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer.join("");
                }
                var _settled = /*#__PURE__*/ new WeakMap();
                var PromiseCapability = /*#__PURE__*/ function() {
                    function PromiseCapability() {
                        var _this = this;
                        (0, $5sFFs._)(this, PromiseCapability);
                        (0, $g12Hy._)(this, _settled, {
                            writable: true,
                            value: false
                        });
                        this.promise = new Promise(function(resolve, reject) {
                            _this.resolve = function(data) {
                                (0, $4LHB0._)(_this, _settled, true);
                                resolve(data);
                            };
                            _this.reject = function(reason) {
                                (0, $4LHB0._)(_this, _settled, true);
                                reject(reason);
                            };
                        });
                    }
                    (0, $8O2fV._)(PromiseCapability, [
                        {
                            key: "settled",
                            get: function get() {
                                return (0, $057QZ._)(this, _settled);
                            }
                        }
                    ]);
                    return PromiseCapability;
                }();
                exports.PromiseCapability = PromiseCapability;
                var NormalizeRegex = null;
                var NormalizationMap = null;
                function normalizeUnicode(str) {
                    if (!NormalizeRegex) {
                        NormalizeRegex = RegExp("([\\u00a0\\u00b5\\u037e\\u0eb3\\u2000-\\u200a\\u202f\\u2126\\ufb00-\\ufb04\\ufb06\\ufb20-\\ufb36\\ufb38-\\ufb3c\\ufb3e\\ufb40-\\ufb41\\ufb43-\\ufb44\\ufb46-\\ufba1\\ufba4-\\ufba9\\ufbae-\\ufbb1\\ufbd3-\\ufbdc\\ufbde-\\ufbe7\\ufbea-\\ufbf8\\ufbfc-\\ufbfd\\ufc00-\\ufc5d\\ufc64-\\ufcf1\\ufcf5-\\ufd3d\\ufd88\\ufdf4\\ufdfa-\\ufdfb\\ufe71\\ufe77\\ufe79\\ufe7b\\ufe7d]+)|(\\ufb05+)", "gu");
                        NormalizationMap = new Map([
                            [
                                "\uFB05",
                                "\u017Ft"
                            ]
                        ]);
                    }
                    return str.replaceAll(NormalizeRegex, function(_, p1, p2) {
                        return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2);
                    });
                }
                function getUuid() {
                    var _crypto, _crypto1;
                    if (typeof crypto !== "undefined" && typeof ((_crypto = crypto) === null || _crypto === void 0 ? void 0 : _crypto.randomUUID) === "function") return crypto.randomUUID();
                    var buf = new Uint8Array(32);
                    if (typeof crypto !== "undefined" && typeof ((_crypto1 = crypto) === null || _crypto1 === void 0 ? void 0 : _crypto1.getRandomValues) === "function") crypto.getRandomValues(buf);
                    else for(var i = 0; i < 32; i++)buf[i] = Math.floor(Math.random() * 255);
                    return bytesToString(buf);
                }
                var AnnotationPrefix = "pdfjs_internal_id_";
                exports.AnnotationPrefix = AnnotationPrefix;
            /***/ },
            /* 2 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
                Object.defineProperty(exports, "SVGGraphics", {
                    enumerable: true,
                    get: function get() {
                        return _displaySvg.SVGGraphics;
                    }
                });
                exports.build = void 0;
                exports.getDocument = getDocument;
                exports.version = void 0;
                var _util = __w_pdfjs_require__(1);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _display_utils = __w_pdfjs_require__(6);
                var _font_loader = __w_pdfjs_require__(9);
                var _displayNode_utils = __w_pdfjs_require__(10);
                var _canvas = __w_pdfjs_require__(11);
                var _worker_options = __w_pdfjs_require__(14);
                var _message_handler = __w_pdfjs_require__(15);
                var _metadata = __w_pdfjs_require__(16);
                var _optional_content_config = __w_pdfjs_require__(17);
                var _transport_stream = __w_pdfjs_require__(18);
                var _displayFetch_stream = __w_pdfjs_require__(19);
                var _displayNetwork = __w_pdfjs_require__(22);
                var _displayNode_stream = __w_pdfjs_require__(23);
                var _displaySvg = __w_pdfjs_require__(24);
                var _xfa_text = __w_pdfjs_require__(25);
                var DEFAULT_RANGE_CHUNK_SIZE = 65536;
                var RENDERING_CANCELLED_TIMEOUT = 100;
                var DELAYED_CLEANUP_TIMEOUT = 5000;
                var DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
                exports.DefaultCanvasFactory = DefaultCanvasFactory;
                var DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
                exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
                var DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
                exports.DefaultFilterFactory = DefaultFilterFactory;
                var DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
                exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
                function getDocument(src) {
                    if (typeof src === "string" || src instanceof URL) src = {
                        url: src
                    };
                    else if ((0, _util.isArrayBuffer)(src)) src = {
                        data: src
                    };
                    if (typeof src !== "object") throw new Error("Invalid parameter in getDocument, need parameter object.");
                    if (!src.url && !src.data && !src.range) throw new Error("Invalid parameter object: need either .data, .range or .url");
                    var task = new PDFDocumentLoadingTask();
                    var docId = task.docId;
                    var url = src.url ? getUrlProp(src.url) : null;
                    var data = src.data ? getDataProp(src.data) : null;
                    var httpHeaders = src.httpHeaders || null;
                    var withCredentials = src.withCredentials === true;
                    var _src_password;
                    var password = (_src_password = src.password) !== null && _src_password !== void 0 ? _src_password : null;
                    var rangeTransport = src.range instanceof PDFDataRangeTransport ? src.range : null;
                    var rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
                    var worker = src.worker instanceof PDFWorker ? src.worker : null;
                    var verbosity = src.verbosity;
                    var docBaseUrl = typeof src.docBaseUrl === "string" && !(0, _display_utils.isDataScheme)(src.docBaseUrl) ? src.docBaseUrl : null;
                    var cMapUrl = typeof src.cMapUrl === "string" ? src.cMapUrl : null;
                    var cMapPacked = src.cMapPacked !== false;
                    var CMapReaderFactory = src.CMapReaderFactory || DefaultCMapReaderFactory;
                    var standardFontDataUrl = typeof src.standardFontDataUrl === "string" ? src.standardFontDataUrl : null;
                    var StandardFontDataFactory = src.StandardFontDataFactory || DefaultStandardFontDataFactory;
                    var ignoreErrors = src.stopAtErrors !== true;
                    var maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
                    var isEvalSupported = src.isEvalSupported !== false;
                    var isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !_util.isNodeJS;
                    var canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
                    var disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : _util.isNodeJS;
                    var fontExtraProperties = src.fontExtraProperties === true;
                    var enableXfa = src.enableXfa === true;
                    var ownerDocument = src.ownerDocument || globalThis.document;
                    var disableRange = src.disableRange === true;
                    var disableStream = src.disableStream === true;
                    var disableAutoFetch = src.disableAutoFetch === true;
                    var pdfBug = src.pdfBug === true;
                    var _src_length;
                    var length = rangeTransport ? rangeTransport.length : (_src_length = src.length) !== null && _src_length !== void 0 ? _src_length : NaN;
                    var useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !_util.isNodeJS && !disableFontFace;
                    var useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : CMapReaderFactory === _display_utils.DOMCMapReaderFactory && StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory && cMapUrl && standardFontDataUrl && (0, _display_utils.isValidFetchUrl)(cMapUrl, document.baseURI) && (0, _display_utils.isValidFetchUrl)(standardFontDataUrl, document.baseURI);
                    var canvasFactory = src.canvasFactory || new DefaultCanvasFactory({
                        ownerDocument: ownerDocument
                    });
                    var filterFactory = src.filterFactory || new DefaultFilterFactory({
                        docId: docId,
                        ownerDocument: ownerDocument
                    });
                    var styleElement = null;
                    (0, _util.setVerbosityLevel)(verbosity);
                    var transportFactory = {
                        canvasFactory: canvasFactory,
                        filterFactory: filterFactory
                    };
                    if (!useWorkerFetch) {
                        transportFactory.cMapReaderFactory = new CMapReaderFactory({
                            baseUrl: cMapUrl,
                            isCompressed: cMapPacked
                        });
                        transportFactory.standardFontDataFactory = new StandardFontDataFactory({
                            baseUrl: standardFontDataUrl
                        });
                    }
                    if (!worker) {
                        var workerParams = {
                            verbosity: verbosity,
                            port: _worker_options.GlobalWorkerOptions.workerPort
                        };
                        worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
                        task._worker = worker;
                    }
                    var fetchDocParams = {
                        docId: docId,
                        apiVersion: "3.11.174",
                        data: data,
                        password: password,
                        disableAutoFetch: disableAutoFetch,
                        rangeChunkSize: rangeChunkSize,
                        length: length,
                        docBaseUrl: docBaseUrl,
                        enableXfa: enableXfa,
                        evaluatorOptions: {
                            maxImageSize: maxImageSize,
                            disableFontFace: disableFontFace,
                            ignoreErrors: ignoreErrors,
                            isEvalSupported: isEvalSupported,
                            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
                            canvasMaxAreaInBytes: canvasMaxAreaInBytes,
                            fontExtraProperties: fontExtraProperties,
                            useSystemFonts: useSystemFonts,
                            cMapUrl: useWorkerFetch ? cMapUrl : null,
                            standardFontDataUrl: useWorkerFetch ? standardFontDataUrl : null
                        }
                    };
                    var transportParams = {
                        ignoreErrors: ignoreErrors,
                        isEvalSupported: isEvalSupported,
                        disableFontFace: disableFontFace,
                        fontExtraProperties: fontExtraProperties,
                        enableXfa: enableXfa,
                        ownerDocument: ownerDocument,
                        disableAutoFetch: disableAutoFetch,
                        pdfBug: pdfBug,
                        styleElement: styleElement
                    };
                    worker.promise.then(function() {
                        if (task.destroyed) throw new Error("Loading aborted");
                        var workerIdPromise = _fetchDocument(worker, fetchDocParams);
                        var networkStreamPromise = new Promise(function(resolve) {
                            var networkStream;
                            if (rangeTransport) networkStream = new _transport_stream.PDFDataTransportStream({
                                length: length,
                                initialData: rangeTransport.initialData,
                                progressiveDone: rangeTransport.progressiveDone,
                                contentDispositionFilename: rangeTransport.contentDispositionFilename,
                                disableRange: disableRange,
                                disableStream: disableStream
                            }, rangeTransport);
                            else if (!data) {
                                var createPDFNetworkStream = function(params) {
                                    if (_util.isNodeJS) return new _displayNode_stream.PDFNodeStream(params);
                                    return (0, _display_utils.isValidFetchUrl)(params.url) ? new _displayFetch_stream.PDFFetchStream(params) : new _displayNetwork.PDFNetworkStream(params);
                                };
                                networkStream = createPDFNetworkStream({
                                    url: url,
                                    length: length,
                                    httpHeaders: httpHeaders,
                                    withCredentials: withCredentials,
                                    rangeChunkSize: rangeChunkSize,
                                    disableRange: disableRange,
                                    disableStream: disableStream
                                });
                            }
                            resolve(networkStream);
                        });
                        return Promise.all([
                            workerIdPromise,
                            networkStreamPromise
                        ]).then(function(param) {
                            var _param = (0, $52tJv._)(param, 2), workerId = _param[0], networkStream = _param[1];
                            if (task.destroyed) throw new Error("Loading aborted");
                            var messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port);
                            var transport = new WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory);
                            task._transport = transport;
                            messageHandler.send("Ready", null);
                        });
                    }).catch(task._capability.reject);
                    return task;
                }
                function _fetchDocument(worker, source) {
                    return __fetchDocument.apply(this, arguments);
                }
                function __fetchDocument() {
                    __fetchDocument = (0, $7hBys._)(function(worker, source) {
                        var workerId;
                        return (0, $ajhIL.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (worker.destroyed) throw new Error("Worker was destroyed");
                                    return [
                                        4,
                                        worker.messageHandler.sendWithPromise("GetDocRequest", source, source.data ? [
                                            source.data.buffer
                                        ] : null)
                                    ];
                                case 1:
                                    workerId = _state.sent();
                                    if (worker.destroyed) throw new Error("Worker was destroyed");
                                    return [
                                        2,
                                        workerId
                                    ];
                            }
                        });
                    });
                    return __fetchDocument.apply(this, arguments);
                }
                function getUrlProp(val) {
                    if (val instanceof URL) return val.href;
                    try {
                        return new URL(val, window.location).href;
                    } catch (e) {
                        if (_util.isNodeJS && typeof val === "string") return val;
                    }
                    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                }
                function getDataProp(val) {
                    if (_util.isNodeJS && typeof $6e4e36316ba04d62$require$Buffer !== "undefined" && val instanceof $6e4e36316ba04d62$require$Buffer) throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
                    if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) return val;
                    if (typeof val === "string") return (0, _util.stringToBytes)(val);
                    if (typeof val === "object" && !isNaN(val === null || val === void 0 ? void 0 : val.length) || (0, _util.isArrayBuffer)(val)) return new Uint8Array(val);
                    throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
                }
                var PDFDocumentLoadingTask = /*#__PURE__*/ function() {
                    function PDFDocumentLoadingTask() {
                        (0, $5sFFs._)(this, PDFDocumentLoadingTask);
                        this._capability = new _util.PromiseCapability();
                        this._transport = null;
                        this._worker = null;
                        this.docId = "d".concat((0, $fC5Fv._)(PDFDocumentLoadingTask, PDFDocumentLoadingTask, _docId).value++);
                        this.destroyed = false;
                        this.onPassword = null;
                        this.onProgress = null;
                    }
                    (0, $8O2fV._)(PDFDocumentLoadingTask, [
                        {
                            key: "promise",
                            get: function get() {
                                return this._capability.promise;
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var _this__worker, _this__transport, ex, _this__worker1;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _this.destroyed = true;
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                if ((_this__worker = _this._worker) === null || _this__worker === void 0 ? void 0 : _this__worker.port) _this._worker._pendingDestroy = true;
                                                return [
                                                    4,
                                                    (_this__transport = _this._transport) === null || _this__transport === void 0 ? void 0 : _this__transport.destroy()
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                ex = _state.sent();
                                                if ((_this__worker1 = _this._worker) === null || _this__worker1 === void 0 ? void 0 : _this__worker1.port) delete _this._worker._pendingDestroy;
                                                throw ex;
                                            case 4:
                                                _this._transport = null;
                                                if (_this._worker) {
                                                    _this._worker.destroy();
                                                    _this._worker = null;
                                                }
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }
                        }
                    ]);
                    return PDFDocumentLoadingTask;
                }();
                var _docId = {
                    writable: true,
                    value: 0
                };
                exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
                var PDFDataRangeTransport = /*#__PURE__*/ function() {
                    function PDFDataRangeTransport(length, initialData) {
                        var progressiveDone = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, contentDispositionFilename = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
                        (0, $5sFFs._)(this, PDFDataRangeTransport);
                        this.length = length;
                        this.initialData = initialData;
                        this.progressiveDone = progressiveDone;
                        this.contentDispositionFilename = contentDispositionFilename;
                        this._rangeListeners = [];
                        this._progressListeners = [];
                        this._progressiveReadListeners = [];
                        this._progressiveDoneListeners = [];
                        this._readyCapability = new _util.PromiseCapability();
                    }
                    (0, $8O2fV._)(PDFDataRangeTransport, [
                        {
                            key: "addRangeListener",
                            value: function addRangeListener(listener) {
                                this._rangeListeners.push(listener);
                            }
                        },
                        {
                            key: "addProgressListener",
                            value: function addProgressListener(listener) {
                                this._progressListeners.push(listener);
                            }
                        },
                        {
                            key: "addProgressiveReadListener",
                            value: function addProgressiveReadListener(listener) {
                                this._progressiveReadListeners.push(listener);
                            }
                        },
                        {
                            key: "addProgressiveDoneListener",
                            value: function addProgressiveDoneListener(listener) {
                                this._progressiveDoneListeners.push(listener);
                            }
                        },
                        {
                            key: "onDataRange",
                            value: function onDataRange(begin, chunk) {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._rangeListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var listener = _step.value;
                                        listener(begin, chunk);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "onDataProgress",
                            value: function onDataProgress(loaded, total) {
                                var _this = this;
                                this._readyCapability.promise.then(function() {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = _this._progressListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var listener = _step.value;
                                            listener(loaded, total);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                });
                            }
                        },
                        {
                            key: "onDataProgressiveRead",
                            value: function onDataProgressiveRead(chunk) {
                                var _this = this;
                                this._readyCapability.promise.then(function() {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = _this._progressiveReadListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var listener = _step.value;
                                            listener(chunk);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                });
                            }
                        },
                        {
                            key: "onDataProgressiveDone",
                            value: function onDataProgressiveDone() {
                                var _this = this;
                                this._readyCapability.promise.then(function() {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = _this._progressiveDoneListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var listener = _step.value;
                                            listener();
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                });
                            }
                        },
                        {
                            key: "transportReady",
                            value: function transportReady() {
                                this._readyCapability.resolve();
                            }
                        },
                        {
                            key: "requestDataRange",
                            value: function requestDataRange(begin, end) {
                                (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
                            }
                        },
                        {
                            key: "abort",
                            value: function abort() {}
                        }
                    ]);
                    return PDFDataRangeTransport;
                }();
                exports.PDFDataRangeTransport = PDFDataRangeTransport;
                var PDFDocumentProxy = /*#__PURE__*/ function() {
                    function PDFDocumentProxy(pdfInfo, transport) {
                        var _this = this;
                        (0, $5sFFs._)(this, PDFDocumentProxy);
                        this._pdfInfo = pdfInfo;
                        this._transport = transport;
                        Object.defineProperty(this, "getJavaScript", {
                            value: function() {
                                (0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, please use `PDFDocumentProxy.getJSActions` instead.");
                                return _this.getJSActions().then(function(js) {
                                    var _jsArr;
                                    if (!js) return js;
                                    var jsArr = [];
                                    for(var name in js)(_jsArr = jsArr).push.apply(_jsArr, (0, $fyztb._)(js[name]));
                                    return jsArr;
                                });
                            }
                        });
                    }
                    (0, $8O2fV._)(PDFDocumentProxy, [
                        {
                            key: "annotationStorage",
                            get: function get() {
                                return this._transport.annotationStorage;
                            }
                        },
                        {
                            key: "filterFactory",
                            get: function get() {
                                return this._transport.filterFactory;
                            }
                        },
                        {
                            key: "numPages",
                            get: function get() {
                                return this._pdfInfo.numPages;
                            }
                        },
                        {
                            key: "fingerprints",
                            get: function get() {
                                return this._pdfInfo.fingerprints;
                            }
                        },
                        {
                            key: "isPureXfa",
                            get: function get() {
                                return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                            }
                        },
                        {
                            key: "allXfaHtml",
                            get: function get() {
                                return this._transport._htmlForXfa;
                            }
                        },
                        {
                            key: "getPage",
                            value: function getPage(pageNumber) {
                                return this._transport.getPage(pageNumber);
                            }
                        },
                        {
                            key: "getPageIndex",
                            value: function getPageIndex(ref) {
                                return this._transport.getPageIndex(ref);
                            }
                        },
                        {
                            key: "getDestinations",
                            value: function getDestinations() {
                                return this._transport.getDestinations();
                            }
                        },
                        {
                            key: "getDestination",
                            value: function getDestination(id) {
                                return this._transport.getDestination(id);
                            }
                        },
                        {
                            key: "getPageLabels",
                            value: function getPageLabels() {
                                return this._transport.getPageLabels();
                            }
                        },
                        {
                            key: "getPageLayout",
                            value: function getPageLayout() {
                                return this._transport.getPageLayout();
                            }
                        },
                        {
                            key: "getPageMode",
                            value: function getPageMode() {
                                return this._transport.getPageMode();
                            }
                        },
                        {
                            key: "getViewerPreferences",
                            value: function getViewerPreferences() {
                                return this._transport.getViewerPreferences();
                            }
                        },
                        {
                            key: "getOpenAction",
                            value: function getOpenAction() {
                                return this._transport.getOpenAction();
                            }
                        },
                        {
                            key: "getAttachments",
                            value: function getAttachments() {
                                return this._transport.getAttachments();
                            }
                        },
                        {
                            key: "getJSActions",
                            value: function getJSActions() {
                                return this._transport.getDocJSActions();
                            }
                        },
                        {
                            key: "getOutline",
                            value: function getOutline() {
                                return this._transport.getOutline();
                            }
                        },
                        {
                            key: "getOptionalContentConfig",
                            value: function getOptionalContentConfig() {
                                return this._transport.getOptionalContentConfig();
                            }
                        },
                        {
                            key: "getPermissions",
                            value: function getPermissions() {
                                return this._transport.getPermissions();
                            }
                        },
                        {
                            key: "getMetadata",
                            value: function getMetadata() {
                                return this._transport.getMetadata();
                            }
                        },
                        {
                            key: "getMarkInfo",
                            value: function getMarkInfo() {
                                return this._transport.getMarkInfo();
                            }
                        },
                        {
                            key: "getData",
                            value: function getData() {
                                return this._transport.getData();
                            }
                        },
                        {
                            key: "saveDocument",
                            value: function saveDocument() {
                                return this._transport.saveDocument();
                            }
                        },
                        {
                            key: "getDownloadInfo",
                            value: function getDownloadInfo() {
                                return this._transport.downloadInfoCapability.promise;
                            }
                        },
                        {
                            key: "cleanup",
                            value: function cleanup() {
                                var keepLoadedFonts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                                return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                return this.loadingTask.destroy();
                            }
                        },
                        {
                            key: "loadingParams",
                            get: function get() {
                                return this._transport.loadingParams;
                            }
                        },
                        {
                            key: "loadingTask",
                            get: function get() {
                                return this._transport.loadingTask;
                            }
                        },
                        {
                            key: "getFieldObjects",
                            value: function getFieldObjects() {
                                return this._transport.getFieldObjects();
                            }
                        },
                        {
                            key: "hasJSActions",
                            value: function hasJSActions() {
                                return this._transport.hasJSActions();
                            }
                        },
                        {
                            key: "getCalculationOrderIds",
                            value: function getCalculationOrderIds() {
                                return this._transport.getCalculationOrderIds();
                            }
                        }
                    ]);
                    return PDFDocumentProxy;
                }();
                exports.PDFDocumentProxy = PDFDocumentProxy;
                var _delayedCleanupTimeout = /*#__PURE__*/ new WeakMap(), _pendingCleanup = /*#__PURE__*/ new WeakMap(), _tryCleanup = /*#__PURE__*/ new WeakSet(), _abortDelayedCleanup = /*#__PURE__*/ new WeakSet();
                var PDFPageProxy = /*#__PURE__*/ function() {
                    function PDFPageProxy(pageIndex, pageInfo, transport) {
                        var pdfBug = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                        (0, $5sFFs._)(this, PDFPageProxy);
                        (0, $iB2CV._)(this, _tryCleanup);
                        (0, $iB2CV._)(this, _abortDelayedCleanup);
                        (0, $g12Hy._)(this, _delayedCleanupTimeout, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _pendingCleanup, {
                            writable: true,
                            value: false
                        });
                        this._pageIndex = pageIndex;
                        this._pageInfo = pageInfo;
                        this._transport = transport;
                        this._stats = pdfBug ? new _display_utils.StatTimer() : null;
                        this._pdfBug = pdfBug;
                        this.commonObjs = transport.commonObjs;
                        this.objs = new PDFObjects();
                        this._maybeCleanupAfterRender = false;
                        this._intentStates = new Map();
                        this.destroyed = false;
                    }
                    (0, $8O2fV._)(PDFPageProxy, [
                        {
                            key: "pageNumber",
                            get: function get() {
                                return this._pageIndex + 1;
                            }
                        },
                        {
                            key: "rotate",
                            get: function get() {
                                return this._pageInfo.rotate;
                            }
                        },
                        {
                            key: "ref",
                            get: function get() {
                                return this._pageInfo.ref;
                            }
                        },
                        {
                            key: "userUnit",
                            get: function get() {
                                return this._pageInfo.userUnit;
                            }
                        },
                        {
                            key: "view",
                            get: function get() {
                                return this._pageInfo.view;
                            }
                        },
                        {
                            key: "getViewport",
                            value: function getViewport() {
                                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, scale = _ref.scale, _ref_rotation = _ref.rotation, rotation = _ref_rotation === void 0 ? this.rotate : _ref_rotation, _ref_offsetX = _ref.offsetX, offsetX = _ref_offsetX === void 0 ? 0 : _ref_offsetX, _ref_offsetY = _ref.offsetY, offsetY = _ref_offsetY === void 0 ? 0 : _ref_offsetY, _ref_dontFlip = _ref.dontFlip, dontFlip = _ref_dontFlip === void 0 ? false : _ref_dontFlip;
                                return new _display_utils.PageViewport({
                                    viewBox: this.view,
                                    scale: scale,
                                    rotation: rotation,
                                    offsetX: offsetX,
                                    offsetY: offsetY,
                                    dontFlip: dontFlip
                                });
                            }
                        },
                        {
                            key: "getAnnotations",
                            value: function getAnnotations() {
                                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_intent = _ref.intent, intent = _ref_intent === void 0 ? "display" : _ref_intent;
                                var intentArgs = this._transport.getRenderingIntent(intent);
                                return this._transport.getAnnotations(this._pageIndex, intentArgs.renderingIntent);
                            }
                        },
                        {
                            key: "getJSActions",
                            value: function getJSActions() {
                                return this._transport.getPageJSActions(this._pageIndex);
                            }
                        },
                        {
                            key: "filterFactory",
                            get: function get() {
                                return this._transport.filterFactory;
                            }
                        },
                        {
                            key: "isPureXfa",
                            get: function get() {
                                return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                            }
                        },
                        {
                            key: "getXfa",
                            value: function getXfa() {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var _this__transport__htmlForXfa;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            ((_this__transport__htmlForXfa = _this._transport._htmlForXfa) === null || _this__transport__htmlForXfa === void 0 ? void 0 : _this__transport__htmlForXfa.children[_this._pageIndex]) || null
                                        ];
                                    });
                                })();
                            }
                        },
                        {
                            key: "render",
                            value: function render(param) {
                                var canvasContext = param.canvasContext, viewport = param.viewport, _param_intent = param.intent, intent = _param_intent === void 0 ? "display" : _param_intent, _param_annotationMode = param.annotationMode, annotationMode = _param_annotationMode === void 0 ? _util.AnnotationMode.ENABLE : _param_annotationMode, _param_transform = param.transform, transform = _param_transform === void 0 ? null : _param_transform, _param_background = param.background, background = _param_background === void 0 ? null : _param_background, _param_optionalContentConfigPromise = param.optionalContentConfigPromise, optionalContentConfigPromise = _param_optionalContentConfigPromise === void 0 ? null : _param_optionalContentConfigPromise, _param_annotationCanvasMap = param.annotationCanvasMap, annotationCanvasMap = _param_annotationCanvasMap === void 0 ? null : _param_annotationCanvasMap, _param_pageColors = param.pageColors, pageColors = _param_pageColors === void 0 ? null : _param_pageColors, _param_printAnnotationStorage = param.printAnnotationStorage, printAnnotationStorage = _param_printAnnotationStorage === void 0 ? null : _param_printAnnotationStorage;
                                var _this = this;
                                var _this__stats;
                                var _intentState;
                                (_this__stats = this._stats) === null || _this__stats === void 0 ? void 0 : _this__stats.time("Overall");
                                var intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage);
                                (0, $4LHB0._)(this, _pendingCleanup, false);
                                (0, $lNbhr._)(this, _abortDelayedCleanup, abortDelayedCleanup).call(this);
                                if (!optionalContentConfigPromise) optionalContentConfigPromise = this._transport.getOptionalContentConfig();
                                var intentState = this._intentStates.get(intentArgs.cacheKey);
                                if (!intentState) {
                                    intentState = Object.create(null);
                                    this._intentStates.set(intentArgs.cacheKey, intentState);
                                }
                                if (intentState.streamReaderCancelTimeout) {
                                    clearTimeout(intentState.streamReaderCancelTimeout);
                                    intentState.streamReaderCancelTimeout = null;
                                }
                                var intentPrint = !!(intentArgs.renderingIntent & _util.RenderingIntentFlag.PRINT);
                                if (!intentState.displayReadyCapability) {
                                    var _this__stats1;
                                    intentState.displayReadyCapability = new _util.PromiseCapability();
                                    intentState.operatorList = {
                                        fnArray: [],
                                        argsArray: [],
                                        lastChunk: false,
                                        separateAnnots: null
                                    };
                                    (_this__stats1 = this._stats) === null || _this__stats1 === void 0 ? void 0 : _this__stats1.time("Page Request");
                                    this._pumpOperatorList(intentArgs);
                                }
                                var complete = function(error) {
                                    var _this__stats, _this__stats1;
                                    intentState.renderTasks.delete(internalRenderTask);
                                    if (_this._maybeCleanupAfterRender || intentPrint) (0, $4LHB0._)(_this, _pendingCleanup, true);
                                    (0, $lNbhr._)(_this, _tryCleanup, tryCleanup).call(_this, !intentPrint);
                                    if (error) {
                                        internalRenderTask.capability.reject(error);
                                        _this._abortOperatorList({
                                            intentState: intentState,
                                            reason: error instanceof Error ? error : new Error(error)
                                        });
                                    } else internalRenderTask.capability.resolve();
                                    (_this__stats = _this._stats) === null || _this__stats === void 0 ? void 0 : _this__stats.timeEnd("Rendering");
                                    (_this__stats1 = _this._stats) === null || _this__stats1 === void 0 ? void 0 : _this__stats1.timeEnd("Overall");
                                };
                                var internalRenderTask = new InternalRenderTask({
                                    callback: complete,
                                    params: {
                                        canvasContext: canvasContext,
                                        viewport: viewport,
                                        transform: transform,
                                        background: background
                                    },
                                    objs: this.objs,
                                    commonObjs: this.commonObjs,
                                    annotationCanvasMap: annotationCanvasMap,
                                    operatorList: intentState.operatorList,
                                    pageIndex: this._pageIndex,
                                    canvasFactory: this._transport.canvasFactory,
                                    filterFactory: this._transport.filterFactory,
                                    useRequestAnimationFrame: !intentPrint,
                                    pdfBug: this._pdfBug,
                                    pageColors: pageColors
                                });
                                ((_intentState = intentState).renderTasks || (_intentState.renderTasks = new Set())).add(internalRenderTask);
                                var renderTask = internalRenderTask.task;
                                Promise.all([
                                    intentState.displayReadyCapability.promise,
                                    optionalContentConfigPromise
                                ]).then(function(param) {
                                    var _param = (0, $52tJv._)(param, 2), transparency = _param[0], optionalContentConfig = _param[1];
                                    var _this__stats;
                                    if (_this.destroyed) {
                                        complete();
                                        return;
                                    }
                                    (_this__stats = _this._stats) === null || _this__stats === void 0 ? void 0 : _this__stats.time("Rendering");
                                    internalRenderTask.initializeGraphics({
                                        transparency: transparency,
                                        optionalContentConfig: optionalContentConfig
                                    });
                                    internalRenderTask.operatorListChanged();
                                }).catch(complete);
                                return renderTask;
                            }
                        },
                        {
                            key: "getOperatorList",
                            value: function getOperatorList() {
                                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_intent = _ref.intent, intent = _ref_intent === void 0 ? "display" : _ref_intent, _ref_annotationMode = _ref.annotationMode, annotationMode = _ref_annotationMode === void 0 ? _util.AnnotationMode.ENABLE : _ref_annotationMode, _ref_printAnnotationStorage = _ref.printAnnotationStorage, printAnnotationStorage = _ref_printAnnotationStorage === void 0 ? null : _ref_printAnnotationStorage;
                                function operatorListChanged() {
                                    if (intentState.operatorList.lastChunk) {
                                        intentState.opListReadCapability.resolve(intentState.operatorList);
                                        intentState.renderTasks.delete(opListTask);
                                    }
                                }
                                var intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, true);
                                var intentState = this._intentStates.get(intentArgs.cacheKey);
                                if (!intentState) {
                                    intentState = Object.create(null);
                                    this._intentStates.set(intentArgs.cacheKey, intentState);
                                }
                                var opListTask;
                                if (!intentState.opListReadCapability) {
                                    var _this__stats;
                                    var _intentState;
                                    opListTask = Object.create(null);
                                    opListTask.operatorListChanged = operatorListChanged;
                                    intentState.opListReadCapability = new _util.PromiseCapability();
                                    ((_intentState = intentState).renderTasks || (_intentState.renderTasks = new Set())).add(opListTask);
                                    intentState.operatorList = {
                                        fnArray: [],
                                        argsArray: [],
                                        lastChunk: false,
                                        separateAnnots: null
                                    };
                                    (_this__stats = this._stats) === null || _this__stats === void 0 ? void 0 : _this__stats.time("Page Request");
                                    this._pumpOperatorList(intentArgs);
                                }
                                return intentState.opListReadCapability.promise;
                            }
                        },
                        {
                            key: "streamTextContent",
                            value: function streamTextContent() {
                                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_includeMarkedContent = _ref.includeMarkedContent, includeMarkedContent = _ref_includeMarkedContent === void 0 ? false : _ref_includeMarkedContent, _ref_disableNormalization = _ref.disableNormalization, disableNormalization = _ref_disableNormalization === void 0 ? false : _ref_disableNormalization;
                                var TEXT_CONTENT_CHUNK_SIZE = 100;
                                return this._transport.messageHandler.sendWithStream("GetTextContent", {
                                    pageIndex: this._pageIndex,
                                    includeMarkedContent: includeMarkedContent === true,
                                    disableNormalization: disableNormalization === true
                                }, {
                                    highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
                                    size: function(textContent) {
                                        return textContent.items.length;
                                    }
                                });
                            }
                        },
                        {
                            key: "getTextContent",
                            value: function getTextContent() {
                                var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                                if (this._transport._htmlForXfa) return this.getXfa().then(function(xfa) {
                                    return _xfa_text.XfaText.textContent(xfa);
                                });
                                var readableStream = this.streamTextContent(params);
                                return new Promise(function(resolve, reject) {
                                    function pump() {
                                        reader.read().then(function(param) {
                                            var value = param.value, done = param.done;
                                            var _textContent_items;
                                            if (done) {
                                                resolve(textContent);
                                                return;
                                            }
                                            Object.assign(textContent.styles, value.styles);
                                            (_textContent_items = textContent.items).push.apply(_textContent_items, (0, $fyztb._)(value.items));
                                            pump();
                                        }, reject);
                                    }
                                    var reader = readableStream.getReader();
                                    var textContent = {
                                        items: [],
                                        styles: Object.create(null)
                                    };
                                    pump();
                                });
                            }
                        },
                        {
                            key: "getStructTree",
                            value: function getStructTree() {
                                return this._transport.getStructTree(this._pageIndex);
                            }
                        },
                        {
                            key: "_destroy",
                            value: function _destroy() {
                                this.destroyed = true;
                                var waitOn = [];
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._intentStates.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var intentState = _step.value;
                                        this._abortOperatorList({
                                            intentState: intentState,
                                            reason: new Error("Page was destroyed."),
                                            force: true
                                        });
                                        if (intentState.opListReadCapability) continue;
                                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(var _iterator1 = intentState.renderTasks[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                var internalRenderTask = _step1.value;
                                                waitOn.push(internalRenderTask.completed);
                                                internalRenderTask.cancel();
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this.objs.clear();
                                (0, $4LHB0._)(this, _pendingCleanup, false);
                                (0, $lNbhr._)(this, _abortDelayedCleanup, abortDelayedCleanup).call(this);
                                return Promise.all(waitOn);
                            }
                        },
                        {
                            key: "cleanup",
                            value: function cleanup() {
                                var resetStats = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                                (0, $4LHB0._)(this, _pendingCleanup, true);
                                var success = (0, $lNbhr._)(this, _tryCleanup, tryCleanup).call(this, false);
                                if (resetStats && success) this._stats && (this._stats = new _display_utils.StatTimer());
                                return success;
                            }
                        },
                        {
                            key: "_startRenderPage",
                            value: function _startRenderPage(transparency, cacheKey) {
                                var _this__stats, _intentState_displayReadyCapability;
                                var intentState = this._intentStates.get(cacheKey);
                                if (!intentState) return;
                                (_this__stats = this._stats) === null || _this__stats === void 0 ? void 0 : _this__stats.timeEnd("Page Request");
                                (_intentState_displayReadyCapability = intentState.displayReadyCapability) === null || _intentState_displayReadyCapability === void 0 ? void 0 : _intentState_displayReadyCapability.resolve(transparency);
                            }
                        },
                        {
                            key: "_renderPageChunk",
                            value: function _renderPageChunk(operatorListChunk, intentState) {
                                for(var i = 0, ii = operatorListChunk.length; i < ii; i++){
                                    intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
                                    intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
                                }
                                intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
                                intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = intentState.renderTasks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var internalRenderTask = _step.value;
                                        internalRenderTask.operatorListChanged();
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (operatorListChunk.lastChunk) (0, $lNbhr._)(this, _tryCleanup, tryCleanup).call(this, true);
                            }
                        },
                        {
                            key: "_pumpOperatorList",
                            value: function _pumpOperatorList(param) {
                                var renderingIntent = param.renderingIntent, cacheKey = param.cacheKey, annotationStorageSerializable = param.annotationStorageSerializable;
                                var _this = this;
                                var map = annotationStorageSerializable.map, transfers = annotationStorageSerializable.transfers;
                                var readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                                    pageIndex: this._pageIndex,
                                    intent: renderingIntent,
                                    cacheKey: cacheKey,
                                    annotationStorage: map
                                }, transfers);
                                var reader = readableStream.getReader();
                                var intentState = this._intentStates.get(cacheKey);
                                intentState.streamReader = reader;
                                var pump = function() {
                                    reader.read().then(function(param) {
                                        var value = param.value, done = param.done;
                                        if (done) {
                                            intentState.streamReader = null;
                                            return;
                                        }
                                        if (_this._transport.destroyed) return;
                                        _this._renderPageChunk(value, intentState);
                                        pump();
                                    }, function(reason) {
                                        intentState.streamReader = null;
                                        if (_this._transport.destroyed) return;
                                        if (intentState.operatorList) {
                                            intentState.operatorList.lastChunk = true;
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = intentState.renderTasks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var internalRenderTask = _step.value;
                                                    internalRenderTask.operatorListChanged();
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                            (0, $lNbhr._)(_this, _tryCleanup, tryCleanup).call(_this, true);
                                        }
                                        if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                                        else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                                        else throw reason;
                                    });
                                };
                                pump();
                            }
                        },
                        {
                            key: "_abortOperatorList",
                            value: function _abortOperatorList(param) {
                                var intentState = param.intentState, reason = param.reason, _param_force = param.force, force = _param_force === void 0 ? false : _param_force;
                                var _this = this;
                                if (!intentState.streamReader) return;
                                if (intentState.streamReaderCancelTimeout) {
                                    clearTimeout(intentState.streamReaderCancelTimeout);
                                    intentState.streamReaderCancelTimeout = null;
                                }
                                if (!force) {
                                    if (intentState.renderTasks.size > 0) return;
                                    if (reason instanceof _display_utils.RenderingCancelledException) {
                                        var delay = RENDERING_CANCELLED_TIMEOUT;
                                        if (reason.extraDelay > 0 && reason.extraDelay < 1000) delay += reason.extraDelay;
                                        intentState.streamReaderCancelTimeout = setTimeout(function() {
                                            intentState.streamReaderCancelTimeout = null;
                                            _this._abortOperatorList({
                                                intentState: intentState,
                                                reason: reason,
                                                force: true
                                            });
                                        }, delay);
                                        return;
                                    }
                                }
                                intentState.streamReader.cancel(new _util.AbortException(reason.message)).catch(function() {});
                                intentState.streamReader = null;
                                if (this._transport.destroyed) return;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._intentStates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _step_value = (0, $52tJv._)(_step.value, 2), curCacheKey = _step_value[0], curIntentState = _step_value[1];
                                        if (curIntentState === intentState) {
                                            this._intentStates.delete(curCacheKey);
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this.cleanup();
                            }
                        },
                        {
                            key: "stats",
                            get: function get() {
                                return this._stats;
                            }
                        }
                    ]);
                    return PDFPageProxy;
                }();
                function tryCleanup() {
                    var delayed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                    var _this = this;
                    (0, $lNbhr._)(this, _abortDelayedCleanup, abortDelayedCleanup).call(this);
                    if (!(0, $057QZ._)(this, _pendingCleanup) || this.destroyed) return false;
                    if (delayed) {
                        (0, $4LHB0._)(this, _delayedCleanupTimeout, setTimeout(function() {
                            (0, $4LHB0._)(_this, _delayedCleanupTimeout, null);
                            (0, $lNbhr._)(_this, _tryCleanup, tryCleanup).call(_this, false);
                        }, DELAYED_CLEANUP_TIMEOUT));
                        return false;
                    }
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this._intentStates.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = _step.value, renderTasks = _step_value.renderTasks, operatorList = _step_value.operatorList;
                            if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this._intentStates.clear();
                    this.objs.clear();
                    (0, $4LHB0._)(this, _pendingCleanup, false);
                    return true;
                }
                function abortDelayedCleanup() {
                    if ((0, $057QZ._)(this, _delayedCleanupTimeout)) {
                        clearTimeout((0, $057QZ._)(this, _delayedCleanupTimeout));
                        (0, $4LHB0._)(this, _delayedCleanupTimeout, null);
                    }
                }
                exports.PDFPageProxy = PDFPageProxy;
                var _listeners = /*#__PURE__*/ new WeakMap(), _deferred = /*#__PURE__*/ new WeakMap();
                var LoopbackPort = /*#__PURE__*/ function() {
                    function LoopbackPort() {
                        (0, $5sFFs._)(this, LoopbackPort);
                        (0, $g12Hy._)(this, _listeners, {
                            writable: true,
                            value: new Set()
                        });
                        (0, $g12Hy._)(this, _deferred, {
                            writable: true,
                            value: Promise.resolve()
                        });
                    }
                    (0, $8O2fV._)(LoopbackPort, [
                        {
                            key: "postMessage",
                            value: function postMessage(obj, transfer) {
                                var _this = this;
                                var event = {
                                    data: structuredClone(obj, transfer ? {
                                        transfer: transfer
                                    } : null)
                                };
                                (0, $057QZ._)(this, _deferred).then(function() {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = (0, $057QZ._)(_this, _listeners)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var listener = _step.value;
                                            listener.call(_this, event);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                });
                            }
                        },
                        {
                            key: "addEventListener",
                            value: function addEventListener(name, listener) {
                                (0, $057QZ._)(this, _listeners).add(listener);
                            }
                        },
                        {
                            key: "removeEventListener",
                            value: function removeEventListener(name, listener) {
                                (0, $057QZ._)(this, _listeners).delete(listener);
                            }
                        },
                        {
                            key: "terminate",
                            value: function terminate() {
                                (0, $057QZ._)(this, _listeners).clear();
                            }
                        }
                    ]);
                    return LoopbackPort;
                }();
                exports.LoopbackPort = LoopbackPort;
                var PDFWorkerUtil = {
                    isWorkerDisabled: false,
                    fallbackWorkerSrc: null,
                    fakeWorkerId: 0
                };
                exports.PDFWorkerUtil = PDFWorkerUtil;
                if (_util.isNodeJS && true) {
                    PDFWorkerUtil.isWorkerDisabled = true;
                    PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
                } else if (typeof document === "object") {
                    var _document_currentScript, _document;
                    var pdfjsFilePath = (_document = document) === null || _document === void 0 ? void 0 : (_document_currentScript = _document.currentScript) === null || _document_currentScript === void 0 ? void 0 : _document_currentScript.src;
                    if (pdfjsFilePath) PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
                }
                PDFWorkerUtil.isSameOrigin = function(baseUrl, otherUrl) {
                    var base;
                    try {
                        base = new URL(baseUrl);
                        if (!base.origin || base.origin === "null") return false;
                    } catch (e) {
                        return false;
                    }
                    var other = new URL(otherUrl, base);
                    return base.origin === other.origin;
                };
                PDFWorkerUtil.createCDNWrapper = function(url) {
                    var wrapper = 'importScripts("'.concat(url, '");');
                    return URL.createObjectURL(new Blob([
                        wrapper
                    ]));
                };
                var PDFWorker = /*#__PURE__*/ function() {
                    function PDFWorker() {
                        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_name = _ref.name, name = _ref_name === void 0 ? null : _ref_name, _ref_port = _ref.port, port = _ref_port === void 0 ? null : _ref_port, _ref_verbosity = _ref.verbosity, verbosity = _ref_verbosity === void 0 ? (0, _util.getVerbosityLevel)() : _ref_verbosity;
                        (0, $5sFFs._)(this, PDFWorker);
                        var _PDFWorker;
                        this.name = name;
                        this.destroyed = false;
                        this.verbosity = verbosity;
                        this._readyCapability = new _util.PromiseCapability();
                        this._port = null;
                        this._webWorker = null;
                        this._messageHandler = null;
                        if (port) {
                            var _$_class_static_private_field_spec_get;
                            if ((_$_class_static_private_field_spec_get = (0, $cZGNE._)(PDFWorker, PDFWorker, _workerPorts)) === null || _$_class_static_private_field_spec_get === void 0 ? void 0 : _$_class_static_private_field_spec_get.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
                            (0, $3CqVU._)(_PDFWorker = PDFWorker, PDFWorker, _workerPorts, (0, $cZGNE._)(PDFWorker, PDFWorker, _workerPorts) || new WeakMap()).set(port, this);
                            this._initializeFromPort(port);
                            return;
                        }
                        this._initialize();
                    }
                    (0, $8O2fV._)(PDFWorker, [
                        {
                            key: "promise",
                            get: function get() {
                                return this._readyCapability.promise;
                            }
                        },
                        {
                            key: "port",
                            get: function get() {
                                return this._port;
                            }
                        },
                        {
                            key: "messageHandler",
                            get: function get() {
                                return this._messageHandler;
                            }
                        },
                        {
                            key: "_initializeFromPort",
                            value: function _initializeFromPort(port) {
                                this._port = port;
                                this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
                                this._messageHandler.on("ready", function() {});
                                this._readyCapability.resolve();
                                this._messageHandler.send("configure", {
                                    verbosity: this.verbosity
                                });
                            }
                        },
                        {
                            key: "_initialize",
                            value: function _initialize() {
                                var _this = this;
                                if (!PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                                    var workerSrc = PDFWorker.workerSrc;
                                    try {
                                        if (!PDFWorkerUtil.isSameOrigin(window.location.href, workerSrc)) workerSrc = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
                                        var worker = new Worker(workerSrc);
                                        var messageHandler = new _message_handler.MessageHandler("main", "worker", worker);
                                        var terminateEarly = function() {
                                            worker.removeEventListener("error", onWorkerError);
                                            messageHandler.destroy();
                                            worker.terminate();
                                            if (_this.destroyed) _this._readyCapability.reject(new Error("Worker was destroyed"));
                                            else _this._setupFakeWorker();
                                        };
                                        var onWorkerError = function() {
                                            if (!_this._webWorker) terminateEarly();
                                        };
                                        worker.addEventListener("error", onWorkerError);
                                        messageHandler.on("test", function(data) {
                                            worker.removeEventListener("error", onWorkerError);
                                            if (_this.destroyed) {
                                                terminateEarly();
                                                return;
                                            }
                                            if (data) {
                                                _this._messageHandler = messageHandler;
                                                _this._port = worker;
                                                _this._webWorker = worker;
                                                _this._readyCapability.resolve();
                                                messageHandler.send("configure", {
                                                    verbosity: _this.verbosity
                                                });
                                            } else {
                                                _this._setupFakeWorker();
                                                messageHandler.destroy();
                                                worker.terminate();
                                            }
                                        });
                                        messageHandler.on("ready", function(data) {
                                            worker.removeEventListener("error", onWorkerError);
                                            if (_this.destroyed) {
                                                terminateEarly();
                                                return;
                                            }
                                            try {
                                                sendTest();
                                            } catch (e) {
                                                _this._setupFakeWorker();
                                            }
                                        });
                                        var sendTest = function() {
                                            var testObj = new Uint8Array();
                                            messageHandler.send("test", testObj, [
                                                testObj.buffer
                                            ]);
                                        };
                                        sendTest();
                                        return;
                                    } catch (e) {
                                        (0, _util.info)("The worker has been disabled.");
                                    }
                                }
                                this._setupFakeWorker();
                            }
                        },
                        {
                            key: "_setupFakeWorker",
                            value: function _setupFakeWorker() {
                                var _this = this;
                                if (!PDFWorkerUtil.isWorkerDisabled) {
                                    (0, _util.warn)("Setting up fake worker.");
                                    PDFWorkerUtil.isWorkerDisabled = true;
                                }
                                PDFWorker._setupFakeWorkerGlobal.then(function(WorkerMessageHandler) {
                                    if (_this.destroyed) {
                                        _this._readyCapability.reject(new Error("Worker was destroyed"));
                                        return;
                                    }
                                    var port = new LoopbackPort();
                                    _this._port = port;
                                    var id = "fake".concat(PDFWorkerUtil.fakeWorkerId++);
                                    var workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
                                    WorkerMessageHandler.setup(workerHandler, port);
                                    var messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
                                    _this._messageHandler = messageHandler;
                                    _this._readyCapability.resolve();
                                    messageHandler.send("configure", {
                                        verbosity: _this.verbosity
                                    });
                                }).catch(function(reason) {
                                    _this._readyCapability.reject(new Error('Setting up fake worker failed: "'.concat(reason.message, '".')));
                                });
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                var _$_class_static_private_field_spec_get;
                                this.destroyed = true;
                                if (this._webWorker) {
                                    this._webWorker.terminate();
                                    this._webWorker = null;
                                }
                                (_$_class_static_private_field_spec_get = (0, $cZGNE._)(PDFWorker, PDFWorker, _workerPorts)) === null || _$_class_static_private_field_spec_get === void 0 ? void 0 : _$_class_static_private_field_spec_get.delete(this._port);
                                this._port = null;
                                if (this._messageHandler) {
                                    this._messageHandler.destroy();
                                    this._messageHandler = null;
                                }
                            }
                        }
                    ], [
                        {
                            key: "fromPort",
                            value: function fromPort(params) {
                                var _$_class_static_private_field_spec_get;
                                if (!(params === null || params === void 0 ? void 0 : params.port)) throw new Error("PDFWorker.fromPort - invalid method signature.");
                                var cachedPort = (_$_class_static_private_field_spec_get = (0, $cZGNE._)(this, PDFWorker, _workerPorts)) === null || _$_class_static_private_field_spec_get === void 0 ? void 0 : _$_class_static_private_field_spec_get.get(params.port);
                                if (cachedPort) {
                                    if (cachedPort._pendingDestroy) throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                                    return cachedPort;
                                }
                                return new PDFWorker(params);
                            }
                        },
                        {
                            key: "workerSrc",
                            get: function get() {
                                if (_worker_options.GlobalWorkerOptions.workerSrc) return _worker_options.GlobalWorkerOptions.workerSrc;
                                if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
                                    if (!_util.isNodeJS) (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                                    return PDFWorkerUtil.fallbackWorkerSrc;
                                }
                                throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
                            }
                        },
                        {
                            key: "_mainThreadWorkerMessageHandler",
                            get: function get() {
                                try {
                                    var _globalThis_pdfjsWorker;
                                    return ((_globalThis_pdfjsWorker = globalThis.pdfjsWorker) === null || _globalThis_pdfjsWorker === void 0 ? void 0 : _globalThis_pdfjsWorker.WorkerMessageHandler) || null;
                                } catch (e) {
                                    return null;
                                }
                            }
                        },
                        {
                            key: "_setupFakeWorkerGlobal",
                            get: function get() {
                                var _this = this;
                                var loader = function() {
                                    var _ref = (0, $7hBys._)(function() {
                                        var mainWorkerMessageHandler, worker;
                                        return (0, $ajhIL.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    mainWorkerMessageHandler = _this._mainThreadWorkerMessageHandler;
                                                    if (mainWorkerMessageHandler) return [
                                                        2,
                                                        mainWorkerMessageHandler
                                                    ];
                                                    if (_util.isNodeJS && true) {
                                                        worker = eval("require")(_this.workerSrc);
                                                        return [
                                                            2,
                                                            worker.WorkerMessageHandler
                                                        ];
                                                    }
                                                    return [
                                                        4,
                                                        (0, _display_utils.loadScript)(_this.workerSrc)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2,
                                                        window.pdfjsWorker.WorkerMessageHandler
                                                    ];
                                            }
                                        });
                                    });
                                    return function loader() {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
                            }
                        }
                    ]);
                    return PDFWorker;
                }();
                var _workerPorts = {
                    writable: true,
                    value: void 0
                };
                exports.PDFWorker = PDFWorker;
                var _methodPromises = /*#__PURE__*/ new WeakMap(), _pageCache = /*#__PURE__*/ new WeakMap(), _pagePromises = /*#__PURE__*/ new WeakMap(), _passwordCapability = /*#__PURE__*/ new WeakMap(), _cacheSimpleMethod = /*#__PURE__*/ new WeakSet();
                var WorkerTransport = /*#__PURE__*/ function() {
                    function WorkerTransport(messageHandler, loadingTask, networkStream, params, factory) {
                        (0, $5sFFs._)(this, WorkerTransport);
                        (0, $iB2CV._)(this, _cacheSimpleMethod);
                        (0, $g12Hy._)(this, _methodPromises, {
                            writable: true,
                            value: new Map()
                        });
                        (0, $g12Hy._)(this, _pageCache, {
                            writable: true,
                            value: new Map()
                        });
                        (0, $g12Hy._)(this, _pagePromises, {
                            writable: true,
                            value: new Map()
                        });
                        (0, $g12Hy._)(this, _passwordCapability, {
                            writable: true,
                            value: null
                        });
                        this.messageHandler = messageHandler;
                        this.loadingTask = loadingTask;
                        this.commonObjs = new PDFObjects();
                        this.fontLoader = new _font_loader.FontLoader({
                            ownerDocument: params.ownerDocument,
                            styleElement: params.styleElement
                        });
                        this._params = params;
                        this.canvasFactory = factory.canvasFactory;
                        this.filterFactory = factory.filterFactory;
                        this.cMapReaderFactory = factory.cMapReaderFactory;
                        this.standardFontDataFactory = factory.standardFontDataFactory;
                        this.destroyed = false;
                        this.destroyCapability = null;
                        this._networkStream = networkStream;
                        this._fullReader = null;
                        this._lastProgress = null;
                        this.downloadInfoCapability = new _util.PromiseCapability();
                        this.setupMessageHandler();
                    }
                    (0, $8O2fV._)(WorkerTransport, [
                        {
                            key: "annotationStorage",
                            get: function get() {
                                return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
                            }
                        },
                        {
                            key: "getRenderingIntent",
                            value: function getRenderingIntent(intent) {
                                var annotationMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _util.AnnotationMode.ENABLE, printAnnotationStorage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, isOpList = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                                var renderingIntent = _util.RenderingIntentFlag.DISPLAY;
                                var annotationStorageSerializable = _annotation_storage.SerializableEmpty;
                                switch(intent){
                                    case "any":
                                        renderingIntent = _util.RenderingIntentFlag.ANY;
                                        break;
                                    case "display":
                                        break;
                                    case "print":
                                        renderingIntent = _util.RenderingIntentFlag.PRINT;
                                        break;
                                    default:
                                        (0, _util.warn)("getRenderingIntent - invalid intent: ".concat(intent));
                                }
                                switch(annotationMode){
                                    case _util.AnnotationMode.DISABLE:
                                        renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                                        break;
                                    case _util.AnnotationMode.ENABLE:
                                        break;
                                    case _util.AnnotationMode.ENABLE_FORMS:
                                        renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                                        break;
                                    case _util.AnnotationMode.ENABLE_STORAGE:
                                        renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                                        var annotationStorage = renderingIntent & _util.RenderingIntentFlag.PRINT && printAnnotationStorage instanceof _annotation_storage.PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
                                        annotationStorageSerializable = annotationStorage.serializable;
                                        break;
                                    default:
                                        (0, _util.warn)("getRenderingIntent - invalid annotationMode: ".concat(annotationMode));
                                }
                                if (isOpList) renderingIntent += _util.RenderingIntentFlag.OPLIST;
                                return {
                                    renderingIntent: renderingIntent,
                                    cacheKey: "".concat(renderingIntent, "_").concat(annotationStorageSerializable.hash),
                                    annotationStorageSerializable: annotationStorageSerializable
                                };
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                var _this = this;
                                var _$_class_private_field_get;
                                if (this.destroyCapability) return this.destroyCapability.promise;
                                this.destroyed = true;
                                this.destroyCapability = new _util.PromiseCapability();
                                (_$_class_private_field_get = (0, $057QZ._)(this, _passwordCapability)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.reject(new Error("Worker was destroyed during onPassword callback"));
                                var waitOn = [];
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _pageCache).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var page = _step.value;
                                        waitOn.push(page._destroy());
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                (0, $057QZ._)(this, _pageCache).clear();
                                (0, $057QZ._)(this, _pagePromises).clear();
                                if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
                                var terminated = this.messageHandler.sendWithPromise("Terminate", null);
                                waitOn.push(terminated);
                                Promise.all(waitOn).then(function() {
                                    var _this__networkStream;
                                    _this.commonObjs.clear();
                                    _this.fontLoader.clear();
                                    (0, $057QZ._)(_this, _methodPromises).clear();
                                    _this.filterFactory.destroy();
                                    (_this__networkStream = _this._networkStream) === null || _this__networkStream === void 0 ? void 0 : _this__networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                                    if (_this.messageHandler) {
                                        _this.messageHandler.destroy();
                                        _this.messageHandler = null;
                                    }
                                    _this.destroyCapability.resolve();
                                }, this.destroyCapability.reject);
                                return this.destroyCapability.promise;
                            }
                        },
                        {
                            key: "setupMessageHandler",
                            value: function setupMessageHandler() {
                                var _this = this;
                                var _this1 = this, messageHandler = _this1.messageHandler, loadingTask = _this1.loadingTask;
                                messageHandler.on("GetReader", function(data, sink) {
                                    (0, _util.assert)(_this._networkStream, "GetReader - no `IPDFStream` instance available.");
                                    _this._fullReader = _this._networkStream.getFullReader();
                                    _this._fullReader.onProgress = function(evt) {
                                        _this._lastProgress = {
                                            loaded: evt.loaded,
                                            total: evt.total
                                        };
                                    };
                                    sink.onPull = function() {
                                        _this._fullReader.read().then(function(param) {
                                            var value = param.value, done = param.done;
                                            if (done) {
                                                sink.close();
                                                return;
                                            }
                                            (0, _util.assert)(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                                            sink.enqueue(new Uint8Array(value), 1, [
                                                value
                                            ]);
                                        }).catch(function(reason) {
                                            sink.error(reason);
                                        });
                                    };
                                    sink.onCancel = function(reason) {
                                        _this._fullReader.cancel(reason);
                                        sink.ready.catch(function(readyReason) {
                                            if (_this.destroyed) return;
                                            throw readyReason;
                                        });
                                    };
                                });
                                messageHandler.on("ReaderHeadersReady", function(data) {
                                    var headersCapability = new _util.PromiseCapability();
                                    var fullReader = _this._fullReader;
                                    fullReader.headersReady.then(function() {
                                        if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                                            var _loadingTask_onProgress;
                                            if (_this._lastProgress) (_loadingTask_onProgress = loadingTask.onProgress) === null || _loadingTask_onProgress === void 0 ? void 0 : _loadingTask_onProgress.call(loadingTask, _this._lastProgress);
                                            fullReader.onProgress = function(evt) {
                                                var _loadingTask_onProgress;
                                                (_loadingTask_onProgress = loadingTask.onProgress) === null || _loadingTask_onProgress === void 0 ? void 0 : _loadingTask_onProgress.call(loadingTask, {
                                                    loaded: evt.loaded,
                                                    total: evt.total
                                                });
                                            };
                                        }
                                        headersCapability.resolve({
                                            isStreamingSupported: fullReader.isStreamingSupported,
                                            isRangeSupported: fullReader.isRangeSupported,
                                            contentLength: fullReader.contentLength
                                        });
                                    }, headersCapability.reject);
                                    return headersCapability.promise;
                                });
                                messageHandler.on("GetRangeReader", function(data, sink) {
                                    (0, _util.assert)(_this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                                    var rangeReader = _this._networkStream.getRangeReader(data.begin, data.end);
                                    if (!rangeReader) {
                                        sink.close();
                                        return;
                                    }
                                    sink.onPull = function() {
                                        rangeReader.read().then(function(param) {
                                            var value = param.value, done = param.done;
                                            if (done) {
                                                sink.close();
                                                return;
                                            }
                                            (0, _util.assert)(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                                            sink.enqueue(new Uint8Array(value), 1, [
                                                value
                                            ]);
                                        }).catch(function(reason) {
                                            sink.error(reason);
                                        });
                                    };
                                    sink.onCancel = function(reason) {
                                        rangeReader.cancel(reason);
                                        sink.ready.catch(function(readyReason) {
                                            if (_this.destroyed) return;
                                            throw readyReason;
                                        });
                                    };
                                });
                                messageHandler.on("GetDoc", function(param) {
                                    var pdfInfo = param.pdfInfo;
                                    _this._numPages = pdfInfo.numPages;
                                    _this._htmlForXfa = pdfInfo.htmlForXfa;
                                    delete pdfInfo.htmlForXfa;
                                    loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, _this));
                                });
                                messageHandler.on("DocException", function(ex) {
                                    var reason;
                                    switch(ex.name){
                                        case "PasswordException":
                                            reason = new _util.PasswordException(ex.message, ex.code);
                                            break;
                                        case "InvalidPDFException":
                                            reason = new _util.InvalidPDFException(ex.message);
                                            break;
                                        case "MissingPDFException":
                                            reason = new _util.MissingPDFException(ex.message);
                                            break;
                                        case "UnexpectedResponseException":
                                            reason = new _util.UnexpectedResponseException(ex.message, ex.status);
                                            break;
                                        case "UnknownErrorException":
                                            reason = new _util.UnknownErrorException(ex.message, ex.details);
                                            break;
                                        default:
                                            (0, _util.unreachable)("DocException - expected a valid Error.");
                                    }
                                    loadingTask._capability.reject(reason);
                                });
                                messageHandler.on("PasswordRequest", function(exception) {
                                    (0, $4LHB0._)(_this, _passwordCapability, new _util.PromiseCapability());
                                    if (loadingTask.onPassword) {
                                        var updatePassword = function(password) {
                                            if (password instanceof Error) (0, $057QZ._)(_this, _passwordCapability).reject(password);
                                            else (0, $057QZ._)(_this, _passwordCapability).resolve({
                                                password: password
                                            });
                                        };
                                        try {
                                            loadingTask.onPassword(updatePassword, exception.code);
                                        } catch (ex) {
                                            (0, $057QZ._)(_this, _passwordCapability).reject(ex);
                                        }
                                    } else (0, $057QZ._)(_this, _passwordCapability).reject(new _util.PasswordException(exception.message, exception.code));
                                    return (0, $057QZ._)(_this, _passwordCapability).promise;
                                });
                                messageHandler.on("DataLoaded", function(data) {
                                    var _loadingTask_onProgress;
                                    (_loadingTask_onProgress = loadingTask.onProgress) === null || _loadingTask_onProgress === void 0 ? void 0 : _loadingTask_onProgress.call(loadingTask, {
                                        loaded: data.length,
                                        total: data.length
                                    });
                                    _this.downloadInfoCapability.resolve(data);
                                });
                                messageHandler.on("StartRenderPage", function(data) {
                                    if (_this.destroyed) return;
                                    var page = (0, $057QZ._)(_this, _pageCache).get(data.pageIndex);
                                    page._startRenderPage(data.transparency, data.cacheKey);
                                });
                                messageHandler.on("commonobj", function(param) {
                                    var _param = (0, $52tJv._)(param, 3), id = _param[0], type = _param[1], exportedData = _param[2];
                                    if (_this.destroyed) return;
                                    if (_this.commonObjs.has(id)) return;
                                    switch(type){
                                        case "Font":
                                            var _globalThis_FontInspector;
                                            var params = _this._params;
                                            if ("error" in exportedData) {
                                                var exportedError = exportedData.error;
                                                (0, _util.warn)("Error during font loading: ".concat(exportedError));
                                                _this.commonObjs.resolve(id, exportedError);
                                                break;
                                            }
                                            var inspectFont = params.pdfBug && ((_globalThis_FontInspector = globalThis.FontInspector) === null || _globalThis_FontInspector === void 0 ? void 0 : _globalThis_FontInspector.enabled) ? function(font, url) {
                                                return globalThis.FontInspector.fontAdded(font, url);
                                            } : null;
                                            var font = new _font_loader.FontFaceObject(exportedData, {
                                                isEvalSupported: params.isEvalSupported,
                                                disableFontFace: params.disableFontFace,
                                                ignoreErrors: params.ignoreErrors,
                                                inspectFont: inspectFont
                                            });
                                            _this.fontLoader.bind(font).catch(function(reason) {
                                                return messageHandler.sendWithPromise("FontFallback", {
                                                    id: id
                                                });
                                            }).finally(function() {
                                                if (!params.fontExtraProperties && font.data) font.data = null;
                                                _this.commonObjs.resolve(id, font);
                                            });
                                            break;
                                        case "FontPath":
                                        case "Image":
                                        case "Pattern":
                                            _this.commonObjs.resolve(id, exportedData);
                                            break;
                                        default:
                                            throw new Error("Got unknown common object type ".concat(type));
                                    }
                                });
                                messageHandler.on("obj", function(param) {
                                    var _param = (0, $52tJv._)(param, 4), id = _param[0], pageIndex = _param[1], type = _param[2], imageData = _param[3];
                                    if (_this.destroyed) return;
                                    var pageProxy = (0, $057QZ._)(_this, _pageCache).get(pageIndex);
                                    if (pageProxy.objs.has(id)) return;
                                    switch(type){
                                        case "Image":
                                            pageProxy.objs.resolve(id, imageData);
                                            if (imageData) {
                                                var _imageData_data;
                                                var length;
                                                if (imageData.bitmap) {
                                                    var width = imageData.width, height = imageData.height;
                                                    length = width * height * 4;
                                                } else length = ((_imageData_data = imageData.data) === null || _imageData_data === void 0 ? void 0 : _imageData_data.length) || 0;
                                                if (length > _util.MAX_IMAGE_SIZE_TO_CACHE) pageProxy._maybeCleanupAfterRender = true;
                                            }
                                            break;
                                        case "Pattern":
                                            pageProxy.objs.resolve(id, imageData);
                                            break;
                                        default:
                                            throw new Error("Got unknown object type ".concat(type));
                                    }
                                });
                                messageHandler.on("DocProgress", function(data) {
                                    var _loadingTask_onProgress;
                                    if (_this.destroyed) return;
                                    (_loadingTask_onProgress = loadingTask.onProgress) === null || _loadingTask_onProgress === void 0 ? void 0 : _loadingTask_onProgress.call(loadingTask, {
                                        loaded: data.loaded,
                                        total: data.total
                                    });
                                });
                                messageHandler.on("FetchBuiltInCMap", function(data) {
                                    if (_this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                                    if (!_this.cMapReaderFactory) return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                                    return _this.cMapReaderFactory.fetch(data);
                                });
                                messageHandler.on("FetchStandardFontData", function(data) {
                                    if (_this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                                    if (!_this.standardFontDataFactory) return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                                    return _this.standardFontDataFactory.fetch(data);
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function getData() {
                                return this.messageHandler.sendWithPromise("GetData", null);
                            }
                        },
                        {
                            key: "saveDocument",
                            value: function saveDocument() {
                                var _this = this;
                                var _this__fullReader;
                                if (this.annotationStorage.size <= 0) (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                                var _this_annotationStorage_serializable = this.annotationStorage.serializable, map = _this_annotationStorage_serializable.map, transfers = _this_annotationStorage_serializable.transfers;
                                var _this__fullReader_filename;
                                return this.messageHandler.sendWithPromise("SaveDocument", {
                                    isPureXfa: !!this._htmlForXfa,
                                    numPages: this._numPages,
                                    annotationStorage: map,
                                    filename: (_this__fullReader_filename = (_this__fullReader = this._fullReader) === null || _this__fullReader === void 0 ? void 0 : _this__fullReader.filename) !== null && _this__fullReader_filename !== void 0 ? _this__fullReader_filename : null
                                }, transfers).finally(function() {
                                    _this.annotationStorage.resetModified();
                                });
                            }
                        },
                        {
                            key: "getPage",
                            value: function getPage(pageNumber) {
                                var _this = this;
                                if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) return Promise.reject(new Error("Invalid page request."));
                                var pageIndex = pageNumber - 1, cachedPromise = (0, $057QZ._)(this, _pagePromises).get(pageIndex);
                                if (cachedPromise) return cachedPromise;
                                var promise = this.messageHandler.sendWithPromise("GetPage", {
                                    pageIndex: pageIndex
                                }).then(function(pageInfo) {
                                    if (_this.destroyed) throw new Error("Transport destroyed");
                                    var page = new PDFPageProxy(pageIndex, pageInfo, _this, _this._params.pdfBug);
                                    (0, $057QZ._)(_this, _pageCache).set(pageIndex, page);
                                    return page;
                                });
                                (0, $057QZ._)(this, _pagePromises).set(pageIndex, promise);
                                return promise;
                            }
                        },
                        {
                            key: "getPageIndex",
                            value: function getPageIndex(ref) {
                                if (typeof ref !== "object" || ref === null || !Number.isInteger(ref.num) || ref.num < 0 || !Number.isInteger(ref.gen) || ref.gen < 0) return Promise.reject(new Error("Invalid pageIndex request."));
                                return this.messageHandler.sendWithPromise("GetPageIndex", {
                                    num: ref.num,
                                    gen: ref.gen
                                });
                            }
                        },
                        {
                            key: "getAnnotations",
                            value: function getAnnotations(pageIndex, intent) {
                                return this.messageHandler.sendWithPromise("GetAnnotations", {
                                    pageIndex: pageIndex,
                                    intent: intent
                                });
                            }
                        },
                        {
                            key: "getFieldObjects",
                            value: function getFieldObjects() {
                                return (0, $lNbhr._)(this, _cacheSimpleMethod, cacheSimpleMethod).call(this, "GetFieldObjects");
                            }
                        },
                        {
                            key: "hasJSActions",
                            value: function hasJSActions() {
                                return (0, $lNbhr._)(this, _cacheSimpleMethod, cacheSimpleMethod).call(this, "HasJSActions");
                            }
                        },
                        {
                            key: "getCalculationOrderIds",
                            value: function getCalculationOrderIds() {
                                return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
                            }
                        },
                        {
                            key: "getDestinations",
                            value: function getDestinations() {
                                return this.messageHandler.sendWithPromise("GetDestinations", null);
                            }
                        },
                        {
                            key: "getDestination",
                            value: function getDestination(id) {
                                if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
                                return this.messageHandler.sendWithPromise("GetDestination", {
                                    id: id
                                });
                            }
                        },
                        {
                            key: "getPageLabels",
                            value: function getPageLabels() {
                                return this.messageHandler.sendWithPromise("GetPageLabels", null);
                            }
                        },
                        {
                            key: "getPageLayout",
                            value: function getPageLayout() {
                                return this.messageHandler.sendWithPromise("GetPageLayout", null);
                            }
                        },
                        {
                            key: "getPageMode",
                            value: function getPageMode() {
                                return this.messageHandler.sendWithPromise("GetPageMode", null);
                            }
                        },
                        {
                            key: "getViewerPreferences",
                            value: function getViewerPreferences() {
                                return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
                            }
                        },
                        {
                            key: "getOpenAction",
                            value: function getOpenAction() {
                                return this.messageHandler.sendWithPromise("GetOpenAction", null);
                            }
                        },
                        {
                            key: "getAttachments",
                            value: function getAttachments() {
                                return this.messageHandler.sendWithPromise("GetAttachments", null);
                            }
                        },
                        {
                            key: "getDocJSActions",
                            value: function getDocJSActions() {
                                return (0, $lNbhr._)(this, _cacheSimpleMethod, cacheSimpleMethod).call(this, "GetDocJSActions");
                            }
                        },
                        {
                            key: "getPageJSActions",
                            value: function getPageJSActions(pageIndex) {
                                return this.messageHandler.sendWithPromise("GetPageJSActions", {
                                    pageIndex: pageIndex
                                });
                            }
                        },
                        {
                            key: "getStructTree",
                            value: function getStructTree(pageIndex) {
                                return this.messageHandler.sendWithPromise("GetStructTree", {
                                    pageIndex: pageIndex
                                });
                            }
                        },
                        {
                            key: "getOutline",
                            value: function getOutline() {
                                return this.messageHandler.sendWithPromise("GetOutline", null);
                            }
                        },
                        {
                            key: "getOptionalContentConfig",
                            value: function getOptionalContentConfig() {
                                return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then(function(results) {
                                    return new _optional_content_config.OptionalContentConfig(results);
                                });
                            }
                        },
                        {
                            key: "getPermissions",
                            value: function getPermissions() {
                                return this.messageHandler.sendWithPromise("GetPermissions", null);
                            }
                        },
                        {
                            key: "getMetadata",
                            value: function getMetadata() {
                                var _this = this;
                                var name = "GetMetadata", cachedPromise = (0, $057QZ._)(this, _methodPromises).get(name);
                                if (cachedPromise) return cachedPromise;
                                var promise = this.messageHandler.sendWithPromise(name, null).then(function(results) {
                                    var _this__fullReader, _this__fullReader1;
                                    var _this__fullReader_filename, _this__fullReader_contentLength;
                                    return {
                                        info: results[0],
                                        metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                                        contentDispositionFilename: (_this__fullReader_filename = (_this__fullReader = _this._fullReader) === null || _this__fullReader === void 0 ? void 0 : _this__fullReader.filename) !== null && _this__fullReader_filename !== void 0 ? _this__fullReader_filename : null,
                                        contentLength: (_this__fullReader_contentLength = (_this__fullReader1 = _this._fullReader) === null || _this__fullReader1 === void 0 ? void 0 : _this__fullReader1.contentLength) !== null && _this__fullReader_contentLength !== void 0 ? _this__fullReader_contentLength : null
                                    };
                                });
                                (0, $057QZ._)(this, _methodPromises).set(name, promise);
                                return promise;
                            }
                        },
                        {
                            key: "getMarkInfo",
                            value: function getMarkInfo() {
                                return this.messageHandler.sendWithPromise("GetMarkInfo", null);
                            }
                        },
                        {
                            key: "startCleanup",
                            value: function startCleanup() {
                                var keepLoadedFonts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, page, cleanupSuccessful;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (_this.destroyed) return [
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    _this.messageHandler.sendWithPromise("Cleanup", null)
                                                ];
                                            case 1:
                                                _state.sent();
                                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                try {
                                                    for(_iterator = (0, $057QZ._)(_this, _pageCache).values()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                        page = _step.value;
                                                        cleanupSuccessful = page.cleanup();
                                                        if (!cleanupSuccessful) throw new Error("startCleanup: Page ".concat(page.pageNumber, " is currently rendering."));
                                                    }
                                                } catch (err) {
                                                    _didIteratorError = true;
                                                    _iteratorError = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                            _iterator.return();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError) {
                                                            throw _iteratorError;
                                                        }
                                                    }
                                                }
                                                _this.commonObjs.clear();
                                                if (!keepLoadedFonts) _this.fontLoader.clear();
                                                (0, $057QZ._)(_this, _methodPromises).clear();
                                                _this.filterFactory.destroy(true);
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }
                        },
                        {
                            key: "loadingParams",
                            get: function get() {
                                var _this__params = this._params, disableAutoFetch = _this__params.disableAutoFetch, enableXfa = _this__params.enableXfa;
                                return (0, _util.shadow)(this, "loadingParams", {
                                    disableAutoFetch: disableAutoFetch,
                                    enableXfa: enableXfa
                                });
                            }
                        }
                    ]);
                    return WorkerTransport;
                }();
                function cacheSimpleMethod(name) {
                    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                    var cachedPromise = (0, $057QZ._)(this, _methodPromises).get(name);
                    if (cachedPromise) return cachedPromise;
                    var promise = this.messageHandler.sendWithPromise(name, data);
                    (0, $057QZ._)(this, _methodPromises).set(name, promise);
                    return promise;
                }
                var _objs = /*#__PURE__*/ new WeakMap(), _ensureObj = /*#__PURE__*/ new WeakSet();
                var PDFObjects = /*#__PURE__*/ function() {
                    function PDFObjects() {
                        (0, $5sFFs._)(this, PDFObjects);
                        (0, $iB2CV._)(this, _ensureObj);
                        (0, $g12Hy._)(this, _objs, {
                            writable: true,
                            value: Object.create(null)
                        });
                    }
                    (0, $8O2fV._)(PDFObjects, [
                        {
                            key: "get",
                            value: function get(objId) {
                                var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                                if (callback) {
                                    var obj = (0, $lNbhr._)(this, _ensureObj, ensureObj).call(this, objId);
                                    obj.capability.promise.then(function() {
                                        return callback(obj.data);
                                    });
                                    return null;
                                }
                                var obj1 = (0, $057QZ._)(this, _objs)[objId];
                                if (!(obj1 === null || obj1 === void 0 ? void 0 : obj1.capability.settled)) throw new Error("Requesting object that isn't resolved yet ".concat(objId, "."));
                                return obj1.data;
                            }
                        },
                        {
                            key: "has",
                            value: function has(objId) {
                                var obj = (0, $057QZ._)(this, _objs)[objId];
                                return (obj === null || obj === void 0 ? void 0 : obj.capability.settled) || false;
                            }
                        },
                        {
                            key: "resolve",
                            value: function resolve(objId) {
                                var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                                var obj = (0, $lNbhr._)(this, _ensureObj, ensureObj).call(this, objId);
                                obj.data = data;
                                obj.capability.resolve();
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                for(var objId in (0, $057QZ._)(this, _objs)){
                                    var _data_bitmap;
                                    var data = (0, $057QZ._)(this, _objs)[objId].data;
                                    data === null || data === void 0 ? void 0 : (_data_bitmap = data.bitmap) === null || _data_bitmap === void 0 ? void 0 : _data_bitmap.close();
                                }
                                (0, $4LHB0._)(this, _objs, Object.create(null));
                            }
                        }
                    ]);
                    return PDFObjects;
                }();
                function ensureObj(objId) {
                    var _$_class_private_field_get, _objId;
                    return (_$_class_private_field_get = (0, $057QZ._)(this, _objs))[_objId = objId] || (_$_class_private_field_get[_objId] = {
                        capability: new _util.PromiseCapability(),
                        data: null
                    });
                }
                var _internalRenderTask = /*#__PURE__*/ new WeakMap();
                var RenderTask = /*#__PURE__*/ function() {
                    function RenderTask(internalRenderTask) {
                        (0, $5sFFs._)(this, RenderTask);
                        (0, $g12Hy._)(this, _internalRenderTask, {
                            writable: true,
                            value: null
                        });
                        (0, $4LHB0._)(this, _internalRenderTask, internalRenderTask);
                        this.onContinue = null;
                    }
                    (0, $8O2fV._)(RenderTask, [
                        {
                            key: "promise",
                            get: function get() {
                                return (0, $057QZ._)(this, _internalRenderTask).capability.promise;
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel() {
                                var extraDelay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                                (0, $057QZ._)(this, _internalRenderTask).cancel(null, extraDelay);
                            }
                        },
                        {
                            key: "separateAnnots",
                            get: function get() {
                                var separateAnnots = (0, $057QZ._)(this, _internalRenderTask).operatorList.separateAnnots;
                                if (!separateAnnots) return false;
                                var annotationCanvasMap = (0, $057QZ._)(this, _internalRenderTask).annotationCanvasMap;
                                return separateAnnots.form || separateAnnots.canvas && (annotationCanvasMap === null || annotationCanvasMap === void 0 ? void 0 : annotationCanvasMap.size) > 0;
                            }
                        }
                    ]);
                    return RenderTask;
                }();
                exports.RenderTask = RenderTask;
                var InternalRenderTask = /*#__PURE__*/ function() {
                    function InternalRenderTask(param) {
                        var callback = param.callback, params = param.params, objs = param.objs, commonObjs = param.commonObjs, annotationCanvasMap = param.annotationCanvasMap, operatorList = param.operatorList, pageIndex = param.pageIndex, canvasFactory = param.canvasFactory, filterFactory = param.filterFactory, _param_useRequestAnimationFrame = param.useRequestAnimationFrame, useRequestAnimationFrame = _param_useRequestAnimationFrame === void 0 ? false : _param_useRequestAnimationFrame, _param_pdfBug = param.pdfBug, pdfBug = _param_pdfBug === void 0 ? false : _param_pdfBug, _param_pageColors = param.pageColors, pageColors = _param_pageColors === void 0 ? null : _param_pageColors;
                        (0, $5sFFs._)(this, InternalRenderTask);
                        this.callback = callback;
                        this.params = params;
                        this.objs = objs;
                        this.commonObjs = commonObjs;
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.operatorListIdx = null;
                        this.operatorList = operatorList;
                        this._pageIndex = pageIndex;
                        this.canvasFactory = canvasFactory;
                        this.filterFactory = filterFactory;
                        this._pdfBug = pdfBug;
                        this.pageColors = pageColors;
                        this.running = false;
                        this.graphicsReadyCallback = null;
                        this.graphicsReady = false;
                        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
                        this.cancelled = false;
                        this.capability = new _util.PromiseCapability();
                        this.task = new RenderTask(this);
                        this._cancelBound = this.cancel.bind(this);
                        this._continueBound = this._continue.bind(this);
                        this._scheduleNextBound = this._scheduleNext.bind(this);
                        this._nextBound = this._next.bind(this);
                        this._canvas = params.canvasContext.canvas;
                    }
                    (0, $8O2fV._)(InternalRenderTask, [
                        {
                            key: "completed",
                            get: function get() {
                                return this.capability.promise.catch(function() {});
                            }
                        },
                        {
                            key: "initializeGraphics",
                            value: function initializeGraphics(param) {
                                var _param_transparency = param.transparency, transparency = _param_transparency === void 0 ? false : _param_transparency, optionalContentConfig = param.optionalContentConfig;
                                var _globalThis_StepperManager, _this_graphicsReadyCallback, _this;
                                if (this.cancelled) return;
                                if (this._canvas) {
                                    if ((0, $cZGNE._)(InternalRenderTask, InternalRenderTask, _canvasInUse).has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                                    (0, $cZGNE._)(InternalRenderTask, InternalRenderTask, _canvasInUse).add(this._canvas);
                                }
                                if (this._pdfBug && ((_globalThis_StepperManager = globalThis.StepperManager) === null || _globalThis_StepperManager === void 0 ? void 0 : _globalThis_StepperManager.enabled)) {
                                    this.stepper = globalThis.StepperManager.create(this._pageIndex);
                                    this.stepper.init(this.operatorList);
                                    this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                                }
                                var _this_params = this.params, canvasContext = _this_params.canvasContext, viewport = _this_params.viewport, transform = _this_params.transform, background = _this_params.background;
                                this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                                    optionalContentConfig: optionalContentConfig
                                }, this.annotationCanvasMap, this.pageColors);
                                this.gfx.beginDrawing({
                                    transform: transform,
                                    viewport: viewport,
                                    transparency: transparency,
                                    background: background
                                });
                                this.operatorListIdx = 0;
                                this.graphicsReady = true;
                                (_this_graphicsReadyCallback = (_this = this).graphicsReadyCallback) === null || _this_graphicsReadyCallback === void 0 ? void 0 : _this_graphicsReadyCallback.call(_this);
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel() {
                                var error = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, extraDelay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                                var _this_gfx;
                                this.running = false;
                                this.cancelled = true;
                                (_this_gfx = this.gfx) === null || _this_gfx === void 0 ? void 0 : _this_gfx.endDrawing();
                                (0, $cZGNE._)(InternalRenderTask, InternalRenderTask, _canvasInUse).delete(this._canvas);
                                this.callback(error || new _display_utils.RenderingCancelledException("Rendering cancelled, page ".concat(this._pageIndex + 1), extraDelay));
                            }
                        },
                        {
                            key: "operatorListChanged",
                            value: function operatorListChanged() {
                                var _this_stepper;
                                if (!this.graphicsReady) {
                                    this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
                                    return;
                                }
                                (_this_stepper = this.stepper) === null || _this_stepper === void 0 ? void 0 : _this_stepper.updateOperatorList(this.operatorList);
                                if (this.running) return;
                                this._continue();
                            }
                        },
                        {
                            key: "_continue",
                            value: function _continue() {
                                this.running = true;
                                if (this.cancelled) return;
                                if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
                                else this._scheduleNext();
                            }
                        },
                        {
                            key: "_scheduleNext",
                            value: function _scheduleNext() {
                                var _this = this;
                                if (this._useRequestAnimationFrame) window.requestAnimationFrame(function() {
                                    _this._nextBound().catch(_this._cancelBound);
                                });
                                else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
                            }
                        },
                        {
                            key: "_next",
                            value: function _next() {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        if (_this.cancelled) return [
                                            2
                                        ];
                                        _this.operatorListIdx = _this.gfx.executeOperatorList(_this.operatorList, _this.operatorListIdx, _this._continueBound, _this.stepper);
                                        if (_this.operatorListIdx === _this.operatorList.argsArray.length) {
                                            _this.running = false;
                                            if (_this.operatorList.lastChunk) {
                                                _this.gfx.endDrawing();
                                                (0, $cZGNE._)(InternalRenderTask, InternalRenderTask, _canvasInUse).delete(_this._canvas);
                                                _this.callback();
                                            }
                                        }
                                        return [
                                            2
                                        ];
                                    });
                                })();
                            }
                        }
                    ]);
                    return InternalRenderTask;
                }();
                var _canvasInUse = {
                    writable: true,
                    value: new WeakSet()
                };
                var version = "3.11.174";
                exports.version = version;
                var build = "ce8716743";
                exports.build = build;
            /***/ },
            /* 3 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SerializableEmpty = exports.PrintAnnotationStorage = exports.AnnotationStorage = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _murmurhash = __w_pdfjs_require__(8);
                var SerializableEmpty = Object.freeze({
                    map: null,
                    hash: "",
                    transfers: undefined
                });
                exports.SerializableEmpty = SerializableEmpty;
                var _modified = /*#__PURE__*/ new WeakMap(), _storage = /*#__PURE__*/ new WeakMap(), _setModified = /*#__PURE__*/ new WeakSet();
                var AnnotationStorage = /*#__PURE__*/ function() {
                    function AnnotationStorage() {
                        (0, $5sFFs._)(this, AnnotationStorage);
                        (0, $iB2CV._)(this, _setModified);
                        (0, $g12Hy._)(this, _modified, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)(this, _storage, {
                            writable: true,
                            value: new Map()
                        });
                        this.onSetModified = null;
                        this.onResetModified = null;
                        this.onAnnotationEditor = null;
                    }
                    (0, $8O2fV._)(AnnotationStorage, [
                        {
                            key: "getValue",
                            value: function getValue(key, defaultValue) {
                                var value = (0, $057QZ._)(this, _storage).get(key);
                                if (value === undefined) return defaultValue;
                                return Object.assign(defaultValue, value);
                            }
                        },
                        {
                            key: "getRawValue",
                            value: function getRawValue(key) {
                                return (0, $057QZ._)(this, _storage).get(key);
                            }
                        },
                        {
                            key: "remove",
                            value: function remove(key) {
                                (0, $057QZ._)(this, _storage).delete(key);
                                if ((0, $057QZ._)(this, _storage).size === 0) this.resetModified();
                                if (typeof this.onAnnotationEditor === "function") {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = (0, $057QZ._)(this, _storage).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var value = _step.value;
                                            if (value instanceof _editor.AnnotationEditor) return;
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    this.onAnnotationEditor(null);
                                }
                            }
                        },
                        {
                            key: "setValue",
                            value: function setValue(key, value) {
                                var obj = (0, $057QZ._)(this, _storage).get(key);
                                var modified = false;
                                if (obj !== undefined) {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = Object.entries(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var _step_value = (0, $52tJv._)(_step.value, 2), entry = _step_value[0], val = _step_value[1];
                                            if (obj[entry] !== val) {
                                                modified = true;
                                                obj[entry] = val;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                } else {
                                    modified = true;
                                    (0, $057QZ._)(this, _storage).set(key, value);
                                }
                                if (modified) (0, $lNbhr._)(this, _setModified, setModified).call(this);
                                if (value instanceof _editor.AnnotationEditor && typeof this.onAnnotationEditor === "function") this.onAnnotationEditor(value.constructor._type);
                            }
                        },
                        {
                            key: "has",
                            value: function has(key) {
                                return (0, $057QZ._)(this, _storage).has(key);
                            }
                        },
                        {
                            key: "getAll",
                            value: function getAll() {
                                return (0, $057QZ._)(this, _storage).size > 0 ? (0, _util.objectFromMap)((0, $057QZ._)(this, _storage)) : null;
                            }
                        },
                        {
                            key: "setAll",
                            value: function setAll(obj) {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = Object.entries(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _step_value = (0, $52tJv._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
                                        this.setValue(key, val);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "size",
                            get: function get() {
                                return (0, $057QZ._)(this, _storage).size;
                            }
                        },
                        {
                            key: "resetModified",
                            value: function resetModified() {
                                if ((0, $057QZ._)(this, _modified)) {
                                    (0, $4LHB0._)(this, _modified, false);
                                    if (typeof this.onResetModified === "function") this.onResetModified();
                                }
                            }
                        },
                        {
                            key: "print",
                            get: function get() {
                                return new PrintAnnotationStorage(this);
                            }
                        },
                        {
                            key: "serializable",
                            get: function get() {
                                if ((0, $057QZ._)(this, _storage).size === 0) return SerializableEmpty;
                                var map = new Map(), hash = new _murmurhash.MurmurHash3_64(), transfers = [];
                                var context = Object.create(null);
                                var hasBitmap = false;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _storage)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _step_value = (0, $52tJv._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
                                        var serialized = val instanceof _editor.AnnotationEditor ? val.serialize(false, context) : val;
                                        if (serialized) {
                                            map.set(key, serialized);
                                            hash.update("".concat(key, ":").concat(JSON.stringify(serialized)));
                                            hasBitmap || (hasBitmap = !!serialized.bitmap);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (hasBitmap) {
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = map.values()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var value = _step1.value;
                                            if (value.bitmap) transfers.push(value.bitmap);
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                }
                                return map.size > 0 ? {
                                    map: map,
                                    hash: hash.hexdigest(),
                                    transfers: transfers
                                } : SerializableEmpty;
                            }
                        }
                    ]);
                    return AnnotationStorage;
                }();
                function setModified() {
                    if (!(0, $057QZ._)(this, _modified)) {
                        (0, $4LHB0._)(this, _modified, true);
                        if (typeof this.onSetModified === "function") this.onSetModified();
                    }
                }
                exports.AnnotationStorage = AnnotationStorage;
                var _serializable = /*#__PURE__*/ new WeakMap();
                var PrintAnnotationStorage = /*#__PURE__*/ function(AnnotationStorage) {
                    (0, $kcqLc._)(PrintAnnotationStorage, AnnotationStorage);
                    var _super = (0, $4jYWU._)(PrintAnnotationStorage);
                    function PrintAnnotationStorage(parent) {
                        (0, $5sFFs._)(this, PrintAnnotationStorage);
                        var _this;
                        _this = _super.call(this);
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _serializable, {
                            writable: true,
                            value: void 0
                        });
                        var _parent_serializable = parent.serializable, map = _parent_serializable.map, hash = _parent_serializable.hash, transfers = _parent_serializable.transfers;
                        var clone = structuredClone(map, transfers ? {
                            transfer: transfers
                        } : null);
                        (0, $4LHB0._)((0, $lyFcw._)(_this), _serializable, {
                            map: clone,
                            hash: hash,
                            transfers: transfers
                        });
                        return _this;
                    }
                    (0, $8O2fV._)(PrintAnnotationStorage, [
                        {
                            key: "print",
                            get: function get() {
                                (0, _util.unreachable)("Should not call PrintAnnotationStorage.print");
                            }
                        },
                        {
                            key: "serializable",
                            get: function get() {
                                return (0, $057QZ._)(this, _serializable);
                            }
                        }
                    ]);
                    return PrintAnnotationStorage;
                }(AnnotationStorage);
                exports.PrintAnnotationStorage = PrintAnnotationStorage;
            /***/ },
            /* 4 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationEditor = void 0;
                var _tools = __w_pdfjs_require__(5);
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _altText = /*#__PURE__*/ new WeakMap(), _altTextDecorative = /*#__PURE__*/ new WeakMap(), _altTextButton = /*#__PURE__*/ new WeakMap(), _altTextTooltip = /*#__PURE__*/ new WeakMap(), _altTextTooltipTimeout = /*#__PURE__*/ new WeakMap(), _keepAspectRatio = /*#__PURE__*/ new WeakMap(), _resizersDiv = /*#__PURE__*/ new WeakMap(), _boundFocusin = /*#__PURE__*/ new WeakMap(), _boundFocusout = /*#__PURE__*/ new WeakMap(), _hasBeenClicked = /*#__PURE__*/ new WeakMap(), _isEditing = /*#__PURE__*/ new WeakMap(), _isInEditMode = /*#__PURE__*/ new WeakMap(), _isDraggable = /*#__PURE__*/ new WeakMap(), _zIndex = /*#__PURE__*/ new WeakMap(), _translate = /*#__PURE__*/ new WeakSet(), _getBaseTranslation = /*#__PURE__*/ new WeakSet(), _getRotationMatrix = /*#__PURE__*/ new WeakSet(), _createResizers = /*#__PURE__*/ new WeakSet(), _resizerPointerdown = /*#__PURE__*/ new WeakSet(), _resizerPointermove = /*#__PURE__*/ new WeakSet(), _setAltTextButtonState = /*#__PURE__*/ new WeakSet(), _setUpDragSession = /*#__PURE__*/ new WeakSet();
                var AnnotationEditor = /*#__PURE__*/ function() {
                    function AnnotationEditor(parameters) {
                        (0, $5sFFs._)(this, AnnotationEditor);
                        (0, $iB2CV._)(this, _translate);
                        (0, $iB2CV._)(this, _getBaseTranslation);
                        (0, $iB2CV._)(this, _getRotationMatrix);
                        (0, $iB2CV._)(this, _createResizers);
                        (0, $iB2CV._)(this, _resizerPointerdown);
                        (0, $iB2CV._)(this, _resizerPointermove);
                        (0, $iB2CV._)(this, _setAltTextButtonState);
                        (0, $iB2CV._)(this, _setUpDragSession);
                        (0, $g12Hy._)(this, _altText, {
                            writable: true,
                            value: ""
                        });
                        (0, $g12Hy._)(this, _altTextDecorative, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)(this, _altTextButton, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _altTextTooltip, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _altTextTooltipTimeout, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _keepAspectRatio, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)(this, _resizersDiv, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _boundFocusin, {
                            writable: true,
                            value: this.focusin.bind(this)
                        });
                        (0, $g12Hy._)(this, _boundFocusout, {
                            writable: true,
                            value: this.focusout.bind(this)
                        });
                        (0, $g12Hy._)(this, _hasBeenClicked, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)(this, _isEditing, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)(this, _isInEditMode, {
                            writable: true,
                            value: false
                        });
                        (0, $iCQyW._)(this, "_initialOptions", Object.create(null));
                        (0, $iCQyW._)(this, "_uiManager", null);
                        (0, $iCQyW._)(this, "_focusEventsAllowed", true);
                        (0, $iCQyW._)(this, "_l10nPromise", null);
                        (0, $g12Hy._)(this, _isDraggable, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)(this, _zIndex, {
                            writable: true,
                            value: AnnotationEditor._zIndex++
                        });
                        if (this.constructor === AnnotationEditor) (0, _util.unreachable)("Cannot initialize AnnotationEditor.");
                        this.parent = parameters.parent;
                        this.id = parameters.id;
                        this.width = this.height = null;
                        this.pageIndex = parameters.parent.pageIndex;
                        this.name = parameters.name;
                        this.div = null;
                        this._uiManager = parameters.uiManager;
                        this.annotationElementId = null;
                        this._willKeepAspectRatio = false;
                        this._initialOptions.isCentered = parameters.isCentered;
                        this._structTreeParentId = null;
                        var _this_parent_viewport = this.parent.viewport, rotation = _this_parent_viewport.rotation, _this_parent_viewport_rawDims = _this_parent_viewport.rawDims, pageWidth = _this_parent_viewport_rawDims.pageWidth, pageHeight = _this_parent_viewport_rawDims.pageHeight, pageX = _this_parent_viewport_rawDims.pageX, pageY = _this_parent_viewport_rawDims.pageY;
                        this.rotation = rotation;
                        this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
                        this.pageDimensions = [
                            pageWidth,
                            pageHeight
                        ];
                        this.pageTranslation = [
                            pageX,
                            pageY
                        ];
                        var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), width = _this_parentDimensions[0], height = _this_parentDimensions[1];
                        this.x = parameters.x / width;
                        this.y = parameters.y / height;
                        this.isAttachedToDOM = false;
                        this.deleted = false;
                    }
                    (0, $8O2fV._)(AnnotationEditor, [
                        {
                            key: "editorType",
                            get: function get() {
                                return Object.getPrototypeOf(this).constructor._type;
                            }
                        },
                        {
                            key: "propertiesToUpdate",
                            get: function get() {
                                return [];
                            }
                        },
                        {
                            key: "_isDraggable",
                            get: function get() {
                                return (0, $057QZ._)(this, _isDraggable);
                            },
                            set: function set(value) {
                                var _this_div;
                                (0, $4LHB0._)(this, _isDraggable, value);
                                (_this_div = this.div) === null || _this_div === void 0 ? void 0 : _this_div.classList.toggle("draggable", value);
                            }
                        },
                        {
                            key: "center",
                            value: function center() {
                                var _this_pageDimensions = (0, $52tJv._)(this.pageDimensions, 2), pageWidth = _this_pageDimensions[0], pageHeight = _this_pageDimensions[1];
                                switch(this.parentRotation){
                                    case 90:
                                        this.x -= this.height * pageHeight / (pageWidth * 2);
                                        this.y += this.width * pageWidth / (pageHeight * 2);
                                        break;
                                    case 180:
                                        this.x += this.width / 2;
                                        this.y += this.height / 2;
                                        break;
                                    case 270:
                                        this.x += this.height * pageHeight / (pageWidth * 2);
                                        this.y -= this.width * pageWidth / (pageHeight * 2);
                                        break;
                                    default:
                                        this.x -= this.width / 2;
                                        this.y -= this.height / 2;
                                        break;
                                }
                                this.fixAndSetPosition();
                            }
                        },
                        {
                            key: "addCommands",
                            value: function addCommands(params) {
                                this._uiManager.addCommands(params);
                            }
                        },
                        {
                            key: "currentLayer",
                            get: function get() {
                                return this._uiManager.currentLayer;
                            }
                        },
                        {
                            key: "setInBackground",
                            value: function setInBackground() {
                                this.div.style.zIndex = 0;
                            }
                        },
                        {
                            key: "setInForeground",
                            value: function setInForeground() {
                                this.div.style.zIndex = (0, $057QZ._)(this, _zIndex);
                            }
                        },
                        {
                            key: "setParent",
                            value: function setParent(parent) {
                                if (parent !== null) {
                                    this.pageIndex = parent.pageIndex;
                                    this.pageDimensions = parent.pageDimensions;
                                }
                                this.parent = parent;
                            }
                        },
                        {
                            key: "focusin",
                            value: function focusin(event) {
                                if (!this._focusEventsAllowed) return;
                                if (!(0, $057QZ._)(this, _hasBeenClicked)) this.parent.setSelected(this);
                                else (0, $4LHB0._)(this, _hasBeenClicked, false);
                            }
                        },
                        {
                            key: "focusout",
                            value: function focusout(event) {
                                var _this_parent;
                                if (!this._focusEventsAllowed) return;
                                if (!this.isAttachedToDOM) return;
                                var target = event.relatedTarget;
                                if (target === null || target === void 0 ? void 0 : target.closest("#".concat(this.id))) return;
                                event.preventDefault();
                                if (!((_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.isMultipleSelection)) this.commitOrRemove();
                            }
                        },
                        {
                            key: "commitOrRemove",
                            value: function commitOrRemove() {
                                if (this.isEmpty()) this.remove();
                                else this.commit();
                            }
                        },
                        {
                            key: "commit",
                            value: function commit() {
                                this.addToAnnotationStorage();
                            }
                        },
                        {
                            key: "addToAnnotationStorage",
                            value: function addToAnnotationStorage() {
                                this._uiManager.addToAnnotationStorage(this);
                            }
                        },
                        {
                            key: "setAt",
                            value: function setAt(x, y, tx, ty) {
                                var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), width = _this_parentDimensions[0], height = _this_parentDimensions[1];
                                var ref;
                                ref = (0, $52tJv._)(this.screenToPageTranslation(tx, ty), 2), tx = ref[0], ty = ref[1], ref;
                                this.x = (x + tx) / width;
                                this.y = (y + ty) / height;
                                this.fixAndSetPosition();
                            }
                        },
                        {
                            key: "translate",
                            value: function translate1(x, y) {
                                (0, $lNbhr._)(this, _translate, translate).call(this, this.parentDimensions, x, y);
                            }
                        },
                        {
                            key: "translateInPage",
                            value: function translateInPage(x, y) {
                                (0, $lNbhr._)(this, _translate, translate).call(this, this.pageDimensions, x, y);
                                this.div.scrollIntoView({
                                    block: "nearest"
                                });
                            }
                        },
                        {
                            key: "drag",
                            value: function drag(tx, ty) {
                                var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                                this.x += tx / parentWidth;
                                this.y += ty / parentHeight;
                                if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
                                    var _this_div_getBoundingClientRect = this.div.getBoundingClientRect(), x = _this_div_getBoundingClientRect.x, y = _this_div_getBoundingClientRect.y;
                                    if (this.parent.findNewParent(this, x, y)) {
                                        this.x -= Math.floor(this.x);
                                        this.y -= Math.floor(this.y);
                                    }
                                }
                                var _this = this, x1 = _this.x, y1 = _this.y;
                                var _class_private_method_get_call = (0, $52tJv._)((0, $lNbhr._)(this, _getBaseTranslation, getBaseTranslation).call(this), 2), bx = _class_private_method_get_call[0], by = _class_private_method_get_call[1];
                                x1 += bx;
                                y1 += by;
                                this.div.style.left = "".concat((100 * x1).toFixed(2), "%");
                                this.div.style.top = "".concat((100 * y1).toFixed(2), "%");
                                this.div.scrollIntoView({
                                    block: "nearest"
                                });
                            }
                        },
                        {
                            key: "fixAndSetPosition",
                            value: function fixAndSetPosition() {
                                var _this_pageDimensions = (0, $52tJv._)(this.pageDimensions, 2), pageWidth = _this_pageDimensions[0], pageHeight = _this_pageDimensions[1];
                                var _this = this, x = _this.x, y = _this.y, width = _this.width, height = _this.height;
                                width *= pageWidth;
                                height *= pageHeight;
                                x *= pageWidth;
                                y *= pageHeight;
                                switch(this.rotation){
                                    case 0:
                                        x = Math.max(0, Math.min(pageWidth - width, x));
                                        y = Math.max(0, Math.min(pageHeight - height, y));
                                        break;
                                    case 90:
                                        x = Math.max(0, Math.min(pageWidth - height, x));
                                        y = Math.min(pageHeight, Math.max(width, y));
                                        break;
                                    case 180:
                                        x = Math.min(pageWidth, Math.max(width, x));
                                        y = Math.min(pageHeight, Math.max(height, y));
                                        break;
                                    case 270:
                                        x = Math.min(pageWidth, Math.max(height, x));
                                        y = Math.max(0, Math.min(pageHeight - width, y));
                                        break;
                                }
                                this.x = x /= pageWidth;
                                this.y = y /= pageHeight;
                                var _class_private_method_get_call = (0, $52tJv._)((0, $lNbhr._)(this, _getBaseTranslation, getBaseTranslation).call(this), 2), bx = _class_private_method_get_call[0], by = _class_private_method_get_call[1];
                                x += bx;
                                y += by;
                                var style = this.div.style;
                                style.left = "".concat((100 * x).toFixed(2), "%");
                                style.top = "".concat((100 * y).toFixed(2), "%");
                                this.moveInDOM();
                            }
                        },
                        {
                            key: "screenToPageTranslation",
                            value: function screenToPageTranslation(x, y) {
                                return (0, $9hJkT._)(AnnotationEditor, AnnotationEditor, rotatePoint).call(AnnotationEditor, x, y, this.parentRotation);
                            }
                        },
                        {
                            key: "pageTranslationToScreen",
                            value: function pageTranslationToScreen(x, y) {
                                return (0, $9hJkT._)(AnnotationEditor, AnnotationEditor, rotatePoint).call(AnnotationEditor, x, y, 360 - this.parentRotation);
                            }
                        },
                        {
                            key: "parentScale",
                            get: function get() {
                                return this._uiManager.viewParameters.realScale;
                            }
                        },
                        {
                            key: "parentRotation",
                            get: function get() {
                                return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
                            }
                        },
                        {
                            key: "parentDimensions",
                            get: function get() {
                                var _this = this, parentScale = _this.parentScale, _this_pageDimensions = (0, $52tJv._)(_this.pageDimensions, 2), pageWidth = _this_pageDimensions[0], pageHeight = _this_pageDimensions[1];
                                var scaledWidth = pageWidth * parentScale;
                                var scaledHeight = pageHeight * parentScale;
                                return _util.FeatureTest.isCSSRoundSupported ? [
                                    Math.round(scaledWidth),
                                    Math.round(scaledHeight)
                                ] : [
                                    scaledWidth,
                                    scaledHeight
                                ];
                            }
                        },
                        {
                            key: "setDims",
                            value: function setDims(width, height) {
                                var _$_class_private_field_get;
                                var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                                this.div.style.width = "".concat((100 * width / parentWidth).toFixed(2), "%");
                                if (!(0, $057QZ._)(this, _keepAspectRatio)) this.div.style.height = "".concat((100 * height / parentHeight).toFixed(2), "%");
                                (_$_class_private_field_get = (0, $057QZ._)(this, _altTextButton)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.classList.toggle("small", width < AnnotationEditor.SMALL_EDITOR_SIZE || height < AnnotationEditor.SMALL_EDITOR_SIZE);
                            }
                        },
                        {
                            key: "fixDims",
                            value: function fixDims() {
                                var style = this.div.style;
                                var height = style.height, width = style.width;
                                var widthPercent = width.endsWith("%");
                                var heightPercent = !(0, $057QZ._)(this, _keepAspectRatio) && height.endsWith("%");
                                if (widthPercent && heightPercent) return;
                                var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                                if (!widthPercent) style.width = "".concat((100 * parseFloat(width) / parentWidth).toFixed(2), "%");
                                if (!(0, $057QZ._)(this, _keepAspectRatio) && !heightPercent) style.height = "".concat((100 * parseFloat(height) / parentHeight).toFixed(2), "%");
                            }
                        },
                        {
                            key: "getInitialTranslation",
                            value: function getInitialTranslation() {
                                return [
                                    0,
                                    0
                                ];
                            }
                        },
                        {
                            key: "addAltTextButton",
                            value: function addAltTextButton() {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var altText, msg, PERCENT;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if ((0, $057QZ._)(_this, _altTextButton)) return [
                                                    2
                                                ];
                                                altText = (0, $4LHB0._)(_this, _altTextButton, document.createElement("button"));
                                                altText.className = "altText";
                                                return [
                                                    4,
                                                    AnnotationEditor._l10nPromise.get("editor_alt_text_button_label")
                                                ];
                                            case 1:
                                                msg = _state.sent();
                                                altText.textContent = msg;
                                                altText.setAttribute("aria-label", msg);
                                                altText.tabIndex = "0";
                                                altText.addEventListener("contextmenu", _display_utils.noContextMenu);
                                                altText.addEventListener("pointerdown", function(event) {
                                                    return event.stopPropagation();
                                                });
                                                altText.addEventListener("click", function(event) {
                                                    event.preventDefault();
                                                    _this._uiManager.editAltText(_this);
                                                }, {
                                                    capture: true
                                                });
                                                altText.addEventListener("keydown", function(event) {
                                                    if (event.target === altText && event.key === "Enter") {
                                                        event.preventDefault();
                                                        _this._uiManager.editAltText(_this);
                                                    }
                                                });
                                                (0, $lNbhr._)(_this, _setAltTextButtonState, setAltTextButtonState).call(_this);
                                                _this.div.append(altText);
                                                if (!AnnotationEditor.SMALL_EDITOR_SIZE) {
                                                    PERCENT = 40;
                                                    AnnotationEditor.SMALL_EDITOR_SIZE = Math.min(128, Math.round(altText.getBoundingClientRect().width * (1 + PERCENT / 100)));
                                                }
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }
                        },
                        {
                            key: "getClientDimensions",
                            value: function getClientDimensions() {
                                return this.div.getBoundingClientRect();
                            }
                        },
                        {
                            key: "altTextData",
                            get: function get() {
                                return {
                                    altText: (0, $057QZ._)(this, _altText),
                                    decorative: (0, $057QZ._)(this, _altTextDecorative)
                                };
                            },
                            set: function set(param) {
                                var altText = param.altText, decorative = param.decorative;
                                if ((0, $057QZ._)(this, _altText) === altText && (0, $057QZ._)(this, _altTextDecorative) === decorative) return;
                                (0, $4LHB0._)(this, _altText, altText);
                                (0, $4LHB0._)(this, _altTextDecorative, decorative);
                                (0, $lNbhr._)(this, _setAltTextButtonState, setAltTextButtonState).call(this);
                            }
                        },
                        {
                            key: "render",
                            value: function render() {
                                this.div = document.createElement("div");
                                this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
                                this.div.className = this.name;
                                this.div.setAttribute("id", this.id);
                                this.div.setAttribute("tabIndex", 0);
                                this.setInForeground();
                                this.div.addEventListener("focusin", (0, $057QZ._)(this, _boundFocusin));
                                this.div.addEventListener("focusout", (0, $057QZ._)(this, _boundFocusout));
                                var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                                if (this.parentRotation % 180 !== 0) {
                                    this.div.style.maxWidth = "".concat((100 * parentHeight / parentWidth).toFixed(2), "%");
                                    this.div.style.maxHeight = "".concat((100 * parentWidth / parentHeight).toFixed(2), "%");
                                }
                                var _this_getInitialTranslation = (0, $52tJv._)(this.getInitialTranslation(), 2), tx = _this_getInitialTranslation[0], ty = _this_getInitialTranslation[1];
                                this.translate(tx, ty);
                                (0, _tools.bindEvents)(this, this.div, [
                                    "pointerdown"
                                ]);
                                return this.div;
                            }
                        },
                        {
                            key: "pointerdown",
                            value: function pointerdown(event) {
                                var isMac = _util.FeatureTest.platform.isMac;
                                if (event.button !== 0 || event.ctrlKey && isMac) {
                                    event.preventDefault();
                                    return;
                                }
                                (0, $4LHB0._)(this, _hasBeenClicked, true);
                                (0, $lNbhr._)(this, _setUpDragSession, setUpDragSession).call(this, event);
                            }
                        },
                        {
                            key: "moveInDOM",
                            value: function moveInDOM() {
                                var _this_parent;
                                (_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.moveEditorInDOM(this);
                            }
                        },
                        {
                            key: "_setParentAndPosition",
                            value: function _setParentAndPosition(parent, x, y) {
                                parent.changeParent(this);
                                this.x = x;
                                this.y = y;
                                this.fixAndSetPosition();
                            }
                        },
                        {
                            key: "getRect",
                            value: function getRect(tx, ty) {
                                var scale = this.parentScale;
                                var _this_pageDimensions = (0, $52tJv._)(this.pageDimensions, 2), pageWidth = _this_pageDimensions[0], pageHeight = _this_pageDimensions[1];
                                var _this_pageTranslation = (0, $52tJv._)(this.pageTranslation, 2), pageX = _this_pageTranslation[0], pageY = _this_pageTranslation[1];
                                var shiftX = tx / scale;
                                var shiftY = ty / scale;
                                var x = this.x * pageWidth;
                                var y = this.y * pageHeight;
                                var width = this.width * pageWidth;
                                var height = this.height * pageHeight;
                                switch(this.rotation){
                                    case 0:
                                        return [
                                            x + shiftX + pageX,
                                            pageHeight - y - shiftY - height + pageY,
                                            x + shiftX + width + pageX,
                                            pageHeight - y - shiftY + pageY
                                        ];
                                    case 90:
                                        return [
                                            x + shiftY + pageX,
                                            pageHeight - y + shiftX + pageY,
                                            x + shiftY + height + pageX,
                                            pageHeight - y + shiftX + width + pageY
                                        ];
                                    case 180:
                                        return [
                                            x - shiftX - width + pageX,
                                            pageHeight - y + shiftY + pageY,
                                            x - shiftX + pageX,
                                            pageHeight - y + shiftY + height + pageY
                                        ];
                                    case 270:
                                        return [
                                            x - shiftY - height + pageX,
                                            pageHeight - y - shiftX - width + pageY,
                                            x - shiftY + pageX,
                                            pageHeight - y - shiftX + pageY
                                        ];
                                    default:
                                        throw new Error("Invalid rotation");
                                }
                            }
                        },
                        {
                            key: "getRectInCurrentCoords",
                            value: function getRectInCurrentCoords(rect, pageHeight) {
                                var _rect = (0, $52tJv._)(rect, 4), x1 = _rect[0], y1 = _rect[1], x2 = _rect[2], y2 = _rect[3];
                                var width = x2 - x1;
                                var height = y2 - y1;
                                switch(this.rotation){
                                    case 0:
                                        return [
                                            x1,
                                            pageHeight - y2,
                                            width,
                                            height
                                        ];
                                    case 90:
                                        return [
                                            x1,
                                            pageHeight - y1,
                                            height,
                                            width
                                        ];
                                    case 180:
                                        return [
                                            x2,
                                            pageHeight - y1,
                                            width,
                                            height
                                        ];
                                    case 270:
                                        return [
                                            x2,
                                            pageHeight - y2,
                                            height,
                                            width
                                        ];
                                    default:
                                        throw new Error("Invalid rotation");
                                }
                            }
                        },
                        {
                            key: "onceAdded",
                            value: function onceAdded() {}
                        },
                        {
                            key: "isEmpty",
                            value: function isEmpty() {
                                return false;
                            }
                        },
                        {
                            key: "enableEditMode",
                            value: function enableEditMode() {
                                (0, $4LHB0._)(this, _isInEditMode, true);
                            }
                        },
                        {
                            key: "disableEditMode",
                            value: function disableEditMode() {
                                (0, $4LHB0._)(this, _isInEditMode, false);
                            }
                        },
                        {
                            key: "isInEditMode",
                            value: function isInEditMode() {
                                return (0, $057QZ._)(this, _isInEditMode);
                            }
                        },
                        {
                            key: "shouldGetKeyboardEvents",
                            value: function shouldGetKeyboardEvents() {
                                return false;
                            }
                        },
                        {
                            key: "needsToBeRebuilt",
                            value: function needsToBeRebuilt() {
                                return this.div && !this.isAttachedToDOM;
                            }
                        },
                        {
                            key: "rebuild",
                            value: function rebuild() {
                                var _this_div, _this_div1;
                                (_this_div = this.div) === null || _this_div === void 0 ? void 0 : _this_div.addEventListener("focusin", (0, $057QZ._)(this, _boundFocusin));
                                (_this_div1 = this.div) === null || _this_div1 === void 0 ? void 0 : _this_div1.addEventListener("focusout", (0, $057QZ._)(this, _boundFocusout));
                            }
                        },
                        {
                            key: "serialize",
                            value: function serialize() {
                                var isForCopying = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                                (0, _util.unreachable)("An editor must be serializable");
                            }
                        },
                        {
                            key: "remove",
                            value: function remove() {
                                var _$_class_private_field_get;
                                this.div.removeEventListener("focusin", (0, $057QZ._)(this, _boundFocusin));
                                this.div.removeEventListener("focusout", (0, $057QZ._)(this, _boundFocusout));
                                if (!this.isEmpty()) this.commit();
                                if (this.parent) this.parent.remove(this);
                                else this._uiManager.removeEditor(this);
                                (_$_class_private_field_get = (0, $057QZ._)(this, _altTextButton)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.remove();
                                (0, $4LHB0._)(this, _altTextButton, null);
                                (0, $4LHB0._)(this, _altTextTooltip, null);
                            }
                        },
                        {
                            key: "isResizable",
                            get: function get() {
                                return false;
                            }
                        },
                        {
                            key: "makeResizable",
                            value: function makeResizable() {
                                if (this.isResizable) {
                                    (0, $lNbhr._)(this, _createResizers, createResizers).call(this);
                                    (0, $057QZ._)(this, _resizersDiv).classList.remove("hidden");
                                }
                            }
                        },
                        {
                            key: "select",
                            value: function select() {
                                var _this_div;
                                this.makeResizable();
                                (_this_div = this.div) === null || _this_div === void 0 ? void 0 : _this_div.classList.add("selectedEditor");
                            }
                        },
                        {
                            key: "unselect",
                            value: function unselect() {
                                var _$_class_private_field_get, _this_div, _this_div1;
                                (_$_class_private_field_get = (0, $057QZ._)(this, _resizersDiv)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.classList.add("hidden");
                                (_this_div = this.div) === null || _this_div === void 0 ? void 0 : _this_div.classList.remove("selectedEditor");
                                if ((_this_div1 = this.div) === null || _this_div1 === void 0 ? void 0 : _this_div1.contains(document.activeElement)) this._uiManager.currentLayer.div.focus();
                            }
                        },
                        {
                            key: "updateParams",
                            value: function updateParams(type, value) {}
                        },
                        {
                            key: "disableEditing",
                            value: function disableEditing() {
                                if ((0, $057QZ._)(this, _altTextButton)) (0, $057QZ._)(this, _altTextButton).hidden = true;
                            }
                        },
                        {
                            key: "enableEditing",
                            value: function enableEditing() {
                                if ((0, $057QZ._)(this, _altTextButton)) (0, $057QZ._)(this, _altTextButton).hidden = false;
                            }
                        },
                        {
                            key: "enterInEditMode",
                            value: function enterInEditMode() {}
                        },
                        {
                            key: "contentDiv",
                            get: function get() {
                                return this.div;
                            }
                        },
                        {
                            key: "isEditing",
                            get: function get() {
                                return (0, $057QZ._)(this, _isEditing);
                            },
                            set: function set(value) {
                                (0, $4LHB0._)(this, _isEditing, value);
                                if (!this.parent) return;
                                if (value) {
                                    this.parent.setSelected(this);
                                    this.parent.setActiveEditor(this);
                                } else this.parent.setActiveEditor(null);
                            }
                        },
                        {
                            key: "setAspectRatio",
                            value: function setAspectRatio(width, height) {
                                (0, $4LHB0._)(this, _keepAspectRatio, true);
                                var aspectRatio = width / height;
                                var style = this.div.style;
                                style.aspectRatio = aspectRatio;
                                style.height = "auto";
                            }
                        }
                    ], [
                        {
                            key: "_defaultLineColor",
                            get: function get() {
                                return (0, _util.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
                            }
                        },
                        {
                            key: "deleteAnnotationElement",
                            value: function deleteAnnotationElement(editor) {
                                var fakeEditor = new FakeEditor({
                                    id: editor.parent.getNextId(),
                                    parent: editor.parent,
                                    uiManager: editor._uiManager
                                });
                                fakeEditor.annotationElementId = editor.annotationElementId;
                                fakeEditor.deleted = true;
                                fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
                            }
                        },
                        {
                            key: "initialize",
                            value: function initialize(l10n) {
                                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                                var _AnnotationEditor;
                                (_AnnotationEditor = AnnotationEditor)._l10nPromise || (_AnnotationEditor._l10nPromise = new Map([
                                    "editor_alt_text_button_label",
                                    "editor_alt_text_edit_button_label",
                                    "editor_alt_text_decorative_tooltip"
                                ].map(function(str) {
                                    return [
                                        str,
                                        l10n.get(str)
                                    ];
                                })));
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (options === null || options === void 0 ? void 0 : options.strings) try {
                                    for(var _iterator = options.strings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var str = _step.value;
                                        AnnotationEditor._l10nPromise.set(str, l10n.get(str));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (AnnotationEditor._borderLineWidth !== -1) return;
                                var style = getComputedStyle(document.documentElement);
                                AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
                            }
                        },
                        {
                            key: "updateDefaultParams",
                            value: function updateDefaultParams(_type, _value) {}
                        },
                        {
                            key: "defaultPropertiesToUpdate",
                            get: function get() {
                                return [];
                            }
                        },
                        {
                            key: "isHandlingMimeForPasting",
                            value: function isHandlingMimeForPasting(mime) {
                                return false;
                            }
                        },
                        {
                            key: "paste",
                            value: function paste(item, parent) {
                                (0, _util.unreachable)("Not implemented");
                            }
                        },
                        {
                            key: "deserialize",
                            value: function deserialize(data, parent, uiManager) {
                                var editor = new this.prototype.constructor({
                                    parent: parent,
                                    id: parent.getNextId(),
                                    uiManager: uiManager
                                });
                                editor.rotation = data.rotation;
                                var _editor_pageDimensions = (0, $52tJv._)(editor.pageDimensions, 2), pageWidth = _editor_pageDimensions[0], pageHeight = _editor_pageDimensions[1];
                                var _editor_getRectInCurrentCoords = (0, $52tJv._)(editor.getRectInCurrentCoords(data.rect, pageHeight), 4), x = _editor_getRectInCurrentCoords[0], y = _editor_getRectInCurrentCoords[1], width = _editor_getRectInCurrentCoords[2], height = _editor_getRectInCurrentCoords[3];
                                editor.x = x / pageWidth;
                                editor.y = y / pageHeight;
                                editor.width = width / pageWidth;
                                editor.height = height / pageHeight;
                                return editor;
                            }
                        },
                        {
                            key: "MIN_SIZE",
                            get: function get() {
                                return 16;
                            }
                        }
                    ]);
                    return AnnotationEditor;
                }();
                (0, $iCQyW._)(AnnotationEditor, "_borderLineWidth", -1);
                (0, $iCQyW._)(AnnotationEditor, "_colorManager", new _tools.ColorManager());
                (0, $iCQyW._)(AnnotationEditor, "_zIndex", 1);
                (0, $iCQyW._)(AnnotationEditor, "SMALL_EDITOR_SIZE", 0);
                function translate(param, x, y) {
                    var _param = (0, $52tJv._)(param, 2), width = _param[0], height = _param[1];
                    var ref;
                    ref = (0, $52tJv._)(this.screenToPageTranslation(x, y), 2), x = ref[0], y = ref[1], ref;
                    this.x += x / width;
                    this.y += y / height;
                    this.fixAndSetPosition();
                }
                function getBaseTranslation() {
                    var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                    var _borderLineWidth = AnnotationEditor._borderLineWidth;
                    var x = _borderLineWidth / parentWidth;
                    var y = _borderLineWidth / parentHeight;
                    switch(this.rotation){
                        case 90:
                            return [
                                -x,
                                y
                            ];
                        case 180:
                            return [
                                x,
                                y
                            ];
                        case 270:
                            return [
                                x,
                                -y
                            ];
                        default:
                            return [
                                -x,
                                -y
                            ];
                    }
                }
                function rotatePoint(x, y, angle) {
                    switch(angle){
                        case 90:
                            return [
                                y,
                                -x
                            ];
                        case 180:
                            return [
                                -x,
                                -y
                            ];
                        case 270:
                            return [
                                -y,
                                x
                            ];
                        default:
                            return [
                                x,
                                y
                            ];
                    }
                }
                function getRotationMatrix(rotation) {
                    switch(rotation){
                        case 90:
                            {
                                var _this_pageDimensions = (0, $52tJv._)(this.pageDimensions, 2), pageWidth = _this_pageDimensions[0], pageHeight = _this_pageDimensions[1];
                                return [
                                    0,
                                    -pageWidth / pageHeight,
                                    pageHeight / pageWidth,
                                    0
                                ];
                            }
                        case 180:
                            return [
                                -1,
                                0,
                                0,
                                -1
                            ];
                        case 270:
                            {
                                var _this_pageDimensions1 = (0, $52tJv._)(this.pageDimensions, 2), pageWidth1 = _this_pageDimensions1[0], pageHeight1 = _this_pageDimensions1[1];
                                return [
                                    0,
                                    pageWidth1 / pageHeight1,
                                    -pageHeight1 / pageWidth1,
                                    0
                                ];
                            }
                        default:
                            return [
                                1,
                                0,
                                0,
                                1
                            ];
                    }
                }
                function createResizers() {
                    if ((0, $057QZ._)(this, _resizersDiv)) return;
                    (0, $4LHB0._)(this, _resizersDiv, document.createElement("div"));
                    (0, $057QZ._)(this, _resizersDiv).classList.add("resizers");
                    var classes = [
                        "topLeft",
                        "topRight",
                        "bottomRight",
                        "bottomLeft"
                    ];
                    if (!this._willKeepAspectRatio) classes.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = classes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var name = _step.value;
                            var div = document.createElement("div");
                            (0, $057QZ._)(this, _resizersDiv).append(div);
                            div.classList.add("resizer", name);
                            div.addEventListener("pointerdown", (0, $lNbhr._)(this, _resizerPointerdown, resizerPointerdown).bind(this, name));
                            div.addEventListener("contextmenu", _display_utils.noContextMenu);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.div.prepend((0, $057QZ._)(this, _resizersDiv));
                }
                function resizerPointerdown(name, event) {
                    var _this = this;
                    event.preventDefault();
                    var isMac = _util.FeatureTest.platform.isMac;
                    if (event.button !== 0 || event.ctrlKey && isMac) return;
                    var boundResizerPointermove = (0, $lNbhr._)(this, _resizerPointermove, resizerPointermove).bind(this, name);
                    var savedDraggable = this._isDraggable;
                    this._isDraggable = false;
                    var pointerMoveOptions = {
                        passive: true,
                        capture: true
                    };
                    window.addEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                    var savedX = this.x;
                    var savedY = this.y;
                    var savedWidth = this.width;
                    var savedHeight = this.height;
                    var savedParentCursor = this.parent.div.style.cursor;
                    var savedCursor = this.div.style.cursor;
                    this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
                    var pointerUpCallback = function() {
                        _this._isDraggable = savedDraggable;
                        window.removeEventListener("pointerup", pointerUpCallback);
                        window.removeEventListener("blur", pointerUpCallback);
                        window.removeEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                        _this.parent.div.style.cursor = savedParentCursor;
                        _this.div.style.cursor = savedCursor;
                        var newX = _this.x;
                        var newY = _this.y;
                        var newWidth = _this.width;
                        var newHeight = _this.height;
                        if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) return;
                        _this.addCommands({
                            cmd: function() {
                                _this.width = newWidth;
                                _this.height = newHeight;
                                _this.x = newX;
                                _this.y = newY;
                                var _this_parentDimensions = (0, $52tJv._)(_this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                                _this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                                _this.fixAndSetPosition();
                            },
                            undo: function() {
                                _this.width = savedWidth;
                                _this.height = savedHeight;
                                _this.x = savedX;
                                _this.y = savedY;
                                var _this_parentDimensions = (0, $52tJv._)(_this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                                _this.setDims(parentWidth * savedWidth, parentHeight * savedHeight);
                                _this.fixAndSetPosition();
                            },
                            mustExec: true
                        });
                    };
                    window.addEventListener("pointerup", pointerUpCallback);
                    window.addEventListener("blur", pointerUpCallback);
                }
                function resizerPointermove(name, event) {
                    var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                    var savedX = this.x;
                    var savedY = this.y;
                    var savedWidth = this.width;
                    var savedHeight = this.height;
                    var minWidth = AnnotationEditor.MIN_SIZE / parentWidth;
                    var minHeight = AnnotationEditor.MIN_SIZE / parentHeight;
                    var round = function(x) {
                        return Math.round(x * 10000) / 10000;
                    };
                    var rotationMatrix = (0, $lNbhr._)(this, _getRotationMatrix, getRotationMatrix).call(this, this.rotation);
                    var transf = function(x, y) {
                        return [
                            rotationMatrix[0] * x + rotationMatrix[2] * y,
                            rotationMatrix[1] * x + rotationMatrix[3] * y
                        ];
                    };
                    var invRotationMatrix = (0, $lNbhr._)(this, _getRotationMatrix, getRotationMatrix).call(this, 360 - this.rotation);
                    var invTransf = function(x, y) {
                        return [
                            invRotationMatrix[0] * x + invRotationMatrix[2] * y,
                            invRotationMatrix[1] * x + invRotationMatrix[3] * y
                        ];
                    };
                    var getPoint;
                    var getOpposite;
                    var isDiagonal = false;
                    var isHorizontal = false;
                    switch(name){
                        case "topLeft":
                            isDiagonal = true;
                            getPoint = function(w, h) {
                                return [
                                    0,
                                    0
                                ];
                            };
                            getOpposite = function(w, h) {
                                return [
                                    w,
                                    h
                                ];
                            };
                            break;
                        case "topMiddle":
                            getPoint = function(w, h) {
                                return [
                                    w / 2,
                                    0
                                ];
                            };
                            getOpposite = function(w, h) {
                                return [
                                    w / 2,
                                    h
                                ];
                            };
                            break;
                        case "topRight":
                            isDiagonal = true;
                            getPoint = function(w, h) {
                                return [
                                    w,
                                    0
                                ];
                            };
                            getOpposite = function(w, h) {
                                return [
                                    0,
                                    h
                                ];
                            };
                            break;
                        case "middleRight":
                            isHorizontal = true;
                            getPoint = function(w, h) {
                                return [
                                    w,
                                    h / 2
                                ];
                            };
                            getOpposite = function(w, h) {
                                return [
                                    0,
                                    h / 2
                                ];
                            };
                            break;
                        case "bottomRight":
                            isDiagonal = true;
                            getPoint = function(w, h) {
                                return [
                                    w,
                                    h
                                ];
                            };
                            getOpposite = function(w, h) {
                                return [
                                    0,
                                    0
                                ];
                            };
                            break;
                        case "bottomMiddle":
                            getPoint = function(w, h) {
                                return [
                                    w / 2,
                                    h
                                ];
                            };
                            getOpposite = function(w, h) {
                                return [
                                    w / 2,
                                    0
                                ];
                            };
                            break;
                        case "bottomLeft":
                            isDiagonal = true;
                            getPoint = function(w, h) {
                                return [
                                    0,
                                    h
                                ];
                            };
                            getOpposite = function(w, h) {
                                return [
                                    w,
                                    0
                                ];
                            };
                            break;
                        case "middleLeft":
                            isHorizontal = true;
                            getPoint = function(w, h) {
                                return [
                                    0,
                                    h / 2
                                ];
                            };
                            getOpposite = function(w, h) {
                                return [
                                    w,
                                    h / 2
                                ];
                            };
                            break;
                    }
                    var point = getPoint(savedWidth, savedHeight);
                    var oppositePoint = getOpposite(savedWidth, savedHeight);
                    var transfOppositePoint = transf.apply(void 0, (0, $fyztb._)(oppositePoint));
                    var oppositeX = round(savedX + transfOppositePoint[0]);
                    var oppositeY = round(savedY + transfOppositePoint[1]);
                    var ratioX = 1;
                    var ratioY = 1;
                    var _this_screenToPageTranslation = (0, $52tJv._)(this.screenToPageTranslation(event.movementX, event.movementY), 2), deltaX = _this_screenToPageTranslation[0], deltaY = _this_screenToPageTranslation[1];
                    var ref;
                    ref = (0, $52tJv._)(invTransf(deltaX / parentWidth, deltaY / parentHeight), 2), deltaX = ref[0], deltaY = ref[1], ref;
                    if (isDiagonal) {
                        var oldDiag = Math.hypot(savedWidth, savedHeight);
                        ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
                    } else if (isHorizontal) ratioX = Math.max(minWidth, Math.min(1, Math.abs(oppositePoint[0] - point[0] - deltaX))) / savedWidth;
                    else ratioY = Math.max(minHeight, Math.min(1, Math.abs(oppositePoint[1] - point[1] - deltaY))) / savedHeight;
                    var newWidth = round(savedWidth * ratioX);
                    var newHeight = round(savedHeight * ratioY);
                    transfOppositePoint = transf.apply(void 0, (0, $fyztb._)(getOpposite(newWidth, newHeight)));
                    var newX = oppositeX - transfOppositePoint[0];
                    var newY = oppositeY - transfOppositePoint[1];
                    this.width = newWidth;
                    this.height = newHeight;
                    this.x = newX;
                    this.y = newY;
                    this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                    this.fixAndSetPosition();
                }
                function setAltTextButtonState() {
                    return _setAltTextButtonState1.apply(this, arguments);
                }
                function _setAltTextButtonState1() {
                    _setAltTextButtonState1 = (0, $7hBys._)(function() {
                        var _this, button, _$_class_private_field_get, tooltip, id, DELAY_TO_SHOW_TOOLTIP, _tmp;
                        return (0, $ajhIL.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this;
                                    button = (0, $057QZ._)(this, _altTextButton);
                                    if (!button) return [
                                        2
                                    ];
                                    if (!(0, $057QZ._)(this, _altText) && !(0, $057QZ._)(this, _altTextDecorative)) {
                                        ;
                                        button.classList.remove("done");
                                        (_$_class_private_field_get = (0, $057QZ._)(this, _altTextTooltip)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.remove();
                                        return [
                                            2
                                        ];
                                    }
                                    AnnotationEditor._l10nPromise.get("editor_alt_text_edit_button_label").then(function(msg) {
                                        button.setAttribute("aria-label", msg);
                                    });
                                    tooltip = (0, $057QZ._)(this, _altTextTooltip);
                                    if (!tooltip) {
                                        (0, $4LHB0._)(this, _altTextTooltip, tooltip = document.createElement("span"));
                                        tooltip.className = "tooltip";
                                        tooltip.setAttribute("role", "tooltip");
                                        id = tooltip.id = "alt-text-tooltip-".concat(this.id);
                                        button.setAttribute("aria-describedby", id);
                                        DELAY_TO_SHOW_TOOLTIP = 100;
                                        button.addEventListener("mouseenter", function() {
                                            (0, $4LHB0._)(_this, _altTextTooltipTimeout, setTimeout(function() {
                                                (0, $4LHB0._)(_this, _altTextTooltipTimeout, null);
                                                (0, $057QZ._)(_this, _altTextTooltip).classList.add("show");
                                                _this._uiManager._eventBus.dispatch("reporttelemetry", {
                                                    source: _this,
                                                    details: {
                                                        type: "editing",
                                                        subtype: _this.editorType,
                                                        data: {
                                                            action: "alt_text_tooltip"
                                                        }
                                                    }
                                                });
                                            }, DELAY_TO_SHOW_TOOLTIP));
                                        });
                                        button.addEventListener("mouseleave", function() {
                                            var _$_class_private_field_get;
                                            clearTimeout((0, $057QZ._)(_this, _altTextTooltipTimeout));
                                            (0, $4LHB0._)(_this, _altTextTooltipTimeout, null);
                                            (_$_class_private_field_get = (0, $057QZ._)(_this, _altTextTooltip)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.classList.remove("show");
                                        });
                                    }
                                    button.classList.add("done");
                                    if (!(0, $057QZ._)(this, _altTextDecorative)) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        AnnotationEditor._l10nPromise.get("editor_alt_text_decorative_tooltip")
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    _tmp = (0, $057QZ._)(this, _altText);
                                    _state.label = 3;
                                case 3:
                                    tooltip.innerText = _tmp;
                                    if (!tooltip.parentNode) button.append(tooltip);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return _setAltTextButtonState1.apply(this, arguments);
                }
                function setUpDragSession(event) {
                    var _this = this;
                    if (!this._isDraggable) return;
                    var isSelected = this._uiManager.isSelected(this);
                    this._uiManager.setUpDragSession();
                    var pointerMoveOptions, pointerMoveCallback;
                    if (isSelected) {
                        pointerMoveOptions = {
                            passive: true,
                            capture: true
                        };
                        pointerMoveCallback = function(e) {
                            var _this_screenToPageTranslation = (0, $52tJv._)(_this.screenToPageTranslation(e.movementX, e.movementY), 2), tx = _this_screenToPageTranslation[0], ty = _this_screenToPageTranslation[1];
                            _this._uiManager.dragSelectedEditors(tx, ty);
                        };
                        window.addEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                    }
                    var pointerUpCallback = function() {
                        window.removeEventListener("pointerup", pointerUpCallback);
                        window.removeEventListener("blur", pointerUpCallback);
                        if (isSelected) window.removeEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                        (0, $4LHB0._)(_this, _hasBeenClicked, false);
                        if (!_this._uiManager.endDragSession()) {
                            var isMac = _util.FeatureTest.platform.isMac;
                            if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) _this.parent.toggleSelected(_this);
                            else _this.parent.setSelected(_this);
                        }
                    };
                    window.addEventListener("pointerup", pointerUpCallback);
                    window.addEventListener("blur", pointerUpCallback);
                }
                exports.AnnotationEditor = AnnotationEditor;
                var FakeEditor = /*#__PURE__*/ function(AnnotationEditor) {
                    (0, $kcqLc._)(FakeEditor, AnnotationEditor);
                    var _super = (0, $4jYWU._)(FakeEditor);
                    function FakeEditor(params) {
                        (0, $5sFFs._)(this, FakeEditor);
                        var _this;
                        _this = _super.call(this, params);
                        _this.annotationElementId = params.annotationElementId;
                        _this.deleted = true;
                        return _this;
                    }
                    (0, $8O2fV._)(FakeEditor, [
                        {
                            key: "serialize",
                            value: function serialize() {
                                return {
                                    id: this.annotationElementId,
                                    deleted: true,
                                    pageIndex: this.pageIndex
                                };
                            }
                        }
                    ]);
                    return FakeEditor;
                }(AnnotationEditor);
            /***/ },
            /* 5 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.KeyboardManager = exports.CommandManager = exports.ColorManager = exports.AnnotationEditorUIManager = void 0;
                exports.bindEvents = bindEvents;
                exports.opacityToHex = opacityToHex;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                function bindEvents(obj, element, names) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var name = _step.value;
                            element.addEventListener(name, obj[name].bind(obj));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                function opacityToHex(opacity) {
                    return Math.round(Math.min(255, Math.max(1, 255 * opacity))).toString(16).padStart(2, "0");
                }
                var _id = /*#__PURE__*/ new WeakMap();
                var IdManager = /*#__PURE__*/ function() {
                    function IdManager() {
                        (0, $5sFFs._)(this, IdManager);
                        (0, $g12Hy._)(this, _id, {
                            writable: true,
                            value: 0
                        });
                    }
                    (0, $8O2fV._)(IdManager, [
                        {
                            key: "getId",
                            value: function getId() {
                                return "".concat(_util.AnnotationEditorPrefix).concat((0, $l0C3h._)(this, _id).value++);
                            }
                        }
                    ]);
                    return IdManager;
                }();
                var _baseId = /*#__PURE__*/ new WeakMap(), _id1 = /*#__PURE__*/ new WeakMap(), _cache = /*#__PURE__*/ new WeakMap(), _get = /*#__PURE__*/ new WeakSet();
                var ImageManager = /*#__PURE__*/ function() {
                    function ImageManager() {
                        (0, $5sFFs._)(this, ImageManager);
                        (0, $iB2CV._)(this, _get);
                        (0, $g12Hy._)(this, _baseId, {
                            writable: true,
                            value: (0, _util.getUuid)()
                        });
                        (0, $g12Hy._)(this, _id1, {
                            writable: true,
                            value: 0
                        });
                        (0, $g12Hy._)(this, _cache, {
                            writable: true,
                            value: null
                        });
                    }
                    (0, $8O2fV._)(ImageManager, [
                        {
                            key: "getFromFile",
                            value: function getFromFile(file) {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var lastModified, name, size, type;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        lastModified = file.lastModified, name = file.name, size = file.size, type = file.type;
                                        return [
                                            2,
                                            (0, $lNbhr._)(_this, _get, get).call(_this, "".concat(lastModified, "_").concat(name, "_").concat(size, "_").concat(type), file)
                                        ];
                                    });
                                })();
                            }
                        },
                        {
                            key: "getFromUrl",
                            value: function getFromUrl(url) {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            (0, $lNbhr._)(_this, _get, get).call(_this, url, url)
                                        ];
                                    });
                                })();
                            }
                        },
                        {
                            key: "getFromId",
                            value: function getFromId(id) {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var data;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        (0, $4LHB0._)(_this, _cache, (0, $057QZ._)(_this, _cache) || new Map());
                                        data = (0, $057QZ._)(_this, _cache).get(id);
                                        if (!data) return [
                                            2,
                                            null
                                        ];
                                        if (data.bitmap) {
                                            data.refCounter += 1;
                                            return [
                                                2,
                                                data
                                            ];
                                        }
                                        if (data.file) return [
                                            2,
                                            _this.getFromFile(data.file)
                                        ];
                                        return [
                                            2,
                                            _this.getFromUrl(data.url)
                                        ];
                                    });
                                })();
                            }
                        },
                        {
                            key: "getSvgUrl",
                            value: function getSvgUrl(id) {
                                var data = (0, $057QZ._)(this, _cache).get(id);
                                if (!(data === null || data === void 0 ? void 0 : data.isSvg)) return null;
                                return data.svgUrl;
                            }
                        },
                        {
                            key: "deleteId",
                            value: function deleteId(id) {
                                (0, $4LHB0._)(this, _cache, (0, $057QZ._)(this, _cache) || new Map());
                                var data = (0, $057QZ._)(this, _cache).get(id);
                                if (!data) return;
                                data.refCounter -= 1;
                                if (data.refCounter !== 0) return;
                                data.bitmap = null;
                            }
                        },
                        {
                            key: "isValidId",
                            value: function isValidId(id) {
                                return id.startsWith("image_".concat((0, $057QZ._)(this, _baseId), "_"));
                            }
                        }
                    ], [
                        {
                            key: "_isSVGFittingCanvas",
                            get: function get() {
                                var svg = 'data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>';
                                var canvas = new OffscreenCanvas(1, 3);
                                var ctx = canvas.getContext("2d");
                                var image = new Image();
                                image.src = svg;
                                var promise = image.decode().then(function() {
                                    ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
                                    return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
                                });
                                return (0, _util.shadow)(this, "_isSVGFittingCanvas", promise);
                            }
                        }
                    ]);
                    return ImageManager;
                }();
                function get(key, rawData) {
                    return _get1.apply(this, arguments);
                }
                function _get1() {
                    _get1 = (0, $7hBys._)(function(key, rawData) {
                        var data, image, response, mustRemoveAspectRatioPromise, fileReader, imageElement, imagePromise, e;
                        return (0, $ajhIL.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    (0, $4LHB0._)(this, _cache, (0, $057QZ._)(this, _cache) || new Map());
                                    data = (0, $057QZ._)(this, _cache).get(key);
                                    if (data === null) return [
                                        2,
                                        null
                                    ];
                                    if (data === null || data === void 0 ? void 0 : data.bitmap) {
                                        data.refCounter += 1;
                                        return [
                                            2,
                                            data
                                        ];
                                    }
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        10,
                                        ,
                                        11
                                    ]);
                                    data || (data = {
                                        bitmap: null,
                                        id: "image_".concat((0, $057QZ._)(this, _baseId), "_").concat((0, $l0C3h._)(this, _id1).value++),
                                        refCounter: 0,
                                        isSvg: false
                                    });
                                    if (!(typeof rawData === "string")) return [
                                        3,
                                        4
                                    ];
                                    data.url = rawData;
                                    return [
                                        4,
                                        fetch(rawData)
                                    ];
                                case 2:
                                    response = _state.sent();
                                    if (!response.ok) throw new Error(response.statusText);
                                    return [
                                        4,
                                        response.blob()
                                    ];
                                case 3:
                                    image = _state.sent();
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    image = data.file = rawData;
                                    _state.label = 5;
                                case 5:
                                    if (!(image.type === "image/svg+xml")) return [
                                        3,
                                        7
                                    ];
                                    mustRemoveAspectRatioPromise = ImageManager._isSVGFittingCanvas;
                                    fileReader = new FileReader();
                                    imageElement = new Image();
                                    imagePromise = new Promise(function(resolve, reject) {
                                        imageElement.onload = function() {
                                            data.bitmap = imageElement;
                                            data.isSvg = true;
                                            resolve();
                                        };
                                        fileReader.onload = /*#__PURE__*/ (0, $7hBys._)(function() {
                                            var url;
                                            return (0, $ajhIL.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        url = data.svgUrl = fileReader.result;
                                                        return [
                                                            4,
                                                            mustRemoveAspectRatioPromise
                                                        ];
                                                    case 1:
                                                        imageElement.src = _state.sent() ? "".concat(url, "#svgView(preserveAspectRatio(none))") : url;
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        imageElement.onerror = fileReader.onerror = reject;
                                    });
                                    fileReader.readAsDataURL(image);
                                    return [
                                        4,
                                        imagePromise
                                    ];
                                case 6:
                                    _state.sent();
                                    return [
                                        3,
                                        9
                                    ];
                                case 7:
                                    return [
                                        4,
                                        createImageBitmap(image)
                                    ];
                                case 8:
                                    data.bitmap = _state.sent();
                                    _state.label = 9;
                                case 9:
                                    data.refCounter = 1;
                                    return [
                                        3,
                                        11
                                    ];
                                case 10:
                                    e = _state.sent();
                                    console.error(e);
                                    data = null;
                                    return [
                                        3,
                                        11
                                    ];
                                case 11:
                                    (0, $057QZ._)(this, _cache).set(key, data);
                                    if (data) (0, $057QZ._)(this, _cache).set(data.id, data);
                                    return [
                                        2,
                                        data
                                    ];
                            }
                        });
                    });
                    return _get1.apply(this, arguments);
                }
                var _commands = /*#__PURE__*/ new WeakMap(), _locked = /*#__PURE__*/ new WeakMap(), _maxSize = /*#__PURE__*/ new WeakMap(), _position = /*#__PURE__*/ new WeakMap();
                var CommandManager = /*#__PURE__*/ function() {
                    function CommandManager() {
                        var maxSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 128;
                        (0, $5sFFs._)(this, CommandManager);
                        (0, $g12Hy._)(this, _commands, {
                            writable: true,
                            value: []
                        });
                        (0, $g12Hy._)(this, _locked, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)(this, _maxSize, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)(this, _position, {
                            writable: true,
                            value: -1
                        });
                        (0, $4LHB0._)(this, _maxSize, maxSize);
                    }
                    (0, $8O2fV._)(CommandManager, [
                        {
                            key: "add",
                            value: function add(param) {
                                var cmd = param.cmd, undo = param.undo, mustExec = param.mustExec, _param_type = param.type, type = _param_type === void 0 ? NaN : _param_type, _param_overwriteIfSameType = param.overwriteIfSameType, overwriteIfSameType = _param_overwriteIfSameType === void 0 ? false : _param_overwriteIfSameType, _param_keepUndo = param.keepUndo, keepUndo = _param_keepUndo === void 0 ? false : _param_keepUndo;
                                if (mustExec) cmd();
                                if ((0, $057QZ._)(this, _locked)) return;
                                var save = {
                                    cmd: cmd,
                                    undo: undo,
                                    type: type
                                };
                                if ((0, $057QZ._)(this, _position) === -1) {
                                    if ((0, $057QZ._)(this, _commands).length > 0) (0, $057QZ._)(this, _commands).length = 0;
                                    (0, $4LHB0._)(this, _position, 0);
                                    (0, $057QZ._)(this, _commands).push(save);
                                    return;
                                }
                                if (overwriteIfSameType && (0, $057QZ._)(this, _commands)[(0, $057QZ._)(this, _position)].type === type) {
                                    if (keepUndo) save.undo = (0, $057QZ._)(this, _commands)[(0, $057QZ._)(this, _position)].undo;
                                    (0, $057QZ._)(this, _commands)[(0, $057QZ._)(this, _position)] = save;
                                    return;
                                }
                                var next = (0, $057QZ._)(this, _position) + 1;
                                if (next === (0, $057QZ._)(this, _maxSize)) (0, $057QZ._)(this, _commands).splice(0, 1);
                                else {
                                    (0, $4LHB0._)(this, _position, next);
                                    if (next < (0, $057QZ._)(this, _commands).length) (0, $057QZ._)(this, _commands).splice(next);
                                }
                                (0, $057QZ._)(this, _commands).push(save);
                            }
                        },
                        {
                            key: "undo",
                            value: function undo() {
                                if ((0, $057QZ._)(this, _position) === -1) return;
                                (0, $4LHB0._)(this, _locked, true);
                                (0, $057QZ._)(this, _commands)[(0, $057QZ._)(this, _position)].undo();
                                (0, $4LHB0._)(this, _locked, false);
                                (0, $4LHB0._)(this, _position, (0, $057QZ._)(this, _position) - 1);
                            }
                        },
                        {
                            key: "redo",
                            value: function redo() {
                                if ((0, $057QZ._)(this, _position) < (0, $057QZ._)(this, _commands).length - 1) {
                                    (0, $4LHB0._)(this, _position, (0, $057QZ._)(this, _position) + 1);
                                    (0, $4LHB0._)(this, _locked, true);
                                    (0, $057QZ._)(this, _commands)[(0, $057QZ._)(this, _position)].cmd();
                                    (0, $4LHB0._)(this, _locked, false);
                                }
                            }
                        },
                        {
                            key: "hasSomethingToUndo",
                            value: function hasSomethingToUndo() {
                                return (0, $057QZ._)(this, _position) !== -1;
                            }
                        },
                        {
                            key: "hasSomethingToRedo",
                            value: function hasSomethingToRedo() {
                                return (0, $057QZ._)(this, _position) < (0, $057QZ._)(this, _commands).length - 1;
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                (0, $4LHB0._)(this, _commands, null);
                            }
                        }
                    ]);
                    return CommandManager;
                }();
                exports.CommandManager = CommandManager;
                var _serialize = /*#__PURE__*/ new WeakSet();
                var KeyboardManager = /*#__PURE__*/ function() {
                    function KeyboardManager(callbacks) {
                        (0, $5sFFs._)(this, KeyboardManager);
                        (0, $iB2CV._)(this, _serialize);
                        this.buffer = [];
                        this.callbacks = new Map();
                        this.allKeys = new Set();
                        var isMac = _util.FeatureTest.platform.isMac;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                var _step_value = (0, $52tJv._)(_step.value, 3), keys = _step_value[0], callback = _step_value[1], tmp = _step_value[2], options = tmp === void 0 ? {} : tmp;
                                try {
                                    for(var _iterator1 = keys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                        var key = _step1.value;
                                        var isMacKey = key.startsWith("mac+");
                                        if (isMac && isMacKey) {
                                            this.callbacks.set(key.slice(4), {
                                                callback: callback,
                                                options: options
                                            });
                                            this.allKeys.add(key.split("+").at(-1));
                                        } else if (!isMac && !isMacKey) {
                                            this.callbacks.set(key, {
                                                callback: callback,
                                                options: options
                                            });
                                            this.allKeys.add(key.split("+").at(-1));
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                    (0, $8O2fV._)(KeyboardManager, [
                        {
                            key: "exec",
                            value: function exec(self, event) {
                                var _callback;
                                if (!this.allKeys.has(event.key)) return;
                                var info = this.callbacks.get((0, $lNbhr._)(this, _serialize, serialize).call(this, event));
                                if (!info) return;
                                var callback = info.callback, _info_options = info.options, _info_options_bubbles = _info_options.bubbles, bubbles = _info_options_bubbles === void 0 ? false : _info_options_bubbles, _info_options_args = _info_options.args, args = _info_options_args === void 0 ? [] : _info_options_args, _info_options_checker = _info_options.checker, checker = _info_options_checker === void 0 ? null : _info_options_checker;
                                if (checker && !checker(self, event)) return;
                                (_callback = callback).bind.apply(_callback, [
                                    self
                                ].concat((0, $fyztb._)(args)))();
                                if (!bubbles) {
                                    event.stopPropagation();
                                    event.preventDefault();
                                }
                            }
                        }
                    ]);
                    return KeyboardManager;
                }();
                function serialize(event) {
                    if (event.altKey) this.buffer.push("alt");
                    if (event.ctrlKey) this.buffer.push("ctrl");
                    if (event.metaKey) this.buffer.push("meta");
                    if (event.shiftKey) this.buffer.push("shift");
                    this.buffer.push(event.key);
                    var str = this.buffer.join("+");
                    this.buffer.length = 0;
                    return str;
                }
                exports.KeyboardManager = KeyboardManager;
                var ColorManager = /*#__PURE__*/ function() {
                    function ColorManager() {
                        (0, $5sFFs._)(this, ColorManager);
                    }
                    (0, $8O2fV._)(ColorManager, [
                        {
                            key: "_colors",
                            get: function get() {
                                var colors = new Map([
                                    [
                                        "CanvasText",
                                        null
                                    ],
                                    [
                                        "Canvas",
                                        null
                                    ]
                                ]);
                                (0, _display_utils.getColorValues)(colors);
                                return (0, _util.shadow)(this, "_colors", colors);
                            }
                        },
                        {
                            key: "convert",
                            value: function convert(color) {
                                var rgb = (0, _display_utils.getRGB)(color);
                                if (!window.matchMedia("(forced-colors: active)").matches) return rgb;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._colors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _step_value = (0, $52tJv._)(_step.value, 2), name = _step_value[0], RGB = _step_value[1];
                                        if (RGB.every(function(x, i) {
                                            return x === rgb[i];
                                        })) return ColorManager._colorsMapping.get(name);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return rgb;
                            }
                        },
                        {
                            key: "getHexCode",
                            value: function getHexCode(name) {
                                var _util_Util;
                                var rgb = this._colors.get(name);
                                if (!rgb) return name;
                                return (_util_Util = _util.Util).makeHexColor.apply(_util_Util, (0, $fyztb._)(rgb));
                            }
                        }
                    ]);
                    return ColorManager;
                }();
                (0, $iCQyW._)(ColorManager, "_colorsMapping", new Map([
                    [
                        "CanvasText",
                        [
                            0,
                            0,
                            0
                        ]
                    ],
                    [
                        "Canvas",
                        [
                            255,
                            255,
                            255
                        ]
                    ]
                ]));
                exports.ColorManager = ColorManager;
                var _activeEditor = /*#__PURE__*/ new WeakMap(), _allEditors = /*#__PURE__*/ new WeakMap(), _allLayers = /*#__PURE__*/ new WeakMap(), _altTextManager = /*#__PURE__*/ new WeakMap(), _annotationStorage = /*#__PURE__*/ new WeakMap(), _commandManager = /*#__PURE__*/ new WeakMap(), _currentPageIndex = /*#__PURE__*/ new WeakMap(), _deletedAnnotationsElementIds = /*#__PURE__*/ new WeakMap(), _draggingEditors = /*#__PURE__*/ new WeakMap(), _editorTypes = /*#__PURE__*/ new WeakMap(), _editorsToRescale = /*#__PURE__*/ new WeakMap(), _filterFactory = /*#__PURE__*/ new WeakMap(), _idManager = /*#__PURE__*/ new WeakMap(), _isEnabled = /*#__PURE__*/ new WeakMap(), _isWaiting = /*#__PURE__*/ new WeakMap(), _lastActiveElement = /*#__PURE__*/ new WeakMap(), _mode = /*#__PURE__*/ new WeakMap(), _selectedEditors = /*#__PURE__*/ new WeakMap(), _pageColors = /*#__PURE__*/ new WeakMap(), _boundBlur = /*#__PURE__*/ new WeakMap(), _boundFocus = /*#__PURE__*/ new WeakMap(), _boundCopy = /*#__PURE__*/ new WeakMap(), _boundCut = /*#__PURE__*/ new WeakMap(), _boundPaste = /*#__PURE__*/ new WeakMap(), _boundKeydown = /*#__PURE__*/ new WeakMap(), _boundOnEditingAction = /*#__PURE__*/ new WeakMap(), _boundOnPageChanging = /*#__PURE__*/ new WeakMap(), _boundOnScaleChanging = /*#__PURE__*/ new WeakMap(), _boundOnRotationChanging = /*#__PURE__*/ new WeakMap(), _previousStates = /*#__PURE__*/ new WeakMap(), _translation = /*#__PURE__*/ new WeakMap(), _translationTimeoutId = /*#__PURE__*/ new WeakMap(), _container = /*#__PURE__*/ new WeakMap(), _viewer = /*#__PURE__*/ new WeakMap(), _addFocusManager = /*#__PURE__*/ new WeakSet(), _removeFocusManager = /*#__PURE__*/ new WeakSet(), _addKeyboardManager = /*#__PURE__*/ new WeakSet(), _removeKeyboardManager = /*#__PURE__*/ new WeakSet(), _addCopyPasteListeners = /*#__PURE__*/ new WeakSet(), _removeCopyPasteListeners = /*#__PURE__*/ new WeakSet(), _dispatchUpdateStates = /*#__PURE__*/ new WeakSet(), _dispatchUpdateUI = /*#__PURE__*/ new WeakSet(), _enableAll = /*#__PURE__*/ new WeakSet(), _disableAll = /*#__PURE__*/ new WeakSet(), _addEditorToLayer = /*#__PURE__*/ new WeakSet(), _isEmpty = /*#__PURE__*/ new WeakSet(), _selectEditors = /*#__PURE__*/ new WeakSet();
                var AnnotationEditorUIManager = /*#__PURE__*/ function() {
                    function AnnotationEditorUIManager(container, viewer, altTextManager, eventBus, pdfDocument, pageColors) {
                        (0, $5sFFs._)(this, AnnotationEditorUIManager);
                        (0, $iB2CV._)(this, _addFocusManager);
                        (0, $iB2CV._)(this, _removeFocusManager);
                        (0, $iB2CV._)(this, _addKeyboardManager);
                        (0, $iB2CV._)(this, _removeKeyboardManager);
                        (0, $iB2CV._)(this, _addCopyPasteListeners);
                        (0, $iB2CV._)(this, _removeCopyPasteListeners);
                        (0, $iB2CV._)(this, _dispatchUpdateStates);
                        (0, $iB2CV._)(this, _dispatchUpdateUI);
                        (0, $iB2CV._)(this, _enableAll);
                        (0, $iB2CV._)(this, _disableAll);
                        (0, $iB2CV._)(this, _addEditorToLayer);
                        (0, $iB2CV._)(this, _isEmpty);
                        (0, $iB2CV._)(this, _selectEditors);
                        (0, $g12Hy._)(this, _activeEditor, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _allEditors, {
                            writable: true,
                            value: new Map()
                        });
                        (0, $g12Hy._)(this, _allLayers, {
                            writable: true,
                            value: new Map()
                        });
                        (0, $g12Hy._)(this, _altTextManager, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _annotationStorage, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _commandManager, {
                            writable: true,
                            value: new CommandManager()
                        });
                        (0, $g12Hy._)(this, _currentPageIndex, {
                            writable: true,
                            value: 0
                        });
                        (0, $g12Hy._)(this, _deletedAnnotationsElementIds, {
                            writable: true,
                            value: new Set()
                        });
                        (0, $g12Hy._)(this, _draggingEditors, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _editorTypes, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _editorsToRescale, {
                            writable: true,
                            value: new Set()
                        });
                        (0, $g12Hy._)(this, _filterFactory, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _idManager, {
                            writable: true,
                            value: new IdManager()
                        });
                        (0, $g12Hy._)(this, _isEnabled, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)(this, _isWaiting, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)(this, _lastActiveElement, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _mode, {
                            writable: true,
                            value: _util.AnnotationEditorType.NONE
                        });
                        (0, $g12Hy._)(this, _selectedEditors, {
                            writable: true,
                            value: new Set()
                        });
                        (0, $g12Hy._)(this, _pageColors, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _boundBlur, {
                            writable: true,
                            value: this.blur.bind(this)
                        });
                        (0, $g12Hy._)(this, _boundFocus, {
                            writable: true,
                            value: this.focus.bind(this)
                        });
                        (0, $g12Hy._)(this, _boundCopy, {
                            writable: true,
                            value: this.copy.bind(this)
                        });
                        (0, $g12Hy._)(this, _boundCut, {
                            writable: true,
                            value: this.cut.bind(this)
                        });
                        (0, $g12Hy._)(this, _boundPaste, {
                            writable: true,
                            value: this.paste.bind(this)
                        });
                        (0, $g12Hy._)(this, _boundKeydown, {
                            writable: true,
                            value: this.keydown.bind(this)
                        });
                        (0, $g12Hy._)(this, _boundOnEditingAction, {
                            writable: true,
                            value: this.onEditingAction.bind(this)
                        });
                        (0, $g12Hy._)(this, _boundOnPageChanging, {
                            writable: true,
                            value: this.onPageChanging.bind(this)
                        });
                        (0, $g12Hy._)(this, _boundOnScaleChanging, {
                            writable: true,
                            value: this.onScaleChanging.bind(this)
                        });
                        (0, $g12Hy._)(this, _boundOnRotationChanging, {
                            writable: true,
                            value: this.onRotationChanging.bind(this)
                        });
                        (0, $g12Hy._)(this, _previousStates, {
                            writable: true,
                            value: {
                                isEditing: false,
                                isEmpty: true,
                                hasSomethingToUndo: false,
                                hasSomethingToRedo: false,
                                hasSelectedEditor: false
                            }
                        });
                        (0, $g12Hy._)(this, _translation, {
                            writable: true,
                            value: [
                                0,
                                0
                            ]
                        });
                        (0, $g12Hy._)(this, _translationTimeoutId, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _container, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _viewer, {
                            writable: true,
                            value: null
                        });
                        (0, $4LHB0._)(this, _container, container);
                        (0, $4LHB0._)(this, _viewer, viewer);
                        (0, $4LHB0._)(this, _altTextManager, altTextManager);
                        this._eventBus = eventBus;
                        this._eventBus._on("editingaction", (0, $057QZ._)(this, _boundOnEditingAction));
                        this._eventBus._on("pagechanging", (0, $057QZ._)(this, _boundOnPageChanging));
                        this._eventBus._on("scalechanging", (0, $057QZ._)(this, _boundOnScaleChanging));
                        this._eventBus._on("rotationchanging", (0, $057QZ._)(this, _boundOnRotationChanging));
                        (0, $4LHB0._)(this, _annotationStorage, pdfDocument.annotationStorage);
                        (0, $4LHB0._)(this, _filterFactory, pdfDocument.filterFactory);
                        (0, $4LHB0._)(this, _pageColors, pageColors);
                        this.viewParameters = {
                            realScale: _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS,
                            rotation: 0
                        };
                    }
                    (0, $8O2fV._)(AnnotationEditorUIManager, [
                        {
                            key: "destroy",
                            value: function destroy() {
                                (0, $lNbhr._)(this, _removeKeyboardManager, removeKeyboardManager).call(this);
                                (0, $lNbhr._)(this, _removeFocusManager, removeFocusManager).call(this);
                                this._eventBus._off("editingaction", (0, $057QZ._)(this, _boundOnEditingAction));
                                this._eventBus._off("pagechanging", (0, $057QZ._)(this, _boundOnPageChanging));
                                this._eventBus._off("scalechanging", (0, $057QZ._)(this, _boundOnScaleChanging));
                                this._eventBus._off("rotationchanging", (0, $057QZ._)(this, _boundOnRotationChanging));
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _allLayers).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var layer = _step.value;
                                        layer.destroy();
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                (0, $057QZ._)(this, _allLayers).clear();
                                (0, $057QZ._)(this, _allEditors).clear();
                                (0, $057QZ._)(this, _editorsToRescale).clear();
                                (0, $4LHB0._)(this, _activeEditor, null);
                                (0, $057QZ._)(this, _selectedEditors).clear();
                                (0, $057QZ._)(this, _commandManager).destroy();
                                (0, $057QZ._)(this, _altTextManager).destroy();
                            }
                        },
                        {
                            key: "hcmFilter",
                            get: function get() {
                                return (0, _util.shadow)(this, "hcmFilter", (0, $057QZ._)(this, _pageColors) ? (0, $057QZ._)(this, _filterFactory).addHCMFilter((0, $057QZ._)(this, _pageColors).foreground, (0, $057QZ._)(this, _pageColors).background) : "none");
                            }
                        },
                        {
                            key: "direction",
                            get: function get() {
                                return (0, _util.shadow)(this, "direction", getComputedStyle((0, $057QZ._)(this, _container)).direction);
                            }
                        },
                        {
                            key: "editAltText",
                            value: function editAltText(editor) {
                                var _$_class_private_field_get;
                                (_$_class_private_field_get = (0, $057QZ._)(this, _altTextManager)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.editAltText(this, editor);
                            }
                        },
                        {
                            key: "onPageChanging",
                            value: function onPageChanging(param) {
                                var pageNumber = param.pageNumber;
                                (0, $4LHB0._)(this, _currentPageIndex, pageNumber - 1);
                            }
                        },
                        {
                            key: "focusMainContainer",
                            value: function focusMainContainer() {
                                (0, $057QZ._)(this, _container).focus();
                            }
                        },
                        {
                            key: "findParent",
                            value: function findParent(x, y) {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _allLayers).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var layer = _step.value;
                                        var _layer_div_getBoundingClientRect = layer.div.getBoundingClientRect(), layerX = _layer_div_getBoundingClientRect.x, layerY = _layer_div_getBoundingClientRect.y, width = _layer_div_getBoundingClientRect.width, height = _layer_div_getBoundingClientRect.height;
                                        if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) return layer;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return null;
                            }
                        },
                        {
                            key: "disableUserSelect",
                            value: function disableUserSelect() {
                                var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                                (0, $057QZ._)(this, _viewer).classList.toggle("noUserSelect", value);
                            }
                        },
                        {
                            key: "addShouldRescale",
                            value: function addShouldRescale(editor) {
                                (0, $057QZ._)(this, _editorsToRescale).add(editor);
                            }
                        },
                        {
                            key: "removeShouldRescale",
                            value: function removeShouldRescale(editor) {
                                (0, $057QZ._)(this, _editorsToRescale).delete(editor);
                            }
                        },
                        {
                            key: "onScaleChanging",
                            value: function onScaleChanging(param) {
                                var scale = param.scale;
                                this.commitOrRemove();
                                this.viewParameters.realScale = scale * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _editorsToRescale)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editor = _step.value;
                                        editor.onScaleChanging();
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "onRotationChanging",
                            value: function onRotationChanging(param) {
                                var pagesRotation = param.pagesRotation;
                                this.commitOrRemove();
                                this.viewParameters.rotation = pagesRotation;
                            }
                        },
                        {
                            key: "addToAnnotationStorage",
                            value: function addToAnnotationStorage(editor) {
                                if (!editor.isEmpty() && (0, $057QZ._)(this, _annotationStorage) && !(0, $057QZ._)(this, _annotationStorage).has(editor.id)) (0, $057QZ._)(this, _annotationStorage).setValue(editor.id, editor);
                            }
                        },
                        {
                            key: "blur",
                            value: function blur() {
                                if (!this.hasSelection) return;
                                var activeElement = document.activeElement;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _selectedEditors)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editor = _step.value;
                                        if (editor.div.contains(activeElement)) {
                                            (0, $4LHB0._)(this, _lastActiveElement, [
                                                editor,
                                                activeElement
                                            ]);
                                            editor._focusEventsAllowed = false;
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "focus",
                            value: function focus() {
                                if (!(0, $057QZ._)(this, _lastActiveElement)) return;
                                var _$_class_private_field_get = (0, $52tJv._)((0, $057QZ._)(this, _lastActiveElement), 2), lastEditor = _$_class_private_field_get[0], lastActiveElement = _$_class_private_field_get[1];
                                (0, $4LHB0._)(this, _lastActiveElement, null);
                                lastActiveElement.addEventListener("focusin", function() {
                                    lastEditor._focusEventsAllowed = true;
                                }, {
                                    once: true
                                });
                                lastActiveElement.focus();
                            }
                        },
                        {
                            key: "addEditListeners",
                            value: function addEditListeners() {
                                (0, $lNbhr._)(this, _addKeyboardManager, addKeyboardManager).call(this);
                                (0, $lNbhr._)(this, _addCopyPasteListeners, addCopyPasteListeners).call(this);
                            }
                        },
                        {
                            key: "removeEditListeners",
                            value: function removeEditListeners() {
                                (0, $lNbhr._)(this, _removeKeyboardManager, removeKeyboardManager).call(this);
                                (0, $lNbhr._)(this, _removeCopyPasteListeners, removeCopyPasteListeners).call(this);
                            }
                        },
                        {
                            key: "copy",
                            value: function copy(event) {
                                var _$_class_private_field_get;
                                event.preventDefault();
                                (_$_class_private_field_get = (0, $057QZ._)(this, _activeEditor)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.commitOrRemove();
                                if (!this.hasSelection) return;
                                var editors = [];
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _selectedEditors)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editor = _step.value;
                                        var serialized = editor.serialize(true);
                                        if (serialized) editors.push(serialized);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (editors.length === 0) return;
                                event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
                            }
                        },
                        {
                            key: "cut",
                            value: function cut(event) {
                                this.copy(event);
                                this.delete();
                            }
                        },
                        {
                            key: "paste",
                            value: function paste(event) {
                                var _this = this;
                                event.preventDefault();
                                var clipboardData = event.clipboardData;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = clipboardData.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var item = _step.value;
                                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(var _iterator1 = (0, $057QZ._)(this, _editorTypes)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                var editorType = _step1.value;
                                                if (editorType.isHandlingMimeForPasting(item.type)) {
                                                    editorType.paste(item, this.currentLayer);
                                                    return;
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                var data = clipboardData.getData("application/pdfjs");
                                if (!data) return;
                                try {
                                    data = JSON.parse(data);
                                } catch (ex) {
                                    (0, _util.warn)('paste: "'.concat(ex.message, '".'));
                                    return;
                                }
                                if (!Array.isArray(data)) return;
                                this.unselectAll();
                                var layer = this.currentLayer;
                                try {
                                    var newEditors = [];
                                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                    try {
                                        for(var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                            var editor = _step2.value;
                                            var deserializedEditor = layer.deserialize(editor);
                                            if (!deserializedEditor) return;
                                            newEditors.push(deserializedEditor);
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                                _iterator2.return();
                                            }
                                        } finally{
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }
                                    var cmd = function() {
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = newEditors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var editor = _step.value;
                                                (0, $lNbhr._)(_this, _addEditorToLayer, addEditorToLayer).call(_this, editor);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        (0, $lNbhr._)(_this, _selectEditors, selectEditors).call(_this, newEditors);
                                    };
                                    var undo = function() {
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = newEditors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var editor = _step.value;
                                                editor.remove();
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    };
                                    this.addCommands({
                                        cmd: cmd,
                                        undo: undo,
                                        mustExec: true
                                    });
                                } catch (ex) {
                                    (0, _util.warn)('paste: "'.concat(ex.message, '".'));
                                }
                            }
                        },
                        {
                            key: "keydown",
                            value: function keydown(event) {
                                var _this_getActive;
                                if (!((_this_getActive = this.getActive()) === null || _this_getActive === void 0 ? void 0 : _this_getActive.shouldGetKeyboardEvents())) AnnotationEditorUIManager._keyboardManager.exec(this, event);
                            }
                        },
                        {
                            key: "onEditingAction",
                            value: function onEditingAction(details) {
                                if ([
                                    "undo",
                                    "redo",
                                    "delete",
                                    "selectAll"
                                ].includes(details.name)) this[details.name]();
                            }
                        },
                        {
                            key: "setEditingState",
                            value: function setEditingState(isEditing) {
                                if (isEditing) {
                                    (0, $lNbhr._)(this, _addFocusManager, addFocusManager).call(this);
                                    (0, $lNbhr._)(this, _addKeyboardManager, addKeyboardManager).call(this);
                                    (0, $lNbhr._)(this, _addCopyPasteListeners, addCopyPasteListeners).call(this);
                                    (0, $lNbhr._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                                        isEditing: (0, $057QZ._)(this, _mode) !== _util.AnnotationEditorType.NONE,
                                        isEmpty: (0, $lNbhr._)(this, _isEmpty, isEmpty).call(this),
                                        hasSomethingToUndo: (0, $057QZ._)(this, _commandManager).hasSomethingToUndo(),
                                        hasSomethingToRedo: (0, $057QZ._)(this, _commandManager).hasSomethingToRedo(),
                                        hasSelectedEditor: false
                                    });
                                } else {
                                    (0, $lNbhr._)(this, _removeFocusManager, removeFocusManager).call(this);
                                    (0, $lNbhr._)(this, _removeKeyboardManager, removeKeyboardManager).call(this);
                                    (0, $lNbhr._)(this, _removeCopyPasteListeners, removeCopyPasteListeners).call(this);
                                    (0, $lNbhr._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                                        isEditing: false
                                    });
                                    this.disableUserSelect(false);
                                }
                            }
                        },
                        {
                            key: "registerEditorTypes",
                            value: function registerEditorTypes(types) {
                                if ((0, $057QZ._)(this, _editorTypes)) return;
                                (0, $4LHB0._)(this, _editorTypes, types);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _editorTypes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editorType = _step.value;
                                        (0, $lNbhr._)(this, _dispatchUpdateUI, dispatchUpdateUI).call(this, editorType.defaultPropertiesToUpdate);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "getId",
                            value: function getId() {
                                return (0, $057QZ._)(this, _idManager).getId();
                            }
                        },
                        {
                            key: "currentLayer",
                            get: function get() {
                                return (0, $057QZ._)(this, _allLayers).get((0, $057QZ._)(this, _currentPageIndex));
                            }
                        },
                        {
                            key: "getLayer",
                            value: function getLayer(pageIndex) {
                                return (0, $057QZ._)(this, _allLayers).get(pageIndex);
                            }
                        },
                        {
                            key: "currentPageIndex",
                            get: function get() {
                                return (0, $057QZ._)(this, _currentPageIndex);
                            }
                        },
                        {
                            key: "addLayer",
                            value: function addLayer(layer) {
                                (0, $057QZ._)(this, _allLayers).set(layer.pageIndex, layer);
                                if ((0, $057QZ._)(this, _isEnabled)) layer.enable();
                                else layer.disable();
                            }
                        },
                        {
                            key: "removeLayer",
                            value: function removeLayer(layer) {
                                (0, $057QZ._)(this, _allLayers).delete(layer.pageIndex);
                            }
                        },
                        {
                            key: "updateMode",
                            value: function updateMode(mode) {
                                var editId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                                if ((0, $057QZ._)(this, _mode) === mode) return;
                                (0, $4LHB0._)(this, _mode, mode);
                                if (mode === _util.AnnotationEditorType.NONE) {
                                    this.setEditingState(false);
                                    (0, $lNbhr._)(this, _disableAll, disableAll).call(this);
                                    return;
                                }
                                this.setEditingState(true);
                                (0, $lNbhr._)(this, _enableAll, enableAll).call(this);
                                this.unselectAll();
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _allLayers).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var layer = _step.value;
                                        layer.updateMode(mode);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (!editId) return;
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = (0, $057QZ._)(this, _allEditors).values()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var editor = _step1.value;
                                        if (editor.annotationElementId === editId) {
                                            this.setSelected(editor);
                                            editor.enterInEditMode();
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "updateToolbar",
                            value: function updateToolbar(mode) {
                                if (mode === (0, $057QZ._)(this, _mode)) return;
                                this._eventBus.dispatch("switchannotationeditormode", {
                                    source: this,
                                    mode: mode
                                });
                            }
                        },
                        {
                            key: "updateParams",
                            value: function updateParams(type, value) {
                                if (!(0, $057QZ._)(this, _editorTypes)) return;
                                if (type === _util.AnnotationEditorParamsType.CREATE) {
                                    this.currentLayer.addNewEditor(type);
                                    return;
                                }
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _selectedEditors)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editor = _step.value;
                                        editor.updateParams(type, value);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = (0, $057QZ._)(this, _editorTypes)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var editorType = _step1.value;
                                        editorType.updateDefaultParams(type, value);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "enableWaiting",
                            value: function enableWaiting() {
                                var mustWait = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                                if ((0, $057QZ._)(this, _isWaiting) === mustWait) return;
                                (0, $4LHB0._)(this, _isWaiting, mustWait);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _allLayers).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var layer = _step.value;
                                        if (mustWait) layer.disableClick();
                                        else layer.enableClick();
                                        layer.div.classList.toggle("waiting", mustWait);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "getEditors",
                            value: function getEditors(pageIndex) {
                                var editors = [];
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _allEditors).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editor = _step.value;
                                        if (editor.pageIndex === pageIndex) editors.push(editor);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return editors;
                            }
                        },
                        {
                            key: "getEditor",
                            value: function getEditor(id) {
                                return (0, $057QZ._)(this, _allEditors).get(id);
                            }
                        },
                        {
                            key: "addEditor",
                            value: function addEditor(editor) {
                                (0, $057QZ._)(this, _allEditors).set(editor.id, editor);
                            }
                        },
                        {
                            key: "removeEditor",
                            value: function removeEditor(editor) {
                                var _$_class_private_field_get;
                                (0, $057QZ._)(this, _allEditors).delete(editor.id);
                                this.unselect(editor);
                                if (!editor.annotationElementId || !(0, $057QZ._)(this, _deletedAnnotationsElementIds).has(editor.annotationElementId)) (_$_class_private_field_get = (0, $057QZ._)(this, _annotationStorage)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.remove(editor.id);
                            }
                        },
                        {
                            key: "addDeletedAnnotationElement",
                            value: function addDeletedAnnotationElement(editor) {
                                (0, $057QZ._)(this, _deletedAnnotationsElementIds).add(editor.annotationElementId);
                                editor.deleted = true;
                            }
                        },
                        {
                            key: "isDeletedAnnotationElement",
                            value: function isDeletedAnnotationElement(annotationElementId) {
                                return (0, $057QZ._)(this, _deletedAnnotationsElementIds).has(annotationElementId);
                            }
                        },
                        {
                            key: "removeDeletedAnnotationElement",
                            value: function removeDeletedAnnotationElement(editor) {
                                (0, $057QZ._)(this, _deletedAnnotationsElementIds).delete(editor.annotationElementId);
                                editor.deleted = false;
                            }
                        },
                        {
                            key: "setActiveEditor",
                            value: function setActiveEditor(editor) {
                                if ((0, $057QZ._)(this, _activeEditor) === editor) return;
                                (0, $4LHB0._)(this, _activeEditor, editor);
                                if (editor) (0, $lNbhr._)(this, _dispatchUpdateUI, dispatchUpdateUI).call(this, editor.propertiesToUpdate);
                            }
                        },
                        {
                            key: "toggleSelected",
                            value: function toggleSelected(editor) {
                                if ((0, $057QZ._)(this, _selectedEditors).has(editor)) {
                                    (0, $057QZ._)(this, _selectedEditors).delete(editor);
                                    editor.unselect();
                                    (0, $lNbhr._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                                        hasSelectedEditor: this.hasSelection
                                    });
                                    return;
                                }
                                (0, $057QZ._)(this, _selectedEditors).add(editor);
                                editor.select();
                                (0, $lNbhr._)(this, _dispatchUpdateUI, dispatchUpdateUI).call(this, editor.propertiesToUpdate);
                                (0, $lNbhr._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                                    hasSelectedEditor: true
                                });
                            }
                        },
                        {
                            key: "setSelected",
                            value: function setSelected(editor) {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _selectedEditors)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var ed = _step.value;
                                        if (ed !== editor) ed.unselect();
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                (0, $057QZ._)(this, _selectedEditors).clear();
                                (0, $057QZ._)(this, _selectedEditors).add(editor);
                                editor.select();
                                (0, $lNbhr._)(this, _dispatchUpdateUI, dispatchUpdateUI).call(this, editor.propertiesToUpdate);
                                (0, $lNbhr._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                                    hasSelectedEditor: true
                                });
                            }
                        },
                        {
                            key: "isSelected",
                            value: function isSelected(editor) {
                                return (0, $057QZ._)(this, _selectedEditors).has(editor);
                            }
                        },
                        {
                            key: "unselect",
                            value: function unselect(editor) {
                                editor.unselect();
                                (0, $057QZ._)(this, _selectedEditors).delete(editor);
                                (0, $lNbhr._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                                    hasSelectedEditor: this.hasSelection
                                });
                            }
                        },
                        {
                            key: "hasSelection",
                            get: function get() {
                                return (0, $057QZ._)(this, _selectedEditors).size !== 0;
                            }
                        },
                        {
                            key: "undo",
                            value: function undo() {
                                (0, $057QZ._)(this, _commandManager).undo();
                                (0, $lNbhr._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                                    hasSomethingToUndo: (0, $057QZ._)(this, _commandManager).hasSomethingToUndo(),
                                    hasSomethingToRedo: true,
                                    isEmpty: (0, $lNbhr._)(this, _isEmpty, isEmpty).call(this)
                                });
                            }
                        },
                        {
                            key: "redo",
                            value: function redo() {
                                (0, $057QZ._)(this, _commandManager).redo();
                                (0, $lNbhr._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                                    hasSomethingToUndo: true,
                                    hasSomethingToRedo: (0, $057QZ._)(this, _commandManager).hasSomethingToRedo(),
                                    isEmpty: (0, $lNbhr._)(this, _isEmpty, isEmpty).call(this)
                                });
                            }
                        },
                        {
                            key: "addCommands",
                            value: function addCommands(params) {
                                (0, $057QZ._)(this, _commandManager).add(params);
                                (0, $lNbhr._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                                    hasSomethingToUndo: true,
                                    hasSomethingToRedo: false,
                                    isEmpty: (0, $lNbhr._)(this, _isEmpty, isEmpty).call(this)
                                });
                            }
                        },
                        {
                            key: "delete",
                            value: function _delete() {
                                var _this = this;
                                this.commitOrRemove();
                                if (!this.hasSelection) return;
                                var editors = (0, $fyztb._)((0, $057QZ._)(this, _selectedEditors));
                                var cmd = function() {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = editors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var editor = _step.value;
                                            editor.remove();
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                };
                                var undo = function() {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = editors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var editor = _step.value;
                                            (0, $lNbhr._)(_this, _addEditorToLayer, addEditorToLayer).call(_this, editor);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                };
                                this.addCommands({
                                    cmd: cmd,
                                    undo: undo,
                                    mustExec: true
                                });
                            }
                        },
                        {
                            key: "commitOrRemove",
                            value: function commitOrRemove() {
                                var _$_class_private_field_get;
                                (_$_class_private_field_get = (0, $057QZ._)(this, _activeEditor)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.commitOrRemove();
                            }
                        },
                        {
                            key: "hasSomethingToControl",
                            value: function hasSomethingToControl() {
                                return (0, $057QZ._)(this, _activeEditor) || this.hasSelection;
                            }
                        },
                        {
                            key: "selectAll",
                            value: function selectAll() {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _selectedEditors)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editor = _step.value;
                                        editor.commit();
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                (0, $lNbhr._)(this, _selectEditors, selectEditors).call(this, (0, $057QZ._)(this, _allEditors).values());
                            }
                        },
                        {
                            key: "unselectAll",
                            value: function unselectAll() {
                                if ((0, $057QZ._)(this, _activeEditor)) {
                                    (0, $057QZ._)(this, _activeEditor).commitOrRemove();
                                    return;
                                }
                                if (!this.hasSelection) return;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _selectedEditors)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editor = _step.value;
                                        editor.unselect();
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                (0, $057QZ._)(this, _selectedEditors).clear();
                                (0, $lNbhr._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                                    hasSelectedEditor: false
                                });
                            }
                        },
                        {
                            key: "translateSelectedEditors",
                            value: function translateSelectedEditors(x, y) {
                                var noCommit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                                var _this = this;
                                if (!noCommit) this.commitOrRemove();
                                if (!this.hasSelection) return;
                                (0, $057QZ._)(this, _translation)[0] += x;
                                (0, $057QZ._)(this, _translation)[1] += y;
                                var _$_class_private_field_get = (0, $52tJv._)((0, $057QZ._)(this, _translation), 2), totalX = _$_class_private_field_get[0], totalY = _$_class_private_field_get[1];
                                var editors = (0, $fyztb._)((0, $057QZ._)(this, _selectedEditors));
                                var TIME_TO_WAIT = 1000;
                                if ((0, $057QZ._)(this, _translationTimeoutId)) clearTimeout((0, $057QZ._)(this, _translationTimeoutId));
                                (0, $4LHB0._)(this, _translationTimeoutId, setTimeout(function() {
                                    (0, $4LHB0._)(_this, _translationTimeoutId, null);
                                    (0, $057QZ._)(_this, _translation)[0] = (0, $057QZ._)(_this, _translation)[1] = 0;
                                    _this.addCommands({
                                        cmd: function() {
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = editors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var editor = _step.value;
                                                    if ((0, $057QZ._)(_this, _allEditors).has(editor.id)) editor.translateInPage(totalX, totalY);
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        },
                                        undo: function() {
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = editors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var editor = _step.value;
                                                    if ((0, $057QZ._)(_this, _allEditors).has(editor.id)) editor.translateInPage(-totalX, -totalY);
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        },
                                        mustExec: false
                                    });
                                }, TIME_TO_WAIT));
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = editors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editor = _step.value;
                                        editor.translateInPage(x, y);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "setUpDragSession",
                            value: function setUpDragSession() {
                                if (!this.hasSelection) return;
                                this.disableUserSelect(true);
                                (0, $4LHB0._)(this, _draggingEditors, new Map());
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _selectedEditors)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editor = _step.value;
                                        (0, $057QZ._)(this, _draggingEditors).set(editor, {
                                            savedX: editor.x,
                                            savedY: editor.y,
                                            savedPageIndex: editor.pageIndex,
                                            newX: 0,
                                            newY: 0,
                                            newPageIndex: -1
                                        });
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "endDragSession",
                            value: function endDragSession() {
                                var _this = this;
                                if (!(0, $057QZ._)(this, _draggingEditors)) return false;
                                this.disableUserSelect(false);
                                var map = (0, $057QZ._)(this, _draggingEditors);
                                (0, $4LHB0._)(this, _draggingEditors, null);
                                var mustBeAddedInUndoStack = false;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = map[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _step_value = (0, $52tJv._)(_step.value, 2), _step_value_ = _step_value[0], x = _step_value_.x, y = _step_value_.y, pageIndex = _step_value_.pageIndex, value = _step_value[1];
                                        value.newX = x;
                                        value.newY = y;
                                        value.newPageIndex = pageIndex;
                                        mustBeAddedInUndoStack || (mustBeAddedInUndoStack = x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (!mustBeAddedInUndoStack) return false;
                                var move = function(editor, x, y, pageIndex) {
                                    if ((0, $057QZ._)(_this, _allEditors).has(editor.id)) {
                                        var parent = (0, $057QZ._)(_this, _allLayers).get(pageIndex);
                                        if (parent) editor._setParentAndPosition(parent, x, y);
                                        else {
                                            editor.pageIndex = pageIndex;
                                            editor.x = x;
                                            editor.y = y;
                                        }
                                    }
                                };
                                this.addCommands({
                                    cmd: function() {
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = map[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var _step_value = (0, $52tJv._)(_step.value, 2), editor = _step_value[0], _step_value_ = _step_value[1], newX = _step_value_.newX, newY = _step_value_.newY, newPageIndex = _step_value_.newPageIndex;
                                                move(editor, newX, newY, newPageIndex);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    },
                                    undo: function() {
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = map[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var _step_value = (0, $52tJv._)(_step.value, 2), editor = _step_value[0], _step_value_ = _step_value[1], savedX = _step_value_.savedX, savedY = _step_value_.savedY, savedPageIndex = _step_value_.savedPageIndex;
                                                move(editor, savedX, savedY, savedPageIndex);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    },
                                    mustExec: true
                                });
                                return true;
                            }
                        },
                        {
                            key: "dragSelectedEditors",
                            value: function dragSelectedEditors(tx, ty) {
                                if (!(0, $057QZ._)(this, _draggingEditors)) return;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _draggingEditors).keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editor = _step.value;
                                        editor.drag(tx, ty);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "rebuild",
                            value: function rebuild(editor) {
                                if (editor.parent === null) {
                                    var parent = this.getLayer(editor.pageIndex);
                                    if (parent) {
                                        parent.changeParent(editor);
                                        parent.addOrRebuild(editor);
                                    } else {
                                        this.addEditor(editor);
                                        this.addToAnnotationStorage(editor);
                                        editor.rebuild();
                                    }
                                } else editor.parent.addOrRebuild(editor);
                            }
                        },
                        {
                            key: "isActive",
                            value: function isActive(editor) {
                                return (0, $057QZ._)(this, _activeEditor) === editor;
                            }
                        },
                        {
                            key: "getActive",
                            value: function getActive() {
                                return (0, $057QZ._)(this, _activeEditor);
                            }
                        },
                        {
                            key: "getMode",
                            value: function getMode() {
                                return (0, $057QZ._)(this, _mode);
                            }
                        },
                        {
                            key: "imageManager",
                            get: function get() {
                                return (0, _util.shadow)(this, "imageManager", new ImageManager());
                            }
                        }
                    ], [
                        {
                            key: "_keyboardManager",
                            get: function get() {
                                var proto = AnnotationEditorUIManager.prototype;
                                var arrowChecker = function(self) {
                                    var activeElement = document.activeElement;
                                    return activeElement && (0, $057QZ._)(self, _container).contains(activeElement) && self.hasSomethingToControl();
                                };
                                var small = this.TRANSLATE_SMALL;
                                var big = this.TRANSLATE_BIG;
                                return (0, _util.shadow)(this, "_keyboardManager", new KeyboardManager([
                                    [
                                        [
                                            "ctrl+a",
                                            "mac+meta+a"
                                        ],
                                        proto.selectAll
                                    ],
                                    [
                                        [
                                            "ctrl+z",
                                            "mac+meta+z"
                                        ],
                                        proto.undo
                                    ],
                                    [
                                        [
                                            "ctrl+y",
                                            "ctrl+shift+z",
                                            "mac+meta+shift+z",
                                            "ctrl+shift+Z",
                                            "mac+meta+shift+Z"
                                        ],
                                        proto.redo
                                    ],
                                    [
                                        [
                                            "Backspace",
                                            "alt+Backspace",
                                            "ctrl+Backspace",
                                            "shift+Backspace",
                                            "mac+Backspace",
                                            "mac+alt+Backspace",
                                            "mac+ctrl+Backspace",
                                            "Delete",
                                            "ctrl+Delete",
                                            "shift+Delete",
                                            "mac+Delete"
                                        ],
                                        proto.delete
                                    ],
                                    [
                                        [
                                            "Escape",
                                            "mac+Escape"
                                        ],
                                        proto.unselectAll
                                    ],
                                    [
                                        [
                                            "ArrowLeft",
                                            "mac+ArrowLeft"
                                        ],
                                        proto.translateSelectedEditors,
                                        {
                                            args: [
                                                -small,
                                                0
                                            ],
                                            checker: arrowChecker
                                        }
                                    ],
                                    [
                                        [
                                            "ctrl+ArrowLeft",
                                            "mac+shift+ArrowLeft"
                                        ],
                                        proto.translateSelectedEditors,
                                        {
                                            args: [
                                                -big,
                                                0
                                            ],
                                            checker: arrowChecker
                                        }
                                    ],
                                    [
                                        [
                                            "ArrowRight",
                                            "mac+ArrowRight"
                                        ],
                                        proto.translateSelectedEditors,
                                        {
                                            args: [
                                                small,
                                                0
                                            ],
                                            checker: arrowChecker
                                        }
                                    ],
                                    [
                                        [
                                            "ctrl+ArrowRight",
                                            "mac+shift+ArrowRight"
                                        ],
                                        proto.translateSelectedEditors,
                                        {
                                            args: [
                                                big,
                                                0
                                            ],
                                            checker: arrowChecker
                                        }
                                    ],
                                    [
                                        [
                                            "ArrowUp",
                                            "mac+ArrowUp"
                                        ],
                                        proto.translateSelectedEditors,
                                        {
                                            args: [
                                                0,
                                                -small
                                            ],
                                            checker: arrowChecker
                                        }
                                    ],
                                    [
                                        [
                                            "ctrl+ArrowUp",
                                            "mac+shift+ArrowUp"
                                        ],
                                        proto.translateSelectedEditors,
                                        {
                                            args: [
                                                0,
                                                -big
                                            ],
                                            checker: arrowChecker
                                        }
                                    ],
                                    [
                                        [
                                            "ArrowDown",
                                            "mac+ArrowDown"
                                        ],
                                        proto.translateSelectedEditors,
                                        {
                                            args: [
                                                0,
                                                small
                                            ],
                                            checker: arrowChecker
                                        }
                                    ],
                                    [
                                        [
                                            "ctrl+ArrowDown",
                                            "mac+shift+ArrowDown"
                                        ],
                                        proto.translateSelectedEditors,
                                        {
                                            args: [
                                                0,
                                                big
                                            ],
                                            checker: arrowChecker
                                        }
                                    ]
                                ]));
                            }
                        }
                    ]);
                    return AnnotationEditorUIManager;
                }();
                (0, $iCQyW._)(AnnotationEditorUIManager, "TRANSLATE_SMALL", 1);
                (0, $iCQyW._)(AnnotationEditorUIManager, "TRANSLATE_BIG", 10);
                function addFocusManager() {
                    window.addEventListener("focus", (0, $057QZ._)(this, _boundFocus));
                    window.addEventListener("blur", (0, $057QZ._)(this, _boundBlur));
                }
                function removeFocusManager() {
                    window.removeEventListener("focus", (0, $057QZ._)(this, _boundFocus));
                    window.removeEventListener("blur", (0, $057QZ._)(this, _boundBlur));
                }
                function addKeyboardManager() {
                    window.addEventListener("keydown", (0, $057QZ._)(this, _boundKeydown), {
                        capture: true
                    });
                }
                function removeKeyboardManager() {
                    window.removeEventListener("keydown", (0, $057QZ._)(this, _boundKeydown), {
                        capture: true
                    });
                }
                function addCopyPasteListeners() {
                    document.addEventListener("copy", (0, $057QZ._)(this, _boundCopy));
                    document.addEventListener("cut", (0, $057QZ._)(this, _boundCut));
                    document.addEventListener("paste", (0, $057QZ._)(this, _boundPaste));
                }
                function removeCopyPasteListeners() {
                    document.removeEventListener("copy", (0, $057QZ._)(this, _boundCopy));
                    document.removeEventListener("cut", (0, $057QZ._)(this, _boundCut));
                    document.removeEventListener("paste", (0, $057QZ._)(this, _boundPaste));
                }
                function dispatchUpdateStates(details) {
                    var _this = this;
                    var hasChanged = Object.entries(details).some(function(param) {
                        var _param = (0, $52tJv._)(param, 2), key = _param[0], value = _param[1];
                        return (0, $057QZ._)(_this, _previousStates)[key] !== value;
                    });
                    if (hasChanged) this._eventBus.dispatch("annotationeditorstateschanged", {
                        source: this,
                        details: Object.assign((0, $057QZ._)(this, _previousStates), details)
                    });
                }
                function dispatchUpdateUI(details) {
                    this._eventBus.dispatch("annotationeditorparamschanged", {
                        source: this,
                        details: details
                    });
                }
                function enableAll() {
                    if (!(0, $057QZ._)(this, _isEnabled)) {
                        (0, $4LHB0._)(this, _isEnabled, true);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = (0, $057QZ._)(this, _allLayers).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var layer = _step.value;
                                layer.enable();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                }
                function disableAll() {
                    this.unselectAll();
                    if ((0, $057QZ._)(this, _isEnabled)) {
                        (0, $4LHB0._)(this, _isEnabled, false);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = (0, $057QZ._)(this, _allLayers).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var layer = _step.value;
                                layer.disable();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                }
                function addEditorToLayer(editor) {
                    var layer = (0, $057QZ._)(this, _allLayers).get(editor.pageIndex);
                    if (layer) layer.addOrRebuild(editor);
                    else this.addEditor(editor);
                }
                function isEmpty() {
                    if ((0, $057QZ._)(this, _allEditors).size === 0) return true;
                    if ((0, $057QZ._)(this, _allEditors).size === 1) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = (0, $057QZ._)(this, _allEditors).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var editor = _step.value;
                                return editor.isEmpty();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    return false;
                }
                function selectEditors(editors) {
                    (0, $057QZ._)(this, _selectedEditors).clear();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = editors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var editor = _step.value;
                            if (editor.isEmpty()) continue;
                            (0, $057QZ._)(this, _selectedEditors).add(editor);
                            editor.select();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    (0, $lNbhr._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                        hasSelectedEditor: true
                    });
                }
                exports.AnnotationEditorUIManager = AnnotationEditorUIManager;
            /***/ },
            /* 6 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StatTimer = exports.RenderingCancelledException = exports.PixelsPerInch = exports.PageViewport = exports.PDFDateString = exports.DOMStandardFontDataFactory = exports.DOMSVGFactory = exports.DOMFilterFactory = exports.DOMCanvasFactory = exports.DOMCMapReaderFactory = void 0;
                exports.deprecated = deprecated;
                exports.getColorValues = getColorValues;
                exports.getCurrentTransform = getCurrentTransform;
                exports.getCurrentTransformInverse = getCurrentTransformInverse;
                exports.getFilenameFromUrl = getFilenameFromUrl;
                exports.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
                exports.getRGB = getRGB1;
                exports.getXfaPageViewport = getXfaPageViewport;
                exports.isDataScheme = isDataScheme;
                exports.isPdfFile = isPdfFile;
                exports.isValidFetchUrl = isValidFetchUrl;
                exports.loadScript = loadScript;
                exports.noContextMenu = noContextMenu;
                exports.setLayerDimensions = setLayerDimensions;
                var _base_factory = __w_pdfjs_require__(7);
                var _util = __w_pdfjs_require__(1);
                var SVG_NS = "http://www.w3.org/2000/svg";
                var PixelsPerInch = function PixelsPerInch() {
                    (0, $5sFFs._)(this, PixelsPerInch);
                };
                (0, $iCQyW._)(PixelsPerInch, "CSS", 96.0);
                (0, $iCQyW._)(PixelsPerInch, "PDF", 72.0);
                (0, $iCQyW._)(PixelsPerInch, "PDF_TO_CSS_UNITS", PixelsPerInch.CSS / PixelsPerInch.PDF);
                exports.PixelsPerInch = PixelsPerInch;
                var __cache = /*#__PURE__*/ new WeakMap(), __defs = /*#__PURE__*/ new WeakMap(), _docId = /*#__PURE__*/ new WeakMap(), _document = /*#__PURE__*/ new WeakMap(), _hcmFilter = /*#__PURE__*/ new WeakMap(), _hcmKey = /*#__PURE__*/ new WeakMap(), _hcmUrl = /*#__PURE__*/ new WeakMap(), _hcmHighlightFilter = /*#__PURE__*/ new WeakMap(), _hcmHighlightKey = /*#__PURE__*/ new WeakMap(), _hcmHighlightUrl = /*#__PURE__*/ new WeakMap(), _id = /*#__PURE__*/ new WeakMap(), _cache = /*#__PURE__*/ new WeakMap(), _defs = /*#__PURE__*/ new WeakMap(), _addGrayConversion = /*#__PURE__*/ new WeakSet(), _createFilter = /*#__PURE__*/ new WeakSet(), _appendFeFunc = /*#__PURE__*/ new WeakSet(), _addTransferMapConversion = /*#__PURE__*/ new WeakSet(), _getRGB = /*#__PURE__*/ new WeakSet();
                var DOMFilterFactory = /*#__PURE__*/ function(_base_factory_BaseFilterFactory) {
                    (0, $kcqLc._)(DOMFilterFactory, _base_factory_BaseFilterFactory);
                    var _super = (0, $4jYWU._)(DOMFilterFactory);
                    function DOMFilterFactory() {
                        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, docId = _ref.docId, _ref_ownerDocument = _ref.ownerDocument, ownerDocument = _ref_ownerDocument === void 0 ? globalThis.document : _ref_ownerDocument;
                        (0, $5sFFs._)(this, DOMFilterFactory);
                        var _this;
                        _this = _super.call(this);
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _cache, {
                            get: get_cache,
                            set: void 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _defs, {
                            get: get_defs,
                            set: void 0
                        });
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _addGrayConversion);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _createFilter);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _appendFeFunc);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _addTransferMapConversion);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _getRGB);
                        (0, $g12Hy._)((0, $lyFcw._)(_this), __cache, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), __defs, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _docId, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _document, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _hcmFilter, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _hcmKey, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _hcmUrl, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _hcmHighlightFilter, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _hcmHighlightKey, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _hcmHighlightUrl, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _id, {
                            writable: true,
                            value: 0
                        });
                        (0, $4LHB0._)((0, $lyFcw._)(_this), _docId, docId);
                        (0, $4LHB0._)((0, $lyFcw._)(_this), _document, ownerDocument);
                        return _this;
                    }
                    (0, $8O2fV._)(DOMFilterFactory, [
                        {
                            key: "addFilter",
                            value: function addFilter(maps) {
                                if (!maps) return "none";
                                var value = (0, $057QZ._)(this, _cache).get(maps);
                                if (value) return value;
                                var tableR, tableG, tableB, key;
                                if (maps.length === 1) {
                                    var mapR = maps[0];
                                    var buffer = new Array(256);
                                    for(var i = 0; i < 256; i++)buffer[i] = mapR[i] / 255;
                                    key = tableR = tableG = tableB = buffer.join(",");
                                } else {
                                    var _maps = (0, $52tJv._)(maps, 3), mapR1 = _maps[0], mapG = _maps[1], mapB = _maps[2];
                                    var bufferR = new Array(256);
                                    var bufferG = new Array(256);
                                    var bufferB = new Array(256);
                                    for(var i1 = 0; i1 < 256; i1++){
                                        bufferR[i1] = mapR1[i1] / 255;
                                        bufferG[i1] = mapG[i1] / 255;
                                        bufferB[i1] = mapB[i1] / 255;
                                    }
                                    tableR = bufferR.join(",");
                                    tableG = bufferG.join(",");
                                    tableB = bufferB.join(",");
                                    key = "".concat(tableR).concat(tableG).concat(tableB);
                                }
                                value = (0, $057QZ._)(this, _cache).get(key);
                                if (value) {
                                    (0, $057QZ._)(this, _cache).set(maps, value);
                                    return value;
                                }
                                var id = "g_".concat((0, $057QZ._)(this, _docId), "_transfer_map_").concat((0, $l0C3h._)(this, _id).value++);
                                var url = "url(#".concat(id, ")");
                                (0, $057QZ._)(this, _cache).set(maps, url);
                                (0, $057QZ._)(this, _cache).set(key, url);
                                var filter = (0, $lNbhr._)(this, _createFilter, createFilter).call(this, id);
                                (0, $lNbhr._)(this, _addTransferMapConversion, addTransferMapConversion).call(this, tableR, tableG, tableB, filter);
                                return url;
                            }
                        },
                        {
                            key: "addHCMFilter",
                            value: function addHCMFilter(fgColor, bgColor) {
                                var _util_Util, _util_Util1;
                                var _$_class_private_field_get;
                                var key = "".concat(fgColor, "-").concat(bgColor);
                                if ((0, $057QZ._)(this, _hcmKey) === key) return (0, $057QZ._)(this, _hcmUrl);
                                (0, $4LHB0._)(this, _hcmKey, key);
                                (0, $4LHB0._)(this, _hcmUrl, "none");
                                (_$_class_private_field_get = (0, $057QZ._)(this, _hcmFilter)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.remove();
                                if (!fgColor || !bgColor) return (0, $057QZ._)(this, _hcmUrl);
                                var fgRGB = (0, $lNbhr._)(this, _getRGB, getRGB).call(this, fgColor);
                                fgColor = (_util_Util = _util.Util).makeHexColor.apply(_util_Util, (0, $fyztb._)(fgRGB));
                                var bgRGB = (0, $lNbhr._)(this, _getRGB, getRGB).call(this, bgColor);
                                bgColor = (_util_Util1 = _util.Util).makeHexColor.apply(_util_Util1, (0, $fyztb._)(bgRGB));
                                (0, $057QZ._)(this, _defs).style.color = "";
                                if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) return (0, $057QZ._)(this, _hcmUrl);
                                var map = new Array(256);
                                for(var i = 0; i <= 255; i++){
                                    var x = i / 255;
                                    map[i] = x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
                                }
                                var table = map.join(",");
                                var id = "g_".concat((0, $057QZ._)(this, _docId), "_hcm_filter");
                                var filter = (0, $4LHB0._)(this, _hcmHighlightFilter, (0, $lNbhr._)(this, _createFilter, createFilter).call(this, id));
                                (0, $lNbhr._)(this, _addTransferMapConversion, addTransferMapConversion).call(this, table, table, table, filter);
                                (0, $lNbhr._)(this, _addGrayConversion, addGrayConversion).call(this, filter);
                                var getSteps = function(c, n) {
                                    var start = fgRGB[c] / 255;
                                    var end = bgRGB[c] / 255;
                                    var arr = new Array(n + 1);
                                    for(var i = 0; i <= n; i++)arr[i] = start + i / n * (end - start);
                                    return arr.join(",");
                                };
                                (0, $lNbhr._)(this, _addTransferMapConversion, addTransferMapConversion).call(this, getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
                                (0, $4LHB0._)(this, _hcmUrl, "url(#".concat(id, ")"));
                                return (0, $057QZ._)(this, _hcmUrl);
                            }
                        },
                        {
                            key: "addHighlightHCMFilter",
                            value: function addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                                var _$_class_private_field_get;
                                var key = "".concat(fgColor, "-").concat(bgColor, "-").concat(newFgColor, "-").concat(newBgColor);
                                if ((0, $057QZ._)(this, _hcmHighlightKey) === key) return (0, $057QZ._)(this, _hcmHighlightUrl);
                                (0, $4LHB0._)(this, _hcmHighlightKey, key);
                                (0, $4LHB0._)(this, _hcmHighlightUrl, "none");
                                (_$_class_private_field_get = (0, $057QZ._)(this, _hcmHighlightFilter)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.remove();
                                if (!fgColor || !bgColor) return (0, $057QZ._)(this, _hcmHighlightUrl);
                                var _map = (0, $52tJv._)([
                                    fgColor,
                                    bgColor
                                ].map((0, $lNbhr._)(this, _getRGB, getRGB).bind(this)), 2), fgRGB = _map[0], bgRGB = _map[1];
                                var fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
                                var bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
                                var _map1 = (0, $52tJv._)([
                                    newFgColor,
                                    newBgColor
                                ].map((0, $lNbhr._)(this, _getRGB, getRGB).bind(this)), 2), newFgRGB = _map1[0], newBgRGB = _map1[1];
                                var ref;
                                if (bgGray < fgGray) ref = [
                                    bgGray,
                                    fgGray,
                                    newBgRGB,
                                    newFgRGB
                                ], fgGray = ref[0], bgGray = ref[1], newFgRGB = ref[2], newBgRGB = ref[3], ref;
                                (0, $057QZ._)(this, _defs).style.color = "";
                                var getSteps = function(fg, bg, n) {
                                    var arr = new Array(256);
                                    var step = (bgGray - fgGray) / n;
                                    var newStart = fg / 255;
                                    var newStep = (bg - fg) / (255 * n);
                                    var prev = 0;
                                    for(var i = 0; i <= n; i++){
                                        var k = Math.round(fgGray + i * step);
                                        var value = newStart + i * newStep;
                                        for(var j = prev; j <= k; j++)arr[j] = value;
                                        prev = k + 1;
                                    }
                                    for(var i1 = prev; i1 < 256; i1++)arr[i1] = arr[prev - 1];
                                    return arr.join(",");
                                };
                                var id = "g_".concat((0, $057QZ._)(this, _docId), "_hcm_highlight_filter");
                                var filter = (0, $4LHB0._)(this, _hcmHighlightFilter, (0, $lNbhr._)(this, _createFilter, createFilter).call(this, id));
                                (0, $lNbhr._)(this, _addGrayConversion, addGrayConversion).call(this, filter);
                                (0, $lNbhr._)(this, _addTransferMapConversion, addTransferMapConversion).call(this, getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
                                (0, $4LHB0._)(this, _hcmHighlightUrl, "url(#".concat(id, ")"));
                                return (0, $057QZ._)(this, _hcmHighlightUrl);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                var keepHCM = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                                if (keepHCM && ((0, $057QZ._)(this, _hcmUrl) || (0, $057QZ._)(this, _hcmHighlightUrl))) return;
                                if ((0, $057QZ._)(this, __defs)) {
                                    (0, $057QZ._)(this, __defs).parentNode.parentNode.remove();
                                    (0, $4LHB0._)(this, __defs, null);
                                }
                                if ((0, $057QZ._)(this, __cache)) {
                                    (0, $057QZ._)(this, __cache).clear();
                                    (0, $4LHB0._)(this, __cache, null);
                                }
                                (0, $4LHB0._)(this, _id, 0);
                            }
                        }
                    ]);
                    return DOMFilterFactory;
                }(_base_factory.BaseFilterFactory);
                function get_cache() {
                    return (0, $4LHB0._)(this, __cache, (0, $057QZ._)(this, __cache) || new Map());
                }
                function get_defs() {
                    if (!(0, $057QZ._)(this, __defs)) {
                        var div = (0, $057QZ._)(this, _document).createElement("div");
                        var style = div.style;
                        style.visibility = "hidden";
                        style.contain = "strict";
                        style.width = style.height = 0;
                        style.position = "absolute";
                        style.top = style.left = 0;
                        style.zIndex = -1;
                        var svg = (0, $057QZ._)(this, _document).createElementNS(SVG_NS, "svg");
                        svg.setAttribute("width", 0);
                        svg.setAttribute("height", 0);
                        (0, $4LHB0._)(this, __defs, (0, $057QZ._)(this, _document).createElementNS(SVG_NS, "defs"));
                        div.append(svg);
                        svg.append((0, $057QZ._)(this, __defs));
                        (0, $057QZ._)(this, _document).body.append(div);
                    }
                    return (0, $057QZ._)(this, __defs);
                }
                function addGrayConversion(filter) {
                    var feColorMatrix = (0, $057QZ._)(this, _document).createElementNS(SVG_NS, "feColorMatrix");
                    feColorMatrix.setAttribute("type", "matrix");
                    feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
                    filter.append(feColorMatrix);
                }
                function createFilter(id) {
                    var filter = (0, $057QZ._)(this, _document).createElementNS(SVG_NS, "filter");
                    filter.setAttribute("color-interpolation-filters", "sRGB");
                    filter.setAttribute("id", id);
                    (0, $057QZ._)(this, _defs).append(filter);
                    return filter;
                }
                function appendFeFunc(feComponentTransfer, func, table) {
                    var feFunc = (0, $057QZ._)(this, _document).createElementNS(SVG_NS, func);
                    feFunc.setAttribute("type", "discrete");
                    feFunc.setAttribute("tableValues", table);
                    feComponentTransfer.append(feFunc);
                }
                function addTransferMapConversion(rTable, gTable, bTable, filter) {
                    var feComponentTransfer = (0, $057QZ._)(this, _document).createElementNS(SVG_NS, "feComponentTransfer");
                    filter.append(feComponentTransfer);
                    (0, $lNbhr._)(this, _appendFeFunc, appendFeFunc).call(this, feComponentTransfer, "feFuncR", rTable);
                    (0, $lNbhr._)(this, _appendFeFunc, appendFeFunc).call(this, feComponentTransfer, "feFuncG", gTable);
                    (0, $lNbhr._)(this, _appendFeFunc, appendFeFunc).call(this, feComponentTransfer, "feFuncB", bTable);
                }
                function getRGB(color) {
                    (0, $057QZ._)(this, _defs).style.color = color;
                    return getRGB1(getComputedStyle((0, $057QZ._)(this, _defs)).getPropertyValue("color"));
                }
                exports.DOMFilterFactory = DOMFilterFactory;
                var DOMCanvasFactory = /*#__PURE__*/ function(_base_factory_BaseCanvasFactory) {
                    (0, $kcqLc._)(DOMCanvasFactory, _base_factory_BaseCanvasFactory);
                    var _super = (0, $4jYWU._)(DOMCanvasFactory);
                    function DOMCanvasFactory() {
                        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_ownerDocument = _ref.ownerDocument, ownerDocument = _ref_ownerDocument === void 0 ? globalThis.document : _ref_ownerDocument;
                        (0, $5sFFs._)(this, DOMCanvasFactory);
                        var _this;
                        _this = _super.call(this);
                        _this._document = ownerDocument;
                        return _this;
                    }
                    (0, $8O2fV._)(DOMCanvasFactory, [
                        {
                            key: "_createCanvas",
                            value: function _createCanvas(width, height) {
                                var canvas = this._document.createElement("canvas");
                                canvas.width = width;
                                canvas.height = height;
                                return canvas;
                            }
                        }
                    ]);
                    return DOMCanvasFactory;
                }(_base_factory.BaseCanvasFactory);
                exports.DOMCanvasFactory = DOMCanvasFactory;
                function fetchData(url) {
                    return _fetchData.apply(this, arguments);
                }
                function _fetchData() {
                    _fetchData = (0, $7hBys._)(function(url) {
                        var asTypedArray, response, _tmp, _, _1;
                        var _arguments = arguments;
                        return (0, $ajhIL.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    asTypedArray = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                                    if (!isValidFetchUrl(url, document.baseURI)) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        fetch(url)
                                    ];
                                case 1:
                                    response = _state.sent();
                                    if (!response.ok) throw new Error(response.statusText);
                                    if (!asTypedArray) return [
                                        3,
                                        3
                                    ];
                                    _ = Uint8Array.bind;
                                    return [
                                        4,
                                        response.arrayBuffer()
                                    ];
                                case 2:
                                    _tmp = new (_.apply(Uint8Array, [
                                        void 0,
                                        _state.sent()
                                    ]));
                                    return [
                                        3,
                                        5
                                    ];
                                case 3:
                                    _1 = (0, _util.stringToBytes);
                                    return [
                                        4,
                                        response.text()
                                    ];
                                case 4:
                                    _tmp = _1.apply(void 0, [
                                        _state.sent()
                                    ]);
                                    _state.label = 5;
                                case 5:
                                    return [
                                        2,
                                        _tmp
                                    ];
                                case 6:
                                    return [
                                        2,
                                        new Promise(function(resolve, reject) {
                                            var request = new XMLHttpRequest();
                                            request.open("GET", url, true);
                                            if (asTypedArray) request.responseType = "arraybuffer";
                                            request.onreadystatechange = function() {
                                                if (request.readyState !== XMLHttpRequest.DONE) return;
                                                if (request.status === 200 || request.status === 0) {
                                                    var data;
                                                    if (asTypedArray && request.response) data = new Uint8Array(request.response);
                                                    else if (!asTypedArray && request.responseText) data = (0, _util.stringToBytes)(request.responseText);
                                                    if (data) {
                                                        resolve(data);
                                                        return;
                                                    }
                                                }
                                                reject(new Error(request.statusText));
                                            };
                                            request.send(null);
                                        })
                                    ];
                            }
                        });
                    });
                    return _fetchData.apply(this, arguments);
                }
                var DOMCMapReaderFactory = /*#__PURE__*/ function(_base_factory_BaseCMapReaderFactory) {
                    (0, $kcqLc._)(DOMCMapReaderFactory, _base_factory_BaseCMapReaderFactory);
                    var _super = (0, $4jYWU._)(DOMCMapReaderFactory);
                    function DOMCMapReaderFactory() {
                        (0, $5sFFs._)(this, DOMCMapReaderFactory);
                        return _super.apply(this, arguments);
                    }
                    (0, $8O2fV._)(DOMCMapReaderFactory, [
                        {
                            key: "_fetchData",
                            value: function _fetchData(url, compressionType) {
                                return fetchData(url, this.isCompressed).then(function(data) {
                                    return {
                                        cMapData: data,
                                        compressionType: compressionType
                                    };
                                });
                            }
                        }
                    ]);
                    return DOMCMapReaderFactory;
                }(_base_factory.BaseCMapReaderFactory);
                exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
                var DOMStandardFontDataFactory = /*#__PURE__*/ function(_base_factory_BaseStandardFontDataFactory) {
                    (0, $kcqLc._)(DOMStandardFontDataFactory, _base_factory_BaseStandardFontDataFactory);
                    var _super = (0, $4jYWU._)(DOMStandardFontDataFactory);
                    function DOMStandardFontDataFactory() {
                        (0, $5sFFs._)(this, DOMStandardFontDataFactory);
                        return _super.apply(this, arguments);
                    }
                    (0, $8O2fV._)(DOMStandardFontDataFactory, [
                        {
                            key: "_fetchData",
                            value: function _fetchData(url) {
                                return fetchData(url, true);
                            }
                        }
                    ]);
                    return DOMStandardFontDataFactory;
                }(_base_factory.BaseStandardFontDataFactory);
                exports.DOMStandardFontDataFactory = DOMStandardFontDataFactory;
                var DOMSVGFactory = /*#__PURE__*/ function(_base_factory_BaseSVGFactory) {
                    (0, $kcqLc._)(DOMSVGFactory, _base_factory_BaseSVGFactory);
                    var _super = (0, $4jYWU._)(DOMSVGFactory);
                    function DOMSVGFactory() {
                        (0, $5sFFs._)(this, DOMSVGFactory);
                        return _super.apply(this, arguments);
                    }
                    (0, $8O2fV._)(DOMSVGFactory, [
                        {
                            key: "_createSVG",
                            value: function _createSVG(type) {
                                return document.createElementNS(SVG_NS, type);
                            }
                        }
                    ]);
                    return DOMSVGFactory;
                }(_base_factory.BaseSVGFactory);
                exports.DOMSVGFactory = DOMSVGFactory;
                var PageViewport = /*#__PURE__*/ function() {
                    function PageViewport(param) {
                        var viewBox = param.viewBox, scale = param.scale, rotation = param.rotation, _param_offsetX = param.offsetX, offsetX = _param_offsetX === void 0 ? 0 : _param_offsetX, _param_offsetY = param.offsetY, offsetY = _param_offsetY === void 0 ? 0 : _param_offsetY, _param_dontFlip = param.dontFlip, dontFlip = _param_dontFlip === void 0 ? false : _param_dontFlip;
                        (0, $5sFFs._)(this, PageViewport);
                        this.viewBox = viewBox;
                        this.scale = scale;
                        this.rotation = rotation;
                        this.offsetX = offsetX;
                        this.offsetY = offsetY;
                        var centerX = (viewBox[2] + viewBox[0]) / 2;
                        var centerY = (viewBox[3] + viewBox[1]) / 2;
                        var rotateA, rotateB, rotateC, rotateD;
                        rotation %= 360;
                        if (rotation < 0) rotation += 360;
                        switch(rotation){
                            case 180:
                                rotateA = -1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = 1;
                                break;
                            case 90:
                                rotateA = 0;
                                rotateB = 1;
                                rotateC = 1;
                                rotateD = 0;
                                break;
                            case 270:
                                rotateA = 0;
                                rotateB = -1;
                                rotateC = -1;
                                rotateD = 0;
                                break;
                            case 0:
                                rotateA = 1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = -1;
                                break;
                            default:
                                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                        }
                        if (dontFlip) {
                            rotateC = -rotateC;
                            rotateD = -rotateD;
                        }
                        var offsetCanvasX, offsetCanvasY;
                        var width, height;
                        if (rotateA === 0) {
                            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
                            width = (viewBox[3] - viewBox[1]) * scale;
                            height = (viewBox[2] - viewBox[0]) * scale;
                        } else {
                            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
                            width = (viewBox[2] - viewBox[0]) * scale;
                            height = (viewBox[3] - viewBox[1]) * scale;
                        }
                        this.transform = [
                            rotateA * scale,
                            rotateB * scale,
                            rotateC * scale,
                            rotateD * scale,
                            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
                            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
                        ];
                        this.width = width;
                        this.height = height;
                    }
                    (0, $8O2fV._)(PageViewport, [
                        {
                            key: "rawDims",
                            get: function get() {
                                var viewBox = this.viewBox;
                                return (0, _util.shadow)(this, "rawDims", {
                                    pageWidth: viewBox[2] - viewBox[0],
                                    pageHeight: viewBox[3] - viewBox[1],
                                    pageX: viewBox[0],
                                    pageY: viewBox[1]
                                });
                            }
                        },
                        {
                            key: "clone",
                            value: function clone() {
                                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_scale = _ref.scale, scale = _ref_scale === void 0 ? this.scale : _ref_scale, _ref_rotation = _ref.rotation, rotation = _ref_rotation === void 0 ? this.rotation : _ref_rotation, _ref_offsetX = _ref.offsetX, offsetX = _ref_offsetX === void 0 ? this.offsetX : _ref_offsetX, _ref_offsetY = _ref.offsetY, offsetY = _ref_offsetY === void 0 ? this.offsetY : _ref_offsetY, _ref_dontFlip = _ref.dontFlip, dontFlip = _ref_dontFlip === void 0 ? false : _ref_dontFlip;
                                return new PageViewport({
                                    viewBox: this.viewBox.slice(),
                                    scale: scale,
                                    rotation: rotation,
                                    offsetX: offsetX,
                                    offsetY: offsetY,
                                    dontFlip: dontFlip
                                });
                            }
                        },
                        {
                            key: "convertToViewportPoint",
                            value: function convertToViewportPoint(x, y) {
                                return _util.Util.applyTransform([
                                    x,
                                    y
                                ], this.transform);
                            }
                        },
                        {
                            key: "convertToViewportRectangle",
                            value: function convertToViewportRectangle(rect) {
                                var topLeft = _util.Util.applyTransform([
                                    rect[0],
                                    rect[1]
                                ], this.transform);
                                var bottomRight = _util.Util.applyTransform([
                                    rect[2],
                                    rect[3]
                                ], this.transform);
                                return [
                                    topLeft[0],
                                    topLeft[1],
                                    bottomRight[0],
                                    bottomRight[1]
                                ];
                            }
                        },
                        {
                            key: "convertToPdfPoint",
                            value: function convertToPdfPoint(x, y) {
                                return _util.Util.applyInverseTransform([
                                    x,
                                    y
                                ], this.transform);
                            }
                        }
                    ]);
                    return PageViewport;
                }();
                exports.PageViewport = PageViewport;
                var RenderingCancelledException = /*#__PURE__*/ function(_util_BaseException) {
                    (0, $kcqLc._)(RenderingCancelledException, _util_BaseException);
                    var _super = (0, $4jYWU._)(RenderingCancelledException);
                    function RenderingCancelledException(msg) {
                        var extraDelay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                        (0, $5sFFs._)(this, RenderingCancelledException);
                        var _this;
                        _this = _super.call(this, msg, "RenderingCancelledException");
                        _this.extraDelay = extraDelay;
                        return _this;
                    }
                    return RenderingCancelledException;
                }(_util.BaseException);
                exports.RenderingCancelledException = RenderingCancelledException;
                function isDataScheme(url) {
                    var ii = url.length;
                    var i = 0;
                    while(i < ii && url[i].trim() === "")i++;
                    return url.substring(i, i + 5).toLowerCase() === "data:";
                }
                function isPdfFile(filename) {
                    return typeof filename === "string" && /\.pdf$/i.test(filename);
                }
                function getFilenameFromUrl(url) {
                    var onlyStripPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    var ref;
                    if (!onlyStripPath) ref = (0, $52tJv._)(url.split(/[#?]/, 1), 1), url = ref[0], ref;
                    return url.substring(url.lastIndexOf("/") + 1);
                }
                function getPdfFilenameFromUrl(url) {
                    var defaultFilename = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "document.pdf";
                    if (typeof url !== "string") return defaultFilename;
                    if (isDataScheme(url)) {
                        (0, _util.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
                        return defaultFilename;
                    }
                    var reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
                    var reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
                    var splitURI = reURI.exec(url);
                    var suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
                    if (suggestedFilename) {
                        suggestedFilename = suggestedFilename[0];
                        if (suggestedFilename.includes("%")) try {
                            suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
                        } catch (e) {}
                    }
                    return suggestedFilename || defaultFilename;
                }
                var StatTimer = /*#__PURE__*/ function() {
                    function StatTimer() {
                        (0, $5sFFs._)(this, StatTimer);
                        (0, $iCQyW._)(this, "started", Object.create(null));
                        (0, $iCQyW._)(this, "times", []);
                    }
                    (0, $8O2fV._)(StatTimer, [
                        {
                            key: "time",
                            value: function time(name) {
                                if (name in this.started) (0, _util.warn)("Timer is already running for ".concat(name));
                                this.started[name] = Date.now();
                            }
                        },
                        {
                            key: "timeEnd",
                            value: function timeEnd(name) {
                                if (!(name in this.started)) (0, _util.warn)("Timer has not been started for ".concat(name));
                                this.times.push({
                                    name: name,
                                    start: this.started[name],
                                    end: Date.now()
                                });
                                delete this.started[name];
                            }
                        },
                        {
                            key: "toString",
                            value: function toString() {
                                var outBuf = [];
                                var longest = 0;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this.times[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var name = _step.value.name;
                                        longest = Math.max(name.length, longest);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = this.times[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var _step_value = _step1.value, name1 = _step_value.name, start = _step_value.start, end = _step_value.end;
                                        outBuf.push("".concat(name1.padEnd(longest), " ").concat(end - start, "ms\n"));
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                return outBuf.join("");
                            }
                        }
                    ]);
                    return StatTimer;
                }();
                exports.StatTimer = StatTimer;
                function isValidFetchUrl(url, baseUrl) {
                    try {
                        var protocol = (baseUrl ? new URL(url, baseUrl) : new URL(url)).protocol;
                        return protocol === "http:" || protocol === "https:";
                    } catch (e) {
                        return false;
                    }
                }
                function noContextMenu(e) {
                    e.preventDefault();
                }
                function loadScript(src) {
                    var removeScriptElement = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    return new Promise(function(resolve, reject) {
                        var script = document.createElement("script");
                        script.src = src;
                        script.onload = function(evt) {
                            if (removeScriptElement) script.remove();
                            resolve(evt);
                        };
                        script.onerror = function() {
                            reject(new Error("Cannot load script at: ".concat(script.src)));
                        };
                        (document.head || document.documentElement).append(script);
                    });
                }
                function deprecated(details) {
                    console.log("Deprecated API usage: " + details);
                }
                var pdfDateStringRegex;
                var PDFDateString = /*#__PURE__*/ function() {
                    function PDFDateString() {
                        (0, $5sFFs._)(this, PDFDateString);
                    }
                    (0, $8O2fV._)(PDFDateString, null, [
                        {
                            key: "toDateObject",
                            value: function toDateObject(input) {
                                if (!input || typeof input !== "string") return null;
                                pdfDateStringRegex || (pdfDateStringRegex = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"));
                                var matches = pdfDateStringRegex.exec(input);
                                if (!matches) return null;
                                var year = parseInt(matches[1], 10);
                                var month = parseInt(matches[2], 10);
                                month = month >= 1 && month <= 12 ? month - 1 : 0;
                                var day = parseInt(matches[3], 10);
                                day = day >= 1 && day <= 31 ? day : 1;
                                var hour = parseInt(matches[4], 10);
                                hour = hour >= 0 && hour <= 23 ? hour : 0;
                                var minute = parseInt(matches[5], 10);
                                minute = minute >= 0 && minute <= 59 ? minute : 0;
                                var second = parseInt(matches[6], 10);
                                second = second >= 0 && second <= 59 ? second : 0;
                                var universalTimeRelation = matches[7] || "Z";
                                var offsetHour = parseInt(matches[8], 10);
                                offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
                                var offsetMinute = parseInt(matches[9], 10) || 0;
                                offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
                                if (universalTimeRelation === "-") {
                                    hour += offsetHour;
                                    minute += offsetMinute;
                                } else if (universalTimeRelation === "+") {
                                    hour -= offsetHour;
                                    minute -= offsetMinute;
                                }
                                return new Date(Date.UTC(year, month, day, hour, minute, second));
                            }
                        }
                    ]);
                    return PDFDateString;
                }();
                exports.PDFDateString = PDFDateString;
                function getXfaPageViewport(xfaPage, param) {
                    var _param_scale = param.scale, scale = _param_scale === void 0 ? 1 : _param_scale, _param_rotation = param.rotation, rotation = _param_rotation === void 0 ? 0 : _param_rotation;
                    var _xfaPage_attributes_style = xfaPage.attributes.style, width = _xfaPage_attributes_style.width, height = _xfaPage_attributes_style.height;
                    var viewBox = [
                        0,
                        0,
                        parseInt(width),
                        parseInt(height)
                    ];
                    return new PageViewport({
                        viewBox: viewBox,
                        scale: scale,
                        rotation: rotation
                    });
                }
                function getRGB1(color) {
                    if (color.startsWith("#")) {
                        var colorRGB = parseInt(color.slice(1), 16);
                        return [
                            (colorRGB & 0xff0000) >> 16,
                            (colorRGB & 0x00ff00) >> 8,
                            colorRGB & 0x0000ff
                        ];
                    }
                    if (color.startsWith("rgb(")) return color.slice(4, -1).split(",").map(function(x) {
                        return parseInt(x);
                    });
                    if (color.startsWith("rgba(")) return color.slice(5, -1).split(",").map(function(x) {
                        return parseInt(x);
                    }).slice(0, 3);
                    (0, _util.warn)('Not a valid color format: "'.concat(color, '"'));
                    return [
                        0,
                        0,
                        0
                    ];
                }
                function getColorValues(colors) {
                    var span = document.createElement("span");
                    span.style.visibility = "hidden";
                    document.body.append(span);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = colors.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var name = _step.value;
                            span.style.color = name;
                            var computedColor = window.getComputedStyle(span).color;
                            colors.set(name, getRGB1(computedColor));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    span.remove();
                }
                function getCurrentTransform(ctx) {
                    var _ctx_getTransform = ctx.getTransform(), a = _ctx_getTransform.a, b = _ctx_getTransform.b, c = _ctx_getTransform.c, d = _ctx_getTransform.d, e = _ctx_getTransform.e, f = _ctx_getTransform.f;
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
                function getCurrentTransformInverse(ctx) {
                    var _ctx_getTransform_invertSelf = ctx.getTransform().invertSelf(), a = _ctx_getTransform_invertSelf.a, b = _ctx_getTransform_invertSelf.b, c = _ctx_getTransform_invertSelf.c, d = _ctx_getTransform_invertSelf.d, e = _ctx_getTransform_invertSelf.e, f = _ctx_getTransform_invertSelf.f;
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
                function setLayerDimensions(div, viewport) {
                    var mustFlip = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, mustRotate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
                    if (viewport instanceof PageViewport) {
                        var _viewport_rawDims = viewport.rawDims, pageWidth = _viewport_rawDims.pageWidth, pageHeight = _viewport_rawDims.pageHeight;
                        var style = div.style;
                        var useRound = _util.FeatureTest.isCSSRoundSupported;
                        var w = "var(--scale-factor) * ".concat(pageWidth, "px"), h = "var(--scale-factor) * ".concat(pageHeight, "px");
                        var widthStr = useRound ? "round(".concat(w, ", 1px)") : "calc(".concat(w, ")"), heightStr = useRound ? "round(".concat(h, ", 1px)") : "calc(".concat(h, ")");
                        if (!mustFlip || viewport.rotation % 180 === 0) {
                            style.width = widthStr;
                            style.height = heightStr;
                        } else {
                            style.width = heightStr;
                            style.height = widthStr;
                        }
                    }
                    if (mustRotate) div.setAttribute("data-main-rotation", viewport.rotation);
                }
            /***/ },
            /* 7 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BaseStandardFontDataFactory = exports.BaseSVGFactory = exports.BaseFilterFactory = exports.BaseCanvasFactory = exports.BaseCMapReaderFactory = void 0;
                var _util = __w_pdfjs_require__(1);
                var BaseFilterFactory = /*#__PURE__*/ function() {
                    function BaseFilterFactory() {
                        (0, $5sFFs._)(this, BaseFilterFactory);
                        if (this.constructor === BaseFilterFactory) (0, _util.unreachable)("Cannot initialize BaseFilterFactory.");
                    }
                    (0, $8O2fV._)(BaseFilterFactory, [
                        {
                            key: "addFilter",
                            value: function addFilter(maps) {
                                return "none";
                            }
                        },
                        {
                            key: "addHCMFilter",
                            value: function addHCMFilter(fgColor, bgColor) {
                                return "none";
                            }
                        },
                        {
                            key: "addHighlightHCMFilter",
                            value: function addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                                return "none";
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                var keepHCM = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                            }
                        }
                    ]);
                    return BaseFilterFactory;
                }();
                exports.BaseFilterFactory = BaseFilterFactory;
                var BaseCanvasFactory = /*#__PURE__*/ function() {
                    function BaseCanvasFactory() {
                        (0, $5sFFs._)(this, BaseCanvasFactory);
                        if (this.constructor === BaseCanvasFactory) (0, _util.unreachable)("Cannot initialize BaseCanvasFactory.");
                    }
                    (0, $8O2fV._)(BaseCanvasFactory, [
                        {
                            key: "create",
                            value: function create(width, height) {
                                if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                                var canvas = this._createCanvas(width, height);
                                return {
                                    canvas: canvas,
                                    context: canvas.getContext("2d")
                                };
                            }
                        },
                        {
                            key: "reset",
                            value: function reset(canvasAndContext, width, height) {
                                if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                                if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                                canvasAndContext.canvas.width = width;
                                canvasAndContext.canvas.height = height;
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy(canvasAndContext) {
                                if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                                canvasAndContext.canvas.width = 0;
                                canvasAndContext.canvas.height = 0;
                                canvasAndContext.canvas = null;
                                canvasAndContext.context = null;
                            }
                        },
                        {
                            key: "_createCanvas",
                            value: function _createCanvas(width, height) {
                                (0, _util.unreachable)("Abstract method `_createCanvas` called.");
                            }
                        }
                    ]);
                    return BaseCanvasFactory;
                }();
                exports.BaseCanvasFactory = BaseCanvasFactory;
                var BaseCMapReaderFactory = /*#__PURE__*/ function() {
                    function BaseCMapReaderFactory(param) {
                        var _param_baseUrl = param.baseUrl, baseUrl = _param_baseUrl === void 0 ? null : _param_baseUrl, _param_isCompressed = param.isCompressed, isCompressed = _param_isCompressed === void 0 ? true : _param_isCompressed;
                        (0, $5sFFs._)(this, BaseCMapReaderFactory);
                        if (this.constructor === BaseCMapReaderFactory) (0, _util.unreachable)("Cannot initialize BaseCMapReaderFactory.");
                        this.baseUrl = baseUrl;
                        this.isCompressed = isCompressed;
                    }
                    (0, $8O2fV._)(BaseCMapReaderFactory, [
                        {
                            key: "fetch",
                            value: function fetch1(param) {
                                var name = param.name;
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var url, compressionType;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        if (!_this.baseUrl) throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                                        if (!name) throw new Error("CMap name must be specified.");
                                        url = _this.baseUrl + name + (_this.isCompressed ? ".bcmap" : "");
                                        compressionType = _this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE;
                                        return [
                                            2,
                                            _this._fetchData(url, compressionType).catch(function(reason) {
                                                throw new Error("Unable to load ".concat(_this.isCompressed ? "binary " : "", "CMap at: ").concat(url));
                                            })
                                        ];
                                    });
                                })();
                            }
                        },
                        {
                            key: "_fetchData",
                            value: function _fetchData(url, compressionType) {
                                (0, _util.unreachable)("Abstract method `_fetchData` called.");
                            }
                        }
                    ]);
                    return BaseCMapReaderFactory;
                }();
                exports.BaseCMapReaderFactory = BaseCMapReaderFactory;
                var BaseStandardFontDataFactory = /*#__PURE__*/ function() {
                    function BaseStandardFontDataFactory(param) {
                        var _param_baseUrl = param.baseUrl, baseUrl = _param_baseUrl === void 0 ? null : _param_baseUrl;
                        (0, $5sFFs._)(this, BaseStandardFontDataFactory);
                        if (this.constructor === BaseStandardFontDataFactory) (0, _util.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
                        this.baseUrl = baseUrl;
                    }
                    (0, $8O2fV._)(BaseStandardFontDataFactory, [
                        {
                            key: "fetch",
                            value: function fetch1(param) {
                                var filename = param.filename;
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var url;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        if (!_this.baseUrl) throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                                        if (!filename) throw new Error("Font filename must be specified.");
                                        url = "".concat(_this.baseUrl).concat(filename);
                                        return [
                                            2,
                                            _this._fetchData(url).catch(function(reason) {
                                                throw new Error("Unable to load font data at: ".concat(url));
                                            })
                                        ];
                                    });
                                })();
                            }
                        },
                        {
                            key: "_fetchData",
                            value: function _fetchData(url) {
                                (0, _util.unreachable)("Abstract method `_fetchData` called.");
                            }
                        }
                    ]);
                    return BaseStandardFontDataFactory;
                }();
                exports.BaseStandardFontDataFactory = BaseStandardFontDataFactory;
                var BaseSVGFactory = /*#__PURE__*/ function() {
                    function BaseSVGFactory() {
                        (0, $5sFFs._)(this, BaseSVGFactory);
                        if (this.constructor === BaseSVGFactory) (0, _util.unreachable)("Cannot initialize BaseSVGFactory.");
                    }
                    (0, $8O2fV._)(BaseSVGFactory, [
                        {
                            key: "create",
                            value: function create(width, height) {
                                var skipDimensions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                                if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
                                var svg = this._createSVG("svg:svg");
                                svg.setAttribute("version", "1.1");
                                if (!skipDimensions) {
                                    svg.setAttribute("width", "".concat(width, "px"));
                                    svg.setAttribute("height", "".concat(height, "px"));
                                }
                                svg.setAttribute("preserveAspectRatio", "none");
                                svg.setAttribute("viewBox", "0 0 ".concat(width, " ").concat(height));
                                return svg;
                            }
                        },
                        {
                            key: "createElement",
                            value: function createElement(type) {
                                if (typeof type !== "string") throw new Error("Invalid SVG element type");
                                return this._createSVG(type);
                            }
                        },
                        {
                            key: "_createSVG",
                            value: function _createSVG(type) {
                                (0, _util.unreachable)("Abstract method `_createSVG` called.");
                            }
                        }
                    ]);
                    return BaseSVGFactory;
                }();
                exports.BaseSVGFactory = BaseSVGFactory;
            /***/ },
            /* 8 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MurmurHash3_64 = void 0;
                var _util = __w_pdfjs_require__(1);
                var SEED = 0xc3d2e1f0;
                var MASK_HIGH = 0xffff0000;
                var MASK_LOW = 0xffff;
                var MurmurHash3_64 = /*#__PURE__*/ function() {
                    function MurmurHash3_64(seed) {
                        (0, $5sFFs._)(this, MurmurHash3_64);
                        this.h1 = seed ? seed & 0xffffffff : SEED;
                        this.h2 = seed ? seed & 0xffffffff : SEED;
                    }
                    (0, $8O2fV._)(MurmurHash3_64, [
                        {
                            key: "update",
                            value: function update(input) {
                                var data, length;
                                if (typeof input === "string") {
                                    data = new Uint8Array(input.length * 2);
                                    length = 0;
                                    for(var i = 0, ii = input.length; i < ii; i++){
                                        var code = input.charCodeAt(i);
                                        if (code <= 0xff) data[length++] = code;
                                        else {
                                            data[length++] = code >>> 8;
                                            data[length++] = code & 0xff;
                                        }
                                    }
                                } else if ((0, _util.isArrayBuffer)(input)) {
                                    data = input.slice();
                                    length = data.byteLength;
                                } else throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                                var blockCounts = length >> 2;
                                var tailLength = length - blockCounts * 4;
                                var dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
                                var k1 = 0, k2 = 0;
                                var h1 = this.h1, h2 = this.h2;
                                var C1 = 0xcc9e2d51, C2 = 0x1b873593;
                                var C1_LOW = C1 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
                                for(var i1 = 0; i1 < blockCounts; i1++)if (i1 & 1) {
                                    k1 = dataUint32[i1];
                                    k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                                    k1 = k1 << 15 | k1 >>> 17;
                                    k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                                    h1 ^= k1;
                                    h1 = h1 << 13 | h1 >>> 19;
                                    h1 = h1 * 5 + 0xe6546b64;
                                } else {
                                    k2 = dataUint32[i1];
                                    k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                                    k2 = k2 << 15 | k2 >>> 17;
                                    k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                                    h2 ^= k2;
                                    h2 = h2 << 13 | h2 >>> 19;
                                    h2 = h2 * 5 + 0xe6546b64;
                                }
                                k1 = 0;
                                switch(tailLength){
                                    case 3:
                                        k1 ^= data[blockCounts * 4 + 2] << 16;
                                    case 2:
                                        k1 ^= data[blockCounts * 4 + 1] << 8;
                                    case 1:
                                        k1 ^= data[blockCounts * 4];
                                        k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                                        k1 = k1 << 15 | k1 >>> 17;
                                        k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                                        if (blockCounts & 1) h1 ^= k1;
                                        else h2 ^= k1;
                                }
                                this.h1 = h1;
                                this.h2 = h2;
                            }
                        },
                        {
                            key: "hexdigest",
                            value: function hexdigest() {
                                var h1 = this.h1, h2 = this.h2;
                                h1 ^= h2 >>> 1;
                                h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
                                h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
                                h1 ^= h2 >>> 1;
                                h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
                                h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
                                h1 ^= h2 >>> 1;
                                return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
                            }
                        }
                    ]);
                    return MurmurHash3_64;
                }();
                exports.MurmurHash3_64 = MurmurHash3_64;
            /***/ },
            /* 9 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FontLoader = exports.FontFaceObject = void 0;
                var _util = __w_pdfjs_require__(1);
                var _systemFonts = /*#__PURE__*/ new WeakMap();
                var FontLoader = /*#__PURE__*/ function() {
                    function FontLoader(param) {
                        var _param_ownerDocument = param.ownerDocument, ownerDocument = _param_ownerDocument === void 0 ? globalThis.document : _param_ownerDocument, _param_styleElement = param.styleElement, styleElement = _param_styleElement === void 0 ? null : _param_styleElement;
                        (0, $5sFFs._)(this, FontLoader);
                        (0, $g12Hy._)(this, _systemFonts, {
                            writable: true,
                            value: new Set()
                        });
                        this._document = ownerDocument;
                        this.nativeFontFaces = new Set();
                        this.styleElement = null;
                        this.loadingRequests = [];
                        this.loadTestFontId = 0;
                    }
                    (0, $8O2fV._)(FontLoader, [
                        {
                            key: "addNativeFontFace",
                            value: function addNativeFontFace(nativeFontFace) {
                                this.nativeFontFaces.add(nativeFontFace);
                                this._document.fonts.add(nativeFontFace);
                            }
                        },
                        {
                            key: "removeNativeFontFace",
                            value: function removeNativeFontFace(nativeFontFace) {
                                this.nativeFontFaces.delete(nativeFontFace);
                                this._document.fonts.delete(nativeFontFace);
                            }
                        },
                        {
                            key: "insertRule",
                            value: function insertRule(rule) {
                                if (!this.styleElement) {
                                    this.styleElement = this._document.createElement("style");
                                    this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
                                }
                                var styleSheet = this.styleElement.sheet;
                                styleSheet.insertRule(rule, styleSheet.cssRules.length);
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this.nativeFontFaces[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var nativeFontFace = _step.value;
                                        this._document.fonts.delete(nativeFontFace);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this.nativeFontFaces.clear();
                                (0, $057QZ._)(this, _systemFonts).clear();
                                if (this.styleElement) {
                                    this.styleElement.remove();
                                    this.styleElement = null;
                                }
                            }
                        },
                        {
                            key: "loadSystemFont",
                            value: function loadSystemFont(info) {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var loadedName, src, style, fontFace, e;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!info || (0, $057QZ._)(_this, _systemFonts).has(info.loadedName)) return [
                                                    2
                                                ];
                                                (0, _util.assert)(!_this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
                                                if (!_this.isFontLoadingAPISupported) return [
                                                    3,
                                                    5
                                                ];
                                                loadedName = info.loadedName, src = info.src, style = info.style;
                                                fontFace = new FontFace(loadedName, src, style);
                                                _this.addNativeFontFace(fontFace);
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                return [
                                                    4,
                                                    fontFace.load()
                                                ];
                                            case 2:
                                                _state.sent();
                                                (0, $057QZ._)(_this, _systemFonts).add(loadedName);
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                e = _state.sent();
                                                (0, _util.warn)("Cannot load system font: ".concat(info.baseFontName, ", installing it could help to improve PDF rendering."));
                                                _this.removeNativeFontFace(fontFace);
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                            case 5:
                                                (0, _util.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }
                        },
                        {
                            key: "bind",
                            value: function bind(font) {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var nativeFontFace, ex, rule;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (font.attached || font.missingFile && !font.systemFontInfo) return [
                                                    2
                                                ];
                                                font.attached = true;
                                                if (!font.systemFontInfo) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    _this.loadSystemFont(font.systemFontInfo)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                            case 2:
                                                if (!_this.isFontLoadingAPISupported) return [
                                                    3,
                                                    7
                                                ];
                                                nativeFontFace = font.createNativeFontFace();
                                                if (!nativeFontFace) return [
                                                    3,
                                                    6
                                                ];
                                                _this.addNativeFontFace(nativeFontFace);
                                                _state.label = 3;
                                            case 3:
                                                _state.trys.push([
                                                    3,
                                                    5,
                                                    ,
                                                    6
                                                ]);
                                                return [
                                                    4,
                                                    nativeFontFace.loaded
                                                ];
                                            case 4:
                                                _state.sent();
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 5:
                                                ex = _state.sent();
                                                (0, _util.warn)("Failed to load font '".concat(nativeFontFace.family, "': '").concat(ex, "'."));
                                                font.disableFontFace = true;
                                                throw ex;
                                            case 6:
                                                return [
                                                    2
                                                ];
                                            case 7:
                                                rule = font.createFontFaceRule();
                                                if (!rule) return [
                                                    3,
                                                    9
                                                ];
                                                _this.insertRule(rule);
                                                if (_this.isSyncFontLoadingSupported) return [
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    new Promise(function(resolve) {
                                                        var request = _this._queueLoadingCallback(resolve);
                                                        _this._prepareFontLoadEvent(font, request);
                                                    })
                                                ];
                                            case 8:
                                                _state.sent();
                                                _state.label = 9;
                                            case 9:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }
                        },
                        {
                            key: "isFontLoadingAPISupported",
                            get: function get() {
                                var _this__document;
                                var hasFonts = !!((_this__document = this._document) === null || _this__document === void 0 ? void 0 : _this__document.fonts);
                                return (0, _util.shadow)(this, "isFontLoadingAPISupported", hasFonts);
                            }
                        },
                        {
                            key: "isSyncFontLoadingSupported",
                            get: function get() {
                                var supported = false;
                                if (_util.isNodeJS) supported = true;
                                else if (typeof navigator !== "undefined" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) supported = true;
                                return (0, _util.shadow)(this, "isSyncFontLoadingSupported", supported);
                            }
                        },
                        {
                            key: "_queueLoadingCallback",
                            value: function _queueLoadingCallback(callback) {
                                function completeRequest() {
                                    (0, _util.assert)(!request.done, "completeRequest() cannot be called twice.");
                                    request.done = true;
                                    while(loadingRequests.length > 0 && loadingRequests[0].done){
                                        var otherRequest = loadingRequests.shift();
                                        setTimeout(otherRequest.callback, 0);
                                    }
                                }
                                var loadingRequests = this.loadingRequests;
                                var request = {
                                    done: false,
                                    complete: completeRequest,
                                    callback: callback
                                };
                                loadingRequests.push(request);
                                return request;
                            }
                        },
                        {
                            key: "_loadTestFont",
                            get: function get() {
                                var testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                                return (0, _util.shadow)(this, "_loadTestFont", testFont);
                            }
                        },
                        {
                            key: "_prepareFontLoadEvent",
                            value: function _prepareFontLoadEvent(font, request) {
                                function int32(data, offset) {
                                    return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
                                }
                                function spliceString(s, offset, remove, insert) {
                                    var chunk1 = s.substring(0, offset);
                                    var chunk2 = s.substring(offset + remove);
                                    return chunk1 + insert + chunk2;
                                }
                                var i, ii;
                                var canvas = this._document.createElement("canvas");
                                canvas.width = 1;
                                canvas.height = 1;
                                var ctx = canvas.getContext("2d");
                                var called = 0;
                                function isFontReady(name, callback) {
                                    if (++called > 30) {
                                        (0, _util.warn)("Load test font never loaded.");
                                        callback();
                                        return;
                                    }
                                    ctx.font = "30px " + name;
                                    ctx.fillText(".", 0, 20);
                                    var imageData = ctx.getImageData(0, 0, 1, 1);
                                    if (imageData.data[3] > 0) {
                                        callback();
                                        return;
                                    }
                                    setTimeout(isFontReady.bind(null, name, callback));
                                }
                                var loadTestFontId = "lt".concat(Date.now()).concat(this.loadTestFontId++);
                                var data = this._loadTestFont;
                                var COMMENT_OFFSET = 976;
                                data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
                                var CFF_CHECKSUM_OFFSET = 16;
                                var XXXX_VALUE = 0x58585858;
                                var checksum = int32(data, CFF_CHECKSUM_OFFSET);
                                for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
                                if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
                                data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
                                var url = "url(data:font/opentype;base64,".concat(btoa(data), ");");
                                var rule = '@font-face {font-family:"'.concat(loadTestFontId, '";src:').concat(url, "}");
                                this.insertRule(rule);
                                var div = this._document.createElement("div");
                                div.style.visibility = "hidden";
                                div.style.width = div.style.height = "10px";
                                div.style.position = "absolute";
                                div.style.top = div.style.left = "0px";
                                for(var _i = 0, _iter = [
                                    font.loadedName,
                                    loadTestFontId
                                ]; _i < _iter.length; _i++){
                                    var name = _iter[_i];
                                    var span = this._document.createElement("span");
                                    span.textContent = "Hi";
                                    span.style.fontFamily = name;
                                    div.append(span);
                                }
                                this._document.body.append(div);
                                isFontReady(loadTestFontId, function() {
                                    div.remove();
                                    request.complete();
                                });
                            }
                        }
                    ]);
                    return FontLoader;
                }();
                exports.FontLoader = FontLoader;
                var FontFaceObject = /*#__PURE__*/ function() {
                    function FontFaceObject(translatedData, param) {
                        var _param_isEvalSupported = param.isEvalSupported, isEvalSupported = _param_isEvalSupported === void 0 ? true : _param_isEvalSupported, _param_disableFontFace = param.disableFontFace, disableFontFace = _param_disableFontFace === void 0 ? false : _param_disableFontFace, _param_ignoreErrors = param.ignoreErrors, ignoreErrors = _param_ignoreErrors === void 0 ? false : _param_ignoreErrors, _param_inspectFont = param.inspectFont, inspectFont = _param_inspectFont === void 0 ? null : _param_inspectFont;
                        (0, $5sFFs._)(this, FontFaceObject);
                        this.compiledGlyphs = Object.create(null);
                        for(var i in translatedData)this[i] = translatedData[i];
                        this.isEvalSupported = isEvalSupported !== false;
                        this.disableFontFace = disableFontFace === true;
                        this.ignoreErrors = ignoreErrors === true;
                        this._inspectFont = inspectFont;
                    }
                    (0, $8O2fV._)(FontFaceObject, [
                        {
                            key: "createNativeFontFace",
                            value: function createNativeFontFace() {
                                var _this__inspectFont, _this;
                                if (!this.data || this.disableFontFace) return null;
                                var nativeFontFace;
                                if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
                                else {
                                    var css = {
                                        weight: this.cssFontInfo.fontWeight
                                    };
                                    if (this.cssFontInfo.italicAngle) css.style = "oblique ".concat(this.cssFontInfo.italicAngle, "deg");
                                    nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
                                }
                                (_this__inspectFont = (_this = this)._inspectFont) === null || _this__inspectFont === void 0 ? void 0 : _this__inspectFont.call(_this, this);
                                return nativeFontFace;
                            }
                        },
                        {
                            key: "createFontFaceRule",
                            value: function createFontFaceRule() {
                                var _this__inspectFont, _this;
                                if (!this.data || this.disableFontFace) return null;
                                var data = (0, _util.bytesToString)(this.data);
                                var url = "url(data:".concat(this.mimetype, ";base64,").concat(btoa(data), ");");
                                var rule;
                                if (!this.cssFontInfo) rule = '@font-face {font-family:"'.concat(this.loadedName, '";src:').concat(url, "}");
                                else {
                                    var css = "font-weight: ".concat(this.cssFontInfo.fontWeight, ";");
                                    if (this.cssFontInfo.italicAngle) css += "font-style: oblique ".concat(this.cssFontInfo.italicAngle, "deg;");
                                    rule = '@font-face {font-family:"'.concat(this.cssFontInfo.fontFamily, '";').concat(css, "src:").concat(url, "}");
                                }
                                (_this__inspectFont = (_this = this)._inspectFont) === null || _this__inspectFont === void 0 ? void 0 : _this__inspectFont.call(_this, this, url);
                                return rule;
                            }
                        },
                        {
                            key: "getPathGenerator",
                            value: function getPathGenerator(objs, character) {
                                if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
                                var cmds;
                                try {
                                    cmds = objs.get(this.loadedName + "_path_" + character);
                                } catch (ex) {
                                    if (!this.ignoreErrors) throw ex;
                                    (0, _util.warn)('getPathGenerator - ignoring character: "'.concat(ex, '".'));
                                    return this.compiledGlyphs[character] = function(c, size) {};
                                }
                                if (this.isEvalSupported && _util.FeatureTest.isEvalSupported) {
                                    var jsBuf = [];
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = cmds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var current = _step.value;
                                            var args = current.args !== undefined ? current.args.join(",") : "";
                                            jsBuf.push("c.", current.cmd, "(", args, ");\n");
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    return this.compiledGlyphs[character] = new Function("c", "size", jsBuf.join(""));
                                }
                                return this.compiledGlyphs[character] = function(c, size) {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = cmds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var current = _step.value;
                                            if (current.cmd === "scale") current.args = [
                                                size,
                                                -size
                                            ];
                                            c[current.cmd].apply(c, current.args);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                };
                            }
                        }
                    ]);
                    return FontFaceObject;
                }();
                exports.FontFaceObject = FontFaceObject;
            /***/ },
            /* 10 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NodeStandardFontDataFactory = exports.NodeFilterFactory = exports.NodeCanvasFactory = exports.NodeCMapReaderFactory = void 0;
                var _base_factory = __w_pdfjs_require__(7);
                var _util = __w_pdfjs_require__(1);
                var fetchData = function fetchData(url) {
                    return new Promise(function(resolve, reject) {
                        var fs = (parcelRequire("6Guue"));
                        fs.readFile(url, function(error, data) {
                            if (error || !data) {
                                reject(new Error(error));
                                return;
                            }
                            resolve(new Uint8Array(data));
                        });
                    });
                };
                var NodeFilterFactory = /*#__PURE__*/ function(_base_factory_BaseFilterFactory) {
                    (0, $kcqLc._)(NodeFilterFactory, _base_factory_BaseFilterFactory);
                    var _super = (0, $4jYWU._)(NodeFilterFactory);
                    function NodeFilterFactory() {
                        (0, $5sFFs._)(this, NodeFilterFactory);
                        return _super.apply(this, arguments);
                    }
                    return NodeFilterFactory;
                }(_base_factory.BaseFilterFactory);
                exports.NodeFilterFactory = NodeFilterFactory;
                var NodeCanvasFactory = /*#__PURE__*/ function(_base_factory_BaseCanvasFactory) {
                    (0, $kcqLc._)(NodeCanvasFactory, _base_factory_BaseCanvasFactory);
                    var _super = (0, $4jYWU._)(NodeCanvasFactory);
                    function NodeCanvasFactory() {
                        (0, $5sFFs._)(this, NodeCanvasFactory);
                        return _super.apply(this, arguments);
                    }
                    (0, $8O2fV._)(NodeCanvasFactory, [
                        {
                            key: "_createCanvas",
                            value: function _createCanvas(width, height) {
                                var Canvas = (parcelRequire("6Guue"));
                                return Canvas.createCanvas(width, height);
                            }
                        }
                    ]);
                    return NodeCanvasFactory;
                }(_base_factory.BaseCanvasFactory);
                exports.NodeCanvasFactory = NodeCanvasFactory;
                var NodeCMapReaderFactory = /*#__PURE__*/ function(_base_factory_BaseCMapReaderFactory) {
                    (0, $kcqLc._)(NodeCMapReaderFactory, _base_factory_BaseCMapReaderFactory);
                    var _super = (0, $4jYWU._)(NodeCMapReaderFactory);
                    function NodeCMapReaderFactory() {
                        (0, $5sFFs._)(this, NodeCMapReaderFactory);
                        return _super.apply(this, arguments);
                    }
                    (0, $8O2fV._)(NodeCMapReaderFactory, [
                        {
                            key: "_fetchData",
                            value: function _fetchData(url, compressionType) {
                                return fetchData(url).then(function(data) {
                                    return {
                                        cMapData: data,
                                        compressionType: compressionType
                                    };
                                });
                            }
                        }
                    ]);
                    return NodeCMapReaderFactory;
                }(_base_factory.BaseCMapReaderFactory);
                exports.NodeCMapReaderFactory = NodeCMapReaderFactory;
                var NodeStandardFontDataFactory = /*#__PURE__*/ function(_base_factory_BaseStandardFontDataFactory) {
                    (0, $kcqLc._)(NodeStandardFontDataFactory, _base_factory_BaseStandardFontDataFactory);
                    var _super = (0, $4jYWU._)(NodeStandardFontDataFactory);
                    function NodeStandardFontDataFactory() {
                        (0, $5sFFs._)(this, NodeStandardFontDataFactory);
                        return _super.apply(this, arguments);
                    }
                    (0, $8O2fV._)(NodeStandardFontDataFactory, [
                        {
                            key: "_fetchData",
                            value: function _fetchData(url) {
                                return fetchData(url);
                            }
                        }
                    ]);
                    return NodeStandardFontDataFactory;
                }(_base_factory.BaseStandardFontDataFactory);
                exports.NodeStandardFontDataFactory = NodeStandardFontDataFactory;
            /***/ },
            /* 11 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CanvasGraphics = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _pattern_helper = __w_pdfjs_require__(12);
                var _image_utils = __w_pdfjs_require__(13);
                var MIN_FONT_SIZE = 16;
                var MAX_FONT_SIZE = 100;
                var MAX_GROUP_SIZE = 4096;
                var EXECUTION_TIME = 15;
                var EXECUTION_STEPS = 10;
                var MAX_SIZE_TO_COMPILE = 1000;
                var FULL_CHUNK_HEIGHT = 16;
                function mirrorContextOperations(ctx, destCtx) {
                    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
                    ctx.__originalSave = ctx.save;
                    ctx.__originalRestore = ctx.restore;
                    ctx.__originalRotate = ctx.rotate;
                    ctx.__originalScale = ctx.scale;
                    ctx.__originalTranslate = ctx.translate;
                    ctx.__originalTransform = ctx.transform;
                    ctx.__originalSetTransform = ctx.setTransform;
                    ctx.__originalResetTransform = ctx.resetTransform;
                    ctx.__originalClip = ctx.clip;
                    ctx.__originalMoveTo = ctx.moveTo;
                    ctx.__originalLineTo = ctx.lineTo;
                    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
                    ctx.__originalRect = ctx.rect;
                    ctx.__originalClosePath = ctx.closePath;
                    ctx.__originalBeginPath = ctx.beginPath;
                    ctx._removeMirroring = function() {
                        ctx.save = ctx.__originalSave;
                        ctx.restore = ctx.__originalRestore;
                        ctx.rotate = ctx.__originalRotate;
                        ctx.scale = ctx.__originalScale;
                        ctx.translate = ctx.__originalTranslate;
                        ctx.transform = ctx.__originalTransform;
                        ctx.setTransform = ctx.__originalSetTransform;
                        ctx.resetTransform = ctx.__originalResetTransform;
                        ctx.clip = ctx.__originalClip;
                        ctx.moveTo = ctx.__originalMoveTo;
                        ctx.lineTo = ctx.__originalLineTo;
                        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
                        ctx.rect = ctx.__originalRect;
                        ctx.closePath = ctx.__originalClosePath;
                        ctx.beginPath = ctx.__originalBeginPath;
                        delete ctx._removeMirroring;
                    };
                    ctx.save = function ctxSave() {
                        destCtx.save();
                        this.__originalSave();
                    };
                    ctx.restore = function ctxRestore() {
                        destCtx.restore();
                        this.__originalRestore();
                    };
                    ctx.translate = function ctxTranslate(x, y) {
                        destCtx.translate(x, y);
                        this.__originalTranslate(x, y);
                    };
                    ctx.scale = function ctxScale(x, y) {
                        destCtx.scale(x, y);
                        this.__originalScale(x, y);
                    };
                    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
                        destCtx.transform(a, b, c, d, e, f);
                        this.__originalTransform(a, b, c, d, e, f);
                    };
                    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
                        destCtx.setTransform(a, b, c, d, e, f);
                        this.__originalSetTransform(a, b, c, d, e, f);
                    };
                    ctx.resetTransform = function ctxResetTransform() {
                        destCtx.resetTransform();
                        this.__originalResetTransform();
                    };
                    ctx.rotate = function ctxRotate(angle) {
                        destCtx.rotate(angle);
                        this.__originalRotate(angle);
                    };
                    ctx.clip = function ctxRotate(rule) {
                        destCtx.clip(rule);
                        this.__originalClip(rule);
                    };
                    ctx.moveTo = function(x, y) {
                        destCtx.moveTo(x, y);
                        this.__originalMoveTo(x, y);
                    };
                    ctx.lineTo = function(x, y) {
                        destCtx.lineTo(x, y);
                        this.__originalLineTo(x, y);
                    };
                    ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
                        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                    };
                    ctx.rect = function(x, y, width, height) {
                        destCtx.rect(x, y, width, height);
                        this.__originalRect(x, y, width, height);
                    };
                    ctx.closePath = function() {
                        destCtx.closePath();
                        this.__originalClosePath();
                    };
                    ctx.beginPath = function() {
                        destCtx.beginPath();
                        this.__originalBeginPath();
                    };
                }
                var CachedCanvases = /*#__PURE__*/ function() {
                    function CachedCanvases(canvasFactory) {
                        (0, $5sFFs._)(this, CachedCanvases);
                        this.canvasFactory = canvasFactory;
                        this.cache = Object.create(null);
                    }
                    (0, $8O2fV._)(CachedCanvases, [
                        {
                            key: "getCanvas",
                            value: function getCanvas(id, width, height) {
                                var canvasEntry;
                                if (this.cache[id] !== undefined) {
                                    canvasEntry = this.cache[id];
                                    this.canvasFactory.reset(canvasEntry, width, height);
                                } else {
                                    canvasEntry = this.canvasFactory.create(width, height);
                                    this.cache[id] = canvasEntry;
                                }
                                return canvasEntry;
                            }
                        },
                        {
                            key: "delete",
                            value: function _delete(id) {
                                delete this.cache[id];
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                for(var id in this.cache){
                                    var canvasEntry = this.cache[id];
                                    this.canvasFactory.destroy(canvasEntry);
                                    delete this.cache[id];
                                }
                            }
                        }
                    ]);
                    return CachedCanvases;
                }();
                function drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
                    var _ref = (0, $52tJv._)((0, _display_utils.getCurrentTransform)(ctx), 6), a = _ref[0], b = _ref[1], c = _ref[2], d = _ref[3], tx = _ref[4], ty = _ref[5];
                    if (b === 0 && c === 0) {
                        var tlX = destX * a + tx;
                        var rTlX = Math.round(tlX);
                        var tlY = destY * d + ty;
                        var rTlY = Math.round(tlY);
                        var brX = (destX + destW) * a + tx;
                        var rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                        var brY = (destY + destH) * d + ty;
                        var rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                        ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
                        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
                        ctx.setTransform(a, b, c, d, tx, ty);
                        return [
                            rWidth,
                            rHeight
                        ];
                    }
                    if (a === 0 && d === 0) {
                        var tlX1 = destY * c + tx;
                        var rTlX1 = Math.round(tlX1);
                        var tlY1 = destX * b + ty;
                        var rTlY1 = Math.round(tlY1);
                        var brX1 = (destY + destH) * c + tx;
                        var rWidth1 = Math.abs(Math.round(brX1) - rTlX1) || 1;
                        var brY1 = (destX + destW) * b + ty;
                        var rHeight1 = Math.abs(Math.round(brY1) - rTlY1) || 1;
                        ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX1, rTlY1);
                        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight1, rWidth1);
                        ctx.setTransform(a, b, c, d, tx, ty);
                        return [
                            rHeight1,
                            rWidth1
                        ];
                    }
                    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
                    var scaleX = Math.hypot(a, b);
                    var scaleY = Math.hypot(c, d);
                    return [
                        scaleX * destW,
                        scaleY * destH
                    ];
                }
                function compileType3Glyph(imgData) {
                    var width = imgData.width, height = imgData.height;
                    if (width > MAX_SIZE_TO_COMPILE || height > MAX_SIZE_TO_COMPILE) return null;
                    var POINT_TO_PROCESS_LIMIT = 1000;
                    var POINT_TYPES = new Uint8Array([
                        0,
                        2,
                        4,
                        0,
                        1,
                        0,
                        5,
                        4,
                        8,
                        10,
                        0,
                        8,
                        0,
                        2,
                        1,
                        0
                    ]);
                    var width1 = width + 1;
                    var points = new Uint8Array(width1 * (height + 1));
                    var i, j, j0;
                    var lineSize = width + 7 & -8;
                    var data = new Uint8Array(lineSize * height), pos = 0;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = imgData.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var elem = _step.value;
                            var mask = 128;
                            while(mask > 0){
                                data[pos++] = elem & mask ? 0 : 255;
                                mask >>= 1;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var count = 0;
                    pos = 0;
                    if (data[pos] !== 0) {
                        points[0] = 1;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j] = data[pos] ? 2 : 1;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j] = 2;
                        ++count;
                    }
                    for(i = 1; i < height; i++){
                        pos = i * lineSize;
                        j0 = i * width1;
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0] = data[pos] ? 1 : 8;
                            ++count;
                        }
                        var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
                        for(j = 1; j < width; j++){
                            sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
                            if (POINT_TYPES[sum]) {
                                points[j0 + j] = POINT_TYPES[sum];
                                ++count;
                            }
                            pos++;
                        }
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0 + j] = data[pos] ? 2 : 4;
                            ++count;
                        }
                        if (count > POINT_TO_PROCESS_LIMIT) return null;
                    }
                    pos = lineSize * (height - 1);
                    j0 = i * width1;
                    if (data[pos] !== 0) {
                        points[j0] = 8;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j0 + j] = data[pos] ? 4 : 8;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j0 + j] = 4;
                        ++count;
                    }
                    if (count > POINT_TO_PROCESS_LIMIT) return null;
                    var steps = new Int32Array([
                        0,
                        width1,
                        -1,
                        0,
                        -width1,
                        0,
                        0,
                        0,
                        1
                    ]);
                    var path = new Path2D();
                    for(i = 0; count && i <= height; i++){
                        var p = i * width1;
                        var end = p + width;
                        while(p < end && !points[p])p++;
                        if (p === end) continue;
                        path.moveTo(p % width1, i);
                        var p0 = p;
                        var type = points[p];
                        do {
                            var step = steps[type];
                            do p += step;
                            while (!points[p]);
                            var pp = points[p];
                            if (pp !== 5 && pp !== 10) {
                                type = pp;
                                points[p] = 0;
                            } else {
                                type = pp & 0x33 * type >> 4;
                                points[p] &= type >> 2 | type << 2;
                            }
                            path.lineTo(p % width1, p / width1 | 0);
                            if (!points[p]) --count;
                        }while (p0 !== p);
                        --i;
                    }
                    data = null;
                    points = null;
                    var drawOutline = function drawOutline(c) {
                        c.save();
                        c.scale(1 / width, -1 / height);
                        c.translate(0, -height);
                        c.fill(path);
                        c.beginPath();
                        c.restore();
                    };
                    return drawOutline;
                }
                var CanvasExtraState = /*#__PURE__*/ function() {
                    function CanvasExtraState(width, height) {
                        (0, $5sFFs._)(this, CanvasExtraState);
                        this.alphaIsShape = false;
                        this.fontSize = 0;
                        this.fontSizeScale = 1;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.textMatrixScale = 1;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textRise = 0;
                        this.fillColor = "#000000";
                        this.strokeColor = "#000000";
                        this.patternFill = false;
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.activeSMask = null;
                        this.transferMaps = "none";
                        this.startNewPathAndClipBox([
                            0,
                            0,
                            width,
                            height
                        ]);
                    }
                    (0, $8O2fV._)(CanvasExtraState, [
                        {
                            key: "clone",
                            value: function clone() {
                                var clone = Object.create(this);
                                clone.clipBox = this.clipBox.slice();
                                return clone;
                            }
                        },
                        {
                            key: "setCurrentPoint",
                            value: function setCurrentPoint(x, y) {
                                this.x = x;
                                this.y = y;
                            }
                        },
                        {
                            key: "updatePathMinMax",
                            value: function updatePathMinMax(transform, x, y) {
                                var ref;
                                ref = (0, $52tJv._)(_util.Util.applyTransform([
                                    x,
                                    y
                                ], transform), 2), x = ref[0], y = ref[1], ref;
                                this.minX = Math.min(this.minX, x);
                                this.minY = Math.min(this.minY, y);
                                this.maxX = Math.max(this.maxX, x);
                                this.maxY = Math.max(this.maxY, y);
                            }
                        },
                        {
                            key: "updateRectMinMax",
                            value: function updateRectMinMax(transform, rect) {
                                var p1 = _util.Util.applyTransform(rect, transform);
                                var p2 = _util.Util.applyTransform(rect.slice(2), transform);
                                this.minX = Math.min(this.minX, p1[0], p2[0]);
                                this.minY = Math.min(this.minY, p1[1], p2[1]);
                                this.maxX = Math.max(this.maxX, p1[0], p2[0]);
                                this.maxY = Math.max(this.maxY, p1[1], p2[1]);
                            }
                        },
                        {
                            key: "updateScalingPathMinMax",
                            value: function updateScalingPathMinMax(transform, minMax) {
                                _util.Util.scaleMinMax(transform, minMax);
                                this.minX = Math.min(this.minX, minMax[0]);
                                this.maxX = Math.max(this.maxX, minMax[1]);
                                this.minY = Math.min(this.minY, minMax[2]);
                                this.maxY = Math.max(this.maxY, minMax[3]);
                            }
                        },
                        {
                            key: "updateCurvePathMinMax",
                            value: function updateCurvePathMinMax(transform, x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
                                var box = _util.Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3);
                                if (minMax) {
                                    minMax[0] = Math.min(minMax[0], box[0], box[2]);
                                    minMax[1] = Math.max(minMax[1], box[0], box[2]);
                                    minMax[2] = Math.min(minMax[2], box[1], box[3]);
                                    minMax[3] = Math.max(minMax[3], box[1], box[3]);
                                    return;
                                }
                                this.updateRectMinMax(transform, box);
                            }
                        },
                        {
                            key: "getPathBoundingBox",
                            value: function getPathBoundingBox() {
                                var pathType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _pattern_helper.PathType.FILL, transform = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                                var box = [
                                    this.minX,
                                    this.minY,
                                    this.maxX,
                                    this.maxY
                                ];
                                if (pathType === _pattern_helper.PathType.STROKE) {
                                    if (!transform) (0, _util.unreachable)("Stroke bounding box must include transform.");
                                    var scale = _util.Util.singularValueDecompose2dScale(transform);
                                    var xStrokePad = scale[0] * this.lineWidth / 2;
                                    var yStrokePad = scale[1] * this.lineWidth / 2;
                                    box[0] -= xStrokePad;
                                    box[1] -= yStrokePad;
                                    box[2] += xStrokePad;
                                    box[3] += yStrokePad;
                                }
                                return box;
                            }
                        },
                        {
                            key: "updateClipFromPath",
                            value: function updateClipFromPath() {
                                var intersect = _util.Util.intersect(this.clipBox, this.getPathBoundingBox());
                                this.startNewPathAndClipBox(intersect || [
                                    0,
                                    0,
                                    0,
                                    0
                                ]);
                            }
                        },
                        {
                            key: "isEmptyClip",
                            value: function isEmptyClip() {
                                return this.minX === Infinity;
                            }
                        },
                        {
                            key: "startNewPathAndClipBox",
                            value: function startNewPathAndClipBox(box) {
                                this.clipBox = box;
                                this.minX = Infinity;
                                this.minY = Infinity;
                                this.maxX = 0;
                                this.maxY = 0;
                            }
                        },
                        {
                            key: "getClippedPathBoundingBox",
                            value: function getClippedPathBoundingBox() {
                                var pathType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _pattern_helper.PathType.FILL, transform = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                                return _util.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
                            }
                        }
                    ]);
                    return CanvasExtraState;
                }();
                function putBinaryImageData(ctx, imgData) {
                    if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
                        ctx.putImageData(imgData, 0, 0);
                        return;
                    }
                    var height = imgData.height, width = imgData.width;
                    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    var srcPos = 0, destPos;
                    var src = imgData.data;
                    var dest = chunkImgData.data;
                    var i, j, thisChunkHeight, elemsInThisChunk;
                    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
                        var srcLength = src.byteLength;
                        var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
                        var dest32DataLength = dest32.length;
                        var fullSrcDiff = width + 7 >> 3;
                        var white = 0xffffffff;
                        var black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                        for(i = 0; i < totalChunks; i++){
                            thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                            destPos = 0;
                            for(j = 0; j < thisChunkHeight; j++){
                                var srcDiff = srcLength - srcPos;
                                var k = 0;
                                var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                                var kEndUnrolled = kEnd & -8;
                                var mask = 0;
                                var srcByte = 0;
                                for(; k < kEndUnrolled; k += 8){
                                    srcByte = src[srcPos++];
                                    dest32[destPos++] = srcByte & 128 ? white : black;
                                    dest32[destPos++] = srcByte & 64 ? white : black;
                                    dest32[destPos++] = srcByte & 32 ? white : black;
                                    dest32[destPos++] = srcByte & 16 ? white : black;
                                    dest32[destPos++] = srcByte & 8 ? white : black;
                                    dest32[destPos++] = srcByte & 4 ? white : black;
                                    dest32[destPos++] = srcByte & 2 ? white : black;
                                    dest32[destPos++] = srcByte & 1 ? white : black;
                                }
                                for(; k < kEnd; k++){
                                    if (mask === 0) {
                                        srcByte = src[srcPos++];
                                        mask = 128;
                                    }
                                    dest32[destPos++] = srcByte & mask ? white : black;
                                    mask >>= 1;
                                }
                            }
                            while(destPos < dest32DataLength)dest32[destPos++] = 0;
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
                        j = 0;
                        elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
                        for(i = 0; i < fullChunks; i++){
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            srcPos += elemsInThisChunk;
                            ctx.putImageData(chunkImgData, 0, j);
                            j += FULL_CHUNK_HEIGHT;
                        }
                        if (i < totalChunks) {
                            elemsInThisChunk = width * partialChunkHeight * 4;
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            ctx.putImageData(chunkImgData, 0, j);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
                        thisChunkHeight = FULL_CHUNK_HEIGHT;
                        elemsInThisChunk = width * thisChunkHeight;
                        for(i = 0; i < totalChunks; i++){
                            if (i >= fullChunks) {
                                thisChunkHeight = partialChunkHeight;
                                elemsInThisChunk = width * thisChunkHeight;
                            }
                            destPos = 0;
                            for(j = elemsInThisChunk; j--;){
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = 255;
                            }
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else throw new Error("bad image kind: ".concat(imgData.kind));
                }
                function putBinaryImageMask(ctx, imgData) {
                    if (imgData.bitmap) {
                        ctx.drawImage(imgData.bitmap, 0, 0);
                        return;
                    }
                    var height = imgData.height, width = imgData.width;
                    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    var srcPos = 0;
                    var src = imgData.data;
                    var dest = chunkImgData.data;
                    for(var i = 0; i < totalChunks; i++){
                        var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                        srcPos = (0, _image_utils.convertBlackAndWhiteToRGBA)({
                            src: src,
                            srcPos: srcPos,
                            dest: dest,
                            width: width,
                            height: thisChunkHeight,
                            nonBlackColor: 0
                        }).srcPos;
                        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                    }
                }
                function copyCtxState(sourceCtx, destCtx) {
                    var properties = [
                        "strokeStyle",
                        "fillStyle",
                        "fillRule",
                        "globalAlpha",
                        "lineWidth",
                        "lineCap",
                        "lineJoin",
                        "miterLimit",
                        "globalCompositeOperation",
                        "font",
                        "filter"
                    ];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var property = _step.value;
                            if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (sourceCtx.setLineDash !== undefined) {
                        destCtx.setLineDash(sourceCtx.getLineDash());
                        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
                    }
                }
                function resetCtxToDefault(ctx) {
                    ctx.strokeStyle = ctx.fillStyle = "#000000";
                    ctx.fillRule = "nonzero";
                    ctx.globalAlpha = 1;
                    ctx.lineWidth = 1;
                    ctx.lineCap = "butt";
                    ctx.lineJoin = "miter";
                    ctx.miterLimit = 10;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.font = "10px sans-serif";
                    if (ctx.setLineDash !== undefined) {
                        ctx.setLineDash([]);
                        ctx.lineDashOffset = 0;
                    }
                    if (!_util.isNodeJS) {
                        var filter = ctx.filter;
                        if (filter !== "none" && filter !== "") ctx.filter = "none";
                    }
                }
                function composeSMaskBackdrop(bytes, r0, g0, b0) {
                    var length = bytes.length;
                    for(var i = 3; i < length; i += 4){
                        var alpha = bytes[i];
                        if (alpha === 0) {
                            bytes[i - 3] = r0;
                            bytes[i - 2] = g0;
                            bytes[i - 1] = b0;
                        } else if (alpha < 255) {
                            var alpha_ = 255 - alpha;
                            bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
                            bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
                            bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
                        }
                    }
                }
                function composeSMaskAlpha(maskData, layerData, transferMap) {
                    var length = maskData.length;
                    var scale = 1 / 255;
                    for(var i = 3; i < length; i += 4){
                        var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
                        layerData[i] = layerData[i] * alpha * scale | 0;
                    }
                }
                function composeSMaskLuminosity(maskData, layerData, transferMap) {
                    var length = maskData.length;
                    for(var i = 3; i < length; i += 4){
                        var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
                        layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
                    }
                }
                function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
                    var hasBackdrop = !!backdrop;
                    var r0 = hasBackdrop ? backdrop[0] : 0;
                    var g0 = hasBackdrop ? backdrop[1] : 0;
                    var b0 = hasBackdrop ? backdrop[2] : 0;
                    var composeFn = subtype === "Luminosity" ? composeSMaskLuminosity : composeSMaskAlpha;
                    var PIXELS_TO_PROCESS = 1048576;
                    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
                    for(var row = 0; row < height; row += chunkSize){
                        var chunkHeight = Math.min(chunkSize, height - row);
                        var maskData = maskCtx.getImageData(layerOffsetX - maskOffsetX, row + (layerOffsetY - maskOffsetY), width, chunkHeight);
                        var layerData = layerCtx.getImageData(layerOffsetX, row + layerOffsetY, width, chunkHeight);
                        if (hasBackdrop) composeSMaskBackdrop(maskData.data, r0, g0, b0);
                        composeFn(maskData.data, layerData.data, transferMap);
                        layerCtx.putImageData(layerData, layerOffsetX, row + layerOffsetY);
                    }
                }
                function composeSMask(ctx, smask, layerCtx, layerBox) {
                    var layerOffsetX = layerBox[0];
                    var layerOffsetY = layerBox[1];
                    var layerWidth = layerBox[2] - layerOffsetX;
                    var layerHeight = layerBox[3] - layerOffsetY;
                    if (layerWidth === 0 || layerHeight === 0) return;
                    genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
                    ctx.save();
                    ctx.globalAlpha = 1;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.drawImage(layerCtx.canvas, 0, 0);
                    ctx.restore();
                }
                function getImageSmoothingEnabled(transform, interpolate) {
                    var scale = _util.Util.singularValueDecompose2dScale(transform);
                    scale[0] = Math.fround(scale[0]);
                    scale[1] = Math.fround(scale[1]);
                    var actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                    if (interpolate !== undefined) return interpolate;
                    else if (scale[0] <= actualScale || scale[1] <= actualScale) return true;
                    return false;
                }
                var LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                var LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                var NORMAL_CLIP = {};
                var EO_CLIP = {};
                var _restoreInitialState = /*#__PURE__*/ new WeakSet(), _drawFilter = /*#__PURE__*/ new WeakSet();
                var CanvasGraphics = /*#__PURE__*/ function() {
                    function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, param, annotationCanvasMap, pageColors) {
                        var optionalContentConfig = param.optionalContentConfig, _param_markedContentStack = param.markedContentStack, markedContentStack = _param_markedContentStack === void 0 ? null : _param_markedContentStack;
                        (0, $5sFFs._)(this, CanvasGraphics);
                        (0, $iB2CV._)(this, _restoreInitialState);
                        (0, $iB2CV._)(this, _drawFilter);
                        this.ctx = canvasCtx;
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.stateStack = [];
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.res = null;
                        this.xobjs = null;
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.canvasFactory = canvasFactory;
                        this.filterFactory = filterFactory;
                        this.groupStack = [];
                        this.processingType3 = null;
                        this.baseTransform = null;
                        this.baseTransformStack = [];
                        this.groupLevel = 0;
                        this.smaskStack = [];
                        this.smaskCounter = 0;
                        this.tempSMask = null;
                        this.suspendedCtx = null;
                        this.contentVisible = true;
                        this.markedContentStack = markedContentStack || [];
                        this.optionalContentConfig = optionalContentConfig;
                        this.cachedCanvases = new CachedCanvases(this.canvasFactory);
                        this.cachedPatterns = new Map();
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.viewportScale = 1;
                        this.outputScaleX = 1;
                        this.outputScaleY = 1;
                        this.pageColors = pageColors;
                        this._cachedScaleForStroking = [
                            -1,
                            0
                        ];
                        this._cachedGetSinglePixelWidth = null;
                        this._cachedBitmapsMap = new Map();
                    }
                    (0, $8O2fV._)(CanvasGraphics, [
                        {
                            key: "getObject",
                            value: function getObject(data) {
                                var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                                if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
                                return fallback;
                            }
                        },
                        {
                            key: "beginDrawing",
                            value: function beginDrawing(param) {
                                var transform = param.transform, viewport = param.viewport, _param_transparency = param.transparency, transparency = _param_transparency === void 0 ? false : _param_transparency, _param_background = param.background, background = _param_background === void 0 ? null : _param_background;
                                var _this_ctx;
                                var width = this.ctx.canvas.width;
                                var height = this.ctx.canvas.height;
                                var savedFillStyle = this.ctx.fillStyle;
                                this.ctx.fillStyle = background || "#ffffff";
                                this.ctx.fillRect(0, 0, width, height);
                                this.ctx.fillStyle = savedFillStyle;
                                if (transparency) {
                                    var _this_ctx1;
                                    var transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
                                    this.compositeCtx = this.ctx;
                                    this.transparentCanvas = transparentCanvas.canvas;
                                    this.ctx = transparentCanvas.context;
                                    this.ctx.save();
                                    (_this_ctx1 = this.ctx).transform.apply(_this_ctx1, (0, $fyztb._)((0, _display_utils.getCurrentTransform)(this.compositeCtx)));
                                }
                                this.ctx.save();
                                resetCtxToDefault(this.ctx);
                                if (transform) {
                                    var _this_ctx2;
                                    (_this_ctx2 = this.ctx).transform.apply(_this_ctx2, (0, $fyztb._)(transform));
                                    this.outputScaleX = transform[0];
                                    this.outputScaleY = transform[0];
                                }
                                (_this_ctx = this.ctx).transform.apply(_this_ctx, (0, $fyztb._)(viewport.transform));
                                this.viewportScale = viewport.scale;
                                this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
                            }
                        },
                        {
                            key: "executeOperatorList",
                            value: function executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
                                var argsArray = operatorList.argsArray;
                                var fnArray = operatorList.fnArray;
                                var i = executionStartIdx || 0;
                                var argsArrayLen = argsArray.length;
                                if (argsArrayLen === i) return i;
                                var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
                                var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
                                var steps = 0;
                                var commonObjs = this.commonObjs;
                                var objs = this.objs;
                                var fnId;
                                while(true){
                                    if (stepper !== undefined && i === stepper.nextBreakPoint) {
                                        stepper.breakIt(i, continueCallback);
                                        return i;
                                    }
                                    fnId = fnArray[i];
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    if (fnId !== _util.OPS.dependency) this[fnId].apply(this, argsArray[i]);
                                    else try {
                                        for(var _iterator = argsArray[i][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var depObjId = _step.value;
                                            var objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                                            if (!objsPool.has(depObjId)) {
                                                objsPool.get(depObjId, continueCallback);
                                                return i;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    i++;
                                    if (i === argsArrayLen) return i;
                                    if (chunkOperations && ++steps > EXECUTION_STEPS) {
                                        if (Date.now() > endTime) {
                                            continueCallback();
                                            return i;
                                        }
                                        steps = 0;
                                    }
                                }
                            }
                        },
                        {
                            key: "endDrawing",
                            value: function endDrawing() {
                                (0, $lNbhr._)(this, _restoreInitialState, restoreInitialState).call(this);
                                this.cachedCanvases.clear();
                                this.cachedPatterns.clear();
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._cachedBitmapsMap.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var cache = _step.value;
                                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(var _iterator1 = cache.values()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                var canvas = _step1.value;
                                                if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) canvas.width = canvas.height = 0;
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                        cache.clear();
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this._cachedBitmapsMap.clear();
                                (0, $lNbhr._)(this, _drawFilter, drawFilter).call(this);
                            }
                        },
                        {
                            key: "_scaleImage",
                            value: function _scaleImage(img, inverseTransform) {
                                var width = img.width;
                                var height = img.height;
                                var widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
                                var heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
                                var paintWidth = width, paintHeight = height;
                                var tmpCanvasId = "prescale1";
                                var tmpCanvas, tmpCtx;
                                while(widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1){
                                    var newWidth = paintWidth, newHeight = paintHeight;
                                    if (widthScale > 2 && paintWidth > 1) {
                                        newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
                                        widthScale /= paintWidth / newWidth;
                                    }
                                    if (heightScale > 2 && paintHeight > 1) {
                                        newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
                                        heightScale /= paintHeight / newHeight;
                                    }
                                    tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
                                    tmpCtx = tmpCanvas.context;
                                    tmpCtx.clearRect(0, 0, newWidth, newHeight);
                                    tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
                                    img = tmpCanvas.canvas;
                                    paintWidth = newWidth;
                                    paintHeight = newHeight;
                                    tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
                                }
                                return {
                                    img: img,
                                    paintWidth: paintWidth,
                                    paintHeight: paintHeight
                                };
                            }
                        },
                        {
                            key: "_createMaskCanvas",
                            value: function _createMaskCanvas(img) {
                                var _fillCtx;
                                var ctx = this.ctx;
                                var width = img.width, height = img.height;
                                var fillColor = this.current.fillColor;
                                var isPatternFill = this.current.patternFill;
                                var currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                                var cache, cacheKey, scaled, maskCanvas;
                                if ((img.bitmap || img.data) && img.count > 1) {
                                    var mainKey = img.bitmap || img.data.buffer;
                                    cacheKey = JSON.stringify(isPatternFill ? currentTransform : [
                                        currentTransform.slice(0, 4),
                                        fillColor
                                    ]);
                                    cache = this._cachedBitmapsMap.get(mainKey);
                                    if (!cache) {
                                        cache = new Map();
                                        this._cachedBitmapsMap.set(mainKey, cache);
                                    }
                                    var cachedImage = cache.get(cacheKey);
                                    if (cachedImage && !isPatternFill) {
                                        var offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                                        var offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                                        return {
                                            canvas: cachedImage,
                                            offsetX: offsetX,
                                            offsetY: offsetY
                                        };
                                    }
                                    scaled = cachedImage;
                                }
                                if (!scaled) {
                                    maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                                    putBinaryImageMask(maskCanvas.context, img);
                                }
                                var maskToCanvas = _util.Util.transform(currentTransform, [
                                    1 / width,
                                    0,
                                    0,
                                    -1 / height,
                                    0,
                                    0
                                ]);
                                maskToCanvas = _util.Util.transform(maskToCanvas, [
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    -height
                                ]);
                                var cord1 = _util.Util.applyTransform([
                                    0,
                                    0
                                ], maskToCanvas);
                                var cord2 = _util.Util.applyTransform([
                                    width,
                                    height
                                ], maskToCanvas);
                                var rect = _util.Util.normalizeRect([
                                    cord1[0],
                                    cord1[1],
                                    cord2[0],
                                    cord2[1]
                                ]);
                                var drawnWidth = Math.round(rect[2] - rect[0]) || 1;
                                var drawnHeight = Math.round(rect[3] - rect[1]) || 1;
                                var fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
                                var fillCtx = fillCanvas.context;
                                var offsetX1 = Math.min(cord1[0], cord2[0]);
                                var offsetY1 = Math.min(cord1[1], cord2[1]);
                                fillCtx.translate(-offsetX1, -offsetY1);
                                (_fillCtx = fillCtx).transform.apply(_fillCtx, (0, $fyztb._)(maskToCanvas));
                                if (!scaled) {
                                    scaled = this._scaleImage(maskCanvas.canvas, (0, _display_utils.getCurrentTransformInverse)(fillCtx));
                                    scaled = scaled.img;
                                    if (cache && isPatternFill) cache.set(cacheKey, scaled);
                                }
                                fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(fillCtx), img.interpolate);
                                drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
                                fillCtx.globalCompositeOperation = "source-in";
                                var inverse = _util.Util.transform((0, _display_utils.getCurrentTransformInverse)(fillCtx), [
                                    1,
                                    0,
                                    0,
                                    1,
                                    -offsetX1,
                                    -offsetY1
                                ]);
                                fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, _pattern_helper.PathType.FILL) : fillColor;
                                fillCtx.fillRect(0, 0, width, height);
                                if (cache && !isPatternFill) {
                                    this.cachedCanvases.delete("fillCanvas");
                                    cache.set(cacheKey, fillCanvas.canvas);
                                }
                                return {
                                    canvas: fillCanvas.canvas,
                                    offsetX: Math.round(offsetX1),
                                    offsetY: Math.round(offsetY1)
                                };
                            }
                        },
                        {
                            key: "setLineWidth",
                            value: function setLineWidth(width) {
                                if (width !== this.current.lineWidth) this._cachedScaleForStroking[0] = -1;
                                this.current.lineWidth = width;
                                this.ctx.lineWidth = width;
                            }
                        },
                        {
                            key: "setLineCap",
                            value: function setLineCap(style) {
                                this.ctx.lineCap = LINE_CAP_STYLES[style];
                            }
                        },
                        {
                            key: "setLineJoin",
                            value: function setLineJoin(style) {
                                this.ctx.lineJoin = LINE_JOIN_STYLES[style];
                            }
                        },
                        {
                            key: "setMiterLimit",
                            value: function setMiterLimit(limit) {
                                this.ctx.miterLimit = limit;
                            }
                        },
                        {
                            key: "setDash",
                            value: function setDash(dashArray, dashPhase) {
                                var ctx = this.ctx;
                                if (ctx.setLineDash !== undefined) {
                                    ctx.setLineDash(dashArray);
                                    ctx.lineDashOffset = dashPhase;
                                }
                            }
                        },
                        {
                            key: "setRenderingIntent",
                            value: function setRenderingIntent(intent) {}
                        },
                        {
                            key: "setFlatness",
                            value: function setFlatness(flatness) {}
                        },
                        {
                            key: "setGState",
                            value: function setGState(states) {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = states[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _step_value = (0, $52tJv._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                                        switch(key){
                                            case "LW":
                                                this.setLineWidth(value);
                                                break;
                                            case "LC":
                                                this.setLineCap(value);
                                                break;
                                            case "LJ":
                                                this.setLineJoin(value);
                                                break;
                                            case "ML":
                                                this.setMiterLimit(value);
                                                break;
                                            case "D":
                                                this.setDash(value[0], value[1]);
                                                break;
                                            case "RI":
                                                this.setRenderingIntent(value);
                                                break;
                                            case "FL":
                                                this.setFlatness(value);
                                                break;
                                            case "Font":
                                                this.setFont(value[0], value[1]);
                                                break;
                                            case "CA":
                                                this.current.strokeAlpha = value;
                                                break;
                                            case "ca":
                                                this.current.fillAlpha = value;
                                                this.ctx.globalAlpha = value;
                                                break;
                                            case "BM":
                                                this.ctx.globalCompositeOperation = value;
                                                break;
                                            case "SMask":
                                                this.current.activeSMask = value ? this.tempSMask : null;
                                                this.tempSMask = null;
                                                this.checkSMaskState();
                                                break;
                                            case "TR":
                                                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                                                break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "inSMaskMode",
                            get: function get() {
                                return !!this.suspendedCtx;
                            }
                        },
                        {
                            key: "checkSMaskState",
                            value: function checkSMaskState() {
                                var inSMaskMode = this.inSMaskMode;
                                if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode();
                                else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
                            }
                        },
                        {
                            key: "beginSMaskMode",
                            value: function beginSMaskMode() {
                                var _ctx;
                                if (this.inSMaskMode) throw new Error("beginSMaskMode called while already in smask mode");
                                var drawnWidth = this.ctx.canvas.width;
                                var drawnHeight = this.ctx.canvas.height;
                                var cacheId = "smaskGroupAt" + this.groupLevel;
                                var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                                this.suspendedCtx = this.ctx;
                                this.ctx = scratchCanvas.context;
                                var ctx = this.ctx;
                                (_ctx = ctx).setTransform.apply(_ctx, (0, $fyztb._)((0, _display_utils.getCurrentTransform)(this.suspendedCtx)));
                                copyCtxState(this.suspendedCtx, ctx);
                                mirrorContextOperations(ctx, this.suspendedCtx);
                                this.setGState([
                                    [
                                        "BM",
                                        "source-over"
                                    ],
                                    [
                                        "ca",
                                        1
                                    ],
                                    [
                                        "CA",
                                        1
                                    ]
                                ]);
                            }
                        },
                        {
                            key: "endSMaskMode",
                            value: function endSMaskMode() {
                                if (!this.inSMaskMode) throw new Error("endSMaskMode called while not in smask mode");
                                this.ctx._removeMirroring();
                                copyCtxState(this.ctx, this.suspendedCtx);
                                this.ctx = this.suspendedCtx;
                                this.suspendedCtx = null;
                            }
                        },
                        {
                            key: "compose",
                            value: function compose(dirtyBox) {
                                if (!this.current.activeSMask) return;
                                if (!dirtyBox) dirtyBox = [
                                    0,
                                    0,
                                    this.ctx.canvas.width,
                                    this.ctx.canvas.height
                                ];
                                else {
                                    dirtyBox[0] = Math.floor(dirtyBox[0]);
                                    dirtyBox[1] = Math.floor(dirtyBox[1]);
                                    dirtyBox[2] = Math.ceil(dirtyBox[2]);
                                    dirtyBox[3] = Math.ceil(dirtyBox[3]);
                                }
                                var smask = this.current.activeSMask;
                                var suspendedCtx = this.suspendedCtx;
                                composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
                                this.ctx.save();
                                this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                                this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
                                this.ctx.restore();
                            }
                        },
                        {
                            key: "save",
                            value: function save() {
                                if (this.inSMaskMode) {
                                    copyCtxState(this.ctx, this.suspendedCtx);
                                    this.suspendedCtx.save();
                                } else this.ctx.save();
                                var old = this.current;
                                this.stateStack.push(old);
                                this.current = old.clone();
                            }
                        },
                        {
                            key: "restore",
                            value: function restore() {
                                if (this.stateStack.length === 0 && this.inSMaskMode) this.endSMaskMode();
                                if (this.stateStack.length !== 0) {
                                    this.current = this.stateStack.pop();
                                    if (this.inSMaskMode) {
                                        this.suspendedCtx.restore();
                                        copyCtxState(this.suspendedCtx, this.ctx);
                                    } else this.ctx.restore();
                                    this.checkSMaskState();
                                    this.pendingClip = null;
                                    this._cachedScaleForStroking[0] = -1;
                                    this._cachedGetSinglePixelWidth = null;
                                }
                            }
                        },
                        {
                            key: "transform",
                            value: function transform(a, b, c, d, e, f) {
                                this.ctx.transform(a, b, c, d, e, f);
                                this._cachedScaleForStroking[0] = -1;
                                this._cachedGetSinglePixelWidth = null;
                            }
                        },
                        {
                            key: "constructPath",
                            value: function constructPath(ops, args, minMax) {
                                var ctx = this.ctx;
                                var current = this.current;
                                var x = current.x, y = current.y;
                                var startX, startY;
                                var currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                                var isScalingMatrix = currentTransform[0] === 0 && currentTransform[3] === 0 || currentTransform[1] === 0 && currentTransform[2] === 0;
                                var minMaxForBezier = isScalingMatrix ? minMax.slice(0) : null;
                                for(var i = 0, j = 0, ii = ops.length; i < ii; i++)switch(ops[i] | 0){
                                    case _util.OPS.rectangle:
                                        x = args[j++];
                                        y = args[j++];
                                        var width = args[j++];
                                        var height = args[j++];
                                        var xw = x + width;
                                        var yh = y + height;
                                        ctx.moveTo(x, y);
                                        if (width === 0 || height === 0) ctx.lineTo(xw, yh);
                                        else {
                                            ctx.lineTo(xw, y);
                                            ctx.lineTo(xw, yh);
                                            ctx.lineTo(x, yh);
                                        }
                                        if (!isScalingMatrix) current.updateRectMinMax(currentTransform, [
                                            x,
                                            y,
                                            xw,
                                            yh
                                        ]);
                                        ctx.closePath();
                                        break;
                                    case _util.OPS.moveTo:
                                        x = args[j++];
                                        y = args[j++];
                                        ctx.moveTo(x, y);
                                        if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                                        break;
                                    case _util.OPS.lineTo:
                                        x = args[j++];
                                        y = args[j++];
                                        ctx.lineTo(x, y);
                                        if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                                        break;
                                    case _util.OPS.curveTo:
                                        startX = x;
                                        startY = y;
                                        x = args[j + 4];
                                        y = args[j + 5];
                                        ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                                        current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], args[j + 2], args[j + 3], x, y, minMaxForBezier);
                                        j += 6;
                                        break;
                                    case _util.OPS.curveTo2:
                                        startX = x;
                                        startY = y;
                                        ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                                        current.updateCurvePathMinMax(currentTransform, startX, startY, x, y, args[j], args[j + 1], args[j + 2], args[j + 3], minMaxForBezier);
                                        x = args[j + 2];
                                        y = args[j + 3];
                                        j += 4;
                                        break;
                                    case _util.OPS.curveTo3:
                                        startX = x;
                                        startY = y;
                                        x = args[j + 2];
                                        y = args[j + 3];
                                        ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
                                        current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], x, y, x, y, minMaxForBezier);
                                        j += 4;
                                        break;
                                    case _util.OPS.closePath:
                                        ctx.closePath();
                                        break;
                                }
                                if (isScalingMatrix) current.updateScalingPathMinMax(currentTransform, minMaxForBezier);
                                current.setCurrentPoint(x, y);
                            }
                        },
                        {
                            key: "closePath",
                            value: function closePath() {
                                this.ctx.closePath();
                            }
                        },
                        {
                            key: "stroke",
                            value: function stroke() {
                                var consumePath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                                var ctx = this.ctx;
                                var strokeColor = this.current.strokeColor;
                                ctx.globalAlpha = this.current.strokeAlpha;
                                if (this.contentVisible) {
                                    if (typeof strokeColor === "object" && (strokeColor === null || strokeColor === void 0 ? void 0 : strokeColor.getPattern)) {
                                        ctx.save();
                                        ctx.strokeStyle = strokeColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.STROKE);
                                        this.rescaleAndStroke(false);
                                        ctx.restore();
                                    } else this.rescaleAndStroke(true);
                                }
                                if (consumePath) this.consumePath(this.current.getClippedPathBoundingBox());
                                ctx.globalAlpha = this.current.fillAlpha;
                            }
                        },
                        {
                            key: "closeStroke",
                            value: function closeStroke() {
                                this.closePath();
                                this.stroke();
                            }
                        },
                        {
                            key: "fill",
                            value: function fill() {
                                var consumePath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                                var ctx = this.ctx;
                                var fillColor = this.current.fillColor;
                                var isPatternFill = this.current.patternFill;
                                var needRestore = false;
                                if (isPatternFill) {
                                    ctx.save();
                                    ctx.fillStyle = fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                                    needRestore = true;
                                }
                                var intersect = this.current.getClippedPathBoundingBox();
                                if (this.contentVisible && intersect !== null) {
                                    if (this.pendingEOFill) {
                                        ctx.fill("evenodd");
                                        this.pendingEOFill = false;
                                    } else ctx.fill();
                                }
                                if (needRestore) ctx.restore();
                                if (consumePath) this.consumePath(intersect);
                            }
                        },
                        {
                            key: "eoFill",
                            value: function eoFill() {
                                this.pendingEOFill = true;
                                this.fill();
                            }
                        },
                        {
                            key: "fillStroke",
                            value: function fillStroke() {
                                this.fill(false);
                                this.stroke(false);
                                this.consumePath();
                            }
                        },
                        {
                            key: "eoFillStroke",
                            value: function eoFillStroke() {
                                this.pendingEOFill = true;
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeFillStroke",
                            value: function closeFillStroke() {
                                this.closePath();
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeEOFillStroke",
                            value: function closeEOFillStroke() {
                                this.pendingEOFill = true;
                                this.closePath();
                                this.fillStroke();
                            }
                        },
                        {
                            key: "endPath",
                            value: function endPath() {
                                this.consumePath();
                            }
                        },
                        {
                            key: "clip",
                            value: function clip() {
                                this.pendingClip = NORMAL_CLIP;
                            }
                        },
                        {
                            key: "eoClip",
                            value: function eoClip() {
                                this.pendingClip = EO_CLIP;
                            }
                        },
                        {
                            key: "beginText",
                            value: function beginText() {
                                this.current.textMatrix = _util.IDENTITY_MATRIX;
                                this.current.textMatrixScale = 1;
                                this.current.x = this.current.lineX = 0;
                                this.current.y = this.current.lineY = 0;
                            }
                        },
                        {
                            key: "endText",
                            value: function endText() {
                                var paths = this.pendingTextPaths;
                                var ctx = this.ctx;
                                if (paths === undefined) {
                                    ctx.beginPath();
                                    return;
                                }
                                ctx.save();
                                ctx.beginPath();
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var path = _step.value;
                                        var _ctx;
                                        (_ctx = ctx).setTransform.apply(_ctx, (0, $fyztb._)(path.transform));
                                        ctx.translate(path.x, path.y);
                                        path.addToPath(ctx, path.fontSize);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                ctx.restore();
                                ctx.clip();
                                ctx.beginPath();
                                delete this.pendingTextPaths;
                            }
                        },
                        {
                            key: "setCharSpacing",
                            value: function setCharSpacing(spacing) {
                                this.current.charSpacing = spacing;
                            }
                        },
                        {
                            key: "setWordSpacing",
                            value: function setWordSpacing(spacing) {
                                this.current.wordSpacing = spacing;
                            }
                        },
                        {
                            key: "setHScale",
                            value: function setHScale(scale) {
                                this.current.textHScale = scale / 100;
                            }
                        },
                        {
                            key: "setLeading",
                            value: function setLeading(leading) {
                                this.current.leading = -leading;
                            }
                        },
                        {
                            key: "setFont",
                            value: function setFont(fontRefName, size) {
                                var _fontObj_systemFontInfo;
                                var fontObj = this.commonObjs.get(fontRefName);
                                var current = this.current;
                                if (!fontObj) throw new Error("Can't find font for ".concat(fontRefName));
                                current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                                if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) (0, _util.warn)("Invalid font matrix for font " + fontRefName);
                                if (size < 0) {
                                    size = -size;
                                    current.fontDirection = -1;
                                } else current.fontDirection = 1;
                                this.current.font = fontObj;
                                this.current.fontSize = size;
                                if (fontObj.isType3Font) return;
                                var name = fontObj.loadedName || "sans-serif";
                                var typeface = ((_fontObj_systemFontInfo = fontObj.systemFontInfo) === null || _fontObj_systemFontInfo === void 0 ? void 0 : _fontObj_systemFontInfo.css) || '"'.concat(name, '", ').concat(fontObj.fallbackName);
                                var bold = "normal";
                                if (fontObj.black) bold = "900";
                                else if (fontObj.bold) bold = "bold";
                                var italic = fontObj.italic ? "italic" : "normal";
                                var browserFontSize = size;
                                if (size < MIN_FONT_SIZE) browserFontSize = MIN_FONT_SIZE;
                                else if (size > MAX_FONT_SIZE) browserFontSize = MAX_FONT_SIZE;
                                this.current.fontSizeScale = size / browserFontSize;
                                this.ctx.font = "".concat(italic, " ").concat(bold, " ").concat(browserFontSize, "px ").concat(typeface);
                            }
                        },
                        {
                            key: "setTextRenderingMode",
                            value: function setTextRenderingMode(mode) {
                                this.current.textRenderingMode = mode;
                            }
                        },
                        {
                            key: "setTextRise",
                            value: function setTextRise(rise) {
                                this.current.textRise = rise;
                            }
                        },
                        {
                            key: "moveText",
                            value: function moveText(x, y) {
                                this.current.x = this.current.lineX += x;
                                this.current.y = this.current.lineY += y;
                            }
                        },
                        {
                            key: "setLeadingMoveText",
                            value: function setLeadingMoveText(x, y) {
                                this.setLeading(-y);
                                this.moveText(x, y);
                            }
                        },
                        {
                            key: "setTextMatrix",
                            value: function setTextMatrix(a, b, c, d, e, f) {
                                this.current.textMatrix = [
                                    a,
                                    b,
                                    c,
                                    d,
                                    e,
                                    f
                                ];
                                this.current.textMatrixScale = Math.hypot(a, b);
                                this.current.x = this.current.lineX = 0;
                                this.current.y = this.current.lineY = 0;
                            }
                        },
                        {
                            key: "nextLine",
                            value: function nextLine() {
                                this.moveText(0, this.current.leading);
                            }
                        },
                        {
                            key: "paintChar",
                            value: function paintChar(character, x, y, patternTransform) {
                                var ctx = this.ctx;
                                var current = this.current;
                                var font = current.font;
                                var textRenderingMode = current.textRenderingMode;
                                var fontSize = current.fontSize / current.fontSizeScale;
                                var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                                var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
                                var patternFill = current.patternFill && !font.missingFile;
                                var addToPath;
                                if (font.disableFontFace || isAddToPathSet || patternFill) addToPath = font.getPathGenerator(this.commonObjs, character);
                                if (font.disableFontFace || patternFill) {
                                    var _ctx;
                                    ctx.save();
                                    ctx.translate(x, y);
                                    ctx.beginPath();
                                    addToPath(ctx, fontSize);
                                    if (patternTransform) (_ctx = ctx).setTransform.apply(_ctx, (0, $fyztb._)(patternTransform));
                                    if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fill();
                                    if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.stroke();
                                    ctx.restore();
                                } else {
                                    if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fillText(character, x, y);
                                    if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.strokeText(character, x, y);
                                }
                                if (isAddToPathSet) {
                                    var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
                                    paths.push({
                                        transform: (0, _display_utils.getCurrentTransform)(ctx),
                                        x: x,
                                        y: y,
                                        fontSize: fontSize,
                                        addToPath: addToPath
                                    });
                                }
                            }
                        },
                        {
                            key: "isFontSubpixelAAEnabled",
                            get: function get() {
                                var _this_cachedCanvases_getCanvas = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10), ctx = _this_cachedCanvases_getCanvas.context;
                                ctx.scale(1.5, 1);
                                ctx.fillText("I", 0, 10);
                                var data = ctx.getImageData(0, 0, 10, 10).data;
                                var enabled = false;
                                for(var i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
                                    enabled = true;
                                    break;
                                }
                                return (0, _util.shadow)(this, "isFontSubpixelAAEnabled", enabled);
                            }
                        },
                        {
                            key: "showText",
                            value: function showText(glyphs) {
                                var _ctx;
                                var current = this.current;
                                var font = current.font;
                                if (font.isType3Font) return this.showType3Text(glyphs);
                                var fontSize = current.fontSize;
                                if (fontSize === 0) return undefined;
                                var ctx = this.ctx;
                                var fontSizeScale = current.fontSizeScale;
                                var charSpacing = current.charSpacing;
                                var wordSpacing = current.wordSpacing;
                                var fontDirection = current.fontDirection;
                                var textHScale = current.textHScale * fontDirection;
                                var glyphsLength = glyphs.length;
                                var vertical = font.vertical;
                                var spacingDir = vertical ? 1 : -1;
                                var defaultVMetrics = font.defaultVMetrics;
                                var widthAdvanceScale = fontSize * current.fontMatrix[0];
                                var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
                                ctx.save();
                                (_ctx = ctx).transform.apply(_ctx, (0, $fyztb._)(current.textMatrix));
                                ctx.translate(current.x, current.y + current.textRise);
                                if (fontDirection > 0) ctx.scale(textHScale, -1);
                                else ctx.scale(textHScale, 1);
                                var patternTransform;
                                if (current.patternFill) {
                                    ctx.save();
                                    var pattern = current.fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                                    patternTransform = (0, _display_utils.getCurrentTransform)(ctx);
                                    ctx.restore();
                                    ctx.fillStyle = pattern;
                                }
                                var lineWidth = current.lineWidth;
                                var scale = current.textMatrixScale;
                                if (scale === 0 || lineWidth === 0) {
                                    var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                                    if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) lineWidth = this.getSinglePixelWidth();
                                } else lineWidth /= scale;
                                if (fontSizeScale !== 1.0) {
                                    ctx.scale(fontSizeScale, fontSizeScale);
                                    lineWidth /= fontSizeScale;
                                }
                                ctx.lineWidth = lineWidth;
                                if (font.isInvalidPDFjsFont) {
                                    var chars = [];
                                    var width = 0;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = glyphs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var glyph = _step.value;
                                            chars.push(glyph.unicode);
                                            width += glyph.width;
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    ctx.fillText(chars.join(""), 0, 0);
                                    current.x += width * widthAdvanceScale * textHScale;
                                    ctx.restore();
                                    this.compose();
                                    return undefined;
                                }
                                var x = 0, i;
                                for(i = 0; i < glyphsLength; ++i){
                                    var glyph1 = glyphs[i];
                                    if (typeof glyph1 === "number") {
                                        x += spacingDir * glyph1 * fontSize / 1000;
                                        continue;
                                    }
                                    var restoreNeeded = false;
                                    var spacing = (glyph1.isSpace ? wordSpacing : 0) + charSpacing;
                                    var character = glyph1.fontChar;
                                    var accent = glyph1.accent;
                                    var scaledX = void 0, scaledY = void 0;
                                    var width1 = glyph1.width;
                                    if (vertical) {
                                        var vmetric = glyph1.vmetric || defaultVMetrics;
                                        var vx = -(glyph1.vmetric ? vmetric[1] : width1 * 0.5) * widthAdvanceScale;
                                        var vy = vmetric[2] * widthAdvanceScale;
                                        width1 = vmetric ? -vmetric[0] : width1;
                                        scaledX = vx / fontSizeScale;
                                        scaledY = (x + vy) / fontSizeScale;
                                    } else {
                                        scaledX = x / fontSizeScale;
                                        scaledY = 0;
                                    }
                                    if (font.remeasure && width1 > 0) {
                                        var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
                                        if (width1 < measuredWidth && this.isFontSubpixelAAEnabled) {
                                            var characterScaleX = width1 / measuredWidth;
                                            restoreNeeded = true;
                                            ctx.save();
                                            ctx.scale(characterScaleX, 1);
                                            scaledX /= characterScaleX;
                                        } else if (width1 !== measuredWidth) scaledX += (width1 - measuredWidth) / 2000 * fontSize / fontSizeScale;
                                    }
                                    if (this.contentVisible && (glyph1.isInFont || font.missingFile)) {
                                        if (simpleFillText && !accent) ctx.fillText(character, scaledX, scaledY);
                                        else {
                                            this.paintChar(character, scaledX, scaledY, patternTransform);
                                            if (accent) {
                                                var scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                                                var scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                                                this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
                                            }
                                        }
                                    }
                                    var charWidth = vertical ? width1 * widthAdvanceScale - spacing * fontDirection : width1 * widthAdvanceScale + spacing * fontDirection;
                                    x += charWidth;
                                    if (restoreNeeded) ctx.restore();
                                }
                                if (vertical) current.y -= x;
                                else current.x += x * textHScale;
                                ctx.restore();
                                this.compose();
                                return undefined;
                            }
                        },
                        {
                            key: "showType3Text",
                            value: function showType3Text(glyphs) {
                                var _ctx;
                                var ctx = this.ctx;
                                var current = this.current;
                                var font = current.font;
                                var fontSize = current.fontSize;
                                var fontDirection = current.fontDirection;
                                var spacingDir = font.vertical ? 1 : -1;
                                var charSpacing = current.charSpacing;
                                var wordSpacing = current.wordSpacing;
                                var textHScale = current.textHScale * fontDirection;
                                var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                                var glyphsLength = glyphs.length;
                                var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
                                var i, glyph, width, spacingLength;
                                if (isTextInvisible || fontSize === 0) return;
                                this._cachedScaleForStroking[0] = -1;
                                this._cachedGetSinglePixelWidth = null;
                                ctx.save();
                                (_ctx = ctx).transform.apply(_ctx, (0, $fyztb._)(current.textMatrix));
                                ctx.translate(current.x, current.y);
                                ctx.scale(textHScale, fontDirection);
                                for(i = 0; i < glyphsLength; ++i){
                                    glyph = glyphs[i];
                                    if (typeof glyph === "number") {
                                        spacingLength = spacingDir * glyph * fontSize / 1000;
                                        this.ctx.translate(spacingLength, 0);
                                        current.x += spacingLength * textHScale;
                                        continue;
                                    }
                                    var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                                    var operatorList = font.charProcOperatorList[glyph.operatorListId];
                                    if (!operatorList) {
                                        (0, _util.warn)('Type3 character "'.concat(glyph.operatorListId, '" is not available.'));
                                        continue;
                                    }
                                    if (this.contentVisible) {
                                        var _ctx1;
                                        this.processingType3 = glyph;
                                        this.save();
                                        ctx.scale(fontSize, fontSize);
                                        (_ctx1 = ctx).transform.apply(_ctx1, (0, $fyztb._)(fontMatrix));
                                        this.executeOperatorList(operatorList);
                                        this.restore();
                                    }
                                    var transformed = _util.Util.applyTransform([
                                        glyph.width,
                                        0
                                    ], fontMatrix);
                                    width = transformed[0] * fontSize + spacing;
                                    ctx.translate(width, 0);
                                    current.x += width * textHScale;
                                }
                                ctx.restore();
                                this.processingType3 = null;
                            }
                        },
                        {
                            key: "setCharWidth",
                            value: function setCharWidth(xWidth, yWidth) {}
                        },
                        {
                            key: "setCharWidthAndBounds",
                            value: function setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
                                this.ctx.rect(llx, lly, urx - llx, ury - lly);
                                this.ctx.clip();
                                this.endPath();
                            }
                        },
                        {
                            key: "getColorN_Pattern",
                            value: function getColorN_Pattern(IR) {
                                var _this = this;
                                var pattern;
                                if (IR[0] === "TilingPattern") {
                                    var color = IR[1];
                                    var baseTransform = this.baseTransform || (0, _display_utils.getCurrentTransform)(this.ctx);
                                    var canvasGraphicsFactory = {
                                        createCanvasGraphics: function(ctx) {
                                            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory, _this.filterFactory, {
                                                optionalContentConfig: _this.optionalContentConfig,
                                                markedContentStack: _this.markedContentStack
                                            });
                                        }
                                    };
                                    pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
                                } else pattern = this._getPattern(IR[1], IR[2]);
                                return pattern;
                            }
                        },
                        {
                            key: "setStrokeColorN",
                            value: function setStrokeColorN() {
                                this.current.strokeColor = this.getColorN_Pattern(arguments);
                            }
                        },
                        {
                            key: "setFillColorN",
                            value: function setFillColorN() {
                                this.current.fillColor = this.getColorN_Pattern(arguments);
                                this.current.patternFill = true;
                            }
                        },
                        {
                            key: "setStrokeRGBColor",
                            value: function setStrokeRGBColor(r, g, b) {
                                var color = _util.Util.makeHexColor(r, g, b);
                                this.ctx.strokeStyle = color;
                                this.current.strokeColor = color;
                            }
                        },
                        {
                            key: "setFillRGBColor",
                            value: function setFillRGBColor(r, g, b) {
                                var color = _util.Util.makeHexColor(r, g, b);
                                this.ctx.fillStyle = color;
                                this.current.fillColor = color;
                                this.current.patternFill = false;
                            }
                        },
                        {
                            key: "_getPattern",
                            value: function _getPattern(objId) {
                                var matrix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                                var pattern;
                                if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
                                else {
                                    pattern = (0, _pattern_helper.getShadingPattern)(this.getObject(objId));
                                    this.cachedPatterns.set(objId, pattern);
                                }
                                if (matrix) pattern.matrix = matrix;
                                return pattern;
                            }
                        },
                        {
                            key: "shadingFill",
                            value: function shadingFill(objId) {
                                if (!this.contentVisible) return;
                                var ctx = this.ctx;
                                this.save();
                                var pattern = this._getPattern(objId);
                                ctx.fillStyle = pattern.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.SHADING);
                                var inv = (0, _display_utils.getCurrentTransformInverse)(ctx);
                                if (inv) {
                                    var _ctx_canvas = ctx.canvas, width = _ctx_canvas.width, height = _ctx_canvas.height;
                                    var _util_Util_getAxialAlignedBoundingBox = (0, $52tJv._)(_util.Util.getAxialAlignedBoundingBox([
                                        0,
                                        0,
                                        width,
                                        height
                                    ], inv), 4), x0 = _util_Util_getAxialAlignedBoundingBox[0], y0 = _util_Util_getAxialAlignedBoundingBox[1], x1 = _util_Util_getAxialAlignedBoundingBox[2], y1 = _util_Util_getAxialAlignedBoundingBox[3];
                                    this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
                                } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                                this.compose(this.current.getClippedPathBoundingBox());
                                this.restore();
                            }
                        },
                        {
                            key: "beginInlineImage",
                            value: function beginInlineImage() {
                                (0, _util.unreachable)("Should not call beginInlineImage");
                            }
                        },
                        {
                            key: "beginImageData",
                            value: function beginImageData() {
                                (0, _util.unreachable)("Should not call beginImageData");
                            }
                        },
                        {
                            key: "paintFormXObjectBegin",
                            value: function paintFormXObjectBegin(matrix, bbox) {
                                if (!this.contentVisible) return;
                                this.save();
                                this.baseTransformStack.push(this.baseTransform);
                                if (Array.isArray(matrix) && matrix.length === 6) this.transform.apply(this, (0, $fyztb._)(matrix));
                                this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
                                if (bbox) {
                                    var width = bbox[2] - bbox[0];
                                    var height = bbox[3] - bbox[1];
                                    this.ctx.rect(bbox[0], bbox[1], width, height);
                                    this.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(this.ctx), bbox);
                                    this.clip();
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "paintFormXObjectEnd",
                            value: function paintFormXObjectEnd() {
                                if (!this.contentVisible) return;
                                this.restore();
                                this.baseTransform = this.baseTransformStack.pop();
                            }
                        },
                        {
                            key: "beginGroup",
                            value: function beginGroup(group) {
                                var _currentCtx, _groupCtx;
                                if (!this.contentVisible) return;
                                this.save();
                                if (this.inSMaskMode) {
                                    this.endSMaskMode();
                                    this.current.activeSMask = null;
                                }
                                var currentCtx = this.ctx;
                                if (!group.isolated) (0, _util.info)("TODO: Support non-isolated groups.");
                                if (group.knockout) (0, _util.warn)("Knockout groups not supported.");
                                var currentTransform = (0, _display_utils.getCurrentTransform)(currentCtx);
                                if (group.matrix) (_currentCtx = currentCtx).transform.apply(_currentCtx, (0, $fyztb._)(group.matrix));
                                if (!group.bbox) throw new Error("Bounding box is required.");
                                var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, (0, _display_utils.getCurrentTransform)(currentCtx));
                                var canvasBounds = [
                                    0,
                                    0,
                                    currentCtx.canvas.width,
                                    currentCtx.canvas.height
                                ];
                                bounds = _util.Util.intersect(bounds, canvasBounds) || [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                var offsetX = Math.floor(bounds[0]);
                                var offsetY = Math.floor(bounds[1]);
                                var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
                                var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
                                var scaleX = 1, scaleY = 1;
                                if (drawnWidth > MAX_GROUP_SIZE) {
                                    scaleX = drawnWidth / MAX_GROUP_SIZE;
                                    drawnWidth = MAX_GROUP_SIZE;
                                }
                                if (drawnHeight > MAX_GROUP_SIZE) {
                                    scaleY = drawnHeight / MAX_GROUP_SIZE;
                                    drawnHeight = MAX_GROUP_SIZE;
                                }
                                this.current.startNewPathAndClipBox([
                                    0,
                                    0,
                                    drawnWidth,
                                    drawnHeight
                                ]);
                                var cacheId = "groupAt" + this.groupLevel;
                                if (group.smask) cacheId += "_smask_" + this.smaskCounter++ % 2;
                                var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                                var groupCtx = scratchCanvas.context;
                                groupCtx.scale(1 / scaleX, 1 / scaleY);
                                groupCtx.translate(-offsetX, -offsetY);
                                (_groupCtx = groupCtx).transform.apply(_groupCtx, (0, $fyztb._)(currentTransform));
                                if (group.smask) this.smaskStack.push({
                                    canvas: scratchCanvas.canvas,
                                    context: groupCtx,
                                    offsetX: offsetX,
                                    offsetY: offsetY,
                                    scaleX: scaleX,
                                    scaleY: scaleY,
                                    subtype: group.smask.subtype,
                                    backdrop: group.smask.backdrop,
                                    transferMap: group.smask.transferMap || null,
                                    startTransformInverse: null
                                });
                                else {
                                    currentCtx.setTransform(1, 0, 0, 1, 0, 0);
                                    currentCtx.translate(offsetX, offsetY);
                                    currentCtx.scale(scaleX, scaleY);
                                    currentCtx.save();
                                }
                                copyCtxState(currentCtx, groupCtx);
                                this.ctx = groupCtx;
                                this.setGState([
                                    [
                                        "BM",
                                        "source-over"
                                    ],
                                    [
                                        "ca",
                                        1
                                    ],
                                    [
                                        "CA",
                                        1
                                    ]
                                ]);
                                this.groupStack.push(currentCtx);
                                this.groupLevel++;
                            }
                        },
                        {
                            key: "endGroup",
                            value: function endGroup(group) {
                                if (!this.contentVisible) return;
                                this.groupLevel--;
                                var groupCtx = this.ctx;
                                var ctx = this.groupStack.pop();
                                this.ctx = ctx;
                                this.ctx.imageSmoothingEnabled = false;
                                if (group.smask) {
                                    this.tempSMask = this.smaskStack.pop();
                                    this.restore();
                                } else {
                                    var _this_ctx;
                                    this.ctx.restore();
                                    var currentMtx = (0, _display_utils.getCurrentTransform)(this.ctx);
                                    this.restore();
                                    this.ctx.save();
                                    (_this_ctx = this.ctx).setTransform.apply(_this_ctx, (0, $fyztb._)(currentMtx));
                                    var dirtyBox = _util.Util.getAxialAlignedBoundingBox([
                                        0,
                                        0,
                                        groupCtx.canvas.width,
                                        groupCtx.canvas.height
                                    ], currentMtx);
                                    this.ctx.drawImage(groupCtx.canvas, 0, 0);
                                    this.ctx.restore();
                                    this.compose(dirtyBox);
                                }
                            }
                        },
                        {
                            key: "beginAnnotation",
                            value: function beginAnnotation(id, rect, transform, matrix, hasOwnCanvas) {
                                var _this_ctx;
                                (0, $lNbhr._)(this, _restoreInitialState, restoreInitialState).call(this);
                                resetCtxToDefault(this.ctx);
                                this.ctx.save();
                                this.save();
                                if (this.baseTransform) (_this_ctx = this.ctx).setTransform.apply(_this_ctx, (0, $fyztb._)(this.baseTransform));
                                if (Array.isArray(rect) && rect.length === 4) {
                                    var width = rect[2] - rect[0];
                                    var height = rect[3] - rect[1];
                                    if (hasOwnCanvas && this.annotationCanvasMap) {
                                        transform = transform.slice();
                                        transform[4] -= rect[0];
                                        transform[5] -= rect[1];
                                        rect = rect.slice();
                                        rect[0] = rect[1] = 0;
                                        rect[2] = width;
                                        rect[3] = height;
                                        var _util_Util_singularValueDecompose2dScale = (0, $52tJv._)(_util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(this.ctx)), 2), scaleX = _util_Util_singularValueDecompose2dScale[0], scaleY = _util_Util_singularValueDecompose2dScale[1];
                                        var viewportScale = this.viewportScale;
                                        var canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                                        var canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                                        this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                                        var _this_annotationCanvas = this.annotationCanvas, canvas = _this_annotationCanvas.canvas, context = _this_annotationCanvas.context;
                                        this.annotationCanvasMap.set(id, canvas);
                                        this.annotationCanvas.savedCtx = this.ctx;
                                        this.ctx = context;
                                        this.ctx.save();
                                        this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height * scaleY);
                                        resetCtxToDefault(this.ctx);
                                    } else {
                                        resetCtxToDefault(this.ctx);
                                        this.ctx.rect(rect[0], rect[1], width, height);
                                        this.ctx.clip();
                                        this.endPath();
                                    }
                                }
                                this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                                this.transform.apply(this, (0, $fyztb._)(transform));
                                this.transform.apply(this, (0, $fyztb._)(matrix));
                            }
                        },
                        {
                            key: "endAnnotation",
                            value: function endAnnotation() {
                                if (this.annotationCanvas) {
                                    this.ctx.restore();
                                    (0, $lNbhr._)(this, _drawFilter, drawFilter).call(this);
                                    this.ctx = this.annotationCanvas.savedCtx;
                                    delete this.annotationCanvas.savedCtx;
                                    delete this.annotationCanvas;
                                }
                            }
                        },
                        {
                            key: "paintImageMaskXObject",
                            value: function paintImageMaskXObject(img) {
                                if (!this.contentVisible) return;
                                var count = img.count;
                                img = this.getObject(img.data, img);
                                img.count = count;
                                var ctx = this.ctx;
                                var glyph = this.processingType3;
                                if (glyph) {
                                    if (glyph.compiled === undefined) glyph.compiled = compileType3Glyph(img);
                                    if (glyph.compiled) {
                                        glyph.compiled(ctx);
                                        return;
                                    }
                                }
                                var mask = this._createMaskCanvas(img);
                                var maskCanvas = mask.canvas;
                                ctx.save();
                                ctx.setTransform(1, 0, 0, 1, 0, 0);
                                ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
                                ctx.restore();
                                this.compose();
                            }
                        },
                        {
                            key: "paintImageMaskXObjectRepeat",
                            value: function paintImageMaskXObjectRepeat(img, scaleX) {
                                var skewX = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, skewY = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, scaleY = arguments.length > 4 ? arguments[4] : void 0, positions = arguments.length > 5 ? arguments[5] : void 0;
                                if (!this.contentVisible) return;
                                img = this.getObject(img.data, img);
                                var ctx = this.ctx;
                                ctx.save();
                                var currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                                ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
                                var mask = this._createMaskCanvas(img);
                                ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
                                for(var i = 0, ii = positions.length; i < ii; i += 2){
                                    var trans = _util.Util.transform(currentTransform, [
                                        scaleX,
                                        skewX,
                                        skewY,
                                        scaleY,
                                        positions[i],
                                        positions[i + 1]
                                    ]);
                                    var _util_Util_applyTransform = (0, $52tJv._)(_util.Util.applyTransform([
                                        0,
                                        0
                                    ], trans), 2), x = _util_Util_applyTransform[0], y = _util_Util_applyTransform[1];
                                    ctx.drawImage(mask.canvas, x, y);
                                }
                                ctx.restore();
                                this.compose();
                            }
                        },
                        {
                            key: "paintImageMaskXObjectGroup",
                            value: function paintImageMaskXObjectGroup(images) {
                                if (!this.contentVisible) return;
                                var ctx = this.ctx;
                                var fillColor = this.current.fillColor;
                                var isPatternFill = this.current.patternFill;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = images[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var image = _step.value;
                                        var _ctx;
                                        var data = image.data, width = image.width, height = image.height, transform = image.transform;
                                        var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                                        var maskCtx = maskCanvas.context;
                                        maskCtx.save();
                                        var img = this.getObject(data, image);
                                        putBinaryImageMask(maskCtx, img);
                                        maskCtx.globalCompositeOperation = "source-in";
                                        maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL) : fillColor;
                                        maskCtx.fillRect(0, 0, width, height);
                                        maskCtx.restore();
                                        ctx.save();
                                        (_ctx = ctx).transform.apply(_ctx, (0, $fyztb._)(transform));
                                        ctx.scale(1, -1);
                                        drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
                                        ctx.restore();
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this.compose();
                            }
                        },
                        {
                            key: "paintImageXObject",
                            value: function paintImageXObject(objId) {
                                if (!this.contentVisible) return;
                                var imgData = this.getObject(objId);
                                if (!imgData) {
                                    (0, _util.warn)("Dependent image isn't ready yet");
                                    return;
                                }
                                this.paintInlineImageXObject(imgData);
                            }
                        },
                        {
                            key: "paintImageXObjectRepeat",
                            value: function paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
                                if (!this.contentVisible) return;
                                var imgData = this.getObject(objId);
                                if (!imgData) {
                                    (0, _util.warn)("Dependent image isn't ready yet");
                                    return;
                                }
                                var width = imgData.width;
                                var height = imgData.height;
                                var map = [];
                                for(var i = 0, ii = positions.length; i < ii; i += 2)map.push({
                                    transform: [
                                        scaleX,
                                        0,
                                        0,
                                        scaleY,
                                        positions[i],
                                        positions[i + 1]
                                    ],
                                    x: 0,
                                    y: 0,
                                    w: width,
                                    h: height
                                });
                                this.paintInlineImageXObjectGroup(imgData, map);
                            }
                        },
                        {
                            key: "applyTransferMapsToCanvas",
                            value: function applyTransferMapsToCanvas(ctx) {
                                if (this.current.transferMaps !== "none") {
                                    ctx.filter = this.current.transferMaps;
                                    ctx.drawImage(ctx.canvas, 0, 0);
                                    ctx.filter = "none";
                                }
                                return ctx.canvas;
                            }
                        },
                        {
                            key: "applyTransferMapsToBitmap",
                            value: function applyTransferMapsToBitmap(imgData) {
                                if (this.current.transferMaps === "none") return imgData.bitmap;
                                var bitmap = imgData.bitmap, width = imgData.width, height = imgData.height;
                                var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                                var tmpCtx = tmpCanvas.context;
                                tmpCtx.filter = this.current.transferMaps;
                                tmpCtx.drawImage(bitmap, 0, 0);
                                tmpCtx.filter = "none";
                                return tmpCanvas.canvas;
                            }
                        },
                        {
                            key: "paintInlineImageXObject",
                            value: function paintInlineImageXObject(imgData) {
                                if (!this.contentVisible) return;
                                var width = imgData.width;
                                var height = imgData.height;
                                var ctx = this.ctx;
                                this.save();
                                if (!_util.isNodeJS) {
                                    var filter = ctx.filter;
                                    if (filter !== "none" && filter !== "") ctx.filter = "none";
                                }
                                ctx.scale(1 / width, -1 / height);
                                var imgToPaint;
                                if (imgData.bitmap) imgToPaint = this.applyTransferMapsToBitmap(imgData);
                                else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
                                else {
                                    var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                                    var tmpCtx = tmpCanvas.context;
                                    putBinaryImageData(tmpCtx, imgData);
                                    imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                                }
                                var scaled = this._scaleImage(imgToPaint, (0, _display_utils.getCurrentTransformInverse)(ctx));
                                ctx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(ctx), imgData.interpolate);
                                drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
                                this.compose();
                                this.restore();
                            }
                        },
                        {
                            key: "paintInlineImageXObjectGroup",
                            value: function paintInlineImageXObjectGroup(imgData, map) {
                                if (!this.contentVisible) return;
                                var ctx = this.ctx;
                                var imgToPaint;
                                if (imgData.bitmap) imgToPaint = imgData.bitmap;
                                else {
                                    var w = imgData.width;
                                    var h = imgData.height;
                                    var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
                                    var tmpCtx = tmpCanvas.context;
                                    putBinaryImageData(tmpCtx, imgData);
                                    imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                                }
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = map[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var entry = _step.value;
                                        var _ctx;
                                        ctx.save();
                                        (_ctx = ctx).transform.apply(_ctx, (0, $fyztb._)(entry.transform));
                                        ctx.scale(1, -1);
                                        drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                                        ctx.restore();
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this.compose();
                            }
                        },
                        {
                            key: "paintSolidColorImageMask",
                            value: function paintSolidColorImageMask() {
                                if (!this.contentVisible) return;
                                this.ctx.fillRect(0, 0, 1, 1);
                                this.compose();
                            }
                        },
                        {
                            key: "markPoint",
                            value: function markPoint(tag) {}
                        },
                        {
                            key: "markPointProps",
                            value: function markPointProps(tag, properties) {}
                        },
                        {
                            key: "beginMarkedContent",
                            value: function beginMarkedContent(tag) {
                                this.markedContentStack.push({
                                    visible: true
                                });
                            }
                        },
                        {
                            key: "beginMarkedContentProps",
                            value: function beginMarkedContentProps(tag, properties) {
                                if (tag === "OC") this.markedContentStack.push({
                                    visible: this.optionalContentConfig.isVisible(properties)
                                });
                                else this.markedContentStack.push({
                                    visible: true
                                });
                                this.contentVisible = this.isContentVisible();
                            }
                        },
                        {
                            key: "endMarkedContent",
                            value: function endMarkedContent() {
                                this.markedContentStack.pop();
                                this.contentVisible = this.isContentVisible();
                            }
                        },
                        {
                            key: "beginCompat",
                            value: function beginCompat() {}
                        },
                        {
                            key: "endCompat",
                            value: function endCompat() {}
                        },
                        {
                            key: "consumePath",
                            value: function consumePath(clipBox) {
                                var isEmpty = this.current.isEmptyClip();
                                if (this.pendingClip) this.current.updateClipFromPath();
                                if (!this.pendingClip) this.compose(clipBox);
                                var ctx = this.ctx;
                                if (this.pendingClip) {
                                    if (!isEmpty) {
                                        if (this.pendingClip === EO_CLIP) ctx.clip("evenodd");
                                        else ctx.clip();
                                    }
                                    this.pendingClip = null;
                                }
                                this.current.startNewPathAndClipBox(this.current.clipBox);
                                ctx.beginPath();
                            }
                        },
                        {
                            key: "getSinglePixelWidth",
                            value: function getSinglePixelWidth() {
                                if (!this._cachedGetSinglePixelWidth) {
                                    var m = (0, _display_utils.getCurrentTransform)(this.ctx);
                                    if (m[1] === 0 && m[2] === 0) this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
                                    else {
                                        var absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                                        var normX = Math.hypot(m[0], m[2]);
                                        var normY = Math.hypot(m[1], m[3]);
                                        this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
                                    }
                                }
                                return this._cachedGetSinglePixelWidth;
                            }
                        },
                        {
                            key: "getScaleForStroking",
                            value: function getScaleForStroking() {
                                if (this._cachedScaleForStroking[0] === -1) {
                                    var lineWidth = this.current.lineWidth;
                                    var _this_ctx_getTransform = this.ctx.getTransform(), a = _this_ctx_getTransform.a, b = _this_ctx_getTransform.b, c = _this_ctx_getTransform.c, d = _this_ctx_getTransform.d;
                                    var scaleX, scaleY;
                                    if (b === 0 && c === 0) {
                                        var normX = Math.abs(a);
                                        var normY = Math.abs(d);
                                        if (normX === normY) {
                                            if (lineWidth === 0) scaleX = scaleY = 1 / normX;
                                            else {
                                                var scaledLineWidth = normX * lineWidth;
                                                scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                                            }
                                        } else if (lineWidth === 0) {
                                            scaleX = 1 / normX;
                                            scaleY = 1 / normY;
                                        } else {
                                            var scaledXLineWidth = normX * lineWidth;
                                            var scaledYLineWidth = normY * lineWidth;
                                            scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                                            scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                                        }
                                    } else {
                                        var absDet = Math.abs(a * d - b * c);
                                        var normX1 = Math.hypot(a, b);
                                        var normY1 = Math.hypot(c, d);
                                        if (lineWidth === 0) {
                                            scaleX = normY1 / absDet;
                                            scaleY = normX1 / absDet;
                                        } else {
                                            var baseArea = lineWidth * absDet;
                                            scaleX = normY1 > baseArea ? normY1 / baseArea : 1;
                                            scaleY = normX1 > baseArea ? normX1 / baseArea : 1;
                                        }
                                    }
                                    this._cachedScaleForStroking[0] = scaleX;
                                    this._cachedScaleForStroking[1] = scaleY;
                                }
                                return this._cachedScaleForStroking;
                            }
                        },
                        {
                            key: "rescaleAndStroke",
                            value: function rescaleAndStroke(saveRestore) {
                                var ctx = this.ctx;
                                var lineWidth = this.current.lineWidth;
                                var _this_getScaleForStroking = (0, $52tJv._)(this.getScaleForStroking(), 2), scaleX = _this_getScaleForStroking[0], scaleY = _this_getScaleForStroking[1];
                                ctx.lineWidth = lineWidth || 1;
                                if (scaleX === 1 && scaleY === 1) {
                                    ctx.stroke();
                                    return;
                                }
                                var dashes = ctx.getLineDash();
                                if (saveRestore) ctx.save();
                                ctx.scale(scaleX, scaleY);
                                if (dashes.length > 0) {
                                    var scale = Math.max(scaleX, scaleY);
                                    ctx.setLineDash(dashes.map(function(x) {
                                        return x / scale;
                                    }));
                                    ctx.lineDashOffset /= scale;
                                }
                                ctx.stroke();
                                if (saveRestore) ctx.restore();
                            }
                        },
                        {
                            key: "isContentVisible",
                            value: function isContentVisible() {
                                for(var i = this.markedContentStack.length - 1; i >= 0; i--){
                                    if (!this.markedContentStack[i].visible) return false;
                                }
                                return true;
                            }
                        }
                    ]);
                    return CanvasGraphics;
                }();
                function restoreInitialState() {
                    while(this.stateStack.length || this.inSMaskMode)this.restore();
                    this.ctx.restore();
                    if (this.transparentCanvas) {
                        this.ctx = this.compositeCtx;
                        this.ctx.save();
                        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                        this.ctx.drawImage(this.transparentCanvas, 0, 0);
                        this.ctx.restore();
                        this.transparentCanvas = null;
                    }
                }
                function drawFilter() {
                    if (this.pageColors) {
                        var hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
                        if (hcmFilterId !== "none") {
                            var savedFilter = this.ctx.filter;
                            this.ctx.filter = hcmFilterId;
                            this.ctx.drawImage(this.ctx.canvas, 0, 0);
                            this.ctx.filter = savedFilter;
                        }
                    }
                }
                exports.CanvasGraphics = CanvasGraphics;
                for(var op in _util.OPS)if (CanvasGraphics.prototype[op] !== undefined) CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
            /***/ },
            /* 12 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TilingPattern = exports.PathType = void 0;
                exports.getShadingPattern = getShadingPattern;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var PathType = {
                    FILL: "Fill",
                    STROKE: "Stroke",
                    SHADING: "Shading"
                };
                exports.PathType = PathType;
                function applyBoundingBox(ctx, bbox) {
                    if (!bbox) return;
                    var width = bbox[2] - bbox[0];
                    var height = bbox[3] - bbox[1];
                    var region = new Path2D();
                    region.rect(bbox[0], bbox[1], width, height);
                    ctx.clip(region);
                }
                var BaseShadingPattern = /*#__PURE__*/ function() {
                    function BaseShadingPattern() {
                        (0, $5sFFs._)(this, BaseShadingPattern);
                        if (this.constructor === BaseShadingPattern) (0, _util.unreachable)("Cannot initialize BaseShadingPattern.");
                    }
                    (0, $8O2fV._)(BaseShadingPattern, [
                        {
                            key: "getPattern",
                            value: function getPattern() {
                                (0, _util.unreachable)("Abstract method `getPattern` called.");
                            }
                        }
                    ]);
                    return BaseShadingPattern;
                }();
                var RadialAxialShadingPattern = /*#__PURE__*/ function(BaseShadingPattern) {
                    (0, $kcqLc._)(RadialAxialShadingPattern, BaseShadingPattern);
                    var _super = (0, $4jYWU._)(RadialAxialShadingPattern);
                    function RadialAxialShadingPattern(IR) {
                        (0, $5sFFs._)(this, RadialAxialShadingPattern);
                        var _this;
                        _this = _super.call(this);
                        _this._type = IR[1];
                        _this._bbox = IR[2];
                        _this._colorStops = IR[3];
                        _this._p0 = IR[4];
                        _this._p1 = IR[5];
                        _this._r0 = IR[6];
                        _this._r1 = IR[7];
                        _this.matrix = null;
                        return _this;
                    }
                    (0, $8O2fV._)(RadialAxialShadingPattern, [
                        {
                            key: "_createGradient",
                            value: function _createGradient(ctx) {
                                var grad;
                                if (this._type === "axial") grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                                else if (this._type === "radial") grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._colorStops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var colorStop = _step.value;
                                        grad.addColorStop(colorStop[0], colorStop[1]);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return grad;
                            }
                        },
                        {
                            key: "getPattern",
                            value: function getPattern(ctx, owner, inverse, pathType) {
                                var pattern;
                                if (pathType === PathType.STROKE || pathType === PathType.FILL) {
                                    var _tmpCtx, _tmpCtx1;
                                    var ownerBBox = owner.current.getClippedPathBoundingBox(pathType, (0, _display_utils.getCurrentTransform)(ctx)) || [
                                        0,
                                        0,
                                        0,
                                        0
                                    ];
                                    var width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
                                    var height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
                                    var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
                                    var tmpCtx = tmpCanvas.context;
                                    tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                                    tmpCtx.beginPath();
                                    tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                                    tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
                                    inverse = _util.Util.transform(inverse, [
                                        1,
                                        0,
                                        0,
                                        1,
                                        ownerBBox[0],
                                        ownerBBox[1]
                                    ]);
                                    (_tmpCtx = tmpCtx).transform.apply(_tmpCtx, (0, $fyztb._)(owner.baseTransform));
                                    if (this.matrix) (_tmpCtx1 = tmpCtx).transform.apply(_tmpCtx1, (0, $fyztb._)(this.matrix));
                                    applyBoundingBox(tmpCtx, this._bbox);
                                    tmpCtx.fillStyle = this._createGradient(tmpCtx);
                                    tmpCtx.fill();
                                    pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
                                    var domMatrix = new DOMMatrix(inverse);
                                    pattern.setTransform(domMatrix);
                                } else {
                                    applyBoundingBox(ctx, this._bbox);
                                    pattern = this._createGradient(ctx);
                                }
                                return pattern;
                            }
                        }
                    ]);
                    return RadialAxialShadingPattern;
                }(BaseShadingPattern);
                function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
                    var coords = context.coords, colors = context.colors;
                    var bytes = data.data, rowSize = data.width * 4;
                    var tmp;
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    if (coords[p2 + 1] > coords[p3 + 1]) {
                        tmp = p2;
                        p2 = p3;
                        p3 = tmp;
                        tmp = c2;
                        c2 = c3;
                        c3 = tmp;
                    }
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
                    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
                    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
                    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
                    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
                    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
                    if (y1 >= y3) return;
                    var c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
                    var c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
                    var c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
                    var minY = Math.round(y1), maxY = Math.round(y3);
                    var xa, car, cag, cab;
                    var xb, cbr, cbg, cbb;
                    for(var y = minY; y <= maxY; y++){
                        if (y < y2) {
                            var k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
                            xa = x1 - (x1 - x2) * k;
                            car = c1r - (c1r - c2r) * k;
                            cag = c1g - (c1g - c2g) * k;
                            cab = c1b - (c1b - c2b) * k;
                        } else {
                            var k1 = void 0;
                            if (y > y3) k1 = 1;
                            else if (y2 === y3) k1 = 0;
                            else k1 = (y2 - y) / (y2 - y3);
                            xa = x2 - (x2 - x3) * k1;
                            car = c2r - (c2r - c3r) * k1;
                            cag = c2g - (c2g - c3g) * k1;
                            cab = c2b - (c2b - c3b) * k1;
                        }
                        var k2 = void 0;
                        if (y < y1) k2 = 0;
                        else if (y > y3) k2 = 1;
                        else k2 = (y1 - y) / (y1 - y3);
                        xb = x1 - (x1 - x3) * k2;
                        cbr = c1r - (c1r - c3r) * k2;
                        cbg = c1g - (c1g - c3g) * k2;
                        cbb = c1b - (c1b - c3b) * k2;
                        var x1_ = Math.round(Math.min(xa, xb));
                        var x2_ = Math.round(Math.max(xa, xb));
                        var j = rowSize * y + x1_ * 4;
                        for(var x = x1_; x <= x2_; x++){
                            k2 = (xa - x) / (xa - xb);
                            if (k2 < 0) k2 = 0;
                            else if (k2 > 1) k2 = 1;
                            bytes[j++] = car - (car - cbr) * k2 | 0;
                            bytes[j++] = cag - (cag - cbg) * k2 | 0;
                            bytes[j++] = cab - (cab - cbb) * k2 | 0;
                            bytes[j++] = 255;
                        }
                    }
                }
                function drawFigure(data, figure, context) {
                    var ps = figure.coords;
                    var cs = figure.colors;
                    var i, ii;
                    switch(figure.type){
                        case "lattice":
                            var verticesPerRow = figure.verticesPerRow;
                            var rows = Math.floor(ps.length / verticesPerRow) - 1;
                            var cols = verticesPerRow - 1;
                            for(i = 0; i < rows; i++){
                                var q = i * verticesPerRow;
                                for(var j = 0; j < cols; j++, q++){
                                    drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                                    drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                                }
                            }
                            break;
                        case "triangles":
                            for(i = 0, ii = ps.length; i < ii; i += 3)drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
                            break;
                        default:
                            throw new Error("illegal figure");
                    }
                }
                var MeshShadingPattern = /*#__PURE__*/ function(BaseShadingPattern) {
                    (0, $kcqLc._)(MeshShadingPattern, BaseShadingPattern);
                    var _super = (0, $4jYWU._)(MeshShadingPattern);
                    function MeshShadingPattern(IR) {
                        (0, $5sFFs._)(this, MeshShadingPattern);
                        var _this;
                        _this = _super.call(this);
                        _this._coords = IR[2];
                        _this._colors = IR[3];
                        _this._figures = IR[4];
                        _this._bounds = IR[5];
                        _this._bbox = IR[7];
                        _this._background = IR[8];
                        _this.matrix = null;
                        return _this;
                    }
                    (0, $8O2fV._)(MeshShadingPattern, [
                        {
                            key: "_createMeshCanvas",
                            value: function _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
                                var EXPECTED_SCALE = 1.1;
                                var MAX_PATTERN_SIZE = 3000;
                                var BORDER_SIZE = 2;
                                var offsetX = Math.floor(this._bounds[0]);
                                var offsetY = Math.floor(this._bounds[1]);
                                var boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
                                var boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
                                var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                                var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                                var scaleX = boundsWidth / width;
                                var scaleY = boundsHeight / height;
                                var context = {
                                    coords: this._coords,
                                    colors: this._colors,
                                    offsetX: -offsetX,
                                    offsetY: -offsetY,
                                    scaleX: 1 / scaleX,
                                    scaleY: 1 / scaleY
                                };
                                var paddedWidth = width + BORDER_SIZE * 2;
                                var paddedHeight = height + BORDER_SIZE * 2;
                                var tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
                                var tmpCtx = tmpCanvas.context;
                                var data = tmpCtx.createImageData(width, height);
                                if (backgroundColor) {
                                    var bytes = data.data;
                                    for(var i = 0, ii = bytes.length; i < ii; i += 4){
                                        bytes[i] = backgroundColor[0];
                                        bytes[i + 1] = backgroundColor[1];
                                        bytes[i + 2] = backgroundColor[2];
                                        bytes[i + 3] = 255;
                                    }
                                }
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._figures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var figure = _step.value;
                                        drawFigure(data, figure, context);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
                                var canvas = tmpCanvas.canvas;
                                return {
                                    canvas: canvas,
                                    offsetX: offsetX - BORDER_SIZE * scaleX,
                                    offsetY: offsetY - BORDER_SIZE * scaleY,
                                    scaleX: scaleX,
                                    scaleY: scaleY
                                };
                            }
                        },
                        {
                            key: "getPattern",
                            value: function getPattern(ctx, owner, inverse, pathType) {
                                applyBoundingBox(ctx, this._bbox);
                                var scale;
                                if (pathType === PathType.SHADING) scale = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(ctx));
                                else {
                                    scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
                                    if (this.matrix) {
                                        var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                                        scale = [
                                            scale[0] * matrixScale[0],
                                            scale[1] * matrixScale[1]
                                        ];
                                    }
                                }
                                var temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
                                if (pathType !== PathType.SHADING) {
                                    var _ctx, _ctx1;
                                    (_ctx = ctx).setTransform.apply(_ctx, (0, $fyztb._)(owner.baseTransform));
                                    if (this.matrix) (_ctx1 = ctx).transform.apply(_ctx1, (0, $fyztb._)(this.matrix));
                                }
                                ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                                ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
                                return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
                            }
                        }
                    ]);
                    return MeshShadingPattern;
                }(BaseShadingPattern);
                var DummyShadingPattern = /*#__PURE__*/ function(BaseShadingPattern) {
                    (0, $kcqLc._)(DummyShadingPattern, BaseShadingPattern);
                    var _super = (0, $4jYWU._)(DummyShadingPattern);
                    function DummyShadingPattern() {
                        (0, $5sFFs._)(this, DummyShadingPattern);
                        return _super.apply(this, arguments);
                    }
                    (0, $8O2fV._)(DummyShadingPattern, [
                        {
                            key: "getPattern",
                            value: function getPattern() {
                                return "hotpink";
                            }
                        }
                    ]);
                    return DummyShadingPattern;
                }(BaseShadingPattern);
                function getShadingPattern(IR) {
                    switch(IR[0]){
                        case "RadialAxial":
                            return new RadialAxialShadingPattern(IR);
                        case "Mesh":
                            return new MeshShadingPattern(IR);
                        case "Dummy":
                            return new DummyShadingPattern();
                    }
                    throw new Error("Unknown IR type: ".concat(IR[0]));
                }
                var PaintType = {
                    COLORED: 1,
                    UNCOLORED: 2
                };
                var TilingPattern = /*#__PURE__*/ function() {
                    function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
                        (0, $5sFFs._)(this, TilingPattern);
                        this.operatorList = IR[2];
                        this.matrix = IR[3] || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        this.bbox = IR[4];
                        this.xstep = IR[5];
                        this.ystep = IR[6];
                        this.paintType = IR[7];
                        this.tilingType = IR[8];
                        this.color = color;
                        this.ctx = ctx;
                        this.canvasGraphicsFactory = canvasGraphicsFactory;
                        this.baseTransform = baseTransform;
                    }
                    (0, $8O2fV._)(TilingPattern, [
                        {
                            key: "createPatternCanvas",
                            value: function createPatternCanvas(owner) {
                                var operatorList = this.operatorList;
                                var bbox = this.bbox;
                                var xstep = this.xstep;
                                var ystep = this.ystep;
                                var paintType = this.paintType;
                                var tilingType = this.tilingType;
                                var color = this.color;
                                var canvasGraphicsFactory = this.canvasGraphicsFactory;
                                (0, _util.info)("TilingType: " + tilingType);
                                var x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
                                var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                                var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
                                var combinedScale = [
                                    matrixScale[0] * curMatrixScale[0],
                                    matrixScale[1] * curMatrixScale[1]
                                ];
                                var dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
                                var dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
                                var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
                                var tmpCtx = tmpCanvas.context;
                                var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
                                graphics.groupLevel = owner.groupLevel;
                                this.setFillAndStrokeStyleToContext(graphics, paintType, color);
                                var adjustedX0 = x0;
                                var adjustedY0 = y0;
                                var adjustedX1 = x1;
                                var adjustedY1 = y1;
                                if (x0 < 0) {
                                    adjustedX0 = 0;
                                    adjustedX1 += Math.abs(x0);
                                }
                                if (y0 < 0) {
                                    adjustedY0 = 0;
                                    adjustedY1 += Math.abs(y0);
                                }
                                tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
                                graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
                                tmpCtx.save();
                                this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
                                graphics.baseTransform = (0, _display_utils.getCurrentTransform)(graphics.ctx);
                                graphics.executeOperatorList(operatorList);
                                graphics.endDrawing();
                                return {
                                    canvas: tmpCanvas.canvas,
                                    scaleX: dimx.scale,
                                    scaleY: dimy.scale,
                                    offsetX: adjustedX0,
                                    offsetY: adjustedY0
                                };
                            }
                        },
                        {
                            key: "getSizeAndScale",
                            value: function getSizeAndScale(step, realOutputSize, scale) {
                                step = Math.abs(step);
                                var maxSize = Math.max(TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
                                var size = Math.ceil(step * scale);
                                if (size >= maxSize) size = maxSize;
                                else scale = size / step;
                                return {
                                    scale: scale,
                                    size: size
                                };
                            }
                        },
                        {
                            key: "clipBbox",
                            value: function clipBbox(graphics, x0, y0, x1, y1) {
                                var bboxWidth = x1 - x0;
                                var bboxHeight = y1 - y0;
                                graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
                                graphics.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(graphics.ctx), [
                                    x0,
                                    y0,
                                    x1,
                                    y1
                                ]);
                                graphics.clip();
                                graphics.endPath();
                            }
                        },
                        {
                            key: "setFillAndStrokeStyleToContext",
                            value: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
                                var context = graphics.ctx, current = graphics.current;
                                switch(paintType){
                                    case PaintType.COLORED:
                                        var ctx = this.ctx;
                                        context.fillStyle = ctx.fillStyle;
                                        context.strokeStyle = ctx.strokeStyle;
                                        current.fillColor = ctx.fillStyle;
                                        current.strokeColor = ctx.strokeStyle;
                                        break;
                                    case PaintType.UNCOLORED:
                                        var cssColor = _util.Util.makeHexColor(color[0], color[1], color[2]);
                                        context.fillStyle = cssColor;
                                        context.strokeStyle = cssColor;
                                        current.fillColor = cssColor;
                                        current.strokeColor = cssColor;
                                        break;
                                    default:
                                        throw new _util.FormatError("Unsupported paint type: ".concat(paintType));
                                }
                            }
                        },
                        {
                            key: "getPattern",
                            value: function getPattern(ctx, owner, inverse, pathType) {
                                var matrix = inverse;
                                if (pathType !== PathType.SHADING) {
                                    matrix = _util.Util.transform(matrix, owner.baseTransform);
                                    if (this.matrix) matrix = _util.Util.transform(matrix, this.matrix);
                                }
                                var temporaryPatternCanvas = this.createPatternCanvas(owner);
                                var domMatrix = new DOMMatrix(matrix);
                                domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                                domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
                                var pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
                                pattern.setTransform(domMatrix);
                                return pattern;
                            }
                        }
                    ]);
                    return TilingPattern;
                }();
                (0, $iCQyW._)(TilingPattern, "MAX_PATTERN_SIZE", 3000);
                exports.TilingPattern = TilingPattern;
            /***/ },
            /* 13 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA;
                exports.convertToRGBA = convertToRGBA;
                exports.grayToRGBA = grayToRGBA;
                var _util = __w_pdfjs_require__(1);
                function convertToRGBA(params) {
                    switch(params.kind){
                        case _util.ImageKind.GRAYSCALE_1BPP:
                            return convertBlackAndWhiteToRGBA(params);
                        case _util.ImageKind.RGB_24BPP:
                            return convertRGBToRGBA(params);
                    }
                    return null;
                }
                function convertBlackAndWhiteToRGBA(param) {
                    var src = param.src, _param_srcPos = param.srcPos, srcPos = _param_srcPos === void 0 ? 0 : _param_srcPos, dest = param.dest, width = param.width, height = param.height, _param_nonBlackColor = param.nonBlackColor, nonBlackColor = _param_nonBlackColor === void 0 ? 0xffffffff : _param_nonBlackColor, _param_inverseDecode = param.inverseDecode, inverseDecode = _param_inverseDecode === void 0 ? false : _param_inverseDecode;
                    var black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                    var _ref = (0, $52tJv._)(inverseDecode ? [
                        nonBlackColor,
                        black
                    ] : [
                        black,
                        nonBlackColor
                    ], 2), zeroMapping = _ref[0], oneMapping = _ref[1];
                    var widthInSource = width >> 3;
                    var widthRemainder = width & 7;
                    var srcLength = src.length;
                    dest = new Uint32Array(dest.buffer);
                    var destPos = 0;
                    for(var i = 0; i < height; i++){
                        for(var max = srcPos + widthInSource; srcPos < max; srcPos++){
                            var elem = srcPos < srcLength ? src[srcPos] : 255;
                            dest[destPos++] = elem & 128 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 64 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 32 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 16 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 8 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 4 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 2 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 1 ? oneMapping : zeroMapping;
                        }
                        if (widthRemainder === 0) continue;
                        var elem1 = srcPos < srcLength ? src[srcPos++] : 255;
                        for(var j = 0; j < widthRemainder; j++)dest[destPos++] = elem1 & 1 << 7 - j ? oneMapping : zeroMapping;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function convertRGBToRGBA(param) {
                    var src = param.src, _param_srcPos = param.srcPos, srcPos = _param_srcPos === void 0 ? 0 : _param_srcPos, dest = param.dest, _param_destPos = param.destPos, destPos = _param_destPos === void 0 ? 0 : _param_destPos, width = param.width, height = param.height;
                    var i = 0;
                    var len32 = src.length >> 2;
                    var src32 = new Uint32Array(src.buffer, srcPos, len32);
                    if (_util.FeatureTest.isLittleEndian) {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            var s1 = src32[i];
                            var s2 = src32[i + 1];
                            var s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff000000;
                            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
                            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
                            dest[destPos + 3] = s3 >>> 8 | 0xff000000;
                        }
                        for(var j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
                    } else {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            var s11 = src32[i];
                            var s21 = src32[i + 1];
                            var s31 = src32[i + 2];
                            dest[destPos] = s11 | 0xff;
                            dest[destPos + 1] = s11 << 24 | s21 >>> 8 | 0xff;
                            dest[destPos + 2] = s21 << 16 | s31 >>> 16 | 0xff;
                            dest[destPos + 3] = s31 << 8 | 0xff;
                        }
                        for(var j1 = i * 4, jj1 = src.length; j1 < jj1; j1 += 3)dest[destPos++] = src[j1] << 24 | src[j1 + 1] << 16 | src[j1 + 2] << 8 | 0xff;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function grayToRGBA(src, dest) {
                    if (_util.FeatureTest.isLittleEndian) for(var i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
                    else for(var i1 = 0, ii1 = src.length; i1 < ii1; i1++)dest[i1] = src[i1] * 0x1010100 | 0x000000ff;
                }
            /***/ },
            /* 14 */ /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.GlobalWorkerOptions = void 0;
                var GlobalWorkerOptions = Object.create(null);
                exports.GlobalWorkerOptions = GlobalWorkerOptions;
                GlobalWorkerOptions.workerPort = null;
                GlobalWorkerOptions.workerSrc = "";
            /***/ },
            /* 15 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MessageHandler = void 0;
                var _util = __w_pdfjs_require__(1);
                var CallbackKind = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                var StreamKind = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason(reason) {
                    if (!(reason instanceof Error || typeof reason === "object" && reason !== null)) (0, _util.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                    switch(reason.name){
                        case "AbortException":
                            return new _util.AbortException(reason.message);
                        case "MissingPDFException":
                            return new _util.MissingPDFException(reason.message);
                        case "PasswordException":
                            return new _util.PasswordException(reason.message, reason.code);
                        case "UnexpectedResponseException":
                            return new _util.UnexpectedResponseException(reason.message, reason.status);
                        case "UnknownErrorException":
                            return new _util.UnknownErrorException(reason.message, reason.details);
                        default:
                            return new _util.UnknownErrorException(reason.message, reason.toString());
                    }
                }
                var _createStreamSink = /*#__PURE__*/ new WeakSet(), _processStreamMessage = /*#__PURE__*/ new WeakSet(), _deleteStreamController = /*#__PURE__*/ new WeakSet();
                var MessageHandler = /*#__PURE__*/ function() {
                    function MessageHandler(sourceName, targetName, comObj) {
                        var _this = this;
                        (0, $5sFFs._)(this, MessageHandler);
                        (0, $iB2CV._)(this, _createStreamSink);
                        (0, $iB2CV._)(this, _processStreamMessage);
                        (0, $iB2CV._)(this, _deleteStreamController);
                        this.sourceName = sourceName;
                        this.targetName = targetName;
                        this.comObj = comObj;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = function(event) {
                            var data = event.data;
                            if (data.targetName !== _this.sourceName) return;
                            if (data.stream) {
                                (0, $lNbhr._)(_this, _processStreamMessage, processStreamMessage).call(_this, data);
                                return;
                            }
                            if (data.callback) {
                                var callbackId = data.callbackId;
                                var capability = _this.callbackCapabilities[callbackId];
                                if (!capability) throw new Error("Cannot resolve callback ".concat(callbackId));
                                delete _this.callbackCapabilities[callbackId];
                                if (data.callback === CallbackKind.DATA) capability.resolve(data.data);
                                else if (data.callback === CallbackKind.ERROR) capability.reject(wrapReason(data.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            var action = _this.actionHandler[data.action];
                            if (!action) throw new Error("Unknown action from worker: ".concat(data.action));
                            if (data.callbackId) {
                                var cbSourceName = _this.sourceName;
                                var cbTargetName = data.sourceName;
                                new Promise(function(resolve) {
                                    resolve(action(data.data));
                                }).then(function(result) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.DATA,
                                        callbackId: data.callbackId,
                                        data: result
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.ERROR,
                                        callbackId: data.callbackId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                return;
                            }
                            if (data.streamId) {
                                (0, $lNbhr._)(_this, _createStreamSink, createStreamSink).call(_this, data);
                                return;
                            }
                            action(data.data);
                        };
                        comObj.addEventListener("message", this._onComObjOnMessage);
                    }
                    (0, $8O2fV._)(MessageHandler, [
                        {
                            key: "on",
                            value: function on(actionName, handler) {
                                var ah = this.actionHandler;
                                if (ah[actionName]) throw new Error('There is already an actionName called "'.concat(actionName, '"'));
                                ah[actionName] = handler;
                            }
                        },
                        {
                            key: "send",
                            value: function send(actionName, data, transfers) {
                                this.comObj.postMessage({
                                    sourceName: this.sourceName,
                                    targetName: this.targetName,
                                    action: actionName,
                                    data: data
                                }, transfers);
                            }
                        },
                        {
                            key: "sendWithPromise",
                            value: function sendWithPromise(actionName, data, transfers) {
                                var callbackId = this.callbackId++;
                                var capability = new _util.PromiseCapability();
                                this.callbackCapabilities[callbackId] = capability;
                                try {
                                    this.comObj.postMessage({
                                        sourceName: this.sourceName,
                                        targetName: this.targetName,
                                        action: actionName,
                                        callbackId: callbackId,
                                        data: data
                                    }, transfers);
                                } catch (ex) {
                                    capability.reject(ex);
                                }
                                return capability.promise;
                            }
                        },
                        {
                            key: "sendWithStream",
                            value: function sendWithStream(actionName, data, queueingStrategy, transfers) {
                                var _this = this;
                                var streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                                return new ReadableStream({
                                    start: function(controller) {
                                        var startCapability = new _util.PromiseCapability();
                                        _this.streamControllers[streamId] = {
                                            controller: controller,
                                            startCall: startCapability,
                                            pullCall: null,
                                            cancelCall: null,
                                            isClosed: false
                                        };
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            action: actionName,
                                            streamId: streamId,
                                            data: data,
                                            desiredSize: controller.desiredSize
                                        }, transfers);
                                        return startCapability.promise;
                                    },
                                    pull: function(controller) {
                                        var pullCapability = new _util.PromiseCapability();
                                        _this.streamControllers[streamId].pullCall = pullCapability;
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            stream: StreamKind.PULL,
                                            streamId: streamId,
                                            desiredSize: controller.desiredSize
                                        });
                                        return pullCapability.promise;
                                    },
                                    cancel: function(reason) {
                                        (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
                                        var cancelCapability = new _util.PromiseCapability();
                                        _this.streamControllers[streamId].cancelCall = cancelCapability;
                                        _this.streamControllers[streamId].isClosed = true;
                                        comObj.postMessage({
                                            sourceName: sourceName,
                                            targetName: targetName,
                                            stream: StreamKind.CANCEL,
                                            streamId: streamId,
                                            reason: wrapReason(reason)
                                        });
                                        return cancelCapability.promise;
                                    }
                                }, queueingStrategy);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.comObj.removeEventListener("message", this._onComObjOnMessage);
                            }
                        }
                    ]);
                    return MessageHandler;
                }();
                function createStreamSink(data) {
                    var streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                    var self = this, action = this.actionHandler[data.action];
                    var streamSink = {
                        enqueue: function(chunk) {
                            var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, transfers = arguments.length > 2 ? arguments[2] : void 0;
                            if (this.isCancelled) return;
                            var lastDesiredSize = this.desiredSize;
                            this.desiredSize -= size;
                            if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                                this.sinkCapability = new _util.PromiseCapability();
                                this.ready = this.sinkCapability.promise;
                            }
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.ENQUEUE,
                                streamId: streamId,
                                chunk: chunk
                            }, transfers);
                        },
                        close: function() {
                            if (this.isCancelled) return;
                            this.isCancelled = true;
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.CLOSE,
                                streamId: streamId
                            });
                            delete self.streamSinks[streamId];
                        },
                        error: function(reason) {
                            (0, _util.assert)(reason instanceof Error, "error must have a valid reason");
                            if (this.isCancelled) return;
                            this.isCancelled = true;
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.ERROR,
                                streamId: streamId,
                                reason: wrapReason(reason)
                            });
                        },
                        sinkCapability: new _util.PromiseCapability(),
                        onPull: null,
                        onCancel: null,
                        isCancelled: false,
                        desiredSize: data.desiredSize,
                        ready: null
                    };
                    streamSink.sinkCapability.resolve();
                    streamSink.ready = streamSink.sinkCapability.promise;
                    this.streamSinks[streamId] = streamSink;
                    new Promise(function(resolve) {
                        resolve(action(data.data, streamSink));
                    }).then(function() {
                        comObj.postMessage({
                            sourceName: sourceName,
                            targetName: targetName,
                            stream: StreamKind.START_COMPLETE,
                            streamId: streamId,
                            success: true
                        });
                    }, function(reason) {
                        comObj.postMessage({
                            sourceName: sourceName,
                            targetName: targetName,
                            stream: StreamKind.START_COMPLETE,
                            streamId: streamId,
                            reason: wrapReason(reason)
                        });
                    });
                }
                function processStreamMessage(data) {
                    var streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                    var streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
                    switch(data.stream){
                        case StreamKind.START_COMPLETE:
                            if (data.success) streamController.startCall.resolve();
                            else streamController.startCall.reject(wrapReason(data.reason));
                            break;
                        case StreamKind.PULL_COMPLETE:
                            if (data.success) streamController.pullCall.resolve();
                            else streamController.pullCall.reject(wrapReason(data.reason));
                            break;
                        case StreamKind.PULL:
                            if (!streamSink) {
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL_COMPLETE,
                                    streamId: streamId,
                                    success: true
                                });
                                break;
                            }
                            if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                            streamSink.desiredSize = data.desiredSize;
                            new Promise(function(resolve) {
                                var _streamSink_onPull;
                                resolve((_streamSink_onPull = streamSink.onPull) === null || _streamSink_onPull === void 0 ? void 0 : _streamSink_onPull.call(streamSink));
                            }).then(function() {
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL_COMPLETE,
                                    streamId: streamId,
                                    success: true
                                });
                            }, function(reason) {
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL_COMPLETE,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                            });
                            break;
                        case StreamKind.ENQUEUE:
                            (0, _util.assert)(streamController, "enqueue should have stream controller");
                            if (streamController.isClosed) break;
                            streamController.controller.enqueue(data.chunk);
                            break;
                        case StreamKind.CLOSE:
                            (0, _util.assert)(streamController, "close should have stream controller");
                            if (streamController.isClosed) break;
                            streamController.isClosed = true;
                            streamController.controller.close();
                            (0, $lNbhr._)(this, _deleteStreamController, deleteStreamController).call(this, streamController, streamId);
                            break;
                        case StreamKind.ERROR:
                            (0, _util.assert)(streamController, "error should have stream controller");
                            streamController.controller.error(wrapReason(data.reason));
                            (0, $lNbhr._)(this, _deleteStreamController, deleteStreamController).call(this, streamController, streamId);
                            break;
                        case StreamKind.CANCEL_COMPLETE:
                            if (data.success) streamController.cancelCall.resolve();
                            else streamController.cancelCall.reject(wrapReason(data.reason));
                            (0, $lNbhr._)(this, _deleteStreamController, deleteStreamController).call(this, streamController, streamId);
                            break;
                        case StreamKind.CANCEL:
                            if (!streamSink) break;
                            new Promise(function(resolve) {
                                var _streamSink_onCancel;
                                resolve((_streamSink_onCancel = streamSink.onCancel) === null || _streamSink_onCancel === void 0 ? void 0 : _streamSink_onCancel.call(streamSink, wrapReason(data.reason)));
                            }).then(function() {
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CANCEL_COMPLETE,
                                    streamId: streamId,
                                    success: true
                                });
                            }, function(reason) {
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CANCEL_COMPLETE,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                            });
                            streamSink.sinkCapability.reject(wrapReason(data.reason));
                            streamSink.isCancelled = true;
                            delete this.streamSinks[streamId];
                            break;
                        default:
                            throw new Error("Unexpected stream case");
                    }
                }
                function deleteStreamController(streamController, streamId) {
                    return _deleteStreamController1.apply(this, arguments);
                }
                function _deleteStreamController1() {
                    _deleteStreamController1 = (0, $7hBys._)(function(streamController, streamId) {
                        var _streamController_startCall, _streamController_pullCall, _streamController_cancelCall;
                        return (0, $ajhIL.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        Promise.allSettled([
                                            (_streamController_startCall = streamController.startCall) === null || _streamController_startCall === void 0 ? void 0 : _streamController_startCall.promise,
                                            (_streamController_pullCall = streamController.pullCall) === null || _streamController_pullCall === void 0 ? void 0 : _streamController_pullCall.promise,
                                            (_streamController_cancelCall = streamController.cancelCall) === null || _streamController_cancelCall === void 0 ? void 0 : _streamController_cancelCall.promise
                                        ])
                                    ];
                                case 1:
                                    _state.sent();
                                    delete this.streamControllers[streamId];
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return _deleteStreamController1.apply(this, arguments);
                }
                exports.MessageHandler = MessageHandler;
            /***/ },
            /* 16 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Metadata = void 0;
                var _util = __w_pdfjs_require__(1);
                var _metadataMap = /*#__PURE__*/ new WeakMap(), _data = /*#__PURE__*/ new WeakMap();
                var Metadata = /*#__PURE__*/ function() {
                    function Metadata(param) {
                        var parsedData = param.parsedData, rawData = param.rawData;
                        (0, $5sFFs._)(this, Metadata);
                        (0, $g12Hy._)(this, _metadataMap, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)(this, _data, {
                            writable: true,
                            value: void 0
                        });
                        (0, $4LHB0._)(this, _metadataMap, parsedData);
                        (0, $4LHB0._)(this, _data, rawData);
                    }
                    (0, $8O2fV._)(Metadata, [
                        {
                            key: "getRaw",
                            value: function getRaw() {
                                return (0, $057QZ._)(this, _data);
                            }
                        },
                        {
                            key: "get",
                            value: function get(name) {
                                var _class_private_field_get_get;
                                return (_class_private_field_get_get = (0, $057QZ._)(this, _metadataMap).get(name)) !== null && _class_private_field_get_get !== void 0 ? _class_private_field_get_get : null;
                            }
                        },
                        {
                            key: "getAll",
                            value: function getAll() {
                                return (0, _util.objectFromMap)((0, $057QZ._)(this, _metadataMap));
                            }
                        },
                        {
                            key: "has",
                            value: function has(name) {
                                return (0, $057QZ._)(this, _metadataMap).has(name);
                            }
                        }
                    ]);
                    return Metadata;
                }();
                exports.Metadata = Metadata;
            /***/ },
            /* 17 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OptionalContentConfig = void 0;
                var _util = __w_pdfjs_require__(1);
                var _murmurhash = __w_pdfjs_require__(8);
                var INTERNAL = Symbol("INTERNAL");
                var _visible = /*#__PURE__*/ new WeakMap();
                var OptionalContentGroup = /*#__PURE__*/ function() {
                    function OptionalContentGroup(name, intent) {
                        (0, $5sFFs._)(this, OptionalContentGroup);
                        (0, $g12Hy._)(this, _visible, {
                            writable: true,
                            value: true
                        });
                        this.name = name;
                        this.intent = intent;
                    }
                    (0, $8O2fV._)(OptionalContentGroup, [
                        {
                            key: "visible",
                            get: function get() {
                                return (0, $057QZ._)(this, _visible);
                            }
                        },
                        {
                            key: "_setVisible",
                            value: function _setVisible(internal, visible) {
                                if (internal !== INTERNAL) (0, _util.unreachable)("Internal method `_setVisible` called.");
                                (0, $4LHB0._)(this, _visible, visible);
                            }
                        }
                    ]);
                    return OptionalContentGroup;
                }();
                var _cachedGetHash = /*#__PURE__*/ new WeakMap(), _groups = /*#__PURE__*/ new WeakMap(), _initialHash = /*#__PURE__*/ new WeakMap(), _order = /*#__PURE__*/ new WeakMap(), _evaluateVisibilityExpression = /*#__PURE__*/ new WeakSet();
                var OptionalContentConfig = /*#__PURE__*/ function() {
                    function OptionalContentConfig(data) {
                        (0, $5sFFs._)(this, OptionalContentConfig);
                        (0, $iB2CV._)(this, _evaluateVisibilityExpression);
                        (0, $g12Hy._)(this, _cachedGetHash, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _groups, {
                            writable: true,
                            value: new Map()
                        });
                        (0, $g12Hy._)(this, _initialHash, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _order, {
                            writable: true,
                            value: null
                        });
                        this.name = null;
                        this.creator = null;
                        if (data === null) return;
                        this.name = data.name;
                        this.creator = data.creator;
                        (0, $4LHB0._)(this, _order, data.order);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = data.groups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var group = _step.value;
                                (0, $057QZ._)(this, _groups).set(group.id, new OptionalContentGroup(group.name, group.intent));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        if (data.baseState === "OFF") try {
                            for(var _iterator1 = (0, $057QZ._)(this, _groups).values()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var group1 = _step1.value;
                                group1._setVisible(INTERNAL, false);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = data.on[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var on = _step2.value;
                                (0, $057QZ._)(this, _groups).get(on)._setVisible(INTERNAL, true);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                        try {
                            for(var _iterator3 = data.off[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                var off = _step3.value;
                                (0, $057QZ._)(this, _groups).get(off)._setVisible(INTERNAL, false);
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                    _iterator3.return();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                        (0, $4LHB0._)(this, _initialHash, this.getHash());
                    }
                    (0, $8O2fV._)(OptionalContentConfig, [
                        {
                            key: "isVisible",
                            value: function isVisible(group) {
                                if ((0, $057QZ._)(this, _groups).size === 0) return true;
                                if (!group) {
                                    (0, _util.warn)("Optional content group not defined.");
                                    return true;
                                }
                                if (group.type === "OCG") {
                                    if (!(0, $057QZ._)(this, _groups).has(group.id)) {
                                        (0, _util.warn)("Optional content group not found: ".concat(group.id));
                                        return true;
                                    }
                                    return (0, $057QZ._)(this, _groups).get(group.id).visible;
                                } else if (group.type === "OCMD") {
                                    if (group.expression) return (0, $lNbhr._)(this, _evaluateVisibilityExpression, evaluateVisibilityExpression).call(this, group.expression);
                                    if (!group.policy || group.policy === "AnyOn") {
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = group.ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var id = _step.value;
                                                if (!(0, $057QZ._)(this, _groups).has(id)) {
                                                    (0, _util.warn)("Optional content group not found: ".concat(id));
                                                    return true;
                                                }
                                                if ((0, $057QZ._)(this, _groups).get(id).visible) return true;
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        return false;
                                    } else if (group.policy === "AllOn") {
                                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(var _iterator1 = group.ids[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                var id1 = _step1.value;
                                                if (!(0, $057QZ._)(this, _groups).has(id1)) {
                                                    (0, _util.warn)("Optional content group not found: ".concat(id1));
                                                    return true;
                                                }
                                                if (!(0, $057QZ._)(this, _groups).get(id1).visible) return false;
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                        return true;
                                    } else if (group.policy === "AnyOff") {
                                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                        try {
                                            for(var _iterator2 = group.ids[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                                var id2 = _step2.value;
                                                if (!(0, $057QZ._)(this, _groups).has(id2)) {
                                                    (0, _util.warn)("Optional content group not found: ".concat(id2));
                                                    return true;
                                                }
                                                if (!(0, $057QZ._)(this, _groups).get(id2).visible) return true;
                                            }
                                        } catch (err) {
                                            _didIteratorError2 = true;
                                            _iteratorError2 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                                    _iterator2.return();
                                                }
                                            } finally{
                                                if (_didIteratorError2) {
                                                    throw _iteratorError2;
                                                }
                                            }
                                        }
                                        return false;
                                    } else if (group.policy === "AllOff") {
                                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                        try {
                                            for(var _iterator3 = group.ids[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                                var id3 = _step3.value;
                                                if (!(0, $057QZ._)(this, _groups).has(id3)) {
                                                    (0, _util.warn)("Optional content group not found: ".concat(id3));
                                                    return true;
                                                }
                                                if ((0, $057QZ._)(this, _groups).get(id3).visible) return false;
                                            }
                                        } catch (err) {
                                            _didIteratorError3 = true;
                                            _iteratorError3 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                                    _iterator3.return();
                                                }
                                            } finally{
                                                if (_didIteratorError3) {
                                                    throw _iteratorError3;
                                                }
                                            }
                                        }
                                        return true;
                                    }
                                    (0, _util.warn)("Unknown optional content policy ".concat(group.policy, "."));
                                    return true;
                                }
                                (0, _util.warn)("Unknown group type ".concat(group.type, "."));
                                return true;
                            }
                        },
                        {
                            key: "setVisibility",
                            value: function setVisibility(id) {
                                var visible = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                                if (!(0, $057QZ._)(this, _groups).has(id)) {
                                    (0, _util.warn)("Optional content group not found: ".concat(id));
                                    return;
                                }
                                (0, $057QZ._)(this, _groups).get(id)._setVisible(INTERNAL, !!visible);
                                (0, $4LHB0._)(this, _cachedGetHash, null);
                            }
                        },
                        {
                            key: "hasInitialVisibility",
                            get: function get() {
                                return (0, $057QZ._)(this, _initialHash) === null || this.getHash() === (0, $057QZ._)(this, _initialHash);
                            }
                        },
                        {
                            key: "getOrder",
                            value: function getOrder() {
                                if (!(0, $057QZ._)(this, _groups).size) return null;
                                if ((0, $057QZ._)(this, _order)) return (0, $057QZ._)(this, _order).slice();
                                return (0, $fyztb._)((0, $057QZ._)(this, _groups).keys());
                            }
                        },
                        {
                            key: "getGroups",
                            value: function getGroups() {
                                return (0, $057QZ._)(this, _groups).size > 0 ? (0, _util.objectFromMap)((0, $057QZ._)(this, _groups)) : null;
                            }
                        },
                        {
                            key: "getGroup",
                            value: function getGroup(id) {
                                return (0, $057QZ._)(this, _groups).get(id) || null;
                            }
                        },
                        {
                            key: "getHash",
                            value: function getHash() {
                                if ((0, $057QZ._)(this, _cachedGetHash) !== null) return (0, $057QZ._)(this, _cachedGetHash);
                                var hash = new _murmurhash.MurmurHash3_64();
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _groups)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _step_value = (0, $52tJv._)(_step.value, 2), id = _step_value[0], group = _step_value[1];
                                        hash.update("".concat(id, ":").concat(group.visible));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return (0, $4LHB0._)(this, _cachedGetHash, hash.hexdigest());
                            }
                        }
                    ]);
                    return OptionalContentConfig;
                }();
                function evaluateVisibilityExpression(array) {
                    var length = array.length;
                    if (length < 2) return true;
                    var operator = array[0];
                    for(var i = 1; i < length; i++){
                        var element = array[i];
                        var state = void 0;
                        if (Array.isArray(element)) state = (0, $lNbhr._)(this, _evaluateVisibilityExpression, evaluateVisibilityExpression).call(this, element);
                        else if ((0, $057QZ._)(this, _groups).has(element)) state = (0, $057QZ._)(this, _groups).get(element).visible;
                        else {
                            (0, _util.warn)("Optional content group not found: ".concat(element));
                            return true;
                        }
                        switch(operator){
                            case "And":
                                if (!state) return false;
                                break;
                            case "Or":
                                if (state) return true;
                                break;
                            case "Not":
                                return !state;
                            default:
                                return true;
                        }
                    }
                    return operator === "And";
                }
                exports.OptionalContentConfig = OptionalContentConfig;
            /***/ },
            /* 18 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFDataTransportStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var PDFDataTransportStream = /*#__PURE__*/ function() {
                    function PDFDataTransportStream(param, pdfDataRangeTransport) {
                        var length = param.length, initialData = param.initialData, _param_progressiveDone = param.progressiveDone, progressiveDone = _param_progressiveDone === void 0 ? false : _param_progressiveDone, _param_contentDispositionFilename = param.contentDispositionFilename, contentDispositionFilename = _param_contentDispositionFilename === void 0 ? null : _param_contentDispositionFilename, _param_disableRange = param.disableRange, disableRange = _param_disableRange === void 0 ? false : _param_disableRange, _param_disableStream = param.disableStream, disableStream = _param_disableStream === void 0 ? false : _param_disableStream;
                        var _this = this;
                        (0, $5sFFs._)(this, PDFDataTransportStream);
                        (0, _util.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                        this._queuedChunks = [];
                        this._progressiveDone = progressiveDone;
                        this._contentDispositionFilename = contentDispositionFilename;
                        if ((initialData === null || initialData === void 0 ? void 0 : initialData.length) > 0) {
                            var buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
                            this._queuedChunks.push(buffer);
                        }
                        this._pdfDataRangeTransport = pdfDataRangeTransport;
                        this._isStreamingSupported = !disableStream;
                        this._isRangeSupported = !disableRange;
                        this._contentLength = length;
                        this._fullRequestReader = null;
                        this._rangeReaders = [];
                        this._pdfDataRangeTransport.addRangeListener(function(begin, chunk) {
                            _this._onReceiveData({
                                begin: begin,
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressListener(function(loaded, total) {
                            _this._onProgress({
                                loaded: loaded,
                                total: total
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveReadListener(function(chunk) {
                            _this._onReceiveData({
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveDoneListener(function() {
                            _this._onProgressiveDone();
                        });
                        this._pdfDataRangeTransport.transportReady();
                    }
                    (0, $8O2fV._)(PDFDataTransportStream, [
                        {
                            key: "_onReceiveData",
                            value: function _onReceiveData(param) {
                                var begin = param.begin, chunk = param.chunk;
                                var buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
                                if (begin === undefined) {
                                    if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer);
                                    else this._queuedChunks.push(buffer);
                                } else {
                                    var found = this._rangeReaders.some(function(rangeReader) {
                                        if (rangeReader._begin !== begin) return false;
                                        rangeReader._enqueue(buffer);
                                        return true;
                                    });
                                    (0, _util.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                                }
                            }
                        },
                        {
                            key: "_progressiveDataLength",
                            get: function get() {
                                var _this__fullRequestReader;
                                var _this__fullRequestReader__loaded;
                                return (_this__fullRequestReader__loaded = (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader._loaded) !== null && _this__fullRequestReader__loaded !== void 0 ? _this__fullRequestReader__loaded : 0;
                            }
                        },
                        {
                            key: "_onProgress",
                            value: function _onProgress(evt) {
                                var _this__rangeReaders__onProgress, _this__rangeReaders_, _this__fullRequestReader_onProgress, _this__fullRequestReader;
                                if (evt.total === undefined) (_this__rangeReaders_ = this._rangeReaders[0]) === null || _this__rangeReaders_ === void 0 ? void 0 : (_this__rangeReaders__onProgress = _this__rangeReaders_.onProgress) === null || _this__rangeReaders__onProgress === void 0 ? void 0 : _this__rangeReaders__onProgress.call(_this__rangeReaders_, {
                                    loaded: evt.loaded
                                });
                                else (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : (_this__fullRequestReader_onProgress = _this__fullRequestReader.onProgress) === null || _this__fullRequestReader_onProgress === void 0 ? void 0 : _this__fullRequestReader_onProgress.call(_this__fullRequestReader, {
                                    loaded: evt.loaded,
                                    total: evt.total
                                });
                            }
                        },
                        {
                            key: "_onProgressiveDone",
                            value: function _onProgressiveDone() {
                                var _this__fullRequestReader;
                                (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader.progressiveDone();
                                this._progressiveDone = true;
                            }
                        },
                        {
                            key: "_removeRangeReader",
                            value: function _removeRangeReader(reader) {
                                var i = this._rangeReaders.indexOf(reader);
                                if (i >= 0) this._rangeReaders.splice(i, 1);
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader() {
                                (0, _util.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                                var queuedChunks = this._queuedChunks;
                                this._queuedChunks = null;
                                return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader(begin, end) {
                                if (end <= this._progressiveDataLength) return null;
                                var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
                                this._pdfDataRangeTransport.requestDataRange(begin, end);
                                this._rangeReaders.push(reader);
                                return reader;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests(reason) {
                                var _this__fullRequestReader;
                                (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader.cancel(reason);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._rangeReaders.slice(0)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var reader = _step.value;
                                        reader.cancel(reason);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this._pdfDataRangeTransport.abort();
                            }
                        }
                    ]);
                    return PDFDataTransportStream;
                }();
                exports.PDFDataTransportStream = PDFDataTransportStream;
                var PDFDataTransportStreamReader = /*#__PURE__*/ function() {
                    function PDFDataTransportStreamReader(stream, queuedChunks) {
                        var progressiveDone = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, contentDispositionFilename = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
                        (0, $5sFFs._)(this, PDFDataTransportStreamReader);
                        this._stream = stream;
                        this._done = progressiveDone || false;
                        this._filename = (0, _display_utils.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
                        this._queuedChunks = queuedChunks || [];
                        this._loaded = 0;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._queuedChunks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var chunk = _step.value;
                                this._loaded += chunk.byteLength;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this._requests = [];
                        this._headersReady = Promise.resolve();
                        stream._fullRequestReader = this;
                        this.onProgress = null;
                    }
                    (0, $8O2fV._)(PDFDataTransportStreamReader, [
                        {
                            key: "_enqueue",
                            value: function _enqueue(chunk) {
                                if (this._done) return;
                                if (this._requests.length > 0) {
                                    var requestCapability = this._requests.shift();
                                    requestCapability.resolve({
                                        value: chunk,
                                        done: false
                                    });
                                } else this._queuedChunks.push(chunk);
                                this._loaded += chunk.byteLength;
                            }
                        },
                        {
                            key: "headersReady",
                            get: function get() {
                                return this._headersReady;
                            }
                        },
                        {
                            key: "filename",
                            get: function get() {
                                return this._filename;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get() {
                                return this._stream._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._stream._isStreamingSupported;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get() {
                                return this._stream._contentLength;
                            }
                        },
                        {
                            key: "read",
                            value: function read() {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var chunk, requestCapability;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        if (_this._queuedChunks.length > 0) {
                                            chunk = _this._queuedChunks.shift();
                                            return [
                                                2,
                                                {
                                                    value: chunk,
                                                    done: false
                                                }
                                            ];
                                        }
                                        if (_this._done) return [
                                            2,
                                            {
                                                value: undefined,
                                                done: true
                                            }
                                        ];
                                        requestCapability = new _util.PromiseCapability();
                                        _this._requests.push(requestCapability);
                                        return [
                                            2,
                                            requestCapability.promise
                                        ];
                                    });
                                })();
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                this._done = true;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._requests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var requestCapability = _step.value;
                                        requestCapability.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this._requests.length = 0;
                            }
                        },
                        {
                            key: "progressiveDone",
                            value: function progressiveDone() {
                                if (this._done) return;
                                this._done = true;
                            }
                        }
                    ]);
                    return PDFDataTransportStreamReader;
                }();
                var PDFDataTransportStreamRangeReader = /*#__PURE__*/ function() {
                    function PDFDataTransportStreamRangeReader(stream, begin, end) {
                        (0, $5sFFs._)(this, PDFDataTransportStreamRangeReader);
                        this._stream = stream;
                        this._begin = begin;
                        this._end = end;
                        this._queuedChunk = null;
                        this._requests = [];
                        this._done = false;
                        this.onProgress = null;
                    }
                    (0, $8O2fV._)(PDFDataTransportStreamRangeReader, [
                        {
                            key: "_enqueue",
                            value: function _enqueue(chunk) {
                                if (this._done) return;
                                if (this._requests.length === 0) this._queuedChunk = chunk;
                                else {
                                    var requestsCapability = this._requests.shift();
                                    requestsCapability.resolve({
                                        value: chunk,
                                        done: false
                                    });
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = this._requests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var requestCapability = _step.value;
                                            requestCapability.resolve({
                                                value: undefined,
                                                done: true
                                            });
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    this._requests.length = 0;
                                }
                                this._done = true;
                                this._stream._removeRangeReader(this);
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return false;
                            }
                        },
                        {
                            key: "read",
                            value: function read() {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var chunk, requestCapability;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        if (_this._queuedChunk) {
                                            chunk = _this._queuedChunk;
                                            _this._queuedChunk = null;
                                            return [
                                                2,
                                                {
                                                    value: chunk,
                                                    done: false
                                                }
                                            ];
                                        }
                                        if (_this._done) return [
                                            2,
                                            {
                                                value: undefined,
                                                done: true
                                            }
                                        ];
                                        requestCapability = new _util.PromiseCapability();
                                        _this._requests.push(requestCapability);
                                        return [
                                            2,
                                            requestCapability.promise
                                        ];
                                    });
                                })();
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                this._done = true;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._requests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var requestCapability = _step.value;
                                        requestCapability.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this._requests.length = 0;
                                this._stream._removeRangeReader(this);
                            }
                        }
                    ]);
                    return PDFDataTransportStreamRangeReader;
                }();
            /***/ },
            /* 19 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFFetchStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                function createFetchOptions(headers, withCredentials, abortController) {
                    return {
                        method: "GET",
                        headers: headers,
                        signal: abortController.signal,
                        mode: "cors",
                        credentials: withCredentials ? "include" : "same-origin",
                        redirect: "follow"
                    };
                }
                function createHeaders(httpHeaders) {
                    var headers = new Headers();
                    for(var property in httpHeaders){
                        var value = httpHeaders[property];
                        if (value === undefined) continue;
                        headers.append(property, value);
                    }
                    return headers;
                }
                function getArrayBuffer(val) {
                    if (val instanceof Uint8Array) return val.buffer;
                    if (val instanceof ArrayBuffer) return val;
                    (0, _util.warn)("getArrayBuffer - unexpected data format: ".concat(val));
                    return new Uint8Array(val).buffer;
                }
                var PDFFetchStream = /*#__PURE__*/ function() {
                    function PDFFetchStream(source) {
                        (0, $5sFFs._)(this, PDFFetchStream);
                        this.source = source;
                        this.isHttp = /^https?:/i.test(source.url);
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    (0, $8O2fV._)(PDFFetchStream, [
                        {
                            key: "_progressiveDataLength",
                            get: function get() {
                                var _this__fullRequestReader;
                                var _this__fullRequestReader__loaded;
                                return (_this__fullRequestReader__loaded = (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader._loaded) !== null && _this__fullRequestReader__loaded !== void 0 ? _this__fullRequestReader__loaded : 0;
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader() {
                                (0, _util.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                                this._fullRequestReader = new PDFFetchStreamReader(this);
                                return this._fullRequestReader;
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader(begin, end) {
                                if (end <= this._progressiveDataLength) return null;
                                var reader = new PDFFetchStreamRangeReader(this, begin, end);
                                this._rangeRequestReaders.push(reader);
                                return reader;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests(reason) {
                                var _this__fullRequestReader;
                                (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader.cancel(reason);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._rangeRequestReaders.slice(0)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var reader = _step.value;
                                        reader.cancel(reason);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        }
                    ]);
                    return PDFFetchStream;
                }();
                exports.PDFFetchStream = PDFFetchStream;
                var PDFFetchStreamReader = /*#__PURE__*/ function() {
                    function PDFFetchStreamReader(stream) {
                        var _this = this;
                        (0, $5sFFs._)(this, PDFFetchStreamReader);
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        this._filename = null;
                        var source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._contentLength = source.length;
                        this._headersCapability = new _util.PromiseCapability();
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._abortController = new AbortController();
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._headers = createHeaders(this._stream.httpHeaders);
                        var url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function(response) {
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            _this._reader = response.body.getReader();
                            _this._headersCapability.resolve();
                            var getResponseHeader = function(name) {
                                return response.headers.get(name);
                            };
                            var _ref = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: _this._stream.isHttp,
                                rangeChunkSize: _this._rangeChunkSize,
                                disableRange: _this._disableRange
                            }), allowRangeRequests = _ref.allowRangeRequests, suggestedLength = _ref.suggestedLength;
                            _this._isRangeSupported = allowRangeRequests;
                            _this._contentLength = suggestedLength || _this._contentLength;
                            _this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                            if (!_this._isStreamingSupported && _this._isRangeSupported) _this.cancel(new _util.AbortException("Streaming is disabled."));
                        }).catch(this._headersCapability.reject);
                        this.onProgress = null;
                    }
                    (0, $8O2fV._)(PDFFetchStreamReader, [
                        {
                            key: "headersReady",
                            get: function get() {
                                return this._headersCapability.promise;
                            }
                        },
                        {
                            key: "filename",
                            get: function get() {
                                return this._filename;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get() {
                                return this._contentLength;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get() {
                                return this._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function read() {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var _this_onProgress, _this1, _ref, value, done;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    _this._headersCapability.promise
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    4,
                                                    _this._reader.read()
                                                ];
                                            case 2:
                                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                                if (done) return [
                                                    2,
                                                    {
                                                        value: value,
                                                        done: done
                                                    }
                                                ];
                                                _this._loaded += value.byteLength;
                                                (_this_onProgress = (_this1 = _this).onProgress) === null || _this_onProgress === void 0 ? void 0 : _this_onProgress.call(_this1, {
                                                    loaded: _this._loaded,
                                                    total: _this._contentLength
                                                });
                                                return [
                                                    2,
                                                    {
                                                        value: getArrayBuffer(value),
                                                        done: false
                                                    }
                                                ];
                                        }
                                    });
                                })();
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                var _this__reader;
                                (_this__reader = this._reader) === null || _this__reader === void 0 ? void 0 : _this__reader.cancel(reason);
                                this._abortController.abort();
                            }
                        }
                    ]);
                    return PDFFetchStreamReader;
                }();
                var PDFFetchStreamRangeReader = /*#__PURE__*/ function() {
                    function PDFFetchStreamRangeReader(stream, begin, end) {
                        var _this = this;
                        (0, $5sFFs._)(this, PDFFetchStreamRangeReader);
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        var source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._readCapability = new _util.PromiseCapability();
                        this._isStreamingSupported = !source.disableStream;
                        this._abortController = new AbortController();
                        this._headers = createHeaders(this._stream.httpHeaders);
                        this._headers.append("Range", "bytes=".concat(begin, "-").concat(end - 1));
                        var url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function(response) {
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            _this._readCapability.resolve();
                            _this._reader = response.body.getReader();
                        }).catch(this._readCapability.reject);
                        this.onProgress = null;
                    }
                    (0, $8O2fV._)(PDFFetchStreamRangeReader, [
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function read() {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var _this_onProgress, _this1, _ref, value, done;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    _this._readCapability.promise
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    4,
                                                    _this._reader.read()
                                                ];
                                            case 2:
                                                _ref = _state.sent(), value = _ref.value, done = _ref.done;
                                                if (done) return [
                                                    2,
                                                    {
                                                        value: value,
                                                        done: done
                                                    }
                                                ];
                                                _this._loaded += value.byteLength;
                                                (_this_onProgress = (_this1 = _this).onProgress) === null || _this_onProgress === void 0 ? void 0 : _this_onProgress.call(_this1, {
                                                    loaded: _this._loaded
                                                });
                                                return [
                                                    2,
                                                    {
                                                        value: getArrayBuffer(value),
                                                        done: false
                                                    }
                                                ];
                                        }
                                    });
                                })();
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                var _this__reader;
                                (_this__reader = this._reader) === null || _this__reader === void 0 ? void 0 : _this__reader.cancel(reason);
                                this._abortController.abort();
                            }
                        }
                    ]);
                    return PDFFetchStreamRangeReader;
                }();
            /***/ },
            /* 20 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createResponseStatusError = createResponseStatusError;
                exports.extractFilenameFromHeader = extractFilenameFromHeader;
                exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
                exports.validateResponseStatus = validateResponseStatus;
                var _util = __w_pdfjs_require__(1);
                var _content_disposition = __w_pdfjs_require__(21);
                var _display_utils = __w_pdfjs_require__(6);
                function validateRangeRequestCapabilities(param) {
                    var getResponseHeader = param.getResponseHeader, isHttp = param.isHttp, rangeChunkSize = param.rangeChunkSize, disableRange = param.disableRange;
                    var returnValues = {
                        allowRangeRequests: false,
                        suggestedLength: undefined
                    };
                    var length = parseInt(getResponseHeader("Content-Length"), 10);
                    if (!Number.isInteger(length)) return returnValues;
                    returnValues.suggestedLength = length;
                    if (length <= 2 * rangeChunkSize) return returnValues;
                    if (disableRange || !isHttp) return returnValues;
                    if (getResponseHeader("Accept-Ranges") !== "bytes") return returnValues;
                    var contentEncoding = getResponseHeader("Content-Encoding") || "identity";
                    if (contentEncoding !== "identity") return returnValues;
                    returnValues.allowRangeRequests = true;
                    return returnValues;
                }
                function extractFilenameFromHeader(getResponseHeader) {
                    var contentDisposition = getResponseHeader("Content-Disposition");
                    if (contentDisposition) {
                        var filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
                        if (filename.includes("%")) try {
                            filename = decodeURIComponent(filename);
                        } catch (e) {}
                        if ((0, _display_utils.isPdfFile)(filename)) return filename;
                    }
                    return null;
                }
                function createResponseStatusError(status, url) {
                    if (status === 404 || status === 0 && url.startsWith("file:")) return new _util.MissingPDFException('Missing PDF "' + url + '".');
                    return new _util.UnexpectedResponseException("Unexpected server response (".concat(status, ') while retrieving PDF "').concat(url, '".'), status);
                }
                function validateResponseStatus(status) {
                    return status === 200 || status === 206;
                }
            /***/ },
            /* 21 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
                var _util = __w_pdfjs_require__(1);
                function getFilenameFromContentDispositionHeader(contentDisposition) {
                    var needsEncodingFixup = true;
                    var tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        var filename = rfc2616unquote(tmp);
                        filename = unescape(filename);
                        filename = rfc5987decode(filename);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    tmp = rfc2231getparam(contentDisposition);
                    if (tmp) {
                        var filename1 = rfc2047decode(tmp);
                        return fixupEncoding(filename1);
                    }
                    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        var filename2 = rfc2616unquote(tmp);
                        filename2 = rfc2047decode(filename2);
                        return fixupEncoding(filename2);
                    }
                    function toParamRegExp(attributePattern, flags) {
                        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
                    }
                    function textdecode(encoding, value) {
                        if (encoding) {
                            if (!/^[\x00-\xFF]+$/.test(value)) return value;
                            try {
                                var decoder = new TextDecoder(encoding, {
                                    fatal: true
                                });
                                var buffer = (0, _util.stringToBytes)(value);
                                value = decoder.decode(buffer);
                                needsEncodingFixup = false;
                            } catch (e) {}
                        }
                        return value;
                    }
                    function fixupEncoding(value) {
                        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
                            value = textdecode("utf-8", value);
                            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
                        }
                        return value;
                    }
                    function rfc2231getparam(contentDispositionStr) {
                        var matches = [];
                        var match;
                        var iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                        while((match = iter.exec(contentDispositionStr)) !== null){
                            var _match = (0, $52tJv._)(match, 4), n = _match[1], quot = _match[2], part = _match[3];
                            n = parseInt(n, 10);
                            if (n in matches) {
                                if (n === 0) break;
                                continue;
                            }
                            matches[n] = [
                                quot,
                                part
                            ];
                        }
                        var parts = [];
                        for(var n1 = 0; n1 < matches.length; ++n1){
                            if (!(n1 in matches)) break;
                            var _matches_n = (0, $52tJv._)(matches[n1], 2), quot1 = _matches_n[0], part1 = _matches_n[1];
                            part1 = rfc2616unquote(part1);
                            if (quot1) {
                                part1 = unescape(part1);
                                if (n1 === 0) part1 = rfc5987decode(part1);
                            }
                            parts.push(part1);
                        }
                        return parts.join("");
                    }
                    function rfc2616unquote(value) {
                        if (value.startsWith('"')) {
                            var parts = value.slice(1).split('\\"');
                            for(var i = 0; i < parts.length; ++i){
                                var quotindex = parts[i].indexOf('"');
                                if (quotindex !== -1) {
                                    parts[i] = parts[i].slice(0, quotindex);
                                    parts.length = i + 1;
                                }
                                parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
                            }
                            value = parts.join('"');
                        }
                        return value;
                    }
                    function rfc5987decode(extvalue) {
                        var encodingend = extvalue.indexOf("'");
                        if (encodingend === -1) return extvalue;
                        var encoding = extvalue.slice(0, encodingend);
                        var langvalue = extvalue.slice(encodingend + 1);
                        var value = langvalue.replace(/^[^']*'/, "");
                        return textdecode(encoding, value);
                    }
                    function rfc2047decode(value) {
                        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
                        return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
                            if (encoding === "q" || encoding === "Q") {
                                text = text.replaceAll("_", " ");
                                text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                                    return String.fromCharCode(parseInt(hex, 16));
                                });
                                return textdecode(charset, text);
                            }
                            try {
                                text = atob(text);
                            } catch (e) {}
                            return textdecode(charset, text);
                        });
                    }
                    return "";
                }
            /***/ },
            /* 22 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNetworkStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                var OK_RESPONSE = 200;
                var PARTIAL_CONTENT_RESPONSE = 206;
                function getArrayBuffer(xhr) {
                    var data = xhr.response;
                    if (typeof data !== "string") return data;
                    return (0, _util.stringToBytes)(data).buffer;
                }
                var NetworkManager = /*#__PURE__*/ function() {
                    function NetworkManager(url) {
                        var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        (0, $5sFFs._)(this, NetworkManager);
                        this.url = url;
                        this.isHttp = /^https?:/i.test(url);
                        this.httpHeaders = this.isHttp && args.httpHeaders || Object.create(null);
                        this.withCredentials = args.withCredentials || false;
                        this.currXhrId = 0;
                        this.pendingRequests = Object.create(null);
                    }
                    (0, $8O2fV._)(NetworkManager, [
                        {
                            key: "requestRange",
                            value: function requestRange(begin, end, listeners) {
                                var args = {
                                    begin: begin,
                                    end: end
                                };
                                for(var prop in listeners)args[prop] = listeners[prop];
                                return this.request(args);
                            }
                        },
                        {
                            key: "requestFull",
                            value: function requestFull(listeners) {
                                return this.request(listeners);
                            }
                        },
                        {
                            key: "request",
                            value: function request(args) {
                                var xhr = new XMLHttpRequest();
                                var xhrId = this.currXhrId++;
                                var pendingRequest = this.pendingRequests[xhrId] = {
                                    xhr: xhr
                                };
                                xhr.open("GET", this.url);
                                xhr.withCredentials = this.withCredentials;
                                for(var property in this.httpHeaders){
                                    var value = this.httpHeaders[property];
                                    if (value === undefined) continue;
                                    xhr.setRequestHeader(property, value);
                                }
                                if (this.isHttp && "begin" in args && "end" in args) {
                                    xhr.setRequestHeader("Range", "bytes=".concat(args.begin, "-").concat(args.end - 1));
                                    pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
                                } else pendingRequest.expectedStatus = OK_RESPONSE;
                                xhr.responseType = "arraybuffer";
                                if (args.onError) xhr.onerror = function(evt) {
                                    args.onError(xhr.status);
                                };
                                xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
                                xhr.onprogress = this.onProgress.bind(this, xhrId);
                                pendingRequest.onHeadersReceived = args.onHeadersReceived;
                                pendingRequest.onDone = args.onDone;
                                pendingRequest.onError = args.onError;
                                pendingRequest.onProgress = args.onProgress;
                                xhr.send(null);
                                return xhrId;
                            }
                        },
                        {
                            key: "onProgress",
                            value: function onProgress(xhrId, evt) {
                                var _pendingRequest_onProgress;
                                var pendingRequest = this.pendingRequests[xhrId];
                                if (!pendingRequest) return;
                                (_pendingRequest_onProgress = pendingRequest.onProgress) === null || _pendingRequest_onProgress === void 0 ? void 0 : _pendingRequest_onProgress.call(pendingRequest, evt);
                            }
                        },
                        {
                            key: "onStateChange",
                            value: function onStateChange(xhrId, evt) {
                                var _pendingRequest_onError;
                                var pendingRequest = this.pendingRequests[xhrId];
                                if (!pendingRequest) return;
                                var xhr = pendingRequest.xhr;
                                if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
                                    pendingRequest.onHeadersReceived();
                                    delete pendingRequest.onHeadersReceived;
                                }
                                if (xhr.readyState !== 4) return;
                                if (!(xhrId in this.pendingRequests)) return;
                                delete this.pendingRequests[xhrId];
                                if (xhr.status === 0 && this.isHttp) {
                                    var _pendingRequest_onError1;
                                    (_pendingRequest_onError1 = pendingRequest.onError) === null || _pendingRequest_onError1 === void 0 ? void 0 : _pendingRequest_onError1.call(pendingRequest, xhr.status);
                                    return;
                                }
                                var xhrStatus = xhr.status || OK_RESPONSE;
                                var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
                                if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
                                    var _pendingRequest_onError2;
                                    (_pendingRequest_onError2 = pendingRequest.onError) === null || _pendingRequest_onError2 === void 0 ? void 0 : _pendingRequest_onError2.call(pendingRequest, xhr.status);
                                    return;
                                }
                                var chunk = getArrayBuffer(xhr);
                                if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
                                    var rangeHeader = xhr.getResponseHeader("Content-Range");
                                    var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
                                    pendingRequest.onDone({
                                        begin: parseInt(matches[1], 10),
                                        chunk: chunk
                                    });
                                } else if (chunk) pendingRequest.onDone({
                                    begin: 0,
                                    chunk: chunk
                                });
                                else (_pendingRequest_onError = pendingRequest.onError) === null || _pendingRequest_onError === void 0 ? void 0 : _pendingRequest_onError.call(pendingRequest, xhr.status);
                            }
                        },
                        {
                            key: "getRequestXhr",
                            value: function getRequestXhr(xhrId) {
                                return this.pendingRequests[xhrId].xhr;
                            }
                        },
                        {
                            key: "isPendingRequest",
                            value: function isPendingRequest(xhrId) {
                                return xhrId in this.pendingRequests;
                            }
                        },
                        {
                            key: "abortRequest",
                            value: function abortRequest(xhrId) {
                                var xhr = this.pendingRequests[xhrId].xhr;
                                delete this.pendingRequests[xhrId];
                                xhr.abort();
                            }
                        }
                    ]);
                    return NetworkManager;
                }();
                var PDFNetworkStream = /*#__PURE__*/ function() {
                    function PDFNetworkStream(source) {
                        (0, $5sFFs._)(this, PDFNetworkStream);
                        this._source = source;
                        this._manager = new NetworkManager(source.url, {
                            httpHeaders: source.httpHeaders,
                            withCredentials: source.withCredentials
                        });
                        this._rangeChunkSize = source.rangeChunkSize;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    (0, $8O2fV._)(PDFNetworkStream, [
                        {
                            key: "_onRangeRequestReaderClosed",
                            value: function _onRangeRequestReaderClosed(reader) {
                                var i = this._rangeRequestReaders.indexOf(reader);
                                if (i >= 0) this._rangeRequestReaders.splice(i, 1);
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader() {
                                (0, _util.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                                this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
                                return this._fullRequestReader;
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader(begin, end) {
                                var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
                                reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
                                this._rangeRequestReaders.push(reader);
                                return reader;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests(reason) {
                                var _this__fullRequestReader;
                                (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader.cancel(reason);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._rangeRequestReaders.slice(0)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var reader = _step.value;
                                        reader.cancel(reason);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        }
                    ]);
                    return PDFNetworkStream;
                }();
                exports.PDFNetworkStream = PDFNetworkStream;
                var PDFNetworkStreamFullRequestReader = /*#__PURE__*/ function() {
                    function PDFNetworkStreamFullRequestReader(manager, source) {
                        (0, $5sFFs._)(this, PDFNetworkStreamFullRequestReader);
                        this._manager = manager;
                        var args = {
                            onHeadersReceived: this._onHeadersReceived.bind(this),
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = source.url;
                        this._fullRequestId = manager.requestFull(args);
                        this._headersReceivedCapability = new _util.PromiseCapability();
                        this._disableRange = source.disableRange || false;
                        this._contentLength = source.length;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = false;
                        this._isRangeSupported = false;
                        this._cachedChunks = [];
                        this._requests = [];
                        this._done = false;
                        this._storedError = undefined;
                        this._filename = null;
                        this.onProgress = null;
                    }
                    (0, $8O2fV._)(PDFNetworkStreamFullRequestReader, [
                        {
                            key: "_onHeadersReceived",
                            value: function _onHeadersReceived() {
                                var fullRequestXhrId = this._fullRequestId;
                                var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
                                var getResponseHeader = function(name) {
                                    return fullRequestXhr.getResponseHeader(name);
                                };
                                var _ref = (0, _network_utils.validateRangeRequestCapabilities)({
                                    getResponseHeader: getResponseHeader,
                                    isHttp: this._manager.isHttp,
                                    rangeChunkSize: this._rangeChunkSize,
                                    disableRange: this._disableRange
                                }), allowRangeRequests = _ref.allowRangeRequests, suggestedLength = _ref.suggestedLength;
                                if (allowRangeRequests) this._isRangeSupported = true;
                                this._contentLength = suggestedLength || this._contentLength;
                                this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                                if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId);
                                this._headersReceivedCapability.resolve();
                            }
                        },
                        {
                            key: "_onDone",
                            value: function _onDone(data) {
                                if (data) {
                                    if (this._requests.length > 0) {
                                        var requestCapability = this._requests.shift();
                                        requestCapability.resolve({
                                            value: data.chunk,
                                            done: false
                                        });
                                    } else this._cachedChunks.push(data.chunk);
                                }
                                this._done = true;
                                if (this._cachedChunks.length > 0) return;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._requests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var requestCapability1 = _step.value;
                                        requestCapability1.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this._requests.length = 0;
                            }
                        },
                        {
                            key: "_onError",
                            value: function _onError(status) {
                                this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                                this._headersReceivedCapability.reject(this._storedError);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._requests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var requestCapability = _step.value;
                                        requestCapability.reject(this._storedError);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this._requests.length = 0;
                                this._cachedChunks.length = 0;
                            }
                        },
                        {
                            key: "_onProgress",
                            value: function _onProgress(evt) {
                                var _this_onProgress, _this;
                                (_this_onProgress = (_this = this).onProgress) === null || _this_onProgress === void 0 ? void 0 : _this_onProgress.call(_this, {
                                    loaded: evt.loaded,
                                    total: evt.lengthComputable ? evt.total : this._contentLength
                                });
                            }
                        },
                        {
                            key: "filename",
                            get: function get() {
                                return this._filename;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get() {
                                return this._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get() {
                                return this._contentLength;
                            }
                        },
                        {
                            key: "headersReady",
                            get: function get() {
                                return this._headersReceivedCapability.promise;
                            }
                        },
                        {
                            key: "read",
                            value: function read() {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var chunk, requestCapability;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        if (_this._storedError) throw _this._storedError;
                                        if (_this._cachedChunks.length > 0) {
                                            chunk = _this._cachedChunks.shift();
                                            return [
                                                2,
                                                {
                                                    value: chunk,
                                                    done: false
                                                }
                                            ];
                                        }
                                        if (_this._done) return [
                                            2,
                                            {
                                                value: undefined,
                                                done: true
                                            }
                                        ];
                                        requestCapability = new _util.PromiseCapability();
                                        _this._requests.push(requestCapability);
                                        return [
                                            2,
                                            requestCapability.promise
                                        ];
                                    });
                                })();
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                this._done = true;
                                this._headersReceivedCapability.reject(reason);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._requests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var requestCapability = _step.value;
                                        requestCapability.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this._requests.length = 0;
                                if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
                                this._fullRequestReader = null;
                            }
                        }
                    ]);
                    return PDFNetworkStreamFullRequestReader;
                }();
                var PDFNetworkStreamRangeRequestReader = /*#__PURE__*/ function() {
                    function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
                        (0, $5sFFs._)(this, PDFNetworkStreamRangeRequestReader);
                        this._manager = manager;
                        var args = {
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = manager.url;
                        this._requestId = manager.requestRange(begin, end, args);
                        this._requests = [];
                        this._queuedChunk = null;
                        this._done = false;
                        this._storedError = undefined;
                        this.onProgress = null;
                        this.onClosed = null;
                    }
                    (0, $8O2fV._)(PDFNetworkStreamRangeRequestReader, [
                        {
                            key: "_close",
                            value: function _close() {
                                var _this_onClosed, _this;
                                (_this_onClosed = (_this = this).onClosed) === null || _this_onClosed === void 0 ? void 0 : _this_onClosed.call(_this, this);
                            }
                        },
                        {
                            key: "_onDone",
                            value: function _onDone(data) {
                                var chunk = data.chunk;
                                if (this._requests.length > 0) {
                                    var requestCapability = this._requests.shift();
                                    requestCapability.resolve({
                                        value: chunk,
                                        done: false
                                    });
                                } else this._queuedChunk = chunk;
                                this._done = true;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._requests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var requestCapability1 = _step.value;
                                        requestCapability1.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this._requests.length = 0;
                                this._close();
                            }
                        },
                        {
                            key: "_onError",
                            value: function _onError(status) {
                                this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._requests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var requestCapability = _step.value;
                                        requestCapability.reject(this._storedError);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this._requests.length = 0;
                                this._queuedChunk = null;
                            }
                        },
                        {
                            key: "_onProgress",
                            value: function _onProgress(evt) {
                                var _this_onProgress, _this;
                                if (!this.isStreamingSupported) (_this_onProgress = (_this = this).onProgress) === null || _this_onProgress === void 0 ? void 0 : _this_onProgress.call(_this, {
                                    loaded: evt.loaded
                                });
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return false;
                            }
                        },
                        {
                            key: "read",
                            value: function read() {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var chunk, requestCapability;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        if (_this._storedError) throw _this._storedError;
                                        if (_this._queuedChunk !== null) {
                                            chunk = _this._queuedChunk;
                                            _this._queuedChunk = null;
                                            return [
                                                2,
                                                {
                                                    value: chunk,
                                                    done: false
                                                }
                                            ];
                                        }
                                        if (_this._done) return [
                                            2,
                                            {
                                                value: undefined,
                                                done: true
                                            }
                                        ];
                                        requestCapability = new _util.PromiseCapability();
                                        _this._requests.push(requestCapability);
                                        return [
                                            2,
                                            requestCapability.promise
                                        ];
                                    });
                                })();
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                this._done = true;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._requests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var requestCapability = _step.value;
                                        requestCapability.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this._requests.length = 0;
                                if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
                                this._close();
                            }
                        }
                    ]);
                    return PDFNetworkStreamRangeRequestReader;
                }();
            /***/ },
            /* 23 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNodeStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                var fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
                function parseUrl(sourceUrl) {
                    var url = (parcelRequire("6Guue"));
                    var parsedUrl = url.parse(sourceUrl);
                    if (parsedUrl.protocol === "file:" || parsedUrl.host) return parsedUrl;
                    if (/^[a-z]:[/\\]/i.test(sourceUrl)) return url.parse("file:///".concat(sourceUrl));
                    if (!parsedUrl.host) parsedUrl.protocol = "file:";
                    return parsedUrl;
                }
                var PDFNodeStream = /*#__PURE__*/ function() {
                    function PDFNodeStream(source) {
                        (0, $5sFFs._)(this, PDFNodeStream);
                        this.source = source;
                        this.url = parseUrl(source.url);
                        this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
                        this.isFsUrl = this.url.protocol === "file:";
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    (0, $8O2fV._)(PDFNodeStream, [
                        {
                            key: "_progressiveDataLength",
                            get: function get() {
                                var _this__fullRequestReader;
                                var _this__fullRequestReader__loaded;
                                return (_this__fullRequestReader__loaded = (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader._loaded) !== null && _this__fullRequestReader__loaded !== void 0 ? _this__fullRequestReader__loaded : 0;
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader() {
                                (0, _util.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                                this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
                                return this._fullRequestReader;
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader(start, end) {
                                if (end <= this._progressiveDataLength) return null;
                                var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
                                this._rangeRequestReaders.push(rangeReader);
                                return rangeReader;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests(reason) {
                                var _this__fullRequestReader;
                                (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader.cancel(reason);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._rangeRequestReaders.slice(0)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var reader = _step.value;
                                        reader.cancel(reason);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        }
                    ]);
                    return PDFNodeStream;
                }();
                exports.PDFNodeStream = PDFNodeStream;
                var BaseFullReader = /*#__PURE__*/ function() {
                    function BaseFullReader(stream) {
                        (0, $5sFFs._)(this, BaseFullReader);
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        var source = stream.source;
                        this._contentLength = source.length;
                        this._loaded = 0;
                        this._filename = null;
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._readableStream = null;
                        this._readCapability = new _util.PromiseCapability();
                        this._headersCapability = new _util.PromiseCapability();
                    }
                    (0, $8O2fV._)(BaseFullReader, [
                        {
                            key: "headersReady",
                            get: function get() {
                                return this._headersCapability.promise;
                            }
                        },
                        {
                            key: "filename",
                            get: function get() {
                                return this._filename;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get() {
                                return this._contentLength;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get() {
                                return this._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function read() {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var _this_onProgress, _this1, chunk, buffer;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    _this._readCapability.promise
                                                ];
                                            case 1:
                                                _state.sent();
                                                if (_this._done) return [
                                                    2,
                                                    {
                                                        value: undefined,
                                                        done: true
                                                    }
                                                ];
                                                if (_this._storedError) throw _this._storedError;
                                                chunk = _this._readableStream.read();
                                                if (chunk === null) {
                                                    _this._readCapability = new _util.PromiseCapability();
                                                    return [
                                                        2,
                                                        _this.read()
                                                    ];
                                                }
                                                _this._loaded += chunk.length;
                                                (_this_onProgress = (_this1 = _this).onProgress) === null || _this_onProgress === void 0 ? void 0 : _this_onProgress.call(_this1, {
                                                    loaded: _this._loaded,
                                                    total: _this._contentLength
                                                });
                                                buffer = new Uint8Array(chunk).buffer;
                                                return [
                                                    2,
                                                    {
                                                        value: buffer,
                                                        done: false
                                                    }
                                                ];
                                        }
                                    });
                                })();
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                if (!this._readableStream) {
                                    this._error(reason);
                                    return;
                                }
                                this._readableStream.destroy(reason);
                            }
                        },
                        {
                            key: "_error",
                            value: function _error(reason) {
                                this._storedError = reason;
                                this._readCapability.resolve();
                            }
                        },
                        {
                            key: "_setReadableStream",
                            value: function _setReadableStream(readableStream) {
                                var _this = this;
                                this._readableStream = readableStream;
                                readableStream.on("readable", function() {
                                    _this._readCapability.resolve();
                                });
                                readableStream.on("end", function() {
                                    readableStream.destroy();
                                    _this._done = true;
                                    _this._readCapability.resolve();
                                });
                                readableStream.on("error", function(reason) {
                                    _this._error(reason);
                                });
                                if (!this._isStreamingSupported && this._isRangeSupported) this._error(new _util.AbortException("streaming is disabled"));
                                if (this._storedError) this._readableStream.destroy(this._storedError);
                            }
                        }
                    ]);
                    return BaseFullReader;
                }();
                var BaseRangeReader = /*#__PURE__*/ function() {
                    function BaseRangeReader(stream) {
                        (0, $5sFFs._)(this, BaseRangeReader);
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        this._loaded = 0;
                        this._readableStream = null;
                        this._readCapability = new _util.PromiseCapability();
                        var source = stream.source;
                        this._isStreamingSupported = !source.disableStream;
                    }
                    (0, $8O2fV._)(BaseRangeReader, [
                        {
                            key: "isStreamingSupported",
                            get: function get() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function read() {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var _this_onProgress, _this1, chunk, buffer;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    _this._readCapability.promise
                                                ];
                                            case 1:
                                                _state.sent();
                                                if (_this._done) return [
                                                    2,
                                                    {
                                                        value: undefined,
                                                        done: true
                                                    }
                                                ];
                                                if (_this._storedError) throw _this._storedError;
                                                chunk = _this._readableStream.read();
                                                if (chunk === null) {
                                                    _this._readCapability = new _util.PromiseCapability();
                                                    return [
                                                        2,
                                                        _this.read()
                                                    ];
                                                }
                                                _this._loaded += chunk.length;
                                                (_this_onProgress = (_this1 = _this).onProgress) === null || _this_onProgress === void 0 ? void 0 : _this_onProgress.call(_this1, {
                                                    loaded: _this._loaded
                                                });
                                                buffer = new Uint8Array(chunk).buffer;
                                                return [
                                                    2,
                                                    {
                                                        value: buffer,
                                                        done: false
                                                    }
                                                ];
                                        }
                                    });
                                })();
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel(reason) {
                                if (!this._readableStream) {
                                    this._error(reason);
                                    return;
                                }
                                this._readableStream.destroy(reason);
                            }
                        },
                        {
                            key: "_error",
                            value: function _error(reason) {
                                this._storedError = reason;
                                this._readCapability.resolve();
                            }
                        },
                        {
                            key: "_setReadableStream",
                            value: function _setReadableStream(readableStream) {
                                var _this = this;
                                this._readableStream = readableStream;
                                readableStream.on("readable", function() {
                                    _this._readCapability.resolve();
                                });
                                readableStream.on("end", function() {
                                    readableStream.destroy();
                                    _this._done = true;
                                    _this._readCapability.resolve();
                                });
                                readableStream.on("error", function(reason) {
                                    _this._error(reason);
                                });
                                if (this._storedError) this._readableStream.destroy(this._storedError);
                            }
                        }
                    ]);
                    return BaseRangeReader;
                }();
                function createRequestOptions(parsedUrl, headers) {
                    return {
                        protocol: parsedUrl.protocol,
                        auth: parsedUrl.auth,
                        host: parsedUrl.hostname,
                        port: parsedUrl.port,
                        path: parsedUrl.path,
                        method: "GET",
                        headers: headers
                    };
                }
                var PDFNodeStreamFullReader = /*#__PURE__*/ function(BaseFullReader) {
                    (0, $kcqLc._)(PDFNodeStreamFullReader, BaseFullReader);
                    var _super = (0, $4jYWU._)(PDFNodeStreamFullReader);
                    function PDFNodeStreamFullReader(stream) {
                        (0, $5sFFs._)(this, PDFNodeStreamFullReader);
                        var _this;
                        _this = _super.call(this, stream);
                        var handleResponse = function(response) {
                            if (response.statusCode === 404) {
                                var error = new _util.MissingPDFException('Missing PDF "'.concat(_this._url, '".'));
                                _this._storedError = error;
                                _this._headersCapability.reject(error);
                                return;
                            }
                            _this._headersCapability.resolve();
                            _this._setReadableStream(response);
                            var getResponseHeader = function(name) {
                                return _this._readableStream.headers[name.toLowerCase()];
                            };
                            var _ref = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: stream.isHttp,
                                rangeChunkSize: _this._rangeChunkSize,
                                disableRange: _this._disableRange
                            }), allowRangeRequests = _ref.allowRangeRequests, suggestedLength = _ref.suggestedLength;
                            _this._isRangeSupported = allowRangeRequests;
                            _this._contentLength = suggestedLength || _this._contentLength;
                            _this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        };
                        _this._request = null;
                        if (_this._url.protocol === "http:") {
                            var http = (parcelRequire("6Guue"));
                            _this._request = http.request(createRequestOptions(_this._url, stream.httpHeaders), handleResponse);
                        } else {
                            var https = (parcelRequire("6Guue"));
                            _this._request = https.request(createRequestOptions(_this._url, stream.httpHeaders), handleResponse);
                        }
                        _this._request.on("error", function(reason) {
                            _this._storedError = reason;
                            _this._headersCapability.reject(reason);
                        });
                        _this._request.end();
                        return _this;
                    }
                    return PDFNodeStreamFullReader;
                }(BaseFullReader);
                var PDFNodeStreamRangeReader = /*#__PURE__*/ function(BaseRangeReader) {
                    (0, $kcqLc._)(PDFNodeStreamRangeReader, BaseRangeReader);
                    var _super = (0, $4jYWU._)(PDFNodeStreamRangeReader);
                    function PDFNodeStreamRangeReader(stream, start, end) {
                        (0, $5sFFs._)(this, PDFNodeStreamRangeReader);
                        var _this;
                        _this = _super.call(this, stream);
                        _this._httpHeaders = {};
                        for(var property in stream.httpHeaders){
                            var value = stream.httpHeaders[property];
                            if (value === undefined) continue;
                            _this._httpHeaders[property] = value;
                        }
                        _this._httpHeaders.Range = "bytes=".concat(start, "-").concat(end - 1);
                        var handleResponse = function(response) {
                            if (response.statusCode === 404) {
                                var error = new _util.MissingPDFException('Missing PDF "'.concat(_this._url, '".'));
                                _this._storedError = error;
                                return;
                            }
                            _this._setReadableStream(response);
                        };
                        _this._request = null;
                        if (_this._url.protocol === "http:") {
                            var http = (parcelRequire("6Guue"));
                            _this._request = http.request(createRequestOptions(_this._url, _this._httpHeaders), handleResponse);
                        } else {
                            var https = (parcelRequire("6Guue"));
                            _this._request = https.request(createRequestOptions(_this._url, _this._httpHeaders), handleResponse);
                        }
                        _this._request.on("error", function(reason) {
                            _this._storedError = reason;
                        });
                        _this._request.end();
                        return _this;
                    }
                    return PDFNodeStreamRangeReader;
                }(BaseRangeReader);
                var PDFNodeStreamFsFullReader = /*#__PURE__*/ function(BaseFullReader) {
                    (0, $kcqLc._)(PDFNodeStreamFsFullReader, BaseFullReader);
                    var _super = (0, $4jYWU._)(PDFNodeStreamFsFullReader);
                    function PDFNodeStreamFsFullReader(stream) {
                        (0, $5sFFs._)(this, PDFNodeStreamFsFullReader);
                        var _this;
                        _this = _super.call(this, stream);
                        var path = decodeURIComponent(_this._url.path);
                        if (fileUriRegex.test(_this._url.href)) path = path.replace(/^\//, "");
                        var fs = (parcelRequire("6Guue"));
                        fs.lstat(path, function(error, stat) {
                            if (error) {
                                if (error.code === "ENOENT") error = new _util.MissingPDFException('Missing PDF "'.concat(path, '".'));
                                _this._storedError = error;
                                _this._headersCapability.reject(error);
                                return;
                            }
                            _this._contentLength = stat.size;
                            _this._setReadableStream(fs.createReadStream(path));
                            _this._headersCapability.resolve();
                        });
                        return _this;
                    }
                    return PDFNodeStreamFsFullReader;
                }(BaseFullReader);
                var PDFNodeStreamFsRangeReader = /*#__PURE__*/ function(BaseRangeReader) {
                    (0, $kcqLc._)(PDFNodeStreamFsRangeReader, BaseRangeReader);
                    var _super = (0, $4jYWU._)(PDFNodeStreamFsRangeReader);
                    function PDFNodeStreamFsRangeReader(stream, start, end) {
                        (0, $5sFFs._)(this, PDFNodeStreamFsRangeReader);
                        var _this;
                        _this = _super.call(this, stream);
                        var path = decodeURIComponent(_this._url.path);
                        if (fileUriRegex.test(_this._url.href)) path = path.replace(/^\//, "");
                        var fs = (parcelRequire("6Guue"));
                        _this._setReadableStream(fs.createReadStream(path, {
                            start: start,
                            end: end - 1
                        }));
                        return _this;
                    }
                    return PDFNodeStreamFsRangeReader;
                }(BaseRangeReader);
            /***/ },
            /* 24 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SVGGraphics = void 0;
                var _display_utils = __w_pdfjs_require__(6);
                var _util = __w_pdfjs_require__(1);
                var SVG_DEFAULTS = {
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fillColor: "#000000"
                };
                var XML_NS = "http://www.w3.org/XML/1998/namespace";
                var XLINK_NS = "http://www.w3.org/1999/xlink";
                var LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                var LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                var createObjectURL = function createObjectURL(data) {
                    var contentType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", forceDataSchema = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                    if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema) return URL.createObjectURL(new Blob([
                        data
                    ], {
                        type: contentType
                    }));
                    var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    var buffer = "data:".concat(contentType, ";base64,");
                    for(var i = 0, ii = data.length; i < ii; i += 3){
                        var b1 = data[i] & 0xff;
                        var b2 = data[i + 1] & 0xff;
                        var b3 = data[i + 2] & 0xff;
                        var d1 = b1 >> 2, d2 = (b1 & 3) << 4 | b2 >> 4;
                        var d3 = i + 1 < ii ? (b2 & 0xf) << 2 | b3 >> 6 : 64;
                        var d4 = i + 2 < ii ? b3 & 0x3f : 64;
                        buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
                    }
                    return buffer;
                };
                var convertImgDataToPng = function() {
                    var PNG_HEADER = new Uint8Array([
                        0x89,
                        0x50,
                        0x4e,
                        0x47,
                        0x0d,
                        0x0a,
                        0x1a,
                        0x0a
                    ]);
                    var CHUNK_WRAPPER_SIZE = 12;
                    var crcTable = new Int32Array(256);
                    for(var i = 0; i < 256; i++){
                        var c = i;
                        for(var h = 0; h < 8; h++)c = c & 1 ? 0xedb88320 ^ c >> 1 & 0x7fffffff : c >> 1 & 0x7fffffff;
                        crcTable[i] = c;
                    }
                    function crc32(data, start, end) {
                        var crc = -1;
                        for(var i = start; i < end; i++){
                            var a = (crc ^ data[i]) & 0xff;
                            var b = crcTable[a];
                            crc = crc >>> 8 ^ b;
                        }
                        return crc ^ -1;
                    }
                    function writePngChunk(type, body, data, offset) {
                        var p = offset;
                        var len = body.length;
                        data[p] = len >> 24 & 0xff;
                        data[p + 1] = len >> 16 & 0xff;
                        data[p + 2] = len >> 8 & 0xff;
                        data[p + 3] = len & 0xff;
                        p += 4;
                        data[p] = type.charCodeAt(0) & 0xff;
                        data[p + 1] = type.charCodeAt(1) & 0xff;
                        data[p + 2] = type.charCodeAt(2) & 0xff;
                        data[p + 3] = type.charCodeAt(3) & 0xff;
                        p += 4;
                        data.set(body, p);
                        p += body.length;
                        var crc = crc32(data, offset + 4, p);
                        data[p] = crc >> 24 & 0xff;
                        data[p + 1] = crc >> 16 & 0xff;
                        data[p + 2] = crc >> 8 & 0xff;
                        data[p + 3] = crc & 0xff;
                    }
                    function adler32(data, start, end) {
                        var a = 1;
                        var b = 0;
                        for(var i = start; i < end; ++i){
                            a = (a + (data[i] & 0xff)) % 65521;
                            b = (b + a) % 65521;
                        }
                        return b << 16 | a;
                    }
                    function deflateSync(literals) {
                        if (!_util.isNodeJS) return deflateSyncUncompressed(literals);
                        try {
                            var input = parseInt($kTBk6.versions.node) >= 8 ? literals : $6e4e36316ba04d62$require$Buffer.from(literals);
                            var output = (parcelRequire("6Guue")).deflateSync(input, {
                                level: 9
                            });
                            return output instanceof Uint8Array ? output : new Uint8Array(output);
                        } catch (e) {
                            (0, _util.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e);
                        }
                        return deflateSyncUncompressed(literals);
                    }
                    function deflateSyncUncompressed(literals) {
                        var len = literals.length;
                        var maxBlockLength = 0xffff;
                        var deflateBlocks = Math.ceil(len / maxBlockLength);
                        var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
                        var pi = 0;
                        idat[pi++] = 0x78;
                        idat[pi++] = 0x9c;
                        var pos = 0;
                        while(len > maxBlockLength){
                            idat[pi++] = 0x00;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0x00;
                            idat[pi++] = 0x00;
                            idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
                            pi += maxBlockLength;
                            pos += maxBlockLength;
                            len -= maxBlockLength;
                        }
                        idat[pi++] = 0x01;
                        idat[pi++] = len & 0xff;
                        idat[pi++] = len >> 8 & 0xff;
                        idat[pi++] = ~len & 255;
                        idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
                        idat.set(literals.subarray(pos), pi);
                        pi += literals.length - pos;
                        var adler = adler32(literals, 0, literals.length);
                        idat[pi++] = adler >> 24 & 0xff;
                        idat[pi++] = adler >> 16 & 0xff;
                        idat[pi++] = adler >> 8 & 0xff;
                        idat[pi++] = adler & 0xff;
                        return idat;
                    }
                    function encode(imgData, kind, forceDataSchema, isMask) {
                        var width = imgData.width;
                        var height = imgData.height;
                        var bitDepth, colorType, lineSize;
                        var bytes = imgData.data;
                        switch(kind){
                            case _util.ImageKind.GRAYSCALE_1BPP:
                                colorType = 0;
                                bitDepth = 1;
                                lineSize = width + 7 >> 3;
                                break;
                            case _util.ImageKind.RGB_24BPP:
                                colorType = 2;
                                bitDepth = 8;
                                lineSize = width * 3;
                                break;
                            case _util.ImageKind.RGBA_32BPP:
                                colorType = 6;
                                bitDepth = 8;
                                lineSize = width * 4;
                                break;
                            default:
                                throw new Error("invalid format");
                        }
                        var literals = new Uint8Array((1 + lineSize) * height);
                        var offsetLiterals = 0, offsetBytes = 0;
                        for(var y = 0; y < height; ++y){
                            literals[offsetLiterals++] = 0;
                            literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
                            offsetBytes += lineSize;
                            offsetLiterals += lineSize;
                        }
                        if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
                            offsetLiterals = 0;
                            for(var y1 = 0; y1 < height; y1++){
                                offsetLiterals++;
                                for(var i = 0; i < lineSize; i++)literals[offsetLiterals++] ^= 0xff;
                            }
                        }
                        var ihdr = new Uint8Array([
                            width >> 24 & 0xff,
                            width >> 16 & 0xff,
                            width >> 8 & 0xff,
                            width & 0xff,
                            height >> 24 & 0xff,
                            height >> 16 & 0xff,
                            height >> 8 & 0xff,
                            height & 0xff,
                            bitDepth,
                            colorType,
                            0x00,
                            0x00,
                            0x00
                        ]);
                        var idat = deflateSync(literals);
                        var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
                        var data = new Uint8Array(pngLength);
                        var offset = 0;
                        data.set(PNG_HEADER, offset);
                        offset += PNG_HEADER.length;
                        writePngChunk("IHDR", ihdr, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + ihdr.length;
                        writePngChunk("IDATA", idat, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + idat.length;
                        writePngChunk("IEND", new Uint8Array(0), data, offset);
                        return createObjectURL(data, "image/png", forceDataSchema);
                    }
                    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
                        var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
                        return encode(imgData, kind, forceDataSchema, isMask);
                    };
                }();
                var SVGExtraState = /*#__PURE__*/ function() {
                    function SVGExtraState() {
                        (0, $5sFFs._)(this, SVGExtraState);
                        this.fontSizeScale = 1;
                        this.fontWeight = SVG_DEFAULTS.fontWeight;
                        this.fontSize = 0;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textMatrixScale = 1;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                        this.fillColor = SVG_DEFAULTS.fillColor;
                        this.strokeColor = "#000000";
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.lineJoin = "";
                        this.lineCap = "";
                        this.miterLimit = 0;
                        this.dashArray = [];
                        this.dashPhase = 0;
                        this.dependencies = [];
                        this.activeClipUrl = null;
                        this.clipGroup = null;
                        this.maskId = "";
                    }
                    (0, $8O2fV._)(SVGExtraState, [
                        {
                            key: "clone",
                            value: function clone() {
                                return Object.create(this);
                            }
                        },
                        {
                            key: "setCurrentPoint",
                            value: function setCurrentPoint(x, y) {
                                this.x = x;
                                this.y = y;
                            }
                        }
                    ]);
                    return SVGExtraState;
                }();
                function opListToTree(opList) {
                    var opTree = [];
                    var tmp = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = opList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var opListElement = _step.value;
                            if (opListElement.fn === "save") {
                                opTree.push({
                                    fnId: 92,
                                    fn: "group",
                                    items: []
                                });
                                tmp.push(opTree);
                                opTree = opTree.at(-1).items;
                                continue;
                            }
                            if (opListElement.fn === "restore") opTree = tmp.pop();
                            else opTree.push(opListElement);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return opTree;
                }
                function pf(value) {
                    if (Number.isInteger(value)) return value.toString();
                    var s = value.toFixed(10);
                    var i = s.length - 1;
                    if (s[i] !== "0") return s;
                    do i--;
                    while (s[i] === "0");
                    return s.substring(0, s[i] === "." ? i : i + 1);
                }
                function pm(m) {
                    if (m[4] === 0 && m[5] === 0) {
                        if (m[1] === 0 && m[2] === 0) {
                            if (m[0] === 1 && m[3] === 1) return "";
                            return "scale(".concat(pf(m[0]), " ").concat(pf(m[3]), ")");
                        }
                        if (m[0] === m[3] && m[1] === -m[2]) {
                            var a = Math.acos(m[0]) * 180 / Math.PI;
                            return "rotate(".concat(pf(a), ")");
                        }
                    } else if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) return "translate(".concat(pf(m[4]), " ").concat(pf(m[5]), ")");
                    return "matrix(".concat(pf(m[0]), " ").concat(pf(m[1]), " ").concat(pf(m[2]), " ").concat(pf(m[3]), " ").concat(pf(m[4]), " ") + "".concat(pf(m[5]), ")");
                }
                var clipCount = 0;
                var maskCount = 0;
                var shadingCount = 0;
                var SVGGraphics = /*#__PURE__*/ function() {
                    function SVGGraphics(commonObjs, objs) {
                        var forceDataSchema = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                        (0, $5sFFs._)(this, SVGGraphics);
                        (0, _display_utils.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future.");
                        this.svgFactory = new _display_utils.DOMSVGFactory();
                        this.current = new SVGExtraState();
                        this.transformMatrix = _util.IDENTITY_MATRIX;
                        this.transformStack = [];
                        this.extraStack = [];
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.embedFonts = false;
                        this.embeddedFonts = Object.create(null);
                        this.cssStyle = null;
                        this.forceDataSchema = !!forceDataSchema;
                        this._operatorIdMapping = [];
                        for(var op in _util.OPS)this._operatorIdMapping[_util.OPS[op]] = op;
                    }
                    (0, $8O2fV._)(SVGGraphics, [
                        {
                            key: "getObject",
                            value: function getObject(data) {
                                var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                                if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
                                return fallback;
                            }
                        },
                        {
                            key: "save",
                            value: function save() {
                                this.transformStack.push(this.transformMatrix);
                                var old = this.current;
                                this.extraStack.push(old);
                                this.current = old.clone();
                            }
                        },
                        {
                            key: "restore",
                            value: function restore() {
                                this.transformMatrix = this.transformStack.pop();
                                this.current = this.extraStack.pop();
                                this.pendingClip = null;
                                this.tgrp = null;
                            }
                        },
                        {
                            key: "group",
                            value: function group(items) {
                                this.save();
                                this.executeOpTree(items);
                                this.restore();
                            }
                        },
                        {
                            key: "loadDependencies",
                            value: function loadDependencies(operatorList) {
                                var fnArray = operatorList.fnArray;
                                var argsArray = operatorList.argsArray;
                                for(var i = 0, ii = fnArray.length; i < ii; i++){
                                    if (fnArray[i] !== _util.OPS.dependency) continue;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        var _this = this, _loop = function() {
                                            var obj = _step.value;
                                            var objsPool = obj.startsWith("g_") ? _this.commonObjs : _this.objs;
                                            var promise = new Promise(function(resolve) {
                                                objsPool.get(obj, resolve);
                                            });
                                            _this.current.dependencies.push(promise);
                                        };
                                        for(var _iterator = argsArray[i][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                                return Promise.all(this.current.dependencies);
                            }
                        },
                        {
                            key: "transform",
                            value: function transform(a, b, c, d, e, f) {
                                var transformMatrix = [
                                    a,
                                    b,
                                    c,
                                    d,
                                    e,
                                    f
                                ];
                                this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
                                this.tgrp = null;
                            }
                        },
                        {
                            key: "getSVG",
                            value: function getSVG(operatorList, viewport) {
                                var _this = this;
                                this.viewport = viewport;
                                var svgElement = this._initialize(viewport);
                                return this.loadDependencies(operatorList).then(function() {
                                    _this.transformMatrix = _util.IDENTITY_MATRIX;
                                    _this.executeOpTree(_this.convertOpList(operatorList));
                                    return svgElement;
                                });
                            }
                        },
                        {
                            key: "convertOpList",
                            value: function convertOpList(operatorList) {
                                var operatorIdMapping = this._operatorIdMapping;
                                var argsArray = operatorList.argsArray;
                                var fnArray = operatorList.fnArray;
                                var opList = [];
                                for(var i = 0, ii = fnArray.length; i < ii; i++){
                                    var fnId = fnArray[i];
                                    opList.push({
                                        fnId: fnId,
                                        fn: operatorIdMapping[fnId],
                                        args: argsArray[i]
                                    });
                                }
                                return opListToTree(opList);
                            }
                        },
                        {
                            key: "executeOpTree",
                            value: function executeOpTree(opTree) {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = opTree[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var opTreeElement = _step.value;
                                        var fn = opTreeElement.fn;
                                        var fnId = opTreeElement.fnId;
                                        var args = opTreeElement.args;
                                        switch(fnId | 0){
                                            case _util.OPS.beginText:
                                                this.beginText();
                                                break;
                                            case _util.OPS.dependency:
                                                break;
                                            case _util.OPS.setLeading:
                                                this.setLeading(args);
                                                break;
                                            case _util.OPS.setLeadingMoveText:
                                                this.setLeadingMoveText(args[0], args[1]);
                                                break;
                                            case _util.OPS.setFont:
                                                this.setFont(args);
                                                break;
                                            case _util.OPS.showText:
                                                this.showText(args[0]);
                                                break;
                                            case _util.OPS.showSpacedText:
                                                this.showText(args[0]);
                                                break;
                                            case _util.OPS.endText:
                                                this.endText();
                                                break;
                                            case _util.OPS.moveText:
                                                this.moveText(args[0], args[1]);
                                                break;
                                            case _util.OPS.setCharSpacing:
                                                this.setCharSpacing(args[0]);
                                                break;
                                            case _util.OPS.setWordSpacing:
                                                this.setWordSpacing(args[0]);
                                                break;
                                            case _util.OPS.setHScale:
                                                this.setHScale(args[0]);
                                                break;
                                            case _util.OPS.setTextMatrix:
                                                this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                                break;
                                            case _util.OPS.setTextRise:
                                                this.setTextRise(args[0]);
                                                break;
                                            case _util.OPS.setTextRenderingMode:
                                                this.setTextRenderingMode(args[0]);
                                                break;
                                            case _util.OPS.setLineWidth:
                                                this.setLineWidth(args[0]);
                                                break;
                                            case _util.OPS.setLineJoin:
                                                this.setLineJoin(args[0]);
                                                break;
                                            case _util.OPS.setLineCap:
                                                this.setLineCap(args[0]);
                                                break;
                                            case _util.OPS.setMiterLimit:
                                                this.setMiterLimit(args[0]);
                                                break;
                                            case _util.OPS.setFillRGBColor:
                                                this.setFillRGBColor(args[0], args[1], args[2]);
                                                break;
                                            case _util.OPS.setStrokeRGBColor:
                                                this.setStrokeRGBColor(args[0], args[1], args[2]);
                                                break;
                                            case _util.OPS.setStrokeColorN:
                                                this.setStrokeColorN(args);
                                                break;
                                            case _util.OPS.setFillColorN:
                                                this.setFillColorN(args);
                                                break;
                                            case _util.OPS.shadingFill:
                                                this.shadingFill(args[0]);
                                                break;
                                            case _util.OPS.setDash:
                                                this.setDash(args[0], args[1]);
                                                break;
                                            case _util.OPS.setRenderingIntent:
                                                this.setRenderingIntent(args[0]);
                                                break;
                                            case _util.OPS.setFlatness:
                                                this.setFlatness(args[0]);
                                                break;
                                            case _util.OPS.setGState:
                                                this.setGState(args[0]);
                                                break;
                                            case _util.OPS.fill:
                                                this.fill();
                                                break;
                                            case _util.OPS.eoFill:
                                                this.eoFill();
                                                break;
                                            case _util.OPS.stroke:
                                                this.stroke();
                                                break;
                                            case _util.OPS.fillStroke:
                                                this.fillStroke();
                                                break;
                                            case _util.OPS.eoFillStroke:
                                                this.eoFillStroke();
                                                break;
                                            case _util.OPS.clip:
                                                this.clip("nonzero");
                                                break;
                                            case _util.OPS.eoClip:
                                                this.clip("evenodd");
                                                break;
                                            case _util.OPS.paintSolidColorImageMask:
                                                this.paintSolidColorImageMask();
                                                break;
                                            case _util.OPS.paintImageXObject:
                                                this.paintImageXObject(args[0]);
                                                break;
                                            case _util.OPS.paintInlineImageXObject:
                                                this.paintInlineImageXObject(args[0]);
                                                break;
                                            case _util.OPS.paintImageMaskXObject:
                                                this.paintImageMaskXObject(args[0]);
                                                break;
                                            case _util.OPS.paintFormXObjectBegin:
                                                this.paintFormXObjectBegin(args[0], args[1]);
                                                break;
                                            case _util.OPS.paintFormXObjectEnd:
                                                this.paintFormXObjectEnd();
                                                break;
                                            case _util.OPS.closePath:
                                                this.closePath();
                                                break;
                                            case _util.OPS.closeStroke:
                                                this.closeStroke();
                                                break;
                                            case _util.OPS.closeFillStroke:
                                                this.closeFillStroke();
                                                break;
                                            case _util.OPS.closeEOFillStroke:
                                                this.closeEOFillStroke();
                                                break;
                                            case _util.OPS.nextLine:
                                                this.nextLine();
                                                break;
                                            case _util.OPS.transform:
                                                this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                                                break;
                                            case _util.OPS.constructPath:
                                                this.constructPath(args[0], args[1]);
                                                break;
                                            case _util.OPS.endPath:
                                                this.endPath();
                                                break;
                                            case 92:
                                                this.group(opTreeElement.items);
                                                break;
                                            default:
                                                (0, _util.warn)("Unimplemented operator ".concat(fn));
                                                break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "setWordSpacing",
                            value: function setWordSpacing(wordSpacing) {
                                this.current.wordSpacing = wordSpacing;
                            }
                        },
                        {
                            key: "setCharSpacing",
                            value: function setCharSpacing(charSpacing) {
                                this.current.charSpacing = charSpacing;
                            }
                        },
                        {
                            key: "nextLine",
                            value: function nextLine() {
                                this.moveText(0, this.current.leading);
                            }
                        },
                        {
                            key: "setTextMatrix",
                            value: function setTextMatrix(a, b, c, d, e, f) {
                                var current = this.current;
                                current.textMatrix = current.lineMatrix = [
                                    a,
                                    b,
                                    c,
                                    d,
                                    e,
                                    f
                                ];
                                current.textMatrixScale = Math.hypot(a, b);
                                current.x = current.lineX = 0;
                                current.y = current.lineY = 0;
                                current.xcoords = [];
                                current.ycoords = [];
                                current.tspan = this.svgFactory.createElement("svg:tspan");
                                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                                current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
                                current.tspan.setAttributeNS(null, "y", pf(-current.y));
                                current.txtElement = this.svgFactory.createElement("svg:text");
                                current.txtElement.append(current.tspan);
                            }
                        },
                        {
                            key: "beginText",
                            value: function beginText() {
                                var current = this.current;
                                current.x = current.lineX = 0;
                                current.y = current.lineY = 0;
                                current.textMatrix = _util.IDENTITY_MATRIX;
                                current.lineMatrix = _util.IDENTITY_MATRIX;
                                current.textMatrixScale = 1;
                                current.tspan = this.svgFactory.createElement("svg:tspan");
                                current.txtElement = this.svgFactory.createElement("svg:text");
                                current.txtgrp = this.svgFactory.createElement("svg:g");
                                current.xcoords = [];
                                current.ycoords = [];
                            }
                        },
                        {
                            key: "moveText",
                            value: function moveText(x, y) {
                                var current = this.current;
                                current.x = current.lineX += x;
                                current.y = current.lineY += y;
                                current.xcoords = [];
                                current.ycoords = [];
                                current.tspan = this.svgFactory.createElement("svg:tspan");
                                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                                current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
                                current.tspan.setAttributeNS(null, "y", pf(-current.y));
                            }
                        },
                        {
                            key: "showText",
                            value: function showText(glyphs) {
                                var current = this.current;
                                var font = current.font;
                                var fontSize = current.fontSize;
                                if (fontSize === 0) return;
                                var fontSizeScale = current.fontSizeScale;
                                var charSpacing = current.charSpacing;
                                var wordSpacing = current.wordSpacing;
                                var fontDirection = current.fontDirection;
                                var textHScale = current.textHScale * fontDirection;
                                var vertical = font.vertical;
                                var spacingDir = vertical ? 1 : -1;
                                var defaultVMetrics = font.defaultVMetrics;
                                var widthAdvanceScale = fontSize * current.fontMatrix[0];
                                var x = 0;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = glyphs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var glyph = _step.value;
                                        if (glyph === null) {
                                            x += fontDirection * wordSpacing;
                                            continue;
                                        } else if (typeof glyph === "number") {
                                            x += spacingDir * glyph * fontSize / 1000;
                                            continue;
                                        }
                                        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                                        var character = glyph.fontChar;
                                        var scaledX = void 0, scaledY = void 0;
                                        var width = glyph.width;
                                        if (vertical) {
                                            var vx = void 0;
                                            var vmetric = glyph.vmetric || defaultVMetrics;
                                            vx = glyph.vmetric ? vmetric[1] : width * 0.5;
                                            vx = -vx * widthAdvanceScale;
                                            var vy = vmetric[2] * widthAdvanceScale;
                                            width = vmetric ? -vmetric[0] : width;
                                            scaledX = vx / fontSizeScale;
                                            scaledY = (x + vy) / fontSizeScale;
                                        } else {
                                            scaledX = x / fontSizeScale;
                                            scaledY = 0;
                                        }
                                        if (glyph.isInFont || font.missingFile) {
                                            current.xcoords.push(current.x + scaledX);
                                            if (vertical) current.ycoords.push(-current.y + scaledY);
                                            current.tspan.textContent += character;
                                        }
                                        var charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                                        x += charWidth;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
                                if (vertical) current.tspan.setAttributeNS(null, "y", current.ycoords.map(pf).join(" "));
                                else current.tspan.setAttributeNS(null, "y", pf(-current.y));
                                if (vertical) current.y -= x;
                                else current.x += x * textHScale;
                                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                                current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
                                if (current.fontStyle !== SVG_DEFAULTS.fontStyle) current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
                                if (current.fontWeight !== SVG_DEFAULTS.fontWeight) current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
                                var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                                if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                                    if (current.fillColor !== SVG_DEFAULTS.fillColor) current.tspan.setAttributeNS(null, "fill", current.fillColor);
                                    if (current.fillAlpha < 1) current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                                } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) current.tspan.setAttributeNS(null, "fill", "transparent");
                                else current.tspan.setAttributeNS(null, "fill", "none");
                                if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                                    var lineWidthScale = 1 / (current.textMatrixScale || 1);
                                    this._setStrokeAttributes(current.tspan, lineWidthScale);
                                }
                                var textMatrix = current.textMatrix;
                                if (current.textRise !== 0) {
                                    textMatrix = textMatrix.slice();
                                    textMatrix[5] += current.textRise;
                                }
                                current.txtElement.setAttributeNS(null, "transform", "".concat(pm(textMatrix), " scale(").concat(pf(textHScale), ", -1)"));
                                current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
                                current.txtElement.append(current.tspan);
                                current.txtgrp.append(current.txtElement);
                                this._ensureTransformGroup().append(current.txtElement);
                            }
                        },
                        {
                            key: "setLeadingMoveText",
                            value: function setLeadingMoveText(x, y) {
                                this.setLeading(-y);
                                this.moveText(x, y);
                            }
                        },
                        {
                            key: "addFontStyle",
                            value: function addFontStyle(fontObj) {
                                if (!fontObj.data) throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                                if (!this.cssStyle) {
                                    this.cssStyle = this.svgFactory.createElement("svg:style");
                                    this.cssStyle.setAttributeNS(null, "type", "text/css");
                                    this.defs.append(this.cssStyle);
                                }
                                var url = createObjectURL(fontObj.data, fontObj.mimetype, this.forceDataSchema);
                                this.cssStyle.textContent += '@font-face { font-family: "'.concat(fontObj.loadedName, '";') + " src: url(".concat(url, "); }\n");
                            }
                        },
                        {
                            key: "setFont",
                            value: function setFont(details) {
                                var current = this.current;
                                var fontObj = this.commonObjs.get(details[0]);
                                var size = details[1];
                                current.font = fontObj;
                                if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
                                    this.addFontStyle(fontObj);
                                    this.embeddedFonts[fontObj.loadedName] = fontObj;
                                }
                                current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                                var bold = "normal";
                                if (fontObj.black) bold = "900";
                                else if (fontObj.bold) bold = "bold";
                                var italic = fontObj.italic ? "italic" : "normal";
                                if (size < 0) {
                                    size = -size;
                                    current.fontDirection = -1;
                                } else current.fontDirection = 1;
                                current.fontSize = size;
                                current.fontFamily = fontObj.loadedName;
                                current.fontWeight = bold;
                                current.fontStyle = italic;
                                current.tspan = this.svgFactory.createElement("svg:tspan");
                                current.tspan.setAttributeNS(null, "y", pf(-current.y));
                                current.xcoords = [];
                                current.ycoords = [];
                            }
                        },
                        {
                            key: "endText",
                            value: function endText() {
                                var _current_txtElement;
                                var current = this.current;
                                if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && ((_current_txtElement = current.txtElement) === null || _current_txtElement === void 0 ? void 0 : _current_txtElement.hasChildNodes())) {
                                    current.element = current.txtElement;
                                    this.clip("nonzero");
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "setLineWidth",
                            value: function setLineWidth(width) {
                                if (width > 0) this.current.lineWidth = width;
                            }
                        },
                        {
                            key: "setLineCap",
                            value: function setLineCap(style) {
                                this.current.lineCap = LINE_CAP_STYLES[style];
                            }
                        },
                        {
                            key: "setLineJoin",
                            value: function setLineJoin(style) {
                                this.current.lineJoin = LINE_JOIN_STYLES[style];
                            }
                        },
                        {
                            key: "setMiterLimit",
                            value: function setMiterLimit(limit) {
                                this.current.miterLimit = limit;
                            }
                        },
                        {
                            key: "setStrokeAlpha",
                            value: function setStrokeAlpha(strokeAlpha) {
                                this.current.strokeAlpha = strokeAlpha;
                            }
                        },
                        {
                            key: "setStrokeRGBColor",
                            value: function setStrokeRGBColor(r, g, b) {
                                this.current.strokeColor = _util.Util.makeHexColor(r, g, b);
                            }
                        },
                        {
                            key: "setFillAlpha",
                            value: function setFillAlpha(fillAlpha) {
                                this.current.fillAlpha = fillAlpha;
                            }
                        },
                        {
                            key: "setFillRGBColor",
                            value: function setFillRGBColor(r, g, b) {
                                this.current.fillColor = _util.Util.makeHexColor(r, g, b);
                                this.current.tspan = this.svgFactory.createElement("svg:tspan");
                                this.current.xcoords = [];
                                this.current.ycoords = [];
                            }
                        },
                        {
                            key: "setStrokeColorN",
                            value: function setStrokeColorN(args) {
                                this.current.strokeColor = this._makeColorN_Pattern(args);
                            }
                        },
                        {
                            key: "setFillColorN",
                            value: function setFillColorN(args) {
                                this.current.fillColor = this._makeColorN_Pattern(args);
                            }
                        },
                        {
                            key: "shadingFill",
                            value: function shadingFill(args) {
                                var _this_viewport = this.viewport, width = _this_viewport.width, height = _this_viewport.height;
                                var inv = _util.Util.inverseTransform(this.transformMatrix);
                                var _util_Util_getAxialAlignedBoundingBox = (0, $52tJv._)(_util.Util.getAxialAlignedBoundingBox([
                                    0,
                                    0,
                                    width,
                                    height
                                ], inv), 4), x0 = _util_Util_getAxialAlignedBoundingBox[0], y0 = _util_Util_getAxialAlignedBoundingBox[1], x1 = _util_Util_getAxialAlignedBoundingBox[2], y1 = _util_Util_getAxialAlignedBoundingBox[3];
                                var rect = this.svgFactory.createElement("svg:rect");
                                rect.setAttributeNS(null, "x", x0);
                                rect.setAttributeNS(null, "y", y0);
                                rect.setAttributeNS(null, "width", x1 - x0);
                                rect.setAttributeNS(null, "height", y1 - y0);
                                rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
                                if (this.current.fillAlpha < 1) rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                                this._ensureTransformGroup().append(rect);
                            }
                        },
                        {
                            key: "_makeColorN_Pattern",
                            value: function _makeColorN_Pattern(args) {
                                if (args[0] === "TilingPattern") return this._makeTilingPattern(args);
                                return this._makeShadingPattern(args);
                            }
                        },
                        {
                            key: "_makeTilingPattern",
                            value: function _makeTilingPattern(args) {
                                var color = args[1];
                                var operatorList = args[2];
                                var matrix = args[3] || _util.IDENTITY_MATRIX;
                                var _args_ = (0, $52tJv._)(args[4], 4), x0 = _args_[0], y0 = _args_[1], x1 = _args_[2], y1 = _args_[3];
                                var xstep = args[5];
                                var ystep = args[6];
                                var paintType = args[7];
                                var tilingId = "shading".concat(shadingCount++);
                                var _util_Util_normalizeRect = (0, $52tJv._)(_util.Util.normalizeRect((0, $fyztb._)(_util.Util.applyTransform([
                                    x0,
                                    y0
                                ], matrix)).concat((0, $fyztb._)(_util.Util.applyTransform([
                                    x1,
                                    y1
                                ], matrix)))), 4), tx0 = _util_Util_normalizeRect[0], ty0 = _util_Util_normalizeRect[1], tx1 = _util_Util_normalizeRect[2], ty1 = _util_Util_normalizeRect[3];
                                var _util_Util_singularValueDecompose2dScale = (0, $52tJv._)(_util.Util.singularValueDecompose2dScale(matrix), 2), xscale = _util_Util_singularValueDecompose2dScale[0], yscale = _util_Util_singularValueDecompose2dScale[1];
                                var txstep = xstep * xscale;
                                var tystep = ystep * yscale;
                                var tiling = this.svgFactory.createElement("svg:pattern");
                                tiling.setAttributeNS(null, "id", tilingId);
                                tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                                tiling.setAttributeNS(null, "width", txstep);
                                tiling.setAttributeNS(null, "height", tystep);
                                tiling.setAttributeNS(null, "x", "".concat(tx0));
                                tiling.setAttributeNS(null, "y", "".concat(ty0));
                                var svg = this.svg;
                                var transformMatrix = this.transformMatrix;
                                var fillColor = this.current.fillColor;
                                var strokeColor = this.current.strokeColor;
                                var bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
                                this.svg = bbox;
                                this.transformMatrix = matrix;
                                if (paintType === 2) {
                                    var _util_Util;
                                    var cssColor = (_util_Util = _util.Util).makeHexColor.apply(_util_Util, (0, $fyztb._)(color));
                                    this.current.fillColor = cssColor;
                                    this.current.strokeColor = cssColor;
                                }
                                this.executeOpTree(this.convertOpList(operatorList));
                                this.svg = svg;
                                this.transformMatrix = transformMatrix;
                                this.current.fillColor = fillColor;
                                this.current.strokeColor = strokeColor;
                                tiling.append(bbox.childNodes[0]);
                                this.defs.append(tiling);
                                return "url(#".concat(tilingId, ")");
                            }
                        },
                        {
                            key: "_makeShadingPattern",
                            value: function _makeShadingPattern(args) {
                                if (typeof args === "string") args = this.objs.get(args);
                                switch(args[0]){
                                    case "RadialAxial":
                                        var shadingId = "shading".concat(shadingCount++);
                                        var colorStops = args[3];
                                        var gradient;
                                        switch(args[1]){
                                            case "axial":
                                                var point0 = args[4];
                                                var point1 = args[5];
                                                gradient = this.svgFactory.createElement("svg:linearGradient");
                                                gradient.setAttributeNS(null, "id", shadingId);
                                                gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                                gradient.setAttributeNS(null, "x1", point0[0]);
                                                gradient.setAttributeNS(null, "y1", point0[1]);
                                                gradient.setAttributeNS(null, "x2", point1[0]);
                                                gradient.setAttributeNS(null, "y2", point1[1]);
                                                break;
                                            case "radial":
                                                var focalPoint = args[4];
                                                var circlePoint = args[5];
                                                var focalRadius = args[6];
                                                var circleRadius = args[7];
                                                gradient = this.svgFactory.createElement("svg:radialGradient");
                                                gradient.setAttributeNS(null, "id", shadingId);
                                                gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                                gradient.setAttributeNS(null, "cx", circlePoint[0]);
                                                gradient.setAttributeNS(null, "cy", circlePoint[1]);
                                                gradient.setAttributeNS(null, "r", circleRadius);
                                                gradient.setAttributeNS(null, "fx", focalPoint[0]);
                                                gradient.setAttributeNS(null, "fy", focalPoint[1]);
                                                gradient.setAttributeNS(null, "fr", focalRadius);
                                                break;
                                            default:
                                                throw new Error("Unknown RadialAxial type: ".concat(args[1]));
                                        }
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = colorStops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var colorStop = _step.value;
                                                var stop = this.svgFactory.createElement("svg:stop");
                                                stop.setAttributeNS(null, "offset", colorStop[0]);
                                                stop.setAttributeNS(null, "stop-color", colorStop[1]);
                                                gradient.append(stop);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        this.defs.append(gradient);
                                        return "url(#".concat(shadingId, ")");
                                    case "Mesh":
                                        (0, _util.warn)("Unimplemented pattern Mesh");
                                        return null;
                                    case "Dummy":
                                        return "hotpink";
                                    default:
                                        throw new Error("Unknown IR type: ".concat(args[0]));
                                }
                            }
                        },
                        {
                            key: "setDash",
                            value: function setDash(dashArray, dashPhase) {
                                this.current.dashArray = dashArray;
                                this.current.dashPhase = dashPhase;
                            }
                        },
                        {
                            key: "constructPath",
                            value: function constructPath(ops, args) {
                                var current = this.current;
                                var x = current.x, y = current.y;
                                var d = [];
                                var j = 0;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = ops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var op = _step.value;
                                        switch(op | 0){
                                            case _util.OPS.rectangle:
                                                x = args[j++];
                                                y = args[j++];
                                                var width = args[j++];
                                                var height = args[j++];
                                                var xw = x + width;
                                                var yh = y + height;
                                                d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
                                                break;
                                            case _util.OPS.moveTo:
                                                x = args[j++];
                                                y = args[j++];
                                                d.push("M", pf(x), pf(y));
                                                break;
                                            case _util.OPS.lineTo:
                                                x = args[j++];
                                                y = args[j++];
                                                d.push("L", pf(x), pf(y));
                                                break;
                                            case _util.OPS.curveTo:
                                                x = args[j + 4];
                                                y = args[j + 5];
                                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                                                j += 6;
                                                break;
                                            case _util.OPS.curveTo2:
                                                d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                                                x = args[j + 2];
                                                y = args[j + 3];
                                                j += 4;
                                                break;
                                            case _util.OPS.curveTo3:
                                                x = args[j + 2];
                                                y = args[j + 3];
                                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                                                j += 4;
                                                break;
                                            case _util.OPS.closePath:
                                                d.push("Z");
                                                break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                d = d.join(" ");
                                if (current.path && ops.length > 0 && ops[0] !== _util.OPS.rectangle && ops[0] !== _util.OPS.moveTo) d = current.path.getAttributeNS(null, "d") + d;
                                else {
                                    current.path = this.svgFactory.createElement("svg:path");
                                    this._ensureTransformGroup().append(current.path);
                                }
                                current.path.setAttributeNS(null, "d", d);
                                current.path.setAttributeNS(null, "fill", "none");
                                current.element = current.path;
                                current.setCurrentPoint(x, y);
                            }
                        },
                        {
                            key: "endPath",
                            value: function endPath() {
                                var current = this.current;
                                current.path = null;
                                if (!this.pendingClip) return;
                                if (!current.element) {
                                    this.pendingClip = null;
                                    return;
                                }
                                var clipId = "clippath".concat(clipCount++);
                                var clipPath = this.svgFactory.createElement("svg:clipPath");
                                clipPath.setAttributeNS(null, "id", clipId);
                                clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
                                var clipElement = current.element.cloneNode(true);
                                if (this.pendingClip === "evenodd") clipElement.setAttributeNS(null, "clip-rule", "evenodd");
                                else clipElement.setAttributeNS(null, "clip-rule", "nonzero");
                                this.pendingClip = null;
                                clipPath.append(clipElement);
                                this.defs.append(clipPath);
                                if (current.activeClipUrl) {
                                    current.clipGroup = null;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = this.extraStack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var prev = _step.value;
                                            prev.clipGroup = null;
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
                                }
                                current.activeClipUrl = "url(#".concat(clipId, ")");
                                this.tgrp = null;
                            }
                        },
                        {
                            key: "clip",
                            value: function clip(type) {
                                this.pendingClip = type;
                            }
                        },
                        {
                            key: "closePath",
                            value: function closePath() {
                                var current = this.current;
                                if (current.path) {
                                    var d = "".concat(current.path.getAttributeNS(null, "d"), "Z");
                                    current.path.setAttributeNS(null, "d", d);
                                }
                            }
                        },
                        {
                            key: "setLeading",
                            value: function setLeading(leading) {
                                this.current.leading = -leading;
                            }
                        },
                        {
                            key: "setTextRise",
                            value: function setTextRise(textRise) {
                                this.current.textRise = textRise;
                            }
                        },
                        {
                            key: "setTextRenderingMode",
                            value: function setTextRenderingMode(textRenderingMode) {
                                this.current.textRenderingMode = textRenderingMode;
                            }
                        },
                        {
                            key: "setHScale",
                            value: function setHScale(scale) {
                                this.current.textHScale = scale / 100;
                            }
                        },
                        {
                            key: "setRenderingIntent",
                            value: function setRenderingIntent(intent) {}
                        },
                        {
                            key: "setFlatness",
                            value: function setFlatness(flatness) {}
                        },
                        {
                            key: "setGState",
                            value: function setGState(states) {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = states[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _step_value = (0, $52tJv._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                                        switch(key){
                                            case "LW":
                                                this.setLineWidth(value);
                                                break;
                                            case "LC":
                                                this.setLineCap(value);
                                                break;
                                            case "LJ":
                                                this.setLineJoin(value);
                                                break;
                                            case "ML":
                                                this.setMiterLimit(value);
                                                break;
                                            case "D":
                                                this.setDash(value[0], value[1]);
                                                break;
                                            case "RI":
                                                this.setRenderingIntent(value);
                                                break;
                                            case "FL":
                                                this.setFlatness(value);
                                                break;
                                            case "Font":
                                                this.setFont(value);
                                                break;
                                            case "CA":
                                                this.setStrokeAlpha(value);
                                                break;
                                            case "ca":
                                                this.setFillAlpha(value);
                                                break;
                                            default:
                                                (0, _util.warn)("Unimplemented graphic state operator ".concat(key));
                                                break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "fill",
                            value: function fill() {
                                var current = this.current;
                                if (current.element) {
                                    current.element.setAttributeNS(null, "fill", current.fillColor);
                                    current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "stroke",
                            value: function stroke() {
                                var current = this.current;
                                if (current.element) {
                                    this._setStrokeAttributes(current.element);
                                    current.element.setAttributeNS(null, "fill", "none");
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "_setStrokeAttributes",
                            value: function _setStrokeAttributes(element) {
                                var lineWidthScale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
                                var current = this.current;
                                var dashArray = current.dashArray;
                                if (lineWidthScale !== 1 && dashArray.length > 0) dashArray = dashArray.map(function(value) {
                                    return lineWidthScale * value;
                                });
                                element.setAttributeNS(null, "stroke", current.strokeColor);
                                element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
                                element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
                                element.setAttributeNS(null, "stroke-linecap", current.lineCap);
                                element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
                                element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
                                element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
                                element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
                            }
                        },
                        {
                            key: "eoFill",
                            value: function eoFill() {
                                var _this_current_element;
                                (_this_current_element = this.current.element) === null || _this_current_element === void 0 ? void 0 : _this_current_element.setAttributeNS(null, "fill-rule", "evenodd");
                                this.fill();
                            }
                        },
                        {
                            key: "fillStroke",
                            value: function fillStroke() {
                                this.stroke();
                                this.fill();
                            }
                        },
                        {
                            key: "eoFillStroke",
                            value: function eoFillStroke() {
                                var _this_current_element;
                                (_this_current_element = this.current.element) === null || _this_current_element === void 0 ? void 0 : _this_current_element.setAttributeNS(null, "fill-rule", "evenodd");
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeStroke",
                            value: function closeStroke() {
                                this.closePath();
                                this.stroke();
                            }
                        },
                        {
                            key: "closeFillStroke",
                            value: function closeFillStroke() {
                                this.closePath();
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeEOFillStroke",
                            value: function closeEOFillStroke() {
                                this.closePath();
                                this.eoFillStroke();
                            }
                        },
                        {
                            key: "paintSolidColorImageMask",
                            value: function paintSolidColorImageMask() {
                                var rect = this.svgFactory.createElement("svg:rect");
                                rect.setAttributeNS(null, "x", "0");
                                rect.setAttributeNS(null, "y", "0");
                                rect.setAttributeNS(null, "width", "1px");
                                rect.setAttributeNS(null, "height", "1px");
                                rect.setAttributeNS(null, "fill", this.current.fillColor);
                                this._ensureTransformGroup().append(rect);
                            }
                        },
                        {
                            key: "paintImageXObject",
                            value: function paintImageXObject(objId) {
                                var imgData = this.getObject(objId);
                                if (!imgData) {
                                    (0, _util.warn)("Dependent image with object ID ".concat(objId, " is not ready yet"));
                                    return;
                                }
                                this.paintInlineImageXObject(imgData);
                            }
                        },
                        {
                            key: "paintInlineImageXObject",
                            value: function paintInlineImageXObject(imgData, mask) {
                                var width = imgData.width;
                                var height = imgData.height;
                                var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
                                var cliprect = this.svgFactory.createElement("svg:rect");
                                cliprect.setAttributeNS(null, "x", "0");
                                cliprect.setAttributeNS(null, "y", "0");
                                cliprect.setAttributeNS(null, "width", pf(width));
                                cliprect.setAttributeNS(null, "height", pf(height));
                                this.current.element = cliprect;
                                this.clip("nonzero");
                                var imgEl = this.svgFactory.createElement("svg:image");
                                imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
                                imgEl.setAttributeNS(null, "x", "0");
                                imgEl.setAttributeNS(null, "y", pf(-height));
                                imgEl.setAttributeNS(null, "width", pf(width) + "px");
                                imgEl.setAttributeNS(null, "height", pf(height) + "px");
                                imgEl.setAttributeNS(null, "transform", "scale(".concat(pf(1 / width), " ").concat(pf(-1 / height), ")"));
                                if (mask) mask.append(imgEl);
                                else this._ensureTransformGroup().append(imgEl);
                            }
                        },
                        {
                            key: "paintImageMaskXObject",
                            value: function paintImageMaskXObject(img) {
                                var imgData = this.getObject(img.data, img);
                                if (imgData.bitmap) {
                                    (0, _util.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                                    return;
                                }
                                var current = this.current;
                                var width = imgData.width;
                                var height = imgData.height;
                                var fillColor = current.fillColor;
                                current.maskId = "mask".concat(maskCount++);
                                var mask = this.svgFactory.createElement("svg:mask");
                                mask.setAttributeNS(null, "id", current.maskId);
                                var rect = this.svgFactory.createElement("svg:rect");
                                rect.setAttributeNS(null, "x", "0");
                                rect.setAttributeNS(null, "y", "0");
                                rect.setAttributeNS(null, "width", pf(width));
                                rect.setAttributeNS(null, "height", pf(height));
                                rect.setAttributeNS(null, "fill", fillColor);
                                rect.setAttributeNS(null, "mask", "url(#".concat(current.maskId, ")"));
                                this.defs.append(mask);
                                this._ensureTransformGroup().append(rect);
                                this.paintInlineImageXObject(imgData, mask);
                            }
                        },
                        {
                            key: "paintFormXObjectBegin",
                            value: function paintFormXObjectBegin(matrix, bbox) {
                                if (Array.isArray(matrix) && matrix.length === 6) this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                                if (bbox) {
                                    var width = bbox[2] - bbox[0];
                                    var height = bbox[3] - bbox[1];
                                    var cliprect = this.svgFactory.createElement("svg:rect");
                                    cliprect.setAttributeNS(null, "x", bbox[0]);
                                    cliprect.setAttributeNS(null, "y", bbox[1]);
                                    cliprect.setAttributeNS(null, "width", pf(width));
                                    cliprect.setAttributeNS(null, "height", pf(height));
                                    this.current.element = cliprect;
                                    this.clip("nonzero");
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "paintFormXObjectEnd",
                            value: function paintFormXObjectEnd() {}
                        },
                        {
                            key: "_initialize",
                            value: function _initialize(viewport) {
                                var svg = this.svgFactory.create(viewport.width, viewport.height);
                                var definitions = this.svgFactory.createElement("svg:defs");
                                svg.append(definitions);
                                this.defs = definitions;
                                var rootGroup = this.svgFactory.createElement("svg:g");
                                rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
                                svg.append(rootGroup);
                                this.svg = rootGroup;
                                return svg;
                            }
                        },
                        {
                            key: "_ensureClipGroup",
                            value: function _ensureClipGroup() {
                                if (!this.current.clipGroup) {
                                    var clipGroup = this.svgFactory.createElement("svg:g");
                                    clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                                    this.svg.append(clipGroup);
                                    this.current.clipGroup = clipGroup;
                                }
                                return this.current.clipGroup;
                            }
                        },
                        {
                            key: "_ensureTransformGroup",
                            value: function _ensureTransformGroup() {
                                if (!this.tgrp) {
                                    this.tgrp = this.svgFactory.createElement("svg:g");
                                    this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                                    if (this.current.activeClipUrl) this._ensureClipGroup().append(this.tgrp);
                                    else this.svg.append(this.tgrp);
                                }
                                return this.tgrp;
                            }
                        }
                    ]);
                    return SVGGraphics;
                }();
                exports.SVGGraphics = SVGGraphics;
            /***/ },
            /* 25 */ /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaText = void 0;
                var XfaText = /*#__PURE__*/ function() {
                    function XfaText() {
                        (0, $5sFFs._)(this, XfaText);
                    }
                    (0, $8O2fV._)(XfaText, null, [
                        {
                            key: "textContent",
                            value: function textContent(xfa) {
                                var items = [];
                                var output = {
                                    items: items,
                                    styles: Object.create(null)
                                };
                                function walk(node) {
                                    var _node_attributes;
                                    if (!node) return;
                                    var str = null;
                                    var name = node.name;
                                    if (name === "#text") str = node.value;
                                    else if (!XfaText.shouldBuildText(name)) return;
                                    else if (node === null || node === void 0 ? void 0 : (_node_attributes = node.attributes) === null || _node_attributes === void 0 ? void 0 : _node_attributes.textContent) str = node.attributes.textContent;
                                    else if (node.value) str = node.value;
                                    if (str !== null) items.push({
                                        str: str
                                    });
                                    if (!node.children) return;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = node.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var child = _step.value;
                                            walk(child);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                                walk(xfa);
                                return output;
                            }
                        },
                        {
                            key: "shouldBuildText",
                            value: function shouldBuildText(name) {
                                return !(name === "textarea" || name === "input" || name === "option" || name === "select");
                            }
                        }
                    ]);
                    return XfaText;
                }();
                exports.XfaText = XfaText;
            /***/ },
            /* 26 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TextLayerRenderTask = void 0;
                exports.renderTextLayer = renderTextLayer;
                exports.updateTextLayer = updateTextLayer;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var MAX_TEXT_DIVS_TO_RENDER = 100000;
                var DEFAULT_FONT_SIZE = 30;
                var DEFAULT_FONT_ASCENT = 0.8;
                var ascentCache = new Map();
                function getCtx(size, isOffscreenCanvasSupported) {
                    var ctx;
                    if (isOffscreenCanvasSupported && _util.FeatureTest.isOffscreenCanvasSupported) ctx = new OffscreenCanvas(size, size).getContext("2d", {
                        alpha: false
                    });
                    else {
                        var canvas = document.createElement("canvas");
                        canvas.width = canvas.height = size;
                        ctx = canvas.getContext("2d", {
                            alpha: false
                        });
                    }
                    return ctx;
                }
                function getAscent(fontFamily, isOffscreenCanvasSupported) {
                    var cachedAscent = ascentCache.get(fontFamily);
                    if (cachedAscent) return cachedAscent;
                    var ctx = getCtx(DEFAULT_FONT_SIZE, isOffscreenCanvasSupported);
                    ctx.font = "".concat(DEFAULT_FONT_SIZE, "px ").concat(fontFamily);
                    var metrics = ctx.measureText("");
                    var ascent = metrics.fontBoundingBoxAscent;
                    var descent = Math.abs(metrics.fontBoundingBoxDescent);
                    if (ascent) {
                        var ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        ctx.canvas.width = ctx.canvas.height = 0;
                        return ratio;
                    }
                    ctx.strokeStyle = "red";
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("g", 0, 0);
                    var pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    descent = 0;
                    for(var i = pixels.length - 1 - 3; i >= 0; i -= 4)if (pixels[i] > 0) {
                        descent = Math.ceil(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("A", 0, DEFAULT_FONT_SIZE);
                    pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    ascent = 0;
                    for(var i1 = 0, ii = pixels.length; i1 < ii; i1 += 4)if (pixels[i1] > 0) {
                        ascent = DEFAULT_FONT_SIZE - Math.floor(i1 / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.canvas.width = ctx.canvas.height = 0;
                    if (ascent) {
                        var ratio1 = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio1);
                        return ratio1;
                    }
                    ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
                    return DEFAULT_FONT_ASCENT;
                }
                function appendText(task, geom, styles) {
                    var textDiv = document.createElement("span");
                    var textDivProperties = {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom.str !== "",
                        hasEOL: geom.hasEOL,
                        fontSize: 0
                    };
                    task._textDivs.push(textDiv);
                    var tx = _util.Util.transform(task._transform, geom.transform);
                    var angle = Math.atan2(tx[1], tx[0]);
                    var style = styles[geom.fontName];
                    if (style.vertical) angle += Math.PI / 2;
                    var fontHeight = Math.hypot(tx[2], tx[3]);
                    var fontAscent = fontHeight * getAscent(style.fontFamily, task._isOffscreenCanvasSupported);
                    var left, top;
                    if (angle === 0) {
                        left = tx[4];
                        top = tx[5] - fontAscent;
                    } else {
                        left = tx[4] + fontAscent * Math.sin(angle);
                        top = tx[5] - fontAscent * Math.cos(angle);
                    }
                    var scaleFactorStr = "calc(var(--scale-factor)*";
                    var divStyle = textDiv.style;
                    if (task._container === task._rootContainer) {
                        divStyle.left = "".concat((100 * left / task._pageWidth).toFixed(2), "%");
                        divStyle.top = "".concat((100 * top / task._pageHeight).toFixed(2), "%");
                    } else {
                        divStyle.left = "".concat(scaleFactorStr).concat(left.toFixed(2), "px)");
                        divStyle.top = "".concat(scaleFactorStr).concat(top.toFixed(2), "px)");
                    }
                    divStyle.fontSize = "".concat(scaleFactorStr).concat(fontHeight.toFixed(2), "px)");
                    divStyle.fontFamily = style.fontFamily;
                    textDivProperties.fontSize = fontHeight;
                    textDiv.setAttribute("role", "presentation");
                    textDiv.textContent = geom.str;
                    textDiv.dir = geom.dir;
                    if (task._fontInspectorEnabled) textDiv.dataset.fontName = geom.fontName;
                    if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
                    var shouldScaleText = false;
                    if (geom.str.length > 1) shouldScaleText = true;
                    else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
                        var absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
                        if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
                    }
                    if (shouldScaleText) textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
                    task._textDivProperties.set(textDiv, textDivProperties);
                    if (task._isReadableStream) task._layoutText(textDiv);
                }
                function layout(params) {
                    var div = params.div, scale = params.scale, properties = params.properties, ctx = params.ctx, prevFontSize = params.prevFontSize, prevFontFamily = params.prevFontFamily;
                    var style = div.style;
                    var transform = "";
                    if (properties.canvasWidth !== 0 && properties.hasText) {
                        var fontFamily = style.fontFamily;
                        var canvasWidth = properties.canvasWidth, fontSize = properties.fontSize;
                        if (prevFontSize !== fontSize || prevFontFamily !== fontFamily) {
                            ctx.font = "".concat(fontSize * scale, "px ").concat(fontFamily);
                            params.prevFontSize = fontSize;
                            params.prevFontFamily = fontFamily;
                        }
                        var width = ctx.measureText(div.textContent).width;
                        if (width > 0) transform = "scaleX(".concat(canvasWidth * scale / width, ")");
                    }
                    if (properties.angle !== 0) transform = "rotate(".concat(properties.angle, "deg) ").concat(transform);
                    if (transform.length > 0) style.transform = transform;
                }
                function render(task) {
                    if (task._canceled) return;
                    var textDivs = task._textDivs;
                    var capability = task._capability;
                    var textDivsLength = textDivs.length;
                    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
                        capability.resolve();
                        return;
                    }
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (!task._isReadableStream) try {
                        for(var _iterator = textDivs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var textDiv = _step.value;
                            task._layoutText(textDiv);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    capability.resolve();
                }
                var TextLayerRenderTask = /*#__PURE__*/ function() {
                    function TextLayerRenderTask(param) {
                        var textContentSource = param.textContentSource, container = param.container, viewport = param.viewport, textDivs = param.textDivs, textDivProperties = param.textDivProperties, textContentItemsStr = param.textContentItemsStr, isOffscreenCanvasSupported = param.isOffscreenCanvasSupported;
                        var _this = this;
                        (0, $5sFFs._)(this, TextLayerRenderTask);
                        var _globalThis_FontInspector;
                        this._textContentSource = textContentSource;
                        this._isReadableStream = textContentSource instanceof ReadableStream;
                        this._container = this._rootContainer = container;
                        this._textDivs = textDivs || [];
                        this._textContentItemsStr = textContentItemsStr || [];
                        this._isOffscreenCanvasSupported = isOffscreenCanvasSupported;
                        this._fontInspectorEnabled = !!((_globalThis_FontInspector = globalThis.FontInspector) === null || _globalThis_FontInspector === void 0 ? void 0 : _globalThis_FontInspector.enabled);
                        this._reader = null;
                        this._textDivProperties = textDivProperties || new WeakMap();
                        this._canceled = false;
                        this._capability = new _util.PromiseCapability();
                        this._layoutTextParams = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: viewport.scale * (globalThis.devicePixelRatio || 1),
                            properties: null,
                            ctx: getCtx(0, isOffscreenCanvasSupported)
                        };
                        var _viewport_rawDims = viewport.rawDims, pageWidth = _viewport_rawDims.pageWidth, pageHeight = _viewport_rawDims.pageHeight, pageX = _viewport_rawDims.pageX, pageY = _viewport_rawDims.pageY;
                        this._transform = [
                            1,
                            0,
                            0,
                            -1,
                            -pageX,
                            pageY + pageHeight
                        ];
                        this._pageWidth = pageWidth;
                        this._pageHeight = pageHeight;
                        (0, _display_utils.setLayerDimensions)(container, viewport);
                        this._capability.promise.finally(function() {
                            _this._layoutTextParams = null;
                        }).catch(function() {});
                    }
                    (0, $8O2fV._)(TextLayerRenderTask, [
                        {
                            key: "promise",
                            get: function get() {
                                return this._capability.promise;
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel() {
                                this._canceled = true;
                                if (this._reader) {
                                    this._reader.cancel(new _util.AbortException("TextLayer task cancelled.")).catch(function() {});
                                    this._reader = null;
                                }
                                this._capability.reject(new _util.AbortException("TextLayer task cancelled."));
                            }
                        },
                        {
                            key: "_processItems",
                            value: function _processItems(items, styleCache) {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var item = _step.value;
                                        if (item.str === undefined) {
                                            if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                                                var parent = this._container;
                                                this._container = document.createElement("span");
                                                this._container.classList.add("markedContent");
                                                if (item.id !== null) this._container.setAttribute("id", "".concat(item.id));
                                                parent.append(this._container);
                                            } else if (item.type === "endMarkedContent") this._container = this._container.parentNode;
                                            continue;
                                        }
                                        this._textContentItemsStr.push(item.str);
                                        appendText(this, item, styleCache);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "_layoutText",
                            value: function _layoutText(textDiv) {
                                var textDivProperties = this._layoutTextParams.properties = this._textDivProperties.get(textDiv);
                                this._layoutTextParams.div = textDiv;
                                layout(this._layoutTextParams);
                                if (textDivProperties.hasText) this._container.append(textDiv);
                                if (textDivProperties.hasEOL) {
                                    var br = document.createElement("br");
                                    br.setAttribute("role", "presentation");
                                    this._container.append(br);
                                }
                            }
                        },
                        {
                            key: "_render",
                            value: function _render() {
                                var _this = this;
                                var capability = new _util.PromiseCapability();
                                var styleCache = Object.create(null);
                                if (this._isReadableStream) {
                                    var pump = function() {
                                        _this._reader.read().then(function(param) {
                                            var value = param.value, done = param.done;
                                            if (done) {
                                                capability.resolve();
                                                return;
                                            }
                                            Object.assign(styleCache, value.styles);
                                            _this._processItems(value.items, styleCache);
                                            pump();
                                        }, capability.reject);
                                    };
                                    this._reader = this._textContentSource.getReader();
                                    pump();
                                } else if (this._textContentSource) {
                                    var _this__textContentSource = this._textContentSource, items = _this__textContentSource.items, styles = _this__textContentSource.styles;
                                    this._processItems(items, styles);
                                    capability.resolve();
                                } else throw new Error('No "textContentSource" parameter specified.');
                                capability.promise.then(function() {
                                    styleCache = null;
                                    render(_this);
                                }, this._capability.reject);
                            }
                        }
                    ]);
                    return TextLayerRenderTask;
                }();
                exports.TextLayerRenderTask = TextLayerRenderTask;
                function renderTextLayer(params) {
                    if (!params.textContentSource && (params.textContent || params.textContentStream)) {
                        (0, _display_utils.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead.");
                        params.textContentSource = params.textContent || params.textContentStream;
                    }
                    var container = params.container, viewport = params.viewport;
                    var style = getComputedStyle(container);
                    var visibility = style.getPropertyValue("visibility");
                    var scaleFactor = parseFloat(style.getPropertyValue("--scale-factor"));
                    if (visibility === "visible" && (!scaleFactor || Math.abs(scaleFactor - viewport.scale) > 1e-5)) console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
                    var task = new TextLayerRenderTask(params);
                    task._render();
                    return task;
                }
                function updateTextLayer(param) {
                    var container = param.container, viewport = param.viewport, textDivs = param.textDivs, textDivProperties = param.textDivProperties, isOffscreenCanvasSupported = param.isOffscreenCanvasSupported, _param_mustRotate = param.mustRotate, mustRotate = _param_mustRotate === void 0 ? true : _param_mustRotate, _param_mustRescale = param.mustRescale, mustRescale = _param_mustRescale === void 0 ? true : _param_mustRescale;
                    if (mustRotate) (0, _display_utils.setLayerDimensions)(container, {
                        rotation: viewport.rotation
                    });
                    if (mustRescale) {
                        var ctx = getCtx(0, isOffscreenCanvasSupported);
                        var scale = viewport.scale * (globalThis.devicePixelRatio || 1);
                        var params = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: scale,
                            properties: null,
                            ctx: ctx
                        };
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = textDivs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var div = _step.value;
                                params.properties = textDivProperties.get(div);
                                params.div = div;
                                layout(params);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                }
            /***/ },
            /* 27 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationEditorLayer = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _freetext = __w_pdfjs_require__(28);
                var _ink = __w_pdfjs_require__(33);
                var _display_utils = __w_pdfjs_require__(6);
                var _stamp = __w_pdfjs_require__(34);
                var _accessibilityManager = /*#__PURE__*/ new WeakMap(), _allowClick = /*#__PURE__*/ new WeakMap(), _annotationLayer = /*#__PURE__*/ new WeakMap(), _boundPointerup = /*#__PURE__*/ new WeakMap(), _boundPointerdown = /*#__PURE__*/ new WeakMap(), _editors = /*#__PURE__*/ new WeakMap(), _hadPointerDown = /*#__PURE__*/ new WeakMap(), _isCleaningUp = /*#__PURE__*/ new WeakMap(), _isDisabling = /*#__PURE__*/ new WeakMap(), _uiManager = /*#__PURE__*/ new WeakMap(), _createNewEditor = /*#__PURE__*/ new WeakSet(), _createAndAddNewEditor = /*#__PURE__*/ new WeakSet(), _getCenterPoint = /*#__PURE__*/ new WeakSet(), _cleanup = /*#__PURE__*/ new WeakSet();
                var AnnotationEditorLayer = /*#__PURE__*/ function() {
                    function AnnotationEditorLayer(param) {
                        var uiManager = param.uiManager, pageIndex = param.pageIndex, div = param.div, accessibilityManager = param.accessibilityManager, annotationLayer = param.annotationLayer, viewport = param.viewport, l10n = param.l10n;
                        (0, $5sFFs._)(this, AnnotationEditorLayer);
                        (0, $iB2CV._)(this, _createNewEditor);
                        (0, $iB2CV._)(this, _createAndAddNewEditor);
                        (0, $iB2CV._)(this, _getCenterPoint);
                        (0, $iB2CV._)(this, _cleanup);
                        (0, $g12Hy._)(this, _accessibilityManager, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)(this, _allowClick, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)(this, _annotationLayer, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _boundPointerup, {
                            writable: true,
                            value: this.pointerup.bind(this)
                        });
                        (0, $g12Hy._)(this, _boundPointerdown, {
                            writable: true,
                            value: this.pointerdown.bind(this)
                        });
                        (0, $g12Hy._)(this, _editors, {
                            writable: true,
                            value: new Map()
                        });
                        (0, $g12Hy._)(this, _hadPointerDown, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)(this, _isCleaningUp, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)(this, _isDisabling, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)(this, _uiManager, {
                            writable: true,
                            value: void 0
                        });
                        var editorTypes = [
                            _freetext.FreeTextEditor,
                            _ink.InkEditor,
                            _stamp.StampEditor
                        ];
                        if (!AnnotationEditorLayer._initialized) {
                            AnnotationEditorLayer._initialized = true;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = editorTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var editorType = _step.value;
                                    editorType.initialize(l10n);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        uiManager.registerEditorTypes(editorTypes);
                        (0, $4LHB0._)(this, _uiManager, uiManager);
                        this.pageIndex = pageIndex;
                        this.div = div;
                        (0, $4LHB0._)(this, _accessibilityManager, accessibilityManager);
                        (0, $4LHB0._)(this, _annotationLayer, annotationLayer);
                        this.viewport = viewport;
                        (0, $057QZ._)(this, _uiManager).addLayer(this);
                    }
                    (0, $8O2fV._)(AnnotationEditorLayer, [
                        {
                            key: "isEmpty",
                            get: function get() {
                                return (0, $057QZ._)(this, _editors).size === 0;
                            }
                        },
                        {
                            key: "updateToolbar",
                            value: function updateToolbar(mode) {
                                (0, $057QZ._)(this, _uiManager).updateToolbar(mode);
                            }
                        },
                        {
                            key: "updateMode",
                            value: function updateMode() {
                                var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $057QZ._)(this, _uiManager).getMode();
                                (0, $lNbhr._)(this, _cleanup, cleanup).call(this);
                                if (mode === _util.AnnotationEditorType.INK) {
                                    this.addInkEditorIfNeeded(false);
                                    this.disableClick();
                                } else this.enableClick();
                                if (mode !== _util.AnnotationEditorType.NONE) {
                                    this.div.classList.toggle("freeTextEditing", mode === _util.AnnotationEditorType.FREETEXT);
                                    this.div.classList.toggle("inkEditing", mode === _util.AnnotationEditorType.INK);
                                    this.div.classList.toggle("stampEditing", mode === _util.AnnotationEditorType.STAMP);
                                    this.div.hidden = false;
                                }
                            }
                        },
                        {
                            key: "addInkEditorIfNeeded",
                            value: function addInkEditorIfNeeded(isCommitting) {
                                if (!isCommitting && (0, $057QZ._)(this, _uiManager).getMode() !== _util.AnnotationEditorType.INK) return;
                                if (!isCommitting) {
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = (0, $057QZ._)(this, _editors).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var editor = _step.value;
                                            if (editor.isEmpty()) {
                                                editor.setInBackground();
                                                return;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                                var editor1 = (0, $lNbhr._)(this, _createAndAddNewEditor, createAndAddNewEditor).call(this, {
                                    offsetX: 0,
                                    offsetY: 0
                                }, false);
                                editor1.setInBackground();
                            }
                        },
                        {
                            key: "setEditingState",
                            value: function setEditingState(isEditing) {
                                (0, $057QZ._)(this, _uiManager).setEditingState(isEditing);
                            }
                        },
                        {
                            key: "addCommands",
                            value: function addCommands(params) {
                                (0, $057QZ._)(this, _uiManager).addCommands(params);
                            }
                        },
                        {
                            key: "enable",
                            value: function enable() {
                                this.div.style.pointerEvents = "auto";
                                var annotationElementIds = new Set();
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _editors).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editor = _step.value;
                                        editor.enableEditing();
                                        if (editor.annotationElementId) annotationElementIds.add(editor.annotationElementId);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (!(0, $057QZ._)(this, _annotationLayer)) return;
                                var editables = (0, $057QZ._)(this, _annotationLayer).getEditableAnnotations();
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = editables[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var editable = _step1.value;
                                        editable.hide();
                                        if ((0, $057QZ._)(this, _uiManager).isDeletedAnnotationElement(editable.data.id)) continue;
                                        if (annotationElementIds.has(editable.data.id)) continue;
                                        var editor1 = this.deserialize(editable);
                                        if (!editor1) continue;
                                        this.addOrRebuild(editor1);
                                        editor1.enableEditing();
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "disable",
                            value: function disable() {
                                (0, $4LHB0._)(this, _isDisabling, true);
                                this.div.style.pointerEvents = "none";
                                var hiddenAnnotationIds = new Set();
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _editors).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editor = _step.value;
                                        var _this_getEditableAnnotation;
                                        editor.disableEditing();
                                        if (!editor.annotationElementId || editor.serialize() !== null) {
                                            hiddenAnnotationIds.add(editor.annotationElementId);
                                            continue;
                                        }
                                        (_this_getEditableAnnotation = this.getEditableAnnotation(editor.annotationElementId)) === null || _this_getEditableAnnotation === void 0 ? void 0 : _this_getEditableAnnotation.show();
                                        editor.remove();
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if ((0, $057QZ._)(this, _annotationLayer)) {
                                    var editables = (0, $057QZ._)(this, _annotationLayer).getEditableAnnotations();
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = editables[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var editable = _step1.value;
                                            var id = editable.data.id;
                                            if (hiddenAnnotationIds.has(id) || (0, $057QZ._)(this, _uiManager).isDeletedAnnotationElement(id)) continue;
                                            editable.show();
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                }
                                (0, $lNbhr._)(this, _cleanup, cleanup).call(this);
                                if (this.isEmpty) this.div.hidden = true;
                                (0, $4LHB0._)(this, _isDisabling, false);
                            }
                        },
                        {
                            key: "getEditableAnnotation",
                            value: function getEditableAnnotation(id) {
                                var _$_class_private_field_get;
                                return ((_$_class_private_field_get = (0, $057QZ._)(this, _annotationLayer)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.getEditableAnnotation(id)) || null;
                            }
                        },
                        {
                            key: "setActiveEditor",
                            value: function setActiveEditor(editor) {
                                var currentActive = (0, $057QZ._)(this, _uiManager).getActive();
                                if (currentActive === editor) return;
                                (0, $057QZ._)(this, _uiManager).setActiveEditor(editor);
                            }
                        },
                        {
                            key: "enableClick",
                            value: function enableClick() {
                                this.div.addEventListener("pointerdown", (0, $057QZ._)(this, _boundPointerdown));
                                this.div.addEventListener("pointerup", (0, $057QZ._)(this, _boundPointerup));
                            }
                        },
                        {
                            key: "disableClick",
                            value: function disableClick() {
                                this.div.removeEventListener("pointerdown", (0, $057QZ._)(this, _boundPointerdown));
                                this.div.removeEventListener("pointerup", (0, $057QZ._)(this, _boundPointerup));
                            }
                        },
                        {
                            key: "attach",
                            value: function attach(editor) {
                                (0, $057QZ._)(this, _editors).set(editor.id, editor);
                                var annotationElementId = editor.annotationElementId;
                                if (annotationElementId && (0, $057QZ._)(this, _uiManager).isDeletedAnnotationElement(annotationElementId)) (0, $057QZ._)(this, _uiManager).removeDeletedAnnotationElement(editor);
                            }
                        },
                        {
                            key: "detach",
                            value: function detach(editor) {
                                var _$_class_private_field_get;
                                (0, $057QZ._)(this, _editors).delete(editor.id);
                                (_$_class_private_field_get = (0, $057QZ._)(this, _accessibilityManager)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.removePointerInTextLayer(editor.contentDiv);
                                if (!(0, $057QZ._)(this, _isDisabling) && editor.annotationElementId) (0, $057QZ._)(this, _uiManager).addDeletedAnnotationElement(editor);
                            }
                        },
                        {
                            key: "remove",
                            value: function remove(editor) {
                                var _this = this;
                                this.detach(editor);
                                (0, $057QZ._)(this, _uiManager).removeEditor(editor);
                                if (editor.div.contains(document.activeElement)) setTimeout(function() {
                                    (0, $057QZ._)(_this, _uiManager).focusMainContainer();
                                }, 0);
                                editor.div.remove();
                                editor.isAttachedToDOM = false;
                                if (!(0, $057QZ._)(this, _isCleaningUp)) this.addInkEditorIfNeeded(false);
                            }
                        },
                        {
                            key: "changeParent",
                            value: function changeParent(editor) {
                                var _editor_parent;
                                if (editor.parent === this) return;
                                if (editor.annotationElementId) {
                                    (0, $057QZ._)(this, _uiManager).addDeletedAnnotationElement(editor.annotationElementId);
                                    _editor.AnnotationEditor.deleteAnnotationElement(editor);
                                    editor.annotationElementId = null;
                                }
                                this.attach(editor);
                                (_editor_parent = editor.parent) === null || _editor_parent === void 0 ? void 0 : _editor_parent.detach(editor);
                                editor.setParent(this);
                                if (editor.div && editor.isAttachedToDOM) {
                                    editor.div.remove();
                                    this.div.append(editor.div);
                                }
                            }
                        },
                        {
                            key: "add",
                            value: function add(editor) {
                                this.changeParent(editor);
                                (0, $057QZ._)(this, _uiManager).addEditor(editor);
                                this.attach(editor);
                                if (!editor.isAttachedToDOM) {
                                    var div = editor.render();
                                    this.div.append(div);
                                    editor.isAttachedToDOM = true;
                                }
                                editor.fixAndSetPosition();
                                editor.onceAdded();
                                (0, $057QZ._)(this, _uiManager).addToAnnotationStorage(editor);
                            }
                        },
                        {
                            key: "moveEditorInDOM",
                            value: function moveEditorInDOM(editor) {
                                var _$_class_private_field_get;
                                if (!editor.isAttachedToDOM) return;
                                var activeElement = document.activeElement;
                                if (editor.div.contains(activeElement)) {
                                    editor._focusEventsAllowed = false;
                                    setTimeout(function() {
                                        if (!editor.div.contains(document.activeElement)) {
                                            editor.div.addEventListener("focusin", function() {
                                                editor._focusEventsAllowed = true;
                                            }, {
                                                once: true
                                            });
                                            activeElement.focus();
                                        } else editor._focusEventsAllowed = true;
                                    }, 0);
                                }
                                editor._structTreeParentId = (_$_class_private_field_get = (0, $057QZ._)(this, _accessibilityManager)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
                            }
                        },
                        {
                            key: "addOrRebuild",
                            value: function addOrRebuild(editor) {
                                if (editor.needsToBeRebuilt()) editor.rebuild();
                                else this.add(editor);
                            }
                        },
                        {
                            key: "addUndoableEditor",
                            value: function addUndoableEditor(editor) {
                                var cmd = function() {
                                    return editor._uiManager.rebuild(editor);
                                };
                                var undo = function() {
                                    editor.remove();
                                };
                                this.addCommands({
                                    cmd: cmd,
                                    undo: undo,
                                    mustExec: false
                                });
                            }
                        },
                        {
                            key: "getNextId",
                            value: function getNextId() {
                                return (0, $057QZ._)(this, _uiManager).getId();
                            }
                        },
                        {
                            key: "pasteEditor",
                            value: function pasteEditor(mode, params) {
                                (0, $057QZ._)(this, _uiManager).updateToolbar(mode);
                                (0, $057QZ._)(this, _uiManager).updateMode(mode);
                                var _class_private_method_get_call = (0, $lNbhr._)(this, _getCenterPoint, getCenterPoint).call(this), offsetX = _class_private_method_get_call.offsetX, offsetY = _class_private_method_get_call.offsetY;
                                var id = this.getNextId();
                                var editor = (0, $lNbhr._)(this, _createNewEditor, createNewEditor).call(this, (0, $lwFY2._)({
                                    parent: this,
                                    id: id,
                                    x: offsetX,
                                    y: offsetY,
                                    uiManager: (0, $057QZ._)(this, _uiManager),
                                    isCentered: true
                                }, params));
                                if (editor) this.add(editor);
                            }
                        },
                        {
                            key: "deserialize",
                            value: function deserialize(data) {
                                var _data_annotationType;
                                switch((_data_annotationType = data.annotationType) !== null && _data_annotationType !== void 0 ? _data_annotationType : data.annotationEditorType){
                                    case _util.AnnotationEditorType.FREETEXT:
                                        return _freetext.FreeTextEditor.deserialize(data, this, (0, $057QZ._)(this, _uiManager));
                                    case _util.AnnotationEditorType.INK:
                                        return _ink.InkEditor.deserialize(data, this, (0, $057QZ._)(this, _uiManager));
                                    case _util.AnnotationEditorType.STAMP:
                                        return _stamp.StampEditor.deserialize(data, this, (0, $057QZ._)(this, _uiManager));
                                }
                                return null;
                            }
                        },
                        {
                            key: "addNewEditor",
                            value: function addNewEditor() {
                                (0, $lNbhr._)(this, _createAndAddNewEditor, createAndAddNewEditor).call(this, (0, $lNbhr._)(this, _getCenterPoint, getCenterPoint).call(this), true);
                            }
                        },
                        {
                            key: "setSelected",
                            value: function setSelected(editor) {
                                (0, $057QZ._)(this, _uiManager).setSelected(editor);
                            }
                        },
                        {
                            key: "toggleSelected",
                            value: function toggleSelected(editor) {
                                (0, $057QZ._)(this, _uiManager).toggleSelected(editor);
                            }
                        },
                        {
                            key: "isSelected",
                            value: function isSelected(editor) {
                                return (0, $057QZ._)(this, _uiManager).isSelected(editor);
                            }
                        },
                        {
                            key: "unselect",
                            value: function unselect(editor) {
                                (0, $057QZ._)(this, _uiManager).unselect(editor);
                            }
                        },
                        {
                            key: "pointerup",
                            value: function pointerup(event) {
                                var isMac = _util.FeatureTest.platform.isMac;
                                if (event.button !== 0 || event.ctrlKey && isMac) return;
                                if (event.target !== this.div) return;
                                if (!(0, $057QZ._)(this, _hadPointerDown)) return;
                                (0, $4LHB0._)(this, _hadPointerDown, false);
                                if (!(0, $057QZ._)(this, _allowClick)) {
                                    (0, $4LHB0._)(this, _allowClick, true);
                                    return;
                                }
                                if ((0, $057QZ._)(this, _uiManager).getMode() === _util.AnnotationEditorType.STAMP) {
                                    (0, $057QZ._)(this, _uiManager).unselectAll();
                                    return;
                                }
                                (0, $lNbhr._)(this, _createAndAddNewEditor, createAndAddNewEditor).call(this, event, false);
                            }
                        },
                        {
                            key: "pointerdown",
                            value: function pointerdown(event) {
                                if ((0, $057QZ._)(this, _hadPointerDown)) {
                                    (0, $4LHB0._)(this, _hadPointerDown, false);
                                    return;
                                }
                                var isMac = _util.FeatureTest.platform.isMac;
                                if (event.button !== 0 || event.ctrlKey && isMac) return;
                                if (event.target !== this.div) return;
                                (0, $4LHB0._)(this, _hadPointerDown, true);
                                var editor = (0, $057QZ._)(this, _uiManager).getActive();
                                (0, $4LHB0._)(this, _allowClick, !editor || editor.isEmpty());
                            }
                        },
                        {
                            key: "findNewParent",
                            value: function findNewParent(editor, x, y) {
                                var layer = (0, $057QZ._)(this, _uiManager).findParent(x, y);
                                if (layer === null || layer === this) return false;
                                layer.changeParent(editor);
                                return true;
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                var _class_private_field_get_getActive;
                                if (((_class_private_field_get_getActive = (0, $057QZ._)(this, _uiManager).getActive()) === null || _class_private_field_get_getActive === void 0 ? void 0 : _class_private_field_get_getActive.parent) === this) {
                                    (0, $057QZ._)(this, _uiManager).commitOrRemove();
                                    (0, $057QZ._)(this, _uiManager).setActiveEditor(null);
                                }
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _editors).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editor = _step.value;
                                        var _$_class_private_field_get;
                                        (_$_class_private_field_get = (0, $057QZ._)(this, _accessibilityManager)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.removePointerInTextLayer(editor.contentDiv);
                                        editor.setParent(null);
                                        editor.isAttachedToDOM = false;
                                        editor.div.remove();
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this.div = null;
                                (0, $057QZ._)(this, _editors).clear();
                                (0, $057QZ._)(this, _uiManager).removeLayer(this);
                            }
                        },
                        {
                            key: "render",
                            value: function render(param) {
                                var viewport = param.viewport;
                                this.viewport = viewport;
                                (0, _display_utils.setLayerDimensions)(this.div, viewport);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _uiManager).getEditors(this.pageIndex)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var editor = _step.value;
                                        this.add(editor);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this.updateMode();
                            }
                        },
                        {
                            key: "update",
                            value: function update(param) {
                                var viewport = param.viewport;
                                (0, $057QZ._)(this, _uiManager).commitOrRemove();
                                this.viewport = viewport;
                                (0, _display_utils.setLayerDimensions)(this.div, {
                                    rotation: viewport.rotation
                                });
                                this.updateMode();
                            }
                        },
                        {
                            key: "pageDimensions",
                            get: function get() {
                                var _this_viewport_rawDims = this.viewport.rawDims, pageWidth = _this_viewport_rawDims.pageWidth, pageHeight = _this_viewport_rawDims.pageHeight;
                                return [
                                    pageWidth,
                                    pageHeight
                                ];
                            }
                        }
                    ]);
                    return AnnotationEditorLayer;
                }();
                (0, $iCQyW._)(AnnotationEditorLayer, "_initialized", false);
                function createNewEditor(params) {
                    switch((0, $057QZ._)(this, _uiManager).getMode()){
                        case _util.AnnotationEditorType.FREETEXT:
                            return new _freetext.FreeTextEditor(params);
                        case _util.AnnotationEditorType.INK:
                            return new _ink.InkEditor(params);
                        case _util.AnnotationEditorType.STAMP:
                            return new _stamp.StampEditor(params);
                    }
                    return null;
                }
                function createAndAddNewEditor(event, isCentered) {
                    var id = this.getNextId();
                    var editor = (0, $lNbhr._)(this, _createNewEditor, createNewEditor).call(this, {
                        parent: this,
                        id: id,
                        x: event.offsetX,
                        y: event.offsetY,
                        uiManager: (0, $057QZ._)(this, _uiManager),
                        isCentered: isCentered
                    });
                    if (editor) this.add(editor);
                    return editor;
                }
                function getCenterPoint() {
                    var _this_div_getBoundingClientRect = this.div.getBoundingClientRect(), x = _this_div_getBoundingClientRect.x, y = _this_div_getBoundingClientRect.y, width = _this_div_getBoundingClientRect.width, height = _this_div_getBoundingClientRect.height;
                    var tlX = Math.max(0, x);
                    var tlY = Math.max(0, y);
                    var brX = Math.min(window.innerWidth, x + width);
                    var brY = Math.min(window.innerHeight, y + height);
                    var centerX = (tlX + brX) / 2 - x;
                    var centerY = (tlY + brY) / 2 - y;
                    var _ref = (0, $52tJv._)(this.viewport.rotation % 180 === 0 ? [
                        centerX,
                        centerY
                    ] : [
                        centerY,
                        centerX
                    ], 2), offsetX = _ref[0], offsetY = _ref[1];
                    return {
                        offsetX: offsetX,
                        offsetY: offsetY
                    };
                }
                function cleanup() {
                    (0, $4LHB0._)(this, _isCleaningUp, true);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = (0, $057QZ._)(this, _editors).values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var editor = _step.value;
                            if (editor.isEmpty()) editor.remove();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    (0, $4LHB0._)(this, _isCleaningUp, false);
                }
                exports.AnnotationEditorLayer = AnnotationEditorLayer;
            /***/ },
            /* 28 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FreeTextEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _tools = __w_pdfjs_require__(5);
                var _editor = __w_pdfjs_require__(4);
                var _annotation_layer = __w_pdfjs_require__(29);
                var _boundEditorDivBlur = /*#__PURE__*/ new WeakMap(), _boundEditorDivFocus = /*#__PURE__*/ new WeakMap(), _boundEditorDivInput = /*#__PURE__*/ new WeakMap(), _boundEditorDivKeydown = /*#__PURE__*/ new WeakMap(), _color = /*#__PURE__*/ new WeakMap(), _content = /*#__PURE__*/ new WeakMap(), _editorDivId = /*#__PURE__*/ new WeakMap(), _fontSize = /*#__PURE__*/ new WeakMap(), _initialData = /*#__PURE__*/ new WeakMap(), _editor_AnnotationEditor, _updateFontSize = /*#__PURE__*/ new WeakSet(), _updateColor = /*#__PURE__*/ new WeakSet(), _extractText = /*#__PURE__*/ new WeakSet(), _setEditorDimensions = /*#__PURE__*/ new WeakSet(), _setContent = /*#__PURE__*/ new WeakSet(), _hasElementChanged = /*#__PURE__*/ new WeakSet(), _cheatInitialRect = /*#__PURE__*/ new WeakSet();
                var FreeTextEditor = /*#__PURE__*/ function(_superClass) {
                    (0, $kcqLc._)(FreeTextEditor, _superClass);
                    var _super = (0, $4jYWU._)(FreeTextEditor);
                    function FreeTextEditor(params) {
                        (0, $5sFFs._)(this, FreeTextEditor);
                        var _this;
                        _this = _super.call(this, (0, $bqLxK._)((0, $lwFY2._)({}, params), {
                            name: "freeTextEditor"
                        }));
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _updateFontSize);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _updateColor);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _extractText);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _setEditorDimensions);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _setContent);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _hasElementChanged);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _cheatInitialRect);
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _boundEditorDivBlur, {
                            writable: true,
                            value: _this.editorDivBlur.bind((0, $lyFcw._)(_this))
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _boundEditorDivFocus, {
                            writable: true,
                            value: _this.editorDivFocus.bind((0, $lyFcw._)(_this))
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _boundEditorDivInput, {
                            writable: true,
                            value: _this.editorDivInput.bind((0, $lyFcw._)(_this))
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _boundEditorDivKeydown, {
                            writable: true,
                            value: _this.editorDivKeydown.bind((0, $lyFcw._)(_this))
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _color, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _content, {
                            writable: true,
                            value: ""
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _editorDivId, {
                            writable: true,
                            value: "".concat(_this.id, "-editor")
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _fontSize, {
                            writable: true,
                            value: void 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _initialData, {
                            writable: true,
                            value: null
                        });
                        (0, $4LHB0._)((0, $lyFcw._)(_this), _color, params.color || FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor);
                        (0, $4LHB0._)((0, $lyFcw._)(_this), _fontSize, params.fontSize || FreeTextEditor._defaultFontSize);
                        return _this;
                    }
                    (0, $8O2fV._)(FreeTextEditor, [
                        {
                            key: "updateParams",
                            value: function updateParams(type, value) {
                                switch(type){
                                    case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                                        (0, $lNbhr._)(this, _updateFontSize, updateFontSize).call(this, value);
                                        break;
                                    case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                                        (0, $lNbhr._)(this, _updateColor, updateColor).call(this, value);
                                        break;
                                }
                            }
                        },
                        {
                            key: "propertiesToUpdate",
                            get: function get() {
                                return [
                                    [
                                        _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                                        (0, $057QZ._)(this, _fontSize)
                                    ],
                                    [
                                        _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                                        (0, $057QZ._)(this, _color)
                                    ]
                                ];
                            }
                        },
                        {
                            key: "_translateEmpty",
                            value: function _translateEmpty(x, y) {
                                this._uiManager.translateSelectedEditors(x, y, true);
                            }
                        },
                        {
                            key: "getInitialTranslation",
                            value: function getInitialTranslation() {
                                var scale = this.parentScale;
                                return [
                                    -FreeTextEditor._internalPadding * scale,
                                    -(FreeTextEditor._internalPadding + (0, $057QZ._)(this, _fontSize)) * scale
                                ];
                            }
                        },
                        {
                            key: "rebuild",
                            value: function rebuild() {
                                if (!this.parent) return;
                                (0, $404BM._)((0, $cEF31._)(FreeTextEditor.prototype), "rebuild", this).call(this);
                                if (this.div === null) return;
                                if (!this.isAttachedToDOM) this.parent.add(this);
                            }
                        },
                        {
                            key: "enableEditMode",
                            value: function enableEditMode() {
                                if (this.isInEditMode()) return;
                                this.parent.setEditingState(false);
                                this.parent.updateToolbar(_util.AnnotationEditorType.FREETEXT);
                                (0, $404BM._)((0, $cEF31._)(FreeTextEditor.prototype), "enableEditMode", this).call(this);
                                this.overlayDiv.classList.remove("enabled");
                                this.editorDiv.contentEditable = true;
                                this._isDraggable = false;
                                this.div.removeAttribute("aria-activedescendant");
                                this.editorDiv.addEventListener("keydown", (0, $057QZ._)(this, _boundEditorDivKeydown));
                                this.editorDiv.addEventListener("focus", (0, $057QZ._)(this, _boundEditorDivFocus));
                                this.editorDiv.addEventListener("blur", (0, $057QZ._)(this, _boundEditorDivBlur));
                                this.editorDiv.addEventListener("input", (0, $057QZ._)(this, _boundEditorDivInput));
                            }
                        },
                        {
                            key: "disableEditMode",
                            value: function disableEditMode() {
                                if (!this.isInEditMode()) return;
                                this.parent.setEditingState(true);
                                (0, $404BM._)((0, $cEF31._)(FreeTextEditor.prototype), "disableEditMode", this).call(this);
                                this.overlayDiv.classList.add("enabled");
                                this.editorDiv.contentEditable = false;
                                this.div.setAttribute("aria-activedescendant", (0, $057QZ._)(this, _editorDivId));
                                this._isDraggable = true;
                                this.editorDiv.removeEventListener("keydown", (0, $057QZ._)(this, _boundEditorDivKeydown));
                                this.editorDiv.removeEventListener("focus", (0, $057QZ._)(this, _boundEditorDivFocus));
                                this.editorDiv.removeEventListener("blur", (0, $057QZ._)(this, _boundEditorDivBlur));
                                this.editorDiv.removeEventListener("input", (0, $057QZ._)(this, _boundEditorDivInput));
                                this.div.focus({
                                    preventScroll: true
                                });
                                this.isEditing = false;
                                this.parent.div.classList.add("freeTextEditing");
                            }
                        },
                        {
                            key: "focusin",
                            value: function focusin(event) {
                                if (!this._focusEventsAllowed) return;
                                (0, $404BM._)((0, $cEF31._)(FreeTextEditor.prototype), "focusin", this).call(this, event);
                                if (event.target !== this.editorDiv) this.editorDiv.focus();
                            }
                        },
                        {
                            key: "onceAdded",
                            value: function onceAdded() {
                                var _this__initialOptions;
                                if (this.width) {
                                    (0, $lNbhr._)(this, _cheatInitialRect, cheatInitialRect).call(this);
                                    return;
                                }
                                this.enableEditMode();
                                this.editorDiv.focus();
                                if ((_this__initialOptions = this._initialOptions) === null || _this__initialOptions === void 0 ? void 0 : _this__initialOptions.isCentered) this.center();
                                this._initialOptions = null;
                            }
                        },
                        {
                            key: "isEmpty",
                            value: function isEmpty() {
                                return !this.editorDiv || this.editorDiv.innerText.trim() === "";
                            }
                        },
                        {
                            key: "remove",
                            value: function remove() {
                                this.isEditing = false;
                                if (this.parent) {
                                    this.parent.setEditingState(true);
                                    this.parent.div.classList.add("freeTextEditing");
                                }
                                (0, $404BM._)((0, $cEF31._)(FreeTextEditor.prototype), "remove", this).call(this);
                            }
                        },
                        {
                            key: "commit",
                            value: function commit() {
                                var _this = this;
                                if (!this.isInEditMode()) return;
                                (0, $404BM._)((0, $cEF31._)(FreeTextEditor.prototype), "commit", this).call(this);
                                this.disableEditMode();
                                var savedText = (0, $057QZ._)(this, _content);
                                var newText = (0, $4LHB0._)(this, _content, (0, $lNbhr._)(this, _extractText, extractText).call(this).trimEnd());
                                if (savedText === newText) return;
                                var setText = function(text) {
                                    (0, $4LHB0._)(_this, _content, text);
                                    if (!text) {
                                        _this.remove();
                                        return;
                                    }
                                    (0, $lNbhr._)(_this, _setContent, setContent).call(_this);
                                    _this._uiManager.rebuild(_this);
                                    (0, $lNbhr._)(_this, _setEditorDimensions, setEditorDimensions).call(_this);
                                };
                                this.addCommands({
                                    cmd: function() {
                                        setText(newText);
                                    },
                                    undo: function() {
                                        setText(savedText);
                                    },
                                    mustExec: false
                                });
                                (0, $lNbhr._)(this, _setEditorDimensions, setEditorDimensions).call(this);
                            }
                        },
                        {
                            key: "shouldGetKeyboardEvents",
                            value: function shouldGetKeyboardEvents() {
                                return this.isInEditMode();
                            }
                        },
                        {
                            key: "enterInEditMode",
                            value: function enterInEditMode() {
                                this.enableEditMode();
                                this.editorDiv.focus();
                            }
                        },
                        {
                            key: "dblclick",
                            value: function dblclick(event) {
                                this.enterInEditMode();
                            }
                        },
                        {
                            key: "keydown",
                            value: function keydown(event) {
                                if (event.target === this.div && event.key === "Enter") {
                                    this.enterInEditMode();
                                    event.preventDefault();
                                }
                            }
                        },
                        {
                            key: "editorDivKeydown",
                            value: function editorDivKeydown(event) {
                                FreeTextEditor._keyboardManager.exec(this, event);
                            }
                        },
                        {
                            key: "editorDivFocus",
                            value: function editorDivFocus(event) {
                                this.isEditing = true;
                            }
                        },
                        {
                            key: "editorDivBlur",
                            value: function editorDivBlur(event) {
                                this.isEditing = false;
                            }
                        },
                        {
                            key: "editorDivInput",
                            value: function editorDivInput(event) {
                                this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
                            }
                        },
                        {
                            key: "disableEditing",
                            value: function disableEditing() {
                                this.editorDiv.setAttribute("role", "comment");
                                this.editorDiv.removeAttribute("aria-multiline");
                            }
                        },
                        {
                            key: "enableEditing",
                            value: function enableEditing() {
                                this.editorDiv.setAttribute("role", "textbox");
                                this.editorDiv.setAttribute("aria-multiline", true);
                            }
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this = this;
                                if (this.div) return this.div;
                                var baseX, baseY;
                                if (this.width) {
                                    baseX = this.x;
                                    baseY = this.y;
                                }
                                (0, $404BM._)((0, $cEF31._)(FreeTextEditor.prototype), "render", this).call(this);
                                this.editorDiv = document.createElement("div");
                                this.editorDiv.className = "internal";
                                this.editorDiv.setAttribute("id", (0, $057QZ._)(this, _editorDivId));
                                this.enableEditing();
                                _editor.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then(function(msg) {
                                    var _this_editorDiv;
                                    return (_this_editorDiv = _this.editorDiv) === null || _this_editorDiv === void 0 ? void 0 : _this_editorDiv.setAttribute("aria-label", msg);
                                });
                                _editor.AnnotationEditor._l10nPromise.get("free_text2_default_content").then(function(msg) {
                                    var _this_editorDiv;
                                    return (_this_editorDiv = _this.editorDiv) === null || _this_editorDiv === void 0 ? void 0 : _this_editorDiv.setAttribute("default-content", msg);
                                });
                                this.editorDiv.contentEditable = true;
                                var style = this.editorDiv.style;
                                style.fontSize = "calc(".concat((0, $057QZ._)(this, _fontSize), "px * var(--scale-factor))");
                                style.color = (0, $057QZ._)(this, _color);
                                this.div.append(this.editorDiv);
                                this.overlayDiv = document.createElement("div");
                                this.overlayDiv.classList.add("overlay", "enabled");
                                this.div.append(this.overlayDiv);
                                (0, _tools.bindEvents)(this, this.div, [
                                    "dblclick",
                                    "keydown"
                                ]);
                                if (this.width) {
                                    var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                                    if (this.annotationElementId) {
                                        var position = (0, $057QZ._)(this, _initialData).position;
                                        var _this_getInitialTranslation = (0, $52tJv._)(this.getInitialTranslation(), 2), tx = _this_getInitialTranslation[0], ty = _this_getInitialTranslation[1];
                                        var ref;
                                        ref = (0, $52tJv._)(this.pageTranslationToScreen(tx, ty), 2), tx = ref[0], ty = ref[1], ref;
                                        var _this_pageDimensions = (0, $52tJv._)(this.pageDimensions, 2), pageWidth = _this_pageDimensions[0], pageHeight = _this_pageDimensions[1];
                                        var _this_pageTranslation = (0, $52tJv._)(this.pageTranslation, 2), pageX = _this_pageTranslation[0], pageY = _this_pageTranslation[1];
                                        var posX, posY;
                                        switch(this.rotation){
                                            case 0:
                                                posX = baseX + (position[0] - pageX) / pageWidth;
                                                posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                                                break;
                                            case 90:
                                                posX = baseX + (position[0] - pageX) / pageWidth;
                                                posY = baseY - (position[1] - pageY) / pageHeight;
                                                var ref1;
                                                ref1 = [
                                                    ty,
                                                    -tx
                                                ], tx = ref1[0], ty = ref1[1], ref1;
                                                break;
                                            case 180:
                                                posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                                                posY = baseY - (position[1] - pageY) / pageHeight;
                                                var ref2;
                                                ref2 = [
                                                    -tx,
                                                    -ty
                                                ], tx = ref2[0], ty = ref2[1], ref2;
                                                break;
                                            case 270:
                                                posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                                                posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                                                var ref3;
                                                ref3 = [
                                                    -ty,
                                                    tx
                                                ], tx = ref3[0], ty = ref3[1], ref3;
                                                break;
                                        }
                                        this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
                                    } else this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                                    (0, $lNbhr._)(this, _setContent, setContent).call(this);
                                    this._isDraggable = true;
                                    this.editorDiv.contentEditable = false;
                                } else {
                                    this._isDraggable = false;
                                    this.editorDiv.contentEditable = true;
                                }
                                return this.div;
                            }
                        },
                        {
                            key: "contentDiv",
                            get: function get() {
                                return this.editorDiv;
                            }
                        },
                        {
                            key: "serialize",
                            value: function serialize() {
                                var isForCopying = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                                if (this.isEmpty()) return null;
                                if (this.deleted) return {
                                    pageIndex: this.pageIndex,
                                    id: this.annotationElementId,
                                    deleted: true
                                };
                                var padding = FreeTextEditor._internalPadding * this.parentScale;
                                var rect = this.getRect(padding, padding);
                                var color = _editor.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : (0, $057QZ._)(this, _color));
                                var serialized = {
                                    annotationType: _util.AnnotationEditorType.FREETEXT,
                                    color: color,
                                    fontSize: (0, $057QZ._)(this, _fontSize),
                                    value: (0, $057QZ._)(this, _content),
                                    pageIndex: this.pageIndex,
                                    rect: rect,
                                    rotation: this.rotation,
                                    structTreeParentId: this._structTreeParentId
                                };
                                if (isForCopying) return serialized;
                                if (this.annotationElementId && !(0, $lNbhr._)(this, _hasElementChanged, hasElementChanged).call(this, serialized)) return null;
                                serialized.id = this.annotationElementId;
                                return serialized;
                            }
                        }
                    ], [
                        {
                            key: "_keyboardManager",
                            get: function get() {
                                var proto = FreeTextEditor.prototype;
                                var arrowChecker = function(self) {
                                    return self.isEmpty();
                                };
                                var small = _tools.AnnotationEditorUIManager.TRANSLATE_SMALL;
                                var big = _tools.AnnotationEditorUIManager.TRANSLATE_BIG;
                                return (0, _util.shadow)(this, "_keyboardManager", new _tools.KeyboardManager([
                                    [
                                        [
                                            "ctrl+s",
                                            "mac+meta+s",
                                            "ctrl+p",
                                            "mac+meta+p"
                                        ],
                                        proto.commitOrRemove,
                                        {
                                            bubbles: true
                                        }
                                    ],
                                    [
                                        [
                                            "ctrl+Enter",
                                            "mac+meta+Enter",
                                            "Escape",
                                            "mac+Escape"
                                        ],
                                        proto.commitOrRemove
                                    ],
                                    [
                                        [
                                            "ArrowLeft",
                                            "mac+ArrowLeft"
                                        ],
                                        proto._translateEmpty,
                                        {
                                            args: [
                                                -small,
                                                0
                                            ],
                                            checker: arrowChecker
                                        }
                                    ],
                                    [
                                        [
                                            "ctrl+ArrowLeft",
                                            "mac+shift+ArrowLeft"
                                        ],
                                        proto._translateEmpty,
                                        {
                                            args: [
                                                -big,
                                                0
                                            ],
                                            checker: arrowChecker
                                        }
                                    ],
                                    [
                                        [
                                            "ArrowRight",
                                            "mac+ArrowRight"
                                        ],
                                        proto._translateEmpty,
                                        {
                                            args: [
                                                small,
                                                0
                                            ],
                                            checker: arrowChecker
                                        }
                                    ],
                                    [
                                        [
                                            "ctrl+ArrowRight",
                                            "mac+shift+ArrowRight"
                                        ],
                                        proto._translateEmpty,
                                        {
                                            args: [
                                                big,
                                                0
                                            ],
                                            checker: arrowChecker
                                        }
                                    ],
                                    [
                                        [
                                            "ArrowUp",
                                            "mac+ArrowUp"
                                        ],
                                        proto._translateEmpty,
                                        {
                                            args: [
                                                0,
                                                -small
                                            ],
                                            checker: arrowChecker
                                        }
                                    ],
                                    [
                                        [
                                            "ctrl+ArrowUp",
                                            "mac+shift+ArrowUp"
                                        ],
                                        proto._translateEmpty,
                                        {
                                            args: [
                                                0,
                                                -big
                                            ],
                                            checker: arrowChecker
                                        }
                                    ],
                                    [
                                        [
                                            "ArrowDown",
                                            "mac+ArrowDown"
                                        ],
                                        proto._translateEmpty,
                                        {
                                            args: [
                                                0,
                                                small
                                            ],
                                            checker: arrowChecker
                                        }
                                    ],
                                    [
                                        [
                                            "ctrl+ArrowDown",
                                            "mac+shift+ArrowDown"
                                        ],
                                        proto._translateEmpty,
                                        {
                                            args: [
                                                0,
                                                big
                                            ],
                                            checker: arrowChecker
                                        }
                                    ]
                                ]));
                            }
                        },
                        {
                            key: "initialize",
                            value: function initialize(l10n) {
                                _editor.AnnotationEditor.initialize(l10n, {
                                    strings: [
                                        "free_text2_default_content",
                                        "editor_free_text2_aria_label"
                                    ]
                                });
                                var style = getComputedStyle(document.documentElement);
                                this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
                            }
                        },
                        {
                            key: "updateDefaultParams",
                            value: function updateDefaultParams(type, value) {
                                switch(type){
                                    case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                                        FreeTextEditor._defaultFontSize = value;
                                        break;
                                    case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                                        FreeTextEditor._defaultColor = value;
                                        break;
                                }
                            }
                        },
                        {
                            key: "defaultPropertiesToUpdate",
                            get: function get() {
                                return [
                                    [
                                        _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                                        FreeTextEditor._defaultFontSize
                                    ],
                                    [
                                        _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                                        FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                                    ]
                                ];
                            }
                        },
                        {
                            key: "deserialize",
                            value: function deserialize(data, parent, uiManager) {
                                var _util_Util;
                                var initialData = null;
                                if (data instanceof _annotation_layer.FreeTextAnnotationElement) {
                                    var _data_data = data.data, _data_data_defaultAppearanceData = _data_data.defaultAppearanceData, fontSize = _data_data_defaultAppearanceData.fontSize, fontColor = _data_data_defaultAppearanceData.fontColor, rect = _data_data.rect, rotation = _data_data.rotation, id = _data_data.id, textContent = data.textContent, textPosition = data.textPosition, _data_parent = data.parent, pageNumber = _data_parent.page.pageNumber;
                                    if (!textContent || textContent.length === 0) return null;
                                    initialData = data = {
                                        annotationType: _util.AnnotationEditorType.FREETEXT,
                                        color: Array.from(fontColor),
                                        fontSize: fontSize,
                                        value: textContent.join("\n"),
                                        position: textPosition,
                                        pageIndex: pageNumber - 1,
                                        rect: rect,
                                        rotation: rotation,
                                        id: id,
                                        deleted: false
                                    };
                                }
                                var editor = (0, $404BM._)((0, $cEF31._)(FreeTextEditor), "deserialize", this).call(this, data, parent, uiManager);
                                (0, $4LHB0._)(editor, _fontSize, data.fontSize);
                                (0, $4LHB0._)(editor, _color, (_util_Util = _util.Util).makeHexColor.apply(_util_Util, (0, $fyztb._)(data.color)));
                                (0, $4LHB0._)(editor, _content, data.value);
                                editor.annotationElementId = data.id || null;
                                (0, $4LHB0._)(editor, _initialData, initialData);
                                return editor;
                            }
                        }
                    ]);
                    return FreeTextEditor;
                }(_editor_AnnotationEditor = _editor.AnnotationEditor);
                (0, $iCQyW._)(FreeTextEditor, "_freeTextDefaultContent", "");
                (0, $iCQyW._)(FreeTextEditor, "_internalPadding", 0);
                (0, $iCQyW._)(FreeTextEditor, "_defaultColor", null);
                (0, $iCQyW._)(FreeTextEditor, "_defaultFontSize", 10);
                (0, $iCQyW._)(FreeTextEditor, "_type", "freetext");
                function updateFontSize(fontSize) {
                    var _this = this;
                    var setFontsize = function(size) {
                        _this.editorDiv.style.fontSize = "calc(".concat(size, "px * var(--scale-factor))");
                        _this.translate(0, -(size - (0, $057QZ._)(_this, _fontSize)) * _this.parentScale);
                        (0, $4LHB0._)(_this, _fontSize, size);
                        (0, $lNbhr._)(_this, _setEditorDimensions, setEditorDimensions).call(_this);
                    };
                    var savedFontsize = (0, $057QZ._)(this, _fontSize);
                    this.addCommands({
                        cmd: function() {
                            setFontsize(fontSize);
                        },
                        undo: function() {
                            setFontsize(savedFontsize);
                        },
                        mustExec: true,
                        type: _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                        overwriteIfSameType: true,
                        keepUndo: true
                    });
                }
                function updateColor(color) {
                    var _this = this;
                    var savedColor = (0, $057QZ._)(this, _color);
                    this.addCommands({
                        cmd: function() {
                            (0, $4LHB0._)(_this, _color, _this.editorDiv.style.color = color);
                        },
                        undo: function() {
                            (0, $4LHB0._)(_this, _color, _this.editorDiv.style.color = savedColor);
                        },
                        mustExec: true,
                        type: _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                        overwriteIfSameType: true,
                        keepUndo: true
                    });
                }
                function extractText() {
                    var divs = this.editorDiv.getElementsByTagName("div");
                    if (divs.length === 0) return this.editorDiv.innerText;
                    var buffer = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = divs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var div = _step.value;
                            buffer.push(div.innerText.replace(/\r\n?|\n/, ""));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return buffer.join("\n");
                }
                function setEditorDimensions() {
                    var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                    var rect;
                    if (this.isAttachedToDOM) rect = this.div.getBoundingClientRect();
                    else {
                        var _this = this, currentLayer = _this.currentLayer, div = _this.div;
                        var savedDisplay = div.style.display;
                        div.style.display = "hidden";
                        currentLayer.div.append(this.div);
                        rect = div.getBoundingClientRect();
                        div.remove();
                        div.style.display = savedDisplay;
                    }
                    if (this.rotation % 180 === this.parentRotation % 180) {
                        this.width = rect.width / parentWidth;
                        this.height = rect.height / parentHeight;
                    } else {
                        this.width = rect.height / parentWidth;
                        this.height = rect.width / parentHeight;
                    }
                    this.fixAndSetPosition();
                }
                function setContent() {
                    this.editorDiv.replaceChildren();
                    if (!(0, $057QZ._)(this, _content)) return;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = (0, $057QZ._)(this, _content).split("\n")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var line = _step.value;
                            var div = document.createElement("div");
                            div.append(line ? document.createTextNode(line) : document.createElement("br"));
                            this.editorDiv.append(div);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                function hasElementChanged(serialized) {
                    var _$_class_private_field_get = (0, $057QZ._)(this, _initialData), value = _$_class_private_field_get.value, fontSize = _$_class_private_field_get.fontSize, color = _$_class_private_field_get.color, rect = _$_class_private_field_get.rect, pageIndex = _$_class_private_field_get.pageIndex;
                    return serialized.value !== value || serialized.fontSize !== fontSize || serialized.rect.some(function(x, i) {
                        return Math.abs(x - rect[i]) >= 1;
                    }) || serialized.color.some(function(c, i) {
                        return c !== color[i];
                    }) || serialized.pageIndex !== pageIndex;
                }
                function cheatInitialRect() {
                    var delayed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                    var _this = this;
                    if (!this.annotationElementId) return;
                    (0, $lNbhr._)(this, _setEditorDimensions, setEditorDimensions).call(this);
                    if (!delayed && (this.width === 0 || this.height === 0)) {
                        setTimeout(function() {
                            return (0, $lNbhr._)(_this, _cheatInitialRect, cheatInitialRect).call(_this, true);
                        }, 0);
                        return;
                    }
                    var padding = FreeTextEditor._internalPadding * this.parentScale;
                    (0, $057QZ._)(this, _initialData).rect = this.getRect(padding, padding);
                }
                exports.FreeTextEditor = FreeTextEditor;
            /***/ },
            /* 29 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StampAnnotationElement = exports.InkAnnotationElement = exports.FreeTextAnnotationElement = exports.AnnotationLayer = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _scripting_utils = __w_pdfjs_require__(30);
                var _displayL10n_utils = __w_pdfjs_require__(31);
                var _xfa_layer = __w_pdfjs_require__(32);
                var DEFAULT_TAB_INDEX = 1000;
                var DEFAULT_FONT_SIZE = 9;
                var GetElementsByNameSet = new WeakSet();
                function getRectDims(rect) {
                    return {
                        width: rect[2] - rect[0],
                        height: rect[3] - rect[1]
                    };
                }
                var AnnotationElementFactory = /*#__PURE__*/ function() {
                    function AnnotationElementFactory() {
                        (0, $5sFFs._)(this, AnnotationElementFactory);
                    }
                    (0, $8O2fV._)(AnnotationElementFactory, null, [
                        {
                            key: "create",
                            value: function create(parameters) {
                                var subtype = parameters.data.annotationType;
                                switch(subtype){
                                    case _util.AnnotationType.LINK:
                                        return new LinkAnnotationElement(parameters);
                                    case _util.AnnotationType.TEXT:
                                        return new TextAnnotationElement(parameters);
                                    case _util.AnnotationType.WIDGET:
                                        var fieldType = parameters.data.fieldType;
                                        switch(fieldType){
                                            case "Tx":
                                                return new TextWidgetAnnotationElement(parameters);
                                            case "Btn":
                                                if (parameters.data.radioButton) return new RadioButtonWidgetAnnotationElement(parameters);
                                                else if (parameters.data.checkBox) return new CheckboxWidgetAnnotationElement(parameters);
                                                return new PushButtonWidgetAnnotationElement(parameters);
                                            case "Ch":
                                                return new ChoiceWidgetAnnotationElement(parameters);
                                            case "Sig":
                                                return new SignatureWidgetAnnotationElement(parameters);
                                        }
                                        return new WidgetAnnotationElement(parameters);
                                    case _util.AnnotationType.POPUP:
                                        return new PopupAnnotationElement(parameters);
                                    case _util.AnnotationType.FREETEXT:
                                        return new FreeTextAnnotationElement(parameters);
                                    case _util.AnnotationType.LINE:
                                        return new LineAnnotationElement(parameters);
                                    case _util.AnnotationType.SQUARE:
                                        return new SquareAnnotationElement(parameters);
                                    case _util.AnnotationType.CIRCLE:
                                        return new CircleAnnotationElement(parameters);
                                    case _util.AnnotationType.POLYLINE:
                                        return new PolylineAnnotationElement(parameters);
                                    case _util.AnnotationType.CARET:
                                        return new CaretAnnotationElement(parameters);
                                    case _util.AnnotationType.INK:
                                        return new InkAnnotationElement(parameters);
                                    case _util.AnnotationType.POLYGON:
                                        return new PolygonAnnotationElement(parameters);
                                    case _util.AnnotationType.HIGHLIGHT:
                                        return new HighlightAnnotationElement(parameters);
                                    case _util.AnnotationType.UNDERLINE:
                                        return new UnderlineAnnotationElement(parameters);
                                    case _util.AnnotationType.SQUIGGLY:
                                        return new SquigglyAnnotationElement(parameters);
                                    case _util.AnnotationType.STRIKEOUT:
                                        return new StrikeOutAnnotationElement(parameters);
                                    case _util.AnnotationType.STAMP:
                                        return new StampAnnotationElement(parameters);
                                    case _util.AnnotationType.FILEATTACHMENT:
                                        return new FileAttachmentAnnotationElement(parameters);
                                    default:
                                        return new AnnotationElement(parameters);
                                }
                            }
                        }
                    ]);
                    return AnnotationElementFactory;
                }();
                var _hasBorder = /*#__PURE__*/ new WeakMap();
                var AnnotationElement = /*#__PURE__*/ function() {
                    function AnnotationElement(parameters) {
                        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_isRenderable = _ref.isRenderable, isRenderable = _ref_isRenderable === void 0 ? false : _ref_isRenderable, _ref_ignoreBorder = _ref.ignoreBorder, ignoreBorder = _ref_ignoreBorder === void 0 ? false : _ref_ignoreBorder, _ref_createQuadrilaterals = _ref.createQuadrilaterals, createQuadrilaterals = _ref_createQuadrilaterals === void 0 ? false : _ref_createQuadrilaterals;
                        (0, $5sFFs._)(this, AnnotationElement);
                        (0, $g12Hy._)(this, _hasBorder, {
                            writable: true,
                            value: false
                        });
                        this.isRenderable = isRenderable;
                        this.data = parameters.data;
                        this.layer = parameters.layer;
                        this.linkService = parameters.linkService;
                        this.downloadManager = parameters.downloadManager;
                        this.imageResourcesPath = parameters.imageResourcesPath;
                        this.renderForms = parameters.renderForms;
                        this.svgFactory = parameters.svgFactory;
                        this.annotationStorage = parameters.annotationStorage;
                        this.enableScripting = parameters.enableScripting;
                        this.hasJSActions = parameters.hasJSActions;
                        this._fieldObjects = parameters.fieldObjects;
                        this.parent = parameters.parent;
                        if (isRenderable) this.container = this._createContainer(ignoreBorder);
                        if (createQuadrilaterals) this._createQuadrilaterals();
                    }
                    (0, $8O2fV._)(AnnotationElement, [
                        {
                            key: "hasPopupData",
                            get: function get() {
                                return AnnotationElement._hasPopupData(this.data);
                            }
                        },
                        {
                            key: "_createContainer",
                            value: function _createContainer(ignoreBorder) {
                                var _this = this, data = _this.data, _this_parent = _this.parent, page = _this_parent.page, viewport = _this_parent.viewport;
                                var container = document.createElement("section");
                                container.setAttribute("data-annotation-id", data.id);
                                if (!(this instanceof WidgetAnnotationElement)) container.tabIndex = DEFAULT_TAB_INDEX;
                                container.style.zIndex = this.parent.zIndex++;
                                if (this.data.popupRef) container.setAttribute("aria-haspopup", "dialog");
                                if (data.noRotate) container.classList.add("norotate");
                                var _viewport_rawDims = viewport.rawDims, pageWidth = _viewport_rawDims.pageWidth, pageHeight = _viewport_rawDims.pageHeight, pageX = _viewport_rawDims.pageX, pageY = _viewport_rawDims.pageY;
                                if (!data.rect || this instanceof PopupAnnotationElement) {
                                    var rotation = data.rotation;
                                    if (!data.hasOwnCanvas && rotation !== 0) this.setRotation(rotation, container);
                                    return container;
                                }
                                var _getRectDims = getRectDims(data.rect), width = _getRectDims.width, height = _getRectDims.height;
                                var rect = _util.Util.normalizeRect([
                                    data.rect[0],
                                    page.view[3] - data.rect[1] + page.view[1],
                                    data.rect[2],
                                    page.view[3] - data.rect[3] + page.view[1]
                                ]);
                                if (!ignoreBorder && data.borderStyle.width > 0) {
                                    container.style.borderWidth = "".concat(data.borderStyle.width, "px");
                                    var horizontalRadius = data.borderStyle.horizontalCornerRadius;
                                    var verticalRadius = data.borderStyle.verticalCornerRadius;
                                    if (horizontalRadius > 0 || verticalRadius > 0) {
                                        var radius = "calc(".concat(horizontalRadius, "px * var(--scale-factor)) / calc(").concat(verticalRadius, "px * var(--scale-factor))");
                                        container.style.borderRadius = radius;
                                    } else if (this instanceof RadioButtonWidgetAnnotationElement) {
                                        var radius1 = "calc(".concat(width, "px * var(--scale-factor)) / calc(").concat(height, "px * var(--scale-factor))");
                                        container.style.borderRadius = radius1;
                                    }
                                    switch(data.borderStyle.style){
                                        case _util.AnnotationBorderStyleType.SOLID:
                                            container.style.borderStyle = "solid";
                                            break;
                                        case _util.AnnotationBorderStyleType.DASHED:
                                            container.style.borderStyle = "dashed";
                                            break;
                                        case _util.AnnotationBorderStyleType.BEVELED:
                                            (0, _util.warn)("Unimplemented border style: beveled");
                                            break;
                                        case _util.AnnotationBorderStyleType.INSET:
                                            (0, _util.warn)("Unimplemented border style: inset");
                                            break;
                                        case _util.AnnotationBorderStyleType.UNDERLINE:
                                            container.style.borderBottomStyle = "solid";
                                            break;
                                        default:
                                            break;
                                    }
                                    var borderColor = data.borderColor || null;
                                    if (borderColor) {
                                        (0, $4LHB0._)(this, _hasBorder, true);
                                        container.style.borderColor = _util.Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
                                    } else container.style.borderWidth = 0;
                                }
                                container.style.left = "".concat(100 * (rect[0] - pageX) / pageWidth, "%");
                                container.style.top = "".concat(100 * (rect[1] - pageY) / pageHeight, "%");
                                var rotation1 = data.rotation;
                                if (data.hasOwnCanvas || rotation1 === 0) {
                                    container.style.width = "".concat(100 * width / pageWidth, "%");
                                    container.style.height = "".concat(100 * height / pageHeight, "%");
                                } else this.setRotation(rotation1, container);
                                return container;
                            }
                        },
                        {
                            key: "setRotation",
                            value: function setRotation(angle) {
                                var container = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.container;
                                if (!this.data.rect) return;
                                var _this_parent_viewport_rawDims = this.parent.viewport.rawDims, pageWidth = _this_parent_viewport_rawDims.pageWidth, pageHeight = _this_parent_viewport_rawDims.pageHeight;
                                var _getRectDims = getRectDims(this.data.rect), width = _getRectDims.width, height = _getRectDims.height;
                                var elementWidth, elementHeight;
                                if (angle % 180 === 0) {
                                    elementWidth = 100 * width / pageWidth;
                                    elementHeight = 100 * height / pageHeight;
                                } else {
                                    elementWidth = 100 * height / pageWidth;
                                    elementHeight = 100 * width / pageHeight;
                                }
                                container.style.width = "".concat(elementWidth, "%");
                                container.style.height = "".concat(elementHeight, "%");
                                container.setAttribute("data-main-rotation", (360 - angle) % 360);
                            }
                        },
                        {
                            key: "_commonActions",
                            get: function get() {
                                var _this = this;
                                var setColor = function(jsName, styleName, event) {
                                    var color = event.detail[jsName];
                                    var colorType = color[0];
                                    var colorArray = color.slice(1);
                                    event.target.style[styleName] = _scripting_utils.ColorConverters["".concat(colorType, "_HTML")](colorArray);
                                    _this.annotationStorage.setValue(_this.data.id, (0, $iCQyW._)({}, styleName, _scripting_utils.ColorConverters["".concat(colorType, "_rgb")](colorArray)));
                                };
                                return (0, _util.shadow)(this, "_commonActions", {
                                    display: function(event) {
                                        var display = event.detail.display;
                                        var hidden = display % 2 === 1;
                                        _this.container.style.visibility = hidden ? "hidden" : "visible";
                                        _this.annotationStorage.setValue(_this.data.id, {
                                            noView: hidden,
                                            noPrint: display === 1 || display === 2
                                        });
                                    },
                                    print: function(event) {
                                        _this.annotationStorage.setValue(_this.data.id, {
                                            noPrint: !event.detail.print
                                        });
                                    },
                                    hidden: function(event) {
                                        var hidden = event.detail.hidden;
                                        _this.container.style.visibility = hidden ? "hidden" : "visible";
                                        _this.annotationStorage.setValue(_this.data.id, {
                                            noPrint: hidden,
                                            noView: hidden
                                        });
                                    },
                                    focus: function(event) {
                                        setTimeout(function() {
                                            return event.target.focus({
                                                preventScroll: false
                                            });
                                        }, 0);
                                    },
                                    userName: function(event) {
                                        event.target.title = event.detail.userName;
                                    },
                                    readonly: function(event) {
                                        event.target.disabled = event.detail.readonly;
                                    },
                                    required: function(event) {
                                        _this._setRequired(event.target, event.detail.required);
                                    },
                                    bgColor: function(event) {
                                        setColor("bgColor", "backgroundColor", event);
                                    },
                                    fillColor: function(event) {
                                        setColor("fillColor", "backgroundColor", event);
                                    },
                                    fgColor: function(event) {
                                        setColor("fgColor", "color", event);
                                    },
                                    textColor: function(event) {
                                        setColor("textColor", "color", event);
                                    },
                                    borderColor: function(event) {
                                        setColor("borderColor", "borderColor", event);
                                    },
                                    strokeColor: function(event) {
                                        setColor("strokeColor", "borderColor", event);
                                    },
                                    rotation: function(event) {
                                        var angle = event.detail.rotation;
                                        _this.setRotation(angle);
                                        _this.annotationStorage.setValue(_this.data.id, {
                                            rotation: angle
                                        });
                                    }
                                });
                            }
                        },
                        {
                            key: "_dispatchEventFromSandbox",
                            value: function _dispatchEventFromSandbox(actions, jsEvent) {
                                var commonActions = this._commonActions;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = Object.keys(jsEvent.detail)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var name = _step.value;
                                        var action = actions[name] || commonActions[name];
                                        action === null || action === void 0 ? void 0 : action(jsEvent);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "_setDefaultPropertiesFromJS",
                            value: function _setDefaultPropertiesFromJS(element) {
                                if (!this.enableScripting) return;
                                var storedData = this.annotationStorage.getRawValue(this.data.id);
                                if (!storedData) return;
                                var commonActions = this._commonActions;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = Object.entries(storedData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _step_value = (0, $52tJv._)(_step.value, 2), actionName = _step_value[0], detail = _step_value[1];
                                        var action = commonActions[actionName];
                                        if (action) {
                                            var eventProxy = {
                                                detail: (0, $iCQyW._)({}, actionName, detail),
                                                target: element
                                            };
                                            action(eventProxy);
                                            delete storedData[actionName];
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "_createQuadrilaterals",
                            value: function _createQuadrilaterals() {
                                if (!this.container) return;
                                var quadPoints = this.data.quadPoints;
                                if (!quadPoints) return;
                                var _this_data_rect = (0, $52tJv._)(this.data.rect, 4), rectBlX = _this_data_rect[0], rectBlY = _this_data_rect[1], rectTrX = _this_data_rect[2], rectTrY = _this_data_rect[3];
                                if (quadPoints.length === 1) {
                                    var _quadPoints_ = (0, $52tJv._)(quadPoints[0], 3), _quadPoints__ = _quadPoints_[1], trX = _quadPoints__.x, trY = _quadPoints__.y, _quadPoints__1 = _quadPoints_[2], blX = _quadPoints__1.x, blY = _quadPoints__1.y;
                                    if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) return;
                                }
                                var style = this.container.style;
                                var svgBuffer;
                                if ((0, $057QZ._)(this, _hasBorder)) {
                                    var borderColor = style.borderColor, borderWidth = style.borderWidth;
                                    style.borderWidth = 0;
                                    svgBuffer = [
                                        "url('data:image/svg+xml;utf8,",
                                        '<svg xmlns="http://www.w3.org/2000/svg"',
                                        ' preserveAspectRatio="none" viewBox="0 0 1 1">',
                                        '<g fill="transparent" stroke="'.concat(borderColor, '" stroke-width="').concat(borderWidth, '">')
                                    ];
                                    this.container.classList.add("hasBorder");
                                }
                                var width = rectTrX - rectBlX;
                                var height = rectTrY - rectBlY;
                                var svgFactory = this.svgFactory;
                                var svg = svgFactory.createElement("svg");
                                svg.classList.add("quadrilateralsContainer");
                                svg.setAttribute("width", 0);
                                svg.setAttribute("height", 0);
                                var defs = svgFactory.createElement("defs");
                                svg.append(defs);
                                var clipPath = svgFactory.createElement("clipPath");
                                var id = "clippath_".concat(this.data.id);
                                clipPath.setAttribute("id", id);
                                clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
                                defs.append(clipPath);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = quadPoints[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _step_value = (0, $52tJv._)(_step.value, 3), _step_value_ = _step_value[1], trX1 = _step_value_.x, trY1 = _step_value_.y, _step_value_1 = _step_value[2], blX1 = _step_value_1.x, blY1 = _step_value_1.y;
                                        var rect = svgFactory.createElement("rect");
                                        var x = (blX1 - rectBlX) / width;
                                        var y = (rectTrY - trY1) / height;
                                        var rectWidth = (trX1 - blX1) / width;
                                        var rectHeight = (trY1 - blY1) / height;
                                        rect.setAttribute("x", x);
                                        rect.setAttribute("y", y);
                                        rect.setAttribute("width", rectWidth);
                                        rect.setAttribute("height", rectHeight);
                                        clipPath.append(rect);
                                        svgBuffer === null || svgBuffer === void 0 ? void 0 : svgBuffer.push('<rect vector-effect="non-scaling-stroke" x="'.concat(x, '" y="').concat(y, '" width="').concat(rectWidth, '" height="').concat(rectHeight, '"/>'));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if ((0, $057QZ._)(this, _hasBorder)) {
                                    svgBuffer.push("</g></svg>')");
                                    style.backgroundImage = svgBuffer.join("");
                                }
                                this.container.append(svg);
                                this.container.style.clipPath = "url(#".concat(id, ")");
                            }
                        },
                        {
                            key: "_createPopup",
                            value: function _createPopup() {
                                var _this = this, container = _this.container, data = _this.data;
                                container.setAttribute("aria-haspopup", "dialog");
                                var popup = new PopupAnnotationElement({
                                    data: {
                                        color: data.color,
                                        titleObj: data.titleObj,
                                        modificationDate: data.modificationDate,
                                        contentsObj: data.contentsObj,
                                        richText: data.richText,
                                        parentRect: data.rect,
                                        borderStyle: 0,
                                        id: "popup_".concat(data.id),
                                        rotation: data.rotation
                                    },
                                    parent: this.parent,
                                    elements: [
                                        this
                                    ]
                                });
                                this.parent.div.append(popup.render());
                            }
                        },
                        {
                            key: "render",
                            value: function render() {
                                (0, _util.unreachable)("Abstract method `AnnotationElement.render` called");
                            }
                        },
                        {
                            key: "_getElementsByName",
                            value: function _getElementsByName(name) {
                                var skipId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                                var fields = [];
                                if (this._fieldObjects) {
                                    var fieldObj = this._fieldObjects[name];
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    if (fieldObj) try {
                                        for(var _iterator = fieldObj[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var _step_value = _step.value, page = _step_value.page, id = _step_value.id, exportValues = _step_value.exportValues;
                                            if (page === -1) continue;
                                            if (id === skipId) continue;
                                            var exportValue = typeof exportValues === "string" ? exportValues : null;
                                            var domElement = document.querySelector('[data-element-id="'.concat(id, '"]'));
                                            if (domElement && !GetElementsByNameSet.has(domElement)) {
                                                (0, _util.warn)("_getElementsByName - element not allowed: ".concat(id));
                                                continue;
                                            }
                                            fields.push({
                                                id: id,
                                                exportValue: exportValue,
                                                domElement: domElement
                                            });
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    return fields;
                                }
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = document.getElementsByName(name)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var domElement1 = _step1.value;
                                        var exportValue1 = domElement1.exportValue;
                                        var id1 = domElement1.getAttribute("data-element-id");
                                        if (id1 === skipId) continue;
                                        if (!GetElementsByNameSet.has(domElement1)) continue;
                                        fields.push({
                                            id: id1,
                                            exportValue: exportValue1,
                                            domElement: domElement1
                                        });
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                return fields;
                            }
                        },
                        {
                            key: "show",
                            value: function show() {
                                var _this_popup;
                                if (this.container) this.container.hidden = false;
                                (_this_popup = this.popup) === null || _this_popup === void 0 ? void 0 : _this_popup.maybeShow();
                            }
                        },
                        {
                            key: "hide",
                            value: function hide() {
                                var _this_popup;
                                if (this.container) this.container.hidden = true;
                                (_this_popup = this.popup) === null || _this_popup === void 0 ? void 0 : _this_popup.forceHide();
                            }
                        },
                        {
                            key: "getElementsToTriggerPopup",
                            value: function getElementsToTriggerPopup() {
                                return this.container;
                            }
                        },
                        {
                            key: "addHighlightArea",
                            value: function addHighlightArea() {
                                var triggers = this.getElementsToTriggerPopup();
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (Array.isArray(triggers)) try {
                                    for(var _iterator = triggers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var element = _step.value;
                                        element.classList.add("highlightArea");
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                else triggers.classList.add("highlightArea");
                            }
                        },
                        {
                            key: "_editOnDoubleClick",
                            value: function _editOnDoubleClick() {
                                var _this = this;
                                var _this1 = this, mode = _this1.annotationEditorType, _this_data = _this1.data, editId = _this_data.id;
                                this.container.addEventListener("dblclick", function() {
                                    var _this_linkService_eventBus;
                                    (_this_linkService_eventBus = _this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("switchannotationeditormode", {
                                        source: _this,
                                        mode: mode,
                                        editId: editId
                                    });
                                });
                            }
                        }
                    ], [
                        {
                            key: "_hasPopupData",
                            value: function _hasPopupData(param) {
                                var titleObj = param.titleObj, contentsObj = param.contentsObj, richText = param.richText;
                                return !!((titleObj === null || titleObj === void 0 ? void 0 : titleObj.str) || (contentsObj === null || contentsObj === void 0 ? void 0 : contentsObj.str) || (richText === null || richText === void 0 ? void 0 : richText.str));
                            }
                        }
                    ]);
                    return AnnotationElement;
                }();
                var _setInternalLink = /*#__PURE__*/ new WeakSet(), _bindSetOCGState = /*#__PURE__*/ new WeakSet();
                var LinkAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(LinkAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(LinkAnnotationElement);
                    function LinkAnnotationElement(parameters) {
                        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                        (0, $5sFFs._)(this, LinkAnnotationElement);
                        var _this;
                        _this = _super.call(this, parameters, {
                            isRenderable: true,
                            ignoreBorder: !!(options === null || options === void 0 ? void 0 : options.ignoreBorder),
                            createQuadrilaterals: true
                        });
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _setInternalLink);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _bindSetOCGState);
                        _this.isTooltipOnly = parameters.data.isTooltipOnly;
                        return _this;
                    }
                    (0, $8O2fV._)(LinkAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this = this, data = _this.data, linkService = _this.linkService;
                                var link = document.createElement("a");
                                link.setAttribute("data-element-id", data.id);
                                var isBound = false;
                                if (data.url) {
                                    linkService.addLinkAttributes(link, data.url, data.newWindow);
                                    isBound = true;
                                } else if (data.action) {
                                    this._bindNamedAction(link, data.action);
                                    isBound = true;
                                } else if (data.attachment) {
                                    this._bindAttachment(link, data.attachment);
                                    isBound = true;
                                } else if (data.setOCGState) {
                                    (0, $lNbhr._)(this, _bindSetOCGState, bindSetOCGState).call(this, link, data.setOCGState);
                                    isBound = true;
                                } else if (data.dest) {
                                    this._bindLink(link, data.dest);
                                    isBound = true;
                                } else {
                                    if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                                        this._bindJSAction(link, data);
                                        isBound = true;
                                    }
                                    if (data.resetForm) {
                                        this._bindResetFormAction(link, data.resetForm);
                                        isBound = true;
                                    } else if (this.isTooltipOnly && !isBound) {
                                        this._bindLink(link, "");
                                        isBound = true;
                                    }
                                }
                                this.container.classList.add("linkAnnotation");
                                if (isBound) this.container.append(link);
                                return this.container;
                            }
                        },
                        {
                            key: "_bindLink",
                            value: function _bindLink(link, destination) {
                                var _this = this;
                                link.href = this.linkService.getDestinationHash(destination);
                                link.onclick = function() {
                                    if (destination) _this.linkService.goToDestination(destination);
                                    return false;
                                };
                                if (destination || destination === "") (0, $lNbhr._)(this, _setInternalLink, setInternalLink).call(this);
                            }
                        },
                        {
                            key: "_bindNamedAction",
                            value: function _bindNamedAction(link, action) {
                                var _this = this;
                                link.href = this.linkService.getAnchorUrl("");
                                link.onclick = function() {
                                    _this.linkService.executeNamedAction(action);
                                    return false;
                                };
                                (0, $lNbhr._)(this, _setInternalLink, setInternalLink).call(this);
                            }
                        },
                        {
                            key: "_bindAttachment",
                            value: function _bindAttachment(link, attachment) {
                                var _this = this;
                                link.href = this.linkService.getAnchorUrl("");
                                link.onclick = function() {
                                    var _this_downloadManager;
                                    (_this_downloadManager = _this.downloadManager) === null || _this_downloadManager === void 0 ? void 0 : _this_downloadManager.openOrDownloadData(_this.container, attachment.content, attachment.filename);
                                    return false;
                                };
                                (0, $lNbhr._)(this, _setInternalLink, setInternalLink).call(this);
                            }
                        },
                        {
                            key: "_bindJSAction",
                            value: function _bindJSAction(link, data) {
                                var _this = this;
                                link.href = this.linkService.getAnchorUrl("");
                                var map = new Map([
                                    [
                                        "Action",
                                        "onclick"
                                    ],
                                    [
                                        "Mouse Up",
                                        "onmouseup"
                                    ],
                                    [
                                        "Mouse Down",
                                        "onmousedown"
                                    ]
                                ]);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    var _loop = function() {
                                        var name = _step.value;
                                        var jsName = map.get(name);
                                        if (!jsName) return "continue";
                                        link[jsName] = function() {
                                            var _this_linkService_eventBus;
                                            (_this_linkService_eventBus = _this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                                source: _this,
                                                detail: {
                                                    id: data.id,
                                                    name: name
                                                }
                                            });
                                            return false;
                                        };
                                    };
                                    for(var _iterator = Object.keys(data.actions)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (!link.onclick) link.onclick = function() {
                                    return false;
                                };
                                (0, $lNbhr._)(this, _setInternalLink, setInternalLink).call(this);
                            }
                        },
                        {
                            key: "_bindResetFormAction",
                            value: function _bindResetFormAction(link, resetForm) {
                                var _this = this;
                                var otherClickAction = link.onclick;
                                if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
                                (0, $lNbhr._)(this, _setInternalLink, setInternalLink).call(this);
                                if (!this._fieldObjects) {
                                    (0, _util.warn)('_bindResetFormAction - "resetForm" action not supported, ' + "ensure that the `fieldObjects` parameter is provided.");
                                    if (!otherClickAction) link.onclick = function() {
                                        return false;
                                    };
                                    return;
                                }
                                link.onclick = function() {
                                    var _allFields;
                                    var _this_linkService_eventBus;
                                    otherClickAction === null || otherClickAction === void 0 ? void 0 : otherClickAction();
                                    var resetFormFields = resetForm.fields, resetFormRefs = resetForm.refs, include = resetForm.include;
                                    var allFields = [];
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                                        var fieldIds = new Set(resetFormRefs);
                                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(var _iterator = resetFormFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                                var fieldName = _step.value;
                                                var fields = _this._fieldObjects[fieldName] || [];
                                                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                                try {
                                                    for(var _iterator1 = fields[Symbol.iterator](), _step1; !(_iteratorNormalCompletion2 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
                                                        var id = _step1.value.id;
                                                        fieldIds.add(id);
                                                    }
                                                } catch (err) {
                                                    _didIteratorError2 = true;
                                                    _iteratorError2 = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion2 && _iterator1.return != null) {
                                                            _iterator1.return();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError2) {
                                                            throw _iteratorError2;
                                                        }
                                                    }
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                        try {
                                            for(var _iterator2 = Object.values(_this._fieldObjects)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion3 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion3 = true){
                                                var fields1 = _step2.value;
                                                var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                                                try {
                                                    for(var _iterator3 = fields1[Symbol.iterator](), _step3; !(_iteratorNormalCompletion4 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion4 = true){
                                                        var field = _step3.value;
                                                        if (fieldIds.has(field.id) === include) allFields.push(field);
                                                    }
                                                } catch (err) {
                                                    _didIteratorError4 = true;
                                                    _iteratorError4 = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion4 && _iterator3.return != null) {
                                                            _iterator3.return();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError4) {
                                                            throw _iteratorError4;
                                                        }
                                                    }
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError3 = true;
                                            _iteratorError3 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion3 && _iterator2.return != null) {
                                                    _iterator2.return();
                                                }
                                            } finally{
                                                if (_didIteratorError3) {
                                                    throw _iteratorError3;
                                                }
                                            }
                                        }
                                    } else try {
                                        for(var _iterator4 = Object.values(_this._fieldObjects)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion = true){
                                            var fields2 = _step4.value;
                                            (_allFields = allFields).push.apply(_allFields, (0, $fyztb._)(fields2));
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator4.return != null) {
                                                _iterator4.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    var storage = _this.annotationStorage;
                                    var allIds = [];
                                    var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                                    try {
                                        for(var _iterator5 = allFields[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                                            var field1 = _step5.value;
                                            var id1 = field1.id;
                                            allIds.push(id1);
                                            switch(field1.type){
                                                case "text":
                                                    {
                                                        var value = field1.defaultValue || "";
                                                        storage.setValue(id1, {
                                                            value: value
                                                        });
                                                        break;
                                                    }
                                                case "checkbox":
                                                case "radiobutton":
                                                    {
                                                        var value1 = field1.defaultValue === field1.exportValues;
                                                        storage.setValue(id1, {
                                                            value: value1
                                                        });
                                                        break;
                                                    }
                                                case "combobox":
                                                case "listbox":
                                                    {
                                                        var value2 = field1.defaultValue || "";
                                                        storage.setValue(id1, {
                                                            value: value2
                                                        });
                                                        break;
                                                    }
                                                default:
                                                    continue;
                                            }
                                            var domElement = document.querySelector('[data-element-id="'.concat(id1, '"]'));
                                            if (!domElement) continue;
                                            else if (!GetElementsByNameSet.has(domElement)) {
                                                (0, _util.warn)("_bindResetFormAction - element not allowed: ".concat(id1));
                                                continue;
                                            }
                                            domElement.dispatchEvent(new Event("resetform"));
                                        }
                                    } catch (err) {
                                        _didIteratorError5 = true;
                                        _iteratorError5 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                                _iterator5.return();
                                            }
                                        } finally{
                                            if (_didIteratorError5) {
                                                throw _iteratorError5;
                                            }
                                        }
                                    }
                                    if (_this.enableScripting) (_this_linkService_eventBus = _this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                        source: _this,
                                        detail: {
                                            id: "app",
                                            ids: allIds,
                                            name: "ResetForm"
                                        }
                                    });
                                    return false;
                                };
                            }
                        }
                    ]);
                    return LinkAnnotationElement;
                }(AnnotationElement);
                function setInternalLink() {
                    this.container.setAttribute("data-internal-link", "");
                }
                function bindSetOCGState(link, action) {
                    var _this = this;
                    link.href = this.linkService.getAnchorUrl("");
                    link.onclick = function() {
                        _this.linkService.executeSetOCGState(action);
                        return false;
                    };
                    (0, $lNbhr._)(this, _setInternalLink, setInternalLink).call(this);
                }
                var TextAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(TextAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(TextAnnotationElement);
                    function TextAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, TextAnnotationElement);
                        return _super.call(this, parameters, {
                            isRenderable: true
                        });
                    }
                    (0, $8O2fV._)(TextAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.classList.add("textAnnotation");
                                var image = document.createElement("img");
                                image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                                image.alt = "[{{type}} Annotation]";
                                image.dataset.l10nId = "text_annotation_type";
                                image.dataset.l10nArgs = JSON.stringify({
                                    type: this.data.name
                                });
                                if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                                this.container.append(image);
                                return this.container;
                            }
                        }
                    ]);
                    return TextAnnotationElement;
                }(AnnotationElement);
                var WidgetAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(WidgetAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(WidgetAnnotationElement);
                    function WidgetAnnotationElement() {
                        (0, $5sFFs._)(this, WidgetAnnotationElement);
                        return _super.apply(this, arguments);
                    }
                    (0, $8O2fV._)(WidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (this.data.alternativeText) this.container.title = this.data.alternativeText;
                                return this.container;
                            }
                        },
                        {
                            key: "showElementAndHideCanvas",
                            value: function showElementAndHideCanvas(element) {
                                if (this.data.hasOwnCanvas) {
                                    var _element_previousSibling;
                                    if (((_element_previousSibling = element.previousSibling) === null || _element_previousSibling === void 0 ? void 0 : _element_previousSibling.nodeName) === "CANVAS") element.previousSibling.hidden = true;
                                    element.hidden = false;
                                }
                            }
                        },
                        {
                            key: "_getKeyModifier",
                            value: function _getKeyModifier(event) {
                                var _util_FeatureTest_platform = _util.FeatureTest.platform, isWin = _util_FeatureTest_platform.isWin, isMac = _util_FeatureTest_platform.isMac;
                                return isWin && event.ctrlKey || isMac && event.metaKey;
                            }
                        },
                        {
                            key: "_setEventListener",
                            value: function _setEventListener(element, elementData, baseName, eventName, valueGetter) {
                                var _this = this;
                                if (baseName.includes("mouse")) element.addEventListener(baseName, function(event) {
                                    var _this_linkService_eventBus;
                                    (_this_linkService_eventBus = _this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                        source: _this,
                                        detail: {
                                            id: _this.data.id,
                                            name: eventName,
                                            value: valueGetter(event),
                                            shift: event.shiftKey,
                                            modifier: _this._getKeyModifier(event)
                                        }
                                    });
                                });
                                else element.addEventListener(baseName, function(event) {
                                    var _this_linkService_eventBus;
                                    if (baseName === "blur") {
                                        if (!elementData.focused || !event.relatedTarget) return;
                                        elementData.focused = false;
                                    } else if (baseName === "focus") {
                                        if (elementData.focused) return;
                                        elementData.focused = true;
                                    }
                                    if (!valueGetter) return;
                                    (_this_linkService_eventBus = _this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                        source: _this,
                                        detail: {
                                            id: _this.data.id,
                                            name: eventName,
                                            value: valueGetter(event)
                                        }
                                    });
                                });
                            }
                        },
                        {
                            key: "_setEventListeners",
                            value: function _setEventListeners(element, elementData, names, getter) {
                                var _this_data_actions;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _step_value = (0, $52tJv._)(_step.value, 2), baseName = _step_value[0], eventName = _step_value[1];
                                        if (eventName === "Action" || ((_this_data_actions = this.data.actions) === null || _this_data_actions === void 0 ? void 0 : _this_data_actions[eventName])) {
                                            var _this_data_actions1, _this_data_actions2;
                                            if (eventName === "Focus" || eventName === "Blur") elementData || (elementData = {
                                                focused: false
                                            });
                                            this._setEventListener(element, elementData, baseName, eventName, getter);
                                            if (eventName === "Focus" && !((_this_data_actions1 = this.data.actions) === null || _this_data_actions1 === void 0 ? void 0 : _this_data_actions1.Blur)) this._setEventListener(element, elementData, "blur", "Blur", null);
                                            else if (eventName === "Blur" && !((_this_data_actions2 = this.data.actions) === null || _this_data_actions2 === void 0 ? void 0 : _this_data_actions2.Focus)) this._setEventListener(element, elementData, "focus", "Focus", null);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "_setBackgroundColor",
                            value: function _setBackgroundColor(element) {
                                var color = this.data.backgroundColor || null;
                                element.style.backgroundColor = color === null ? "transparent" : _util.Util.makeHexColor(color[0], color[1], color[2]);
                            }
                        },
                        {
                            key: "_setTextStyle",
                            value: function _setTextStyle(element) {
                                var TEXT_ALIGNMENT = [
                                    "left",
                                    "center",
                                    "right"
                                ];
                                var fontColor = this.data.defaultAppearanceData.fontColor;
                                var fontSize = this.data.defaultAppearanceData.fontSize || DEFAULT_FONT_SIZE;
                                var style = element.style;
                                var computedFontSize;
                                var BORDER_SIZE = 2;
                                var roundToOneDecimal = function(x) {
                                    return Math.round(10 * x) / 10;
                                };
                                if (this.data.multiLine) {
                                    var height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                                    var numberOfLines = Math.round(height / (_util.LINE_FACTOR * fontSize)) || 1;
                                    var lineHeight = height / numberOfLines;
                                    computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / _util.LINE_FACTOR));
                                } else {
                                    var height1 = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                                    computedFontSize = Math.min(fontSize, roundToOneDecimal(height1 / _util.LINE_FACTOR));
                                }
                                style.fontSize = "calc(".concat(computedFontSize, "px * var(--scale-factor))");
                                style.color = _util.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
                                if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
                            }
                        },
                        {
                            key: "_setRequired",
                            value: function _setRequired(element, isRequired) {
                                if (isRequired) element.setAttribute("required", true);
                                else element.removeAttribute("required");
                                element.setAttribute("aria-required", isRequired);
                            }
                        }
                    ]);
                    return WidgetAnnotationElement;
                }(AnnotationElement);
                var TextWidgetAnnotationElement = /*#__PURE__*/ function(WidgetAnnotationElement) {
                    (0, $kcqLc._)(TextWidgetAnnotationElement, WidgetAnnotationElement);
                    var _super = (0, $4jYWU._)(TextWidgetAnnotationElement);
                    function TextWidgetAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, TextWidgetAnnotationElement);
                        var isRenderable = parameters.renderForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
                        return _super.call(this, parameters, {
                            isRenderable: isRenderable
                        });
                    }
                    (0, $8O2fV._)(TextWidgetAnnotationElement, [
                        {
                            key: "setPropertyOnSiblings",
                            value: function setPropertyOnSiblings(base, key, value, keyInStorage) {
                                var storage = this.annotationStorage;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this._getElementsByName(base.name, base.id)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var element = _step.value;
                                        if (element.domElement) element.domElement[key] = value;
                                        storage.setValue(element.id, (0, $iCQyW._)({}, keyInStorage, value));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this = this;
                                var storage = this.annotationStorage;
                                var id = this.data.id;
                                this.container.classList.add("textWidgetAnnotation");
                                var element = null;
                                if (this.renderForms) {
                                    var _this_data_textContent;
                                    var storedData = storage.getValue(id, {
                                        value: this.data.fieldValue
                                    });
                                    var textContent = storedData.value || "";
                                    var maxLen = storage.getValue(id, {
                                        charLimit: this.data.maxLen
                                    }).charLimit;
                                    if (maxLen && textContent.length > maxLen) textContent = textContent.slice(0, maxLen);
                                    var fieldFormattedValues = storedData.formattedValue || ((_this_data_textContent = this.data.textContent) === null || _this_data_textContent === void 0 ? void 0 : _this_data_textContent.join("\n")) || null;
                                    if (fieldFormattedValues && this.data.comb) fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
                                    var elementData = {
                                        userValue: textContent,
                                        formattedValue: fieldFormattedValues,
                                        lastCommittedValue: null,
                                        commitKey: 1,
                                        focused: false
                                    };
                                    if (this.data.multiLine) {
                                        element = document.createElement("textarea");
                                        element.textContent = fieldFormattedValues !== null && fieldFormattedValues !== void 0 ? fieldFormattedValues : textContent;
                                        if (this.data.doNotScroll) element.style.overflowY = "hidden";
                                    } else {
                                        element = document.createElement("input");
                                        element.type = "text";
                                        element.setAttribute("value", fieldFormattedValues !== null && fieldFormattedValues !== void 0 ? fieldFormattedValues : textContent);
                                        if (this.data.doNotScroll) element.style.overflowX = "hidden";
                                    }
                                    if (this.data.hasOwnCanvas) element.hidden = true;
                                    GetElementsByNameSet.add(element);
                                    element.setAttribute("data-element-id", id);
                                    element.disabled = this.data.readOnly;
                                    element.name = this.data.fieldName;
                                    element.tabIndex = DEFAULT_TAB_INDEX;
                                    this._setRequired(element, this.data.required);
                                    if (maxLen) element.maxLength = maxLen;
                                    element.addEventListener("input", function(event) {
                                        storage.setValue(id, {
                                            value: event.target.value
                                        });
                                        _this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                                        elementData.formattedValue = null;
                                    });
                                    element.addEventListener("resetform", function(event) {
                                        var _this_data_defaultFieldValue;
                                        var defaultValue = (_this_data_defaultFieldValue = _this.data.defaultFieldValue) !== null && _this_data_defaultFieldValue !== void 0 ? _this_data_defaultFieldValue : "";
                                        element.value = elementData.userValue = defaultValue;
                                        elementData.formattedValue = null;
                                    });
                                    var blurListener = function(event) {
                                        var formattedValue = elementData.formattedValue;
                                        if (formattedValue !== null && formattedValue !== undefined) event.target.value = formattedValue;
                                        event.target.scrollLeft = 0;
                                    };
                                    if (this.enableScripting && this.hasJSActions) {
                                        var _this_data_actions;
                                        element.addEventListener("focus", function(event) {
                                            if (elementData.focused) return;
                                            var target = event.target;
                                            if (elementData.userValue) target.value = elementData.userValue;
                                            elementData.lastCommittedValue = target.value;
                                            elementData.commitKey = 1;
                                            elementData.focused = true;
                                        });
                                        element.addEventListener("updatefromsandbox", function(jsEvent) {
                                            _this.showElementAndHideCanvas(jsEvent.target);
                                            var actions = {
                                                value: function(event) {
                                                    var _event_detail_value;
                                                    elementData.userValue = (_event_detail_value = event.detail.value) !== null && _event_detail_value !== void 0 ? _event_detail_value : "";
                                                    storage.setValue(id, {
                                                        value: elementData.userValue.toString()
                                                    });
                                                    event.target.value = elementData.userValue;
                                                },
                                                formattedValue: function(event) {
                                                    var formattedValue = event.detail.formattedValue;
                                                    elementData.formattedValue = formattedValue;
                                                    if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) event.target.value = formattedValue;
                                                    storage.setValue(id, {
                                                        formattedValue: formattedValue
                                                    });
                                                },
                                                selRange: function(event) {
                                                    var _event_target;
                                                    (_event_target = event.target).setSelectionRange.apply(_event_target, (0, $fyztb._)(event.detail.selRange));
                                                },
                                                charLimit: function(event) {
                                                    var _this_linkService_eventBus;
                                                    var charLimit = event.detail.charLimit;
                                                    var target = event.target;
                                                    if (charLimit === 0) {
                                                        target.removeAttribute("maxLength");
                                                        return;
                                                    }
                                                    target.setAttribute("maxLength", charLimit);
                                                    var value = elementData.userValue;
                                                    if (!value || value.length <= charLimit) return;
                                                    value = value.slice(0, charLimit);
                                                    target.value = elementData.userValue = value;
                                                    storage.setValue(id, {
                                                        value: value
                                                    });
                                                    (_this_linkService_eventBus = _this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                                        source: _this,
                                                        detail: {
                                                            id: id,
                                                            name: "Keystroke",
                                                            value: value,
                                                            willCommit: true,
                                                            commitKey: 1,
                                                            selStart: target.selectionStart,
                                                            selEnd: target.selectionEnd
                                                        }
                                                    });
                                                }
                                            };
                                            _this._dispatchEventFromSandbox(actions, jsEvent);
                                        });
                                        element.addEventListener("keydown", function(event) {
                                            var _this_linkService_eventBus;
                                            elementData.commitKey = 1;
                                            var commitKey = -1;
                                            if (event.key === "Escape") commitKey = 0;
                                            else if (event.key === "Enter" && !_this.data.multiLine) commitKey = 2;
                                            else if (event.key === "Tab") elementData.commitKey = 3;
                                            if (commitKey === -1) return;
                                            var value = event.target.value;
                                            if (elementData.lastCommittedValue === value) return;
                                            elementData.lastCommittedValue = value;
                                            elementData.userValue = value;
                                            (_this_linkService_eventBus = _this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                                source: _this,
                                                detail: {
                                                    id: id,
                                                    name: "Keystroke",
                                                    value: value,
                                                    willCommit: true,
                                                    commitKey: commitKey,
                                                    selStart: event.target.selectionStart,
                                                    selEnd: event.target.selectionEnd
                                                }
                                            });
                                        });
                                        var _blurListener = blurListener;
                                        blurListener = null;
                                        element.addEventListener("blur", function(event) {
                                            var _this_linkService_eventBus;
                                            if (!elementData.focused || !event.relatedTarget) return;
                                            elementData.focused = false;
                                            var value = event.target.value;
                                            elementData.userValue = value;
                                            if (elementData.lastCommittedValue !== value) (_this_linkService_eventBus = _this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                                source: _this,
                                                detail: {
                                                    id: id,
                                                    name: "Keystroke",
                                                    value: value,
                                                    willCommit: true,
                                                    commitKey: elementData.commitKey,
                                                    selStart: event.target.selectionStart,
                                                    selEnd: event.target.selectionEnd
                                                }
                                            });
                                            _blurListener(event);
                                        });
                                        if ((_this_data_actions = this.data.actions) === null || _this_data_actions === void 0 ? void 0 : _this_data_actions.Keystroke) element.addEventListener("beforeinput", function(event) {
                                            var _this_linkService_eventBus;
                                            elementData.lastCommittedValue = null;
                                            var data = event.data, target = event.target;
                                            var value = target.value, selectionStart = target.selectionStart, selectionEnd = target.selectionEnd;
                                            var selStart = selectionStart, selEnd = selectionEnd;
                                            switch(event.inputType){
                                                case "deleteWordBackward":
                                                    {
                                                        var match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                                                        if (match) selStart -= match[0].length;
                                                        break;
                                                    }
                                                case "deleteWordForward":
                                                    {
                                                        var match1 = value.substring(selectionStart).match(/^[^\w]*\w*/);
                                                        if (match1) selEnd += match1[0].length;
                                                        break;
                                                    }
                                                case "deleteContentBackward":
                                                    if (selectionStart === selectionEnd) selStart -= 1;
                                                    break;
                                                case "deleteContentForward":
                                                    if (selectionStart === selectionEnd) selEnd += 1;
                                                    break;
                                            }
                                            event.preventDefault();
                                            (_this_linkService_eventBus = _this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                                source: _this,
                                                detail: {
                                                    id: id,
                                                    name: "Keystroke",
                                                    value: value,
                                                    change: data || "",
                                                    willCommit: false,
                                                    selStart: selStart,
                                                    selEnd: selEnd
                                                }
                                            });
                                        });
                                        this._setEventListeners(element, elementData, [
                                            [
                                                "focus",
                                                "Focus"
                                            ],
                                            [
                                                "blur",
                                                "Blur"
                                            ],
                                            [
                                                "mousedown",
                                                "Mouse Down"
                                            ],
                                            [
                                                "mouseenter",
                                                "Mouse Enter"
                                            ],
                                            [
                                                "mouseleave",
                                                "Mouse Exit"
                                            ],
                                            [
                                                "mouseup",
                                                "Mouse Up"
                                            ]
                                        ], function(event) {
                                            return event.target.value;
                                        });
                                    }
                                    if (blurListener) element.addEventListener("blur", blurListener);
                                    if (this.data.comb) {
                                        var fieldWidth = this.data.rect[2] - this.data.rect[0];
                                        var combWidth = fieldWidth / maxLen;
                                        element.classList.add("comb");
                                        element.style.letterSpacing = "calc(".concat(combWidth, "px * var(--scale-factor) - 1ch)");
                                    }
                                } else {
                                    element = document.createElement("div");
                                    element.textContent = this.data.fieldValue;
                                    element.style.verticalAlign = "middle";
                                    element.style.display = "table-cell";
                                }
                                this._setTextStyle(element);
                                this._setBackgroundColor(element);
                                this._setDefaultPropertiesFromJS(element);
                                this.container.append(element);
                                return this.container;
                            }
                        }
                    ]);
                    return TextWidgetAnnotationElement;
                }(WidgetAnnotationElement);
                var SignatureWidgetAnnotationElement = /*#__PURE__*/ function(WidgetAnnotationElement) {
                    (0, $kcqLc._)(SignatureWidgetAnnotationElement, WidgetAnnotationElement);
                    var _super = (0, $4jYWU._)(SignatureWidgetAnnotationElement);
                    function SignatureWidgetAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, SignatureWidgetAnnotationElement);
                        return _super.call(this, parameters, {
                            isRenderable: !!parameters.data.hasOwnCanvas
                        });
                    }
                    return SignatureWidgetAnnotationElement;
                }(WidgetAnnotationElement);
                var CheckboxWidgetAnnotationElement = /*#__PURE__*/ function(WidgetAnnotationElement) {
                    (0, $kcqLc._)(CheckboxWidgetAnnotationElement, WidgetAnnotationElement);
                    var _super = (0, $4jYWU._)(CheckboxWidgetAnnotationElement);
                    function CheckboxWidgetAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, CheckboxWidgetAnnotationElement);
                        return _super.call(this, parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    (0, $8O2fV._)(CheckboxWidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this = this;
                                var storage = this.annotationStorage;
                                var data = this.data;
                                var id = data.id;
                                var value = storage.getValue(id, {
                                    value: data.exportValue === data.fieldValue
                                }).value;
                                if (typeof value === "string") {
                                    value = value !== "Off";
                                    storage.setValue(id, {
                                        value: value
                                    });
                                }
                                this.container.classList.add("buttonWidgetAnnotation", "checkBox");
                                var element = document.createElement("input");
                                GetElementsByNameSet.add(element);
                                element.setAttribute("data-element-id", id);
                                element.disabled = data.readOnly;
                                this._setRequired(element, this.data.required);
                                element.type = "checkbox";
                                element.name = data.fieldName;
                                if (value) element.setAttribute("checked", true);
                                element.setAttribute("exportValue", data.exportValue);
                                element.tabIndex = DEFAULT_TAB_INDEX;
                                element.addEventListener("change", function(event) {
                                    var _event_target = event.target, name = _event_target.name, checked = _event_target.checked;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = _this._getElementsByName(name, id)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var checkbox = _step.value;
                                            var curChecked = checked && checkbox.exportValue === data.exportValue;
                                            if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                                            storage.setValue(checkbox.id, {
                                                value: curChecked
                                            });
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    storage.setValue(id, {
                                        value: checked
                                    });
                                });
                                element.addEventListener("resetform", function(event) {
                                    var defaultValue = data.defaultFieldValue || "Off";
                                    event.target.checked = defaultValue === data.exportValue;
                                });
                                if (this.enableScripting && this.hasJSActions) {
                                    element.addEventListener("updatefromsandbox", function(jsEvent) {
                                        var actions = {
                                            value: function(event) {
                                                event.target.checked = event.detail.value !== "Off";
                                                storage.setValue(id, {
                                                    value: event.target.checked
                                                });
                                            }
                                        };
                                        _this._dispatchEventFromSandbox(actions, jsEvent);
                                    });
                                    this._setEventListeners(element, null, [
                                        [
                                            "change",
                                            "Validate"
                                        ],
                                        [
                                            "change",
                                            "Action"
                                        ],
                                        [
                                            "focus",
                                            "Focus"
                                        ],
                                        [
                                            "blur",
                                            "Blur"
                                        ],
                                        [
                                            "mousedown",
                                            "Mouse Down"
                                        ],
                                        [
                                            "mouseenter",
                                            "Mouse Enter"
                                        ],
                                        [
                                            "mouseleave",
                                            "Mouse Exit"
                                        ],
                                        [
                                            "mouseup",
                                            "Mouse Up"
                                        ]
                                    ], function(event) {
                                        return event.target.checked;
                                    });
                                }
                                this._setBackgroundColor(element);
                                this._setDefaultPropertiesFromJS(element);
                                this.container.append(element);
                                return this.container;
                            }
                        }
                    ]);
                    return CheckboxWidgetAnnotationElement;
                }(WidgetAnnotationElement);
                var RadioButtonWidgetAnnotationElement = /*#__PURE__*/ function(WidgetAnnotationElement) {
                    (0, $kcqLc._)(RadioButtonWidgetAnnotationElement, WidgetAnnotationElement);
                    var _super = (0, $4jYWU._)(RadioButtonWidgetAnnotationElement);
                    function RadioButtonWidgetAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, RadioButtonWidgetAnnotationElement);
                        return _super.call(this, parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    (0, $8O2fV._)(RadioButtonWidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this = this;
                                this.container.classList.add("buttonWidgetAnnotation", "radioButton");
                                var storage = this.annotationStorage;
                                var data = this.data;
                                var id = data.id;
                                var value = storage.getValue(id, {
                                    value: data.fieldValue === data.buttonValue
                                }).value;
                                if (typeof value === "string") {
                                    value = value !== data.buttonValue;
                                    storage.setValue(id, {
                                        value: value
                                    });
                                }
                                var element = document.createElement("input");
                                GetElementsByNameSet.add(element);
                                element.setAttribute("data-element-id", id);
                                element.disabled = data.readOnly;
                                this._setRequired(element, this.data.required);
                                element.type = "radio";
                                element.name = data.fieldName;
                                if (value) element.setAttribute("checked", true);
                                element.tabIndex = DEFAULT_TAB_INDEX;
                                element.addEventListener("change", function(event) {
                                    var _event_target = event.target, name = _event_target.name, checked = _event_target.checked;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = _this._getElementsByName(name, id)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var radio = _step.value;
                                            storage.setValue(radio.id, {
                                                value: false
                                            });
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    storage.setValue(id, {
                                        value: checked
                                    });
                                });
                                element.addEventListener("resetform", function(event) {
                                    var defaultValue = data.defaultFieldValue;
                                    event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
                                });
                                if (this.enableScripting && this.hasJSActions) {
                                    var pdfButtonValue = data.buttonValue;
                                    element.addEventListener("updatefromsandbox", function(jsEvent) {
                                        var actions = {
                                            value: function(event) {
                                                var checked = pdfButtonValue === event.detail.value;
                                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                try {
                                                    for(var _iterator = _this._getElementsByName(event.target.name)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                        var radio = _step.value;
                                                        var curChecked = checked && radio.id === id;
                                                        if (radio.domElement) radio.domElement.checked = curChecked;
                                                        storage.setValue(radio.id, {
                                                            value: curChecked
                                                        });
                                                    }
                                                } catch (err) {
                                                    _didIteratorError = true;
                                                    _iteratorError = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                            _iterator.return();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError) {
                                                            throw _iteratorError;
                                                        }
                                                    }
                                                }
                                            }
                                        };
                                        _this._dispatchEventFromSandbox(actions, jsEvent);
                                    });
                                    this._setEventListeners(element, null, [
                                        [
                                            "change",
                                            "Validate"
                                        ],
                                        [
                                            "change",
                                            "Action"
                                        ],
                                        [
                                            "focus",
                                            "Focus"
                                        ],
                                        [
                                            "blur",
                                            "Blur"
                                        ],
                                        [
                                            "mousedown",
                                            "Mouse Down"
                                        ],
                                        [
                                            "mouseenter",
                                            "Mouse Enter"
                                        ],
                                        [
                                            "mouseleave",
                                            "Mouse Exit"
                                        ],
                                        [
                                            "mouseup",
                                            "Mouse Up"
                                        ]
                                    ], function(event) {
                                        return event.target.checked;
                                    });
                                }
                                this._setBackgroundColor(element);
                                this._setDefaultPropertiesFromJS(element);
                                this.container.append(element);
                                return this.container;
                            }
                        }
                    ]);
                    return RadioButtonWidgetAnnotationElement;
                }(WidgetAnnotationElement);
                var PushButtonWidgetAnnotationElement = /*#__PURE__*/ function(LinkAnnotationElement) {
                    (0, $kcqLc._)(PushButtonWidgetAnnotationElement, LinkAnnotationElement);
                    var _super = (0, $4jYWU._)(PushButtonWidgetAnnotationElement);
                    function PushButtonWidgetAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, PushButtonWidgetAnnotationElement);
                        return _super.call(this, parameters, {
                            ignoreBorder: parameters.data.hasAppearance
                        });
                    }
                    (0, $8O2fV._)(PushButtonWidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this = this;
                                var container = (0, $404BM._)((0, $cEF31._)(PushButtonWidgetAnnotationElement.prototype), "render", this).call(this);
                                container.classList.add("buttonWidgetAnnotation", "pushButton");
                                if (this.data.alternativeText) container.title = this.data.alternativeText;
                                var linkElement = container.lastChild;
                                if (this.enableScripting && this.hasJSActions && linkElement) {
                                    this._setDefaultPropertiesFromJS(linkElement);
                                    linkElement.addEventListener("updatefromsandbox", function(jsEvent) {
                                        _this._dispatchEventFromSandbox({}, jsEvent);
                                    });
                                }
                                return container;
                            }
                        }
                    ]);
                    return PushButtonWidgetAnnotationElement;
                }(LinkAnnotationElement);
                var ChoiceWidgetAnnotationElement = /*#__PURE__*/ function(WidgetAnnotationElement) {
                    (0, $kcqLc._)(ChoiceWidgetAnnotationElement, WidgetAnnotationElement);
                    var _super = (0, $4jYWU._)(ChoiceWidgetAnnotationElement);
                    function ChoiceWidgetAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, ChoiceWidgetAnnotationElement);
                        return _super.call(this, parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    (0, $8O2fV._)(ChoiceWidgetAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this = this;
                                this.container.classList.add("choiceWidgetAnnotation");
                                var storage = this.annotationStorage;
                                var id = this.data.id;
                                var storedData = storage.getValue(id, {
                                    value: this.data.fieldValue
                                });
                                var selectElement = document.createElement("select");
                                GetElementsByNameSet.add(selectElement);
                                selectElement.setAttribute("data-element-id", id);
                                selectElement.disabled = this.data.readOnly;
                                this._setRequired(selectElement, this.data.required);
                                selectElement.name = this.data.fieldName;
                                selectElement.tabIndex = DEFAULT_TAB_INDEX;
                                var addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
                                if (!this.data.combo) {
                                    selectElement.size = this.data.options.length;
                                    if (this.data.multiSelect) selectElement.multiple = true;
                                }
                                selectElement.addEventListener("resetform", function(event) {
                                    var defaultValue = _this.data.defaultFieldValue;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = selectElement.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var option = _step.value;
                                            option.selected = option.value === defaultValue;
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                });
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this.data.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var option = _step.value;
                                        var optionElement = document.createElement("option");
                                        optionElement.textContent = option.displayValue;
                                        optionElement.value = option.exportValue;
                                        if (storedData.value.includes(option.exportValue)) {
                                            optionElement.setAttribute("selected", true);
                                            addAnEmptyEntry = false;
                                        }
                                        selectElement.append(optionElement);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                var removeEmptyEntry = null;
                                if (addAnEmptyEntry) {
                                    var noneOptionElement = document.createElement("option");
                                    noneOptionElement.value = " ";
                                    noneOptionElement.setAttribute("hidden", true);
                                    noneOptionElement.setAttribute("selected", true);
                                    selectElement.prepend(noneOptionElement);
                                    removeEmptyEntry = function() {
                                        noneOptionElement.remove();
                                        selectElement.removeEventListener("input", removeEmptyEntry);
                                        removeEmptyEntry = null;
                                    };
                                    selectElement.addEventListener("input", removeEmptyEntry);
                                }
                                var getValue = function(isExport) {
                                    var name = isExport ? "value" : "textContent";
                                    var options = selectElement.options, multiple = selectElement.multiple;
                                    if (!multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
                                    return Array.prototype.filter.call(options, function(option) {
                                        return option.selected;
                                    }).map(function(option) {
                                        return option[name];
                                    });
                                };
                                var selectedValues = getValue(false);
                                var getItems = function(event) {
                                    var options = event.target.options;
                                    return Array.prototype.map.call(options, function(option) {
                                        return {
                                            displayValue: option.textContent,
                                            exportValue: option.value
                                        };
                                    });
                                };
                                if (this.enableScripting && this.hasJSActions) {
                                    selectElement.addEventListener("updatefromsandbox", function(jsEvent) {
                                        var actions = {
                                            value: function(event) {
                                                removeEmptyEntry === null || removeEmptyEntry === void 0 ? void 0 : removeEmptyEntry();
                                                var value = event.detail.value;
                                                var values = new Set(Array.isArray(value) ? value : [
                                                    value
                                                ]);
                                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                try {
                                                    for(var _iterator = selectElement.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                        var option = _step.value;
                                                        option.selected = values.has(option.value);
                                                    }
                                                } catch (err) {
                                                    _didIteratorError = true;
                                                    _iteratorError = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                            _iterator.return();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError) {
                                                            throw _iteratorError;
                                                        }
                                                    }
                                                }
                                                storage.setValue(id, {
                                                    value: getValue(true)
                                                });
                                                selectedValues = getValue(false);
                                            },
                                            multipleSelection: function(event) {
                                                selectElement.multiple = true;
                                            },
                                            remove: function(event) {
                                                var options = selectElement.options;
                                                var index = event.detail.remove;
                                                options[index].selected = false;
                                                selectElement.remove(index);
                                                if (options.length > 0) {
                                                    var i = Array.prototype.findIndex.call(options, function(option) {
                                                        return option.selected;
                                                    });
                                                    if (i === -1) options[0].selected = true;
                                                }
                                                storage.setValue(id, {
                                                    value: getValue(true),
                                                    items: getItems(event)
                                                });
                                                selectedValues = getValue(false);
                                            },
                                            clear: function(event) {
                                                while(selectElement.length !== 0)selectElement.remove(0);
                                                storage.setValue(id, {
                                                    value: null,
                                                    items: []
                                                });
                                                selectedValues = getValue(false);
                                            },
                                            insert: function(event) {
                                                var _event_detail_insert = event.detail.insert, index = _event_detail_insert.index, displayValue = _event_detail_insert.displayValue, exportValue = _event_detail_insert.exportValue;
                                                var selectChild = selectElement.children[index];
                                                var optionElement = document.createElement("option");
                                                optionElement.textContent = displayValue;
                                                optionElement.value = exportValue;
                                                if (selectChild) selectChild.before(optionElement);
                                                else selectElement.append(optionElement);
                                                storage.setValue(id, {
                                                    value: getValue(true),
                                                    items: getItems(event)
                                                });
                                                selectedValues = getValue(false);
                                            },
                                            items: function(event) {
                                                var items = event.detail.items;
                                                while(selectElement.length !== 0)selectElement.remove(0);
                                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                try {
                                                    for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                        var item = _step.value;
                                                        var displayValue = item.displayValue, exportValue = item.exportValue;
                                                        var optionElement = document.createElement("option");
                                                        optionElement.textContent = displayValue;
                                                        optionElement.value = exportValue;
                                                        selectElement.append(optionElement);
                                                    }
                                                } catch (err) {
                                                    _didIteratorError = true;
                                                    _iteratorError = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                            _iterator.return();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError) {
                                                            throw _iteratorError;
                                                        }
                                                    }
                                                }
                                                if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                                                storage.setValue(id, {
                                                    value: getValue(true),
                                                    items: getItems(event)
                                                });
                                                selectedValues = getValue(false);
                                            },
                                            indices: function(event) {
                                                var indices = new Set(event.detail.indices);
                                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                try {
                                                    for(var _iterator = event.target.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                        var option = _step.value;
                                                        option.selected = indices.has(option.index);
                                                    }
                                                } catch (err) {
                                                    _didIteratorError = true;
                                                    _iteratorError = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                            _iterator.return();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError) {
                                                            throw _iteratorError;
                                                        }
                                                    }
                                                }
                                                storage.setValue(id, {
                                                    value: getValue(true)
                                                });
                                                selectedValues = getValue(false);
                                            },
                                            editable: function(event) {
                                                event.target.disabled = !event.detail.editable;
                                            }
                                        };
                                        _this._dispatchEventFromSandbox(actions, jsEvent);
                                    });
                                    selectElement.addEventListener("input", function(event) {
                                        var _this_linkService_eventBus;
                                        var exportValue = getValue(true);
                                        storage.setValue(id, {
                                            value: exportValue
                                        });
                                        event.preventDefault();
                                        (_this_linkService_eventBus = _this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                            source: _this,
                                            detail: {
                                                id: id,
                                                name: "Keystroke",
                                                value: selectedValues,
                                                changeEx: exportValue,
                                                willCommit: false,
                                                commitKey: 1,
                                                keyDown: false
                                            }
                                        });
                                    });
                                    this._setEventListeners(selectElement, null, [
                                        [
                                            "focus",
                                            "Focus"
                                        ],
                                        [
                                            "blur",
                                            "Blur"
                                        ],
                                        [
                                            "mousedown",
                                            "Mouse Down"
                                        ],
                                        [
                                            "mouseenter",
                                            "Mouse Enter"
                                        ],
                                        [
                                            "mouseleave",
                                            "Mouse Exit"
                                        ],
                                        [
                                            "mouseup",
                                            "Mouse Up"
                                        ],
                                        [
                                            "input",
                                            "Action"
                                        ],
                                        [
                                            "input",
                                            "Validate"
                                        ]
                                    ], function(event) {
                                        return event.target.value;
                                    });
                                } else selectElement.addEventListener("input", function(event) {
                                    storage.setValue(id, {
                                        value: getValue(true)
                                    });
                                });
                                if (this.data.combo) this._setTextStyle(selectElement);
                                this._setBackgroundColor(selectElement);
                                this._setDefaultPropertiesFromJS(selectElement);
                                this.container.append(selectElement);
                                return this.container;
                            }
                        }
                    ]);
                    return ChoiceWidgetAnnotationElement;
                }(WidgetAnnotationElement);
                var PopupAnnotationElement = /*#__PURE__*/ function(AnnotationElement1) {
                    (0, $kcqLc._)(PopupAnnotationElement, AnnotationElement1);
                    var _super = (0, $4jYWU._)(PopupAnnotationElement);
                    function PopupAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, PopupAnnotationElement);
                        var _this;
                        var data = parameters.data, elements = parameters.elements;
                        _this = _super.call(this, parameters, {
                            isRenderable: AnnotationElement._hasPopupData(data)
                        });
                        _this.elements = elements;
                        return _this;
                    }
                    (0, $8O2fV._)(PopupAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.classList.add("popupAnnotation");
                                var popup = new PopupElement({
                                    container: this.container,
                                    color: this.data.color,
                                    titleObj: this.data.titleObj,
                                    modificationDate: this.data.modificationDate,
                                    contentsObj: this.data.contentsObj,
                                    richText: this.data.richText,
                                    rect: this.data.rect,
                                    parentRect: this.data.parentRect || null,
                                    parent: this.parent,
                                    elements: this.elements,
                                    open: this.data.open
                                });
                                var elementIds = [];
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = this.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var element = _step.value;
                                        element.popup = popup;
                                        elementIds.push(element.data.id);
                                        element.addHighlightArea();
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this.container.setAttribute("aria-controls", elementIds.map(function(id) {
                                    return "".concat(_util.AnnotationPrefix).concat(id);
                                }).join(","));
                                return this.container;
                            }
                        }
                    ]);
                    return PopupAnnotationElement;
                }(AnnotationElement);
                var _dateTimePromise = /*#__PURE__*/ new WeakMap(), _boundKeyDown = /*#__PURE__*/ new WeakMap(), _boundHide = /*#__PURE__*/ new WeakMap(), _boundShow = /*#__PURE__*/ new WeakMap(), _boundToggle = /*#__PURE__*/ new WeakMap(), _color = /*#__PURE__*/ new WeakMap(), _container = /*#__PURE__*/ new WeakMap(), _contentsObj = /*#__PURE__*/ new WeakMap(), _elements = /*#__PURE__*/ new WeakMap(), _parent = /*#__PURE__*/ new WeakMap(), _parentRect = /*#__PURE__*/ new WeakMap(), _pinned = /*#__PURE__*/ new WeakMap(), _popup = /*#__PURE__*/ new WeakMap(), _rect = /*#__PURE__*/ new WeakMap(), _richText = /*#__PURE__*/ new WeakMap(), _titleObj = /*#__PURE__*/ new WeakMap(), _wasVisible = /*#__PURE__*/ new WeakMap(), _keyDown = /*#__PURE__*/ new WeakSet(), _toggle = /*#__PURE__*/ new WeakSet(), _show = /*#__PURE__*/ new WeakSet(), _hide = /*#__PURE__*/ new WeakSet();
                var PopupElement = /*#__PURE__*/ function() {
                    function PopupElement(param) {
                        var container = param.container, color = param.color, elements = param.elements, titleObj = param.titleObj, modificationDate = param.modificationDate, contentsObj = param.contentsObj, richText = param.richText, parent = param.parent, rect = param.rect, parentRect = param.parentRect, open = param.open;
                        (0, $5sFFs._)(this, PopupElement);
                        var _element_container;
                        (0, $iB2CV._)(this, _keyDown);
                        (0, $iB2CV._)(this, _toggle);
                        (0, $iB2CV._)(this, _show);
                        (0, $iB2CV._)(this, _hide);
                        (0, $g12Hy._)(this, _dateTimePromise, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _boundKeyDown, {
                            writable: true,
                            value: (0, $lNbhr._)(this, _keyDown, keyDown).bind(this)
                        });
                        (0, $g12Hy._)(this, _boundHide, {
                            writable: true,
                            value: (0, $lNbhr._)(this, _hide, hide).bind(this)
                        });
                        (0, $g12Hy._)(this, _boundShow, {
                            writable: true,
                            value: (0, $lNbhr._)(this, _show, show).bind(this)
                        });
                        (0, $g12Hy._)(this, _boundToggle, {
                            writable: true,
                            value: (0, $lNbhr._)(this, _toggle, toggle).bind(this)
                        });
                        (0, $g12Hy._)(this, _color, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _container, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _contentsObj, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _elements, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _parent, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _parentRect, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _pinned, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)(this, _popup, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _rect, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _richText, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _titleObj, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _wasVisible, {
                            writable: true,
                            value: false
                        });
                        (0, $4LHB0._)(this, _container, container);
                        (0, $4LHB0._)(this, _titleObj, titleObj);
                        (0, $4LHB0._)(this, _contentsObj, contentsObj);
                        (0, $4LHB0._)(this, _richText, richText);
                        (0, $4LHB0._)(this, _parent, parent);
                        (0, $4LHB0._)(this, _color, color);
                        (0, $4LHB0._)(this, _rect, rect);
                        (0, $4LHB0._)(this, _parentRect, parentRect);
                        (0, $4LHB0._)(this, _elements, elements);
                        var dateObject = _display_utils.PDFDateString.toDateObject(modificationDate);
                        if (dateObject) (0, $4LHB0._)(this, _dateTimePromise, parent.l10n.get("annotation_date_string", {
                            date: dateObject.toLocaleDateString(),
                            time: dateObject.toLocaleTimeString()
                        }));
                        this.trigger = elements.flatMap(function(e) {
                            return e.getElementsToTriggerPopup();
                        });
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.trigger[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var element = _step.value;
                                element.addEventListener("click", (0, $057QZ._)(this, _boundToggle));
                                element.addEventListener("mouseenter", (0, $057QZ._)(this, _boundShow));
                                element.addEventListener("mouseleave", (0, $057QZ._)(this, _boundHide));
                                element.classList.add("popupTriggerArea");
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = elements[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var element1 = _step1.value;
                                (_element_container = element1.container) === null || _element_container === void 0 ? void 0 : _element_container.addEventListener("keydown", (0, $057QZ._)(this, _boundKeyDown));
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        (0, $057QZ._)(this, _container).hidden = true;
                        if (open) (0, $lNbhr._)(this, _toggle, toggle).call(this);
                    }
                    (0, $8O2fV._)(PopupElement, [
                        {
                            key: "render",
                            value: function render() {
                                if ((0, $057QZ._)(this, _popup)) return;
                                var _$_class_private_field_get = (0, $057QZ._)(this, _parent), view = _$_class_private_field_get.page.view, _class_private_field_get_viewport = _$_class_private_field_get.viewport, _class_private_field_get_viewport_rawDims = _class_private_field_get_viewport.rawDims, pageWidth = _class_private_field_get_viewport_rawDims.pageWidth, pageHeight = _class_private_field_get_viewport_rawDims.pageHeight, pageX = _class_private_field_get_viewport_rawDims.pageX, pageY = _class_private_field_get_viewport_rawDims.pageY;
                                var popup = (0, $4LHB0._)(this, _popup, document.createElement("div"));
                                popup.className = "popup";
                                if ((0, $057QZ._)(this, _color)) {
                                    var _util_Util;
                                    var baseColor = popup.style.outlineColor = (_util_Util = _util.Util).makeHexColor.apply(_util_Util, (0, $fyztb._)((0, $057QZ._)(this, _color)));
                                    if (CSS.supports("background-color", "color-mix(in srgb, red 30%, white)")) popup.style.backgroundColor = "color-mix(in srgb, ".concat(baseColor, " 30%, white)");
                                    else {
                                        var _util_Util1;
                                        var BACKGROUND_ENLIGHT = 0.7;
                                        popup.style.backgroundColor = (_util_Util1 = _util.Util).makeHexColor.apply(_util_Util1, (0, $fyztb._)((0, $057QZ._)(this, _color).map(function(c) {
                                            return Math.floor(BACKGROUND_ENLIGHT * (255 - c) + c);
                                        })));
                                    }
                                }
                                var header = document.createElement("span");
                                header.className = "header";
                                var title = document.createElement("h1");
                                header.append(title);
                                var ref;
                                ref = (0, $057QZ._)(this, _titleObj), title.dir = ref.dir, title.textContent = ref.str, ref;
                                popup.append(header);
                                if ((0, $057QZ._)(this, _dateTimePromise)) {
                                    var modificationDate = document.createElement("span");
                                    modificationDate.classList.add("popupDate");
                                    (0, $057QZ._)(this, _dateTimePromise).then(function(localized) {
                                        modificationDate.textContent = localized;
                                    });
                                    header.append(modificationDate);
                                }
                                var contentsObj = (0, $057QZ._)(this, _contentsObj);
                                var richText = (0, $057QZ._)(this, _richText);
                                if ((richText === null || richText === void 0 ? void 0 : richText.str) && (!(contentsObj === null || contentsObj === void 0 ? void 0 : contentsObj.str) || contentsObj.str === richText.str)) {
                                    _xfa_layer.XfaLayer.render({
                                        xfaHtml: richText.html,
                                        intent: "richText",
                                        div: popup
                                    });
                                    popup.lastChild.classList.add("richText", "popupContent");
                                } else {
                                    var contents = this._formatContents(contentsObj);
                                    popup.append(contents);
                                }
                                var useParentRect = !!(0, $057QZ._)(this, _parentRect);
                                var rect = useParentRect ? (0, $057QZ._)(this, _parentRect) : (0, $057QZ._)(this, _rect);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = (0, $057QZ._)(this, _elements)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var element = _step.value;
                                        if (!rect || _util.Util.intersect(element.data.rect, rect) !== null) {
                                            rect = element.data.rect;
                                            useParentRect = true;
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                var normalizedRect = _util.Util.normalizeRect([
                                    rect[0],
                                    view[3] - rect[1] + view[1],
                                    rect[2],
                                    view[3] - rect[3] + view[1]
                                ]);
                                var HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
                                var parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
                                var popupLeft = normalizedRect[0] + parentWidth;
                                var popupTop = normalizedRect[1];
                                var style = (0, $057QZ._)(this, _container).style;
                                style.left = "".concat(100 * (popupLeft - pageX) / pageWidth, "%");
                                style.top = "".concat(100 * (popupTop - pageY) / pageHeight, "%");
                                (0, $057QZ._)(this, _container).append(popup);
                            }
                        },
                        {
                            key: "_formatContents",
                            value: function _formatContents(param) {
                                var str = param.str, dir = param.dir;
                                var p = document.createElement("p");
                                p.classList.add("popupContent");
                                p.dir = dir;
                                var lines = str.split(/(?:\r\n?|\n)/);
                                for(var i = 0, ii = lines.length; i < ii; ++i){
                                    var line = lines[i];
                                    p.append(document.createTextNode(line));
                                    if (i < ii - 1) p.append(document.createElement("br"));
                                }
                                return p;
                            }
                        },
                        {
                            key: "forceHide",
                            value: function forceHide() {
                                (0, $4LHB0._)(this, _wasVisible, this.isVisible);
                                if (!(0, $057QZ._)(this, _wasVisible)) return;
                                (0, $057QZ._)(this, _container).hidden = true;
                            }
                        },
                        {
                            key: "maybeShow",
                            value: function maybeShow() {
                                if (!(0, $057QZ._)(this, _wasVisible)) return;
                                (0, $4LHB0._)(this, _wasVisible, false);
                                (0, $057QZ._)(this, _container).hidden = false;
                            }
                        },
                        {
                            key: "isVisible",
                            get: function get() {
                                return (0, $057QZ._)(this, _container).hidden === false;
                            }
                        }
                    ]);
                    return PopupElement;
                }();
                function keyDown(event) {
                    if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
                    if (event.key === "Enter" || event.key === "Escape" && (0, $057QZ._)(this, _pinned)) (0, $lNbhr._)(this, _toggle, toggle).call(this);
                }
                function toggle() {
                    (0, $4LHB0._)(this, _pinned, !(0, $057QZ._)(this, _pinned));
                    if ((0, $057QZ._)(this, _pinned)) {
                        (0, $lNbhr._)(this, _show, show).call(this);
                        (0, $057QZ._)(this, _container).addEventListener("click", (0, $057QZ._)(this, _boundToggle));
                        (0, $057QZ._)(this, _container).addEventListener("keydown", (0, $057QZ._)(this, _boundKeyDown));
                    } else {
                        (0, $lNbhr._)(this, _hide, hide).call(this);
                        (0, $057QZ._)(this, _container).removeEventListener("click", (0, $057QZ._)(this, _boundToggle));
                        (0, $057QZ._)(this, _container).removeEventListener("keydown", (0, $057QZ._)(this, _boundKeyDown));
                    }
                }
                function show() {
                    if (!(0, $057QZ._)(this, _popup)) this.render();
                    if (!this.isVisible) {
                        (0, $057QZ._)(this, _container).hidden = false;
                        (0, $057QZ._)(this, _container).style.zIndex = parseInt((0, $057QZ._)(this, _container).style.zIndex) + 1000;
                    } else if ((0, $057QZ._)(this, _pinned)) (0, $057QZ._)(this, _container).classList.add("focused");
                }
                function hide() {
                    (0, $057QZ._)(this, _container).classList.remove("focused");
                    if ((0, $057QZ._)(this, _pinned) || !this.isVisible) return;
                    (0, $057QZ._)(this, _container).hidden = true;
                    (0, $057QZ._)(this, _container).style.zIndex = parseInt((0, $057QZ._)(this, _container).style.zIndex) - 1000;
                }
                var FreeTextAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(FreeTextAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(FreeTextAnnotationElement);
                    function FreeTextAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, FreeTextAnnotationElement);
                        var _this;
                        _this = _super.call(this, parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        _this.textContent = parameters.data.textContent;
                        _this.textPosition = parameters.data.textPosition;
                        _this.annotationEditorType = _util.AnnotationEditorType.FREETEXT;
                        return _this;
                    }
                    (0, $8O2fV._)(FreeTextAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.classList.add("freeTextAnnotation");
                                if (this.textContent) {
                                    var content = document.createElement("div");
                                    content.classList.add("annotationTextContent");
                                    content.setAttribute("role", "comment");
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = this.textContent[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var line = _step.value;
                                            var lineSpan = document.createElement("span");
                                            lineSpan.textContent = line;
                                            content.append(lineSpan);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    this.container.append(content);
                                }
                                if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                                this._editOnDoubleClick();
                                return this.container;
                            }
                        }
                    ]);
                    return FreeTextAnnotationElement;
                }(AnnotationElement);
                exports.FreeTextAnnotationElement = FreeTextAnnotationElement;
                var _line = /*#__PURE__*/ new WeakMap();
                var LineAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(LineAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(LineAnnotationElement);
                    function LineAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, LineAnnotationElement);
                        var _this;
                        _this = _super.call(this, parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _line, {
                            writable: true,
                            value: null
                        });
                        return _this;
                    }
                    (0, $8O2fV._)(LineAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.classList.add("lineAnnotation");
                                var data = this.data;
                                var _getRectDims = getRectDims(data.rect), width = _getRectDims.width, height = _getRectDims.height;
                                var svg = this.svgFactory.create(width, height, true);
                                var line = (0, $4LHB0._)(this, _line, this.svgFactory.createElement("svg:line"));
                                line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
                                line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
                                line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
                                line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
                                line.setAttribute("stroke-width", data.borderStyle.width || 1);
                                line.setAttribute("stroke", "transparent");
                                line.setAttribute("fill", "transparent");
                                svg.append(line);
                                this.container.append(svg);
                                if (!data.popupRef && this.hasPopupData) this._createPopup();
                                return this.container;
                            }
                        },
                        {
                            key: "getElementsToTriggerPopup",
                            value: function getElementsToTriggerPopup() {
                                return (0, $057QZ._)(this, _line);
                            }
                        },
                        {
                            key: "addHighlightArea",
                            value: function addHighlightArea() {
                                this.container.classList.add("highlightArea");
                            }
                        }
                    ]);
                    return LineAnnotationElement;
                }(AnnotationElement);
                var _square = /*#__PURE__*/ new WeakMap();
                var SquareAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(SquareAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(SquareAnnotationElement);
                    function SquareAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, SquareAnnotationElement);
                        var _this;
                        _this = _super.call(this, parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _square, {
                            writable: true,
                            value: null
                        });
                        return _this;
                    }
                    (0, $8O2fV._)(SquareAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.classList.add("squareAnnotation");
                                var data = this.data;
                                var _getRectDims = getRectDims(data.rect), width = _getRectDims.width, height = _getRectDims.height;
                                var svg = this.svgFactory.create(width, height, true);
                                var borderWidth = data.borderStyle.width;
                                var square = (0, $4LHB0._)(this, _square, this.svgFactory.createElement("svg:rect"));
                                square.setAttribute("x", borderWidth / 2);
                                square.setAttribute("y", borderWidth / 2);
                                square.setAttribute("width", width - borderWidth);
                                square.setAttribute("height", height - borderWidth);
                                square.setAttribute("stroke-width", borderWidth || 1);
                                square.setAttribute("stroke", "transparent");
                                square.setAttribute("fill", "transparent");
                                svg.append(square);
                                this.container.append(svg);
                                if (!data.popupRef && this.hasPopupData) this._createPopup();
                                return this.container;
                            }
                        },
                        {
                            key: "getElementsToTriggerPopup",
                            value: function getElementsToTriggerPopup() {
                                return (0, $057QZ._)(this, _square);
                            }
                        },
                        {
                            key: "addHighlightArea",
                            value: function addHighlightArea() {
                                this.container.classList.add("highlightArea");
                            }
                        }
                    ]);
                    return SquareAnnotationElement;
                }(AnnotationElement);
                var _circle = /*#__PURE__*/ new WeakMap();
                var CircleAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(CircleAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(CircleAnnotationElement);
                    function CircleAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, CircleAnnotationElement);
                        var _this;
                        _this = _super.call(this, parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _circle, {
                            writable: true,
                            value: null
                        });
                        return _this;
                    }
                    (0, $8O2fV._)(CircleAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.classList.add("circleAnnotation");
                                var data = this.data;
                                var _getRectDims = getRectDims(data.rect), width = _getRectDims.width, height = _getRectDims.height;
                                var svg = this.svgFactory.create(width, height, true);
                                var borderWidth = data.borderStyle.width;
                                var circle = (0, $4LHB0._)(this, _circle, this.svgFactory.createElement("svg:ellipse"));
                                circle.setAttribute("cx", width / 2);
                                circle.setAttribute("cy", height / 2);
                                circle.setAttribute("rx", width / 2 - borderWidth / 2);
                                circle.setAttribute("ry", height / 2 - borderWidth / 2);
                                circle.setAttribute("stroke-width", borderWidth || 1);
                                circle.setAttribute("stroke", "transparent");
                                circle.setAttribute("fill", "transparent");
                                svg.append(circle);
                                this.container.append(svg);
                                if (!data.popupRef && this.hasPopupData) this._createPopup();
                                return this.container;
                            }
                        },
                        {
                            key: "getElementsToTriggerPopup",
                            value: function getElementsToTriggerPopup() {
                                return (0, $057QZ._)(this, _circle);
                            }
                        },
                        {
                            key: "addHighlightArea",
                            value: function addHighlightArea() {
                                this.container.classList.add("highlightArea");
                            }
                        }
                    ]);
                    return CircleAnnotationElement;
                }(AnnotationElement);
                var _polyline = /*#__PURE__*/ new WeakMap();
                var PolylineAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(PolylineAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(PolylineAnnotationElement);
                    function PolylineAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, PolylineAnnotationElement);
                        var _this;
                        _this = _super.call(this, parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _polyline, {
                            writable: true,
                            value: null
                        });
                        _this.containerClassName = "polylineAnnotation";
                        _this.svgElementName = "svg:polyline";
                        return _this;
                    }
                    (0, $8O2fV._)(PolylineAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.classList.add(this.containerClassName);
                                var data = this.data;
                                var _getRectDims = getRectDims(data.rect), width = _getRectDims.width, height = _getRectDims.height;
                                var svg = this.svgFactory.create(width, height, true);
                                var points = [];
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = data.vertices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var coordinate = _step.value;
                                        var x = coordinate.x - data.rect[0];
                                        var y = data.rect[3] - coordinate.y;
                                        points.push(x + "," + y);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                points = points.join(" ");
                                var polyline = (0, $4LHB0._)(this, _polyline, this.svgFactory.createElement(this.svgElementName));
                                polyline.setAttribute("points", points);
                                polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                                polyline.setAttribute("stroke", "transparent");
                                polyline.setAttribute("fill", "transparent");
                                svg.append(polyline);
                                this.container.append(svg);
                                if (!data.popupRef && this.hasPopupData) this._createPopup();
                                return this.container;
                            }
                        },
                        {
                            key: "getElementsToTriggerPopup",
                            value: function getElementsToTriggerPopup() {
                                return (0, $057QZ._)(this, _polyline);
                            }
                        },
                        {
                            key: "addHighlightArea",
                            value: function addHighlightArea() {
                                this.container.classList.add("highlightArea");
                            }
                        }
                    ]);
                    return PolylineAnnotationElement;
                }(AnnotationElement);
                var PolygonAnnotationElement = /*#__PURE__*/ function(PolylineAnnotationElement) {
                    (0, $kcqLc._)(PolygonAnnotationElement, PolylineAnnotationElement);
                    var _super = (0, $4jYWU._)(PolygonAnnotationElement);
                    function PolygonAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, PolygonAnnotationElement);
                        var _this;
                        _this = _super.call(this, parameters);
                        _this.containerClassName = "polygonAnnotation";
                        _this.svgElementName = "svg:polygon";
                        return _this;
                    }
                    return PolygonAnnotationElement;
                }(PolylineAnnotationElement);
                var CaretAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(CaretAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(CaretAnnotationElement);
                    function CaretAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, CaretAnnotationElement);
                        return _super.call(this, parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    (0, $8O2fV._)(CaretAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.classList.add("caretAnnotation");
                                if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                                return this.container;
                            }
                        }
                    ]);
                    return CaretAnnotationElement;
                }(AnnotationElement);
                var _polylines = /*#__PURE__*/ new WeakMap();
                var InkAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(InkAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(InkAnnotationElement);
                    function InkAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, InkAnnotationElement);
                        var _this;
                        _this = _super.call(this, parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _polylines, {
                            writable: true,
                            value: []
                        });
                        _this.containerClassName = "inkAnnotation";
                        _this.svgElementName = "svg:polyline";
                        _this.annotationEditorType = _util.AnnotationEditorType.INK;
                        return _this;
                    }
                    (0, $8O2fV._)(InkAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.classList.add(this.containerClassName);
                                var data = this.data;
                                var _getRectDims = getRectDims(data.rect), width = _getRectDims.width, height = _getRectDims.height;
                                var svg = this.svgFactory.create(width, height, true);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = data.inkLists[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var inkList = _step.value;
                                        var points = [];
                                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(var _iterator1 = inkList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                var coordinate = _step1.value;
                                                var x = coordinate.x - data.rect[0];
                                                var y = data.rect[3] - coordinate.y;
                                                points.push("".concat(x, ",").concat(y));
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                        points = points.join(" ");
                                        var polyline = this.svgFactory.createElement(this.svgElementName);
                                        (0, $057QZ._)(this, _polylines).push(polyline);
                                        polyline.setAttribute("points", points);
                                        polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                                        polyline.setAttribute("stroke", "transparent");
                                        polyline.setAttribute("fill", "transparent");
                                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                                        svg.append(polyline);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this.container.append(svg);
                                return this.container;
                            }
                        },
                        {
                            key: "getElementsToTriggerPopup",
                            value: function getElementsToTriggerPopup() {
                                return (0, $057QZ._)(this, _polylines);
                            }
                        },
                        {
                            key: "addHighlightArea",
                            value: function addHighlightArea() {
                                this.container.classList.add("highlightArea");
                            }
                        }
                    ]);
                    return InkAnnotationElement;
                }(AnnotationElement);
                exports.InkAnnotationElement = InkAnnotationElement;
                var HighlightAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(HighlightAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(HighlightAnnotationElement);
                    function HighlightAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, HighlightAnnotationElement);
                        return _super.call(this, parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    (0, $8O2fV._)(HighlightAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                                this.container.classList.add("highlightAnnotation");
                                return this.container;
                            }
                        }
                    ]);
                    return HighlightAnnotationElement;
                }(AnnotationElement);
                var UnderlineAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(UnderlineAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(UnderlineAnnotationElement);
                    function UnderlineAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, UnderlineAnnotationElement);
                        return _super.call(this, parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    (0, $8O2fV._)(UnderlineAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                                this.container.classList.add("underlineAnnotation");
                                return this.container;
                            }
                        }
                    ]);
                    return UnderlineAnnotationElement;
                }(AnnotationElement);
                var SquigglyAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(SquigglyAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(SquigglyAnnotationElement);
                    function SquigglyAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, SquigglyAnnotationElement);
                        return _super.call(this, parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    (0, $8O2fV._)(SquigglyAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                                this.container.classList.add("squigglyAnnotation");
                                return this.container;
                            }
                        }
                    ]);
                    return SquigglyAnnotationElement;
                }(AnnotationElement);
                var StrikeOutAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(StrikeOutAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(StrikeOutAnnotationElement);
                    function StrikeOutAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, StrikeOutAnnotationElement);
                        return _super.call(this, parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    (0, $8O2fV._)(StrikeOutAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                                this.container.classList.add("strikeoutAnnotation");
                                return this.container;
                            }
                        }
                    ]);
                    return StrikeOutAnnotationElement;
                }(AnnotationElement);
                var StampAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(StampAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(StampAnnotationElement);
                    function StampAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, StampAnnotationElement);
                        return _super.call(this, parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    (0, $8O2fV._)(StampAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                this.container.classList.add("stampAnnotation");
                                if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                                return this.container;
                            }
                        }
                    ]);
                    return StampAnnotationElement;
                }(AnnotationElement);
                exports.StampAnnotationElement = StampAnnotationElement;
                var _trigger = /*#__PURE__*/ new WeakMap(), _download = /*#__PURE__*/ new WeakSet();
                var FileAttachmentAnnotationElement = /*#__PURE__*/ function(AnnotationElement) {
                    (0, $kcqLc._)(FileAttachmentAnnotationElement, AnnotationElement);
                    var _super = (0, $4jYWU._)(FileAttachmentAnnotationElement);
                    function FileAttachmentAnnotationElement(parameters) {
                        (0, $5sFFs._)(this, FileAttachmentAnnotationElement);
                        var _this;
                        var _this_linkService_eventBus;
                        _this = _super.call(this, parameters, {
                            isRenderable: true
                        });
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _download);
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _trigger, {
                            writable: true,
                            value: null
                        });
                        var _this_data_file = _this.data.file, filename = _this_data_file.filename, content = _this_data_file.content;
                        _this.filename = (0, _display_utils.getFilenameFromUrl)(filename, true);
                        _this.content = content;
                        (_this_linkService_eventBus = _this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("fileattachmentannotation", {
                            source: (0, $lyFcw._)(_this),
                            filename: filename,
                            content: content
                        });
                        return _this;
                    }
                    (0, $8O2fV._)(FileAttachmentAnnotationElement, [
                        {
                            key: "render",
                            value: function render() {
                                var _this = this;
                                this.container.classList.add("fileAttachmentAnnotation");
                                var _this1 = this, container = _this1.container, data = _this1.data;
                                var trigger;
                                if (data.hasAppearance || data.fillAlpha === 0) trigger = document.createElement("div");
                                else {
                                    trigger = document.createElement("img");
                                    trigger.src = "".concat(this.imageResourcesPath, "annotation-").concat(/paperclip/i.test(data.name) ? "paperclip" : "pushpin", ".svg");
                                    if (data.fillAlpha && data.fillAlpha < 1) trigger.style = "filter: opacity(".concat(Math.round(data.fillAlpha * 100), "%);");
                                }
                                trigger.addEventListener("dblclick", (0, $lNbhr._)(this, _download, download).bind(this));
                                (0, $4LHB0._)(this, _trigger, trigger);
                                var isMac = _util.FeatureTest.platform.isMac;
                                container.addEventListener("keydown", function(evt) {
                                    if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) (0, $lNbhr._)(_this, _download, download).call(_this);
                                });
                                if (!data.popupRef && this.hasPopupData) this._createPopup();
                                else trigger.classList.add("popupTriggerArea");
                                container.append(trigger);
                                return container;
                            }
                        },
                        {
                            key: "getElementsToTriggerPopup",
                            value: function getElementsToTriggerPopup() {
                                return (0, $057QZ._)(this, _trigger);
                            }
                        },
                        {
                            key: "addHighlightArea",
                            value: function addHighlightArea() {
                                this.container.classList.add("highlightArea");
                            }
                        }
                    ]);
                    return FileAttachmentAnnotationElement;
                }(AnnotationElement);
                function download() {
                    var _this_downloadManager;
                    (_this_downloadManager = this.downloadManager) === null || _this_downloadManager === void 0 ? void 0 : _this_downloadManager.openOrDownloadData(this.container, this.content, this.filename);
                }
                var _accessibilityManager = /*#__PURE__*/ new WeakMap(), _annotationCanvasMap = /*#__PURE__*/ new WeakMap(), _editableAnnotations = /*#__PURE__*/ new WeakMap(), _appendElement = /*#__PURE__*/ new WeakSet(), _setAnnotationCanvasMap = /*#__PURE__*/ new WeakSet();
                var AnnotationLayer = /*#__PURE__*/ function() {
                    function AnnotationLayer(param) {
                        var div = param.div, accessibilityManager = param.accessibilityManager, annotationCanvasMap = param.annotationCanvasMap, l10n = param.l10n, page = param.page, viewport = param.viewport;
                        (0, $5sFFs._)(this, AnnotationLayer);
                        (0, $iB2CV._)(this, _appendElement);
                        (0, $iB2CV._)(this, _setAnnotationCanvasMap);
                        (0, $g12Hy._)(this, _accessibilityManager, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _annotationCanvasMap, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)(this, _editableAnnotations, {
                            writable: true,
                            value: new Map()
                        });
                        this.div = div;
                        (0, $4LHB0._)(this, _accessibilityManager, accessibilityManager);
                        (0, $4LHB0._)(this, _annotationCanvasMap, annotationCanvasMap);
                        this.l10n = l10n;
                        this.page = page;
                        this.viewport = viewport;
                        this.zIndex = 0;
                        this.l10n || (this.l10n = _displayL10n_utils.NullL10n);
                    }
                    (0, $8O2fV._)(AnnotationLayer, [
                        {
                            key: "render",
                            value: function render(params) {
                                var _this = this;
                                return (0, $7hBys._)(function() {
                                    var annotations, layer, popupToElements, elementParams, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, isPopupAnnotation, _getRectDims, width, height, elements, element, elements1, rendered;
                                    return (0, $ajhIL.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                annotations = params.annotations;
                                                layer = _this.div;
                                                (0, _display_utils.setLayerDimensions)(layer, _this.viewport);
                                                popupToElements = new Map();
                                                elementParams = {
                                                    data: null,
                                                    layer: layer,
                                                    linkService: params.linkService,
                                                    downloadManager: params.downloadManager,
                                                    imageResourcesPath: params.imageResourcesPath || "",
                                                    renderForms: params.renderForms !== false,
                                                    svgFactory: new _display_utils.DOMSVGFactory(),
                                                    annotationStorage: params.annotationStorage || new _annotation_storage.AnnotationStorage(),
                                                    enableScripting: params.enableScripting === true,
                                                    hasJSActions: params.hasJSActions,
                                                    fieldObjects: params.fieldObjects,
                                                    parent: _this,
                                                    elements: null
                                                };
                                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                try {
                                                    for(_iterator = annotations[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                        data = _step.value;
                                                        if (data.noHTML) continue;
                                                        isPopupAnnotation = data.annotationType === _util.AnnotationType.POPUP;
                                                        if (!isPopupAnnotation) {
                                                            _getRectDims = getRectDims(data.rect), width = _getRectDims.width, height = _getRectDims.height;
                                                            if (width <= 0 || height <= 0) continue;
                                                        } else {
                                                            elements = popupToElements.get(data.id);
                                                            if (!elements) continue;
                                                            elementParams.elements = elements;
                                                        }
                                                        elementParams.data = data;
                                                        element = AnnotationElementFactory.create(elementParams);
                                                        if (!element.isRenderable) continue;
                                                        if (!isPopupAnnotation && data.popupRef) {
                                                            elements1 = popupToElements.get(data.popupRef);
                                                            if (!elements1) popupToElements.set(data.popupRef, [
                                                                element
                                                            ]);
                                                            else elements1.push(element);
                                                        }
                                                        if (element.annotationEditorType > 0) (0, $057QZ._)(_this, _editableAnnotations).set(element.data.id, element);
                                                        rendered = element.render();
                                                        if (data.hidden) rendered.style.visibility = "hidden";
                                                        (0, $lNbhr._)(_this, _appendElement, appendElement).call(_this, rendered, data.id);
                                                    }
                                                } catch (err) {
                                                    _didIteratorError = true;
                                                    _iteratorError = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                            _iterator.return();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError) {
                                                            throw _iteratorError;
                                                        }
                                                    }
                                                }
                                                (0, $lNbhr._)(_this, _setAnnotationCanvasMap, setAnnotationCanvasMap).call(_this);
                                                return [
                                                    4,
                                                    _this.l10n.translate(layer)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }
                        },
                        {
                            key: "update",
                            value: function update(param) {
                                var viewport = param.viewport;
                                var layer = this.div;
                                this.viewport = viewport;
                                (0, _display_utils.setLayerDimensions)(layer, {
                                    rotation: viewport.rotation
                                });
                                (0, $lNbhr._)(this, _setAnnotationCanvasMap, setAnnotationCanvasMap).call(this);
                                layer.hidden = false;
                            }
                        },
                        {
                            key: "getEditableAnnotations",
                            value: function getEditableAnnotations() {
                                return Array.from((0, $057QZ._)(this, _editableAnnotations).values());
                            }
                        },
                        {
                            key: "getEditableAnnotation",
                            value: function getEditableAnnotation(id) {
                                return (0, $057QZ._)(this, _editableAnnotations).get(id);
                            }
                        }
                    ]);
                    return AnnotationLayer;
                }();
                function appendElement(element, id) {
                    var _$_class_private_field_get;
                    var contentElement = element.firstChild || element;
                    contentElement.id = "".concat(_util.AnnotationPrefix).concat(id);
                    this.div.append(element);
                    (_$_class_private_field_get = (0, $057QZ._)(this, _accessibilityManager)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.moveElementInDOM(this.div, element, contentElement, false);
                }
                function setAnnotationCanvasMap() {
                    if (!(0, $057QZ._)(this, _annotationCanvasMap)) return;
                    var layer = this.div;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = (0, $057QZ._)(this, _annotationCanvasMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $52tJv._)(_step.value, 2), id = _step_value[0], canvas = _step_value[1];
                            var element = layer.querySelector('[data-annotation-id="'.concat(id, '"]'));
                            if (!element) continue;
                            var firstChild = element.firstChild;
                            if (!firstChild) element.append(canvas);
                            else if (firstChild.nodeName === "CANVAS") firstChild.replaceWith(canvas);
                            else firstChild.before(canvas);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    (0, $057QZ._)(this, _annotationCanvasMap).clear();
                }
                exports.AnnotationLayer = AnnotationLayer;
            /***/ },
            /* 30 */ /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ColorConverters = void 0;
                function makeColorComp(n) {
                    return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
                }
                function scaleAndClamp(x) {
                    return Math.max(0, Math.min(255, 255 * x));
                }
                var ColorConverters = /*#__PURE__*/ function() {
                    function ColorConverters() {
                        (0, $5sFFs._)(this, ColorConverters);
                    }
                    (0, $8O2fV._)(ColorConverters, null, [
                        {
                            key: "CMYK_G",
                            value: function CMYK_G(param) {
                                var _param = (0, $52tJv._)(param, 4), c = _param[0], y = _param[1], m = _param[2], k = _param[3];
                                return [
                                    "G",
                                    1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
                                ];
                            }
                        },
                        {
                            key: "G_CMYK",
                            value: function G_CMYK(param) {
                                var _param = (0, $52tJv._)(param, 1), g = _param[0];
                                return [
                                    "CMYK",
                                    0,
                                    0,
                                    0,
                                    1 - g
                                ];
                            }
                        },
                        {
                            key: "G_RGB",
                            value: function G_RGB(param) {
                                var _param = (0, $52tJv._)(param, 1), g = _param[0];
                                return [
                                    "RGB",
                                    g,
                                    g,
                                    g
                                ];
                            }
                        },
                        {
                            key: "G_rgb",
                            value: function G_rgb(param) {
                                var _param = (0, $52tJv._)(param, 1), g = _param[0];
                                g = scaleAndClamp(g);
                                return [
                                    g,
                                    g,
                                    g
                                ];
                            }
                        },
                        {
                            key: "G_HTML",
                            value: function G_HTML(param) {
                                var _param = (0, $52tJv._)(param, 1), g = _param[0];
                                var G = makeColorComp(g);
                                return "#".concat(G).concat(G).concat(G);
                            }
                        },
                        {
                            key: "RGB_G",
                            value: function RGB_G(param) {
                                var _param = (0, $52tJv._)(param, 3), r = _param[0], g = _param[1], b = _param[2];
                                return [
                                    "G",
                                    0.3 * r + 0.59 * g + 0.11 * b
                                ];
                            }
                        },
                        {
                            key: "RGB_rgb",
                            value: function RGB_rgb(color) {
                                return color.map(scaleAndClamp);
                            }
                        },
                        {
                            key: "RGB_HTML",
                            value: function RGB_HTML(color) {
                                return "#".concat(color.map(makeColorComp).join(""));
                            }
                        },
                        {
                            key: "T_HTML",
                            value: function T_HTML() {
                                return "#00000000";
                            }
                        },
                        {
                            key: "T_rgb",
                            value: function T_rgb() {
                                return [
                                    null
                                ];
                            }
                        },
                        {
                            key: "CMYK_RGB",
                            value: function CMYK_RGB(param) {
                                var _param = (0, $52tJv._)(param, 4), c = _param[0], y = _param[1], m = _param[2], k = _param[3];
                                return [
                                    "RGB",
                                    1 - Math.min(1, c + k),
                                    1 - Math.min(1, m + k),
                                    1 - Math.min(1, y + k)
                                ];
                            }
                        },
                        {
                            key: "CMYK_rgb",
                            value: function CMYK_rgb(param) {
                                var _param = (0, $52tJv._)(param, 4), c = _param[0], y = _param[1], m = _param[2], k = _param[3];
                                return [
                                    scaleAndClamp(1 - Math.min(1, c + k)),
                                    scaleAndClamp(1 - Math.min(1, m + k)),
                                    scaleAndClamp(1 - Math.min(1, y + k))
                                ];
                            }
                        },
                        {
                            key: "CMYK_HTML",
                            value: function CMYK_HTML(components) {
                                var rgb = this.CMYK_RGB(components).slice(1);
                                return this.RGB_HTML(rgb);
                            }
                        },
                        {
                            key: "RGB_CMYK",
                            value: function RGB_CMYK(param) {
                                var _param = (0, $52tJv._)(param, 3), r = _param[0], g = _param[1], b = _param[2];
                                var c = 1 - r;
                                var m = 1 - g;
                                var y = 1 - b;
                                var k = Math.min(c, m, y);
                                return [
                                    "CMYK",
                                    c,
                                    m,
                                    y,
                                    k
                                ];
                            }
                        }
                    ]);
                    return ColorConverters;
                }();
                exports.ColorConverters = ColorConverters;
            /***/ },
            /* 31 */ /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NullL10n = void 0;
                exports.getL10nFallback = getL10nFallback;
                var DEFAULT_L10N_STRINGS = {
                    of_pages: "of {{pagesCount}}",
                    page_of_pages: "({{pageNumber}} of {{pagesCount}})",
                    document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
                    document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
                    document_properties_date_string: "{{date}}, {{time}}",
                    document_properties_page_size_unit_inches: "in",
                    document_properties_page_size_unit_millimeters: "mm",
                    document_properties_page_size_orientation_portrait: "portrait",
                    document_properties_page_size_orientation_landscape: "landscape",
                    document_properties_page_size_name_a3: "A3",
                    document_properties_page_size_name_a4: "A4",
                    document_properties_page_size_name_letter: "Letter",
                    document_properties_page_size_name_legal: "Legal",
                    document_properties_page_size_dimension_string: "{{width}} \xd7 {{height}} {{unit}} ({{orientation}})",
                    document_properties_page_size_dimension_name_string: "{{width}} \xd7 {{height}} {{unit}} ({{name}}, {{orientation}})",
                    document_properties_linearized_yes: "Yes",
                    document_properties_linearized_no: "No",
                    additional_layers: "Additional Layers",
                    page_landmark: "Page {{page}}",
                    thumb_page_title: "Page {{page}}",
                    thumb_page_canvas: "Thumbnail of Page {{page}}",
                    find_reached_top: "Reached top of document, continued from bottom",
                    find_reached_bottom: "Reached end of document, continued from top",
                    "find_match_count[one]": "{{current}} of {{total}} match",
                    "find_match_count[other]": "{{current}} of {{total}} matches",
                    "find_match_count_limit[one]": "More than {{limit}} match",
                    "find_match_count_limit[other]": "More than {{limit}} matches",
                    find_not_found: "Phrase not found",
                    page_scale_width: "Page Width",
                    page_scale_fit: "Page Fit",
                    page_scale_auto: "Automatic Zoom",
                    page_scale_actual: "Actual Size",
                    page_scale_percent: "{{scale}}%",
                    loading_error: "An error occurred while loading the PDF.",
                    invalid_file_error: "Invalid or corrupted PDF file.",
                    missing_file_error: "Missing PDF file.",
                    unexpected_response_error: "Unexpected server response.",
                    rendering_error: "An error occurred while rendering the page.",
                    annotation_date_string: "{{date}}, {{time}}",
                    printing_not_supported: "Warning: Printing is not fully supported by this browser.",
                    printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
                    web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
                    free_text2_default_content: "Start typing\u2026",
                    editor_free_text2_aria_label: "Text Editor",
                    editor_ink2_aria_label: "Draw Editor",
                    editor_ink_canvas_aria_label: "User-created image",
                    editor_alt_text_button_label: "Alt text",
                    editor_alt_text_edit_button_label: "Edit alt text",
                    editor_alt_text_decorative_tooltip: "Marked as decorative"
                };
                DEFAULT_L10N_STRINGS.print_progress_percent = "{{progress}}%";
                function getL10nFallback(key, args) {
                    switch(key){
                        case "find_match_count":
                            key = "find_match_count[".concat(args.total === 1 ? "one" : "other", "]");
                            break;
                        case "find_match_count_limit":
                            key = "find_match_count_limit[".concat(args.limit === 1 ? "one" : "other", "]");
                            break;
                    }
                    return DEFAULT_L10N_STRINGS[key] || "";
                }
                function formatL10nValue(text, args) {
                    if (!args) return text;
                    return text.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, function(all, name) {
                        return name in args ? args[name] : "{{" + name + "}}";
                    });
                }
                var NullL10n = {
                    getLanguage: function() {
                        return (0, $7hBys._)(function() {
                            return (0, $ajhIL.__generator)(this, function(_state) {
                                return [
                                    2,
                                    "en-us"
                                ];
                            });
                        })();
                    },
                    getDirection: function() {
                        return (0, $7hBys._)(function() {
                            return (0, $ajhIL.__generator)(this, function(_state) {
                                return [
                                    2,
                                    "ltr"
                                ];
                            });
                        })();
                    },
                    get: function(key) {
                        var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, fallback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : getL10nFallback(key, args);
                        return (0, $7hBys._)(function() {
                            return (0, $ajhIL.__generator)(this, function(_state) {
                                return [
                                    2,
                                    formatL10nValue(fallback, args)
                                ];
                            });
                        })();
                    },
                    translate: function(element) {
                        return (0, $7hBys._)(function() {
                            return (0, $ajhIL.__generator)(this, function(_state) {
                                return [
                                    2
                                ];
                            });
                        })();
                    }
                };
                exports.NullL10n = NullL10n;
            /***/ },
            /* 32 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaLayer = void 0;
                var _xfa_text = __w_pdfjs_require__(25);
                var XfaLayer = /*#__PURE__*/ function() {
                    function XfaLayer() {
                        (0, $5sFFs._)(this, XfaLayer);
                    }
                    (0, $8O2fV._)(XfaLayer, null, [
                        {
                            key: "setupStorage",
                            value: function setupStorage(html, id, element, storage, intent) {
                                var storedData = storage.getValue(id, {
                                    value: null
                                });
                                switch(element.name){
                                    case "textarea":
                                        if (storedData.value !== null) html.textContent = storedData.value;
                                        if (intent === "print") break;
                                        html.addEventListener("input", function(event) {
                                            storage.setValue(id, {
                                                value: event.target.value
                                            });
                                        });
                                        break;
                                    case "input":
                                        if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                                            if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                                            else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                                            if (intent === "print") break;
                                            html.addEventListener("change", function(event) {
                                                storage.setValue(id, {
                                                    value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                                                });
                                            });
                                        } else {
                                            if (storedData.value !== null) html.setAttribute("value", storedData.value);
                                            if (intent === "print") break;
                                            html.addEventListener("input", function(event) {
                                                storage.setValue(id, {
                                                    value: event.target.value
                                                });
                                            });
                                        }
                                        break;
                                    case "select":
                                        if (storedData.value !== null) {
                                            html.setAttribute("value", storedData.value);
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = element.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var option = _step.value;
                                                    if (option.attributes.value === storedData.value) option.attributes.selected = true;
                                                    else if (option.attributes.hasOwnProperty("selected")) delete option.attributes.selected;
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        }
                                        html.addEventListener("input", function(event) {
                                            var options = event.target.options;
                                            var value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                        });
                                        break;
                                }
                            }
                        },
                        {
                            key: "setAttributes",
                            value: function setAttributes(param) {
                                var html = param.html, element = param.element, _param_storage = param.storage, storage = _param_storage === void 0 ? null : _param_storage, intent = param.intent, linkService = param.linkService;
                                var attributes = element.attributes;
                                var isHTMLAnchorElement = html instanceof HTMLAnchorElement;
                                if (attributes.type === "radio") attributes.name = "".concat(attributes.name, "-").concat(intent);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = Object.entries(attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _step_value = (0, $52tJv._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                                        if (value === null || value === undefined) continue;
                                        switch(key){
                                            case "class":
                                                if (value.length) html.setAttribute(key, value.join(" "));
                                                break;
                                            case "dataId":
                                                break;
                                            case "id":
                                                html.setAttribute("data-element-id", value);
                                                break;
                                            case "style":
                                                Object.assign(html.style, value);
                                                break;
                                            case "textContent":
                                                html.textContent = value;
                                                break;
                                            default:
                                                if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") html.setAttribute(key, value);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (isHTMLAnchorElement) linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
                                if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
                            }
                        },
                        {
                            key: "render",
                            value: function render(parameters) {
                                var storage = parameters.annotationStorage;
                                var linkService = parameters.linkService;
                                var root = parameters.xfaHtml;
                                var intent = parameters.intent || "display";
                                var rootHtml = document.createElement(root.name);
                                if (root.attributes) this.setAttributes({
                                    html: rootHtml,
                                    element: root,
                                    intent: intent,
                                    linkService: linkService
                                });
                                var stack = [
                                    [
                                        root,
                                        -1,
                                        rootHtml
                                    ]
                                ];
                                var rootDiv = parameters.div;
                                rootDiv.append(rootHtml);
                                if (parameters.viewport) {
                                    var transform = "matrix(".concat(parameters.viewport.transform.join(","), ")");
                                    rootDiv.style.transform = transform;
                                }
                                if (intent !== "richText") rootDiv.setAttribute("class", "xfaLayer xfaFont");
                                var textDivs = [];
                                while(stack.length > 0){
                                    var _child_attributes;
                                    var _stack_at = (0, $52tJv._)(stack.at(-1), 3), parent = _stack_at[0], i = _stack_at[1], html = _stack_at[2];
                                    if (i + 1 === parent.children.length) {
                                        stack.pop();
                                        continue;
                                    }
                                    var child = parent.children[++stack.at(-1)[1]];
                                    if (child === null) continue;
                                    var name = child.name;
                                    if (name === "#text") {
                                        var node = document.createTextNode(child.value);
                                        textDivs.push(node);
                                        html.append(node);
                                        continue;
                                    }
                                    var childHtml = (child === null || child === void 0 ? void 0 : (_child_attributes = child.attributes) === null || _child_attributes === void 0 ? void 0 : _child_attributes.xmlns) ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
                                    html.append(childHtml);
                                    if (child.attributes) this.setAttributes({
                                        html: childHtml,
                                        element: child,
                                        storage: storage,
                                        intent: intent,
                                        linkService: linkService
                                    });
                                    if (child.children && child.children.length > 0) stack.push([
                                        child,
                                        -1,
                                        childHtml
                                    ]);
                                    else if (child.value) {
                                        var node1 = document.createTextNode(child.value);
                                        if (_xfa_text.XfaText.shouldBuildText(name)) textDivs.push(node1);
                                        childHtml.append(node1);
                                    }
                                }
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var el = _step.value;
                                        el.setAttribute("readOnly", true);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return {
                                    textDivs: textDivs
                                };
                            }
                        },
                        {
                            key: "update",
                            value: function update(parameters) {
                                var transform = "matrix(".concat(parameters.viewport.transform.join(","), ")");
                                parameters.div.style.transform = transform;
                                parameters.div.hidden = false;
                            }
                        }
                    ]);
                    return XfaLayer;
                }();
                exports.XfaLayer = XfaLayer;
            /***/ },
            /* 33 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.InkEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _annotation_layer = __w_pdfjs_require__(29);
                var _display_utils = __w_pdfjs_require__(6);
                var _tools = __w_pdfjs_require__(5);
                var _baseHeight = /*#__PURE__*/ new WeakMap(), _baseWidth = /*#__PURE__*/ new WeakMap(), _boundCanvasPointermove = /*#__PURE__*/ new WeakMap(), _boundCanvasPointerleave = /*#__PURE__*/ new WeakMap(), _boundCanvasPointerup = /*#__PURE__*/ new WeakMap(), _boundCanvasPointerdown = /*#__PURE__*/ new WeakMap(), _currentPath2D = /*#__PURE__*/ new WeakMap(), _disableEditing = /*#__PURE__*/ new WeakMap(), _hasSomethingToDraw = /*#__PURE__*/ new WeakMap(), _isCanvasInitialized = /*#__PURE__*/ new WeakMap(), _observer = /*#__PURE__*/ new WeakMap(), _realWidth = /*#__PURE__*/ new WeakMap(), _realHeight = /*#__PURE__*/ new WeakMap(), _requestFrameCallback = /*#__PURE__*/ new WeakMap(), _editor_AnnotationEditor, _updateThickness = /*#__PURE__*/ new WeakSet(), _updateColor = /*#__PURE__*/ new WeakSet(), _updateOpacity = /*#__PURE__*/ new WeakSet(), _getInitialBBox = /*#__PURE__*/ new WeakSet(), _setStroke = /*#__PURE__*/ new WeakSet(), _startDrawing = /*#__PURE__*/ new WeakSet(), _draw = /*#__PURE__*/ new WeakSet(), _endPath = /*#__PURE__*/ new WeakSet(), _stopDrawing = /*#__PURE__*/ new WeakSet(), _drawPoints = /*#__PURE__*/ new WeakSet(), _makeBezierCurve = /*#__PURE__*/ new WeakSet(), _generateBezierPoints = /*#__PURE__*/ new WeakSet(), _redraw = /*#__PURE__*/ new WeakSet(), _endDrawing = /*#__PURE__*/ new WeakSet(), _createCanvas = /*#__PURE__*/ new WeakSet(), _createObserver = /*#__PURE__*/ new WeakSet(), _setCanvasDims = /*#__PURE__*/ new WeakSet(), _setScaleFactor = /*#__PURE__*/ new WeakSet(), _updateTransform = /*#__PURE__*/ new WeakSet(), _serializePaths = /*#__PURE__*/ new WeakSet(), _getBbox = /*#__PURE__*/ new WeakSet(), _getPadding = /*#__PURE__*/ new WeakSet(), _fitToContent = /*#__PURE__*/ new WeakSet();
                var InkEditor = /*#__PURE__*/ function(_superClass) {
                    (0, $kcqLc._)(InkEditor, _superClass);
                    var _super = (0, $4jYWU._)(InkEditor);
                    function InkEditor(params) {
                        (0, $5sFFs._)(this, InkEditor);
                        var _this;
                        _this = _super.call(this, (0, $bqLxK._)((0, $lwFY2._)({}, params), {
                            name: "inkEditor"
                        }));
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _updateThickness);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _updateColor);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _updateOpacity);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _getInitialBBox);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _setStroke);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _startDrawing);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _draw);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _endPath);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _stopDrawing);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _drawPoints);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _makeBezierCurve);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _generateBezierPoints);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _redraw);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _endDrawing);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _createCanvas);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _createObserver);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _setCanvasDims);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _setScaleFactor);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _updateTransform);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _serializePaths);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _getBbox);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _getPadding);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _fitToContent);
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _baseHeight, {
                            writable: true,
                            value: 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _baseWidth, {
                            writable: true,
                            value: 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _boundCanvasPointermove, {
                            writable: true,
                            value: _this.canvasPointermove.bind((0, $lyFcw._)(_this))
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _boundCanvasPointerleave, {
                            writable: true,
                            value: _this.canvasPointerleave.bind((0, $lyFcw._)(_this))
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _boundCanvasPointerup, {
                            writable: true,
                            value: _this.canvasPointerup.bind((0, $lyFcw._)(_this))
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _boundCanvasPointerdown, {
                            writable: true,
                            value: _this.canvasPointerdown.bind((0, $lyFcw._)(_this))
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _currentPath2D, {
                            writable: true,
                            value: new Path2D()
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _disableEditing, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _hasSomethingToDraw, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _isCanvasInitialized, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _observer, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _realWidth, {
                            writable: true,
                            value: 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _realHeight, {
                            writable: true,
                            value: 0
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _requestFrameCallback, {
                            writable: true,
                            value: null
                        });
                        _this.color = params.color || null;
                        _this.thickness = params.thickness || null;
                        _this.opacity = params.opacity || null;
                        _this.paths = [];
                        _this.bezierPath2D = [];
                        _this.allRawPaths = [];
                        _this.currentPath = [];
                        _this.scaleFactor = 1;
                        _this.translationX = _this.translationY = 0;
                        _this.x = 0;
                        _this.y = 0;
                        _this._willKeepAspectRatio = true;
                        return _this;
                    }
                    (0, $8O2fV._)(InkEditor, [
                        {
                            key: "updateParams",
                            value: function updateParams(type, value) {
                                switch(type){
                                    case _util.AnnotationEditorParamsType.INK_THICKNESS:
                                        (0, $lNbhr._)(this, _updateThickness, updateThickness).call(this, value);
                                        break;
                                    case _util.AnnotationEditorParamsType.INK_COLOR:
                                        (0, $lNbhr._)(this, _updateColor, updateColor).call(this, value);
                                        break;
                                    case _util.AnnotationEditorParamsType.INK_OPACITY:
                                        (0, $lNbhr._)(this, _updateOpacity, updateOpacity).call(this, value);
                                        break;
                                }
                            }
                        },
                        {
                            key: "propertiesToUpdate",
                            get: function get() {
                                var _this_opacity;
                                return [
                                    [
                                        _util.AnnotationEditorParamsType.INK_THICKNESS,
                                        this.thickness || InkEditor._defaultThickness
                                    ],
                                    [
                                        _util.AnnotationEditorParamsType.INK_COLOR,
                                        this.color || InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                                    ],
                                    [
                                        _util.AnnotationEditorParamsType.INK_OPACITY,
                                        Math.round(100 * ((_this_opacity = this.opacity) !== null && _this_opacity !== void 0 ? _this_opacity : InkEditor._defaultOpacity))
                                    ]
                                ];
                            }
                        },
                        {
                            key: "rebuild",
                            value: function rebuild() {
                                if (!this.parent) return;
                                (0, $404BM._)((0, $cEF31._)(InkEditor.prototype), "rebuild", this).call(this);
                                if (this.div === null) return;
                                if (!this.canvas) {
                                    (0, $lNbhr._)(this, _createCanvas, createCanvas).call(this);
                                    (0, $lNbhr._)(this, _createObserver, createObserver).call(this);
                                }
                                if (!this.isAttachedToDOM) {
                                    this.parent.add(this);
                                    (0, $lNbhr._)(this, _setCanvasDims, setCanvasDims).call(this);
                                }
                                (0, $lNbhr._)(this, _fitToContent, fitToContent).call(this);
                            }
                        },
                        {
                            key: "remove",
                            value: function remove() {
                                if (this.canvas === null) return;
                                if (!this.isEmpty()) this.commit();
                                this.canvas.width = this.canvas.height = 0;
                                this.canvas.remove();
                                this.canvas = null;
                                (0, $057QZ._)(this, _observer).disconnect();
                                (0, $4LHB0._)(this, _observer, null);
                                (0, $404BM._)((0, $cEF31._)(InkEditor.prototype), "remove", this).call(this);
                            }
                        },
                        {
                            key: "setParent",
                            value: function setParent(parent) {
                                if (!this.parent && parent) this._uiManager.removeShouldRescale(this);
                                else if (this.parent && parent === null) this._uiManager.addShouldRescale(this);
                                (0, $404BM._)((0, $cEF31._)(InkEditor.prototype), "setParent", this).call(this, parent);
                            }
                        },
                        {
                            key: "onScaleChanging",
                            value: function onScaleChanging() {
                                var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                                var width = this.width * parentWidth;
                                var height = this.height * parentHeight;
                                this.setDimensions(width, height);
                            }
                        },
                        {
                            key: "enableEditMode",
                            value: function enableEditMode() {
                                if ((0, $057QZ._)(this, _disableEditing) || this.canvas === null) return;
                                (0, $404BM._)((0, $cEF31._)(InkEditor.prototype), "enableEditMode", this).call(this);
                                this._isDraggable = false;
                                this.canvas.addEventListener("pointerdown", (0, $057QZ._)(this, _boundCanvasPointerdown));
                            }
                        },
                        {
                            key: "disableEditMode",
                            value: function disableEditMode() {
                                if (!this.isInEditMode() || this.canvas === null) return;
                                (0, $404BM._)((0, $cEF31._)(InkEditor.prototype), "disableEditMode", this).call(this);
                                this._isDraggable = !this.isEmpty();
                                this.div.classList.remove("editing");
                                this.canvas.removeEventListener("pointerdown", (0, $057QZ._)(this, _boundCanvasPointerdown));
                            }
                        },
                        {
                            key: "onceAdded",
                            value: function onceAdded() {
                                this._isDraggable = !this.isEmpty();
                            }
                        },
                        {
                            key: "isEmpty",
                            value: function isEmpty() {
                                return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
                            }
                        },
                        {
                            key: "commit",
                            value: function commit() {
                                if ((0, $057QZ._)(this, _disableEditing)) return;
                                (0, $404BM._)((0, $cEF31._)(InkEditor.prototype), "commit", this).call(this);
                                this.isEditing = false;
                                this.disableEditMode();
                                this.setInForeground();
                                (0, $4LHB0._)(this, _disableEditing, true);
                                this.div.classList.add("disabled");
                                (0, $lNbhr._)(this, _fitToContent, fitToContent).call(this, true);
                                this.makeResizable();
                                this.parent.addInkEditorIfNeeded(true);
                                this.moveInDOM();
                                this.div.focus({
                                    preventScroll: true
                                });
                            }
                        },
                        {
                            key: "focusin",
                            value: function focusin(event) {
                                if (!this._focusEventsAllowed) return;
                                (0, $404BM._)((0, $cEF31._)(InkEditor.prototype), "focusin", this).call(this, event);
                                this.enableEditMode();
                            }
                        },
                        {
                            key: "canvasPointerdown",
                            value: function canvasPointerdown(event) {
                                if (event.button !== 0 || !this.isInEditMode() || (0, $057QZ._)(this, _disableEditing)) return;
                                this.setInForeground();
                                event.preventDefault();
                                if (event.type !== "mouse") this.div.focus();
                                (0, $lNbhr._)(this, _startDrawing, startDrawing).call(this, event.offsetX, event.offsetY);
                            }
                        },
                        {
                            key: "canvasPointermove",
                            value: function canvasPointermove(event) {
                                event.preventDefault();
                                (0, $lNbhr._)(this, _draw, draw).call(this, event.offsetX, event.offsetY);
                            }
                        },
                        {
                            key: "canvasPointerup",
                            value: function canvasPointerup(event) {
                                event.preventDefault();
                                (0, $lNbhr._)(this, _endDrawing, endDrawing).call(this, event);
                            }
                        },
                        {
                            key: "canvasPointerleave",
                            value: function canvasPointerleave(event) {
                                (0, $lNbhr._)(this, _endDrawing, endDrawing).call(this, event);
                            }
                        },
                        {
                            key: "isResizable",
                            get: function get() {
                                return !this.isEmpty() && (0, $057QZ._)(this, _disableEditing);
                            }
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this = this;
                                if (this.div) return this.div;
                                var baseX, baseY;
                                if (this.width) {
                                    baseX = this.x;
                                    baseY = this.y;
                                }
                                (0, $404BM._)((0, $cEF31._)(InkEditor.prototype), "render", this).call(this);
                                _editor.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then(function(msg) {
                                    var _this_div;
                                    return (_this_div = _this.div) === null || _this_div === void 0 ? void 0 : _this_div.setAttribute("aria-label", msg);
                                });
                                var _class_private_method_get_call = (0, $52tJv._)((0, $lNbhr._)(this, _getInitialBBox, getInitialBBox).call(this), 4), x = _class_private_method_get_call[0], y = _class_private_method_get_call[1], w = _class_private_method_get_call[2], h = _class_private_method_get_call[3];
                                this.setAt(x, y, 0, 0);
                                this.setDims(w, h);
                                (0, $lNbhr._)(this, _createCanvas, createCanvas).call(this);
                                if (this.width) {
                                    var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                                    this.setAspectRatio(this.width * parentWidth, this.height * parentHeight);
                                    this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                                    (0, $4LHB0._)(this, _isCanvasInitialized, true);
                                    (0, $lNbhr._)(this, _setCanvasDims, setCanvasDims).call(this);
                                    this.setDims(this.width * parentWidth, this.height * parentHeight);
                                    (0, $lNbhr._)(this, _redraw, redraw).call(this);
                                    this.div.classList.add("disabled");
                                } else {
                                    this.div.classList.add("editing");
                                    this.enableEditMode();
                                }
                                (0, $lNbhr._)(this, _createObserver, createObserver).call(this);
                                return this.div;
                            }
                        },
                        {
                            key: "setDimensions",
                            value: function setDimensions(width, height) {
                                var roundedWidth = Math.round(width);
                                var roundedHeight = Math.round(height);
                                if ((0, $057QZ._)(this, _realWidth) === roundedWidth && (0, $057QZ._)(this, _realHeight) === roundedHeight) return;
                                (0, $4LHB0._)(this, _realWidth, roundedWidth);
                                (0, $4LHB0._)(this, _realHeight, roundedHeight);
                                this.canvas.style.visibility = "hidden";
                                var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                                this.width = width / parentWidth;
                                this.height = height / parentHeight;
                                this.fixAndSetPosition();
                                if ((0, $057QZ._)(this, _disableEditing)) (0, $lNbhr._)(this, _setScaleFactor, setScaleFactor).call(this, width, height);
                                (0, $lNbhr._)(this, _setCanvasDims, setCanvasDims).call(this);
                                (0, $lNbhr._)(this, _redraw, redraw).call(this);
                                this.canvas.style.visibility = "visible";
                                this.fixDims();
                            }
                        },
                        {
                            key: "serialize",
                            value: function serialize() {
                                if (this.isEmpty()) return null;
                                var rect = this.getRect(0, 0);
                                var color = _editor.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                                return {
                                    annotationType: _util.AnnotationEditorType.INK,
                                    color: color,
                                    thickness: this.thickness,
                                    opacity: this.opacity,
                                    paths: (0, $lNbhr._)(this, _serializePaths, serializePaths).call(this, this.scaleFactor / this.parentScale, this.translationX, this.translationY, rect),
                                    pageIndex: this.pageIndex,
                                    rect: rect,
                                    rotation: this.rotation,
                                    structTreeParentId: this._structTreeParentId
                                };
                            }
                        }
                    ], [
                        {
                            key: "initialize",
                            value: function initialize(l10n) {
                                _editor.AnnotationEditor.initialize(l10n, {
                                    strings: [
                                        "editor_ink_canvas_aria_label",
                                        "editor_ink2_aria_label"
                                    ]
                                });
                            }
                        },
                        {
                            key: "updateDefaultParams",
                            value: function updateDefaultParams(type, value) {
                                switch(type){
                                    case _util.AnnotationEditorParamsType.INK_THICKNESS:
                                        InkEditor._defaultThickness = value;
                                        break;
                                    case _util.AnnotationEditorParamsType.INK_COLOR:
                                        InkEditor._defaultColor = value;
                                        break;
                                    case _util.AnnotationEditorParamsType.INK_OPACITY:
                                        InkEditor._defaultOpacity = value / 100;
                                        break;
                                }
                            }
                        },
                        {
                            key: "defaultPropertiesToUpdate",
                            get: function get() {
                                return [
                                    [
                                        _util.AnnotationEditorParamsType.INK_THICKNESS,
                                        InkEditor._defaultThickness
                                    ],
                                    [
                                        _util.AnnotationEditorParamsType.INK_COLOR,
                                        InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                                    ],
                                    [
                                        _util.AnnotationEditorParamsType.INK_OPACITY,
                                        Math.round(InkEditor._defaultOpacity * 100)
                                    ]
                                ];
                            }
                        },
                        {
                            key: "deserialize",
                            value: function deserialize(data, parent, uiManager) {
                                var _util_Util;
                                if (data instanceof _annotation_layer.InkAnnotationElement) return null;
                                var editor = (0, $404BM._)((0, $cEF31._)(InkEditor), "deserialize", this).call(this, data, parent, uiManager);
                                editor.thickness = data.thickness;
                                editor.color = (_util_Util = _util.Util).makeHexColor.apply(_util_Util, (0, $fyztb._)(data.color));
                                editor.opacity = data.opacity;
                                var _editor_pageDimensions = (0, $52tJv._)(editor.pageDimensions, 2), pageWidth = _editor_pageDimensions[0], pageHeight = _editor_pageDimensions[1];
                                var width = editor.width * pageWidth;
                                var height = editor.height * pageHeight;
                                var scaleFactor = editor.parentScale;
                                var padding = data.thickness / 2;
                                (0, $4LHB0._)(editor, _disableEditing, true);
                                (0, $4LHB0._)(editor, _realWidth, Math.round(width));
                                (0, $4LHB0._)(editor, _realHeight, Math.round(height));
                                var paths = data.paths, rect = data.rect, rotation = data.rotation;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var bezier = _step.value.bezier;
                                        bezier = (0, $9hJkT._)(InkEditor, InkEditor, fromPDFCoordinates).call(InkEditor, bezier, rect, rotation);
                                        var path = [];
                                        editor.paths.push(path);
                                        var p0 = scaleFactor * (bezier[0] - padding);
                                        var p1 = scaleFactor * (bezier[1] - padding);
                                        for(var i = 2, ii = bezier.length; i < ii; i += 6){
                                            var p10 = scaleFactor * (bezier[i] - padding);
                                            var p11 = scaleFactor * (bezier[i + 1] - padding);
                                            var p20 = scaleFactor * (bezier[i + 2] - padding);
                                            var p21 = scaleFactor * (bezier[i + 3] - padding);
                                            var p30 = scaleFactor * (bezier[i + 4] - padding);
                                            var p31 = scaleFactor * (bezier[i + 5] - padding);
                                            path.push([
                                                [
                                                    p0,
                                                    p1
                                                ],
                                                [
                                                    p10,
                                                    p11
                                                ],
                                                [
                                                    p20,
                                                    p21
                                                ],
                                                [
                                                    p30,
                                                    p31
                                                ]
                                            ]);
                                            p0 = p30;
                                            p1 = p31;
                                        }
                                        var path2D = (0, $9hJkT._)(this, InkEditor, buildPath2D).call(InkEditor, path);
                                        editor.bezierPath2D.push(path2D);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                var bbox = (0, $lNbhr._)(editor, _getBbox, getBbox).call(editor);
                                (0, $4LHB0._)(editor, _baseWidth, Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]));
                                (0, $4LHB0._)(editor, _baseHeight, Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]));
                                (0, $lNbhr._)(editor, _setScaleFactor, setScaleFactor).call(editor, width, height);
                                return editor;
                            }
                        }
                    ]);
                    return InkEditor;
                }(_editor_AnnotationEditor = _editor.AnnotationEditor);
                (0, $iCQyW._)(InkEditor, "_defaultColor", null);
                (0, $iCQyW._)(InkEditor, "_defaultOpacity", 1);
                (0, $iCQyW._)(InkEditor, "_defaultThickness", 1);
                (0, $iCQyW._)(InkEditor, "_type", "ink");
                function updateThickness(thickness) {
                    var _this = this;
                    var savedThickness = this.thickness;
                    this.addCommands({
                        cmd: function() {
                            _this.thickness = thickness;
                            (0, $lNbhr._)(_this, _fitToContent, fitToContent).call(_this);
                        },
                        undo: function() {
                            _this.thickness = savedThickness;
                            (0, $lNbhr._)(_this, _fitToContent, fitToContent).call(_this);
                        },
                        mustExec: true,
                        type: _util.AnnotationEditorParamsType.INK_THICKNESS,
                        overwriteIfSameType: true,
                        keepUndo: true
                    });
                }
                function updateColor(color) {
                    var _this = this;
                    var savedColor = this.color;
                    this.addCommands({
                        cmd: function() {
                            _this.color = color;
                            (0, $lNbhr._)(_this, _redraw, redraw).call(_this);
                        },
                        undo: function() {
                            _this.color = savedColor;
                            (0, $lNbhr._)(_this, _redraw, redraw).call(_this);
                        },
                        mustExec: true,
                        type: _util.AnnotationEditorParamsType.INK_COLOR,
                        overwriteIfSameType: true,
                        keepUndo: true
                    });
                }
                function updateOpacity(opacity) {
                    var _this = this;
                    opacity /= 100;
                    var savedOpacity = this.opacity;
                    this.addCommands({
                        cmd: function() {
                            _this.opacity = opacity;
                            (0, $lNbhr._)(_this, _redraw, redraw).call(_this);
                        },
                        undo: function() {
                            _this.opacity = savedOpacity;
                            (0, $lNbhr._)(_this, _redraw, redraw).call(_this);
                        },
                        mustExec: true,
                        type: _util.AnnotationEditorParamsType.INK_OPACITY,
                        overwriteIfSameType: true,
                        keepUndo: true
                    });
                }
                function getInitialBBox() {
                    var _this = this, parentRotation = _this.parentRotation, _this_parentDimensions = (0, $52tJv._)(_this.parentDimensions, 2), width = _this_parentDimensions[0], height = _this_parentDimensions[1];
                    switch(parentRotation){
                        case 90:
                            return [
                                0,
                                height,
                                height,
                                width
                            ];
                        case 180:
                            return [
                                width,
                                height,
                                width,
                                height
                            ];
                        case 270:
                            return [
                                width,
                                0,
                                height,
                                width
                            ];
                        default:
                            return [
                                0,
                                0,
                                width,
                                height
                            ];
                    }
                }
                function setStroke() {
                    var _this = this, ctx = _this.ctx, color = _this.color, opacity = _this.opacity, thickness = _this.thickness, parentScale = _this.parentScale, scaleFactor = _this.scaleFactor;
                    ctx.lineWidth = thickness * parentScale / scaleFactor;
                    ctx.lineCap = "round";
                    ctx.lineJoin = "round";
                    ctx.miterLimit = 10;
                    ctx.strokeStyle = "".concat(color).concat((0, _tools.opacityToHex)(opacity));
                }
                function startDrawing(x, y) {
                    var _this = this;
                    this.canvas.addEventListener("contextmenu", _display_utils.noContextMenu);
                    this.canvas.addEventListener("pointerleave", (0, $057QZ._)(this, _boundCanvasPointerleave));
                    this.canvas.addEventListener("pointermove", (0, $057QZ._)(this, _boundCanvasPointermove));
                    this.canvas.addEventListener("pointerup", (0, $057QZ._)(this, _boundCanvasPointerup));
                    this.canvas.removeEventListener("pointerdown", (0, $057QZ._)(this, _boundCanvasPointerdown));
                    this.isEditing = true;
                    if (!(0, $057QZ._)(this, _isCanvasInitialized)) {
                        (0, $4LHB0._)(this, _isCanvasInitialized, true);
                        (0, $lNbhr._)(this, _setCanvasDims, setCanvasDims).call(this);
                        this.thickness || (this.thickness = InkEditor._defaultThickness);
                        this.color || (this.color = InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor);
                        var _this_opacity;
                        (_this_opacity = this.opacity) !== null && _this_opacity !== void 0 ? _this_opacity : this.opacity = InkEditor._defaultOpacity;
                    }
                    this.currentPath.push([
                        x,
                        y
                    ]);
                    (0, $4LHB0._)(this, _hasSomethingToDraw, false);
                    (0, $lNbhr._)(this, _setStroke, setStroke).call(this);
                    (0, $4LHB0._)(this, _requestFrameCallback, function() {
                        (0, $lNbhr._)(_this, _drawPoints, drawPoints).call(_this);
                        if ((0, $057QZ._)(_this, _requestFrameCallback)) window.requestAnimationFrame((0, $057QZ._)(_this, _requestFrameCallback));
                    });
                    window.requestAnimationFrame((0, $057QZ._)(this, _requestFrameCallback));
                }
                function draw(x, y) {
                    var _$_class_private_method_get;
                    var _this_currentPath_at = (0, $52tJv._)(this.currentPath.at(-1), 2), lastX = _this_currentPath_at[0], lastY = _this_currentPath_at[1];
                    if (this.currentPath.length > 1 && x === lastX && y === lastY) return;
                    var currentPath = this.currentPath;
                    var path2D = (0, $057QZ._)(this, _currentPath2D);
                    currentPath.push([
                        x,
                        y
                    ]);
                    (0, $4LHB0._)(this, _hasSomethingToDraw, true);
                    if (currentPath.length <= 2) {
                        var _path2D;
                        (_path2D = path2D).moveTo.apply(_path2D, (0, $fyztb._)(currentPath[0]));
                        path2D.lineTo(x, y);
                        return;
                    }
                    if (currentPath.length === 3) {
                        var _path2D1;
                        (0, $4LHB0._)(this, _currentPath2D, path2D = new Path2D());
                        (_path2D1 = path2D).moveTo.apply(_path2D1, (0, $fyztb._)(currentPath[0]));
                    }
                    (_$_class_private_method_get = (0, $lNbhr._)(this, _makeBezierCurve, makeBezierCurve)).call.apply(_$_class_private_method_get, [
                        this,
                        path2D
                    ].concat((0, $fyztb._)(currentPath.at(-3)), (0, $fyztb._)(currentPath.at(-2)), [
                        x,
                        y
                    ]));
                }
                function endPath() {
                    var _$_class_private_field_get;
                    if (this.currentPath.length === 0) return;
                    var lastPoint = this.currentPath.at(-1);
                    (_$_class_private_field_get = (0, $057QZ._)(this, _currentPath2D)).lineTo.apply(_$_class_private_field_get, (0, $fyztb._)(lastPoint));
                }
                function stopDrawing(x, y) {
                    var _this = this;
                    (0, $4LHB0._)(this, _requestFrameCallback, null);
                    x = Math.min(Math.max(x, 0), this.canvas.width);
                    y = Math.min(Math.max(y, 0), this.canvas.height);
                    (0, $lNbhr._)(this, _draw, draw).call(this, x, y);
                    (0, $lNbhr._)(this, _endPath, endPath).call(this);
                    var bezier;
                    if (this.currentPath.length !== 1) bezier = (0, $lNbhr._)(this, _generateBezierPoints, generateBezierPoints).call(this);
                    else {
                        var xy = [
                            x,
                            y
                        ];
                        bezier = [
                            [
                                xy,
                                xy.slice(),
                                xy.slice(),
                                xy
                            ]
                        ];
                    }
                    var path2D = (0, $057QZ._)(this, _currentPath2D);
                    var currentPath = this.currentPath;
                    this.currentPath = [];
                    (0, $4LHB0._)(this, _currentPath2D, new Path2D());
                    var cmd = function() {
                        _this.allRawPaths.push(currentPath);
                        _this.paths.push(bezier);
                        _this.bezierPath2D.push(path2D);
                        _this.rebuild();
                    };
                    var undo = function() {
                        _this.allRawPaths.pop();
                        _this.paths.pop();
                        _this.bezierPath2D.pop();
                        if (_this.paths.length === 0) _this.remove();
                        else {
                            if (!_this.canvas) {
                                (0, $lNbhr._)(_this, _createCanvas, createCanvas).call(_this);
                                (0, $lNbhr._)(_this, _createObserver, createObserver).call(_this);
                            }
                            (0, $lNbhr._)(_this, _fitToContent, fitToContent).call(_this);
                        }
                    };
                    this.addCommands({
                        cmd: cmd,
                        undo: undo,
                        mustExec: true
                    });
                }
                function drawPoints() {
                    var _Math, _Math1, _Math2, _Math3;
                    if (!(0, $057QZ._)(this, _hasSomethingToDraw)) return;
                    (0, $4LHB0._)(this, _hasSomethingToDraw, false);
                    var thickness = Math.ceil(this.thickness * this.parentScale);
                    var lastPoints = this.currentPath.slice(-3);
                    var x = lastPoints.map(function(xy) {
                        return xy[0];
                    });
                    var y = lastPoints.map(function(xy) {
                        return xy[1];
                    });
                    var xMin = (_Math = Math).min.apply(_Math, (0, $fyztb._)(x)) - thickness;
                    var xMax = (_Math1 = Math).max.apply(_Math1, (0, $fyztb._)(x)) + thickness;
                    var yMin = (_Math2 = Math).min.apply(_Math2, (0, $fyztb._)(y)) - thickness;
                    var yMax = (_Math3 = Math).max.apply(_Math3, (0, $fyztb._)(y)) + thickness;
                    var ctx = this.ctx;
                    ctx.save();
                    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.bezierPath2D[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var path = _step.value;
                            ctx.stroke(path);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    ctx.stroke((0, $057QZ._)(this, _currentPath2D));
                    ctx.restore();
                }
                function makeBezierCurve(path2D, x0, y0, x1, y1, x2, y2) {
                    var prevX = (x0 + x1) / 2;
                    var prevY = (y0 + y1) / 2;
                    var x3 = (x1 + x2) / 2;
                    var y3 = (y1 + y2) / 2;
                    path2D.bezierCurveTo(prevX + 2 * (x1 - prevX) / 3, prevY + 2 * (y1 - prevY) / 3, x3 + 2 * (x1 - x3) / 3, y3 + 2 * (y1 - y3) / 3, x3, y3);
                }
                function generateBezierPoints() {
                    var path = this.currentPath;
                    if (path.length <= 2) return [
                        [
                            path[0],
                            path[0],
                            path.at(-1),
                            path.at(-1)
                        ]
                    ];
                    var bezierPoints = [];
                    var i;
                    var _path_ = (0, $52tJv._)(path[0], 2), x0 = _path_[0], y0 = _path_[1];
                    for(i = 1; i < path.length - 2; i++){
                        var _path_i = (0, $52tJv._)(path[i], 2), x1 = _path_i[0], y1 = _path_i[1];
                        var _path_1 = (0, $52tJv._)(path[i + 1], 2), x2 = _path_1[0], y2 = _path_1[1];
                        var x3 = (x1 + x2) / 2;
                        var y3 = (y1 + y2) / 2;
                        var control1 = [
                            x0 + 2 * (x1 - x0) / 3,
                            y0 + 2 * (y1 - y0) / 3
                        ];
                        var control2 = [
                            x3 + 2 * (x1 - x3) / 3,
                            y3 + 2 * (y1 - y3) / 3
                        ];
                        bezierPoints.push([
                            [
                                x0,
                                y0
                            ],
                            control1,
                            control2,
                            [
                                x3,
                                y3
                            ]
                        ]);
                        var ref;
                        ref = [
                            x3,
                            y3
                        ], x0 = ref[0], y0 = ref[1], ref;
                    }
                    var _path_i1 = (0, $52tJv._)(path[i], 2), x11 = _path_i1[0], y11 = _path_i1[1];
                    var _path_2 = (0, $52tJv._)(path[i + 1], 2), x21 = _path_2[0], y21 = _path_2[1];
                    var control11 = [
                        x0 + 2 * (x11 - x0) / 3,
                        y0 + 2 * (y11 - y0) / 3
                    ];
                    var control21 = [
                        x21 + 2 * (x11 - x21) / 3,
                        y21 + 2 * (y11 - y21) / 3
                    ];
                    bezierPoints.push([
                        [
                            x0,
                            y0
                        ],
                        control11,
                        control21,
                        [
                            x21,
                            y21
                        ]
                    ]);
                    return bezierPoints;
                }
                function redraw() {
                    if (this.isEmpty()) {
                        (0, $lNbhr._)(this, _updateTransform, updateTransform).call(this);
                        return;
                    }
                    (0, $lNbhr._)(this, _setStroke, setStroke).call(this);
                    var _this = this, canvas = _this.canvas, ctx = _this.ctx;
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    (0, $lNbhr._)(this, _updateTransform, updateTransform).call(this);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.bezierPath2D[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var path = _step.value;
                            ctx.stroke(path);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                function endDrawing(event) {
                    var _this = this;
                    this.canvas.removeEventListener("pointerleave", (0, $057QZ._)(this, _boundCanvasPointerleave));
                    this.canvas.removeEventListener("pointermove", (0, $057QZ._)(this, _boundCanvasPointermove));
                    this.canvas.removeEventListener("pointerup", (0, $057QZ._)(this, _boundCanvasPointerup));
                    this.canvas.addEventListener("pointerdown", (0, $057QZ._)(this, _boundCanvasPointerdown));
                    setTimeout(function() {
                        _this.canvas.removeEventListener("contextmenu", _display_utils.noContextMenu);
                    }, 10);
                    (0, $lNbhr._)(this, _stopDrawing, stopDrawing).call(this, event.offsetX, event.offsetY);
                    this.addToAnnotationStorage();
                    this.setInBackground();
                }
                function createCanvas() {
                    var _this = this;
                    this.canvas = document.createElement("canvas");
                    this.canvas.width = this.canvas.height = 0;
                    this.canvas.className = "inkEditorCanvas";
                    _editor.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then(function(msg) {
                        var _this_canvas;
                        return (_this_canvas = _this.canvas) === null || _this_canvas === void 0 ? void 0 : _this_canvas.setAttribute("aria-label", msg);
                    });
                    this.div.append(this.canvas);
                    this.ctx = this.canvas.getContext("2d");
                }
                function createObserver() {
                    var _this = this;
                    (0, $4LHB0._)(this, _observer, new ResizeObserver(function(entries) {
                        var rect = entries[0].contentRect;
                        if (rect.width && rect.height) _this.setDimensions(rect.width, rect.height);
                    }));
                    (0, $057QZ._)(this, _observer).observe(this.div);
                }
                function setCanvasDims() {
                    if (!(0, $057QZ._)(this, _isCanvasInitialized)) return;
                    var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                    this.canvas.width = Math.ceil(this.width * parentWidth);
                    this.canvas.height = Math.ceil(this.height * parentHeight);
                    (0, $lNbhr._)(this, _updateTransform, updateTransform).call(this);
                }
                function setScaleFactor(width, height) {
                    var padding = (0, $lNbhr._)(this, _getPadding, getPadding).call(this);
                    var scaleFactorW = (width - padding) / (0, $057QZ._)(this, _baseWidth);
                    var scaleFactorH = (height - padding) / (0, $057QZ._)(this, _baseHeight);
                    this.scaleFactor = Math.min(scaleFactorW, scaleFactorH);
                }
                function updateTransform() {
                    var padding = (0, $lNbhr._)(this, _getPadding, getPadding).call(this) / 2;
                    this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + padding, this.translationY * this.scaleFactor + padding);
                }
                function buildPath2D(bezier) {
                    var path2D = new Path2D();
                    for(var i = 0, ii = bezier.length; i < ii; i++){
                        var _path2D;
                        var _bezier_i = (0, $52tJv._)(bezier[i], 4), first = _bezier_i[0], control1 = _bezier_i[1], control2 = _bezier_i[2], second = _bezier_i[3];
                        if (i === 0) (_path2D = path2D).moveTo.apply(_path2D, (0, $fyztb._)(first));
                        path2D.bezierCurveTo(control1[0], control1[1], control2[0], control2[1], second[0], second[1]);
                    }
                    return path2D;
                }
                function toPDFCoordinates(points, rect, rotation) {
                    var _rect = (0, $52tJv._)(rect, 4), blX = _rect[0], blY = _rect[1], trX = _rect[2], trY = _rect[3];
                    switch(rotation){
                        case 0:
                            for(var i = 0, ii = points.length; i < ii; i += 2){
                                points[i] += blX;
                                points[i + 1] = trY - points[i + 1];
                            }
                            break;
                        case 90:
                            for(var i1 = 0, ii1 = points.length; i1 < ii1; i1 += 2){
                                var x = points[i1];
                                points[i1] = points[i1 + 1] + blX;
                                points[i1 + 1] = x + blY;
                            }
                            break;
                        case 180:
                            for(var i2 = 0, ii2 = points.length; i2 < ii2; i2 += 2){
                                points[i2] = trX - points[i2];
                                points[i2 + 1] += blY;
                            }
                            break;
                        case 270:
                            for(var i3 = 0, ii3 = points.length; i3 < ii3; i3 += 2){
                                var x1 = points[i3];
                                points[i3] = trX - points[i3 + 1];
                                points[i3 + 1] = trY - x1;
                            }
                            break;
                        default:
                            throw new Error("Invalid rotation");
                    }
                    return points;
                }
                function fromPDFCoordinates(points, rect, rotation) {
                    var _rect = (0, $52tJv._)(rect, 4), blX = _rect[0], blY = _rect[1], trX = _rect[2], trY = _rect[3];
                    switch(rotation){
                        case 0:
                            for(var i = 0, ii = points.length; i < ii; i += 2){
                                points[i] -= blX;
                                points[i + 1] = trY - points[i + 1];
                            }
                            break;
                        case 90:
                            for(var i1 = 0, ii1 = points.length; i1 < ii1; i1 += 2){
                                var x = points[i1];
                                points[i1] = points[i1 + 1] - blY;
                                points[i1 + 1] = x - blX;
                            }
                            break;
                        case 180:
                            for(var i2 = 0, ii2 = points.length; i2 < ii2; i2 += 2){
                                points[i2] = trX - points[i2];
                                points[i2 + 1] -= blY;
                            }
                            break;
                        case 270:
                            for(var i3 = 0, ii3 = points.length; i3 < ii3; i3 += 2){
                                var x1 = points[i3];
                                points[i3] = trY - points[i3 + 1];
                                points[i3 + 1] = trX - x1;
                            }
                            break;
                        default:
                            throw new Error("Invalid rotation");
                    }
                    return points;
                }
                function serializePaths(s, tx, ty, rect) {
                    var paths = [];
                    var padding = this.thickness / 2;
                    var shiftX = s * tx + padding;
                    var shiftY = s * ty + padding;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var bezier = _step.value;
                            var buffer = [];
                            var points = [];
                            for(var j = 0, jj = bezier.length; j < jj; j++){
                                var _bezier_j = (0, $52tJv._)(bezier[j], 4), first = _bezier_j[0], control1 = _bezier_j[1], control2 = _bezier_j[2], second = _bezier_j[3];
                                var p10 = s * first[0] + shiftX;
                                var p11 = s * first[1] + shiftY;
                                var p20 = s * control1[0] + shiftX;
                                var p21 = s * control1[1] + shiftY;
                                var p30 = s * control2[0] + shiftX;
                                var p31 = s * control2[1] + shiftY;
                                var p40 = s * second[0] + shiftX;
                                var p41 = s * second[1] + shiftY;
                                if (j === 0) {
                                    buffer.push(p10, p11);
                                    points.push(p10, p11);
                                }
                                buffer.push(p20, p21, p30, p31, p40, p41);
                                points.push(p20, p21);
                                if (j === jj - 1) points.push(p40, p41);
                            }
                            paths.push({
                                bezier: (0, $9hJkT._)(InkEditor, InkEditor, toPDFCoordinates).call(InkEditor, buffer, rect, this.rotation),
                                points: (0, $9hJkT._)(InkEditor, InkEditor, toPDFCoordinates).call(InkEditor, points, rect, this.rotation)
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return paths;
                }
                function getBbox() {
                    var xMin = Infinity;
                    var xMax = -Infinity;
                    var yMin = Infinity;
                    var yMax = -Infinity;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator = this.paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                            var path = _step.value;
                            try {
                                for(var _iterator1 = path[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                    var _step_value = (0, $52tJv._)(_step1.value, 4), first = _step_value[0], control1 = _step_value[1], control2 = _step_value[2], second = _step_value[3];
                                    var _util_Util;
                                    var bbox = (_util_Util = _util.Util).bezierBoundingBox.apply(_util_Util, (0, $fyztb._)(first).concat((0, $fyztb._)(control1), (0, $fyztb._)(control2), (0, $fyztb._)(second)));
                                    xMin = Math.min(xMin, bbox[0]);
                                    yMin = Math.min(yMin, bbox[1]);
                                    xMax = Math.max(xMax, bbox[2]);
                                    yMax = Math.max(yMax, bbox[3]);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return [
                        xMin,
                        yMin,
                        xMax,
                        yMax
                    ];
                }
                function getPadding() {
                    return (0, $057QZ._)(this, _disableEditing) ? Math.ceil(this.thickness * this.parentScale) : 0;
                }
                function fitToContent() {
                    var firstTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                    if (this.isEmpty()) return;
                    if (!(0, $057QZ._)(this, _disableEditing)) {
                        (0, $lNbhr._)(this, _redraw, redraw).call(this);
                        return;
                    }
                    var bbox = (0, $lNbhr._)(this, _getBbox, getBbox).call(this);
                    var padding = (0, $lNbhr._)(this, _getPadding, getPadding).call(this);
                    (0, $4LHB0._)(this, _baseWidth, Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]));
                    (0, $4LHB0._)(this, _baseHeight, Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]));
                    var width = Math.ceil(padding + (0, $057QZ._)(this, _baseWidth) * this.scaleFactor);
                    var height = Math.ceil(padding + (0, $057QZ._)(this, _baseHeight) * this.scaleFactor);
                    var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                    this.width = width / parentWidth;
                    this.height = height / parentHeight;
                    this.setAspectRatio(width, height);
                    var prevTranslationX = this.translationX;
                    var prevTranslationY = this.translationY;
                    this.translationX = -bbox[0];
                    this.translationY = -bbox[1];
                    (0, $lNbhr._)(this, _setCanvasDims, setCanvasDims).call(this);
                    (0, $lNbhr._)(this, _redraw, redraw).call(this);
                    (0, $4LHB0._)(this, _realWidth, width);
                    (0, $4LHB0._)(this, _realHeight, height);
                    this.setDims(width, height);
                    var unscaledPadding = firstTime ? padding / this.scaleFactor / 2 : 0;
                    this.translate(prevTranslationX - this.translationX - unscaledPadding, prevTranslationY - this.translationY - unscaledPadding);
                }
                exports.InkEditor = InkEditor;
            /***/ },
            /* 34 */ /***/ function(__unused_webpack_module, exports, __w_pdfjs_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StampEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(6);
                var _annotation_layer = __w_pdfjs_require__(29);
                var _bitmap = /*#__PURE__*/ new WeakMap(), _bitmapId = /*#__PURE__*/ new WeakMap(), _bitmapPromise = /*#__PURE__*/ new WeakMap(), _bitmapUrl = /*#__PURE__*/ new WeakMap(), _bitmapFile = /*#__PURE__*/ new WeakMap(), _canvas = /*#__PURE__*/ new WeakMap(), _observer = /*#__PURE__*/ new WeakMap(), _resizeTimeoutId = /*#__PURE__*/ new WeakMap(), _isSvg = /*#__PURE__*/ new WeakMap(), _hasBeenAddedInUndoStack = /*#__PURE__*/ new WeakMap(), _editor_AnnotationEditor, _getBitmapFetched = /*#__PURE__*/ new WeakSet(), _getBitmapDone = /*#__PURE__*/ new WeakSet(), _getBitmap = /*#__PURE__*/ new WeakSet(), _createCanvas = /*#__PURE__*/ new WeakSet(), _setDimensions = /*#__PURE__*/ new WeakSet(), _scaleBitmap = /*#__PURE__*/ new WeakSet(), _drawBitmap = /*#__PURE__*/ new WeakSet(), _serializeBitmap = /*#__PURE__*/ new WeakSet(), _createObserver = /*#__PURE__*/ new WeakSet();
                var StampEditor = /*#__PURE__*/ function(_superClass) {
                    (0, $kcqLc._)(StampEditor, _superClass);
                    var _super = (0, $4jYWU._)(StampEditor);
                    function StampEditor(params) {
                        (0, $5sFFs._)(this, StampEditor);
                        var _this;
                        _this = _super.call(this, (0, $bqLxK._)((0, $lwFY2._)({}, params), {
                            name: "stampEditor"
                        }));
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _getBitmapFetched);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _getBitmapDone);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _getBitmap);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _createCanvas);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _setDimensions);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _scaleBitmap);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _drawBitmap);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _serializeBitmap);
                        (0, $iB2CV._)((0, $lyFcw._)(_this), _createObserver);
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _bitmap, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _bitmapId, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _bitmapPromise, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _bitmapUrl, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _bitmapFile, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _canvas, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _observer, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _resizeTimeoutId, {
                            writable: true,
                            value: null
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _isSvg, {
                            writable: true,
                            value: false
                        });
                        (0, $g12Hy._)((0, $lyFcw._)(_this), _hasBeenAddedInUndoStack, {
                            writable: true,
                            value: false
                        });
                        (0, $4LHB0._)((0, $lyFcw._)(_this), _bitmapUrl, params.bitmapUrl);
                        (0, $4LHB0._)((0, $lyFcw._)(_this), _bitmapFile, params.bitmapFile);
                        return _this;
                    }
                    (0, $8O2fV._)(StampEditor, [
                        {
                            key: "remove",
                            value: function remove() {
                                if ((0, $057QZ._)(this, _bitmapId)) {
                                    var _$_class_private_field_get, _$_class_private_field_get1;
                                    (0, $4LHB0._)(this, _bitmap, null);
                                    this._uiManager.imageManager.deleteId((0, $057QZ._)(this, _bitmapId));
                                    (_$_class_private_field_get = (0, $057QZ._)(this, _canvas)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.remove();
                                    (0, $4LHB0._)(this, _canvas, null);
                                    (_$_class_private_field_get1 = (0, $057QZ._)(this, _observer)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.disconnect();
                                    (0, $4LHB0._)(this, _observer, null);
                                }
                                (0, $404BM._)((0, $cEF31._)(StampEditor.prototype), "remove", this).call(this);
                            }
                        },
                        {
                            key: "rebuild",
                            value: function rebuild() {
                                if (!this.parent) {
                                    if ((0, $057QZ._)(this, _bitmapId)) (0, $lNbhr._)(this, _getBitmap, getBitmap).call(this);
                                    return;
                                }
                                (0, $404BM._)((0, $cEF31._)(StampEditor.prototype), "rebuild", this).call(this);
                                if (this.div === null) return;
                                if ((0, $057QZ._)(this, _bitmapId)) (0, $lNbhr._)(this, _getBitmap, getBitmap).call(this);
                                if (!this.isAttachedToDOM) this.parent.add(this);
                            }
                        },
                        {
                            key: "onceAdded",
                            value: function onceAdded() {
                                this._isDraggable = true;
                                this.div.focus();
                            }
                        },
                        {
                            key: "isEmpty",
                            value: function isEmpty() {
                                return !((0, $057QZ._)(this, _bitmapPromise) || (0, $057QZ._)(this, _bitmap) || (0, $057QZ._)(this, _bitmapUrl) || (0, $057QZ._)(this, _bitmapFile));
                            }
                        },
                        {
                            key: "isResizable",
                            get: function get() {
                                return true;
                            }
                        },
                        {
                            key: "render",
                            value: function render() {
                                if (this.div) return this.div;
                                var baseX, baseY;
                                if (this.width) {
                                    baseX = this.x;
                                    baseY = this.y;
                                }
                                (0, $404BM._)((0, $cEF31._)(StampEditor.prototype), "render", this).call(this);
                                this.div.hidden = true;
                                if ((0, $057QZ._)(this, _bitmap)) (0, $lNbhr._)(this, _createCanvas, createCanvas).call(this);
                                else (0, $lNbhr._)(this, _getBitmap, getBitmap).call(this);
                                if (this.width) {
                                    var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                                    this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                                }
                                return this.div;
                            }
                        },
                        {
                            key: "serialize",
                            value: function serialize() {
                                var isForCopying = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                                var _context;
                                if (this.isEmpty()) return null;
                                var serialized = {
                                    annotationType: _util.AnnotationEditorType.STAMP,
                                    bitmapId: (0, $057QZ._)(this, _bitmapId),
                                    pageIndex: this.pageIndex,
                                    rect: this.getRect(0, 0),
                                    rotation: this.rotation,
                                    isSvg: (0, $057QZ._)(this, _isSvg),
                                    structTreeParentId: this._structTreeParentId
                                };
                                if (isForCopying) {
                                    serialized.bitmapUrl = (0, $lNbhr._)(this, _serializeBitmap, serializeBitmap).call(this, true);
                                    serialized.accessibilityData = this.altTextData;
                                    return serialized;
                                }
                                var _this_altTextData = this.altTextData, decorative = _this_altTextData.decorative, altText = _this_altTextData.altText;
                                if (!decorative && altText) serialized.accessibilityData = {
                                    type: "Figure",
                                    alt: altText
                                };
                                if (context === null) return serialized;
                                (_context = context).stamps || (_context.stamps = new Map());
                                var area = (0, $057QZ._)(this, _isSvg) ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
                                if (!context.stamps.has((0, $057QZ._)(this, _bitmapId))) {
                                    context.stamps.set((0, $057QZ._)(this, _bitmapId), {
                                        area: area,
                                        serialized: serialized
                                    });
                                    serialized.bitmap = (0, $lNbhr._)(this, _serializeBitmap, serializeBitmap).call(this, false);
                                } else if ((0, $057QZ._)(this, _isSvg)) {
                                    var prevData = context.stamps.get((0, $057QZ._)(this, _bitmapId));
                                    if (area > prevData.area) {
                                        prevData.area = area;
                                        prevData.serialized.bitmap.close();
                                        prevData.serialized.bitmap = (0, $lNbhr._)(this, _serializeBitmap, serializeBitmap).call(this, false);
                                    }
                                }
                                return serialized;
                            }
                        }
                    ], [
                        {
                            key: "initialize",
                            value: function initialize(l10n) {
                                _editor.AnnotationEditor.initialize(l10n);
                            }
                        },
                        {
                            key: "supportedTypes",
                            get: function get() {
                                var types = [
                                    "apng",
                                    "avif",
                                    "bmp",
                                    "gif",
                                    "jpeg",
                                    "png",
                                    "svg+xml",
                                    "webp",
                                    "x-icon"
                                ];
                                return (0, _util.shadow)(this, "supportedTypes", types.map(function(type) {
                                    return "image/".concat(type);
                                }));
                            }
                        },
                        {
                            key: "supportedTypesStr",
                            get: function get() {
                                return (0, _util.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
                            }
                        },
                        {
                            key: "isHandlingMimeForPasting",
                            value: function isHandlingMimeForPasting(mime) {
                                return this.supportedTypes.includes(mime);
                            }
                        },
                        {
                            key: "paste",
                            value: function paste(item, parent) {
                                parent.pasteEditor(_util.AnnotationEditorType.STAMP, {
                                    bitmapFile: item.getAsFile()
                                });
                            }
                        },
                        {
                            key: "deserialize",
                            value: function deserialize(data, parent, uiManager) {
                                if (data instanceof _annotation_layer.StampAnnotationElement) return null;
                                var editor = (0, $404BM._)((0, $cEF31._)(StampEditor), "deserialize", this).call(this, data, parent, uiManager);
                                var rect = data.rect, bitmapUrl = data.bitmapUrl, bitmapId = data.bitmapId, isSvg = data.isSvg, accessibilityData = data.accessibilityData;
                                if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) (0, $4LHB0._)(editor, _bitmapId, bitmapId);
                                else (0, $4LHB0._)(editor, _bitmapUrl, bitmapUrl);
                                (0, $4LHB0._)(editor, _isSvg, isSvg);
                                var _editor_pageDimensions = (0, $52tJv._)(editor.pageDimensions, 2), parentWidth = _editor_pageDimensions[0], parentHeight = _editor_pageDimensions[1];
                                editor.width = (rect[2] - rect[0]) / parentWidth;
                                editor.height = (rect[3] - rect[1]) / parentHeight;
                                if (accessibilityData) editor.altTextData = accessibilityData;
                                return editor;
                            }
                        }
                    ]);
                    return StampEditor;
                }(_editor_AnnotationEditor = _editor.AnnotationEditor);
                (0, $iCQyW._)(StampEditor, "_type", "stamp");
                function getBitmapFetched(data) {
                    var fromId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    if (!data) {
                        this.remove();
                        return;
                    }
                    (0, $4LHB0._)(this, _bitmap, data.bitmap);
                    if (!fromId) {
                        (0, $4LHB0._)(this, _bitmapId, data.id);
                        (0, $4LHB0._)(this, _isSvg, data.isSvg);
                    }
                    (0, $lNbhr._)(this, _createCanvas, createCanvas).call(this);
                }
                function getBitmapDone() {
                    (0, $4LHB0._)(this, _bitmapPromise, null);
                    this._uiManager.enableWaiting(false);
                    if ((0, $057QZ._)(this, _canvas)) this.div.focus();
                }
                function getBitmap() {
                    var _this = this;
                    if ((0, $057QZ._)(this, _bitmapId)) {
                        this._uiManager.enableWaiting(true);
                        this._uiManager.imageManager.getFromId((0, $057QZ._)(this, _bitmapId)).then(function(data) {
                            return (0, $lNbhr._)(_this, _getBitmapFetched, getBitmapFetched).call(_this, data, true);
                        }).finally(function() {
                            return (0, $lNbhr._)(_this, _getBitmapDone, getBitmapDone).call(_this);
                        });
                        return;
                    }
                    if ((0, $057QZ._)(this, _bitmapUrl)) {
                        var url = (0, $057QZ._)(this, _bitmapUrl);
                        (0, $4LHB0._)(this, _bitmapUrl, null);
                        this._uiManager.enableWaiting(true);
                        (0, $4LHB0._)(this, _bitmapPromise, this._uiManager.imageManager.getFromUrl(url).then(function(data) {
                            return (0, $lNbhr._)(_this, _getBitmapFetched, getBitmapFetched).call(_this, data);
                        }).finally(function() {
                            return (0, $lNbhr._)(_this, _getBitmapDone, getBitmapDone).call(_this);
                        }));
                        return;
                    }
                    if ((0, $057QZ._)(this, _bitmapFile)) {
                        var file = (0, $057QZ._)(this, _bitmapFile);
                        (0, $4LHB0._)(this, _bitmapFile, null);
                        this._uiManager.enableWaiting(true);
                        (0, $4LHB0._)(this, _bitmapPromise, this._uiManager.imageManager.getFromFile(file).then(function(data) {
                            return (0, $lNbhr._)(_this, _getBitmapFetched, getBitmapFetched).call(_this, data);
                        }).finally(function() {
                            return (0, $lNbhr._)(_this, _getBitmapDone, getBitmapDone).call(_this);
                        }));
                        return;
                    }
                    var input = document.createElement("input");
                    input.type = "file";
                    input.accept = StampEditor.supportedTypesStr;
                    (0, $4LHB0._)(this, _bitmapPromise, new Promise(function(resolve) {
                        var _this1 = _this;
                        input.addEventListener("change", /*#__PURE__*/ (0, $7hBys._)(function() {
                            var data;
                            return (0, $ajhIL.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!(!input.files || input.files.length === 0)) return [
                                            3,
                                            1
                                        ];
                                        _this1.remove();
                                        return [
                                            3,
                                            3
                                        ];
                                    case 1:
                                        _this1._uiManager.enableWaiting(true);
                                        return [
                                            4,
                                            _this1._uiManager.imageManager.getFromFile(input.files[0])
                                        ];
                                    case 2:
                                        data = _state.sent();
                                        (0, $lNbhr._)(_this1, _getBitmapFetched, getBitmapFetched).call(_this1, data);
                                        _state.label = 3;
                                    case 3:
                                        resolve();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                        input.addEventListener("cancel", function() {
                            _this.remove();
                            resolve();
                        });
                    }).finally(function() {
                        return (0, $lNbhr._)(_this, _getBitmapDone, getBitmapDone).call(_this);
                    }));
                    input.click();
                }
                function createCanvas() {
                    var div = this.div;
                    var _$_class_private_field_get = (0, $057QZ._)(this, _bitmap), width = _$_class_private_field_get.width, height = _$_class_private_field_get.height;
                    var _this_pageDimensions = (0, $52tJv._)(this.pageDimensions, 2), pageWidth = _this_pageDimensions[0], pageHeight = _this_pageDimensions[1];
                    var MAX_RATIO = 0.75;
                    if (this.width) {
                        width = this.width * pageWidth;
                        height = this.height * pageHeight;
                    } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
                        var factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
                        width *= factor;
                        height *= factor;
                    }
                    var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                    this.setDims(width * parentWidth / pageWidth, height * parentHeight / pageHeight);
                    this._uiManager.enableWaiting(false);
                    var canvas = (0, $4LHB0._)(this, _canvas, document.createElement("canvas"));
                    div.append(canvas);
                    div.hidden = false;
                    (0, $lNbhr._)(this, _drawBitmap, drawBitmap).call(this, width, height);
                    (0, $lNbhr._)(this, _createObserver, createObserver).call(this);
                    if (!(0, $057QZ._)(this, _hasBeenAddedInUndoStack)) {
                        this.parent.addUndoableEditor(this);
                        (0, $4LHB0._)(this, _hasBeenAddedInUndoStack, true);
                    }
                    this._uiManager._eventBus.dispatch("reporttelemetry", {
                        source: this,
                        details: {
                            type: "editing",
                            subtype: this.editorType,
                            data: {
                                action: "inserted_image"
                            }
                        }
                    });
                    this.addAltTextButton();
                }
                function setDimensions(width, height) {
                    var _this = this;
                    var _this__initialOptions;
                    var _this_parentDimensions = (0, $52tJv._)(this.parentDimensions, 2), parentWidth = _this_parentDimensions[0], parentHeight = _this_parentDimensions[1];
                    this.width = width / parentWidth;
                    this.height = height / parentHeight;
                    this.setDims(width, height);
                    if ((_this__initialOptions = this._initialOptions) === null || _this__initialOptions === void 0 ? void 0 : _this__initialOptions.isCentered) this.center();
                    else this.fixAndSetPosition();
                    this._initialOptions = null;
                    if ((0, $057QZ._)(this, _resizeTimeoutId) !== null) clearTimeout((0, $057QZ._)(this, _resizeTimeoutId));
                    var TIME_TO_WAIT = 200;
                    (0, $4LHB0._)(this, _resizeTimeoutId, setTimeout(function() {
                        (0, $4LHB0._)(_this, _resizeTimeoutId, null);
                        (0, $lNbhr._)(_this, _drawBitmap, drawBitmap).call(_this, width, height);
                    }, TIME_TO_WAIT));
                }
                function scaleBitmap(width, height) {
                    var _$_class_private_field_get = (0, $057QZ._)(this, _bitmap), bitmapWidth = _$_class_private_field_get.width, bitmapHeight = _$_class_private_field_get.height;
                    var newWidth = bitmapWidth;
                    var newHeight = bitmapHeight;
                    var bitmap = (0, $057QZ._)(this, _bitmap);
                    while(newWidth > 2 * width || newHeight > 2 * height){
                        var prevWidth = newWidth;
                        var prevHeight = newHeight;
                        if (newWidth > 2 * width) newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
                        if (newHeight > 2 * height) newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
                        var offscreen = new OffscreenCanvas(newWidth, newHeight);
                        var ctx = offscreen.getContext("2d");
                        ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                        bitmap = offscreen.transferToImageBitmap();
                    }
                    return bitmap;
                }
                function drawBitmap(width, height) {
                    width = Math.ceil(width);
                    height = Math.ceil(height);
                    var canvas = (0, $057QZ._)(this, _canvas);
                    if (!canvas || canvas.width === width && canvas.height === height) return;
                    canvas.width = width;
                    canvas.height = height;
                    var bitmap = (0, $057QZ._)(this, _isSvg) ? (0, $057QZ._)(this, _bitmap) : (0, $lNbhr._)(this, _scaleBitmap, scaleBitmap).call(this, width, height);
                    var ctx = canvas.getContext("2d");
                    ctx.filter = this._uiManager.hcmFilter;
                    ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, width, height);
                }
                function serializeBitmap(toUrl) {
                    if (toUrl) {
                        if ((0, $057QZ._)(this, _isSvg)) {
                            var url = this._uiManager.imageManager.getSvgUrl((0, $057QZ._)(this, _bitmapId));
                            if (url) return url;
                        }
                        var canvas = document.createElement("canvas");
                        var ref;
                        ref = (0, $057QZ._)(this, _bitmap), canvas.width = ref.width, canvas.height = ref.height, ref;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage((0, $057QZ._)(this, _bitmap), 0, 0);
                        return canvas.toDataURL();
                    }
                    if ((0, $057QZ._)(this, _isSvg)) {
                        var _this_pageDimensions = (0, $52tJv._)(this.pageDimensions, 2), pageWidth = _this_pageDimensions[0], pageHeight = _this_pageDimensions[1];
                        var width = Math.round(this.width * pageWidth * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                        var height = Math.round(this.height * pageHeight * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                        var offscreen = new OffscreenCanvas(width, height);
                        var ctx1 = offscreen.getContext("2d");
                        ctx1.drawImage((0, $057QZ._)(this, _bitmap), 0, 0, (0, $057QZ._)(this, _bitmap).width, (0, $057QZ._)(this, _bitmap).height, 0, 0, width, height);
                        return offscreen.transferToImageBitmap();
                    }
                    return structuredClone((0, $057QZ._)(this, _bitmap));
                }
                function createObserver() {
                    var _this = this;
                    (0, $4LHB0._)(this, _observer, new ResizeObserver(function(entries) {
                        var rect = entries[0].contentRect;
                        if (rect.width && rect.height) (0, $lNbhr._)(_this, _setDimensions, setDimensions).call(_this, rect.width, rect.height);
                    }));
                    (0, $057QZ._)(this, _observer).observe(this.div);
                }
                exports.StampEditor = StampEditor;
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __w_pdfjs_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (function() {
            var exports = __webpack_exports__;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            Object.defineProperty(exports, "AbortException", {
                enumerable: true,
                get: function get() {
                    return _util.AbortException;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorLayer", {
                enumerable: true,
                get: function get() {
                    return _annotation_editor_layer.AnnotationEditorLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorParamsType", {
                enumerable: true,
                get: function get() {
                    return _util.AnnotationEditorParamsType;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorType", {
                enumerable: true,
                get: function get() {
                    return _util.AnnotationEditorType;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorUIManager", {
                enumerable: true,
                get: function get() {
                    return _tools.AnnotationEditorUIManager;
                }
            });
            Object.defineProperty(exports, "AnnotationLayer", {
                enumerable: true,
                get: function get() {
                    return _annotation_layer.AnnotationLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationMode", {
                enumerable: true,
                get: function get() {
                    return _util.AnnotationMode;
                }
            });
            Object.defineProperty(exports, "CMapCompressionType", {
                enumerable: true,
                get: function get() {
                    return _util.CMapCompressionType;
                }
            });
            Object.defineProperty(exports, "DOMSVGFactory", {
                enumerable: true,
                get: function get() {
                    return _display_utils.DOMSVGFactory;
                }
            });
            Object.defineProperty(exports, "FeatureTest", {
                enumerable: true,
                get: function get() {
                    return _util.FeatureTest;
                }
            });
            Object.defineProperty(exports, "GlobalWorkerOptions", {
                enumerable: true,
                get: function get() {
                    return _worker_options.GlobalWorkerOptions;
                }
            });
            Object.defineProperty(exports, "ImageKind", {
                enumerable: true,
                get: function get() {
                    return _util.ImageKind;
                }
            });
            Object.defineProperty(exports, "InvalidPDFException", {
                enumerable: true,
                get: function get() {
                    return _util.InvalidPDFException;
                }
            });
            Object.defineProperty(exports, "MissingPDFException", {
                enumerable: true,
                get: function get() {
                    return _util.MissingPDFException;
                }
            });
            Object.defineProperty(exports, "OPS", {
                enumerable: true,
                get: function get() {
                    return _util.OPS;
                }
            });
            Object.defineProperty(exports, "PDFDataRangeTransport", {
                enumerable: true,
                get: function get() {
                    return _api.PDFDataRangeTransport;
                }
            });
            Object.defineProperty(exports, "PDFDateString", {
                enumerable: true,
                get: function get() {
                    return _display_utils.PDFDateString;
                }
            });
            Object.defineProperty(exports, "PDFWorker", {
                enumerable: true,
                get: function get() {
                    return _api.PDFWorker;
                }
            });
            Object.defineProperty(exports, "PasswordResponses", {
                enumerable: true,
                get: function get() {
                    return _util.PasswordResponses;
                }
            });
            Object.defineProperty(exports, "PermissionFlag", {
                enumerable: true,
                get: function get() {
                    return _util.PermissionFlag;
                }
            });
            Object.defineProperty(exports, "PixelsPerInch", {
                enumerable: true,
                get: function get() {
                    return _display_utils.PixelsPerInch;
                }
            });
            Object.defineProperty(exports, "PromiseCapability", {
                enumerable: true,
                get: function get() {
                    return _util.PromiseCapability;
                }
            });
            Object.defineProperty(exports, "RenderingCancelledException", {
                enumerable: true,
                get: function get() {
                    return _display_utils.RenderingCancelledException;
                }
            });
            Object.defineProperty(exports, "SVGGraphics", {
                enumerable: true,
                get: function get() {
                    return _api.SVGGraphics;
                }
            });
            Object.defineProperty(exports, "UnexpectedResponseException", {
                enumerable: true,
                get: function get() {
                    return _util.UnexpectedResponseException;
                }
            });
            Object.defineProperty(exports, "Util", {
                enumerable: true,
                get: function get() {
                    return _util.Util;
                }
            });
            Object.defineProperty(exports, "VerbosityLevel", {
                enumerable: true,
                get: function get() {
                    return _util.VerbosityLevel;
                }
            });
            Object.defineProperty(exports, "XfaLayer", {
                enumerable: true,
                get: function get() {
                    return _xfa_layer.XfaLayer;
                }
            });
            Object.defineProperty(exports, "build", {
                enumerable: true,
                get: function get() {
                    return _api.build;
                }
            });
            Object.defineProperty(exports, "createValidAbsoluteUrl", {
                enumerable: true,
                get: function get() {
                    return _util.createValidAbsoluteUrl;
                }
            });
            Object.defineProperty(exports, "getDocument", {
                enumerable: true,
                get: function get() {
                    return _api.getDocument;
                }
            });
            Object.defineProperty(exports, "getFilenameFromUrl", {
                enumerable: true,
                get: function get() {
                    return _display_utils.getFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getPdfFilenameFromUrl", {
                enumerable: true,
                get: function get() {
                    return _display_utils.getPdfFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getXfaPageViewport", {
                enumerable: true,
                get: function get() {
                    return _display_utils.getXfaPageViewport;
                }
            });
            Object.defineProperty(exports, "isDataScheme", {
                enumerable: true,
                get: function get() {
                    return _display_utils.isDataScheme;
                }
            });
            Object.defineProperty(exports, "isPdfFile", {
                enumerable: true,
                get: function get() {
                    return _display_utils.isPdfFile;
                }
            });
            Object.defineProperty(exports, "loadScript", {
                enumerable: true,
                get: function get() {
                    return _display_utils.loadScript;
                }
            });
            Object.defineProperty(exports, "noContextMenu", {
                enumerable: true,
                get: function get() {
                    return _display_utils.noContextMenu;
                }
            });
            Object.defineProperty(exports, "normalizeUnicode", {
                enumerable: true,
                get: function get() {
                    return _util.normalizeUnicode;
                }
            });
            Object.defineProperty(exports, "renderTextLayer", {
                enumerable: true,
                get: function get() {
                    return _text_layer.renderTextLayer;
                }
            });
            Object.defineProperty(exports, "setLayerDimensions", {
                enumerable: true,
                get: function get() {
                    return _display_utils.setLayerDimensions;
                }
            });
            Object.defineProperty(exports, "shadow", {
                enumerable: true,
                get: function get() {
                    return _util.shadow;
                }
            });
            Object.defineProperty(exports, "updateTextLayer", {
                enumerable: true,
                get: function get() {
                    return _text_layer.updateTextLayer;
                }
            });
            Object.defineProperty(exports, "version", {
                enumerable: true,
                get: function get() {
                    return _api.version;
                }
            });
            var _util = __w_pdfjs_require__(1);
            var _api = __w_pdfjs_require__(2);
            var _display_utils = __w_pdfjs_require__(6);
            var _text_layer = __w_pdfjs_require__(26);
            var _annotation_editor_layer = __w_pdfjs_require__(27);
            var _tools = __w_pdfjs_require__(5);
            var _annotation_layer = __w_pdfjs_require__(29);
            var _worker_options = __w_pdfjs_require__(14);
            var _xfa_layer = __w_pdfjs_require__(32);
            var pdfjsVersion = "3.11.174";
            var pdfjsBuild = "ce8716743";
        })();
        /******/ return __webpack_exports__;
    /******/ }();
});

});
parcelRegister("057QZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $00f68f567cf3e4f4$export$5a67b255b80ee4f2; });

var $2LvEb = parcelRequire("2LvEb");

var $1TTKK = parcelRequire("1TTKK");
function $00f68f567cf3e4f4$export$5a67b255b80ee4f2(receiver, privateMap) {
    var descriptor = (0, $1TTKK._class_extract_field_descriptor)(receiver, privateMap, "get");
    return (0, $2LvEb._class_apply_descriptor_get)(receiver, descriptor);
}

});
parcelRegister("2LvEb", function(module, exports) {

$parcel$export(module.exports, "_class_apply_descriptor_get", function () { return $20388503f54e24a6$export$184ff5d81c0e5775; });
function $20388503f54e24a6$export$184ff5d81c0e5775(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

});

parcelRegister("1TTKK", function(module, exports) {

$parcel$export(module.exports, "_class_extract_field_descriptor", function () { return $16262cdf6196d7c3$export$20c20a422940e173; });
function $16262cdf6196d7c3$export$20c20a422940e173(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

});


parcelRegister("g12Hy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ba8ed5c996cc88e9$export$e235798705076415; });

var $lzWzk = parcelRequire("lzWzk");
function $ba8ed5c996cc88e9$export$e235798705076415(obj, privateMap, value) {
    (0, $lzWzk._check_private_redeclaration)(obj, privateMap);
    privateMap.set(obj, value);
}

});
parcelRegister("lzWzk", function(module, exports) {

$parcel$export(module.exports, "_check_private_redeclaration", function () { return $fb5a4c694b7464ca$export$6b10452b5ac97eba; });
function $fb5a4c694b7464ca$export$6b10452b5ac97eba(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

});


parcelRegister("4LHB0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $378d5e6ccffc03aa$export$268446c9779b3a21; });

var $6gZLW = parcelRequire("6gZLW");

var $1TTKK = parcelRequire("1TTKK");
function $378d5e6ccffc03aa$export$268446c9779b3a21(receiver, privateMap, value) {
    var descriptor = (0, $1TTKK._class_extract_field_descriptor)(receiver, privateMap, "set");
    (0, $6gZLW._class_apply_descriptor_set)(receiver, descriptor, value);
    return value;
}

});
parcelRegister("6gZLW", function(module, exports) {

$parcel$export(module.exports, "_class_apply_descriptor_set", function () { return $4914275d2f58bc09$export$b7b24cdba6bcb11c; });
function $4914275d2f58bc09$export$b7b24cdba6bcb11c(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

});


parcelRegister("l0C3h", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f4b71d5ef99e2135$export$34564f03cc238d9f; });

var $43V0k = parcelRequire("43V0k");

var $1TTKK = parcelRequire("1TTKK");
function $f4b71d5ef99e2135$export$34564f03cc238d9f(receiver, privateMap) {
    var descriptor = (0, $1TTKK._class_extract_field_descriptor)(receiver, privateMap, "update");
    return (0, $43V0k._class_apply_descriptor_update)(receiver, descriptor);
}

});
parcelRegister("43V0k", function(module, exports) {

$parcel$export(module.exports, "_class_apply_descriptor_update", function () { return $2f53a9188f1c06cf$export$2abff382f801d1eb; });
function $2f53a9188f1c06cf$export$2abff382f801d1eb(receiver, descriptor) {
    if (descriptor.set) {
        if (!descriptor.get) throw new TypeError("attempted to read set only private field");
        if (!("__destrWrapper" in descriptor)) descriptor.__destrWrapper = {
            set value (v){
                descriptor.set.call(receiver, v);
            },
            get value () {
                return descriptor.get.call(receiver);
            }
        };
        return descriptor.__destrWrapper;
    } else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        return descriptor;
    }
}

});


parcelRegister("lNbhr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fdd6ec96c8ede4d8$export$ccedaf978f62b9dd; });
function $fdd6ec96c8ede4d8$export$ccedaf978f62b9dd(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}

});

parcelRegister("iB2CV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d89db855b31f7297$export$1002c20f28174dbf; });

var $lzWzk = parcelRequire("lzWzk");
function $d89db855b31f7297$export$1002c20f28174dbf(obj, privateSet) {
    (0, $lzWzk._check_private_redeclaration)(obj, privateSet);
    privateSet.add(obj);
}

});

parcelRegister("cZGNE", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $975c61afa46f1e7d$export$5160b3efe6f07044; });

var $2LvEb = parcelRequire("2LvEb");

var $lwGJA = parcelRequire("lwGJA");

var $gG3vD = parcelRequire("gG3vD");
function $975c61afa46f1e7d$export$5160b3efe6f07044(receiver, classConstructor, descriptor) {
    (0, $lwGJA._class_check_private_static_access)(receiver, classConstructor);
    (0, $gG3vD._class_check_private_static_field_descriptor)(descriptor, "get");
    return (0, $2LvEb._class_apply_descriptor_get)(receiver, descriptor);
}

});
parcelRegister("lwGJA", function(module, exports) {

$parcel$export(module.exports, "_class_check_private_static_access", function () { return $fabdbc3ed8a86479$export$9e7656e55e2ea4f7; });
function $fabdbc3ed8a86479$export$9e7656e55e2ea4f7(receiver, classConstructor) {
    if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
}

});

parcelRegister("gG3vD", function(module, exports) {

$parcel$export(module.exports, "_class_check_private_static_field_descriptor", function () { return $c2434a727bbf76cd$export$d8c518df5e371131; });
function $c2434a727bbf76cd$export$d8c518df5e371131(descriptor, action) {
    if (descriptor === undefined) throw new TypeError("attempted to " + action + " private static field before its declaration");
}

});


parcelRegister("3CqVU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2a29d00ad2f49945$export$32fabec9e9d8204d; });

var $6gZLW = parcelRequire("6gZLW");

var $lwGJA = parcelRequire("lwGJA");

var $gG3vD = parcelRequire("gG3vD");
function $2a29d00ad2f49945$export$32fabec9e9d8204d(receiver, classConstructor, descriptor, value) {
    (0, $lwGJA._class_check_private_static_access)(receiver, classConstructor);
    (0, $gG3vD._class_check_private_static_field_descriptor)(descriptor, "set");
    (0, $6gZLW._class_apply_descriptor_set)(receiver, descriptor, value);
    return value;
}

});

parcelRegister("fC5Fv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b5decd47796c53fd$export$29ae4db76919bfd3; });

var $43V0k = parcelRequire("43V0k");

var $lwGJA = parcelRequire("lwGJA");

var $gG3vD = parcelRequire("gG3vD");
function $b5decd47796c53fd$export$29ae4db76919bfd3(receiver, classConstructor, descriptor) {
    (0, $lwGJA._class_check_private_static_access)(receiver, classConstructor);
    (0, $gG3vD._class_check_private_static_field_descriptor)(descriptor, "update");
    return (0, $43V0k._class_apply_descriptor_update)(receiver, descriptor);
}

});

parcelRegister("lwFY2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fabd23f91d5c20a6$export$581ff339ea0ba762; });

var $iCQyW = parcelRequire("iCQyW");
function $fabd23f91d5c20a6$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $iCQyW._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("bqLxK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8527008305b3b513$export$4fa2f4023c9cbda5; });
function $8527008305b3b513$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8527008305b3b513$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $8527008305b3b513$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("9hJkT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6c28de5aa7e73537$export$68238ee8e0a3fa8c; });

var $lwGJA = parcelRequire("lwGJA");
function $6c28de5aa7e73537$export$68238ee8e0a3fa8c(receiver, classConstructor, method) {
    (0, $lwGJA._class_check_private_static_access)(receiver, classConstructor);
    return method;
}

});

parcelRegister("kTBk6", function(module, exports) {
// shim for using process in browser
var $f365e55448c74ce1$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $f365e55448c74ce1$var$cachedSetTimeout;
var $f365e55448c74ce1$var$cachedClearTimeout;
function $f365e55448c74ce1$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $f365e55448c74ce1$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $f365e55448c74ce1$var$cachedSetTimeout = setTimeout;
        else $f365e55448c74ce1$var$cachedSetTimeout = $f365e55448c74ce1$var$defaultSetTimout;
    } catch (e) {
        $f365e55448c74ce1$var$cachedSetTimeout = $f365e55448c74ce1$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $f365e55448c74ce1$var$cachedClearTimeout = clearTimeout;
        else $f365e55448c74ce1$var$cachedClearTimeout = $f365e55448c74ce1$var$defaultClearTimeout;
    } catch (e) {
        $f365e55448c74ce1$var$cachedClearTimeout = $f365e55448c74ce1$var$defaultClearTimeout;
    }
})();
function $f365e55448c74ce1$var$runTimeout(fun) {
    if ($f365e55448c74ce1$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($f365e55448c74ce1$var$cachedSetTimeout === $f365e55448c74ce1$var$defaultSetTimout || !$f365e55448c74ce1$var$cachedSetTimeout) && setTimeout) {
        $f365e55448c74ce1$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $f365e55448c74ce1$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $f365e55448c74ce1$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $f365e55448c74ce1$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $f365e55448c74ce1$var$runClearTimeout(marker) {
    if ($f365e55448c74ce1$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($f365e55448c74ce1$var$cachedClearTimeout === $f365e55448c74ce1$var$defaultClearTimeout || !$f365e55448c74ce1$var$cachedClearTimeout) && clearTimeout) {
        $f365e55448c74ce1$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $f365e55448c74ce1$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $f365e55448c74ce1$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $f365e55448c74ce1$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $f365e55448c74ce1$var$queue = [];
var $f365e55448c74ce1$var$draining = false;
var $f365e55448c74ce1$var$currentQueue;
var $f365e55448c74ce1$var$queueIndex = -1;
function $f365e55448c74ce1$var$cleanUpNextTick() {
    if (!$f365e55448c74ce1$var$draining || !$f365e55448c74ce1$var$currentQueue) return;
    $f365e55448c74ce1$var$draining = false;
    if ($f365e55448c74ce1$var$currentQueue.length) $f365e55448c74ce1$var$queue = $f365e55448c74ce1$var$currentQueue.concat($f365e55448c74ce1$var$queue);
    else $f365e55448c74ce1$var$queueIndex = -1;
    if ($f365e55448c74ce1$var$queue.length) $f365e55448c74ce1$var$drainQueue();
}
function $f365e55448c74ce1$var$drainQueue() {
    if ($f365e55448c74ce1$var$draining) return;
    var timeout = $f365e55448c74ce1$var$runTimeout($f365e55448c74ce1$var$cleanUpNextTick);
    $f365e55448c74ce1$var$draining = true;
    var len = $f365e55448c74ce1$var$queue.length;
    while(len){
        $f365e55448c74ce1$var$currentQueue = $f365e55448c74ce1$var$queue;
        $f365e55448c74ce1$var$queue = [];
        while(++$f365e55448c74ce1$var$queueIndex < len)if ($f365e55448c74ce1$var$currentQueue) $f365e55448c74ce1$var$currentQueue[$f365e55448c74ce1$var$queueIndex].run();
        $f365e55448c74ce1$var$queueIndex = -1;
        len = $f365e55448c74ce1$var$queue.length;
    }
    $f365e55448c74ce1$var$currentQueue = null;
    $f365e55448c74ce1$var$draining = false;
    $f365e55448c74ce1$var$runClearTimeout(timeout);
}
$f365e55448c74ce1$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $f365e55448c74ce1$var$queue.push(new $f365e55448c74ce1$var$Item(fun, args));
    if ($f365e55448c74ce1$var$queue.length === 1 && !$f365e55448c74ce1$var$draining) $f365e55448c74ce1$var$runTimeout($f365e55448c74ce1$var$drainQueue);
};
// v8 likes predictible objects
function $f365e55448c74ce1$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$f365e55448c74ce1$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$f365e55448c74ce1$var$process.title = "browser";
$f365e55448c74ce1$var$process.browser = true;
$f365e55448c74ce1$var$process.env = {};
$f365e55448c74ce1$var$process.argv = [];
$f365e55448c74ce1$var$process.version = ""; // empty string to avoid regexp issues
$f365e55448c74ce1$var$process.versions = {};
function $f365e55448c74ce1$var$noop() {}
$f365e55448c74ce1$var$process.on = $f365e55448c74ce1$var$noop;
$f365e55448c74ce1$var$process.addListener = $f365e55448c74ce1$var$noop;
$f365e55448c74ce1$var$process.once = $f365e55448c74ce1$var$noop;
$f365e55448c74ce1$var$process.off = $f365e55448c74ce1$var$noop;
$f365e55448c74ce1$var$process.removeListener = $f365e55448c74ce1$var$noop;
$f365e55448c74ce1$var$process.removeAllListeners = $f365e55448c74ce1$var$noop;
$f365e55448c74ce1$var$process.emit = $f365e55448c74ce1$var$noop;
$f365e55448c74ce1$var$process.prependListener = $f365e55448c74ce1$var$noop;
$f365e55448c74ce1$var$process.prependOnceListener = $f365e55448c74ce1$var$noop;
$f365e55448c74ce1$var$process.listeners = function(name) {
    return [];
};
$f365e55448c74ce1$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$f365e55448c74ce1$var$process.cwd = function() {
    return "/";
};
$f365e55448c74ce1$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$f365e55448c74ce1$var$process.umask = function() {
    return 0;
};

});

parcelRegister("cUP0b", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $967246e67e74a063$export$a143d493d941bafc; }, function (v) { return $967246e67e74a063$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $967246e67e74a063$export$f99ded8fe4b79145; }, function (v) { return $967246e67e74a063$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $lyFcw = parcelRequire("lyFcw");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $l6pW7 = parcelRequire("l6pW7");

var $4jYWU = parcelRequire("4jYWU");
var $967246e67e74a063$export$a143d493d941bafc;
var $967246e67e74a063$export$e4cf37d7f6fb9e0a;
var $967246e67e74a063$export$f99ded8fe4b79145;
var $967246e67e74a063$export$599f31c3813fae4d;
"use strict";

var $cQUnu = parcelRequire("cQUnu");

var $lfff2 = parcelRequire("lfff2");
var $967246e67e74a063$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$967246e67e74a063$export$a143d493d941bafc = $967246e67e74a063$var$Buffer;
$967246e67e74a063$export$e4cf37d7f6fb9e0a = $967246e67e74a063$var$SlowBuffer;
$967246e67e74a063$export$f99ded8fe4b79145 = 50;
var $967246e67e74a063$var$K_MAX_LENGTH = 0x7fffffff;
$967246e67e74a063$export$599f31c3813fae4d = $967246e67e74a063$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $967246e67e74a063$var$Buffer.TYPED_ARRAY_SUPPORT = $967246e67e74a063$var$typedArraySupport();
if (!$967246e67e74a063$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $967246e67e74a063$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($967246e67e74a063$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function get() {
        if (!$967246e67e74a063$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($967246e67e74a063$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function get() {
        if (!$967246e67e74a063$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $967246e67e74a063$var$createBuffer(length) {
    if (length > $967246e67e74a063$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $967246e67e74a063$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $967246e67e74a063$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $967246e67e74a063$var$allocUnsafe(arg);
    }
    return $967246e67e74a063$var$from(arg, encodingOrOffset, length);
}
$967246e67e74a063$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $967246e67e74a063$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $967246e67e74a063$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $967246e67e74a063$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $l6pW7._)(value)));
    if ($967246e67e74a063$var$isInstance(value, ArrayBuffer) || value && $967246e67e74a063$var$isInstance(value.buffer, ArrayBuffer)) return $967246e67e74a063$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($967246e67e74a063$var$isInstance(value, SharedArrayBuffer) || value && $967246e67e74a063$var$isInstance(value.buffer, SharedArrayBuffer))) return $967246e67e74a063$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $967246e67e74a063$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $967246e67e74a063$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $967246e67e74a063$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $l6pW7._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $967246e67e74a063$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $967246e67e74a063$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($967246e67e74a063$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($967246e67e74a063$var$Buffer, Uint8Array);
function $967246e67e74a063$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $967246e67e74a063$var$alloc(size, fill, encoding) {
    $967246e67e74a063$var$assertSize(size);
    if (size <= 0) return $967246e67e74a063$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $967246e67e74a063$var$createBuffer(size).fill(fill, encoding) : $967246e67e74a063$var$createBuffer(size).fill(fill);
    return $967246e67e74a063$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $967246e67e74a063$var$Buffer.alloc = function(size, fill, encoding) {
    return $967246e67e74a063$var$alloc(size, fill, encoding);
};
function $967246e67e74a063$var$allocUnsafe(size) {
    $967246e67e74a063$var$assertSize(size);
    return $967246e67e74a063$var$createBuffer(size < 0 ? 0 : $967246e67e74a063$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $967246e67e74a063$var$Buffer.allocUnsafe = function(size) {
    return $967246e67e74a063$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $967246e67e74a063$var$Buffer.allocUnsafeSlow = function(size) {
    return $967246e67e74a063$var$allocUnsafe(size);
};
function $967246e67e74a063$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$967246e67e74a063$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $967246e67e74a063$var$byteLength(string, encoding) | 0;
    var buf = $967246e67e74a063$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $967246e67e74a063$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $967246e67e74a063$var$checked(array.length) | 0;
    var buf = $967246e67e74a063$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $967246e67e74a063$var$fromArrayView(arrayView) {
    if ($967246e67e74a063$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $967246e67e74a063$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $967246e67e74a063$var$fromArrayLike(arrayView);
}
function $967246e67e74a063$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $967246e67e74a063$var$Buffer.prototype);
    return buf;
}
function $967246e67e74a063$var$fromObject(obj) {
    if ($967246e67e74a063$var$Buffer.isBuffer(obj)) {
        var len = $967246e67e74a063$var$checked(obj.length) | 0;
        var buf = $967246e67e74a063$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $967246e67e74a063$var$numberIsNaN(obj.length)) return $967246e67e74a063$var$createBuffer(0);
        return $967246e67e74a063$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $967246e67e74a063$var$fromArrayLike(obj.data);
}
function $967246e67e74a063$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $967246e67e74a063$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $967246e67e74a063$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $967246e67e74a063$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $967246e67e74a063$var$Buffer.alloc(+length);
}
$967246e67e74a063$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $967246e67e74a063$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$967246e67e74a063$var$Buffer.compare = function compare(a, b) {
    if ($967246e67e74a063$var$isInstance(a, Uint8Array)) a = $967246e67e74a063$var$Buffer.from(a, a.offset, a.byteLength);
    if ($967246e67e74a063$var$isInstance(b, Uint8Array)) b = $967246e67e74a063$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$967246e67e74a063$var$Buffer.isBuffer(a) || !$967246e67e74a063$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$967246e67e74a063$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$967246e67e74a063$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $967246e67e74a063$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $967246e67e74a063$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($967246e67e74a063$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$967246e67e74a063$var$Buffer.isBuffer(buf)) buf = $967246e67e74a063$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$967246e67e74a063$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $967246e67e74a063$var$byteLength(string, encoding) {
    if ($967246e67e74a063$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $967246e67e74a063$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $l6pW7._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $967246e67e74a063$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $967246e67e74a063$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $967246e67e74a063$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$967246e67e74a063$var$Buffer.byteLength = $967246e67e74a063$var$byteLength;
function $967246e67e74a063$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $967246e67e74a063$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $967246e67e74a063$var$utf8Slice(this, start, end);
        case "ascii":
            return $967246e67e74a063$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $967246e67e74a063$var$latin1Slice(this, start, end);
        case "base64":
            return $967246e67e74a063$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $967246e67e74a063$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$967246e67e74a063$var$Buffer.prototype._isBuffer = true;
function $967246e67e74a063$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$967246e67e74a063$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$967246e67e74a063$var$swap(this, i, i + 1);
    return this;
};
$967246e67e74a063$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $967246e67e74a063$var$swap(this, i, i + 3);
        $967246e67e74a063$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$967246e67e74a063$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $967246e67e74a063$var$swap(this, i, i + 7);
        $967246e67e74a063$var$swap(this, i + 1, i + 6);
        $967246e67e74a063$var$swap(this, i + 2, i + 5);
        $967246e67e74a063$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$967246e67e74a063$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $967246e67e74a063$var$utf8Slice(this, 0, length);
    return $967246e67e74a063$var$slowToString.apply(this, arguments);
};
$967246e67e74a063$var$Buffer.prototype.toLocaleString = $967246e67e74a063$var$Buffer.prototype.toString;
$967246e67e74a063$var$Buffer.prototype.equals = function equals(b) {
    if (!$967246e67e74a063$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $967246e67e74a063$var$Buffer.compare(this, b) === 0;
};
$967246e67e74a063$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $967246e67e74a063$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($967246e67e74a063$var$customInspectSymbol) $967246e67e74a063$var$Buffer.prototype[$967246e67e74a063$var$customInspectSymbol] = $967246e67e74a063$var$Buffer.prototype.inspect;
$967246e67e74a063$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($967246e67e74a063$var$isInstance(target, Uint8Array)) target = $967246e67e74a063$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$967246e67e74a063$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $l6pW7._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $967246e67e74a063$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($967246e67e74a063$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $967246e67e74a063$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($967246e67e74a063$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $967246e67e74a063$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $967246e67e74a063$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $967246e67e74a063$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$967246e67e74a063$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$967246e67e74a063$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $967246e67e74a063$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$967246e67e74a063$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $967246e67e74a063$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $967246e67e74a063$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($967246e67e74a063$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $967246e67e74a063$var$utf8Write(buf, string, offset, length) {
    return $967246e67e74a063$var$blitBuffer($967246e67e74a063$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $967246e67e74a063$var$asciiWrite(buf, string, offset, length) {
    return $967246e67e74a063$var$blitBuffer($967246e67e74a063$var$asciiToBytes(string), buf, offset, length);
}
function $967246e67e74a063$var$base64Write(buf, string, offset, length) {
    return $967246e67e74a063$var$blitBuffer($967246e67e74a063$var$base64ToBytes(string), buf, offset, length);
}
function $967246e67e74a063$var$ucs2Write(buf, string, offset, length) {
    return $967246e67e74a063$var$blitBuffer($967246e67e74a063$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$967246e67e74a063$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $967246e67e74a063$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $967246e67e74a063$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $967246e67e74a063$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $967246e67e74a063$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $967246e67e74a063$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$967246e67e74a063$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $967246e67e74a063$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $cQUnu.fromByteArray(buf);
    else return $cQUnu.fromByteArray(buf.slice(start, end));
}
function $967246e67e74a063$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $967246e67e74a063$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $967246e67e74a063$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $967246e67e74a063$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $967246e67e74a063$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $967246e67e74a063$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $967246e67e74a063$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $967246e67e74a063$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $967246e67e74a063$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $967246e67e74a063$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $967246e67e74a063$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$967246e67e74a063$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $967246e67e74a063$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $967246e67e74a063$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$967246e67e74a063$var$Buffer.prototype.readUintLE = $967246e67e74a063$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$967246e67e74a063$var$Buffer.prototype.readUintBE = $967246e67e74a063$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$967246e67e74a063$var$Buffer.prototype.readUint8 = $967246e67e74a063$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$967246e67e74a063$var$Buffer.prototype.readUint16LE = $967246e67e74a063$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$967246e67e74a063$var$Buffer.prototype.readUint16BE = $967246e67e74a063$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$967246e67e74a063$var$Buffer.prototype.readUint32LE = $967246e67e74a063$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$967246e67e74a063$var$Buffer.prototype.readUint32BE = $967246e67e74a063$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$967246e67e74a063$var$Buffer.prototype.readBigUInt64LE = $967246e67e74a063$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $967246e67e74a063$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $967246e67e74a063$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$967246e67e74a063$var$Buffer.prototype.readBigUInt64BE = $967246e67e74a063$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $967246e67e74a063$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $967246e67e74a063$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$967246e67e74a063$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$967246e67e74a063$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$967246e67e74a063$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$967246e67e74a063$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$967246e67e74a063$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$967246e67e74a063$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$967246e67e74a063$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$967246e67e74a063$var$Buffer.prototype.readBigInt64LE = $967246e67e74a063$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $967246e67e74a063$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $967246e67e74a063$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$967246e67e74a063$var$Buffer.prototype.readBigInt64BE = $967246e67e74a063$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $967246e67e74a063$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $967246e67e74a063$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$967246e67e74a063$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, 4, this.length);
    return $lfff2.read(this, offset, true, 23, 4);
};
$967246e67e74a063$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, 4, this.length);
    return $lfff2.read(this, offset, false, 23, 4);
};
$967246e67e74a063$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, 8, this.length);
    return $lfff2.read(this, offset, true, 52, 8);
};
$967246e67e74a063$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkOffset(offset, 8, this.length);
    return $lfff2.read(this, offset, false, 52, 8);
};
function $967246e67e74a063$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$967246e67e74a063$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$967246e67e74a063$var$Buffer.prototype.writeUintLE = $967246e67e74a063$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $967246e67e74a063$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$967246e67e74a063$var$Buffer.prototype.writeUintBE = $967246e67e74a063$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $967246e67e74a063$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$967246e67e74a063$var$Buffer.prototype.writeUint8 = $967246e67e74a063$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$967246e67e74a063$var$Buffer.prototype.writeUint16LE = $967246e67e74a063$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$967246e67e74a063$var$Buffer.prototype.writeUint16BE = $967246e67e74a063$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$967246e67e74a063$var$Buffer.prototype.writeUint32LE = $967246e67e74a063$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$967246e67e74a063$var$Buffer.prototype.writeUint32BE = $967246e67e74a063$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $967246e67e74a063$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $967246e67e74a063$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $967246e67e74a063$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $967246e67e74a063$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$967246e67e74a063$var$Buffer.prototype.writeBigUInt64LE = $967246e67e74a063$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $967246e67e74a063$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$967246e67e74a063$var$Buffer.prototype.writeBigUInt64BE = $967246e67e74a063$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $967246e67e74a063$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$967246e67e74a063$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $967246e67e74a063$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$967246e67e74a063$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $967246e67e74a063$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$967246e67e74a063$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$967246e67e74a063$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$967246e67e74a063$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$967246e67e74a063$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$967246e67e74a063$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$967246e67e74a063$var$Buffer.prototype.writeBigInt64LE = $967246e67e74a063$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $967246e67e74a063$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$967246e67e74a063$var$Buffer.prototype.writeBigInt64BE = $967246e67e74a063$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $967246e67e74a063$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $967246e67e74a063$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $967246e67e74a063$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $lfff2.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$967246e67e74a063$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $967246e67e74a063$var$writeFloat(this, value, offset, true, noAssert);
};
$967246e67e74a063$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $967246e67e74a063$var$writeFloat(this, value, offset, false, noAssert);
};
function $967246e67e74a063$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $967246e67e74a063$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $lfff2.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$967246e67e74a063$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $967246e67e74a063$var$writeDouble(this, value, offset, true, noAssert);
};
$967246e67e74a063$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $967246e67e74a063$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$967246e67e74a063$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$967246e67e74a063$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$967246e67e74a063$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$967246e67e74a063$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $967246e67e74a063$var$Buffer.isBuffer(val) ? val : $967246e67e74a063$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $967246e67e74a063$var$errors = {};
function $967246e67e74a063$var$E(sym, getMessage, Base) {
    $967246e67e74a063$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $kcqLc._)(NodeError, Base);
        var _super = (0, $4jYWU._)(NodeError);
        function NodeError() {
            (0, $5sFFs._)(this, NodeError);
            var _this;
            _this = _super.call(this);
            Object.defineProperty((0, $lyFcw._)(_this), "message", {
                value: getMessage.apply((0, $lyFcw._)(_this), arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $8O2fV._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, "code", {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$967246e67e74a063$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$967246e67e74a063$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $l6pW7._)(actual));
}, TypeError);
$967246e67e74a063$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $967246e67e74a063$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $l6pW7._)(input)) === "bigint") {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $967246e67e74a063$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $967246e67e74a063$var$addNumericalSeparator(val) {
    var res = "";
    var i = val.length;
    var start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $967246e67e74a063$var$checkBounds(buf, offset, byteLength) {
    $967246e67e74a063$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $967246e67e74a063$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $967246e67e74a063$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $l6pW7._)(min)) === "bigint" ? "n" : "";
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $967246e67e74a063$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $967246e67e74a063$var$checkBounds(buf, offset, byteLength);
}
function $967246e67e74a063$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $967246e67e74a063$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $967246e67e74a063$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $967246e67e74a063$var$validateNumber(value, type);
        throw new $967246e67e74a063$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $967246e67e74a063$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $967246e67e74a063$var$errors.ERR_OUT_OF_RANGE(type || "offset", ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $967246e67e74a063$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $967246e67e74a063$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($967246e67e74a063$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $967246e67e74a063$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $967246e67e74a063$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $967246e67e74a063$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $967246e67e74a063$var$base64ToBytes(str) {
    return $cQUnu.toByteArray($967246e67e74a063$var$base64clean(str));
}
function $967246e67e74a063$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $967246e67e74a063$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $967246e67e74a063$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $967246e67e74a063$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $967246e67e74a063$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $967246e67e74a063$var$BufferBigIntNotDefined : fn;
}
function $967246e67e74a063$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("cQUnu", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $95b612dbd5930a85$export$d622b2ad8d90c771; }, function (v) { return $95b612dbd5930a85$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $95b612dbd5930a85$export$6100ba28696e12de; }, function (v) { return $95b612dbd5930a85$export$6100ba28696e12de = v; });
var $95b612dbd5930a85$export$a48f0734ac7c2329;
var $95b612dbd5930a85$export$d622b2ad8d90c771;
var $95b612dbd5930a85$export$6100ba28696e12de;
"use strict";
$95b612dbd5930a85$export$a48f0734ac7c2329 = $95b612dbd5930a85$var$byteLength;
$95b612dbd5930a85$export$d622b2ad8d90c771 = $95b612dbd5930a85$var$toByteArray;
$95b612dbd5930a85$export$6100ba28696e12de = $95b612dbd5930a85$var$fromByteArray;
var $95b612dbd5930a85$var$lookup = [];
var $95b612dbd5930a85$var$revLookup = [];
var $95b612dbd5930a85$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $95b612dbd5930a85$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $95b612dbd5930a85$var$i = 0, $95b612dbd5930a85$var$len = $95b612dbd5930a85$var$code.length; $95b612dbd5930a85$var$i < $95b612dbd5930a85$var$len; ++$95b612dbd5930a85$var$i){
    $95b612dbd5930a85$var$lookup[$95b612dbd5930a85$var$i] = $95b612dbd5930a85$var$code[$95b612dbd5930a85$var$i];
    $95b612dbd5930a85$var$revLookup[$95b612dbd5930a85$var$code.charCodeAt($95b612dbd5930a85$var$i)] = $95b612dbd5930a85$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$95b612dbd5930a85$var$revLookup["-".charCodeAt(0)] = 62;
$95b612dbd5930a85$var$revLookup["_".charCodeAt(0)] = 63;
function $95b612dbd5930a85$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $95b612dbd5930a85$var$byteLength(b64) {
    var lens = $95b612dbd5930a85$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $95b612dbd5930a85$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $95b612dbd5930a85$var$toByteArray(b64) {
    var tmp;
    var lens = $95b612dbd5930a85$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $95b612dbd5930a85$var$Arr($95b612dbd5930a85$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $95b612dbd5930a85$var$revLookup[b64.charCodeAt(i)] << 18 | $95b612dbd5930a85$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $95b612dbd5930a85$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $95b612dbd5930a85$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $95b612dbd5930a85$var$revLookup[b64.charCodeAt(i)] << 2 | $95b612dbd5930a85$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $95b612dbd5930a85$var$revLookup[b64.charCodeAt(i)] << 10 | $95b612dbd5930a85$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $95b612dbd5930a85$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $95b612dbd5930a85$var$tripletToBase64(num) {
    return $95b612dbd5930a85$var$lookup[num >> 18 & 0x3F] + $95b612dbd5930a85$var$lookup[num >> 12 & 0x3F] + $95b612dbd5930a85$var$lookup[num >> 6 & 0x3F] + $95b612dbd5930a85$var$lookup[num & 0x3F];
}
function $95b612dbd5930a85$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($95b612dbd5930a85$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $95b612dbd5930a85$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($95b612dbd5930a85$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($95b612dbd5930a85$var$lookup[tmp >> 2] + $95b612dbd5930a85$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($95b612dbd5930a85$var$lookup[tmp >> 10] + $95b612dbd5930a85$var$lookup[tmp >> 4 & 0x3F] + $95b612dbd5930a85$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("lfff2", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $f776d251da5c579c$export$aafa59e2e03f2942; }, function (v) { return $f776d251da5c579c$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $f776d251da5c579c$export$68d8715fc104d294; }, function (v) { return $f776d251da5c579c$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $f776d251da5c579c$export$aafa59e2e03f2942;
var $f776d251da5c579c$export$68d8715fc104d294;
$f776d251da5c579c$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$f776d251da5c579c$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("6Guue", function(module, exports) {
"use strict";

});


var $2a471062978a40a2$exports = {};
"use strict";

$2a471062978a40a2$exports = (parcelRequire("4n6uQ"));


parcelRequire("17VE6");

var $62qDs = parcelRequire("62qDs");


var $87f43e692fc6da61$exports = {};
$87f43e692fc6da61$exports = JSON.parse('{"name":"webfrontend","version":"15.15.5","private":true,"dependencies":{"@fortawesome/fontawesome-free":"^5.13.1","@js-joda/core":"^1.12.0","@js-joda/timezone":"^2.2.0","@types/node":"12.0.10","@types/react":"17.0.0","@types/react-dom":"17.0.0","@types/react-router-dom":"^5.3.0","@types/uuid":"^8.3.0","browserslist":"^4.18.1","buffer":"^6.0.3","css-loader":"^6.5.1","eslint":"^8.3.0","eslint-config-react-app":"^7.0.1","file-loader":"^6.2.0","fs-extra":"^10.0.0","identity-obj-proxy":"^3.0.0","mini-css-extract-plugin":"^2.4.5","ol":"^8.0.0","parcel":"^2.10.0","react":"^17.0.0","react-app-polyfill":"^3.0.0","react-dev-utils":"^12.0.1","react-dom":"^17.0.0","react-pdf":"^7.5.1","react-refresh":"^0.11.0","react-router-dom":"^6.3.0","recharts":"^2.1.9","resolve":"^1.20.0","resolve-url-loader":"^4.0.0","sass-loader":"^12.3.0","semver":"^7.3.5","source-map-loader":"^3.0.0","style-loader":"^3.3.1","typescript":"~3.9.2","uuid":"^8.3.2"},"devDependencies":{"@parcel/config-default":"^2.10.0","@parcel/resolver-default":"^2.10.0","@parcel/transformer-typescript-tsc":"^2.10.0","http-proxy-middleware":"^2.0.6","parcel-reporter-static-files-copy":"^1.5.3","parcel-resolver-ignore":"^2.1.5","process":"^0.11.10"},"proxy":"http://localhost:3003","scripts":{"start":"parcel serve -p 3000 src/index.html","build":"parcel build src/index.html","test":"echo Skipping for now && exit 0"},"eslintConfig":{"extends":"react-app"},"parcelIgnore":["environment.css"],"browserslist":{"production":[">0.15%"],"development":["last 1 chrome version","last 1 firefox version","last 1 safari version"]}}');



var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");

var $ajhIL = parcelRequire("ajhIL");


var $17VE6 = parcelRequire("17VE6");


var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
var $da28a2330eaa34fb$export$d9183a4079b5f34b = [
    {
        id: "0",
        description: "1 Day",
        durationSec: 86400
    },
    {
        id: "1",
        description: "1 Week",
        durationSec: 604800
    },
    {
        id: "2",
        description: "2 Weeks",
        durationSec: 1209600
    },
    {
        id: "3",
        description: "1 Month",
        durationSec: 2592000
    },
    {
        id: "4",
        description: "6 Months",
        durationSec: 15552000
    },
    {
        id: "5",
        description: "1 Year",
        durationSec: 31536000
    }
];



var $7hBys = parcelRequire("7hBys");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $ajhIL = parcelRequire("ajhIL");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
var $c654d78c2f990604$export$d5dc6a7bc778a961 = /*#__PURE__*/ function() {
    "use strict";
    function HttpException(response) {
        (0, $5sFFs._)(this, HttpException);
        this.code = response.status;
        this.error = response.statusText;
    }
    (0, $8O2fV._)(HttpException, [
        {
            key: "toString",
            value: function toString() {
                return this.error;
            }
        }
    ]);
    return HttpException;
}();



var $d426a3f2c6fbebd8$var$ENDPOINT = "/api/login";
function $d426a3f2c6fbebd8$export$280f25a5a6782e3d() {
    var jwt = localStorage.jwt;
    return {
        "Authorization": "Bearer ".concat(jwt)
    };
}
function $d426a3f2c6fbebd8$export$dd7587c4f6d92d8d() {
    return localStorage.jwt;
}
// function createForm(username: string, password: string, options: any) {
//     // const form = new FormData();
//     // form.append("username", username);
//     // form.append("password", password);
//     // return form;
//     let result = `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`;
//     if (options.keepLoggedIn) {
//         result = result + `&keep-logged-in=true`;
//     }
//     return result;
// }
function $d426a3f2c6fbebd8$var$parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    var result = JSON.parse(jsonPayload);
    return result;
}
var $d426a3f2c6fbebd8$var$loginInformation;
var $d426a3f2c6fbebd8$var$LoginService = /*#__PURE__*/ function() {
    "use strict";
    function LoginService() {
        (0, $5sFFs._)(this, LoginService);
    }
    (0, $8O2fV._)(LoginService, [
        {
            key: "login",
            value: function login(username, password, options) {
                return (0, $7hBys._)(function() {
                    var response, jwt, parsedJwt;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.log("Performing login for user ".concat(username));
                                return [
                                    4,
                                    fetch($d426a3f2c6fbebd8$var$ENDPOINT, {
                                        body: JSON.stringify({
                                            username: username,
                                            password: password
                                        }),
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        method: "post"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                jwt = _state.sent().id_token;
                                parsedJwt = $d426a3f2c6fbebd8$var$parseJwt(jwt);
                                localStorage.jwt = jwt;
                                localStorage.username = username;
                                localStorage.roles = JSON.stringify(parsedJwt.roles);
                                localStorage.customerId = parsedJwt.customerId;
                                $d426a3f2c6fbebd8$var$loginInformation = new (0, $e7dcbc6197905a97$export$ff6e957d40887abf)(username, jwt, parsedJwt.roles, parsedJwt.customerId);
                                return [
                                    2,
                                    $d426a3f2c6fbebd8$var$loginInformation
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLoginInformation",
            value: function getLoginInformation() {
                if (!$d426a3f2c6fbebd8$var$loginInformation) {
                    console.log("Login information not available, checking local storage");
                    $d426a3f2c6fbebd8$var$loginInformation = new (0, $e7dcbc6197905a97$export$ff6e957d40887abf)(localStorage["username"], localStorage["jwt"], JSON.parse(localStorage.roles || "[]"), localStorage["customerId"]);
                }
                return $d426a3f2c6fbebd8$var$loginInformation;
            }
        },
        {
            key: "isLoggedIn",
            value: function isLoggedIn() {
                return localStorage["jwt"];
            }
        },
        {
            key: "logout",
            value: function logout() {
                return (0, $7hBys._)(function() {
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        $d426a3f2c6fbebd8$var$loginInformation = undefined;
                        delete localStorage.jwt;
                        delete localStorage.username;
                        delete localStorage.customerId;
                        delete localStorage.roles;
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    ]);
    return LoginService;
}();
var $d426a3f2c6fbebd8$export$9aa0815bbb7f01f0 = new $d426a3f2c6fbebd8$var$LoginService();


var $e7dcbc6197905a97$export$ff6e957d40887abf = /*#__PURE__*/ function() {
    "use strict";
    function LoginInformation(username, jwt, roles, customerId) {
        (0, $5sFFs._)(this, LoginInformation);
        this.username = username;
        this.jwt = jwt;
        this.roles = roles;
        this.customerId = customerId;
    }
    (0, $8O2fV._)(LoginInformation, [
        {
            key: "hasRole",
            value: function hasRole(role) {
                return this.roles.indexOf(role) >= 0;
            }
        }
    ]);
    return LoginInformation;
}();
function $e7dcbc6197905a97$export$d4c72bab9d6cc13a() {
    var login = (0, $d426a3f2c6fbebd8$export$9aa0815bbb7f01f0).isLoggedIn() ? (0, $d426a3f2c6fbebd8$export$9aa0815bbb7f01f0).getLoginInformation() : null;
    return {
        login: login,
        selectedCustomerId: login === null || login === void 0 ? void 0 : login.customerId,
        error: null,
        count: 0,
        userPage: null,
        rangeWidth: (0, $da28a2330eaa34fb$export$d9183a4079b5f34b)[1]
    };
}




var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");


var $17VE6 = parcelRequire("17VE6");


parcelRequire("17VE6");

function $edf8719704ecd0a6$export$2b77a92f1a5ad772(props) {
    var renderHeader = function() {
        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
            className: "modal-header",
            children: props.children[0]
        });
    };
    var renderBody = function() {
        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
            className: "modal-body",
            children: props.children[1]
        });
    };
    var renderFooter = function() {
        return props.children[2] ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
            className: "modal-footer",
            children: props.children[2]
        }) : "";
    };
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        className: "modal-container",
        onClick: function(event) {
            event.stopPropagation();
            props.onOutSideClick && props.onOutsideClick();
        },
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                className: "modal",
                onClick: function(event) {
                    return event.stopPropagation();
                },
                children: [
                    renderHeader(),
                    renderBody(),
                    renderFooter()
                ]
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {})
        ]
    });
}


function $51f1e577e583f24c$export$21a94553ffa41578(props) {
    var _useState = (0, $52tJv._)((0, $17VE6.useState)({
        username: "",
        password: "",
        keepLoggedIn: false
    }), 2), state = _useState[0], setState = _useState[1];
    function handleUsernameChange(event) {
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            username: event.target.value
        }));
    }
    function handlePasswordChange(event) {
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            password: event.target.value
        }));
    }
    function handleSubmit(event) {
        event.preventDefault();
        props.onSubmit(state.username, state.password);
    }
    function renderError() {
        if (props.error) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
            className: "form-row error",
            children: [
                " Unable to login: ",
                props.error
            ]
        });
        else return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
            className: "form-row",
            children: "\xa0"
        });
    }
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("form", {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)((0, $edf8719704ecd0a6$export$2b77a92f1a5ad772), {
                    children: [
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                            children: "Please enter username and password"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                                    className: "form-row",
                                    children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                                        className: "label",
                                        children: "Name:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                                    className: "form-row",
                                    children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                                        id: "login-username",
                                        type: "text",
                                        value: state.username,
                                        onChange: handleUsernameChange
                                    })
                                }),
                                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                                    className: "form-row",
                                    children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                                        className: "label",
                                        children: "Password:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                                    className: "form-row",
                                    children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                                        id: "login-password",
                                        type: "password",
                                        value: state.password,
                                        onChange: handlePasswordChange
                                    })
                                }),
                                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                                    className: "form-row checkbox",
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                                    className: "form-row checkbox",
                                    children: [
                                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                                            id: "keep-logged",
                                            type: "checkbox",
                                            onChange: function() {
                                                setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
                                                    keepLoggedIn: !state.keepLoggedIn
                                                }));
                                            },
                                            checked: state.keepLoggedIn
                                        }),
                                        "Keep me logged in"
                                    ]
                                }),
                                renderError()
                            ]
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                                className: "button-row",
                                children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                                    children: "Login"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                    type: "submit",
                    style: {
                        display: "none"
                    }
                })
            ]
        })
    });
}



var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");

var $ajhIL = parcelRequire("ajhIL");


var $52tJv = parcelRequire("52tJv");

var $fyztb = parcelRequire("fyztb");


var $17VE6 = parcelRequire("17VE6");
/**
 * @module ol/Map
 */ 
var $lyFcw = parcelRequire("lyFcw");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/Object
 */ 
var $lyFcw = parcelRequire("lyFcw");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $aBSBL = parcelRequire("aBSBL");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/events/Event
 */ /**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
var $1a4702ad15857f9a$var$BaseEvent = /*#__PURE__*/ function() {
    "use strict";
    function BaseEvent(type) {
        (0, $5sFFs._)(this, BaseEvent);
        /**
     * @type {boolean}
     */ this.propagationStopped;
        /**
     * @type {boolean}
     */ this.defaultPrevented;
        /**
     * The event type.
     * @type {string}
     * @api
     */ this.type = type;
        /**
     * The event target.
     * @type {Object}
     * @api
     */ this.target = null;
    }
    (0, $8O2fV._)(BaseEvent, [
        {
            /**
   * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
   * will be fired.
   * @api
   */ key: "preventDefault",
            value: function preventDefault() {
                this.defaultPrevented = true;
            }
        },
        {
            /**
   * Stop event propagation.
   * @api
   */ key: "stopPropagation",
            value: function stopPropagation() {
                this.propagationStopped = true;
            }
        }
    ]);
    return BaseEvent;
}();
function $1a4702ad15857f9a$export$51134cce184326b9(evt) {
    evt.stopPropagation();
}
function $1a4702ad15857f9a$export$fa3b29edae795ef4(evt) {
    evt.preventDefault();
}
var $1a4702ad15857f9a$export$2e2bcd8739ae039 = $1a4702ad15857f9a$var$BaseEvent;


/**
 * @module ol/ObjectEventType
 */ /**
 * @enum {string}
 */ var $feee417cd33a5f20$export$2e2bcd8739ae039 /**
 * @typedef {'propertychange'} Types
 */  = {
    /**
   * Triggered when a property is changed.
   * @event module:ol/Object.ObjectEvent#propertychange
   * @api
   */ PROPERTYCHANGE: "propertychange"
};


/**
 * @module ol/Observable
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $aBSBL = parcelRequire("aBSBL");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/events/Target
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/Disposable
 */ /**
 * @classdesc
 * Objects that need to clean up after themselves.
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
var $2a74d1a591bba5b3$var$Disposable = /*#__PURE__*/ function() {
    "use strict";
    function Disposable() {
        (0, $5sFFs._)(this, Disposable);
        /**
     * The object has already been disposed.
     * @type {boolean}
     * @protected
     */ this.disposed = false;
    }
    (0, $8O2fV._)(Disposable, [
        {
            /**
   * Clean up.
   */ key: "dispose",
            value: function dispose() {
                if (!this.disposed) {
                    this.disposed = true;
                    this.disposeInternal();
                }
            }
        },
        {
            /**
   * Extension point for disposable objects.
   * @protected
   */ key: "disposeInternal",
            value: function disposeInternal() {}
        }
    ]);
    return Disposable;
}();
var $2a74d1a591bba5b3$export$2e2bcd8739ae039 = $2a74d1a591bba5b3$var$Disposable;



/**
 * @module ol/functions
 */ /**
 * @module ol/array
 */ /**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function} [comparator] Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */ function $edee3659e50a93f4$export$2e0ae67339d5f1ac(haystack, needle, comparator) {
    var mid, cmp;
    comparator = comparator || $edee3659e50a93f4$export$fcb633242ef15540;
    var low = 0;
    var high = haystack.length;
    var found = false;
    while(low < high){
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
     * to double (which gives the wrong results). */ mid = low + (high - low >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) /* Too low. */ low = mid + 1;
        else {
            /* Key found or too high */ high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */ return found ? low : ~low;
}
function $edee3659e50a93f4$export$fcb633242ef15540(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $edee3659e50a93f4$export$4fa3190a997c3d8f(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function $edee3659e50a93f4$export$8a3786cc03fdb777(arr, target, direction) {
    if (arr[0] <= target) return 0;
    var n = arr.length;
    if (target <= arr[n - 1]) return n - 1;
    if (typeof direction === "function") {
        for(var i = 1; i < n; ++i){
            var candidate = arr[i];
            if (candidate === target) return i;
            if (candidate < target) {
                if (direction(target, arr[i - 1], candidate) > 0) return i - 1;
                return i;
            }
        }
        return n - 1;
    }
    if (direction > 0) {
        for(var i1 = 1; i1 < n; ++i1){
            if (arr[i1] < target) return i1 - 1;
        }
        return n - 1;
    }
    if (direction < 0) {
        for(var i2 = 1; i2 < n; ++i2){
            if (arr[i2] <= target) return i2;
        }
        return n - 1;
    }
    for(var i3 = 1; i3 < n; ++i3){
        if (arr[i3] == target) return i3;
        if (arr[i3] < target) {
            if (arr[i3 - 1] - target < target - arr[i3]) return i3 - 1;
            return i3;
        }
    }
    return n - 1;
}
function $edee3659e50a93f4$export$292cfa960964f0e0(arr, begin, end) {
    while(begin < end){
        var tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
function $edee3659e50a93f4$export$8b58be045bf06082(arr, data) {
    var extension = Array.isArray(data) ? data : [
        data
    ];
    var length = extension.length;
    for(var i = 0; i < length; i++)arr[arr.length] = extension[i];
}
function $edee3659e50a93f4$export$cd7f480d6b8286c3(arr, obj) {
    var i = arr.indexOf(obj);
    var found = i > -1;
    if (found) arr.splice(i, 1);
    return found;
}
function $edee3659e50a93f4$export$e9bab7fafb253603(arr1, arr2) {
    var len1 = arr1.length;
    if (len1 !== arr2.length) return false;
    for(var i = 0; i < len1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $edee3659e50a93f4$export$c7d3d1f96a700512(arr, compareFnc) {
    var length = arr.length;
    var tmp = Array(arr.length);
    var i;
    for(i = 0; i < length; i++)tmp[i] = {
        index: i,
        value: arr[i]
    };
    tmp.sort(function(a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for(i = 0; i < arr.length; i++)arr[i] = tmp[i].value;
}
function $edee3659e50a93f4$export$efa610630f9e181(arr, func, strict) {
    var compare = func || $edee3659e50a93f4$export$fcb633242ef15540;
    return arr.every(function(currentVal, index) {
        if (index === 0) return true;
        var res = compare(arr[index - 1], currentVal);
        return !(res > 0 || strict && res === 0);
    });
}


function $d0c140d5afad5e7c$export$22e23a2304399231() {
    return true;
}
function $d0c140d5afad5e7c$export$8f11cee4bdc7e668() {
    return false;
}
function $d0c140d5afad5e7c$export$1cd1943b3a73bbe8() {}
function $d0c140d5afad5e7c$export$ff83df6f9971435f(fn) {
    var called = false;
    /** @type {ReturnType} */ var lastResult;
    /** @type {Array<any>} */ var lastArgs;
    var lastThis;
    return function() {
        var nextArgs = Array.prototype.slice.call(arguments);
        if (!called || this !== lastThis || !(0, $edee3659e50a93f4$export$e9bab7fafb253603)(nextArgs, lastArgs)) {
            called = true;
            lastThis = this;
            lastArgs = nextArgs;
            lastResult = fn.apply(this, arguments);
        }
        return lastResult;
    };
}
function $d0c140d5afad5e7c$export$4dbaaf6c79705e6c(getter) {
    function promiseGetter() {
        var value;
        try {
            value = getter();
        } catch (err) {
            return Promise.reject(err);
        }
        if (value instanceof Promise) return value;
        return Promise.resolve(value);
    }
    return promiseGetter();
}


/**
 * @module ol/obj
 */ /**
 * Removes all properties from an object.
 * @param {Object<string, unknown>} object The object to clear.
 */ function $29e93681307ffd1e$export$42ffd38884aecdac(object) {
    for(var property in object)delete object[property];
}
function $29e93681307ffd1e$export$dd1bc94b04021eeb(object) {
    var property;
    for(property in object)return false;
    return !property;
}


/**
 * @typedef {EventTarget|Target} EventTargetLike
 */ /**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */ var $e5f438e225cf4aef$var$Target = /*#__PURE__*/ function(Disposable) {
    "use strict";
    (0, $kcqLc._)(Target, Disposable);
    var _super = (0, $4jYWU._)(Target);
    function Target(target) {
        (0, $5sFFs._)(this, Target);
        var _this;
        _this = _super.call(this);
        /**
     * @private
     * @type {*}
     */ _this.eventTarget_ = target;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ _this.pendingRemovals_ = null;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ _this.dispatching_ = null;
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").Listener>>|null}
     */ _this.listeners_ = null;
        return _this;
    }
    (0, $8O2fV._)(Target, [
        {
            /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ key: "addEventListener",
            value: function addEventListener(type, listener) {
                if (!type || !listener) return;
                var listeners = this.listeners_ || (this.listeners_ = {});
                var listenersForType = listeners[type] || (listeners[type] = []);
                if (!listenersForType.includes(listener)) listenersForType.push(listener);
            }
        },
        {
            /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */ key: "dispatchEvent",
            value: function dispatchEvent(event) {
                var isString = typeof event === "string";
                var type = isString ? event : event.type;
                var listeners = this.listeners_ && this.listeners_[type];
                if (!listeners) return;
                var evt = isString ? new (0, $1a4702ad15857f9a$export$2e2bcd8739ae039)(event) : /** @type {Event} */ event;
                if (!evt.target) evt.target = this.eventTarget_ || this;
                var dispatching = this.dispatching_ || (this.dispatching_ = {});
                var pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});
                if (!(type in dispatching)) {
                    dispatching[type] = 0;
                    pendingRemovals[type] = 0;
                }
                ++dispatching[type];
                var propagate;
                for(var i = 0, ii = listeners.length; i < ii; ++i){
                    if ("handleEvent" in listeners[i]) propagate = /** @type {import("../events.js").ListenerObject} */ listeners[i].handleEvent(evt);
                    else propagate = /** @type {import("../events.js").ListenerFunction} */ listeners[i].call(this, evt);
                    if (propagate === false || evt.propagationStopped) {
                        propagate = false;
                        break;
                    }
                }
                if (--dispatching[type] === 0) {
                    var pr = pendingRemovals[type];
                    delete pendingRemovals[type];
                    while(pr--)this.removeEventListener(type, (0, $d0c140d5afad5e7c$export$1cd1943b3a73bbe8));
                    delete dispatching[type];
                }
                return propagate;
            }
        },
        {
            /**
   * Clean up.
   */ key: "disposeInternal",
            value: function disposeInternal() {
                this.listeners_ && (0, $29e93681307ffd1e$export$42ffd38884aecdac)(this.listeners_);
            }
        },
        {
            /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").Listener>|undefined} Listeners.
   */ key: "getListeners",
            value: function getListeners(type) {
                return this.listeners_ && this.listeners_[type] || undefined;
            }
        },
        {
            /**
   * @param {string} [type] Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */ key: "hasListener",
            value: function hasListener(type) {
                if (!this.listeners_) return false;
                return type ? type in this.listeners_ : Object.keys(this.listeners_).length > 0;
            }
        },
        {
            /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ key: "removeEventListener",
            value: function removeEventListener(type, listener) {
                if (!this.listeners_) return;
                var listeners = this.listeners_[type];
                if (!listeners) return;
                var index = listeners.indexOf(listener);
                if (index !== -1) {
                    if (this.pendingRemovals_ && type in this.pendingRemovals_) {
                        // make listener a no-op, and remove later in #dispatchEvent()
                        listeners[index] = (0, $d0c140d5afad5e7c$export$1cd1943b3a73bbe8);
                        ++this.pendingRemovals_[type];
                    } else {
                        listeners.splice(index, 1);
                        if (listeners.length === 0) delete this.listeners_[type];
                    }
                }
            }
        }
    ]);
    return Target;
}((0, $2a74d1a591bba5b3$export$2e2bcd8739ae039));
var $e5f438e225cf4aef$export$2e2bcd8739ae039 = $e5f438e225cf4aef$var$Target;


/**
 * @module ol/events/EventType
 */ /**
 * @enum {string}
 * @const
 */ var $f5ea4d8d74b7a514$export$2e2bcd8739ae039 = {
    /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~BaseEvent#change
   * @api
   */ CHANGE: "change",
    /**
   * Generic error event. Triggered when an error occurs.
   * @event module:ol/events/Event~BaseEvent#error
   * @api
   */ ERROR: "error",
    BLUR: "blur",
    CLEAR: "clear",
    CONTEXTMENU: "contextmenu",
    CLICK: "click",
    DBLCLICK: "dblclick",
    DRAGENTER: "dragenter",
    DRAGOVER: "dragover",
    DROP: "drop",
    FOCUS: "focus",
    KEYDOWN: "keydown",
    KEYPRESS: "keypress",
    LOAD: "load",
    RESIZE: "resize",
    TOUCHMOVE: "touchmove",
    WHEEL: "wheel"
};


/**
 * @module ol/events
 */ 
function $5b08b5a7fd85a110$export$63174c828edd6ff8(target, type, listener, thisArg, once) {
    if (thisArg && thisArg !== target) listener = listener.bind(thisArg);
    if (once) {
        var originalListener = listener;
        listener = function() {
            target.removeEventListener(type, listener);
            originalListener.apply(this, arguments);
        };
    }
    var eventsKey = {
        target: target,
        type: type,
        listener: listener
    };
    target.addEventListener(type, listener);
    return eventsKey;
}
function $5b08b5a7fd85a110$export$8d2a95bc11b44725(target, type, listener, thisArg) {
    return $5b08b5a7fd85a110$export$63174c828edd6ff8(target, type, listener, thisArg, true);
}
function $5b08b5a7fd85a110$export$b0a21c8b3c1c921(key) {
    if (key && key.target) {
        key.target.removeEventListener(key.type, key.listener);
        (0, $29e93681307ffd1e$export$42ffd38884aecdac)(key);
    }
}


/***
 * @template {string} Type
 * @template {Event|import("./events/Event.js").default} EventClass
 * @template Return
 * @typedef {(type: Type, listener: (event: EventClass) => ?) => Return} OnSignature
 */ /***
 * @template {string} Type
 * @template Return
 * @typedef {(type: Type[], listener: (event: Event|import("./events/Event").default) => ?) => Return extends void ? void : Return[]} CombinedOnSignature
 */ /**
 * @typedef {'change'|'error'} EventTypes
 */ /***
 * @template Return
 * @typedef {OnSignature<EventTypes, import("./events/Event.js").default, Return> & CombinedOnSignature<EventTypes, Return>} ObservableOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */ var $ce1a65fd3436dc4f$var$Observable = /*#__PURE__*/ function(EventTarget) {
    "use strict";
    (0, $kcqLc._)(Observable, EventTarget);
    var _super = (0, $4jYWU._)(Observable);
    function Observable() {
        (0, $5sFFs._)(this, Observable);
        var _this;
        _this = _super.call(this);
        _this.on = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ _this.onInternal;
        _this.once = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ _this.onceInternal;
        _this.un = /** @type {ObservableOnSignature<void>} */ _this.unInternal;
        /**
     * @private
     * @type {number}
     */ _this.revision_ = 0;
        return _this;
    }
    (0, $8O2fV._)(Observable, [
        {
            /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */ key: "changed",
            value: function changed() {
                ++this.revision_;
                this.dispatchEvent((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE);
            }
        },
        {
            /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */ key: "getRevision",
            value: function getRevision() {
                return this.revision_;
            }
        },
        {
            /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ key: "onInternal",
            value: function onInternal(type, listener) {
                if (Array.isArray(type)) {
                    var len = type.length;
                    var keys = new Array(len);
                    for(var i = 0; i < len; ++i)keys[i] = (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(this, type[i], listener);
                    return keys;
                }
                return (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(this, /** @type {string} */ type, listener);
            }
        },
        {
            /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ key: "onceInternal",
            value: function onceInternal(type, listener) {
                var key;
                if (Array.isArray(type)) {
                    var len = type.length;
                    key = new Array(len);
                    for(var i = 0; i < len; ++i)key[i] = (0, $5b08b5a7fd85a110$export$8d2a95bc11b44725)(this, type[i], listener);
                } else key = (0, $5b08b5a7fd85a110$export$8d2a95bc11b44725)(this, /** @type {string} */ type, listener);
                /** @type {Object} */ listener.ol_key = key;
                return key;
            }
        },
        {
            /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @protected
   */ key: "unInternal",
            value: function unInternal(type, listener) {
                var key = /** @type {Object} */ listener.ol_key;
                if (key) $ce1a65fd3436dc4f$export$b7ef3f8527533384(key);
                else if (Array.isArray(type)) for(var i = 0, ii = type.length; i < ii; ++i)this.removeEventListener(type[i], listener);
                else this.removeEventListener(type, listener);
            }
        }
    ]);
    return Observable;
}((0, $aBSBL._)((0, $e5f438e225cf4aef$export$2e2bcd8739ae039)));
/**
 * Listen for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $ce1a65fd3436dc4f$var$Observable.prototype.on;
/**
 * Listen once for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $ce1a65fd3436dc4f$var$Observable.prototype.once;
/**
 * Unlisten for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @api
 */ $ce1a65fd3436dc4f$var$Observable.prototype.un;
function $ce1a65fd3436dc4f$export$b7ef3f8527533384(key) {
    if (Array.isArray(key)) for(var i = 0, ii = key.length; i < ii; ++i)(0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921)(key[i]);
    else (0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921)(/** @type {import("./events.js").EventsKey} */ key);
}
var $ce1a65fd3436dc4f$export$2e2bcd8739ae039 = $ce1a65fd3436dc4f$var$Observable;


/**
 * @module ol/util
 */ /**
 * @return {never} Any return.
 */ function $8b32fff2376556ef$export$817eb92a8194bab0() {
    throw new Error("Unimplemented abstract method.");
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */ var $8b32fff2376556ef$var$uidCounter_ = 0;
function $8b32fff2376556ef$export$5e82334337e0f204(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++$8b32fff2376556ef$var$uidCounter_));
}
var $8b32fff2376556ef$export$a4ad2735b021c132 = "8.2.0";



var $7a8d25d40aa0de7f$export$cf395d7c4a2d5a17 = /*#__PURE__*/ function(Event) {
    "use strict";
    (0, $kcqLc._)(ObjectEvent, Event);
    var _super = (0, $4jYWU._)(ObjectEvent);
    function ObjectEvent(type, key, oldValue) {
        (0, $5sFFs._)(this, ObjectEvent);
        var _this;
        _this = _super.call(this, type);
        /**
     * The name of the property whose value is changing.
     * @type {string}
     * @api
     */ _this.key = key;
        /**
     * The old value. To get the new value use `e.target.get(e.key)` where
     * `e` is the event object.
     * @type {*}
     * @api
     */ _this.oldValue = oldValue;
        return _this;
    }
    return ObjectEvent;
}((0, $aBSBL._)((0, $1a4702ad15857f9a$export$2e2bcd8739ae039)));
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<import("./ObjectEventType").Types, ObjectEvent, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types, Return>} ObjectOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable~Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @api
 */ var $7a8d25d40aa0de7f$var$BaseObject = /*#__PURE__*/ function(Observable) {
    "use strict";
    (0, $kcqLc._)(BaseObject, Observable);
    var _super = (0, $4jYWU._)(BaseObject);
    function BaseObject(values) {
        (0, $5sFFs._)(this, BaseObject);
        var _this;
        _this = _super.call(this);
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ _this.on;
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ _this.once;
        /***
     * @type {ObjectOnSignature<void>}
     */ _this.un;
        // Call {@link module:ol/util.getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        (0, $8b32fff2376556ef$export$5e82334337e0f204)((0, $lyFcw._)(_this));
        /**
     * @private
     * @type {Object<string, *>|null}
     */ _this.values_ = null;
        if (values !== undefined) _this.setProperties(values);
        return _this;
    }
    (0, $8O2fV._)(BaseObject, [
        {
            /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */ key: "get",
            value: function get(key) {
                var value;
                if (this.values_ && this.values_.hasOwnProperty(key)) value = this.values_[key];
                return value;
            }
        },
        {
            /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */ key: "getKeys",
            value: function getKeys() {
                return this.values_ && Object.keys(this.values_) || [];
            }
        },
        {
            /**
   * Get an object of all property names and values.
   * @return {Object<string, *>} Object.
   * @api
   */ key: "getProperties",
            value: function getProperties() {
                return this.values_ && Object.assign({}, this.values_) || {};
            }
        },
        {
            /**
   * Get an object of all property names and values.
   * @return {Object<string, *>?} Object.
   */ key: "getPropertiesInternal",
            value: function getPropertiesInternal() {
                return this.values_;
            }
        },
        {
            /**
   * @return {boolean} The object has properties.
   */ key: "hasProperties",
            value: function hasProperties() {
                return !!this.values_;
            }
        },
        {
            /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */ key: "notify",
            value: function notify(key, oldValue) {
                var eventType;
                eventType = "change:".concat(key);
                if (this.hasListener(eventType)) this.dispatchEvent(new $7a8d25d40aa0de7f$export$cf395d7c4a2d5a17(eventType, key, oldValue));
                eventType = (0, $feee417cd33a5f20$export$2e2bcd8739ae039).PROPERTYCHANGE;
                if (this.hasListener(eventType)) this.dispatchEvent(new $7a8d25d40aa0de7f$export$cf395d7c4a2d5a17(eventType, key, oldValue));
            }
        },
        {
            /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ key: "addChangeListener",
            value: function addChangeListener(key, listener) {
                this.addEventListener("change:".concat(key), listener);
            }
        },
        {
            /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ key: "removeChangeListener",
            value: function removeChangeListener(key, listener) {
                this.removeEventListener("change:".concat(key), listener);
            }
        },
        {
            /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ key: "set",
            value: function set(key, value, silent) {
                var values = this.values_ || (this.values_ = {});
                if (silent) values[key] = value;
                else {
                    var oldValue = values[key];
                    values[key] = value;
                    if (oldValue !== value) this.notify(key, oldValue);
                }
            }
        },
        {
            /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Object<string, *>} values Values.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ key: "setProperties",
            value: function setProperties(values, silent) {
                for(var key in values)this.set(key, values[key], silent);
            }
        },
        {
            /**
   * Apply any properties from another object without triggering events.
   * @param {BaseObject} source The source object.
   * @protected
   */ key: "applyProperties",
            value: function applyProperties(source) {
                if (!source.values_) return;
                Object.assign(this.values_ || (this.values_ = {}), source.values_);
            }
        },
        {
            /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean} [silent] Unset without triggering an event.
   * @api
   */ key: "unset",
            value: function unset(key, silent) {
                if (this.values_ && key in this.values_) {
                    var oldValue = this.values_[key];
                    delete this.values_[key];
                    if ((0, $29e93681307ffd1e$export$dd1bc94b04021eeb)(this.values_)) this.values_ = null;
                    if (!silent) this.notify(key, oldValue);
                }
            }
        }
    ]);
    return BaseObject;
}((0, $ce1a65fd3436dc4f$export$2e2bcd8739ae039));
var $7a8d25d40aa0de7f$export$2e2bcd8739ae039 = $7a8d25d40aa0de7f$var$BaseObject;


/**
 * @module ol/Collection
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $aBSBL = parcelRequire("aBSBL");

var $4jYWU = parcelRequire("4jYWU");

/**
 * @module ol/CollectionEventType
 */ /**
 * @enum {string}
 */ var $521f555f87c855d9$export$2e2bcd8739ae039 = {
    /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */ ADD: "add",
    /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */ REMOVE: "remove"
};



/**
 * @enum {string}
 * @private
 */ var $4586ff11f2e741e8$var$Property = {
    LENGTH: "length"
};
var $4586ff11f2e741e8$export$a87ae6eb2761ec6d = /*#__PURE__*/ function(Event) {
    "use strict";
    (0, $kcqLc._)(CollectionEvent, Event);
    var _super = (0, $4jYWU._)(CollectionEvent);
    function CollectionEvent(type, element, index) {
        (0, $5sFFs._)(this, CollectionEvent);
        var _this;
        _this = _super.call(this, type);
        /**
     * The element that is added to or removed from the collection.
     * @type {T}
     * @api
     */ _this.element = element;
        /**
     * The index of the added or removed element.
     * @type {number}
     * @api
     */ _this.index = index;
        return _this;
    }
    return CollectionEvent;
}((0, $aBSBL._)((0, $1a4702ad15857f9a$export$2e2bcd8739ae039)));
/***
 * @template T
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:length', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").OnSignature<'add'|'remove', CollectionEvent<T>, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types|
 *     'change:length'|'add'|'remove',Return>} CollectionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */ /**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */ var $4586ff11f2e741e8$var$Collection = /*#__PURE__*/ function(BaseObject) {
    "use strict";
    (0, $kcqLc._)(Collection, BaseObject);
    var _super = (0, $4jYWU._)(Collection);
    function Collection(array, options) {
        (0, $5sFFs._)(this, Collection);
        var _this;
        _this = _super.call(this);
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ _this.on;
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ _this.once;
        /***
     * @type {CollectionOnSignature<T, void>}
     */ _this.un;
        options = options || {};
        /**
     * @private
     * @type {boolean}
     */ _this.unique_ = !!options.unique;
        /**
     * @private
     * @type {!Array<T>}
     */ _this.array_ = array ? array : [];
        if (_this.unique_) for(var i = 0, ii = _this.array_.length; i < ii; ++i)_this.assertUnique_(_this.array_[i], i);
        _this.updateLength_();
        return _this;
    }
    (0, $8O2fV._)(Collection, [
        {
            /**
   * Remove all elements from the collection.
   * @api
   */ key: "clear",
            value: function clear() {
                while(this.getLength() > 0)this.pop();
            }
        },
        {
            /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */ key: "extend",
            value: function extend(arr) {
                for(var i = 0, ii = arr.length; i < ii; ++i)this.push(arr[i]);
                return this;
            }
        },
        {
            /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */ key: "forEach",
            value: function forEach(f) {
                var array = this.array_;
                for(var i = 0, ii = array.length; i < ii; ++i)f(array[i], i, array);
            }
        },
        {
            /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */ key: "getArray",
            value: function getArray() {
                return this.array_;
            }
        },
        {
            /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */ key: "item",
            value: function item(index) {
                return this.array_[index];
            }
        },
        {
            /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */ key: "getLength",
            value: function getLength() {
                return this.get($4586ff11f2e741e8$var$Property.LENGTH);
            }
        },
        {
            /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ key: "insertAt",
            value: function insertAt(index, elem) {
                if (index < 0 || index > this.getLength()) throw new Error("Index out of bounds: " + index);
                if (this.unique_) this.assertUnique_(elem);
                this.array_.splice(index, 0, elem);
                this.updateLength_();
                this.dispatchEvent(new $4586ff11f2e741e8$export$a87ae6eb2761ec6d((0, $521f555f87c855d9$export$2e2bcd8739ae039).ADD, elem, index));
            }
        },
        {
            /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */ key: "pop",
            value: function pop() {
                return this.removeAt(this.getLength() - 1);
            }
        },
        {
            /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */ key: "push",
            value: function push(elem) {
                if (this.unique_) this.assertUnique_(elem);
                var n = this.getLength();
                this.insertAt(n, elem);
                return this.getLength();
            }
        },
        {
            /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */ key: "remove",
            value: function remove(elem) {
                var arr = this.array_;
                for(var i = 0, ii = arr.length; i < ii; ++i){
                    if (arr[i] === elem) return this.removeAt(i);
                }
                return undefined;
            }
        },
        {
            /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */ key: "removeAt",
            value: function removeAt(index) {
                if (index < 0 || index >= this.getLength()) return undefined;
                var prev = this.array_[index];
                this.array_.splice(index, 1);
                this.updateLength_();
                this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $4586ff11f2e741e8$export$a87ae6eb2761ec6d((0, $521f555f87c855d9$export$2e2bcd8739ae039).REMOVE, prev, index));
                return prev;
            }
        },
        {
            /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ key: "setAt",
            value: function setAt(index, elem) {
                var n = this.getLength();
                if (index >= n) {
                    this.insertAt(index, elem);
                    return;
                }
                if (index < 0) throw new Error("Index out of bounds: " + index);
                if (this.unique_) this.assertUnique_(elem, index);
                var prev = this.array_[index];
                this.array_[index] = elem;
                this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $4586ff11f2e741e8$export$a87ae6eb2761ec6d((0, $521f555f87c855d9$export$2e2bcd8739ae039).REMOVE, prev, index));
                this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $4586ff11f2e741e8$export$a87ae6eb2761ec6d((0, $521f555f87c855d9$export$2e2bcd8739ae039).ADD, elem, index));
            }
        },
        {
            /**
   * @private
   */ key: "updateLength_",
            value: function updateLength_() {
                this.set($4586ff11f2e741e8$var$Property.LENGTH, this.array_.length);
            }
        },
        {
            /**
   * @private
   * @param {T} elem Element.
   * @param {number} [except] Optional index to ignore.
   */ key: "assertUnique_",
            value: function assertUnique_(elem, except) {
                for(var i = 0, ii = this.array_.length; i < ii; ++i){
                    if (this.array_[i] === elem && i !== except) throw new Error("Duplicate item added to a unique collection");
                }
            }
        }
    ]);
    return Collection;
}((0, $7a8d25d40aa0de7f$export$2e2bcd8739ae039));
var $4586ff11f2e741e8$export$2e2bcd8739ae039 = $4586ff11f2e741e8$var$Collection;



/**
 * @module ol/renderer/Composite
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/renderer/Map
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");



/**
 * @module ol/transform
 */ /**
 * @module ol/has
 */ var $c4937aaad0f121a7$var$ua = typeof navigator !== "undefined" && typeof navigator.userAgent !== "undefined" ? navigator.userAgent.toLowerCase() : "";
var $c4937aaad0f121a7$export$8442bdfd18b7b8a6 = $c4937aaad0f121a7$var$ua.includes("firefox");
var $c4937aaad0f121a7$export$3227bfbdaa9275de = $c4937aaad0f121a7$var$ua.includes("safari") && !$c4937aaad0f121a7$var$ua.includes("chrom");
var $c4937aaad0f121a7$export$b23eed0e325a206a = $c4937aaad0f121a7$export$3227bfbdaa9275de && ($c4937aaad0f121a7$var$ua.includes("version/15.4") || /cpu (os|iphone os) 15_4 like mac os x/.test($c4937aaad0f121a7$var$ua));
var $c4937aaad0f121a7$export$39dfd62a25e0fe93 = $c4937aaad0f121a7$var$ua.includes("webkit") && !$c4937aaad0f121a7$var$ua.includes("edge");
var $c4937aaad0f121a7$export$76c0a3b101d93136 = $c4937aaad0f121a7$var$ua.includes("macintosh");
var $c4937aaad0f121a7$export$6b83a0446fc26f94 = typeof devicePixelRatio !== "undefined" ? devicePixelRatio : 1;
var $c4937aaad0f121a7$export$98fcef3dc9973292 = typeof WorkerGlobalScope !== "undefined" && typeof OffscreenCanvas !== "undefined" && self instanceof WorkerGlobalScope; //eslint-disable-line
var $c4937aaad0f121a7$export$716f8695eedb9bad = typeof Image !== "undefined" && Image.prototype.decode;
var $c4937aaad0f121a7$export$7478563940788376 = typeof createImageBitmap === "function";
var $c4937aaad0f121a7$export$f751ce96c6c4e4fc = function() {
    var passive = false;
    try {
        var options = Object.defineProperty({}, "passive", {
            get: function get() {
                passive = true;
            }
        });
        // @ts-ignore Ignore invalid event type '_'
        window.addEventListener("_", null, options);
        // @ts-ignore Ignore invalid event type '_'
        window.removeEventListener("_", null, options);
    } catch (error) {
    // passive not supported
    }
    return passive;
}();


/**
 * @module ol/asserts
 */ /**
 * @param {*} assertion Assertion we expected to be truthy.
 * @param {string} errorMessage Error message.
 */ function $100b4414e338a711$export$a7a9523472993e97(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}


/**
 * An array representing an affine 2d transformation for use with
 * {@link module:ol/transform} functions. The array has 6 elements.
 * @typedef {!Array<number>} Transform
 * @api
 */ /**
 * Collection of affine 2d transformation functions. The functions work on an
 * array of 6 elements. The element order is compatible with the [SVGMatrix
 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
 * a subset (elements a to f) of a 3×3 matrix:
 * ```
 * [ a c e ]
 * [ b d f ]
 * [ 0 0 1 ]
 * ```
 */ /**
 * @private
 * @type {Transform}
 */ var $afa6393b3817702c$var$tmp_ = new Array(6);
function $afa6393b3817702c$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $afa6393b3817702c$export$aad8462122ac592b(transform) {
    return $afa6393b3817702c$export$adaa4cf7ef1b65be(transform, 1, 0, 0, 1, 0, 0);
}
function $afa6393b3817702c$export$2060d2db72cce88f(transform1, transform2) {
    var a1 = transform1[0];
    var b1 = transform1[1];
    var c1 = transform1[2];
    var d1 = transform1[3];
    var e1 = transform1[4];
    var f1 = transform1[5];
    var a2 = transform2[0];
    var b2 = transform2[1];
    var c2 = transform2[2];
    var d2 = transform2[3];
    var e2 = transform2[4];
    var f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
function $afa6393b3817702c$export$adaa4cf7ef1b65be(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
function $afa6393b3817702c$export$42b4187a82d80ed0(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
function $afa6393b3817702c$export$5635d7ef4b8fee1c(transform, coordinate) {
    var x = coordinate[0];
    var y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
function $afa6393b3817702c$export$bb628a54ab399bc9(transform, angle) {
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    return $afa6393b3817702c$export$2060d2db72cce88f(transform, $afa6393b3817702c$export$adaa4cf7ef1b65be($afa6393b3817702c$var$tmp_, cos, sin, -sin, cos, 0, 0));
}
function $afa6393b3817702c$export$dcdf75081b88279d(transform, x, y) {
    return $afa6393b3817702c$export$2060d2db72cce88f(transform, $afa6393b3817702c$export$adaa4cf7ef1b65be($afa6393b3817702c$var$tmp_, x, 0, 0, y, 0, 0));
}
function $afa6393b3817702c$export$3e4e33ea14aeb531(target, x, y) {
    return $afa6393b3817702c$export$adaa4cf7ef1b65be(target, x, 0, 0, y, 0, 0);
}
function $afa6393b3817702c$export$d73ee8ef04f5226a(transform, dx, dy) {
    return $afa6393b3817702c$export$2060d2db72cce88f(transform, $afa6393b3817702c$export$adaa4cf7ef1b65be($afa6393b3817702c$var$tmp_, 1, 0, 0, 1, dx, dy));
}
function $afa6393b3817702c$export$f672e0b6f7222cd7(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    var sin = Math.sin(angle);
    var cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
function $afa6393b3817702c$export$12a96a1aaf5558e3(dx1, dy1, sx, sy, angle, dx2, dy2) {
    return $afa6393b3817702c$export$f84e8e69fd4488a5($afa6393b3817702c$export$f672e0b6f7222cd7($afa6393b3817702c$export$185802fd694ee1f5(), dx1, dy1, sx, sy, angle, dx2, dy2));
}
function $afa6393b3817702c$export$6897c284b6f9f4dc(source) {
    return $afa6393b3817702c$export$bd70ea2a93c0fa4(source, source);
}
function $afa6393b3817702c$export$bd70ea2a93c0fa4(target, source) {
    var det = $afa6393b3817702c$export$a04698f914c55ed9(source);
    (0, $100b4414e338a711$export$a7a9523472993e97)(det !== 0, "Transformation matrix cannot be inverted");
    var a = source[0];
    var b = source[1];
    var c = source[2];
    var d = source[3];
    var e = source[4];
    var f = source[5];
    target[0] = d / det;
    target[1] = -b / det;
    target[2] = -c / det;
    target[3] = a / det;
    target[4] = (c * f - d * e) / det;
    target[5] = -(a * f - b * e) / det;
    return target;
}
function $afa6393b3817702c$export$a04698f914c55ed9(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}
/**
 * @type {HTMLElement}
 * @private
 */ var $afa6393b3817702c$var$transformStringDiv;
function $afa6393b3817702c$export$f84e8e69fd4488a5(mat) {
    var transformString = "matrix(" + mat.join(", ") + ")";
    if (0, $c4937aaad0f121a7$export$98fcef3dc9973292) return transformString;
    var node = $afa6393b3817702c$var$transformStringDiv || ($afa6393b3817702c$var$transformStringDiv = document.createElement("div"));
    node.style.transform = transformString;
    return node.style.transform;
}


/**
 * @module ol/extent
 */ 
var $52tJv = parcelRequire("52tJv");
/**
 * @module ol/extent/Relationship
 */ /**
 * Relationship to an extent.
 * @enum {number}
 */ var $b6471e48cd12371e$export$2e2bcd8739ae039 = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
};


function $e86e0aa087890eb8$export$8aceca7c77505534(coordinates) {
    var extent = $e86e0aa087890eb8$export$fe201bb3bbe031e9();
    for(var i = 0, ii = coordinates.length; i < ii; ++i)$e86e0aa087890eb8$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent} [dest] Destination extent.
 * @private
 * @return {Extent} Extent.
 */ function $e86e0aa087890eb8$var$_boundingExtentXYs(xs, ys, dest) {
    var minX = Math.min.apply(null, xs);
    var minY = Math.min.apply(null, ys);
    var maxX = Math.max.apply(null, xs);
    var maxY = Math.max.apply(null, ys);
    return $e86e0aa087890eb8$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest);
}
function $e86e0aa087890eb8$export$ab1029bcae9ddb4a(extent, value, dest) {
    if (dest) {
        dest[0] = extent[0] - value;
        dest[1] = extent[1] - value;
        dest[2] = extent[2] + value;
        dest[3] = extent[3] + value;
        return dest;
    }
    return [
        extent[0] - value,
        extent[1] - value,
        extent[2] + value,
        extent[3] + value
    ];
}
function $e86e0aa087890eb8$export$9cd59f9826255e47(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent.slice();
}
function $e86e0aa087890eb8$export$cbe64c389534206f(extent, x, y) {
    var dx, dy;
    if (x < extent[0]) dx = extent[0] - x;
    else if (extent[2] < x) dx = x - extent[2];
    else dx = 0;
    if (y < extent[1]) dy = extent[1] - y;
    else if (extent[3] < y) dy = y - extent[3];
    else dy = 0;
    return dx * dx + dy * dy;
}
function $e86e0aa087890eb8$export$ac68c24d37ca240f(extent, coordinate) {
    return $e86e0aa087890eb8$export$805bdfd6d6690e97(extent, coordinate[0], coordinate[1]);
}
function $e86e0aa087890eb8$export$be866b1e0809b17e(extent1, extent2) {
    return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] && extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
}
function $e86e0aa087890eb8$export$805bdfd6d6690e97(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
function $e86e0aa087890eb8$export$f97905ead28c61a8(extent, coordinate) {
    var minX = extent[0];
    var minY = extent[1];
    var maxX = extent[2];
    var maxY = extent[3];
    var x = coordinate[0];
    var y = coordinate[1];
    var relationship = (0, $b6471e48cd12371e$export$2e2bcd8739ae039).UNKNOWN;
    if (x < minX) relationship = relationship | (0, $b6471e48cd12371e$export$2e2bcd8739ae039).LEFT;
    else if (x > maxX) relationship = relationship | (0, $b6471e48cd12371e$export$2e2bcd8739ae039).RIGHT;
    if (y < minY) relationship = relationship | (0, $b6471e48cd12371e$export$2e2bcd8739ae039).BELOW;
    else if (y > maxY) relationship = relationship | (0, $b6471e48cd12371e$export$2e2bcd8739ae039).ABOVE;
    if (relationship === (0, $b6471e48cd12371e$export$2e2bcd8739ae039).UNKNOWN) relationship = (0, $b6471e48cd12371e$export$2e2bcd8739ae039).INTERSECTING;
    return relationship;
}
function $e86e0aa087890eb8$export$fe201bb3bbe031e9() {
    return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
}
function $e86e0aa087890eb8$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest) {
    if (dest) {
        dest[0] = minX;
        dest[1] = minY;
        dest[2] = maxX;
        dest[3] = maxY;
        return dest;
    }
    return [
        minX,
        minY,
        maxX,
        maxY
    ];
}
function $e86e0aa087890eb8$export$3e2152b047719fa1(dest) {
    return $e86e0aa087890eb8$export$958e3e1a02eac4b6(Infinity, Infinity, -Infinity, -Infinity, dest);
}
function $e86e0aa087890eb8$export$4838bf78d04a9440(coordinate, dest) {
    var x = coordinate[0];
    var y = coordinate[1];
    return $e86e0aa087890eb8$export$958e3e1a02eac4b6(x, y, x, y, dest);
}
function $e86e0aa087890eb8$export$29e3ad4dbd0cb863(coordinates, dest) {
    var extent = $e86e0aa087890eb8$export$3e2152b047719fa1(dest);
    return $e86e0aa087890eb8$export$795cd48be4d5f252(extent, coordinates);
}
function $e86e0aa087890eb8$export$be0ab0bf96ca59ca(flatCoordinates, offset, end, stride, dest) {
    var extent = $e86e0aa087890eb8$export$3e2152b047719fa1(dest);
    return $e86e0aa087890eb8$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride);
}
function $e86e0aa087890eb8$export$73b4897e93bc5c83(rings, dest) {
    var extent = $e86e0aa087890eb8$export$3e2152b047719fa1(dest);
    return $e86e0aa087890eb8$export$9b319549574402d7(extent, rings);
}
function $e86e0aa087890eb8$export$e9bab7fafb253603(extent1, extent2) {
    return extent1[0] == extent2[0] && extent1[2] == extent2[2] && extent1[1] == extent2[1] && extent1[3] == extent2[3];
}
function $e86e0aa087890eb8$export$998afeab28643bd6(extent1, extent2, tolerance) {
    return Math.abs(extent1[0] - extent2[0]) < tolerance && Math.abs(extent1[2] - extent2[2]) < tolerance && Math.abs(extent1[1] - extent2[1]) < tolerance && Math.abs(extent1[3] - extent2[3]) < tolerance;
}
function $e86e0aa087890eb8$export$8b58be045bf06082(extent1, extent2) {
    if (extent2[0] < extent1[0]) extent1[0] = extent2[0];
    if (extent2[2] > extent1[2]) extent1[2] = extent2[2];
    if (extent2[1] < extent1[1]) extent1[1] = extent2[1];
    if (extent2[3] > extent1[3]) extent1[3] = extent2[3];
    return extent1;
}
function $e86e0aa087890eb8$export$1f820e3920fa5715(extent, coordinate) {
    if (coordinate[0] < extent[0]) extent[0] = coordinate[0];
    if (coordinate[0] > extent[2]) extent[2] = coordinate[0];
    if (coordinate[1] < extent[1]) extent[1] = coordinate[1];
    if (coordinate[1] > extent[3]) extent[3] = coordinate[1];
}
function $e86e0aa087890eb8$export$795cd48be4d5f252(extent, coordinates) {
    for(var i = 0, ii = coordinates.length; i < ii; ++i)$e86e0aa087890eb8$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
function $e86e0aa087890eb8$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride) {
    for(; offset < end; offset += stride)$e86e0aa087890eb8$export$f1dab130b92b85a9(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    return extent;
}
function $e86e0aa087890eb8$export$9b319549574402d7(extent, rings) {
    for(var i = 0, ii = rings.length; i < ii; ++i)$e86e0aa087890eb8$export$795cd48be4d5f252(extent, rings[i]);
    return extent;
}
function $e86e0aa087890eb8$export$f1dab130b92b85a9(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
function $e86e0aa087890eb8$export$f9ed8a3d123a08e2(extent, callback) {
    var val;
    val = callback($e86e0aa087890eb8$export$8d09f5e2e1bf560d(extent));
    if (val) return val;
    val = callback($e86e0aa087890eb8$export$e77c1cf70445e168(extent));
    if (val) return val;
    val = callback($e86e0aa087890eb8$export$b84fa077c8b05295(extent));
    if (val) return val;
    val = callback($e86e0aa087890eb8$export$cb1538b07e6964ff(extent));
    if (val) return val;
    return false;
}
function $e86e0aa087890eb8$export$520c40045967cb15(extent) {
    var area = 0;
    if (!$e86e0aa087890eb8$export$dd1bc94b04021eeb(extent)) area = $e86e0aa087890eb8$export$3c49c185de0c2bfc(extent) * $e86e0aa087890eb8$export$c08559766941f856(extent);
    return area;
}
function $e86e0aa087890eb8$export$8d09f5e2e1bf560d(extent) {
    return [
        extent[0],
        extent[1]
    ];
}
function $e86e0aa087890eb8$export$e77c1cf70445e168(extent) {
    return [
        extent[2],
        extent[1]
    ];
}
function $e86e0aa087890eb8$export$c91255cadecfe081(extent) {
    return [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2
    ];
}
function $e86e0aa087890eb8$export$a1cfd206661d0801(extent, corner) {
    var coordinate;
    if (corner === "bottom-left") coordinate = $e86e0aa087890eb8$export$8d09f5e2e1bf560d(extent);
    else if (corner === "bottom-right") coordinate = $e86e0aa087890eb8$export$e77c1cf70445e168(extent);
    else if (corner === "top-left") coordinate = $e86e0aa087890eb8$export$cb1538b07e6964ff(extent);
    else if (corner === "top-right") coordinate = $e86e0aa087890eb8$export$b84fa077c8b05295(extent);
    else throw new Error("Invalid corner");
    return coordinate;
}
function $e86e0aa087890eb8$export$7d6fa884b32a3751(extent1, extent2) {
    var minX = Math.min(extent1[0], extent2[0]);
    var minY = Math.min(extent1[1], extent2[1]);
    var maxX = Math.max(extent1[2], extent2[2]);
    var maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
function $e86e0aa087890eb8$export$13ba650faf8308(center, resolution, rotation, size, dest) {
    var _getRotatedViewport = (0, $52tJv._)($e86e0aa087890eb8$export$4b7a6fb4002cd6ac(center, resolution, rotation, size), 8), x0 = _getRotatedViewport[0], y0 = _getRotatedViewport[1], x1 = _getRotatedViewport[2], y1 = _getRotatedViewport[3], x2 = _getRotatedViewport[4], y2 = _getRotatedViewport[5], x3 = _getRotatedViewport[6], y3 = _getRotatedViewport[7];
    return $e86e0aa087890eb8$export$958e3e1a02eac4b6(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), dest);
}
function $e86e0aa087890eb8$export$4b7a6fb4002cd6ac(center, resolution, rotation, size) {
    var dx = resolution * size[0] / 2;
    var dy = resolution * size[1] / 2;
    var cosRotation = Math.cos(rotation);
    var sinRotation = Math.sin(rotation);
    var xCos = dx * cosRotation;
    var xSin = dx * sinRotation;
    var yCos = dy * cosRotation;
    var ySin = dy * sinRotation;
    var x = center[0];
    var y = center[1];
    return [
        x - xCos + ySin,
        y - xSin - yCos,
        x - xCos - ySin,
        y - xSin + yCos,
        x + xCos - ySin,
        y + xSin + yCos,
        x + xCos + ySin,
        y + xSin - yCos,
        x - xCos + ySin,
        y - xSin - yCos
    ];
}
function $e86e0aa087890eb8$export$c08559766941f856(extent) {
    return extent[3] - extent[1];
}
function $e86e0aa087890eb8$export$f3fe0e9a60cde324(extent1, extent2) {
    var intersection = $e86e0aa087890eb8$export$72209efa88586d42(extent1, extent2);
    return $e86e0aa087890eb8$export$520c40045967cb15(intersection);
}
function $e86e0aa087890eb8$export$72209efa88586d42(extent1, extent2, dest) {
    var intersection = dest ? dest : $e86e0aa087890eb8$export$fe201bb3bbe031e9();
    if ($e86e0aa087890eb8$export$7b0a31e10bbff018(extent1, extent2)) {
        if (extent1[0] > extent2[0]) intersection[0] = extent1[0];
        else intersection[0] = extent2[0];
        if (extent1[1] > extent2[1]) intersection[1] = extent1[1];
        else intersection[1] = extent2[1];
        if (extent1[2] < extent2[2]) intersection[2] = extent1[2];
        else intersection[2] = extent2[2];
        if (extent1[3] < extent2[3]) intersection[3] = extent1[3];
        else intersection[3] = extent2[3];
    } else $e86e0aa087890eb8$export$3e2152b047719fa1(intersection);
    return intersection;
}
function $e86e0aa087890eb8$export$1bc603050bd777b1(extent) {
    return $e86e0aa087890eb8$export$3c49c185de0c2bfc(extent) + $e86e0aa087890eb8$export$c08559766941f856(extent);
}
function $e86e0aa087890eb8$export$31b21d0167753bb4(extent) {
    return [
        extent[2] - extent[0],
        extent[3] - extent[1]
    ];
}
function $e86e0aa087890eb8$export$cb1538b07e6964ff(extent) {
    return [
        extent[0],
        extent[3]
    ];
}
function $e86e0aa087890eb8$export$b84fa077c8b05295(extent) {
    return [
        extent[2],
        extent[3]
    ];
}
function $e86e0aa087890eb8$export$3c49c185de0c2bfc(extent) {
    return extent[2] - extent[0];
}
function $e86e0aa087890eb8$export$7b0a31e10bbff018(extent1, extent2) {
    return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] && extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}
function $e86e0aa087890eb8$export$dd1bc94b04021eeb(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
function $e86e0aa087890eb8$export$6a4fe494c558c238(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent;
}
function $e86e0aa087890eb8$export$80cbab86674143b6(extent, value) {
    var deltaX = (extent[2] - extent[0]) / 2 * (value - 1);
    var deltaY = (extent[3] - extent[1]) / 2 * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
function $e86e0aa087890eb8$export$a6a5a7a461419425(extent, start, end) {
    var intersects = false;
    var startRel = $e86e0aa087890eb8$export$f97905ead28c61a8(extent, start);
    var endRel = $e86e0aa087890eb8$export$f97905ead28c61a8(extent, end);
    if (startRel === (0, $b6471e48cd12371e$export$2e2bcd8739ae039).INTERSECTING || endRel === (0, $b6471e48cd12371e$export$2e2bcd8739ae039).INTERSECTING) intersects = true;
    else {
        var minX = extent[0];
        var minY = extent[1];
        var maxX = extent[2];
        var maxY = extent[3];
        var startX = start[0];
        var startY = start[1];
        var endX = end[0];
        var endY = end[1];
        var slope = (endY - startY) / (endX - startX);
        var x, y;
        if (!!(endRel & (0, $b6471e48cd12371e$export$2e2bcd8739ae039).ABOVE) && !(startRel & (0, $b6471e48cd12371e$export$2e2bcd8739ae039).ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $b6471e48cd12371e$export$2e2bcd8739ae039).RIGHT) && !(startRel & (0, $b6471e48cd12371e$export$2e2bcd8739ae039).RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects && !!(endRel & (0, $b6471e48cd12371e$export$2e2bcd8739ae039).BELOW) && !(startRel & (0, $b6471e48cd12371e$export$2e2bcd8739ae039).BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $b6471e48cd12371e$export$2e2bcd8739ae039).LEFT) && !(startRel & (0, $b6471e48cd12371e$export$2e2bcd8739ae039).LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
function $e86e0aa087890eb8$export$9f9dcb98c894b623(extent, transformFn, dest, stops) {
    if ($e86e0aa087890eb8$export$dd1bc94b04021eeb(extent)) return $e86e0aa087890eb8$export$3e2152b047719fa1(dest);
    var coordinates = [];
    if (stops > 1) {
        var width = extent[2] - extent[0];
        var height = extent[3] - extent[1];
        for(var i = 0; i < stops; ++i)coordinates.push(extent[0] + width * i / stops, extent[1], extent[2], extent[1] + height * i / stops, extent[2] - width * i / stops, extent[3], extent[0], extent[3] - height * i / stops);
    } else coordinates = [
        extent[0],
        extent[1],
        extent[2],
        extent[1],
        extent[2],
        extent[3],
        extent[0],
        extent[3]
    ];
    transformFn(coordinates, coordinates, 2);
    var xs = [];
    var ys = [];
    for(var i1 = 0, l = coordinates.length; i1 < l; i1 += 2){
        xs.push(coordinates[i1]);
        ys.push(coordinates[i1 + 1]);
    }
    return $e86e0aa087890eb8$var$_boundingExtentXYs(xs, ys, dest);
}
function $e86e0aa087890eb8$export$39a9ce3624977b84(extent, projection) {
    var projectionExtent = projection.getExtent();
    var center = $e86e0aa087890eb8$export$c91255cadecfe081(extent);
    if (projection.canWrapX() && (center[0] < projectionExtent[0] || center[0] >= projectionExtent[2])) {
        var worldWidth = $e86e0aa087890eb8$export$3c49c185de0c2bfc(projectionExtent);
        var worldsAway = Math.floor((center[0] - projectionExtent[0]) / worldWidth);
        var offset = worldsAway * worldWidth;
        extent[0] -= offset;
        extent[2] -= offset;
    }
    return extent;
}
function $e86e0aa087890eb8$export$9031237f01de0947(extent, projection) {
    if (projection.canWrapX()) {
        var projectionExtent = projection.getExtent();
        if (!isFinite(extent[0]) || !isFinite(extent[2])) return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        $e86e0aa087890eb8$export$39a9ce3624977b84(extent, projection);
        var worldWidth = $e86e0aa087890eb8$export$3c49c185de0c2bfc(projectionExtent);
        if ($e86e0aa087890eb8$export$3c49c185de0c2bfc(extent) > worldWidth) // the extent wraps around on itself
        return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        if (extent[0] < projectionExtent[0]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0] + worldWidth,
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2],
                extent[3]
            ]
        ];
        if (extent[2] > projectionExtent[2]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2] - worldWidth,
                extent[3]
            ]
        ];
    }
    return [
        extent
    ];
}


/**
 * @module ol/style/IconImageCache
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
/**
 * @module ol/color
 */ /**
 * Cylindrical CIE LUV
 *
 * @module color-space/lchuv
 */ /**
 * CIE LUV (C'est la vie)
 *
 * @module color-space/luv
 */ /**
 * CIE XYZ
 *
 * @module  color-space/xyz
 */ /**
 * RGB space.
 *
 * @module  color-space/rgb
 */ var $7e72a7d6ff8acadf$export$2e2bcd8739ae039 = {
    name: "rgb",
    min: [
        0,
        0,
        0
    ],
    max: [
        255,
        255,
        255
    ],
    channel: [
        "red",
        "green",
        "blue"
    ],
    alias: [
        "RGB"
    ]
};


var $7634b6e0defee048$var$xyz = {
    name: "xyz",
    min: [
        0,
        0,
        0
    ],
    channel: [
        "X",
        "Y",
        "Z"
    ],
    alias: [
        "XYZ",
        "ciexyz",
        "cie1931"
    ]
};
/**
 * Whitepoint reference values with observer/illuminant
 *
 * http://en.wikipedia.org/wiki/Standard_illuminant
 */ $7634b6e0defee048$var$xyz.whitepoint = {
    //1931 2°
    2: {
        //incadescent
        A: [
            109.85,
            100,
            35.585
        ],
        // B:[],
        C: [
            98.074,
            100,
            118.232
        ],
        D50: [
            96.422,
            100,
            82.521
        ],
        D55: [
            95.682,
            100,
            92.149
        ],
        //daylight
        D65: [
            95.045592705167,
            100,
            108.9057750759878
        ],
        D75: [
            94.972,
            100,
            122.638
        ],
        //flourescent
        // F1: [],
        F2: [
            99.187,
            100,
            67.395
        ],
        // F3: [],
        // F4: [],
        // F5: [],
        // F6:[],
        F7: [
            95.044,
            100,
            108.755
        ],
        // F8: [],
        // F9: [],
        // F10: [],
        F11: [
            100.966,
            100,
            64.370
        ],
        // F12: [],
        E: [
            100,
            100,
            100
        ]
    },
    //1964  10°
    10: {
        //incadescent
        A: [
            111.144,
            100,
            35.200
        ],
        C: [
            97.285,
            100,
            116.145
        ],
        D50: [
            96.720,
            100,
            81.427
        ],
        D55: [
            95.799,
            100,
            90.926
        ],
        //daylight
        D65: [
            94.811,
            100,
            107.304
        ],
        D75: [
            94.416,
            100,
            120.641
        ],
        //flourescent
        F2: [
            103.280,
            100,
            69.026
        ],
        F7: [
            95.792,
            100,
            107.687
        ],
        F11: [
            103.866,
            100,
            65.627
        ],
        E: [
            100,
            100,
            100
        ]
    }
};
/**
 * Top values are the whitepoint’s top values, default are D65
 */ $7634b6e0defee048$var$xyz.max = $7634b6e0defee048$var$xyz.whitepoint[2].D65;
/**
 * Transform xyz to rgb
 *
 * @param {Array} xyz Array of xyz values
 *
 * @return {Array} RGB values
 */ $7634b6e0defee048$var$xyz.rgb = function(_xyz, white) {
    //FIXME: make sure we have to divide like this. Probably we have to replace matrix as well then
    white = white || $7634b6e0defee048$var$xyz.whitepoint[2].E;
    var x = _xyz[0] / white[0], y = _xyz[1] / white[1], z = _xyz[2] / white[2], r, g, b;
    // assume sRGB
    // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
    r = x * 3.240969941904521 + y * -1.537383177570093 + z * -0.498610760293;
    g = x * -0.96924363628087 + y * 1.87596750150772 + z * 0.041555057407175;
    b = x * 0.055630079696993 + y * -0.20397695888897 + z * 1.056971514242878;
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r = r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g = g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b = b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
/**
 * RGB to XYZ
 *
 * @param {Array} rgb RGB channels
 *
 * @return {Array} XYZ channels
 */ (0, $7e72a7d6ff8acadf$export$2e2bcd8739ae039).xyz = function(rgb, white) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255;
    // assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.41239079926595 + g * 0.35758433938387 + b * 0.18048078840183;
    var y = r * 0.21263900587151 + g * 0.71516867876775 + b * 0.072192315360733;
    var z = r * 0.019330818715591 + g * 0.11919477979462 + b * 0.95053215224966;
    white = white || $7634b6e0defee048$var$xyz.whitepoint[2].E;
    return [
        x * white[0],
        y * white[1],
        z * white[2]
    ];
};
var $7634b6e0defee048$export$2e2bcd8739ae039 = $7634b6e0defee048$var$xyz;


var $33103a9ff32c2e98$export$2e2bcd8739ae039 = {
    name: "luv",
    //NOTE: luv has no rigidly defined limits
    //easyrgb fails to get proper coords
    //boronine states no rigid limits
    //colorMine refers this ones:
    min: [
        0,
        -134,
        -140
    ],
    max: [
        100,
        224,
        122
    ],
    channel: [
        "lightness",
        "u",
        "v"
    ],
    alias: [
        "LUV",
        "cieluv",
        "cie1976"
    ],
    xyz: function xyz1(arg, i, o) {
        var _u, _v, l, u, v, x, y, z, xn, yn, zn, un, vn;
        l = arg[0], u = arg[1], v = arg[2];
        if (l === 0) return [
            0,
            0,
            0
        ];
        //get constants
        //var e = 0.008856451679035631; //(6/29)^3
        var k = 0.0011070564598794539; //(3/29)^3
        //get illuminant/observer
        i = i || "D65";
        o = o || 2;
        xn = (0, $7634b6e0defee048$export$2e2bcd8739ae039).whitepoint[o][i][0];
        yn = (0, $7634b6e0defee048$export$2e2bcd8739ae039).whitepoint[o][i][1];
        zn = (0, $7634b6e0defee048$export$2e2bcd8739ae039).whitepoint[o][i][2];
        un = 4 * xn / (xn + 15 * yn + 3 * zn);
        vn = 9 * yn / (xn + 15 * yn + 3 * zn);
        // un = 0.19783000664283;
        // vn = 0.46831999493879;
        _u = u / (13 * l) + un || 0;
        _v = v / (13 * l) + vn || 0;
        y = l > 8 ? yn * Math.pow((l + 16) / 116, 3) : yn * l * k;
        //wikipedia method
        x = y * 9 * _u / (4 * _v) || 0;
        z = y * (12 - 3 * _u - 20 * _v) / (4 * _v) || 0;
        //boronine method
        //https://github.com/boronine/husl/blob/master/husl.coffee#L201
        // x = 0 - (9 * y * _u) / ((_u - 4) * _v - _u * _v);
        // z = (9 * y - (15 * _v * y) - (_v * x)) / (3 * _v);
        return [
            x,
            y,
            z
        ];
    }
};
// http://www.brucelindbloom.com/index.html?Equations.html
// https://github.com/boronine/husl/blob/master/husl.coffee
//i - illuminant
//o - observer
(0, $7634b6e0defee048$export$2e2bcd8739ae039).luv = function(arg, i, o) {
    var _u, _v, l, u, v, x, y, z, xn, yn, zn, un, vn;
    //get constants
    var e = 0.008856451679035631; //(6/29)^3
    var k = 903.2962962962961; //(29/3)^3
    //get illuminant/observer coords
    i = i || "D65";
    o = o || 2;
    xn = (0, $7634b6e0defee048$export$2e2bcd8739ae039).whitepoint[o][i][0];
    yn = (0, $7634b6e0defee048$export$2e2bcd8739ae039).whitepoint[o][i][1];
    zn = (0, $7634b6e0defee048$export$2e2bcd8739ae039).whitepoint[o][i][2];
    un = 4 * xn / (xn + 15 * yn + 3 * zn);
    vn = 9 * yn / (xn + 15 * yn + 3 * zn);
    x = arg[0], y = arg[1], z = arg[2];
    _u = 4 * x / (x + 15 * y + 3 * z) || 0;
    _v = 9 * y / (x + 15 * y + 3 * z) || 0;
    var yr = y / yn;
    l = yr <= e ? k * yr : 116 * Math.pow(yr, 1 / 3) - 16;
    u = 13 * l * (_u - un);
    v = 13 * l * (_v - vn);
    return [
        l,
        u,
        v
    ];
};



//cylindrical luv
var $b7ebc2763b65750d$var$lchuv = {
    name: "lchuv",
    channel: [
        "lightness",
        "chroma",
        "hue"
    ],
    alias: [
        "LCHuv",
        "cielchuv"
    ],
    min: [
        0,
        0,
        0
    ],
    max: [
        100,
        100,
        360
    ],
    luv: function luv(_luv) {
        var l = _luv[0], c = _luv[1], h = _luv[2], u, v, hr;
        hr = h / 360 * 2 * Math.PI;
        u = c * Math.cos(hr);
        v = c * Math.sin(hr);
        return [
            l,
            u,
            v
        ];
    },
    xyz: function xyz(arg) {
        return (0, $33103a9ff32c2e98$export$2e2bcd8739ae039).xyz($b7ebc2763b65750d$var$lchuv.luv(arg));
    }
};
var $b7ebc2763b65750d$export$2e2bcd8739ae039 = $b7ebc2763b65750d$var$lchuv;
(0, $33103a9ff32c2e98$export$2e2bcd8739ae039).lchuv = function(luv) {
    var l = luv[0], u = luv[1], v = luv[2];
    var c = Math.sqrt(u * u + v * v);
    var hr = Math.atan2(v, u);
    var h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    return [
        l,
        c,
        h
    ];
};
(0, $7634b6e0defee048$export$2e2bcd8739ae039).lchuv = function(arg) {
    return (0, $33103a9ff32c2e98$export$2e2bcd8739ae039).lchuv((0, $7634b6e0defee048$export$2e2bcd8739ae039).luv(arg));
};


/** @module  color-rgba */ /**
 * @module color-parse
 */ var $e66ec8519b079b84$exports = {};
"use strict";
$e66ec8519b079b84$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


var $15664a7d254d5203$export$2e2bcd8739ae039 = $15664a7d254d5203$var$parse;
/**
 * Base hues
 * http://dev.w3.org/csswg/css-color/#typedef-named-hue
 */ //FIXME: use external hue detector
var $15664a7d254d5203$var$baseHues = {
    red: 0,
    orange: 60,
    yellow: 120,
    green: 180,
    blue: 240,
    purple: 300
};
/**
 * Parse color from the string passed
 *
 * @return {Object} A space indicator `space`, an array `values` and `alpha`
 */ function $15664a7d254d5203$var$parse(cstr) {
    var m, parts = [], alpha = 1, space;
    //numeric case
    if (typeof cstr === "number") return {
        space: "rgb",
        values: [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ],
        alpha: 1
    };
    if (typeof cstr === "number") return {
        space: "rgb",
        values: [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ],
        alpha: 1
    };
    cstr = String(cstr).toLowerCase();
    //keyword
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e66ec8519b079b84$exports)))[cstr]) {
        parts = (0, (/*@__PURE__*/$parcel$interopDefault($e66ec8519b079b84$exports)))[cstr].slice();
        space = "rgb";
    } else if (cstr === "transparent") {
        alpha = 0;
        space = "rgb";
        parts = [
            0,
            0,
            0
        ];
    } else if (cstr[0] === "#") {
        var base = cstr.slice(1);
        var size = base.length;
        var isShort = size <= 4;
        alpha = 1;
        if (isShort) {
            parts = [
                parseInt(base[0] + base[0], 16),
                parseInt(base[1] + base[1], 16),
                parseInt(base[2] + base[2], 16)
            ];
            if (size === 4) alpha = parseInt(base[3] + base[3], 16) / 255;
        } else {
            parts = [
                parseInt(base[0] + base[1], 16),
                parseInt(base[2] + base[3], 16),
                parseInt(base[4] + base[5], 16)
            ];
            if (size === 8) alpha = parseInt(base[6] + base[7], 16) / 255;
        }
        if (!parts[0]) parts[0] = 0;
        if (!parts[1]) parts[1] = 0;
        if (!parts[2]) parts[2] = 0;
        space = "rgb";
    } else if (m = /^((?:rgba?|hs[lvb]a?|hwba?|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms|oklch|oklab|color))\s*\(([^\)]*)\)/.exec(cstr)) {
        var name = m[1];
        space = name.replace(/a$/, "");
        var dims = space === "cmyk" ? 4 : space === "gray" ? 1 : 3;
        parts = m[2].trim().split(/\s*[,\/]\s*|\s+/);
        // color(srgb-linear x x x) -> srgb-linear(x x x)
        if (space === "color") space = parts.shift();
        parts = parts.map(function(x, i) {
            //<percentage>
            if (x[x.length - 1] === "%") {
                x = parseFloat(x) / 100;
                // alpha -> 0..1
                if (i === 3) return x;
                // rgb -> 0..255
                if (space === "rgb") return x * 255;
                // hsl, hwb H -> 0..100
                if (space[0] === "h") return x * 100;
                // lch, lab L -> 0..100
                if (space[0] === "l" && !i) return x * 100;
                // lab A B -> -125..125
                if (space === "lab") return x * 125;
                // lch C -> 0..150, H -> 0..360
                if (space === "lch") return i < 2 ? x * 150 : x * 360;
                // oklch/oklab L -> 0..1
                if (space[0] === "o" && !i) return x;
                // oklab A B -> -0.4..0.4
                if (space === "oklab") return x * 0.4;
                // oklch C -> 0..0.4, H -> 0..360
                if (space === "oklch") return i < 2 ? x * 0.4 : x * 360;
                // color(xxx) -> 0..1
                return x;
            }
            //hue
            if (space[i] === "h" || i === 2 && space[space.length - 1] === "h") {
                //<base-hue>
                if ($15664a7d254d5203$var$baseHues[x] !== undefined) return $15664a7d254d5203$var$baseHues[x];
                //<deg>
                if (x.endsWith("deg")) return parseFloat(x);
                //<turn>
                if (x.endsWith("turn")) return parseFloat(x) * 360;
                if (x.endsWith("grad")) return parseFloat(x) * 360 / 400;
                if (x.endsWith("rad")) return parseFloat(x) * 180 / Math.PI;
            }
            if (x === "none") return 0;
            return parseFloat(x);
        });
        alpha = parts.length > dims ? parts.pop() : 1;
    } else if (/[0-9](?:\s|\/|,)/.test(cstr)) {
        var _cstr_match_join, _cstr_match;
        parts = cstr.match(/([0-9]+)/g).map(function(value) {
            return parseFloat(value);
        });
        space = ((_cstr_match = cstr.match(/([a-z])/ig)) === null || _cstr_match === void 0 ? void 0 : (_cstr_match_join = _cstr_match.join("")) === null || _cstr_match_join === void 0 ? void 0 : _cstr_match_join.toLowerCase()) || "rgb";
    }
    return {
        space: space,
        values: parts,
        alpha: alpha
    };
}



/**
 * @module color-space/hsl
 */ 
var $be3fbac18bdf500e$export$2e2bcd8739ae039 = {
    name: "hsl",
    min: [
        0,
        0,
        0
    ],
    max: [
        360,
        100,
        100
    ],
    channel: [
        "hue",
        "saturation",
        "lightness"
    ],
    alias: [
        "HSL"
    ],
    rgb: function rgb(hsl) {
        var h = hsl[0] / 360, s = hsl[1] / 100, l = hsl[2] / 100, t1, t2, t3, _$rgb, val, i = 0;
        if (s === 0) return val = l * 255, [
            val,
            val,
            val
        ];
        t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        t1 = 2 * l - t2;
        _$rgb = [
            0,
            0,
            0
        ];
        for(; i < 3;){
            t3 = h + 1 / 3 * -(i - 1);
            t3 < 0 ? t3++ : t3 > 1 && t3--;
            val = 6 * t3 < 1 ? t1 + (t2 - t1) * 6 * t3 : 2 * t3 < 1 ? t2 : 3 * t3 < 2 ? t1 + (t2 - t1) * (2 / 3 - t3) * 6 : t1;
            _$rgb[i++] = val * 255;
        }
        return _$rgb;
    }
};
//extend rgb
(0, $7e72a7d6ff8acadf$export$2e2bcd8739ae039).hsl = function(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), delta = max - min, h, s, l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};


function $2788c396db6209f7$export$2e2bcd8739ae039(color) {
    var _String;
    // template literals
    if (Array.isArray(color) && color.raw) color = (_String = String).raw.apply(_String, arguments);
    if (color instanceof Number) color = +color;
    var values, i, l;
    //attempt to parse non-array arguments
    var parsed = (0, $15664a7d254d5203$export$2e2bcd8739ae039)(color);
    if (!parsed.space) return [];
    var min = parsed.space[0] === "h" ? (0, $be3fbac18bdf500e$export$2e2bcd8739ae039).min : (0, $7e72a7d6ff8acadf$export$2e2bcd8739ae039).min;
    var max = parsed.space[0] === "h" ? (0, $be3fbac18bdf500e$export$2e2bcd8739ae039).max : (0, $7e72a7d6ff8acadf$export$2e2bcd8739ae039).max;
    values = Array(3);
    values[0] = Math.min(Math.max(parsed.values[0], min[0]), max[0]);
    values[1] = Math.min(Math.max(parsed.values[1], min[1]), max[1]);
    values[2] = Math.min(Math.max(parsed.values[2], min[2]), max[2]);
    if (parsed.space[0] === "h") values = (0, $be3fbac18bdf500e$export$2e2bcd8739ae039).rgb(values);
    values.push(Math.min(Math.max(parsed.alpha, 0), 1));
    return values;
}




/**
 * @module ol/math
 */ /**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */ function $029c1e222d833501$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $029c1e222d833501$export$251bb0a9cef172e6(x, y, x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        var t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return $029c1e222d833501$export$88e6ebb4fe54f538(x, y, x1, y1);
}
function $029c1e222d833501$export$88e6ebb4fe54f538(x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    return dx * dx + dy * dy;
}
function $029c1e222d833501$export$8240f01c446270e6(mat) {
    var n = mat.length;
    for(var i = 0; i < n; i++){
        // Find max in the i-th column (ignoring i - 1 first rows)
        var maxRow = i;
        var maxEl = Math.abs(mat[i][i]);
        for(var r = i + 1; r < n; r++){
            var absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) return null; // matrix is singular
        // Swap max row with i-th (current) row
        var tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for(var j = i + 1; j < n; j++){
            var coef = -mat[j][i] / mat[i][i];
            for(var k = i; k < n + 1; k++)if (i == k) mat[j][k] = 0;
            else mat[j][k] += coef * mat[i][k];
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    var x = new Array(n);
    for(var l = n - 1; l >= 0; l--){
        x[l] = mat[l][n] / mat[l][l];
        for(var m = l - 1; m >= 0; m--)mat[m][n] -= mat[m][l] * x[l];
    }
    return x;
}
function $029c1e222d833501$export$56cb859c01fa134d(angleInRadians) {
    return angleInRadians * 180 / Math.PI;
}
function $029c1e222d833501$export$cba01ba138429a1d(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}
function $029c1e222d833501$export$ba467bec01d66def(a, b) {
    var r = a % b;
    return r * b < 0 ? r + b : r;
}
function $029c1e222d833501$export$3a89f8d6f6bf6c9f(a, b, x) {
    return a + x * (b - a);
}
function $029c1e222d833501$export$a81f732198733497(n, decimals) {
    var factor = Math.pow(10, decimals);
    return Math.round(n * factor) / factor;
}
function $029c1e222d833501$export$2077e0241d6afd3c(n, decimals) {
    return Math.round($029c1e222d833501$export$a81f732198733497(n, decimals));
}
function $029c1e222d833501$export$a3fe094919f356fd(n, decimals) {
    return Math.floor($029c1e222d833501$export$a81f732198733497(n, decimals));
}
function $029c1e222d833501$export$803ce6b71a0a94b2(n, decimals) {
    return Math.ceil($029c1e222d833501$export$a81f732198733497(n, decimals));
}


function $03ff7455ee88c2e9$export$590567be997858b6(color) {
    if (typeof color === "string") return color;
    return $03ff7455ee88c2e9$export$f84e8e69fd4488a5(color);
}
/**
 * @type {number}
 */ var $03ff7455ee88c2e9$var$MAX_CACHE_SIZE = 1024;
/**
 * We maintain a small cache of parsed strings.  Whenever the cache grows too large,
 * we delete an arbitrary set of the entries.
 *
 * @type {Object<string, Color>}
 */ var $03ff7455ee88c2e9$var$cache = {};
/**
 * @type {number}
 */ var $03ff7455ee88c2e9$var$cacheSize = 0;
function $03ff7455ee88c2e9$export$138c09bdd6bd797c(color) {
    if (color.length === 4) return color;
    var output = color.slice();
    output[3] = 1;
    return output;
}
function $03ff7455ee88c2e9$export$44fb54fa2e0c0d4(color) {
    var output = (0, $7634b6e0defee048$export$2e2bcd8739ae039).lchuv((0, $7e72a7d6ff8acadf$export$2e2bcd8739ae039).xyz(color));
    output[3] = color[3];
    return output;
}
function $03ff7455ee88c2e9$export$27cc94530c050f00(color) {
    var output = (0, $7634b6e0defee048$export$2e2bcd8739ae039).rgb((0, $b7ebc2763b65750d$export$2e2bcd8739ae039).xyz(color));
    output[3] = color[3];
    return output;
}
function $03ff7455ee88c2e9$export$3004f64547af360e(s) {
    if ($03ff7455ee88c2e9$var$cache.hasOwnProperty(s)) return $03ff7455ee88c2e9$var$cache[s];
    if ($03ff7455ee88c2e9$var$cacheSize >= $03ff7455ee88c2e9$var$MAX_CACHE_SIZE) {
        var i = 0;
        for(var key in $03ff7455ee88c2e9$var$cache)if ((i++ & 3) === 0) {
            delete $03ff7455ee88c2e9$var$cache[key];
            --$03ff7455ee88c2e9$var$cacheSize;
        }
    }
    var color = (0, $2788c396db6209f7$export$2e2bcd8739ae039)(s);
    if (color.length !== 4) throw new Error('Failed to parse "' + s + '" as color');
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = color[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var c = _step.value;
            if (isNaN(c)) throw new Error('Failed to parse "' + s + '" as color');
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    $03ff7455ee88c2e9$export$a3295358bff77e(color);
    $03ff7455ee88c2e9$var$cache[s] = color;
    ++$03ff7455ee88c2e9$var$cacheSize;
    return color;
}
function $03ff7455ee88c2e9$export$75093a47a9fa838d(color) {
    if (Array.isArray(color)) return color;
    return $03ff7455ee88c2e9$export$3004f64547af360e(color);
}
function $03ff7455ee88c2e9$export$a3295358bff77e(color) {
    color[0] = (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(color[0] + 0.5 | 0, 0, 255);
    color[1] = (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(color[1] + 0.5 | 0, 0, 255);
    color[2] = (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(color[2] + 0.5 | 0, 0, 255);
    color[3] = (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(color[3], 0, 1);
    return color;
}
function $03ff7455ee88c2e9$export$f84e8e69fd4488a5(color) {
    var r = color[0];
    if (r != (r | 0)) r = r + 0.5 | 0;
    var g = color[1];
    if (g != (g | 0)) g = g + 0.5 | 0;
    var b = color[2];
    if (b != (b | 0)) b = b + 0.5 | 0;
    var a = color[3] === undefined ? 1 : Math.round(color[3] * 100) / 100;
    return "rgba(" + r + "," + g + "," + b + "," + a + ")";
}
function $03ff7455ee88c2e9$export$40dd713d7775a0b1(s) {
    try {
        $03ff7455ee88c2e9$export$3004f64547af360e(s);
        return true;
    } catch (_) {
        return false;
    }
}


/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache.shared}.
 */ var $b343747b53167d02$var$IconImageCache = /*#__PURE__*/ function() {
    "use strict";
    function IconImageCache() {
        (0, $5sFFs._)(this, IconImageCache);
        /**
     * @type {!Object<string, import("./IconImage.js").default>}
     * @private
     */ this.cache_ = {};
        /**
     * @type {number}
     * @private
     */ this.cacheSize_ = 0;
        /**
     * @type {number}
     * @private
     */ this.maxCacheSize_ = 32;
    }
    (0, $8O2fV._)(IconImageCache, [
        {
            /**
   * FIXME empty description for jsdoc
   */ key: "clear",
            value: function clear() {
                this.cache_ = {};
                this.cacheSize_ = 0;
            }
        },
        {
            /**
   * @return {boolean} Can expire cache.
   */ key: "canExpireCache",
            value: function canExpireCache() {
                return this.cacheSize_ > this.maxCacheSize_;
            }
        },
        {
            /**
   * FIXME empty description for jsdoc
   */ key: "expire",
            value: function expire() {
                if (this.canExpireCache()) {
                    var i = 0;
                    for(var key in this.cache_){
                        var iconImage = this.cache_[key];
                        if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                            delete this.cache_[key];
                            --this.cacheSize_;
                        }
                    }
                }
            }
        },
        {
            /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color} color Color.
   * @return {import("./IconImage.js").default} Icon image.
   */ key: "get",
            value: function get(src, crossOrigin, color) {
                var key = $b343747b53167d02$var$getKey(src, crossOrigin, color);
                return key in this.cache_ ? this.cache_[key] : null;
            }
        },
        {
            /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color} color Color.
   * @param {import("./IconImage.js").default} iconImage Icon image.
   */ key: "set",
            value: function set(src, crossOrigin, color, iconImage) {
                var key = $b343747b53167d02$var$getKey(src, crossOrigin, color);
                this.cache_[key] = iconImage;
                ++this.cacheSize_;
            }
        },
        {
            /**
   * Set the cache size of the icon cache. Default is `32`. Change this value when
   * your map uses more than 32 different icon images and you are not caching icon
   * styles on the application level.
   * @param {number} maxCacheSize Cache max size.
   * @api
   */ key: "setSize",
            value: function setSize(maxCacheSize) {
                this.maxCacheSize_ = maxCacheSize;
                this.expire();
            }
        }
    ]);
    return IconImageCache;
}();
/**
 * @param {string} src Src.
 * @param {?string} crossOrigin Cross origin.
 * @param {import("../color.js").Color} color Color.
 * @return {string} Cache key.
 */ function $b343747b53167d02$var$getKey(src, crossOrigin, color) {
    var colorString = color ? (0, $03ff7455ee88c2e9$export$590567be997858b6)(color) : "null";
    return crossOrigin + ":" + src + ":" + colorString;
}
var $b343747b53167d02$export$2e2bcd8739ae039 = $b343747b53167d02$var$IconImageCache;
var $b343747b53167d02$export$747ccdf771a87ab8 = new $b343747b53167d02$var$IconImageCache();


/**
 * @module ol/layer/Layer
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/layer/Base
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");

/**
 * @module ol/layer/Property
 */ /**
 * @enum {string}
 */ var $7b9db042957f1b51$export$2e2bcd8739ae039 = {
    OPACITY: "opacity",
    VISIBLE: "visible",
    EXTENT: "extent",
    Z_INDEX: "zIndex",
    MAX_RESOLUTION: "maxResolution",
    MIN_RESOLUTION: "minResolution",
    MAX_ZOOM: "maxZoom",
    MIN_ZOOM: "minZoom",
    SOURCE: "source",
    MAP: "map"
};





/**
 * A css color, or a function called with a view resolution returning a css color.
 *
 * @typedef {string|function(number):string} BackgroundColor
 * @api
 */ /**
 * @typedef {import("../ObjectEventType").Types|'change:extent'|'change:maxResolution'|'change:maxZoom'|
 *    'change:minResolution'|'change:minZoom'|'change:opacity'|'change:visible'|'change:zIndex'} BaseLayerObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<BaseLayerObjectEventTypes, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|BaseLayerObjectEventTypes, Return>} BaseLayerOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number | undefined} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base~BaseLayer} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object~BaseObject} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 */ var $c1595a156af4ac75$var$BaseLayer = /*#__PURE__*/ function(BaseObject) {
    "use strict";
    (0, $kcqLc._)(BaseLayer, BaseObject);
    var _super = (0, $4jYWU._)(BaseLayer);
    function BaseLayer(options) {
        (0, $5sFFs._)(this, BaseLayer);
        var _this;
        _this = _super.call(this);
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ _this.on;
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ _this.once;
        /***
     * @type {BaseLayerOnSignature<void>}
     */ _this.un;
        /**
     * @type {BackgroundColor|false}
     * @private
     */ _this.background_ = options.background;
        /**
     * @type {Object<string, *>}
     */ var properties = Object.assign({}, options);
        if (typeof options.properties === "object") {
            delete properties.properties;
            Object.assign(properties, options.properties);
        }
        properties[(0, $7b9db042957f1b51$export$2e2bcd8739ae039).OPACITY] = options.opacity !== undefined ? options.opacity : 1;
        (0, $100b4414e338a711$export$a7a9523472993e97)(typeof properties[(0, $7b9db042957f1b51$export$2e2bcd8739ae039).OPACITY] === "number", "Layer opacity must be a number");
        properties[(0, $7b9db042957f1b51$export$2e2bcd8739ae039).VISIBLE] = options.visible !== undefined ? options.visible : true;
        properties[(0, $7b9db042957f1b51$export$2e2bcd8739ae039).Z_INDEX] = options.zIndex;
        properties[(0, $7b9db042957f1b51$export$2e2bcd8739ae039).MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[(0, $7b9db042957f1b51$export$2e2bcd8739ae039).MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
        properties[(0, $7b9db042957f1b51$export$2e2bcd8739ae039).MIN_ZOOM] = options.minZoom !== undefined ? options.minZoom : -Infinity;
        properties[(0, $7b9db042957f1b51$export$2e2bcd8739ae039).MAX_ZOOM] = options.maxZoom !== undefined ? options.maxZoom : Infinity;
        /**
     * @type {string}
     * @private
     */ _this.className_ = properties.className !== undefined ? properties.className : "ol-layer";
        delete properties.className;
        _this.setProperties(properties);
        /**
     * @type {import("./Layer.js").State}
     * @private
     */ _this.state_ = null;
        return _this;
    }
    (0, $8O2fV._)(BaseLayer, [
        {
            /**
   * Get the background for this layer.
   * @return {BackgroundColor|false} Layer background.
   */ key: "getBackground",
            value: function getBackground() {
                return this.background_;
            }
        },
        {
            /**
   * @return {string} CSS class name.
   */ key: "getClassName",
            value: function getClassName() {
                return this.className_;
            }
        },
        {
            /**
   * This method is not meant to be called by layers or layer renderers because the state
   * is incorrect if the layer is included in a layer group.
   *
   * @param {boolean} [managed] Layer is managed.
   * @return {import("./Layer.js").State} Layer state.
   */ key: "getLayerState",
            value: function getLayerState(managed) {
                /** @type {import("./Layer.js").State} */ var state = this.state_ || /** @type {?} */ {
                    layer: this,
                    managed: managed === undefined ? true : managed
                };
                var zIndex = this.getZIndex();
                state.opacity = (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(Math.round(this.getOpacity() * 100) / 100, 0, 1);
                state.visible = this.getVisible();
                state.extent = this.getExtent();
                state.zIndex = zIndex === undefined && !state.managed ? Infinity : zIndex;
                state.maxResolution = this.getMaxResolution();
                state.minResolution = Math.max(this.getMinResolution(), 0);
                state.minZoom = this.getMinZoom();
                state.maxZoom = this.getMaxZoom();
                this.state_ = state;
                return state;
            }
        },
        {
            /**
   * @abstract
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ key: "getLayersArray",
            value: function getLayersArray(array) {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * @abstract
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ key: "getLayerStatesArray",
            value: function getLayerStatesArray(states) {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */ key: "getExtent",
            value: function getExtent() {
                return /** @type {import("../extent.js").Extent|undefined} */ this.get((0, $7b9db042957f1b51$export$2e2bcd8739ae039).EXTENT);
            }
        },
        {
            /**
   * Return the maximum resolution of the layer. Returns Infinity if
   * the layer has no maximum resolution set.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */ key: "getMaxResolution",
            value: function getMaxResolution() {
                return /** @type {number} */ this.get((0, $7b9db042957f1b51$export$2e2bcd8739ae039).MAX_RESOLUTION);
            }
        },
        {
            /**
   * Return the minimum resolution of the layer. Returns 0 if
   * the layer has no minimum resolution set.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */ key: "getMinResolution",
            value: function getMinResolution() {
                return /** @type {number} */ this.get((0, $7b9db042957f1b51$export$2e2bcd8739ae039).MIN_RESOLUTION);
            }
        },
        {
            /**
   * Return the minimum zoom level of the layer. Returns -Infinity if
   * the layer has no minimum zoom set.
   * @return {number} The minimum zoom level of the layer.
   * @observable
   * @api
   */ key: "getMinZoom",
            value: function getMinZoom() {
                return /** @type {number} */ this.get((0, $7b9db042957f1b51$export$2e2bcd8739ae039).MIN_ZOOM);
            }
        },
        {
            /**
   * Return the maximum zoom level of the layer. Returns Infinity if
   * the layer has no maximum zoom set.
   * @return {number} The maximum zoom level of the layer.
   * @observable
   * @api
   */ key: "getMaxZoom",
            value: function getMaxZoom() {
                return /** @type {number} */ this.get((0, $7b9db042957f1b51$export$2e2bcd8739ae039).MAX_ZOOM);
            }
        },
        {
            /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */ key: "getOpacity",
            value: function getOpacity() {
                return /** @type {number} */ this.get((0, $7b9db042957f1b51$export$2e2bcd8739ae039).OPACITY);
            }
        },
        {
            /**
   * @abstract
   * @return {import("../source/Source.js").State} Source state.
   */ key: "getSourceState",
            value: function getSourceState() {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Return the value of this layer's `visible` property. To find out whether the layer
   * is visible on a map, use `isVisible()` instead.
   * @return {boolean} The value of the `visible` property of the layer.
   * @observable
   * @api
   */ key: "getVisible",
            value: function getVisible() {
                return /** @type {boolean} */ this.get((0, $7b9db042957f1b51$export$2e2bcd8739ae039).VISIBLE);
            }
        },
        {
            /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. Returns undefined if the layer is unmanaged.
   * @return {number|undefined} The Z-index of the layer.
   * @observable
   * @api
   */ key: "getZIndex",
            value: function getZIndex() {
                return /** @type {number|undefined} */ this.get((0, $7b9db042957f1b51$export$2e2bcd8739ae039).Z_INDEX);
            }
        },
        {
            /**
   * Sets the background color.
   * @param {BackgroundColor} [background] Background color.
   */ key: "setBackground",
            value: function setBackground(background) {
                this.background_ = background;
                this.changed();
            }
        },
        {
            /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */ key: "setExtent",
            value: function setExtent(extent) {
                this.set((0, $7b9db042957f1b51$export$2e2bcd8739ae039).EXTENT, extent);
            }
        },
        {
            /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */ key: "setMaxResolution",
            value: function setMaxResolution(maxResolution) {
                this.set((0, $7b9db042957f1b51$export$2e2bcd8739ae039).MAX_RESOLUTION, maxResolution);
            }
        },
        {
            /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */ key: "setMinResolution",
            value: function setMinResolution(minResolution) {
                this.set((0, $7b9db042957f1b51$export$2e2bcd8739ae039).MIN_RESOLUTION, minResolution);
            }
        },
        {
            /**
   * Set the maximum zoom (exclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} maxZoom The maximum zoom of the layer.
   * @observable
   * @api
   */ key: "setMaxZoom",
            value: function setMaxZoom(maxZoom) {
                this.set((0, $7b9db042957f1b51$export$2e2bcd8739ae039).MAX_ZOOM, maxZoom);
            }
        },
        {
            /**
   * Set the minimum zoom (inclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} minZoom The minimum zoom of the layer.
   * @observable
   * @api
   */ key: "setMinZoom",
            value: function setMinZoom(minZoom) {
                this.set((0, $7b9db042957f1b51$export$2e2bcd8739ae039).MIN_ZOOM, minZoom);
            }
        },
        {
            /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */ key: "setOpacity",
            value: function setOpacity(opacity) {
                (0, $100b4414e338a711$export$a7a9523472993e97)(typeof opacity === "number", "Layer opacity must be a number");
                this.set((0, $7b9db042957f1b51$export$2e2bcd8739ae039).OPACITY, opacity);
            }
        },
        {
            /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */ key: "setVisible",
            value: function setVisible(visible) {
                this.set((0, $7b9db042957f1b51$export$2e2bcd8739ae039).VISIBLE, visible);
            }
        },
        {
            /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */ key: "setZIndex",
            value: function setZIndex(zindex) {
                this.set((0, $7b9db042957f1b51$export$2e2bcd8739ae039).Z_INDEX, zindex);
            }
        },
        {
            /**
   * Clean up.
   */ key: "disposeInternal",
            value: function disposeInternal() {
                if (this.state_) {
                    this.state_.layer = null;
                    this.state_ = null;
                }
                (0, $404BM._)((0, $cEF31._)(BaseLayer.prototype), "disposeInternal", this).call(this);
            }
        }
    ]);
    return BaseLayer;
}((0, $7a8d25d40aa0de7f$export$2e2bcd8739ae039));
var $c1595a156af4ac75$export$2e2bcd8739ae039 = $c1595a156af4ac75$var$BaseLayer;




/**
 * @module ol/render/EventType
 */ /**
 * @enum {string}
 */ var $b1aa6e3366c76eef$export$2e2bcd8739ae039 /**
 * @typedef {'postrender'|'precompose'|'postcompose'|'rendercomplete'} MapRenderEventTypes
 */  /**
 * @typedef {'postrender'|'prerender'} LayerRenderEventTypes
 */  = {
    /**
   * Triggered before a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#prerender
   * @api
   */ PRERENDER: "prerender",
    /**
   * Triggered after a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#postrender
   * @api
   */ POSTRENDER: "postrender",
    /**
   * Triggered before layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */ PRECOMPOSE: "precompose",
    /**
   * Triggered after layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */ POSTCOMPOSE: "postcompose",
    /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * The event object will not have a `context` set.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */ RENDERCOMPLETE: "rendercomplete"
};


/**
 * @module ol/View
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");

/**
 * @module ol/ViewHint
 */ /**
 * @enum {number}
 */ var $2901f2d22a6aa5fb$export$2e2bcd8739ae039 = {
    ANIMATING: 0,
    INTERACTING: 1
};


/**
 * @module ol/ViewProperty
 */ /**
 * @enum {string}
 */ var $6ae0dd408d4b0296$export$2e2bcd8739ae039 = {
    CENTER: "center",
    RESOLUTION: "resolution",
    ROTATION: "rotation"
};


/**
 * @module ol/tilegrid/common
 */ /**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */ var $bb7a9ac0b1791714$export$e98a216cdcc847dc = 42;
var $bb7a9ac0b1791714$export$6b8cb5cd370bd90c = 256;


/**
 * @module ol/proj
 */ /**
 * The ol/proj module stores:
 * * a list of {@link module:ol/proj/Projection~Projection}
 * objects, one for each projection supported by the application
 * * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://epsg.io/, and are a JS function, so can be loaded in a script
 * tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj.addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection~Projection} object for the new projection and add it with
 * {@link module:ol/proj.addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj.addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection~Projection} with
 * {@link module:ol/proj.addProjection}. See examples/wms-no-proj for an example of
 * this.
 */ 
/**
 * @module ol/proj/epsg3857
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/proj/Projection
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
/**
 * @module ol/proj/Units
 */ /**
 * @typedef {'radians' | 'degrees' | 'ft' | 'm' | 'pixels' | 'tile-pixels' | 'us-ft'} Units
 * Projection units.
 */ /**
 * See http://duff.ess.washington.edu/data/raster/drg/docs/geotiff.txt
 * @type {Object<number, Units>}
 */ var $264085f7209eb4a0$var$unitByCode = {
    "9001": "m",
    "9002": "ft",
    "9003": "us-ft",
    "9101": "radians",
    "9102": "degrees"
};
function $264085f7209eb4a0$export$7f58726df3255edc(code) {
    return $264085f7209eb4a0$var$unitByCode[code];
}
var $264085f7209eb4a0$export$1482081eec883108 = {
    // use the radius of the Normal sphere
    "radians": 6370997 / (2 * Math.PI),
    "degrees": 2 * Math.PI * 6370997 / 360,
    "ft": 0.3048,
    "m": 1,
    "us-ft": 1200 / 3937
};


/**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").Units} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {function(number, import("../coordinate.js").Coordinate):number} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `number` view resolution and a {@link module:ol/coordinate~Coordinate} as arguments, and returns
 * the `number` resolution in projection units at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj.getPointResolution} function will be used.
 */ /**
 * @classdesc
 * Projection definition class. One of these is created for each projection
 * supported in the application and stored in the {@link module:ol/proj} namespace.
 * You can use these in applications, but this is not required, as API params
 * and options use {@link module:ol/proj~ProjectionLike} which means the simple string
 * code will suffice.
 *
 * You can use {@link module:ol/proj.get} to retrieve the object for a particular
 * projection.
 *
 * The library includes definitions for `EPSG:4326` and `EPSG:3857`, together
 * with the following aliases:
 * * `EPSG:4326`: CRS:84, urn:ogc:def:crs:EPSG:6.6:4326,
 *     urn:ogc:def:crs:OGC:1.3:CRS84, urn:ogc:def:crs:OGC:2:84,
 *     http://www.opengis.net/gml/srs/epsg.xml#4326,
 *     urn:x-ogc:def:crs:EPSG:4326
 * * `EPSG:3857`: EPSG:102100, EPSG:102113, EPSG:900913,
 *     urn:ogc:def:crs:EPSG:6.18:3:3857,
 *     http://www.opengis.net/gml/srs/epsg.xml#3857
 *
 * If you use [proj4js](https://github.com/proj4js/proj4js), aliases can
 * be added using `proj4.defs()`. After all required projection definitions are
 * added, call the {@link module:ol/proj/proj4.register} function.
 *
 * @api
 */ var $7f0930c45e14ba0b$var$Projection = /*#__PURE__*/ function() {
    "use strict";
    function Projection(options) {
        (0, $5sFFs._)(this, Projection);
        /**
     * @private
     * @type {string}
     */ this.code_ = options.code;
        /**
     * Units of projected coordinates. When set to `TILE_PIXELS`, a
     * `this.extent_` and `this.worldExtent_` must be configured properly for each
     * tile.
     * @private
     * @type {import("./Units.js").Units}
     */ this.units_ = /** @type {import("./Units.js").Units} */ options.units;
        /**
     * Validity extent of the projection in projected coordinates. For projections
     * with `TILE_PIXELS` units, this is the extent of the tile in
     * tile pixel space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = options.extent !== undefined ? options.extent : null;
        /**
     * Extent of the world in EPSG:4326. For projections with
     * `TILE_PIXELS` units, this is the extent of the tile in
     * projected coordinate space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.worldExtent_ = options.worldExtent !== undefined ? options.worldExtent : null;
        /**
     * @private
     * @type {string}
     */ this.axisOrientation_ = options.axisOrientation !== undefined ? options.axisOrientation : "enu";
        /**
     * @private
     * @type {boolean}
     */ this.global_ = options.global !== undefined ? options.global : false;
        /**
     * @private
     * @type {boolean}
     */ this.canWrapX_ = !!(this.global_ && this.extent_);
        /**
     * @private
     * @type {function(number, import("../coordinate.js").Coordinate):number|undefined}
     */ this.getPointResolutionFunc_ = options.getPointResolution;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.defaultTileGrid_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.metersPerUnit_ = options.metersPerUnit;
    }
    (0, $8O2fV._)(Projection, [
        {
            /**
   * @return {boolean} The projection is suitable for wrapping the x-axis
   */ key: "canWrapX",
            value: function canWrapX() {
                return this.canWrapX_;
            }
        },
        {
            /**
   * Get the code for this projection, e.g. 'EPSG:4326'.
   * @return {string} Code.
   * @api
   */ key: "getCode",
            value: function getCode() {
                return this.code_;
            }
        },
        {
            /**
   * Get the validity extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ key: "getExtent",
            value: function getExtent() {
                return this.extent_;
            }
        },
        {
            /**
   * Get the units of this projection.
   * @return {import("./Units.js").Units} Units.
   * @api
   */ key: "getUnits",
            value: function getUnits() {
                return this.units_;
            }
        },
        {
            /**
   * Get the amount of meters per unit of this projection.  If the projection is
   * not configured with `metersPerUnit` or a units identifier, the return is
   * `undefined`.
   * @return {number|undefined} Meters.
   * @api
   */ key: "getMetersPerUnit",
            value: function getMetersPerUnit() {
                return this.metersPerUnit_ || (0, $264085f7209eb4a0$export$1482081eec883108)[this.units_];
            }
        },
        {
            /**
   * Get the world extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ key: "getWorldExtent",
            value: function getWorldExtent() {
                return this.worldExtent_;
            }
        },
        {
            /**
   * Get the axis orientation of this projection.
   * Example values are:
   * enu - the default easting, northing, elevation.
   * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
   *     or south orientated transverse mercator.
   * wnu - westing, northing, up - some planetary coordinate systems have
   *     "west positive" coordinate systems
   * @return {string} Axis orientation.
   * @api
   */ key: "getAxisOrientation",
            value: function getAxisOrientation() {
                return this.axisOrientation_;
            }
        },
        {
            /**
   * Is this projection a global projection which spans the whole world?
   * @return {boolean} Whether the projection is global.
   * @api
   */ key: "isGlobal",
            value: function isGlobal() {
                return this.global_;
            }
        },
        {
            /**
   * Set if the projection is a global projection which spans the whole world
   * @param {boolean} global Whether the projection is global.
   * @api
   */ key: "setGlobal",
            value: function setGlobal(global) {
                this.global_ = global;
                this.canWrapX_ = !!(global && this.extent_);
            }
        },
        {
            /**
   * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
   */ key: "getDefaultTileGrid",
            value: function getDefaultTileGrid() {
                return this.defaultTileGrid_;
            }
        },
        {
            /**
   * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
   */ key: "setDefaultTileGrid",
            value: function setDefaultTileGrid(tileGrid) {
                this.defaultTileGrid_ = tileGrid;
            }
        },
        {
            /**
   * Set the validity extent for this projection.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ key: "setExtent",
            value: function setExtent(extent) {
                this.extent_ = extent;
                this.canWrapX_ = !!(this.global_ && extent);
            }
        },
        {
            /**
   * Set the world extent for this projection.
   * @param {import("../extent.js").Extent} worldExtent World extent
   *     [minlon, minlat, maxlon, maxlat].
   * @api
   */ key: "setWorldExtent",
            value: function setWorldExtent(worldExtent) {
                this.worldExtent_ = worldExtent;
            }
        },
        {
            /**
   * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
   * for this projection.
   * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
   * @api
   */ key: "setGetPointResolution",
            value: function setGetPointResolution(func) {
                this.getPointResolutionFunc_ = func;
            }
        },
        {
            /**
   * Get the custom point resolution function for this projection (if set).
   * @return {function(number, import("../coordinate.js").Coordinate):number|undefined} The custom point
   * resolution function (if set).
   */ key: "getPointResolutionFunc",
            value: function getPointResolutionFunc() {
                return this.getPointResolutionFunc_;
            }
        }
    ]);
    return Projection;
}();
var $7f0930c45e14ba0b$export$2e2bcd8739ae039 = $7f0930c45e14ba0b$var$Projection;


var $507e80ba0416a37a$export$2d2c9be8b5b863f = 6378137;
var $507e80ba0416a37a$export$f3928063e5e96d35 = Math.PI * $507e80ba0416a37a$export$2d2c9be8b5b863f;
var $507e80ba0416a37a$export$21e6da8a7375dfe8 = [
    -$507e80ba0416a37a$export$f3928063e5e96d35,
    -$507e80ba0416a37a$export$f3928063e5e96d35,
    $507e80ba0416a37a$export$f3928063e5e96d35,
    $507e80ba0416a37a$export$f3928063e5e96d35
];
var $507e80ba0416a37a$export$ae9d6ed80df710e5 = [
    -180,
    -85,
    180,
    85
];
var $507e80ba0416a37a$export$d26945d1ad52feeb = $507e80ba0416a37a$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */ var $507e80ba0416a37a$var$EPSG3857Projection = /*#__PURE__*/ function(Projection) {
    "use strict";
    (0, $kcqLc._)(EPSG3857Projection, Projection);
    var _super = (0, $4jYWU._)(EPSG3857Projection);
    function EPSG3857Projection(code) {
        (0, $5sFFs._)(this, EPSG3857Projection);
        return _super.call(this, {
            code: code,
            units: "m",
            extent: $507e80ba0416a37a$export$21e6da8a7375dfe8,
            global: true,
            worldExtent: $507e80ba0416a37a$export$ae9d6ed80df710e5,
            getPointResolution: function getPointResolution(resolution, point) {
                return resolution / Math.cosh(point[1] / $507e80ba0416a37a$export$2d2c9be8b5b863f);
            }
        });
    }
    return EPSG3857Projection;
}((0, $7f0930c45e14ba0b$export$2e2bcd8739ae039));
var $507e80ba0416a37a$export$b508d7ad9a891c1b = [
    new $507e80ba0416a37a$var$EPSG3857Projection("EPSG:3857"),
    new $507e80ba0416a37a$var$EPSG3857Projection("EPSG:102100"),
    new $507e80ba0416a37a$var$EPSG3857Projection("EPSG:102113"),
    new $507e80ba0416a37a$var$EPSG3857Projection("EPSG:900913"),
    new $507e80ba0416a37a$var$EPSG3857Projection("http://www.opengis.net/def/crs/EPSG/0/3857"),
    new $507e80ba0416a37a$var$EPSG3857Projection("http://www.opengis.net/gml/srs/epsg.xml#3857")
];
function $507e80ba0416a37a$export$1ff8bb36c0983070(input, output, dimension) {
    var length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(var i = 0; i < length; i += dimension){
        output[i] = $507e80ba0416a37a$export$f3928063e5e96d35 * input[i] / 180;
        var y = $507e80ba0416a37a$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI * (+input[i + 1] + 90) / 360));
        if (y > $507e80ba0416a37a$export$d26945d1ad52feeb) y = $507e80ba0416a37a$export$d26945d1ad52feeb;
        else if (y < -$507e80ba0416a37a$export$d26945d1ad52feeb) y = -$507e80ba0416a37a$export$d26945d1ad52feeb;
        output[i + 1] = y;
    }
    return output;
}
function $507e80ba0416a37a$export$8c71322ec28ed6b4(input, output, dimension) {
    var length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(var i = 0; i < length; i += dimension){
        output[i] = 180 * input[i] / $507e80ba0416a37a$export$f3928063e5e96d35;
        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / $507e80ba0416a37a$export$2d2c9be8b5b863f)) / Math.PI - 90;
    }
    return output;
}


/**
 * @module ol/proj/epsg4326
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");

var $370142b4dedfb24c$export$2d2c9be8b5b863f = 6378137;
var $370142b4dedfb24c$export$21e6da8a7375dfe8 = [
    -180,
    -90,
    180,
    90
];
var $370142b4dedfb24c$export$1482081eec883108 = Math.PI * $370142b4dedfb24c$export$2d2c9be8b5b863f / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */ var $370142b4dedfb24c$var$EPSG4326Projection = /*#__PURE__*/ function(Projection) {
    "use strict";
    (0, $kcqLc._)(EPSG4326Projection, Projection);
    var _super = (0, $4jYWU._)(EPSG4326Projection);
    function EPSG4326Projection(code, axisOrientation) {
        (0, $5sFFs._)(this, EPSG4326Projection);
        return _super.call(this, {
            code: code,
            units: "degrees",
            extent: $370142b4dedfb24c$export$21e6da8a7375dfe8,
            axisOrientation: axisOrientation,
            global: true,
            metersPerUnit: $370142b4dedfb24c$export$1482081eec883108,
            worldExtent: $370142b4dedfb24c$export$21e6da8a7375dfe8
        });
    }
    return EPSG4326Projection;
}((0, $7f0930c45e14ba0b$export$2e2bcd8739ae039));
var $370142b4dedfb24c$export$b508d7ad9a891c1b = [
    new $370142b4dedfb24c$var$EPSG4326Projection("CRS:84"),
    new $370142b4dedfb24c$var$EPSG4326Projection("EPSG:4326", "neu"),
    new $370142b4dedfb24c$var$EPSG4326Projection("urn:ogc:def:crs:OGC:1.3:CRS84"),
    new $370142b4dedfb24c$var$EPSG4326Projection("urn:ogc:def:crs:OGC:2:84"),
    new $370142b4dedfb24c$var$EPSG4326Projection("http://www.opengis.net/def/crs/OGC/1.3/CRS84"),
    new $370142b4dedfb24c$var$EPSG4326Projection("http://www.opengis.net/gml/srs/epsg.xml#4326", "neu"),
    new $370142b4dedfb24c$var$EPSG4326Projection("http://www.opengis.net/def/crs/EPSG/0/4326", "neu")
];



/**
 * @module ol/proj/projections
 */ /**
 * @type {Object<string, import("./Projection.js").default>}
 */ var $f6dc837b52ed5a87$var$cache = {};
function $f6dc837b52ed5a87$export$42ffd38884aecdac() {
    $f6dc837b52ed5a87$var$cache = {};
}
function $f6dc837b52ed5a87$export$3988ae62b71be9a3(code) {
    return $f6dc837b52ed5a87$var$cache[code] || $f6dc837b52ed5a87$var$cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, "EPSG:$3")] || null;
}
function $f6dc837b52ed5a87$export$e16d8520af44a096(code, projection) {
    $f6dc837b52ed5a87$var$cache[code] = projection;
}


/**
 * @module ol/proj/transforms
 */ 
/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */ var $4e262705aa0b1b0b$var$transforms = {};
function $4e262705aa0b1b0b$export$42ffd38884aecdac() {
    $4e262705aa0b1b0b$var$transforms = {};
}
function $4e262705aa0b1b0b$export$e16d8520af44a096(source, destination, transformFn) {
    var sourceCode = source.getCode();
    var destinationCode = destination.getCode();
    if (!(sourceCode in $4e262705aa0b1b0b$var$transforms)) $4e262705aa0b1b0b$var$transforms[sourceCode] = {};
    $4e262705aa0b1b0b$var$transforms[sourceCode][destinationCode] = transformFn;
}
function $4e262705aa0b1b0b$export$cd7f480d6b8286c3(source, destination) {
    var sourceCode = source.getCode();
    var destinationCode = destination.getCode();
    var transform = $4e262705aa0b1b0b$var$transforms[sourceCode][destinationCode];
    delete $4e262705aa0b1b0b$var$transforms[sourceCode][destinationCode];
    if ((0, $29e93681307ffd1e$export$dd1bc94b04021eeb)($4e262705aa0b1b0b$var$transforms[sourceCode])) delete $4e262705aa0b1b0b$var$transforms[sourceCode];
    return transform;
}
function $4e262705aa0b1b0b$export$3988ae62b71be9a3(sourceCode, destinationCode) {
    var transform;
    if (sourceCode in $4e262705aa0b1b0b$var$transforms && destinationCode in $4e262705aa0b1b0b$var$transforms[sourceCode]) transform = $4e262705aa0b1b0b$var$transforms[sourceCode][destinationCode];
    return transform;
}




/**
 * @module ol/coordinate
 */ 

/**
 * @module ol/string
 */ /**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number} [precision] Precision of the output string (i.e. number of decimal places)
 * @return {string} Formatted string
 */ function $f24b2d947568a204$export$24be126cb0a7bbeb(number, width, precision) {
    var numberString = precision !== undefined ? number.toFixed(precision) : "" + number;
    var decimal = numberString.indexOf(".");
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width ? numberString : new Array(1 + width - decimal).join("0") + numberString;
}
function $f24b2d947568a204$export$66e1c0999abad646(v1, v2) {
    var s1 = ("" + v1).split(".");
    var s2 = ("" + v2).split(".");
    for(var i = 0; i < Math.max(s1.length, s2.length); i++){
        var n1 = parseInt(s1[i] || "0", 10);
        var n2 = parseInt(s2[i] || "0", 10);
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
    }
    return 0;
}


function $96b4c00c3a1729e3$export$e16d8520af44a096(coordinate, delta) {
    coordinate[0] += +delta[0];
    coordinate[1] += +delta[1];
    return coordinate;
}
function $96b4c00c3a1729e3$export$cbe80a3fcd2b99b7(coordinate, circle) {
    var r = circle.getRadius();
    var center = circle.getCenter();
    var x0 = center[0];
    var y0 = center[1];
    var x1 = coordinate[0];
    var y1 = coordinate[1];
    var dx = x1 - x0;
    var dy = y1 - y0;
    if (dx === 0 && dy === 0) dx = 1;
    var d = Math.sqrt(dx * dx + dy * dy);
    var x = x0 + r * dx / d;
    var y = y0 + r * dy / d;
    return [
        x,
        y
    ];
}
function $96b4c00c3a1729e3$export$18cdd31d17f97131(coordinate, segment) {
    var x0 = coordinate[0];
    var y0 = coordinate[1];
    var start = segment[0];
    var end = segment[1];
    var x1 = start[0];
    var y1 = start[1];
    var x2 = end[0];
    var y2 = end[1];
    var dx = x2 - x1;
    var dy = y2 - y1;
    var along = dx === 0 && dy === 0 ? 0 : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    var x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    } else if (along >= 1) {
        x = x2;
        y = y2;
    } else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [
        x,
        y
    ];
}
function $96b4c00c3a1729e3$export$35ad6765fe262b6(fractionDigits) {
    return(/**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */ function(coordinate) {
        return $96b4c00c3a1729e3$export$9ff8f16060979e0a(coordinate, fractionDigits);
    });
}
function $96b4c00c3a1729e3$export$6eb0ac5f024d8590(hemispheres, degrees, fractionDigits) {
    var normalizedDegrees = (0, $029c1e222d833501$export$ba467bec01d66def)(degrees + 180, 360) - 180;
    var x = Math.abs(3600 * normalizedDegrees);
    var decimals = fractionDigits || 0;
    var deg = Math.floor(x / 3600);
    var min = Math.floor((x - deg * 3600) / 60);
    var sec = (0, $029c1e222d833501$export$a81f732198733497)(x - deg * 3600 - min * 60, decimals);
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    var hdms = deg + "\xb0";
    if (min !== 0 || sec !== 0) hdms += " " + (0, $f24b2d947568a204$export$24be126cb0a7bbeb)(min, 2) + "\u2032";
    if (sec !== 0) hdms += " " + (0, $f24b2d947568a204$export$24be126cb0a7bbeb)(sec, 2, decimals) + "\u2033";
    if (normalizedDegrees !== 0) hdms += " " + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0);
    return hdms;
}
function $96b4c00c3a1729e3$export$d9468344d3651243(coordinate, template, fractionDigits) {
    if (coordinate) return template.replace("{x}", coordinate[0].toFixed(fractionDigits)).replace("{y}", coordinate[1].toFixed(fractionDigits));
    return "";
}
function $96b4c00c3a1729e3$export$e9bab7fafb253603(coordinate1, coordinate2) {
    var equals = true;
    for(var i = coordinate1.length - 1; i >= 0; --i)if (coordinate1[i] != coordinate2[i]) {
        equals = false;
        break;
    }
    return equals;
}
function $96b4c00c3a1729e3$export$bb628a54ab399bc9(coordinate, angle) {
    var cosAngle = Math.cos(angle);
    var sinAngle = Math.sin(angle);
    var x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    var y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
function $96b4c00c3a1729e3$export$dcdf75081b88279d(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
function $96b4c00c3a1729e3$export$88e6ebb4fe54f538(coord1, coord2) {
    var dx = coord1[0] - coord2[0];
    var dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
function $96b4c00c3a1729e3$export$9f17032d917177de(coord1, coord2) {
    return Math.sqrt($96b4c00c3a1729e3$export$88e6ebb4fe54f538(coord1, coord2));
}
function $96b4c00c3a1729e3$export$6985570514055196(coordinate, segment) {
    return $96b4c00c3a1729e3$export$88e6ebb4fe54f538(coordinate, $96b4c00c3a1729e3$export$18cdd31d17f97131(coordinate, segment));
}
function $96b4c00c3a1729e3$export$c883fd238161f841(coordinate, fractionDigits) {
    if (coordinate) return $96b4c00c3a1729e3$export$6eb0ac5f024d8590("NS", coordinate[1], fractionDigits) + " " + $96b4c00c3a1729e3$export$6eb0ac5f024d8590("EW", coordinate[0], fractionDigits);
    return "";
}
function $96b4c00c3a1729e3$export$9ff8f16060979e0a(coordinate, fractionDigits) {
    return $96b4c00c3a1729e3$export$d9468344d3651243(coordinate, "{x}, {y}", fractionDigits);
}
function $96b4c00c3a1729e3$export$39a9ce3624977b84(coordinate, projection) {
    if (projection.canWrapX()) {
        var worldWidth = (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(projection.getExtent());
        var worldsAway = $96b4c00c3a1729e3$export$24e2b27d1ff0c1d5(coordinate, projection, worldWidth);
        if (worldsAway) coordinate[0] -= worldsAway * worldWidth;
    }
    return coordinate;
}
function $96b4c00c3a1729e3$export$24e2b27d1ff0c1d5(coordinate, projection, sourceExtentWidth) {
    var projectionExtent = projection.getExtent();
    var worldsAway = 0;
    if (projection.canWrapX() && (coordinate[0] < projectionExtent[0] || coordinate[0] > projectionExtent[2])) {
        sourceExtentWidth = sourceExtentWidth || (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(projectionExtent);
        worldsAway = Math.floor((coordinate[0] - projectionExtent[0]) / sourceExtentWidth);
    }
    return worldsAway;
}


/**
 * @module ol/sphere
 */ 
var $1ce38b0c4fa2f949$export$63f2df7bd7371262 = 6371008.8;
function $1ce38b0c4fa2f949$export$79376507b09a66f(c1, c2, radius) {
    radius = radius || $1ce38b0c4fa2f949$export$63f2df7bd7371262;
    var lat1 = (0, $029c1e222d833501$export$cba01ba138429a1d)(c1[1]);
    var lat2 = (0, $029c1e222d833501$export$cba01ba138429a1d)(c2[1]);
    var deltaLatBy2 = (lat2 - lat1) / 2;
    var deltaLonBy2 = (0, $029c1e222d833501$export$cba01ba138429a1d)(c2[0] - c1[0]) / 2;
    var a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) + Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */ function $1ce38b0c4fa2f949$var$getLengthInternal(coordinates, radius) {
    var length = 0;
    for(var i = 0, ii = coordinates.length; i < ii - 1; ++i)length += $1ce38b0c4fa2f949$export$79376507b09a66f(coordinates[i], coordinates[i + 1], radius);
    return length;
}
function $1ce38b0c4fa2f949$export$f0d11c074a923179(geometry, options) {
    options = options || {};
    var radius = options.radius || $1ce38b0c4fa2f949$export$63f2df7bd7371262;
    var projection = options.projection || "EPSG:3857";
    var type = geometry.getType();
    if (type !== "GeometryCollection") geometry = geometry.clone().transform(projection, "EPSG:4326");
    var length = 0;
    var coordinates, coords, i, ii, j, jj;
    switch(type){
        case "Point":
        case "MultiPoint":
            break;
        case "LineString":
        case "LinearRing":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            length = $1ce38b0c4fa2f949$var$getLengthInternal(coordinates, radius);
            break;
        case "MultiLineString":
        case "Polygon":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i)length += $1ce38b0c4fa2f949$var$getLengthInternal(coordinates[i], radius);
            break;
        case "MultiPolygon":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                for(j = 0, jj = coords.length; j < jj; ++j)length += $1ce38b0c4fa2f949$var$getLengthInternal(coords[j], radius);
            }
            break;
        case "GeometryCollection":
            {
                var geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)length += $1ce38b0c4fa2f949$export$f0d11c074a923179(geometries[i], options);
                break;
            }
        default:
            throw new Error("Unsupported geometry type: " + type);
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */ function $1ce38b0c4fa2f949$var$getAreaInternal(coordinates, radius) {
    var area = 0;
    var len = coordinates.length;
    var x1 = coordinates[len - 1][0];
    var y1 = coordinates[len - 1][1];
    for(var i = 0; i < len; i++){
        var x2 = coordinates[i][0];
        var y2 = coordinates[i][1];
        area += (0, $029c1e222d833501$export$cba01ba138429a1d)(x2 - x1) * (2 + Math.sin((0, $029c1e222d833501$export$cba01ba138429a1d)(y1)) + Math.sin((0, $029c1e222d833501$export$cba01ba138429a1d)(y2)));
        x1 = x2;
        y1 = y2;
    }
    return area * radius * radius / 2.0;
}
function $1ce38b0c4fa2f949$export$520c40045967cb15(geometry, options) {
    options = options || {};
    var radius = options.radius || $1ce38b0c4fa2f949$export$63f2df7bd7371262;
    var projection = options.projection || "EPSG:3857";
    var type = geometry.getType();
    if (type !== "GeometryCollection") geometry = geometry.clone().transform(projection, "EPSG:4326");
    var area = 0;
    var coordinates, coords, i, ii, j, jj;
    switch(type){
        case "Point":
        case "MultiPoint":
        case "LineString":
        case "MultiLineString":
        case "LinearRing":
            break;
        case "Polygon":
            coordinates = /** @type {import("./geom/Polygon.js").default} */ geometry.getCoordinates();
            area = Math.abs($1ce38b0c4fa2f949$var$getAreaInternal(coordinates[0], radius));
            for(i = 1, ii = coordinates.length; i < ii; ++i)area -= Math.abs($1ce38b0c4fa2f949$var$getAreaInternal(coordinates[i], radius));
            break;
        case "MultiPolygon":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                area += Math.abs($1ce38b0c4fa2f949$var$getAreaInternal(coords[0], radius));
                for(j = 1, jj = coords.length; j < jj; ++j)area -= Math.abs($1ce38b0c4fa2f949$var$getAreaInternal(coords[j], radius));
            }
            break;
        case "GeometryCollection":
            {
                var geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)area += $1ce38b0c4fa2f949$export$520c40045967cb15(geometries[i], options);
                break;
            }
        default:
            throw new Error("Unsupported geometry type: " + type);
    }
    return area;
}
function $1ce38b0c4fa2f949$export$cc800923e997bb8(c1, distance, bearing, radius) {
    radius = radius || $1ce38b0c4fa2f949$export$63f2df7bd7371262;
    var lat1 = (0, $029c1e222d833501$export$cba01ba138429a1d)(c1[1]);
    var lon1 = (0, $029c1e222d833501$export$cba01ba138429a1d)(c1[0]);
    var dByR = distance / radius;
    var lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    var lon = lon1 + Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [
        (0, $029c1e222d833501$export$56cb859c01fa134d)(lon),
        (0, $029c1e222d833501$export$56cb859c01fa134d)(lat)
    ];
}


/**
 * @module ol/console
 */ /**
 * @typedef {'info'|'warn'|'error'|'none'} Level
 */ /**
 * @type {Object<Level, number>}
 */ 
var $fyztb = parcelRequire("fyztb");
var $ca13f81415d41843$var$levels = {
    info: 1,
    warn: 2,
    error: 3,
    none: 4
};
/**
 * @type {number}
 */ var $ca13f81415d41843$var$level = $ca13f81415d41843$var$levels.info;
function $ca13f81415d41843$export$2c97a59140dbf245(l) {
    $ca13f81415d41843$var$level = $ca13f81415d41843$var$levels[l];
}
function $ca13f81415d41843$export$bef1f36f5486a6a3() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    if ($ca13f81415d41843$var$level > $ca13f81415d41843$var$levels.info) return;
    (_console = console).log.apply(_console, (0, $fyztb._)(args)); // eslint-disable-line no-console
}
function $ca13f81415d41843$export$c106dd0671a0fc2d() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    if ($ca13f81415d41843$var$level > $ca13f81415d41843$var$levels.warn) return;
    (_console = console).warn.apply(_console, (0, $fyztb._)(args)); // eslint-disable-line no-console
}
function $ca13f81415d41843$export$a3bc9b8ed74fc() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    if ($ca13f81415d41843$var$level > $ca13f81415d41843$var$levels.error) return;
    (_console = console).error.apply(_console, (0, $fyztb._)(args)); // eslint-disable-line no-console
}


var $401a58d9dec354c1$var$showCoordinateWarning = true;
function $401a58d9dec354c1$export$ed949affbc7c4223(disable) {
    var hide = disable === undefined ? true : disable;
    $401a58d9dec354c1$var$showCoordinateWarning = !hide;
}
function $401a58d9dec354c1$export$dd516654c5f598fb(input, output) {
    if (output !== undefined) {
        for(var i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        output;
    } else output = input.slice();
    return output;
}
function $401a58d9dec354c1$export$83e8ab53904f8022(input, output) {
    if (output !== undefined && input !== output) {
        for(var i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        input = output;
    }
    return input;
}
function $401a58d9dec354c1$export$59ae956cd3e343f7(projection) {
    (0, $f6dc837b52ed5a87$export$e16d8520af44a096)(projection.getCode(), projection);
    (0, $4e262705aa0b1b0b$export$e16d8520af44a096)(projection, projection, $401a58d9dec354c1$export$dd516654c5f598fb);
}
function $401a58d9dec354c1$export$638ad73f7aafb913(projections) {
    projections.forEach($401a58d9dec354c1$export$59ae956cd3e343f7);
}
function $401a58d9dec354c1$export$3988ae62b71be9a3(projectionLike) {
    return typeof projectionLike === "string" ? (0, $f6dc837b52ed5a87$export$3988ae62b71be9a3)(/** @type {string} */ projectionLike) : /** @type {Projection} */ projectionLike || null;
}
function $401a58d9dec354c1$export$2d8f7b4eec383d44(projection, resolution, point, units) {
    projection = $401a58d9dec354c1$export$3988ae62b71be9a3(projection);
    var pointResolution;
    var getter = projection.getPointResolutionFunc();
    if (getter) {
        pointResolution = getter(resolution, point);
        if (units && units !== projection.getUnits()) {
            var metersPerUnit = projection.getMetersPerUnit();
            if (metersPerUnit) pointResolution = pointResolution * metersPerUnit / (0, $264085f7209eb4a0$export$1482081eec883108)[units];
        }
    } else {
        var projUnits = projection.getUnits();
        if (projUnits == "degrees" && !units || units == "degrees") pointResolution = resolution;
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            var toEPSG4326 = $401a58d9dec354c1$export$e3c4995a701c26a3(projection, $401a58d9dec354c1$export$3988ae62b71be9a3("EPSG:4326"));
            if (toEPSG4326 === $401a58d9dec354c1$export$83e8ab53904f8022 && projUnits !== "degrees") // no transform is available
            pointResolution = resolution * projection.getMetersPerUnit();
            else {
                var vertices = [
                    point[0] - resolution / 2,
                    point[1],
                    point[0] + resolution / 2,
                    point[1],
                    point[0],
                    point[1] - resolution / 2,
                    point[0],
                    point[1] + resolution / 2
                ];
                vertices = toEPSG4326(vertices, vertices, 2);
                var width = (0, $1ce38b0c4fa2f949$export$79376507b09a66f)(vertices.slice(0, 2), vertices.slice(2, 4));
                var height = (0, $1ce38b0c4fa2f949$export$79376507b09a66f)(vertices.slice(4, 6), vertices.slice(6, 8));
                pointResolution = (width + height) / 2;
            }
            var metersPerUnit1 = units ? (0, $264085f7209eb4a0$export$1482081eec883108)[units] : projection.getMetersPerUnit();
            if (metersPerUnit1 !== undefined) pointResolution /= metersPerUnit1;
        }
    }
    return pointResolution;
}
function $401a58d9dec354c1$export$eeb8392580a05a37(projections) {
    $401a58d9dec354c1$export$638ad73f7aafb913(projections);
    projections.forEach(function(source) {
        projections.forEach(function(destination) {
            if (source !== destination) (0, $4e262705aa0b1b0b$export$e16d8520af44a096)(source, destination, $401a58d9dec354c1$export$dd516654c5f598fb);
        });
    });
}
function $401a58d9dec354c1$export$4856f21c2f184f24(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function(projection1) {
        projections2.forEach(function(projection2) {
            (0, $4e262705aa0b1b0b$export$e16d8520af44a096)(projection1, projection2, forwardTransform);
            (0, $4e262705aa0b1b0b$export$e16d8520af44a096)(projection2, projection1, inverseTransform);
        });
    });
}
function $401a58d9dec354c1$export$4860237d10380594() {
    (0, $f6dc837b52ed5a87$export$42ffd38884aecdac)();
    (0, $4e262705aa0b1b0b$export$42ffd38884aecdac)();
}
function $401a58d9dec354c1$export$549167224996a0fb(projection, defaultCode) {
    if (!projection) return $401a58d9dec354c1$export$3988ae62b71be9a3(defaultCode);
    if (typeof projection === "string") return $401a58d9dec354c1$export$3988ae62b71be9a3(projection);
    return /** @type {Projection} */ projection;
}
function $401a58d9dec354c1$export$6b4aafd331159e0d(coordTransform) {
    return(/**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [output] Output.
     * @param {number} [dimension] Dimension.
     * @return {Array<number>} Output.
     */ function(input, output, dimension) {
        var length = input.length;
        dimension = dimension !== undefined ? dimension : 2;
        output = output !== undefined ? output : new Array(length);
        for(var i = 0; i < length; i += dimension){
            var point = coordTransform(input.slice(i, i + dimension));
            var pointLength = point.length;
            for(var j = 0, jj = dimension; j < jj; ++j)output[i + j] = j >= pointLength ? input[i + j] : point[j];
        }
        return output;
    });
}
function $401a58d9dec354c1$export$6b1c2e6623f4f49d(source, destination, forward, inverse) {
    var sourceProj = $401a58d9dec354c1$export$3988ae62b71be9a3(source);
    var destProj = $401a58d9dec354c1$export$3988ae62b71be9a3(destination);
    (0, $4e262705aa0b1b0b$export$e16d8520af44a096)(sourceProj, destProj, $401a58d9dec354c1$export$6b4aafd331159e0d(forward));
    (0, $4e262705aa0b1b0b$export$e16d8520af44a096)(destProj, sourceProj, $401a58d9dec354c1$export$6b4aafd331159e0d(inverse));
}
function $401a58d9dec354c1$export$b15d9668511529b9(coordinate, projection) {
    $401a58d9dec354c1$export$ed949affbc7c4223();
    return $401a58d9dec354c1$export$51186ad6e864892a(coordinate, "EPSG:4326", projection !== undefined ? projection : "EPSG:3857");
}
function $401a58d9dec354c1$export$3fb495868742d370(coordinate, projection) {
    var lonLat = $401a58d9dec354c1$export$51186ad6e864892a(coordinate, projection !== undefined ? projection : "EPSG:3857", "EPSG:4326");
    var lon = lonLat[0];
    if (lon < -180 || lon > 180) lonLat[0] = (0, $029c1e222d833501$export$ba467bec01d66def)(lon + 180, 360) - 180;
    return lonLat;
}
function $401a58d9dec354c1$export$fe091d73a555748b(projection1, projection2) {
    if (projection1 === projection2) return true;
    var equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) return equalUnits;
    var transformFunc = $401a58d9dec354c1$export$e3c4995a701c26a3(projection1, projection2);
    return transformFunc === $401a58d9dec354c1$export$dd516654c5f598fb && equalUnits;
}
function $401a58d9dec354c1$export$e3c4995a701c26a3(sourceProjection, destinationProjection) {
    var sourceCode = sourceProjection.getCode();
    var destinationCode = destinationProjection.getCode();
    var transformFunc = (0, $4e262705aa0b1b0b$export$3988ae62b71be9a3)(sourceCode, destinationCode);
    if (!transformFunc) transformFunc = $401a58d9dec354c1$export$83e8ab53904f8022;
    return transformFunc;
}
function $401a58d9dec354c1$export$fce0c6cfca85ed96(source, destination) {
    var sourceProjection = $401a58d9dec354c1$export$3988ae62b71be9a3(source);
    var destinationProjection = $401a58d9dec354c1$export$3988ae62b71be9a3(destination);
    return $401a58d9dec354c1$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
}
function $401a58d9dec354c1$export$51186ad6e864892a(coordinate, source, destination) {
    var transformFunc = $401a58d9dec354c1$export$fce0c6cfca85ed96(source, destination);
    return transformFunc(coordinate, undefined, coordinate.length);
}
function $401a58d9dec354c1$export$751c68e0e0efff79(extent, source, destination, stops) {
    var transformFunc = $401a58d9dec354c1$export$fce0c6cfca85ed96(source, destination);
    return (0, $e86e0aa087890eb8$export$9f9dcb98c894b623)(extent, transformFunc, undefined, stops);
}
function $401a58d9dec354c1$export$affbde93b1db73f8(point, sourceProjection, destinationProjection) {
    var transformFunc = $401a58d9dec354c1$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
    return transformFunc(point);
}
/**
 * @type {Projection|null}
 */ var $401a58d9dec354c1$var$userProjection = null;
function $401a58d9dec354c1$export$d0aeadbeac54116e(projection) {
    $401a58d9dec354c1$var$userProjection = $401a58d9dec354c1$export$3988ae62b71be9a3(projection);
}
function $401a58d9dec354c1$export$1ae11279759d4e8f() {
    $401a58d9dec354c1$var$userProjection = null;
}
function $401a58d9dec354c1$export$3973b77d5f6f2790() {
    return $401a58d9dec354c1$var$userProjection;
}
function $401a58d9dec354c1$export$aa7494edfbe36197() {
    $401a58d9dec354c1$export$d0aeadbeac54116e("EPSG:4326");
}
function $401a58d9dec354c1$export$698f563af1ba02a5(coordinate, sourceProjection) {
    if (!$401a58d9dec354c1$var$userProjection) return coordinate;
    return $401a58d9dec354c1$export$51186ad6e864892a(coordinate, sourceProjection, $401a58d9dec354c1$var$userProjection);
}
function $401a58d9dec354c1$export$d4b8ec0b96db1ee2(coordinate, destProjection) {
    if (!$401a58d9dec354c1$var$userProjection) {
        if ($401a58d9dec354c1$var$showCoordinateWarning && !(0, $96b4c00c3a1729e3$export$e9bab7fafb253603)(coordinate, [
            0,
            0
        ]) && coordinate[0] >= -180 && coordinate[0] <= 180 && coordinate[1] >= -90 && coordinate[1] <= 90) {
            $401a58d9dec354c1$var$showCoordinateWarning = false;
            (0, $ca13f81415d41843$export$c106dd0671a0fc2d)("Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates.");
        }
        return coordinate;
    }
    return $401a58d9dec354c1$export$51186ad6e864892a(coordinate, $401a58d9dec354c1$var$userProjection, destProjection);
}
function $401a58d9dec354c1$export$96bfd09e2cffb006(extent, sourceProjection) {
    if (!$401a58d9dec354c1$var$userProjection) return extent;
    return $401a58d9dec354c1$export$751c68e0e0efff79(extent, sourceProjection, $401a58d9dec354c1$var$userProjection);
}
function $401a58d9dec354c1$export$494be3a3a25689ca(extent, destProjection) {
    if (!$401a58d9dec354c1$var$userProjection) return extent;
    return $401a58d9dec354c1$export$751c68e0e0efff79(extent, $401a58d9dec354c1$var$userProjection, destProjection);
}
function $401a58d9dec354c1$export$b56bb8ad8b3a00e9(resolution, sourceProjection) {
    if (!$401a58d9dec354c1$var$userProjection) return resolution;
    var sourceMetersPerUnit = $401a58d9dec354c1$export$3988ae62b71be9a3(sourceProjection).getMetersPerUnit();
    var userMetersPerUnit = $401a58d9dec354c1$var$userProjection.getMetersPerUnit();
    return sourceMetersPerUnit && userMetersPerUnit ? resolution * sourceMetersPerUnit / userMetersPerUnit : resolution;
}
function $401a58d9dec354c1$export$bd1cd3b88140b906(resolution, destProjection) {
    if (!$401a58d9dec354c1$var$userProjection) return resolution;
    var destMetersPerUnit = $401a58d9dec354c1$export$3988ae62b71be9a3(destProjection).getMetersPerUnit();
    var userMetersPerUnit = $401a58d9dec354c1$var$userProjection.getMetersPerUnit();
    return destMetersPerUnit && userMetersPerUnit ? resolution * userMetersPerUnit / destMetersPerUnit : resolution;
}
function $401a58d9dec354c1$export$1873f9cfeb8bd1d6(sourceProj, destProj, transform) {
    return function(coord) {
        var transformed, worldsAway;
        if (sourceProj.canWrapX()) {
            var sourceExtent = sourceProj.getExtent();
            var sourceExtentWidth = (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(sourceExtent);
            coord = coord.slice(0);
            worldsAway = (0, $96b4c00c3a1729e3$export$24e2b27d1ff0c1d5)(coord, sourceProj, sourceExtentWidth);
            if (worldsAway) // Move x to the real world
            coord[0] = coord[0] - worldsAway * sourceExtentWidth;
            coord[0] = (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(coord[0], sourceExtent[0], sourceExtent[2]);
            coord[1] = (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(coord[1], sourceExtent[1], sourceExtent[3]);
            transformed = transform(coord);
        } else transformed = transform(coord);
        if (worldsAway && destProj.canWrapX()) // Move transformed coordinate back to the offset world
        transformed[0] += worldsAway * (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(destProj.getExtent());
        return transformed;
    };
}
function $401a58d9dec354c1$export$86eed449eb2dcac4() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    $401a58d9dec354c1$export$eeb8392580a05a37((0, $507e80ba0416a37a$export$b508d7ad9a891c1b));
    $401a58d9dec354c1$export$eeb8392580a05a37((0, $370142b4dedfb24c$export$b508d7ad9a891c1b));
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    $401a58d9dec354c1$export$4856f21c2f184f24((0, $370142b4dedfb24c$export$b508d7ad9a891c1b), (0, $507e80ba0416a37a$export$b508d7ad9a891c1b), (0, $507e80ba0416a37a$export$1ff8bb36c0983070), (0, $507e80ba0416a37a$export$8c71322ec28ed6b4));
}
$401a58d9dec354c1$export$86eed449eb2dcac4();





/**
 * @module ol/centerconstraint
 */ 
function $70ed134fa9019b60$export$c2f0af2c946f6897(extent, onlyCenter, smooth) {
    return(/**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */ function(center, resolution, size, isMoving, centerShift) {
        if (!center) return undefined;
        if (!resolution && !onlyCenter) return center;
        var viewWidth = onlyCenter ? 0 : size[0] * resolution;
        var viewHeight = onlyCenter ? 0 : size[1] * resolution;
        var shiftX = centerShift ? centerShift[0] : 0;
        var shiftY = centerShift ? centerShift[1] : 0;
        var minX = extent[0] + viewWidth / 2 + shiftX;
        var maxX = extent[2] - viewWidth / 2 + shiftX;
        var minY = extent[1] + viewHeight / 2 + shiftY;
        var maxY = extent[3] - viewHeight / 2 + shiftY;
        // note: when zooming out of bounds, min and max values for x and y may
        // end up inverted (min > max); this has to be accounted for
        if (minX > maxX) {
            minX = (maxX + minX) / 2;
            maxX = minX;
        }
        if (minY > maxY) {
            minY = (maxY + minY) / 2;
            maxY = minY;
        }
        var x = (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(center[0], minX, maxX);
        var y = (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(center[1], minY, maxY);
        // during an interaction, allow some overscroll
        if (isMoving && smooth && resolution) {
            var ratio = 30 * resolution;
            x += -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) + ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
            y += -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) + ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
        }
        return [
            x,
            y
        ];
    });
}
function $70ed134fa9019b60$export$f883a24d5edde77c(center) {
    return center;
}



/**
 * @module ol/resolutionconstraint
 */ 


/**
 * @typedef {function((number|undefined), number, import("./size.js").Size, boolean=): (number|undefined)} Type
 */ /**
 * Returns a modified resolution taking into account the viewport size and maximum
 * allowed extent.
 * @param {number} resolution Resolution
 * @param {import("./extent.js").Extent} maxExtent Maximum allowed extent.
 * @param {import("./size.js").Size} viewportSize Viewport size.
 * @param {boolean} showFullExtent Whether to show the full extent.
 * @return {number} Capped resolution.
 */ function $34497cb7009ade3f$var$getViewportClampedResolution(resolution, maxExtent, viewportSize, showFullExtent) {
    var xResolution = (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(maxExtent) / viewportSize[0];
    var yResolution = (0, $e86e0aa087890eb8$export$c08559766941f856)(maxExtent) / viewportSize[1];
    if (showFullExtent) return Math.min(resolution, Math.max(xResolution, yResolution));
    return Math.min(resolution, Math.min(xResolution, yResolution));
}
/**
 * Returns a modified resolution to be between maxResolution and minResolution while
 * still allowing the value to be slightly out of bounds.
 * Note: the computation is based on the logarithm function (ln):
 *  - at 1, ln(x) is 0
 *  - above 1, ln(x) keeps increasing but at a much slower pace than x
 * The final result is clamped to prevent getting too far away from bounds.
 * @param {number} resolution Resolution.
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @return {number} Smoothed resolution.
 */ function $34497cb7009ade3f$var$getSmoothClampedResolution(resolution, maxResolution, minResolution) {
    var result = Math.min(resolution, maxResolution);
    var ratio = 50;
    result *= Math.log(1 + ratio * Math.max(0, resolution / maxResolution - 1)) / ratio + 1;
    if (minResolution) {
        result = Math.max(result, minResolution);
        result /= Math.log(1 + ratio * Math.max(0, minResolution / resolution - 1)) / ratio + 1;
    }
    return (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(result, minResolution / 2, maxResolution * 2);
}
function $34497cb7009ade3f$export$d65a517690fc4385(resolutions, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            var maxResolution = resolutions[0];
            var minResolution = resolutions[resolutions.length - 1];
            var cappedMaxRes = maxExtent ? $34497cb7009ade3f$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $34497cb7009ade3f$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            var capped = Math.min(cappedMaxRes, resolution);
            var z = Math.floor((0, $edee3659e50a93f4$export$8a3786cc03fdb777)(resolutions, capped, direction));
            if (resolutions[z] > cappedMaxRes && z < resolutions.length - 1) return resolutions[z + 1];
            return resolutions[z];
        }
        return undefined;
    });
}
function $34497cb7009ade3f$export$22ac0f6b219de91a(power, maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    minResolution = minResolution !== undefined ? minResolution : 0;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            var cappedMaxRes = maxExtent ? $34497cb7009ade3f$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $34497cb7009ade3f$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            var tolerance = 1e-9;
            var minZoomLevel = Math.ceil(Math.log(maxResolution / cappedMaxRes) / Math.log(power) - tolerance);
            var offset = -direction * (0.5 - tolerance) + 0.5;
            var capped = Math.min(cappedMaxRes, resolution);
            var cappedZoomLevel = Math.floor(Math.log(maxResolution / capped) / Math.log(power) + offset);
            var zoomLevel = Math.max(minZoomLevel, cappedZoomLevel);
            var newResolution = maxResolution / Math.pow(power, zoomLevel);
            return (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(newResolution, minResolution, cappedMaxRes);
        }
        return undefined;
    });
}
function $34497cb7009ade3f$export$1c4e6da9b4b066fe(maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            var cappedMaxRes = maxExtent ? $34497cb7009ade3f$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            if (!smooth || !isMoving) return (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
            return $34497cb7009ade3f$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
        }
        return undefined;
    });
}


/**
 * @module ol/rotationconstraint
 */ 
function $bf3f3efa75c51dce$export$e20fbacbb41798b(rotation) {
    if (rotation !== undefined) return 0;
    return undefined;
}
function $bf3f3efa75c51dce$export$f883a24d5edde77c(rotation) {
    if (rotation !== undefined) return rotation;
    return undefined;
}
function $bf3f3efa75c51dce$export$9ba78806de831083(n) {
    var theta = 2 * Math.PI / n;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving) return rotation;
        if (rotation !== undefined) {
            rotation = Math.floor(rotation / theta + 0.5) * theta;
            return rotation;
        }
        return undefined;
    });
}
function $bf3f3efa75c51dce$export$17a6e6f3448b17e8(tolerance) {
    var t = tolerance === undefined ? (0, $029c1e222d833501$export$cba01ba138429a1d)(5) : tolerance;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving || rotation === undefined) return rotation;
        if (Math.abs(rotation) <= t) return 0;
        return rotation;
    });
}


/**
 * @module ol/easing
 */ /**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ function $eba911dc905f0f7f$export$929e5a82286172a6(t) {
    return Math.pow(t, 3);
}
function $eba911dc905f0f7f$export$57636bb43b1ccbb0(t) {
    return 1 - $eba911dc905f0f7f$export$929e5a82286172a6(1 - t);
}
function $eba911dc905f0f7f$export$9b47139b511b56e4(t) {
    return 3 * t * t - 2 * t * t * t;
}
function $eba911dc905f0f7f$export$45db2fc2f15997e7(t) {
    return t;
}
function $eba911dc905f0f7f$export$7f4472f6708afaf3(t) {
    if (t < 0.5) return $eba911dc905f0f7f$export$9b47139b511b56e4(2 * t);
    return 1 - $eba911dc905f0f7f$export$9b47139b511b56e4(2 * (t - 0.5));
}




/**
 * @module ol/geom/Polygon
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/geom/LinearRing
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/geom/SimpleGeometry
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/geom/Geometry
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");






/**
 * @module ol/geom/flat/transform
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>} [dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */ function $c8fb0baeba325f5c$export$b92b2dedcfff79de(flatCoordinates, offset, end, stride, transform, dest) {
    dest = dest ? dest : [];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        var x = flatCoordinates[j];
        var y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $c8fb0baeba325f5c$export$bb628a54ab399bc9(flatCoordinates, offset, end, stride, angle, anchor, dest) {
    dest = dest ? dest : [];
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var anchorX = anchor[0];
    var anchorY = anchor[1];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        var deltaX = flatCoordinates[j] - anchorX;
        var deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for(var k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $c8fb0baeba325f5c$export$dcdf75081b88279d(flatCoordinates, offset, end, stride, sx, sy, anchor, dest) {
    dest = dest ? dest : [];
    var anchorX = anchor[0];
    var anchorY = anchor[1];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        var deltaX = flatCoordinates[j] - anchorX;
        var deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for(var k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $c8fb0baeba325f5c$export$d73ee8ef04f5226a(flatCoordinates, offset, end, stride, deltaX, deltaY, dest) {
    dest = dest ? dest : [];
    var i = 0;
    for(var j = offset; j < end; j += stride){
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for(var k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}


/**
 * @typedef {'XY' | 'XYZ' | 'XYM' | 'XYZM'} GeometryLayout
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available.
 */ /**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon' | 'GeometryCollection' | 'Circle'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, or `'Circle'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ var $6acd52922d46c144$var$tmpTransform = (0, $afa6393b3817702c$export$185802fd694ee1f5)();
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */ var $6acd52922d46c144$var$Geometry = /*#__PURE__*/ function(BaseObject) {
    "use strict";
    (0, $kcqLc._)(Geometry, BaseObject);
    var _super = (0, $4jYWU._)(Geometry);
    function Geometry() {
        (0, $5sFFs._)(this, Geometry);
        var _this;
        _this = _super.call(this);
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ _this.extent_ = (0, $e86e0aa087890eb8$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ _this.extentRevision_ = -1;
        /**
     * @protected
     * @type {number}
     */ _this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
     * @protected
     * @type {number}
     */ _this.simplifiedGeometryRevision = 0;
        /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} revision The geometry revision.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */ _this.simplifyTransformedInternal = (0, $d0c140d5afad5e7c$export$ff83df6f9971435f)(function(revision, squaredTolerance, transform) {
            if (!transform) return _this.getSimplifiedGeometry(squaredTolerance);
            var clone = _this.clone();
            clone.applyTransform(transform);
            return clone.getSimplifiedGeometry(squaredTolerance);
        });
        return _this;
    }
    (0, $8O2fV._)(Geometry, [
        {
            /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {Geometry} Simplified geometry.
   */ key: "simplifyTransformed",
            value: function simplifyTransformed(squaredTolerance, transform) {
                return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, transform);
            }
        },
        {
            /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */ key: "clone",
            value: function clone() {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ key: "closestPointXY",
            value: function closestPointXY(x, y, closestPoint, minSquaredDistance) {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ key: "containsXY",
            value: function containsXY(x, y) {
                var coord = this.getClosestPoint([
                    x,
                    y
                ]);
                return coord[0] === x && coord[1] === y;
            }
        },
        {
            /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate} [closestPoint] Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */ key: "getClosestPoint",
            value: function getClosestPoint(point, closestPoint) {
                closestPoint = closestPoint ? closestPoint : [
                    NaN,
                    NaN
                ];
                this.closestPointXY(point[0], point[1], closestPoint, Infinity);
                return closestPoint;
            }
        },
        {
            /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */ key: "intersectsCoordinate",
            value: function intersectsCoordinate(coordinate) {
                return this.containsXY(coordinate[0], coordinate[1]);
            }
        },
        {
            /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ key: "computeExtent",
            value: function computeExtent(extent) {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */ key: "getExtent",
            value: function getExtent(extent) {
                if (this.extentRevision_ != this.getRevision()) {
                    var _$extent = this.computeExtent(this.extent_);
                    if (isNaN(_$extent[0]) || isNaN(_$extent[1])) (0, $e86e0aa087890eb8$export$3e2152b047719fa1)(_$extent);
                    this.extentRevision_ = this.getRevision();
                }
                return (0, $e86e0aa087890eb8$export$6a4fe494c558c238)(this.extent_, extent);
            }
        },
        {
            /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ key: "rotate",
            value: function rotate(angle, anchor) {
                (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ key: "scale",
            value: function scale(sx, sy, anchor) {
                (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
   * algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */ key: "simplify",
            value: function simplify(tolerance) {
                return this.getSimplifiedGeometry(tolerance * tolerance);
            }
        },
        {
            /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */ key: "getSimplifiedGeometry",
            value: function getSimplifiedGeometry(squaredTolerance) {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Get the type of this geometry.
   * @abstract
   * @return {Type} Geometry type.
   */ key: "getType",
            value: function getType() {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   */ key: "applyTransform",
            value: function applyTransform(transformFn) {
                (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */ key: "intersectsExtent",
            value: function intersectsExtent(extent) {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ key: "translate",
            value: function translate(deltaX, deltaY) {
                (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {Geometry} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */ key: "transform",
            value: function transform(source, destination) {
                /** @type {import("../proj/Projection.js").default} */ var sourceProj = (0, $401a58d9dec354c1$export$3988ae62b71be9a3)(source);
                var transformFn = sourceProj.getUnits() == "tile-pixels" ? function transformFn(inCoordinates, outCoordinates, stride) {
                    var pixelExtent = sourceProj.getExtent();
                    var projectedExtent = sourceProj.getWorldExtent();
                    var scale = (0, $e86e0aa087890eb8$export$c08559766941f856)(projectedExtent) / (0, $e86e0aa087890eb8$export$c08559766941f856)(pixelExtent);
                    (0, $afa6393b3817702c$export$f672e0b6f7222cd7)($6acd52922d46c144$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
                    (0, $c8fb0baeba325f5c$export$b92b2dedcfff79de)(inCoordinates, 0, inCoordinates.length, stride, $6acd52922d46c144$var$tmpTransform, outCoordinates);
                    return (0, $401a58d9dec354c1$export$fce0c6cfca85ed96)(sourceProj, destination)(inCoordinates, outCoordinates, stride);
                } : (0, $401a58d9dec354c1$export$fce0c6cfca85ed96)(sourceProj, destination);
                this.applyTransform(transformFn);
                return this;
            }
        }
    ]);
    return Geometry;
}((0, $7a8d25d40aa0de7f$export$2e2bcd8739ae039));
var $6acd52922d46c144$export$2e2bcd8739ae039 = $6acd52922d46c144$var$Geometry;





/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */ var $b8a34d748252df7d$var$SimpleGeometry = /*#__PURE__*/ function(Geometry) {
    "use strict";
    (0, $kcqLc._)(SimpleGeometry, Geometry);
    var _super = (0, $4jYWU._)(SimpleGeometry);
    function SimpleGeometry() {
        (0, $5sFFs._)(this, SimpleGeometry);
        var _this;
        _this = _super.call(this);
        /**
     * @protected
     * @type {import("./Geometry.js").GeometryLayout}
     */ _this.layout = "XY";
        /**
     * @protected
     * @type {number}
     */ _this.stride = 2;
        /**
     * @protected
     * @type {Array<number>}
     */ _this.flatCoordinates;
        return _this;
    }
    (0, $8O2fV._)(SimpleGeometry, [
        {
            /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ key: "computeExtent",
            value: function computeExtent(extent) {
                return (0, $e86e0aa087890eb8$export$be0ab0bf96ca59ca)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
            }
        },
        {
            /**
   * @abstract
   * @return {Array<*> | null} Coordinates.
   */ key: "getCoordinates",
            value: function getCoordinates() {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */ key: "getFirstCoordinate",
            value: function getFirstCoordinate() {
                return this.flatCoordinates.slice(0, this.stride);
            }
        },
        {
            /**
   * @return {Array<number>} Flat coordinates.
   */ key: "getFlatCoordinates",
            value: function getFlatCoordinates() {
                return this.flatCoordinates;
            }
        },
        {
            /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */ key: "getLastCoordinate",
            value: function getLastCoordinate() {
                return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
            }
        },
        {
            /**
   * Return the {@link import("./Geometry.js").GeometryLayout layout} of the geometry.
   * @return {import("./Geometry.js").GeometryLayout} Layout.
   * @api
   */ key: "getLayout",
            value: function getLayout() {
                return this.layout;
            }
        },
        {
            /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   */ key: "getSimplifiedGeometry",
            value: function getSimplifiedGeometry(squaredTolerance) {
                if (this.simplifiedGeometryRevision !== this.getRevision()) {
                    this.simplifiedGeometryMaxMinSquaredTolerance = 0;
                    this.simplifiedGeometryRevision = this.getRevision();
                }
                // If squaredTolerance is negative or if we know that simplification will not
                // have any effect then just return this.
                if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) return this;
                var simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
                var simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
                if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) return simplifiedGeometry;
                // Simplification did not actually remove any coordinates.  We now know
                // that any calls to getSimplifiedGeometry with a squaredTolerance less
                // than or equal to the current squaredTolerance will also not have any
                // effect.  This allows us to short circuit simplification (saving CPU
                // cycles) and prevents the cache of simplified geometries from filling
                // up with useless identical copies of this geometry (saving memory).
                this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
                return this;
            }
        },
        {
            /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */ key: "getSimplifiedGeometryInternal",
            value: function getSimplifiedGeometryInternal(squaredTolerance) {
                return this;
            }
        },
        {
            /**
   * @return {number} Stride.
   */ key: "getStride",
            value: function getStride() {
                return this.stride;
            }
        },
        {
            /**
   * @param {import("./Geometry.js").GeometryLayout} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */ key: "setFlatCoordinates",
            value: function setFlatCoordinates(layout, flatCoordinates) {
                this.stride = $b8a34d748252df7d$export$6af0c1b4a8549a43(layout);
                this.layout = layout;
                this.flatCoordinates = flatCoordinates;
            }
        },
        {
            /**
   * @abstract
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ key: "setCoordinates",
            value: function setCoordinates(coordinates, layout) {
                (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * @param {import("./Geometry.js").GeometryLayout|undefined} layout Layout.
   * @param {Array<*>} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */ key: "setLayout",
            value: function setLayout(layout, coordinates, nesting) {
                var stride;
                if (layout) stride = $b8a34d748252df7d$export$6af0c1b4a8549a43(layout);
                else {
                    for(var i = 0; i < nesting; ++i){
                        if (coordinates.length === 0) {
                            this.layout = "XY";
                            this.stride = 2;
                            return;
                        }
                        coordinates = /** @type {Array<unknown>} */ coordinates[0];
                    }
                    stride = coordinates.length;
                    layout = $b8a34d748252df7d$export$61bb6938093db2c8(stride);
                }
                this.layout = layout;
                this.stride = stride;
            }
        },
        {
            /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   */ key: "applyTransform",
            value: function applyTransform(transformFn) {
                if (this.flatCoordinates) {
                    transformFn(this.flatCoordinates, this.flatCoordinates, this.stride);
                    this.changed();
                }
            }
        },
        {
            /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ key: "rotate",
            value: function rotate1(angle, anchor) {
                var flatCoordinates = this.getFlatCoordinates();
                if (flatCoordinates) {
                    var stride = this.getStride();
                    (0, $c8fb0baeba325f5c$export$bb628a54ab399bc9)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
                    this.changed();
                }
            }
        },
        {
            /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ key: "scale",
            value: function scale1(sx, sy, anchor) {
                if (sy === undefined) sy = sx;
                if (!anchor) anchor = (0, $e86e0aa087890eb8$export$c91255cadecfe081)(this.getExtent());
                var flatCoordinates = this.getFlatCoordinates();
                if (flatCoordinates) {
                    var stride = this.getStride();
                    (0, $c8fb0baeba325f5c$export$dcdf75081b88279d)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
                    this.changed();
                }
            }
        },
        {
            /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ key: "translate",
            value: function translate1(deltaX, deltaY) {
                var flatCoordinates = this.getFlatCoordinates();
                if (flatCoordinates) {
                    var stride = this.getStride();
                    (0, $c8fb0baeba325f5c$export$d73ee8ef04f5226a)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
                    this.changed();
                }
            }
        }
    ]);
    return SimpleGeometry;
}((0, $6acd52922d46c144$export$2e2bcd8739ae039));
function $b8a34d748252df7d$export$61bb6938093db2c8(stride) {
    var layout;
    if (stride == 2) layout = "XY";
    else if (stride == 3) layout = "XYZ";
    else if (stride == 4) layout = "XYZM";
    return /** @type {import("./Geometry.js").GeometryLayout} */ layout;
}
function $b8a34d748252df7d$export$6af0c1b4a8549a43(layout) {
    var stride;
    if (layout == "XY") stride = 2;
    else if (layout == "XYZ" || layout == "XYM") stride = 3;
    else if (layout == "XYZM") stride = 4;
    return /** @type {number} */ stride;
}
function $b8a34d748252df7d$export$a3767472617c7861(simpleGeometry, transform, dest) {
    var flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) return null;
    var stride = simpleGeometry.getStride();
    return (0, $c8fb0baeba325f5c$export$b92b2dedcfff79de)(flatCoordinates, 0, flatCoordinates.length, stride, transform, dest);
}
var $b8a34d748252df7d$export$2e2bcd8739ae039 = $b8a34d748252df7d$var$SimpleGeometry;


/**
 * @module ol/geom/flat/closest
 */ 
/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */ function $7359464f07c6bbdb$var$assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    var x1 = flatCoordinates[offset1];
    var y1 = flatCoordinates[offset1 + 1];
    var dx = flatCoordinates[offset2] - x1;
    var dy = flatCoordinates[offset2 + 1] - y1;
    var offset;
    if (dx === 0 && dy === 0) offset = offset1;
    else {
        var t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) offset = offset2;
        else if (t > 0) {
            for(var i = 0; i < stride; ++i)closestPoint[i] = (0, $029c1e222d833501$export$3a89f8d6f6bf6c9f)(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            closestPoint.length = stride;
            return;
        } else offset = offset1;
    }
    for(var i1 = 0; i1 < stride; ++i1)closestPoint[i1] = flatCoordinates[offset + i1];
    closestPoint.length = stride;
}
function $7359464f07c6bbdb$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max) {
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    for(offset += stride; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        var squaredDelta = (0, $029c1e222d833501$export$88e6ebb4fe54f538)(x1, y1, x2, y2);
        if (squaredDelta > max) max = squaredDelta;
        x1 = x2;
        y1 = y2;
    }
    return max;
}
function $7359464f07c6bbdb$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        max = $7359464f07c6bbdb$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
function $7359464f07c6bbdb$export$37c18e6e7d50501a(flatCoordinates, offset, endss, stride, max) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        max = $7359464f07c6bbdb$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
function $7359464f07c6bbdb$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    if (offset == end) return minSquaredDistance;
    var i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = (0, $029c1e222d833501$export$88e6ebb4fe54f538)(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for(i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    var index = offset + stride;
    while(index < end){
        $7359464f07c6bbdb$var$assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = (0, $029c1e222d833501$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
            index += stride;
        } else // Skip ahead multiple points, because we know that all the skipped
        // points cannot be any closer than the closest point we have found so
        // far.  We know this because we know how close the current point is, how
        // close the closest point we have found so far is, and the maximum
        // distance between consecutive points.  For example, if we're currently
        // at distance 10, the best we've found so far is 3, and that the maximum
        // distance between consecutive points is 2, then we'll need to skip at
        // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
        // finding a closer point.  We use Math.max(..., 1) to ensure that we
        // always advance at least one point, to avoid an infinite loop.
        index += stride * Math.max((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) / maxDelta | 0, 1);
    }
    if (isRing) {
        // Check the closing segment.
        $7359464f07c6bbdb$var$assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = (0, $029c1e222d833501$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
function $7359464f07c6bbdb$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        minSquaredDistance = $7359464f07c6bbdb$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
function $7359464f07c6bbdb$export$60e067685eb8f9c4(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        minSquaredDistance = $7359464f07c6bbdb$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}



/**
 * @module ol/geom/flat/deflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ function $619b917ada0c75a6$export$60815ead40ec79ab(flatCoordinates, offset, coordinate, stride) {
    for(var i = 0, ii = coordinate.length; i < ii; ++i)flatCoordinates[offset++] = coordinate[i];
    return offset;
}
function $619b917ada0c75a6$export$5c4daf67e03c190f(flatCoordinates, offset, coordinates, stride) {
    for(var i = 0, ii = coordinates.length; i < ii; ++i){
        var coordinate = coordinates[i];
        for(var j = 0; j < stride; ++j)flatCoordinates[offset++] = coordinate[j];
    }
    return offset;
}
function $619b917ada0c75a6$export$47c3746a74384d45(flatCoordinates, offset, coordinatess, stride, ends) {
    ends = ends ? ends : [];
    var i = 0;
    for(var j = 0, jj = coordinatess.length; j < jj; ++j){
        var end = $619b917ada0c75a6$export$5c4daf67e03c190f(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
function $619b917ada0c75a6$export$f9f2bb59da4accd3(flatCoordinates, offset, coordinatesss, stride, endss) {
    endss = endss ? endss : [];
    var i = 0;
    for(var j = 0, jj = coordinatesss.length; j < jj; ++j){
        var ends = $619b917ada0c75a6$export$47c3746a74384d45(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        if (ends.length === 0) ends[0] = offset;
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}


/**
 * @module ol/geom/flat/simplify
 */ // Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

function $a4f7faacf16083d1$export$2cbbcce9030b8734(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, simplifiedFlatCoordinates) {
    simplifiedFlatCoordinates = simplifiedFlatCoordinates !== undefined ? simplifiedFlatCoordinates : [];
    if (!highQuality) {
        end = $a4f7faacf16083d1$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = $a4f7faacf16083d1$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
function $a4f7faacf16083d1$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    var n = (end - offset) / stride;
    if (n < 3) {
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */ var markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */ var stack = [
        offset,
        end - stride
    ];
    var index = 0;
    while(stack.length > 0){
        var last = stack.pop();
        var first = stack.pop();
        var maxSquaredDistance = 0;
        var x1 = flatCoordinates[first];
        var y1 = flatCoordinates[first + 1];
        var x2 = flatCoordinates[last];
        var y2 = flatCoordinates[last + 1];
        for(var i = first + stride; i < last; i += stride){
            var x = flatCoordinates[i];
            var y = flatCoordinates[i + 1];
            var squaredDistance = (0, $029c1e222d833501$export$251bb0a9cef172e6)(x, y, x1, y1, x2, y2);
            if (squaredDistance > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) stack.push(first, index);
            if (index + stride < last) stack.push(index, last);
        }
    }
    for(var i1 = 0; i1 < n; ++i1)if (markers[i1]) {
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i1 * stride];
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i1 * stride + 1];
    }
    return simplifiedOffset;
}
function $a4f7faacf16083d1$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        simplifiedOffset = $a4f7faacf16083d1$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $a4f7faacf16083d1$export$5d74fb54bb752ea0(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        /** @type {Array<number>} */ var simplifiedEnds = [];
        simplifiedOffset = $a4f7faacf16083d1$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
function $a4f7faacf16083d1$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    var x2 = x1;
    var y2 = y1;
    for(offset += stride; offset < end; offset += stride){
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if ((0, $029c1e222d833501$export$88e6ebb4fe54f538)(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
function $a4f7faacf16083d1$export$51a0620f7a28532b(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
function $a4f7faacf16083d1$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) return simplifiedOffset;
    // snap the first coordinate (P1)
    var x1 = $a4f7faacf16083d1$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
    var y1 = $a4f7faacf16083d1$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    var x2, y2;
    do {
        x2 = $a4f7faacf16083d1$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        y2 = $a4f7faacf16083d1$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    }while (x2 == x1 && y2 == y1);
    while(offset < end){
        // snap the next coordinate (P3)
        var x3 = $a4f7faacf16083d1$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        var y3 = $a4f7faacf16083d1$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) continue;
        // calculate the delta between P1 and P2
        var dx1 = x2 - x1;
        var dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        var dx2 = x3 - x1;
        var dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 && (dx1 < 0 && dx2 < dx1 || dx1 == dx2 || dx1 > 0 && dx2 > dx1) && (dy1 < 0 && dy2 < dy1 || dy1 == dy2 || dy1 > 0 && dy2 > dy1)) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
function $a4f7faacf16083d1$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        simplifiedOffset = $a4f7faacf16083d1$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $a4f7faacf16083d1$export$b9acf67ef05cd17c(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        /** @type {Array<number>} */ var simplifiedEnds = [];
        simplifiedOffset = $a4f7faacf16083d1$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}


/**
 * @module ol/geom/flat/inflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>} [coordinates] Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */ function $c51d6f1a0abb2d94$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinates) {
    coordinates = coordinates !== undefined ? coordinates : [];
    var i = 0;
    for(var j = offset; j < end; j += stride)coordinates[i++] = flatCoordinates.slice(j, j + stride);
    coordinates.length = i;
    return coordinates;
}
function $c51d6f1a0abb2d94$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatess) {
    coordinatess = coordinatess !== undefined ? coordinatess : [];
    var i = 0;
    for(var j = 0, jj = ends.length; j < jj; ++j){
        var end = ends[j];
        coordinatess[i++] = $c51d6f1a0abb2d94$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
function $c51d6f1a0abb2d94$export$915c7058aeb4dfeb(flatCoordinates, offset, endss, stride, coordinatesss) {
    coordinatesss = coordinatesss !== undefined ? coordinatesss : [];
    var i = 0;
    for(var j = 0, jj = endss.length; j < jj; ++j){
        var ends = endss[j];
        coordinatesss[i++] = ends.length === 1 && ends[0] === offset ? [] : $c51d6f1a0abb2d94$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}


/**
 * @module ol/geom/flat/area
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ function $d7e1f37d96190f57$export$3c5e1905f889266e(flatCoordinates, offset, end, stride) {
    var twiceArea = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        twiceArea += y1 * x2 - x1 * y2;
        x1 = x2;
        y1 = y2;
    }
    return twiceArea / 2;
}
function $d7e1f37d96190f57$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride) {
    var area = 0;
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        area += $d7e1f37d96190f57$export$3c5e1905f889266e(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
function $d7e1f37d96190f57$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    var area = 0;
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        area += $d7e1f37d96190f57$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}


/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */ var $f30e6fc6e3b4e404$var$LinearRing = /*#__PURE__*/ function(SimpleGeometry) {
    "use strict";
    (0, $kcqLc._)(LinearRing, SimpleGeometry);
    var _super = (0, $4jYWU._)(LinearRing);
    function LinearRing(coordinates, layout) {
        (0, $5sFFs._)(this, LinearRing);
        var _this;
        _this = _super.call(this);
        /**
     * @private
     * @type {number}
     */ _this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ _this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) _this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else _this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
        return _this;
    }
    (0, $8O2fV._)(LinearRing, [
        {
            /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @api
   */ key: "clone",
            value: function clone() {
                return new LinearRing(this.flatCoordinates.slice(), this.layout);
            }
        },
        {
            /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ key: "closestPointXY",
            value: function closestPointXY(x, y, closestPoint, minSquaredDistance) {
                if (minSquaredDistance < (0, $e86e0aa087890eb8$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
                if (this.maxDeltaRevision_ != this.getRevision()) {
                    this.maxDelta_ = Math.sqrt((0, $7359464f07c6bbdb$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
                    this.maxDeltaRevision_ = this.getRevision();
                }
                return (0, $7359464f07c6bbdb$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
            }
        },
        {
            /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ key: "getArea",
            value: function getArea() {
                return (0, $d7e1f37d96190f57$export$3c5e1905f889266e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
            }
        },
        {
            /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */ key: "getCoordinates",
            value: function getCoordinates() {
                return (0, $c51d6f1a0abb2d94$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
            }
        },
        {
            /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LinearRing} Simplified LinearRing.
   * @protected
   */ key: "getSimplifiedGeometryInternal",
            value: function getSimplifiedGeometryInternal(squaredTolerance) {
                /** @type {Array<number>} */ var simplifiedFlatCoordinates = [];
                simplifiedFlatCoordinates.length = (0, $a4f7faacf16083d1$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
                return new LinearRing(simplifiedFlatCoordinates, "XY");
            }
        },
        {
            /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ key: "getType",
            value: function getType() {
                return "LinearRing";
            }
        },
        {
            /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ key: "intersectsExtent",
            value: function intersectsExtent(extent) {
                return false;
            }
        },
        {
            /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ key: "setCoordinates",
            value: function setCoordinates(coordinates, layout) {
                this.setLayout(layout, coordinates, 1);
                if (!this.flatCoordinates) this.flatCoordinates = [];
                this.flatCoordinates.length = (0, $619b917ada0c75a6$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
                this.changed();
            }
        }
    ]);
    return LinearRing;
}((0, $b8a34d748252df7d$export$2e2bcd8739ae039));
var $f30e6fc6e3b4e404$export$2e2bcd8739ae039 = $f30e6fc6e3b4e404$var$LinearRing;


/**
 * @module ol/geom/Point
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");




/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */ var $b36c6ea9ae4054c8$var$Point = /*#__PURE__*/ function(SimpleGeometry) {
    "use strict";
    (0, $kcqLc._)(Point, SimpleGeometry);
    var _super = (0, $4jYWU._)(Point);
    function Point(coordinates, layout) {
        (0, $5sFFs._)(this, Point);
        var _this;
        _this = _super.call(this);
        _this.setCoordinates(coordinates, layout);
        return _this;
    }
    (0, $8O2fV._)(Point, [
        {
            /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @api
   */ key: "clone",
            value: function clone() {
                var point = new Point(this.flatCoordinates.slice(), this.layout);
                point.applyProperties(this);
                return point;
            }
        },
        {
            /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ key: "closestPointXY",
            value: function closestPointXY(x, y, closestPoint, minSquaredDistance) {
                var flatCoordinates = this.flatCoordinates;
                var squaredDistance = (0, $029c1e222d833501$export$88e6ebb4fe54f538)(x, y, flatCoordinates[0], flatCoordinates[1]);
                if (squaredDistance < minSquaredDistance) {
                    var stride = this.stride;
                    for(var i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[i];
                    closestPoint.length = stride;
                    return squaredDistance;
                }
                return minSquaredDistance;
            }
        },
        {
            /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @api
   */ key: "getCoordinates",
            value: function getCoordinates() {
                return this.flatCoordinates.slice();
            }
        },
        {
            /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ key: "computeExtent",
            value: function computeExtent(extent) {
                return (0, $e86e0aa087890eb8$export$4838bf78d04a9440)(this.flatCoordinates, extent);
            }
        },
        {
            /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ key: "getType",
            value: function getType() {
                return "Point";
            }
        },
        {
            /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ key: "intersectsExtent",
            value: function intersectsExtent(extent) {
                return (0, $e86e0aa087890eb8$export$805bdfd6d6690e97)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
            }
        },
        {
            /**
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ key: "setCoordinates",
            value: function setCoordinates(coordinates, layout) {
                this.setLayout(layout, coordinates, 0);
                if (!this.flatCoordinates) this.flatCoordinates = [];
                this.flatCoordinates.length = (0, $619b917ada0c75a6$export$60815ead40ec79ab)(this.flatCoordinates, 0, coordinates, this.stride);
                this.changed();
            }
        }
    ]);
    return Point;
}((0, $b8a34d748252df7d$export$2e2bcd8739ae039));
var $b36c6ea9ae4054c8$export$2e2bcd8739ae039 = $b36c6ea9ae4054c8$var$Point;







/**
 * @module ol/geom/flat/interiorpoint
 */ 
/**
 * @module ol/geom/flat/contains
 */ 
function $b261aa1bdd186388$export$cedabedc7ac0e138(flatCoordinates, offset, end, stride, extent) {
    var outside = (0, $e86e0aa087890eb8$export$f9ed8a3d123a08e2)(extent, /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */ function(coordinate) {
        return !$b261aa1bdd186388$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
function $b261aa1bdd186388$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, x, y) {
    // https://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    var wn = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) wn++;
        } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) wn--;
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
function $b261aa1bdd186388$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) return false;
    if (!$b261aa1bdd186388$export$949a7a3a4b6f34fa(flatCoordinates, offset, ends[0], stride, x, y)) return false;
    for(var i = 1, ii = ends.length; i < ii; ++i){
        if ($b261aa1bdd186388$export$949a7a3a4b6f34fa(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) return false;
    }
    return true;
}
function $b261aa1bdd186388$export$c760d9d16cf92043(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) return false;
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        if ($b261aa1bdd186388$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


function $42d3f2f160e2d087$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, dest) {
    var i, ii, x, x1, x2, y1, y2;
    var y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */ var intersections = [];
    // Calculate intersections with the horizontal line
    for(var r = 0, rr = ends.length; r < rr; ++r){
        var end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for(i = offset; i < end; i += stride){
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
                x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    var pointX = NaN;
    var maxSegmentLength = -Infinity;
    intersections.sort((0, $edee3659e50a93f4$export$fcb633242ef15540));
    x1 = intersections[0];
    for(i = 1, ii = intersections.length; i < ii; ++i){
        x2 = intersections[i];
        var segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if ((0, $b261aa1bdd186388$export$ae868c0f6acc3355)(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
    if (dest) {
        dest.push(pointX, y, maxSegmentLength);
        return dest;
    }
    return [
        pointX,
        y,
        maxSegmentLength
    ];
}
function $42d3f2f160e2d087$export$11463803eda8a372(flatCoordinates, offset, endss, stride, flatCenters) {
    /** @type {Array<number>} */ var interiorPoints = [];
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        interiorPoints = $42d3f2f160e2d087$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}



/**
 * @module ol/geom/flat/intersectsextent
 */ 
/**
 * @module ol/geom/flat/segments
 */ /**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */ function $360ddee7ab6dd00c$export$4b80e395e36b5a56(flatCoordinates, offset, end, stride, callback) {
    var ret;
    offset += stride;
    for(; offset < end; offset += stride){
        ret = callback(flatCoordinates.slice(offset - stride, offset), flatCoordinates.slice(offset, offset + stride));
        if (ret) return ret;
    }
    return false;
}



function $065e72ea2e35a5d2$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent) {
    var coordinatesExtent = (0, $e86e0aa087890eb8$export$30570204156ffd18)((0, $e86e0aa087890eb8$export$fe201bb3bbe031e9)(), flatCoordinates, offset, end, stride);
    if (!(0, $e86e0aa087890eb8$export$7b0a31e10bbff018)(extent, coordinatesExtent)) return false;
    if ((0, $e86e0aa087890eb8$export$be866b1e0809b17e)(extent, coordinatesExtent)) return true;
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2]) return true;
    if (coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) return true;
    return (0, $360ddee7ab6dd00c$export$4b80e395e36b5a56)(flatCoordinates, offset, end, stride, /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */ function(point1, point2) {
        return (0, $e86e0aa087890eb8$export$a6a5a7a461419425)(extent, point1, point2);
    });
}
function $065e72ea2e35a5d2$export$fdb1d8e850bf7937(flatCoordinates, offset, ends, stride, extent) {
    for(var i = 0, ii = ends.length; i < ii; ++i){
        if ($065e72ea2e35a5d2$export$40d8d71841a3d779(flatCoordinates, offset, ends[i], stride, extent)) return true;
        offset = ends[i];
    }
    return false;
}
function $065e72ea2e35a5d2$export$830a0dafbb2ef1c5(flatCoordinates, offset, end, stride, extent) {
    if ($065e72ea2e35a5d2$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent)) return true;
    if ((0, $b261aa1bdd186388$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[1])) return true;
    if ((0, $b261aa1bdd186388$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[3])) return true;
    if ((0, $b261aa1bdd186388$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[1])) return true;
    if ((0, $b261aa1bdd186388$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[3])) return true;
    return false;
}
function $065e72ea2e35a5d2$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent) {
    if (!$065e72ea2e35a5d2$export$830a0dafbb2ef1c5(flatCoordinates, offset, ends[0], stride, extent)) return false;
    if (ends.length === 1) return true;
    for(var i = 1, ii = ends.length; i < ii; ++i)if ((0, $b261aa1bdd186388$export$cedabedc7ac0e138)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        if (!$065e72ea2e35a5d2$export$40d8d71841a3d779(flatCoordinates, ends[i - 1], ends[i], stride, extent)) return false;
    }
    return true;
}
function $065e72ea2e35a5d2$export$77b72fa3792f5bf0(flatCoordinates, offset, endss, stride, extent) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        if ($065e72ea2e35a5d2$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


/**
 * @module ol/geom/flat/orient
 */ /**
 * @module ol/geom/flat/reverse
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */ function $df96c75868a5f5f1$export$741858880c96b18c(flatCoordinates, offset, end, stride) {
    while(offset < end - stride){
        for(var i = 0; i < stride; ++i){
            var tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}


function $a716268c87c20199$export$318f2842ed17e094(flatCoordinates, offset, end, stride) {
    // https://stackoverflow.com/q/1165647/clockwise-method#1165943
    // https://github.com/OSGeo/gdal/blob/master/gdal/ogr/ogrlinearring.cpp
    var edge = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge === 0 ? undefined : edge > 0;
}
function $a716268c87c20199$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        var isClockwise = $a716268c87c20199$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if (right && isClockwise || !right && !isClockwise) return false;
        } else {
            if (right && !isClockwise || !right && isClockwise) return false;
        }
        offset = end;
    }
    return true;
}
function $a716268c87c20199$export$a1d138f4bd85f4b4(flatCoordinates, offset, endss, stride, right) {
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        if (!$a716268c87c20199$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right)) return false;
        if (ends.length) offset = ends[ends.length - 1];
    }
    return true;
}
function $a716268c87c20199$export$b71b604ddfc778c7(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        var isClockwise = $a716268c87c20199$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        var reverse = i === 0 ? right && isClockwise || !right && !isClockwise : right && !isClockwise || !right && isClockwise;
        if (reverse) (0, $df96c75868a5f5f1$export$741858880c96b18c)(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return offset;
}
function $a716268c87c20199$export$ea9ed55fc2a85010(flatCoordinates, offset, endss, stride, right) {
    for(var i = 0, ii = endss.length; i < ii; ++i)offset = $a716268c87c20199$export$b71b604ddfc778c7(flatCoordinates, offset, endss[i], stride, right);
    return offset;
}
function $a716268c87c20199$export$cb72ae403d6e78e6(flatCoordinates, ends) {
    var endss = [];
    var offset = 0;
    var prevEndIndex = 0;
    var startOrientation;
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        // classifies an array of rings into polygons with outer rings and holes
        var orientation = $a716268c87c20199$export$318f2842ed17e094(flatCoordinates, offset, end, 2);
        if (startOrientation === undefined) startOrientation = orientation;
        if (orientation === startOrientation) endss.push(ends.slice(prevEndIndex, i + 1));
        else {
            if (endss.length === 0) continue;
            endss[endss.length - 1].push(ends[prevEndIndex]);
        }
        prevEndIndex = i + 1;
        offset = end;
    }
    return endss;
}







/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */ var $933385b05f7b89e7$var$Polygon = /*#__PURE__*/ function(SimpleGeometry) {
    "use strict";
    (0, $kcqLc._)(Polygon, SimpleGeometry);
    var _super = (0, $4jYWU._)(Polygon);
    function Polygon(coordinates, layout, ends) {
        (0, $5sFFs._)(this, Polygon);
        var _this;
        _this = _super.call(this);
        /**
     * @type {Array<number>}
     * @private
     */ _this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ _this.flatInteriorPointRevision_ = -1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ _this.flatInteriorPoint_ = null;
        /**
     * @private
     * @type {number}
     */ _this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ _this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ _this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ _this.orientedFlatCoordinates_ = null;
        if (layout !== undefined && ends) {
            _this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            _this.ends_ = ends;
        } else _this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
        return _this;
    }
    (0, $8O2fV._)(Polygon, [
        {
            /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */ key: "appendLinearRing",
            value: function appendLinearRing(linearRing) {
                if (!this.flatCoordinates) this.flatCoordinates = linearRing.getFlatCoordinates().slice();
                else (0, $edee3659e50a93f4$export$8b58be045bf06082)(this.flatCoordinates, linearRing.getFlatCoordinates());
                this.ends_.push(this.flatCoordinates.length);
                this.changed();
            }
        },
        {
            /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @api
   */ key: "clone",
            value: function clone() {
                var polygon = new Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
                polygon.applyProperties(this);
                return polygon;
            }
        },
        {
            /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ key: "closestPointXY",
            value: function closestPointXY(x, y, closestPoint, minSquaredDistance) {
                if (minSquaredDistance < (0, $e86e0aa087890eb8$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
                if (this.maxDeltaRevision_ != this.getRevision()) {
                    this.maxDelta_ = Math.sqrt((0, $7359464f07c6bbdb$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
                    this.maxDeltaRevision_ = this.getRevision();
                }
                return (0, $7359464f07c6bbdb$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
            }
        },
        {
            /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ key: "containsXY",
            value: function containsXY(x, y) {
                return (0, $b261aa1bdd186388$export$ae868c0f6acc3355)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
            }
        },
        {
            /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ key: "getArea",
            value: function getArea() {
                return (0, $d7e1f37d96190f57$export$7a8ee541dfdf2ed5)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
            }
        },
        {
            /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   */ key: "getCoordinates",
            value: function getCoordinates(right) {
                var flatCoordinates;
                if (right !== undefined) {
                    flatCoordinates = this.getOrientedFlatCoordinates().slice();
                    (0, $a716268c87c20199$export$b71b604ddfc778c7)(flatCoordinates, 0, this.ends_, this.stride, right);
                } else flatCoordinates = this.flatCoordinates;
                return (0, $c51d6f1a0abb2d94$export$cbb9596fc0f40db2)(flatCoordinates, 0, this.ends_, this.stride);
            }
        },
        {
            /**
   * @return {Array<number>} Ends.
   */ key: "getEnds",
            value: function getEnds() {
                return this.ends_;
            }
        },
        {
            /**
   * @return {Array<number>} Interior point.
   */ key: "getFlatInteriorPoint",
            value: function getFlatInteriorPoint() {
                if (this.flatInteriorPointRevision_ != this.getRevision()) {
                    var flatCenter = (0, $e86e0aa087890eb8$export$c91255cadecfe081)(this.getExtent());
                    this.flatInteriorPoint_ = (0, $42d3f2f160e2d087$export$50e3b25928a5e892)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
                    this.flatInteriorPointRevision_ = this.getRevision();
                }
                return /** @type {import("../coordinate.js").Coordinate} */ this.flatInteriorPoint_;
            }
        },
        {
            /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */ key: "getInteriorPoint",
            value: function getInteriorPoint() {
                return new (0, $b36c6ea9ae4054c8$export$2e2bcd8739ae039)(this.getFlatInteriorPoint(), "XYM");
            }
        },
        {
            /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */ key: "getLinearRingCount",
            value: function getLinearRingCount() {
                return this.ends_.length;
            }
        },
        {
            /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing|null} Linear ring.
   * @api
   */ key: "getLinearRing",
            value: function getLinearRing(index) {
                if (index < 0 || this.ends_.length <= index) return null;
                return new (0, $f30e6fc6e3b4e404$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
            }
        },
        {
            /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */ key: "getLinearRings",
            value: function getLinearRings() {
                var layout = this.layout;
                var flatCoordinates = this.flatCoordinates;
                var ends = this.ends_;
                var linearRings = [];
                var offset = 0;
                for(var i = 0, ii = ends.length; i < ii; ++i){
                    var end = ends[i];
                    var linearRing = new (0, $f30e6fc6e3b4e404$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
                    linearRings.push(linearRing);
                    offset = end;
                }
                return linearRings;
            }
        },
        {
            /**
   * @return {Array<number>} Oriented flat coordinates.
   */ key: "getOrientedFlatCoordinates",
            value: function getOrientedFlatCoordinates() {
                if (this.orientedRevision_ != this.getRevision()) {
                    var flatCoordinates = this.flatCoordinates;
                    if ((0, $a716268c87c20199$export$f27cd06e85f4ba28)(flatCoordinates, 0, this.ends_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
                    else {
                        this.orientedFlatCoordinates_ = flatCoordinates.slice();
                        this.orientedFlatCoordinates_.length = (0, $a716268c87c20199$export$b71b604ddfc778c7)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
                    }
                    this.orientedRevision_ = this.getRevision();
                }
                return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
            }
        },
        {
            /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Polygon} Simplified Polygon.
   * @protected
   */ key: "getSimplifiedGeometryInternal",
            value: function getSimplifiedGeometryInternal(squaredTolerance) {
                /** @type {Array<number>} */ var simplifiedFlatCoordinates = [];
                /** @type {Array<number>} */ var simplifiedEnds = [];
                simplifiedFlatCoordinates.length = (0, $a4f7faacf16083d1$export$60a9904b67f8d51b)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
                return new Polygon(simplifiedFlatCoordinates, "XY", simplifiedEnds);
            }
        },
        {
            /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ key: "getType",
            value: function getType() {
                return "Polygon";
            }
        },
        {
            /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ key: "intersectsExtent",
            value: function intersectsExtent(extent) {
                return (0, $065e72ea2e35a5d2$export$76dcd8f8f83b6ddb)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
            }
        },
        {
            /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ key: "setCoordinates",
            value: function setCoordinates(coordinates, layout) {
                this.setLayout(layout, coordinates, 2);
                if (!this.flatCoordinates) this.flatCoordinates = [];
                var ends = (0, $619b917ada0c75a6$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
                this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
                this.changed();
            }
        }
    ]);
    return Polygon;
}((0, $b8a34d748252df7d$export$2e2bcd8739ae039));
var $933385b05f7b89e7$export$2e2bcd8739ae039 = $933385b05f7b89e7$var$Polygon;
function $933385b05f7b89e7$export$f99d756c6d81ae3f(center, radius, n, sphereRadius) {
    n = n ? n : 32;
    /** @type {Array<number>} */ var flatCoordinates = [];
    for(var i = 0; i < n; ++i)(0, $edee3659e50a93f4$export$8b58be045bf06082)(flatCoordinates, (0, $1ce38b0c4fa2f949$export$cc800923e997bb8)(center, radius, 2 * Math.PI * i / n, sphereRadius));
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new $933385b05f7b89e7$var$Polygon(flatCoordinates, "XY", [
        flatCoordinates.length
    ]);
}
function $933385b05f7b89e7$export$c16b671815801c75(extent) {
    if ((0, $e86e0aa087890eb8$export$dd1bc94b04021eeb)(extent)) throw new Error("Cannot create polygon from empty extent");
    var minX = extent[0];
    var minY = extent[1];
    var maxX = extent[2];
    var maxY = extent[3];
    var flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY
    ];
    return new $933385b05f7b89e7$var$Polygon(flatCoordinates, "XY", [
        flatCoordinates.length
    ]);
}
function $933385b05f7b89e7$export$2451009d645fb8c2(circle, sides, angle) {
    sides = sides ? sides : 32;
    var stride = circle.getStride();
    var layout = circle.getLayout();
    var center = circle.getCenter();
    var arrayLength = stride * (sides + 1);
    var flatCoordinates = new Array(arrayLength);
    for(var i = 0; i < arrayLength; i += stride){
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for(var j = 2; j < stride; j++)flatCoordinates[i + j] = center[j];
    }
    var ends = [
        flatCoordinates.length
    ];
    var polygon = new $933385b05f7b89e7$var$Polygon(flatCoordinates, layout, ends);
    $933385b05f7b89e7$export$87d6a1539a56e47f(polygon, center, circle.getRadius(), angle);
    return polygon;
}
function $933385b05f7b89e7$export$87d6a1539a56e47f(polygon, center, radius, angle) {
    var flatCoordinates = polygon.getFlatCoordinates();
    var stride = polygon.getStride();
    var sides = flatCoordinates.length / stride - 1;
    var startAngle = angle ? angle : 0;
    for(var i = 0; i <= sides; ++i){
        var offset = i * stride;
        var _$angle = startAngle + (0, $029c1e222d833501$export$ba467bec01d66def)(i, sides) * 2 * Math.PI / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(_$angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(_$angle);
    }
    polygon.changed();
}


/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter] Source center.
 * @property {import("./coordinate.js").Coordinate} [targetCenter] Target center.
 * @property {number} [sourceResolution] Source resolution.
 * @property {number} [targetResolution] Target resolution.
 * @property {number} [sourceRotation] Source rotation.
 * @property {number} [targetRotation] Target rotation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Anchor.
 * @property {number} start Start.
 * @property {number} duration Duration.
 * @property {boolean} complete Complete.
 * @property {function(number):number} easing Easing.
 * @property {function(boolean):void} callback Callback.
 */ /**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center Center.
 * @property {import("./resolutionconstraint.js").Type} resolution Resolution.
 * @property {import("./rotationconstraint.js").Type} rotation Rotation.
 */ /**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to
 * fit the extent into. Defaults to the size of the map the view is associated with.
 * If no map or multiple maps are connected to the view, provide the desired box size
 * (e.g. `map.getSize()`).
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [nearest=false] If the view `constrainResolution` option is `true`,
 * get the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean):void} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */ /**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. If a user projection is not set, the coordinate system for the center is
 * specified with the `projection` option. Layer sources will not be fetched if this
 * is not set, but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * view, in other words, nothing outside of this extent can be visible on the map.
 * @property {boolean} [constrainOnlyCenter=false] If true, the extent
 * constraint will only apply to the view center and not the whole extent.
 * @property {boolean} [smoothExtentConstraint=true] If true, the extent
 * constraint will be applied smoothly, i.e. allow the view to go slightly outside
 * of the given `extent`.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {boolean} [multiWorld=false] If `false` the view is constrained so
 * only one world is visible, and you cannot pan off the edge.  If `true` the map
 * may show multiple worlds at low zoom levels.  Only used if the `projection` is
 * global.  Note that if `extent` is also provided it is given precedence.
 * @property {boolean} [constrainResolution=false] If true, the view will always
 * animate to the closest zoom level after an interaction; false means
 * intermediary zoom levels are allowed.
 * @property {boolean} [smoothResolutionConstraint=true] If true, the resolution
 * min/max values will be applied smoothly, i. e. allow the view to exceed slightly
 * the given resolution or zoom bounds.
 * @property {boolean} [showFullExtent=false] Allow the view to be zoomed out to
 * show the full configured extent. By default, when a view is configured with an
 * extent, users will not be able to zoom out so the viewport exceeds the extent in
 * either dimension. This means the full extent may not be visible if the viewport
 * is taller or wider than the aspect ratio of the configured extent. If
 * showFullExtent is true, the user will be able to zoom out so that the viewport
 * exceeds the height or width of the configured extent, but not both, allowing the
 * full extent to be shown.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions that determine the
 * zoom levels if specified. The index in the array corresponds to the zoom level,
 * therefore the resolution values have to be in descending order. It also constrains
 * the resolution by the minimum and maximum value. If set the `maxResolution`,
 * `minResolution`, `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view.
 * @property {number} [zoomFactor=2] The zoom factor used to compute the
 * corresponding resolution.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in css pixels).
 * If the map viewport is partially covered with other content (overlays) along
 * its edges, this setting allows to shift the center of the viewport away from
 * that content. The order of the values is top, right, bottom, left.
 */ /**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remain fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */ /**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center Center (in view projection coordinates).
 * @property {import("./proj/Projection.js").default} projection Projection.
 * @property {number} resolution Resolution.
 * @property {import("./coordinate.js").Coordinate} [nextCenter] The next center during an animation series.
 * @property {number} [nextResolution] The next resolution during an animation series.
 * @property {number} [nextRotation] The next rotation during an animation series.
 * @property {number} rotation Rotation.
 * @property {number} zoom Zoom.
 */ /**
 * Like {@link import("./Map.js").FrameState}, but just `viewState` and `extent`.
 * @typedef {Object} ViewStateLayerStateExtent
 * @property {State} viewState View state.
 * @property {import("./extent.js").Extent} extent Extent (in user projection coordinates).
 * @property {Array<import("./layer/Layer.js").State>} [layerStatesArray] Layer states.
 */ /**
 * Default min zoom level for the map view.
 * @type {number}
 */ var $2d5eedb534d9ecb2$var$DEFAULT_MIN_ZOOM = 0;
/**
 * @typedef {import("./ObjectEventType").Types|'change:center'|'change:resolution'|'change:rotation'} ViewObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<ViewObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|ViewObjectEventTypes, Return>} ViewOnSignature
 */ /**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * A View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Web Mercator (EPSG:3857).
 *
 * ### The view states
 *
 * A View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * The `zoom` state is actually not saved on the view: all computations
 * internally use the `resolution` state. Still, the `setZoom` and `getZoom`
 * methods are available, as well as `getResolutionForZoom` and
 * `getZoomForResolution` to switch from one system to the other.
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view, but any constraint defined in the constructor will
 * be applied along the way.
 *
 * A View object can have a *resolution constraint*, a *rotation constraint*
 * and a *center constraint*.
 *
 * The *resolution constraint* typically restricts min/max values and
 * snaps to specific resolutions. It is determined by the following
 * options: `resolutions`, `maxResolution`, `maxZoom` and `zoomFactor`.
 * If `resolutions` is set, the other three options are ignored. See
 * documentation for each option for more information. By default, the view
 * only has a min/max restriction and allow intermediary zoom levels when
 * pinch-zooming for example.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default rotation is allowed and its value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the view center is not constrained at all.
 *
 * ### Changing the view state
 *
 * It is important to note that `setZoom`, `setResolution`, `setCenter` and
 * `setRotation` are subject to the above mentioned constraints. As such, it
 * may sometimes not be possible to know in advance the resulting state of the
 * View. For example, calling `setResolution(10)` does not guarantee that
 * `getResolution()` will return `10`.
 *
 * A consequence of this is that, when applying a delta on the view state, one
 * should use `adjustCenter`, `adjustRotation`, `adjustZoom` and `adjustResolution`
 * rather than the corresponding setters. This will let view do its internal
 * computations. Besides, the `adjust*` methods also take an `anchor`
 * argument which allows specifying an origin for the transformation.
 *
 * ### Interacting with the view
 *
 * View constraints are usually only applied when the view is *at rest*, meaning that
 * no interaction or animation is ongoing. As such, if the user puts the view in a
 * state that is not equivalent to a constrained one (e.g. rotating the view when
 * the snap angle is 0), an animation will be triggered at the interaction end to
 * put back the view to a stable state;
 *
 * @api
 */ var $2d5eedb534d9ecb2$var$View = /*#__PURE__*/ function(BaseObject) {
    "use strict";
    (0, $kcqLc._)(View, BaseObject);
    var _super = (0, $4jYWU._)(View);
    function View(options) {
        (0, $5sFFs._)(this, View);
        var _this;
        _this = _super.call(this);
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ _this.on;
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ _this.once;
        /***
     * @type {ViewOnSignature<void>}
     */ _this.un;
        options = Object.assign({}, options);
        /**
     * @private
     * @type {Array<number>}
     */ _this.hints_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {Array<Array<Animation>>}
     */ _this.animations_ = [];
        /**
     * @private
     * @type {number|undefined}
     */ _this.updateAnimationKey_;
        /**
     * @private
     * @const
     * @type {import("./proj/Projection.js").default}
     */ _this.projection_ = (0, $401a58d9dec354c1$export$549167224996a0fb)(options.projection, "EPSG:3857");
        /**
     * @private
     * @type {import("./size.js").Size}
     */ _this.viewportSize_ = [
            100,
            100
        ];
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ _this.targetCenter_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ _this.targetResolution_;
        /**
     * @private
     * @type {number|undefined}
     */ _this.targetRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate}
     */ _this.nextCenter_ = null;
        /**
     * @private
     * @type {number}
     */ _this.nextResolution_;
        /**
     * @private
     * @type {number}
     */ _this.nextRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ _this.cancelAnchor_ = undefined;
        if (options.projection) (0, $401a58d9dec354c1$export$ed949affbc7c4223)();
        if (options.center) options.center = (0, $401a58d9dec354c1$export$d4b8ec0b96db1ee2)(options.center, _this.projection_);
        if (options.extent) options.extent = (0, $401a58d9dec354c1$export$494be3a3a25689ca)(options.extent, _this.projection_);
        _this.applyOptions_(options);
        return _this;
    }
    (0, $8O2fV._)(View, [
        {
            /**
   * Set up the view with the given options.
   * @param {ViewOptions} options View options.
   */ key: "applyOptions_",
            value: function applyOptions_(options) {
                var properties = Object.assign({}, options);
                for(var key in 0, $6ae0dd408d4b0296$export$2e2bcd8739ae039)delete properties[key];
                this.setProperties(properties, true);
                var resolutionConstraintInfo = $2d5eedb534d9ecb2$export$c68d65f9148da196(options);
                /**
     * @private
     * @type {number}
     */ this.maxResolution_ = resolutionConstraintInfo.maxResolution;
                /**
     * @private
     * @type {number}
     */ this.minResolution_ = resolutionConstraintInfo.minResolution;
                /**
     * @private
     * @type {number}
     */ this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
                /**
     * @private
     * @type {Array<number>|undefined}
     */ this.resolutions_ = options.resolutions;
                /**
     * @type {Array<number>|undefined}
     * @private
     */ this.padding_ = options.padding;
                /**
     * @private
     * @type {number}
     */ this.minZoom_ = resolutionConstraintInfo.minZoom;
                var centerConstraint = $2d5eedb534d9ecb2$export$964345001ee9ac52(options);
                var resolutionConstraint = resolutionConstraintInfo.constraint;
                var rotationConstraint = $2d5eedb534d9ecb2$export$4eeaa08dd550e3c0(options);
                /**
     * @private
     * @type {Constraints}
     */ this.constraints_ = {
                    center: centerConstraint,
                    resolution: resolutionConstraint,
                    rotation: rotationConstraint
                };
                this.setRotation(options.rotation !== undefined ? options.rotation : 0);
                this.setCenterInternal(options.center !== undefined ? options.center : null);
                if (options.resolution !== undefined) this.setResolution(options.resolution);
                else if (options.zoom !== undefined) this.setZoom(options.zoom);
            }
        },
        {
            key: "padding",
            get: /**
   * Padding (in css pixels).
   * If the map viewport is partially covered with other content (overlays) along
   * its edges, this setting allows to shift the center of the viewport away from that
   * content. The order of the values in the array is top, right, bottom, left.
   * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
   * @type {Array<number>|undefined}
   * @api
   */ function get() {
                return this.padding_;
            },
            set: function set(padding) {
                var oldPadding = this.padding_;
                this.padding_ = padding;
                var center = this.getCenterInternal();
                if (center) {
                    var newPadding = padding || [
                        0,
                        0,
                        0,
                        0
                    ];
                    oldPadding = oldPadding || [
                        0,
                        0,
                        0,
                        0
                    ];
                    var resolution = this.getResolution();
                    var offsetX = resolution / 2 * (newPadding[3] - oldPadding[3] + oldPadding[1] - newPadding[1]);
                    var offsetY = resolution / 2 * (newPadding[0] - oldPadding[0] + oldPadding[2] - newPadding[2]);
                    this.setCenterInternal([
                        center[0] + offsetX,
                        center[1] - offsetY
                    ]);
                }
            }
        },
        {
            /**
   * Get an updated version of the view options used to construct the view.  The
   * current resolution (or zoom), center, and rotation are applied to any stored
   * options.  The provided options can be used to apply new min/max zoom or
   * resolution limits.
   * @param {ViewOptions} newOptions New options to be applied.
   * @return {ViewOptions} New options updated with the current view state.
   */ key: "getUpdatedOptions_",
            value: function getUpdatedOptions_(newOptions) {
                var options = this.getProperties();
                // preserve resolution (or zoom)
                if (options.resolution !== undefined) options.resolution = this.getResolution();
                else options.zoom = this.getZoom();
                // preserve center
                options.center = this.getCenterInternal();
                // preserve rotation
                options.rotation = this.getRotation();
                return Object.assign({}, options, newOptions);
            }
        },
        {
            /**
   * Animate the view.  The view's center, zoom (or resolution), and rotation
   * can be animated for smooth transitions between view states.  For example,
   * to animate the view to a new zoom level:
   *
   *     view.animate({zoom: view.getZoom() + 1});
   *
   * By default, the animation lasts one second and uses in-and-out easing.  You
   * can customize this behavior by including `duration` (in milliseconds) and
   * `easing` options (see {@link module:ol/easing}).
   *
   * To chain together multiple animations, call the method with multiple
   * animation objects.  For example, to first zoom and then pan:
   *
   *     view.animate({zoom: 10}, {center: [0, 0]});
   *
   * If you provide a function as the last argument to the animate method, it
   * will get called at the end of an animation series.  The callback will be
   * called with `true` if the animation series completed on its own or `false`
   * if it was cancelled.
   *
   * Animations are cancelled by user interactions (e.g. dragging the map) or by
   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
   * (or another method that calls one of these).
   *
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
   *     options.  Multiple animations can be run in series by passing multiple
   *     options objects.  To run multiple animations in parallel, call the method
   *     multiple times.  An optional callback can be provided as a final
   *     argument.  The callback will be called with a boolean indicating whether
   *     the animation completed without being cancelled.
   * @api
   */ key: "animate",
            value: function animate(var_args) {
                if (this.isDef() && !this.getAnimating()) this.resolveConstraints(0);
                var args = new Array(arguments.length);
                for(var i = 0; i < args.length; ++i){
                    var options = arguments[i];
                    if (options.center) {
                        options = Object.assign({}, options);
                        options.center = (0, $401a58d9dec354c1$export$d4b8ec0b96db1ee2)(options.center, this.getProjection());
                    }
                    if (options.anchor) {
                        options = Object.assign({}, options);
                        options.anchor = (0, $401a58d9dec354c1$export$d4b8ec0b96db1ee2)(options.anchor, this.getProjection());
                    }
                    args[i] = options;
                }
                this.animateInternal.apply(this, args);
            }
        },
        {
            /**
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
   */ key: "animateInternal",
            value: function animateInternal(var_args) {
                var animationCount = arguments.length;
                var callback;
                if (animationCount > 1 && typeof arguments[animationCount - 1] === "function") {
                    callback = arguments[animationCount - 1];
                    --animationCount;
                }
                var i = 0;
                for(; i < animationCount && !this.isDef(); ++i){
                    // if view properties are not yet set, shortcut to the final state
                    var state = arguments[i];
                    if (state.center) this.setCenterInternal(state.center);
                    if (state.zoom !== undefined) this.setZoom(state.zoom);
                    else if (state.resolution) this.setResolution(state.resolution);
                    if (state.rotation !== undefined) this.setRotation(state.rotation);
                }
                if (i === animationCount) {
                    if (callback) $2d5eedb534d9ecb2$var$animationCallback(callback, true);
                    return;
                }
                var start = Date.now();
                var center = this.targetCenter_.slice();
                var resolution = this.targetResolution_;
                var rotation = this.targetRotation_;
                var series = [];
                for(; i < animationCount; ++i){
                    var options = /** @type {AnimationOptions} */ arguments[i];
                    var animation = {
                        start: start,
                        complete: false,
                        anchor: options.anchor,
                        duration: options.duration !== undefined ? options.duration : 1000,
                        easing: options.easing || (0, $eba911dc905f0f7f$export$9b47139b511b56e4),
                        callback: callback
                    };
                    if (options.center) {
                        animation.sourceCenter = center;
                        animation.targetCenter = options.center.slice();
                        center = animation.targetCenter;
                    }
                    if (options.zoom !== undefined) {
                        animation.sourceResolution = resolution;
                        animation.targetResolution = this.getResolutionForZoom(options.zoom);
                        resolution = animation.targetResolution;
                    } else if (options.resolution) {
                        animation.sourceResolution = resolution;
                        animation.targetResolution = options.resolution;
                        resolution = animation.targetResolution;
                    }
                    if (options.rotation !== undefined) {
                        animation.sourceRotation = rotation;
                        var delta = (0, $029c1e222d833501$export$ba467bec01d66def)(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                        animation.targetRotation = rotation + delta;
                        rotation = animation.targetRotation;
                    }
                    // check if animation is a no-op
                    if ($2d5eedb534d9ecb2$export$ee75376562060184(animation)) animation.complete = true;
                    else start += animation.duration;
                    series.push(animation);
                }
                this.animations_.push(series);
                this.setHint((0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).ANIMATING, 1);
                this.updateAnimations_();
            }
        },
        {
            /**
   * Determine if the view is being animated.
   * @return {boolean} The view is being animated.
   * @api
   */ key: "getAnimating",
            value: function getAnimating() {
                return this.hints_[(0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).ANIMATING] > 0;
            }
        },
        {
            /**
   * Determine if the user is interacting with the view, such as panning or zooming.
   * @return {boolean} The view is being interacted with.
   * @api
   */ key: "getInteracting",
            value: function getInteracting() {
                return this.hints_[(0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).INTERACTING] > 0;
            }
        },
        {
            /**
   * Cancel any ongoing animations.
   * @api
   */ key: "cancelAnimations",
            value: function cancelAnimations() {
                this.setHint((0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).ANIMATING, -this.hints_[(0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).ANIMATING]);
                var anchor;
                for(var i = 0, ii = this.animations_.length; i < ii; ++i){
                    var series = this.animations_[i];
                    if (series[0].callback) $2d5eedb534d9ecb2$var$animationCallback(series[0].callback, false);
                    if (!anchor) for(var j = 0, jj = series.length; j < jj; ++j){
                        var animation = series[j];
                        if (!animation.complete) {
                            anchor = animation.anchor;
                            break;
                        }
                    }
                }
                this.animations_.length = 0;
                this.cancelAnchor_ = anchor;
                this.nextCenter_ = null;
                this.nextResolution_ = NaN;
                this.nextRotation_ = NaN;
            }
        },
        {
            /**
   * Update all animations.
   */ key: "updateAnimations_",
            value: function updateAnimations_() {
                if (this.updateAnimationKey_ !== undefined) {
                    cancelAnimationFrame(this.updateAnimationKey_);
                    this.updateAnimationKey_ = undefined;
                }
                if (!this.getAnimating()) return;
                var now = Date.now();
                var more = false;
                for(var i = this.animations_.length - 1; i >= 0; --i){
                    var series = this.animations_[i];
                    var seriesComplete = true;
                    for(var j = 0, jj = series.length; j < jj; ++j){
                        var animation = series[j];
                        if (animation.complete) continue;
                        var elapsed = now - animation.start;
                        var fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                        if (fraction >= 1) {
                            animation.complete = true;
                            fraction = 1;
                        } else seriesComplete = false;
                        var progress = animation.easing(fraction);
                        if (animation.sourceCenter) {
                            var x0 = animation.sourceCenter[0];
                            var y0 = animation.sourceCenter[1];
                            var x1 = animation.targetCenter[0];
                            var y1 = animation.targetCenter[1];
                            this.nextCenter_ = animation.targetCenter;
                            var x = x0 + progress * (x1 - x0);
                            var y = y0 + progress * (y1 - y0);
                            this.targetCenter_ = [
                                x,
                                y
                            ];
                        }
                        if (animation.sourceResolution && animation.targetResolution) {
                            var resolution = progress === 1 ? animation.targetResolution : animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
                            if (animation.anchor) {
                                var size = this.getViewportSize_(this.getRotation());
                                var constrainedResolution = this.constraints_.resolution(resolution, 0, size, true);
                                this.targetCenter_ = this.calculateCenterZoom(constrainedResolution, animation.anchor);
                            }
                            this.nextResolution_ = animation.targetResolution;
                            this.targetResolution_ = resolution;
                            this.applyTargetState_(true);
                        }
                        if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
                            var rotation = progress === 1 ? (0, $029c1e222d833501$export$ba467bec01d66def)(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
                            if (animation.anchor) {
                                var constrainedRotation = this.constraints_.rotation(rotation, true);
                                this.targetCenter_ = this.calculateCenterRotate(constrainedRotation, animation.anchor);
                            }
                            this.nextRotation_ = animation.targetRotation;
                            this.targetRotation_ = rotation;
                        }
                        this.applyTargetState_(true);
                        more = true;
                        if (!animation.complete) break;
                    }
                    if (seriesComplete) {
                        this.animations_[i] = null;
                        this.setHint((0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).ANIMATING, -1);
                        this.nextCenter_ = null;
                        this.nextResolution_ = NaN;
                        this.nextRotation_ = NaN;
                        var callback = series[0].callback;
                        if (callback) $2d5eedb534d9ecb2$var$animationCallback(callback, true);
                    }
                }
                // prune completed series
                this.animations_ = this.animations_.filter(Boolean);
                if (more && this.updateAnimationKey_ === undefined) this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_.bind(this));
            }
        },
        {
            /**
   * @param {number} rotation Target rotation.
   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
   */ key: "calculateCenterRotate",
            value: function calculateCenterRotate(rotation, anchor) {
                var center;
                var currentCenter = this.getCenterInternal();
                if (currentCenter !== undefined) {
                    center = [
                        currentCenter[0] - anchor[0],
                        currentCenter[1] - anchor[1]
                    ];
                    (0, $96b4c00c3a1729e3$export$bb628a54ab399bc9)(center, rotation - this.getRotation());
                    (0, $96b4c00c3a1729e3$export$e16d8520af44a096)(center, anchor);
                }
                return center;
            }
        },
        {
            /**
   * @param {number} resolution Target resolution.
   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
   */ key: "calculateCenterZoom",
            value: function calculateCenterZoom(resolution, anchor) {
                var center;
                var currentCenter = this.getCenterInternal();
                var currentResolution = this.getResolution();
                if (currentCenter !== undefined && currentResolution !== undefined) {
                    var x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
                    var y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
                    center = [
                        x,
                        y
                    ];
                }
                return center;
            }
        },
        {
            /**
   * Returns the current viewport size.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
   */ key: "getViewportSize_",
            value: function getViewportSize_(rotation) {
                var size = this.viewportSize_;
                if (rotation) {
                    var w = size[0];
                    var h = size[1];
                    return [
                        Math.abs(w * Math.cos(rotation)) + Math.abs(h * Math.sin(rotation)),
                        Math.abs(w * Math.sin(rotation)) + Math.abs(h * Math.cos(rotation))
                    ];
                }
                return size;
            }
        },
        {
            /**
   * Stores the viewport size on the view. The viewport size is not read every time from the DOM
   * to avoid performance hit and layout reflow.
   * This should be done on map size change.
   * Note: the constraints are not resolved during an animation to avoid stopping it
   * @param {import("./size.js").Size} [size] Viewport size; if undefined, [100, 100] is assumed
   */ key: "setViewportSize",
            value: function setViewportSize(size) {
                this.viewportSize_ = Array.isArray(size) ? size.slice() : [
                    100,
                    100
                ];
                if (!this.getAnimating()) this.resolveConstraints(0);
            }
        },
        {
            /**
   * Get the view center.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   * @observable
   * @api
   */ key: "getCenter",
            value: function getCenter() {
                var center = this.getCenterInternal();
                if (!center) return center;
                return (0, $401a58d9dec354c1$export$698f563af1ba02a5)(center, this.getProjection());
            }
        },
        {
            /**
   * Get the view center without transforming to user projection.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   */ key: "getCenterInternal",
            value: function getCenterInternal() {
                return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get((0, $6ae0dd408d4b0296$export$2e2bcd8739ae039).CENTER);
            }
        },
        {
            /**
   * @return {Constraints} Constraints.
   */ key: "getConstraints",
            value: function getConstraints() {
                return this.constraints_;
            }
        },
        {
            /**
   * @return {boolean} Resolution constraint is set
   */ key: "getConstrainResolution",
            value: function getConstrainResolution() {
                return this.get("constrainResolution");
            }
        },
        {
            /**
   * @param {Array<number>} [hints] Destination array.
   * @return {Array<number>} Hint.
   */ key: "getHints",
            value: function getHints(hints) {
                if (hints !== undefined) {
                    hints[0] = this.hints_[0];
                    hints[1] = this.hints_[1];
                    return hints;
                }
                return this.hints_.slice();
            }
        },
        {
            /**
   * Calculate the extent for the current view state and the passed box size.
   * @param {import("./size.js").Size} [size] The pixel dimensions of the box
   * into which the calculated extent should fit. Defaults to the size of the
   * map the view is associated with.
   * If no map or multiple maps are connected to the view, provide the desired
   * box size (e.g. `map.getSize()`).
   * @return {import("./extent.js").Extent} Extent.
   * @api
   */ key: "calculateExtent",
            value: function calculateExtent(size) {
                var extent = this.calculateExtentInternal(size);
                return (0, $401a58d9dec354c1$export$96bfd09e2cffb006)(extent, this.getProjection());
            }
        },
        {
            /**
   * @param {import("./size.js").Size} [size] Box pixel size. If not provided,
   * the map's last known viewport size will be used.
   * @return {import("./extent.js").Extent} Extent.
   */ key: "calculateExtentInternal",
            value: function calculateExtentInternal(size) {
                size = size || this.getViewportSizeMinusPadding_();
                var center = /** @type {!import("./coordinate.js").Coordinate} */ this.getCenterInternal();
                (0, $100b4414e338a711$export$a7a9523472993e97)(center, "The view center is not defined");
                var resolution = /** @type {!number} */ this.getResolution();
                (0, $100b4414e338a711$export$a7a9523472993e97)(resolution !== undefined, "The view resolution is not defined");
                var rotation = /** @type {!number} */ this.getRotation();
                (0, $100b4414e338a711$export$a7a9523472993e97)(rotation !== undefined, "The view rotation is not defined");
                return (0, $e86e0aa087890eb8$export$13ba650faf8308)(center, resolution, rotation, size);
            }
        },
        {
            /**
   * Get the maximum resolution of the view.
   * @return {number} The maximum resolution of the view.
   * @api
   */ key: "getMaxResolution",
            value: function getMaxResolution() {
                return this.maxResolution_;
            }
        },
        {
            /**
   * Get the minimum resolution of the view.
   * @return {number} The minimum resolution of the view.
   * @api
   */ key: "getMinResolution",
            value: function getMinResolution() {
                return this.minResolution_;
            }
        },
        {
            /**
   * Get the maximum zoom level for the view.
   * @return {number} The maximum zoom level.
   * @api
   */ key: "getMaxZoom",
            value: function getMaxZoom() {
                return /** @type {number} */ this.getZoomForResolution(this.minResolution_);
            }
        },
        {
            /**
   * Set a new maximum zoom level for the view.
   * @param {number} zoom The maximum zoom level.
   * @api
   */ key: "setMaxZoom",
            value: function setMaxZoom(zoom) {
                this.applyOptions_(this.getUpdatedOptions_({
                    maxZoom: zoom
                }));
            }
        },
        {
            /**
   * Get the minimum zoom level for the view.
   * @return {number} The minimum zoom level.
   * @api
   */ key: "getMinZoom",
            value: function getMinZoom() {
                return /** @type {number} */ this.getZoomForResolution(this.maxResolution_);
            }
        },
        {
            /**
   * Set a new minimum zoom level for the view.
   * @param {number} zoom The minimum zoom level.
   * @api
   */ key: "setMinZoom",
            value: function setMinZoom(zoom) {
                this.applyOptions_(this.getUpdatedOptions_({
                    minZoom: zoom
                }));
            }
        },
        {
            /**
   * Set whether the view should allow intermediary zoom levels.
   * @param {boolean} enabled Whether the resolution is constrained.
   * @api
   */ key: "setConstrainResolution",
            value: function setConstrainResolution(enabled) {
                this.applyOptions_(this.getUpdatedOptions_({
                    constrainResolution: enabled
                }));
            }
        },
        {
            /**
   * Get the view projection.
   * @return {import("./proj/Projection.js").default} The projection of the view.
   * @api
   */ key: "getProjection",
            value: function getProjection() {
                return this.projection_;
            }
        },
        {
            /**
   * Get the view resolution.
   * @return {number|undefined} The resolution of the view.
   * @observable
   * @api
   */ key: "getResolution",
            value: function getResolution() {
                return /** @type {number|undefined} */ this.get((0, $6ae0dd408d4b0296$export$2e2bcd8739ae039).RESOLUTION);
            }
        },
        {
            /**
   * Get the resolutions for the view. This returns the array of resolutions
   * passed to the constructor of the View, or undefined if none were given.
   * @return {Array<number>|undefined} The resolutions of the view.
   * @api
   */ key: "getResolutions",
            value: function getResolutions() {
                return this.resolutions_;
            }
        },
        {
            /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   * @api
   */ key: "getResolutionForExtent",
            value: function getResolutionForExtent(extent, size) {
                return this.getResolutionForExtentInternal((0, $401a58d9dec354c1$export$494be3a3a25689ca)(extent, this.getProjection()), size);
            }
        },
        {
            /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   */ key: "getResolutionForExtentInternal",
            value: function getResolutionForExtentInternal(extent, size) {
                size = size || this.getViewportSizeMinusPadding_();
                var xResolution = (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(extent) / size[0];
                var yResolution = (0, $e86e0aa087890eb8$export$c08559766941f856)(extent) / size[1];
                return Math.max(xResolution, yResolution);
            }
        },
        {
            /**
   * Return a function that returns a value between 0 and 1 for a
   * resolution. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Resolution for value function.
   */ key: "getResolutionForValueFunction",
            value: function getResolutionForValueFunction(power) {
                power = power || 2;
                var maxResolution = this.getConstrainedResolution(this.maxResolution_);
                var minResolution = this.minResolution_;
                var max = Math.log(maxResolution / minResolution) / Math.log(power);
                return(/**
       * @param {number} value Value.
       * @return {number} Resolution.
       */ function(value) {
                    var resolution = maxResolution / Math.pow(power, value * max);
                    return resolution;
                });
            }
        },
        {
            /**
   * Get the view rotation.
   * @return {number} The rotation of the view in radians.
   * @observable
   * @api
   */ key: "getRotation",
            value: function getRotation() {
                return /** @type {number} */ this.get((0, $6ae0dd408d4b0296$export$2e2bcd8739ae039).ROTATION);
            }
        },
        {
            /**
   * Return a function that returns a resolution for a value between
   * 0 and 1. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Value for resolution function.
   */ key: "getValueForResolutionFunction",
            value: function getValueForResolutionFunction(power) {
                var logPower = Math.log(power || 2);
                var maxResolution = this.getConstrainedResolution(this.maxResolution_);
                var minResolution = this.minResolution_;
                var max = Math.log(maxResolution / minResolution) / logPower;
                return(/**
       * @param {number} resolution Resolution.
       * @return {number} Value.
       */ function(resolution) {
                    var value = Math.log(maxResolution / resolution) / logPower / max;
                    return value;
                });
            }
        },
        {
            /**
   * Returns the size of the viewport minus padding.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size reduced by the padding.
   */ key: "getViewportSizeMinusPadding_",
            value: function getViewportSizeMinusPadding_(rotation) {
                var size = this.getViewportSize_(rotation);
                var padding = this.padding_;
                if (padding) size = [
                    size[0] - padding[1] - padding[3],
                    size[1] - padding[0] - padding[2]
                ];
                return size;
            }
        },
        {
            /**
   * @return {State} View state.
   */ key: "getState",
            value: function getState() {
                var projection = this.getProjection();
                var resolution = this.getResolution();
                var rotation = this.getRotation();
                var center = /** @type {import("./coordinate.js").Coordinate} */ this.getCenterInternal();
                var padding = this.padding_;
                if (padding) {
                    var reducedSize = this.getViewportSizeMinusPadding_();
                    center = $2d5eedb534d9ecb2$var$calculateCenterOn(center, this.getViewportSize_(), [
                        reducedSize[0] / 2 + padding[3],
                        reducedSize[1] / 2 + padding[0]
                    ], resolution, rotation);
                }
                return {
                    center: center.slice(0),
                    projection: projection !== undefined ? projection : null,
                    resolution: resolution,
                    nextCenter: this.nextCenter_,
                    nextResolution: this.nextResolution_,
                    nextRotation: this.nextRotation_,
                    rotation: rotation,
                    zoom: this.getZoom()
                };
            }
        },
        {
            /**
   * @return {ViewStateLayerStateExtent} Like `FrameState`, but just `viewState` and `extent`.
   */ key: "getViewStateAndExtent",
            value: function getViewStateAndExtent() {
                return {
                    viewState: this.getState(),
                    extent: this.calculateExtent()
                };
            }
        },
        {
            /**
   * Get the current zoom level. This method may return non-integer zoom levels
   * if the view does not constrain the resolution, or if an interaction or
   * animation is underway.
   * @return {number|undefined} Zoom.
   * @api
   */ key: "getZoom",
            value: function getZoom() {
                var zoom;
                var resolution = this.getResolution();
                if (resolution !== undefined) zoom = this.getZoomForResolution(resolution);
                return zoom;
            }
        },
        {
            /**
   * Get the zoom level for a resolution.
   * @param {number} resolution The resolution.
   * @return {number|undefined} The zoom level for the provided resolution.
   * @api
   */ key: "getZoomForResolution",
            value: function getZoomForResolution(resolution) {
                var offset = this.minZoom_ || 0;
                var max, zoomFactor;
                if (this.resolutions_) {
                    var nearest = (0, $edee3659e50a93f4$export$8a3786cc03fdb777)(this.resolutions_, resolution, 1);
                    offset = nearest;
                    max = this.resolutions_[nearest];
                    if (nearest == this.resolutions_.length - 1) zoomFactor = 2;
                    else zoomFactor = max / this.resolutions_[nearest + 1];
                } else {
                    max = this.maxResolution_;
                    zoomFactor = this.zoomFactor_;
                }
                return offset + Math.log(max / resolution) / Math.log(zoomFactor);
            }
        },
        {
            /**
   * Get the resolution for a zoom level.
   * @param {number} zoom Zoom level.
   * @return {number} The view resolution for the provided zoom level.
   * @api
   */ key: "getResolutionForZoom",
            value: function getResolutionForZoom(zoom) {
                if (this.resolutions_) {
                    if (this.resolutions_.length <= 1) return 0;
                    var baseLevel = (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(Math.floor(zoom), 0, this.resolutions_.length - 2);
                    var zoomFactor = this.resolutions_[baseLevel] / this.resolutions_[baseLevel + 1];
                    return this.resolutions_[baseLevel] / Math.pow(zoomFactor, (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(zoom - baseLevel, 0, 1));
                }
                return this.maxResolution_ / Math.pow(this.zoomFactor_, zoom - this.minZoom_);
            }
        },
        {
            /**
   * Fit the given geometry or extent based on the given map size and border.
   * The size is pixel dimensions of the box to fit the extent into.
   * In most cases you will want to use the map size, that is `map.getSize()`.
   * Takes care of the map angle.
   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
   *     extent to fit the view to.
   * @param {FitOptions} [options] Options.
   * @api
   */ key: "fit",
            value: function fit(geometryOrExtent, options) {
                /** @type {import("./geom/SimpleGeometry.js").default} */ var geometry;
                (0, $100b4414e338a711$export$a7a9523472993e97)(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ geometryOrExtent.getSimplifiedGeometry === "function", "Invalid extent or geometry provided as `geometry`");
                if (Array.isArray(geometryOrExtent)) {
                    (0, $100b4414e338a711$export$a7a9523472993e97)(!(0, $e86e0aa087890eb8$export$dd1bc94b04021eeb)(geometryOrExtent), "Cannot fit empty extent provided as `geometry`");
                    var extent = (0, $401a58d9dec354c1$export$494be3a3a25689ca)(geometryOrExtent, this.getProjection());
                    geometry = (0, $933385b05f7b89e7$export$c16b671815801c75)(extent);
                } else if (geometryOrExtent.getType() === "Circle") {
                    var extent1 = (0, $401a58d9dec354c1$export$494be3a3a25689ca)(geometryOrExtent.getExtent(), this.getProjection());
                    geometry = (0, $933385b05f7b89e7$export$c16b671815801c75)(extent1);
                    geometry.rotate(this.getRotation(), (0, $e86e0aa087890eb8$export$c91255cadecfe081)(extent1));
                } else {
                    var userProjection = (0, $401a58d9dec354c1$export$3973b77d5f6f2790)();
                    if (userProjection) geometry = /** @type {import("./geom/SimpleGeometry.js").default} */ geometryOrExtent.clone().transform(userProjection, this.getProjection());
                    else geometry = geometryOrExtent;
                }
                this.fitInternal(geometry, options);
            }
        },
        {
            /**
   * Calculate rotated extent
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @return {import("./extent").Extent} The rotated extent for the geometry.
   */ key: "rotatedExtentForGeometry",
            value: function rotatedExtentForGeometry(geometry) {
                var rotation = this.getRotation();
                var cosAngle = Math.cos(rotation);
                var sinAngle = Math.sin(-rotation);
                var coords = geometry.getFlatCoordinates();
                var stride = geometry.getStride();
                var minRotX = Infinity;
                var minRotY = Infinity;
                var maxRotX = -Infinity;
                var maxRotY = -Infinity;
                for(var i = 0, ii = coords.length; i < ii; i += stride){
                    var rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
                    var rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
                    minRotX = Math.min(minRotX, rotX);
                    minRotY = Math.min(minRotY, rotY);
                    maxRotX = Math.max(maxRotX, rotX);
                    maxRotY = Math.max(maxRotY, rotY);
                }
                return [
                    minRotX,
                    minRotY,
                    maxRotX,
                    maxRotY
                ];
            }
        },
        {
            /**
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @param {FitOptions} [options] Options.
   */ key: "fitInternal",
            value: function fitInternal(geometry, options) {
                options = options || {};
                var size = options.size;
                if (!size) size = this.getViewportSizeMinusPadding_();
                var padding = options.padding !== undefined ? options.padding : [
                    0,
                    0,
                    0,
                    0
                ];
                var nearest = options.nearest !== undefined ? options.nearest : false;
                var minResolution;
                if (options.minResolution !== undefined) minResolution = options.minResolution;
                else if (options.maxZoom !== undefined) minResolution = this.getResolutionForZoom(options.maxZoom);
                else minResolution = 0;
                var rotatedExtent = this.rotatedExtentForGeometry(geometry);
                // calculate resolution
                var resolution = this.getResolutionForExtentInternal(rotatedExtent, [
                    size[0] - padding[1] - padding[3],
                    size[1] - padding[0] - padding[2]
                ]);
                resolution = isNaN(resolution) ? minResolution : Math.max(resolution, minResolution);
                resolution = this.getConstrainedResolution(resolution, nearest ? 0 : 1);
                // calculate center
                var rotation = this.getRotation();
                var sinAngle = Math.sin(rotation);
                var cosAngle = Math.cos(rotation);
                var centerRot = (0, $e86e0aa087890eb8$export$c91255cadecfe081)(rotatedExtent);
                centerRot[0] += (padding[1] - padding[3]) / 2 * resolution;
                centerRot[1] += (padding[0] - padding[2]) / 2 * resolution;
                var centerX = centerRot[0] * cosAngle - centerRot[1] * sinAngle;
                var centerY = centerRot[1] * cosAngle + centerRot[0] * sinAngle;
                var center = this.getConstrainedCenter([
                    centerX,
                    centerY
                ], resolution);
                var callback = options.callback ? options.callback : (0, $d0c140d5afad5e7c$export$1cd1943b3a73bbe8);
                if (options.duration !== undefined) this.animateInternal({
                    resolution: resolution,
                    center: center,
                    duration: options.duration,
                    easing: options.easing
                }, callback);
                else {
                    this.targetResolution_ = resolution;
                    this.targetCenter_ = center;
                    this.applyTargetState_(false, true);
                    $2d5eedb534d9ecb2$var$animationCallback(callback, true);
                }
            }
        },
        {
            /**
   * Center on coordinate and view position.
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   * @api
   */ key: "centerOn",
            value: function centerOn(coordinate, size, position) {
                this.centerOnInternal((0, $401a58d9dec354c1$export$d4b8ec0b96db1ee2)(coordinate, this.getProjection()), size, position);
            }
        },
        {
            /**
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   */ key: "centerOnInternal",
            value: function centerOnInternal(coordinate, size, position) {
                this.setCenterInternal($2d5eedb534d9ecb2$var$calculateCenterOn(coordinate, size, position, this.getResolution(), this.getRotation()));
            }
        },
        {
            /**
   * Calculates the shift between map and viewport center.
   * @param {import("./coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {import("./size.js").Size} size Size.
   * @return {Array<number>|undefined} Center shift.
   */ key: "calculateCenterShift",
            value: function calculateCenterShift(center, resolution, rotation, size) {
                var centerShift;
                var padding = this.padding_;
                if (padding && center) {
                    var reducedSize = this.getViewportSizeMinusPadding_(-rotation);
                    var shiftedCenter = $2d5eedb534d9ecb2$var$calculateCenterOn(center, size, [
                        reducedSize[0] / 2 + padding[3],
                        reducedSize[1] / 2 + padding[0]
                    ], resolution, rotation);
                    centerShift = [
                        center[0] - shiftedCenter[0],
                        center[1] - shiftedCenter[1]
                    ];
                }
                return centerShift;
            }
        },
        {
            /**
   * @return {boolean} Is defined.
   */ key: "isDef",
            value: function isDef() {
                return !!this.getCenterInternal() && this.getResolution() !== undefined;
            }
        },
        {
            /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   * @api
   */ key: "adjustCenter",
            value: function adjustCenter(deltaCoordinates) {
                var center = (0, $401a58d9dec354c1$export$698f563af1ba02a5)(this.targetCenter_, this.getProjection());
                this.setCenter([
                    center[0] + deltaCoordinates[0],
                    center[1] + deltaCoordinates[1]
                ]);
            }
        },
        {
            /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   */ key: "adjustCenterInternal",
            value: function adjustCenterInternal(deltaCoordinates) {
                var center = this.targetCenter_;
                this.setCenterInternal([
                    center[0] + deltaCoordinates[0],
                    center[1] + deltaCoordinates[1]
                ]);
            }
        },
        {
            /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ key: "adjustResolution",
            value: function adjustResolution(ratio, anchor) {
                anchor = anchor && (0, $401a58d9dec354c1$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
                this.adjustResolutionInternal(ratio, anchor);
            }
        },
        {
            /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ key: "adjustResolutionInternal",
            value: function adjustResolutionInternal(ratio, anchor) {
                var isMoving = this.getAnimating() || this.getInteracting();
                var size = this.getViewportSize_(this.getRotation());
                var newResolution = this.constraints_.resolution(this.targetResolution_ * ratio, 0, size, isMoving);
                if (anchor) this.targetCenter_ = this.calculateCenterZoom(newResolution, anchor);
                this.targetResolution_ *= ratio;
                this.applyTargetState_();
            }
        },
        {
            /**
   * Adds a value to the view zoom level, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom level.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ key: "adjustZoom",
            value: function adjustZoom(delta, anchor) {
                this.adjustResolution(Math.pow(this.zoomFactor_, -delta), anchor);
            }
        },
        {
            /**
   * Adds a value to the view rotation, optionally using an anchor. Any rotation
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   * @api
   */ key: "adjustRotation",
            value: function adjustRotation(delta, anchor) {
                if (anchor) anchor = (0, $401a58d9dec354c1$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
                this.adjustRotationInternal(delta, anchor);
            }
        },
        {
            /**
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   */ key: "adjustRotationInternal",
            value: function adjustRotationInternal(delta, anchor) {
                var isMoving = this.getAnimating() || this.getInteracting();
                var newRotation = this.constraints_.rotation(this.targetRotation_ + delta, isMoving);
                if (anchor) this.targetCenter_ = this.calculateCenterRotate(newRotation, anchor);
                this.targetRotation_ += delta;
                this.applyTargetState_();
            }
        },
        {
            /**
   * Set the center of the current view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   * @observable
   * @api
   */ key: "setCenter",
            value: function setCenter(center) {
                this.setCenterInternal(center ? (0, $401a58d9dec354c1$export$d4b8ec0b96db1ee2)(center, this.getProjection()) : center);
            }
        },
        {
            /**
   * Set the center using the view projection (not the user projection).
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   */ key: "setCenterInternal",
            value: function setCenterInternal(center) {
                this.targetCenter_ = center;
                this.applyTargetState_();
            }
        },
        {
            /**
   * @param {import("./ViewHint.js").default} hint Hint.
   * @param {number} delta Delta.
   * @return {number} New value.
   */ key: "setHint",
            value: function setHint(hint, delta) {
                this.hints_[hint] += delta;
                this.changed();
                return this.hints_[hint];
            }
        },
        {
            /**
   * Set the resolution for this view. Any resolution constraint will apply.
   * @param {number|undefined} resolution The resolution of the view.
   * @observable
   * @api
   */ key: "setResolution",
            value: function setResolution(resolution) {
                this.targetResolution_ = resolution;
                this.applyTargetState_();
            }
        },
        {
            /**
   * Set the rotation for this view. Any rotation constraint will apply.
   * @param {number} rotation The rotation of the view in radians.
   * @observable
   * @api
   */ key: "setRotation",
            value: function setRotation(rotation) {
                this.targetRotation_ = rotation;
                this.applyTargetState_();
            }
        },
        {
            /**
   * Zoom to a specific zoom level. Any resolution constrain will apply.
   * @param {number} zoom Zoom level.
   * @api
   */ key: "setZoom",
            value: function setZoom(zoom) {
                this.setResolution(this.getResolutionForZoom(zoom));
            }
        },
        {
            /**
   * Recompute rotation/resolution/center based on target values.
   * Note: we have to compute rotation first, then resolution and center considering that
   * parameters can influence one another in case a view extent constraint is present.
   * @param {boolean} [doNotCancelAnims] Do not cancel animations.
   * @param {boolean} [forceMoving] Apply constraints as if the view is moving.
   * @private
   */ key: "applyTargetState_",
            value: function applyTargetState_(doNotCancelAnims, forceMoving) {
                var isMoving = this.getAnimating() || this.getInteracting() || forceMoving;
                // compute rotation
                var newRotation = this.constraints_.rotation(this.targetRotation_, isMoving);
                var size = this.getViewportSize_(newRotation);
                var newResolution = this.constraints_.resolution(this.targetResolution_, 0, size, isMoving);
                var newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, isMoving, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
                if (this.get((0, $6ae0dd408d4b0296$export$2e2bcd8739ae039).ROTATION) !== newRotation) this.set((0, $6ae0dd408d4b0296$export$2e2bcd8739ae039).ROTATION, newRotation);
                if (this.get((0, $6ae0dd408d4b0296$export$2e2bcd8739ae039).RESOLUTION) !== newResolution) {
                    this.set((0, $6ae0dd408d4b0296$export$2e2bcd8739ae039).RESOLUTION, newResolution);
                    this.set("zoom", this.getZoom(), true);
                }
                if (!newCenter || !this.get((0, $6ae0dd408d4b0296$export$2e2bcd8739ae039).CENTER) || !(0, $96b4c00c3a1729e3$export$e9bab7fafb253603)(this.get((0, $6ae0dd408d4b0296$export$2e2bcd8739ae039).CENTER), newCenter)) this.set((0, $6ae0dd408d4b0296$export$2e2bcd8739ae039).CENTER, newCenter);
                if (this.getAnimating() && !doNotCancelAnims) this.cancelAnimations();
                this.cancelAnchor_ = undefined;
            }
        },
        {
            /**
   * If any constraints need to be applied, an animation will be triggered.
   * This is typically done on interaction end.
   * Note: calling this with a duration of 0 will apply the constrained values straight away,
   * without animation.
   * @param {number} [duration] The animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ key: "resolveConstraints",
            value: function resolveConstraints(duration, resolutionDirection, anchor) {
                duration = duration !== undefined ? duration : 200;
                var direction = resolutionDirection || 0;
                var newRotation = this.constraints_.rotation(this.targetRotation_);
                var size = this.getViewportSize_(newRotation);
                var newResolution = this.constraints_.resolution(this.targetResolution_, direction, size);
                var newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, false, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
                if (duration === 0 && !this.cancelAnchor_) {
                    this.targetResolution_ = newResolution;
                    this.targetRotation_ = newRotation;
                    this.targetCenter_ = newCenter;
                    this.applyTargetState_();
                    return;
                }
                anchor = anchor || (duration === 0 ? this.cancelAnchor_ : undefined);
                this.cancelAnchor_ = undefined;
                if (this.getResolution() !== newResolution || this.getRotation() !== newRotation || !this.getCenterInternal() || !(0, $96b4c00c3a1729e3$export$e9bab7fafb253603)(this.getCenterInternal(), newCenter)) {
                    if (this.getAnimating()) this.cancelAnimations();
                    this.animateInternal({
                        rotation: newRotation,
                        center: newCenter,
                        resolution: newResolution,
                        duration: duration,
                        easing: (0, $eba911dc905f0f7f$export$57636bb43b1ccbb0),
                        anchor: anchor
                    });
                }
            }
        },
        {
            /**
   * Notify the View that an interaction has started.
   * The view state will be resolved to a stable one if needed
   * (depending on its constraints).
   * @api
   */ key: "beginInteraction",
            value: function beginInteraction() {
                this.resolveConstraints(0);
                this.setHint((0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).INTERACTING, 1);
            }
        },
        {
            /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ key: "endInteraction",
            value: function endInteraction(duration, resolutionDirection, anchor) {
                anchor = anchor && (0, $401a58d9dec354c1$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
                this.endInteractionInternal(duration, resolutionDirection, anchor);
            }
        },
        {
            /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ key: "endInteractionInternal",
            value: function endInteractionInternal(duration, resolutionDirection, anchor) {
                if (!this.getInteracting()) return;
                this.setHint((0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).INTERACTING, -1);
                this.resolveConstraints(duration, resolutionDirection, anchor);
            }
        },
        {
            /**
   * Get a valid position for the view center according to the current constraints.
   * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
   * @param {number} [targetResolution] Target resolution. If not supplied, the current one will be used.
   * This is useful to guess a valid center position at a different zoom level.
   * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
   */ key: "getConstrainedCenter",
            value: function getConstrainedCenter(targetCenter, targetResolution) {
                var size = this.getViewportSize_(this.getRotation());
                return this.constraints_.center(targetCenter, targetResolution || this.getResolution(), size);
            }
        },
        {
            /**
   * Get a valid zoom level according to the current view constraints.
   * @param {number|undefined} targetZoom Target zoom.
   * @param {number} [direction=0] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid zoom level.
   */ key: "getConstrainedZoom",
            value: function getConstrainedZoom(targetZoom, direction) {
                var targetRes = this.getResolutionForZoom(targetZoom);
                return this.getZoomForResolution(this.getConstrainedResolution(targetRes, direction));
            }
        },
        {
            /**
   * Get a valid resolution according to the current view constraints.
   * @param {number|undefined} targetResolution Target resolution.
   * @param {number} [direction=0] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid resolution.
   */ key: "getConstrainedResolution",
            value: function getConstrainedResolution(targetResolution, direction) {
                direction = direction || 0;
                var size = this.getViewportSize_(this.getRotation());
                return this.constraints_.resolution(targetResolution, direction, size);
            }
        }
    ]);
    return View;
}((0, $7a8d25d40aa0de7f$export$2e2bcd8739ae039));
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */ function $2d5eedb534d9ecb2$var$animationCallback(callback, returnValue) {
    setTimeout(function() {
        callback(returnValue);
    }, 0);
}
function $2d5eedb534d9ecb2$export$964345001ee9ac52(options) {
    if (options.extent !== undefined) {
        var smooth = options.smoothExtentConstraint !== undefined ? options.smoothExtentConstraint : true;
        return (0, $70ed134fa9019b60$export$c2f0af2c946f6897)(options.extent, options.constrainOnlyCenter, smooth);
    }
    var projection = (0, $401a58d9dec354c1$export$549167224996a0fb)(options.projection, "EPSG:3857");
    if (options.multiWorld !== true && projection.isGlobal()) {
        var extent = projection.getExtent().slice();
        extent[0] = -Infinity;
        extent[2] = Infinity;
        return (0, $70ed134fa9019b60$export$c2f0af2c946f6897)(extent, false, false);
    }
    return 0, $70ed134fa9019b60$export$f883a24d5edde77c;
}
function $2d5eedb534d9ecb2$export$c68d65f9148da196(options) {
    var resolutionConstraint;
    var maxResolution;
    var minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    var defaultMaxZoom = 28;
    var defaultZoomFactor = 2;
    var minZoom = options.minZoom !== undefined ? options.minZoom : $2d5eedb534d9ecb2$var$DEFAULT_MIN_ZOOM;
    var maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    var zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    var multiWorld = options.multiWorld !== undefined ? options.multiWorld : false;
    var smooth = options.smoothResolutionConstraint !== undefined ? options.smoothResolutionConstraint : true;
    var showFullExtent = options.showFullExtent !== undefined ? options.showFullExtent : false;
    var projection = (0, $401a58d9dec354c1$export$549167224996a0fb)(options.projection, "EPSG:3857");
    var projExtent = projection.getExtent();
    var constrainOnlyCenter = options.constrainOnlyCenter;
    var extent = options.extent;
    if (!multiWorld && !extent && projection.isGlobal()) {
        constrainOnlyCenter = false;
        extent = projExtent;
    }
    if (options.resolutions !== undefined) {
        var resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution = resolutions[maxZoom] !== undefined ? resolutions[maxZoom] : resolutions[resolutions.length - 1];
        if (options.constrainResolution) resolutionConstraint = (0, $34497cb7009ade3f$export$d65a517690fc4385)(resolutions, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $34497cb7009ade3f$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    } else {
        // calculate the default min and max resolution
        var size = !projExtent ? 360 * (0, $264085f7209eb4a0$export$1482081eec883108).degrees / projection.getMetersPerUnit() : Math.max((0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(projExtent), (0, $e86e0aa087890eb8$export$c08559766941f856)(projExtent));
        var defaultMaxResolution = size / (0, $bb7a9ac0b1791714$export$6b8cb5cd370bd90c) / Math.pow(defaultZoomFactor, $2d5eedb534d9ecb2$var$DEFAULT_MIN_ZOOM);
        var defaultMinResolution = defaultMaxResolution / Math.pow(defaultZoomFactor, defaultMaxZoom - $2d5eedb534d9ecb2$var$DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) minZoom = 0;
        else maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                else minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
            } else minResolution = defaultMinResolution;
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom = minZoom + Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        if (options.constrainResolution) resolutionConstraint = (0, $34497cb7009ade3f$export$22ac0f6b219de91a)(zoomFactor, maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $34497cb7009ade3f$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor
    };
}
function $2d5eedb534d9ecb2$export$4eeaa08dd550e3c0(options) {
    var enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        var constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) return (0, $bf3f3efa75c51dce$export$17a6e6f3448b17e8)();
        if (constrainRotation === false) return 0, $bf3f3efa75c51dce$export$f883a24d5edde77c;
        if (typeof constrainRotation === "number") return (0, $bf3f3efa75c51dce$export$9ba78806de831083)(constrainRotation);
        return 0, $bf3f3efa75c51dce$export$f883a24d5edde77c;
    }
    return 0, $bf3f3efa75c51dce$export$e20fbacbb41798b;
}
function $2d5eedb534d9ecb2$export$ee75376562060184(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!(0, $96b4c00c3a1729e3$export$e9bab7fafb253603)(animation.sourceCenter, animation.targetCenter)) return false;
    }
    if (animation.sourceResolution !== animation.targetResolution) return false;
    if (animation.sourceRotation !== animation.targetRotation) return false;
    return true;
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {import("./size.js").Size} size Box pixel size.
 * @param {import("./pixel.js").Pixel} position Position on the view to center on.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {import("./coordinate.js").Coordinate} Shifted center.
 */ function $2d5eedb534d9ecb2$var$calculateCenterOn(coordinate, size, position, resolution, rotation) {
    // calculate rotated position
    var cosAngle = Math.cos(-rotation);
    var sinAngle = Math.sin(-rotation);
    var rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    var rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    rotX += (size[0] / 2 - position[0]) * resolution;
    rotY += (position[1] - size[1] / 2) * resolution;
    // go back to original angle
    sinAngle = -sinAngle; // go back to original rotation
    var centerX = rotX * cosAngle - rotY * sinAngle;
    var centerY = rotY * cosAngle + rotX * sinAngle;
    return [
        centerX,
        centerY
    ];
}
var $2d5eedb534d9ecb2$export$2e2bcd8739ae039 = $2d5eedb534d9ecb2$var$View;





/**
 * @typedef {function(import("../Map.js").FrameState):HTMLElement} RenderFunction
 */ /**
 * @typedef {'sourceready'|'change:source'} LayerEventType
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     LayerEventType, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|LayerEventType|
 *     import("../render/EventType").LayerRenderEventTypes, Return>} LayerOnSignature
 */ /**
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {SourceType} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer~Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../Map.js").default|null} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer Layer.
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {boolean} visible Visible.
 * @property {boolean} managed Managed.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {number | undefined} zIndex ZIndex.
 * @property {number} maxResolution Maximum resolution.
 * @property {number} minResolution Minimum resolution.
 * @property {number} minZoom Minimum zoom.
 * @property {number} maxZoom Maximum zoom.
 */ /**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * Components like {@link module:ol/interaction/Draw~Draw} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * [layer.setMap()]{@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 * A `sourceready` event is fired when the layer's source is ready.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 * @fires import("../events/Event.js").BaseEvent#sourceready
 *
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {import("../renderer/Layer.js").default} [RendererType=import("../renderer/Layer.js").default]
 * @api
 */ var $45f7b7b1b4f025e5$var$Layer = /*#__PURE__*/ function(BaseLayer) {
    "use strict";
    (0, $kcqLc._)(Layer, BaseLayer);
    var _super = (0, $4jYWU._)(Layer);
    function Layer(options) {
        (0, $5sFFs._)(this, Layer);
        var _this;
        var baseOptions = Object.assign({}, options);
        delete baseOptions.source;
        _this = _super.call(this, baseOptions);
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ _this.on;
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ _this.once;
        /***
     * @type {LayerOnSignature<void>}
     */ _this.un;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ _this.mapPrecomposeKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ _this.mapRenderKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ _this.sourceChangeKey_ = null;
        /**
     * @private
     * @type {RendererType}
     */ _this.renderer_ = null;
        /**
     * @private
     * @type {boolean}
     */ _this.sourceReady_ = false;
        /**
     * @protected
     * @type {boolean}
     */ _this.rendered = false;
        // Overwrite default render method with a custom one
        if (options.render) _this.render = options.render;
        if (options.map) _this.setMap(options.map);
        _this.addChangeListener((0, $7b9db042957f1b51$export$2e2bcd8739ae039).SOURCE, _this.handleSourcePropertyChange_);
        var source = options.source ? /** @type {SourceType} */ options.source : null;
        _this.setSource(source);
        return _this;
    }
    (0, $8O2fV._)(Layer, [
        {
            /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ key: "getLayersArray",
            value: function getLayersArray(array) {
                array = array ? array : [];
                array.push(this);
                return array;
            }
        },
        {
            /**
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ key: "getLayerStatesArray",
            value: function getLayerStatesArray(states) {
                states = states ? states : [];
                states.push(this.getLayerState());
                return states;
            }
        },
        {
            /**
   * Get the layer source.
   * @return {SourceType|null} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */ key: "getSource",
            value: function getSource() {
                return /** @type {SourceType} */ this.get((0, $7b9db042957f1b51$export$2e2bcd8739ae039).SOURCE) || null;
            }
        },
        {
            /**
   * @return {SourceType|null} The source being rendered.
   */ key: "getRenderSource",
            value: function getRenderSource() {
                return this.getSource();
            }
        },
        {
            /**
   * @return {import("../source/Source.js").State} Source state.
   */ key: "getSourceState",
            value: function getSourceState() {
                var source = this.getSource();
                return !source ? "undefined" : source.getState();
            }
        },
        {
            /**
   * @private
   */ key: "handleSourceChange_",
            value: function handleSourceChange_() {
                this.changed();
                if (this.sourceReady_ || this.getSource().getState() !== "ready") return;
                this.sourceReady_ = true;
                this.dispatchEvent("sourceready");
            }
        },
        {
            /**
   * @private
   */ key: "handleSourcePropertyChange_",
            value: function handleSourcePropertyChange_() {
                var _this = this;
                if (this.sourceChangeKey_) {
                    (0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921)(this.sourceChangeKey_);
                    this.sourceChangeKey_ = null;
                }
                this.sourceReady_ = false;
                var source = this.getSource();
                if (source) {
                    this.sourceChangeKey_ = (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(source, (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE, this.handleSourceChange_, this);
                    if (source.getState() === "ready") {
                        this.sourceReady_ = true;
                        setTimeout(function() {
                            _this.dispatchEvent("sourceready");
                        }, 0);
                    }
                }
                this.changed();
            }
        },
        {
            /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ key: "getFeatures",
            value: function getFeatures(pixel) {
                if (!this.renderer_) return Promise.resolve([]);
                return this.renderer_.getFeatures(pixel);
            }
        },
        {
            /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ key: "getData",
            value: function getData(pixel) {
                if (!this.renderer_ || !this.rendered) return null;
                return this.renderer_.getData(pixel);
            }
        },
        {
            /**
   * The layer is visible on the map view, i.e. within its min/max resolution or zoom and
   * extent, not set to `visible: false`, and not inside a layer group that is set
   * to `visible: false`.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {boolean} The layer is visible in the map view.
   * @api
   */ key: "isVisible",
            value: function isVisible(view) {
                var _this = this;
                var frameState;
                var map = this.getMapInternal();
                if (!view && map) view = map.getView();
                if (view instanceof (0, $2d5eedb534d9ecb2$export$2e2bcd8739ae039)) frameState = {
                    viewState: view.getState(),
                    extent: view.calculateExtent()
                };
                else frameState = view;
                if (!frameState.layerStatesArray && map) frameState.layerStatesArray = map.getLayerGroup().getLayerStatesArray();
                var layerState;
                if (frameState.layerStatesArray) layerState = frameState.layerStatesArray.find(function(layerState) {
                    return layerState.layer === _this;
                });
                else layerState = this.getLayerState();
                var layerExtent = this.getExtent();
                return $45f7b7b1b4f025e5$export$acb1e9cb9ce4ca56(layerState, frameState.viewState) && (!layerExtent || (0, $e86e0aa087890eb8$export$7b0a31e10bbff018)(layerExtent, frameState.extent));
            }
        },
        {
            /**
   * Get the attributions of the source of this layer for the given view.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {Array<string>} Attributions for this layer at the given view.
   * @api
   */ key: "getAttributions",
            value: function getAttributions(view) {
                if (!this.isVisible(view)) return [];
                var getAttributions;
                var source = this.getSource();
                if (source) getAttributions = source.getAttributions();
                if (!getAttributions) return [];
                var frameState = view instanceof (0, $2d5eedb534d9ecb2$export$2e2bcd8739ae039) ? view.getViewStateAndExtent() : view;
                var attributions = getAttributions(frameState);
                if (!Array.isArray(attributions)) attributions = [
                    attributions
                ];
                return attributions;
            }
        },
        {
            /**
   * In charge to manage the rendering of the layer. One layer type is
   * bounded with one layer renderer.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement|null} The rendered element.
   */ key: "render",
            value: function render(frameState, target) {
                var layerRenderer = this.getRenderer();
                if (layerRenderer.prepareFrame(frameState)) {
                    this.rendered = true;
                    return layerRenderer.renderFrame(frameState, target);
                }
                return null;
            }
        },
        {
            /**
   * Called when a layer is not visible during a map render.
   */ key: "unrender",
            value: function unrender() {
                this.rendered = false;
            }
        },
        {
            /**
   * For use inside the library only.
   * @param {import("../Map.js").default|null} map Map.
   */ key: "setMapInternal",
            value: function setMapInternal(map) {
                if (!map) this.unrender();
                this.set((0, $7b9db042957f1b51$export$2e2bcd8739ae039).MAP, map);
            }
        },
        {
            /**
   * For use inside the library only.
   * @return {import("../Map.js").default|null} Map.
   */ key: "getMapInternal",
            value: function getMapInternal() {
                return this.get((0, $7b9db042957f1b51$export$2e2bcd8739ae039).MAP);
            }
        },
        {
            /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map~Map#addLayer} instead.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ key: "setMap",
            value: function setMap(map) {
                if (this.mapPrecomposeKey_) {
                    (0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921)(this.mapPrecomposeKey_);
                    this.mapPrecomposeKey_ = null;
                }
                if (!map) this.changed();
                if (this.mapRenderKey_) {
                    (0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921)(this.mapRenderKey_);
                    this.mapRenderKey_ = null;
                }
                if (map) {
                    this.mapPrecomposeKey_ = (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(map, (0, $b1aa6e3366c76eef$export$2e2bcd8739ae039).PRECOMPOSE, function(evt) {
                        var renderEvent = /** @type {import("../render/Event.js").default} */ evt;
                        var layerStatesArray = renderEvent.frameState.layerStatesArray;
                        var layerState = this.getLayerState(false);
                        (0, $100b4414e338a711$export$a7a9523472993e97)(!layerStatesArray.some(function(arrayLayerState) {
                            return arrayLayerState.layer === layerState.layer;
                        }), "A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.");
                        layerStatesArray.push(layerState);
                    }, this);
                    this.mapRenderKey_ = (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(this, (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE, map.render, map);
                    this.changed();
                }
            }
        },
        {
            /**
   * Set the layer source.
   * @param {SourceType|null} source The layer source.
   * @observable
   * @api
   */ key: "setSource",
            value: function setSource(source) {
                this.set((0, $7b9db042957f1b51$export$2e2bcd8739ae039).SOURCE, source);
            }
        },
        {
            /**
   * Get the renderer for this layer.
   * @return {RendererType|null} The layer renderer.
   */ key: "getRenderer",
            value: function getRenderer() {
                if (!this.renderer_) this.renderer_ = this.createRenderer();
                return this.renderer_;
            }
        },
        {
            /**
   * @return {boolean} The layer has a renderer.
   */ key: "hasRenderer",
            value: function hasRenderer() {
                return !!this.renderer_;
            }
        },
        {
            /**
   * Create a renderer for this layer.
   * @return {RendererType} A layer renderer.
   * @protected
   */ key: "createRenderer",
            value: function createRenderer() {
                return null;
            }
        },
        {
            /**
   * Clean up.
   */ key: "disposeInternal",
            value: function disposeInternal() {
                if (this.renderer_) {
                    this.renderer_.dispose();
                    delete this.renderer_;
                }
                this.setSource(null);
                (0, $404BM._)((0, $cEF31._)(Layer.prototype), "disposeInternal", this).call(this);
            }
        }
    ]);
    return Layer;
}((0, $c1595a156af4ac75$export$2e2bcd8739ae039));
function $45f7b7b1b4f025e5$export$acb1e9cb9ce4ca56(layerState, viewState) {
    if (!layerState.visible) return false;
    var resolution = viewState.resolution;
    if (resolution < layerState.minResolution || resolution >= layerState.maxResolution) return false;
    var zoom = viewState.zoom;
    return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}
var $45f7b7b1b4f025e5$export$2e2bcd8739ae039 = $45f7b7b1b4f025e5$var$Layer;



/**
 * @template T
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature Feature.
 * @property {import("../layer/Layer.js").default} layer Layer.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} distanceSq Squared distance.
 * @property {import("./vector.js").FeatureCallback<T>} callback Callback.
 */ /**
 * @abstract
 */ var $cd04b95a9c5349ae$var$MapRenderer = /*#__PURE__*/ function(Disposable) {
    "use strict";
    (0, $kcqLc._)(MapRenderer, Disposable);
    var _super = (0, $4jYWU._)(MapRenderer);
    function MapRenderer(map) {
        (0, $5sFFs._)(this, MapRenderer);
        var _this;
        _this = _super.call(this);
        /**
     * @private
     * @type {import("../Map.js").default}
     */ _this.map_ = map;
        return _this;
    }
    (0, $8O2fV._)(MapRenderer, [
        {
            /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ key: "dispatchRenderEvent",
            value: function dispatchRenderEvent(type, frameState) {
                (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @protected
   */ key: "calculateMatrices2D",
            value: function calculateMatrices2D(frameState) {
                var viewState = frameState.viewState;
                var coordinateToPixelTransform = frameState.coordinateToPixelTransform;
                var pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
                (0, $afa6393b3817702c$export$f672e0b6f7222cd7)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
                (0, $afa6393b3817702c$export$bd70ea2a93c0fa4)(pixelToCoordinateTransform, coordinateToPixelTransform);
            }
        },
        {
            /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */ key: "forEachFeatureAtCoordinate",
            value: function forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
                var result;
                var viewState = frameState.viewState;
                /**
     * @param {boolean} managed Managed layer.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @return {T|undefined} Callback result.
     */ function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
                    return callback.call(thisArg, feature, managed ? layer : null, geometry);
                }
                var projection = viewState.projection;
                var translatedCoordinate = (0, $96b4c00c3a1729e3$export$39a9ce3624977b84)(coordinate.slice(), projection);
                var offsets = [
                    [
                        0,
                        0
                    ]
                ];
                if (projection.canWrapX() && checkWrapped) {
                    var projectionExtent = projection.getExtent();
                    var worldWidth = (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(projectionExtent);
                    offsets.push([
                        -worldWidth,
                        0
                    ], [
                        worldWidth,
                        0
                    ]);
                }
                var layerStates = frameState.layerStatesArray;
                var numLayers = layerStates.length;
                var matches = /** @type {Array<HitMatch<T>>} */ [];
                var tmpCoord = [];
                for(var i = 0; i < offsets.length; i++)for(var j = numLayers - 1; j >= 0; --j){
                    var layerState = layerStates[j];
                    var layer = layerState.layer;
                    if (layer.hasRenderer() && (0, $45f7b7b1b4f025e5$export$acb1e9cb9ce4ca56)(layerState, viewState) && layerFilter.call(thisArg2, layer)) {
                        var layerRenderer = layer.getRenderer();
                        var source = layer.getSource();
                        if (layerRenderer && source) {
                            var coordinates = source.getWrapX() ? translatedCoordinate : coordinate;
                            var callback1 = forEachFeatureAtCoordinate.bind(null, layerState.managed);
                            tmpCoord[0] = coordinates[0] + offsets[i][0];
                            tmpCoord[1] = coordinates[1] + offsets[i][1];
                            result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback1, matches);
                        }
                        if (result) return result;
                    }
                }
                if (matches.length === 0) return undefined;
                var order = 1 / matches.length;
                matches.forEach(function(m, i) {
                    return m.distanceSq += i * order;
                });
                matches.sort(function(a, b) {
                    return a.distanceSq - b.distanceSq;
                });
                matches.some(function(m) {
                    return result = m.callback(m.feature, m.layer, m.geometry);
                });
                return result;
            }
        },
        {
            /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */ key: "hasFeatureAtCoordinate",
            value: function hasFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
                var hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, (0, $d0c140d5afad5e7c$export$22e23a2304399231), this, layerFilter, thisArg);
                return hasFeature !== undefined;
            }
        },
        {
            /**
   * @return {import("../Map.js").default} Map.
   */ key: "getMap",
            value: function getMap() {
                return this.map_;
            }
        },
        {
            /**
   * Render.
   * @abstract
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ key: "renderFrame",
            value: function renderFrame(frameState) {
                (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ key: "flushDeclutterItems",
            value: function flushDeclutterItems(frameState) {}
        },
        {
            /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @protected
   */ key: "scheduleExpireIconCache",
            value: function scheduleExpireIconCache(frameState) {
                if ((0, $b343747b53167d02$export$747ccdf771a87ab8).canExpireCache()) frameState.postRenderFunctions.push($cd04b95a9c5349ae$var$expireIconCache);
            }
        }
    ]);
    return MapRenderer;
}((0, $2a74d1a591bba5b3$export$2e2bcd8739ae039));
/**
 * @param {import("../Map.js").default} map Map.
 * @param {import("../Map.js").FrameState} frameState Frame state.
 */ function $cd04b95a9c5349ae$var$expireIconCache(map, frameState) {
    (0, $b343747b53167d02$export$747ccdf771a87ab8).expire();
}
var $cd04b95a9c5349ae$export$2e2bcd8739ae039 = $cd04b95a9c5349ae$var$MapRenderer;



/**
 * @module ol/render/Event
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $kcqLc = parcelRequire("kcqLc");

var $aBSBL = parcelRequire("aBSBL");

var $4jYWU = parcelRequire("4jYWU");

var $7739959762426842$var$RenderEvent = /*#__PURE__*/ function(Event) {
    "use strict";
    (0, $kcqLc._)(RenderEvent, Event);
    var _super = (0, $4jYWU._)(RenderEvent);
    function RenderEvent(type, inversePixelTransform, frameState, context) {
        (0, $5sFFs._)(this, RenderEvent);
        var _this;
        _this = _super.call(this, type);
        /**
     * Transform from CSS pixels (relative to the top-left corner of the map viewport)
     * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
     * @type {import("../transform.js").Transform|undefined}
     * @api
     */ _this.inversePixelTransform = inversePixelTransform;
        /**
     * An object representing the current render frame state.
     * @type {import("../Map.js").FrameState|undefined}
     * @api
     */ _this.frameState = frameState;
        /**
     * Canvas context. Not available when the event is dispatched by the map. For Canvas 2D layers,
     * the context will be the 2D rendering context.  For WebGL layers, the context will be the WebGL
     * context.
     * @type {CanvasRenderingContext2D|WebGLRenderingContext|undefined}
     * @api
     */ _this.context = context;
        return _this;
    }
    return RenderEvent;
}((0, $aBSBL._)((0, $1a4702ad15857f9a$export$2e2bcd8739ae039)));
var $7739959762426842$export$2e2bcd8739ae039 = $7739959762426842$var$RenderEvent;



/**
 * @module ol/css
 */ /**
 * @typedef {Object} FontParameters
 * @property {string} style Style.
 * @property {string} variant Variant.
 * @property {string} weight Weight.
 * @property {string} size Size.
 * @property {string} lineHeight LineHeight.
 * @property {string} family Family.
 * @property {Array<string>} families Families.
 */ /**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */ var $51bd5289664fd4d3$export$981241db82723ce2 = "ol-hidden";
var $51bd5289664fd4d3$export$99b49471b0394319 = "ol-selectable";
var $51bd5289664fd4d3$export$1afde3d6e16a7b29 = "ol-unselectable";
var $51bd5289664fd4d3$export$68eede0dd8c6c1da = "ol-unsupported";
var $51bd5289664fd4d3$export$4d4f8be70b656192 = "ol-control";
var $51bd5289664fd4d3$export$e16017ac68d14492 = "ol-collapsed";
/**
 * From https://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */ var $51bd5289664fd4d3$var$fontRegEx = new RegExp([
    "^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)",
    "(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)",
    "(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)",
    "(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?",
    "(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))",
    "(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))",
    "?\\s*([-,\\\"\\'\\sa-z]+?)\\s*$"
].join(""), "i");
/** @type {Array<'style'|'variant'|'weight'|'size'|'lineHeight'|'family'>} */ var $51bd5289664fd4d3$var$fontRegExMatchIndex = [
    "style",
    "variant",
    "weight",
    "size",
    "lineHeight",
    "family"
];
var $51bd5289664fd4d3$export$5abde8a6aec4a131 = function getFontParameters(fontSpec) {
    var match = fontSpec.match($51bd5289664fd4d3$var$fontRegEx);
    if (!match) return null;
    var style = /** @type {FontParameters} */ {
        lineHeight: "normal",
        size: "1.2em",
        style: "normal",
        weight: "normal",
        variant: "normal"
    };
    for(var i = 0, ii = $51bd5289664fd4d3$var$fontRegExMatchIndex.length; i < ii; ++i){
        var value = match[i + 1];
        if (value !== undefined) style[$51bd5289664fd4d3$var$fontRegExMatchIndex[i]] = value;
    }
    style.families = style.family.split(/,\s?/);
    return style;
};


/**
 * @module ol/render/canvas
 */ 



function $e000035bb4c81589$export$9e05d10eae75c464(width, height, canvasPool, settings) {
    /** @type {HTMLCanvasElement|OffscreenCanvas} */ var canvas;
    if (canvasPool && canvasPool.length) canvas = /** @type {HTMLCanvasElement} */ canvasPool.shift();
    else if (0, $c4937aaad0f121a7$export$98fcef3dc9973292) canvas = new OffscreenCanvas(width || 300, height || 300);
    else canvas = document.createElement("canvas");
    if (width) canvas.width = width;
    if (height) canvas.height = height;
    //FIXME Allow OffscreenCanvasRenderingContext2D as return type
    return /** @type {CanvasRenderingContext2D} */ canvas.getContext("2d", settings);
}
function $e000035bb4c81589$export$e918ac6a1026a12a(context) {
    var canvas = context.canvas;
    canvas.width = 1;
    canvas.height = 1;
    context.clearRect(0, 0, 1, 1);
}
function $e000035bb4c81589$export$e823f88e4111159a(element) {
    var width = element.offsetWidth;
    var style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function $e000035bb4c81589$export$fc5b8aac72846d1e(element) {
    var height = element.offsetHeight;
    var style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
function $e000035bb4c81589$export$5542201de9311ab2(newNode, oldNode) {
    var parent = oldNode.parentNode;
    if (parent) parent.replaceChild(newNode, oldNode);
}
function $e000035bb4c81589$export$1d0aa160432dfea5(node) {
    return node && node.parentNode ? node.parentNode.removeChild(node) : null;
}
function $e000035bb4c81589$export$1e1c9bf5a4ffe0d1(node) {
    while(node.lastChild)node.removeChild(node.lastChild);
}
function $e000035bb4c81589$export$caeacfe04f52533a(node, children) {
    var oldChildren = node.childNodes;
    for(var i = 0;; ++i){
        var oldChild = oldChildren[i];
        var newChild = children[i];
        // check if our work is done
        if (!oldChild && !newChild) break;
        // check if children match
        if (oldChild === newChild) continue;
        // check if a new child needs to be added
        if (!oldChild) {
            node.appendChild(newChild);
            continue;
        }
        // check if an old child needs to be removed
        if (!newChild) {
            node.removeChild(oldChild);
            --i;
            continue;
        }
        // reorder
        node.insertBefore(newChild, oldChild);
    }
}



var $069ac9f2344fe90f$export$3847dfea4f8d4dfa = "10px sans-serif";
var $069ac9f2344fe90f$export$c495d52ee3fd74b2 = "#000";
var $069ac9f2344fe90f$export$17bd0c38d6ae694e = "round";
var $069ac9f2344fe90f$export$e21b4112fdc612fc = [];
var $069ac9f2344fe90f$export$e06efc2409049f76 = 0;
var $069ac9f2344fe90f$export$365eb9648cf19bd0 = "round";
var $069ac9f2344fe90f$export$80c1c01844597b7b = 10;
var $069ac9f2344fe90f$export$1eb2eaecacf2031e = "#000";
var $069ac9f2344fe90f$export$94d53b95641b5766 = "center";
var $069ac9f2344fe90f$export$cf2279a1bff62eb = "middle";
var $069ac9f2344fe90f$export$40a9eeef55665a40 = [
    0,
    0,
    0,
    0
];
var $069ac9f2344fe90f$export$79661f132c62010e = 1;
var $069ac9f2344fe90f$export$1d36981fcadac93b = new (0, $7a8d25d40aa0de7f$export$2e2bcd8739ae039)();
/**
 * @type {CanvasRenderingContext2D}
 */ var $069ac9f2344fe90f$var$measureContext = null;
/**
 * @type {string}
 */ var $069ac9f2344fe90f$var$measureFont;
var $069ac9f2344fe90f$export$7fdcec604f0b1fa7 = {};
var $069ac9f2344fe90f$export$a534074a28fa87ff = function() {
    var retries = 100;
    var size = "32px ";
    var referenceFonts = [
        "monospace",
        "serif"
    ];
    var len = referenceFonts.length;
    var text = "wmytzilWMYTZIL@#/&?$%10\uF013";
    var interval, referenceWidth;
    /**
   * @param {string} fontStyle Css font-style
   * @param {string} fontWeight Css font-weight
   * @param {*} fontFamily Css font-family
   * @return {boolean} Font with style and weight is available
   */ function isAvailable(fontStyle, fontWeight, fontFamily) {
        var available = true;
        for(var i = 0; i < len; ++i){
            var referenceFont = referenceFonts[i];
            referenceWidth = $069ac9f2344fe90f$export$4ea92329b673abd1(fontStyle + " " + fontWeight + " " + size + referenceFont, text);
            if (fontFamily != referenceFont) {
                var width = $069ac9f2344fe90f$export$4ea92329b673abd1(fontStyle + " " + fontWeight + " " + size + fontFamily + "," + referenceFont, text);
                // If width and referenceWidth are the same, then the fallback was used
                // instead of the font we wanted, so the font is not available.
                available = available && width != referenceWidth;
            }
        }
        if (available) return true;
        return false;
    }
    function check() {
        var done = true;
        var fonts = $069ac9f2344fe90f$export$1d36981fcadac93b.getKeys();
        for(var i = 0, ii = fonts.length; i < ii; ++i){
            var font = fonts[i];
            if ($069ac9f2344fe90f$export$1d36981fcadac93b.get(font) < retries) {
                if (isAvailable.apply(this, font.split("\n"))) {
                    (0, $29e93681307ffd1e$export$42ffd38884aecdac)($069ac9f2344fe90f$export$7fdcec604f0b1fa7);
                    // Make sure that loaded fonts are picked up by Safari
                    $069ac9f2344fe90f$var$measureContext = null;
                    $069ac9f2344fe90f$var$measureFont = undefined;
                    $069ac9f2344fe90f$export$1d36981fcadac93b.set(font, retries);
                } else {
                    $069ac9f2344fe90f$export$1d36981fcadac93b.set(font, $069ac9f2344fe90f$export$1d36981fcadac93b.get(font) + 1, true);
                    done = false;
                }
            }
        }
        if (done) {
            clearInterval(interval);
            interval = undefined;
        }
    }
    return function(fontSpec) {
        var font = (0, $51bd5289664fd4d3$export$5abde8a6aec4a131)(fontSpec);
        if (!font) return;
        var families = font.families;
        for(var i = 0, ii = families.length; i < ii; ++i){
            var family = families[i];
            var key = font.style + "\n" + font.weight + "\n" + family;
            if ($069ac9f2344fe90f$export$1d36981fcadac93b.get(key) === undefined) {
                $069ac9f2344fe90f$export$1d36981fcadac93b.set(key, retries, true);
                if (!isAvailable(font.style, font.weight, family)) {
                    $069ac9f2344fe90f$export$1d36981fcadac93b.set(key, 0, true);
                    if (interval === undefined) interval = setInterval(check, 32);
                }
            }
        }
    };
}();
var $069ac9f2344fe90f$export$4feaf6852ff92513 = function() {
    /**
   * @type {HTMLDivElement}
   */ var measureElement;
    return function(fontSpec) {
        var height = $069ac9f2344fe90f$export$7fdcec604f0b1fa7[fontSpec];
        if (height == undefined) {
            if (0, $c4937aaad0f121a7$export$98fcef3dc9973292) {
                var font = (0, $51bd5289664fd4d3$export$5abde8a6aec4a131)(fontSpec);
                var metrics = $069ac9f2344fe90f$var$measureText(fontSpec, "\u017Dg");
                var lineHeight = isNaN(Number(font.lineHeight)) ? 1.2 : Number(font.lineHeight);
                height = lineHeight * (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
            } else {
                if (!measureElement) {
                    measureElement = document.createElement("div");
                    measureElement.innerHTML = "M";
                    measureElement.style.minHeight = "0";
                    measureElement.style.maxHeight = "none";
                    measureElement.style.height = "auto";
                    measureElement.style.padding = "0";
                    measureElement.style.border = "none";
                    measureElement.style.position = "absolute";
                    measureElement.style.display = "block";
                    measureElement.style.left = "-99999px";
                }
                measureElement.style.font = fontSpec;
                document.body.appendChild(measureElement);
                height = measureElement.offsetHeight;
                document.body.removeChild(measureElement);
            }
            $069ac9f2344fe90f$export$7fdcec604f0b1fa7[fontSpec] = height;
        }
        return height;
    };
}();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */ function $069ac9f2344fe90f$var$measureText(font, text) {
    if (!$069ac9f2344fe90f$var$measureContext) $069ac9f2344fe90f$var$measureContext = (0, $e000035bb4c81589$export$9e05d10eae75c464)(1, 1);
    if (font != $069ac9f2344fe90f$var$measureFont) {
        $069ac9f2344fe90f$var$measureContext.font = font;
        $069ac9f2344fe90f$var$measureFont = $069ac9f2344fe90f$var$measureContext.font;
    }
    return $069ac9f2344fe90f$var$measureContext.measureText(text);
}
function $069ac9f2344fe90f$export$4ea92329b673abd1(font, text) {
    return $069ac9f2344fe90f$var$measureText(font, text).width;
}
function $069ac9f2344fe90f$export$915c7ba51467308f(font, text, cache) {
    if (text in cache) return cache[text];
    var width = text.split("\n").reduce(function(prev, curr) {
        return Math.max(prev, $069ac9f2344fe90f$export$4ea92329b673abd1(font, curr));
    }, 0);
    cache[text] = width;
    return width;
}
function $069ac9f2344fe90f$export$7d7c13020df1e791(baseStyle, chunks) {
    var widths = [];
    var heights = [];
    var lineWidths = [];
    var width = 0;
    var lineWidth = 0;
    var height = 0;
    var lineHeight = 0;
    for(var i = 0, ii = chunks.length; i <= ii; i += 2){
        var text = chunks[i];
        if (text === "\n" || i === ii) {
            width = Math.max(width, lineWidth);
            lineWidths.push(lineWidth);
            lineWidth = 0;
            height += lineHeight;
            continue;
        }
        var font = chunks[i + 1] || baseStyle.font;
        var currentWidth = $069ac9f2344fe90f$export$4ea92329b673abd1(font, text);
        widths.push(currentWidth);
        lineWidth += currentWidth;
        var currentHeight = $069ac9f2344fe90f$export$4feaf6852ff92513(font);
        heights.push(currentHeight);
        lineHeight = Math.max(lineHeight, currentHeight);
    }
    return {
        width: width,
        height: height,
        widths: widths,
        heights: heights,
        lineWidths: lineWidths
    };
}
function $069ac9f2344fe90f$export$8ac4d72be78047e6(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
function $069ac9f2344fe90f$export$3cb6f3a6e49cc0ee(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
    context.save();
    if (opacity !== 1) context.globalAlpha *= opacity;
    if (transform) context.transform.apply(context, transform);
    if (/** @type {*} */ labelOrImage.contextInstructions) {
        // label
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        $069ac9f2344fe90f$var$executeLabelInstructions(/** @type {Label} */ labelOrImage, context);
    } else if (scale[0] < 0 || scale[1] < 0) {
        // flipped image
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, 0, 0, w, h);
    } else // if image not flipped translate and scale can be avoided
    context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
    context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D} context Context.
 */ function $069ac9f2344fe90f$var$executeLabelInstructions(label, context) {
    var contextInstructions = label.contextInstructions;
    for(var i = 0, ii = contextInstructions.length; i < ii; i += 2)if (Array.isArray(contextInstructions[i + 1])) context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
    else context[contextInstructions[i]] = contextInstructions[i + 1];
}





/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */ var $118c078137a8f6cc$var$CompositeMapRenderer = /*#__PURE__*/ function(MapRenderer) {
    "use strict";
    (0, $kcqLc._)(CompositeMapRenderer, MapRenderer);
    var _super = (0, $4jYWU._)(CompositeMapRenderer);
    function CompositeMapRenderer(map) {
        (0, $5sFFs._)(this, CompositeMapRenderer);
        var _this;
        _this = _super.call(this, map);
        /**
     * @type {import("../events.js").EventsKey}
     */ _this.fontChangeListenerKey_ = (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)((0, $069ac9f2344fe90f$export$1d36981fcadac93b), (0, $feee417cd33a5f20$export$2e2bcd8739ae039).PROPERTYCHANGE, map.redrawText.bind(map));
        /**
     * @private
     * @type {HTMLDivElement}
     */ _this.element_ = document.createElement("div");
        var style = _this.element_.style;
        style.position = "absolute";
        style.width = "100%";
        style.height = "100%";
        style.zIndex = "0";
        _this.element_.className = (0, $51bd5289664fd4d3$export$1afde3d6e16a7b29) + " ol-layers";
        var container = map.getViewport();
        container.insertBefore(_this.element_, container.firstChild || null);
        /**
     * @private
     * @type {Array<HTMLElement>}
     */ _this.children_ = [];
        /**
     * @private
     * @type {boolean}
     */ _this.renderedVisible_ = true;
        /**
     * @type {Array<import("../layer/BaseVector.js").default>}
     */ _this.declutterLayers_ = [];
        return _this;
    }
    (0, $8O2fV._)(CompositeMapRenderer, [
        {
            /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ key: "dispatchRenderEvent",
            value: function dispatchRenderEvent(type, frameState) {
                var map = this.getMap();
                if (map.hasListener(type)) {
                    var event = new (0, $7739959762426842$export$2e2bcd8739ae039)(type, undefined, frameState);
                    map.dispatchEvent(event);
                }
            }
        },
        {
            key: "disposeInternal",
            value: function disposeInternal() {
                (0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921)(this.fontChangeListenerKey_);
                this.element_.parentNode.removeChild(this.element_);
                (0, $404BM._)((0, $cEF31._)(CompositeMapRenderer.prototype), "disposeInternal", this).call(this);
            }
        },
        {
            /**
   * Render.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ key: "renderFrame",
            value: function renderFrame(frameState) {
                if (!frameState) {
                    if (this.renderedVisible_) {
                        this.element_.style.display = "none";
                        this.renderedVisible_ = false;
                    }
                    return;
                }
                this.calculateMatrices2D(frameState);
                this.dispatchRenderEvent((0, $b1aa6e3366c76eef$export$2e2bcd8739ae039).PRECOMPOSE, frameState);
                var layerStatesArray = frameState.layerStatesArray.sort(function(a, b) {
                    return a.zIndex - b.zIndex;
                });
                var viewState = frameState.viewState;
                this.children_.length = 0;
                var declutterLayers = this.declutterLayers_;
                declutterLayers.length = 0;
                var previousElement = null;
                for(var i = 0, ii = layerStatesArray.length; i < ii; ++i){
                    var layerState = layerStatesArray[i];
                    frameState.layerIndex = i;
                    var layer = layerState.layer;
                    var sourceState = layer.getSourceState();
                    if (!(0, $45f7b7b1b4f025e5$export$acb1e9cb9ce4ca56)(layerState, viewState) || sourceState != "ready" && sourceState != "undefined") {
                        layer.unrender();
                        continue;
                    }
                    var element = layer.render(frameState, previousElement);
                    if (!element) continue;
                    if (element !== previousElement) {
                        this.children_.push(element);
                        previousElement = element;
                    }
                    if ("getDeclutter" in layer) declutterLayers.push(/** @type {import("../layer/BaseVector.js").default} */ layer);
                }
                this.flushDeclutterItems(frameState);
                (0, $e000035bb4c81589$export$caeacfe04f52533a)(this.element_, this.children_);
                this.dispatchRenderEvent((0, $b1aa6e3366c76eef$export$2e2bcd8739ae039).POSTCOMPOSE, frameState);
                if (!this.renderedVisible_) {
                    this.element_.style.display = "";
                    this.renderedVisible_ = true;
                }
                this.scheduleExpireIconCache(frameState);
            }
        },
        {
            /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ key: "flushDeclutterItems",
            value: function flushDeclutterItems(frameState) {
                var layers = this.declutterLayers_;
                for(var i = layers.length - 1; i >= 0; --i)layers[i].renderDeclutter(frameState);
                layers.length = 0;
            }
        }
    ]);
    return CompositeMapRenderer;
}((0, $cd04b95a9c5349ae$export$2e2bcd8739ae039));
var $118c078137a8f6cc$export$2e2bcd8739ae039 = $118c078137a8f6cc$var$CompositeMapRenderer;




/**
 * @module ol/layer/Group
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $aBSBL = parcelRequire("aBSBL");

var $4jYWU = parcelRequire("4jYWU");











var $27fbb3acd6648829$export$2f5ff21d758d25a7 = /*#__PURE__*/ function(Event) {
    "use strict";
    (0, $kcqLc._)(GroupEvent, Event);
    var _super = (0, $4jYWU._)(GroupEvent);
    function GroupEvent(type, layer) {
        (0, $5sFFs._)(this, GroupEvent);
        var _this;
        _this = _super.call(this, type);
        /**
     * The added or removed layer.
     * @type {BaseLayer}
     * @api
     */ _this.layer = layer;
        return _this;
    }
    return GroupEvent;
}((0, $aBSBL._)((0, $1a4702ad15857f9a$export$2e2bcd8739ae039)));
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:layers', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|'change:layers', Return>} GroupOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|Collection<import("./Base.js").default>} [layers] Child layers.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ var $27fbb3acd6648829$var$Property = {
    LAYERS: "layers"
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @api
 */ var $27fbb3acd6648829$var$LayerGroup = /*#__PURE__*/ function(BaseLayer) {
    "use strict";
    (0, $kcqLc._)(LayerGroup, BaseLayer);
    var _super = (0, $4jYWU._)(LayerGroup);
    function LayerGroup(options) {
        (0, $5sFFs._)(this, LayerGroup);
        var _this;
        options = options || {};
        var baseOptions = /** @type {Options} */ Object.assign({}, options);
        delete baseOptions.layers;
        var layers = options.layers;
        _this = _super.call(this, baseOptions);
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ _this.on;
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ _this.once;
        /***
     * @type {GroupOnSignature<void>}
     */ _this.un;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ _this.layersListenerKeys_ = [];
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ _this.listenerKeys_ = {};
        _this.addChangeListener($27fbb3acd6648829$var$Property.LAYERS, _this.handleLayersChanged_);
        if (layers) {
            if (Array.isArray(layers)) layers = new (0, $4586ff11f2e741e8$export$2e2bcd8739ae039)(layers.slice(), {
                unique: true
            });
            else (0, $100b4414e338a711$export$a7a9523472993e97)(typeof /** @type {?} */ layers.getArray === "function", "Expected `layers` to be an array or a `Collection`");
        } else layers = new (0, $4586ff11f2e741e8$export$2e2bcd8739ae039)(undefined, {
            unique: true
        });
        _this.setLayers(layers);
        return _this;
    }
    (0, $8O2fV._)(LayerGroup, [
        {
            /**
   * @private
   */ key: "handleLayerChange_",
            value: function handleLayerChange_() {
                this.changed();
            }
        },
        {
            /**
   * @private
   */ key: "handleLayersChanged_",
            value: function handleLayersChanged_() {
                this.layersListenerKeys_.forEach((0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921));
                this.layersListenerKeys_.length = 0;
                var layers = this.getLayers();
                this.layersListenerKeys_.push((0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(layers, (0, $521f555f87c855d9$export$2e2bcd8739ae039).ADD, this.handleLayersAdd_, this), (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(layers, (0, $521f555f87c855d9$export$2e2bcd8739ae039).REMOVE, this.handleLayersRemove_, this));
                for(var id in this.listenerKeys_)this.listenerKeys_[id].forEach((0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921));
                (0, $29e93681307ffd1e$export$42ffd38884aecdac)(this.listenerKeys_);
                var layersArray = layers.getArray();
                for(var i = 0, ii = layersArray.length; i < ii; i++){
                    var layer = layersArray[i];
                    this.registerLayerListeners_(layer);
                    this.dispatchEvent(new $27fbb3acd6648829$export$2f5ff21d758d25a7("addlayer", layer));
                }
                this.changed();
            }
        },
        {
            /**
   * @param {BaseLayer} layer The layer.
   */ key: "registerLayerListeners_",
            value: function registerLayerListeners_(layer) {
                var listenerKeys = [
                    (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(layer, (0, $feee417cd33a5f20$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleLayerChange_, this),
                    (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(layer, (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE, this.handleLayerChange_, this)
                ];
                if (layer instanceof LayerGroup) listenerKeys.push((0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(layer, "addlayer", this.handleLayerGroupAdd_, this), (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(layer, "removelayer", this.handleLayerGroupRemove_, this));
                this.listenerKeys_[(0, $8b32fff2376556ef$export$5e82334337e0f204)(layer)] = listenerKeys;
            }
        },
        {
            /**
   * @param {GroupEvent} event The layer group event.
   */ key: "handleLayerGroupAdd_",
            value: function handleLayerGroupAdd_(event) {
                this.dispatchEvent(new $27fbb3acd6648829$export$2f5ff21d758d25a7("addlayer", event.layer));
            }
        },
        {
            /**
   * @param {GroupEvent} event The layer group event.
   */ key: "handleLayerGroupRemove_",
            value: function handleLayerGroupRemove_(event) {
                this.dispatchEvent(new $27fbb3acd6648829$export$2f5ff21d758d25a7("removelayer", event.layer));
            }
        },
        {
            /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ key: "handleLayersAdd_",
            value: function handleLayersAdd_(collectionEvent) {
                var layer = collectionEvent.element;
                this.registerLayerListeners_(layer);
                this.dispatchEvent(new $27fbb3acd6648829$export$2f5ff21d758d25a7("addlayer", layer));
                this.changed();
            }
        },
        {
            /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ key: "handleLayersRemove_",
            value: function handleLayersRemove_(collectionEvent) {
                var layer = collectionEvent.element;
                var key = (0, $8b32fff2376556ef$export$5e82334337e0f204)(layer);
                this.listenerKeys_[key].forEach((0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921));
                delete this.listenerKeys_[key];
                this.dispatchEvent(new $27fbb3acd6648829$export$2f5ff21d758d25a7("removelayer", layer));
                this.changed();
            }
        },
        {
            /**
   * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!Collection<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ key: "getLayers",
            value: function getLayers() {
                return /** @type {!Collection<import("./Base.js").default>} */ this.get($27fbb3acd6648829$var$Property.LAYERS);
            }
        },
        {
            /**
   * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!Collection<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ key: "setLayers",
            value: function setLayers(layers) {
                var collection = this.getLayers();
                if (collection) {
                    var currentLayers = collection.getArray();
                    for(var i = 0, ii = currentLayers.length; i < ii; ++i)this.dispatchEvent(new $27fbb3acd6648829$export$2f5ff21d758d25a7("removelayer", currentLayers[i]));
                }
                this.set($27fbb3acd6648829$var$Property.LAYERS, layers);
            }
        },
        {
            /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ key: "getLayersArray",
            value: function getLayersArray(array) {
                array = array !== undefined ? array : [];
                this.getLayers().forEach(function(layer) {
                    layer.getLayersArray(array);
                });
                return array;
            }
        },
        {
            /**
   * Get the layer states list and use this groups z-index as the default
   * for all layers in this and nested groups, if it is unset at this point.
   * If dest is not provided and this group's z-index is undefined
   * 0 is used a the default z-index.
   * @param {Array<import("./Layer.js").State>} [dest] Optional list
   * of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ key: "getLayerStatesArray",
            value: function getLayerStatesArray(dest) {
                var states = dest !== undefined ? dest : [];
                var pos = states.length;
                this.getLayers().forEach(function(layer) {
                    layer.getLayerStatesArray(states);
                });
                var ownLayerState = this.getLayerState();
                var defaultZIndex = ownLayerState.zIndex;
                if (!dest && ownLayerState.zIndex === undefined) defaultZIndex = 0;
                for(var i = pos, ii = states.length; i < ii; i++){
                    var layerState = states[i];
                    layerState.opacity *= ownLayerState.opacity;
                    layerState.visible = layerState.visible && ownLayerState.visible;
                    layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
                    layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
                    layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
                    layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);
                    if (ownLayerState.extent !== undefined) {
                        if (layerState.extent !== undefined) layerState.extent = (0, $e86e0aa087890eb8$export$72209efa88586d42)(layerState.extent, ownLayerState.extent);
                        else layerState.extent = ownLayerState.extent;
                    }
                    if (layerState.zIndex === undefined) layerState.zIndex = defaultZIndex;
                }
                return states;
            }
        },
        {
            /**
   * @return {import("../source/Source.js").State} Source state.
   */ key: "getSourceState",
            value: function getSourceState() {
                return "ready";
            }
        }
    ]);
    return LayerGroup;
}((0, $c1595a156af4ac75$export$2e2bcd8739ae039));
var $27fbb3acd6648829$export$2e2bcd8739ae039 = $27fbb3acd6648829$var$LayerGroup;


/**
 * @module ol/MapBrowserEvent
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/MapEvent
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $kcqLc = parcelRequire("kcqLc");

var $aBSBL = parcelRequire("aBSBL");

var $4jYWU = parcelRequire("4jYWU");

/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map event.
 */ var $3822396dcb007337$var$MapEvent = /*#__PURE__*/ function(Event) {
    "use strict";
    (0, $kcqLc._)(MapEvent, Event);
    var _super = (0, $4jYWU._)(MapEvent);
    function MapEvent(type, map, frameState) {
        (0, $5sFFs._)(this, MapEvent);
        var _this;
        _this = _super.call(this, type);
        /**
     * The map where the event occurred.
     * @type {import("./Map.js").default}
     * @api
     */ _this.map = map;
        /**
     * The frame state at the time of the event.
     * @type {?import("./Map.js").FrameState}
     * @api
     */ _this.frameState = frameState !== undefined ? frameState : null;
        return _this;
    }
    return MapEvent;
}((0, $aBSBL._)((0, $1a4702ad15857f9a$export$2e2bcd8739ae039)));
var $3822396dcb007337$export$2e2bcd8739ae039 = $3822396dcb007337$var$MapEvent;


/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map browser event.
 * @template {UIEvent} EVENT
 */ var $deabb4b46d514882$var$MapBrowserEvent = /*#__PURE__*/ function(MapEvent) {
    "use strict";
    (0, $kcqLc._)(MapBrowserEvent, MapEvent);
    var _super = (0, $4jYWU._)(MapBrowserEvent);
    function MapBrowserEvent(type, map, originalEvent, dragging, frameState, activePointers) {
        (0, $5sFFs._)(this, MapBrowserEvent);
        var _this;
        _this = _super.call(this, type, map, frameState);
        /**
     * The original browser event.
     * @const
     * @type {EVENT}
     * @api
     */ _this.originalEvent = originalEvent;
        /**
     * The map pixel relative to the viewport corresponding to the original browser event.
     * @type {?import("./pixel.js").Pixel}
     */ _this.pixel_ = null;
        /**
     * The coordinate in the user projection corresponding to the original browser event.
     * @type {?import("./coordinate.js").Coordinate}
     */ _this.coordinate_ = null;
        /**
     * Indicates if the map is currently being dragged. Only set for
     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
     *
     * @type {boolean}
     * @api
     */ _this.dragging = dragging !== undefined ? dragging : false;
        /**
     * @type {Array<PointerEvent>|undefined}
     */ _this.activePointers = activePointers;
        return _this;
    }
    (0, $8O2fV._)(MapBrowserEvent, [
        {
            key: "pixel",
            get: /**
   * The map pixel relative to the viewport corresponding to the original event.
   * @type {import("./pixel.js").Pixel}
   * @api
   */ function get() {
                if (!this.pixel_) this.pixel_ = this.map.getEventPixel(this.originalEvent);
                return this.pixel_;
            },
            set: function set(pixel) {
                this.pixel_ = pixel;
            }
        },
        {
            key: "coordinate",
            get: /**
   * The coordinate corresponding to the original browser event.  This will be in the user
   * projection if one is set.  Otherwise it will be in the view projection.
   * @type {import("./coordinate.js").Coordinate}
   * @api
   */ function get() {
                if (!this.coordinate_) this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
                return this.coordinate_;
            },
            set: function set(coordinate) {
                this.coordinate_ = coordinate;
            }
        },
        {
            /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @api
   */ key: "preventDefault",
            value: function preventDefault() {
                (0, $404BM._)((0, $cEF31._)(MapBrowserEvent.prototype), "preventDefault", this).call(this);
                if ("preventDefault" in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.preventDefault();
            }
        },
        {
            /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @api
   */ key: "stopPropagation",
            value: function stopPropagation() {
                (0, $404BM._)((0, $cEF31._)(MapBrowserEvent.prototype), "stopPropagation", this).call(this);
                if ("stopPropagation" in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.stopPropagation();
            }
        }
    ]);
    return MapBrowserEvent;
}((0, $3822396dcb007337$export$2e2bcd8739ae039));
var $deabb4b46d514882$export$2e2bcd8739ae039 = $deabb4b46d514882$var$MapBrowserEvent;


/**
 * @module ol/MapBrowserEventHandler
 */ 
var $lyFcw = parcelRequire("lyFcw");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");


/**
 * @module ol/MapBrowserEventType
 */ 
var /**
 * Constants for event names.
 * @enum {string}
 */ $5bf4deee70ab5b42$export$2e2bcd8739ae039 /***
 * @typedef {'singleclick'|'click'|'dblclick'|'pointerdrag'|'pointermove'} Types
 */  = {
    /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */ SINGLECLICK: "singleclick",
    /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */ CLICK: (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CLICK,
    /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */ DBLCLICK: (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).DBLCLICK,
    /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */ POINTERDRAG: "pointerdrag",
    /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */ POINTERMOVE: "pointermove",
    POINTERDOWN: "pointerdown",
    POINTERUP: "pointerup",
    POINTEROVER: "pointerover",
    POINTEROUT: "pointerout",
    POINTERENTER: "pointerenter",
    POINTERLEAVE: "pointerleave",
    POINTERCANCEL: "pointercancel"
};


/**
 * @module ol/pointer/EventType
 */ /**
 * Constants for event names.
 * @enum {string}
 */ var $b75a92c87c1246de$export$2e2bcd8739ae039 = {
    POINTERMOVE: "pointermove",
    POINTERDOWN: "pointerdown",
    POINTERUP: "pointerup",
    POINTEROVER: "pointerover",
    POINTEROUT: "pointerout",
    POINTERENTER: "pointerenter",
    POINTERLEAVE: "pointerleave",
    POINTERCANCEL: "pointercancel"
};





var $9b368d45b630e177$var$MapBrowserEventHandler = /*#__PURE__*/ function(Target) {
    "use strict";
    (0, $kcqLc._)(MapBrowserEventHandler, Target);
    var _super = (0, $4jYWU._)(MapBrowserEventHandler);
    function MapBrowserEventHandler(map, moveTolerance) {
        (0, $5sFFs._)(this, MapBrowserEventHandler);
        var _this;
        _this = _super.call(this, map);
        /**
     * This is the element that we will listen to the real events on.
     * @type {import("./Map.js").default}
     * @private
     */ _this.map_ = map;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ _this.clickTimeoutId_;
        /**
     * Emulate dblclick and singleclick. Will be true when only one pointer is active.
     * @type {boolean}
     */ _this.emulateClicks_ = false;
        /**
     * @type {boolean}
     * @private
     */ _this.dragging_ = false;
        /**
     * @type {!Array<import("./events.js").EventsKey>}
     * @private
     */ _this.dragListenerKeys_ = [];
        /**
     * @type {number}
     * @private
     */ _this.moveTolerance_ = moveTolerance === undefined ? 1 : moveTolerance;
        /**
     * The most recent "down" type event (or null if none have occurred).
     * Set on pointerdown.
     * @type {PointerEvent|null}
     * @private
     */ _this.down_ = null;
        var element = _this.map_.getViewport();
        /**
     * @type {Array<PointerEvent>}
     * @private
     */ _this.activePointers_ = [];
        /**
     * @type {!Object<number, Event>}
     * @private
     */ _this.trackedTouches_ = {};
        _this.element_ = element;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ _this.pointerdownListenerKey_ = (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(element, (0, $b75a92c87c1246de$export$2e2bcd8739ae039).POINTERDOWN, _this.handlePointerDown_, (0, $lyFcw._)(_this));
        /**
     * @type {PointerEvent}
     * @private
     */ _this.originalPointerMoveEvent_;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ _this.relayedListenerKey_ = (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(element, (0, $b75a92c87c1246de$export$2e2bcd8739ae039).POINTERMOVE, _this.relayMoveEvent_, (0, $lyFcw._)(_this));
        /**
     * @private
     */ _this.boundHandleTouchMove_ = _this.handleTouchMove_.bind((0, $lyFcw._)(_this));
        _this.element_.addEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).TOUCHMOVE, _this.boundHandleTouchMove_, (0, $c4937aaad0f121a7$export$f751ce96c6c4e4fc) ? {
            passive: false
        } : false);
        return _this;
    }
    (0, $8O2fV._)(MapBrowserEventHandler, [
        {
            /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ key: "emulateClick_",
            value: function emulateClick_(pointerEvent) {
                var _this = this;
                var newEvent = new (0, $deabb4b46d514882$export$2e2bcd8739ae039)((0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).CLICK, this.map_, pointerEvent);
                this.dispatchEvent(newEvent);
                if (this.clickTimeoutId_ !== undefined) {
                    // double-click
                    clearTimeout(this.clickTimeoutId_);
                    this.clickTimeoutId_ = undefined;
                    newEvent = new (0, $deabb4b46d514882$export$2e2bcd8739ae039)((0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).DBLCLICK, this.map_, pointerEvent);
                    this.dispatchEvent(newEvent);
                } else // click
                this.clickTimeoutId_ = setTimeout(function() {
                    _this.clickTimeoutId_ = undefined;
                    var newEvent = new (0, $deabb4b46d514882$export$2e2bcd8739ae039)((0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).SINGLECLICK, _this.map_, pointerEvent);
                    _this.dispatchEvent(newEvent);
                }, 250);
            }
        },
        {
            /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ key: "updateActivePointers_",
            value: function updateActivePointers_(pointerEvent) {
                var event = pointerEvent;
                var id = event.pointerId;
                if (event.type == (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERUP || event.type == (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERCANCEL) {
                    delete this.trackedTouches_[id];
                    for(var pointerId in this.trackedTouches_)if (this.trackedTouches_[pointerId].target !== event.target) {
                        // Some platforms assign a new pointerId when the target changes.
                        // If this happens, delete one tracked pointer. If there is more
                        // than one tracked pointer for the old target, it will be cleared
                        // by subsequent POINTERUP events from other pointers.
                        delete this.trackedTouches_[pointerId];
                        break;
                    }
                } else if (event.type == (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERDOWN || event.type == (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERMOVE) this.trackedTouches_[id] = event;
                this.activePointers_ = Object.values(this.trackedTouches_);
            }
        },
        {
            /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ key: "handlePointerUp_",
            value: function handlePointerUp_(pointerEvent) {
                this.updateActivePointers_(pointerEvent);
                var newEvent = new (0, $deabb4b46d514882$export$2e2bcd8739ae039)((0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERUP, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
                this.dispatchEvent(newEvent);
                // We emulate click events on left mouse button click, touch contact, and pen
                // contact. isMouseActionButton returns true in these cases (evt.button is set
                // to 0).
                // See http://www.w3.org/TR/pointerevents/#button-states
                // We only fire click, singleclick, and doubleclick if nobody has called
                // event.preventDefault().
                if (this.emulateClicks_ && !newEvent.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) this.emulateClick_(this.down_);
                if (this.activePointers_.length === 0) {
                    this.dragListenerKeys_.forEach((0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921));
                    this.dragListenerKeys_.length = 0;
                    this.dragging_ = false;
                    this.down_ = null;
                }
            }
        },
        {
            /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */ key: "isMouseActionButton_",
            value: function isMouseActionButton_(pointerEvent) {
                return pointerEvent.button === 0;
            }
        },
        {
            /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ key: "handlePointerDown_",
            value: function handlePointerDown_(pointerEvent) {
                this.emulateClicks_ = this.activePointers_.length === 0;
                this.updateActivePointers_(pointerEvent);
                var newEvent = new (0, $deabb4b46d514882$export$2e2bcd8739ae039)((0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERDOWN, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
                this.dispatchEvent(newEvent);
                this.down_ = new PointerEvent(pointerEvent.type, pointerEvent);
                Object.defineProperty(this.down_, "target", {
                    writable: false,
                    value: pointerEvent.target
                });
                if (this.dragListenerKeys_.length === 0) {
                    var doc = this.map_.getOwnerDocument();
                    this.dragListenerKeys_.push((0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(doc, (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERMOVE, this.handlePointerMove_, this), (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(doc, (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this), /* Note that the listener for `pointercancel is set up on
         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
         * the `pointerup` and `pointermove` listeners.
         *
         * The reason for this is the following: `TouchSource.vacuumTouches_()`
         * issues `pointercancel` events, when there was no `touchend` for a
         * `touchstart`. Now, let's say a first `touchstart` is registered on
         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
         * But `documentPointerEventHandler_` doesn't know about the first
         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
         * only registered there.
         */ (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(this.element_, (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERCANCEL, this.handlePointerUp_, this));
                    if (this.element_.getRootNode && this.element_.getRootNode() !== doc) this.dragListenerKeys_.push((0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(this.element_.getRootNode(), (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this));
                }
            }
        },
        {
            /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ key: "handlePointerMove_",
            value: function handlePointerMove_(pointerEvent) {
                // Between pointerdown and pointerup, pointermove events are triggered.
                // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
                // moved a significant distance.
                if (this.isMoving_(pointerEvent)) {
                    this.updateActivePointers_(pointerEvent);
                    this.dragging_ = true;
                    var newEvent = new (0, $deabb4b46d514882$export$2e2bcd8739ae039)((0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERDRAG, this.map_, pointerEvent, this.dragging_, undefined, this.activePointers_);
                    this.dispatchEvent(newEvent);
                }
            }
        },
        {
            /**
   * Wrap and relay a pointermove event.
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ key: "relayMoveEvent_",
            value: function relayMoveEvent_(pointerEvent) {
                this.originalPointerMoveEvent_ = pointerEvent;
                var dragging = !!(this.down_ && this.isMoving_(pointerEvent));
                this.dispatchEvent(new (0, $deabb4b46d514882$export$2e2bcd8739ae039)((0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERMOVE, this.map_, pointerEvent, dragging));
            }
        },
        {
            /**
   * Flexible handling of a `touch-action: none` css equivalent: because calling
   * `preventDefault()` on a `pointermove` event does not stop native page scrolling
   * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
   * when an interaction (currently `DragPan` handles the event.
   * @param {TouchEvent} event Event.
   * @private
   */ key: "handleTouchMove_",
            value: function handleTouchMove_(event) {
                // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
                // may not be initialized yet when we get here on a platform without native pointer events,
                // when elm-pep is used as pointer events polyfill.
                var originalEvent = this.originalPointerMoveEvent_;
                if ((!originalEvent || originalEvent.defaultPrevented) && (typeof event.cancelable !== "boolean" || event.cancelable === true)) event.preventDefault();
            }
        },
        {
            /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */ key: "isMoving_",
            value: function isMoving_(pointerEvent) {
                return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
            }
        },
        {
            /**
   * Clean up.
   */ key: "disposeInternal",
            value: function disposeInternal() {
                if (this.relayedListenerKey_) {
                    (0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921)(this.relayedListenerKey_);
                    this.relayedListenerKey_ = null;
                }
                this.element_.removeEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_);
                if (this.pointerdownListenerKey_) {
                    (0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921)(this.pointerdownListenerKey_);
                    this.pointerdownListenerKey_ = null;
                }
                this.dragListenerKeys_.forEach((0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921));
                this.dragListenerKeys_.length = 0;
                this.element_ = null;
                (0, $404BM._)((0, $cEF31._)(MapBrowserEventHandler.prototype), "disposeInternal", this).call(this);
            }
        }
    ]);
    return MapBrowserEventHandler;
}((0, $e5f438e225cf4aef$export$2e2bcd8739ae039));
var $9b368d45b630e177$export$2e2bcd8739ae039 = $9b368d45b630e177$var$MapBrowserEventHandler;




/**
 * @module ol/MapEventType
 */ /**
 * @enum {string}
 */ var $c12eb239491bfe04$export$2e2bcd8739ae039 /***
 * @typedef {'postrender'|'movestart'|'moveend'|'loadstart'|'loadend'} Types
 */  = {
    /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */ POSTRENDER: "postrender",
    /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */ MOVESTART: "movestart",
    /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */ MOVEEND: "moveend",
    /**
   * Triggered when loading of additional map data (tiles, images, features) starts.
   * @event module:ol/MapEvent~MapEvent#loadstart
   * @api
   */ LOADSTART: "loadstart",
    /**
   * Triggered when loading of additional map data has completed.
   * @event module:ol/MapEvent~MapEvent#loadend
   * @api
   */ LOADEND: "loadend"
};


/**
 * @module ol/MapProperty
 */ /**
 * @enum {string}
 */ var $577f7939e4cd625e$export$2e2bcd8739ae039 = {
    LAYERGROUP: "layergroup",
    SIZE: "size",
    TARGET: "target",
    VIEW: "view"
};





/**
 * @module ol/TileQueue
 */ 
var $lyFcw = parcelRequire("lyFcw");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");

/**
 * @module ol/structs/PriorityQueue
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");


var $2a2ad0efecdd6e8a$export$b4af72c40fd57063 = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See https://github.com/google/closure-library/blob/master/closure/goog/structs/heap.js
 * and https://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */ var $2a2ad0efecdd6e8a$var$PriorityQueue = /*#__PURE__*/ function() {
    "use strict";
    function PriorityQueue(priorityFunction, keyFunction) {
        (0, $5sFFs._)(this, PriorityQueue);
        /**
     * @type {function(T): number}
     * @private
     */ this.priorityFunction_ = priorityFunction;
        /**
     * @type {function(T): string}
     * @private
     */ this.keyFunction_ = keyFunction;
        /**
     * @type {Array<T>}
     * @private
     */ this.elements_ = [];
        /**
     * @type {Array<number>}
     * @private
     */ this.priorities_ = [];
        /**
     * @type {!Object<string, boolean>}
     * @private
     */ this.queuedElements_ = {};
    }
    (0, $8O2fV._)(PriorityQueue, [
        {
            /**
   * FIXME empty description for jsdoc
   */ key: "clear",
            value: function clear1() {
                this.elements_.length = 0;
                this.priorities_.length = 0;
                (0, $29e93681307ffd1e$export$42ffd38884aecdac)(this.queuedElements_);
            }
        },
        {
            /**
   * Remove and return the highest-priority element. O(log N).
   * @return {T} Element.
   */ key: "dequeue",
            value: function dequeue() {
                var elements = this.elements_;
                var priorities = this.priorities_;
                var element = elements[0];
                if (elements.length == 1) {
                    elements.length = 0;
                    priorities.length = 0;
                } else {
                    elements[0] = /** @type {T} */ elements.pop();
                    priorities[0] = /** @type {number} */ priorities.pop();
                    this.siftUp_(0);
                }
                var elementKey = this.keyFunction_(element);
                delete this.queuedElements_[elementKey];
                return element;
            }
        },
        {
            /**
   * Enqueue an element. O(log N).
   * @param {T} element Element.
   * @return {boolean} The element was added to the queue.
   */ key: "enqueue",
            value: function enqueue(element) {
                (0, $100b4414e338a711$export$a7a9523472993e97)(!(this.keyFunction_(element) in this.queuedElements_), "Tried to enqueue an `element` that was already added to the queue");
                var priority = this.priorityFunction_(element);
                if (priority != $2a2ad0efecdd6e8a$export$b4af72c40fd57063) {
                    this.elements_.push(element);
                    this.priorities_.push(priority);
                    this.queuedElements_[this.keyFunction_(element)] = true;
                    this.siftDown_(0, this.elements_.length - 1);
                    return true;
                }
                return false;
            }
        },
        {
            /**
   * @return {number} Count.
   */ key: "getCount",
            value: function getCount() {
                return this.elements_.length;
            }
        },
        {
            /**
   * Gets the index of the left child of the node at the given index.
   * @param {number} index The index of the node to get the left child for.
   * @return {number} The index of the left child.
   * @private
   */ key: "getLeftChildIndex_",
            value: function getLeftChildIndex_(index) {
                return index * 2 + 1;
            }
        },
        {
            /**
   * Gets the index of the right child of the node at the given index.
   * @param {number} index The index of the node to get the right child for.
   * @return {number} The index of the right child.
   * @private
   */ key: "getRightChildIndex_",
            value: function getRightChildIndex_(index) {
                return index * 2 + 2;
            }
        },
        {
            /**
   * Gets the index of the parent of the node at the given index.
   * @param {number} index The index of the node to get the parent for.
   * @return {number} The index of the parent.
   * @private
   */ key: "getParentIndex_",
            value: function getParentIndex_(index) {
                return index - 1 >> 1;
            }
        },
        {
            /**
   * Make this a heap. O(N).
   * @private
   */ key: "heapify_",
            value: function heapify_() {
                var i;
                for(i = (this.elements_.length >> 1) - 1; i >= 0; i--)this.siftUp_(i);
            }
        },
        {
            /**
   * @return {boolean} Is empty.
   */ key: "isEmpty",
            value: function isEmpty() {
                return this.elements_.length === 0;
            }
        },
        {
            /**
   * @param {string} key Key.
   * @return {boolean} Is key queued.
   */ key: "isKeyQueued",
            value: function isKeyQueued(key) {
                return key in this.queuedElements_;
            }
        },
        {
            /**
   * @param {T} element Element.
   * @return {boolean} Is queued.
   */ key: "isQueued",
            value: function isQueued(element) {
                return this.isKeyQueued(this.keyFunction_(element));
            }
        },
        {
            /**
   * @param {number} index The index of the node to move down.
   * @private
   */ key: "siftUp_",
            value: function siftUp_(index) {
                var elements = this.elements_;
                var priorities = this.priorities_;
                var count = elements.length;
                var element = elements[index];
                var priority = priorities[index];
                var startIndex = index;
                while(index < count >> 1){
                    var lIndex = this.getLeftChildIndex_(index);
                    var rIndex = this.getRightChildIndex_(index);
                    var smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex] ? rIndex : lIndex;
                    elements[index] = elements[smallerChildIndex];
                    priorities[index] = priorities[smallerChildIndex];
                    index = smallerChildIndex;
                }
                elements[index] = element;
                priorities[index] = priority;
                this.siftDown_(startIndex, index);
            }
        },
        {
            /**
   * @param {number} startIndex The index of the root.
   * @param {number} index The index of the node to move up.
   * @private
   */ key: "siftDown_",
            value: function siftDown_(startIndex, index) {
                var elements = this.elements_;
                var priorities = this.priorities_;
                var element = elements[index];
                var priority = priorities[index];
                while(index > startIndex){
                    var parentIndex = this.getParentIndex_(index);
                    if (priorities[parentIndex] > priority) {
                        elements[index] = elements[parentIndex];
                        priorities[index] = priorities[parentIndex];
                        index = parentIndex;
                    } else break;
                }
                elements[index] = element;
                priorities[index] = priority;
            }
        },
        {
            /**
   * FIXME empty description for jsdoc
   */ key: "reprioritize",
            value: function reprioritize() {
                var priorityFunction = this.priorityFunction_;
                var elements = this.elements_;
                var priorities = this.priorities_;
                var index = 0;
                var n = elements.length;
                var element, i, priority;
                for(i = 0; i < n; ++i){
                    element = elements[i];
                    priority = priorityFunction(element);
                    if (priority == $2a2ad0efecdd6e8a$export$b4af72c40fd57063) delete this.queuedElements_[this.keyFunction_(element)];
                    else {
                        priorities[index] = priority;
                        elements[index++] = element;
                    }
                }
                elements.length = index;
                priorities.length = index;
                this.heapify_();
            }
        }
    ]);
    return PriorityQueue;
}();
var $2a2ad0efecdd6e8a$export$2e2bcd8739ae039 = $2a2ad0efecdd6e8a$var$PriorityQueue;


/**
 * @module ol/TileState
 */ /**
 * @enum {number}
 */ var $4b81523a11dd716e$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
   * Indicates that tile loading failed
   * @type {number}
   */ ERROR: 3,
    EMPTY: 4
};


/**
 * @typedef {function(import("./Tile.js").default, string, import("./coordinate.js").Coordinate, number): number} PriorityFunction
 */ var $be228fca8008ab39$var$TileQueue = /*#__PURE__*/ function(PriorityQueue) {
    "use strict";
    (0, $kcqLc._)(TileQueue, PriorityQueue);
    var _super = (0, $4jYWU._)(TileQueue);
    function TileQueue(tilePriorityFunction, tileChangeCallback) {
        (0, $5sFFs._)(this, TileQueue);
        var _this;
        _this = _super.call(this, /**
       * @param {Array} element Element.
       * @return {number} Priority.
       */ function(element) {
            return tilePriorityFunction.apply(null, element);
        }, /**
       * @param {Array} element Element.
       * @return {string} Key.
       */ function(element) {
            return /** @type {import("./Tile.js").default} */ element[0].getKey();
        });
        /** @private */ _this.boundHandleTileChange_ = _this.handleTileChange.bind((0, $lyFcw._)(_this));
        /**
     * @private
     * @type {function(): ?}
     */ _this.tileChangeCallback_ = tileChangeCallback;
        /**
     * @private
     * @type {number}
     */ _this.tilesLoading_ = 0;
        /**
     * @private
     * @type {!Object<string,boolean>}
     */ _this.tilesLoadingKeys_ = {};
        return _this;
    }
    (0, $8O2fV._)(TileQueue, [
        {
            /**
   * @param {Array} element Element.
   * @return {boolean} The element was added to the queue.
   */ key: "enqueue",
            value: function enqueue(element) {
                var added = (0, $404BM._)((0, $cEF31._)(TileQueue.prototype), "enqueue", this).call(this, element);
                if (added) {
                    var tile = element[0];
                    tile.addEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
                }
                return added;
            }
        },
        {
            /**
   * @return {number} Number of tiles loading.
   */ key: "getTilesLoading",
            value: function getTilesLoading() {
                return this.tilesLoading_;
            }
        },
        {
            /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */ key: "handleTileChange",
            value: function handleTileChange(event) {
                var tile = /** @type {import("./Tile.js").default} */ event.target;
                var state = tile.getState();
                if (state === (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADED || state === (0, $4b81523a11dd716e$export$2e2bcd8739ae039).ERROR || state === (0, $4b81523a11dd716e$export$2e2bcd8739ae039).EMPTY) {
                    if (state !== (0, $4b81523a11dd716e$export$2e2bcd8739ae039).ERROR) tile.removeEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
                    var tileKey = tile.getKey();
                    if (tileKey in this.tilesLoadingKeys_) {
                        delete this.tilesLoadingKeys_[tileKey];
                        --this.tilesLoading_;
                    }
                    this.tileChangeCallback_();
                }
            }
        },
        {
            /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */ key: "loadMoreTiles",
            value: function loadMoreTiles(maxTotalLoading, maxNewLoads) {
                var newLoads = 0;
                var state, tile, tileKey;
                while(this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0){
                    tile = /** @type {import("./Tile.js").default} */ this.dequeue()[0];
                    tileKey = tile.getKey();
                    state = tile.getState();
                    if (state === (0, $4b81523a11dd716e$export$2e2bcd8739ae039).IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                        this.tilesLoadingKeys_[tileKey] = true;
                        ++this.tilesLoading_;
                        ++newLoads;
                        tile.load();
                    }
                }
            }
        }
    ]);
    return TileQueue;
}((0, $2a2ad0efecdd6e8a$export$2e2bcd8739ae039));
var $be228fca8008ab39$export$2e2bcd8739ae039 = $be228fca8008ab39$var$TileQueue;
function $be228fca8008ab39$export$f08ad5eceeff5d45(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
    // Filter out tiles at higher zoom levels than the current zoom level, or that
    // are outside the visible extent.
    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) return 0, $2a2ad0efecdd6e8a$export$b4af72c40fd57063;
    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) return 0, $2a2ad0efecdd6e8a$export$b4af72c40fd57063;
    // Prioritize the highest zoom level tiles closest to the focus.
    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
    // Within a zoom level, tiles are prioritized by the distance in pixels between
    // the center of the tile and the center of the viewport.  The factor of 65536
    // means that the prioritization should behave as desired for tiles up to
    // 65536 * Math.log(2) = 45426 pixels from the focus.
    var center = frameState.viewState.center;
    var deltaX = tileCenter[0] - center[0];
    var deltaY = tileCenter[1] - center[1];
    return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
}









/**
 * @module ol/control/defaults
 */ /**
 * @module ol/control/Attribution
 */ 
var $lyFcw = parcelRequire("lyFcw");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/control/Control
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");





/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * const myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */ var $7e80cc7a31bf3554$var$Control = /*#__PURE__*/ function(BaseObject) {
    "use strict";
    (0, $kcqLc._)(Control, BaseObject);
    var _super = (0, $4jYWU._)(Control);
    function Control(options) {
        (0, $5sFFs._)(this, Control);
        var _this;
        _this = _super.call(this);
        var element = options.element;
        if (element && !options.target && !element.style.pointerEvents) element.style.pointerEvents = "auto";
        /**
     * @protected
     * @type {HTMLElement}
     */ _this.element = element ? element : null;
        /**
     * @private
     * @type {HTMLElement}
     */ _this.target_ = null;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ _this.map_ = null;
        /**
     * @protected
     * @type {!Array<import("../events.js").EventsKey>}
     */ _this.listenerKeys = [];
        if (options.render) _this.render = options.render;
        if (options.target) _this.setTarget(options.target);
        return _this;
    }
    (0, $8O2fV._)(Control, [
        {
            /**
   * Clean up.
   */ key: "disposeInternal",
            value: function disposeInternal() {
                (0, $e000035bb4c81589$export$1d0aa160432dfea5)(this.element);
                (0, $404BM._)((0, $cEF31._)(Control.prototype), "disposeInternal", this).call(this);
            }
        },
        {
            /**
   * Get the map associated with this control.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ key: "getMap",
            value: function getMap() {
                return this.map_;
            }
        },
        {
            /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ key: "setMap",
            value: function setMap(map) {
                if (this.map_) (0, $e000035bb4c81589$export$1d0aa160432dfea5)(this.element);
                for(var i = 0, ii = this.listenerKeys.length; i < ii; ++i)(0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921)(this.listenerKeys[i]);
                this.listenerKeys.length = 0;
                this.map_ = map;
                if (map) {
                    var target = this.target_ ? this.target_ : map.getOverlayContainerStopEvent();
                    target.appendChild(this.element);
                    if (this.render !== (0, $d0c140d5afad5e7c$export$1cd1943b3a73bbe8)) this.listenerKeys.push((0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(map, (0, $c12eb239491bfe04$export$2e2bcd8739ae039).POSTRENDER, this.render, this));
                    map.render();
                }
            }
        },
        {
            /**
   * Renders the control.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @api
   */ key: "render",
            value: function render(mapEvent) {}
        },
        {
            /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */ key: "setTarget",
            value: function setTarget(target) {
                this.target_ = typeof target === "string" ? document.getElementById(target) : target;
            }
        }
    ]);
    return Control;
}((0, $7a8d25d40aa0de7f$export$2e2bcd8739ae039));
var $7e80cc7a31bf3554$export$2e2bcd8739ae039 = $7e80cc7a31bf3554$var$Control;






/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string|HTMLElement} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='›'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 */ /**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */ var $699dd4598c9245b1$var$Attribution = /*#__PURE__*/ function(Control) {
    "use strict";
    (0, $kcqLc._)(Attribution, Control);
    var _super = (0, $4jYWU._)(Attribution);
    function Attribution(options) {
        (0, $5sFFs._)(this, Attribution);
        var _this;
        options = options ? options : {};
        _this = _super.call(this, {
            element: document.createElement("div"),
            render: options.render,
            target: options.target
        });
        /**
     * @private
     * @type {HTMLElement}
     */ _this.ulElement_ = document.createElement("ul");
        /**
     * @private
     * @type {boolean}
     */ _this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
     * @private
     * @type {boolean}
     */ _this.userCollapsed_ = _this.collapsed_;
        /**
     * @private
     * @type {boolean}
     */ _this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
     * @private
     * @type {boolean}
     */ _this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!_this.collapsible_) _this.collapsed_ = false;
        var className = options.className !== undefined ? options.className : "ol-attribution";
        var tipLabel = options.tipLabel !== undefined ? options.tipLabel : "Attributions";
        var expandClassName = options.expandClassName !== undefined ? options.expandClassName : className + "-expand";
        var collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : "\u203A";
        var collapseClassName = options.collapseClassName !== undefined ? options.collapseClassName : className + "-collapse";
        if (typeof collapseLabel === "string") {
            /**
       * @private
       * @type {HTMLElement}
       */ _this.collapseLabel_ = document.createElement("span");
            _this.collapseLabel_.textContent = collapseLabel;
            _this.collapseLabel_.className = collapseClassName;
        } else _this.collapseLabel_ = collapseLabel;
        var label = options.label !== undefined ? options.label : "i";
        if (typeof label === "string") {
            /**
       * @private
       * @type {HTMLElement}
       */ _this.label_ = document.createElement("span");
            _this.label_.textContent = label;
            _this.label_.className = expandClassName;
        } else _this.label_ = label;
        var activeLabel = _this.collapsible_ && !_this.collapsed_ ? _this.collapseLabel_ : _this.label_;
        /**
     * @private
     * @type {HTMLElement}
     */ _this.toggleButton_ = document.createElement("button");
        _this.toggleButton_.setAttribute("type", "button");
        _this.toggleButton_.setAttribute("aria-expanded", String(!_this.collapsed_));
        _this.toggleButton_.title = tipLabel;
        _this.toggleButton_.appendChild(activeLabel);
        _this.toggleButton_.addEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CLICK, _this.handleClick_.bind((0, $lyFcw._)(_this)), false);
        var cssClasses = className + " " + (0, $51bd5289664fd4d3$export$1afde3d6e16a7b29) + " " + (0, $51bd5289664fd4d3$export$4d4f8be70b656192) + (_this.collapsed_ && _this.collapsible_ ? " " + (0, $51bd5289664fd4d3$export$e16017ac68d14492) : "") + (_this.collapsible_ ? "" : " ol-uncollapsible");
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(_this.toggleButton_);
        element.appendChild(_this.ulElement_);
        /**
     * A list of currently rendered resolutions.
     * @type {Array<string>}
     * @private
     */ _this.renderedAttributions_ = [];
        /**
     * @private
     * @type {boolean}
     */ _this.renderedVisible_ = true;
        return _this;
    }
    (0, $8O2fV._)(Attribution, [
        {
            /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */ key: "collectSourceAttributions_",
            value: function collectSourceAttributions_(frameState) {
                var visibleAttributions = Array.from(new Set(this.getMap().getAllLayers().flatMap(function(layer) {
                    return layer.getAttributions(frameState);
                })));
                var collapsible = !this.getMap().getAllLayers().some(function(layer) {
                    return layer.getSource() && layer.getSource().getAttributionsCollapsible() === false;
                });
                if (!this.overrideCollapsible_) this.setCollapsible(collapsible);
                return visibleAttributions;
            }
        },
        {
            /**
   * @private
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ key: "updateElement_",
            value: function updateElement_(frameState) {
                if (!frameState) {
                    if (this.renderedVisible_) {
                        this.element.style.display = "none";
                        this.renderedVisible_ = false;
                    }
                    return;
                }
                var attributions = this.collectSourceAttributions_(frameState);
                var visible = attributions.length > 0;
                if (this.renderedVisible_ != visible) {
                    this.element.style.display = visible ? "" : "none";
                    this.renderedVisible_ = visible;
                }
                if ((0, $edee3659e50a93f4$export$e9bab7fafb253603)(attributions, this.renderedAttributions_)) return;
                (0, $e000035bb4c81589$export$1e1c9bf5a4ffe0d1)(this.ulElement_);
                // append the attributions
                for(var i = 0, ii = attributions.length; i < ii; ++i){
                    var element = document.createElement("li");
                    element.innerHTML = attributions[i];
                    this.ulElement_.appendChild(element);
                }
                this.renderedAttributions_ = attributions;
            }
        },
        {
            /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ key: "handleClick_",
            value: function handleClick_(event) {
                event.preventDefault();
                this.handleToggle_();
                this.userCollapsed_ = this.collapsed_;
            }
        },
        {
            /**
   * @private
   */ key: "handleToggle_",
            value: function handleToggle_() {
                this.element.classList.toggle((0, $51bd5289664fd4d3$export$e16017ac68d14492));
                if (this.collapsed_) (0, $e000035bb4c81589$export$5542201de9311ab2)(this.collapseLabel_, this.label_);
                else (0, $e000035bb4c81589$export$5542201de9311ab2)(this.label_, this.collapseLabel_);
                this.collapsed_ = !this.collapsed_;
                this.toggleButton_.setAttribute("aria-expanded", String(!this.collapsed_));
            }
        },
        {
            /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */ key: "getCollapsible",
            value: function getCollapsible() {
                return this.collapsible_;
            }
        },
        {
            /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */ key: "setCollapsible",
            value: function setCollapsible(collapsible) {
                if (this.collapsible_ === collapsible) return;
                this.collapsible_ = collapsible;
                this.element.classList.toggle("ol-uncollapsible");
                if (this.userCollapsed_) this.handleToggle_();
            }
        },
        {
            /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */ key: "setCollapsed",
            value: function setCollapsed(collapsed) {
                this.userCollapsed_ = collapsed;
                if (!this.collapsible_ || this.collapsed_ === collapsed) return;
                this.handleToggle_();
            }
        },
        {
            /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */ key: "getCollapsed",
            value: function getCollapsed() {
                return this.collapsed_;
            }
        },
        {
            /**
   * Update the attribution element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ key: "render",
            value: function render(mapEvent) {
                this.updateElement_(mapEvent.frameState);
            }
        }
    ]);
    return Attribution;
}((0, $7e80cc7a31bf3554$export$2e2bcd8739ae039));
var $699dd4598c9245b1$export$2e2bcd8739ae039 = $699dd4598c9245b1$var$Attribution;



/**
 * @module ol/control/Rotate
 */ 
var $lyFcw = parcelRequire("lyFcw");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");




/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */ var $b1787917a2fb9911$var$Rotate = /*#__PURE__*/ function(Control) {
    "use strict";
    (0, $kcqLc._)(Rotate, Control);
    var _super = (0, $4jYWU._)(Rotate);
    function Rotate(options) {
        (0, $5sFFs._)(this, Rotate);
        var _this;
        options = options ? options : {};
        _this = _super.call(this, {
            element: document.createElement("div"),
            render: options.render,
            target: options.target
        });
        var className = options.className !== undefined ? options.className : "ol-rotate";
        var label = options.label !== undefined ? options.label : "\u21E7";
        var compassClassName = options.compassClassName !== undefined ? options.compassClassName : "ol-compass";
        /**
     * @type {HTMLElement}
     * @private
     */ _this.label_ = null;
        if (typeof label === "string") {
            _this.label_ = document.createElement("span");
            _this.label_.className = compassClassName;
            _this.label_.textContent = label;
        } else {
            _this.label_ = label;
            _this.label_.classList.add(compassClassName);
        }
        var tipLabel = options.tipLabel ? options.tipLabel : "Reset rotation";
        var button = document.createElement("button");
        button.className = className + "-reset";
        button.setAttribute("type", "button");
        button.title = tipLabel;
        button.appendChild(_this.label_);
        button.addEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CLICK, _this.handleClick_.bind((0, $lyFcw._)(_this)), false);
        var cssClasses = className + " " + (0, $51bd5289664fd4d3$export$1afde3d6e16a7b29) + " " + (0, $51bd5289664fd4d3$export$4d4f8be70b656192);
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(button);
        _this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
     * @type {number}
     * @private
     */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @type {boolean}
     * @private
     */ _this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
     * @private
     * @type {number|undefined}
     */ _this.rotation_ = undefined;
        if (_this.autoHide_) _this.element.classList.add((0, $51bd5289664fd4d3$export$981241db82723ce2));
        return _this;
    }
    (0, $8O2fV._)(Rotate, [
        {
            /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ key: "handleClick_",
            value: function handleClick_(event) {
                event.preventDefault();
                if (this.callResetNorth_ !== undefined) this.callResetNorth_();
                else this.resetNorth_();
            }
        },
        {
            /**
   * @private
   */ key: "resetNorth_",
            value: function resetNorth_() {
                var map = this.getMap();
                var view = map.getView();
                if (!view) // the map does not have a view, so we can't act
                // upon it
                return;
                var rotation = view.getRotation();
                if (rotation !== undefined) {
                    if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) view.animate({
                        rotation: 0,
                        duration: this.duration_,
                        easing: (0, $eba911dc905f0f7f$export$57636bb43b1ccbb0)
                    });
                    else view.setRotation(0);
                }
            }
        },
        {
            /**
   * Update the rotate control element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ key: "render",
            value: function render(mapEvent) {
                var frameState = mapEvent.frameState;
                if (!frameState) return;
                var rotation = frameState.viewState.rotation;
                if (rotation != this.rotation_) {
                    var transform = "rotate(" + rotation + "rad)";
                    if (this.autoHide_) {
                        var contains = this.element.classList.contains((0, $51bd5289664fd4d3$export$981241db82723ce2));
                        if (!contains && rotation === 0) this.element.classList.add((0, $51bd5289664fd4d3$export$981241db82723ce2));
                        else if (contains && rotation !== 0) this.element.classList.remove((0, $51bd5289664fd4d3$export$981241db82723ce2));
                    }
                    this.label_.style.transform = transform;
                }
                this.rotation_ = rotation;
            }
        }
    ]);
    return Rotate;
}((0, $7e80cc7a31bf3554$export$2e2bcd8739ae039));
var $b1787917a2fb9911$export$2e2bcd8739ae039 = $b1787917a2fb9911$var$Rotate;


/**
 * @module ol/control/Zoom
 */ 
var $lyFcw = parcelRequire("lyFcw");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");




/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='–'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */ var $b37960bd4a5add2f$var$Zoom = /*#__PURE__*/ function(Control) {
    "use strict";
    (0, $kcqLc._)(Zoom, Control);
    var _super = (0, $4jYWU._)(Zoom);
    function Zoom(options) {
        (0, $5sFFs._)(this, Zoom);
        var _this;
        options = options ? options : {};
        _this = _super.call(this, {
            element: document.createElement("div"),
            target: options.target
        });
        var className = options.className !== undefined ? options.className : "ol-zoom";
        var delta = options.delta !== undefined ? options.delta : 1;
        var zoomInClassName = options.zoomInClassName !== undefined ? options.zoomInClassName : className + "-in";
        var zoomOutClassName = options.zoomOutClassName !== undefined ? options.zoomOutClassName : className + "-out";
        var zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : "+";
        var zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : "\u2013";
        var zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : "Zoom in";
        var zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : "Zoom out";
        var inElement = document.createElement("button");
        inElement.className = zoomInClassName;
        inElement.setAttribute("type", "button");
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === "string" ? document.createTextNode(zoomInLabel) : zoomInLabel);
        inElement.addEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CLICK, _this.handleClick_.bind((0, $lyFcw._)(_this), delta), false);
        var outElement = document.createElement("button");
        outElement.className = zoomOutClassName;
        outElement.setAttribute("type", "button");
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === "string" ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
        outElement.addEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CLICK, _this.handleClick_.bind((0, $lyFcw._)(_this), -delta), false);
        var cssClasses = className + " " + (0, $51bd5289664fd4d3$export$1afde3d6e16a7b29) + " " + (0, $51bd5289664fd4d3$export$4d4f8be70b656192);
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
     * @type {number}
     * @private
     */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    (0, $8O2fV._)(Zoom, [
        {
            /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */ key: "handleClick_",
            value: function handleClick_(delta, event) {
                event.preventDefault();
                this.zoomByDelta_(delta);
            }
        },
        {
            /**
   * @param {number} delta Zoom delta.
   * @private
   */ key: "zoomByDelta_",
            value: function zoomByDelta_(delta) {
                var map = this.getMap();
                var view = map.getView();
                if (!view) // the map does not have a view, so we can't act
                // upon it
                return;
                var currentZoom = view.getZoom();
                if (currentZoom !== undefined) {
                    var newZoom = view.getConstrainedZoom(currentZoom + delta);
                    if (this.duration_ > 0) {
                        if (view.getAnimating()) view.cancelAnimations();
                        view.animate({
                            zoom: newZoom,
                            duration: this.duration_,
                            easing: (0, $eba911dc905f0f7f$export$57636bb43b1ccbb0)
                        });
                    } else view.setZoom(newZoom);
                }
            }
        }
    ]);
    return Zoom;
}((0, $7e80cc7a31bf3554$export$2e2bcd8739ae039));
var $b37960bd4a5add2f$export$2e2bcd8739ae039 = $b37960bd4a5add2f$var$Zoom;


function $b49292dbcddf523e$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Control.js").default>} */ var controls = new (0, $4586ff11f2e741e8$export$2e2bcd8739ae039)();
    var zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) controls.push(new (0, $b37960bd4a5add2f$export$2e2bcd8739ae039)(options.zoomOptions));
    var rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) controls.push(new (0, $b1787917a2fb9911$export$2e2bcd8739ae039)(options.rotateOptions));
    var attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) controls.push(new (0, $699dd4598c9245b1$export$2e2bcd8739ae039)(options.attributionOptions));
    return controls;
}


/**
 * @module ol/interaction/defaults
 */ 
/**
 * @module ol/interaction/DoubleClickZoom
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/interaction/Interaction
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");

/**
 * @module ol/interaction/Property
 */ /**
 * @enum {string}
 */ var $7ac6db23fc260417$export$2e2bcd8739ae039 = {
    ACTIVE: "active"
};



/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active', Return>} InteractionOnSignature
 */ /**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} handleEvent
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */ var $8d152b473ff8d06b$var$Interaction = /*#__PURE__*/ function(BaseObject) {
    "use strict";
    (0, $kcqLc._)(Interaction, BaseObject);
    var _super = (0, $4jYWU._)(Interaction);
    function Interaction(options) {
        (0, $5sFFs._)(this, Interaction);
        var _this;
        _this = _super.call(this);
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ _this.on;
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ _this.once;
        /***
     * @type {InteractionOnSignature<void>}
     */ _this.un;
        if (options && options.handleEvent) _this.handleEvent = options.handleEvent;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ _this.map_ = null;
        _this.setActive(true);
        return _this;
    }
    (0, $8O2fV._)(Interaction, [
        {
            /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */ key: "getActive",
            value: function getActive() {
                return /** @type {boolean} */ this.get((0, $7ac6db23fc260417$export$2e2bcd8739ae039).ACTIVE);
            }
        },
        {
            /**
   * Get the map associated with this interaction.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ key: "getMap",
            value: function getMap() {
                return this.map_;
            }
        },
        {
            /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ key: "handleEvent",
            value: function handleEvent(mapBrowserEvent) {
                return true;
            }
        },
        {
            /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ key: "setActive",
            value: function setActive(active) {
                this.set((0, $7ac6db23fc260417$export$2e2bcd8739ae039).ACTIVE, active);
            }
        },
        {
            /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   */ key: "setMap",
            value: function setMap(map) {
                this.map_ = map;
            }
        }
    ]);
    return Interaction;
}((0, $7a8d25d40aa0de7f$export$2e2bcd8739ae039));
function $8d152b473ff8d06b$export$4c486572e961a974(view, delta, duration) {
    var currentCenter = view.getCenterInternal();
    if (currentCenter) {
        var center = [
            currentCenter[0] + delta[0],
            currentCenter[1] + delta[1]
        ];
        view.animateInternal({
            duration: duration !== undefined ? duration : 250,
            easing: (0, $eba911dc905f0f7f$export$45db2fc2f15997e7),
            center: view.getConstrainedCenter(center)
        });
    }
}
function $8d152b473ff8d06b$export$ace321ff2a8016ef(view, delta, anchor, duration) {
    var currentZoom = view.getZoom();
    if (currentZoom === undefined) return;
    var newZoom = view.getConstrainedZoom(currentZoom + delta);
    var newResolution = view.getResolutionForZoom(newZoom);
    if (view.getAnimating()) view.cancelAnimations();
    view.animate({
        resolution: newResolution,
        anchor: anchor,
        duration: duration !== undefined ? duration : 250,
        easing: (0, $eba911dc905f0f7f$export$57636bb43b1ccbb0)
    });
}
var $8d152b473ff8d06b$export$2e2bcd8739ae039 = $8d152b473ff8d06b$var$Interaction;



/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */ /**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */ var $2f9262e3640b16eb$var$DoubleClickZoom = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $kcqLc._)(DoubleClickZoom, Interaction);
    var _super = (0, $4jYWU._)(DoubleClickZoom);
    function DoubleClickZoom(options) {
        (0, $5sFFs._)(this, DoubleClickZoom);
        var _this;
        _this = _super.call(this);
        options = options ? options : {};
        /**
     * @private
     * @type {number}
     */ _this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    (0, $8O2fV._)(DoubleClickZoom, [
        {
            /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */ key: "handleEvent",
            value: function handleEvent(mapBrowserEvent) {
                var stopEvent = false;
                if (mapBrowserEvent.type == (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).DBLCLICK) {
                    var browserEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
                    var map = mapBrowserEvent.map;
                    var anchor = mapBrowserEvent.coordinate;
                    var delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
                    var view = map.getView();
                    (0, $8d152b473ff8d06b$export$ace321ff2a8016ef)(view, delta, anchor, this.duration_);
                    browserEvent.preventDefault();
                    stopEvent = true;
                }
                return !stopEvent;
            }
        }
    ]);
    return DoubleClickZoom;
}((0, $8d152b473ff8d06b$export$2e2bcd8739ae039));
var $2f9262e3640b16eb$export$2e2bcd8739ae039 = $2f9262e3640b16eb$var$DoubleClickZoom;


/**
 * @module ol/interaction/DragPan
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/interaction/Pointer
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");


/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */ /**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */ var $55974e46ba8893a2$var$PointerInteraction = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $kcqLc._)(PointerInteraction, Interaction);
    var _super = (0, $4jYWU._)(PointerInteraction);
    function PointerInteraction(options) {
        (0, $5sFFs._)(this, PointerInteraction);
        var _this;
        options = options ? options : {};
        _this = _super.call(this, /** @type {import("./Interaction.js").InteractionOptions} */ options);
        if (options.handleDownEvent) _this.handleDownEvent = options.handleDownEvent;
        if (options.handleDragEvent) _this.handleDragEvent = options.handleDragEvent;
        if (options.handleMoveEvent) _this.handleMoveEvent = options.handleMoveEvent;
        if (options.handleUpEvent) _this.handleUpEvent = options.handleUpEvent;
        if (options.stopDown) _this.stopDown = options.stopDown;
        /**
     * @type {boolean}
     * @protected
     */ _this.handlingDownUpSequence = false;
        /**
     * @type {Array<PointerEvent>}
     * @protected
     */ _this.targetPointers = [];
        return _this;
    }
    (0, $8O2fV._)(PointerInteraction, [
        {
            /**
   * Returns the current number of pointers involved in the interaction,
   * e.g. `2` when two fingers are used.
   * @return {number} The number of pointers.
   * @api
   */ key: "getPointerCount",
            value: function getPointerCount() {
                return this.targetPointers.length;
            }
        },
        {
            /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ key: "handleDownEvent",
            value: function handleDownEvent(mapBrowserEvent) {
                return false;
            }
        },
        {
            /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ key: "handleDragEvent",
            value: function handleDragEvent(mapBrowserEvent) {}
        },
        {
            /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ key: "handleEvent",
            value: function handleEvent(mapBrowserEvent) {
                if (!mapBrowserEvent.originalEvent) return true;
                var stopEvent = false;
                this.updateTrackedPointers_(mapBrowserEvent);
                if (this.handlingDownUpSequence) {
                    if (mapBrowserEvent.type == (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERDRAG) {
                        this.handleDragEvent(mapBrowserEvent);
                        // prevent page scrolling during dragging
                        mapBrowserEvent.originalEvent.preventDefault();
                    } else if (mapBrowserEvent.type == (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERUP) {
                        var handledUp = this.handleUpEvent(mapBrowserEvent);
                        this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
                    }
                } else {
                    if (mapBrowserEvent.type == (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERDOWN) {
                        var handled = this.handleDownEvent(mapBrowserEvent);
                        this.handlingDownUpSequence = handled;
                        stopEvent = this.stopDown(handled);
                    } else if (mapBrowserEvent.type == (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).POINTERMOVE) this.handleMoveEvent(mapBrowserEvent);
                }
                return !stopEvent;
            }
        },
        {
            /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ key: "handleMoveEvent",
            value: function handleMoveEvent(mapBrowserEvent) {}
        },
        {
            /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ key: "handleUpEvent",
            value: function handleUpEvent(mapBrowserEvent) {
                return false;
            }
        },
        {
            /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */ key: "stopDown",
            value: function stopDown(handled) {
                return handled;
            }
        },
        {
            /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @private
   */ key: "updateTrackedPointers_",
            value: function updateTrackedPointers_(mapBrowserEvent) {
                if (mapBrowserEvent.activePointers) this.targetPointers = mapBrowserEvent.activePointers;
            }
        }
    ]);
    return PointerInteraction;
}((0, $8d152b473ff8d06b$export$2e2bcd8739ae039));
function $55974e46ba8893a2$export$e2a20c553f6c85ce(pointerEvents) {
    var length = pointerEvents.length;
    var clientX = 0;
    var clientY = 0;
    for(var i = 0; i < length; i++){
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return {
        clientX: clientX / length,
        clientY: clientY / length
    };
}
var $55974e46ba8893a2$export$2e2bcd8739ae039 = $55974e46ba8893a2$var$PointerInteraction;



/**
 * @module ol/events/condition
 */ 



function $480dbb0a0480b91f$export$84bf76cd7afc7469(var_args) {
    var conditions = arguments;
    /**
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} All conditions passed.
   */ return function(event) {
        var pass = true;
        for(var i = 0, ii = conditions.length; i < ii; ++i){
            pass = pass && conditions[i](event);
            if (!pass) break;
        }
        return pass;
    };
}
var $480dbb0a0480b91f$export$573409992e89967e = function altKeyOnly(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
var $480dbb0a0480b91f$export$4e5f01653f9f1f82 = function altShiftKeysOnly(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
var $480dbb0a0480b91f$export$d7ddd398f22d79ef = function focus(event) {
    var targetElement = event.map.getTargetElement();
    var activeElement = event.map.getOwnerDocument().activeElement;
    return targetElement.contains(activeElement);
};
var $480dbb0a0480b91f$export$ae2cdf064e3b0c55 = function focusWithTabindex(event) {
    return event.map.getTargetElement().hasAttribute("tabindex") ? $480dbb0a0480b91f$export$d7ddd398f22d79ef(event) : true;
};
var $480dbb0a0480b91f$export$ba9e5d519bc326ca = (0, $d0c140d5afad5e7c$export$22e23a2304399231);
var $480dbb0a0480b91f$export$64ef1bee2b9504c1 = function click(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).CLICK;
};
var $480dbb0a0480b91f$export$1238ad6b5e7fff70 = function mouseActionButton(mapBrowserEvent) {
    var originalEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.button == 0 && !((0, $c4937aaad0f121a7$export$39dfd62a25e0fe93) && (0, $c4937aaad0f121a7$export$76c0a3b101d93136) && originalEvent.ctrlKey);
};
var $480dbb0a0480b91f$export$b3e22bcfd64c1022 = (0, $d0c140d5afad5e7c$export$8f11cee4bdc7e668);
var $480dbb0a0480b91f$export$71eac0963f2c2f01 = function pointerMove(mapBrowserEvent) {
    return mapBrowserEvent.type == "pointermove";
};
var $480dbb0a0480b91f$export$194df8bad091b401 = function singleClick(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).SINGLECLICK;
};
var $480dbb0a0480b91f$export$c59d944dd10b3dc7 = function doubleClick(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $5bf4deee70ab5b42$export$2e2bcd8739ae039).DBLCLICK;
};
var $480dbb0a0480b91f$export$fdc892d0d8fe3bfb = function noModifierKeys(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
var $480dbb0a0480b91f$export$f3100d8d6292d638 = function platformModifierKeyOnly(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && ((0, $c4937aaad0f121a7$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
var $480dbb0a0480b91f$export$32603ad571dd22b5 = function platformModifierKey(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return (0, $c4937aaad0f121a7$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey;
};
var $480dbb0a0480b91f$export$5d31fe68a477cfbb = function shiftKeyOnly(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
var $480dbb0a0480b91f$export$e5570ca80cd8fd54 = function targetNotEditable(mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    var tagName = /** @type {Element} */ originalEvent.target.tagName;
    return tagName !== "INPUT" && tagName !== "SELECT" && tagName !== "TEXTAREA" && // `isContentEditable` is only available on `HTMLElement`, but it may also be a
    // different type like `SVGElement`.
    // @ts-ignore
    !originalEvent.target.isContentEditable;
};
var $480dbb0a0480b91f$export$abb7acbfa76bf3c4 = function mouseOnly(mapBrowserEvent) {
    var pointerEvent = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $100b4414e338a711$export$a7a9523472993e97)(pointerEvent !== undefined, "mapBrowserEvent must originate from a pointer event");
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvent.pointerType == "mouse";
};
var $480dbb0a0480b91f$export$e74de664a571d084 = function touchOnly(mapBrowserEvent) {
    var pointerEvt = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $100b4414e338a711$export$a7a9523472993e97)(pointerEvt !== undefined, "mapBrowserEvent must originate from a pointer event");
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === "touch";
};
var $480dbb0a0480b91f$export$cd1707283a23f059 = function penOnly(mapBrowserEvent) {
    var pointerEvt = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $100b4414e338a711$export$a7a9523472993e97)(pointerEvt !== undefined, "mapBrowserEvent must originate from a pointer event");
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === "pen";
};
var $480dbb0a0480b91f$export$189f0d593022b199 = function primaryAction(mapBrowserEvent) {
    var pointerEvent = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $100b4414e338a711$export$a7a9523472993e97)(pointerEvent !== undefined, "mapBrowserEvent must originate from a pointer event");
    return pointerEvent.isPrimary && pointerEvent.button === 0;
};




/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.noModifierKeys} and {@link module:ol/events/condition.primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */ /**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */ var $e4ba2fe60a0a7e42$var$DragPan = /*#__PURE__*/ function(PointerInteraction) {
    "use strict";
    (0, $kcqLc._)(DragPan, PointerInteraction);
    var _super = (0, $4jYWU._)(DragPan);
    function DragPan(options) {
        (0, $5sFFs._)(this, DragPan);
        var _this;
        _this = _super.call(this, {
            stopDown: (0, $d0c140d5afad5e7c$export$8f11cee4bdc7e668)
        });
        options = options ? options : {};
        /**
     * @private
     * @type {import("../Kinetic.js").default|undefined}
     */ _this.kinetic_ = options.kinetic;
        /**
     * @type {import("../pixel.js").Pixel}
     */ _this.lastCentroid = null;
        /**
     * @type {number}
     */ _this.lastPointersCount_;
        /**
     * @type {boolean}
     */ _this.panning_ = false;
        var condition = options.condition ? options.condition : (0, $480dbb0a0480b91f$export$84bf76cd7afc7469)((0, $480dbb0a0480b91f$export$fdc892d0d8fe3bfb), (0, $480dbb0a0480b91f$export$189f0d593022b199));
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ _this.condition_ = options.onFocusOnly ? (0, $480dbb0a0480b91f$export$84bf76cd7afc7469)((0, $480dbb0a0480b91f$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {boolean}
     */ _this.noKinetic_ = false;
        return _this;
    }
    (0, $8O2fV._)(DragPan, [
        {
            /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ key: "handleDragEvent",
            value: function handleDragEvent(mapBrowserEvent) {
                var map = mapBrowserEvent.map;
                if (!this.panning_) {
                    this.panning_ = true;
                    map.getView().beginInteraction();
                }
                var targetPointers = this.targetPointers;
                var centroid = map.getEventPixel((0, $55974e46ba8893a2$export$e2a20c553f6c85ce)(targetPointers));
                if (targetPointers.length == this.lastPointersCount_) {
                    if (this.kinetic_) this.kinetic_.update(centroid[0], centroid[1]);
                    if (this.lastCentroid) {
                        var delta = [
                            this.lastCentroid[0] - centroid[0],
                            centroid[1] - this.lastCentroid[1]
                        ];
                        var map1 = mapBrowserEvent.map;
                        var view = map1.getView();
                        (0, $96b4c00c3a1729e3$export$dcdf75081b88279d)(delta, view.getResolution());
                        (0, $96b4c00c3a1729e3$export$bb628a54ab399bc9)(delta, view.getRotation());
                        view.adjustCenterInternal(delta);
                    }
                } else if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
                // after one finger down, tiny drag, second finger down
                this.kinetic_.begin();
                this.lastCentroid = centroid;
                this.lastPointersCount_ = targetPointers.length;
                mapBrowserEvent.originalEvent.preventDefault();
            }
        },
        {
            /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ key: "handleUpEvent",
            value: function handleUpEvent(mapBrowserEvent) {
                var map = mapBrowserEvent.map;
                var view = map.getView();
                if (this.targetPointers.length === 0) {
                    if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                        var distance = this.kinetic_.getDistance();
                        var angle = this.kinetic_.getAngle();
                        var center = view.getCenterInternal();
                        var centerpx = map.getPixelFromCoordinateInternal(center);
                        var dest = map.getCoordinateFromPixelInternal([
                            centerpx[0] - distance * Math.cos(angle),
                            centerpx[1] - distance * Math.sin(angle)
                        ]);
                        view.animateInternal({
                            center: view.getConstrainedCenter(dest),
                            duration: 500,
                            easing: (0, $eba911dc905f0f7f$export$57636bb43b1ccbb0)
                        });
                    }
                    if (this.panning_) {
                        this.panning_ = false;
                        view.endInteraction();
                    }
                    return false;
                }
                if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
                // after one finger up, tiny drag, second finger up
                this.kinetic_.begin();
                this.lastCentroid = null;
                return true;
            }
        },
        {
            /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ key: "handleDownEvent",
            value: function handleDownEvent(mapBrowserEvent) {
                if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
                    var map = mapBrowserEvent.map;
                    var view = map.getView();
                    this.lastCentroid = null;
                    // stop any current animation
                    if (view.getAnimating()) view.cancelAnimations();
                    if (this.kinetic_) this.kinetic_.begin();
                    // No kinetic as soon as more than one pointer on the screen is
                    // detected. This is to prevent nasty pans after pinch.
                    this.noKinetic_ = this.targetPointers.length > 1;
                    return true;
                }
                return false;
            }
        }
    ]);
    return DragPan;
}((0, $55974e46ba8893a2$export$2e2bcd8739ae039));
var $e4ba2fe60a0a7e42$export$2e2bcd8739ae039 = $e4ba2fe60a0a7e42$var$DragPan;


/**
 * @module ol/interaction/DragRotate
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");




/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */ var $00178efbfa0b89f3$var$DragRotate = /*#__PURE__*/ function(PointerInteraction) {
    "use strict";
    (0, $kcqLc._)(DragRotate, PointerInteraction);
    var _super = (0, $4jYWU._)(DragRotate);
    function DragRotate(options) {
        (0, $5sFFs._)(this, DragRotate);
        var _this;
        options = options ? options : {};
        _this = _super.call(this, {
            stopDown: (0, $d0c140d5afad5e7c$export$8f11cee4bdc7e668)
        });
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ _this.condition_ = options.condition ? options.condition : (0, $480dbb0a0480b91f$export$4e5f01653f9f1f82);
        /**
     * @private
     * @type {number|undefined}
     */ _this.lastAngle_ = undefined;
        /**
     * @private
     * @type {number}
     */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    (0, $8O2fV._)(DragRotate, [
        {
            /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ key: "handleDragEvent",
            value: function handleDragEvent(mapBrowserEvent) {
                if (!(0, $480dbb0a0480b91f$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return;
                var map = mapBrowserEvent.map;
                var view = map.getView();
                if (view.getConstraints().rotation === (0, $bf3f3efa75c51dce$export$e20fbacbb41798b)) return;
                var size = map.getSize();
                var offset = mapBrowserEvent.pixel;
                var theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
                if (this.lastAngle_ !== undefined) {
                    var delta = theta - this.lastAngle_;
                    view.adjustRotationInternal(-delta);
                }
                this.lastAngle_ = theta;
            }
        },
        {
            /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ key: "handleUpEvent",
            value: function handleUpEvent(mapBrowserEvent) {
                if (!(0, $480dbb0a0480b91f$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return true;
                var map = mapBrowserEvent.map;
                var view = map.getView();
                view.endInteraction(this.duration_);
                return false;
            }
        },
        {
            /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ key: "handleDownEvent",
            value: function handleDownEvent(mapBrowserEvent) {
                if (!(0, $480dbb0a0480b91f$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return false;
                if ((0, $480dbb0a0480b91f$export$1238ad6b5e7fff70)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
                    var map = mapBrowserEvent.map;
                    map.getView().beginInteraction();
                    this.lastAngle_ = undefined;
                    return true;
                }
                return false;
            }
        }
    ]);
    return DragRotate;
}((0, $55974e46ba8893a2$export$2e2bcd8739ae039));
var $00178efbfa0b89f3$export$2e2bcd8739ae039 = $00178efbfa0b89f3$var$DragRotate;


/**
 * @module ol/interaction/DragZoom
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/interaction/DragBox
 */ // FIXME draw drag box

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $aBSBL = parcelRequire("aBSBL");

var $4jYWU = parcelRequire("4jYWU");


/**
 * @module ol/render/Box
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");


var $a830307417a252f6$var$RenderBox = /*#__PURE__*/ function(Disposable) {
    "use strict";
    (0, $kcqLc._)(RenderBox, Disposable);
    var _super = (0, $4jYWU._)(RenderBox);
    function RenderBox(className) {
        (0, $5sFFs._)(this, RenderBox);
        var _this;
        _this = _super.call(this);
        /**
     * @type {import("../geom/Polygon.js").default}
     * @private
     */ _this.geometry_ = null;
        /**
     * @type {HTMLDivElement}
     * @private
     */ _this.element_ = document.createElement("div");
        _this.element_.style.position = "absolute";
        _this.element_.style.pointerEvents = "auto";
        _this.element_.className = "ol-box " + className;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ _this.map_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ _this.startPixel_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ _this.endPixel_ = null;
        return _this;
    }
    (0, $8O2fV._)(RenderBox, [
        {
            /**
   * Clean up.
   */ key: "disposeInternal",
            value: function disposeInternal() {
                this.setMap(null);
            }
        },
        {
            /**
   * @private
   */ key: "render_",
            value: function render_() {
                var startPixel = this.startPixel_;
                var endPixel = this.endPixel_;
                var px = "px";
                var style = this.element_.style;
                style.left = Math.min(startPixel[0], endPixel[0]) + px;
                style.top = Math.min(startPixel[1], endPixel[1]) + px;
                style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
                style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
            }
        },
        {
            /**
   * @param {import("../Map.js").default|null} map Map.
   */ key: "setMap",
            value: function setMap(map) {
                if (this.map_) {
                    this.map_.getOverlayContainer().removeChild(this.element_);
                    var style = this.element_.style;
                    style.left = "inherit";
                    style.top = "inherit";
                    style.width = "inherit";
                    style.height = "inherit";
                }
                this.map_ = map;
                if (this.map_) this.map_.getOverlayContainer().appendChild(this.element_);
            }
        },
        {
            /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */ key: "setPixels",
            value: function setPixels(startPixel, endPixel) {
                this.startPixel_ = startPixel;
                this.endPixel_ = endPixel;
                this.createOrUpdateGeometry();
                this.render_();
            }
        },
        {
            /**
   * Creates or updates the cached geometry.
   */ key: "createOrUpdateGeometry",
            value: function createOrUpdateGeometry() {
                var startPixel = this.startPixel_;
                var endPixel = this.endPixel_;
                var pixels = [
                    startPixel,
                    [
                        startPixel[0],
                        endPixel[1]
                    ],
                    endPixel,
                    [
                        endPixel[0],
                        startPixel[1]
                    ]
                ];
                var coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_);
                // close the polygon
                coordinates[4] = coordinates[0].slice();
                if (!this.geometry_) this.geometry_ = new (0, $933385b05f7b89e7$export$2e2bcd8739ae039)([
                    coordinates
                ]);
                else this.geometry_.setCoordinates([
                    coordinates
                ]);
            }
        },
        {
            /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */ key: "getGeometry",
            value: function getGeometry() {
                return this.geometry_;
            }
        }
    ]);
    return RenderBox;
}((0, $2a74d1a591bba5b3$export$2e2bcd8739ae039));
var $a830307417a252f6$export$2e2bcd8739ae039 = $a830307417a252f6$var$RenderBox;



/**
 * A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */ /**
 * @enum {string}
 */ var $03a4bddc67d54e5b$var$DragBoxEventType = {
    /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */ BOXSTART: "boxstart",
    /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */ BOXDRAG: "boxdrag",
    /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */ BOXEND: "boxend",
    /**
   * Triggered upon drag box canceled.
   * @event DragBoxEvent#boxcancel
   * @api
   */ BOXCANCEL: "boxcancel"
};
var $03a4bddc67d54e5b$export$7053c33c051365ea = /*#__PURE__*/ function(Event) {
    "use strict";
    (0, $kcqLc._)(DragBoxEvent, Event);
    var _super = (0, $4jYWU._)(DragBoxEvent);
    function DragBoxEvent(type, coordinate, mapBrowserEvent) {
        (0, $5sFFs._)(this, DragBoxEvent);
        var _this;
        _this = _super.call(this, type);
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ _this.coordinate = coordinate;
        /**
     * @const
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ _this.mapBrowserEvent = mapBrowserEvent;
        return _this;
    }
    return DragBoxEvent;
}((0, $aBSBL._)((0, $1a4702ad15857f9a$export$2e2bcd8739ae039)));
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'boxcancel'|'boxdrag'|'boxend'|'boxstart', DragBoxEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'boxcancel'|'boxdrag'|'boxend', Return>} DragBoxOnSignature
 */ /**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom~DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */ var $03a4bddc67d54e5b$var$DragBox = /*#__PURE__*/ function(PointerInteraction) {
    "use strict";
    (0, $kcqLc._)(DragBox, PointerInteraction);
    var _super = (0, $4jYWU._)(DragBox);
    function DragBox(options) {
        (0, $5sFFs._)(this, DragBox);
        var _this;
        _this = _super.call(this);
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ _this.on;
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ _this.once;
        /***
     * @type {DragBoxOnSignature<void>}
     */ _this.un;
        options = options ? options : {};
        /**
     * @type {import("../render/Box.js").default}
     * @private
     */ _this.box_ = new (0, $a830307417a252f6$export$2e2bcd8739ae039)(options.className || "ol-dragbox");
        /**
     * @type {number}
     * @private
     */ _this.minArea_ = options.minArea !== undefined ? options.minArea : 64;
        if (options.onBoxEnd) _this.onBoxEnd = options.onBoxEnd;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ _this.startPixel_ = null;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ _this.condition_ = options.condition ? options.condition : (0, $480dbb0a0480b91f$export$1238ad6b5e7fff70);
        /**
     * @private
     * @type {EndCondition}
     */ _this.boxEndCondition_ = options.boxEndCondition ? options.boxEndCondition : _this.defaultBoxEndCondition;
        return _this;
    }
    (0, $8O2fV._)(DragBox, [
        {
            /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */ key: "defaultBoxEndCondition",
            value: function defaultBoxEndCondition(mapBrowserEvent, startPixel, endPixel) {
                var width = endPixel[0] - startPixel[0];
                var height = endPixel[1] - startPixel[1];
                return width * width + height * height >= this.minArea_;
            }
        },
        {
            /**
   * Returns geometry of last drawn box.
   * @return {import("../geom/Polygon.js").default} Geometry.
   * @api
   */ key: "getGeometry",
            value: function getGeometry() {
                return this.box_.getGeometry();
            }
        },
        {
            /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ key: "handleDragEvent",
            value: function handleDragEvent(mapBrowserEvent) {
                this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
                this.dispatchEvent(new $03a4bddc67d54e5b$export$7053c33c051365ea($03a4bddc67d54e5b$var$DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
            }
        },
        {
            /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ key: "handleUpEvent",
            value: function handleUpEvent(mapBrowserEvent) {
                this.box_.setMap(null);
                var completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);
                if (completeBox) this.onBoxEnd(mapBrowserEvent);
                this.dispatchEvent(new $03a4bddc67d54e5b$export$7053c33c051365ea(completeBox ? $03a4bddc67d54e5b$var$DragBoxEventType.BOXEND : $03a4bddc67d54e5b$var$DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
                return false;
            }
        },
        {
            /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ key: "handleDownEvent",
            value: function handleDownEvent(mapBrowserEvent) {
                if (this.condition_(mapBrowserEvent)) {
                    this.startPixel_ = mapBrowserEvent.pixel;
                    this.box_.setMap(mapBrowserEvent.map);
                    this.box_.setPixels(this.startPixel_, this.startPixel_);
                    this.dispatchEvent(new $03a4bddc67d54e5b$export$7053c33c051365ea($03a4bddc67d54e5b$var$DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
                    return true;
                }
                return false;
            }
        },
        {
            /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */ key: "onBoxEnd",
            value: function onBoxEnd(event) {}
        }
    ]);
    return DragBox;
}((0, $55974e46ba8893a2$export$2e2bcd8739ae039));
var $03a4bddc67d54e5b$export$2e2bcd8739ae039 = $03a4bddc67d54e5b$var$DragBox;




/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */ var $b2ece6ec42baa809$var$DragZoom = /*#__PURE__*/ function(DragBox) {
    "use strict";
    (0, $kcqLc._)(DragZoom, DragBox);
    var _super = (0, $4jYWU._)(DragZoom);
    function DragZoom(options) {
        (0, $5sFFs._)(this, DragZoom);
        var _this;
        options = options ? options : {};
        var condition = options.condition ? options.condition : (0, $480dbb0a0480b91f$export$5d31fe68a477cfbb);
        _this = _super.call(this, {
            condition: condition,
            className: options.className || "ol-dragzoom",
            minArea: options.minArea
        });
        /**
     * @private
     * @type {number}
     */ _this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
     * @private
     * @type {boolean}
     */ _this.out_ = options.out !== undefined ? options.out : false;
        return _this;
    }
    (0, $8O2fV._)(DragZoom, [
        {
            /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */ key: "onBoxEnd",
            value: function onBoxEnd(event) {
                var map = this.getMap();
                var view = /** @type {!import("../View.js").default} */ map.getView();
                var geometry = this.getGeometry();
                if (this.out_) {
                    var rotatedExtent = view.rotatedExtentForGeometry(geometry);
                    var resolution = view.getResolutionForExtentInternal(rotatedExtent);
                    var factor = view.getResolution() / resolution;
                    geometry = geometry.clone();
                    geometry.scale(factor * factor);
                }
                view.fitInternal(geometry, {
                    duration: this.duration_,
                    easing: (0, $eba911dc905f0f7f$export$57636bb43b1ccbb0)
                });
            }
        }
    ]);
    return DragZoom;
}((0, $03a4bddc67d54e5b$export$2e2bcd8739ae039));
var $b2ece6ec42baa809$export$2e2bcd8739ae039 = $b2ece6ec42baa809$var$DragZoom;


/**
 * @module ol/interaction/KeyboardPan
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");


/**
 * @module ol/events/Key
 */ /**
 * @enum {string}
 * @const
 */ var $94e1bd2294cada04$export$2e2bcd8739ae039 = {
    LEFT: "ArrowLeft",
    UP: "ArrowUp",
    RIGHT: "ArrowRight",
    DOWN: "ArrowDown"
};




/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.noModifierKeys} and
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */ /**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */ var $3b398bbf2b891f8d$var$KeyboardPan = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $kcqLc._)(KeyboardPan, Interaction);
    var _super = (0, $4jYWU._)(KeyboardPan);
    function KeyboardPan(options) {
        (0, $5sFFs._)(this, KeyboardPan);
        var _this;
        _this = _super.call(this);
        options = options || {};
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ _this.defaultCondition_ = function(mapBrowserEvent) {
            return (0, $480dbb0a0480b91f$export$fdc892d0d8fe3bfb)(mapBrowserEvent) && (0, $480dbb0a0480b91f$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ _this.condition_ = options.condition !== undefined ? options.condition : _this.defaultCondition_;
        /**
     * @private
     * @type {number}
     */ _this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
     * @private
     * @type {number}
     */ _this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
        return _this;
    }
    (0, $8O2fV._)(KeyboardPan, [
        {
            /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides the direction to pan to (if an arrow key was
   * pressed).
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */ key: "handleEvent",
            value: function handleEvent(mapBrowserEvent) {
                var stopEvent = false;
                if (mapBrowserEvent.type == (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).KEYDOWN) {
                    var keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
                    var key = keyEvent.key;
                    if (this.condition_(mapBrowserEvent) && (key == (0, $94e1bd2294cada04$export$2e2bcd8739ae039).DOWN || key == (0, $94e1bd2294cada04$export$2e2bcd8739ae039).LEFT || key == (0, $94e1bd2294cada04$export$2e2bcd8739ae039).RIGHT || key == (0, $94e1bd2294cada04$export$2e2bcd8739ae039).UP)) {
                        var map = mapBrowserEvent.map;
                        var view = map.getView();
                        var mapUnitsDelta = view.getResolution() * this.pixelDelta_;
                        var deltaX = 0, deltaY = 0;
                        if (key == (0, $94e1bd2294cada04$export$2e2bcd8739ae039).DOWN) deltaY = -mapUnitsDelta;
                        else if (key == (0, $94e1bd2294cada04$export$2e2bcd8739ae039).LEFT) deltaX = -mapUnitsDelta;
                        else if (key == (0, $94e1bd2294cada04$export$2e2bcd8739ae039).RIGHT) deltaX = mapUnitsDelta;
                        else deltaY = mapUnitsDelta;
                        var delta = [
                            deltaX,
                            deltaY
                        ];
                        (0, $96b4c00c3a1729e3$export$bb628a54ab399bc9)(delta, view.getRotation());
                        (0, $8d152b473ff8d06b$export$4c486572e961a974)(view, delta, this.duration_);
                        keyEvent.preventDefault();
                        stopEvent = true;
                    }
                }
                return !stopEvent;
            }
        }
    ]);
    return KeyboardPan;
}((0, $8d152b473ff8d06b$export$2e2bcd8739ae039));
var $3b398bbf2b891f8d$export$2e2bcd8739ae039 = $3b398bbf2b891f8d$var$KeyboardPan;


/**
 * @module ol/interaction/KeyboardZoom
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");



/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. The default condition is
 * that {@link module:ol/events/condition.targetNotEditable} is fulfilled and that
 * the platform modifier key isn't pressed
 * (!{@link module:ol/events/condition.platformModifierKey}).
 * @property {number} [delta=1] The zoom level delta on each key press.
 */ /**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */ var $e400524f5f3e9797$var$KeyboardZoom = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $kcqLc._)(KeyboardZoom, Interaction);
    var _super = (0, $4jYWU._)(KeyboardZoom);
    function KeyboardZoom(options) {
        (0, $5sFFs._)(this, KeyboardZoom);
        var _this;
        _this = _super.call(this);
        options = options ? options : {};
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ _this.condition_ = options.condition ? options.condition : function(mapBrowserEvent) {
            return !(0, $480dbb0a0480b91f$export$32603ad571dd22b5)(mapBrowserEvent) && (0, $480dbb0a0480b91f$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {number}
     */ _this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ _this.duration_ = options.duration !== undefined ? options.duration : 100;
        return _this;
    }
    (0, $8O2fV._)(KeyboardZoom, [
        {
            /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
   * key pressed was '+' or '-').
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */ key: "handleEvent",
            value: function handleEvent(mapBrowserEvent) {
                var stopEvent = false;
                if (mapBrowserEvent.type == (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).KEYDOWN || mapBrowserEvent.type == (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).KEYPRESS) {
                    var keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
                    var key = keyEvent.key;
                    if (this.condition_(mapBrowserEvent) && (key === "+" || key === "-")) {
                        var map = mapBrowserEvent.map;
                        var delta = key === "+" ? this.delta_ : -this.delta_;
                        var view = map.getView();
                        (0, $8d152b473ff8d06b$export$ace321ff2a8016ef)(view, delta, undefined, this.duration_);
                        keyEvent.preventDefault();
                        stopEvent = true;
                    }
                }
                return !stopEvent;
            }
        }
    ]);
    return KeyboardZoom;
}((0, $8d152b473ff8d06b$export$2e2bcd8739ae039));
var $e400524f5f3e9797$export$2e2bcd8739ae039 = $e400524f5f3e9797$var$KeyboardZoom;


/**
 * @module ol/Kinetic
 */ /**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
var $a071775e7ce3ec59$var$Kinetic = /*#__PURE__*/ function() {
    "use strict";
    function Kinetic(decay, minVelocity, delay) {
        (0, $5sFFs._)(this, Kinetic);
        /**
     * @private
     * @type {number}
     */ this.decay_ = decay;
        /**
     * @private
     * @type {number}
     */ this.minVelocity_ = minVelocity;
        /**
     * @private
     * @type {number}
     */ this.delay_ = delay;
        /**
     * @private
     * @type {Array<number>}
     */ this.points_ = [];
        /**
     * @private
     * @type {number}
     */ this.angle_ = 0;
        /**
     * @private
     * @type {number}
     */ this.initialVelocity_ = 0;
    }
    (0, $8O2fV._)(Kinetic, [
        {
            /**
   * FIXME empty description for jsdoc
   */ key: "begin",
            value: function begin() {
                this.points_.length = 0;
                this.angle_ = 0;
                this.initialVelocity_ = 0;
            }
        },
        {
            /**
   * @param {number} x X.
   * @param {number} y Y.
   */ key: "update",
            value: function update(x, y) {
                this.points_.push(x, y, Date.now());
            }
        },
        {
            /**
   * @return {boolean} Whether we should do kinetic animation.
   */ key: "end",
            value: function end() {
                if (this.points_.length < 6) // at least 2 points are required (i.e. there must be at least 6 elements
                // in the array)
                return false;
                var delay = Date.now() - this.delay_;
                var lastIndex = this.points_.length - 3;
                if (this.points_[lastIndex + 2] < delay) // the last tracked point is too old, which means that the user stopped
                // panning before releasing the map
                return false;
                // get the first point which still falls into the delay time
                var firstIndex = lastIndex - 3;
                while(firstIndex > 0 && this.points_[firstIndex + 2] > delay)firstIndex -= 3;
                var duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
                // we don't want a duration of 0 (divide by zero)
                // we also make sure the user panned for a duration of at least one frame
                // (1/60s) to compute sane displacement values
                if (duration < 1000 / 60) return false;
                var dx = this.points_[lastIndex] - this.points_[firstIndex];
                var dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
                this.angle_ = Math.atan2(dy, dx);
                this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
                return this.initialVelocity_ > this.minVelocity_;
            }
        },
        {
            /**
   * @return {number} Total distance travelled (pixels).
   */ key: "getDistance",
            value: function getDistance() {
                return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
            }
        },
        {
            /**
   * @return {number} Angle of the kinetic panning animation (radians).
   */ key: "getAngle",
            value: function getAngle() {
                return this.angle_;
            }
        }
    ]);
    return Kinetic;
}();
var $a071775e7ce3ec59$export$2e2bcd8739ae039 = $a071775e7ce3ec59$var$Kinetic;


/**
 * @module ol/interaction/MouseWheelZoom
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");





/**
 * @typedef {'trackpad' | 'wheel'} Mode
 */ /**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */ var $60d1be5ee228f0fc$var$MouseWheelZoom = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $kcqLc._)(MouseWheelZoom, Interaction);
    var _super = (0, $4jYWU._)(MouseWheelZoom);
    function MouseWheelZoom(options) {
        (0, $5sFFs._)(this, MouseWheelZoom);
        var _this;
        options = options ? options : {};
        _this = _super.call(this, /** @type {import("./Interaction.js").InteractionOptions} */ options);
        /**
     * @private
     * @type {number}
     */ _this.totalDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ _this.lastDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ _this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
        /**
     * @private
     * @type {number}
     */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @private
     * @type {number}
     */ _this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
     * @private
     * @type {boolean}
     */ _this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
        /**
     * @private
     * @type {boolean}
     */ _this.constrainResolution_ = options.constrainResolution !== undefined ? options.constrainResolution : false;
        var condition = options.condition ? options.condition : (0, $480dbb0a0480b91f$export$ba9e5d519bc326ca);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ _this.condition_ = options.onFocusOnly ? (0, $480dbb0a0480b91f$export$84bf76cd7afc7469)((0, $480dbb0a0480b91f$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {?import("../coordinate.js").Coordinate}
     */ _this.lastAnchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ _this.startTime_ = undefined;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ _this.timeoutId_;
        /**
     * @private
     * @type {Mode|undefined}
     */ _this.mode_ = undefined;
        /**
     * Trackpad events separated by this delay will be considered separate
     * interactions.
     * @private
     * @type {number}
     */ _this.trackpadEventGap_ = 400;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ _this.trackpadTimeoutId_;
        /**
     * The number of delta values per zoom level
     * @private
     * @type {number}
     */ _this.deltaPerZoom_ = 300;
        return _this;
    }
    (0, $8O2fV._)(MouseWheelZoom, [
        {
            /**
   * @private
   */ key: "endInteraction_",
            value: function endInteraction_() {
                this.trackpadTimeoutId_ = undefined;
                var map = this.getMap();
                if (!map) return;
                var view = map.getView();
                view.endInteraction(undefined, this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0, this.lastAnchor_);
            }
        },
        {
            /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */ key: "handleEvent",
            value: function handleEvent(mapBrowserEvent) {
                if (!this.condition_(mapBrowserEvent)) return true;
                var type = mapBrowserEvent.type;
                if (type !== (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).WHEEL) return true;
                var map = mapBrowserEvent.map;
                var wheelEvent = /** @type {WheelEvent} */ mapBrowserEvent.originalEvent;
                wheelEvent.preventDefault();
                if (this.useAnchor_) this.lastAnchor_ = mapBrowserEvent.coordinate;
                // Delta normalisation inspired by
                // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
                var delta;
                if (mapBrowserEvent.type == (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).WHEEL) {
                    delta = wheelEvent.deltaY;
                    if ((0, $c4937aaad0f121a7$export$8442bdfd18b7b8a6) && wheelEvent.deltaMode === WheelEvent.DOM_DELTA_PIXEL) delta /= (0, $c4937aaad0f121a7$export$6b83a0446fc26f94);
                    if (wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE) delta *= 40;
                }
                if (delta === 0) return false;
                this.lastDelta_ = delta;
                var now = Date.now();
                if (this.startTime_ === undefined) this.startTime_ = now;
                if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) this.mode_ = Math.abs(delta) < 4 ? "trackpad" : "wheel";
                var view = map.getView();
                if (this.mode_ === "trackpad" && !(view.getConstrainResolution() || this.constrainResolution_)) {
                    if (this.trackpadTimeoutId_) clearTimeout(this.trackpadTimeoutId_);
                    else {
                        if (view.getAnimating()) view.cancelAnimations();
                        view.beginInteraction();
                    }
                    this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
                    view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_);
                    this.startTime_ = now;
                    return false;
                }
                this.totalDelta_ += delta;
                var timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
                clearTimeout(this.timeoutId_);
                this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
                return false;
            }
        },
        {
            /**
   * @private
   * @param {import("../Map.js").default} map Map.
   */ key: "handleWheelZoom_",
            value: function handleWheelZoom_(map) {
                var view = map.getView();
                if (view.getAnimating()) view.cancelAnimations();
                var delta = -(0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;
                if (view.getConstrainResolution() || this.constrainResolution_) // view has a zoom constraint, zoom by 1
                delta = delta ? delta > 0 ? 1 : -1 : 0;
                (0, $8d152b473ff8d06b$export$ace321ff2a8016ef)(view, delta, this.lastAnchor_, this.duration_);
                this.mode_ = undefined;
                this.totalDelta_ = 0;
                this.lastAnchor_ = null;
                this.startTime_ = undefined;
                this.timeoutId_ = undefined;
            }
        },
        {
            /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */ key: "setMouseAnchor",
            value: function setMouseAnchor(useAnchor) {
                this.useAnchor_ = useAnchor;
                if (!useAnchor) this.lastAnchor_ = null;
            }
        }
    ]);
    return MouseWheelZoom;
}((0, $8d152b473ff8d06b$export$2e2bcd8739ae039));
var $60d1be5ee228f0fc$export$2e2bcd8739ae039 = $60d1be5ee228f0fc$var$MouseWheelZoom;


/**
 * @module ol/interaction/PinchRotate
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");



/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */ var $558b88938ad92655$var$PinchRotate = /*#__PURE__*/ function(PointerInteraction) {
    "use strict";
    (0, $kcqLc._)(PinchRotate, PointerInteraction);
    var _super = (0, $4jYWU._)(PinchRotate);
    function PinchRotate(options) {
        (0, $5sFFs._)(this, PinchRotate);
        var _this;
        options = options ? options : {};
        var pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $d0c140d5afad5e7c$export$8f11cee4bdc7e668);
        _this = _super.call(this, pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ _this.anchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ _this.lastAngle_ = undefined;
        /**
     * @private
     * @type {boolean}
     */ _this.rotating_ = false;
        /**
     * @private
     * @type {number}
     */ _this.rotationDelta_ = 0.0;
        /**
     * @private
     * @type {number}
     */ _this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
     * @private
     * @type {number}
     */ _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    (0, $8O2fV._)(PinchRotate, [
        {
            /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ key: "handleDragEvent",
            value: function handleDragEvent(mapBrowserEvent) {
                var rotationDelta = 0.0;
                var touch0 = this.targetPointers[0];
                var touch1 = this.targetPointers[1];
                // angle between touches
                var angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
                if (this.lastAngle_ !== undefined) {
                    var delta = angle - this.lastAngle_;
                    this.rotationDelta_ += delta;
                    if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) this.rotating_ = true;
                    rotationDelta = delta;
                }
                this.lastAngle_ = angle;
                var map = mapBrowserEvent.map;
                var view = map.getView();
                if (view.getConstraints().rotation === (0, $bf3f3efa75c51dce$export$e20fbacbb41798b)) return;
                // rotate anchor point.
                // FIXME: should be the intersection point between the lines:
                //     touch0,touch1 and previousTouch0,previousTouch1
                this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $55974e46ba8893a2$export$e2a20c553f6c85ce)(this.targetPointers)));
                // rotate
                if (this.rotating_) {
                    map.render();
                    view.adjustRotationInternal(rotationDelta, this.anchor_);
                }
            }
        },
        {
            /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ key: "handleUpEvent",
            value: function handleUpEvent(mapBrowserEvent) {
                if (this.targetPointers.length < 2) {
                    var map = mapBrowserEvent.map;
                    var view = map.getView();
                    view.endInteraction(this.duration_);
                    return false;
                }
                return true;
            }
        },
        {
            /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ key: "handleDownEvent",
            value: function handleDownEvent(mapBrowserEvent) {
                if (this.targetPointers.length >= 2) {
                    var map = mapBrowserEvent.map;
                    this.anchor_ = null;
                    this.lastAngle_ = undefined;
                    this.rotating_ = false;
                    this.rotationDelta_ = 0.0;
                    if (!this.handlingDownUpSequence) map.getView().beginInteraction();
                    return true;
                }
                return false;
            }
        }
    ]);
    return PinchRotate;
}((0, $55974e46ba8893a2$export$2e2bcd8739ae039));
var $558b88938ad92655$export$2e2bcd8739ae039 = $558b88938ad92655$var$PinchRotate;


/**
 * @module ol/interaction/PinchZoom
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");


/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */ var $3d74ec0e492e0bac$var$PinchZoom = /*#__PURE__*/ function(PointerInteraction) {
    "use strict";
    (0, $kcqLc._)(PinchZoom, PointerInteraction);
    var _super = (0, $4jYWU._)(PinchZoom);
    function PinchZoom(options) {
        (0, $5sFFs._)(this, PinchZoom);
        var _this;
        options = options ? options : {};
        var pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $d0c140d5afad5e7c$export$8f11cee4bdc7e668);
        _this = _super.call(this, pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ _this.anchor_ = null;
        /**
     * @private
     * @type {number}
     */ _this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
     * @private
     * @type {number|undefined}
     */ _this.lastDistance_ = undefined;
        /**
     * @private
     * @type {number}
     */ _this.lastScaleDelta_ = 1;
        return _this;
    }
    (0, $8O2fV._)(PinchZoom, [
        {
            /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */ key: "handleDragEvent",
            value: function handleDragEvent(mapBrowserEvent) {
                var scaleDelta = 1.0;
                var touch0 = this.targetPointers[0];
                var touch1 = this.targetPointers[1];
                var dx = touch0.clientX - touch1.clientX;
                var dy = touch0.clientY - touch1.clientY;
                // distance between touches
                var distance = Math.sqrt(dx * dx + dy * dy);
                if (this.lastDistance_ !== undefined) scaleDelta = this.lastDistance_ / distance;
                this.lastDistance_ = distance;
                var map = mapBrowserEvent.map;
                var view = map.getView();
                if (scaleDelta != 1.0) this.lastScaleDelta_ = scaleDelta;
                // scale anchor point.
                this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $55974e46ba8893a2$export$e2a20c553f6c85ce)(this.targetPointers)));
                // scale, bypass the resolution constraint
                map.render();
                view.adjustResolutionInternal(scaleDelta, this.anchor_);
            }
        },
        {
            /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ key: "handleUpEvent",
            value: function handleUpEvent(mapBrowserEvent) {
                if (this.targetPointers.length < 2) {
                    var map = mapBrowserEvent.map;
                    var view = map.getView();
                    var direction = this.lastScaleDelta_ > 1 ? 1 : -1;
                    view.endInteraction(this.duration_, direction);
                    return false;
                }
                return true;
            }
        },
        {
            /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */ key: "handleDownEvent",
            value: function handleDownEvent(mapBrowserEvent) {
                if (this.targetPointers.length >= 2) {
                    var map = mapBrowserEvent.map;
                    this.anchor_ = null;
                    this.lastDistance_ = undefined;
                    this.lastScaleDelta_ = 1;
                    if (!this.handlingDownUpSequence) map.getView().beginInteraction();
                    return true;
                }
                return false;
            }
        }
    ]);
    return PinchZoom;
}((0, $55974e46ba8893a2$export$2e2bcd8739ae039));
var $3d74ec0e492e0bac$export$2e2bcd8739ae039 = $3d74ec0e492e0bac$var$PinchZoom;


function $7c0401c3e7970d40$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Interaction.js").default>} */ var interactions = new (0, $4586ff11f2e741e8$export$2e2bcd8739ae039)();
    var kinetic = new (0, $a071775e7ce3ec59$export$2e2bcd8739ae039)(-0.005, 0.05, 100);
    var altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;
    if (altShiftDragRotate) interactions.push(new (0, $00178efbfa0b89f3$export$2e2bcd8739ae039)());
    var doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) interactions.push(new (0, $2f9262e3640b16eb$export$2e2bcd8739ae039)({
        delta: options.zoomDelta,
        duration: options.zoomDuration
    }));
    var dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) interactions.push(new (0, $e4ba2fe60a0a7e42$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        kinetic: kinetic
    }));
    var pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) interactions.push(new (0, $558b88938ad92655$export$2e2bcd8739ae039)());
    var pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) interactions.push(new (0, $3d74ec0e492e0bac$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    var keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new (0, $3b398bbf2b891f8d$export$2e2bcd8739ae039)());
        interactions.push(new (0, $e400524f5f3e9797$export$2e2bcd8739ae039)({
            delta: options.zoomDelta,
            duration: options.zoomDuration
        }));
    }
    var mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) interactions.push(new (0, $60d1be5ee228f0fc$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        duration: options.zoomDuration
    }));
    var shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) interactions.push(new (0, $b2ece6ec42baa809$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    return interactions;
}





/**
 * @module ol/size
 */ /**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */ /**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size} [dest] Optional reusable size array.
 * @return {Size} The buffered size.
 */ function $9fd3f8f53b8c7a01$export$ab1029bcae9ddb4a(size, num, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] + 2 * num;
    dest[1] = size[1] + 2 * num;
    return dest;
}
function $9fd3f8f53b8c7a01$export$622c471beb1693c7(size) {
    return size[0] > 0 && size[1] > 0;
}
function $9fd3f8f53b8c7a01$export$dcdf75081b88279d(size, ratio, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] * ratio + 0.5 | 0;
    dest[1] = size[1] * ratio + 0.5 | 0;
    return dest;
}
function $9fd3f8f53b8c7a01$export$a71a825ff42fb8e1(size, dest) {
    if (Array.isArray(size)) return size;
    if (dest === undefined) dest = [
        size,
        size
    ];
    else {
        dest[0] = size;
        dest[1] = size;
    }
    return dest;
}





/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate Animate.
 * @property {import("./transform.js").Transform} coordinateToPixelTransform CoordinateToPixelTransform.
 * @property {import("rbush").default} declutterTree DeclutterTree.
 * @property {null|import("./extent.js").Extent} extent Extent (in view projection coordinates).
 * @property {import("./extent.js").Extent} [nextExtent] Next extent during an animation series.
 * @property {number} index Index.
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray LayerStatesArray.
 * @property {number} layerIndex LayerIndex.
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform PixelToCoordinateTransform.
 * @property {Array<PostRenderFunction>} postRenderFunctions PostRenderFunctions.
 * @property {import("./size.js").Size} size Size.
 * @property {TileQueue} tileQueue TileQueue.
 * @property {!Object<string, Object<string, boolean>>} usedTiles UsedTiles.
 * @property {Array<number>} viewHints ViewHints.
 * @property {!Object<string, Object<string, boolean>>} wantedTiles WantedTiles.
 * @property {string} mapId The id of the map.
 * @property {Object<string, boolean>} renderTargets Identifiers of previously rendered elements.
 */ /**
 * @typedef {function(Map, ?FrameState): any} PostRenderFunction
 */ /**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default<import("./source/Source").default>): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer~Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */ /**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls] Controls.
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions] Interactions.
 * @property {HTMLElement|Document} keyboardEventTarget KeyboardEventTarget.
 * @property {Collection<import("./Overlay.js").default>} overlays Overlays.
 * @property {Object<string, *>} values Values.
 */ /**
 * @typedef {import("./ObjectEventType").Types|'change:layergroup'|'change:size'|'change:target'|'change:view'} MapObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<MapObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *    import("./Observable").OnSignature<import("./MapBrowserEventType").Types, import("./MapBrowserEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./MapEventType").Types, import("./MapEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./render/EventType").MapRenderEventTypes, import("./render/Event").default, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|MapObjectEventTypes|
 *      import("./MapBrowserEventType").Types|import("./MapEventType").Types|
 *      import("./render/EventType").MapRenderEventTypes, Return>} MapEventHandler
 */ /**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control/defaults.defaults} is used.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction/defaults.defaults} is used.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * **Note:** CSS `transform` support for the target element is limited to `scale`.
 * @property {View|Promise<import("./View.js").ViewOptions>} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */ /**
 * @param {import("./layer/Base.js").default} layer Layer.
 */ function $11907e309f89aeba$var$removeLayerMapProperty(layer) {
    if (layer instanceof (0, $45f7b7b1b4f025e5$export$2e2bcd8739ae039)) {
        layer.setMapInternal(null);
        return;
    }
    if (layer instanceof (0, $27fbb3acd6648829$export$2e2bcd8739ae039)) layer.getLayers().forEach($11907e309f89aeba$var$removeLayerMapProperty);
}
/**
 * @param {import("./layer/Base.js").default} layer Layer.
 * @param {Map} map Map.
 */ function $11907e309f89aeba$var$setLayerMapProperty(layer, map) {
    if (layer instanceof (0, $45f7b7b1b4f025e5$export$2e2bcd8739ae039)) {
        layer.setMapInternal(map);
        return;
    }
    if (layer instanceof (0, $27fbb3acd6648829$export$2e2bcd8739ae039)) {
        var layers = layer.getLayers().getArray();
        for(var i = 0, ii = layers.length; i < ii; ++i)$11907e309f89aeba$var$setLayerMapProperty(layers[i], map);
    }
}
/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map.js';
 *     import View from 'ol/View.js';
 *     import TileLayer from 'ol/layer/Tile.js';
 *     import OSM from 'ol/source/OSM.js';
 *
 *     const map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1,
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM(),
 *         }),
 *       ],
 *       target: 'map',
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile~TileLayer} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~LayerGroup}
 * is a subclass of {@link module:ol/layer/Base~BaseLayer}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires import("./render/Event.js").default#precompose
 * @fires import("./render/Event.js").default#postcompose
 * @fires import("./render/Event.js").default#rendercomplete
 * @api
 */ var $11907e309f89aeba$var$Map = /*#__PURE__*/ function(BaseObject) {
    "use strict";
    (0, $kcqLc._)(Map, BaseObject);
    var _super = (0, $4jYWU._)(Map);
    function Map(options) {
        (0, $5sFFs._)(this, Map);
        var _this;
        _this = _super.call(this);
        options = options || {};
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ _this.on;
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ _this.once;
        /***
     * @type {MapEventHandler<void>}
     */ _this.un;
        var optionsInternal = $11907e309f89aeba$var$createOptionsInternal(options);
        /**
     * @private
     * @type {boolean|undefined}
     */ _this.renderComplete_;
        /**
     * @private
     * @type {boolean}
     */ _this.loaded_ = true;
        /** @private */ _this.boundHandleBrowserEvent_ = _this.handleBrowserEvent.bind((0, $lyFcw._)(_this));
        /**
     * @type {number}
     * @private
     */ _this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
     * @private
     * @type {number}
     */ _this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : (0, $c4937aaad0f121a7$export$6b83a0446fc26f94);
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ _this.postRenderTimeoutHandle_;
        /**
     * @private
     * @type {number|undefined}
     */ _this.animationDelayKey_;
        /**
     * @private
     */ _this.animationDelay_ = _this.animationDelay_.bind((0, $lyFcw._)(_this));
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ _this.coordinateToPixelTransform_ = (0, $afa6393b3817702c$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ _this.pixelToCoordinateTransform_ = (0, $afa6393b3817702c$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {number}
     */ _this.frameIndex_ = 0;
        /**
     * @private
     * @type {?FrameState}
     */ _this.frameState_ = null;
        /**
     * The extent at the previous 'moveend' event.
     * @private
     * @type {import("./extent.js").Extent}
     */ _this.previousExtent_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ _this.viewPropertyListenerKey_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ _this.viewChangeListenerKey_ = null;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ _this.layerGroupPropertyListenerKeys_ = null;
        /**
     * @private
     * @type {!HTMLElement}
     */ _this.viewport_ = document.createElement("div");
        _this.viewport_.className = "ol-viewport" + ("ontouchstart" in window ? " ol-touch" : "");
        _this.viewport_.style.position = "relative";
        _this.viewport_.style.overflow = "hidden";
        _this.viewport_.style.width = "100%";
        _this.viewport_.style.height = "100%";
        /**
     * @private
     * @type {!HTMLElement}
     */ _this.overlayContainer_ = document.createElement("div");
        _this.overlayContainer_.style.position = "absolute";
        _this.overlayContainer_.style.zIndex = "0";
        _this.overlayContainer_.style.width = "100%";
        _this.overlayContainer_.style.height = "100%";
        _this.overlayContainer_.style.pointerEvents = "none";
        _this.overlayContainer_.className = "ol-overlaycontainer";
        _this.viewport_.appendChild(_this.overlayContainer_);
        /**
     * @private
     * @type {!HTMLElement}
     */ _this.overlayContainerStopEvent_ = document.createElement("div");
        _this.overlayContainerStopEvent_.style.position = "absolute";
        _this.overlayContainerStopEvent_.style.zIndex = "0";
        _this.overlayContainerStopEvent_.style.width = "100%";
        _this.overlayContainerStopEvent_.style.height = "100%";
        _this.overlayContainerStopEvent_.style.pointerEvents = "none";
        _this.overlayContainerStopEvent_.className = "ol-overlaycontainer-stopevent";
        _this.viewport_.appendChild(_this.overlayContainerStopEvent_);
        /**
     * @private
     * @type {MapBrowserEventHandler}
     */ _this.mapBrowserEventHandler_ = null;
        /**
     * @private
     * @type {number}
     */ _this.moveTolerance_ = options.moveTolerance;
        /**
     * @private
     * @type {HTMLElement|Document}
     */ _this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ _this.targetChangeHandlerKeys_ = null;
        /**
     * @private
     * @type {HTMLElement|null}
     */ _this.targetElement_ = null;
        /**
     * @type {ResizeObserver}
     */ _this.resizeObserver_ = new ResizeObserver(function() {
            return _this.updateSize();
        });
        /**
     * @type {Collection<import("./control/Control.js").default>}
     * @protected
     */ _this.controls = optionsInternal.controls || (0, $b49292dbcddf523e$export$ebe90cb607ad99e)();
        /**
     * @type {Collection<import("./interaction/Interaction.js").default>}
     * @protected
     */ _this.interactions = optionsInternal.interactions || (0, $7c0401c3e7970d40$export$ebe90cb607ad99e)({
            onFocusOnly: true
        });
        /**
     * @type {Collection<import("./Overlay.js").default>}
     * @private
     */ _this.overlays_ = optionsInternal.overlays;
        /**
     * A lookup of overlays by id.
     * @private
     * @type {Object<string, import("./Overlay.js").default>}
     */ _this.overlayIdIndex_ = {};
        /**
     * @type {import("./renderer/Map.js").default|null}
     * @private
     */ _this.renderer_ = null;
        /**
     * @private
     * @type {!Array<PostRenderFunction>}
     */ _this.postRenderFunctions_ = [];
        /**
     * @private
     * @type {TileQueue}
     */ _this.tileQueue_ = new (0, $be228fca8008ab39$export$2e2bcd8739ae039)(_this.getTilePriority.bind((0, $lyFcw._)(_this)), _this.handleTileChange_.bind((0, $lyFcw._)(_this)));
        _this.addChangeListener((0, $577f7939e4cd625e$export$2e2bcd8739ae039).LAYERGROUP, _this.handleLayerGroupChanged_);
        _this.addChangeListener((0, $577f7939e4cd625e$export$2e2bcd8739ae039).VIEW, _this.handleViewChanged_);
        _this.addChangeListener((0, $577f7939e4cd625e$export$2e2bcd8739ae039).SIZE, _this.handleSizeChanged_);
        _this.addChangeListener((0, $577f7939e4cd625e$export$2e2bcd8739ae039).TARGET, _this.handleTargetChanged_);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        _this.setProperties(optionsInternal.values);
        var map = (0, $lyFcw._)(_this);
        if (options.view && !(options.view instanceof (0, $2d5eedb534d9ecb2$export$2e2bcd8739ae039))) options.view.then(function(viewOptions) {
            map.setView(new (0, $2d5eedb534d9ecb2$export$2e2bcd8739ae039)(viewOptions));
        });
        _this.controls.addEventListener((0, $521f555f87c855d9$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent
       */ function(event) {
            event.element.setMap((0, $lyFcw._)(_this));
        });
        _this.controls.addEventListener((0, $521f555f87c855d9$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent.
       */ function(event) {
            event.element.setMap(null);
        });
        _this.interactions.addEventListener((0, $521f555f87c855d9$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ function(event) {
            event.element.setMap((0, $lyFcw._)(_this));
        });
        _this.interactions.addEventListener((0, $521f555f87c855d9$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ function(event) {
            event.element.setMap(null);
        });
        _this.overlays_.addEventListener((0, $521f555f87c855d9$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ function(event) {
            _this.addOverlayInternal_(event.element);
        });
        _this.overlays_.addEventListener((0, $521f555f87c855d9$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ function(event) {
            var id = event.element.getId();
            if (id !== undefined) delete _this.overlayIdIndex_[id.toString()];
            event.element.setMap(null);
        });
        _this.controls.forEach(/**
       * @param {import("./control/Control.js").default} control Control.
       */ function(control) {
            control.setMap((0, $lyFcw._)(_this));
        });
        _this.interactions.forEach(/**
       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
       */ function(interaction) {
            interaction.setMap((0, $lyFcw._)(_this));
        });
        _this.overlays_.forEach(_this.addOverlayInternal_.bind((0, $lyFcw._)(_this)));
        return _this;
    }
    (0, $8O2fV._)(Map, [
        {
            /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */ key: "addControl",
            value: function addControl(control) {
                this.getControls().push(control);
            }
        },
        {
            /**
   * Add the given interaction to the map. If you want to add an interaction
   * at another point of the collection use `getInteractions()` and the methods
   * available on {@link module:ol/Collection~Collection}. This can be used to
   * stop the event propagation from the handleEvent function. The interactions
   * get to handle the events in the reverse order of this collection.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */ key: "addInteraction",
            value: function addInteraction(interaction) {
                this.getInteractions().push(interaction);
            }
        },
        {
            /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */ key: "addLayer",
            value: function addLayer(layer) {
                var layers = this.getLayerGroup().getLayers();
                layers.push(layer);
            }
        },
        {
            /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
   * @private
   */ key: "handleLayerAdd_",
            value: function handleLayerAdd_(event) {
                $11907e309f89aeba$var$setLayerMapProperty(event.layer, this);
            }
        },
        {
            /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */ key: "addOverlay",
            value: function addOverlay(overlay) {
                this.getOverlays().push(overlay);
            }
        },
        {
            /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */ key: "addOverlayInternal_",
            value: function addOverlayInternal_(overlay) {
                var id = overlay.getId();
                if (id !== undefined) this.overlayIdIndex_[id.toString()] = overlay;
                overlay.setMap(this);
            }
        },
        {
            /**
   *
   * Clean up.
   */ key: "disposeInternal",
            value: function disposeInternal() {
                this.controls.clear();
                this.interactions.clear();
                this.overlays_.clear();
                this.resizeObserver_.disconnect();
                this.setTarget(null);
                (0, $404BM._)((0, $cEF31._)(Map.prototype), "disposeInternal", this).call(this);
            }
        },
        {
            /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `options`.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature~Feature feature} or
   *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template T
   * @api
   */ key: "forEachFeatureAtPixel",
            value: function forEachFeatureAtPixel(pixel, callback, options) {
                if (!this.frameState_ || !this.renderer_) return;
                var coordinate = this.getCoordinateFromPixelInternal(pixel);
                options = options !== undefined ? options : {};
                var hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
                var layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $d0c140d5afad5e7c$export$22e23a2304399231);
                var checkWrapped = options.checkWrapped !== false;
                return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
            }
        },
        {
            /**
   * Get all features that intersect a pixel on the viewport.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * an empty array if none were found.
   * @api
   */ key: "getFeaturesAtPixel",
            value: function getFeaturesAtPixel(pixel, options) {
                var features = [];
                this.forEachFeatureAtPixel(pixel, function(feature) {
                    features.push(feature);
                }, options);
                return features;
            }
        },
        {
            /**
   * Get all layers from all layer groups.
   * @return {Array<import("./layer/Layer.js").default>} Layers.
   * @api
   */ key: "getAllLayers",
            value: function getAllLayers() {
                var layers = [];
                function addLayersFrom(layerGroup) {
                    layerGroup.forEach(function(layer) {
                        if (layer instanceof (0, $27fbb3acd6648829$export$2e2bcd8739ae039)) addLayersFrom(layer.getLayers());
                        else layers.push(layer);
                    });
                }
                addLayersFrom(this.getLayers());
                return layers;
            }
        },
        {
            /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through the `layerFilter` option.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @api
   */ key: "hasFeatureAtPixel",
            value: function hasFeatureAtPixel(pixel, options) {
                if (!this.frameState_ || !this.renderer_) return false;
                var coordinate = this.getCoordinateFromPixelInternal(pixel);
                options = options !== undefined ? options : {};
                var layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $d0c140d5afad5e7c$export$22e23a2304399231);
                var hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
                var checkWrapped = options.checkWrapped !== false;
                return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
            }
        },
        {
            /**
   * Returns the coordinate in user projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */ key: "getEventCoordinate",
            value: function getEventCoordinate(event) {
                return this.getCoordinateFromPixel(this.getEventPixel(event));
            }
        },
        {
            /**
   * Returns the coordinate in view projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   */ key: "getEventCoordinateInternal",
            value: function getEventCoordinateInternal(event) {
                return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
            }
        },
        {
            /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {UIEvent|{clientX: number, clientY: number}} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */ key: "getEventPixel",
            value: function getEventPixel(event) {
                var viewport = this.viewport_;
                var viewportPosition = viewport.getBoundingClientRect();
                var viewportSize = this.getSize();
                var scaleX = viewportPosition.width / viewportSize[0];
                var scaleY = viewportPosition.height / viewportSize[1];
                var eventPosition = //FIXME Are we really calling this with a TouchEvent anywhere?
                "changedTouches" in event ? /** @type {TouchEvent} */ event.changedTouches[0] : /** @type {MouseEvent} */ event;
                return [
                    (eventPosition.clientX - viewportPosition.left) / scaleX,
                    (eventPosition.clientY - viewportPosition.top) / scaleY
                ];
            }
        },
        {
            /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */ key: "getTarget",
            value: function getTarget() {
                return /** @type {HTMLElement|string|undefined} */ this.get((0, $577f7939e4cd625e$export$2e2bcd8739ae039).TARGET);
            }
        },
        {
            /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */ key: "getTargetElement",
            value: function getTargetElement() {
                return this.targetElement_;
            }
        },
        {
            /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * user projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */ key: "getCoordinateFromPixel",
            value: function getCoordinateFromPixel(pixel) {
                return (0, $401a58d9dec354c1$export$698f563af1ba02a5)(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
            }
        },
        {
            /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   */ key: "getCoordinateFromPixelInternal",
            value: function getCoordinateFromPixelInternal(pixel) {
                var frameState = this.frameState_;
                if (!frameState) return null;
                return (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
            }
        },
        {
            /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */ key: "getControls",
            value: function getControls() {
                return this.controls;
            }
        },
        {
            /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */ key: "getOverlays",
            value: function getOverlays() {
                return this.overlays_;
            }
        },
        {
            /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default} Overlay.
   * @api
   */ key: "getOverlayById",
            value: function getOverlayById(id) {
                var overlay = this.overlayIdIndex_[id.toString()];
                return overlay !== undefined ? overlay : null;
            }
        },
        {
            /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */ key: "getInteractions",
            value: function getInteractions() {
                return this.interactions;
            }
        },
        {
            /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */ key: "getLayerGroup",
            value: function getLayerGroup() {
                return /** @type {LayerGroup} */ this.get((0, $577f7939e4cd625e$export$2e2bcd8739ae039).LAYERGROUP);
            }
        },
        {
            /**
   * Clear any existing layers and add layers to the map.
   * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
   * @api
   */ key: "setLayers",
            value: function setLayers(layers) {
                var group = this.getLayerGroup();
                if (layers instanceof (0, $4586ff11f2e741e8$export$2e2bcd8739ae039)) {
                    group.setLayers(layers);
                    return;
                }
                var collection = group.getLayers();
                collection.clear();
                collection.extend(layers);
            }
        },
        {
            /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */ key: "getLayers",
            value: function getLayers() {
                var layers = this.getLayerGroup().getLayers();
                return layers;
            }
        },
        {
            /**
   * @return {boolean} Layers have sources that are still loading.
   */ key: "getLoadingOrNotReady",
            value: function getLoadingOrNotReady() {
                var layerStatesArray = this.getLayerGroup().getLayerStatesArray();
                for(var i = 0, ii = layerStatesArray.length; i < ii; ++i){
                    var state = layerStatesArray[i];
                    if (!state.visible) continue;
                    var renderer = state.layer.getRenderer();
                    if (renderer && !renderer.ready) return true;
                    var source = state.layer.getSource();
                    if (source && source.loading) return true;
                }
                return false;
            }
        },
        {
            /**
   * Get the pixel for a coordinate.  This takes a coordinate in the user
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */ key: "getPixelFromCoordinate",
            value: function getPixelFromCoordinate(coordinate) {
                var viewCoordinate = (0, $401a58d9dec354c1$export$d4b8ec0b96db1ee2)(coordinate, this.getView().getProjection());
                return this.getPixelFromCoordinateInternal(viewCoordinate);
            }
        },
        {
            /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   */ key: "getPixelFromCoordinateInternal",
            value: function getPixelFromCoordinateInternal(coordinate) {
                var frameState = this.frameState_;
                if (!frameState) return null;
                return (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
            }
        },
        {
            /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default|null} Renderer
   */ key: "getRenderer",
            value: function getRenderer() {
                return this.renderer_;
            }
        },
        {
            /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ key: "getSize",
            value: function getSize() {
                return /** @type {import("./size.js").Size|undefined} */ this.get((0, $577f7939e4cd625e$export$2e2bcd8739ae039).SIZE);
            }
        },
        {
            /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */ key: "getView",
            value: function getView() {
                return /** @type {View} */ this.get((0, $577f7939e4cd625e$export$2e2bcd8739ae039).VIEW);
            }
        },
        {
            /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */ key: "getViewport",
            value: function getViewport() {
                return this.viewport_;
            }
        },
        {
            /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */ key: "getOverlayContainer",
            value: function getOverlayContainer() {
                return this.overlayContainer_;
            }
        },
        {
            /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */ key: "getOverlayContainerStopEvent",
            value: function getOverlayContainerStopEvent() {
                return this.overlayContainerStopEvent_;
            }
        },
        {
            /**
   * @return {!Document} The document where the map is displayed.
   */ key: "getOwnerDocument",
            value: function getOwnerDocument() {
                var targetElement = this.getTargetElement();
                return targetElement ? targetElement.ownerDocument : document;
            }
        },
        {
            /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */ key: "getTilePriority",
            value: function getTilePriority1(tile, tileSourceKey, tileCenter, tileResolution) {
                return (0, $be228fca8008ab39$export$f08ad5eceeff5d45)(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
            }
        },
        {
            /**
   * @param {UIEvent} browserEvent Browser event.
   * @param {string} [type] Type.
   */ key: "handleBrowserEvent",
            value: function handleBrowserEvent(browserEvent, type) {
                type = type || browserEvent.type;
                var mapBrowserEvent = new (0, $deabb4b46d514882$export$2e2bcd8739ae039)(type, this, browserEvent);
                this.handleMapBrowserEvent(mapBrowserEvent);
            }
        },
        {
            /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */ key: "handleMapBrowserEvent",
            value: function handleMapBrowserEvent(mapBrowserEvent) {
                if (!this.frameState_) // With no view defined, we cannot translate pixels into geographical
                // coordinates so interactions cannot be used.
                return;
                var originalEvent = /** @type {PointerEvent} */ mapBrowserEvent.originalEvent;
                var eventType = originalEvent.type;
                if (eventType === (0, $b75a92c87c1246de$export$2e2bcd8739ae039).POINTERDOWN || eventType === (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).WHEEL || eventType === (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).KEYDOWN) {
                    var doc = this.getOwnerDocument();
                    var rootNode = this.viewport_.getRootNode ? this.viewport_.getRootNode() : doc;
                    var target = /** @type {Node} */ originalEvent.target;
                    if (// Abort if the target is a child of the container for elements whose events are not meant
                    // to be handled by map interactions.
                    this.overlayContainerStopEvent_.contains(target) || // Abort if the event target is a child of the container that is no longer in the page.
                    // It's possible for the target to no longer be in the page if it has been removed in an
                    // event listener, this might happen in a Control that recreates it's content based on
                    // user interaction either manually or via a render in something like https://reactjs.org/
                    !(rootNode === doc ? doc.documentElement : rootNode).contains(target)) return;
                }
                mapBrowserEvent.frameState = this.frameState_;
                if (this.dispatchEvent(mapBrowserEvent) !== false) {
                    var interactionsArray = this.getInteractions().getArray().slice();
                    for(var i = interactionsArray.length - 1; i >= 0; i--){
                        var interaction = interactionsArray[i];
                        if (interaction.getMap() !== this || !interaction.getActive() || !this.getTargetElement()) continue;
                        var cont = interaction.handleEvent(mapBrowserEvent);
                        if (!cont || mapBrowserEvent.propagationStopped) break;
                    }
                }
            }
        },
        {
            /**
   * @protected
   */ key: "handlePostRender",
            value: function handlePostRender() {
                var frameState = this.frameState_;
                // Manage the tile queue
                // Image loads are expensive and a limited resource, so try to use them
                // efficiently:
                // * When the view is static we allow a large number of parallel tile loads
                //   to complete the frame as quickly as possible.
                // * When animating or interacting, image loads can cause janks, so we reduce
                //   the maximum number of loads per frame and limit the number of parallel
                //   tile loads to remain reactive to view changes and to reduce the chance of
                //   loading tiles that will quickly disappear from view.
                var tileQueue = this.tileQueue_;
                if (!tileQueue.isEmpty()) {
                    var maxTotalLoading = this.maxTilesLoading_;
                    var maxNewLoads = maxTotalLoading;
                    if (frameState) {
                        var hints = frameState.viewHints;
                        if (hints[(0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).ANIMATING] || hints[(0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).INTERACTING]) {
                            var lowOnFrameBudget = Date.now() - frameState.time > 8;
                            maxTotalLoading = lowOnFrameBudget ? 0 : 8;
                            maxNewLoads = lowOnFrameBudget ? 0 : 2;
                        }
                    }
                    if (tileQueue.getTilesLoading() < maxTotalLoading) {
                        tileQueue.reprioritize(); // FIXME only call if view has changed
                        tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
                    }
                }
                if (frameState && this.renderer_ && !frameState.animate) {
                    if (this.renderComplete_ === true) {
                        if (this.hasListener((0, $b1aa6e3366c76eef$export$2e2bcd8739ae039).RENDERCOMPLETE)) this.renderer_.dispatchRenderEvent((0, $b1aa6e3366c76eef$export$2e2bcd8739ae039).RENDERCOMPLETE, frameState);
                        if (this.loaded_ === false) {
                            this.loaded_ = true;
                            this.dispatchEvent(new (0, $3822396dcb007337$export$2e2bcd8739ae039)((0, $c12eb239491bfe04$export$2e2bcd8739ae039).LOADEND, this, frameState));
                        }
                    } else if (this.loaded_ === true) {
                        this.loaded_ = false;
                        this.dispatchEvent(new (0, $3822396dcb007337$export$2e2bcd8739ae039)((0, $c12eb239491bfe04$export$2e2bcd8739ae039).LOADSTART, this, frameState));
                    }
                }
                var postRenderFunctions = this.postRenderFunctions_;
                for(var i = 0, ii = postRenderFunctions.length; i < ii; ++i)postRenderFunctions[i](this, frameState);
                postRenderFunctions.length = 0;
            }
        },
        {
            /**
   * @private
   */ key: "handleSizeChanged_",
            value: function handleSizeChanged_() {
                if (this.getView() && !this.getView().getAnimating()) this.getView().resolveConstraints(0);
                this.render();
            }
        },
        {
            /**
   * @private
   */ key: "handleTargetChanged_",
            value: function handleTargetChanged_() {
                if (this.mapBrowserEventHandler_) {
                    for(var i = 0, ii = this.targetChangeHandlerKeys_.length; i < ii; ++i)(0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921)(this.targetChangeHandlerKeys_[i]);
                    this.targetChangeHandlerKeys_ = null;
                    this.viewport_.removeEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_);
                    this.viewport_.removeEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_);
                    this.mapBrowserEventHandler_.dispose();
                    this.mapBrowserEventHandler_ = null;
                    (0, $e000035bb4c81589$export$1d0aa160432dfea5)(this.viewport_);
                }
                if (this.targetElement_) {
                    this.resizeObserver_.unobserve(this.targetElement_);
                    var rootNode = this.targetElement_.getRootNode();
                    if (rootNode instanceof ShadowRoot) this.resizeObserver_.unobserve(rootNode.host);
                    this.setSize(undefined);
                }
                // target may be undefined, null, a string or an Element.
                // If it's a string we convert it to an Element before proceeding.
                // If it's not now an Element we remove the viewport from the DOM.
                // If it's an Element we append the viewport element to it.
                var target = this.getTarget();
                var targetElement = typeof target === "string" ? document.getElementById(target) : target;
                this.targetElement_ = targetElement;
                if (!targetElement) {
                    if (this.renderer_) {
                        clearTimeout(this.postRenderTimeoutHandle_);
                        this.postRenderTimeoutHandle_ = undefined;
                        this.postRenderFunctions_.length = 0;
                        this.renderer_.dispose();
                        this.renderer_ = null;
                    }
                    if (this.animationDelayKey_) {
                        cancelAnimationFrame(this.animationDelayKey_);
                        this.animationDelayKey_ = undefined;
                    }
                } else {
                    targetElement.appendChild(this.viewport_);
                    if (!this.renderer_) this.renderer_ = new (0, $118c078137a8f6cc$export$2e2bcd8739ae039)(this);
                    this.mapBrowserEventHandler_ = new (0, $9b368d45b630e177$export$2e2bcd8739ae039)(this, this.moveTolerance_);
                    for(var key in 0, $5bf4deee70ab5b42$export$2e2bcd8739ae039)this.mapBrowserEventHandler_.addEventListener((0, $5bf4deee70ab5b42$export$2e2bcd8739ae039)[key], this.handleMapBrowserEvent.bind(this));
                    this.viewport_.addEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_, false);
                    this.viewport_.addEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_, (0, $c4937aaad0f121a7$export$f751ce96c6c4e4fc) ? {
                        passive: false
                    } : false);
                    var keyboardEventTarget = !this.keyboardEventTarget_ ? targetElement : this.keyboardEventTarget_;
                    this.targetChangeHandlerKeys_ = [
                        (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(keyboardEventTarget, (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).KEYDOWN, this.handleBrowserEvent, this),
                        (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(keyboardEventTarget, (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).KEYPRESS, this.handleBrowserEvent, this)
                    ];
                    var rootNode1 = targetElement.getRootNode();
                    if (rootNode1 instanceof ShadowRoot) this.resizeObserver_.observe(rootNode1.host);
                    this.resizeObserver_.observe(targetElement);
                }
                this.updateSize();
            // updateSize calls setSize, so no need to call this.render
            // ourselves here.
            }
        },
        {
            /**
   * @private
   */ key: "handleTileChange_",
            value: function handleTileChange_() {
                this.render();
            }
        },
        {
            /**
   * @private
   */ key: "handleViewPropertyChanged_",
            value: function handleViewPropertyChanged_() {
                this.render();
            }
        },
        {
            /**
   * @private
   */ key: "handleViewChanged_",
            value: function handleViewChanged_() {
                if (this.viewPropertyListenerKey_) {
                    (0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921)(this.viewPropertyListenerKey_);
                    this.viewPropertyListenerKey_ = null;
                }
                if (this.viewChangeListenerKey_) {
                    (0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921)(this.viewChangeListenerKey_);
                    this.viewChangeListenerKey_ = null;
                }
                var view = this.getView();
                if (view) {
                    this.updateViewportSize_(this.getSize());
                    this.viewPropertyListenerKey_ = (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(view, (0, $feee417cd33a5f20$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
                    this.viewChangeListenerKey_ = (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(view, (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE, this.handleViewPropertyChanged_, this);
                    view.resolveConstraints(0);
                }
                this.render();
            }
        },
        {
            /**
   * @private
   */ key: "handleLayerGroupChanged_",
            value: function handleLayerGroupChanged_() {
                if (this.layerGroupPropertyListenerKeys_) {
                    this.layerGroupPropertyListenerKeys_.forEach((0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921));
                    this.layerGroupPropertyListenerKeys_ = null;
                }
                var layerGroup = this.getLayerGroup();
                if (layerGroup) {
                    this.handleLayerAdd_(new (0, $27fbb3acd6648829$export$2f5ff21d758d25a7)("addlayer", layerGroup));
                    this.layerGroupPropertyListenerKeys_ = [
                        (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(layerGroup, (0, $feee417cd33a5f20$export$2e2bcd8739ae039).PROPERTYCHANGE, this.render, this),
                        (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(layerGroup, (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE, this.render, this),
                        (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(layerGroup, "addlayer", this.handleLayerAdd_, this),
                        (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(layerGroup, "removelayer", this.handleLayerRemove_, this)
                    ];
                }
                this.render();
            }
        },
        {
            /**
   * @return {boolean} Is rendered.
   */ key: "isRendered",
            value: function isRendered() {
                return !!this.frameState_;
            }
        },
        {
            /**
   * @private
   */ key: "animationDelay_",
            value: function animationDelay_() {
                this.animationDelayKey_ = undefined;
                this.renderFrame_(Date.now());
            }
        },
        {
            /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */ key: "renderSync",
            value: function renderSync() {
                if (this.animationDelayKey_) cancelAnimationFrame(this.animationDelayKey_);
                this.animationDelay_();
            }
        },
        {
            /**
   * Redraws all text after new fonts have loaded
   */ key: "redrawText",
            value: function redrawText() {
                var layerStates = this.getLayerGroup().getLayerStatesArray();
                for(var i = 0, ii = layerStates.length; i < ii; ++i){
                    var layer = layerStates[i].layer;
                    if (layer.hasRenderer()) layer.getRenderer().handleFontsChanged();
                }
            }
        },
        {
            /**
   * Request a map rendering (at the next animation frame).
   * @api
   */ key: "render",
            value: function render() {
                if (this.renderer_ && this.animationDelayKey_ === undefined) this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
            }
        },
        {
            /**
   * This method is meant to be called in a layer's `prerender` listener. It causes all collected
   * declutter items to be decluttered and rendered on the map immediately. This is useful for
   * layers that need to appear entirely above the decluttered items of layers lower in the layer
   * stack.
   * @api
   */ key: "flushDeclutterItems",
            value: function flushDeclutterItems() {
                var frameState = this.frameState_;
                if (!frameState) return;
                this.renderer_.flushDeclutterItems(frameState);
            }
        },
        {
            /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */ key: "removeControl",
            value: function removeControl(control) {
                return this.getControls().remove(control);
            }
        },
        {
            /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */ key: "removeInteraction",
            value: function removeInteraction(interaction) {
                return this.getInteractions().remove(interaction);
            }
        },
        {
            /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */ key: "removeLayer",
            value: function removeLayer(layer) {
                var layers = this.getLayerGroup().getLayers();
                return layers.remove(layer);
            }
        },
        {
            /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
   * @private
   */ key: "handleLayerRemove_",
            value: function handleLayerRemove_(event) {
                $11907e309f89aeba$var$removeLayerMapProperty(event.layer);
            }
        },
        {
            /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */ key: "removeOverlay",
            value: function removeOverlay(overlay) {
                return this.getOverlays().remove(overlay);
            }
        },
        {
            /**
   * @param {number} time Time.
   * @private
   */ key: "renderFrame_",
            value: function renderFrame_(time) {
                var _this = this;
                var size = this.getSize();
                var view = this.getView();
                var previousFrameState = this.frameState_;
                /** @type {?FrameState} */ var frameState = null;
                if (size !== undefined && (0, $9fd3f8f53b8c7a01$export$622c471beb1693c7)(size) && view && view.isDef()) {
                    var viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
                    var viewState = view.getState();
                    frameState = {
                        animate: false,
                        coordinateToPixelTransform: this.coordinateToPixelTransform_,
                        declutterTree: null,
                        extent: (0, $e86e0aa087890eb8$export$13ba650faf8308)(viewState.center, viewState.resolution, viewState.rotation, size),
                        index: this.frameIndex_++,
                        layerIndex: 0,
                        layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
                        pixelRatio: this.pixelRatio_,
                        pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                        postRenderFunctions: [],
                        size: size,
                        tileQueue: this.tileQueue_,
                        time: time,
                        usedTiles: {},
                        viewState: viewState,
                        viewHints: viewHints,
                        wantedTiles: {},
                        mapId: (0, $8b32fff2376556ef$export$5e82334337e0f204)(this),
                        renderTargets: {}
                    };
                    if (viewState.nextCenter && viewState.nextResolution) {
                        var rotation = isNaN(viewState.nextRotation) ? viewState.rotation : viewState.nextRotation;
                        frameState.nextExtent = (0, $e86e0aa087890eb8$export$13ba650faf8308)(viewState.nextCenter, viewState.nextResolution, rotation, size);
                    }
                }
                this.frameState_ = frameState;
                this.renderer_.renderFrame(frameState);
                if (frameState) {
                    if (frameState.animate) this.render();
                    Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
                    if (previousFrameState) {
                        var moveStart = !this.previousExtent_ || !(0, $e86e0aa087890eb8$export$dd1bc94b04021eeb)(this.previousExtent_) && !(0, $e86e0aa087890eb8$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
                        if (moveStart) {
                            this.dispatchEvent(new (0, $3822396dcb007337$export$2e2bcd8739ae039)((0, $c12eb239491bfe04$export$2e2bcd8739ae039).MOVESTART, this, previousFrameState));
                            this.previousExtent_ = (0, $e86e0aa087890eb8$export$3e2152b047719fa1)(this.previousExtent_);
                        }
                    }
                    var idle = this.previousExtent_ && !frameState.viewHints[(0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).ANIMATING] && !frameState.viewHints[(0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).INTERACTING] && !(0, $e86e0aa087890eb8$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
                    if (idle) {
                        this.dispatchEvent(new (0, $3822396dcb007337$export$2e2bcd8739ae039)((0, $c12eb239491bfe04$export$2e2bcd8739ae039).MOVEEND, this, frameState));
                        (0, $e86e0aa087890eb8$export$9cd59f9826255e47)(frameState.extent, this.previousExtent_);
                    }
                }
                this.dispatchEvent(new (0, $3822396dcb007337$export$2e2bcd8739ae039)((0, $c12eb239491bfe04$export$2e2bcd8739ae039).POSTRENDER, this, frameState));
                this.renderComplete_ = this.hasListener((0, $c12eb239491bfe04$export$2e2bcd8739ae039).LOADSTART) || this.hasListener((0, $c12eb239491bfe04$export$2e2bcd8739ae039).LOADEND) || this.hasListener((0, $b1aa6e3366c76eef$export$2e2bcd8739ae039).RENDERCOMPLETE) ? !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady() : undefined;
                if (!this.postRenderTimeoutHandle_) this.postRenderTimeoutHandle_ = setTimeout(function() {
                    _this.postRenderTimeoutHandle_ = undefined;
                    _this.handlePostRender();
                }, 0);
            }
        },
        {
            /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */ key: "setLayerGroup",
            value: function setLayerGroup(layerGroup) {
                var oldLayerGroup = this.getLayerGroup();
                if (oldLayerGroup) this.handleLayerRemove_(new (0, $27fbb3acd6648829$export$2f5ff21d758d25a7)("removelayer", oldLayerGroup));
                this.set((0, $577f7939e4cd625e$export$2e2bcd8739ae039).LAYERGROUP, layerGroup);
            }
        },
        {
            /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ key: "setSize",
            value: function setSize(size) {
                this.set((0, $577f7939e4cd625e$export$2e2bcd8739ae039).SIZE, size);
            }
        },
        {
            /**
   * Set the target element to render this map into.
   * @param {HTMLElement|string} [target] The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */ key: "setTarget",
            value: function setTarget(target) {
                this.set((0, $577f7939e4cd625e$export$2e2bcd8739ae039).TARGET, target);
            }
        },
        {
            /**
   * Set the view for this map.
   * @param {View|Promise<import("./View.js").ViewOptions>} view The view that controls this map.
   * It is also possible to pass a promise that resolves to options for constructing a view.  This
   * alternative allows view properties to be resolved by sources or other components that load
   * view-related metadata.
   * @observable
   * @api
   */ key: "setView",
            value: function setView(view) {
                if (!view || view instanceof (0, $2d5eedb534d9ecb2$export$2e2bcd8739ae039)) {
                    this.set((0, $577f7939e4cd625e$export$2e2bcd8739ae039).VIEW, view);
                    return;
                }
                this.set((0, $577f7939e4cd625e$export$2e2bcd8739ae039).VIEW, new (0, $2d5eedb534d9ecb2$export$2e2bcd8739ae039)());
                var map = this;
                view.then(function(viewOptions) {
                    map.setView(new (0, $2d5eedb534d9ecb2$export$2e2bcd8739ae039)(viewOptions));
                });
            }
        },
        {
            /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */ key: "updateSize",
            value: function updateSize() {
                var targetElement = this.getTargetElement();
                var size = undefined;
                if (targetElement) {
                    var computedStyle = getComputedStyle(targetElement);
                    var width = targetElement.offsetWidth - parseFloat(computedStyle["borderLeftWidth"]) - parseFloat(computedStyle["paddingLeft"]) - parseFloat(computedStyle["paddingRight"]) - parseFloat(computedStyle["borderRightWidth"]);
                    var height = targetElement.offsetHeight - parseFloat(computedStyle["borderTopWidth"]) - parseFloat(computedStyle["paddingTop"]) - parseFloat(computedStyle["paddingBottom"]) - parseFloat(computedStyle["borderBottomWidth"]);
                    if (!isNaN(width) && !isNaN(height)) {
                        size = [
                            width,
                            height
                        ];
                        if (!(0, $9fd3f8f53b8c7a01$export$622c471beb1693c7)(size) && !!(targetElement.offsetWidth || targetElement.offsetHeight || targetElement.getClientRects().length)) (0, $ca13f81415d41843$export$c106dd0671a0fc2d)("No map visible because the map container's width or height are 0.");
                    }
                }
                var oldSize = this.getSize();
                if (size && (!oldSize || !(0, $edee3659e50a93f4$export$e9bab7fafb253603)(size, oldSize))) {
                    this.setSize(size);
                    this.updateViewportSize_(size);
                }
            }
        },
        {
            /**
   * Recomputes the viewport size and save it on the view object (if any)
   * @param {import("./size.js").Size|undefined} size The size.
   * @private
   */ key: "updateViewportSize_",
            value: function updateViewportSize_(size) {
                var view = this.getView();
                if (view) view.setViewportSize(size);
            }
        }
    ]);
    return Map;
}((0, $7a8d25d40aa0de7f$export$2e2bcd8739ae039));
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */ function $11907e309f89aeba$var$createOptionsInternal(options) {
    /**
   * @type {HTMLElement|Document}
   */ var keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) keyboardEventTarget = typeof options.keyboardEventTarget === "string" ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
    /**
   * @type {Object<string, *>}
   */ var values = {};
    var layerGroup = options.layers && typeof /** @type {?} */ options.layers.getLayers === "function" ? /** @type {LayerGroup} */ options.layers : new (0, $27fbb3acd6648829$export$2e2bcd8739ae039)({
        layers: /** @type {Collection<import("./layer/Base.js").default>|Array<import("./layer/Base.js").default>} */ options.layers
    });
    values[(0, $577f7939e4cd625e$export$2e2bcd8739ae039).LAYERGROUP] = layerGroup;
    values[(0, $577f7939e4cd625e$export$2e2bcd8739ae039).TARGET] = options.target;
    values[(0, $577f7939e4cd625e$export$2e2bcd8739ae039).VIEW] = options.view instanceof (0, $2d5eedb534d9ecb2$export$2e2bcd8739ae039) ? options.view : new (0, $2d5eedb534d9ecb2$export$2e2bcd8739ae039)();
    /** @type {Collection<import("./control/Control.js").default>} */ var controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) controls = new (0, $4586ff11f2e741e8$export$2e2bcd8739ae039)(options.controls.slice());
        else {
            (0, $100b4414e338a711$export$a7a9523472993e97)(typeof /** @type {?} */ options.controls.getArray === "function", "Expected `controls` to be an array or an `ol/Collection.js`");
            controls = options.controls;
        }
    }
    /** @type {Collection<import("./interaction/Interaction").default>} */ var interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) interactions = new (0, $4586ff11f2e741e8$export$2e2bcd8739ae039)(options.interactions.slice());
        else {
            (0, $100b4414e338a711$export$a7a9523472993e97)(typeof /** @type {?} */ options.interactions.getArray === "function", "Expected `interactions` to be an array or an `ol/Collection.js`");
            interactions = options.interactions;
        }
    }
    /** @type {Collection<import("./Overlay.js").default>} */ var overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) overlays = new (0, $4586ff11f2e741e8$export$2e2bcd8739ae039)(options.overlays.slice());
        else {
            (0, $100b4414e338a711$export$a7a9523472993e97)(typeof /** @type {?} */ options.overlays.getArray === "function", "Expected `overlays` to be an array or an `ol/Collection.js`");
            overlays = options.overlays;
        }
    } else overlays = new (0, $4586ff11f2e741e8$export$2e2bcd8739ae039)();
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values
    };
}
var $11907e309f89aeba$export$2e2bcd8739ae039 = $11907e309f89aeba$var$Map;



/**
 * @module ol/control/ZoomSlider
 */ 
var $lyFcw = parcelRequire("lyFcw");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");








/**
 * The enum for available directions.
 *
 * @enum {number}
 */ var $d3d972a304380ffd$var$Direction = {
    VERTICAL: 0,
    HORIZONTAL: 1
};
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-zoomslider'] CSS class name.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control
 * should be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A slider type of control for zooming.
 *
 * Example:
 *
 *     map.addControl(new ZoomSlider());
 *
 * @api
 */ var $d3d972a304380ffd$var$ZoomSlider = /*#__PURE__*/ function(Control) {
    "use strict";
    (0, $kcqLc._)(ZoomSlider, Control);
    var _super = (0, $4jYWU._)(ZoomSlider);
    function ZoomSlider(options) {
        (0, $5sFFs._)(this, ZoomSlider);
        var _this;
        options = options ? options : {};
        _this = _super.call(this, {
            target: options.target,
            element: document.createElement("div"),
            render: options.render
        });
        /**
     * @type {!Array<import("../events.js").EventsKey>}
     * @private
     */ _this.dragListenerKeys_ = [];
        /**
     * Will hold the current resolution of the view.
     *
     * @type {number|undefined}
     * @private
     */ _this.currentResolution_ = undefined;
        /**
     * The direction of the slider. Will be determined from actual display of the
     * container and defaults to Direction.VERTICAL.
     *
     * @type {Direction}
     * @private
     */ _this.direction_ = $d3d972a304380ffd$var$Direction.VERTICAL;
        /**
     * @type {boolean}
     * @private
     */ _this.dragging_;
        /**
     * @type {number}
     * @private
     */ _this.heightLimit_ = 0;
        /**
     * @type {number}
     * @private
     */ _this.widthLimit_ = 0;
        /**
     * @type {number|undefined}
     * @private
     */ _this.startX_;
        /**
     * @type {number|undefined}
     * @private
     */ _this.startY_;
        /**
     * The calculated thumb size (border box plus margins).  Set when initSlider_
     * is called.
     * @type {import("../size.js").Size}
     * @private
     */ _this.thumbSize_ = null;
        /**
     * Whether the slider is initialized.
     * @type {boolean}
     * @private
     */ _this.sliderInitialized_ = false;
        /**
     * @type {number}
     * @private
     */ _this.duration_ = options.duration !== undefined ? options.duration : 200;
        var className = options.className !== undefined ? options.className : "ol-zoomslider";
        var thumbElement = document.createElement("button");
        thumbElement.setAttribute("type", "button");
        thumbElement.className = className + "-thumb " + (0, $51bd5289664fd4d3$export$1afde3d6e16a7b29);
        var containerElement = _this.element;
        containerElement.className = className + " " + (0, $51bd5289664fd4d3$export$1afde3d6e16a7b29) + " " + (0, $51bd5289664fd4d3$export$4d4f8be70b656192);
        containerElement.appendChild(thumbElement);
        containerElement.addEventListener((0, $b75a92c87c1246de$export$2e2bcd8739ae039).POINTERDOWN, _this.handleDraggerStart_.bind((0, $lyFcw._)(_this)), false);
        containerElement.addEventListener((0, $b75a92c87c1246de$export$2e2bcd8739ae039).POINTERMOVE, _this.handleDraggerDrag_.bind((0, $lyFcw._)(_this)), false);
        containerElement.addEventListener((0, $b75a92c87c1246de$export$2e2bcd8739ae039).POINTERUP, _this.handleDraggerEnd_.bind((0, $lyFcw._)(_this)), false);
        containerElement.addEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CLICK, _this.handleContainerClick_.bind((0, $lyFcw._)(_this)), false);
        thumbElement.addEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CLICK, (0, $1a4702ad15857f9a$export$51134cce184326b9), false);
        return _this;
    }
    (0, $8O2fV._)(ZoomSlider, [
        {
            /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ key: "setMap",
            value: function setMap(map) {
                (0, $404BM._)((0, $cEF31._)(ZoomSlider.prototype), "setMap", this).call(this, map);
                if (map) map.render();
            }
        },
        {
            /**
   * Initializes the slider element. This will determine and set this controls
   * direction_ and also constrain the dragging of the thumb to always be within
   * the bounds of the container.
   *
   * @return {boolean} Initialization successful
   * @private
   */ key: "initSlider_",
            value: function initSlider_() {
                var container = this.element;
                var containerWidth = container.offsetWidth;
                var containerHeight = container.offsetHeight;
                if (containerWidth === 0 && containerHeight === 0) return this.sliderInitialized_ = false;
                var containerStyle = getComputedStyle(container);
                containerWidth -= parseFloat(containerStyle["paddingRight"]) + parseFloat(containerStyle["paddingLeft"]);
                containerHeight -= parseFloat(containerStyle["paddingTop"]) + parseFloat(containerStyle["paddingBottom"]);
                var thumb = /** @type {HTMLElement} */ container.firstElementChild;
                var thumbStyle = getComputedStyle(thumb);
                var thumbWidth = thumb.offsetWidth + parseFloat(thumbStyle["marginRight"]) + parseFloat(thumbStyle["marginLeft"]);
                var thumbHeight = thumb.offsetHeight + parseFloat(thumbStyle["marginTop"]) + parseFloat(thumbStyle["marginBottom"]);
                this.thumbSize_ = [
                    thumbWidth,
                    thumbHeight
                ];
                if (containerWidth > containerHeight) {
                    this.direction_ = $d3d972a304380ffd$var$Direction.HORIZONTAL;
                    this.widthLimit_ = containerWidth - thumbWidth;
                } else {
                    this.direction_ = $d3d972a304380ffd$var$Direction.VERTICAL;
                    this.heightLimit_ = containerHeight - thumbHeight;
                }
                return this.sliderInitialized_ = true;
            }
        },
        {
            /**
   * @param {PointerEvent} event The browser event to handle.
   * @private
   */ key: "handleContainerClick_",
            value: function handleContainerClick_(event) {
                var view = this.getMap().getView();
                var relativePosition = this.getRelativePosition_(event.offsetX - this.thumbSize_[0] / 2, event.offsetY - this.thumbSize_[1] / 2);
                var resolution = this.getResolutionForPosition_(relativePosition);
                var zoom = view.getConstrainedZoom(view.getZoomForResolution(resolution));
                view.animateInternal({
                    zoom: zoom,
                    duration: this.duration_,
                    easing: (0, $eba911dc905f0f7f$export$57636bb43b1ccbb0)
                });
            }
        },
        {
            /**
   * Handle dragger start events.
   * @param {PointerEvent} event The drag event.
   * @private
   */ key: "handleDraggerStart_",
            value: function handleDraggerStart_(event) {
                if (!this.dragging_ && event.target === this.element.firstElementChild) {
                    var element = /** @type {HTMLElement} */ this.element.firstElementChild;
                    this.getMap().getView().beginInteraction();
                    this.startX_ = event.clientX - parseFloat(element.style.left);
                    this.startY_ = event.clientY - parseFloat(element.style.top);
                    this.dragging_ = true;
                    if (this.dragListenerKeys_.length === 0) {
                        var drag = this.handleDraggerDrag_;
                        var end = this.handleDraggerEnd_;
                        var doc = this.getMap().getOwnerDocument();
                        this.dragListenerKeys_.push((0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(doc, (0, $b75a92c87c1246de$export$2e2bcd8739ae039).POINTERMOVE, drag, this), (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(doc, (0, $b75a92c87c1246de$export$2e2bcd8739ae039).POINTERUP, end, this));
                    }
                }
            }
        },
        {
            /**
   * Handle dragger drag events.
   *
   * @param {PointerEvent} event The drag event.
   * @private
   */ key: "handleDraggerDrag_",
            value: function handleDraggerDrag_(event) {
                if (this.dragging_) {
                    var deltaX = event.clientX - this.startX_;
                    var deltaY = event.clientY - this.startY_;
                    var relativePosition = this.getRelativePosition_(deltaX, deltaY);
                    this.currentResolution_ = this.getResolutionForPosition_(relativePosition);
                    this.getMap().getView().setResolution(this.currentResolution_);
                }
            }
        },
        {
            /**
   * Handle dragger end events.
   * @param {PointerEvent} event The drag event.
   * @private
   */ key: "handleDraggerEnd_",
            value: function handleDraggerEnd_(event) {
                if (this.dragging_) {
                    var view = this.getMap().getView();
                    view.endInteraction();
                    this.dragging_ = false;
                    this.startX_ = undefined;
                    this.startY_ = undefined;
                    this.dragListenerKeys_.forEach((0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921));
                    this.dragListenerKeys_.length = 0;
                }
            }
        },
        {
            /**
   * Positions the thumb inside its container according to the given resolution.
   *
   * @param {number} res The res.
   * @private
   */ key: "setThumbPosition_",
            value: function setThumbPosition_(res) {
                var position = this.getPositionForResolution_(res);
                var thumb = /** @type {HTMLElement} */ this.element.firstElementChild;
                if (this.direction_ == $d3d972a304380ffd$var$Direction.HORIZONTAL) thumb.style.left = this.widthLimit_ * position + "px";
                else thumb.style.top = this.heightLimit_ * position + "px";
            }
        },
        {
            /**
   * Calculates the relative position of the thumb given x and y offsets.  The
   * relative position scales from 0 to 1.  The x and y offsets are assumed to be
   * in pixel units within the dragger limits.
   *
   * @param {number} x Pixel position relative to the left of the slider.
   * @param {number} y Pixel position relative to the top of the slider.
   * @return {number} The relative position of the thumb.
   * @private
   */ key: "getRelativePosition_",
            value: function getRelativePosition_(x, y) {
                var amount;
                if (this.direction_ === $d3d972a304380ffd$var$Direction.HORIZONTAL) amount = x / this.widthLimit_;
                else amount = y / this.heightLimit_;
                return (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(amount, 0, 1);
            }
        },
        {
            /**
   * Calculates the corresponding resolution of the thumb given its relative
   * position (where 0 is the minimum and 1 is the maximum).
   *
   * @param {number} position The relative position of the thumb.
   * @return {number} The corresponding resolution.
   * @private
   */ key: "getResolutionForPosition_",
            value: function getResolutionForPosition_(position) {
                var fn = this.getMap().getView().getResolutionForValueFunction();
                return fn(1 - position);
            }
        },
        {
            /**
   * Determines the relative position of the slider for the given resolution.  A
   * relative position of 0 corresponds to the minimum view resolution.  A
   * relative position of 1 corresponds to the maximum view resolution.
   *
   * @param {number} res The resolution.
   * @return {number} The relative position value (between 0 and 1).
   * @private
   */ key: "getPositionForResolution_",
            value: function getPositionForResolution_(res) {
                var fn = this.getMap().getView().getValueForResolutionFunction();
                return (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(1 - fn(res), 0, 1);
            }
        },
        {
            /**
   * Update the zoomslider element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ key: "render",
            value: function render(mapEvent) {
                if (!mapEvent.frameState) return;
                if (!this.sliderInitialized_ && !this.initSlider_()) return;
                var res = mapEvent.frameState.viewState.resolution;
                this.currentResolution_ = res;
                this.setThumbPosition_(res);
            }
        }
    ]);
    return ZoomSlider;
}((0, $7e80cc7a31bf3554$export$2e2bcd8739ae039));
var $d3d972a304380ffd$export$2e2bcd8739ae039 = $d3d972a304380ffd$var$ZoomSlider;


/**
 * @module ol/layer/Tile
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/layer/BaseTile
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");

/**
 * @module ol/layer/TileProperty
 */ /**
 * @enum {string}
 */ var $e1c95a396f035cdc$export$2e2bcd8739ae039 = {
    PRELOAD: "preload",
    USE_INTERIM_TILES_ON_ERROR: "useInterimTilesOnError"
};


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|
 *   import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType").LayerRenderEventTypes, Return>} BaseTileLayerOnSignature
 */ /**
 * @template {import("../source/Tile.js").default} TileSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {TileSourceType} [source] Source for this layer.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {boolean} [useInterimTilesOnError=true] Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<TileSourceType, RendererType>}
 * @api
 */ var $9dfc33056102de08$var$BaseTileLayer = /*#__PURE__*/ function(Layer) {
    "use strict";
    (0, $kcqLc._)(BaseTileLayer, Layer);
    var _super = (0, $4jYWU._)(BaseTileLayer);
    function BaseTileLayer(options) {
        (0, $5sFFs._)(this, BaseTileLayer);
        var _this;
        options = options ? options : {};
        var baseOptions = Object.assign({}, options);
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        _this = _super.call(this, baseOptions);
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ _this.on;
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ _this.once;
        /***
     * @type {BaseTileLayerOnSignature<void>}
     */ _this.un;
        _this.setPreload(options.preload !== undefined ? options.preload : 0);
        _this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
        return _this;
    }
    (0, $8O2fV._)(BaseTileLayer, [
        {
            /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */ key: "getPreload",
            value: function getPreload() {
                return /** @type {number} */ this.get((0, $e1c95a396f035cdc$export$2e2bcd8739ae039).PRELOAD);
            }
        },
        {
            /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */ key: "setPreload",
            value: function setPreload(preload) {
                this.set((0, $e1c95a396f035cdc$export$2e2bcd8739ae039).PRELOAD, preload);
            }
        },
        {
            /**
   * Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */ key: "getUseInterimTilesOnError",
            value: function getUseInterimTilesOnError() {
                return /** @type {boolean} */ this.get((0, $e1c95a396f035cdc$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR);
            }
        },
        {
            /**
   * Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */ key: "setUseInterimTilesOnError",
            value: function setUseInterimTilesOnError(useInterimTilesOnError) {
                this.set((0, $e1c95a396f035cdc$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
            }
        },
        {
            /**
   * Get data for a pixel location.  The return type depends on the source data.  For image tiles,
   * a four element RGBA array will be returned.  For data tiles, the array length will match the
   * number of bands in the dataset.  For requests outside the layer extent, `null` will be returned.
   * Data for a image tiles can only be retrieved if the source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   */ key: "getData",
            value: function getData(pixel) {
                return (0, $404BM._)((0, $cEF31._)(BaseTileLayer.prototype), "getData", this).call(this, pixel);
            }
        }
    ]);
    return BaseTileLayer;
}((0, $45f7b7b1b4f025e5$export$2e2bcd8739ae039));
var $9dfc33056102de08$export$2e2bcd8739ae039 = $9dfc33056102de08$var$BaseTileLayer;


/**
 * @module ol/renderer/canvas/TileLayer
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/renderer/canvas/Layer
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/renderer/Layer
 */ 
var $lyFcw = parcelRequire("lyFcw");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");

/**
 * @module ol/ImageState
 */ /**
 * @enum {number}
 */ var $6d1d6830cef5bca2$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4
};




/**
 * @template {import("../layer/Layer.js").default} LayerType
 */ var $43fe14449f792e4d$var$LayerRenderer = /*#__PURE__*/ function(Observable) {
    "use strict";
    (0, $kcqLc._)(LayerRenderer, Observable);
    var _super = (0, $4jYWU._)(LayerRenderer);
    function LayerRenderer(layer) {
        (0, $5sFFs._)(this, LayerRenderer);
        var _this;
        _this = _super.call(this);
        /**
     * The renderer is initialized and ready to render.
     * @type {boolean}
     */ _this.ready = true;
        /** @private */ _this.boundHandleImageChange_ = _this.handleImageChange_.bind((0, $lyFcw._)(_this));
        /**
     * @protected
     * @type {LayerType}
     */ _this.layer_ = layer;
        /**
     * @type {import("../render/canvas/ExecutorGroup").default}
     */ _this.declutterExecutorGroup = null;
        return _this;
    }
    (0, $8O2fV._)(LayerRenderer, [
        {
            /**
   * Asynchronous layer level hit detection.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ key: "getFeatures",
            value: function getFeatures(pixel) {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ key: "getData",
            value: function getData(pixel) {
                return null;
            }
        },
        {
            /**
   * Determine whether render should be called.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ key: "prepareFrame",
            value: function prepareFrame(frameState) {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Render the layer.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement|null} The rendered element.
   */ key: "renderFrame",
            value: function renderFrame(frameState, target) {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @param {number} zoom Zoom level.
   * @param {import("../Tile.js").default} tile Tile.
   * @return {boolean|void} If `false`, the tile will not be considered loaded.
   */ key: "loadedTileCallback",
            value: function loadedTileCallback(tiles, zoom, tile) {
                if (!tiles[zoom]) tiles[zoom] = {};
                tiles[zoom][tile.tileCoord.toString()] = tile;
                return undefined;
            }
        },
        {
            /**
   * Create a function that adds loaded tiles to the tile lookup.
   * @param {import("../source/Tile.js").default} source Tile source.
   * @param {import("../proj/Projection.js").default} projection Projection of the tiles.
   * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @return {function(number, import("../TileRange.js").default):boolean} A function that can be
   *     called with a zoom level and a tile range to add loaded tiles to the lookup.
   * @protected
   */ key: "createLoadedTileFinder",
            value: function createLoadedTileFinder(source, projection, tiles) {
                var _this = this;
                return(/**
       * @param {number} zoom Zoom level.
       * @param {import("../TileRange.js").default} tileRange Tile range.
       * @return {boolean} The tile range is fully loaded.
       */ function(zoom, tileRange) {
                    var callback = _this.loadedTileCallback.bind(_this, tiles, zoom);
                    return source.forEachLoadedTile(projection, zoom, tileRange, callback);
                });
            }
        },
        {
            /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */ key: "forEachFeatureAtCoordinate",
            value: function forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
                return undefined;
            }
        },
        {
            /**
   * @return {LayerType} Layer.
   */ key: "getLayer",
            value: function getLayer() {
                return this.layer_;
            }
        },
        {
            /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @abstract
   */ key: "handleFontsChanged",
            value: function handleFontsChanged() {}
        },
        {
            /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */ key: "handleImageChange_",
            value: function handleImageChange_(event) {
                var image = /** @type {import("../Image.js").default} */ event.target;
                if (image.getState() === (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED || image.getState() === (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).ERROR) this.renderIfReadyAndVisible();
            }
        },
        {
            /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../Image.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */ key: "loadImage",
            value: function loadImage(image) {
                var imageState = image.getState();
                if (imageState != (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED && imageState != (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).ERROR) image.addEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE, this.boundHandleImageChange_);
                if (imageState == (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).IDLE) {
                    image.load();
                    imageState = image.getState();
                }
                return imageState == (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED;
            }
        },
        {
            /**
   * @protected
   */ key: "renderIfReadyAndVisible",
            value: function renderIfReadyAndVisible() {
                var layer = this.getLayer();
                if (layer && layer.getVisible() && layer.getSourceState() === "ready") layer.changed();
            }
        },
        {
            /**
   * Clean up.
   */ key: "disposeInternal",
            value: function disposeInternal() {
                delete this.layer_;
                (0, $404BM._)((0, $cEF31._)(LayerRenderer.prototype), "disposeInternal", this).call(this);
            }
        }
    ]);
    return LayerRenderer;
}((0, $ce1a65fd3436dc4f$export$2e2bcd8739ae039));
var $43fe14449f792e4d$export$2e2bcd8739ae039 = $43fe14449f792e4d$var$LayerRenderer;









var $633e710cc85fca5f$export$a166f0857c555517 = [];
/**
 * @type {CanvasRenderingContext2D}
 */ var $633e710cc85fca5f$var$pixelContext = null;
function $633e710cc85fca5f$var$createPixelContext() {
    $633e710cc85fca5f$var$pixelContext = (0, $e000035bb4c81589$export$9e05d10eae75c464)(1, 1, undefined, {
        willReadFrequently: true
    });
}
/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 * @extends {LayerRenderer<LayerType>}
 */ var $633e710cc85fca5f$var$CanvasLayerRenderer = /*#__PURE__*/ function(LayerRenderer) {
    "use strict";
    (0, $kcqLc._)(CanvasLayerRenderer, LayerRenderer);
    var _super = (0, $4jYWU._)(CanvasLayerRenderer);
    function CanvasLayerRenderer(layer) {
        (0, $5sFFs._)(this, CanvasLayerRenderer);
        var _this;
        _this = _super.call(this, layer);
        /**
     * @protected
     * @type {HTMLElement}
     */ _this.container = null;
        /**
     * @protected
     * @type {number}
     */ _this.renderedResolution;
        /**
     * A temporary transform.  The values in this transform should only be used in a
     * function that sets the values.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ _this.tempTransform = (0, $afa6393b3817702c$export$185802fd694ee1f5)();
        /**
     * The transform for rendered pixels to viewport CSS pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ _this.pixelTransform = (0, $afa6393b3817702c$export$185802fd694ee1f5)();
        /**
     * The transform for viewport CSS pixels to rendered pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ _this.inversePixelTransform = (0, $afa6393b3817702c$export$185802fd694ee1f5)();
        /**
     * @type {CanvasRenderingContext2D}
     */ _this.context = null;
        /**
     * @type {boolean}
     */ _this.containerReused = false;
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ _this.pixelContext_ = null;
        /**
     * @protected
     * @type {import("../../Map.js").FrameState|null}
     */ _this.frameState = null;
        return _this;
    }
    (0, $8O2fV._)(CanvasLayerRenderer, [
        {
            /**
   * @param {import('../../DataTile.js').ImageLike} image Image.
   * @param {number} col The column index.
   * @param {number} row The row index.
   * @return {Uint8ClampedArray|null} The image data.
   */ key: "getImageData",
            value: function getImageData(image, col, row) {
                if (!$633e710cc85fca5f$var$pixelContext) $633e710cc85fca5f$var$createPixelContext();
                $633e710cc85fca5f$var$pixelContext.clearRect(0, 0, 1, 1);
                var data;
                try {
                    $633e710cc85fca5f$var$pixelContext.drawImage(image, col, row, 1, 1, 0, 0, 1, 1);
                    data = $633e710cc85fca5f$var$pixelContext.getImageData(0, 0, 1, 1).data;
                } catch (err) {
                    $633e710cc85fca5f$var$pixelContext = null;
                    return null;
                }
                return data;
            }
        },
        {
            /**
   * @param {import('../../Map.js').FrameState} frameState Frame state.
   * @return {string} Background color.
   */ key: "getBackground",
            value: function getBackground(frameState) {
                var layer = this.getLayer();
                var background = layer.getBackground();
                if (typeof background === "function") background = background(frameState.viewState.resolution);
                return background || undefined;
            }
        },
        {
            /**
   * Get a rendering container from an existing target, if compatible.
   * @param {HTMLElement} target Potential render target.
   * @param {string} transform CSS Transform.
   * @param {string} [backgroundColor] Background color.
   */ key: "useContainer",
            value: function useContainer(target, transform, backgroundColor) {
                var layerClassName = this.getLayer().getClassName();
                var container, context;
                if (target && target.className === layerClassName && (!backgroundColor || target && target.style.backgroundColor && (0, $edee3659e50a93f4$export$e9bab7fafb253603)((0, $03ff7455ee88c2e9$export$75093a47a9fa838d)(target.style.backgroundColor), (0, $03ff7455ee88c2e9$export$75093a47a9fa838d)(backgroundColor)))) {
                    var canvas = target.firstElementChild;
                    if (canvas instanceof HTMLCanvasElement) context = canvas.getContext("2d");
                }
                if (context && context.canvas.style.transform === transform) {
                    // Container of the previous layer renderer can be used.
                    this.container = target;
                    this.context = context;
                    this.containerReused = true;
                } else if (this.containerReused) {
                    // Previously reused container cannot be used any more.
                    this.container = null;
                    this.context = null;
                    this.containerReused = false;
                } else if (this.container) this.container.style.backgroundColor = null;
                if (!this.container) {
                    container = document.createElement("div");
                    container.className = layerClassName;
                    var style = container.style;
                    style.position = "absolute";
                    style.width = "100%";
                    style.height = "100%";
                    context = (0, $e000035bb4c81589$export$9e05d10eae75c464)();
                    var canvas1 = context.canvas;
                    container.appendChild(canvas1);
                    style = canvas1.style;
                    style.position = "absolute";
                    style.left = "0";
                    style.transformOrigin = "top left";
                    this.container = container;
                    this.context = context;
                }
                if (!this.containerReused && backgroundColor && !this.container.style.backgroundColor) this.container.style.backgroundColor = backgroundColor;
            }
        },
        {
            /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */ key: "clipUnrotated",
            value: function clipUnrotated(context, frameState, extent) {
                var topLeft = (0, $e86e0aa087890eb8$export$cb1538b07e6964ff)(extent);
                var topRight = (0, $e86e0aa087890eb8$export$b84fa077c8b05295)(extent);
                var bottomRight = (0, $e86e0aa087890eb8$export$e77c1cf70445e168)(extent);
                var bottomLeft = (0, $e86e0aa087890eb8$export$8d09f5e2e1bf560d)(extent);
                (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topLeft);
                (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topRight);
                (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomRight);
                (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomLeft);
                var inverted = this.inversePixelTransform;
                (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(inverted, topLeft);
                (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(inverted, topRight);
                (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(inverted, bottomRight);
                (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(inverted, bottomLeft);
                context.save();
                context.beginPath();
                context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
                context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
                context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
                context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
                context.clip();
            }
        },
        {
            /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */ key: "dispatchRenderEvent_",
            value: function dispatchRenderEvent_(type, context, frameState) {
                var layer = this.getLayer();
                if (layer.hasListener(type)) {
                    var event = new (0, $7739959762426842$export$2e2bcd8739ae039)(type, this.inversePixelTransform, frameState, context);
                    layer.dispatchEvent(event);
                }
            }
        },
        {
            /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ key: "preRender",
            value: function preRender(context, frameState) {
                this.frameState = frameState;
                this.dispatchRenderEvent_((0, $b1aa6e3366c76eef$export$2e2bcd8739ae039).PRERENDER, context, frameState);
            }
        },
        {
            /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ key: "postRender",
            value: function postRender(context, frameState) {
                this.dispatchRenderEvent_((0, $b1aa6e3366c76eef$export$2e2bcd8739ae039).POSTRENDER, context, frameState);
            }
        },
        {
            /**
   * Creates a transform for rendering to an element that will be rotated after rendering.
   * @param {import("../../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} width Width of the rendered element (in pixels).
   * @param {number} height Height of the rendered element (in pixels).
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */ key: "getRenderTransform",
            value: function getRenderTransform(center, resolution, rotation, pixelRatio, width, height, offsetX) {
                var dx1 = width / 2;
                var dy1 = height / 2;
                var sx = pixelRatio / resolution;
                var sy = -sx;
                var dx2 = -center[0] + offsetX;
                var dy2 = -center[1];
                return (0, $afa6393b3817702c$export$f672e0b6f7222cd7)(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
            }
        },
        {
            /**
   * Clean up.
   */ key: "disposeInternal",
            value: function disposeInternal() {
                delete this.frameState;
                (0, $404BM._)((0, $cEF31._)(CanvasLayerRenderer.prototype), "disposeInternal", this).call(this);
            }
        }
    ]);
    return CanvasLayerRenderer;
}((0, $43fe14449f792e4d$export$2e2bcd8739ae039));
var $633e710cc85fca5f$export$2e2bcd8739ae039 = $633e710cc85fca5f$var$CanvasLayerRenderer;


/**
 * @module ol/ImageTile
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/Tile
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $aBSBL = parcelRequire("aBSBL");

var $4jYWU = parcelRequire("4jYWU");





/**
 * A function that takes an {@link module:ol/Tile~Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState.js';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   const xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     const data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string): void} LoadFunction
 * @api
 */ /**
 * {@link module:ol/source/Tile~TileSource} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes an {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection~Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @api
 */ /**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */ var $136a2fdcc54b2e52$var$Tile = /*#__PURE__*/ function(EventTarget) {
    "use strict";
    (0, $kcqLc._)(Tile, EventTarget);
    var _super = (0, $4jYWU._)(Tile);
    function Tile(tileCoord, state, options) {
        (0, $5sFFs._)(this, Tile);
        var _this;
        _this = _super.call(this);
        options = options ? options : {};
        /**
     * @type {import("./tilecoord.js").TileCoord}
     */ _this.tileCoord = tileCoord;
        /**
     * @protected
     * @type {import("./TileState.js").default}
     */ _this.state = state;
        /**
     * An "interim" tile for this tile. The interim tile may be used while this
     * one is loading, for "smooth" transitions when changing params/dimensions
     * on the source.
     * @type {Tile|null}
     */ _this.interimTile = null;
        /**
     * A key assigned to the tile. This is used by the tile source to determine
     * if this tile can effectively be used, or if a new tile should be created
     * and this one be used as an interim tile for this new tile.
     * @type {string}
     */ _this.key = "";
        /**
     * The duration for the opacity transition.
     * @type {number}
     */ _this.transition_ = options.transition === undefined ? 250 : options.transition;
        /**
     * Lookup of start times for rendering transitions.  If the start time is
     * equal to -1, the transition is complete.
     * @type {Object<string, number>}
     */ _this.transitionStarts_ = {};
        /**
     * @type {boolean}
     */ _this.interpolate = !!options.interpolate;
        return _this;
    }
    (0, $8O2fV._)(Tile, [
        {
            /**
   * @protected
   */ key: "changed",
            value: function changed() {
                this.dispatchEvent((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE);
            }
        },
        {
            /**
   * Called by the tile cache when the tile is removed from the cache due to expiry
   */ key: "release",
            value: function release() {
                if (this.state === (0, $4b81523a11dd716e$export$2e2bcd8739ae039).ERROR) // to remove the `change` listener on this tile in `ol/TileQueue#handleTileChange`
                this.setState((0, $4b81523a11dd716e$export$2e2bcd8739ae039).EMPTY);
            }
        },
        {
            /**
   * @return {string} Key.
   */ key: "getKey",
            value: function getKey() {
                return this.key + "/" + this.tileCoord;
            }
        },
        {
            /**
   * Get the interim tile most suitable for rendering using the chain of interim
   * tiles. This corresponds to the  most recent tile that has been loaded, if no
   * such tile exists, the original tile is returned.
   * @return {!Tile} Best tile for rendering.
   */ key: "getInterimTile",
            value: function getInterimTile() {
                var tile = this.interimTile;
                if (!tile) //empty chain
                return this;
                // find the first loaded tile and return it. Since the chain is sorted in
                // decreasing order of creation time, there is no need to search the remainder
                // of the list (all those tiles correspond to older requests and will be
                // cleaned up by refreshInterimChain)
                do {
                    if (tile.getState() == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADED) {
                        // Show tile immediately instead of fading it in after loading, because
                        // the interim tile is in place already
                        this.transition_ = 0;
                        return tile;
                    }
                    tile = tile.interimTile;
                }while (tile);
                // we can not find a better tile
                return this;
            }
        },
        {
            /**
   * Goes through the chain of interim tiles and discards sections of the chain
   * that are no longer relevant.
   */ key: "refreshInterimChain",
            value: function refreshInterimChain() {
                var tile = this.interimTile;
                if (!tile) return;
                /** @type {Tile} */ var prev = this;
                do {
                    if (tile.getState() == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADED) {
                        //we have a loaded tile, we can discard the rest of the list
                        //we would could abort any LOADING tile request
                        //older than this tile (i.e. any LOADING tile following this entry in the chain)
                        tile.interimTile = null;
                        break;
                    }
                    if (tile.getState() == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADING) //keep this LOADING tile any loaded tiles later in the chain are
                    //older than this tile, so we're still interested in the request
                    prev = tile;
                    else if (tile.getState() == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).IDLE) //the head of the list is the most current tile, we don't need
                    //to start any other requests for this chain
                    prev.interimTile = tile.interimTile;
                    else prev = tile;
                    tile = prev.interimTile;
                }while (tile);
            }
        },
        {
            /**
   * Get the tile coordinate for this tile.
   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
   * @api
   */ key: "getTileCoord",
            value: function getTileCoord() {
                return this.tileCoord;
            }
        },
        {
            /**
   * @return {import("./TileState.js").default} State.
   */ key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            /**
   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
   * the tile queue and will block other requests.
   * @param {import("./TileState.js").default} state State.
   * @api
   */ key: "setState",
            value: function setState(state) {
                if (this.state !== (0, $4b81523a11dd716e$export$2e2bcd8739ae039).ERROR && this.state > state) throw new Error("Tile load sequence violation");
                this.state = state;
                this.changed();
            }
        },
        {
            /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @abstract
   * @api
   */ key: "load",
            value: function load() {
                (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Get the alpha value for rendering.
   * @param {string} id An id for the renderer.
   * @param {number} time The render frame time.
   * @return {number} A number between 0 and 1.
   */ key: "getAlpha",
            value: function getAlpha(id, time) {
                if (!this.transition_) return 1;
                var start = this.transitionStarts_[id];
                if (!start) {
                    start = time;
                    this.transitionStarts_[id] = start;
                } else if (start === -1) return 1;
                var delta = time - start + 1000 / 60; // avoid rendering at 0
                if (delta >= this.transition_) return 1;
                return (0, $eba911dc905f0f7f$export$929e5a82286172a6)(delta / this.transition_);
            }
        },
        {
            /**
   * Determine if a tile is in an alpha transition.  A tile is considered in
   * transition if tile.getAlpha() has not yet been called or has been called
   * and returned 1.
   * @param {string} id An id for the renderer.
   * @return {boolean} The tile is in transition.
   */ key: "inTransition",
            value: function inTransition(id) {
                if (!this.transition_) return false;
                return this.transitionStarts_[id] !== -1;
            }
        },
        {
            /**
   * Mark a transition as complete.
   * @param {string} id An id for the renderer.
   */ key: "endTransition",
            value: function endTransition(id) {
                if (this.transition_) this.transitionStarts_[id] = -1;
            }
        }
    ]);
    return Tile;
}((0, $aBSBL._)((0, $e5f438e225cf4aef$export$2e2bcd8739ae039)));
var $136a2fdcc54b2e52$export$2e2bcd8739ae039 = $136a2fdcc54b2e52$var$Tile;




/**
 * @module ol/Image
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $aBSBL = parcelRequire("aBSBL");

var $4jYWU = parcelRequire("4jYWU");






/**
 * A function that takes an {@link module:ol/Image~ImageWrapper} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~ImageWrapper#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(import("./Image.js").default, string): void} LoadFunction
 * @api
 */ /**
 * @typedef {Object} ImageObject
 * @property {import("./extent.js").Extent} [extent] Extent, if different from the requested one.
 * @property {import("./resolution.js").ResolutionLike} [resolution] Resolution, if different from the requested one.
 * When x and y resolution are different, use the array type (`[xResolution, yResolution]`).
 * @property {number} [pixelRatio] Pixel ratio, if different from the requested one.
 * @property {import('./DataTile.js').ImageLike} image Image.
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * For images that cover any extent and resolution (static images), the loader function should not accept
 * any arguments. The function returns an {@link import("./DataTile.js").ImageLike image}, an
 * {@link import("./Image.js").ImageObject image object}, or a promise for the same.
 * For loaders that generate images, the promise should not resolve until the image is loaded.
 * If the returned image does not match the extent, resolution or pixel ratio passed to the loader,
 * it has to return an {@link import("./Image.js").ImageObject image object} with the `image` and the
 * correct `extent`, `resolution` and `pixelRatio`.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} Loader
 * @api
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * The function returns a promise for an  {@link import("./Image.js").ImageObject image object}.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} ImageObjectPromiseLoader
 */ var $e0be75e54316f60e$var$ImageWrapper = /*#__PURE__*/ function(EventTarget) {
    "use strict";
    (0, $kcqLc._)(ImageWrapper, EventTarget);
    var _super = (0, $4jYWU._)(ImageWrapper);
    function ImageWrapper(extent, resolution, pixelRatio, stateOrLoader) {
        (0, $5sFFs._)(this, ImageWrapper);
        var _this;
        _this = _super.call(this);
        /**
     * @protected
     * @type {import("./extent.js").Extent}
     */ _this.extent = extent;
        /**
     * @private
     * @type {number}
     */ _this.pixelRatio_ = pixelRatio;
        /**
     * @protected
     * @type {number|Array<number>|undefined}
     */ _this.resolution = resolution;
        /**
     * @protected
     * @type {import("./ImageState.js").default}
     */ _this.state = typeof stateOrLoader === "function" ? (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).IDLE : stateOrLoader;
        /**
     * @private
     * @type {import('./DataTile.js').ImageLike|null}
     */ _this.image_ = null;
        /**
     * @protected
     * @type {import("./Image.js").Loader}
     */ _this.loader = typeof stateOrLoader === "function" ? stateOrLoader : null;
        return _this;
    }
    (0, $8O2fV._)(ImageWrapper, [
        {
            /**
   * @protected
   */ key: "changed",
            value: function changed() {
                this.dispatchEvent((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE);
            }
        },
        {
            /**
   * @return {import("./extent.js").Extent} Extent.
   */ key: "getExtent",
            value: function getExtent() {
                return this.extent;
            }
        },
        {
            /**
   * @return {import('./DataTile.js').ImageLike} Image.
   */ key: "getImage",
            value: function getImage() {
                return this.image_;
            }
        },
        {
            /**
   * @return {number} PixelRatio.
   */ key: "getPixelRatio",
            value: function getPixelRatio() {
                return this.pixelRatio_;
            }
        },
        {
            /**
   * @return {number|Array<number>} Resolution.
   */ key: "getResolution",
            value: function getResolution() {
                return /** @type {number} */ this.resolution;
            }
        },
        {
            /**
   * @return {import("./ImageState.js").default} State.
   */ key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            /**
   * Load not yet loaded URI.
   */ key: "load",
            value: function load() {
                var _this = this;
                if (this.state == (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).IDLE) {
                    if (this.loader) {
                        this.state = (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADING;
                        this.changed();
                        var resolution = this.getResolution();
                        var requestResolution = Array.isArray(resolution) ? resolution[0] : resolution;
                        (0, $d0c140d5afad5e7c$export$4dbaaf6c79705e6c)(function() {
                            return _this.loader(_this.getExtent(), requestResolution, _this.getPixelRatio());
                        }).then(function(image) {
                            if ("image" in image) _this.image_ = image.image;
                            if ("extent" in image) _this.extent = image.extent;
                            if ("resolution" in image) _this.resolution = image.resolution;
                            if ("pixelRatio" in image) _this.pixelRatio_ = image.pixelRatio;
                            if (image instanceof HTMLImageElement || image instanceof ImageBitmap || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement) _this.image_ = image;
                            _this.state = (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED;
                        }).catch(function(error) {
                            _this.state = (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).ERROR;
                            console.error(error); // eslint-disable-line no-console
                        }).finally(function() {
                            return _this.changed();
                        });
                    }
                }
            }
        },
        {
            /**
   * @param {import('./DataTile.js').ImageLike} image The image.
   */ key: "setImage",
            value: function setImage(image) {
                this.image_ = image;
            }
        },
        {
            /**
   * @param {number|Array<number>} resolution Resolution.
   */ key: "setResolution",
            value: function setResolution(resolution) {
                this.resolution = resolution;
            }
        }
    ]);
    return ImageWrapper;
}((0, $aBSBL._)((0, $e5f438e225cf4aef$export$2e2bcd8739ae039)));
function $e0be75e54316f60e$export$bc96ecc7c2a50764(image, loadHandler, errorHandler) {
    var img = /** @type {HTMLImageElement} */ image;
    var listening = true;
    var decoding = false;
    var loaded = false;
    var listenerKeys = [
        (0, $5b08b5a7fd85a110$export$8d2a95bc11b44725)(img, (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).LOAD, function() {
            loaded = true;
            if (!decoding) loadHandler();
        })
    ];
    if (img.src && (0, $c4937aaad0f121a7$export$716f8695eedb9bad)) {
        decoding = true;
        img.decode().then(function() {
            if (listening) loadHandler();
        }).catch(function(error) {
            if (listening) {
                if (loaded) loadHandler();
                else errorHandler();
            }
        });
    } else listenerKeys.push((0, $5b08b5a7fd85a110$export$8d2a95bc11b44725)(img, (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).ERROR, errorHandler));
    return function unlisten() {
        listening = false;
        listenerKeys.forEach((0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921));
    };
}
function $e0be75e54316f60e$export$11e63f7b0f3d9900(image, src) {
    return new Promise(function(resolve, reject) {
        function handleLoad() {
            unlisten();
            resolve(image);
        }
        function handleError() {
            unlisten();
            reject(new Error("Image load error"));
        }
        function unlisten() {
            image.removeEventListener("load", handleLoad);
            image.removeEventListener("error", handleError);
        }
        image.addEventListener("load", handleLoad);
        image.addEventListener("error", handleError);
        if (src) image.src = src;
    });
}
function $e0be75e54316f60e$export$a9e5af241c1bd389(image, src) {
    if (src) image.src = src;
    return image.src && (0, $c4937aaad0f121a7$export$716f8695eedb9bad) ? new Promise(function(resolve, reject) {
        return image.decode().then(function() {
            return resolve(image);
        }).catch(function(e) {
            return image.complete && image.width ? resolve(image) : reject(e);
        });
    }) : $e0be75e54316f60e$export$11e63f7b0f3d9900(image);
}
function $e0be75e54316f60e$export$2f872c0f2117be69(image, src) {
    if (src) image.src = src;
    return image.src && (0, $c4937aaad0f121a7$export$716f8695eedb9bad) && (0, $c4937aaad0f121a7$export$7478563940788376) ? image.decode().then(function() {
        return createImageBitmap(image);
    }).catch(function(e) {
        if (image.complete && image.width) return image;
        throw e;
    }) : $e0be75e54316f60e$export$a9e5af241c1bd389(image);
}
var $e0be75e54316f60e$export$2e2bcd8739ae039 = $e0be75e54316f60e$var$ImageWrapper;


var $aa0bea3f7cc55e00$var$ImageTile = /*#__PURE__*/ function(Tile) {
    "use strict";
    (0, $kcqLc._)(ImageTile, Tile);
    var _super = (0, $4jYWU._)(ImageTile);
    function ImageTile(tileCoord, state, src, crossOrigin, tileLoadFunction, options) {
        (0, $5sFFs._)(this, ImageTile);
        var _this;
        _this = _super.call(this, tileCoord, state, options);
        /**
     * @private
     * @type {?string}
     */ _this.crossOrigin_ = crossOrigin;
        /**
     * Image URI
     *
     * @private
     * @type {string}
     */ _this.src_ = src;
        _this.key = src;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement}
     */ _this.image_ = new Image();
        if (crossOrigin !== null) _this.image_.crossOrigin = crossOrigin;
        /**
     * @private
     * @type {?function():void}
     */ _this.unlisten_ = null;
        /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */ _this.tileLoadFunction_ = tileLoadFunction;
        return _this;
    }
    (0, $8O2fV._)(ImageTile, [
        {
            /**
   * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */ key: "getImage",
            value: function getImage() {
                return this.image_;
            }
        },
        {
            /**
   * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
   * @param {HTMLCanvasElement|HTMLImageElement} element Element.
   */ key: "setImage",
            value: function setImage(element) {
                this.image_ = element;
                this.state = (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADED;
                this.unlistenImage_();
                this.changed();
            }
        },
        {
            /**
   * Tracks loading or read errors.
   *
   * @private
   */ key: "handleImageError_",
            value: function handleImageError_() {
                this.state = (0, $4b81523a11dd716e$export$2e2bcd8739ae039).ERROR;
                this.unlistenImage_();
                this.image_ = $aa0bea3f7cc55e00$var$getBlankImage();
                this.changed();
            }
        },
        {
            /**
   * Tracks successful image load.
   *
   * @private
   */ key: "handleImageLoad_",
            value: function handleImageLoad_() {
                var image = /** @type {HTMLImageElement} */ this.image_;
                if (image.naturalWidth && image.naturalHeight) this.state = (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADED;
                else this.state = (0, $4b81523a11dd716e$export$2e2bcd8739ae039).EMPTY;
                this.unlistenImage_();
                this.changed();
            }
        },
        {
            /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   *
   * To retry loading tiles on failed requests, use a custom `tileLoadFunction`
   * that checks for error status codes and reloads only when the status code is
   * 408, 429, 500, 502, 503 and 504, and only when not too many retries have been
   * made already:
   *
   * ```js
   * const retryCodes = [408, 429, 500, 502, 503, 504];
   * const retries = {};
   * source.setTileLoadFunction((tile, src) => {
   *   const image = tile.getImage();
   *   fetch(src)
   *     .then((response) => {
   *       if (retryCodes.includes(response.status)) {
   *         retries[src] = (retries[src] || 0) + 1;
   *         if (retries[src] <= 3) {
   *           setTimeout(() => tile.load(), retries[src] * 1000);
   *         }
   *         return Promise.reject();
   *       }
   *       return response.blob();
   *     })
   *     .then((blob) => {
   *       const imageUrl = URL.createObjectURL(blob);
   *       image.src = imageUrl;
   *       setTimeout(() => URL.revokeObjectURL(imageUrl), 5000);
   *     })
   *     .catch(() => tile.setState(3)); // error
   * });
   * ```
   *
   * @api
   */ key: "load",
            value: function load() {
                if (this.state == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).ERROR) {
                    this.state = (0, $4b81523a11dd716e$export$2e2bcd8739ae039).IDLE;
                    this.image_ = new Image();
                    if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
                }
                if (this.state == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).IDLE) {
                    this.state = (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADING;
                    this.changed();
                    this.tileLoadFunction_(this, this.src_);
                    this.unlisten_ = (0, $e0be75e54316f60e$export$bc96ecc7c2a50764)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
                }
            }
        },
        {
            /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */ key: "unlistenImage_",
            value: function unlistenImage_() {
                if (this.unlisten_) {
                    this.unlisten_();
                    this.unlisten_ = null;
                }
            }
        }
    ]);
    return ImageTile;
}((0, $136a2fdcc54b2e52$export$2e2bcd8739ae039));
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement} Blank image.
 */ function $aa0bea3f7cc55e00$var$getBlankImage() {
    var ctx = (0, $e000035bb4c81589$export$9e05d10eae75c464)(1, 1);
    ctx.fillStyle = "rgba(0,0,0,0)";
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
var $aa0bea3f7cc55e00$export$2e2bcd8739ae039 = $aa0bea3f7cc55e00$var$ImageTile;


/**
 * @module ol/reproj/Tile
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $fSdUO = parcelRequire("fSdUO");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/reproj/common
 */ /**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */ var $45c2db6333857ac3$export$3ecb4bcfa5aae855 = 0.5;





/**
 * @module ol/reproj/Triangulation
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");



/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source Source.
 * @property {Array<import("../coordinate.js").Coordinate>} target Target.
 */ /**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */ var $f6bff0d505bd49a6$var$MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */ var $f6bff0d505bd49a6$var$MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */ var $f6bff0d505bd49a6$var$Triangulation = /*#__PURE__*/ function() {
    "use strict";
    function Triangulation(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold, destinationResolution) {
        var _this = this;
        (0, $5sFFs._)(this, Triangulation);
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.sourceProj_ = sourceProj;
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.targetProj_ = targetProj;
        /** @type {!Object<string, import("../coordinate.js").Coordinate>} */ var transformInvCache = {};
        var transformInv = (0, $401a58d9dec354c1$export$fce0c6cfca85ed96)(this.targetProj_, this.sourceProj_);
        /**
     * @param {import("../coordinate.js").Coordinate} c A coordinate.
     * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
     * @private
     */ this.transformInv_ = function(c) {
            var key = c[0] + "/" + c[1];
            if (!transformInvCache[key]) transformInvCache[key] = transformInv(c);
            return transformInvCache[key];
        };
        /**
     * @type {import("../extent.js").Extent}
     * @private
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @type {number}
     * @private
     */ this.errorThresholdSquared_ = errorThreshold * errorThreshold;
        /**
     * @type {Array<Triangle>}
     * @private
     */ this.triangles_ = [];
        /**
     * Indicates that the triangulation crosses edge of the source projection.
     * @type {boolean}
     * @private
     */ this.wrapsXInSource_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!maxSourceExtent && !!this.sourceProj_.getExtent() && (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(maxSourceExtent) >= (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent());
        /**
     * @type {?number}
     * @private
     */ this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent()) : null;
        /**
     * @type {?number}
     * @private
     */ this.targetWorldWidth_ = this.targetProj_.getExtent() ? (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(this.targetProj_.getExtent()) : null;
        var destinationTopLeft = (0, $e86e0aa087890eb8$export$cb1538b07e6964ff)(targetExtent);
        var destinationTopRight = (0, $e86e0aa087890eb8$export$b84fa077c8b05295)(targetExtent);
        var destinationBottomRight = (0, $e86e0aa087890eb8$export$e77c1cf70445e168)(targetExtent);
        var destinationBottomLeft = (0, $e86e0aa087890eb8$export$8d09f5e2e1bf560d)(targetExtent);
        var sourceTopLeft = this.transformInv_(destinationTopLeft);
        var sourceTopRight = this.transformInv_(destinationTopRight);
        var sourceBottomRight = this.transformInv_(destinationBottomRight);
        var sourceBottomLeft = this.transformInv_(destinationBottomLeft);
        /*
     * The maxSubdivision controls how many splittings of the target area can
     * be done. The idea here is to do a linear mapping of the target areas
     * but the actual overall reprojection (can be) extremely non-linear. The
     * default value of MAX_SUBDIVISION was chosen based on mapping a 256x256
     * tile size. However this function is also called to remap canvas rendered
     * layers which can be much larger. This calculation increases the maxSubdivision
     * value by the right factor so that each 256x256 pixel area has
     * MAX_SUBDIVISION divisions.
     */ var maxSubdivision = $f6bff0d505bd49a6$var$MAX_SUBDIVISION + (destinationResolution ? Math.max(0, Math.ceil(Math.log2((0, $e86e0aa087890eb8$export$520c40045967cb15)(targetExtent) / (destinationResolution * destinationResolution * 65536)))) : 0);
        this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, maxSubdivision);
        if (this.wrapsXInSource_) {
            var leftBound = Infinity;
            this.triangles_.forEach(function(triangle, i, arr) {
                leftBound = Math.min(leftBound, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
            });
            // Shift triangles to be as close to `leftBound` as possible
            // (if the distance is more than `worldWidth / 2` it can be closer.
            this.triangles_.forEach(function(triangle) {
                if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) - leftBound > _this.sourceWorldWidth_ / 2) {
                    var newTriangle = [
                        [
                            triangle.source[0][0],
                            triangle.source[0][1]
                        ],
                        [
                            triangle.source[1][0],
                            triangle.source[1][1]
                        ],
                        [
                            triangle.source[2][0],
                            triangle.source[2][1]
                        ]
                    ];
                    if (newTriangle[0][0] - leftBound > _this.sourceWorldWidth_ / 2) newTriangle[0][0] -= _this.sourceWorldWidth_;
                    if (newTriangle[1][0] - leftBound > _this.sourceWorldWidth_ / 2) newTriangle[1][0] -= _this.sourceWorldWidth_;
                    if (newTriangle[2][0] - leftBound > _this.sourceWorldWidth_ / 2) newTriangle[2][0] -= _this.sourceWorldWidth_;
                    // Rarely (if the extent contains both the dateline and prime meridian)
                    // the shift can in turn break some triangles.
                    // Detect this here and don't shift in such cases.
                    var minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    var maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    if (maxX - minX < _this.sourceWorldWidth_ / 2) triangle.source = newTriangle;
                }
            });
        }
        transformInvCache = {};
    }
    (0, $8O2fV._)(Triangulation, [
        {
            /**
   * Adds triangle to the triangulation.
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @private
   */ key: "addTriangle_",
            value: function addTriangle_(a, b, c, aSrc, bSrc, cSrc) {
                this.triangles_.push({
                    source: [
                        aSrc,
                        bSrc,
                        cSrc
                    ],
                    target: [
                        a,
                        b,
                        c
                    ]
                });
            }
        },
        {
            /**
   * Adds quad (points in clock-wise order) to the triangulation
   * (and reprojects the vertices) if valid.
   * Performs quad subdivision if needed to increase precision.
   *
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
   * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
   * @private
   */ key: "addQuad_",
            value: function addQuad_(a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
                var sourceQuadExtent = (0, $e86e0aa087890eb8$export$8aceca7c77505534)([
                    aSrc,
                    bSrc,
                    cSrc,
                    dSrc
                ]);
                var sourceCoverageX = this.sourceWorldWidth_ ? (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(sourceQuadExtent) / this.sourceWorldWidth_ : null;
                var sourceWorldWidth = /** @type {number} */ this.sourceWorldWidth_;
                // when the quad is wrapped in the source projection
                // it covers most of the projection extent, but not fully
                var wrapsX = this.sourceProj_.canWrapX() && sourceCoverageX > 0.5 && sourceCoverageX < 1;
                var needsSubdivision = false;
                if (maxSubdivision > 0) {
                    if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
                        var targetQuadExtent = (0, $e86e0aa087890eb8$export$8aceca7c77505534)([
                            a,
                            b,
                            c,
                            d
                        ]);
                        var targetCoverageX = (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(targetQuadExtent) / this.targetWorldWidth_;
                        needsSubdivision = targetCoverageX > $f6bff0d505bd49a6$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
                    }
                    if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) needsSubdivision = sourceCoverageX > $f6bff0d505bd49a6$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
                }
                if (!needsSubdivision && this.maxSourceExtent_) {
                    if (isFinite(sourceQuadExtent[0]) && isFinite(sourceQuadExtent[1]) && isFinite(sourceQuadExtent[2]) && isFinite(sourceQuadExtent[3])) {
                        if (!(0, $e86e0aa087890eb8$export$7b0a31e10bbff018)(sourceQuadExtent, this.maxSourceExtent_)) // whole quad outside source projection extent -> ignore
                        return;
                    }
                }
                var isNotFinite = 0;
                if (!needsSubdivision) {
                    if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) || !isFinite(bSrc[0]) || !isFinite(bSrc[1]) || !isFinite(cSrc[0]) || !isFinite(cSrc[1]) || !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
                        if (maxSubdivision > 0) needsSubdivision = true;
                        else {
                            // It might be the case that only 1 of the points is infinite. In this case
                            // we can draw a single triangle with the other three points
                            isNotFinite = (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ? 8 : 0) + (!isFinite(bSrc[0]) || !isFinite(bSrc[1]) ? 4 : 0) + (!isFinite(cSrc[0]) || !isFinite(cSrc[1]) ? 2 : 0) + (!isFinite(dSrc[0]) || !isFinite(dSrc[1]) ? 1 : 0);
                            if (isNotFinite != 1 && isNotFinite != 2 && isNotFinite != 4 && isNotFinite != 8) return;
                        }
                    }
                }
                if (maxSubdivision > 0) {
                    if (!needsSubdivision) {
                        var center = [
                            (a[0] + c[0]) / 2,
                            (a[1] + c[1]) / 2
                        ];
                        var centerSrc = this.transformInv_(center);
                        var dx;
                        if (wrapsX) {
                            var centerSrcEstimX = ((0, $029c1e222d833501$export$ba467bec01d66def)(aSrc[0], sourceWorldWidth) + (0, $029c1e222d833501$export$ba467bec01d66def)(cSrc[0], sourceWorldWidth)) / 2;
                            dx = centerSrcEstimX - (0, $029c1e222d833501$export$ba467bec01d66def)(centerSrc[0], sourceWorldWidth);
                        } else dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
                        var dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
                        var centerSrcErrorSquared = dx * dx + dy * dy;
                        needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
                    }
                    if (needsSubdivision) {
                        if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                            // split horizontally (top & bottom)
                            var bc = [
                                (b[0] + c[0]) / 2,
                                (b[1] + c[1]) / 2
                            ];
                            var bcSrc = this.transformInv_(bc);
                            var da = [
                                (d[0] + a[0]) / 2,
                                (d[1] + a[1]) / 2
                            ];
                            var daSrc = this.transformInv_(da);
                            this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                            this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
                        } else {
                            // split vertically (left & right)
                            var ab = [
                                (a[0] + b[0]) / 2,
                                (a[1] + b[1]) / 2
                            ];
                            var abSrc = this.transformInv_(ab);
                            var cd = [
                                (c[0] + d[0]) / 2,
                                (c[1] + d[1]) / 2
                            ];
                            var cdSrc = this.transformInv_(cd);
                            this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                            this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
                        }
                        return;
                    }
                }
                if (wrapsX) {
                    if (!this.canWrapXInSource_) return;
                    this.wrapsXInSource_ = true;
                }
                // Exactly zero or one of *Src is not finite
                // The triangles must have the diagonal line as the first side
                // This is to allow easy code in reproj.s to make it straight for broken
                // browsers that can't handle diagonal clipping
                if ((isNotFinite & 0xb) == 0) this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
                if ((isNotFinite & 0xe) == 0) this.addTriangle_(a, c, b, aSrc, cSrc, bSrc);
                if (isNotFinite) {
                    // Try the other two triangles
                    if ((isNotFinite & 0xd) == 0) this.addTriangle_(b, d, a, bSrc, dSrc, aSrc);
                    if ((isNotFinite & 0x7) == 0) this.addTriangle_(b, d, c, bSrc, dSrc, cSrc);
                }
            }
        },
        {
            /**
   * Calculates extent of the `source` coordinates from all the triangles.
   *
   * @return {import("../extent.js").Extent} Calculated extent.
   */ key: "calculateSourceExtent",
            value: function calculateSourceExtent() {
                var extent = (0, $e86e0aa087890eb8$export$fe201bb3bbe031e9)();
                this.triangles_.forEach(function(triangle, i, arr) {
                    var src = triangle.source;
                    (0, $e86e0aa087890eb8$export$1f820e3920fa5715)(extent, src[0]);
                    (0, $e86e0aa087890eb8$export$1f820e3920fa5715)(extent, src[1]);
                    (0, $e86e0aa087890eb8$export$1f820e3920fa5715)(extent, src[2]);
                });
                return extent;
            }
        },
        {
            /**
   * @return {Array<Triangle>} Array of the calculated triangles.
   */ key: "getTriangles",
            value: function getTriangles() {
                return this.triangles_;
            }
        }
    ]);
    return Triangulation;
}();
var $f6bff0d505bd49a6$export$2e2bcd8739ae039 = $f6bff0d505bd49a6$var$Triangulation;


/**
 * @module ol/reproj
 */ 



var $edc33bef92792954$var$brokenDiagonalRendering_;
var $edc33bef92792954$export$a166f0857c555517 = [];
/**
 * This draws a small triangle into a canvas by setting the triangle as the clip region
 * and then drawing a (too large) rectangle
 *
 * @param {CanvasRenderingContext2D} ctx The context in which to draw the triangle
 * @param {number} u1 The x-coordinate of the second point. The first point is 0,0.
 * @param {number} v1 The y-coordinate of the second point.
 * @param {number} u2 The x-coordinate of the third point.
 * @param {number} v2 The y-coordinate of the third point.
 */ function $edc33bef92792954$var$drawTestTriangle(ctx, u1, v1, u2, v2) {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(u1, v1);
    ctx.lineTo(u2, v2);
    ctx.closePath();
    ctx.save();
    ctx.clip();
    ctx.fillRect(0, 0, Math.max(u1, u2) + 1, Math.max(v1, v2));
    ctx.restore();
}
/**
 * Given the data from getImageData, see if the right values appear at the provided offset.
 * Returns true if either the color or transparency is off
 *
 * @param {Uint8ClampedArray} data The data returned from getImageData
 * @param {number} offset The pixel offset from the start of data.
 * @return {boolean} true if the diagonal rendering is broken
 */ function $edc33bef92792954$var$verifyBrokenDiagonalRendering(data, offset) {
    // the values ought to be close to the rgba(210, 0, 0, 0.75)
    return Math.abs(data[offset * 4] - 210) > 2 || Math.abs(data[offset * 4 + 3] - 191.25) > 2;
}
/**
 * Determines if the current browser configuration can render triangular clip regions correctly.
 * This value is cached so the function is only expensive the first time called.
 * Firefox on Windows (as of now) does not if HWA is enabled. See https://bugzilla.mozilla.org/show_bug.cgi?id=1606976
 * Chrome works, and everything seems to work on OSX and Android. This function caches the
 * result. I suppose that it is conceivably possible that a browser might flip modes while the app is
 * running, but lets hope not.
 *
 * @return {boolean} true if the Diagonal Rendering is broken.
 */ function $edc33bef92792954$var$isBrokenDiagonalRendering() {
    if ($edc33bef92792954$var$brokenDiagonalRendering_ === undefined) {
        var ctx = (0, $e000035bb4c81589$export$9e05d10eae75c464)(6, 6, $edc33bef92792954$export$a166f0857c555517);
        ctx.globalCompositeOperation = "lighter";
        ctx.fillStyle = "rgba(210, 0, 0, 0.75)";
        $edc33bef92792954$var$drawTestTriangle(ctx, 4, 5, 4, 0);
        $edc33bef92792954$var$drawTestTriangle(ctx, 4, 5, 0, 5);
        var data = ctx.getImageData(0, 0, 3, 3).data;
        $edc33bef92792954$var$brokenDiagonalRendering_ = $edc33bef92792954$var$verifyBrokenDiagonalRendering(data, 0) || $edc33bef92792954$var$verifyBrokenDiagonalRendering(data, 4) || $edc33bef92792954$var$verifyBrokenDiagonalRendering(data, 8);
        (0, $e000035bb4c81589$export$e918ac6a1026a12a)(ctx);
        $edc33bef92792954$export$a166f0857c555517.push(ctx.canvas);
    }
    return $edc33bef92792954$var$brokenDiagonalRendering_;
}
function $edc33bef92792954$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution) {
    var sourceCenter = (0, $401a58d9dec354c1$export$51186ad6e864892a)(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    var sourceResolution = (0, $401a58d9dec354c1$export$2d8f7b4eec383d44)(targetProj, targetResolution, targetCenter);
    var targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) sourceResolution *= targetMetersPerUnit;
    var sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) sourceResolution /= sourceMetersPerUnit;
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    var sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || (0, $e86e0aa087890eb8$export$ac68c24d37ca240f)(sourceExtent, sourceCenter)) {
        var compensationFactor = (0, $401a58d9dec354c1$export$2d8f7b4eec383d44)(sourceProj, sourceResolution, sourceCenter) / sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) sourceResolution /= compensationFactor;
    }
    return sourceResolution;
}
function $edc33bef92792954$export$16d356211d01f1cc(sourceProj, targetProj, targetExtent, targetResolution) {
    var targetCenter = (0, $e86e0aa087890eb8$export$c91255cadecfe081)(targetExtent);
    var sourceResolution = $edc33bef92792954$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution);
    if (!isFinite(sourceResolution) || sourceResolution <= 0) (0, $e86e0aa087890eb8$export$f9ed8a3d123a08e2)(targetExtent, function(corner) {
        sourceResolution = $edc33bef92792954$export$5fbb958059b7e71f(sourceProj, targetProj, corner, targetResolution);
        return isFinite(sourceResolution) && sourceResolution > 0;
    });
    return sourceResolution;
}
function $edc33bef92792954$export$b3890eb0ae9dca99(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, renderEdges, interpolate, drawSingle) {
    var context = (0, $e000035bb4c81589$export$9e05d10eae75c464)(Math.round(pixelRatio * width), Math.round(pixelRatio * height), $edc33bef92792954$export$a166f0857c555517);
    if (!interpolate) context.imageSmoothingEnabled = false;
    if (sources.length === 0) return context.canvas;
    context.scale(pixelRatio, pixelRatio);
    function pixelRound(value) {
        return Math.round(value * pixelRatio) / pixelRatio;
    }
    context.globalCompositeOperation = "lighter";
    var sourceDataExtent = (0, $e86e0aa087890eb8$export$fe201bb3bbe031e9)();
    sources.forEach(function(src, i, arr) {
        (0, $e86e0aa087890eb8$export$8b58be045bf06082)(sourceDataExtent, src.extent);
    });
    var stitchContext;
    if (!drawSingle || sources.length !== 1 || gutter !== 0) {
        var canvasWidthInUnits = (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(sourceDataExtent);
        var canvasHeightInUnits = (0, $e86e0aa087890eb8$export$c08559766941f856)(sourceDataExtent);
        stitchContext = (0, $e000035bb4c81589$export$9e05d10eae75c464)(Math.round(pixelRatio * canvasWidthInUnits / sourceResolution), Math.round(pixelRatio * canvasHeightInUnits / sourceResolution), $edc33bef92792954$export$a166f0857c555517);
        if (!interpolate) stitchContext.imageSmoothingEnabled = false;
        var stitchScale = pixelRatio / sourceResolution;
        sources.forEach(function(src, i, arr) {
            var xPos = src.extent[0] - sourceDataExtent[0];
            var yPos = -(src.extent[3] - sourceDataExtent[3]);
            var srcWidth = (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(src.extent);
            var srcHeight = (0, $e86e0aa087890eb8$export$c08559766941f856)(src.extent);
            // This test should never fail -- but it does. Need to find a fix the upstream condition
            if (src.image.width > 0 && src.image.height > 0) stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, xPos * stitchScale, yPos * stitchScale, srcWidth * stitchScale, srcHeight * stitchScale);
        });
    }
    var targetTopLeft = (0, $e86e0aa087890eb8$export$cb1538b07e6964ff)(targetExtent);
    triangulation.getTriangles().forEach(function(triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
     * Resulting matrix can be used to transform coordinate
     * from `sourceProjection` to destination pixels.
     *
     * To optimize number of context calls and increase numerical stability,
     * we also do the following operations:
     * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
     * here before solving the linear system so [ui, vi] are pixel coordinates.
     *
     * Src points: xi, yi
     * Dst points: ui, vi
     * Affine coefficients: aij
     *
     * | x0 y0 1  0  0 0 |   |a00|   |u0|
     * | x1 y1 1  0  0 0 |   |a01|   |u1|
     * | x2 y2 1  0  0 0 | x |a02| = |u2|
     * |  0  0 0 x0 y0 1 |   |a10|   |v0|
     * |  0  0 0 x1 y1 1 |   |a11|   |v1|
     * |  0  0 0 x2 y2 1 |   |a12|   |v2|
     */ var source = triangle.source;
        var target = triangle.target;
        var x0 = source[0][0], y0 = source[0][1];
        var x1 = source[1][0], y1 = source[1][1];
        var x2 = source[2][0], y2 = source[2][1];
        // Make sure that everything is on pixel boundaries
        var u0 = pixelRound((target[0][0] - targetTopLeft[0]) / targetResolution);
        var v0 = pixelRound(-(target[0][1] - targetTopLeft[1]) / targetResolution);
        var u1 = pixelRound((target[1][0] - targetTopLeft[0]) / targetResolution);
        var v1 = pixelRound(-(target[1][1] - targetTopLeft[1]) / targetResolution);
        var u2 = pixelRound((target[2][0] - targetTopLeft[0]) / targetResolution);
        var v2 = pixelRound(-(target[2][1] - targetTopLeft[1]) / targetResolution);
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        var sourceNumericalShiftX = x0;
        var sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        var augmentedMatrix = [
            [
                x1,
                y1,
                0,
                0,
                u1 - u0
            ],
            [
                x2,
                y2,
                0,
                0,
                u2 - u0
            ],
            [
                0,
                0,
                x1,
                y1,
                v1 - v0
            ],
            [
                0,
                0,
                x2,
                y2,
                v2 - v0
            ]
        ];
        var affineCoefs = (0, $029c1e222d833501$export$8240f01c446270e6)(augmentedMatrix);
        if (!affineCoefs) return;
        context.save();
        context.beginPath();
        if ($edc33bef92792954$var$isBrokenDiagonalRendering() || !interpolate) {
            // Make sure that all lines are horizontal or vertical
            context.moveTo(u1, v1);
            // This is the diagonal line. Do it in 4 steps
            var steps = 4;
            var ud = u0 - u1;
            var vd = v0 - v1;
            for(var step = 0; step < steps; step++){
                // Go horizontally
                context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound(step * vd / (steps - 1)));
                // Go vertically
                if (step != steps - 1) context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound((step + 1) * vd / (steps - 1)));
            }
            // We are almost at u0r, v0r
            context.lineTo(u2, v2);
        } else {
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
        }
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        var image;
        if (stitchContext) {
            image = stitchContext.canvas;
            context.scale(sourceResolution / pixelRatio, -sourceResolution / pixelRatio);
        } else {
            var source1 = sources[0];
            var extent = source1.extent;
            image = source1.image;
            context.scale((0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(extent) / image.width, -(0, $e86e0aa087890eb8$export$c08559766941f856)(extent) / image.height);
        }
        context.drawImage(image, 0, 0);
        context.restore();
    });
    if (stitchContext) {
        (0, $e000035bb4c81589$export$e918ac6a1026a12a)(stitchContext);
        $edc33bef92792954$export$a166f0857c555517.push(stitchContext.canvas);
    }
    if (renderEdges) {
        context.save();
        context.globalCompositeOperation = "source-over";
        context.strokeStyle = "black";
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function(triangle, i, arr) {
            var target = triangle.target;
            var u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            var v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            var u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            var v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            var u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            var v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}






/**
 * @typedef {function(number, number, number, number) : (import("../ImageTile.js").default)} FunctionType
 */ /**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */ var $7e1852452396cdfc$var$ReprojTile = /*#__PURE__*/ function(Tile) {
    "use strict";
    (0, $kcqLc._)(ReprojTile, Tile);
    var _super = (0, $4jYWU._)(ReprojTile);
    function ReprojTile(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, errorThreshold, renderEdges, options) {
        (0, $5sFFs._)(this, ReprojTile);
        var _this;
        _this = _super.call(this, tileCoord, (0, $4b81523a11dd716e$export$2e2bcd8739ae039).IDLE, options);
        /**
     * @private
     * @type {boolean}
     */ _this.renderEdges_ = renderEdges !== undefined ? renderEdges : false;
        /**
     * @private
     * @type {number}
     */ _this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ _this.gutter_ = gutter;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ _this.canvas_ = null;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ _this.sourceTileGrid_ = sourceTileGrid;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ _this.targetTileGrid_ = targetTileGrid;
        /**
     * @private
     * @type {import("../tilecoord.js").TileCoord}
     */ _this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
     * @private
     * @type {!Array<import("../ImageTile.js").default>}
     */ _this.sourceTiles_ = [];
        /**
     * @private
     * @type {?Array<import("../events.js").EventsKey>}
     */ _this.sourcesListenerKeys_ = null;
        /**
     * @private
     * @type {number}
     */ _this.sourceZ_ = 0;
        var targetExtent = targetTileGrid.getTileCoordExtent(_this.wrappedTileCoord_);
        var maxTargetExtent = _this.targetTileGrid_.getExtent();
        var maxSourceExtent = _this.sourceTileGrid_.getExtent();
        var limitedTargetExtent = maxTargetExtent ? (0, $e86e0aa087890eb8$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, $e86e0aa087890eb8$export$520c40045967cb15)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            _this.state = (0, $4b81523a11dd716e$export$2e2bcd8739ae039).EMPTY;
            return (0, $fSdUO._)(_this);
        }
        var sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, $e86e0aa087890eb8$export$72209efa88586d42)(maxSourceExtent, sourceProjExtent);
        }
        var targetResolution = targetTileGrid.getResolution(_this.wrappedTileCoord_[0]);
        var sourceResolution = (0, $edc33bef92792954$export$16d356211d01f1cc)(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            _this.state = (0, $4b81523a11dd716e$export$2e2bcd8739ae039).EMPTY;
            return (0, $fSdUO._)(_this);
        }
        var errorThresholdInPixels = errorThreshold !== undefined ? errorThreshold : (0, $45c2db6333857ac3$export$3ecb4bcfa5aae855);
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ _this.triangulation_ = new (0, $f6bff0d505bd49a6$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (_this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            _this.state = (0, $4b81523a11dd716e$export$2e2bcd8739ae039).EMPTY;
            return (0, $fSdUO._)(_this);
        }
        _this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        var sourceExtent = _this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, $e86e0aa087890eb8$export$72209efa88586d42)(sourceExtent, maxSourceExtent);
        }
        if (!(0, $e86e0aa087890eb8$export$520c40045967cb15)(sourceExtent)) _this.state = (0, $4b81523a11dd716e$export$2e2bcd8739ae039).EMPTY;
        else {
            var sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(sourceExtent, _this.sourceZ_);
            for(var srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(var srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                var tile = getTileFunction(_this.sourceZ_, srcX, srcY, pixelRatio);
                if (tile) _this.sourceTiles_.push(tile);
            }
            if (_this.sourceTiles_.length === 0) _this.state = (0, $4b81523a11dd716e$export$2e2bcd8739ae039).EMPTY;
        }
        return _this;
    }
    (0, $8O2fV._)(ReprojTile, [
        {
            /**
   * Get the HTML Canvas element for this tile.
   * @return {HTMLCanvasElement} Canvas.
   */ key: "getImage",
            value: function getImage() {
                return this.canvas_;
            }
        },
        {
            /**
   * @private
   */ key: "reproject_",
            value: function reproject_() {
                var _this = this;
                var sources = [];
                this.sourceTiles_.forEach(function(tile) {
                    if (tile && tile.getState() == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADED) sources.push({
                        extent: _this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord),
                        image: tile.getImage()
                    });
                });
                this.sourceTiles_.length = 0;
                if (sources.length === 0) this.state = (0, $4b81523a11dd716e$export$2e2bcd8739ae039).ERROR;
                else {
                    var z = this.wrappedTileCoord_[0];
                    var size = this.targetTileGrid_.getTileSize(z);
                    var width = typeof size === "number" ? size : size[0];
                    var height = typeof size === "number" ? size : size[1];
                    var targetResolution = this.targetTileGrid_.getResolution(z);
                    var sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
                    var targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
                    this.canvas_ = (0, $edc33bef92792954$export$b3890eb0ae9dca99)(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_, this.interpolate);
                    this.state = (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADED;
                }
                this.changed();
            }
        },
        {
            /**
   * Load not yet loaded URI.
   */ key: "load",
            value: function load() {
                var _this = this;
                if (this.state == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).IDLE) {
                    this.state = (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADING;
                    this.changed();
                    var leftToLoad = 0;
                    this.sourcesListenerKeys_ = [];
                    this.sourceTiles_.forEach(function(tile) {
                        var state = tile.getState();
                        if (state == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).IDLE || state == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADING) {
                            leftToLoad++;
                            var sourceListenKey = (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(tile, (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE, function(e) {
                                var state = tile.getState();
                                if (state == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADED || state == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).ERROR || state == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).EMPTY) {
                                    (0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921)(sourceListenKey);
                                    leftToLoad--;
                                    if (leftToLoad === 0) {
                                        this.unlistenSources_();
                                        this.reproject_();
                                    }
                                }
                            }, _this);
                            _this.sourcesListenerKeys_.push(sourceListenKey);
                        }
                    });
                    if (leftToLoad === 0) setTimeout(this.reproject_.bind(this), 0);
                    else this.sourceTiles_.forEach(function(tile, i, arr) {
                        var state = tile.getState();
                        if (state == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).IDLE) tile.load();
                    });
                }
            }
        },
        {
            /**
   * @private
   */ key: "unlistenSources_",
            value: function unlistenSources_() {
                this.sourcesListenerKeys_.forEach((0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921));
                this.sourcesListenerKeys_ = null;
            }
        },
        {
            /**
   * Remove from the cache due to expiry
   */ key: "release",
            value: function release() {
                if (this.canvas_) {
                    (0, $e000035bb4c81589$export$e918ac6a1026a12a)(this.canvas_.getContext("2d"));
                    (0, $edc33bef92792954$export$a166f0857c555517).push(this.canvas_);
                    this.canvas_ = null;
                }
                (0, $404BM._)((0, $cEF31._)(ReprojTile.prototype), "release", this).call(this);
            }
        }
    ]);
    return ReprojTile;
}((0, $136a2fdcc54b2e52$export$2e2bcd8739ae039));
var $7e1852452396cdfc$export$2e2bcd8739ae039 = $7e1852452396cdfc$var$ReprojTile;


/**
 * @module ol/TileRange
 */ /**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
var $020488f806cc53de$var$TileRange = /*#__PURE__*/ function() {
    "use strict";
    function TileRange(minX, maxX, minY, maxY) {
        (0, $5sFFs._)(this, TileRange);
        /**
     * @type {number}
     */ this.minX = minX;
        /**
     * @type {number}
     */ this.maxX = maxX;
        /**
     * @type {number}
     */ this.minY = minY;
        /**
     * @type {number}
     */ this.maxY = maxY;
    }
    (0, $8O2fV._)(TileRange, [
        {
            /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {boolean} Contains tile coordinate.
   */ key: "contains",
            value: function contains(tileCoord) {
                return this.containsXY(tileCoord[1], tileCoord[2]);
            }
        },
        {
            /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Contains.
   */ key: "containsTileRange",
            value: function containsTileRange(tileRange) {
                return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
            }
        },
        {
            /**
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @return {boolean} Contains coordinate.
   */ key: "containsXY",
            value: function containsXY(x, y) {
                return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
            }
        },
        {
            /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Equals.
   */ key: "equals",
            value: function equals(tileRange) {
                return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
            }
        },
        {
            /**
   * @param {TileRange} tileRange Tile range.
   */ key: "extend",
            value: function extend(tileRange) {
                if (tileRange.minX < this.minX) this.minX = tileRange.minX;
                if (tileRange.maxX > this.maxX) this.maxX = tileRange.maxX;
                if (tileRange.minY < this.minY) this.minY = tileRange.minY;
                if (tileRange.maxY > this.maxY) this.maxY = tileRange.maxY;
            }
        },
        {
            /**
   * @return {number} Height.
   */ key: "getHeight",
            value: function getHeight() {
                return this.maxY - this.minY + 1;
            }
        },
        {
            /**
   * @return {import("./size.js").Size} Size.
   */ key: "getSize",
            value: function getSize() {
                return [
                    this.getWidth(),
                    this.getHeight()
                ];
            }
        },
        {
            /**
   * @return {number} Width.
   */ key: "getWidth",
            value: function getWidth() {
                return this.maxX - this.minX + 1;
            }
        },
        {
            /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Intersects.
   */ key: "intersects",
            value: function intersects(tileRange) {
                return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
            }
        }
    ]);
    return TileRange;
}();
function $020488f806cc53de$export$958e3e1a02eac4b6(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    }
    return new $020488f806cc53de$var$TileRange(minX, maxX, minY, maxY);
}
var $020488f806cc53de$export$2e2bcd8739ae039 = $020488f806cc53de$var$TileRange;









/**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 * @template {import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default} [LayerType=import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default]
 * @extends {CanvasLayerRenderer<LayerType>}
 */ var $a832cd8688bae570$var$CanvasTileLayerRenderer = /*#__PURE__*/ function(CanvasLayerRenderer) {
    "use strict";
    (0, $kcqLc._)(CanvasTileLayerRenderer, CanvasLayerRenderer);
    var _super = (0, $4jYWU._)(CanvasTileLayerRenderer);
    function CanvasTileLayerRenderer(tileLayer) {
        (0, $5sFFs._)(this, CanvasTileLayerRenderer);
        var _this;
        _this = _super.call(this, tileLayer);
        /**
     * Rendered extent has changed since the previous `renderFrame()` call
     * @type {boolean}
     */ _this.extentChanged = true;
        /**
     * @private
     * @type {?import("../../extent.js").Extent}
     */ _this.renderedExtent_ = null;
        /**
     * @protected
     * @type {number}
     */ _this.renderedPixelRatio;
        /**
     * @protected
     * @type {import("../../proj/Projection.js").default}
     */ _this.renderedProjection = null;
        /**
     * @protected
     * @type {number}
     */ _this.renderedRevision;
        /**
     * @protected
     * @type {!Array<import("../../Tile.js").default>}
     */ _this.renderedTiles = [];
        /**
     * @private
     * @type {boolean}
     */ _this.newTiles_ = false;
        /**
     * @protected
     * @type {import("../../extent.js").Extent}
     */ _this.tmpExtent = (0, $e86e0aa087890eb8$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../TileRange.js").default}
     */ _this.tmpTileRange_ = new (0, $020488f806cc53de$export$2e2bcd8739ae039)(0, 0, 0, 0);
        return _this;
    }
    (0, $8O2fV._)(CanvasTileLayerRenderer, [
        {
            /**
   * @protected
   * @param {import("../../Tile.js").default} tile Tile.
   * @return {boolean} Tile is drawable.
   */ key: "isDrawableTile",
            value: function isDrawableTile(tile) {
                var tileLayer = this.getLayer();
                var tileState = tile.getState();
                var useInterimTilesOnError = tileLayer.getUseInterimTilesOnError();
                return tileState == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADED || tileState == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).EMPTY || tileState == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).ERROR && !useInterimTilesOnError;
            }
        },
        {
            /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {!import("../../Tile.js").default} Tile.
   */ key: "getTile",
            value: function getTile(z, x, y, frameState) {
                var pixelRatio = frameState.pixelRatio;
                var projection = frameState.viewState.projection;
                var tileLayer = this.getLayer();
                var tileSource = tileLayer.getSource();
                var tile = tileSource.getTile(z, x, y, pixelRatio, projection);
                if (tile.getState() == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).ERROR) {
                    if (tileLayer.getUseInterimTilesOnError() && tileLayer.getPreload() > 0) // Preloaded tiles for lower resolutions might have finished loading.
                    this.newTiles_ = true;
                }
                if (!this.isDrawableTile(tile)) tile = tile.getInterimTile();
                return tile;
            }
        },
        {
            /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   */ key: "getData",
            value: function getData(pixel) {
                var frameState = this.frameState;
                if (!frameState) return null;
                var layer = this.getLayer();
                var coordinate = (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
                var layerExtent = layer.getExtent();
                if (layerExtent) {
                    if (!(0, $e86e0aa087890eb8$export$ac68c24d37ca240f)(layerExtent, coordinate)) return null;
                }
                var pixelRatio = frameState.pixelRatio;
                var projection = frameState.viewState.projection;
                var viewState = frameState.viewState;
                var source = layer.getRenderSource();
                var tileGrid = source.getTileGridForProjection(viewState.projection);
                var tilePixelRatio = source.getTilePixelRatio(frameState.pixelRatio);
                for(var z = tileGrid.getZForResolution(viewState.resolution); z >= tileGrid.getMinZoom(); --z){
                    var tileCoord = tileGrid.getTileCoordForCoordAndZ(coordinate, z);
                    var tile = source.getTile(z, tileCoord[1], tileCoord[2], pixelRatio, projection);
                    if (!(tile instanceof (0, $aa0bea3f7cc55e00$export$2e2bcd8739ae039) || tile instanceof (0, $7e1852452396cdfc$export$2e2bcd8739ae039)) || tile instanceof (0, $7e1852452396cdfc$export$2e2bcd8739ae039) && tile.getState() === (0, $4b81523a11dd716e$export$2e2bcd8739ae039).EMPTY) return null;
                    if (tile.getState() !== (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADED) continue;
                    var tileOrigin = tileGrid.getOrigin(z);
                    var tileSize = (0, $9fd3f8f53b8c7a01$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z));
                    var tileResolution = tileGrid.getResolution(z);
                    var col = Math.floor(tilePixelRatio * ((coordinate[0] - tileOrigin[0]) / tileResolution - tileCoord[1] * tileSize[0]));
                    var row = Math.floor(tilePixelRatio * ((tileOrigin[1] - coordinate[1]) / tileResolution - tileCoord[2] * tileSize[1]));
                    var gutter = Math.round(tilePixelRatio * source.getGutterForProjection(viewState.projection));
                    return this.getImageData(tile.getImage(), col + gutter, row + gutter);
                }
                return null;
            }
        },
        {
            /**
   * @param {Object<number, Object<string, import("../../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
   * @param {number} zoom Zoom level.
   * @param {import("../../Tile.js").default} tile Tile.
   * @return {boolean|void} If `false`, the tile will not be considered loaded.
   */ key: "loadedTileCallback",
            value: function loadedTileCallback(tiles, zoom, tile) {
                if (this.isDrawableTile(tile)) return (0, $404BM._)((0, $cEF31._)(CanvasTileLayerRenderer.prototype), "loadedTileCallback", this).call(this, tiles, zoom, tile);
                return false;
            }
        },
        {
            /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ key: "prepareFrame",
            value: function prepareFrame(frameState) {
                return !!this.getLayer().getSource();
            }
        },
        {
            /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   */ key: "renderFrame",
            value: function renderFrame(frameState, target) {
                var layerState = frameState.layerStatesArray[frameState.layerIndex];
                var viewState = frameState.viewState;
                var projection = viewState.projection;
                var viewResolution = viewState.resolution;
                var viewCenter = viewState.center;
                var rotation = viewState.rotation;
                var pixelRatio = frameState.pixelRatio;
                var tileLayer = this.getLayer();
                var tileSource = tileLayer.getSource();
                var sourceRevision = tileSource.getRevision();
                var tileGrid = tileSource.getTileGridForProjection(projection);
                var z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
                var tileResolution = tileGrid.getResolution(z);
                var extent = frameState.extent;
                var resolution = frameState.viewState.resolution;
                var tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
                // desired dimensions of the canvas in pixels
                var width = Math.round((0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
                var height = Math.round((0, $e86e0aa087890eb8$export$c08559766941f856)(extent) / resolution * pixelRatio);
                var layerExtent = layerState.extent && (0, $401a58d9dec354c1$export$494be3a3a25689ca)(layerState.extent, projection);
                if (layerExtent) extent = (0, $e86e0aa087890eb8$export$72209efa88586d42)(extent, (0, $401a58d9dec354c1$export$494be3a3a25689ca)(layerState.extent, projection));
                var dx = tileResolution * width / 2 / tilePixelRatio;
                var dy = tileResolution * height / 2 / tilePixelRatio;
                var canvasExtent = [
                    viewCenter[0] - dx,
                    viewCenter[1] - dy,
                    viewCenter[0] + dx,
                    viewCenter[1] + dy
                ];
                var tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
                /**
     * @type {Object<number, Object<string, import("../../Tile.js").default>>}
     */ var tilesToDrawByZ = {};
                tilesToDrawByZ[z] = {};
                var findLoadedTiles = this.createLoadedTileFinder(tileSource, projection, tilesToDrawByZ);
                var tmpExtent = this.tmpExtent;
                var tmpTileRange = this.tmpTileRange_;
                this.newTiles_ = false;
                var viewport = rotation ? (0, $e86e0aa087890eb8$export$4b7a6fb4002cd6ac)(viewState.center, resolution, rotation, frameState.size) : undefined;
                for(var x = tileRange.minX; x <= tileRange.maxX; ++x)for(var y = tileRange.minY; y <= tileRange.maxY; ++y){
                    if (rotation && !tileGrid.tileCoordIntersectsViewport([
                        z,
                        x,
                        y
                    ], viewport)) continue;
                    var tile = this.getTile(z, x, y, frameState);
                    if (this.isDrawableTile(tile)) {
                        var uid = (0, $8b32fff2376556ef$export$5e82334337e0f204)(this);
                        if (tile.getState() == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADED) {
                            tilesToDrawByZ[z][tile.tileCoord.toString()] = tile;
                            var inTransition = tile.inTransition(uid);
                            if (inTransition && layerState.opacity !== 1) {
                                // Skipping transition when layer is not fully opaque avoids visual artifacts.
                                tile.endTransition(uid);
                                inTransition = false;
                            }
                            if (!this.newTiles_ && (inTransition || !this.renderedTiles.includes(tile))) this.newTiles_ = true;
                        }
                        if (tile.getAlpha(uid, frameState.time) === 1) continue;
                    }
                    var childTileRange = tileGrid.getTileCoordChildTileRange(tile.tileCoord, tmpTileRange, tmpExtent);
                    var covered = false;
                    if (childTileRange) covered = findLoadedTiles(z + 1, childTileRange);
                    if (!covered) tileGrid.forEachTileCoordParentTileRange(tile.tileCoord, findLoadedTiles, tmpTileRange, tmpExtent);
                }
                var canvasScale = tileResolution / viewResolution * pixelRatio / tilePixelRatio;
                // set forward and inverse pixel transforms
                (0, $afa6393b3817702c$export$f672e0b6f7222cd7)(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / pixelRatio, 1 / pixelRatio, rotation, -width / 2, -height / 2);
                var canvasTransform = (0, $afa6393b3817702c$export$f84e8e69fd4488a5)(this.pixelTransform);
                this.useContainer(target, canvasTransform, this.getBackground(frameState));
                var context = this.context;
                var canvas = context.canvas;
                (0, $afa6393b3817702c$export$bd70ea2a93c0fa4)(this.inversePixelTransform, this.pixelTransform);
                // set scale transform for calculating tile positions on the canvas
                (0, $afa6393b3817702c$export$f672e0b6f7222cd7)(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);
                if (canvas.width != width || canvas.height != height) {
                    canvas.width = width;
                    canvas.height = height;
                } else if (!this.containerReused) context.clearRect(0, 0, width, height);
                if (layerExtent) this.clipUnrotated(context, frameState, layerExtent);
                if (!tileSource.getInterpolate()) context.imageSmoothingEnabled = false;
                this.preRender(context, frameState);
                this.renderedTiles.length = 0;
                /** @type {Array<number>} */ var zs = Object.keys(tilesToDrawByZ).map(Number);
                zs.sort((0, $edee3659e50a93f4$export$fcb633242ef15540));
                var clips, clipZs, currentClip;
                if (layerState.opacity === 1 && (!this.containerReused || tileSource.getOpaque(frameState.viewState.projection))) zs = zs.reverse();
                else {
                    clips = [];
                    clipZs = [];
                }
                for(var i = zs.length - 1; i >= 0; --i){
                    var currentZ = zs[i];
                    var currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
                    var currentResolution = tileGrid.getResolution(currentZ);
                    var currentScale = currentResolution / tileResolution;
                    var dx1 = currentTilePixelSize[0] * currentScale * canvasScale;
                    var dy1 = currentTilePixelSize[1] * currentScale * canvasScale;
                    var originTileCoord = tileGrid.getTileCoordForCoordAndZ((0, $e86e0aa087890eb8$export$cb1538b07e6964ff)(canvasExtent), currentZ);
                    var originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
                    var origin = (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(this.tempTransform, [
                        tilePixelRatio * (originTileExtent[0] - canvasExtent[0]) / tileResolution,
                        tilePixelRatio * (canvasExtent[3] - originTileExtent[3]) / tileResolution
                    ]);
                    var tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
                    var tilesToDraw = tilesToDrawByZ[currentZ];
                    for(var tileCoordKey in tilesToDraw){
                        var tile1 = /** @type {import("../../ImageTile.js").default} */ tilesToDraw[tileCoordKey];
                        var tileCoord = tile1.tileCoord;
                        // Calculate integer positions and sizes so that tiles align
                        var xIndex = originTileCoord[1] - tileCoord[1];
                        var nextX = Math.round(origin[0] - (xIndex - 1) * dx1);
                        var yIndex = originTileCoord[2] - tileCoord[2];
                        var nextY = Math.round(origin[1] - (yIndex - 1) * dy1);
                        var x1 = Math.round(origin[0] - xIndex * dx1);
                        var y1 = Math.round(origin[1] - yIndex * dy1);
                        var w = nextX - x1;
                        var h = nextY - y1;
                        var transition = z === currentZ;
                        var inTransition1 = transition && tile1.getAlpha((0, $8b32fff2376556ef$export$5e82334337e0f204)(this), frameState.time) !== 1;
                        var contextSaved = false;
                        if (!inTransition1) {
                            if (clips) {
                                // Clip mask for regions in this tile that already filled by a higher z tile
                                currentClip = [
                                    x1,
                                    y1,
                                    x1 + w,
                                    y1,
                                    x1 + w,
                                    y1 + h,
                                    x1,
                                    y1 + h
                                ];
                                for(var i1 = 0, ii = clips.length; i1 < ii; ++i1)if (z !== currentZ && currentZ < clipZs[i1]) {
                                    var clip = clips[i1];
                                    if ((0, $e86e0aa087890eb8$export$7b0a31e10bbff018)([
                                        x1,
                                        y1,
                                        x1 + w,
                                        y1 + h
                                    ], [
                                        clip[0],
                                        clip[3],
                                        clip[4],
                                        clip[7]
                                    ])) {
                                        if (!contextSaved) {
                                            context.save();
                                            contextSaved = true;
                                        }
                                        context.beginPath();
                                        // counter-clockwise (outer ring) for current tile
                                        context.moveTo(currentClip[0], currentClip[1]);
                                        context.lineTo(currentClip[2], currentClip[3]);
                                        context.lineTo(currentClip[4], currentClip[5]);
                                        context.lineTo(currentClip[6], currentClip[7]);
                                        // clockwise (inner ring) for higher z tile
                                        context.moveTo(clip[6], clip[7]);
                                        context.lineTo(clip[4], clip[5]);
                                        context.lineTo(clip[2], clip[3]);
                                        context.lineTo(clip[0], clip[1]);
                                        context.clip();
                                    }
                                }
                                clips.push(currentClip);
                                clipZs.push(currentZ);
                            } else context.clearRect(x1, y1, w, h);
                        }
                        this.drawTileImage(tile1, frameState, x1, y1, w, h, tileGutter, transition);
                        if (clips && !inTransition1) {
                            if (contextSaved) context.restore();
                            this.renderedTiles.unshift(tile1);
                        } else this.renderedTiles.push(tile1);
                        this.updateUsedTiles(frameState.usedTiles, tileSource, tile1);
                    }
                }
                this.renderedRevision = sourceRevision;
                this.renderedResolution = tileResolution;
                this.extentChanged = !this.renderedExtent_ || !(0, $e86e0aa087890eb8$export$e9bab7fafb253603)(this.renderedExtent_, canvasExtent);
                this.renderedExtent_ = canvasExtent;
                this.renderedPixelRatio = pixelRatio;
                this.renderedProjection = projection;
                this.manageTilePyramid(frameState, tileSource, tileGrid, pixelRatio, projection, extent, z, tileLayer.getPreload());
                this.scheduleExpireCache(frameState, tileSource);
                this.postRender(context, frameState);
                if (layerState.extent) context.restore();
                context.imageSmoothingEnabled = true;
                if (canvasTransform !== canvas.style.transform) canvas.style.transform = canvasTransform;
                return this.container;
            }
        },
        {
            /**
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   */ key: "drawTileImage",
            value: function drawTileImage(tile, frameState, x, y, w, h, gutter, transition) {
                var image = this.getTileImage(tile);
                if (!image) return;
                var uid = (0, $8b32fff2376556ef$export$5e82334337e0f204)(this);
                var layerState = frameState.layerStatesArray[frameState.layerIndex];
                var alpha = layerState.opacity * (transition ? tile.getAlpha(uid, frameState.time) : 1);
                var alphaChanged = alpha !== this.context.globalAlpha;
                if (alphaChanged) {
                    this.context.save();
                    this.context.globalAlpha = alpha;
                }
                this.context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
                if (alphaChanged) this.context.restore();
                if (alpha !== layerState.opacity) frameState.animate = true;
                else if (transition) tile.endTransition(uid);
            }
        },
        {
            /**
   * @return {HTMLCanvasElement} Image
   */ key: "getImage",
            value: function getImage() {
                var context = this.context;
                return context ? context.canvas : null;
            }
        },
        {
            /**
   * Get the image from a tile.
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @protected
   */ key: "getTileImage",
            value: function getTileImage(tile) {
                return tile.getImage();
            }
        },
        {
            /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @protected
   */ key: "scheduleExpireCache",
            value: function scheduleExpireCache(frameState, tileSource) {
                if (tileSource.canExpireCache()) {
                    /**
       * @param {import("../../source/Tile.js").default} tileSource Tile source.
       * @param {import("../../Map.js").default} map Map.
       * @param {import("../../Map.js").FrameState} frameState Frame state.
       */ var postRenderFunction = (function(tileSource, map, frameState) {
                        var tileSourceKey = (0, $8b32fff2376556ef$export$5e82334337e0f204)(tileSource);
                        if (tileSourceKey in frameState.usedTiles) tileSource.expireCache(frameState.viewState.projection, frameState.usedTiles[tileSourceKey]);
                    }).bind(null, tileSource);
                    frameState.postRenderFunctions.push(/** @type {import("../../Map.js").PostRenderFunction} */ postRenderFunction);
                }
            }
        },
        {
            /**
   * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import('../../Tile.js').default} tile Tile.
   * @protected
   */ key: "updateUsedTiles",
            value: function updateUsedTiles(usedTiles, tileSource, tile) {
                // FIXME should we use tilesToDrawByZ instead?
                var tileSourceKey = (0, $8b32fff2376556ef$export$5e82334337e0f204)(tileSource);
                if (!(tileSourceKey in usedTiles)) usedTiles[tileSourceKey] = {};
                usedTiles[tileSourceKey][tile.getKey()] = true;
            }
        },
        {
            /**
   * Manage tile pyramid.
   * This function performs a number of functions related to the tiles at the
   * current zoom and lower zoom levels:
   * - registers idle tiles in frameState.wantedTiles so that they are not
   *   discarded by the tile queue
   * - enqueues missing tiles
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import("../../tilegrid/TileGrid.js").default} tileGrid Tile grid.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../proj/Projection.js").default} projection Projection.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {number} currentZ Current Z.
   * @param {number} preload Load low resolution tiles up to `preload` levels.
   * @param {function(import("../../Tile.js").default):void} [tileCallback] Tile callback.
   * @protected
   */ key: "manageTilePyramid",
            value: function manageTilePyramid(frameState, tileSource, tileGrid, pixelRatio, projection, extent, currentZ, preload, tileCallback) {
                var tileSourceKey = (0, $8b32fff2376556ef$export$5e82334337e0f204)(tileSource);
                if (!(tileSourceKey in frameState.wantedTiles)) frameState.wantedTiles[tileSourceKey] = {};
                var wantedTiles = frameState.wantedTiles[tileSourceKey];
                var tileQueue = frameState.tileQueue;
                var minZoom = tileGrid.getMinZoom();
                var rotation = frameState.viewState.rotation;
                var viewport = rotation ? (0, $e86e0aa087890eb8$export$4b7a6fb4002cd6ac)(frameState.viewState.center, frameState.viewState.resolution, rotation, frameState.size) : undefined;
                var tileCount = 0;
                var tile, tileRange, tileResolution, x, y, z;
                for(z = minZoom; z <= currentZ; ++z){
                    tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, tileRange);
                    tileResolution = tileGrid.getResolution(z);
                    for(x = tileRange.minX; x <= tileRange.maxX; ++x)for(y = tileRange.minY; y <= tileRange.maxY; ++y){
                        if (rotation && !tileGrid.tileCoordIntersectsViewport([
                            z,
                            x,
                            y
                        ], viewport)) continue;
                        if (currentZ - z <= preload) {
                            ++tileCount;
                            tile = tileSource.getTile(z, x, y, pixelRatio, projection);
                            if (tile.getState() == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).IDLE) {
                                wantedTiles[tile.getKey()] = true;
                                if (!tileQueue.isKeyQueued(tile.getKey())) tileQueue.enqueue([
                                    tile,
                                    tileSourceKey,
                                    tileGrid.getTileCoordCenter(tile.tileCoord),
                                    tileResolution
                                ]);
                            }
                            if (tileCallback !== undefined) tileCallback(tile);
                        } else tileSource.useTile(z, x, y, projection);
                    }
                }
                tileSource.updateCacheSize(tileCount, projection);
            }
        }
    ]);
    return CanvasTileLayerRenderer;
}((0, $633e710cc85fca5f$export$2e2bcd8739ae039));
var $a832cd8688bae570$export$2e2bcd8739ae039 = $a832cd8688bae570$var$CanvasTileLayerRenderer;


/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @extends BaseTileLayer<TileSourceType, CanvasTileLayerRenderer>
 * @api
 */ var $23aaf83eabeb7fa5$var$TileLayer = /*#__PURE__*/ function(BaseTileLayer) {
    "use strict";
    (0, $kcqLc._)(TileLayer, BaseTileLayer);
    var _super = (0, $4jYWU._)(TileLayer);
    function TileLayer(options) {
        (0, $5sFFs._)(this, TileLayer);
        return _super.call(this, options);
    }
    (0, $8O2fV._)(TileLayer, [
        {
            key: "createRenderer",
            value: function createRenderer() {
                return new (0, $a832cd8688bae570$export$2e2bcd8739ae039)(this);
            }
        }
    ]);
    return TileLayer;
}((0, $9dfc33056102de08$export$2e2bcd8739ae039));
var $23aaf83eabeb7fa5$export$2e2bcd8739ae039 = $23aaf83eabeb7fa5$var$TileLayer;


/**
 * @module ol/layer/Vector
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/layer/BaseVector
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");

var $82e0979b298e1815$exports = {};
!function(t, i) {
    $82e0979b298e1815$exports = i();
}($82e0979b298e1815$exports, function() {
    "use strict";
    function t(t, r, e, a, h) {
        !function t(n, r, e, a, h) {
            for(; a > e;){
                if (a - e > 600) {
                    var o = a - e + 1, s = r - e + 1, l = Math.log(o), f = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * f * (o - f) / o) * (s - o / 2 < 0 ? -1 : 1), m = Math.max(e, Math.floor(r - s * f / o + u)), c = Math.min(a, Math.floor(r + (o - s) * f / o + u));
                    t(n, r, m, c, h);
                }
                var p = n[r], d = e, x = a;
                for(i(n, e, r), h(n[a], p) > 0 && i(n, e, a); d < x;){
                    for(i(n, d, x), d++, x--; h(n[d], p) < 0;)d++;
                    for(; h(n[x], p) > 0;)x--;
                }
                0 === h(n[e], p) ? i(n, e, x) : i(n, ++x, a), x <= r && (e = x + 1), r <= x && (a = x - 1);
            }
        }(t, r, e || 0, a || t.length - 1, h || n);
    }
    function i(t, i, n) {
        var r = t[i];
        t[i] = t[n], t[n] = r;
    }
    function n(t, i) {
        return t < i ? -1 : t > i ? 1 : 0;
    }
    var r = function r(t) {
        void 0 === t && (t = 9), this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
    };
    function e(t, i, n) {
        if (!n) return i.indexOf(t);
        for(var r = 0; r < i.length; r++)if (n(t, i[r])) return r;
        return -1;
    }
    function a(t, i) {
        h(t, 0, t.children.length, i, t);
    }
    function h(t, i, n, r, e) {
        e || (e = p(null)), e.minX = 1 / 0, e.minY = 1 / 0, e.maxX = -1 / 0, e.maxY = -1 / 0;
        for(var a = i; a < n; a++){
            var h = t.children[a];
            o(e, t.leaf ? r(h) : h);
        }
        return e;
    }
    function o(t, i) {
        return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
    }
    function s(t, i) {
        return t.minX - i.minX;
    }
    function l(t, i) {
        return t.minY - i.minY;
    }
    function f(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function u(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function m(t, i) {
        return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
    }
    function c(t, i) {
        return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
    }
    function p(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function d(i, n, r, e, a) {
        for(var h = [
            n,
            r
        ]; h.length;)if (!((r = h.pop()) - (n = h.pop()) <= e)) {
            var o = n + Math.ceil((r - n) / e / 2) * e;
            t(i, o, n, r, a), h.push(n, o, o, r);
        }
    }
    return r.prototype.all = function() {
        return this._all(this.data, []);
    }, r.prototype.search = function(t) {
        var i = this.data, n = [];
        if (!c(t, i)) return n;
        for(var r = this.toBBox, e = []; i;){
            for(var a = 0; a < i.children.length; a++){
                var h = i.children[a], o = i.leaf ? r(h) : h;
                c(t, o) && (i.leaf ? n.push(h) : m(t, o) ? this._all(h, n) : e.push(h));
            }
            i = e.pop();
        }
        return n;
    }, r.prototype.collides = function(t) {
        var i = this.data;
        if (!c(t, i)) return !1;
        for(var n = []; i;){
            for(var r = 0; r < i.children.length; r++){
                var e = i.children[r], a = i.leaf ? this.toBBox(e) : e;
                if (c(t, a)) {
                    if (i.leaf || m(t, a)) return !0;
                    n.push(e);
                }
            }
            i = n.pop();
        }
        return !1;
    }, r.prototype.load = function(t) {
        if (!t || !t.length) return this;
        if (t.length < this._minEntries) {
            for(var i = 0; i < t.length; i++)this.insert(t[i]);
            return this;
        }
        var n = this._build(t.slice(), 0, t.length - 1, 0);
        if (this.data.children.length) {
            if (this.data.height === n.height) this._splitRoot(this.data, n);
            else {
                if (this.data.height < n.height) {
                    var r = this.data;
                    this.data = n, n = r;
                }
                this._insert(n, this.data.height - n.height - 1, !0);
            }
        } else this.data = n;
        return this;
    }, r.prototype.insert = function(t) {
        return t && this._insert(t, this.data.height - 1), this;
    }, r.prototype.clear = function() {
        return this.data = p([]), this;
    }, r.prototype.remove = function(t, i) {
        if (!t) return this;
        for(var n, r, a, h = this.data, o = this.toBBox(t), s = [], l = []; h || s.length;){
            if (h || (h = s.pop(), r = s[s.length - 1], n = l.pop(), a = !0), h.leaf) {
                var f = e(t, h.children, i);
                if (-1 !== f) return h.children.splice(f, 1), s.push(h), this._condense(s), this;
            }
            a || h.leaf || !m(h, o) ? r ? (n++, h = r.children[n], a = !1) : h = null : (s.push(h), l.push(n), n = 0, r = h, h = h.children[0]);
        }
        return this;
    }, r.prototype.toBBox = function(t) {
        return t;
    }, r.prototype.compareMinX = function(t, i) {
        return t.minX - i.minX;
    }, r.prototype.compareMinY = function(t, i) {
        return t.minY - i.minY;
    }, r.prototype.toJSON = function() {
        return this.data;
    }, r.prototype.fromJSON = function(t) {
        return this.data = t, this;
    }, r.prototype._all = function(t, i) {
        for(var n = []; t;)t.leaf ? i.push.apply(i, t.children) : n.push.apply(n, t.children), t = n.pop();
        return i;
    }, r.prototype._build = function(t, i, n, r) {
        var e, h = n - i + 1, o = this._maxEntries;
        if (h <= o) return a(e = p(t.slice(i, n + 1)), this.toBBox), e;
        r || (r = Math.ceil(Math.log(h) / Math.log(o)), o = Math.ceil(h / Math.pow(o, r - 1))), (e = p([])).leaf = !1, e.height = r;
        var s = Math.ceil(h / o), l = s * Math.ceil(Math.sqrt(o));
        d(t, i, n, l, this.compareMinX);
        for(var f = i; f <= n; f += l){
            var u = Math.min(f + l - 1, n);
            d(t, f, u, s, this.compareMinY);
            for(var m = f; m <= u; m += s){
                var c = Math.min(m + s - 1, u);
                e.children.push(this._build(t, m, c, r - 1));
            }
        }
        return a(e, this.toBBox), e;
    }, r.prototype._chooseSubtree = function(t, i, n, r) {
        for(; r.push(i), !i.leaf && r.length - 1 !== n;){
            for(var e = 1 / 0, a = 1 / 0, h = void 0, o = 0; o < i.children.length; o++){
                var s = i.children[o], l = f(s), u = (m = t, c = s, (Math.max(c.maxX, m.maxX) - Math.min(c.minX, m.minX)) * (Math.max(c.maxY, m.maxY) - Math.min(c.minY, m.minY)) - l);
                u < a ? (a = u, e = l < e ? l : e, h = s) : u === a && l < e && (e = l, h = s);
            }
            i = h || i.children[0];
        }
        var m, c;
        return i;
    }, r.prototype._insert = function(t, i, n) {
        var r = n ? t : this.toBBox(t), e = [], a = this._chooseSubtree(r, this.data, i, e);
        for(a.children.push(t), o(a, r); i >= 0 && e[i].children.length > this._maxEntries;)this._split(e, i), i--;
        this._adjustParentBBoxes(r, e, i);
    }, r.prototype._split = function(t, i) {
        var n = t[i], r = n.children.length, e = this._minEntries;
        this._chooseSplitAxis(n, e, r);
        var h = this._chooseSplitIndex(n, e, r), o = p(n.children.splice(h, n.children.length - h));
        o.height = n.height, o.leaf = n.leaf, a(n, this.toBBox), a(o, this.toBBox), i ? t[i - 1].children.push(o) : this._splitRoot(n, o);
    }, r.prototype._splitRoot = function(t, i) {
        this.data = p([
            t,
            i
        ]), this.data.height = t.height + 1, this.data.leaf = !1, a(this.data, this.toBBox);
    }, r.prototype._chooseSplitIndex = function(t, i, n) {
        for(var r, e, a, o, s, l, u, m = 1 / 0, c = 1 / 0, p = i; p <= n - i; p++){
            var d = h(t, 0, p, this.toBBox), x = h(t, p, n, this.toBBox), v = (e = d, a = x, o = void 0, s = void 0, l = void 0, u = void 0, o = Math.max(e.minX, a.minX), s = Math.max(e.minY, a.minY), l = Math.min(e.maxX, a.maxX), u = Math.min(e.maxY, a.maxY), Math.max(0, l - o) * Math.max(0, u - s)), M = f(d) + f(x);
            v < m ? (m = v, r = p, c = M < c ? M : c) : v === m && M < c && (c = M, r = p);
        }
        return r || n - i;
    }, r.prototype._chooseSplitAxis = function(t, i, n) {
        var r = t.leaf ? this.compareMinX : s, e = t.leaf ? this.compareMinY : l;
        this._allDistMargin(t, i, n, r) < this._allDistMargin(t, i, n, e) && t.children.sort(r);
    }, r.prototype._allDistMargin = function(t, i, n, r) {
        t.children.sort(r);
        for(var e = this.toBBox, a = h(t, 0, i, e), s = h(t, n - i, n, e), l = u(a) + u(s), f = i; f < n - i; f++){
            var m = t.children[f];
            o(a, t.leaf ? e(m) : m), l += u(a);
        }
        for(var c = n - i - 1; c >= i; c--){
            var p = t.children[c];
            o(s, t.leaf ? e(p) : p), l += u(s);
        }
        return l;
    }, r.prototype._adjustParentBBoxes = function(t, i, n) {
        for(var r = n; r >= 0; r--)o(i[r], t);
    }, r.prototype._condense = function(t) {
        for(var i = t.length - 1, n = void 0; i >= 0; i--)0 === t[i].children.length ? i > 0 ? (n = t[i - 1].children).splice(n.indexOf(t[i]), 1) : this.clear() : a(t[i], this.toBBox);
    }, r;
});


/**
 * @module ol/style/Style
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
/**
 * @module ol/style/Circle
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/style/RegularShape
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");

/**
 * @module ol/style/Image
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");


/**
 * @typedef {Object} Options
 * @property {number} opacity Opacity.
 * @property {boolean} rotateWithView If the image should get rotated with the view.
 * @property {number} rotation Rotation.
 * @property {number|import("../size.js").Size} scale Scale.
 * @property {Array<number>} displacement Displacement.
 * @property {"declutter"|"obstacle"|"none"|undefined} declutterMode Declutter mode: `declutter`, `obstacle`, 'none */ /**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */ var $372eeb7b0f34d7f9$var$ImageStyle = /*#__PURE__*/ function() {
    "use strict";
    function ImageStyle(options) {
        (0, $5sFFs._)(this, ImageStyle);
        /**
     * @private
     * @type {number}
     */ this.opacity_ = options.opacity;
        /**
     * @private
     * @type {boolean}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $9fd3f8f53b8c7a01$export$a71a825ff42fb8e1)(options.scale);
        /**
     * @private
     * @type {Array<number>}
     */ this.displacement_ = options.displacement;
        /**
     * @private
     * @type {"declutter"|"obstacle"|"none"|undefined}
     */ this.declutterMode_ = options.declutterMode;
    }
    (0, $8O2fV._)(ImageStyle, [
        {
            /**
   * Clones the style.
   * @return {ImageStyle} The cloned style.
   * @api
   */ key: "clone",
            value: function clone() {
                var scale = this.getScale();
                return new ImageStyle({
                    opacity: this.getOpacity(),
                    scale: Array.isArray(scale) ? scale.slice() : scale,
                    rotation: this.getRotation(),
                    rotateWithView: this.getRotateWithView(),
                    displacement: this.getDisplacement().slice(),
                    declutterMode: this.getDeclutterMode()
                });
            }
        },
        {
            /**
   * Get the symbolizer opacity.
   * @return {number} Opacity.
   * @api
   */ key: "getOpacity",
            value: function getOpacity() {
                return this.opacity_;
            }
        },
        {
            /**
   * Determine whether the symbolizer rotates with the map.
   * @return {boolean} Rotate with map.
   * @api
   */ key: "getRotateWithView",
            value: function getRotateWithView() {
                return this.rotateWithView_;
            }
        },
        {
            /**
   * Get the symoblizer rotation.
   * @return {number} Rotation.
   * @api
   */ key: "getRotation",
            value: function getRotation() {
                return this.rotation_;
            }
        },
        {
            /**
   * Get the symbolizer scale.
   * @return {number|import("../size.js").Size} Scale.
   * @api
   */ key: "getScale",
            value: function getScale() {
                return this.scale_;
            }
        },
        {
            /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ key: "getScaleArray",
            value: function getScaleArray() {
                return this.scaleArray_;
            }
        },
        {
            /**
   * Get the displacement of the shape
   * @return {Array<number>} Shape's center displacement
   * @api
   */ key: "getDisplacement",
            value: function getDisplacement() {
                return this.displacement_;
            }
        },
        {
            /**
   * Get the declutter mode of the shape
   * @return {"declutter"|"obstacle"|"none"|undefined} Shape's declutter mode
   * @api
   */ key: "getDeclutterMode",
            value: function getDeclutterMode() {
                return this.declutterMode_;
            }
        },
        {
            /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @abstract
   * @return {Array<number>} Anchor.
   */ key: "getAnchor",
            value: function getAnchor() {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Get the image element for the symbolizer.
   * @abstract
   * @param {number} pixelRatio Pixel ratio.
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ key: "getImage",
            value: function getImage(pixelRatio) {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * @abstract
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ key: "getHitDetectionImage",
            value: function getHitDetectionImage() {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */ key: "getPixelRatio",
            value: function getPixelRatio(pixelRatio) {
                return 1;
            }
        },
        {
            /**
   * @abstract
   * @return {import("../ImageState.js").default} Image state.
   */ key: "getImageState",
            value: function getImageState() {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * @abstract
   * @return {import("../size.js").Size} Image size.
   */ key: "getImageSize",
            value: function getImageSize() {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Get the origin of the symbolizer.
   * @abstract
   * @return {Array<number>} Origin.
   */ key: "getOrigin",
            value: function getOrigin() {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Get the size of the symbolizer (in pixels).
   * @abstract
   * @return {import("../size.js").Size} Size.
   */ key: "getSize",
            value: function getSize() {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Set the displacement.
   *
   * @param {Array<number>} displacement Displacement.
   * @api
   */ key: "setDisplacement",
            value: function setDisplacement(displacement) {
                this.displacement_ = displacement;
            }
        },
        {
            /**
   * Set the opacity.
   *
   * @param {number} opacity Opacity.
   * @api
   */ key: "setOpacity",
            value: function setOpacity(opacity) {
                this.opacity_ = opacity;
            }
        },
        {
            /**
   * Set whether to rotate the style with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ key: "setRotateWithView",
            value: function setRotateWithView(rotateWithView) {
                this.rotateWithView_ = rotateWithView;
            }
        },
        {
            /**
   * Set the rotation.
   *
   * @param {number} rotation Rotation.
   * @api
   */ key: "setRotation",
            value: function setRotation(rotation) {
                this.rotation_ = rotation;
            }
        },
        {
            /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */ key: "setScale",
            value: function setScale(scale) {
                this.scale_ = scale;
                this.scaleArray_ = (0, $9fd3f8f53b8c7a01$export$a71a825ff42fb8e1)(scale);
            }
        },
        {
            /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ key: "listenImageChange",
            value: function listenImageChange(listener) {
                (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Load not yet loaded URI.
   * @abstract
   */ key: "load",
            value: function load() {
                (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ key: "unlistenImageChange",
            value: function unlistenImageChange(listener) {
                (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        }
    ]);
    return ImageStyle;
}();
var $372eeb7b0f34d7f9$export$2e2bcd8739ae039 = $372eeb7b0f34d7f9$var$ImageStyle;



/**
 * @module ol/colorlike
 */ 
function $11e0a43141029edf$export$dc5b1400ac3a10a8(color) {
    if (Array.isArray(color)) return (0, $03ff7455ee88c2e9$export$f84e8e69fd4488a5)(color);
    return color;
}




/**
 * Specify radius for regular polygons, or radius1 and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} [radius] Radius of a regular polygon.
 * @property {number} [radius1] First radius of a star. Ignored if radius is set.
 * @property {number} [radius2] Second radius of a star.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's points facing up.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the shape in pixels.
 * Positive values will shift the shape right and up.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius`, `radius1` and `radius2`.
 * @property {"declutter"|"obstacle"|"none"|undefined} [declutterMode] Declutter mode.
 */ /**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike|undefined} strokeStyle StrokeStyle.
 * @property {number} strokeWidth StrokeWidth.
 * @property {number} size Size.
 * @property {CanvasLineCap} lineCap LineCap.
 * @property {Array<number>|null} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} miterLimit MiterLimit.
 */ /**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when `radius1` and
 * `radius2` are provided.
 * @api
 */ var $03a6b05da0b86d5c$var$RegularShape = /*#__PURE__*/ function(ImageStyle) {
    "use strict";
    (0, $kcqLc._)(RegularShape, ImageStyle);
    var _super = (0, $4jYWU._)(RegularShape);
    function RegularShape(options) {
        (0, $5sFFs._)(this, RegularShape);
        var _this;
        /**
     * @type {boolean}
     */ var rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        _this = _super.call(this, {
            opacity: 1,
            rotateWithView: rotateWithView,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement>}
     */ _this.canvases_;
        /**
     * @private
     * @type {HTMLCanvasElement|null}
     */ _this.hitDetectionCanvas_ = null;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ _this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {Array<number>}
     */ _this.origin_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ _this.points_ = options.points;
        /**
     * @protected
     * @type {number}
     */ _this.radius_ = options.radius !== undefined ? options.radius : options.radius1;
        /**
     * @private
     * @type {number|undefined}
     */ _this.radius2_ = options.radius2;
        /**
     * @private
     * @type {number}
     */ _this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ _this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ _this.size_;
        /**
     * @private
     * @type {RenderOptions}
     */ _this.renderOptions_;
        _this.render();
        return _this;
    }
    (0, $8O2fV._)(RegularShape, [
        {
            /**
   * Clones the style.
   * @return {RegularShape} The cloned style.
   * @api
   */ key: "clone",
            value: function clone() {
                var scale = this.getScale();
                var style = new RegularShape({
                    fill: this.getFill() ? this.getFill().clone() : undefined,
                    points: this.getPoints(),
                    radius: this.getRadius(),
                    radius2: this.getRadius2(),
                    angle: this.getAngle(),
                    stroke: this.getStroke() ? this.getStroke().clone() : undefined,
                    rotation: this.getRotation(),
                    rotateWithView: this.getRotateWithView(),
                    scale: Array.isArray(scale) ? scale.slice() : scale,
                    displacement: this.getDisplacement().slice(),
                    declutterMode: this.getDeclutterMode()
                });
                style.setOpacity(this.getOpacity());
                return style;
            }
        },
        {
            /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   */ key: "getAnchor",
            value: function getAnchor() {
                var size = this.size_;
                var displacement = this.getDisplacement();
                var scale = this.getScaleArray();
                // anchor is scaled by renderer but displacement should not be scaled
                // so divide by scale here
                return [
                    size[0] / 2 - displacement[0] / scale[0],
                    size[1] / 2 + displacement[1] / scale[1]
                ];
            }
        },
        {
            /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */ key: "getAngle",
            value: function getAngle() {
                return this.angle_;
            }
        },
        {
            /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ key: "getFill",
            value: function getFill() {
                return this.fill_;
            }
        },
        {
            /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ key: "setFill",
            value: function setFill(fill) {
                this.fill_ = fill;
                this.render();
            }
        },
        {
            /**
   * @return {HTMLCanvasElement} Image element.
   */ key: "getHitDetectionImage",
            value: function getHitDetectionImage() {
                if (!this.hitDetectionCanvas_) this.hitDetectionCanvas_ = this.createHitDetectionCanvas_(this.renderOptions_);
                return this.hitDetectionCanvas_;
            }
        },
        {
            /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLCanvasElement} Image or Canvas element.
   * @api
   */ key: "getImage",
            value: function getImage(pixelRatio) {
                var image = this.canvases_[pixelRatio];
                if (!image) {
                    var renderOptions = this.renderOptions_;
                    var context = (0, $e000035bb4c81589$export$9e05d10eae75c464)(renderOptions.size * pixelRatio, renderOptions.size * pixelRatio);
                    this.draw_(renderOptions, context, pixelRatio);
                    image = context.canvas;
                    this.canvases_[pixelRatio] = image;
                }
                return image;
            }
        },
        {
            /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */ key: "getPixelRatio",
            value: function getPixelRatio(pixelRatio) {
                return pixelRatio;
            }
        },
        {
            /**
   * @return {import("../size.js").Size} Image size.
   */ key: "getImageSize",
            value: function getImageSize() {
                return this.size_;
            }
        },
        {
            /**
   * @return {import("../ImageState.js").default} Image state.
   */ key: "getImageState",
            value: function getImageState() {
                return (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED;
            }
        },
        {
            /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   */ key: "getOrigin",
            value: function getOrigin() {
                return this.origin_;
            }
        },
        {
            /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */ key: "getPoints",
            value: function getPoints() {
                return this.points_;
            }
        },
        {
            /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */ key: "getRadius",
            value: function getRadius() {
                return this.radius_;
            }
        },
        {
            /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */ key: "getRadius2",
            value: function getRadius2() {
                return this.radius2_;
            }
        },
        {
            /**
   * Get the size of the symbolizer (in pixels).
   * @return {import("../size.js").Size} Size.
   * @api
   */ key: "getSize",
            value: function getSize() {
                return this.size_;
            }
        },
        {
            /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ key: "getStroke",
            value: function getStroke() {
                return this.stroke_;
            }
        },
        {
            /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ key: "setStroke",
            value: function setStroke(stroke) {
                this.stroke_ = stroke;
                this.render();
            }
        },
        {
            /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ key: "listenImageChange",
            value: function listenImageChange(listener) {}
        },
        {
            /**
   * Load not yet loaded URI.
   */ key: "load",
            value: function load() {}
        },
        {
            /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ key: "unlistenImageChange",
            value: function unlistenImageChange(listener) {}
        },
        {
            /**
   * Calculate additional canvas size needed for the miter.
   * @param {string} lineJoin Line join
   * @param {number} strokeWidth Stroke width
   * @param {number} miterLimit Miter limit
   * @return {number} Additional canvas size needed
   * @private
   */ key: "calculateLineJoinSize_",
            value: function calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit) {
                if (strokeWidth === 0 || this.points_ === Infinity || lineJoin !== "bevel" && lineJoin !== "miter") return strokeWidth;
                // m  | ^
                // i  | |\                  .
                // t >|  #\
                // e  | |\ \              .
                // r      \s\
                //      |  \t\          .                 .
                //          \r\                      .   .
                //      |    \o\      .          .  . . .
                //          e \k\            .  .    . .
                //      |      \e\  .    .  .       . .
                //       d      \ \  .  .          . .
                //      | _ _a_ _\#  .            . .
                //   r1          / `             . .
                //      |                       . .
                //       b     /               . .
                //      |                     . .
                //           / r2            . .
                //      |                        .   .
                //         /                           .   .
                //      |α                                   .   .
                //       /                                         .   .
                //      ° center
                var r1 = this.radius_;
                var r2 = this.radius2_ === undefined ? r1 : this.radius2_;
                if (r1 < r2) {
                    var tmp = r1;
                    r1 = r2;
                    r2 = tmp;
                }
                var points = this.radius2_ === undefined ? this.points_ : this.points_ * 2;
                var alpha = 2 * Math.PI / points;
                var a = r2 * Math.sin(alpha);
                var b = Math.sqrt(r2 * r2 - a * a);
                var d = r1 - b;
                var e = Math.sqrt(a * a + d * d);
                var miterRatio = e / a;
                if (lineJoin === "miter" && miterRatio <= miterLimit) return miterRatio * strokeWidth;
                // Calculate the distance from center to the stroke corner where
                // it was cut short because of the miter limit.
                //              l
                //        ----+---- <= distance from center to here is maxr
                //       /####|k ##\
                //      /#####^#####\
                //     /#### /+\# s #\
                //    /### h/+++\# t #\
                //   /### t/+++++\# r #\
                //  /### a/+++++++\# o #\
                // /### p/++ fill +\# k #\
                ///#### /+++++^+++++\# e #\
                //#####/+++++/+\+++++\#####\
                var k = strokeWidth / 2 / miterRatio;
                var l = strokeWidth / 2 * (d / e);
                var maxr = Math.sqrt((r1 + k) * (r1 + k) + l * l);
                var bevelAdd = maxr - r1;
                if (this.radius2_ === undefined || lineJoin === "bevel") return bevelAdd * 2;
                // If outer miter is over the miter limit the inner miter may reach through the
                // center and be longer than the bevel, same calculation as above but swap r1 / r2.
                var aa = r1 * Math.sin(alpha);
                var bb = Math.sqrt(r1 * r1 - aa * aa);
                var dd = r2 - bb;
                var ee = Math.sqrt(aa * aa + dd * dd);
                var innerMiterRatio = ee / aa;
                if (innerMiterRatio <= miterLimit) {
                    var innerLength = innerMiterRatio * strokeWidth / 2 - r2 - r1;
                    return 2 * Math.max(bevelAdd, innerLength);
                }
                return bevelAdd * 2;
            }
        },
        {
            /**
   * @return {RenderOptions}  The render options
   * @protected
   */ key: "createRenderOptions",
            value: function createRenderOptions() {
                var lineCap = (0, $069ac9f2344fe90f$export$17bd0c38d6ae694e);
                var lineJoin = (0, $069ac9f2344fe90f$export$365eb9648cf19bd0);
                var miterLimit = 0;
                var lineDash = null;
                var lineDashOffset = 0;
                var strokeStyle;
                var strokeWidth = 0;
                if (this.stroke_) {
                    var _this_stroke__getColor;
                    strokeStyle = (0, $11e0a43141029edf$export$dc5b1400ac3a10a8)((_this_stroke__getColor = this.stroke_.getColor()) !== null && _this_stroke__getColor !== void 0 ? _this_stroke__getColor : (0, $069ac9f2344fe90f$export$1eb2eaecacf2031e));
                    var _this_stroke__getWidth;
                    strokeWidth = (_this_stroke__getWidth = this.stroke_.getWidth()) !== null && _this_stroke__getWidth !== void 0 ? _this_stroke__getWidth : (0, $069ac9f2344fe90f$export$79661f132c62010e);
                    lineDash = this.stroke_.getLineDash();
                    var _this_stroke__getLineDashOffset;
                    lineDashOffset = (_this_stroke__getLineDashOffset = this.stroke_.getLineDashOffset()) !== null && _this_stroke__getLineDashOffset !== void 0 ? _this_stroke__getLineDashOffset : 0;
                    var _this_stroke__getLineJoin;
                    lineJoin = (_this_stroke__getLineJoin = this.stroke_.getLineJoin()) !== null && _this_stroke__getLineJoin !== void 0 ? _this_stroke__getLineJoin : (0, $069ac9f2344fe90f$export$365eb9648cf19bd0);
                    var _this_stroke__getLineCap;
                    lineCap = (_this_stroke__getLineCap = this.stroke_.getLineCap()) !== null && _this_stroke__getLineCap !== void 0 ? _this_stroke__getLineCap : (0, $069ac9f2344fe90f$export$17bd0c38d6ae694e);
                    var _this_stroke__getMiterLimit;
                    miterLimit = (_this_stroke__getMiterLimit = this.stroke_.getMiterLimit()) !== null && _this_stroke__getMiterLimit !== void 0 ? _this_stroke__getMiterLimit : (0, $069ac9f2344fe90f$export$80c1c01844597b7b);
                }
                var add = this.calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit);
                var maxRadius = Math.max(this.radius_, this.radius2_ || 0);
                var size = Math.ceil(2 * maxRadius + add);
                return {
                    strokeStyle: strokeStyle,
                    strokeWidth: strokeWidth,
                    size: size,
                    lineCap: lineCap,
                    lineDash: lineDash,
                    lineDashOffset: lineDashOffset,
                    lineJoin: lineJoin,
                    miterLimit: miterLimit
                };
            }
        },
        {
            /**
   * @protected
   */ key: "render",
            value: function render() {
                this.renderOptions_ = this.createRenderOptions();
                var size = this.renderOptions_.size;
                this.canvases_ = {};
                this.hitDetectionCanvas_ = null;
                this.size_ = [
                    size,
                    size
                ];
            }
        },
        {
            /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The rendering context.
   * @param {number} pixelRatio The pixel ratio.
   */ key: "draw_",
            value: function draw_(renderOptions, context, pixelRatio) {
                context.scale(pixelRatio, pixelRatio);
                // set origin to canvas center
                context.translate(renderOptions.size / 2, renderOptions.size / 2);
                this.createPath_(context);
                if (this.fill_) {
                    var color = this.fill_.getColor();
                    if (color === null) color = (0, $069ac9f2344fe90f$export$c495d52ee3fd74b2);
                    context.fillStyle = (0, $11e0a43141029edf$export$dc5b1400ac3a10a8)(color);
                    context.fill();
                }
                if (renderOptions.strokeStyle) {
                    context.strokeStyle = renderOptions.strokeStyle;
                    context.lineWidth = renderOptions.strokeWidth;
                    if (renderOptions.lineDash) {
                        context.setLineDash(renderOptions.lineDash);
                        context.lineDashOffset = renderOptions.lineDashOffset;
                    }
                    context.lineCap = renderOptions.lineCap;
                    context.lineJoin = renderOptions.lineJoin;
                    context.miterLimit = renderOptions.miterLimit;
                    context.stroke();
                }
            }
        },
        {
            /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @return {HTMLCanvasElement} Canvas containing the icon
   */ key: "createHitDetectionCanvas_",
            value: function createHitDetectionCanvas_(renderOptions) {
                var context;
                if (this.fill_) {
                    var color = this.fill_.getColor();
                    // determine if fill is transparent (or pattern or gradient)
                    var opacity = 0;
                    if (typeof color === "string") color = (0, $03ff7455ee88c2e9$export$75093a47a9fa838d)(color);
                    if (color === null) opacity = 1;
                    else if (Array.isArray(color)) opacity = color.length === 4 ? color[3] : 1;
                    if (opacity === 0) {
                        // if a transparent fill style is set, create an extra hit-detection image
                        // with a default fill style
                        context = (0, $e000035bb4c81589$export$9e05d10eae75c464)(renderOptions.size, renderOptions.size);
                        this.drawHitDetectionCanvas_(renderOptions, context);
                    }
                }
                return context ? context.canvas : this.getImage(1);
            }
        },
        {
            /**
   * @private
   * @param {CanvasRenderingContext2D} context The context to draw in.
   */ key: "createPath_",
            value: function createPath_(context) {
                var points = this.points_;
                var radius = this.radius_;
                if (points === Infinity) context.arc(0, 0, radius, 0, 2 * Math.PI);
                else {
                    var radius2 = this.radius2_ === undefined ? radius : this.radius2_;
                    if (this.radius2_ !== undefined) points *= 2;
                    var startAngle = this.angle_ - Math.PI / 2;
                    var step = 2 * Math.PI / points;
                    for(var i = 0; i < points; i++){
                        var angle0 = startAngle + i * step;
                        var radiusC = i % 2 === 0 ? radius : radius2;
                        context.lineTo(radiusC * Math.cos(angle0), radiusC * Math.sin(angle0));
                    }
                    context.closePath();
                }
            }
        },
        {
            /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The context.
   */ key: "drawHitDetectionCanvas_",
            value: function drawHitDetectionCanvas_(renderOptions, context) {
                // set origin to canvas center
                context.translate(renderOptions.size / 2, renderOptions.size / 2);
                this.createPath_(context);
                context.fillStyle = (0, $069ac9f2344fe90f$export$c495d52ee3fd74b2);
                context.fill();
                if (renderOptions.strokeStyle) {
                    context.strokeStyle = renderOptions.strokeStyle;
                    context.lineWidth = renderOptions.strokeWidth;
                    if (renderOptions.lineDash) {
                        context.setLineDash(renderOptions.lineDash);
                        context.lineDashOffset = renderOptions.lineDashOffset;
                    }
                    context.lineJoin = renderOptions.lineJoin;
                    context.miterLimit = renderOptions.miterLimit;
                    context.stroke();
                }
            }
        }
    ]);
    return RegularShape;
}((0, $372eeb7b0f34d7f9$export$2e2bcd8739ae039));
var $03a6b05da0b86d5c$export$2e2bcd8739ae039 = $03a6b05da0b86d5c$var$RegularShape;


/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 * @property {"declutter"|"obstacle"|"none"|undefined} [declutterMode] Declutter mode
 */ /**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */ var $957ba2f77c353f92$var$CircleStyle = /*#__PURE__*/ function(RegularShape) {
    "use strict";
    (0, $kcqLc._)(CircleStyle, RegularShape);
    var _super = (0, $4jYWU._)(CircleStyle);
    function CircleStyle(options) {
        (0, $5sFFs._)(this, CircleStyle);
        options = options ? options : {
            radius: 5
        };
        return _super.call(this, {
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            scale: options.scale !== undefined ? options.scale : 1,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
    }
    (0, $8O2fV._)(CircleStyle, [
        {
            /**
   * Clones the style.
   * @return {CircleStyle} The cloned style.
   * @api
   */ key: "clone",
            value: function clone() {
                var scale = this.getScale();
                var style = new CircleStyle({
                    fill: this.getFill() ? this.getFill().clone() : undefined,
                    stroke: this.getStroke() ? this.getStroke().clone() : undefined,
                    radius: this.getRadius(),
                    scale: Array.isArray(scale) ? scale.slice() : scale,
                    rotation: this.getRotation(),
                    rotateWithView: this.getRotateWithView(),
                    displacement: this.getDisplacement().slice(),
                    declutterMode: this.getDeclutterMode()
                });
                style.setOpacity(this.getOpacity());
                return style;
            }
        },
        {
            /**
   * Set the circle radius.
   *
   * @param {number} radius Circle radius.
   * @api
   */ key: "setRadius",
            value: function setRadius(radius) {
                this.radius_ = radius;
                this.render();
            }
        }
    ]);
    return CircleStyle;
}((0, $03a6b05da0b86d5c$export$2e2bcd8739ae039));
var $957ba2f77c353f92$export$2e2bcd8739ae039 = $957ba2f77c353f92$var$CircleStyle;


/**
 * @module ol/style/Fill
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike|null} [color=null] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 */ /**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
var $3f3dc9dd8a85276f$var$Fill = /*#__PURE__*/ function() {
    "use strict";
    function Fill(options) {
        (0, $5sFFs._)(this, Fill);
        options = options || {};
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike|null}
     */ this.color_ = options.color !== undefined ? options.color : null;
    }
    (0, $8O2fV._)(Fill, [
        {
            /**
   * Clones the style. The color is not cloned if it is an {@link module:ol/colorlike~ColorLike}.
   * @return {Fill} The cloned style.
   * @api
   */ key: "clone",
            value: function clone() {
                var color = this.getColor();
                return new Fill({
                    color: Array.isArray(color) ? color.slice() : color || undefined
                });
            }
        },
        {
            /**
   * Get the fill color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|null} Color.
   * @api
   */ key: "getColor",
            value: function getColor() {
                return this.color_;
            }
        },
        {
            /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|null} color Color.
   * @api
   */ key: "setColor",
            value: function setColor(color) {
                this.color_ = color;
            }
        }
    ]);
    return Fill;
}();
var $3f3dc9dd8a85276f$export$2e2bcd8739ae039 = $3f3dc9dd8a85276f$var$Fill;


/**
 * @module ol/style/Stroke
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {CanvasLineCap} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {CanvasLineJoin} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `null` (no dash).
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [width] Width.
 */ /**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
var $f2ca0e669183cbd3$var$Stroke = /*#__PURE__*/ function() {
    "use strict";
    function Stroke(options) {
        (0, $5sFFs._)(this, Stroke);
        options = options || {};
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
     */ this.color_ = options.color !== undefined ? options.color : null;
        /**
     * @private
     * @type {CanvasLineCap|undefined}
     */ this.lineCap_ = options.lineCap;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lineDashOffset_ = options.lineDashOffset;
        /**
     * @private
     * @type {CanvasLineJoin|undefined}
     */ this.lineJoin_ = options.lineJoin;
        /**
     * @private
     * @type {number|undefined}
     */ this.miterLimit_ = options.miterLimit;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = options.width;
    }
    (0, $8O2fV._)(Stroke, [
        {
            /**
   * Clones the style.
   * @return {Stroke} The cloned style.
   * @api
   */ key: "clone",
            value: function clone() {
                var color = this.getColor();
                return new Stroke({
                    color: Array.isArray(color) ? color.slice() : color || undefined,
                    lineCap: this.getLineCap(),
                    lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
                    lineDashOffset: this.getLineDashOffset(),
                    lineJoin: this.getLineJoin(),
                    miterLimit: this.getMiterLimit(),
                    width: this.getWidth()
                });
            }
        },
        {
            /**
   * Get the stroke color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
   * @api
   */ key: "getColor",
            value: function getColor() {
                return this.color_;
            }
        },
        {
            /**
   * Get the line cap type for the stroke.
   * @return {CanvasLineCap|undefined} Line cap.
   * @api
   */ key: "getLineCap",
            value: function getLineCap() {
                return this.lineCap_;
            }
        },
        {
            /**
   * Get the line dash style for the stroke.
   * @return {Array<number>|null} Line dash.
   * @api
   */ key: "getLineDash",
            value: function getLineDash() {
                return this.lineDash_;
            }
        },
        {
            /**
   * Get the line dash offset for the stroke.
   * @return {number|undefined} Line dash offset.
   * @api
   */ key: "getLineDashOffset",
            value: function getLineDashOffset() {
                return this.lineDashOffset_;
            }
        },
        {
            /**
   * Get the line join type for the stroke.
   * @return {CanvasLineJoin|undefined} Line join.
   * @api
   */ key: "getLineJoin",
            value: function getLineJoin() {
                return this.lineJoin_;
            }
        },
        {
            /**
   * Get the miter limit for the stroke.
   * @return {number|undefined} Miter limit.
   * @api
   */ key: "getMiterLimit",
            value: function getMiterLimit() {
                return this.miterLimit_;
            }
        },
        {
            /**
   * Get the stroke width.
   * @return {number|undefined} Width.
   * @api
   */ key: "getWidth",
            value: function getWidth() {
                return this.width_;
            }
        },
        {
            /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
   * @api
   */ key: "setColor",
            value: function setColor(color) {
                this.color_ = color;
            }
        },
        {
            /**
   * Set the line cap.
   *
   * @param {CanvasLineCap|undefined} lineCap Line cap.
   * @api
   */ key: "setLineCap",
            value: function setLineCap(lineCap) {
                this.lineCap_ = lineCap;
            }
        },
        {
            /**
   * Set the line dash.
   *
   * @param {Array<number>|null} lineDash Line dash.
   * @api
   */ key: "setLineDash",
            value: function setLineDash(lineDash) {
                this.lineDash_ = lineDash;
            }
        },
        {
            /**
   * Set the line dash offset.
   *
   * @param {number|undefined} lineDashOffset Line dash offset.
   * @api
   */ key: "setLineDashOffset",
            value: function setLineDashOffset(lineDashOffset) {
                this.lineDashOffset_ = lineDashOffset;
            }
        },
        {
            /**
   * Set the line join.
   *
   * @param {CanvasLineJoin|undefined} lineJoin Line join.
   * @api
   */ key: "setLineJoin",
            value: function setLineJoin(lineJoin) {
                this.lineJoin_ = lineJoin;
            }
        },
        {
            /**
   * Set the miter limit.
   *
   * @param {number|undefined} miterLimit Miter limit.
   * @api
   */ key: "setMiterLimit",
            value: function setMiterLimit(miterLimit) {
                this.miterLimit_ = miterLimit;
            }
        },
        {
            /**
   * Set the width.
   *
   * @param {number|undefined} width Width.
   * @api
   */ key: "setWidth",
            value: function setWidth(width) {
                this.width_ = width;
            }
        }
    ]);
    return Stroke;
}();
var $f2ca0e669183cbd3$export$2e2bcd8739ae039 = $f2ca0e669183cbd3$var$Stroke;



/**
 * A function that takes an {@link module:ol/Feature~Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style~Style} or an array of them. This way e.g. a
 * vector layer can be styled. If the function returns `undefined`, the
 * feature will not be rendered.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>|void)} StyleFunction
 */ /**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */ /**
 * A function that takes an {@link module:ol/Feature~Feature} as argument and returns an
 * {@link module:ol/geom/Geometry~Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */ /**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>|Array<Array<Array<import("../coordinate.js").Coordinate>>>),import("../render.js").State): void} RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {RenderFunction} [hitDetectionRenderer] Custom renderer for hit detection. If provided will be used
 * in hit detection rendering.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */ /**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 *
 * ## Feature styles
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)',
 *  });
 *  const stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25,
 *  });
 *  const styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5,
 *      }),
 *      fill: fill,
 *      stroke: stroke,
 *    }),
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const styles = {};
 *  const white = [255, 255, 255, 1];
 *  const blue = [0, 153, 255, 1];
 *  const width = 3;
 *  styles['Polygon'] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5],
 *      }),
 *    }),
 *  ];
 *  styles['MultiPolygon'] =
 *      styles['Polygon'];
 *  styles['LineString'] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2,
 *      }),
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width,
 *      }),
 *    }),
 *  ];
 *  styles['MultiLineString'] = styles['LineString'];
 *
 *  styles['Circle'] = styles['Polygon'].concat(
 *    styles['LineString']
 *  );
 *
 *  styles['Point'] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue,
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2,
 *        }),
 *      }),
 *      zIndex: Infinity,
 *    }),
 *  ];
 *  styles['MultiPoint'] =
 *      styles['Point'];
 *  styles['GeometryCollection'] =
 *      styles['Polygon'].concat(
 *          styles['LineString'],
 *          styles['Point']
 *      );
 * ```
 *
 * @api
 */ var $549a2342af29343f$var$Style = /*#__PURE__*/ function() {
    "use strict";
    function Style(options) {
        (0, $5sFFs._)(this, Style);
        options = options || {};
        /**
     * @private
     * @type {string|import("../geom/Geometry.js").default|GeometryFunction|null}
     */ this.geometry_ = null;
        /**
     * @private
     * @type {!GeometryFunction}
     */ this.geometryFunction_ = $549a2342af29343f$var$defaultGeometryFunction;
        if (options.geometry !== undefined) this.setGeometry(options.geometry);
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {import("./Image.js").default|null}
     */ this.image_ = options.image !== undefined ? options.image : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.renderer_ = options.renderer !== undefined ? options.renderer : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.hitDetectionRenderer_ = options.hitDetectionRenderer !== undefined ? options.hitDetectionRenderer : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("./Text.js").default|null}
     */ this.text_ = options.text !== undefined ? options.text : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.zIndex_ = options.zIndex;
    }
    (0, $8O2fV._)(Style, [
        {
            /**
   * Clones the style.
   * @return {Style} The cloned style.
   * @api
   */ key: "clone",
            value: function clone() {
                var geometry = this.getGeometry();
                if (geometry && typeof geometry === "object") geometry = /** @type {import("../geom/Geometry.js").default} */ geometry.clone();
                var _this_getRenderer;
                return new Style({
                    geometry: geometry !== null && geometry !== void 0 ? geometry : undefined,
                    fill: this.getFill() ? this.getFill().clone() : undefined,
                    image: this.getImage() ? this.getImage().clone() : undefined,
                    renderer: (_this_getRenderer = this.getRenderer()) !== null && _this_getRenderer !== void 0 ? _this_getRenderer : undefined,
                    stroke: this.getStroke() ? this.getStroke().clone() : undefined,
                    text: this.getText() ? this.getText().clone() : undefined,
                    zIndex: this.getZIndex()
                });
            }
        },
        {
            /**
   * Get the custom renderer function that was configured with
   * {@link #setRenderer} or the `renderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ key: "getRenderer",
            value: function getRenderer() {
                return this.renderer_;
            }
        },
        {
            /**
   * Sets a custom renderer function for this style. When set, `fill`, `stroke`
   * and `image` options of the style will be ignored.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ key: "setRenderer",
            value: function setRenderer(renderer) {
                this.renderer_ = renderer;
            }
        },
        {
            /**
   * Sets a custom renderer function for this style used
   * in hit detection.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ key: "setHitDetectionRenderer",
            value: function setHitDetectionRenderer(renderer) {
                this.hitDetectionRenderer_ = renderer;
            }
        },
        {
            /**
   * Get the custom renderer function that was configured with
   * {@link #setHitDetectionRenderer} or the `hitDetectionRenderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ key: "getHitDetectionRenderer",
            value: function getHitDetectionRenderer() {
                return this.hitDetectionRenderer_;
            }
        },
        {
            /**
   * Get the geometry to be rendered.
   * @return {string|import("../geom/Geometry.js").default|GeometryFunction|null}
   * Feature property or geometry or function that returns the geometry that will
   * be rendered with this style.
   * @api
   */ key: "getGeometry",
            value: function getGeometry() {
                return this.geometry_;
            }
        },
        {
            /**
   * Get the function used to generate a geometry for rendering.
   * @return {!GeometryFunction} Function that is called with a feature
   * and returns the geometry to render instead of the feature's geometry.
   * @api
   */ key: "getGeometryFunction",
            value: function getGeometryFunction() {
                return this.geometryFunction_;
            }
        },
        {
            /**
   * Get the fill style.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ key: "getFill",
            value: function getFill() {
                return this.fill_;
            }
        },
        {
            /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ key: "setFill",
            value: function setFill(fill) {
                this.fill_ = fill;
            }
        },
        {
            /**
   * Get the image style.
   * @return {import("./Image.js").default|null} Image style.
   * @api
   */ key: "getImage",
            value: function getImage() {
                return this.image_;
            }
        },
        {
            /**
   * Set the image style.
   * @param {import("./Image.js").default} image Image style.
   * @api
   */ key: "setImage",
            value: function setImage(image) {
                this.image_ = image;
            }
        },
        {
            /**
   * Get the stroke style.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ key: "getStroke",
            value: function getStroke() {
                return this.stroke_;
            }
        },
        {
            /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ key: "setStroke",
            value: function setStroke(stroke) {
                this.stroke_ = stroke;
            }
        },
        {
            /**
   * Get the text style.
   * @return {import("./Text.js").default|null} Text style.
   * @api
   */ key: "getText",
            value: function getText() {
                return this.text_;
            }
        },
        {
            /**
   * Set the text style.
   * @param {import("./Text.js").default} text Text style.
   * @api
   */ key: "setText",
            value: function setText(text) {
                this.text_ = text;
            }
        },
        {
            /**
   * Get the z-index for the style.
   * @return {number|undefined} ZIndex.
   * @api
   */ key: "getZIndex",
            value: function getZIndex() {
                return this.zIndex_;
            }
        },
        {
            /**
   * Set a geometry that is rendered instead of the feature's geometry.
   *
   * @param {string|import("../geom/Geometry.js").default|GeometryFunction} geometry
   *     Feature property or geometry or function returning a geometry to render
   *     for this style.
   * @api
   */ key: "setGeometry",
            value: function setGeometry(geometry) {
                if (typeof geometry === "function") this.geometryFunction_ = geometry;
                else if (typeof geometry === "string") this.geometryFunction_ = function(feature) {
                    return /** @type {import("../geom/Geometry.js").default} */ feature.get(geometry);
                };
                else if (!geometry) this.geometryFunction_ = $549a2342af29343f$var$defaultGeometryFunction;
                else if (geometry !== undefined) this.geometryFunction_ = function() {
                    return /** @type {import("../geom/Geometry.js").default} */ geometry;
                };
                this.geometry_ = geometry;
            }
        },
        {
            /**
   * Set the z-index.
   *
   * @param {number|undefined} zIndex ZIndex.
   * @api
   */ key: "setZIndex",
            value: function setZIndex(zIndex) {
                this.zIndex_ = zIndex;
            }
        }
    ]);
    return Style;
}();
function $549a2342af29343f$export$c314ea3f6b164147(obj) {
    var styleFunction;
    if (typeof obj === "function") styleFunction = obj;
    else {
        /**
     * @type {Array<Style>}
     */ var styles;
        if (Array.isArray(obj)) styles = obj;
        else {
            (0, $100b4414e338a711$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === "function", "Expected an `Style` or an array of `Style`");
            var style = /** @type {Style} */ obj;
            styles = [
                style
            ];
        }
        styleFunction = function styleFunction() {
            return styles;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>|null}
 */ var $549a2342af29343f$var$defaultStyles = null;
function $549a2342af29343f$export$6865c5ac2f5ce8b6(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!$549a2342af29343f$var$defaultStyles) {
        var fill = new (0, $3f3dc9dd8a85276f$export$2e2bcd8739ae039)({
            color: "rgba(255,255,255,0.4)"
        });
        var stroke = new (0, $f2ca0e669183cbd3$export$2e2bcd8739ae039)({
            color: "#3399CC",
            width: 1.25
        });
        $549a2342af29343f$var$defaultStyles = [
            new $549a2342af29343f$var$Style({
                image: new (0, $957ba2f77c353f92$export$2e2bcd8739ae039)({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    return $549a2342af29343f$var$defaultStyles;
}
function $549a2342af29343f$export$ed1eaede5d0e77ac() {
    /** @type {Object<import("../geom/Geometry.js").Type, Array<Style>>} */ var styles = {};
    var white = [
        255,
        255,
        255,
        1
    ];
    var blue = [
        0,
        153,
        255,
        1
    ];
    var width = 3;
    styles["Polygon"] = [
        new $549a2342af29343f$var$Style({
            fill: new (0, $3f3dc9dd8a85276f$export$2e2bcd8739ae039)({
                color: [
                    255,
                    255,
                    255,
                    0.5
                ]
            })
        })
    ];
    styles["MultiPolygon"] = styles["Polygon"];
    styles["LineString"] = [
        new $549a2342af29343f$var$Style({
            stroke: new (0, $f2ca0e669183cbd3$export$2e2bcd8739ae039)({
                color: white,
                width: width + 2
            })
        }),
        new $549a2342af29343f$var$Style({
            stroke: new (0, $f2ca0e669183cbd3$export$2e2bcd8739ae039)({
                color: blue,
                width: width
            })
        })
    ];
    styles["MultiLineString"] = styles["LineString"];
    styles["Circle"] = styles["Polygon"].concat(styles["LineString"]);
    styles["Point"] = [
        new $549a2342af29343f$var$Style({
            image: new (0, $957ba2f77c353f92$export$2e2bcd8739ae039)({
                radius: width * 2,
                fill: new (0, $3f3dc9dd8a85276f$export$2e2bcd8739ae039)({
                    color: blue
                }),
                stroke: new (0, $f2ca0e669183cbd3$export$2e2bcd8739ae039)({
                    color: white,
                    width: width / 2
                })
            }),
            zIndex: Infinity
        })
    ];
    styles["MultiPoint"] = styles["Point"];
    styles["GeometryCollection"] = styles["Polygon"].concat(styles["LineString"], styles["Point"]);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */ function $549a2342af29343f$var$defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
var $549a2342af29343f$export$2e2bcd8739ae039 = $549a2342af29343f$var$Style;


/**
 * @module ol/render/canvas/style
 */ 

/**
 * @module ol/style/Icon
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $fSdUO = parcelRequire("fSdUO");

var $52tJv = parcelRequire("52tJv");

var $4jYWU = parcelRequire("4jYWU");





/**
 * @module ol/style/IconImage
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $aBSBL = parcelRequire("aBSBL");

var $4jYWU = parcelRequire("4jYWU");







/**
 * @type {CanvasRenderingContext2D}
 */ var $be61a4f52bd12e4d$var$taintedTestContext = null;
var $be61a4f52bd12e4d$var$IconImage = /*#__PURE__*/ function(EventTarget) {
    "use strict";
    (0, $kcqLc._)(IconImage, EventTarget);
    var _super = (0, $4jYWU._)(IconImage);
    function IconImage(image, src, crossOrigin, imageState, color) {
        (0, $5sFFs._)(this, IconImage);
        var _this;
        _this = _super.call(this);
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|ImageBitmap}
     */ _this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|ImageBitmap}
     */ _this.image_ = image;
        /**
     * @private
     * @type {string|null}
     */ _this.crossOrigin_ = crossOrigin;
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement>}
     */ _this.canvas_ = {};
        /**
     * @private
     * @type {import("../color.js").Color}
     */ _this.color_ = color;
        /**
     * @private
     * @type {import("../ImageState.js").default}
     */ _this.imageState_ = imageState === undefined ? (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).IDLE : imageState;
        /**
     * @private
     * @type {import("../size.js").Size|null}
     */ _this.size_ = image && image.width && image.height ? [
            image.width,
            image.height
        ] : null;
        /**
     * @private
     * @type {string|undefined}
     */ _this.src_ = src;
        /**
     * @private
     */ _this.tainted_;
        return _this;
    }
    (0, $8O2fV._)(IconImage, [
        {
            /**
   * @private
   */ key: "initializeImage_",
            value: function initializeImage_() {
                this.image_ = new Image();
                if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
            }
        },
        {
            /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */ key: "isTainted_",
            value: function isTainted_() {
                if (this.tainted_ === undefined && this.imageState_ === (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED) {
                    if (!$be61a4f52bd12e4d$var$taintedTestContext) $be61a4f52bd12e4d$var$taintedTestContext = (0, $e000035bb4c81589$export$9e05d10eae75c464)(1, 1, undefined, {
                        willReadFrequently: true
                    });
                    $be61a4f52bd12e4d$var$taintedTestContext.drawImage(this.image_, 0, 0);
                    try {
                        $be61a4f52bd12e4d$var$taintedTestContext.getImageData(0, 0, 1, 1);
                        this.tainted_ = false;
                    } catch (e) {
                        $be61a4f52bd12e4d$var$taintedTestContext = null;
                        this.tainted_ = true;
                    }
                }
                return this.tainted_ === true;
            }
        },
        {
            /**
   * @private
   */ key: "dispatchChangeEvent_",
            value: function dispatchChangeEvent_() {
                this.dispatchEvent((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE);
            }
        },
        {
            /**
   * @private
   */ key: "handleImageError_",
            value: function handleImageError_() {
                this.imageState_ = (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).ERROR;
                this.dispatchChangeEvent_();
            }
        },
        {
            /**
   * @private
   */ key: "handleImageLoad_",
            value: function handleImageLoad_() {
                this.imageState_ = (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED;
                this.size_ = [
                    this.image_.width,
                    this.image_.height
                ];
                this.dispatchChangeEvent_();
            }
        },
        {
            /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element or image bitmap.
   */ key: "getImage",
            value: function getImage(pixelRatio) {
                if (!this.image_) this.initializeImage_();
                this.replaceColor_(pixelRatio);
                return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
            }
        },
        {
            /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Image or Canvas element.
   */ key: "getPixelRatio",
            value: function getPixelRatio(pixelRatio) {
                this.replaceColor_(pixelRatio);
                return this.canvas_[pixelRatio] ? pixelRatio : 1;
            }
        },
        {
            /**
   * @return {import("../ImageState.js").default} Image state.
   */ key: "getImageState",
            value: function getImageState() {
                return this.imageState_;
            }
        },
        {
            /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   */ key: "getHitDetectionImage",
            value: function getHitDetectionImage() {
                if (!this.image_) this.initializeImage_();
                if (!this.hitDetectionImage_) {
                    if (this.isTainted_()) {
                        var width = this.size_[0];
                        var height = this.size_[1];
                        var context = (0, $e000035bb4c81589$export$9e05d10eae75c464)(width, height);
                        context.fillRect(0, 0, width, height);
                        this.hitDetectionImage_ = context.canvas;
                    } else this.hitDetectionImage_ = this.image_;
                }
                return this.hitDetectionImage_;
            }
        },
        {
            /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   */ key: "getSize",
            value: function getSize() {
                return this.size_;
            }
        },
        {
            /**
   * @return {string|undefined} Image src.
   */ key: "getSrc",
            value: function getSrc() {
                return this.src_;
            }
        },
        {
            /**
   * Load not yet loaded URI.
   */ key: "load",
            value: function load() {
                var _this = this;
                if (this.imageState_ !== (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).IDLE) return;
                if (!this.image_) this.initializeImage_();
                this.imageState_ = (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADING;
                try {
                    if (this.src_ !== undefined) /** @type {HTMLImageElement} */ this.image_.src = this.src_;
                } catch (e) {
                    this.handleImageError_();
                }
                if (this.image_ instanceof HTMLImageElement) (0, $e0be75e54316f60e$export$a9e5af241c1bd389)(this.image_, this.src_).then(function(image) {
                    _this.image_ = image;
                    _this.handleImageLoad_();
                }).catch(this.handleImageError_.bind(this));
            }
        },
        {
            /**
   * @param {number} pixelRatio Pixel ratio.
   * @private
   */ key: "replaceColor_",
            value: function replaceColor_(pixelRatio) {
                if (!this.color_ || this.canvas_[pixelRatio] || this.imageState_ !== (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED) return;
                var image = this.image_;
                var canvas = document.createElement("canvas");
                canvas.width = Math.ceil(image.width * pixelRatio);
                canvas.height = Math.ceil(image.height * pixelRatio);
                var ctx = canvas.getContext("2d");
                ctx.scale(pixelRatio, pixelRatio);
                ctx.drawImage(image, 0, 0);
                ctx.globalCompositeOperation = "multiply";
                ctx.fillStyle = (0, $03ff7455ee88c2e9$export$590567be997858b6)(this.color_);
                ctx.fillRect(0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);
                ctx.globalCompositeOperation = "destination-in";
                ctx.drawImage(image, 0, 0);
                this.canvas_[pixelRatio] = canvas;
            }
        }
    ]);
    return IconImage;
}((0, $aBSBL._)((0, $e5f438e225cf4aef$export$2e2bcd8739ae039)));
function $be61a4f52bd12e4d$export$3988ae62b71be9a3(image, cacheKey, crossOrigin, imageState, color) {
    var iconImage = cacheKey === undefined ? undefined : (0, $b343747b53167d02$export$747ccdf771a87ab8).get(cacheKey, crossOrigin, color);
    if (!iconImage) {
        iconImage = new $be61a4f52bd12e4d$var$IconImage(image, image instanceof HTMLImageElement ? image.src || undefined : cacheKey, crossOrigin, imageState, color);
        (0, $b343747b53167d02$export$747ccdf771a87ab8).set(cacheKey, crossOrigin, color, iconImage);
    }
    return iconImage;
}
var $be61a4f52bd12e4d$export$2e2bcd8739ae039 = $be61a4f52bd12e4d$var$IconImage;



/**
 * @typedef {'fraction' | 'pixels'} IconAnchorUnits
 * Anchor unit can be either a fraction of the icon size or in pixels.
 */ /**
 * @typedef {'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'} IconOrigin
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 */ /**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {IconOrigin} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {IconAnchorUnits} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {IconAnchorUnits} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {HTMLImageElement|HTMLCanvasElement|ImageBitmap} [img] Image object for the icon.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the icon in pixels.
 * Positive values will shift the icon right and up.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number} [width] The width of the icon in pixels. This can't be used together with `scale`.
 * @property {number} [height] The height of the icon in pixels. This can't be used together with `scale`.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {Array<number>} [offset=[0, 0]] Offset which, together with `size` and `offsetOrigin`, defines the
 * sub-rectangle to use from the original (sprite) image.
 * @property {IconOrigin} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("../size.js").Size} [size] Icon size in pixels. Used together with `offset` to define the
 * sub-rectangle to use from the original (sprite) image.
 * @property {string} [src] Image source URI.
 * @property {"declutter"|"obstacle"|"none"|undefined} [declutterMode] Declutter mode.
 */ /**
 * @param {number} width The width.
 * @param {number} height The height.
 * @param {number|undefined} wantedWidth The wanted width.
 * @param {number|undefined} wantedHeight The wanted height.
 * @return {number|Array<number>} The scale.
 */ function $f18dd4c8d6d98b55$var$calculateScale(width, height, wantedWidth, wantedHeight) {
    if (wantedWidth !== undefined && wantedHeight !== undefined) return [
        wantedWidth / width,
        wantedHeight / height
    ];
    if (wantedWidth !== undefined) return wantedWidth / width;
    if (wantedHeight !== undefined) return wantedHeight / height;
    return 1;
}
/**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */ var $f18dd4c8d6d98b55$var$Icon = /*#__PURE__*/ function(ImageStyle) {
    "use strict";
    (0, $kcqLc._)(Icon, ImageStyle);
    var _super = (0, $4jYWU._)(Icon);
    function Icon(options) {
        (0, $5sFFs._)(this, Icon);
        var _this;
        options = options || {};
        /**
     * @type {number}
     */ var opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
     * @type {number}
     */ var rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
     * @type {number|import("../size.js").Size}
     */ var scale = options.scale !== undefined ? options.scale : 1;
        /**
     * @type {boolean}
     */ var rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        _this = _super.call(this, {
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            rotateWithView: rotateWithView,
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Array<number>}
     */ _this.anchor_ = options.anchor !== undefined ? options.anchor : [
            0.5,
            0.5
        ];
        /**
     * @private
     * @type {Array<number>}
     */ _this.normalizedAnchor_ = null;
        /**
     * @private
     * @type {IconOrigin}
     */ _this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : "top-left";
        /**
     * @private
     * @type {IconAnchorUnits}
     */ _this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : "fraction";
        /**
     * @private
     * @type {IconAnchorUnits}
     */ _this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : "fraction";
        /**
     * @private
     * @type {?string}
     */ _this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        var image = options.img !== undefined ? options.img : null;
        var cacheKey = options.src;
        (0, $100b4414e338a711$export$a7a9523472993e97)(!(cacheKey !== undefined && image), "`image` and `src` cannot be provided at the same time");
        if ((cacheKey === undefined || cacheKey.length === 0) && image) cacheKey = /** @type {HTMLImageElement} */ image.src || (0, $8b32fff2376556ef$export$5e82334337e0f204)(image);
        (0, $100b4414e338a711$export$a7a9523472993e97)(cacheKey !== undefined && cacheKey.length > 0, "A defined and non-empty `src` or `image` must be provided");
        (0, $100b4414e338a711$export$a7a9523472993e97)(!((options.width !== undefined || options.height !== undefined) && options.scale !== undefined), "`width` or `height` cannot be provided together with `scale`");
        var imageState;
        if (options.src !== undefined) imageState = (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).IDLE;
        else if (image !== undefined) {
            if (image instanceof HTMLImageElement) {
                if (image.complete) imageState = image.src ? (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED : (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).IDLE;
                else imageState = (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADING;
            } else imageState = (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED;
        }
        /**
     * @private
     * @type {import("../color.js").Color}
     */ _this.color_ = options.color !== undefined ? (0, $03ff7455ee88c2e9$export$75093a47a9fa838d)(options.color) : null;
        /**
     * @private
     * @type {import("./IconImage.js").default}
     */ _this.iconImage_ = (0, $be61a4f52bd12e4d$export$3988ae62b71be9a3)(image, /** @type {string} */ cacheKey, _this.crossOrigin_, imageState, _this.color_);
        /**
     * @private
     * @type {Array<number>}
     */ _this.offset_ = options.offset !== undefined ? options.offset : [
            0,
            0
        ];
        /**
     * @private
     * @type {IconOrigin}
     */ _this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : "top-left";
        /**
     * @private
     * @type {Array<number>}
     */ _this.origin_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ _this.size_ = options.size !== undefined ? options.size : null;
        /**
     * Calculate the scale if width or height were given.
     */ if (options.width !== undefined || options.height !== undefined) {
            var width, height;
            var ref;
            if (options.size) ref = (0, $52tJv._)(options.size, 2), width = ref[0], height = ref[1], ref;
            else {
                var image1 = _this.getImage(1);
                if (image1.width && image1.height) {
                    width = image1.width;
                    height = image1.height;
                } else if (image1 instanceof HTMLImageElement) {
                    _this.initialOptions_ = options;
                    var onload = function() {
                        _this.unlistenImageChange(onload);
                        if (!_this.initialOptions_) return;
                        var imageSize = _this.iconImage_.getSize();
                        _this.setScale($f18dd4c8d6d98b55$var$calculateScale(imageSize[0], imageSize[1], options.width, options.height));
                    };
                    _this.listenImageChange(onload);
                    return (0, $fSdUO._)(_this);
                }
            }
            if (width !== undefined) _this.setScale($f18dd4c8d6d98b55$var$calculateScale(width, height, options.width, options.height));
        }
        return _this;
    }
    (0, $8O2fV._)(Icon, [
        {
            /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   */ key: "clone",
            value: function clone() {
                var scale, width, height;
                if (this.initialOptions_) {
                    width = this.initialOptions_.width;
                    height = this.initialOptions_.height;
                } else {
                    scale = this.getScale();
                    scale = Array.isArray(scale) ? scale.slice() : scale;
                }
                return new Icon({
                    anchor: this.anchor_.slice(),
                    anchorOrigin: this.anchorOrigin_,
                    anchorXUnits: this.anchorXUnits_,
                    anchorYUnits: this.anchorYUnits_,
                    color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
                    crossOrigin: this.crossOrigin_,
                    offset: this.offset_.slice(),
                    offsetOrigin: this.offsetOrigin_,
                    opacity: this.getOpacity(),
                    rotateWithView: this.getRotateWithView(),
                    rotation: this.getRotation(),
                    scale: scale,
                    width: width,
                    height: height,
                    size: this.size_ !== null ? this.size_.slice() : undefined,
                    src: this.getSrc(),
                    displacement: this.getDisplacement().slice(),
                    declutterMode: this.getDeclutterMode()
                });
            }
        },
        {
            /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   */ key: "getAnchor",
            value: function getAnchor() {
                var anchor = this.normalizedAnchor_;
                if (!anchor) {
                    anchor = this.anchor_;
                    var size = this.getSize();
                    if (this.anchorXUnits_ == "fraction" || this.anchorYUnits_ == "fraction") {
                        if (!size) return null;
                        anchor = this.anchor_.slice();
                        if (this.anchorXUnits_ == "fraction") anchor[0] *= size[0];
                        if (this.anchorYUnits_ == "fraction") anchor[1] *= size[1];
                    }
                    if (this.anchorOrigin_ != "top-left") {
                        if (!size) return null;
                        if (anchor === this.anchor_) anchor = this.anchor_.slice();
                        if (this.anchorOrigin_ == "top-right" || this.anchorOrigin_ == "bottom-right") anchor[0] = -anchor[0] + size[0];
                        if (this.anchorOrigin_ == "bottom-left" || this.anchorOrigin_ == "bottom-right") anchor[1] = -anchor[1] + size[1];
                    }
                    this.normalizedAnchor_ = anchor;
                }
                var displacement = this.getDisplacement();
                var scale = this.getScaleArray();
                // anchor is scaled by renderer but displacement should not be scaled
                // so divide by scale here
                return [
                    anchor[0] - displacement[0] / scale[0],
                    anchor[1] + displacement[1] / scale[1]
                ];
            }
        },
        {
            /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */ key: "setAnchor",
            value: function setAnchor(anchor) {
                this.anchor_ = anchor;
                this.normalizedAnchor_ = null;
            }
        },
        {
            /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */ key: "getColor",
            value: function getColor() {
                return this.color_;
            }
        },
        {
            /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element. If the Icon
   * style was configured with `src` or with a not let loaded `img`, an `ImageBitmap` will be returned.
   * @api
   */ key: "getImage",
            value: function getImage(pixelRatio) {
                return this.iconImage_.getImage(pixelRatio);
            }
        },
        {
            /**
   * Get the pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} The pixel ratio of the image.
   * @api
   */ key: "getPixelRatio",
            value: function getPixelRatio(pixelRatio) {
                return this.iconImage_.getPixelRatio(pixelRatio);
            }
        },
        {
            /**
   * @return {import("../size.js").Size} Image size.
   */ key: "getImageSize",
            value: function getImageSize() {
                return this.iconImage_.getSize();
            }
        },
        {
            /**
   * @return {import("../ImageState.js").default} Image state.
   */ key: "getImageState",
            value: function getImageState() {
                return this.iconImage_.getImageState();
            }
        },
        {
            /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   */ key: "getHitDetectionImage",
            value: function getHitDetectionImage() {
                return this.iconImage_.getHitDetectionImage();
            }
        },
        {
            /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   */ key: "getOrigin",
            value: function getOrigin() {
                if (this.origin_) return this.origin_;
                var offset = this.offset_;
                if (this.offsetOrigin_ != "top-left") {
                    var size = this.getSize();
                    var iconImageSize = this.iconImage_.getSize();
                    if (!size || !iconImageSize) return null;
                    offset = offset.slice();
                    if (this.offsetOrigin_ == "top-right" || this.offsetOrigin_ == "bottom-right") offset[0] = iconImageSize[0] - size[0] - offset[0];
                    if (this.offsetOrigin_ == "bottom-left" || this.offsetOrigin_ == "bottom-right") offset[1] = iconImageSize[1] - size[1] - offset[1];
                }
                this.origin_ = offset;
                return this.origin_;
            }
        },
        {
            /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */ key: "getSrc",
            value: function getSrc() {
                return this.iconImage_.getSrc();
            }
        },
        {
            /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   * @api
   */ key: "getSize",
            value: function getSize() {
                return !this.size_ ? this.iconImage_.getSize() : this.size_;
            }
        },
        {
            /**
   * Get the width of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon width (in pixels).
   * @api
   */ key: "getWidth",
            value: function getWidth() {
                var scale = this.getScaleArray();
                if (this.size_) return this.size_[0] * scale[0];
                if (this.iconImage_.getImageState() == (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[0] * scale[0];
                return undefined;
            }
        },
        {
            /**
   * Get the height of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon height (in pixels).
   * @api
   */ key: "getHeight",
            value: function getHeight() {
                var scale = this.getScaleArray();
                if (this.size_) return this.size_[1] * scale[1];
                if (this.iconImage_.getImageState() == (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[1] * scale[1];
                return undefined;
            }
        },
        {
            /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */ key: "setScale",
            value: function setScale(scale) {
                delete this.initialOptions_;
                (0, $404BM._)((0, $cEF31._)(Icon.prototype), "setScale", this).call(this, scale);
            }
        },
        {
            /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ key: "listenImageChange",
            value: function listenImageChange(listener) {
                this.iconImage_.addEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE, listener);
            }
        },
        {
            /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @api
   */ key: "load",
            value: function load() {
                this.iconImage_.load();
            }
        },
        {
            /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ key: "unlistenImageChange",
            value: function unlistenImageChange(listener) {
                this.iconImage_.removeEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE, listener);
            }
        }
    ]);
    return Icon;
}((0, $372eeb7b0f34d7f9$export$2e2bcd8739ae039));
var $f18dd4c8d6d98b55$export$2e2bcd8739ae039 = $f18dd4c8d6d98b55$var$Icon;





/**
 * @module ol/style/Text
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");


/**
 * @typedef {'point' | 'line'} TextPlacement
 * Default text placement is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 */ /**
 * @typedef {'left' | 'center' | 'right'} TextJustify
 */ /**
 * The default fill color to use if no fill was set at construction time; a
 * blackish `#333`.
 *
 * @const {string}
 */ var $049c95c34238c5a2$var$DEFAULT_FILL_COLOR = "#333";
/**
 * @typedef {Object} Options
 * @property {string} [font] Font style as CSS `font` value, see:
 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is `'10px sans-serif'`
 * @property {number} [maxAngle=Math.PI/4] When `placement` is set to `'line'`, allow a maximum angle between adjacent characters.
 * The expected value is in radians, and the default is 45° (`Math.PI / 4`).
 * @property {number} [offsetX=0] Horizontal text offset in pixels. A positive will shift the text right.
 * @property {number} [offsetY=0] Vertical text offset in pixels. A positive will shift the text down.
 * @property {boolean} [overflow=false] For polygon labels or when `placement` is set to `'line'`, allow text to exceed
 * the width of the polygon at the label position or the length of the path that it follows.
 * @property {TextPlacement} [placement='point'] Text placement.
 * @property {number} [repeat] Repeat interval. When set, the text will be repeated at this interval, which specifies
 * the distance between two text anchors in pixels. Only available when `placement` is set to `'line'`. Overrides 'textAlign'.
 * @property {number|import("../size.js").Size} [scale] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the text with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {string|Array<string>} [text] Text content or rich text content. For plain text provide a string, which can
 * contain line breaks (`\n`). For rich text provide an array of text/font tuples. A tuple consists of the text to
 * render and the font to use (or `''` to use the text style's font). A line break has to be a separate tuple (i.e. `'\n', ''`).
 * **Example:** `['foo', 'bold 10px sans-serif', ' bar', 'italic 10px sans-serif', ' baz', '']` will yield "**foo** *bar* baz".
 * **Note:** Rich text is not supported for `placement: 'line'` or the immediate rendering API.
 * @property {CanvasTextAlign} [textAlign] Text alignment. Possible values: `'left'`, `'right'`, `'center'`, `'end'` or `'start'`.
 * Default is `'center'` for `placement: 'point'`. For `placement: 'line'`, the default is to let the renderer choose a
 * placement where `maxAngle` is not exceeded.
 * @property {TextJustify} [justify] Text justification within the text box.
 * If not set, text is justified towards the `textAlign` anchor.
 * Otherwise, use options `'left'`, `'center'`, or `'right'` to justify the text within the text box.
 * **Note:** `justify` is ignored for immediate rendering and also for `placement: 'line'`.
 * @property {CanvasTextBaseline} [textBaseline='middle'] Text base line. Possible values: `'bottom'`, `'top'`, `'middle'`, `'alphabetic'`,
 * `'hanging'`, `'ideographic'`.
 * @property {import("./Fill.js").default|null} [fill] Fill style. If none is provided, we'll use a dark fill-style (#333). Specify `null` for no fill.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Fill.js").default} [backgroundFill] Fill style for the text background when `placement` is
 * `'point'`. Default is no fill.
 * @property {import("./Stroke.js").default} [backgroundStroke] Stroke style for the text background  when `placement`
 * is `'point'`. Default is no stroke.
 * @property {Array<number>} [padding=[0, 0, 0, 0]] Padding in pixels around the text for decluttering and background. The order of
 * values in the array is `[top, right, bottom, left]`.
 */ /**
 * @classdesc
 * Set text style for vector features.
 * @api
 */ var $049c95c34238c5a2$var$Text = /*#__PURE__*/ function() {
    "use strict";
    function Text(options) {
        (0, $5sFFs._)(this, Text);
        options = options || {};
        /**
     * @private
     * @type {string|undefined}
     */ this.font_ = options.font;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number|import("../size.js").Size|undefined}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $9fd3f8f53b8c7a01$export$a71a825ff42fb8e1)(options.scale !== undefined ? options.scale : 1);
        /**
     * @private
     * @type {string|Array<string>|undefined}
     */ this.text_ = options.text;
        /**
     * @private
     * @type {CanvasTextAlign|undefined}
     */ this.textAlign_ = options.textAlign;
        /**
     * @private
     * @type {TextJustify|undefined}
     */ this.justify_ = options.justify;
        /**
     * @private
     * @type {number|undefined}
     */ this.repeat_ = options.repeat;
        /**
     * @private
     * @type {CanvasTextBaseline|undefined}
     */ this.textBaseline_ = options.textBaseline;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : new (0, $3f3dc9dd8a85276f$export$2e2bcd8739ae039)({
            color: $049c95c34238c5a2$var$DEFAULT_FILL_COLOR
        });
        /**
     * @private
     * @type {number}
     */ this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
        /**
     * @private
     * @type {TextPlacement}
     */ this.placement_ = options.placement !== undefined ? options.placement : "point";
        /**
     * @private
     * @type {boolean}
     */ this.overflow_ = !!options.overflow;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {number}
     */ this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
        /**
     * @private
     * @type {number}
     */ this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.padding_ = options.padding === undefined ? null : options.padding;
    }
    (0, $8O2fV._)(Text, [
        {
            /**
   * Clones the style.
   * @return {Text} The cloned style.
   * @api
   */ key: "clone",
            value: function clone() {
                var scale = this.getScale();
                return new Text({
                    font: this.getFont(),
                    placement: this.getPlacement(),
                    repeat: this.getRepeat(),
                    maxAngle: this.getMaxAngle(),
                    overflow: this.getOverflow(),
                    rotation: this.getRotation(),
                    rotateWithView: this.getRotateWithView(),
                    scale: Array.isArray(scale) ? scale.slice() : scale,
                    text: this.getText(),
                    textAlign: this.getTextAlign(),
                    justify: this.getJustify(),
                    textBaseline: this.getTextBaseline(),
                    fill: this.getFill() ? this.getFill().clone() : undefined,
                    stroke: this.getStroke() ? this.getStroke().clone() : undefined,
                    offsetX: this.getOffsetX(),
                    offsetY: this.getOffsetY(),
                    backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
                    backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined,
                    padding: this.getPadding() || undefined
                });
            }
        },
        {
            /**
   * Get the `overflow` configuration.
   * @return {boolean} Let text overflow the length of the path they follow.
   * @api
   */ key: "getOverflow",
            value: function getOverflow() {
                return this.overflow_;
            }
        },
        {
            /**
   * Get the font name.
   * @return {string|undefined} Font.
   * @api
   */ key: "getFont",
            value: function getFont() {
                return this.font_;
            }
        },
        {
            /**
   * Get the maximum angle between adjacent characters.
   * @return {number} Angle in radians.
   * @api
   */ key: "getMaxAngle",
            value: function getMaxAngle() {
                return this.maxAngle_;
            }
        },
        {
            /**
   * Get the label placement.
   * @return {TextPlacement} Text placement.
   * @api
   */ key: "getPlacement",
            value: function getPlacement() {
                return this.placement_;
            }
        },
        {
            /**
   * Get the repeat interval of the text.
   * @return {number|undefined} Repeat interval in pixels.
   * @api
   */ key: "getRepeat",
            value: function getRepeat() {
                return this.repeat_;
            }
        },
        {
            /**
   * Get the x-offset for the text.
   * @return {number} Horizontal text offset.
   * @api
   */ key: "getOffsetX",
            value: function getOffsetX() {
                return this.offsetX_;
            }
        },
        {
            /**
   * Get the y-offset for the text.
   * @return {number} Vertical text offset.
   * @api
   */ key: "getOffsetY",
            value: function getOffsetY() {
                return this.offsetY_;
            }
        },
        {
            /**
   * Get the fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ key: "getFill",
            value: function getFill() {
                return this.fill_;
            }
        },
        {
            /**
   * Determine whether the text rotates with the map.
   * @return {boolean|undefined} Rotate with map.
   * @api
   */ key: "getRotateWithView",
            value: function getRotateWithView() {
                return this.rotateWithView_;
            }
        },
        {
            /**
   * Get the text rotation.
   * @return {number|undefined} Rotation.
   * @api
   */ key: "getRotation",
            value: function getRotation() {
                return this.rotation_;
            }
        },
        {
            /**
   * Get the text scale.
   * @return {number|import("../size.js").Size|undefined} Scale.
   * @api
   */ key: "getScale",
            value: function getScale() {
                return this.scale_;
            }
        },
        {
            /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ key: "getScaleArray",
            value: function getScaleArray() {
                return this.scaleArray_;
            }
        },
        {
            /**
   * Get the stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ key: "getStroke",
            value: function getStroke() {
                return this.stroke_;
            }
        },
        {
            /**
   * Get the text to be rendered.
   * @return {string|Array<string>|undefined} Text.
   * @api
   */ key: "getText",
            value: function getText() {
                return this.text_;
            }
        },
        {
            /**
   * Get the text alignment.
   * @return {CanvasTextAlign|undefined} Text align.
   * @api
   */ key: "getTextAlign",
            value: function getTextAlign() {
                return this.textAlign_;
            }
        },
        {
            /**
   * Get the justification.
   * @return {TextJustify|undefined} Justification.
   * @api
   */ key: "getJustify",
            value: function getJustify() {
                return this.justify_;
            }
        },
        {
            /**
   * Get the text baseline.
   * @return {CanvasTextBaseline|undefined} Text baseline.
   * @api
   */ key: "getTextBaseline",
            value: function getTextBaseline() {
                return this.textBaseline_;
            }
        },
        {
            /**
   * Get the background fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ key: "getBackgroundFill",
            value: function getBackgroundFill() {
                return this.backgroundFill_;
            }
        },
        {
            /**
   * Get the background stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ key: "getBackgroundStroke",
            value: function getBackgroundStroke() {
                return this.backgroundStroke_;
            }
        },
        {
            /**
   * Get the padding for the text.
   * @return {Array<number>|null} Padding.
   * @api
   */ key: "getPadding",
            value: function getPadding() {
                return this.padding_;
            }
        },
        {
            /**
   * Set the `overflow` property.
   *
   * @param {boolean} overflow Let text overflow the path that it follows.
   * @api
   */ key: "setOverflow",
            value: function setOverflow(overflow) {
                this.overflow_ = overflow;
            }
        },
        {
            /**
   * Set the font.
   *
   * @param {string|undefined} font Font.
   * @api
   */ key: "setFont",
            value: function setFont(font) {
                this.font_ = font;
            }
        },
        {
            /**
   * Set the maximum angle between adjacent characters.
   *
   * @param {number} maxAngle Angle in radians.
   * @api
   */ key: "setMaxAngle",
            value: function setMaxAngle(maxAngle) {
                this.maxAngle_ = maxAngle;
            }
        },
        {
            /**
   * Set the x offset.
   *
   * @param {number} offsetX Horizontal text offset.
   * @api
   */ key: "setOffsetX",
            value: function setOffsetX(offsetX) {
                this.offsetX_ = offsetX;
            }
        },
        {
            /**
   * Set the y offset.
   *
   * @param {number} offsetY Vertical text offset.
   * @api
   */ key: "setOffsetY",
            value: function setOffsetY(offsetY) {
                this.offsetY_ = offsetY;
            }
        },
        {
            /**
   * Set the text placement.
   *
   * @param {TextPlacement} placement Placement.
   * @api
   */ key: "setPlacement",
            value: function setPlacement(placement) {
                this.placement_ = placement;
            }
        },
        {
            /**
   * Set the repeat interval of the text.
   * @param {number|undefined} [repeat] Repeat interval in pixels.
   * @api
   */ key: "setRepeat",
            value: function setRepeat(repeat) {
                this.repeat_ = repeat;
            }
        },
        {
            /**
   * Set whether to rotate the text with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ key: "setRotateWithView",
            value: function setRotateWithView(rotateWithView) {
                this.rotateWithView_ = rotateWithView;
            }
        },
        {
            /**
   * Set the fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ key: "setFill",
            value: function setFill(fill) {
                this.fill_ = fill;
            }
        },
        {
            /**
   * Set the rotation.
   *
   * @param {number|undefined} rotation Rotation.
   * @api
   */ key: "setRotation",
            value: function setRotation(rotation) {
                this.rotation_ = rotation;
            }
        },
        {
            /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size|undefined} scale Scale.
   * @api
   */ key: "setScale",
            value: function setScale(scale) {
                this.scale_ = scale;
                this.scaleArray_ = (0, $9fd3f8f53b8c7a01$export$a71a825ff42fb8e1)(scale !== undefined ? scale : 1);
            }
        },
        {
            /**
   * Set the stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ key: "setStroke",
            value: function setStroke(stroke) {
                this.stroke_ = stroke;
            }
        },
        {
            /**
   * Set the text.
   *
   * @param {string|Array<string>|undefined} text Text.
   * @api
   */ key: "setText",
            value: function setText(text) {
                this.text_ = text;
            }
        },
        {
            /**
   * Set the text alignment.
   *
   * @param {CanvasTextAlign|undefined} textAlign Text align.
   * @api
   */ key: "setTextAlign",
            value: function setTextAlign(textAlign) {
                this.textAlign_ = textAlign;
            }
        },
        {
            /**
   * Set the justification.
   *
   * @param {TextJustify|undefined} justify Justification.
   * @api
   */ key: "setJustify",
            value: function setJustify(justify) {
                this.justify_ = justify;
            }
        },
        {
            /**
   * Set the text baseline.
   *
   * @param {CanvasTextBaseline|undefined} textBaseline Text baseline.
   * @api
   */ key: "setTextBaseline",
            value: function setTextBaseline(textBaseline) {
                this.textBaseline_ = textBaseline;
            }
        },
        {
            /**
   * Set the background fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ key: "setBackgroundFill",
            value: function setBackgroundFill(fill) {
                this.backgroundFill_ = fill;
            }
        },
        {
            /**
   * Set the background stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ key: "setBackgroundStroke",
            value: function setBackgroundStroke(stroke) {
                this.backgroundStroke_ = stroke;
            }
        },
        {
            /**
   * Set the padding (`[top, right, bottom, left]`).
   *
   * @param {Array<number>|null} padding Padding.
   * @api
   */ key: "setPadding",
            value: function setPadding(padding) {
                this.padding_ = padding;
            }
        }
    ]);
    return Text;
}();
var $049c95c34238c5a2$export$2e2bcd8739ae039 = $049c95c34238c5a2$var$Text;


/**
 * @module ol/expr/expression
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $amGNX = parcelRequire("amGNX");

var $iCQyW = parcelRequire("iCQyW");

var $52tJv = parcelRequire("52tJv");

var $fyztb = parcelRequire("fyztb");

var $l6pW7 = parcelRequire("l6pW7");


/**
 * @fileoverview This module includes types and functions for parsing array encoded expressions.
 * The result of parsing an encoded expression is one of the specific expression classes.
 * During parsing, information is added to the parsing context about the data accessed by the
 * expression.
 */ /**
 * Base type used for literal style parameters; can be a number literal or the output of an operator,
 * which in turns takes {@link import("./expression.js").ExpressionValue} arguments.
 *
 * The following operators can be used:
 *
 * * Reading operators:
 *   * `['band', bandIndex, xOffset, yOffset]` For tile layers only. Fetches pixel values from band
 *     `bandIndex` of the source's data. The first `bandIndex` of the source data is `1`. Fetched values
 *     are in the 0..1 range. {@link import("../source/TileImage.js").default} sources have 4 bands: red,
 *     green, blue and alpha. {@link import("../source/DataTile.js").default} sources can have any number
 *     of bands, depending on the underlying data source and
 *     {@link import("../source/GeoTIFF.js").Options configuration}. `xOffset` and `yOffset` are optional
 *     and allow specifying pixel offsets for x and y. This is used for sampling data from neighboring pixels.
 *   * `['get', 'attributeName', typeHint]` fetches a feature property value, similar to `feature.get('attributeName')`
 *     A type hint can optionally be specified, in case the resulting expression contains a type ambiguity which
 *     will make it invalid. Type hints can be one of: 'string', 'color', 'number', 'boolean', 'number[]'
 *   * `['geometry-type']` returns a feature's geometry type as string, either: 'LineString', 'Point' or 'Polygon'
 *     `Multi*` values are returned as their singular equivalent
 *     `Circle` geometries are returned as 'Polygon'
 *     `GeometryCollection` geometries are returned as the type of the first geometry found in the collection
 *   * `['resolution']` returns the current resolution
 *   * `['time']` returns the time in seconds since the creation of the layer
 *   * `['var', 'varName']` fetches a value from the style variables; will throw an error if that variable is undefined
 *   * `['zoom']` returns the current zoom level
 *
 * * Math operators:
 *   * `['*', value1, value2, ...]` multiplies the values (either numbers or colors)
 *   * `['/', value1, value2]` divides `value1` by `value2`
 *   * `['+', value1, value2, ...]` adds the values
 *   * `['-', value1, value2]` subtracts `value2` from `value1`
 *   * `['clamp', value, low, high]` clamps `value` between `low` and `high`
 *   * `['%', value1, value2]` returns the result of `value1 % value2` (modulo)
 *   * `['^', value1, value2]` returns the value of `value1` raised to the `value2` power
 *   * `['abs', value1]` returns the absolute value of `value1`
 *   * `['floor', value1]` returns the nearest integer less than or equal to `value1`
 *   * `['round', value1]` returns the nearest integer to `value1`
 *   * `['ceil', value1]` returns the nearest integer greater than or equal to `value1`
 *   * `['sin', value1]` returns the sine of `value1`
 *   * `['cos', value1]` returns the cosine of `value1`
 *   * `['atan', value1, value2]` returns `atan2(value1, value2)`. If `value2` is not provided, returns `atan(value1)`
 *   * `['sqrt', value1]` returns the square root of `value1`
 *
 * * Transform operators:
 *   * `['case', condition1, output1, ...conditionN, outputN, fallback]` selects the first output whose corresponding
 *     condition evaluates to `true`. If no match is found, returns the `fallback` value.
 *     All conditions should be `boolean`, output and fallback can be any kind.
 *   * `['match', input, match1, output1, ...matchN, outputN, fallback]` compares the `input` value against all
 *     provided `matchX` values, returning the output associated with the first valid match. If no match is found,
 *     returns the `fallback` value.
 *     `input` and `matchX` values must all be of the same type, and can be `number` or `string`. `outputX` and
 *     `fallback` values must be of the same type, and can be of any kind.
 *   * `['interpolate', interpolation, input, stop1, output1, ...stopN, outputN]` returns a value by interpolating between
 *     pairs of inputs and outputs; `interpolation` can either be `['linear']` or `['exponential', base]` where `base` is
 *     the rate of increase from stop A to stop B (i.e. power to which the interpolation ratio is raised); a value
 *     of 1 is equivalent to `['linear']`.
 *     `input` and `stopX` values must all be of type `number`. `outputX` values can be `number` or `color` values.
 *     Note: `input` will be clamped between `stop1` and `stopN`, meaning that all output values will be comprised
 *     between `output1` and `outputN`.
 *
 * * Logical operators:
 *   * `['<', value1, value2]` returns `true` if `value1` is strictly lower than `value2`, or `false` otherwise.
 *   * `['<=', value1, value2]` returns `true` if `value1` is lower than or equals `value2`, or `false` otherwise.
 *   * `['>', value1, value2]` returns `true` if `value1` is strictly greater than `value2`, or `false` otherwise.
 *   * `['>=', value1, value2]` returns `true` if `value1` is greater than or equals `value2`, or `false` otherwise.
 *   * `['==', value1, value2]` returns `true` if `value1` equals `value2`, or `false` otherwise.
 *   * `['!=', value1, value2]` returns `true` if `value1` does not equal `value2`, or `false` otherwise.
 *   * `['!', value1]` returns `false` if `value1` is `true` or greater than `0`, or `true` otherwise.
 *   * `['all', value1, value2, ...]` returns `true` if all the inputs are `true`, `false` otherwise.
 *   * `['any', value1, value2, ...]` returns `true` if any of the inputs are `true`, `false` otherwise.
 *   * `['between', value1, value2, value3]` returns `true` if `value1` is contained between `value2` and `value3`
 *     (inclusively), or `false` otherwise.
 *   * `['in', needle, haystack]` returns `true` if `needle` is found in `haystack`, and
 *     `false` otherwise.
 *     This operator has the following limitations:
 *     * `haystack` has to be an array of numbers or strings (searching for a substring in a string is not supported yet)
 *     * Only literal arrays are supported as `haystack` for now; this means that `haystack` cannot be the result of an
 *     expression. If `haystack` is an array of strings, use the `literal` operator to disambiguate from an expression:
 *     `['literal', ['abc', 'def', 'ghi']]`
 *
 * * Conversion operators:
 *   * `['array', value1, ...valueN]` creates a numerical array from `number` values; please note that the amount of
 *     values can currently only be 2, 3 or 4.
 *   * `['color', red, green, blue, alpha]` creates a `color` value from `number` values; the `alpha` parameter is
 *     optional; if not specified, it will be set to 1.
 *     Note: `red`, `green` and `blue` components must be values between 0 and 255; `alpha` between 0 and 1.
 *   * `['palette', index, colors]` picks a `color` value from an array of colors using the given index; the `index`
 *     expression must evaluate to a number; the items in the `colors` array must be strings with hex colors
 *     (e.g. `'#86A136'`), colors using the rgba[a] functional notation (e.g. `'rgb(134, 161, 54)'` or `'rgba(134, 161, 54, 1)'`),
 *     named colors (e.g. `'red'`), or array literals with 3 ([r, g, b]) or 4 ([r, g, b, a]) values (with r, g, and b
 *     in the 0-255 range and a in the 0-1 range).
 *
 * Values can either be literals or another operator, as they will be evaluated recursively.
 * Literal values can be of the following types:
 * * `boolean`
 * * `number`
 * * `number[]` (number arrays can only have a length of 2, 3 or 4)
 * * `string`
 * * {@link module:ol/color~Color}
 *
 * @typedef {Array<*>|import("../color.js").Color|string|number|boolean} ExpressionValue
 * @api
 */ var $2a0f71133411c509$var$numTypes = 0;
var $2a0f71133411c509$export$267d7ad6fa96ffaf = 0;
var $2a0f71133411c509$export$240f7fffab1b25a0 = 1 << $2a0f71133411c509$var$numTypes++;
var $2a0f71133411c509$export$86a7aca748b1e260 = 1 << $2a0f71133411c509$var$numTypes++;
var $2a0f71133411c509$export$2b93044cbf134323 = 1 << $2a0f71133411c509$var$numTypes++;
var $2a0f71133411c509$export$2cd82751acc0e609 = 1 << $2a0f71133411c509$var$numTypes++;
var $2a0f71133411c509$export$d701d0e49f4bcb39 = 1 << $2a0f71133411c509$var$numTypes++;
var $2a0f71133411c509$export$ec4c9a150bae86cd = Math.pow(2, $2a0f71133411c509$var$numTypes) - 1;
var $2a0f71133411c509$var$_obj;
var $2a0f71133411c509$var$typeNames = ($2a0f71133411c509$var$_obj = {}, (0, $iCQyW._)($2a0f71133411c509$var$_obj, $2a0f71133411c509$export$240f7fffab1b25a0, "boolean"), (0, $iCQyW._)($2a0f71133411c509$var$_obj, $2a0f71133411c509$export$86a7aca748b1e260, "number"), (0, $iCQyW._)($2a0f71133411c509$var$_obj, $2a0f71133411c509$export$2b93044cbf134323, "string"), (0, $iCQyW._)($2a0f71133411c509$var$_obj, $2a0f71133411c509$export$2cd82751acc0e609, "color"), (0, $iCQyW._)($2a0f71133411c509$var$_obj, $2a0f71133411c509$export$d701d0e49f4bcb39, "number[]"), $2a0f71133411c509$var$_obj);
var $2a0f71133411c509$var$namedTypes = Object.keys($2a0f71133411c509$var$typeNames).map(Number).sort((0, $edee3659e50a93f4$export$fcb633242ef15540));
function $2a0f71133411c509$export$b2afc7c96b2b4a45(type) {
    var names = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $2a0f71133411c509$var$namedTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var namedType = _step.value;
            if ($2a0f71133411c509$export$9fdcb8b441c4f2b4(type, namedType)) names.push($2a0f71133411c509$var$typeNames[namedType]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (names.length === 0) return "untyped";
    if (names.length < 3) return names.join(" or ");
    return names.slice(0, -1).join(", ") + ", or " + names[names.length - 1];
}
function $2a0f71133411c509$export$9fdcb8b441c4f2b4(broad, specific) {
    return (broad & specific) === specific;
}
function $2a0f71133411c509$export$3252d368d784c970(oneType, otherType) {
    return !!(oneType & otherType);
}
function $2a0f71133411c509$export$26b9f946b448f23e(type, expected) {
    return type === expected;
}
var $2a0f71133411c509$export$eb63e96e0913dda4 = function LiteralExpression(type, value) {
    "use strict";
    (0, $5sFFs._)(this, LiteralExpression);
    this.type = type;
    this.value = value;
};
var $2a0f71133411c509$export$6f3d80189eb72cd4 = function CallExpression(type, operator) {
    "use strict";
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        args[_key - 2] = arguments[_key];
    }
    (0, $5sFFs._)(this, CallExpression);
    this.type = type;
    this.operator = operator;
    this.args = args;
};
function $2a0f71133411c509$export$1c8b4c1584800354() {
    return {
        variables: new Set(),
        properties: new Set(),
        featureId: false,
        style: {}
    };
}
/**
 * @param {string} typeHint Type hint
 * @return {number} Resulting value type (will be a single type)
 */ function $2a0f71133411c509$var$getTypeFromHint(typeHint) {
    switch(typeHint){
        case "string":
            return $2a0f71133411c509$export$2b93044cbf134323;
        case "color":
            return $2a0f71133411c509$export$2cd82751acc0e609;
        case "number":
            return $2a0f71133411c509$export$86a7aca748b1e260;
        case "boolean":
            return $2a0f71133411c509$export$240f7fffab1b25a0;
        case "number[]":
            return $2a0f71133411c509$export$d701d0e49f4bcb39;
        default:
            throw new Error("Unrecognized type hint: ".concat(typeHint));
    }
}
function $2a0f71133411c509$export$98e6a39c04603d36(encoded, context, typeHint) {
    switch(typeof encoded === "undefined" ? "undefined" : (0, $l6pW7._)(encoded)){
        case "boolean":
            return new $2a0f71133411c509$export$eb63e96e0913dda4($2a0f71133411c509$export$240f7fffab1b25a0, encoded);
        case "number":
            return new $2a0f71133411c509$export$eb63e96e0913dda4($2a0f71133411c509$export$86a7aca748b1e260, encoded);
        case "string":
            {
                var type = $2a0f71133411c509$export$2b93044cbf134323;
                if ((0, $03ff7455ee88c2e9$export$40dd713d7775a0b1)(encoded)) type |= $2a0f71133411c509$export$2cd82751acc0e609;
                // apply the given type hint only if it won't result in an empty type
                if (!$2a0f71133411c509$export$26b9f946b448f23e(type & typeHint, $2a0f71133411c509$export$267d7ad6fa96ffaf)) type &= typeHint;
                return new $2a0f71133411c509$export$eb63e96e0913dda4(type, encoded);
            }
        default:
    }
    if (!Array.isArray(encoded)) throw new Error("Expression must be an array or a primitive value");
    if (encoded.length === 0) throw new Error("Empty expression");
    if (typeof encoded[0] === "string") return $2a0f71133411c509$var$parseCallExpression(encoded, context, typeHint);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = encoded[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (typeof item !== "number") throw new Error("Expected an array of numbers");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var type1 = $2a0f71133411c509$export$d701d0e49f4bcb39;
    if (encoded.length === 3 || encoded.length === 4) type1 |= $2a0f71133411c509$export$2cd82751acc0e609;
    if (typeHint) type1 &= typeHint;
    return new $2a0f71133411c509$export$eb63e96e0913dda4(type1, encoded);
}
var $2a0f71133411c509$export$2655e45458bc48f3 = {
    Get: "get",
    Var: "var",
    Concat: "concat",
    GeometryType: "geometry-type",
    Any: "any",
    All: "all",
    Not: "!",
    Resolution: "resolution",
    Zoom: "zoom",
    Time: "time",
    Equal: "==",
    NotEqual: "!=",
    GreaterThan: ">",
    GreaterThanOrEqualTo: ">=",
    LessThan: "<",
    LessThanOrEqualTo: "<=",
    Multiply: "*",
    Divide: "/",
    Add: "+",
    Subtract: "-",
    Clamp: "clamp",
    Mod: "%",
    Pow: "^",
    Abs: "abs",
    Floor: "floor",
    Ceil: "ceil",
    Round: "round",
    Sin: "sin",
    Cos: "cos",
    Atan: "atan",
    Sqrt: "sqrt",
    Match: "match",
    Between: "between",
    Interpolate: "interpolate",
    Case: "case",
    In: "in",
    Number: "number",
    String: "string",
    Array: "array",
    Color: "color",
    Id: "id",
    Band: "band",
    Palette: "palette"
};
var $2a0f71133411c509$var$_obj1;
/**
 * @typedef {function(Array, ParsingContext, number):Expression} Parser
 * Third argument is a type hint
 */ /**
 * @type {Object<string, Parser>}
 */ var $2a0f71133411c509$var$parsers = ($2a0f71133411c509$var$_obj1 = {}, (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Get, $2a0f71133411c509$var$createParser(function(param) {
    var _param = (0, $52tJv._)(param, 2), _ = _param[0], typeHint = _param[1];
    if (typeHint !== undefined) return $2a0f71133411c509$var$getTypeFromHint(/** @type {string} */ /** @type {LiteralExpression} */ typeHint.value);
    return $2a0f71133411c509$export$ec4c9a150bae86cd;
}, $2a0f71133411c509$var$withArgsCount(1, 2), $2a0f71133411c509$var$withGetArgs)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Var, $2a0f71133411c509$var$createParser(function(param) {
    var _param = (0, $52tJv._)(param, 1), firstArg = _param[0];
    return firstArg.type;
}, $2a0f71133411c509$var$withArgsCount(1, 1), $2a0f71133411c509$var$withVarArgs)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Id, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260 | $2a0f71133411c509$export$2b93044cbf134323, $2a0f71133411c509$var$withNoArgs, $2a0f71133411c509$var$usesFeatureId)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Concat, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$2b93044cbf134323, $2a0f71133411c509$var$withArgsCount(2, Infinity), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$ec4c9a150bae86cd))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.GeometryType, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$2b93044cbf134323, $2a0f71133411c509$var$withNoArgs)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Resolution, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withNoArgs)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Zoom, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withNoArgs)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Time, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withNoArgs)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Any, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$240f7fffab1b25a0, $2a0f71133411c509$var$withArgsCount(2, Infinity), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$240f7fffab1b25a0))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.All, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$240f7fffab1b25a0, $2a0f71133411c509$var$withArgsCount(2, Infinity), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$240f7fffab1b25a0))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Not, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$240f7fffab1b25a0, $2a0f71133411c509$var$withArgsCount(1, 1), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$240f7fffab1b25a0))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Equal, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$240f7fffab1b25a0, $2a0f71133411c509$var$withArgsCount(2, 2), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$ec4c9a150bae86cd), $2a0f71133411c509$var$narrowArgsType)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.NotEqual, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$240f7fffab1b25a0, $2a0f71133411c509$var$withArgsCount(2, 2), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$ec4c9a150bae86cd), $2a0f71133411c509$var$narrowArgsType)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.GreaterThan, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$240f7fffab1b25a0, $2a0f71133411c509$var$withArgsCount(2, 2), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$ec4c9a150bae86cd), $2a0f71133411c509$var$narrowArgsType)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.GreaterThanOrEqualTo, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$240f7fffab1b25a0, $2a0f71133411c509$var$withArgsCount(2, 2), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$ec4c9a150bae86cd), $2a0f71133411c509$var$narrowArgsType)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.LessThan, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$240f7fffab1b25a0, $2a0f71133411c509$var$withArgsCount(2, 2), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$ec4c9a150bae86cd), $2a0f71133411c509$var$narrowArgsType)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.LessThanOrEqualTo, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$240f7fffab1b25a0, $2a0f71133411c509$var$withArgsCount(2, 2), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$ec4c9a150bae86cd), $2a0f71133411c509$var$narrowArgsType)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Multiply, $2a0f71133411c509$var$createParser(function(parsedArgs) {
    var outputType = $2a0f71133411c509$export$86a7aca748b1e260 | $2a0f71133411c509$export$2cd82751acc0e609;
    for(var i = 0; i < parsedArgs.length; i++)outputType &= parsedArgs[i].type;
    return outputType;
}, $2a0f71133411c509$var$withArgsCount(2, Infinity), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260 | $2a0f71133411c509$export$2cd82751acc0e609), $2a0f71133411c509$var$narrowArgsType)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Divide, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(2, 2), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Add, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(2, Infinity), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Subtract, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(2, 2), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Clamp, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(3, 3), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Mod, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(2, 2), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Pow, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(2, 2), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Abs, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(1, 1), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Floor, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(1, 1), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Ceil, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(1, 1), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Round, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(1, 1), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Sin, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(1, 1), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Cos, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(1, 1), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Atan, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(1, 2), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Sqrt, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(1, 1), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Match, $2a0f71133411c509$var$createParser(function(parsedArgs) {
    var type = $2a0f71133411c509$export$ec4c9a150bae86cd;
    for(var i = 2; i < parsedArgs.length; i += 2)type &= parsedArgs[i].type;
    type &= parsedArgs[parsedArgs.length - 1].type;
    return type;
}, $2a0f71133411c509$var$withArgsCount(4, Infinity), $2a0f71133411c509$var$withEvenArgs, $2a0f71133411c509$var$parseMatchArgs)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Between, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$240f7fffab1b25a0, $2a0f71133411c509$var$withArgsCount(3, 3), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Interpolate, $2a0f71133411c509$var$createParser(function(parsedArgs) {
    var type = $2a0f71133411c509$export$2cd82751acc0e609 | $2a0f71133411c509$export$86a7aca748b1e260;
    for(var i = 3; i < parsedArgs.length; i += 2)type &= parsedArgs[i].type;
    return type;
}, $2a0f71133411c509$var$withArgsCount(6, Infinity), $2a0f71133411c509$var$withEvenArgs, $2a0f71133411c509$var$parseInterpolateArgs)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Case, $2a0f71133411c509$var$createParser(function(parsedArgs) {
    var type = $2a0f71133411c509$export$ec4c9a150bae86cd;
    for(var i = 1; i < parsedArgs.length; i += 2)type &= parsedArgs[i].type;
    type &= parsedArgs[parsedArgs.length - 1].type;
    return type;
}, $2a0f71133411c509$var$withArgsCount(3, Infinity), $2a0f71133411c509$var$withOddArgs, $2a0f71133411c509$var$parseCaseArgs)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.In, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$240f7fffab1b25a0, $2a0f71133411c509$var$withArgsCount(2, 2), $2a0f71133411c509$var$parseInArgs)), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Number, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(1, Infinity), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$ec4c9a150bae86cd))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.String, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$2b93044cbf134323, $2a0f71133411c509$var$withArgsCount(1, Infinity), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$ec4c9a150bae86cd))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Array, $2a0f71133411c509$var$createParser(function(parsedArgs) {
    return parsedArgs.length === 3 || parsedArgs.length === 4 ? $2a0f71133411c509$export$d701d0e49f4bcb39 | $2a0f71133411c509$export$2cd82751acc0e609 : $2a0f71133411c509$export$d701d0e49f4bcb39;
}, $2a0f71133411c509$var$withArgsCount(1, Infinity), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Color, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$2cd82751acc0e609, $2a0f71133411c509$var$withArgsCount(3, 4), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Band, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$86a7aca748b1e260, $2a0f71133411c509$var$withArgsCount(1, 3), $2a0f71133411c509$var$parseArgsOfType($2a0f71133411c509$export$86a7aca748b1e260))), (0, $iCQyW._)($2a0f71133411c509$var$_obj1, $2a0f71133411c509$export$2655e45458bc48f3.Palette, $2a0f71133411c509$var$createParser($2a0f71133411c509$export$2cd82751acc0e609, $2a0f71133411c509$var$withArgsCount(2, 2), $2a0f71133411c509$var$parsePaletteArgs)), $2a0f71133411c509$var$_obj1);
/**
 * @typedef {function(Array<EncodedExpression>, ParsingContext, Array<Expression>, number?):Array<Expression>|void} ArgValidator
 * An argument validator applies various checks to an encoded expression arguments
 * Returns the parsed arguments if any.
 * Third argument is the array of parsed arguments from previous validators
 * Fourth argument is an optional type hint
 */ /**
 * @type ArgValidator
 */ function $2a0f71133411c509$var$withGetArgs(encoded, context) {
    var arg = $2a0f71133411c509$export$98e6a39c04603d36(encoded[1], context);
    if (!(arg instanceof $2a0f71133411c509$export$eb63e96e0913dda4)) throw new Error("Expected a literal argument for get operation");
    if (typeof arg.value !== "string") throw new Error("Expected a string argument for get operation");
    context.properties.add(arg.value);
    if (encoded.length === 3) {
        var hint = $2a0f71133411c509$export$98e6a39c04603d36(encoded[2], context);
        return [
            arg,
            hint
        ];
    }
    return [
        arg
    ];
}
/**
 * @type ArgValidator
 */ function $2a0f71133411c509$var$withVarArgs(encoded, context, parsedArgs, typeHint) {
    var varName = encoded[1];
    if (typeof varName !== "string") throw new Error("Expected a string argument for var operation");
    context.variables.add(varName);
    if (!("variables" in context.style) || context.style.variables[varName] === undefined) return [
        new $2a0f71133411c509$export$eb63e96e0913dda4($2a0f71133411c509$export$ec4c9a150bae86cd, varName)
    ];
    var initialValue = context.style.variables[varName];
    var arg = /** @type {LiteralExpression} */ $2a0f71133411c509$export$98e6a39c04603d36(initialValue, context);
    arg.value = varName;
    if (typeHint && !$2a0f71133411c509$export$3252d368d784c970(typeHint, arg.type)) throw new Error("The variable ".concat(varName, " has type ").concat($2a0f71133411c509$export$b2afc7c96b2b4a45(arg.type), " but the following type was expected: ").concat($2a0f71133411c509$export$b2afc7c96b2b4a45(typeHint)));
    return [
        arg
    ];
}
/**
 * @type ArgValidator
 */ function $2a0f71133411c509$var$usesFeatureId(encoded, context) {
    context.featureId = true;
}
/**
 * @type ArgValidator
 */ function $2a0f71133411c509$var$withNoArgs(encoded, context) {
    var operation = encoded[0];
    if (encoded.length !== 1) throw new Error("Expected no arguments for ".concat(operation, " operation"));
    return [];
}
/**
 * @param {number} minArgs The minimum number of arguments.
 * @param {number} maxArgs The maximum number of arguments.
 * @return {ArgValidator} The argument validator
 */ function $2a0f71133411c509$var$withArgsCount(minArgs, maxArgs) {
    return function(encoded, context) {
        var operation = encoded[0];
        var argCount = encoded.length - 1;
        if (minArgs === maxArgs) {
            if (argCount !== minArgs) {
                var plural = minArgs === 1 ? "" : "s";
                throw new Error("Expected ".concat(minArgs, " argument").concat(plural, " for ").concat(operation, ", got ").concat(argCount));
            }
        } else if (argCount < minArgs || argCount > maxArgs) {
            var range = maxArgs === Infinity ? "".concat(minArgs, " or more") : "".concat(minArgs, " to ").concat(maxArgs);
            throw new Error("Expected ".concat(range, " arguments for ").concat(operation, ", got ").concat(argCount));
        }
    };
}
/**
 * @param {number} argType The argument type.
 * @return {ArgValidator} The argument validator
 */ function $2a0f71133411c509$var$parseArgsOfType(argType) {
    return function(encoded, context) {
        var operation = encoded[0];
        var argCount = encoded.length - 1;
        /**
     * @type {Array<Expression>}
     */ var args = new Array(argCount);
        for(var i = 0; i < argCount; ++i){
            var expression = $2a0f71133411c509$export$98e6a39c04603d36(encoded[i + 1], context);
            if (!$2a0f71133411c509$export$3252d368d784c970(argType, expression.type)) {
                var gotType = $2a0f71133411c509$export$b2afc7c96b2b4a45(argType);
                var expectedType = $2a0f71133411c509$export$b2afc7c96b2b4a45(expression.type);
                throw new Error("Unexpected type for argument ".concat(i, " of ").concat(operation, " operation") + ", got ".concat(gotType, " but expected ").concat(expectedType));
            }
            expression.type &= argType;
            args[i] = expression;
        }
        return args;
    };
}
/**
 * @type {ArgValidator}
 */ function $2a0f71133411c509$var$narrowArgsType(encoded, context, parsedArgs) {
    var operation = encoded[0];
    var argCount = encoded.length - 1;
    // first pass to determine a narrowed down type
    var sameType = $2a0f71133411c509$export$ec4c9a150bae86cd;
    for(var i = 0; i < parsedArgs.length; ++i)sameType &= parsedArgs[i].type;
    if (sameType === $2a0f71133411c509$export$267d7ad6fa96ffaf) throw new Error("No common type could be found for arguments of ".concat(operation, " operation"));
    // re-parse args
    var args = new Array(argCount);
    for(var i1 = 0; i1 < argCount; ++i1)args[i1] = $2a0f71133411c509$export$98e6a39c04603d36(encoded[i1 + 1], context, sameType);
    return args;
}
/**
 * @type {ArgValidator}
 */ function $2a0f71133411c509$var$withOddArgs(encoded, context) {
    var operation = encoded[0];
    var argCount = encoded.length - 1;
    if (argCount % 2 === 0) throw new Error("An odd amount of arguments was expected for operation ".concat(operation, ", got ").concat(JSON.stringify(argCount), " instead"));
}
/**
 * @type {ArgValidator}
 */ function $2a0f71133411c509$var$withEvenArgs(encoded, context) {
    var operation = encoded[0];
    var argCount = encoded.length - 1;
    if (argCount % 2 === 1) throw new Error("An even amount of arguments was expected for operation ".concat(operation, ", got ").concat(JSON.stringify(argCount), " instead"));
}
/**
 * @type ArgValidator
 */ function $2a0f71133411c509$var$parseMatchArgs(encoded, context, parsedArgs, typeHint) {
    var argsCount = encoded.length - 1;
    var input = $2a0f71133411c509$export$98e6a39c04603d36(encoded[1], context);
    var inputType = input.type;
    var fallback = $2a0f71133411c509$export$98e6a39c04603d36(encoded[encoded.length - 1], context);
    var outputType = typeHint !== undefined ? typeHint & fallback.type : fallback.type;
    // first parse args to figure out possible types
    var args = new Array(argsCount - 2);
    for(var i = 0; i < argsCount - 2; i += 2){
        var match = $2a0f71133411c509$export$98e6a39c04603d36(encoded[i + 2], context);
        var output = $2a0f71133411c509$export$98e6a39c04603d36(encoded[i + 3], context);
        inputType &= match.type;
        outputType &= output.type;
        args[i] = match;
        args[i + 1] = output;
    }
    // check input and output types validity
    var expectedInputType = $2a0f71133411c509$export$2b93044cbf134323 | $2a0f71133411c509$export$86a7aca748b1e260 | $2a0f71133411c509$export$240f7fffab1b25a0;
    if (!$2a0f71133411c509$export$3252d368d784c970(expectedInputType, inputType)) throw new Error("Expected an input of type ".concat($2a0f71133411c509$export$b2afc7c96b2b4a45(expectedInputType), " for the interpolate operation") + ", got ".concat($2a0f71133411c509$export$b2afc7c96b2b4a45(inputType), " instead"));
    if ($2a0f71133411c509$export$26b9f946b448f23e(outputType, $2a0f71133411c509$export$267d7ad6fa96ffaf)) throw new Error("Could not find a common output type for the following match operation: " + JSON.stringify(encoded));
    // parse again inputs and outputs with common type
    for(var i1 = 0; i1 < argsCount - 2; i1 += 2){
        var match1 = $2a0f71133411c509$export$98e6a39c04603d36(encoded[i1 + 2], context, inputType);
        var output1 = $2a0f71133411c509$export$98e6a39c04603d36(encoded[i1 + 3], context, outputType);
        args[i1] = match1;
        args[i1 + 1] = output1;
    }
    return [
        $2a0f71133411c509$export$98e6a39c04603d36(encoded[1], context, inputType)
    ].concat((0, $fyztb._)(args), [
        $2a0f71133411c509$export$98e6a39c04603d36(encoded[encoded.length - 1], context, outputType)
    ]);
}
/**
 * @type ArgValidator
 */ function $2a0f71133411c509$var$parseInterpolateArgs(encoded, context, parsedArgs, typeHint) {
    var interpolationType = encoded[1];
    var interpolation;
    switch(interpolationType[0]){
        case "linear":
            interpolation = 1;
            break;
        case "exponential":
            interpolation = interpolationType[1];
            if (typeof interpolation !== "number") throw new Error("Expected a number base for exponential interpolation" + ", got ".concat(JSON.stringify(interpolation), " instead"));
            break;
        default:
            interpolation = null;
    }
    if (!interpolation) throw new Error("Invalid interpolation type: ".concat(JSON.stringify(interpolationType)));
    interpolation = $2a0f71133411c509$export$98e6a39c04603d36(interpolation, context);
    // check input types
    var input = $2a0f71133411c509$export$98e6a39c04603d36(encoded[2], context);
    if (!$2a0f71133411c509$export$3252d368d784c970($2a0f71133411c509$export$86a7aca748b1e260, input.type)) throw new Error("Expected an input of type number for the interpolate operation" + ", got ".concat($2a0f71133411c509$export$b2afc7c96b2b4a45(input.type), " instead"));
    input = $2a0f71133411c509$export$98e6a39c04603d36(encoded[2], context, $2a0f71133411c509$export$86a7aca748b1e260); // parse again with narrower output
    var args = new Array(encoded.length - 3);
    for(var i = 0; i < args.length; i += 2){
        var stop = $2a0f71133411c509$export$98e6a39c04603d36(encoded[i + 3], context);
        if (!$2a0f71133411c509$export$3252d368d784c970($2a0f71133411c509$export$86a7aca748b1e260, stop.type)) throw new Error("Expected all stop input values in the interpolate operation to be of type number" + ", got ".concat($2a0f71133411c509$export$b2afc7c96b2b4a45(stop.type), " at position ").concat(i + 2, " instead"));
        var output = $2a0f71133411c509$export$98e6a39c04603d36(encoded[i + 4], context);
        if (!$2a0f71133411c509$export$3252d368d784c970($2a0f71133411c509$export$86a7aca748b1e260 | $2a0f71133411c509$export$2cd82751acc0e609, output.type)) throw new Error("Expected all stop output values in the interpolate operation to be a number or color" + ", got ".concat($2a0f71133411c509$export$b2afc7c96b2b4a45(output.type), " at position ").concat(i + 3, " instead"));
        // parse again with narrower types
        stop = $2a0f71133411c509$export$98e6a39c04603d36(encoded[i + 3], context, $2a0f71133411c509$export$86a7aca748b1e260);
        output = $2a0f71133411c509$export$98e6a39c04603d36(encoded[i + 4], context, $2a0f71133411c509$export$86a7aca748b1e260 | $2a0f71133411c509$export$2cd82751acc0e609);
        args[i] = stop;
        args[i + 1] = output;
    }
    return [
        interpolation,
        input
    ].concat((0, $fyztb._)(args));
}
/**
 * @type ArgValidator
 */ function $2a0f71133411c509$var$parseCaseArgs(encoded, context, parsedArgs, typeHint) {
    var fallback = $2a0f71133411c509$export$98e6a39c04603d36(encoded[encoded.length - 1], context);
    var outputType = typeHint !== undefined ? typeHint & fallback.type : fallback.type;
    // first parse args to figure out possible types
    var args = new Array(encoded.length - 1);
    for(var i = 0; i < args.length - 1; i += 2){
        var condition = $2a0f71133411c509$export$98e6a39c04603d36(encoded[i + 1], context);
        var output = $2a0f71133411c509$export$98e6a39c04603d36(encoded[i + 2], context);
        if (!$2a0f71133411c509$export$3252d368d784c970($2a0f71133411c509$export$240f7fffab1b25a0, condition.type)) throw new Error("Expected all conditions in the case operation to be of type boolean" + ", got ".concat($2a0f71133411c509$export$b2afc7c96b2b4a45(condition.type), " at position ").concat(i, " instead"));
        outputType &= output.type;
        args[i] = condition;
        args[i + 1] = output;
    }
    if ($2a0f71133411c509$export$26b9f946b448f23e(outputType, $2a0f71133411c509$export$267d7ad6fa96ffaf)) throw new Error("Could not find a common output type for the following case operation: " + JSON.stringify(encoded));
    // parse again args with common output type
    for(var i1 = 0; i1 < args.length - 1; i1 += 2)args[i1 + 1] = $2a0f71133411c509$export$98e6a39c04603d36(encoded[i1 + 2], context, outputType);
    args[args.length - 1] = $2a0f71133411c509$export$98e6a39c04603d36(encoded[encoded.length - 1], context, outputType);
    return args;
}
/**
 * @type ArgValidator
 */ function $2a0f71133411c509$var$parseInArgs(encoded, context) {
    /** @type {Array<number|string>} */ var haystack = /** @type {any} */ encoded[2];
    if (!Array.isArray(haystack)) throw new Error('The "in" operator was provided a literal value which was not an array as second argument.');
    if (typeof haystack[0] === "string") {
        if (haystack[0] !== "literal") throw new Error('For the "in" operator, a string array should be wrapped in a "literal" operator to disambiguate from expressions.');
        if (!Array.isArray(haystack[1])) throw new Error('The "in" operator was provided a literal value which was not an array as second argument.');
        haystack = haystack[1];
    }
    var needleType = $2a0f71133411c509$export$2b93044cbf134323 | $2a0f71133411c509$export$86a7aca748b1e260;
    var args = new Array(haystack.length);
    for(var i = 0; i < args.length; i++){
        var arg = $2a0f71133411c509$export$98e6a39c04603d36(haystack[i], context);
        needleType &= arg.type;
        args[i] = arg;
    }
    if ($2a0f71133411c509$export$26b9f946b448f23e(needleType, $2a0f71133411c509$export$267d7ad6fa96ffaf)) throw new Error("Could not find a common type for the following in operation: " + JSON.stringify(encoded));
    var needle = $2a0f71133411c509$export$98e6a39c04603d36(encoded[1], context, needleType);
    return [
        needle
    ].concat((0, $fyztb._)(args));
}
/**
 * @type ArgValidator
 */ function $2a0f71133411c509$var$parsePaletteArgs(encoded, context) {
    var index = $2a0f71133411c509$export$98e6a39c04603d36(encoded[1], context, $2a0f71133411c509$export$86a7aca748b1e260);
    if (index.type !== $2a0f71133411c509$export$86a7aca748b1e260) throw new Error("The first argument of palette must be an number, got ".concat($2a0f71133411c509$export$b2afc7c96b2b4a45(index.type), " instead"));
    var colors = encoded[2];
    if (!Array.isArray(colors)) throw new Error("The second argument of palette must be an array");
    var parsedColors = new Array(colors.length);
    for(var i = 0; i < parsedColors.length; i++){
        var color = $2a0f71133411c509$export$98e6a39c04603d36(colors[i], context, $2a0f71133411c509$export$2cd82751acc0e609);
        if (!(color instanceof $2a0f71133411c509$export$eb63e96e0913dda4)) throw new Error("The palette color at index ".concat(i, " must be a literal value"));
        if (!$2a0f71133411c509$export$3252d368d784c970(color.type, $2a0f71133411c509$export$2cd82751acc0e609)) throw new Error("The palette color at index ".concat(i, " should be of type color, got ").concat($2a0f71133411c509$export$b2afc7c96b2b4a45(color.type), " instead"));
        parsedColors[i] = color;
    }
    return [
        index
    ].concat((0, $fyztb._)(parsedColors));
}
/**
 * @param {number|function(Array<Expression>):number} returnType The return type of the operator; can be a fixed value or a callback taking the parsed
 * arguments
 * @param {Array<ArgValidator>} argValidators A chain of argument validators; the return value of the last validator
 * will be used as parsed arguments
 * @return {Parser} The parser.
 */ function $2a0f71133411c509$var$createParser(returnType) {
    for(var _len = arguments.length, argValidators = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        argValidators[_key - 1] = arguments[_key];
    }
    return function(encoded, context, typeHint) {
        var operator = encoded[0];
        var parsedArgs = [];
        for(var i = 0; i < argValidators.length; i++)parsedArgs = argValidators[i](encoded, context, parsedArgs, typeHint) || parsedArgs;
        var actualType = typeof returnType === "function" ? returnType(parsedArgs) : returnType;
        if (typeHint !== undefined) {
            if (!$2a0f71133411c509$export$3252d368d784c970(actualType, typeHint)) throw new Error("The following expression was expected to return ".concat($2a0f71133411c509$export$b2afc7c96b2b4a45(typeHint), ", but returns ").concat($2a0f71133411c509$export$b2afc7c96b2b4a45(actualType), " instead: ").concat(JSON.stringify(encoded)));
            actualType &= typeHint;
        }
        if (actualType === $2a0f71133411c509$export$267d7ad6fa96ffaf) throw new Error("No matching type was found for the following expression: ".concat(JSON.stringify(encoded)));
        return (0, $amGNX._)($2a0f71133411c509$export$6f3d80189eb72cd4, [
            actualType,
            operator
        ].concat((0, $fyztb._)(parsedArgs)));
    };
}
/**
 * @param {Array} encoded The encoded expression.
 * @param {ParsingContext} context The parsing context.
 * @param {number} [typeHint] Optional type hint
 * @return {Expression} The parsed expression.
 */ function $2a0f71133411c509$var$parseCallExpression(encoded, context, typeHint) {
    var operator = encoded[0];
    var parser = $2a0f71133411c509$var$parsers[operator];
    if (!parser) throw new Error("Unknown operator: ".concat(operator));
    return parser(encoded, context, typeHint);
}


/**
 * @module ol/expr/cpu
 */ 
var $fyztb = parcelRequire("fyztb");

var $l6pW7 = parcelRequire("l6pW7");


function $8409e30b8fa6943e$export$c18f39f0e136c26() {
    return {
        variables: {},
        properties: {},
        resolution: NaN,
        featureId: null
    };
}
function $8409e30b8fa6943e$export$b5f535122a9211f0(encoded, type, context) {
    var expression = (0, $2a0f71133411c509$export$98e6a39c04603d36)(encoded, context);
    if (!(0, $2a0f71133411c509$export$3252d368d784c970)(type, expression.type)) {
        var expected = (0, $2a0f71133411c509$export$b2afc7c96b2b4a45)(type);
        var actual = (0, $2a0f71133411c509$export$b2afc7c96b2b4a45)(expression.type);
        throw new Error("Expected expression to be of type ".concat(expected, ", got ").concat(actual));
    }
    return $8409e30b8fa6943e$var$compileExpression(expression, context);
}
/**
 * @param {import("./expression.js").Expression} expression The expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $8409e30b8fa6943e$var$compileExpression(expression, context) {
    if (expression instanceof (0, $2a0f71133411c509$export$eb63e96e0913dda4)) {
        // convert colors to array if possible
        if (expression.type === (0, $2a0f71133411c509$export$2cd82751acc0e609) && typeof expression.value === "string") {
            var colorValue = (0, $03ff7455ee88c2e9$export$3004f64547af360e)(expression.value);
            return function() {
                return colorValue;
            };
        }
        return function() {
            return expression.value;
        };
    }
    var operator = expression.operator;
    switch(operator){
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Number:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).String:
            return $8409e30b8fa6943e$var$compileAssertionExpression(expression, context);
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Get:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Var:
            return $8409e30b8fa6943e$var$compileAccessorExpression(expression, context);
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Id:
            return function(expression) {
                return expression.featureId;
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Concat:
            {
                var _;
                var args = expression.args.map(function(e) {
                    return $8409e30b8fa6943e$var$compileExpression(e, context);
                });
                return function(context) {
                    return (_ = "").concat.apply(_, (0, $fyztb._)(args.map(function(arg) {
                        return arg(context).toString();
                    })));
                };
            }
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Resolution:
            return function(context) {
                return context.resolution;
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Any:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).All:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Not:
            return $8409e30b8fa6943e$var$compileLogicalExpression(expression, context);
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Equal:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).NotEqual:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).LessThan:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).LessThanOrEqualTo:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).GreaterThan:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return $8409e30b8fa6943e$var$compileComparisonExpression(expression, context);
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Multiply:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Divide:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Add:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Subtract:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Clamp:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Mod:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Pow:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Abs:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Floor:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Ceil:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Round:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Sin:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Cos:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Atan:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Sqrt:
            return $8409e30b8fa6943e$var$compileNumericExpression(expression, context);
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Match:
            return $8409e30b8fa6943e$var$compileMatchExpression(expression, context);
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Interpolate:
            return $8409e30b8fa6943e$var$compileInterpolateExpression(expression, context);
        default:
            throw new Error("Unsupported operator ".concat(operator));
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $8409e30b8fa6943e$var$compileAssertionExpression(expression, context) {
    var type = expression.operator;
    var length = expression.args.length;
    var args = new Array(length);
    for(var i = 0; i < length; ++i)args[i] = $8409e30b8fa6943e$var$compileExpression(expression.args[i], context);
    switch(type){
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Number:
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).String:
            return function(context) {
                for(var i = 0; i < length; ++i){
                    var value = args[i](context);
                    if ((typeof value === "undefined" ? "undefined" : (0, $l6pW7._)(value)) === type) return value;
                }
                throw new Error("Expected one of the values to be a ".concat(type));
            };
        default:
            throw new Error("Unsupported assertion operator ".concat(type));
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $8409e30b8fa6943e$var$compileAccessorExpression(expression, context) {
    var nameExpression = /** @type {LiteralExpression} */ expression.args[0];
    var name = /** @type {string} */ nameExpression.value;
    switch(expression.operator){
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Get:
            return function(context) {
                return context.properties[name];
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Var:
            return function(context) {
                return context.variables[name];
            };
        default:
            throw new Error("Unsupported accessor operator ".concat(expression.operator));
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $8409e30b8fa6943e$var$compileComparisonExpression(expression, context) {
    var op = expression.operator;
    var left = $8409e30b8fa6943e$var$compileExpression(expression.args[0], context);
    var right = $8409e30b8fa6943e$var$compileExpression(expression.args[1], context);
    switch(op){
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Equal:
            return function(context) {
                return left(context) === right(context);
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).NotEqual:
            return function(context) {
                return left(context) !== right(context);
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).LessThan:
            return function(context) {
                return left(context) < right(context);
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).LessThanOrEqualTo:
            return function(context) {
                return left(context) <= right(context);
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).GreaterThan:
            return function(context) {
                return left(context) > right(context);
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return function(context) {
                return left(context) >= right(context);
            };
        default:
            throw new Error("Unsupported comparison operator ".concat(op));
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $8409e30b8fa6943e$var$compileLogicalExpression(expression, context) {
    var op = expression.operator;
    var length = expression.args.length;
    var args = new Array(length);
    for(var i = 0; i < length; ++i)args[i] = $8409e30b8fa6943e$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Any:
            return function(context) {
                for(var i = 0; i < length; ++i){
                    if (args[i](context)) return true;
                }
                return false;
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).All:
            return function(context) {
                for(var i = 0; i < length; ++i){
                    if (!args[i](context)) return false;
                }
                return true;
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Not:
            return function(context) {
                return !args[0](context);
            };
        default:
            throw new Error("Unsupported logical operator ".concat(op));
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {NumberEvaluator} The evaluator function.
 */ function $8409e30b8fa6943e$var$compileNumericExpression(expression, context) {
    var op = expression.operator;
    var length = expression.args.length;
    var args = new Array(length);
    for(var i = 0; i < length; ++i)args[i] = $8409e30b8fa6943e$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Multiply:
            return function(context) {
                var value = 1;
                for(var i = 0; i < length; ++i)value *= args[i](context);
                return value;
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Divide:
            return function(context) {
                return args[0](context) / args[1](context);
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Add:
            return function(context) {
                var value = 0;
                for(var i = 0; i < length; ++i)value += args[i](context);
                return value;
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Subtract:
            return function(context) {
                return args[0](context) - args[1](context);
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Clamp:
            return function(context) {
                var value = args[0](context);
                var min = args[1](context);
                if (value < min) return min;
                var max = args[2](context);
                if (value > max) return max;
                return value;
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Mod:
            return function(context) {
                return args[0](context) % args[1](context);
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Pow:
            return function(context) {
                return Math.pow(args[0](context), args[1](context));
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Abs:
            return function(context) {
                return Math.abs(args[0](context));
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Floor:
            return function(context) {
                return Math.floor(args[0](context));
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Ceil:
            return function(context) {
                return Math.ceil(args[0](context));
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Round:
            return function(context) {
                return Math.round(args[0](context));
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Sin:
            return function(context) {
                return Math.sin(args[0](context));
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Cos:
            return function(context) {
                return Math.cos(args[0](context));
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Atan:
            if (length === 2) return function(context) {
                return Math.atan2(args[0](context), args[1](context));
            };
            return function(context) {
                return Math.atan(args[0](context));
            };
        case (0, $2a0f71133411c509$export$2655e45458bc48f3).Sqrt:
            return function(context) {
                return Math.sqrt(args[0](context));
            };
        default:
            throw new Error("Unsupported numeric operator ".concat(op));
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $8409e30b8fa6943e$var$compileMatchExpression(expression, context) {
    var length = expression.args.length;
    var args = new Array(length);
    for(var i = 0; i < length; ++i)args[i] = $8409e30b8fa6943e$var$compileExpression(expression.args[i], context);
    return function(context) {
        var value = args[0](context);
        for(var i = 1; i < length; i += 2){
            if (value === args[i](context)) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $8409e30b8fa6943e$var$compileInterpolateExpression(expression, context) {
    var length = expression.args.length;
    var args = new Array(length);
    for(var i = 0; i < length; ++i)args[i] = $8409e30b8fa6943e$var$compileExpression(expression.args[i], context);
    return function(context) {
        var base = args[0](context);
        var value = args[1](context);
        var previousInput;
        var previousOutput;
        for(var i = 2; i < length; i += 2){
            var input = args[i](context);
            var output = args[i + 1](context);
            var isColor = Array.isArray(output);
            if (isColor) output = (0, $03ff7455ee88c2e9$export$138c09bdd6bd797c)(output);
            if (input >= value) {
                if (i === 2) return output;
                if (isColor) return $8409e30b8fa6943e$var$interpolateColor(base, value, previousInput, previousOutput, input, output);
                return $8409e30b8fa6943e$var$interpolateNumber(base, value, previousInput, previousOutput, input, output);
            }
            previousInput = input;
            previousOutput = output;
        }
        return previousOutput;
    };
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {number} output1 The first output value.
 * @param {number} input2 The second input value.
 * @param {number} output2 The second output value.
 * @return {number} The interpolated value.
 */ function $8409e30b8fa6943e$var$interpolateNumber(base, value, input1, output1, input2, output2) {
    var delta = input2 - input1;
    if (delta === 0) return output1;
    var along = value - input1;
    var factor = base === 1 ? along / delta : (Math.pow(base, along) - 1) / (Math.pow(base, delta) - 1);
    return output1 + factor * (output2 - output1);
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {import('../color.js').Color} rgba1 The first output value.
 * @param {number} input2 The second input value.
 * @param {import('../color.js').Color} rgba2 The second output value.
 * @return {import('../color.js').Color} The interpolated color.
 */ function $8409e30b8fa6943e$var$interpolateColor(base, value, input1, rgba1, input2, rgba2) {
    var delta = input2 - input1;
    if (delta === 0) return rgba1;
    var lcha1 = (0, $03ff7455ee88c2e9$export$44fb54fa2e0c0d4)(rgba1);
    var lcha2 = (0, $03ff7455ee88c2e9$export$44fb54fa2e0c0d4)(rgba2);
    var deltaHue = lcha2[2] - lcha1[2];
    if (deltaHue > 180) deltaHue -= 360;
    else if (deltaHue < -180) deltaHue += 360;
    var lcha = [
        $8409e30b8fa6943e$var$interpolateNumber(base, value, input1, lcha1[0], input2, lcha2[0]),
        $8409e30b8fa6943e$var$interpolateNumber(base, value, input1, lcha1[1], input2, lcha2[1]),
        lcha1[2] + $8409e30b8fa6943e$var$interpolateNumber(base, value, input1, 0, input2, deltaHue),
        $8409e30b8fa6943e$var$interpolateNumber(base, value, input1, rgba1[3], input2, rgba2[3])
    ];
    return (0, $03ff7455ee88c2e9$export$a3295358bff77e)((0, $03ff7455ee88c2e9$export$27cc94530c050f00)(lcha));
}




/**
 * @fileoverview This module includes functions to build styles for the canvas renderer.  Building
 * is composed of two steps: parsing and compiling.  The parsing step takes an encoded expression
 * and returns an instance of one of the expression classes.  The compiling step takes the
 * expression instance and returns a function that can be evaluated to return a literal value.  The
 * evaluator function should do as little allocation and work as possible.
 */ /**
 * @typedef {import("../../style/flat.js").FlatStyle} FlatStyle
 */ /**
 * @typedef {import("../../expr/expression.js").EncodedExpression} EncodedExpression
 */ /**
 * @typedef {import("../../expr/expression.js").ParsingContext} ParsingContext
 */ /**
 * @typedef {import("../../expr/expression.js").CallExpression} CallExpression
 */ /**
 * @typedef {import("../../expr/cpu.js").EvaluationContext} EvaluationContext
 */ /**
 * @typedef {import("../../expr/cpu.js").ExpressionEvaluator} ExpressionEvaluator
 */ /**
 * @param {EvaluationContext} context The evaluation context.
 * @return {boolean} Always true.
 */ function $55dacb98e1a1f2f7$var$always(context) {
    return true;
}
function $55dacb98e1a1f2f7$export$fc6a94152b1b05a8(rules) {
    var parsingContext = (0, $2a0f71133411c509$export$1c8b4c1584800354)();
    var evaluator = $55dacb98e1a1f2f7$export$d6ae6a4799989976(rules, parsingContext);
    var evaluationContext = (0, $8409e30b8fa6943e$export$c18f39f0e136c26)();
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            var id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        return evaluator(evaluationContext);
    };
}
function $55dacb98e1a1f2f7$export$5a130bc4f0a0420b(flatStyles) {
    var parsingContext = (0, $2a0f71133411c509$export$1c8b4c1584800354)();
    var length = flatStyles.length;
    /**
   * @type {Array<StyleEvaluator>}
   */ var evaluators = new Array(length);
    for(var i = 0; i < length; ++i)evaluators[i] = $55dacb98e1a1f2f7$export$a6e5f510497b7388(flatStyles[i], parsingContext);
    var evaluationContext = (0, $8409e30b8fa6943e$export$c18f39f0e136c26)();
    /**
   * @type {Array<Style>}
   */ var styles = new Array(length);
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            var id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        var nonNullCount = 0;
        for(var i = 0; i < length; ++i){
            var style = evaluators[i](evaluationContext);
            if (style) {
                styles[nonNullCount] = style;
                nonNullCount += 1;
            }
        }
        styles.length = nonNullCount;
        return styles;
    };
}
function $55dacb98e1a1f2f7$export$d6ae6a4799989976(rules, context) {
    var length = rules.length;
    /**
   * @type {Array<CompiledRule>}
   */ var compiledRules = new Array(length);
    for(var i = 0; i < length; ++i){
        var rule = rules[i];
        var filter = "filter" in rule ? (0, $8409e30b8fa6943e$export$b5f535122a9211f0)(rule.filter, (0, $2a0f71133411c509$export$240f7fffab1b25a0), context) : $55dacb98e1a1f2f7$var$always;
        /**
     * @type {Array<StyleEvaluator>}
     */ var styles = void 0;
        if (Array.isArray(rule.style)) {
            var styleLength = rule.style.length;
            styles = new Array(styleLength);
            for(var j = 0; j < styleLength; ++j)styles[j] = $55dacb98e1a1f2f7$export$a6e5f510497b7388(rule.style[j], context);
        } else styles = [
            $55dacb98e1a1f2f7$export$a6e5f510497b7388(rule.style, context)
        ];
        compiledRules[i] = {
            filter: filter,
            styles: styles
        };
    }
    return function(context) {
        /**
     * @type {Array<Style>}
     */ var styles = [];
        var someMatched = false;
        for(var i = 0; i < length; ++i){
            var filterEvaluator = compiledRules[i].filter;
            if (!filterEvaluator(context)) continue;
            if (rules[i].else && someMatched) continue;
            someMatched = true;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = compiledRules[i].styles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var styleEvaluator = _step.value;
                    var style = styleEvaluator(context);
                    if (!style) continue;
                    styles.push(style);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return styles;
    };
}
function $55dacb98e1a1f2f7$export$a6e5f510497b7388(flatStyle, context) {
    var evaluateFill = $55dacb98e1a1f2f7$var$buildFill(flatStyle, "", context);
    var evaluateStroke = $55dacb98e1a1f2f7$var$buildStroke(flatStyle, "", context);
    var evaluateText = $55dacb98e1a1f2f7$var$buildText(flatStyle, context);
    var evaluateImage = $55dacb98e1a1f2f7$var$buildImage(flatStyle, context);
    var evaluateZIndex = $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, "z-index", context);
    if (!evaluateFill && !evaluateStroke && !evaluateText && !evaluateImage && !(0, $29e93681307ffd1e$export$dd1bc94b04021eeb)(flatStyle)) // assume this is a user error
    // would be nice to check the properties and suggest "did you mean..."
    throw new Error("No fill, stroke, point, or text symbolizer properties in style: " + JSON.stringify(flatStyle));
    var style = new (0, $549a2342af29343f$export$2e2bcd8739ae039)();
    return function(context) {
        var empty = true;
        if (evaluateFill) {
            var fill = evaluateFill(context);
            if (fill) empty = false;
            style.setFill(fill);
        }
        if (evaluateStroke) {
            var stroke = evaluateStroke(context);
            if (stroke) empty = false;
            style.setStroke(stroke);
        }
        if (evaluateText) {
            var text = evaluateText(context);
            if (text) empty = false;
            style.setText(text);
        }
        if (evaluateImage) {
            var image = evaluateImage(context);
            if (image) empty = false;
            style.setImage(image);
        }
        if (evaluateZIndex) style.setZIndex(evaluateZIndex(context));
        if (empty) return null;
        return style;
    };
}
/**
 * @typedef {function(EvaluationContext):Fill|null} FillEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {FillEvaluator?} A function that evaluates to a fill.
 */ function $55dacb98e1a1f2f7$var$buildFill(flatStyle, prefix, context) {
    var evaluateColor = $55dacb98e1a1f2f7$var$colorLikeEvaluator(flatStyle, prefix + "fill-color", context);
    if (!evaluateColor) return null;
    var fill = new (0, $3f3dc9dd8a85276f$export$2e2bcd8739ae039)();
    return function(context) {
        var color = evaluateColor(context);
        if (color === "none") return null;
        fill.setColor(color);
        return fill;
    };
}
/**
 * @typedef {function(EvaluationContext):Stroke|null} StrokeEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {StrokeEvaluator?} A function the evaluates to a stroke.
 */ function $55dacb98e1a1f2f7$var$buildStroke(flatStyle, prefix, context) {
    var evaluateWidth = $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, prefix + "stroke-width", context);
    var evaluateColor = $55dacb98e1a1f2f7$var$colorLikeEvaluator(flatStyle, prefix + "stroke-color", context);
    if (!evaluateWidth && !evaluateColor) return null;
    var evaluateLineCap = $55dacb98e1a1f2f7$var$stringEvaluator(flatStyle, prefix + "stroke-line-cap", context);
    var evaluateLineJoin = $55dacb98e1a1f2f7$var$stringEvaluator(flatStyle, prefix + "stroke-line-join", context);
    var evaluateLineDash = $55dacb98e1a1f2f7$var$numberArrayEvaluator(flatStyle, prefix + "stroke-line-dash", context);
    var evaluateLineDashOffset = $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, prefix + "stroke-line-dash-offset", context);
    var evaluateMiterLimit = $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, prefix + "stroke-miter-limit", context);
    var stroke = new (0, $f2ca0e669183cbd3$export$2e2bcd8739ae039)();
    return function(context) {
        if (evaluateColor) {
            var color = evaluateColor(context);
            if (color === "none") return null;
            stroke.setColor(color);
        }
        if (evaluateWidth) stroke.setWidth(evaluateWidth(context));
        if (evaluateLineCap) {
            var lineCap = evaluateLineCap(context);
            if (lineCap !== "butt" && lineCap !== "round" && lineCap !== "square") throw new Error("Expected butt, round, or square line cap");
            stroke.setLineCap(lineCap);
        }
        if (evaluateLineJoin) {
            var lineJoin = evaluateLineJoin(context);
            if (lineJoin !== "bevel" && lineJoin !== "round" && lineJoin !== "miter") throw new Error("Expected bevel, round, or miter line join");
            stroke.setLineJoin(lineJoin);
        }
        if (evaluateLineDash) stroke.setLineDash(evaluateLineDash(context));
        if (evaluateLineDashOffset) stroke.setLineDashOffset(evaluateLineDashOffset(context));
        if (evaluateMiterLimit) stroke.setMiterLimit(evaluateMiterLimit(context));
        return stroke;
    };
}
/**
 * @typedef {function(EvaluationContext):Text} TextEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {TextEvaluator?} A function that evaluates to a text symbolizer.
 */ function $55dacb98e1a1f2f7$var$buildText(flatStyle, context) {
    var prefix = "text-";
    // Currently, an Array<string> may be used for rich text support.  This doesn't
    // work with our expression syntax where arrays of strings are interpreted as
    // call expressions.  To support rich text, we could add a 'strings' operator
    // where all the following arguments would be string values.
    var evaluateValue = $55dacb98e1a1f2f7$var$stringEvaluator(flatStyle, prefix + "value", context);
    if (!evaluateValue) return null;
    var evaluateFill = $55dacb98e1a1f2f7$var$buildFill(flatStyle, prefix, context);
    var evaluateBackgroundFill = $55dacb98e1a1f2f7$var$buildFill(flatStyle, prefix + "background-", context);
    var evaluateStroke = $55dacb98e1a1f2f7$var$buildStroke(flatStyle, prefix, context);
    var evaluateBackgroundStroke = $55dacb98e1a1f2f7$var$buildStroke(flatStyle, prefix + "background-", context);
    var evaluateFont = $55dacb98e1a1f2f7$var$stringEvaluator(flatStyle, prefix + "font", context);
    var evaluateMaxAngle = $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, prefix + "max-angle", context);
    var evaluateOffsetX = $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, prefix + "offset-x", context);
    var evaluateOffsetY = $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, prefix + "offset-y", context);
    var evaluateOverflow = $55dacb98e1a1f2f7$var$booleanEvaluator(flatStyle, prefix + "overflow", context);
    var evaluatePlacement = $55dacb98e1a1f2f7$var$stringEvaluator(flatStyle, prefix + "placement", context);
    var evaluateRepeat = $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, prefix + "repeat", context);
    var evaluateScale = $55dacb98e1a1f2f7$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    var evaluateRotateWithView = $55dacb98e1a1f2f7$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    var evaluateRotation = $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    var evaluateAlign = $55dacb98e1a1f2f7$var$stringEvaluator(flatStyle, prefix + "align", context);
    var evaluateJustify = $55dacb98e1a1f2f7$var$stringEvaluator(flatStyle, prefix + "justify", context);
    var evaluateBaseline = $55dacb98e1a1f2f7$var$stringEvaluator(flatStyle, prefix + "baseline", context);
    var evaluatePadding = $55dacb98e1a1f2f7$var$numberArrayEvaluator(flatStyle, prefix + "padding", context);
    var text = new (0, $049c95c34238c5a2$export$2e2bcd8739ae039)({});
    return function(context) {
        text.setText(evaluateValue(context));
        if (evaluateFill) text.setFill(evaluateFill(context));
        if (evaluateBackgroundFill) text.setBackgroundFill(evaluateBackgroundFill(context));
        if (evaluateStroke) text.setStroke(evaluateStroke(context));
        if (evaluateBackgroundStroke) text.setBackgroundStroke(evaluateBackgroundStroke(context));
        if (evaluateFont) text.setFont(evaluateFont(context));
        if (evaluateMaxAngle) text.setMaxAngle(evaluateMaxAngle(context));
        if (evaluateOffsetX) text.setOffsetX(evaluateOffsetX(context));
        if (evaluateOffsetY) text.setOffsetY(evaluateOffsetY(context));
        if (evaluateOverflow) text.setOverflow(evaluateOverflow(context));
        if (evaluatePlacement) {
            var placement = evaluatePlacement(context);
            if (placement !== "point" && placement !== "line") throw new Error("Expected point or line for text-placement");
            text.setPlacement(placement);
        }
        if (evaluateRepeat) text.setRepeat(evaluateRepeat(context));
        if (evaluateScale) text.setScale(evaluateScale(context));
        if (evaluateRotateWithView) text.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateRotation) text.setRotation(evaluateRotation(context));
        if (evaluateAlign) {
            var textAlign = evaluateAlign(context);
            if (textAlign !== "left" && textAlign !== "center" && textAlign !== "right" && textAlign !== "end" && textAlign !== "start") throw new Error("Expected left, right, center, start, or end for text-align");
            text.setTextAlign(textAlign);
        }
        if (evaluateJustify) {
            var justify = evaluateJustify(context);
            if (justify !== "left" && justify !== "right" && justify !== "center") throw new Error("Expected left, right, or center for text-justify");
            text.setJustify(justify);
        }
        if (evaluateBaseline) {
            var textBaseline = evaluateBaseline(context);
            if (textBaseline !== "bottom" && textBaseline !== "top" && textBaseline !== "middle" && textBaseline !== "alphabetic" && textBaseline !== "hanging") throw new Error("Expected bottom, top, middle, alphabetic, or hanging for text-baseline");
            text.setTextBaseline(textBaseline);
        }
        if (evaluatePadding) text.setPadding(evaluatePadding(context));
        return text;
    };
}
/**
 * @typedef {function(EvaluationContext):import("../../style/Image.js").default} ImageEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator?} A function that evaluates to an image symbolizer.
 */ function $55dacb98e1a1f2f7$var$buildImage(flatStyle, context) {
    if ("icon-src" in flatStyle) return $55dacb98e1a1f2f7$var$buildIcon(flatStyle, context);
    if ("shape-points" in flatStyle) return $55dacb98e1a1f2f7$var$buildShape(flatStyle, context);
    if ("circle-radius" in flatStyle) return $55dacb98e1a1f2f7$var$buildCircle(flatStyle, context);
    return null;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an image symbolizer.
 */ function $55dacb98e1a1f2f7$var$buildIcon(flatStyle, context) {
    var prefix = "icon-";
    // required property
    var srcName = prefix + "src";
    var src = $55dacb98e1a1f2f7$var$requireString(flatStyle[srcName], srcName);
    // settable properties
    var evaluateAnchor = $55dacb98e1a1f2f7$var$coordinateEvaluator(flatStyle, prefix + "anchor", context);
    var evaluateScale = $55dacb98e1a1f2f7$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    var evaluateOpacity = $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, prefix + "opacity", context);
    var evaluateDisplacement = $55dacb98e1a1f2f7$var$coordinateEvaluator(flatStyle, prefix + "displacement", context);
    var evaluateRotation = $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    var evaluateRotateWithView = $55dacb98e1a1f2f7$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    // the remaining symbolizer properties are not currently settable
    var anchorOrigin = $55dacb98e1a1f2f7$var$optionalIconOrigin(flatStyle, prefix + "anchor-origin");
    var anchorXUnits = $55dacb98e1a1f2f7$var$optionalIconAnchorUnits(flatStyle, prefix + "anchor-x-units");
    var anchorYUnits = $55dacb98e1a1f2f7$var$optionalIconAnchorUnits(flatStyle, prefix + "anchor-y-units");
    var color = $55dacb98e1a1f2f7$var$optionalColorLike(flatStyle, prefix + "color");
    var crossOrigin = $55dacb98e1a1f2f7$var$optionalString(flatStyle, prefix + "cross-origin");
    var offset = $55dacb98e1a1f2f7$var$optionalNumberArray(flatStyle, prefix + "offset");
    var offsetOrigin = $55dacb98e1a1f2f7$var$optionalIconOrigin(flatStyle, prefix + "offset-origin");
    var width = $55dacb98e1a1f2f7$var$optionalNumber(flatStyle, prefix + "width");
    var height = $55dacb98e1a1f2f7$var$optionalNumber(flatStyle, prefix + "height");
    var size = $55dacb98e1a1f2f7$var$optionalSize(flatStyle, prefix + "size");
    var declutterMode = $55dacb98e1a1f2f7$var$optionalDeclutterMode(flatStyle, prefix + "declutter");
    var icon = new (0, $f18dd4c8d6d98b55$export$2e2bcd8739ae039)({
        src: src,
        anchorOrigin: anchorOrigin,
        anchorXUnits: anchorXUnits,
        anchorYUnits: anchorYUnits,
        color: color,
        crossOrigin: crossOrigin,
        offset: offset,
        offsetOrigin: offsetOrigin,
        height: height,
        width: width,
        size: size,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateOpacity) icon.setOpacity(evaluateOpacity(context));
        if (evaluateDisplacement) icon.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) icon.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) icon.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) icon.setScale(evaluateScale(context));
        if (evaluateAnchor) icon.setAnchor(evaluateAnchor(context));
        return icon;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an icon symbolizer.
 */ function $55dacb98e1a1f2f7$var$buildShape(flatStyle, context) {
    var prefix = "shape-";
    // required property
    var pointsName = prefix + "points";
    var points = $55dacb98e1a1f2f7$var$requireNumber(flatStyle[pointsName], pointsName);
    // settable properties
    var evaluateFill = $55dacb98e1a1f2f7$var$buildFill(flatStyle, prefix, context);
    var evaluateStroke = $55dacb98e1a1f2f7$var$buildStroke(flatStyle, prefix, context);
    var evaluateScale = $55dacb98e1a1f2f7$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    var evaluateDisplacement = $55dacb98e1a1f2f7$var$coordinateEvaluator(flatStyle, prefix + "displacement", context);
    var evaluateRotation = $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    var evaluateRotateWithView = $55dacb98e1a1f2f7$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    // the remaining properties are not currently settable
    var radius = $55dacb98e1a1f2f7$var$optionalNumber(flatStyle, prefix + "radius");
    var radius1 = $55dacb98e1a1f2f7$var$optionalNumber(flatStyle, prefix + "radius1");
    var radius2 = $55dacb98e1a1f2f7$var$optionalNumber(flatStyle, prefix + "radius2");
    var angle = $55dacb98e1a1f2f7$var$optionalNumber(flatStyle, prefix + "angle");
    var declutterMode = $55dacb98e1a1f2f7$var$optionalDeclutterMode(flatStyle, prefix + "declutter-mode");
    var shape = new (0, $03a6b05da0b86d5c$export$2e2bcd8739ae039)({
        points: points,
        radius: radius,
        radius1: radius1,
        radius2: radius2,
        angle: angle,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateFill) shape.setFill(evaluateFill(context));
        if (evaluateStroke) shape.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) shape.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) shape.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) shape.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) shape.setScale(evaluateScale(context));
        return shape;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to a circle symbolizer.
 */ function $55dacb98e1a1f2f7$var$buildCircle(flatStyle, context) {
    var prefix = "circle-";
    // settable properties
    var evaluateFill = $55dacb98e1a1f2f7$var$buildFill(flatStyle, prefix, context);
    var evaluateStroke = $55dacb98e1a1f2f7$var$buildStroke(flatStyle, prefix, context);
    var evaluateRadius = $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, prefix + "radius", context);
    var evaluateScale = $55dacb98e1a1f2f7$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    var evaluateDisplacement = $55dacb98e1a1f2f7$var$coordinateEvaluator(flatStyle, prefix + "displacement", context);
    var evaluateRotation = $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    var evaluateRotateWithView = $55dacb98e1a1f2f7$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    // the remaining properties are not currently settable
    var declutterMode = $55dacb98e1a1f2f7$var$optionalDeclutterMode(flatStyle, prefix + "declutter-mode");
    var circle = new (0, $957ba2f77c353f92$export$2e2bcd8739ae039)({
        radius: 5,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateRadius) circle.setRadius(evaluateRadius(context));
        if (evaluateFill) circle.setFill(evaluateFill(context));
        if (evaluateStroke) circle.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) circle.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) circle.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) circle.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) circle.setScale(evaluateScale(context));
        return circle;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberEvaluator|undefined} The expression evaluator or undefined.
 */ function $55dacb98e1a1f2f7$var$numberEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return undefined;
    var evaluator = (0, $8409e30b8fa6943e$export$b5f535122a9211f0)(flatStyle[name], (0, $2a0f71133411c509$export$86a7aca748b1e260), context);
    return function(context) {
        return $55dacb98e1a1f2f7$var$requireNumber(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').StringEvaluator?} The expression evaluator.
 */ function $55dacb98e1a1f2f7$var$stringEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    var evaluator = (0, $8409e30b8fa6943e$export$b5f535122a9211f0)(flatStyle[name], (0, $2a0f71133411c509$export$2b93044cbf134323), context);
    return function(context) {
        return $55dacb98e1a1f2f7$var$requireString(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').BooleanEvaluator?} The expression evaluator.
 */ function $55dacb98e1a1f2f7$var$booleanEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    var evaluator = (0, $8409e30b8fa6943e$export$b5f535122a9211f0)(flatStyle[name], (0, $2a0f71133411c509$export$240f7fffab1b25a0), context);
    return function(context) {
        var value = evaluator(context);
        if (typeof value !== "boolean") throw new Error("Expected a boolean for ".concat(name));
        return value;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').ColorLikeEvaluator?} The expression evaluator.
 */ function $55dacb98e1a1f2f7$var$colorLikeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    var evaluator = (0, $8409e30b8fa6943e$export$b5f535122a9211f0)(flatStyle[name], (0, $2a0f71133411c509$export$2cd82751acc0e609) | (0, $2a0f71133411c509$export$2b93044cbf134323), context);
    return function(context) {
        return $55dacb98e1a1f2f7$var$requireColorLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberArrayEvaluator?} The expression evaluator.
 */ function $55dacb98e1a1f2f7$var$numberArrayEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    var evaluator = (0, $8409e30b8fa6943e$export$b5f535122a9211f0)(flatStyle[name], (0, $2a0f71133411c509$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $55dacb98e1a1f2f7$var$requireNumberArray(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').CoordinateEvaluator?} The expression evaluator.
 */ function $55dacb98e1a1f2f7$var$coordinateEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    var evaluator = (0, $8409e30b8fa6943e$export$b5f535122a9211f0)(flatStyle[name], (0, $2a0f71133411c509$export$d701d0e49f4bcb39), context);
    return function(context) {
        var array = $55dacb98e1a1f2f7$var$requireNumberArray(evaluator(context), name);
        if (array.length !== 2) throw new Error("Expected two numbers for ".concat(name));
        return array;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeLikeEvaluator?} The expression evaluator.
 */ function $55dacb98e1a1f2f7$var$sizeLikeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    var evaluator = (0, $8409e30b8fa6943e$export$b5f535122a9211f0)(flatStyle[name], (0, $2a0f71133411c509$export$d701d0e49f4bcb39) | (0, $2a0f71133411c509$export$86a7aca748b1e260), context);
    return function(context) {
        return $55dacb98e1a1f2f7$var$requireSizeLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {number|undefined} A number or undefined.
 */ function $55dacb98e1a1f2f7$var$optionalNumber(flatStyle, property) {
    var value = flatStyle[property];
    if (value === undefined) return undefined;
    if (typeof value !== "number") throw new Error("Expected a number for ".concat(property));
    return value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../size.js").Size|undefined} A size or undefined.
 */ function $55dacb98e1a1f2f7$var$optionalSize(flatStyle, property) {
    var encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded === "number") return (0, $9fd3f8f53b8c7a01$export$a71a825ff42fb8e1)(encoded);
    if (!Array.isArray(encoded)) throw new Error("Expected a number or size array for ".concat(property));
    if (encoded.length !== 2 || typeof encoded[0] !== "number" || typeof encoded[1] !== "number") throw new Error("Expected a number or size array for ".concat(property));
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|undefined} A string or undefined.
 */ function $55dacb98e1a1f2f7$var$optionalString(flatStyle, property) {
    var encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== "string") throw new Error("Expected a string for ".concat(property));
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconOrigin|undefined} An icon origin or undefined.
 */ function $55dacb98e1a1f2f7$var$optionalIconOrigin(flatStyle, property) {
    var encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== "bottom-left" && encoded !== "bottom-right" && encoded !== "top-left" && encoded !== "top-right") throw new Error("Expected bottom-left, bottom-right, top-left, or top-right for ".concat(property));
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconAnchorUnits|undefined} Icon anchor units or undefined.
 */ function $55dacb98e1a1f2f7$var$optionalIconAnchorUnits(flatStyle, property) {
    var encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== "pixels" && encoded !== "fraction") throw new Error("Expected pixels or fraction for ".concat(property));
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {Array<number>|undefined} An array of numbers or undefined.
 */ function $55dacb98e1a1f2f7$var$optionalNumberArray(flatStyle, property) {
    var encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $55dacb98e1a1f2f7$var$requireNumberArray(encoded, property);
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {"declutter"|"obstacle"|"none"|undefined} Icon declutter mode.
 */ function $55dacb98e1a1f2f7$var$optionalDeclutterMode(flatStyle, property) {
    var encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== "string") throw new Error("Expected a string for ".concat(property));
    if (encoded !== "declutter" && encoded !== "obstacle" && encoded !== "none") throw new Error("Expected declutter, obstacle, or none for ".concat(property));
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|Array<number>|undefined} A string or an array of color values or undefined.
 */ function $55dacb98e1a1f2f7$var$optionalColorLike(flatStyle, property) {
    var encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $55dacb98e1a1f2f7$var$requireColorLike(encoded, property);
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} An array of numbers.
 */ function $55dacb98e1a1f2f7$var$requireNumberArray(value, property) {
    if (!Array.isArray(value)) throw new Error("Expected an array for ".concat(property));
    var length = value.length;
    for(var i = 0; i < length; ++i){
        if (typeof value[i] !== "number") throw new Error("Expected an array of numbers for ".concat(property));
    }
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {string} A string.
 */ function $55dacb98e1a1f2f7$var$requireString(value, property) {
    if (typeof value !== "string") throw new Error("Expected a string for ".concat(property));
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number} A number.
 */ function $55dacb98e1a1f2f7$var$requireNumber(value, property) {
    if (typeof value !== "number") throw new Error("Expected a number for ".concat(property));
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>|string} A color.
 */ function $55dacb98e1a1f2f7$var$requireColorLike(value, property) {
    if (typeof value === "string") return value;
    var array = $55dacb98e1a1f2f7$var$requireNumberArray(value, property);
    var length = array.length;
    if (length < 3 || length > 4) throw new Error("Expected a color with 3 or 4 values for ".concat(property));
    return array;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number|Array<number>} A number or an array of two numbers.
 */ function $55dacb98e1a1f2f7$var$requireSizeLike(value, property) {
    if (typeof value === "number") return value;
    var size = $55dacb98e1a1f2f7$var$requireNumberArray(value, property);
    if (size.length !== 2) throw new Error("Expected an array of two numbers for ".concat(property));
    return size;
}


/**
 * @template {import("../source/Vector.js").default|import("../source/VectorTile.js").default} VectorSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean} [declutter=false] Declutter images and text. Decluttering is applied to all
 * image and text styles of all Vector and VectorTile layers that have set this to `true`. The priority
 * is defined by the z-index of the layer, the `zIndex` of the style and the render order of features.
 * Higher z-index means higher priority. Within the same z-index, a feature rendered before another has
 * higher priority.
 *
 * As an optimization decluttered features from layers with the same `className` are rendered above
 * the fill and stroke styles of all of those layers regardless of z-index.  To opt out of this
 * behavior and place declutterd features with their own layer configure the layer with a `className`
 * other than `ol-layer`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ var $d254c52629992442$var$Property = {
    RENDER_ORDER: "renderOrder"
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default|import("../source/VectorTile.js").default} VectorSourceType
 * @template {import("../renderer/canvas/VectorLayer.js").default|import("../renderer/canvas/VectorTileLayer.js").default|import("../renderer/canvas/VectorImageLayer.js").default|import("../renderer/webgl/PointsLayer.js").default} RendererType
 * @extends {Layer<VectorSourceType, RendererType>}
 * @api
 */ var $d254c52629992442$var$BaseVectorLayer = /*#__PURE__*/ function(Layer) {
    "use strict";
    (0, $kcqLc._)(BaseVectorLayer, Layer);
    var _super = (0, $4jYWU._)(BaseVectorLayer);
    function BaseVectorLayer(options) {
        (0, $5sFFs._)(this, BaseVectorLayer);
        var _this;
        options = options ? options : {};
        var baseOptions = Object.assign({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        _this = _super.call(this, baseOptions);
        /**
     * @private
     * @type {boolean}
     */ _this.declutter_ = options.declutter !== undefined ? options.declutter : false;
        /**
     * @type {number}
     * @private
     */ _this.renderBuffer_ = options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
     * User provided style.
     * @type {import("../style/Style.js").StyleLike}
     * @private
     */ _this.style_ = null;
        /**
     * Style function for use within the library.
     * @type {import("../style/Style.js").StyleFunction|undefined}
     * @private
     */ _this.styleFunction_ = undefined;
        _this.setStyle(options.style);
        /**
     * @type {boolean}
     * @private
     */ _this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ? options.updateWhileAnimating : false;
        /**
     * @type {boolean}
     * @private
     */ _this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ? options.updateWhileInteracting : false;
        return _this;
    }
    (0, $8O2fV._)(BaseVectorLayer, [
        {
            /**
   * @return {boolean} Declutter.
   */ key: "getDeclutter",
            value: function getDeclutter() {
                return this.declutter_;
            }
        },
        {
            /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   */ key: "getFeatures",
            value: function getFeatures(pixel) {
                return (0, $404BM._)((0, $cEF31._)(BaseVectorLayer.prototype), "getFeatures", this).call(this, pixel);
            }
        },
        {
            /**
   * @return {number|undefined} Render buffer.
   */ key: "getRenderBuffer",
            value: function getRenderBuffer() {
                return this.renderBuffer_;
            }
        },
        {
            /**
   * @return {function(import("../Feature.js").default, import("../Feature.js").default): number|null|undefined} Render
   *     order.
   */ key: "getRenderOrder",
            value: function getRenderOrder() {
                return /** @type {import("../render.js").OrderFunction|null|undefined} */ this.get($d254c52629992442$var$Property.RENDER_ORDER);
            }
        },
        {
            /**
   * Get the style for features.  This returns whatever was passed to the `style`
   * option at construction or to the `setStyle` method.
   * @return {import("../style/Style.js").StyleLike|null|undefined} Layer style.
   * @api
   */ key: "getStyle",
            value: function getStyle() {
                return this.style_;
            }
        },
        {
            /**
   * Get the style function.
   * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
   * @api
   */ key: "getStyleFunction",
            value: function getStyleFunction() {
                return this.styleFunction_;
            }
        },
        {
            /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     animating.
   */ key: "getUpdateWhileAnimating",
            value: function getUpdateWhileAnimating() {
                return this.updateWhileAnimating_;
            }
        },
        {
            /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     interacting.
   */ key: "getUpdateWhileInteracting",
            value: function getUpdateWhileInteracting() {
                return this.updateWhileInteracting_;
            }
        },
        {
            /**
   * Render declutter items for this layer
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ key: "renderDeclutter",
            value: function renderDeclutter(frameState) {
                if (!frameState.declutterTree) frameState.declutterTree = new (0, (/*@__PURE__*/$parcel$interopDefault($82e0979b298e1815$exports)))(9);
                /** @type {*} */ this.getRenderer().renderDeclutter(frameState);
            }
        },
        {
            /**
   * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
   *     Render order.
   */ key: "setRenderOrder",
            value: function setRenderOrder(renderOrder) {
                this.set($d254c52629992442$var$Property.RENDER_ORDER, renderOrder);
            }
        },
        {
            /**
   * Set the style for features.  This can be a single style object, an array
   * of styles, or a function that takes a feature and resolution and returns
   * an array of styles. If set to `null`, the layer has no style (a `null` style),
   * so only features that have their own styles will be rendered in the layer. Call
   * `setStyle()` without arguments to reset to the default style. See
   * [the ol/style/Style module]{@link module:ol/style/Style~Style} for information on the default style.
   *
   * If your layer has a static style, you can use [flat style]{@link module:ol/style/flat~FlatStyle} object
   * literals instead of using the `Style` and symbolizer constructors (`Fill`, `Stroke`, etc.):
   * ```js
   * vectorLayer.setStyle({
   *   "fill-color": "yellow",
   *   "stroke-color": "black",
   *   "stroke-width": 4
   * })
   * ```
   *
   * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
   * @api
   */ key: "setStyle",
            value: function setStyle(style) {
                this.style_ = $d254c52629992442$var$toStyleLike(style);
                this.styleFunction_ = style === null ? undefined : (0, $549a2342af29343f$export$c314ea3f6b164147)(this.style_);
                this.changed();
            }
        }
    ]);
    return BaseVectorLayer;
}((0, $45f7b7b1b4f025e5$export$2e2bcd8739ae039));
/**
 * Coerce the allowed style types into a shorter list of types.  Flat styles, arrays of flat
 * styles, and arrays of rules are converted into style functions.
 *
 * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
 * @return {import("../style/Style.js").StyleLike|null} The style.
 */ function $d254c52629992442$var$toStyleLike(style) {
    if (style === undefined) return 0, $549a2342af29343f$export$6865c5ac2f5ce8b6;
    if (!style) return null;
    if (typeof style === "function") return style;
    if (style instanceof (0, $549a2342af29343f$export$2e2bcd8739ae039)) return style;
    if (!Array.isArray(style)) return (0, $55dacb98e1a1f2f7$export$5a130bc4f0a0420b)([
        style
    ]);
    if (style.length === 0) return [];
    var length = style.length;
    var first = style[0];
    if (first instanceof (0, $549a2342af29343f$export$2e2bcd8739ae039)) {
        /**
     * @type {Array<Style>}
     */ var styles = new Array(length);
        for(var i = 0; i < length; ++i){
            var candidate = style[i];
            if (!(candidate instanceof (0, $549a2342af29343f$export$2e2bcd8739ae039))) throw new Error("Expected a list of style instances");
            styles[i] = candidate;
        }
        return styles;
    }
    if ("style" in first) {
        /**
     * @type Array<import("../style/flat.js").Rule>
     */ var rules = new Array(length);
        for(var i1 = 0; i1 < length; ++i1){
            var candidate1 = style[i1];
            if (!("style" in candidate1)) throw new Error("Expected a list of rules with a style property");
            rules[i1] = candidate1;
        }
        return (0, $55dacb98e1a1f2f7$export$fc6a94152b1b05a8)(rules);
    }
    var flatStyles = /** @type {Array<import("../style/flat.js").FlatStyle>} */ style;
    return (0, $55dacb98e1a1f2f7$export$5a130bc4f0a0420b)(flatStyles);
}
var $d254c52629992442$export$2e2bcd8739ae039 = $d254c52629992442$var$BaseVectorLayer;


/**
 * @module ol/renderer/canvas/VectorLayer
 */ 
var $lyFcw = parcelRequire("lyFcw");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/render/canvas/BuilderGroup
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
/**
 * @module ol/render/canvas/Builder
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/render/canvas/Instruction
 */ /**
 * @enum {number}
 */ var $54a1b1b9ce0f9fd2$var$Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12
};
var $54a1b1b9ce0f9fd2$export$f21891651e408226 = [
    $54a1b1b9ce0f9fd2$var$Instruction.FILL
];
var $54a1b1b9ce0f9fd2$export$7a98aa5364d62ba8 = [
    $54a1b1b9ce0f9fd2$var$Instruction.STROKE
];
var $54a1b1b9ce0f9fd2$export$9f746cc58a899a00 = [
    $54a1b1b9ce0f9fd2$var$Instruction.BEGIN_PATH
];
var $54a1b1b9ce0f9fd2$export$89b10f327e413e71 = [
    $54a1b1b9ce0f9fd2$var$Instruction.CLOSE_PATH
];
var $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039 = $54a1b1b9ce0f9fd2$var$Instruction;



/**
 * @module ol/render/VectorContext
 */ /**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
var $7016ef4fa08f6c05$var$VectorContext = /*#__PURE__*/ function() {
    "use strict";
    function VectorContext() {
        (0, $5sFFs._)(this, VectorContext);
    }
    (0, $8O2fV._)(VectorContext, [
        {
            /**
   * Render a geometry with a custom renderer.
   *
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   */ key: "drawCustom",
            value: function drawCustom(geometry, feature, renderer, hitDetectionRenderer) {}
        },
        {
            /**
   * Render a geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
   */ key: "drawGeometry",
            value: function drawGeometry(geometry) {}
        },
        {
            /**
   * Set the rendering style.
   *
   * @param {import("../style/Style.js").default} style The rendering style.
   */ key: "setStyle",
            value: function setStyle(style) {}
        },
        {
            /**
   * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../Feature.js").default} feature Feature.
   */ key: "drawCircle",
            value: function drawCircle(circleGeometry, feature) {}
        },
        {
            /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../style/Style.js").default} style Style.
   */ key: "drawFeature",
            value: function drawFeature(feature, style) {}
        },
        {
            /**
   * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
   * @param {import("../Feature.js").default} feature Feature.
   */ key: "drawGeometryCollection",
            value: function drawGeometryCollection(geometryCollectionGeometry, feature) {}
        },
        {
            /**
   * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */ key: "drawLineString",
            value: function drawLineString(lineStringGeometry, feature) {}
        },
        {
            /**
   * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */ key: "drawMultiLineString",
            value: function drawMultiLineString(multiLineStringGeometry, feature) {}
        },
        {
            /**
   * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */ key: "drawMultiPoint",
            value: function drawMultiPoint(multiPointGeometry, feature) {}
        },
        {
            /**
   * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */ key: "drawMultiPolygon",
            value: function drawMultiPolygon(multiPolygonGeometry, feature) {}
        },
        {
            /**
   * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */ key: "drawPoint",
            value: function drawPoint(pointGeometry, feature) {}
        },
        {
            /**
   * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */ key: "drawPolygon",
            value: function drawPolygon(polygonGeometry, feature) {}
        },
        {
            /**
   * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   */ key: "drawText",
            value: function drawText(geometry, feature) {}
        },
        {
            /**
   * @param {import("../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
   */ key: "setFillStrokeStyle",
            value: function setFillStrokeStyle(fillStyle, strokeStyle) {}
        },
        {
            /**
   * @param {import("../style/Image.js").default} imageStyle Image style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with a text style.
   */ key: "setImageStyle",
            value: function setImageStyle(imageStyle, declutterImageWithText) {}
        },
        {
            /**
   * @param {import("../style/Text.js").default} textStyle Text style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with an image style.
   */ key: "setTextStyle",
            value: function setTextStyle(textStyle, declutterImageWithText) {}
        }
    ]);
    return VectorContext;
}();
var $7016ef4fa08f6c05$export$2e2bcd8739ae039 = $7016ef4fa08f6c05$var$VectorContext;







var $9ebbaf4e12b6d86d$var$CanvasBuilder = /*#__PURE__*/ function(VectorContext) {
    "use strict";
    (0, $kcqLc._)(CanvasBuilder, VectorContext);
    var _super = (0, $4jYWU._)(CanvasBuilder);
    function CanvasBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        (0, $5sFFs._)(this, CanvasBuilder);
        var _this;
        _this = _super.call(this);
        /**
     * @protected
     * @type {number}
     */ _this.tolerance = tolerance;
        /**
     * @protected
     * @const
     * @type {import("../../extent.js").Extent}
     */ _this.maxExtent = maxExtent;
        /**
     * @protected
     * @type {number}
     */ _this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @type {number}
     */ _this.maxLineWidth = 0;
        /**
     * @protected
     * @const
     * @type {number}
     */ _this.resolution = resolution;
        /**
     * @private
     * @type {Array<*>}
     */ _this.beginGeometryInstruction1_ = null;
        /**
     * @private
     * @type {Array<*>}
     */ _this.beginGeometryInstruction2_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ _this.bufferedMaxExtent_ = null;
        /**
     * @protected
     * @type {Array<*>}
     */ _this.instructions = [];
        /**
     * @protected
     * @type {Array<number>}
     */ _this.coordinates = [];
        /**
     * @private
     * @type {import("../../coordinate.js").Coordinate}
     */ _this.tmpCoordinate_ = [];
        /**
     * @protected
     * @type {Array<*>}
     */ _this.hitDetectionInstructions = [];
        /**
     * @protected
     * @type {import("../canvas.js").FillStrokeState}
     */ _this.state = /** @type {import("../canvas.js").FillStrokeState} */ {};
        return _this;
    }
    (0, $8O2fV._)(CanvasBuilder, [
        {
            /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */ key: "applyPixelRatio",
            value: function applyPixelRatio(dashArray) {
                var pixelRatio = this.pixelRatio;
                return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
                    return dash * pixelRatio;
                });
            }
        },
        {
            /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} stride Stride.
   * @protected
   * @return {number} My end
   */ key: "appendFlatPointCoordinates",
            value: function appendFlatPointCoordinates(flatCoordinates, stride) {
                var extent = this.getBufferedMaxExtent();
                var tmpCoord = this.tmpCoordinate_;
                var coordinates = this.coordinates;
                var myEnd = coordinates.length;
                for(var i = 0, ii = flatCoordinates.length; i < ii; i += stride){
                    tmpCoord[0] = flatCoordinates[i];
                    tmpCoord[1] = flatCoordinates[i + 1];
                    if ((0, $e86e0aa087890eb8$export$ac68c24d37ca240f)(extent, tmpCoord)) {
                        coordinates[myEnd++] = tmpCoord[0];
                        coordinates[myEnd++] = tmpCoord[1];
                    }
                }
                return myEnd;
            }
        },
        {
            /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */ key: "appendFlatLineCoordinates",
            value: function appendFlatLineCoordinates(flatCoordinates, offset, end, stride, closed, skipFirst) {
                var coordinates = this.coordinates;
                var myEnd = coordinates.length;
                var extent = this.getBufferedMaxExtent();
                if (skipFirst) offset += stride;
                var lastXCoord = flatCoordinates[offset];
                var lastYCoord = flatCoordinates[offset + 1];
                var nextCoord = this.tmpCoordinate_;
                var skipped = true;
                var i, lastRel, nextRel;
                for(i = offset + stride; i < end; i += stride){
                    nextCoord[0] = flatCoordinates[i];
                    nextCoord[1] = flatCoordinates[i + 1];
                    nextRel = (0, $e86e0aa087890eb8$export$f97905ead28c61a8)(extent, nextCoord);
                    if (nextRel !== lastRel) {
                        if (skipped) {
                            coordinates[myEnd++] = lastXCoord;
                            coordinates[myEnd++] = lastYCoord;
                            skipped = false;
                        }
                        coordinates[myEnd++] = nextCoord[0];
                        coordinates[myEnd++] = nextCoord[1];
                    } else if (nextRel === (0, $b6471e48cd12371e$export$2e2bcd8739ae039).INTERSECTING) {
                        coordinates[myEnd++] = nextCoord[0];
                        coordinates[myEnd++] = nextCoord[1];
                        skipped = false;
                    } else skipped = true;
                    lastXCoord = nextCoord[0];
                    lastYCoord = nextCoord[1];
                    lastRel = nextRel;
                }
                // Last coordinate equals first or only one point to append:
                if (closed && skipped || i === offset + stride) {
                    coordinates[myEnd++] = lastXCoord;
                    coordinates[myEnd++] = lastYCoord;
                }
                return myEnd;
            }
        },
        {
            /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} builderEnds Builder ends.
   * @return {number} Offset.
   */ key: "drawCustomCoordinates_",
            value: function drawCustomCoordinates_(flatCoordinates, offset, ends, stride, builderEnds) {
                for(var i = 0, ii = ends.length; i < ii; ++i){
                    var end = ends[i];
                    var builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
                    builderEnds.push(builderEnd);
                    offset = end;
                }
                return offset;
            }
        },
        {
            /**
   * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   */ key: "drawCustom",
            value: function drawCustom(geometry, feature, renderer, hitDetectionRenderer) {
                this.beginGeometry(geometry, feature);
                var type = geometry.getType();
                var stride = geometry.getStride();
                var builderBegin = this.coordinates.length;
                var flatCoordinates, builderEnd, builderEnds, builderEndss;
                var offset;
                switch(type){
                    case "MultiPolygon":
                        flatCoordinates = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getOrientedFlatCoordinates();
                        builderEndss = [];
                        var endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                        offset = 0;
                        for(var i = 0, ii = endss.length; i < ii; ++i){
                            var myEnds = [];
                            offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                            builderEndss.push(myEnds);
                        }
                        this.instructions.push([
                            (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).CUSTOM,
                            builderBegin,
                            builderEndss,
                            geometry,
                            renderer,
                            (0, $c51d6f1a0abb2d94$export$915c7058aeb4dfeb)
                        ]);
                        this.hitDetectionInstructions.push([
                            (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).CUSTOM,
                            builderBegin,
                            builderEndss,
                            geometry,
                            hitDetectionRenderer || renderer,
                            (0, $c51d6f1a0abb2d94$export$915c7058aeb4dfeb)
                        ]);
                        break;
                    case "Polygon":
                    case "MultiLineString":
                        builderEnds = [];
                        flatCoordinates = type == "Polygon" ? /** @type {import("../../geom/Polygon.js").default} */ geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
                        offset = this.drawCustomCoordinates_(flatCoordinates, 0, /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ geometry.getEnds(), stride, builderEnds);
                        this.instructions.push([
                            (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).CUSTOM,
                            builderBegin,
                            builderEnds,
                            geometry,
                            renderer,
                            (0, $c51d6f1a0abb2d94$export$cbb9596fc0f40db2)
                        ]);
                        this.hitDetectionInstructions.push([
                            (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).CUSTOM,
                            builderBegin,
                            builderEnds,
                            geometry,
                            hitDetectionRenderer || renderer,
                            (0, $c51d6f1a0abb2d94$export$cbb9596fc0f40db2)
                        ]);
                        break;
                    case "LineString":
                    case "Circle":
                        flatCoordinates = geometry.getFlatCoordinates();
                        builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
                        this.instructions.push([
                            (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).CUSTOM,
                            builderBegin,
                            builderEnd,
                            geometry,
                            renderer,
                            (0, $c51d6f1a0abb2d94$export$9c0934e4e9c3f61e)
                        ]);
                        this.hitDetectionInstructions.push([
                            (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).CUSTOM,
                            builderBegin,
                            builderEnd,
                            geometry,
                            hitDetectionRenderer || renderer,
                            (0, $c51d6f1a0abb2d94$export$9c0934e4e9c3f61e)
                        ]);
                        break;
                    case "MultiPoint":
                        flatCoordinates = geometry.getFlatCoordinates();
                        builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
                        if (builderEnd > builderBegin) {
                            this.instructions.push([
                                (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).CUSTOM,
                                builderBegin,
                                builderEnd,
                                geometry,
                                renderer,
                                (0, $c51d6f1a0abb2d94$export$9c0934e4e9c3f61e)
                            ]);
                            this.hitDetectionInstructions.push([
                                (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).CUSTOM,
                                builderBegin,
                                builderEnd,
                                geometry,
                                hitDetectionRenderer || renderer,
                                (0, $c51d6f1a0abb2d94$export$9c0934e4e9c3f61e)
                            ]);
                        }
                        break;
                    case "Point":
                        flatCoordinates = geometry.getFlatCoordinates();
                        this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
                        builderEnd = this.coordinates.length;
                        this.instructions.push([
                            (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).CUSTOM,
                            builderBegin,
                            builderEnd,
                            geometry,
                            renderer
                        ]);
                        this.hitDetectionInstructions.push([
                            (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).CUSTOM,
                            builderBegin,
                            builderEnd,
                            geometry,
                            hitDetectionRenderer || renderer
                        ]);
                        break;
                    default:
                }
                this.endGeometry(feature);
            }
        },
        {
            /**
   * @protected
   * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ key: "beginGeometry",
            value: function beginGeometry(geometry, feature) {
                this.beginGeometryInstruction1_ = [
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
                    feature,
                    0,
                    geometry
                ];
                this.instructions.push(this.beginGeometryInstruction1_);
                this.beginGeometryInstruction2_ = [
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
                    feature,
                    0,
                    geometry
                ];
                this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
            }
        },
        {
            /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ key: "finish",
            value: function finish() {
                return {
                    instructions: this.instructions,
                    hitDetectionInstructions: this.hitDetectionInstructions,
                    coordinates: this.coordinates
                };
            }
        },
        {
            /**
   * Reverse the hit detection instructions.
   */ key: "reverseHitDetectionInstructions",
            value: function reverseHitDetectionInstructions() {
                var hitDetectionInstructions = this.hitDetectionInstructions;
                // step 1 - reverse array
                hitDetectionInstructions.reverse();
                // step 2 - reverse instructions within geometry blocks
                var i;
                var n = hitDetectionInstructions.length;
                var instruction;
                var type;
                var begin = -1;
                for(i = 0; i < n; ++i){
                    instruction = hitDetectionInstructions[i];
                    type = /** @type {import("./Instruction.js").default} */ instruction[0];
                    if (type == (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).END_GEOMETRY) begin = i;
                    else if (type == (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).BEGIN_GEOMETRY) {
                        instruction[2] = i;
                        (0, $edee3659e50a93f4$export$292cfa960964f0e0)(this.hitDetectionInstructions, begin, i);
                        begin = -1;
                    }
                }
            }
        },
        {
            /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   */ key: "setFillStrokeStyle",
            value: function setFillStrokeStyle(fillStyle, strokeStyle) {
                var state = this.state;
                if (fillStyle) {
                    var fillStyleColor = fillStyle.getColor();
                    state.fillStyle = (0, $11e0a43141029edf$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $069ac9f2344fe90f$export$c495d52ee3fd74b2));
                } else state.fillStyle = undefined;
                if (strokeStyle) {
                    var strokeStyleColor = strokeStyle.getColor();
                    state.strokeStyle = (0, $11e0a43141029edf$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $069ac9f2344fe90f$export$1eb2eaecacf2031e));
                    var strokeStyleLineCap = strokeStyle.getLineCap();
                    state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $069ac9f2344fe90f$export$17bd0c38d6ae694e);
                    var strokeStyleLineDash = strokeStyle.getLineDash();
                    state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : (0, $069ac9f2344fe90f$export$e21b4112fdc612fc);
                    var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
                    state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $069ac9f2344fe90f$export$e06efc2409049f76);
                    var strokeStyleLineJoin = strokeStyle.getLineJoin();
                    state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $069ac9f2344fe90f$export$365eb9648cf19bd0);
                    var strokeStyleWidth = strokeStyle.getWidth();
                    state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $069ac9f2344fe90f$export$79661f132c62010e);
                    var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
                    state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $069ac9f2344fe90f$export$80c1c01844597b7b);
                    if (state.lineWidth > this.maxLineWidth) {
                        this.maxLineWidth = state.lineWidth;
                        // invalidate the buffered max extent cache
                        this.bufferedMaxExtent_ = null;
                    }
                } else {
                    state.strokeStyle = undefined;
                    state.lineCap = undefined;
                    state.lineDash = null;
                    state.lineDashOffset = undefined;
                    state.lineJoin = undefined;
                    state.lineWidth = undefined;
                    state.miterLimit = undefined;
                }
            }
        },
        {
            /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Fill instruction.
   */ key: "createFill",
            value: function createFill(state) {
                var fillStyle = state.fillStyle;
                /** @type {Array<*>} */ var fillInstruction = [
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).SET_FILL_STYLE,
                    fillStyle
                ];
                if (typeof fillStyle !== "string") // Fill is a pattern or gradient - align it!
                fillInstruction.push(true);
                return fillInstruction;
            }
        },
        {
            /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ key: "applyStroke",
            value: function applyStroke(state) {
                this.instructions.push(this.createStroke(state));
            }
        },
        {
            /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */ key: "createStroke",
            value: function createStroke(state) {
                return [
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).SET_STROKE_STYLE,
                    state.strokeStyle,
                    state.lineWidth * this.pixelRatio,
                    state.lineCap,
                    state.lineJoin,
                    state.miterLimit,
                    this.applyPixelRatio(state.lineDash),
                    state.lineDashOffset * this.pixelRatio
                ];
            }
        },
        {
            /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
   */ key: "updateFillStyle",
            value: function updateFillStyle(state, createFill) {
                var fillStyle = state.fillStyle;
                if (typeof fillStyle !== "string" || state.currentFillStyle != fillStyle) {
                    if (fillStyle !== undefined) this.instructions.push(createFill.call(this, state));
                    state.currentFillStyle = fillStyle;
                }
            }
        },
        {
            /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
   */ key: "updateStrokeStyle",
            value: function updateStrokeStyle(state, applyStroke) {
                var strokeStyle = state.strokeStyle;
                var lineCap = state.lineCap;
                var lineDash = state.lineDash;
                var lineDashOffset = state.lineDashOffset;
                var lineJoin = state.lineJoin;
                var lineWidth = state.lineWidth;
                var miterLimit = state.miterLimit;
                if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, $edee3659e50a93f4$export$e9bab7fafb253603)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit) {
                    if (strokeStyle !== undefined) applyStroke.call(this, state);
                    state.currentStrokeStyle = strokeStyle;
                    state.currentLineCap = lineCap;
                    state.currentLineDash = lineDash;
                    state.currentLineDashOffset = lineDashOffset;
                    state.currentLineJoin = lineJoin;
                    state.currentLineWidth = lineWidth;
                    state.currentMiterLimit = miterLimit;
                }
            }
        },
        {
            /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ key: "endGeometry",
            value: function endGeometry(feature) {
                this.beginGeometryInstruction1_[2] = this.instructions.length;
                this.beginGeometryInstruction1_ = null;
                this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
                this.beginGeometryInstruction2_ = null;
                var endGeometryInstruction = [
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).END_GEOMETRY,
                    feature
                ];
                this.instructions.push(endGeometryInstruction);
                this.hitDetectionInstructions.push(endGeometryInstruction);
            }
        },
        {
            /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */ key: "getBufferedMaxExtent",
            value: function getBufferedMaxExtent() {
                if (!this.bufferedMaxExtent_) {
                    this.bufferedMaxExtent_ = (0, $e86e0aa087890eb8$export$9cd59f9826255e47)(this.maxExtent);
                    if (this.maxLineWidth > 0) {
                        var width = this.resolution * (this.maxLineWidth + 1) / 2;
                        (0, $e86e0aa087890eb8$export$ab1029bcae9ddb4a)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
                    }
                }
                return this.bufferedMaxExtent_;
            }
        }
    ]);
    return CanvasBuilder;
}((0, $7016ef4fa08f6c05$export$2e2bcd8739ae039));
var $9ebbaf4e12b6d86d$export$2e2bcd8739ae039 = $9ebbaf4e12b6d86d$var$CanvasBuilder;


/**
 * @module ol/render/canvas/ImageBuilder
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");


var $beeff49866d88805$var$CanvasImageBuilder = /*#__PURE__*/ function(CanvasBuilder) {
    "use strict";
    (0, $kcqLc._)(CanvasImageBuilder, CanvasBuilder);
    var _super = (0, $4jYWU._)(CanvasImageBuilder);
    function CanvasImageBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        (0, $5sFFs._)(this, CanvasImageBuilder);
        var _this;
        _this = _super.call(this, tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ _this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ _this.image_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ _this.imagePixelRatio_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ _this.anchorX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ _this.anchorY_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ _this.height_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ _this.opacity_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ _this.originX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ _this.originY_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ _this.rotateWithView_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ _this.rotation_ = undefined;
        /**
     * @private
     * @type {import("../../size.js").Size|undefined}
     */ _this.scale_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ _this.width_ = undefined;
        /**
     * @private
     * @type {"declutter"|"obstacle"|"none"|undefined}
     */ _this.declutterMode_ = undefined;
        /**
     * Data shared with a text builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ _this.declutterImageWithText_ = undefined;
        return _this;
    }
    (0, $8O2fV._)(CanvasImageBuilder, [
        {
            /**
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ key: "drawPoint",
            value: function drawPoint(pointGeometry, feature) {
                if (!this.image_) return;
                this.beginGeometry(pointGeometry, feature);
                var flatCoordinates = pointGeometry.getFlatCoordinates();
                var stride = pointGeometry.getStride();
                var myBegin = this.coordinates.length;
                var myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
                this.instructions.push([
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).DRAW_IMAGE,
                    myBegin,
                    myEnd,
                    this.image_,
                    // Remaining arguments to DRAW_IMAGE are in alphabetical order
                    this.anchorX_ * this.imagePixelRatio_,
                    this.anchorY_ * this.imagePixelRatio_,
                    Math.ceil(this.height_ * this.imagePixelRatio_),
                    this.opacity_,
                    this.originX_ * this.imagePixelRatio_,
                    this.originY_ * this.imagePixelRatio_,
                    this.rotateWithView_,
                    this.rotation_,
                    [
                        this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                        this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
                    ],
                    Math.ceil(this.width_ * this.imagePixelRatio_),
                    this.declutterMode_,
                    this.declutterImageWithText_
                ]);
                this.hitDetectionInstructions.push([
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).DRAW_IMAGE,
                    myBegin,
                    myEnd,
                    this.hitDetectionImage_,
                    // Remaining arguments to DRAW_IMAGE are in alphabetical order
                    this.anchorX_,
                    this.anchorY_,
                    this.height_,
                    1,
                    this.originX_,
                    this.originY_,
                    this.rotateWithView_,
                    this.rotation_,
                    this.scale_,
                    this.width_,
                    this.declutterMode_,
                    this.declutterImageWithText_
                ]);
                this.endGeometry(feature);
            }
        },
        {
            /**
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ key: "drawMultiPoint",
            value: function drawMultiPoint(multiPointGeometry, feature) {
                if (!this.image_) return;
                this.beginGeometry(multiPointGeometry, feature);
                var flatCoordinates = multiPointGeometry.getFlatCoordinates();
                var stride = multiPointGeometry.getStride();
                var myBegin = this.coordinates.length;
                var myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
                this.instructions.push([
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).DRAW_IMAGE,
                    myBegin,
                    myEnd,
                    this.image_,
                    // Remaining arguments to DRAW_IMAGE are in alphabetical order
                    this.anchorX_ * this.imagePixelRatio_,
                    this.anchorY_ * this.imagePixelRatio_,
                    Math.ceil(this.height_ * this.imagePixelRatio_),
                    this.opacity_,
                    this.originX_ * this.imagePixelRatio_,
                    this.originY_ * this.imagePixelRatio_,
                    this.rotateWithView_,
                    this.rotation_,
                    [
                        this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                        this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
                    ],
                    Math.ceil(this.width_ * this.imagePixelRatio_),
                    this.declutterMode_,
                    this.declutterImageWithText_
                ]);
                this.hitDetectionInstructions.push([
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).DRAW_IMAGE,
                    myBegin,
                    myEnd,
                    this.hitDetectionImage_,
                    // Remaining arguments to DRAW_IMAGE are in alphabetical order
                    this.anchorX_,
                    this.anchorY_,
                    this.height_,
                    1,
                    this.originX_,
                    this.originY_,
                    this.rotateWithView_,
                    this.rotation_,
                    this.scale_,
                    this.width_,
                    this.declutterMode_,
                    this.declutterImageWithText_
                ]);
                this.endGeometry(feature);
            }
        },
        {
            /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ key: "finish",
            value: function finish() {
                this.reverseHitDetectionInstructions();
                // FIXME this doesn't really protect us against further calls to draw*Geometry
                this.anchorX_ = undefined;
                this.anchorY_ = undefined;
                this.hitDetectionImage_ = null;
                this.image_ = null;
                this.imagePixelRatio_ = undefined;
                this.height_ = undefined;
                this.scale_ = undefined;
                this.opacity_ = undefined;
                this.originX_ = undefined;
                this.originY_ = undefined;
                this.rotateWithView_ = undefined;
                this.rotation_ = undefined;
                this.width_ = undefined;
                return (0, $404BM._)((0, $cEF31._)(CanvasImageBuilder.prototype), "finish", this).call(this);
            }
        },
        {
            /**
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @param {Object} [sharedData] Shared data.
   */ key: "setImageStyle",
            value: function setImageStyle(imageStyle, sharedData) {
                var anchor = imageStyle.getAnchor();
                var size = imageStyle.getSize();
                var origin = imageStyle.getOrigin();
                this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
                this.anchorX_ = anchor[0];
                this.anchorY_ = anchor[1];
                this.hitDetectionImage_ = imageStyle.getHitDetectionImage();
                this.image_ = imageStyle.getImage(this.pixelRatio);
                this.height_ = size[1];
                this.opacity_ = imageStyle.getOpacity();
                this.originX_ = origin[0];
                this.originY_ = origin[1];
                this.rotateWithView_ = imageStyle.getRotateWithView();
                this.rotation_ = imageStyle.getRotation();
                this.scale_ = imageStyle.getScaleArray();
                this.width_ = size[0];
                this.declutterMode_ = imageStyle.getDeclutterMode();
                this.declutterImageWithText_ = sharedData;
            }
        }
    ]);
    return CanvasImageBuilder;
}((0, $9ebbaf4e12b6d86d$export$2e2bcd8739ae039));
var $beeff49866d88805$export$2e2bcd8739ae039 = $beeff49866d88805$var$CanvasImageBuilder;


/**
 * @module ol/render/canvas/LineStringBuilder
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");



var $91930153490caeef$var$CanvasLineStringBuilder = /*#__PURE__*/ function(CanvasBuilder) {
    "use strict";
    (0, $kcqLc._)(CanvasLineStringBuilder, CanvasBuilder);
    var _super = (0, $4jYWU._)(CanvasLineStringBuilder);
    function CanvasLineStringBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        (0, $5sFFs._)(this, CanvasLineStringBuilder);
        return _super.call(this, tolerance, maxExtent, resolution, pixelRatio);
    }
    (0, $8O2fV._)(CanvasLineStringBuilder, [
        {
            /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   * @return {number} end.
   */ key: "drawFlatCoordinates_",
            value: function drawFlatCoordinates_(flatCoordinates, offset, end, stride) {
                var myBegin = this.coordinates.length;
                var myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
                var moveToLineToInstruction = [
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
                    myBegin,
                    myEnd
                ];
                this.instructions.push(moveToLineToInstruction);
                this.hitDetectionInstructions.push(moveToLineToInstruction);
                return end;
            }
        },
        {
            /**
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ key: "drawLineString",
            value: function drawLineString(lineStringGeometry, feature) {
                var state = this.state;
                var strokeStyle = state.strokeStyle;
                var lineWidth = state.lineWidth;
                if (strokeStyle === undefined || lineWidth === undefined) return;
                this.updateStrokeStyle(state, this.applyStroke);
                this.beginGeometry(lineStringGeometry, feature);
                this.hitDetectionInstructions.push([
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).SET_STROKE_STYLE,
                    state.strokeStyle,
                    state.lineWidth,
                    state.lineCap,
                    state.lineJoin,
                    state.miterLimit,
                    (0, $069ac9f2344fe90f$export$e21b4112fdc612fc),
                    (0, $069ac9f2344fe90f$export$e06efc2409049f76)
                ], (0, $54a1b1b9ce0f9fd2$export$9f746cc58a899a00));
                var flatCoordinates = lineStringGeometry.getFlatCoordinates();
                var stride = lineStringGeometry.getStride();
                this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
                this.hitDetectionInstructions.push((0, $54a1b1b9ce0f9fd2$export$7a98aa5364d62ba8));
                this.endGeometry(feature);
            }
        },
        {
            /**
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ key: "drawMultiLineString",
            value: function drawMultiLineString(multiLineStringGeometry, feature) {
                var state = this.state;
                var strokeStyle = state.strokeStyle;
                var lineWidth = state.lineWidth;
                if (strokeStyle === undefined || lineWidth === undefined) return;
                this.updateStrokeStyle(state, this.applyStroke);
                this.beginGeometry(multiLineStringGeometry, feature);
                this.hitDetectionInstructions.push([
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).SET_STROKE_STYLE,
                    state.strokeStyle,
                    state.lineWidth,
                    state.lineCap,
                    state.lineJoin,
                    state.miterLimit,
                    (0, $069ac9f2344fe90f$export$e21b4112fdc612fc),
                    (0, $069ac9f2344fe90f$export$e06efc2409049f76)
                ], (0, $54a1b1b9ce0f9fd2$export$9f746cc58a899a00));
                var ends = multiLineStringGeometry.getEnds();
                var flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
                var stride = multiLineStringGeometry.getStride();
                var offset = 0;
                for(var i = 0, ii = ends.length; i < ii; ++i)offset = this.drawFlatCoordinates_(flatCoordinates, offset, /** @type {number} */ ends[i], stride);
                this.hitDetectionInstructions.push((0, $54a1b1b9ce0f9fd2$export$7a98aa5364d62ba8));
                this.endGeometry(feature);
            }
        },
        {
            /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ key: "finish",
            value: function finish() {
                var state = this.state;
                if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) this.instructions.push((0, $54a1b1b9ce0f9fd2$export$7a98aa5364d62ba8));
                this.reverseHitDetectionInstructions();
                this.state = null;
                return (0, $404BM._)((0, $cEF31._)(CanvasLineStringBuilder.prototype), "finish", this).call(this);
            }
        },
        {
            /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ key: "applyStroke",
            value: function applyStroke(state) {
                if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
                    this.instructions.push((0, $54a1b1b9ce0f9fd2$export$7a98aa5364d62ba8));
                    state.lastStroke = this.coordinates.length;
                }
                state.lastStroke = 0;
                (0, $404BM._)((0, $cEF31._)(CanvasLineStringBuilder.prototype), "applyStroke", this).call(this, state);
                this.instructions.push((0, $54a1b1b9ce0f9fd2$export$9f746cc58a899a00));
            }
        }
    ]);
    return CanvasLineStringBuilder;
}((0, $9ebbaf4e12b6d86d$export$2e2bcd8739ae039));
var $91930153490caeef$export$2e2bcd8739ae039 = $91930153490caeef$var$CanvasLineStringBuilder;


/**
 * @module ol/render/canvas/PolygonBuilder
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");




var $179093a7a0ac9003$var$CanvasPolygonBuilder = /*#__PURE__*/ function(CanvasBuilder) {
    "use strict";
    (0, $kcqLc._)(CanvasPolygonBuilder, CanvasBuilder);
    var _super = (0, $4jYWU._)(CanvasPolygonBuilder);
    function CanvasPolygonBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        (0, $5sFFs._)(this, CanvasPolygonBuilder);
        return _super.call(this, tolerance, maxExtent, resolution, pixelRatio);
    }
    (0, $8O2fV._)(CanvasPolygonBuilder, [
        {
            /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ key: "drawFlatCoordinatess_",
            value: function drawFlatCoordinatess_(flatCoordinates, offset, ends, stride) {
                var state = this.state;
                var fill = state.fillStyle !== undefined;
                var stroke = state.strokeStyle !== undefined;
                var numEnds = ends.length;
                this.instructions.push((0, $54a1b1b9ce0f9fd2$export$9f746cc58a899a00));
                this.hitDetectionInstructions.push((0, $54a1b1b9ce0f9fd2$export$9f746cc58a899a00));
                for(var i = 0; i < numEnds; ++i){
                    var end = ends[i];
                    var myBegin = this.coordinates.length;
                    var myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
                    var moveToLineToInstruction = [
                        (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
                        myBegin,
                        myEnd
                    ];
                    this.instructions.push(moveToLineToInstruction);
                    this.hitDetectionInstructions.push(moveToLineToInstruction);
                    if (stroke) {
                        // Performance optimization: only call closePath() when we have a stroke.
                        // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
                        this.instructions.push((0, $54a1b1b9ce0f9fd2$export$89b10f327e413e71));
                        this.hitDetectionInstructions.push((0, $54a1b1b9ce0f9fd2$export$89b10f327e413e71));
                    }
                    offset = end;
                }
                if (fill) {
                    this.instructions.push((0, $54a1b1b9ce0f9fd2$export$f21891651e408226));
                    this.hitDetectionInstructions.push((0, $54a1b1b9ce0f9fd2$export$f21891651e408226));
                }
                if (stroke) {
                    this.instructions.push((0, $54a1b1b9ce0f9fd2$export$7a98aa5364d62ba8));
                    this.hitDetectionInstructions.push((0, $54a1b1b9ce0f9fd2$export$7a98aa5364d62ba8));
                }
                return offset;
            }
        },
        {
            /**
   * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../../Feature.js").default} feature Feature.
   */ key: "drawCircle",
            value: function drawCircle(circleGeometry, feature) {
                var state = this.state;
                var fillStyle = state.fillStyle;
                var strokeStyle = state.strokeStyle;
                if (fillStyle === undefined && strokeStyle === undefined) return;
                this.setFillStrokeStyles_();
                this.beginGeometry(circleGeometry, feature);
                if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).SET_FILL_STYLE,
                    (0, $069ac9f2344fe90f$export$c495d52ee3fd74b2)
                ]);
                if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).SET_STROKE_STYLE,
                    state.strokeStyle,
                    state.lineWidth,
                    state.lineCap,
                    state.lineJoin,
                    state.miterLimit,
                    (0, $069ac9f2344fe90f$export$e21b4112fdc612fc),
                    (0, $069ac9f2344fe90f$export$e06efc2409049f76)
                ]);
                var flatCoordinates = circleGeometry.getFlatCoordinates();
                var stride = circleGeometry.getStride();
                var myBegin = this.coordinates.length;
                this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
                var circleInstruction = [
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).CIRCLE,
                    myBegin
                ];
                this.instructions.push((0, $54a1b1b9ce0f9fd2$export$9f746cc58a899a00), circleInstruction);
                this.hitDetectionInstructions.push((0, $54a1b1b9ce0f9fd2$export$9f746cc58a899a00), circleInstruction);
                if (state.fillStyle !== undefined) {
                    this.instructions.push((0, $54a1b1b9ce0f9fd2$export$f21891651e408226));
                    this.hitDetectionInstructions.push((0, $54a1b1b9ce0f9fd2$export$f21891651e408226));
                }
                if (state.strokeStyle !== undefined) {
                    this.instructions.push((0, $54a1b1b9ce0f9fd2$export$7a98aa5364d62ba8));
                    this.hitDetectionInstructions.push((0, $54a1b1b9ce0f9fd2$export$7a98aa5364d62ba8));
                }
                this.endGeometry(feature);
            }
        },
        {
            /**
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ key: "drawPolygon",
            value: function drawPolygon(polygonGeometry, feature) {
                var state = this.state;
                var fillStyle = state.fillStyle;
                var strokeStyle = state.strokeStyle;
                if (fillStyle === undefined && strokeStyle === undefined) return;
                this.setFillStrokeStyles_();
                this.beginGeometry(polygonGeometry, feature);
                if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).SET_FILL_STYLE,
                    (0, $069ac9f2344fe90f$export$c495d52ee3fd74b2)
                ]);
                if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).SET_STROKE_STYLE,
                    state.strokeStyle,
                    state.lineWidth,
                    state.lineCap,
                    state.lineJoin,
                    state.miterLimit,
                    (0, $069ac9f2344fe90f$export$e21b4112fdc612fc),
                    (0, $069ac9f2344fe90f$export$e06efc2409049f76)
                ]);
                var ends = polygonGeometry.getEnds();
                var flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
                var stride = polygonGeometry.getStride();
                this.drawFlatCoordinatess_(flatCoordinates, 0, /** @type {Array<number>} */ ends, stride);
                this.endGeometry(feature);
            }
        },
        {
            /**
   * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ key: "drawMultiPolygon",
            value: function drawMultiPolygon(multiPolygonGeometry, feature) {
                var state = this.state;
                var fillStyle = state.fillStyle;
                var strokeStyle = state.strokeStyle;
                if (fillStyle === undefined && strokeStyle === undefined) return;
                this.setFillStrokeStyles_();
                this.beginGeometry(multiPolygonGeometry, feature);
                if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).SET_FILL_STYLE,
                    (0, $069ac9f2344fe90f$export$c495d52ee3fd74b2)
                ]);
                if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).SET_STROKE_STYLE,
                    state.strokeStyle,
                    state.lineWidth,
                    state.lineCap,
                    state.lineJoin,
                    state.miterLimit,
                    (0, $069ac9f2344fe90f$export$e21b4112fdc612fc),
                    (0, $069ac9f2344fe90f$export$e06efc2409049f76)
                ]);
                var endss = multiPolygonGeometry.getEndss();
                var flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
                var stride = multiPolygonGeometry.getStride();
                var offset = 0;
                for(var i = 0, ii = endss.length; i < ii; ++i)offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride);
                this.endGeometry(feature);
            }
        },
        {
            /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ key: "finish",
            value: function finish() {
                this.reverseHitDetectionInstructions();
                this.state = null;
                // We want to preserve topology when drawing polygons.  Polygons are
                // simplified using quantization and point elimination. However, we might
                // have received a mix of quantized and non-quantized geometries, so ensure
                // that all are quantized by quantizing all coordinates in the batch.
                var tolerance = this.tolerance;
                if (tolerance !== 0) {
                    var coordinates = this.coordinates;
                    for(var i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = (0, $a4f7faacf16083d1$export$51a0620f7a28532b)(coordinates[i], tolerance);
                }
                return (0, $404BM._)((0, $cEF31._)(CanvasPolygonBuilder.prototype), "finish", this).call(this);
            }
        },
        {
            /**
   * @private
   */ key: "setFillStrokeStyles_",
            value: function setFillStrokeStyles_() {
                var state = this.state;
                var fillStyle = state.fillStyle;
                if (fillStyle !== undefined) this.updateFillStyle(state, this.createFill);
                if (state.strokeStyle !== undefined) this.updateStrokeStyle(state, this.applyStroke);
            }
        }
    ]);
    return CanvasPolygonBuilder;
}((0, $9ebbaf4e12b6d86d$export$2e2bcd8739ae039));
var $179093a7a0ac9003$export$2e2bcd8739ae039 = $179093a7a0ac9003$var$CanvasPolygonBuilder;


/**
 * @module ol/render/canvas/TextBuilder
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");







var $52tJv = parcelRequire("52tJv");

function $f8437ca0b9f5bae6$export$f08272c6ff321e57(chunkLength, flatCoordinates, offset, end, stride) {
    var chunks = [];
    var cursor = offset;
    var chunkM = 0;
    var currentChunk = flatCoordinates.slice(offset, 2);
    while(chunkM < chunkLength && cursor + stride < end){
        var _currentChunk_slice = (0, $52tJv._)(currentChunk.slice(-2), 2), x1 = _currentChunk_slice[0], y1 = _currentChunk_slice[1];
        var x2 = flatCoordinates[cursor + stride];
        var y2 = flatCoordinates[cursor + stride + 1];
        var segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        chunkM += segmentLength;
        if (chunkM >= chunkLength) {
            var m = (chunkLength - chunkM + segmentLength) / segmentLength;
            var x = (0, $029c1e222d833501$export$3a89f8d6f6bf6c9f)(x1, x2, m);
            var y = (0, $029c1e222d833501$export$3a89f8d6f6bf6c9f)(y1, y2, m);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            if (chunkM == chunkLength) cursor += stride;
            chunkM = 0;
        } else if (chunkM < chunkLength) {
            currentChunk.push(flatCoordinates[cursor + stride], flatCoordinates[cursor + stride + 1]);
            cursor += stride;
        } else {
            var missing = segmentLength - chunkM;
            var x3 = (0, $029c1e222d833501$export$3a89f8d6f6bf6c9f)(x1, x2, missing / segmentLength);
            var y3 = (0, $029c1e222d833501$export$3a89f8d6f6bf6c9f)(y1, y2, missing / segmentLength);
            currentChunk.push(x3, y3);
            chunks.push(currentChunk);
            currentChunk = [
                x3,
                y3
            ];
            chunkM = 0;
            cursor += stride;
        }
    }
    if (chunkM > 0) chunks.push(currentChunk);
    return chunks;
}


/**
 * @module ol/geom/flat/straightchunk
 */ /**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */ function $37935f85ecb1b32e$export$ed6c897eea07a254(maxAngle, flatCoordinates, offset, end, stride) {
    var chunkStart = offset;
    var chunkEnd = offset;
    var chunkM = 0;
    var m = 0;
    var start = offset;
    var acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for(i = offset; i < end; i += stride){
        var x2 = flatCoordinates[i];
        var y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [
        start,
        i
    ] : [
        chunkStart,
        chunkEnd
    ];
}


var $d1934f6411f4416d$export$91a016276e4aee96 = {
    "left": 0,
    "center": 0.5,
    "right": 1,
    "top": 0,
    "middle": 0.5,
    "hanging": 0.2,
    "alphabetic": 0.8,
    "ideographic": 0.8,
    "bottom": 1
};
var $d1934f6411f4416d$var$CanvasTextBuilder = /*#__PURE__*/ function(CanvasBuilder) {
    "use strict";
    (0, $kcqLc._)(CanvasTextBuilder, CanvasBuilder);
    var _super = (0, $4jYWU._)(CanvasTextBuilder);
    function CanvasTextBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        (0, $5sFFs._)(this, CanvasTextBuilder);
        var _this;
        _this = _super.call(this, tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {Array<HTMLCanvasElement>}
     */ _this.labels_ = null;
        /**
     * @private
     * @type {string|Array<string>}
     */ _this.text_ = "";
        /**
     * @private
     * @type {number}
     */ _this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ _this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean|undefined}
     */ _this.textRotateWithView_ = undefined;
        /**
     * @private
     * @type {number}
     */ _this.textRotation_ = 0;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ _this.textFillState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ _this.fillStates = {};
        _this.fillStates[0, $069ac9f2344fe90f$export$c495d52ee3fd74b2] = {
            fillStyle: (0, $069ac9f2344fe90f$export$c495d52ee3fd74b2)
        };
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ _this.textStrokeState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ _this.strokeStates = {};
        /**
     * @private
     * @type {import("../canvas.js").TextState}
     */ _this.textState_ = /** @type {import("../canvas.js").TextState} */ {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ _this.textStates = {};
        /**
     * @private
     * @type {string}
     */ _this.textKey_ = "";
        /**
     * @private
     * @type {string}
     */ _this.fillKey_ = "";
        /**
     * @private
     * @type {string}
     */ _this.strokeKey_ = "";
        /**
     * Data shared with an image builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ _this.declutterImageWithText_ = undefined;
        return _this;
    }
    (0, $8O2fV._)(CanvasTextBuilder, [
        {
            /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ key: "finish",
            value: function finish() {
                var instructions = (0, $404BM._)((0, $cEF31._)(CanvasTextBuilder.prototype), "finish", this).call(this);
                instructions.textStates = this.textStates;
                instructions.fillStates = this.fillStates;
                instructions.strokeStates = this.strokeStates;
                return instructions;
            }
        },
        {
            /**
   * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ key: "drawText",
            value: function drawText(geometry, feature) {
                var fillState = this.textFillState_;
                var strokeState = this.textStrokeState_;
                var textState = this.textState_;
                if (this.text_ === "" || !textState || !fillState && !strokeState) return;
                var coordinates = this.coordinates;
                var begin = coordinates.length;
                var geometryType = geometry.getType();
                var flatCoordinates = null;
                var stride = geometry.getStride();
                if (textState.placement === "line" && (geometryType == "LineString" || geometryType == "MultiLineString" || geometryType == "Polygon" || geometryType == "MultiPolygon")) {
                    if (!(0, $e86e0aa087890eb8$export$7b0a31e10bbff018)(this.getBufferedMaxExtent(), geometry.getExtent())) return;
                    var ends;
                    flatCoordinates = geometry.getFlatCoordinates();
                    if (geometryType == "LineString") ends = [
                        flatCoordinates.length
                    ];
                    else if (geometryType == "MultiLineString") ends = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getEnds();
                    else if (geometryType == "Polygon") ends = /** @type {import("../../geom/Polygon.js").default} */ geometry.getEnds().slice(0, 1);
                    else if (geometryType == "MultiPolygon") {
                        var endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                        ends = [];
                        for(var i = 0, ii = endss.length; i < ii; ++i)ends.push(endss[i][0]);
                    }
                    this.beginGeometry(geometry, feature);
                    var repeat = textState.repeat;
                    var textAlign = repeat ? undefined : textState.textAlign;
                    // No `justify` support for line placement.
                    var flatOffset = 0;
                    for(var o = 0, oo = ends.length; o < oo; ++o){
                        var chunks = void 0;
                        if (repeat) chunks = (0, $f8437ca0b9f5bae6$export$f08272c6ff321e57)(repeat * this.resolution, flatCoordinates, flatOffset, ends[o], stride);
                        else chunks = [
                            flatCoordinates.slice(flatOffset, ends[o])
                        ];
                        for(var c = 0, cc = chunks.length; c < cc; ++c){
                            var chunk = chunks[c];
                            var chunkBegin = 0;
                            var chunkEnd = chunk.length;
                            if (textAlign == undefined) {
                                var range = (0, $37935f85ecb1b32e$export$ed6c897eea07a254)(textState.maxAngle, chunk, 0, chunk.length, 2);
                                chunkBegin = range[0];
                                chunkEnd = range[1];
                            }
                            for(var i1 = chunkBegin; i1 < chunkEnd; i1 += stride)coordinates.push(chunk[i1], chunk[i1 + 1]);
                            var end = coordinates.length;
                            flatOffset = ends[o];
                            this.drawChars_(begin, end);
                            begin = end;
                        }
                    }
                    this.endGeometry(feature);
                } else {
                    var geometryWidths = textState.overflow ? null : [];
                    switch(geometryType){
                        case "Point":
                        case "MultiPoint":
                            flatCoordinates = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.getFlatCoordinates();
                            break;
                        case "LineString":
                            flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ geometry.getFlatMidpoint();
                            break;
                        case "Circle":
                            flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ geometry.getCenter();
                            break;
                        case "MultiLineString":
                            flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getFlatMidpoints();
                            stride = 2;
                            break;
                        case "Polygon":
                            flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ geometry.getFlatInteriorPoint();
                            if (!textState.overflow) geometryWidths.push(flatCoordinates[2] / this.resolution);
                            stride = 3;
                            break;
                        case "MultiPolygon":
                            var interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getFlatInteriorPoints();
                            flatCoordinates = [];
                            for(var i2 = 0, ii1 = interiorPoints.length; i2 < ii1; i2 += 3){
                                if (!textState.overflow) geometryWidths.push(interiorPoints[i2 + 2] / this.resolution);
                                flatCoordinates.push(interiorPoints[i2], interiorPoints[i2 + 1]);
                            }
                            if (flatCoordinates.length === 0) return;
                            stride = 2;
                            break;
                        default:
                    }
                    var end1 = this.appendFlatPointCoordinates(flatCoordinates, stride);
                    if (end1 === begin) return;
                    if (geometryWidths && (end1 - begin) / 2 !== flatCoordinates.length / stride) {
                        var beg = begin / 2;
                        geometryWidths = geometryWidths.filter(function(w, i) {
                            var keep = coordinates[(beg + i) * 2] === flatCoordinates[i * stride] && coordinates[(beg + i) * 2 + 1] === flatCoordinates[i * stride + 1];
                            if (!keep) --beg;
                            return keep;
                        });
                    }
                    this.saveTextStates_();
                    if (textState.backgroundFill || textState.backgroundStroke) {
                        this.setFillStrokeStyle(textState.backgroundFill, textState.backgroundStroke);
                        if (textState.backgroundFill) this.updateFillStyle(this.state, this.createFill);
                        if (textState.backgroundStroke) {
                            this.updateStrokeStyle(this.state, this.applyStroke);
                            this.hitDetectionInstructions.push(this.createStroke(this.state));
                        }
                    }
                    this.beginGeometry(geometry, feature);
                    // adjust padding for negative scale
                    var padding = textState.padding;
                    if (padding != (0, $069ac9f2344fe90f$export$40a9eeef55665a40) && (textState.scale[0] < 0 || textState.scale[1] < 0)) {
                        var p0 = textState.padding[0];
                        var p1 = textState.padding[1];
                        var p2 = textState.padding[2];
                        var p3 = textState.padding[3];
                        if (textState.scale[0] < 0) {
                            p1 = -p1;
                            p3 = -p3;
                        }
                        if (textState.scale[1] < 0) {
                            p0 = -p0;
                            p2 = -p2;
                        }
                        padding = [
                            p0,
                            p1,
                            p2,
                            p3
                        ];
                    }
                    // The image is unknown at this stage so we pass null; it will be computed at render time.
                    // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
                    // render time.
                    var pixelRatio = this.pixelRatio;
                    this.instructions.push([
                        (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).DRAW_IMAGE,
                        begin,
                        end1,
                        null,
                        NaN,
                        NaN,
                        NaN,
                        1,
                        0,
                        0,
                        this.textRotateWithView_,
                        this.textRotation_,
                        [
                            1,
                            1
                        ],
                        NaN,
                        undefined,
                        this.declutterImageWithText_,
                        padding == (0, $069ac9f2344fe90f$export$40a9eeef55665a40) ? (0, $069ac9f2344fe90f$export$40a9eeef55665a40) : padding.map(function(p) {
                            return p * pixelRatio;
                        }),
                        !!textState.backgroundFill,
                        !!textState.backgroundStroke,
                        this.text_,
                        this.textKey_,
                        this.strokeKey_,
                        this.fillKey_,
                        this.textOffsetX_,
                        this.textOffsetY_,
                        geometryWidths
                    ]);
                    var scale = 1 / pixelRatio;
                    // Set default fill for hit detection background
                    var currentFillStyle = this.state.fillStyle;
                    if (textState.backgroundFill) {
                        this.state.fillStyle = (0, $069ac9f2344fe90f$export$c495d52ee3fd74b2);
                        this.hitDetectionInstructions.push(this.createFill(this.state));
                    }
                    this.hitDetectionInstructions.push([
                        (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).DRAW_IMAGE,
                        begin,
                        end1,
                        null,
                        NaN,
                        NaN,
                        NaN,
                        1,
                        0,
                        0,
                        this.textRotateWithView_,
                        this.textRotation_,
                        [
                            scale,
                            scale
                        ],
                        NaN,
                        undefined,
                        this.declutterImageWithText_,
                        padding,
                        !!textState.backgroundFill,
                        !!textState.backgroundStroke,
                        this.text_,
                        this.textKey_,
                        this.strokeKey_,
                        this.fillKey_ ? (0, $069ac9f2344fe90f$export$c495d52ee3fd74b2) : this.fillKey_,
                        this.textOffsetX_,
                        this.textOffsetY_,
                        geometryWidths
                    ]);
                    // Reset previous fill
                    if (textState.backgroundFill) {
                        this.state.fillStyle = currentFillStyle;
                        this.hitDetectionInstructions.push(this.createFill(this.state));
                    }
                    this.endGeometry(feature);
                }
            }
        },
        {
            /**
   * @private
   */ key: "saveTextStates_",
            value: function saveTextStates_() {
                var strokeState = this.textStrokeState_;
                var textState = this.textState_;
                var fillState = this.textFillState_;
                var strokeKey = this.strokeKey_;
                if (strokeState) {
                    if (!(strokeKey in this.strokeStates)) this.strokeStates[strokeKey] = {
                        strokeStyle: strokeState.strokeStyle,
                        lineCap: strokeState.lineCap,
                        lineDashOffset: strokeState.lineDashOffset,
                        lineWidth: strokeState.lineWidth,
                        lineJoin: strokeState.lineJoin,
                        miterLimit: strokeState.miterLimit,
                        lineDash: strokeState.lineDash
                    };
                }
                var textKey = this.textKey_;
                if (!(textKey in this.textStates)) this.textStates[textKey] = {
                    font: textState.font,
                    textAlign: textState.textAlign || (0, $069ac9f2344fe90f$export$94d53b95641b5766),
                    justify: textState.justify,
                    textBaseline: textState.textBaseline || (0, $069ac9f2344fe90f$export$cf2279a1bff62eb),
                    scale: textState.scale
                };
                var fillKey = this.fillKey_;
                if (fillState) {
                    if (!(fillKey in this.fillStates)) this.fillStates[fillKey] = {
                        fillStyle: fillState.fillStyle
                    };
                }
            }
        },
        {
            /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   */ key: "drawChars_",
            value: function drawChars_(begin, end) {
                var strokeState = this.textStrokeState_;
                var textState = this.textState_;
                var strokeKey = this.strokeKey_;
                var textKey = this.textKey_;
                var fillKey = this.fillKey_;
                this.saveTextStates_();
                var pixelRatio = this.pixelRatio;
                var baseline = $d1934f6411f4416d$export$91a016276e4aee96[textState.textBaseline];
                var offsetY = this.textOffsetY_ * pixelRatio;
                var text = this.text_;
                var strokeWidth = strokeState ? strokeState.lineWidth * Math.abs(textState.scale[0]) / 2 : 0;
                this.instructions.push([
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).DRAW_CHARS,
                    begin,
                    end,
                    baseline,
                    textState.overflow,
                    fillKey,
                    textState.maxAngle,
                    pixelRatio,
                    offsetY,
                    strokeKey,
                    strokeWidth * pixelRatio,
                    text,
                    textKey,
                    1
                ]);
                this.hitDetectionInstructions.push([
                    (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).DRAW_CHARS,
                    begin,
                    end,
                    baseline,
                    textState.overflow,
                    fillKey ? (0, $069ac9f2344fe90f$export$c495d52ee3fd74b2) : fillKey,
                    textState.maxAngle,
                    pixelRatio,
                    offsetY,
                    strokeKey,
                    strokeWidth * pixelRatio,
                    text,
                    textKey,
                    1 / pixelRatio
                ]);
            }
        },
        {
            /**
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @param {Object} [sharedData] Shared data.
   */ key: "setTextStyle",
            value: function setTextStyle(textStyle, sharedData) {
                var textState, fillState, strokeState;
                if (!textStyle) this.text_ = "";
                else {
                    var textFillStyle = textStyle.getFill();
                    if (!textFillStyle) {
                        fillState = null;
                        this.textFillState_ = fillState;
                    } else {
                        fillState = this.textFillState_;
                        if (!fillState) {
                            fillState = /** @type {import("../canvas.js").FillState} */ {};
                            this.textFillState_ = fillState;
                        }
                        fillState.fillStyle = (0, $11e0a43141029edf$export$dc5b1400ac3a10a8)(textFillStyle.getColor() || (0, $069ac9f2344fe90f$export$c495d52ee3fd74b2));
                    }
                    var textStrokeStyle = textStyle.getStroke();
                    if (!textStrokeStyle) {
                        strokeState = null;
                        this.textStrokeState_ = strokeState;
                    } else {
                        strokeState = this.textStrokeState_;
                        if (!strokeState) {
                            strokeState = /** @type {import("../canvas.js").StrokeState} */ {};
                            this.textStrokeState_ = strokeState;
                        }
                        var lineDash = textStrokeStyle.getLineDash();
                        var lineDashOffset = textStrokeStyle.getLineDashOffset();
                        var lineWidth = textStrokeStyle.getWidth();
                        var miterLimit = textStrokeStyle.getMiterLimit();
                        strokeState.lineCap = textStrokeStyle.getLineCap() || (0, $069ac9f2344fe90f$export$17bd0c38d6ae694e);
                        strokeState.lineDash = lineDash ? lineDash.slice() : (0, $069ac9f2344fe90f$export$e21b4112fdc612fc);
                        strokeState.lineDashOffset = lineDashOffset === undefined ? (0, $069ac9f2344fe90f$export$e06efc2409049f76) : lineDashOffset;
                        strokeState.lineJoin = textStrokeStyle.getLineJoin() || (0, $069ac9f2344fe90f$export$365eb9648cf19bd0);
                        strokeState.lineWidth = lineWidth === undefined ? (0, $069ac9f2344fe90f$export$79661f132c62010e) : lineWidth;
                        strokeState.miterLimit = miterLimit === undefined ? (0, $069ac9f2344fe90f$export$80c1c01844597b7b) : miterLimit;
                        strokeState.strokeStyle = (0, $11e0a43141029edf$export$dc5b1400ac3a10a8)(textStrokeStyle.getColor() || (0, $069ac9f2344fe90f$export$1eb2eaecacf2031e));
                    }
                    textState = this.textState_;
                    var font = textStyle.getFont() || (0, $069ac9f2344fe90f$export$3847dfea4f8d4dfa);
                    (0, $069ac9f2344fe90f$export$a534074a28fa87ff)(font);
                    var textScale = textStyle.getScaleArray();
                    textState.overflow = textStyle.getOverflow();
                    textState.font = font;
                    textState.maxAngle = textStyle.getMaxAngle();
                    textState.placement = textStyle.getPlacement();
                    textState.textAlign = textStyle.getTextAlign();
                    textState.repeat = textStyle.getRepeat();
                    textState.justify = textStyle.getJustify();
                    textState.textBaseline = textStyle.getTextBaseline() || (0, $069ac9f2344fe90f$export$cf2279a1bff62eb);
                    textState.backgroundFill = textStyle.getBackgroundFill();
                    textState.backgroundStroke = textStyle.getBackgroundStroke();
                    textState.padding = textStyle.getPadding() || (0, $069ac9f2344fe90f$export$40a9eeef55665a40);
                    textState.scale = textScale === undefined ? [
                        1,
                        1
                    ] : textScale;
                    var textOffsetX = textStyle.getOffsetX();
                    var textOffsetY = textStyle.getOffsetY();
                    var textRotateWithView = textStyle.getRotateWithView();
                    var textRotation = textStyle.getRotation();
                    this.text_ = textStyle.getText() || "";
                    this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
                    this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
                    this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
                    this.textRotation_ = textRotation === undefined ? 0 : textRotation;
                    this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == "string" ? strokeState.strokeStyle : (0, $8b32fff2376556ef$export$5e82334337e0f204)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + "|" + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + "[" + strokeState.lineDash.join() + "]" : "";
                    this.textKey_ = textState.font + textState.scale + (textState.textAlign || "?") + (textState.repeat || "?") + (textState.justify || "?") + (textState.textBaseline || "?");
                    this.fillKey_ = fillState ? typeof fillState.fillStyle == "string" ? fillState.fillStyle : "|" + (0, $8b32fff2376556ef$export$5e82334337e0f204)(fillState.fillStyle) : "";
                }
                this.declutterImageWithText_ = sharedData;
            }
        }
    ]);
    return CanvasTextBuilder;
}((0, $9ebbaf4e12b6d86d$export$2e2bcd8739ae039));
var $d1934f6411f4416d$export$2e2bcd8739ae039 = $d1934f6411f4416d$var$CanvasTextBuilder;


/**
 * @type {Object<import("../canvas.js").BuilderType, typeof Builder>}
 */ var $b6b7cfac83330430$var$BATCH_CONSTRUCTORS = {
    "Circle": (0, $179093a7a0ac9003$export$2e2bcd8739ae039),
    "Default": (0, $9ebbaf4e12b6d86d$export$2e2bcd8739ae039),
    "Image": (0, $beeff49866d88805$export$2e2bcd8739ae039),
    "LineString": (0, $91930153490caeef$export$2e2bcd8739ae039),
    "Polygon": (0, $179093a7a0ac9003$export$2e2bcd8739ae039),
    "Text": (0, $d1934f6411f4416d$export$2e2bcd8739ae039)
};
var $b6b7cfac83330430$var$BuilderGroup = /*#__PURE__*/ function() {
    "use strict";
    function BuilderGroup(tolerance, maxExtent, resolution, pixelRatio) {
        (0, $5sFFs._)(this, BuilderGroup);
        /**
     * @private
     * @type {number}
     */ this.tolerance_ = tolerance;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {!Object<string, !Object<import("../canvas.js").BuilderType, Builder>>}
     */ this.buildersByZIndex_ = {};
    }
    (0, $8O2fV._)(BuilderGroup, [
        {
            /**
   * @return {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Builder.js").SerializableInstructions>>} The serializable instructions
   */ key: "finish",
            value: function finish() {
                var builderInstructions = {};
                for(var zKey in this.buildersByZIndex_){
                    builderInstructions[zKey] = builderInstructions[zKey] || {};
                    var builders = this.buildersByZIndex_[zKey];
                    for(var builderKey in builders){
                        var builderInstruction = builders[builderKey].finish();
                        builderInstructions[zKey][builderKey] = builderInstruction;
                    }
                }
                return builderInstructions;
            }
        },
        {
            /**
   * @param {number|undefined} zIndex Z index.
   * @param {import("../canvas.js").BuilderType} builderType Replay type.
   * @return {import("../VectorContext.js").default} Replay.
   */ key: "getBuilder",
            value: function getBuilder(zIndex, builderType) {
                var zIndexKey = zIndex !== undefined ? zIndex.toString() : "0";
                var replays = this.buildersByZIndex_[zIndexKey];
                if (replays === undefined) {
                    replays = {};
                    this.buildersByZIndex_[zIndexKey] = replays;
                }
                var replay = replays[builderType];
                if (replay === undefined) {
                    var Constructor = $b6b7cfac83330430$var$BATCH_CONSTRUCTORS[builderType];
                    replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
                    replays[builderType] = replay;
                }
                return replay;
            }
        }
    ]);
    return BuilderGroup;
}();
var $b6b7cfac83330430$export$2e2bcd8739ae039 = $b6b7cfac83330430$var$BuilderGroup;



/**
 * @module ol/render/canvas/ExecutorGroup
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $fyztb = parcelRequire("fyztb");
/**
 * @module ol/render/canvas/Executor
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");





/**
 * @module ol/geom/flat/textpath
 */ 

function $8b0016a46f19ecae$export$153a9a17ab3e949f(flatCoordinates, offset, end, stride, text, startM, maxAngle, scale, measureAndCacheTextWidth, font, cache, rotation) {
    var x2 = flatCoordinates[offset];
    var y2 = flatCoordinates[offset + 1];
    var x1 = 0;
    var y1 = 0;
    var segmentLength = 0;
    var segmentM = 0;
    function advance() {
        x1 = x2;
        y1 = y2;
        offset += stride;
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        segmentM += segmentLength;
        segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    do advance();
    while (offset < end - stride && segmentM + segmentLength < startM);
    var interpolate = segmentLength === 0 ? 0 : (startM - segmentM) / segmentLength;
    var beginX = (0, $029c1e222d833501$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    var beginY = (0, $029c1e222d833501$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    var startOffset = offset - stride;
    var startLength = segmentM;
    var endM = startM + scale * measureAndCacheTextWidth(font, text, cache);
    while(offset < end - stride && segmentM + segmentLength < endM)advance();
    interpolate = segmentLength === 0 ? 0 : (endM - segmentM) / segmentLength;
    var endX = (0, $029c1e222d833501$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    var endY = (0, $029c1e222d833501$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    // Keep text upright
    var reverse;
    if (rotation) {
        var flat = [
            beginX,
            beginY,
            endX,
            endY
        ];
        (0, $c8fb0baeba325f5c$export$bb628a54ab399bc9)(flat, 0, 4, 2, rotation, flat, flat);
        reverse = flat[0] > flat[2];
    } else reverse = beginX > endX;
    var PI = Math.PI;
    var result = [];
    var singleSegment = startOffset + stride === offset;
    offset = startOffset;
    segmentLength = 0;
    segmentM = startLength;
    x2 = flatCoordinates[offset];
    y2 = flatCoordinates[offset + 1];
    var previousAngle;
    // All on the same segment
    if (singleSegment) {
        advance();
        previousAngle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) previousAngle += previousAngle > 0 ? -PI : PI;
        var x = (endX + beginX) / 2;
        var y = (endY + beginY) / 2;
        result[0] = [
            x,
            y,
            (endM - startM) / 2,
            previousAngle,
            text
        ];
        return result;
    }
    // rendering across line segments
    text = text.replace(/\n/g, " "); // ensure rendering in single-line as all calculations below don't handle multi-lines
    for(var i = 0, ii = text.length; i < ii;){
        advance();
        var angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) angle += angle > 0 ? -PI : PI;
        if (previousAngle !== undefined) {
            var delta = angle - previousAngle;
            delta += delta > PI ? -2 * PI : delta < -PI ? 2 * PI : 0;
            if (Math.abs(delta) > maxAngle) return null;
        }
        previousAngle = angle;
        var iStart = i;
        var charLength = 0;
        for(; i < ii; ++i){
            var index = reverse ? ii - i - 1 : i;
            var len = scale * measureAndCacheTextWidth(font, text[index], cache);
            if (offset + stride < end && segmentM + segmentLength < startM + charLength + len / 2) break;
            charLength += len;
        }
        if (i === iStart) continue;
        var chars = reverse ? text.substring(ii - iStart, ii - i) : text.substring(iStart, i);
        interpolate = segmentLength === 0 ? 0 : (startM + charLength / 2 - segmentM) / segmentLength;
        var x3 = (0, $029c1e222d833501$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
        var y3 = (0, $029c1e222d833501$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
        result.push([
            x3,
            y3,
            charLength / 2,
            angle,
            chars
        ]);
        startM += charLength;
    }
    return result;
}



/**
 * @module ol/geom/flat/length
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */ function $55ad3feb4c83fd65$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride) {
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    var length = 0;
    for(var i = offset + stride; i < end; i += stride){
        var x2 = flatCoordinates[i];
        var y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
function $55ad3feb4c83fd65$export$2bbb4f6f727a75c2(flatCoordinates, offset, end, stride) {
    var perimeter = $55ad3feb4c83fd65$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride);
    var dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    var dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}



/**
 * @typedef {Object} BBox
 * @property {number} minX Minimal x.
 * @property {number} minY Minimal y.
 * @property {number} maxX Maximal x.
 * @property {number} maxY Maximal y
 * @property {*} value Value.
 */ /**
 * @typedef {Object} ImageOrLabelDimensions
 * @property {number} drawImageX DrawImageX.
 * @property {number} drawImageY DrawImageY.
 * @property {number} drawImageW DrawImageW.
 * @property {number} drawImageH DrawImageH.
 * @property {number} originX OriginX.
 * @property {number} originY OriginY.
 * @property {Array<number>} scale Scale.
 * @property {BBox} declutterBox DeclutterBox.
 * @property {import("../../transform.js").Transform} canvasTransform CanvasTransform.
 */ /**
 * @typedef {{0: CanvasRenderingContext2D, 1: number, 2: import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement, 3: ImageOrLabelDimensions, 4: number, 5: Array<*>, 6: Array<*>}} ReplayImageOrLabelArgs
 */ /**
 * @template T
 * @typedef {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * @type {import("../../extent.js").Extent}
 */ var $2e45385babaf4b63$var$tmpExtent = (0, $e86e0aa087890eb8$export$fe201bb3bbe031e9)();
/** @type {import("../../coordinate.js").Coordinate} */ var $2e45385babaf4b63$var$p1 = [];
/** @type {import("../../coordinate.js").Coordinate} */ var $2e45385babaf4b63$var$p2 = [];
/** @type {import("../../coordinate.js").Coordinate} */ var $2e45385babaf4b63$var$p3 = [];
/** @type {import("../../coordinate.js").Coordinate} */ var $2e45385babaf4b63$var$p4 = [];
/**
 * @param {ReplayImageOrLabelArgs} replayImageOrLabelArgs Arguments to replayImageOrLabel
 * @return {BBox} Declutter bbox.
 */ function $2e45385babaf4b63$var$getDeclutterBox(replayImageOrLabelArgs) {
    return replayImageOrLabelArgs[3].declutterBox;
}
var $2e45385babaf4b63$var$rtlRegEx = new RegExp(/* eslint-disable prettier/prettier */ "[" + String.fromCharCode(0x00591) + "-" + String.fromCharCode(0x008ff) + String.fromCharCode(0x0fb1d) + "-" + String.fromCharCode(0x0fdff) + String.fromCharCode(0x0fe70) + "-" + String.fromCharCode(0x0fefc) + String.fromCharCode(0x10800) + "-" + String.fromCharCode(0x10fff) + String.fromCharCode(0x1e800) + "-" + String.fromCharCode(0x1efff) + "]");
/**
 * @param {string} text Text.
 * @param {CanvasTextAlign} align Alignment.
 * @return {number} Text alignment.
 */ function $2e45385babaf4b63$var$horizontalTextAlign(text, align) {
    if (align === "start") align = $2e45385babaf4b63$var$rtlRegEx.test(text) ? "right" : "left";
    else if (align === "end") align = $2e45385babaf4b63$var$rtlRegEx.test(text) ? "left" : "right";
    return (0, $d1934f6411f4416d$export$91a016276e4aee96)[align];
}
/**
 * @param {Array<string>} acc Accumulator.
 * @param {string} line Line of text.
 * @param {number} i Index
 * @return {Array<string>} Accumulator.
 */ function $2e45385babaf4b63$var$createTextChunks(acc, line, i) {
    if (i > 0) acc.push("\n", "");
    acc.push(line, "");
    return acc;
}
var $2e45385babaf4b63$var$Executor = /*#__PURE__*/ function() {
    "use strict";
    function Executor(resolution, pixelRatio, overlaps, instructions) {
        (0, $5sFFs._)(this, Executor);
        /**
     * @protected
     * @type {boolean}
     */ this.overlaps = overlaps;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {boolean}
     */ this.alignFill_;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = instructions.instructions;
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = instructions.coordinates;
        /**
     * @private
     * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
     */ this.coordinateCache_ = {};
        /**
     * @private
     * @type {!import("../../transform.js").Transform}
     */ this.renderedTransform_ = (0, $afa6393b3817702c$export$185802fd694ee1f5)();
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = instructions.hitDetectionInstructions;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = null;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = 0;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = instructions.fillStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = instructions.strokeStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = instructions.textStates || {};
        /**
     * @private
     * @type {Object<string, Object<string, number>>}
     */ this.widths_ = {};
        /**
     * @private
     * @type {Object<string, import("../canvas.js").Label>}
     */ this.labels_ = {};
    }
    (0, $8O2fV._)(Executor, [
        {
            /**
   * @param {string|Array<string>} text Text.
   * @param {string} textKey Text style key.
   * @param {string} fillKey Fill style key.
   * @param {string} strokeKey Stroke style key.
   * @return {import("../canvas.js").Label} Label.
   */ key: "createLabel",
            value: function createLabel(text, textKey, fillKey, strokeKey) {
                var key = text + textKey + fillKey + strokeKey;
                if (this.labels_[key]) return this.labels_[key];
                var strokeState = strokeKey ? this.strokeStates[strokeKey] : null;
                var fillState = fillKey ? this.fillStates[fillKey] : null;
                var textState = this.textStates[textKey];
                var pixelRatio = this.pixelRatio;
                var scale = [
                    textState.scale[0] * pixelRatio,
                    textState.scale[1] * pixelRatio
                ];
                var textIsArray = Array.isArray(text);
                var align = textState.justify ? (0, $d1934f6411f4416d$export$91a016276e4aee96)[textState.justify] : $2e45385babaf4b63$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $069ac9f2344fe90f$export$94d53b95641b5766));
                var strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
                var chunks = textIsArray ? text : text.split("\n").reduce($2e45385babaf4b63$var$createTextChunks, []);
                var _getTextDimensions = (0, $069ac9f2344fe90f$export$7d7c13020df1e791)(textState, chunks), width = _getTextDimensions.width, height = _getTextDimensions.height, widths = _getTextDimensions.widths, heights = _getTextDimensions.heights, lineWidths = _getTextDimensions.lineWidths;
                var renderWidth = width + strokeWidth;
                var contextInstructions = [];
                // make canvas 2 pixels wider to account for italic text width measurement errors
                var w = (renderWidth + 2) * scale[0];
                var h = (height + strokeWidth) * scale[1];
                /** @type {import("../canvas.js").Label} */ var label = {
                    width: w < 0 ? Math.floor(w) : Math.ceil(w),
                    height: h < 0 ? Math.floor(h) : Math.ceil(h),
                    contextInstructions: contextInstructions
                };
                if (scale[0] != 1 || scale[1] != 1) contextInstructions.push("scale", scale);
                if (strokeKey) {
                    contextInstructions.push("strokeStyle", strokeState.strokeStyle);
                    contextInstructions.push("lineWidth", strokeWidth);
                    contextInstructions.push("lineCap", strokeState.lineCap);
                    contextInstructions.push("lineJoin", strokeState.lineJoin);
                    contextInstructions.push("miterLimit", strokeState.miterLimit);
                    contextInstructions.push("setLineDash", [
                        strokeState.lineDash
                    ]);
                    contextInstructions.push("lineDashOffset", strokeState.lineDashOffset);
                }
                if (fillKey) contextInstructions.push("fillStyle", fillState.fillStyle);
                contextInstructions.push("textBaseline", "middle");
                contextInstructions.push("textAlign", "center");
                var leftRight = 0.5 - align;
                var x = align * renderWidth + leftRight * strokeWidth;
                var strokeInstructions = [];
                var fillInstructions = [];
                var lineHeight = 0;
                var lineOffset = 0;
                var widthHeightIndex = 0;
                var lineWidthIndex = 0;
                var previousFont;
                for(var i = 0, ii = chunks.length; i < ii; i += 2){
                    var _$text = chunks[i];
                    if (_$text === "\n") {
                        lineOffset += lineHeight;
                        lineHeight = 0;
                        x = align * renderWidth + leftRight * strokeWidth;
                        ++lineWidthIndex;
                        continue;
                    }
                    var font = chunks[i + 1] || textState.font;
                    if (font !== previousFont) {
                        if (strokeKey) strokeInstructions.push("font", font);
                        if (fillKey) fillInstructions.push("font", font);
                        previousFont = font;
                    }
                    lineHeight = Math.max(lineHeight, heights[widthHeightIndex]);
                    var fillStrokeArgs = [
                        _$text,
                        x + leftRight * widths[widthHeightIndex] + align * (widths[widthHeightIndex] - lineWidths[lineWidthIndex]),
                        0.5 * (strokeWidth + lineHeight) + lineOffset
                    ];
                    x += widths[widthHeightIndex];
                    if (strokeKey) strokeInstructions.push("strokeText", fillStrokeArgs);
                    if (fillKey) fillInstructions.push("fillText", fillStrokeArgs);
                    ++widthHeightIndex;
                }
                Array.prototype.push.apply(contextInstructions, strokeInstructions);
                Array.prototype.push.apply(contextInstructions, fillInstructions);
                this.labels_[key] = label;
                return label;
            }
        },
        {
            /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */ key: "replayTextBackground_",
            value: function replayTextBackground_(context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
                context.beginPath();
                context.moveTo.apply(context, p1);
                context.lineTo.apply(context, p2);
                context.lineTo.apply(context, p3);
                context.lineTo.apply(context, p4);
                context.lineTo.apply(context, p1);
                if (fillInstruction) {
                    this.alignFill_ = /** @type {boolean} */ fillInstruction[2];
                    this.fill_(context);
                }
                if (strokeInstruction) {
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ strokeInstruction);
                    context.stroke();
                }
            }
        },
        {
            /**
   * @private
   * @param {number} sheetWidth Width of the sprite sheet.
   * @param {number} sheetHeight Height of the sprite sheet.
   * @param {number} centerX X.
   * @param {number} centerY Y.
   * @param {number} width Width.
   * @param {number} height Height.
   * @param {number} anchorX Anchor X.
   * @param {number} anchorY Anchor Y.
   * @param {number} originX Origin X.
   * @param {number} originY Origin Y.
   * @param {number} rotation Rotation.
   * @param {import("../../size.js").Size} scale Scale.
   * @param {boolean} snapToPixel Snap to pixel.
   * @param {Array<number>} padding Padding.
   * @param {boolean} fillStroke Background fill or stroke.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
   */ key: "calculateImageOrLabelDimensions_",
            value: function calculateImageOrLabelDimensions_(sheetWidth, sheetHeight, centerX, centerY, width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, fillStroke, feature) {
                anchorX *= scale[0];
                anchorY *= scale[1];
                var x = centerX - anchorX;
                var y = centerY - anchorY;
                var w = width + originX > sheetWidth ? sheetWidth - originX : width;
                var h = height + originY > sheetHeight ? sheetHeight - originY : height;
                var boxW = padding[3] + w * scale[0] + padding[1];
                var boxH = padding[0] + h * scale[1] + padding[2];
                var boxX = x - padding[3];
                var boxY = y - padding[0];
                if (fillStroke || rotation !== 0) {
                    $2e45385babaf4b63$var$p1[0] = boxX;
                    $2e45385babaf4b63$var$p4[0] = boxX;
                    $2e45385babaf4b63$var$p1[1] = boxY;
                    $2e45385babaf4b63$var$p2[1] = boxY;
                    $2e45385babaf4b63$var$p2[0] = boxX + boxW;
                    $2e45385babaf4b63$var$p3[0] = $2e45385babaf4b63$var$p2[0];
                    $2e45385babaf4b63$var$p3[1] = boxY + boxH;
                    $2e45385babaf4b63$var$p4[1] = $2e45385babaf4b63$var$p3[1];
                }
                var transform;
                if (rotation !== 0) {
                    transform = (0, $afa6393b3817702c$export$f672e0b6f7222cd7)((0, $afa6393b3817702c$export$185802fd694ee1f5)(), centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                    (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(transform, $2e45385babaf4b63$var$p1);
                    (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(transform, $2e45385babaf4b63$var$p2);
                    (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(transform, $2e45385babaf4b63$var$p3);
                    (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(transform, $2e45385babaf4b63$var$p4);
                    (0, $e86e0aa087890eb8$export$958e3e1a02eac4b6)(Math.min($2e45385babaf4b63$var$p1[0], $2e45385babaf4b63$var$p2[0], $2e45385babaf4b63$var$p3[0], $2e45385babaf4b63$var$p4[0]), Math.min($2e45385babaf4b63$var$p1[1], $2e45385babaf4b63$var$p2[1], $2e45385babaf4b63$var$p3[1], $2e45385babaf4b63$var$p4[1]), Math.max($2e45385babaf4b63$var$p1[0], $2e45385babaf4b63$var$p2[0], $2e45385babaf4b63$var$p3[0], $2e45385babaf4b63$var$p4[0]), Math.max($2e45385babaf4b63$var$p1[1], $2e45385babaf4b63$var$p2[1], $2e45385babaf4b63$var$p3[1], $2e45385babaf4b63$var$p4[1]), $2e45385babaf4b63$var$tmpExtent);
                } else (0, $e86e0aa087890eb8$export$958e3e1a02eac4b6)(Math.min(boxX, boxX + boxW), Math.min(boxY, boxY + boxH), Math.max(boxX, boxX + boxW), Math.max(boxY, boxY + boxH), $2e45385babaf4b63$var$tmpExtent);
                if (snapToPixel) {
                    x = Math.round(x);
                    y = Math.round(y);
                }
                return {
                    drawImageX: x,
                    drawImageY: y,
                    drawImageW: w,
                    drawImageH: h,
                    originX: originX,
                    originY: originY,
                    declutterBox: {
                        minX: $2e45385babaf4b63$var$tmpExtent[0],
                        minY: $2e45385babaf4b63$var$tmpExtent[1],
                        maxX: $2e45385babaf4b63$var$tmpExtent[2],
                        maxY: $2e45385babaf4b63$var$tmpExtent[3],
                        value: feature
                    },
                    canvasTransform: transform,
                    scale: scale
                };
            }
        },
        {
            /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} contextScale Scale of the context.
   * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
   * @param {ImageOrLabelDimensions} dimensions Dimensions.
   * @param {number} opacity Opacity.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   * @return {boolean} The image or label was rendered.
   */ key: "replayImageOrLabel_",
            value: function replayImageOrLabel_(context, contextScale, imageOrLabel, dimensions, opacity, fillInstruction, strokeInstruction) {
                var fillStroke = !!(fillInstruction || strokeInstruction);
                var box = dimensions.declutterBox;
                var canvas = context.canvas;
                var strokePadding = strokeInstruction ? strokeInstruction[2] * dimensions.scale[0] / 2 : 0;
                var intersects = box.minX - strokePadding <= canvas.width / contextScale && box.maxX + strokePadding >= 0 && box.minY - strokePadding <= canvas.height / contextScale && box.maxY + strokePadding >= 0;
                if (intersects) {
                    if (fillStroke) this.replayTextBackground_(context, $2e45385babaf4b63$var$p1, $2e45385babaf4b63$var$p2, $2e45385babaf4b63$var$p3, $2e45385babaf4b63$var$p4, /** @type {Array<*>} */ fillInstruction, /** @type {Array<*>} */ strokeInstruction);
                    (0, $069ac9f2344fe90f$export$3cb6f3a6e49cc0ee)(context, dimensions.canvasTransform, opacity, imageOrLabel, dimensions.originX, dimensions.originY, dimensions.drawImageW, dimensions.drawImageH, dimensions.drawImageX, dimensions.drawImageY, dimensions.scale);
                }
                return true;
            }
        },
        {
            /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   */ key: "fill_",
            value: function fill_(context) {
                if (this.alignFill_) {
                    var origin = (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(this.renderedTransform_, [
                        0,
                        0
                    ]);
                    var repeatSize = 512 * this.pixelRatio;
                    context.save();
                    context.translate(origin[0] % repeatSize, origin[1] % repeatSize);
                    context.rotate(this.viewRotation_);
                }
                context.fill();
                if (this.alignFill_) context.restore();
            }
        },
        {
            /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {Array<*>} instruction Instruction.
   */ key: "setStrokeStyle_",
            value: function setStrokeStyle_(context, instruction) {
                context["strokeStyle"] = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
                context.lineWidth = /** @type {number} */ instruction[2];
                context.lineCap = /** @type {CanvasLineCap} */ instruction[3];
                context.lineJoin = /** @type {CanvasLineJoin} */ instruction[4];
                context.miterLimit = /** @type {number} */ instruction[5];
                context.lineDashOffset = /** @type {number} */ instruction[7];
                context.setLineDash(/** @type {Array<number>} */ instruction[6]);
            }
        },
        {
            /**
   * @private
   * @param {string|Array<string>} text The text to draw.
   * @param {string} textKey The key of the text state.
   * @param {string} strokeKey The key for the stroke state.
   * @param {string} fillKey The key for the fill state.
   * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
   */ key: "drawLabelWithPointPlacement_",
            value: function drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey) {
                var textState = this.textStates[textKey];
                var label = this.createLabel(text, textKey, fillKey, strokeKey);
                var strokeState = this.strokeStates[strokeKey];
                var pixelRatio = this.pixelRatio;
                var align = $2e45385babaf4b63$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $069ac9f2344fe90f$export$94d53b95641b5766));
                var baseline = (0, $d1934f6411f4416d$export$91a016276e4aee96)[textState.textBaseline || (0, $069ac9f2344fe90f$export$cf2279a1bff62eb)];
                var strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
                // Remove the 2 pixels we added in createLabel() for the anchor
                var width = label.width / pixelRatio - 2 * textState.scale[0];
                var anchorX = align * width + 2 * (0.5 - align) * strokeWidth;
                var anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
                return {
                    label: label,
                    anchorX: anchorX,
                    anchorY: anchorY
                };
            }
        },
        {
            /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} contextScale Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {Array<*>} instructions Instructions array.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @param {import("rbush").default} [declutterTree] Declutter tree.
   * @return {T|undefined} Callback result.
   * @template T
   */ key: "execute_",
            value: function execute_(context, contextScale, transform, instructions, snapToPixel, featureCallback, hitExtent, declutterTree) {
                /** @type {Array<number>} */ var pixelCoordinates;
                if (this.pixelCoordinates_ && (0, $edee3659e50a93f4$export$e9bab7fafb253603)(transform, this.renderedTransform_)) pixelCoordinates = this.pixelCoordinates_;
                else {
                    if (!this.pixelCoordinates_) this.pixelCoordinates_ = [];
                    pixelCoordinates = (0, $c8fb0baeba325f5c$export$b92b2dedcfff79de)(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
                    (0, $afa6393b3817702c$export$42b4187a82d80ed0)(this.renderedTransform_, transform);
                }
                var i = 0; // instruction index
                var ii = instructions.length; // end of instructions
                var d = 0; // data index
                var dd; // end of per-instruction data
                var anchorX, anchorY, prevX, prevY, roundX, roundY, image, text, textKey, strokeKey, fillKey;
                var pendingFill = 0;
                var pendingStroke = 0;
                var lastFillInstruction = null;
                var lastStrokeInstruction = null;
                var coordinateCache = this.coordinateCache_;
                var viewRotation = this.viewRotation_;
                var viewRotationFromTransform = Math.round(Math.atan2(-transform[1], transform[0]) * 1e12) / 1e12;
                var state = /** @type {import("../../render.js").State} */ {
                    context: context,
                    pixelRatio: this.pixelRatio,
                    resolution: this.resolution,
                    rotation: viewRotation
                };
                // When the batch size gets too big, performance decreases. 200 is a good
                // balance between batch size and number of fill/stroke instructions.
                var batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
                var /** @type {import("../../Feature.js").FeatureLike} */ feature;
                var x, y, currentGeometry;
                while(i < ii){
                    var instruction = instructions[i];
                    var type = /** @type {import("./Instruction.js").default} */ instruction[0];
                    switch(type){
                        case (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).BEGIN_GEOMETRY:
                            feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                            currentGeometry = instruction[3];
                            if (!feature.getGeometry()) i = /** @type {number} */ instruction[2];
                            else if (hitExtent !== undefined && !(0, $e86e0aa087890eb8$export$7b0a31e10bbff018)(hitExtent, currentGeometry.getExtent())) i = /** @type {number} */ instruction[2] + 1;
                            else ++i;
                            break;
                        case (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).BEGIN_PATH:
                            if (pendingFill > batchSize) {
                                this.fill_(context);
                                pendingFill = 0;
                            }
                            if (pendingStroke > batchSize) {
                                context.stroke();
                                pendingStroke = 0;
                            }
                            if (!pendingFill && !pendingStroke) {
                                context.beginPath();
                                prevX = NaN;
                                prevY = NaN;
                            }
                            ++i;
                            break;
                        case (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).CIRCLE:
                            d = /** @type {number} */ instruction[1];
                            var x1 = pixelCoordinates[d];
                            var y1 = pixelCoordinates[d + 1];
                            var x2 = pixelCoordinates[d + 2];
                            var y2 = pixelCoordinates[d + 3];
                            var dx = x2 - x1;
                            var dy = y2 - y1;
                            var r = Math.sqrt(dx * dx + dy * dy);
                            context.moveTo(x1 + r, y1);
                            context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                            ++i;
                            break;
                        case (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).CLOSE_PATH:
                            context.closePath();
                            ++i;
                            break;
                        case (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).CUSTOM:
                            d = /** @type {number} */ instruction[1];
                            dd = instruction[2];
                            var geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ instruction[3];
                            var renderer = instruction[4];
                            var fn = instruction.length == 6 ? instruction[5] : undefined;
                            state.geometry = geometry;
                            state.feature = feature;
                            if (!(i in coordinateCache)) coordinateCache[i] = [];
                            var coords = coordinateCache[i];
                            if (fn) fn(pixelCoordinates, d, dd, 2, coords);
                            else {
                                coords[0] = pixelCoordinates[d];
                                coords[1] = pixelCoordinates[d + 1];
                                coords.length = 2;
                            }
                            renderer(coords, state);
                            ++i;
                            break;
                        case (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).DRAW_IMAGE:
                            d = /** @type {number} */ instruction[1];
                            dd = /** @type {number} */ instruction[2];
                            image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ instruction[3];
                            // Remaining arguments in DRAW_IMAGE are in alphabetical order
                            anchorX = /** @type {number} */ instruction[4];
                            anchorY = /** @type {number} */ instruction[5];
                            var height = /** @type {number} */ instruction[6];
                            var opacity = /** @type {number} */ instruction[7];
                            var originX = /** @type {number} */ instruction[8];
                            var originY = /** @type {number} */ instruction[9];
                            var rotateWithView = /** @type {boolean} */ instruction[10];
                            var rotation = /** @type {number} */ instruction[11];
                            var scale = /** @type {import("../../size.js").Size} */ instruction[12];
                            var width = /** @type {number} */ instruction[13];
                            var declutterMode = /** @type {"declutter"|"obstacle"|"none"|undefined} */ instruction[14];
                            var declutterImageWithText = /** @type {import("../canvas.js").DeclutterImageWithText} */ instruction[15];
                            if (!image && instruction.length >= 20) {
                                // create label images
                                text = /** @type {string} */ instruction[19];
                                textKey = /** @type {string} */ instruction[20];
                                strokeKey = /** @type {string} */ instruction[21];
                                fillKey = /** @type {string} */ instruction[22];
                                var labelWithAnchor = this.drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey);
                                image = labelWithAnchor.label;
                                instruction[3] = image;
                                var textOffsetX = /** @type {number} */ instruction[23];
                                anchorX = (labelWithAnchor.anchorX - textOffsetX) * this.pixelRatio;
                                instruction[4] = anchorX;
                                var textOffsetY = /** @type {number} */ instruction[24];
                                anchorY = (labelWithAnchor.anchorY - textOffsetY) * this.pixelRatio;
                                instruction[5] = anchorY;
                                height = image.height;
                                instruction[6] = height;
                                width = image.width;
                                instruction[13] = width;
                            }
                            var geometryWidths = void 0;
                            if (instruction.length > 25) geometryWidths = /** @type {number} */ instruction[25];
                            var padding = void 0, backgroundFill = void 0, backgroundStroke = void 0;
                            if (instruction.length > 17) {
                                padding = /** @type {Array<number>} */ instruction[16];
                                backgroundFill = /** @type {boolean} */ instruction[17];
                                backgroundStroke = /** @type {boolean} */ instruction[18];
                            } else {
                                padding = (0, $069ac9f2344fe90f$export$40a9eeef55665a40);
                                backgroundFill = false;
                                backgroundStroke = false;
                            }
                            if (rotateWithView && viewRotationFromTransform) // Canvas is expected to be rotated to reverse view rotation.
                            rotation += viewRotation;
                            else if (!rotateWithView && !viewRotationFromTransform) // Canvas is not rotated, images need to be rotated back to be north-up.
                            rotation -= viewRotation;
                            var widthIndex = 0;
                            for(; d < dd; d += 2){
                                if (geometryWidths && geometryWidths[widthIndex++] < width / this.pixelRatio) continue;
                                var dimensions = this.calculateImageOrLabelDimensions_(image.width, image.height, pixelCoordinates[d], pixelCoordinates[d + 1], width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, backgroundFill || backgroundStroke, feature);
                                /** @type {ReplayImageOrLabelArgs} */ var args = [
                                    context,
                                    contextScale,
                                    image,
                                    dimensions,
                                    opacity,
                                    backgroundFill ? /** @type {Array<*>} */ lastFillInstruction : null,
                                    backgroundStroke ? /** @type {Array<*>} */ lastStrokeInstruction : null
                                ];
                                if (declutterTree) {
                                    if (declutterMode === "none") continue;
                                    else if (declutterMode === "obstacle") {
                                        // will always be drawn, thus no collision detection, but insert as obstacle
                                        declutterTree.insert(dimensions.declutterBox);
                                        continue;
                                    } else {
                                        var imageArgs = void 0;
                                        var imageDeclutterBox = void 0;
                                        if (declutterImageWithText) {
                                            var index = dd - d;
                                            if (!declutterImageWithText[index]) {
                                                // We now have the image for an image+text combination.
                                                declutterImageWithText[index] = args;
                                                continue;
                                            }
                                            imageArgs = declutterImageWithText[index];
                                            delete declutterImageWithText[index];
                                            imageDeclutterBox = $2e45385babaf4b63$var$getDeclutterBox(imageArgs);
                                            if (declutterTree.collides(imageDeclutterBox)) continue;
                                        }
                                        if (declutterTree.collides(dimensions.declutterBox)) continue;
                                        if (imageArgs) {
                                            // We now have image and text for an image+text combination.
                                            declutterTree.insert(imageDeclutterBox);
                                            // Render the image before we render the text.
                                            this.replayImageOrLabel_.apply(this, imageArgs);
                                        }
                                        declutterTree.insert(dimensions.declutterBox);
                                    }
                                }
                                this.replayImageOrLabel_.apply(this, args);
                            }
                            ++i;
                            break;
                        case (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).DRAW_CHARS:
                            var begin = /** @type {number} */ instruction[1];
                            var end = /** @type {number} */ instruction[2];
                            var baseline = /** @type {number} */ instruction[3];
                            var overflow = /** @type {number} */ instruction[4];
                            fillKey = /** @type {string} */ instruction[5];
                            var maxAngle = /** @type {number} */ instruction[6];
                            var measurePixelRatio = /** @type {number} */ instruction[7];
                            var offsetY = /** @type {number} */ instruction[8];
                            strokeKey = /** @type {string} */ instruction[9];
                            var strokeWidth = /** @type {number} */ instruction[10];
                            text = /** @type {string} */ instruction[11];
                            textKey = /** @type {string} */ instruction[12];
                            var pixelRatioScale = [
                                /** @type {number} */ instruction[13],
                                /** @type {number} */ instruction[13]
                            ];
                            var textState = this.textStates[textKey];
                            var font = textState.font;
                            var textScale = [
                                textState.scale[0] * measurePixelRatio,
                                textState.scale[1] * measurePixelRatio
                            ];
                            var cachedWidths = void 0;
                            if (font in this.widths_) cachedWidths = this.widths_[font];
                            else {
                                cachedWidths = {};
                                this.widths_[font] = cachedWidths;
                            }
                            var pathLength = (0, $55ad3feb4c83fd65$export$153f8c6b4d8caebc)(pixelCoordinates, begin, end, 2);
                            var textLength = Math.abs(textScale[0]) * (0, $069ac9f2344fe90f$export$915c7ba51467308f)(font, text, cachedWidths);
                            if (overflow || textLength <= pathLength) {
                                var textAlign = this.textStates[textKey].textAlign;
                                var startM = (pathLength - textLength) * $2e45385babaf4b63$var$horizontalTextAlign(text, textAlign);
                                var parts = (0, $8b0016a46f19ecae$export$153a9a17ab3e949f)(pixelCoordinates, begin, end, 2, text, startM, maxAngle, Math.abs(textScale[0]), (0, $069ac9f2344fe90f$export$915c7ba51467308f), font, cachedWidths, viewRotationFromTransform ? 0 : this.viewRotation_);
                                drawChars: if (parts) {
                                    /** @type {Array<ReplayImageOrLabelArgs>} */ var replayImageOrLabelArgs = [];
                                    var c = void 0, cc = void 0, chars = void 0, label = void 0, part = void 0;
                                    if (strokeKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                        part = parts[c]; // x, y, anchorX, rotation, chunk
                                        chars = /** @type {string} */ part[4];
                                        label = this.createLabel(chars, textKey, "", strokeKey);
                                        anchorX = /** @type {number} */ part[2] + (textScale[0] < 0 ? -strokeWidth : strokeWidth);
                                        anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth * textScale[1] / textScale[0] - offsetY;
                                        var dimensions1 = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $069ac9f2344fe90f$export$40a9eeef55665a40), false, feature);
                                        if (declutterTree && declutterTree.collides(dimensions1.declutterBox)) break drawChars;
                                        replayImageOrLabelArgs.push([
                                            context,
                                            contextScale,
                                            label,
                                            dimensions1,
                                            1,
                                            null,
                                            null
                                        ]);
                                    }
                                    if (fillKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                        part = parts[c]; // x, y, anchorX, rotation, chunk
                                        chars = /** @type {string} */ part[4];
                                        label = this.createLabel(chars, textKey, fillKey, "");
                                        anchorX = /** @type {number} */ part[2];
                                        anchorY = baseline * label.height - offsetY;
                                        var dimensions2 = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $069ac9f2344fe90f$export$40a9eeef55665a40), false, feature);
                                        if (declutterTree && declutterTree.collides(dimensions2.declutterBox)) break drawChars;
                                        replayImageOrLabelArgs.push([
                                            context,
                                            contextScale,
                                            label,
                                            dimensions2,
                                            1,
                                            null,
                                            null
                                        ]);
                                    }
                                    if (declutterTree) declutterTree.load(replayImageOrLabelArgs.map($2e45385babaf4b63$var$getDeclutterBox));
                                    for(var i1 = 0, ii1 = replayImageOrLabelArgs.length; i1 < ii1; ++i1)this.replayImageOrLabel_.apply(this, replayImageOrLabelArgs[i1]);
                                }
                            }
                            ++i;
                            break;
                        case (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).END_GEOMETRY:
                            if (featureCallback !== undefined) {
                                feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                                var result = featureCallback(feature, currentGeometry);
                                if (result) return result;
                            }
                            ++i;
                            break;
                        case (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).FILL:
                            if (batchSize) pendingFill++;
                            else this.fill_(context);
                            ++i;
                            break;
                        case (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).MOVE_TO_LINE_TO:
                            d = /** @type {number} */ instruction[1];
                            dd = /** @type {number} */ instruction[2];
                            x = pixelCoordinates[d];
                            y = pixelCoordinates[d + 1];
                            roundX = x + 0.5 | 0;
                            roundY = y + 0.5 | 0;
                            if (roundX !== prevX || roundY !== prevY) {
                                context.moveTo(x, y);
                                prevX = roundX;
                                prevY = roundY;
                            }
                            for(d += 2; d < dd; d += 2){
                                x = pixelCoordinates[d];
                                y = pixelCoordinates[d + 1];
                                roundX = x + 0.5 | 0;
                                roundY = y + 0.5 | 0;
                                if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                                    context.lineTo(x, y);
                                    prevX = roundX;
                                    prevY = roundY;
                                }
                            }
                            ++i;
                            break;
                        case (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).SET_FILL_STYLE:
                            lastFillInstruction = instruction;
                            this.alignFill_ = instruction[2];
                            if (pendingFill) {
                                this.fill_(context);
                                pendingFill = 0;
                                if (pendingStroke) {
                                    context.stroke();
                                    pendingStroke = 0;
                                }
                            }
                            context.fillStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
                            ++i;
                            break;
                        case (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).SET_STROKE_STYLE:
                            lastStrokeInstruction = instruction;
                            if (pendingStroke) {
                                context.stroke();
                                pendingStroke = 0;
                            }
                            this.setStrokeStyle_(context, /** @type {Array<*>} */ instruction);
                            ++i;
                            break;
                        case (0, $54a1b1b9ce0f9fd2$export$2e2bcd8739ae039).STROKE:
                            if (batchSize) pendingStroke++;
                            else context.stroke();
                            ++i;
                            break;
                        default:
                            ++i;
                            break;
                    }
                }
                if (pendingFill) this.fill_(context);
                if (pendingStroke) context.stroke();
                return undefined;
            }
        },
        {
            /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} contextScale Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {import("rbush").default} [declutterTree] Declutter tree.
   */ key: "execute",
            value: function execute(context, contextScale, transform, viewRotation, snapToPixel, declutterTree) {
                this.viewRotation_ = viewRotation;
                this.execute_(context, contextScale, transform, this.instructions, snapToPixel, undefined, undefined, declutterTree);
            }
        },
        {
            /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @return {T|undefined} Callback result.
   * @template T
   */ key: "executeHitDetection",
            value: function executeHitDetection(context, transform, viewRotation, featureCallback, hitExtent) {
                this.viewRotation_ = viewRotation;
                return this.execute_(context, 1, transform, this.hitDetectionInstructions, true, featureCallback, hitExtent);
            }
        }
    ]);
    return Executor;
}();
var $2e45385babaf4b63$export$2e2bcd8739ae039 = $2e45385babaf4b63$var$Executor;








/**
 * @const
 * @type {Array<import("../canvas.js").BuilderType>}
 */ var $1533a5c576f9dff1$var$ORDER = [
    "Polygon",
    "Circle",
    "LineString",
    "Image",
    "Text",
    "Default"
];
var $1533a5c576f9dff1$var$ExecutorGroup = /*#__PURE__*/ function() {
    "use strict";
    function ExecutorGroup(maxExtent, resolution, pixelRatio, overlaps, allInstructions, renderBuffer) {
        (0, $5sFFs._)(this, ExecutorGroup);
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = overlaps;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {number|undefined}
     */ this.renderBuffer_ = renderBuffer;
        /**
     * @private
     * @type {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Executor").default>>}
     */ this.executorsByZIndex_ = {};
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.hitDetectionContext_ = null;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.hitDetectionTransform_ = (0, $afa6393b3817702c$export$185802fd694ee1f5)();
        this.createExecutors_(allInstructions);
    }
    (0, $8O2fV._)(ExecutorGroup, [
        {
            /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   */ key: "clip",
            value: function clip(context, transform) {
                var flatClipCoords = this.getClipCoords(transform);
                context.beginPath();
                context.moveTo(flatClipCoords[0], flatClipCoords[1]);
                context.lineTo(flatClipCoords[2], flatClipCoords[3]);
                context.lineTo(flatClipCoords[4], flatClipCoords[5]);
                context.lineTo(flatClipCoords[6], flatClipCoords[7]);
                context.clip();
            }
        },
        {
            /**
   * Create executors and populate them using the provided instructions.
   * @private
   * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
   */ key: "createExecutors_",
            value: function createExecutors_(allInstructions) {
                for(var zIndex in allInstructions){
                    var executors = this.executorsByZIndex_[zIndex];
                    if (executors === undefined) {
                        executors = {};
                        this.executorsByZIndex_[zIndex] = executors;
                    }
                    var instructionByZindex = allInstructions[zIndex];
                    for(var builderType in instructionByZindex){
                        var instructions = instructionByZindex[builderType];
                        executors[builderType] = new (0, $2e45385babaf4b63$export$2e2bcd8739ae039)(this.resolution_, this.pixelRatio_, this.overlaps_, instructions);
                    }
                }
            }
        },
        {
            /**
   * @param {Array<import("../canvas.js").BuilderType>} executors Executors.
   * @return {boolean} Has executors of the provided types.
   */ key: "hasExecutors",
            value: function hasExecutors(executors) {
                for(var zIndex in this.executorsByZIndex_){
                    var candidates = this.executorsByZIndex_[zIndex];
                    for(var i = 0, ii = executors.length; i < ii; ++i){
                        if (executors[i] in candidates) return true;
                    }
                }
                return false;
            }
        },
        {
            /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
   * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
   * @return {T|undefined} Callback result.
   * @template T
   */ key: "forEachFeatureAtCoordinate",
            value: function forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, callback, declutteredFeatures) {
                hitTolerance = Math.round(hitTolerance);
                var contextSize = hitTolerance * 2 + 1;
                var transform = (0, $afa6393b3817702c$export$f672e0b6f7222cd7)(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
                var newContext = !this.hitDetectionContext_;
                if (newContext) this.hitDetectionContext_ = (0, $e000035bb4c81589$export$9e05d10eae75c464)(contextSize, contextSize, undefined, {
                    willReadFrequently: true
                });
                var context = this.hitDetectionContext_;
                if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
                    context.canvas.width = contextSize;
                    context.canvas.height = contextSize;
                } else if (!newContext) context.clearRect(0, 0, contextSize, contextSize);
                /**
     * @type {import("../../extent.js").Extent}
     */ var hitExtent;
                if (this.renderBuffer_ !== undefined) {
                    hitExtent = (0, $e86e0aa087890eb8$export$fe201bb3bbe031e9)();
                    (0, $e86e0aa087890eb8$export$1f820e3920fa5715)(hitExtent, coordinate);
                    (0, $e86e0aa087890eb8$export$ab1029bcae9ddb4a)(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
                }
                var indexes = $1533a5c576f9dff1$export$96fc84ea21b8269f(hitTolerance);
                var builderType;
                /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @return {T|undefined} Callback result.
     */ function featureCallback(feature, geometry) {
                    var imageData = context.getImageData(0, 0, contextSize, contextSize).data;
                    for(var i = 0, ii = indexes.length; i < ii; i++)if (imageData[indexes[i]] > 0) {
                        if (!declutteredFeatures || builderType !== "Image" && builderType !== "Text" || declutteredFeatures.includes(feature)) {
                            var idx = (indexes[i] - 3) / 4;
                            var x = hitTolerance - idx % contextSize;
                            var y = hitTolerance - (idx / contextSize | 0);
                            var result = callback(feature, geometry, x * x + y * y);
                            if (result) return result;
                        }
                        context.clearRect(0, 0, contextSize, contextSize);
                        break;
                    }
                    return undefined;
                }
                /** @type {Array<number>} */ var zs = Object.keys(this.executorsByZIndex_).map(Number);
                zs.sort((0, $edee3659e50a93f4$export$fcb633242ef15540));
                var i, j, executors, executor, result;
                for(i = zs.length - 1; i >= 0; --i){
                    var zIndexKey = zs[i].toString();
                    executors = this.executorsByZIndex_[zIndexKey];
                    for(j = $1533a5c576f9dff1$var$ORDER.length - 1; j >= 0; --j){
                        builderType = $1533a5c576f9dff1$var$ORDER[j];
                        executor = executors[builderType];
                        if (executor !== undefined) {
                            result = executor.executeHitDetection(context, transform, rotation, featureCallback, hitExtent);
                            if (result) return result;
                        }
                    }
                }
                return undefined;
            }
        },
        {
            /**
   * @param {import("../../transform.js").Transform} transform Transform.
   * @return {Array<number>|null} Clip coordinates.
   */ key: "getClipCoords",
            value: function getClipCoords(transform) {
                var maxExtent = this.maxExtent_;
                if (!maxExtent) return null;
                var minX = maxExtent[0];
                var minY = maxExtent[1];
                var maxX = maxExtent[2];
                var maxY = maxExtent[3];
                var flatClipCoords = [
                    minX,
                    minY,
                    minX,
                    maxY,
                    maxX,
                    maxY,
                    maxX,
                    minY
                ];
                (0, $c8fb0baeba325f5c$export$b92b2dedcfff79de)(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
                return flatClipCoords;
            }
        },
        {
            /**
   * @return {boolean} Is empty.
   */ key: "isEmpty",
            value: function isEmpty1() {
                return (0, $29e93681307ffd1e$export$dd1bc94b04021eeb)(this.executorsByZIndex_);
            }
        },
        {
            /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} contextScale Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
   * @param {Array<import("../canvas.js").BuilderType>} [builderTypes] Ordered replay types to replay.
   *     Default is {@link module:ol/render/replay~ORDER}
   * @param {import("rbush").default} [declutterTree] Declutter tree.
   */ key: "execute",
            value: function execute(context, contextScale, transform, viewRotation, snapToPixel, builderTypes, declutterTree) {
                /** @type {Array<number>} */ var zs = Object.keys(this.executorsByZIndex_).map(Number);
                zs.sort((0, $edee3659e50a93f4$export$fcb633242ef15540));
                // setup clipping so that the parts of over-simplified geometries are not
                // visible outside the current extent when panning
                if (this.maxExtent_) {
                    context.save();
                    this.clip(context, transform);
                }
                builderTypes = builderTypes ? builderTypes : $1533a5c576f9dff1$var$ORDER;
                var i, ii, j, jj, replays, replay;
                if (declutterTree) zs.reverse();
                for(i = 0, ii = zs.length; i < ii; ++i){
                    var zIndexKey = zs[i].toString();
                    replays = this.executorsByZIndex_[zIndexKey];
                    for(j = 0, jj = builderTypes.length; j < jj; ++j){
                        var builderType = builderTypes[j];
                        replay = replays[builderType];
                        if (replay !== undefined) replay.execute(context, contextScale, transform, viewRotation, snapToPixel, declutterTree);
                    }
                }
                if (this.maxExtent_) context.restore();
            }
        }
    ]);
    return ExecutorGroup;
}();
/**
 * This cache is used to store arrays of indexes for calculated pixel circles
 * to increase performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<number>>}
 */ var $1533a5c576f9dff1$var$circlePixelIndexArrayCache = {};
function $1533a5c576f9dff1$export$96fc84ea21b8269f(radius) {
    var _pixelIndex;
    if ($1533a5c576f9dff1$var$circlePixelIndexArrayCache[radius] !== undefined) return $1533a5c576f9dff1$var$circlePixelIndexArrayCache[radius];
    var size = radius * 2 + 1;
    var maxDistanceSq = radius * radius;
    var distances = new Array(maxDistanceSq + 1);
    for(var i = 0; i <= radius; ++i)for(var j = 0; j <= radius; ++j){
        var distanceSq = i * i + j * j;
        if (distanceSq > maxDistanceSq) break;
        var distance = distances[distanceSq];
        if (!distance) {
            distance = [];
            distances[distanceSq] = distance;
        }
        distance.push(((radius + i) * size + (radius + j)) * 4 + 3);
        if (i > 0) distance.push(((radius - i) * size + (radius + j)) * 4 + 3);
        if (j > 0) {
            distance.push(((radius + i) * size + (radius - j)) * 4 + 3);
            if (i > 0) distance.push(((radius - i) * size + (radius - j)) * 4 + 3);
        }
    }
    var pixelIndex = [];
    for(var i1 = 0, ii = distances.length; i1 < ii; ++i1)if (distances[i1]) (_pixelIndex = pixelIndex).push.apply(_pixelIndex, (0, $fyztb._)(distances[i1]));
    $1533a5c576f9dff1$var$circlePixelIndexArrayCache[radius] = pixelIndex;
    return pixelIndex;
}
var $1533a5c576f9dff1$export$2e2bcd8739ae039 = $1533a5c576f9dff1$var$ExecutorGroup;




/**
 * @module ol/render/canvas/hitdetect
 */ /**
 * @module ol/render/canvas/Immediate
 */ // FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");









/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext~VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */ var $aa03b5f22440bcfd$var$CanvasImmediateRenderer = /*#__PURE__*/ function(VectorContext) {
    "use strict";
    (0, $kcqLc._)(CanvasImmediateRenderer, VectorContext);
    var _super = (0, $4jYWU._)(CanvasImmediateRenderer);
    function CanvasImmediateRenderer(context, pixelRatio, extent, transform, viewRotation, squaredTolerance, userTransform) {
        (0, $5sFFs._)(this, CanvasImmediateRenderer);
        var _this;
        _this = _super.call(this);
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ _this.context_ = context;
        /**
     * @private
     * @type {number}
     */ _this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ _this.extent_ = extent;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ _this.transform_ = transform;
        /**
     * @private
     * @type {number}
     */ _this.transformRotation_ = transform ? (0, $029c1e222d833501$export$a81f732198733497)(Math.atan2(transform[1], transform[0]), 10) : 0;
        /**
     * @private
     * @type {number}
     */ _this.viewRotation_ = viewRotation;
        /**
     * @private
     * @type {number}
     */ _this.squaredTolerance_ = squaredTolerance;
        /**
     * @private
     * @type {import("../../proj.js").TransformFunction}
     */ _this.userTransform_ = userTransform;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ _this.contextFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ _this.contextStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ _this.contextTextState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ _this.fillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ _this.strokeState_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ _this.image_ = null;
        /**
     * @private
     * @type {number}
     */ _this.imageAnchorX_ = 0;
        /**
     * @private
     * @type {number}
     */ _this.imageAnchorY_ = 0;
        /**
     * @private
     * @type {number}
     */ _this.imageHeight_ = 0;
        /**
     * @private
     * @type {number}
     */ _this.imageOpacity_ = 0;
        /**
     * @private
     * @type {number}
     */ _this.imageOriginX_ = 0;
        /**
     * @private
     * @type {number}
     */ _this.imageOriginY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ _this.imageRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ _this.imageRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ _this.imageScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ _this.imageWidth_ = 0;
        /**
     * @private
     * @type {string}
     */ _this.text_ = "";
        /**
     * @private
     * @type {number}
     */ _this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ _this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ _this.textRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ _this.textRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ _this.textScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ _this.textFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ _this.textStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ _this.textState_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ _this.pixelCoordinates_ = [];
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ _this.tmpLocalTransform_ = (0, $afa6393b3817702c$export$185802fd694ee1f5)();
        return _this;
    }
    (0, $8O2fV._)(CanvasImmediateRenderer, [
        {
            /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ key: "drawImages_",
            value: function drawImages_(flatCoordinates, offset, end, stride) {
                if (!this.image_) return;
                var pixelCoordinates = (0, $c8fb0baeba325f5c$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
                var context = this.context_;
                var localTransform = this.tmpLocalTransform_;
                var alpha = context.globalAlpha;
                if (this.imageOpacity_ != 1) context.globalAlpha = alpha * this.imageOpacity_;
                var rotation = this.imageRotation_;
                if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
                if (this.imageRotateWithView_) rotation += this.viewRotation_;
                for(var i = 0, ii = pixelCoordinates.length; i < ii; i += 2){
                    var x = pixelCoordinates[i] - this.imageAnchorX_;
                    var y = pixelCoordinates[i + 1] - this.imageAnchorY_;
                    if (rotation !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
                        var centerX = x + this.imageAnchorX_;
                        var centerY = y + this.imageAnchorY_;
                        (0, $afa6393b3817702c$export$f672e0b6f7222cd7)(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                        context.save();
                        context.transform.apply(context, localTransform);
                        context.translate(centerX, centerY);
                        context.scale(this.imageScale_[0], this.imageScale_[1]);
                        context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
                        context.restore();
                    } else context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
                }
                if (this.imageOpacity_ != 1) context.globalAlpha = alpha;
            }
        },
        {
            /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ key: "drawText_",
            value: function drawText_(flatCoordinates, offset, end, stride) {
                if (!this.textState_ || this.text_ === "") return;
                if (this.textFillState_) this.setContextFillState_(this.textFillState_);
                if (this.textStrokeState_) this.setContextStrokeState_(this.textStrokeState_);
                this.setContextTextState_(this.textState_);
                var pixelCoordinates = (0, $c8fb0baeba325f5c$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
                var context = this.context_;
                var rotation = this.textRotation_;
                if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
                if (this.textRotateWithView_) rotation += this.viewRotation_;
                for(; offset < end; offset += stride){
                    var x = pixelCoordinates[offset] + this.textOffsetX_;
                    var y = pixelCoordinates[offset + 1] + this.textOffsetY_;
                    if (rotation !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1) {
                        context.save();
                        context.translate(x - this.textOffsetX_, y - this.textOffsetY_);
                        context.rotate(rotation);
                        context.translate(this.textOffsetX_, this.textOffsetY_);
                        context.scale(this.textScale_[0], this.textScale_[1]);
                        if (this.textStrokeState_) context.strokeText(this.text_, 0, 0);
                        if (this.textFillState_) context.fillText(this.text_, 0, 0);
                        context.restore();
                    } else {
                        if (this.textStrokeState_) context.strokeText(this.text_, x, y);
                        if (this.textFillState_) context.fillText(this.text_, x, y);
                    }
                }
            }
        },
        {
            /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @private
   * @return {number} end End.
   */ key: "moveToLineTo_",
            value: function moveToLineTo_(flatCoordinates, offset, end, stride, close) {
                var context = this.context_;
                var pixelCoordinates = (0, $c8fb0baeba325f5c$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
                context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
                var length = pixelCoordinates.length;
                if (close) length -= 2;
                for(var i = 2; i < length; i += 2)context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
                if (close) context.closePath();
                return end;
            }
        },
        {
            /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ key: "drawRings_",
            value: function drawRings_(flatCoordinates, offset, ends, stride) {
                for(var i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true);
                return offset;
            }
        },
        {
            /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @api
   */ key: "drawCircle",
            value: function drawCircle(geometry) {
                if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Circle.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
                if (!(0, $e86e0aa087890eb8$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
                if (this.fillState_ || this.strokeState_) {
                    if (this.fillState_) this.setContextFillState_(this.fillState_);
                    if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
                    var pixelCoordinates = (0, $b8a34d748252df7d$export$a3767472617c7861)(geometry, this.transform_, this.pixelCoordinates_);
                    var dx = pixelCoordinates[2] - pixelCoordinates[0];
                    var dy = pixelCoordinates[3] - pixelCoordinates[1];
                    var radius = Math.sqrt(dx * dx + dy * dy);
                    var context = this.context_;
                    context.beginPath();
                    context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
                    if (this.fillState_) context.fill();
                    if (this.strokeState_) context.stroke();
                }
                if (this.text_ !== "") this.drawText_(geometry.getCenter(), 0, 2, 2);
            }
        },
        {
            /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @api
   */ key: "setStyle",
            value: function setStyle(style) {
                this.setFillStrokeStyle(style.getFill(), style.getStroke());
                this.setImageStyle(style.getImage());
                this.setTextStyle(style.getText());
            }
        },
        {
            /**
   * @param {import("../../transform.js").Transform} transform Transform.
   */ key: "setTransform",
            value: function setTransform(transform) {
                this.transform_ = transform;
            }
        },
        {
            /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @api
   */ key: "drawGeometry",
            value: function drawGeometry(geometry) {
                var type = geometry.getType();
                switch(type){
                    case "Point":
                        this.drawPoint(/** @type {import("../../geom/Point.js").default} */ geometry);
                        break;
                    case "LineString":
                        this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ geometry);
                        break;
                    case "Polygon":
                        this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ geometry);
                        break;
                    case "MultiPoint":
                        this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ geometry);
                        break;
                    case "MultiLineString":
                        this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ geometry);
                        break;
                    case "MultiPolygon":
                        this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ geometry);
                        break;
                    case "GeometryCollection":
                        this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ geometry);
                        break;
                    case "Circle":
                        this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ geometry);
                        break;
                    default:
                }
            }
        },
        {
            /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @api
   */ key: "drawFeature",
            value: function drawFeature(feature, style) {
                var geometry = style.getGeometryFunction()(feature);
                if (!geometry) return;
                this.setStyle(style);
                this.drawGeometry(geometry);
            }
        },
        {
            /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   */ key: "drawGeometryCollection",
            value: function drawGeometryCollection(geometry) {
                var geometries = geometry.getGeometriesArray();
                for(var i = 0, ii = geometries.length; i < ii; ++i)this.drawGeometry(geometries[i]);
            }
        },
        {
            /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   */ key: "drawPoint",
            value: function drawPoint(geometry) {
                if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Point.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
                var flatCoordinates = geometry.getFlatCoordinates();
                var stride = geometry.getStride();
                if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
                if (this.text_ !== "") this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
            }
        },
        {
            /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   */ key: "drawMultiPoint",
            value: function drawMultiPoint(geometry) {
                if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
                var flatCoordinates = geometry.getFlatCoordinates();
                var stride = geometry.getStride();
                if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
                if (this.text_ !== "") this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
            }
        },
        {
            /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   */ key: "drawLineString",
            value: function drawLineString(geometry) {
                if (this.squaredTolerance_) geometry = /** @type {import("../../geom/LineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
                if (!(0, $e86e0aa087890eb8$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
                if (this.strokeState_) {
                    this.setContextStrokeState_(this.strokeState_);
                    var context = this.context_;
                    var flatCoordinates = geometry.getFlatCoordinates();
                    context.beginPath();
                    this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false);
                    context.stroke();
                }
                if (this.text_ !== "") {
                    var flatMidpoint = geometry.getFlatMidpoint();
                    this.drawText_(flatMidpoint, 0, 2, 2);
                }
            }
        },
        {
            /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   */ key: "drawMultiLineString",
            value: function drawMultiLineString(geometry) {
                if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
                var geometryExtent = geometry.getExtent();
                if (!(0, $e86e0aa087890eb8$export$7b0a31e10bbff018)(this.extent_, geometryExtent)) return;
                if (this.strokeState_) {
                    this.setContextStrokeState_(this.strokeState_);
                    var context = this.context_;
                    var flatCoordinates = geometry.getFlatCoordinates();
                    var offset = 0;
                    var ends = /** @type {Array<number>} */ geometry.getEnds();
                    var stride = geometry.getStride();
                    context.beginPath();
                    for(var i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false);
                    context.stroke();
                }
                if (this.text_ !== "") {
                    var flatMidpoints = geometry.getFlatMidpoints();
                    this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
                }
            }
        },
        {
            /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   */ key: "drawPolygon",
            value: function drawPolygon(geometry) {
                if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Polygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
                if (!(0, $e86e0aa087890eb8$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
                if (this.strokeState_ || this.fillState_) {
                    if (this.fillState_) this.setContextFillState_(this.fillState_);
                    if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
                    var context = this.context_;
                    context.beginPath();
                    this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, /** @type {Array<number>} */ geometry.getEnds(), geometry.getStride());
                    if (this.fillState_) context.fill();
                    if (this.strokeState_) context.stroke();
                }
                if (this.text_ !== "") {
                    var flatInteriorPoint = geometry.getFlatInteriorPoint();
                    this.drawText_(flatInteriorPoint, 0, 2, 2);
                }
            }
        },
        {
            /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   */ key: "drawMultiPolygon",
            value: function drawMultiPolygon(geometry) {
                if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
                if (!(0, $e86e0aa087890eb8$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
                if (this.strokeState_ || this.fillState_) {
                    if (this.fillState_) this.setContextFillState_(this.fillState_);
                    if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
                    var context = this.context_;
                    var flatCoordinates = geometry.getOrientedFlatCoordinates();
                    var offset = 0;
                    var endss = geometry.getEndss();
                    var stride = geometry.getStride();
                    context.beginPath();
                    for(var i = 0, ii = endss.length; i < ii; ++i){
                        var ends = endss[i];
                        offset = this.drawRings_(flatCoordinates, offset, ends, stride);
                    }
                    if (this.fillState_) context.fill();
                    if (this.strokeState_) context.stroke();
                }
                if (this.text_ !== "") {
                    var flatInteriorPoints = geometry.getFlatInteriorPoints();
                    this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
                }
            }
        },
        {
            /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */ key: "setContextFillState_",
            value: function setContextFillState_(fillState) {
                var context = this.context_;
                var contextFillState = this.contextFillState_;
                if (!contextFillState) {
                    context.fillStyle = fillState.fillStyle;
                    this.contextFillState_ = {
                        fillStyle: fillState.fillStyle
                    };
                } else if (contextFillState.fillStyle != fillState.fillStyle) {
                    contextFillState.fillStyle = fillState.fillStyle;
                    context.fillStyle = fillState.fillStyle;
                }
            }
        },
        {
            /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */ key: "setContextStrokeState_",
            value: function setContextStrokeState_(strokeState) {
                var context = this.context_;
                var contextStrokeState = this.contextStrokeState_;
                if (!contextStrokeState) {
                    context.lineCap = strokeState.lineCap;
                    context.setLineDash(strokeState.lineDash);
                    context.lineDashOffset = strokeState.lineDashOffset;
                    context.lineJoin = strokeState.lineJoin;
                    context.lineWidth = strokeState.lineWidth;
                    context.miterLimit = strokeState.miterLimit;
                    context.strokeStyle = strokeState.strokeStyle;
                    this.contextStrokeState_ = {
                        lineCap: strokeState.lineCap,
                        lineDash: strokeState.lineDash,
                        lineDashOffset: strokeState.lineDashOffset,
                        lineJoin: strokeState.lineJoin,
                        lineWidth: strokeState.lineWidth,
                        miterLimit: strokeState.miterLimit,
                        strokeStyle: strokeState.strokeStyle
                    };
                } else {
                    if (contextStrokeState.lineCap != strokeState.lineCap) {
                        contextStrokeState.lineCap = strokeState.lineCap;
                        context.lineCap = strokeState.lineCap;
                    }
                    if (!(0, $edee3659e50a93f4$export$e9bab7fafb253603)(contextStrokeState.lineDash, strokeState.lineDash)) context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
                    if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
                        contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
                        context.lineDashOffset = strokeState.lineDashOffset;
                    }
                    if (contextStrokeState.lineJoin != strokeState.lineJoin) {
                        contextStrokeState.lineJoin = strokeState.lineJoin;
                        context.lineJoin = strokeState.lineJoin;
                    }
                    if (contextStrokeState.lineWidth != strokeState.lineWidth) {
                        contextStrokeState.lineWidth = strokeState.lineWidth;
                        context.lineWidth = strokeState.lineWidth;
                    }
                    if (contextStrokeState.miterLimit != strokeState.miterLimit) {
                        contextStrokeState.miterLimit = strokeState.miterLimit;
                        context.miterLimit = strokeState.miterLimit;
                    }
                    if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
                        contextStrokeState.strokeStyle = strokeState.strokeStyle;
                        context.strokeStyle = strokeState.strokeStyle;
                    }
                }
            }
        },
        {
            /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */ key: "setContextTextState_",
            value: function setContextTextState_(textState) {
                var context = this.context_;
                var contextTextState = this.contextTextState_;
                var textAlign = textState.textAlign ? textState.textAlign : (0, $069ac9f2344fe90f$export$94d53b95641b5766);
                if (!contextTextState) {
                    context.font = textState.font;
                    context.textAlign = textAlign;
                    context.textBaseline = textState.textBaseline;
                    this.contextTextState_ = {
                        font: textState.font,
                        textAlign: textAlign,
                        textBaseline: textState.textBaseline
                    };
                } else {
                    if (contextTextState.font != textState.font) {
                        contextTextState.font = textState.font;
                        context.font = textState.font;
                    }
                    if (contextTextState.textAlign != textAlign) {
                        contextTextState.textAlign = textAlign;
                        context.textAlign = textAlign;
                    }
                    if (contextTextState.textBaseline != textState.textBaseline) {
                        contextTextState.textBaseline = textState.textBaseline;
                        context.textBaseline = textState.textBaseline;
                    }
                }
            }
        },
        {
            /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   */ key: "setFillStrokeStyle",
            value: function setFillStrokeStyle(fillStyle, strokeStyle) {
                var _this = this;
                if (!fillStyle) this.fillState_ = null;
                else {
                    var fillStyleColor = fillStyle.getColor();
                    this.fillState_ = {
                        fillStyle: (0, $11e0a43141029edf$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $069ac9f2344fe90f$export$c495d52ee3fd74b2))
                    };
                }
                if (!strokeStyle) this.strokeState_ = null;
                else {
                    var strokeStyleColor = strokeStyle.getColor();
                    var strokeStyleLineCap = strokeStyle.getLineCap();
                    var strokeStyleLineDash = strokeStyle.getLineDash();
                    var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
                    var strokeStyleLineJoin = strokeStyle.getLineJoin();
                    var strokeStyleWidth = strokeStyle.getWidth();
                    var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
                    var lineDash = strokeStyleLineDash ? strokeStyleLineDash : (0, $069ac9f2344fe90f$export$e21b4112fdc612fc);
                    this.strokeState_ = {
                        lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $069ac9f2344fe90f$export$17bd0c38d6ae694e),
                        lineDash: this.pixelRatio_ === 1 ? lineDash : lineDash.map(function(n) {
                            return n * _this.pixelRatio_;
                        }),
                        lineDashOffset: (strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $069ac9f2344fe90f$export$e06efc2409049f76)) * this.pixelRatio_,
                        lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $069ac9f2344fe90f$export$365eb9648cf19bd0),
                        lineWidth: (strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $069ac9f2344fe90f$export$79661f132c62010e)) * this.pixelRatio_,
                        miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $069ac9f2344fe90f$export$80c1c01844597b7b),
                        strokeStyle: (0, $11e0a43141029edf$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $069ac9f2344fe90f$export$1eb2eaecacf2031e))
                    };
                }
            }
        },
        {
            /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   */ key: "setImageStyle",
            value: function setImageStyle(imageStyle) {
                var imageSize;
                if (!imageStyle || !(imageSize = imageStyle.getSize())) {
                    this.image_ = null;
                    return;
                }
                var imagePixelRatio = imageStyle.getPixelRatio(this.pixelRatio_);
                var imageAnchor = imageStyle.getAnchor();
                var imageOrigin = imageStyle.getOrigin();
                this.image_ = imageStyle.getImage(this.pixelRatio_);
                this.imageAnchorX_ = imageAnchor[0] * imagePixelRatio;
                this.imageAnchorY_ = imageAnchor[1] * imagePixelRatio;
                this.imageHeight_ = imageSize[1] * imagePixelRatio;
                this.imageOpacity_ = imageStyle.getOpacity();
                this.imageOriginX_ = imageOrigin[0];
                this.imageOriginY_ = imageOrigin[1];
                this.imageRotateWithView_ = imageStyle.getRotateWithView();
                this.imageRotation_ = imageStyle.getRotation();
                var imageScale = imageStyle.getScaleArray();
                this.imageScale_ = [
                    imageScale[0] * this.pixelRatio_ / imagePixelRatio,
                    imageScale[1] * this.pixelRatio_ / imagePixelRatio
                ];
                this.imageWidth_ = imageSize[0] * imagePixelRatio;
            }
        },
        {
            /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   */ key: "setTextStyle",
            value: function setTextStyle(textStyle) {
                if (!textStyle) this.text_ = "";
                else {
                    var textFillStyle = textStyle.getFill();
                    if (!textFillStyle) this.textFillState_ = null;
                    else {
                        var textFillStyleColor = textFillStyle.getColor();
                        this.textFillState_ = {
                            fillStyle: (0, $11e0a43141029edf$export$dc5b1400ac3a10a8)(textFillStyleColor ? textFillStyleColor : (0, $069ac9f2344fe90f$export$c495d52ee3fd74b2))
                        };
                    }
                    var textStrokeStyle = textStyle.getStroke();
                    if (!textStrokeStyle) this.textStrokeState_ = null;
                    else {
                        var textStrokeStyleColor = textStrokeStyle.getColor();
                        var textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                        var textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                        var textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                        var textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                        var textStrokeStyleWidth = textStrokeStyle.getWidth();
                        var textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                        this.textStrokeState_ = {
                            lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : (0, $069ac9f2344fe90f$export$17bd0c38d6ae694e),
                            lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : (0, $069ac9f2344fe90f$export$e21b4112fdc612fc),
                            lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : (0, $069ac9f2344fe90f$export$e06efc2409049f76),
                            lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : (0, $069ac9f2344fe90f$export$365eb9648cf19bd0),
                            lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : (0, $069ac9f2344fe90f$export$79661f132c62010e),
                            miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : (0, $069ac9f2344fe90f$export$80c1c01844597b7b),
                            strokeStyle: (0, $11e0a43141029edf$export$dc5b1400ac3a10a8)(textStrokeStyleColor ? textStrokeStyleColor : (0, $069ac9f2344fe90f$export$1eb2eaecacf2031e))
                        };
                    }
                    var textFont = textStyle.getFont();
                    var textOffsetX = textStyle.getOffsetX();
                    var textOffsetY = textStyle.getOffsetY();
                    var textRotateWithView = textStyle.getRotateWithView();
                    var textRotation = textStyle.getRotation();
                    var textScale = textStyle.getScaleArray();
                    var textText = textStyle.getText();
                    var textTextAlign = textStyle.getTextAlign();
                    var textTextBaseline = textStyle.getTextBaseline();
                    this.textState_ = {
                        font: textFont !== undefined ? textFont : (0, $069ac9f2344fe90f$export$3847dfea4f8d4dfa),
                        textAlign: textTextAlign !== undefined ? textTextAlign : (0, $069ac9f2344fe90f$export$94d53b95641b5766),
                        textBaseline: textTextBaseline !== undefined ? textTextBaseline : (0, $069ac9f2344fe90f$export$cf2279a1bff62eb)
                    };
                    this.text_ = textText !== undefined ? Array.isArray(textText) ? textText.reduce(function(acc, t, i) {
                        return acc += i % 2 ? " " : t;
                    }, "") : textText : "";
                    this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
                    this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
                    this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
                    this.textRotation_ = textRotation !== undefined ? textRotation : 0;
                    this.textScale_ = [
                        this.pixelRatio_ * textScale[0],
                        this.pixelRatio_ * textScale[1]
                    ];
                }
            }
        }
    ]);
    return CanvasImmediateRenderer;
}((0, $7016ef4fa08f6c05$export$2e2bcd8739ae039));
var $aa03b5f22440bcfd$export$2e2bcd8739ae039 = $aa03b5f22440bcfd$var$CanvasImmediateRenderer;







var $d4c25cf65caa9f58$export$ab51038298418f25 = 0.5;
function $d4c25cf65caa9f58$export$bd05e394339d469(size, transforms, features, styleFunction, extent, resolution, rotation) {
    var width = size[0] * $d4c25cf65caa9f58$export$ab51038298418f25;
    var height = size[1] * $d4c25cf65caa9f58$export$ab51038298418f25;
    var context = (0, $e000035bb4c81589$export$9e05d10eae75c464)(width, height);
    context.imageSmoothingEnabled = false;
    var canvas = context.canvas;
    var renderer = new (0, $aa03b5f22440bcfd$export$2e2bcd8739ae039)(context, $d4c25cf65caa9f58$export$ab51038298418f25, extent, null, rotation);
    var featureCount = features.length;
    // Stretch hit detection index to use the whole available color range
    var indexFactor = Math.floor(16777215 / featureCount);
    var featuresByZIndex = {};
    for(var i = 1; i <= featureCount; ++i){
        var feature = features[i - 1];
        var featureStyleFunction = feature.getStyleFunction() || styleFunction;
        if (!featureStyleFunction) continue;
        var styles = featureStyleFunction(feature, resolution);
        if (!styles) continue;
        if (!Array.isArray(styles)) styles = [
            styles
        ];
        var index = i * indexFactor;
        var color = index.toString(16).padStart(7, "#00000");
        for(var j = 0, jj = styles.length; j < jj; ++j){
            var originalStyle = styles[j];
            var geometry = originalStyle.getGeometryFunction()(feature);
            if (!geometry || !(0, $e86e0aa087890eb8$export$7b0a31e10bbff018)(extent, geometry.getExtent())) continue;
            var style = originalStyle.clone();
            var fill = style.getFill();
            if (fill) fill.setColor(color);
            var stroke = style.getStroke();
            if (stroke) {
                stroke.setColor(color);
                stroke.setLineDash(null);
            }
            style.setText(undefined);
            var image = originalStyle.getImage();
            if (image) {
                var imgSize = image.getImageSize();
                if (!imgSize) continue;
                var imgContext = (0, $e000035bb4c81589$export$9e05d10eae75c464)(imgSize[0], imgSize[1], undefined, {
                    alpha: false
                });
                var img = imgContext.canvas;
                imgContext.fillStyle = color;
                imgContext.fillRect(0, 0, img.width, img.height);
                style.setImage(new (0, $f18dd4c8d6d98b55$export$2e2bcd8739ae039)({
                    img: img,
                    anchor: image.getAnchor(),
                    anchorXUnits: "pixels",
                    anchorYUnits: "pixels",
                    offset: image.getOrigin(),
                    opacity: 1,
                    size: image.getSize(),
                    scale: image.getScale(),
                    rotation: image.getRotation(),
                    rotateWithView: image.getRotateWithView()
                }));
            }
            var zIndex = style.getZIndex() || 0;
            var byGeometryType = featuresByZIndex[zIndex];
            if (!byGeometryType) {
                byGeometryType = {};
                featuresByZIndex[zIndex] = byGeometryType;
                byGeometryType["Polygon"] = [];
                byGeometryType["Circle"] = [];
                byGeometryType["LineString"] = [];
                byGeometryType["Point"] = [];
            }
            var type = geometry.getType();
            if (type === "GeometryCollection") {
                var geometries = /** @type {import("../../geom/GeometryCollection.js").default} */ geometry.getGeometriesArrayRecursive();
                for(var i1 = 0, ii = geometries.length; i1 < ii; ++i1){
                    var geometry1 = geometries[i1];
                    byGeometryType[geometry1.getType().replace("Multi", "")].push(geometry1, style);
                }
            } else byGeometryType[type.replace("Multi", "")].push(geometry, style);
        }
    }
    var zIndexKeys = Object.keys(featuresByZIndex).map(Number).sort((0, $edee3659e50a93f4$export$fcb633242ef15540));
    for(var i2 = 0, ii1 = zIndexKeys.length; i2 < ii1; ++i2){
        var byGeometryType1 = featuresByZIndex[zIndexKeys[i2]];
        for(var type1 in byGeometryType1){
            var geomAndStyle = byGeometryType1[type1];
            for(var j1 = 0, jj1 = geomAndStyle.length; j1 < jj1; j1 += 2){
                renderer.setStyle(geomAndStyle[j1 + 1]);
                for(var k = 0, kk = transforms.length; k < kk; ++k){
                    renderer.setTransform(transforms[k]);
                    renderer.drawGeometry(geomAndStyle[j1]);
                }
            }
        }
    }
    return context.getImageData(0, 0, canvas.width, canvas.height);
}
function $d4c25cf65caa9f58$export$6d4d555ddbfffa32(pixel, features, imageData) {
    /** @type {Array<F>} */ var resultFeatures = [];
    if (imageData) {
        var x = Math.floor(Math.round(pixel[0]) * $d4c25cf65caa9f58$export$ab51038298418f25);
        var y = Math.floor(Math.round(pixel[1]) * $d4c25cf65caa9f58$export$ab51038298418f25);
        // The pixel coordinate is clamped down to the hit-detect canvas' size to account
        // for browsers returning coordinates slightly larger than the actual canvas size
        // due to a non-integer pixel ratio.
        var index = ((0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(x, 0, imageData.width - 1) + (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(y, 0, imageData.height - 1) * imageData.width) * 4;
        var r = imageData.data[index];
        var g = imageData.data[index + 1];
        var b = imageData.data[index + 2];
        var i = b + 256 * (g + 256 * r);
        var indexFactor = Math.floor(16777215 / features.length);
        if (i && i % indexFactor === 0) resultFeatures.push(features[i / indexFactor - 1]);
    }
    return resultFeatures;
}





/**
 * @module ol/renderer/vector
 */ 

/**
 * Feature callback. The callback will be called with three arguments. The first
 * argument is one {@link module:ol/Feature~Feature feature} or {@link module:ol/render/Feature~RenderFeature render feature}
 * at the pixel, the second is the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
 * unmanaged layers. The third is the {@link module:ol/geom/SimpleGeometry~SimpleGeometry} of the feature. For features
 * with a GeometryCollection geometry, it will be the first detected geometry from the collection.
 * @template T
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default<import("../source/Source").default>, import("../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */ var $cbab4feb956a6ab2$var$SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/Geometry.js").Type,
 *                function(import("../render/canvas/BuilderGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object): void>}
 */ var $cbab4feb956a6ab2$var$GEOMETRY_RENDERERS = {
    "Point": $cbab4feb956a6ab2$var$renderPointGeometry,
    "LineString": $cbab4feb956a6ab2$var$renderLineStringGeometry,
    "Polygon": $cbab4feb956a6ab2$var$renderPolygonGeometry,
    "MultiPoint": $cbab4feb956a6ab2$var$renderMultiPointGeometry,
    "MultiLineString": $cbab4feb956a6ab2$var$renderMultiLineStringGeometry,
    "MultiPolygon": $cbab4feb956a6ab2$var$renderMultiPolygonGeometry,
    "GeometryCollection": $cbab4feb956a6ab2$var$renderGeometryCollectionGeometry,
    "Circle": $cbab4feb956a6ab2$var$renderCircleGeometry
};
function $cbab4feb956a6ab2$export$531ddd8416d52dfc(feature1, feature2) {
    return parseInt((0, $8b32fff2376556ef$export$5e82334337e0f204)(feature1), 10) - parseInt((0, $8b32fff2376556ef$export$5e82334337e0f204)(feature2), 10);
}
function $cbab4feb956a6ab2$export$75084a70d324c1e6(resolution, pixelRatio) {
    var tolerance = $cbab4feb956a6ab2$export$bdacc5b475012edb(resolution, pixelRatio);
    return tolerance * tolerance;
}
function $cbab4feb956a6ab2$export$bdacc5b475012edb(resolution, pixelRatio) {
    return $cbab4feb956a6ab2$var$SIMPLIFY_TOLERANCE * resolution / pixelRatio;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 */ function $cbab4feb956a6ab2$var$renderCircleGeometry(builderGroup, geometry, style, feature, declutterBuilderGroup) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        var circleReplay = builderGroup.getBuilder(style.getZIndex(), "Circle");
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
function $cbab4feb956a6ab2$export$36f470a33a42f413(replayGroup, feature, style, squaredTolerance, listener, transform, declutterBuilderGroup) {
    var loading = false;
    var imageStyle = style.getImage();
    if (imageStyle) {
        var imageState = imageStyle.getImageState();
        if (imageState == (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED || imageState == (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).ERROR) imageStyle.unlistenImageChange(listener);
        else {
            if (imageState == (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).IDLE) imageStyle.load();
            imageStyle.listenImageChange(listener);
            loading = true;
        }
    }
    $cbab4feb956a6ab2$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutterBuilderGroup);
    return loading;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 */ function $cbab4feb956a6ab2$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutterBuilderGroup) {
    var geometry = style.getGeometryFunction()(feature);
    if (!geometry) return;
    var simplifiedGeometry = geometry.simplifyTransformed(squaredTolerance, transform);
    var renderer = style.getRenderer();
    if (renderer) $cbab4feb956a6ab2$var$renderGeometry(replayGroup, simplifiedGeometry, style, feature);
    else {
        var geometryRenderer = $cbab4feb956a6ab2$var$GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature, declutterBuilderGroup);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 */ function $cbab4feb956a6ab2$var$renderGeometry(replayGroup, geometry, style, feature) {
    if (geometry.getType() == "GeometryCollection") {
        var geometries = /** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries();
        for(var i = 0, ii = geometries.length; i < ii; ++i)$cbab4feb956a6ab2$var$renderGeometry(replayGroup, geometries[i], style, feature);
        return;
    }
    var replay = replayGroup.getBuilder(style.getZIndex(), "Default");
    replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ geometry, feature, style.getRenderer(), style.getHitDetectionRenderer());
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 */ function $cbab4feb956a6ab2$var$renderGeometryCollectionGeometry(replayGroup, geometry, style, feature, declutterBuilderGroup) {
    var geometries = geometry.getGeometriesArray();
    var i, ii;
    for(i = 0, ii = geometries.length; i < ii; ++i){
        var geometryRenderer = $cbab4feb956a6ab2$var$GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature, declutterBuilderGroup);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 */ function $cbab4feb956a6ab2$var$renderLineStringGeometry(builderGroup, geometry, style, feature, declutterBuilderGroup) {
    var strokeStyle = style.getStroke();
    if (strokeStyle) {
        var lineStringReplay = builderGroup.getBuilder(style.getZIndex(), "LineString");
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 */ function $cbab4feb956a6ab2$var$renderMultiLineStringGeometry(builderGroup, geometry, style, feature, declutterBuilderGroup) {
    var strokeStyle = style.getStroke();
    if (strokeStyle) {
        var lineStringReplay = builderGroup.getBuilder(style.getZIndex(), "LineString");
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 */ function $cbab4feb956a6ab2$var$renderMultiPolygonGeometry(builderGroup, geometry, style, feature, declutterBuilderGroup) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        var polygonReplay = builderGroup.getBuilder(style.getZIndex(), "Polygon");
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 */ function $cbab4feb956a6ab2$var$renderPointGeometry(builderGroup, geometry, style, feature, declutterBuilderGroup) {
    var imageStyle = style.getImage();
    var textStyle = style.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ var declutterImageWithText;
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED) return;
        var imageBuilderGroup = builderGroup;
        if (declutterBuilderGroup) {
            var declutterMode = imageStyle.getDeclutterMode();
            if (declutterMode !== "none") {
                imageBuilderGroup = declutterBuilderGroup;
                if (declutterMode === "obstacle") {
                    // draw in non-declutter group:
                    var imageReplay = builderGroup.getBuilder(style.getZIndex(), "Image");
                    imageReplay.setImageStyle(imageStyle, declutterImageWithText);
                    imageReplay.drawPoint(geometry, feature);
                } else if (textStyle && textStyle.getText()) declutterImageWithText = {};
            }
        }
        var imageReplay1 = imageBuilderGroup.getBuilder(style.getZIndex(), "Image");
        imageReplay1.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay1.drawPoint(geometry, feature);
    }
    if (textStyle && textStyle.getText()) {
        var textBuilderGroup = builderGroup;
        if (declutterBuilderGroup) textBuilderGroup = declutterBuilderGroup;
        var textReplay = textBuilderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 */ function $cbab4feb956a6ab2$var$renderMultiPointGeometry(builderGroup, geometry, style, feature, declutterBuilderGroup) {
    var imageStyle = style.getImage();
    var textStyle = style.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ var declutterImageWithText;
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $6d1d6830cef5bca2$export$2e2bcd8739ae039).LOADED) return;
        var imageBuilderGroup = builderGroup;
        if (declutterBuilderGroup) {
            var declutterMode = imageStyle.getDeclutterMode();
            if (declutterMode !== "none") {
                imageBuilderGroup = declutterBuilderGroup;
                if (declutterMode === "obstacle") {
                    // draw in non-declutter group:
                    var imageReplay = builderGroup.getBuilder(style.getZIndex(), "Image");
                    imageReplay.setImageStyle(imageStyle, declutterImageWithText);
                    imageReplay.drawMultiPoint(geometry, feature);
                } else if (textStyle && textStyle.getText()) declutterImageWithText = {};
            }
        }
        var imageReplay1 = imageBuilderGroup.getBuilder(style.getZIndex(), "Image");
        imageReplay1.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay1.drawMultiPoint(geometry, feature);
    }
    if (textStyle && textStyle.getText()) {
        var textBuilderGroup = builderGroup;
        if (declutterBuilderGroup) textBuilderGroup = declutterBuilderGroup;
        var textReplay = textBuilderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 */ function $cbab4feb956a6ab2$var$renderPolygonGeometry(builderGroup, geometry, style, feature, declutterBuilderGroup) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        var polygonReplay = builderGroup.getBuilder(style.getZIndex(), "Polygon");
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}






/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */ var $af2ccaedb8329281$var$CanvasVectorLayerRenderer = /*#__PURE__*/ function(CanvasLayerRenderer) {
    "use strict";
    (0, $kcqLc._)(CanvasVectorLayerRenderer, CanvasLayerRenderer);
    var _super = (0, $4jYWU._)(CanvasVectorLayerRenderer);
    function CanvasVectorLayerRenderer(vectorLayer) {
        (0, $5sFFs._)(this, CanvasVectorLayerRenderer);
        var _this;
        _this = _super.call(this, vectorLayer);
        /** @private */ _this.boundHandleStyleImageChange_ = _this.handleStyleImageChange_.bind((0, $lyFcw._)(_this));
        /**
     * @type {boolean}
     */ _this.animatingOrInteracting_;
        /**
     * @type {ImageData|null}
     */ _this.hitDetectionImageData_ = null;
        /**
     * @type {Array<import("../../Feature.js").default>}
     */ _this.renderedFeatures_ = null;
        /**
     * @private
     * @type {number}
     */ _this.renderedRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ _this.renderedResolution_ = NaN;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ _this.renderedExtent_ = (0, $e86e0aa087890eb8$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ _this.wrappedRenderedExtent_ = (0, $e86e0aa087890eb8$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ _this.renderedRotation_;
        /**
     * @private
     * @type {import("../../coordinate").Coordinate}
     */ _this.renderedCenter_ = null;
        /**
     * @private
     * @type {import("../../proj/Projection").default}
     */ _this.renderedProjection_ = null;
        /**
     * @private
     * @type {function(import("../../Feature.js").default, import("../../Feature.js").default): number|null}
     */ _this.renderedRenderOrder_ = null;
        /**
     * @private
     * @type {import("../../render/canvas/ExecutorGroup").default}
     */ _this.replayGroup_ = null;
        /**
     * A new replay group had to be created by `prepareFrame()`
     * @type {boolean}
     */ _this.replayGroupChanged = true;
        /**
     * @type {import("../../render/canvas/ExecutorGroup").default}
     */ _this.declutterExecutorGroup = null;
        /**
     * Clipping to be performed by `renderFrame()`
     * @type {boolean}
     */ _this.clipping = true;
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ _this.compositionContext_ = null;
        /**
     * @private
     * @type {number}
     */ _this.opacity_ = 1;
        return _this;
    }
    (0, $8O2fV._)(CanvasVectorLayerRenderer, [
        {
            /**
   * @param {ExecutorGroup} executorGroup Executor group.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("rbush").default} [declutterTree] Declutter tree.
   */ key: "renderWorlds",
            value: function renderWorlds(executorGroup, frameState, declutterTree) {
                var extent = frameState.extent;
                var viewState = frameState.viewState;
                var center = viewState.center;
                var resolution = viewState.resolution;
                var projection = viewState.projection;
                var rotation = viewState.rotation;
                var projectionExtent = projection.getExtent();
                var vectorSource = this.getLayer().getSource();
                var pixelRatio = frameState.pixelRatio;
                var viewHints = frameState.viewHints;
                var snapToPixel = !(viewHints[(0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).INTERACTING]);
                var context = this.compositionContext_;
                var width = Math.round(frameState.size[0] * pixelRatio);
                var height = Math.round(frameState.size[1] * pixelRatio);
                var multiWorld = vectorSource.getWrapX() && projection.canWrapX();
                var worldWidth = multiWorld ? (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(projectionExtent) : null;
                var endWorld = multiWorld ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + 1 : 1;
                var world = multiWorld ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth) : 0;
                do {
                    var transform = this.getRenderTransform(center, resolution, rotation, pixelRatio, width, height, world * worldWidth);
                    executorGroup.execute(context, 1, transform, rotation, snapToPixel, undefined, declutterTree);
                }while (++world < endWorld);
            }
        },
        {
            key: "setupCompositionContext_",
            value: function setupCompositionContext_() {
                if (this.opacity_ !== 1) {
                    var compositionContext = (0, $e000035bb4c81589$export$9e05d10eae75c464)(this.context.canvas.width, this.context.canvas.height, (0, $633e710cc85fca5f$export$a166f0857c555517));
                    this.compositionContext_ = compositionContext;
                } else this.compositionContext_ = this.context;
            }
        },
        {
            key: "releaseCompositionContext_",
            value: function releaseCompositionContext_() {
                if (this.opacity_ !== 1) {
                    var alpha = this.context.globalAlpha;
                    this.context.globalAlpha = this.opacity_;
                    this.context.drawImage(this.compositionContext_.canvas, 0, 0);
                    this.context.globalAlpha = alpha;
                    (0, $e000035bb4c81589$export$e918ac6a1026a12a)(this.compositionContext_);
                    (0, $633e710cc85fca5f$export$a166f0857c555517).push(this.compositionContext_.canvas);
                    this.compositionContext_ = null;
                }
            }
        },
        {
            /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ key: "renderDeclutter",
            value: function renderDeclutter(frameState) {
                if (this.declutterExecutorGroup) {
                    this.setupCompositionContext_();
                    this.renderWorlds(this.declutterExecutorGroup, frameState, frameState.declutterTree);
                    this.releaseCompositionContext_();
                }
            }
        },
        {
            /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement|null} The rendered element.
   */ key: "renderFrame",
            value: function renderFrame(frameState, target) {
                var pixelRatio = frameState.pixelRatio;
                var layerState = frameState.layerStatesArray[frameState.layerIndex];
                // set forward and inverse pixel transforms
                (0, $afa6393b3817702c$export$3e4e33ea14aeb531)(this.pixelTransform, 1 / pixelRatio, 1 / pixelRatio);
                (0, $afa6393b3817702c$export$bd70ea2a93c0fa4)(this.inversePixelTransform, this.pixelTransform);
                var canvasTransform = (0, $afa6393b3817702c$export$f84e8e69fd4488a5)(this.pixelTransform);
                this.useContainer(target, canvasTransform, this.getBackground(frameState));
                var context = this.context;
                var canvas = context.canvas;
                var replayGroup = this.replayGroup_;
                var declutterExecutorGroup = this.declutterExecutorGroup;
                var render = replayGroup && !replayGroup.isEmpty() || declutterExecutorGroup && !declutterExecutorGroup.isEmpty();
                if (!render) {
                    var hasRenderListeners = this.getLayer().hasListener((0, $b1aa6e3366c76eef$export$2e2bcd8739ae039).PRERENDER) || this.getLayer().hasListener((0, $b1aa6e3366c76eef$export$2e2bcd8739ae039).POSTRENDER);
                    if (!hasRenderListeners) return null;
                }
                // resize and clear
                var width = Math.round(frameState.size[0] * pixelRatio);
                var height = Math.round(frameState.size[1] * pixelRatio);
                if (canvas.width != width || canvas.height != height) {
                    canvas.width = width;
                    canvas.height = height;
                    if (canvas.style.transform !== canvasTransform) canvas.style.transform = canvasTransform;
                } else if (!this.containerReused) context.clearRect(0, 0, width, height);
                this.preRender(context, frameState);
                var viewState = frameState.viewState;
                var projection = viewState.projection;
                this.opacity_ = layerState.opacity;
                this.setupCompositionContext_();
                // clipped rendering if layer extent is set
                var clipped = false;
                if (render && layerState.extent && this.clipping) {
                    var layerExtent = (0, $401a58d9dec354c1$export$494be3a3a25689ca)(layerState.extent, projection);
                    render = (0, $e86e0aa087890eb8$export$7b0a31e10bbff018)(layerExtent, frameState.extent);
                    clipped = render && !(0, $e86e0aa087890eb8$export$be866b1e0809b17e)(layerExtent, frameState.extent);
                    if (clipped) this.clipUnrotated(this.compositionContext_, frameState, layerExtent);
                }
                if (render) this.renderWorlds(replayGroup, frameState);
                if (clipped) this.compositionContext_.restore();
                this.releaseCompositionContext_();
                this.postRender(context, frameState);
                if (this.renderedRotation_ !== viewState.rotation) {
                    this.renderedRotation_ = viewState.rotation;
                    this.hitDetectionImageData_ = null;
                }
                return this.container;
            }
        },
        {
            /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature").default>>} Promise
   * that resolves with an array of features.
   */ key: "getFeatures",
            value: function getFeatures(pixel) {
                var _this = this;
                return new Promise(function(resolve) {
                    if (!_this.hitDetectionImageData_ && !_this.animatingOrInteracting_) {
                        var size = [
                            _this.context.canvas.width,
                            _this.context.canvas.height
                        ];
                        (0, $afa6393b3817702c$export$5635d7ef4b8fee1c)(_this.pixelTransform, size);
                        var center = _this.renderedCenter_;
                        var resolution = _this.renderedResolution_;
                        var rotation = _this.renderedRotation_;
                        var projection = _this.renderedProjection_;
                        var extent = _this.wrappedRenderedExtent_;
                        var layer = _this.getLayer();
                        var transforms = [];
                        var width = size[0] * (0, $d4c25cf65caa9f58$export$ab51038298418f25);
                        var height = size[1] * (0, $d4c25cf65caa9f58$export$ab51038298418f25);
                        transforms.push(_this.getRenderTransform(center, resolution, rotation, (0, $d4c25cf65caa9f58$export$ab51038298418f25), width, height, 0).slice());
                        var source = layer.getSource();
                        var projectionExtent = projection.getExtent();
                        if (source.getWrapX() && projection.canWrapX() && !(0, $e86e0aa087890eb8$export$be866b1e0809b17e)(projectionExtent, extent)) {
                            var startX = extent[0];
                            var worldWidth = (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(projectionExtent);
                            var world = 0;
                            var offsetX;
                            while(startX < projectionExtent[0]){
                                --world;
                                offsetX = worldWidth * world;
                                transforms.push(_this.getRenderTransform(center, resolution, rotation, (0, $d4c25cf65caa9f58$export$ab51038298418f25), width, height, offsetX).slice());
                                startX += worldWidth;
                            }
                            world = 0;
                            startX = extent[2];
                            while(startX > projectionExtent[2]){
                                ++world;
                                offsetX = worldWidth * world;
                                transforms.push(_this.getRenderTransform(center, resolution, rotation, (0, $d4c25cf65caa9f58$export$ab51038298418f25), width, height, offsetX).slice());
                                startX -= worldWidth;
                            }
                        }
                        _this.hitDetectionImageData_ = (0, $d4c25cf65caa9f58$export$bd05e394339d469)(size, transforms, _this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation);
                    }
                    resolve((0, $d4c25cf65caa9f58$export$6d4d555ddbfffa32)(pixel, _this.renderedFeatures_, _this.hitDetectionImageData_));
                });
            }
        },
        {
            /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */ key: "forEachFeatureAtCoordinate",
            value: function forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
                var _this = this;
                if (!this.replayGroup_) return undefined;
                var resolution = frameState.viewState.resolution;
                var rotation = frameState.viewState.rotation;
                var layer = this.getLayer();
                /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ var features = {};
                /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} distanceSq The squared distance to the click position
     * @return {T|undefined} Callback result.
     */ var featureCallback = function featureCallback(feature, geometry, distanceSq) {
                    var key = (0, $8b32fff2376556ef$export$5e82334337e0f204)(feature);
                    var match = features[key];
                    if (!match) {
                        if (distanceSq === 0) {
                            features[key] = true;
                            return callback(feature, layer, geometry);
                        }
                        matches.push(features[key] = {
                            feature: feature,
                            layer: layer,
                            geometry: geometry,
                            distanceSq: distanceSq,
                            callback: callback
                        });
                    } else if (match !== true && distanceSq < match.distanceSq) {
                        if (distanceSq === 0) {
                            features[key] = true;
                            matches.splice(matches.lastIndexOf(match), 1);
                            return callback(feature, layer, geometry);
                        }
                        match.geometry = geometry;
                        match.distanceSq = distanceSq;
                    }
                    return undefined;
                };
                var result;
                var executorGroups = [
                    this.replayGroup_
                ];
                if (this.declutterExecutorGroup) executorGroups.push(this.declutterExecutorGroup);
                executorGroups.some(function(executorGroup) {
                    return result = executorGroup.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, executorGroup === _this.declutterExecutorGroup && frameState.declutterTree ? frameState.declutterTree.all().map(function(item) {
                        return item.value;
                    }) : null);
                });
                return result;
            }
        },
        {
            /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   */ key: "handleFontsChanged",
            value: function handleFontsChanged() {
                var layer = this.getLayer();
                if (layer.getVisible() && this.replayGroup_) layer.changed();
            }
        },
        {
            /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ key: "handleStyleImageChange_",
            value: function handleStyleImageChange_(event) {
                this.renderIfReadyAndVisible();
            }
        },
        {
            /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ key: "prepareFrame",
            value: function prepareFrame(frameState) {
                var _this = this;
                var vectorLayer = this.getLayer();
                var vectorSource = vectorLayer.getSource();
                if (!vectorSource) return false;
                var animating = frameState.viewHints[(0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).ANIMATING];
                var interacting = frameState.viewHints[(0, $2901f2d22a6aa5fb$export$2e2bcd8739ae039).INTERACTING];
                var updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
                var updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
                if (this.ready && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) {
                    this.animatingOrInteracting_ = true;
                    return true;
                }
                this.animatingOrInteracting_ = false;
                var frameStateExtent = frameState.extent;
                var viewState = frameState.viewState;
                var projection = viewState.projection;
                var resolution = viewState.resolution;
                var pixelRatio = frameState.pixelRatio;
                var vectorLayerRevision = vectorLayer.getRevision();
                var vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
                var vectorLayerRenderOrder = vectorLayer.getRenderOrder();
                if (vectorLayerRenderOrder === undefined) vectorLayerRenderOrder = (0, $cbab4feb956a6ab2$export$531ddd8416d52dfc);
                var center = viewState.center.slice();
                var extent = (0, $e86e0aa087890eb8$export$ab1029bcae9ddb4a)(frameStateExtent, vectorLayerRenderBuffer * resolution);
                var renderedExtent = extent.slice();
                var loadExtents = [
                    extent.slice()
                ];
                var projectionExtent = projection.getExtent();
                if (vectorSource.getWrapX() && projection.canWrapX() && !(0, $e86e0aa087890eb8$export$be866b1e0809b17e)(projectionExtent, frameState.extent)) {
                    // For the replay group, we need an extent that intersects the real world
                    // (-180° to +180°). To support geometries in a coordinate range from -540°
                    // to +540°, we add at least 1 world width on each side of the projection
                    // extent. If the viewport is wider than the world, we need to add half of
                    // the viewport width to make sure we cover the whole viewport.
                    var worldWidth = (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(projectionExtent);
                    var gutter = Math.max((0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(extent) / 2, worldWidth);
                    extent[0] = projectionExtent[0] - gutter;
                    extent[2] = projectionExtent[2] + gutter;
                    (0, $96b4c00c3a1729e3$export$39a9ce3624977b84)(center, projection);
                    var loadExtent = (0, $e86e0aa087890eb8$export$39a9ce3624977b84)(loadExtents[0], projection);
                    // If the extent crosses the date line, we load data for both edges of the worlds
                    if (loadExtent[0] < projectionExtent[0] && loadExtent[2] < projectionExtent[2]) loadExtents.push([
                        loadExtent[0] + worldWidth,
                        loadExtent[1],
                        loadExtent[2] + worldWidth,
                        loadExtent[3]
                    ]);
                    else if (loadExtent[0] > projectionExtent[0] && loadExtent[2] > projectionExtent[2]) loadExtents.push([
                        loadExtent[0] - worldWidth,
                        loadExtent[1],
                        loadExtent[2] - worldWidth,
                        loadExtent[3]
                    ]);
                }
                if (this.ready && this.renderedResolution_ == resolution && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && (0, $e86e0aa087890eb8$export$be866b1e0809b17e)(this.wrappedRenderedExtent_, extent)) {
                    if (!(0, $edee3659e50a93f4$export$e9bab7fafb253603)(this.renderedExtent_, renderedExtent)) {
                        this.hitDetectionImageData_ = null;
                        this.renderedExtent_ = renderedExtent;
                    }
                    this.renderedCenter_ = center;
                    this.replayGroupChanged = false;
                    return true;
                }
                this.replayGroup_ = null;
                var replayGroup = new (0, $b6b7cfac83330430$export$2e2bcd8739ae039)((0, $cbab4feb956a6ab2$export$bdacc5b475012edb)(resolution, pixelRatio), extent, resolution, pixelRatio);
                var declutterBuilderGroup;
                if (this.getLayer().getDeclutter()) declutterBuilderGroup = new (0, $b6b7cfac83330430$export$2e2bcd8739ae039)((0, $cbab4feb956a6ab2$export$bdacc5b475012edb)(resolution, pixelRatio), extent, resolution, pixelRatio);
                var userProjection = (0, $401a58d9dec354c1$export$3973b77d5f6f2790)();
                var userTransform;
                if (userProjection) {
                    for(var i = 0, ii = loadExtents.length; i < ii; ++i){
                        var extent1 = loadExtents[i];
                        var userExtent = (0, $401a58d9dec354c1$export$96bfd09e2cffb006)(extent1, projection);
                        vectorSource.loadFeatures(userExtent, (0, $401a58d9dec354c1$export$b56bb8ad8b3a00e9)(resolution, projection), userProjection);
                    }
                    userTransform = (0, $401a58d9dec354c1$export$e3c4995a701c26a3)(userProjection, projection);
                } else for(var i1 = 0, ii1 = loadExtents.length; i1 < ii1; ++i1)vectorSource.loadFeatures(loadExtents[i1], resolution, projection);
                var squaredTolerance = (0, $cbab4feb956a6ab2$export$75084a70d324c1e6)(resolution, pixelRatio);
                var ready = true;
                var render = /**
       * @param {import("../../Feature.js").default} feature Feature.
       */ function(feature) {
                    var styles;
                    var styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
                    if (styleFunction) styles = styleFunction(feature, resolution);
                    if (styles) {
                        var dirty = _this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, declutterBuilderGroup);
                        ready = ready && !dirty;
                    }
                };
                var userExtent1 = (0, $401a58d9dec354c1$export$96bfd09e2cffb006)(extent, projection);
                /** @type {Array<import("../../Feature.js").default>} */ var features = vectorSource.getFeaturesInExtent(userExtent1);
                if (vectorLayerRenderOrder) features.sort(vectorLayerRenderOrder);
                for(var i2 = 0, ii2 = features.length; i2 < ii2; ++i2)render(features[i2]);
                this.renderedFeatures_ = features;
                this.ready = ready;
                var replayGroupInstructions = replayGroup.finish();
                var executorGroup = new (0, $1533a5c576f9dff1$export$2e2bcd8739ae039)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer());
                if (declutterBuilderGroup) this.declutterExecutorGroup = new (0, $1533a5c576f9dff1$export$2e2bcd8739ae039)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), declutterBuilderGroup.finish(), vectorLayer.getRenderBuffer());
                this.renderedResolution_ = resolution;
                this.renderedRevision_ = vectorLayerRevision;
                this.renderedRenderOrder_ = vectorLayerRenderOrder;
                this.renderedExtent_ = renderedExtent;
                this.wrappedRenderedExtent_ = extent;
                this.renderedCenter_ = center;
                this.renderedProjection_ = projection;
                this.replayGroup_ = executorGroup;
                this.hitDetectionImageData_ = null;
                this.replayGroupChanged = true;
                return true;
            }
        },
        {
            /**
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} squaredTolerance Squared render tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
   * @param {import("../../proj.js").TransformFunction} [transform] Transform from user to view projection.
   * @param {import("../../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
   * @return {boolean} `true` if an image is loading.
   */ key: "renderFeature",
            value: function renderFeature1(feature, squaredTolerance, styles, builderGroup, transform, declutterBuilderGroup) {
                if (!styles) return false;
                var loading = false;
                if (Array.isArray(styles)) for(var i = 0, ii = styles.length; i < ii; ++i)loading = (0, $cbab4feb956a6ab2$export$36f470a33a42f413)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, transform, declutterBuilderGroup) || loading;
                else loading = (0, $cbab4feb956a6ab2$export$36f470a33a42f413)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, transform, declutterBuilderGroup);
                return loading;
            }
        }
    ]);
    return CanvasVectorLayerRenderer;
}((0, $633e710cc85fca5f$export$2e2bcd8739ae039));
var $af2ccaedb8329281$export$2e2bcd8739ae039 = $af2ccaedb8329281$var$CanvasVectorLayerRenderer;


/**
 * @classdesc
 * Vector data is rendered client-side, as vectors. This layer type provides most accurate rendering
 * even during animations. Points and labels stay upright on rotated views. For very large
 * amounts of vector data, performance may suffer during pan and zoom animations. In this case,
 * try {@link module:ol/layer/VectorImage~VectorImageLayer}.
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default} VectorSourceType
 * @extends {BaseVectorLayer<VectorSourceType, CanvasVectorLayerRenderer>}
 * @api
 */ var $938dc8312d6df4d4$var$VectorLayer = /*#__PURE__*/ function(BaseVectorLayer) {
    "use strict";
    (0, $kcqLc._)(VectorLayer, BaseVectorLayer);
    var _super = (0, $4jYWU._)(VectorLayer);
    function VectorLayer(options) {
        (0, $5sFFs._)(this, VectorLayer);
        return _super.call(this, options);
    }
    (0, $8O2fV._)(VectorLayer, [
        {
            key: "createRenderer",
            value: function createRenderer() {
                return new (0, $af2ccaedb8329281$export$2e2bcd8739ae039)(this);
            }
        }
    ]);
    return VectorLayer;
}((0, $d254c52629992442$export$2e2bcd8739ae039));
var $938dc8312d6df4d4$export$2e2bcd8739ae039 = $938dc8312d6df4d4$var$VectorLayer;


/**
 * @module ol/source/BingMaps
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/source/TileImage
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");



/**
 * @module ol/TileCache
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/structs/LRUCache
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

/**
 * @typedef {Object} Entry
 * @property {string} key_ Key.
 * @property {Entry|null} newer Newer.
 * @property {Entry|null} older Older.
 * @property {*} value_ Value.
 */ /**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").default
 * @template T
 */ var $a97c6b69e8b0f346$var$LRUCache = /*#__PURE__*/ function() {
    "use strict";
    function LRUCache(highWaterMark) {
        (0, $5sFFs._)(this, LRUCache);
        /**
     * Desired max cache size after expireCache(). If set to 0, no cache entries
     * will be pruned at all.
     * @type {number}
     */ this.highWaterMark = highWaterMark !== undefined ? highWaterMark : 2048;
        /**
     * @private
     * @type {number}
     */ this.count_ = 0;
        /**
     * @private
     * @type {!Object<string, Entry>}
     */ this.entries_ = {};
        /**
     * @private
     * @type {?Entry}
     */ this.oldest_ = null;
        /**
     * @private
     * @type {?Entry}
     */ this.newest_ = null;
    }
    (0, $8O2fV._)(LRUCache, [
        {
            /**
   * @return {boolean} Can expire cache.
   */ key: "canExpireCache",
            value: function canExpireCache() {
                return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
            }
        },
        {
            /**
   * Expire the cache.
   * @param {!Object<string, boolean>} [keep] Keys to keep. To be implemented by subclasses.
   */ key: "expireCache",
            value: function expireCache(keep) {
                while(this.canExpireCache())this.pop();
            }
        },
        {
            /**
   * FIXME empty description for jsdoc
   */ key: "clear",
            value: function clear() {
                this.count_ = 0;
                this.entries_ = {};
                this.oldest_ = null;
                this.newest_ = null;
            }
        },
        {
            /**
   * @param {string} key Key.
   * @return {boolean} Contains key.
   */ key: "containsKey",
            value: function containsKey(key) {
                return this.entries_.hasOwnProperty(key);
            }
        },
        {
            /**
   * @param {function(T, string, LRUCache<T>): ?} f The function
   *     to call for every entry from the oldest to the newer. This function takes
   *     3 arguments (the entry value, the entry key and the LRUCache object).
   *     The return value is ignored.
   */ key: "forEach",
            value: function forEach(f) {
                var entry = this.oldest_;
                while(entry){
                    f(entry.value_, entry.key_, this);
                    entry = entry.newer;
                }
            }
        },
        {
            /**
   * @param {string} key Key.
   * @param {*} [options] Options (reserved for subclasses).
   * @return {T} Value.
   */ key: "get",
            value: function get(key, options) {
                var entry = this.entries_[key];
                (0, $100b4414e338a711$export$a7a9523472993e97)(entry !== undefined, "Tried to get a value for a key that does not exist in the cache");
                if (entry === this.newest_) return entry.value_;
                if (entry === this.oldest_) {
                    this.oldest_ = /** @type {Entry} */ this.oldest_.newer;
                    this.oldest_.older = null;
                } else {
                    entry.newer.older = entry.older;
                    entry.older.newer = entry.newer;
                }
                entry.newer = null;
                entry.older = this.newest_;
                this.newest_.newer = entry;
                this.newest_ = entry;
                return entry.value_;
            }
        },
        {
            /**
   * Remove an entry from the cache.
   * @param {string} key The entry key.
   * @return {T} The removed entry.
   */ key: "remove",
            value: function remove(key) {
                var entry = this.entries_[key];
                (0, $100b4414e338a711$export$a7a9523472993e97)(entry !== undefined, "Tried to get a value for a key that does not exist in the cache");
                if (entry === this.newest_) {
                    this.newest_ = /** @type {Entry} */ entry.older;
                    if (this.newest_) this.newest_.newer = null;
                } else if (entry === this.oldest_) {
                    this.oldest_ = /** @type {Entry} */ entry.newer;
                    if (this.oldest_) this.oldest_.older = null;
                } else {
                    entry.newer.older = entry.older;
                    entry.older.newer = entry.newer;
                }
                delete this.entries_[key];
                --this.count_;
                return entry.value_;
            }
        },
        {
            /**
   * @return {number} Count.
   */ key: "getCount",
            value: function getCount() {
                return this.count_;
            }
        },
        {
            /**
   * @return {Array<string>} Keys.
   */ key: "getKeys",
            value: function getKeys() {
                var keys = new Array(this.count_);
                var i = 0;
                var entry;
                for(entry = this.newest_; entry; entry = entry.older)keys[i++] = entry.key_;
                return keys;
            }
        },
        {
            /**
   * @return {Array<T>} Values.
   */ key: "getValues",
            value: function getValues() {
                var values = new Array(this.count_);
                var i = 0;
                var entry;
                for(entry = this.newest_; entry; entry = entry.older)values[i++] = entry.value_;
                return values;
            }
        },
        {
            /**
   * @return {T} Last value.
   */ key: "peekLast",
            value: function peekLast() {
                return this.oldest_.value_;
            }
        },
        {
            /**
   * @return {string} Last key.
   */ key: "peekLastKey",
            value: function peekLastKey() {
                return this.oldest_.key_;
            }
        },
        {
            /**
   * Get the key of the newest item in the cache.  Throws if the cache is empty.
   * @return {string} The newest key.
   */ key: "peekFirstKey",
            value: function peekFirstKey() {
                return this.newest_.key_;
            }
        },
        {
            /**
   * Return an entry without updating least recently used time.
   * @param {string} key Key.
   * @return {T|undefined} Value.
   */ key: "peek",
            value: function peek(key) {
                var _this_entries__key;
                return (_this_entries__key = this.entries_[key]) === null || _this_entries__key === void 0 ? void 0 : _this_entries__key.value_;
            }
        },
        {
            /**
   * @return {T} value Value.
   */ key: "pop",
            value: function pop() {
                var entry = this.oldest_;
                delete this.entries_[entry.key_];
                if (entry.newer) entry.newer.older = null;
                this.oldest_ = /** @type {Entry} */ entry.newer;
                if (!this.oldest_) this.newest_ = null;
                --this.count_;
                return entry.value_;
            }
        },
        {
            /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ key: "replace",
            value: function replace(key, value) {
                this.get(key); // update `newest_`
                this.entries_[key].value_ = value;
            }
        },
        {
            /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ key: "set",
            value: function set(key, value) {
                (0, $100b4414e338a711$export$a7a9523472993e97)(!(key in this.entries_), "Tried to set a value for a key that is used already");
                var entry = {
                    key_: key,
                    newer: null,
                    older: this.newest_,
                    value_: value
                };
                if (!this.newest_) this.oldest_ = entry;
                else this.newest_.newer = entry;
                this.newest_ = entry;
                this.entries_[key] = entry;
                ++this.count_;
            }
        },
        {
            /**
   * Set a maximum number of entries for the cache.
   * @param {number} size Cache size.
   * @api
   */ key: "setSize",
            value: function setSize(size) {
                this.highWaterMark = size;
            }
        }
    ]);
    return LRUCache;
}();
var $a97c6b69e8b0f346$export$2e2bcd8739ae039 = $a97c6b69e8b0f346$var$LRUCache;


/**
 * @module ol/tilecoord
 */ /**
 * An array of three numbers representing the location of a tile in a tile
 * grid. The order is `z` (zoom level), `x` (column), and `y` (row).
 * @typedef {Array<number>} TileCoord
 * @api
 */ /**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {TileCoord} [tileCoord] Tile coordinate.
 * @return {TileCoord} Tile coordinate.
 */ 
var $52tJv = parcelRequire("52tJv");
function $da91b970cd82859b$export$958e3e1a02eac4b6(z, x, y, tileCoord) {
    if (tileCoord !== undefined) {
        tileCoord[0] = z;
        tileCoord[1] = x;
        tileCoord[2] = y;
        return tileCoord;
    }
    return [
        z,
        x,
        y
    ];
}
function $da91b970cd82859b$export$92d0df0f1d25c63c(z, x, y) {
    return z + "/" + x + "/" + y;
}
function $da91b970cd82859b$export$a47fb462a08de82f(tileCoord) {
    return $da91b970cd82859b$export$92d0df0f1d25c63c(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $da91b970cd82859b$export$7f760414a8e3d2b5(tileKey) {
    var _tileKey_substring_split_map = (0, $52tJv._)(tileKey.substring(tileKey.lastIndexOf("/") + 1, tileKey.length).split(",").map(Number), 3), z = _tileKey_substring_split_map[0], x = _tileKey_substring_split_map[1], y = _tileKey_substring_split_map[2];
    return $da91b970cd82859b$export$92d0df0f1d25c63c(z, x, y);
}
function $da91b970cd82859b$export$a807b7874eb66454(key) {
    return key.split("/").map(Number);
}
function $da91b970cd82859b$export$d6af199866bfb566(tileCoord) {
    return (tileCoord[1] << tileCoord[0]) + tileCoord[2];
}
function $da91b970cd82859b$export$60bedf8e3e3c3dbe(tileCoord, tileGrid) {
    var z = tileCoord[0];
    var x = tileCoord[1];
    var y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) return false;
    var tileRange = tileGrid.getFullTileRange(z);
    if (!tileRange) return true;
    return tileRange.containsXY(x, y);
}


var $56867742ea2cf9ab$var$TileCache = /*#__PURE__*/ function(LRUCache) {
    "use strict";
    (0, $kcqLc._)(TileCache, LRUCache);
    var _super = (0, $4jYWU._)(TileCache);
    function TileCache() {
        (0, $5sFFs._)(this, TileCache);
        return _super.apply(this, arguments);
    }
    (0, $8O2fV._)(TileCache, [
        {
            key: "clear",
            value: function clear() {
                while(this.getCount() > 0)this.pop().release();
                (0, $404BM._)((0, $cEF31._)(TileCache.prototype), "clear", this).call(this);
            }
        },
        {
            /**
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */ key: "expireCache",
            value: function expireCache(usedTiles) {
                while(this.canExpireCache()){
                    var tile = this.peekLast();
                    if (tile.getKey() in usedTiles) break;
                    else this.pop().release();
                }
            }
        },
        {
            /**
   * Prune all tiles from the cache that don't have the same z as the newest tile.
   */ key: "pruneExceptNewestZ",
            value: function pruneExceptNewestZ() {
                var _this = this;
                if (this.getCount() === 0) return;
                var key = this.peekFirstKey();
                var tileCoord = (0, $da91b970cd82859b$export$a807b7874eb66454)(key);
                var z = tileCoord[0];
                this.forEach(function(tile) {
                    if (tile.tileCoord[0] !== z) {
                        _this.remove((0, $da91b970cd82859b$export$a47fb462a08de82f)(tile.tileCoord));
                        tile.release();
                    }
                });
            }
        }
    ]);
    return TileCache;
}((0, $a97c6b69e8b0f346$export$2e2bcd8739ae039));
var $56867742ea2cf9ab$export$2e2bcd8739ae039 = $56867742ea2cf9ab$var$TileCache;



/**
 * @module ol/source/UrlTile
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");
/**
 * @module ol/source/TileEventType
 */ /**
 * @enum {string}
 */ var $5483f72e43e07814$export$2e2bcd8739ae039 /**
 * @typedef {'tileloadstart'|'tileloadend'|'tileloaderror'} TileSourceEventTypes
 */  = {
    /**
   * Triggered when a tile starts loading.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
   * @api
   */ TILELOADSTART: "tileloadstart",
    /**
   * Triggered when a tile finishes loading, either when its data is loaded,
   * or when loading was aborted because the tile is no longer needed.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
   * @api
   */ TILELOADEND: "tileloadend",
    /**
   * Triggered if tile loading results in an error. Note that this is not the
   * right place to re-fetch tiles. See {@link module:ol/ImageTile~ImageTile#load}
   * for details.
   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
   * @api
   */ TILELOADERROR: "tileloaderror"
};


/**
 * @module ol/source/Tile
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $aBSBL = parcelRequire("aBSBL");

var $4jYWU = parcelRequire("4jYWU");

/**
 * @module ol/source/Source
 */ 
var $lyFcw = parcelRequire("lyFcw");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");


/**
 * @typedef {'undefined' | 'loading' | 'ready' | 'error'} State
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */ /**
 * A function that takes a {@link import("../View.js").ViewStateLayerStateExtent} and returns a string or
 * an array of strings representing source attributions.
 *
 * @typedef {function(import("../View.js").ViewStateLayerStateExtent): (string|Array<string>)} Attribution
 */ /**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * * a simple string (e.g. `'© Acme Inc.'`)
 * * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */ /**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./Source.js").State} [state='ready'] State.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */ var $b5891f8da53b2054$var$Source = /*#__PURE__*/ function(BaseObject) {
    "use strict";
    (0, $kcqLc._)(Source, BaseObject);
    var _super = (0, $4jYWU._)(Source);
    function Source(options) {
        (0, $5sFFs._)(this, Source);
        var _this;
        _this = _super.call(this);
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|null}
     */ _this.projection = (0, $401a58d9dec354c1$export$3988ae62b71be9a3)(options.projection);
        /**
     * @private
     * @type {?Attribution}
     */ _this.attributions_ = $b5891f8da53b2054$var$adaptAttributions(options.attributions);
        /**
     * @private
     * @type {boolean}
     */ _this.attributionsCollapsible_ = options.attributionsCollapsible !== undefined ? options.attributionsCollapsible : true;
        /**
     * This source is currently loading data. Sources that defer loading to the
     * map's tile queue never set this to `true`.
     * @type {boolean}
     */ _this.loading = false;
        /**
     * @private
     * @type {import("./Source.js").State}
     */ _this.state_ = options.state !== undefined ? options.state : "ready";
        /**
     * @private
     * @type {boolean}
     */ _this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
        /**
     * @private
     * @type {boolean}
     */ _this.interpolate_ = !!options.interpolate;
        /**
     * @protected
     * @type {function(import("../View.js").ViewOptions):void}
     */ _this.viewResolver = null;
        /**
     * @protected
     * @type {function(Error):void}
     */ _this.viewRejector = null;
        var self = (0, $lyFcw._)(_this);
        /**
     * @private
     * @type {Promise<import("../View.js").ViewOptions>}
     */ _this.viewPromise_ = new Promise(function(resolve, reject) {
            self.viewResolver = resolve;
            self.viewRejector = reject;
        });
        return _this;
    }
    (0, $8O2fV._)(Source, [
        {
            /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   * @api
   */ key: "getAttributions",
            value: function getAttributions() {
                return this.attributions_;
            }
        },
        {
            /**
   * @return {boolean} Attributions are collapsible.
   * @api
   */ key: "getAttributionsCollapsible",
            value: function getAttributionsCollapsible() {
                return this.attributionsCollapsible_;
            }
        },
        {
            /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default|null} Projection.
   * @api
   */ key: "getProjection",
            value: function getProjection() {
                return this.projection;
            }
        },
        {
            /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */ key: "getResolutions",
            value: function getResolutions(projection) {
                return null;
            }
        },
        {
            /**
   * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
   */ key: "getView",
            value: function getView() {
                return this.viewPromise_;
            }
        },
        {
            /**
   * Get the state of the source, see {@link import("./Source.js").State} for possible states.
   * @return {import("./Source.js").State} State.
   * @api
   */ key: "getState",
            value: function getState() {
                return this.state_;
            }
        },
        {
            /**
   * @return {boolean|undefined} Wrap X.
   */ key: "getWrapX",
            value: function getWrapX() {
                return this.wrapX_;
            }
        },
        {
            /**
   * @return {boolean} Use linear interpolation when resampling.
   */ key: "getInterpolate",
            value: function getInterpolate() {
                return this.interpolate_;
            }
        },
        {
            /**
   * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
   * @api
   */ key: "refresh",
            value: function refresh() {
                this.changed();
            }
        },
        {
            /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
   *     or `undefined`.
   * @api
   */ key: "setAttributions",
            value: function setAttributions(attributions) {
                this.attributions_ = $b5891f8da53b2054$var$adaptAttributions(attributions);
                this.changed();
            }
        },
        {
            /**
   * Set the state of the source.
   * @param {import("./Source.js").State} state State.
   */ key: "setState",
            value: function setState(state) {
                this.state_ = state;
                this.changed();
            }
        }
    ]);
    return Source;
}((0, $7a8d25d40aa0de7f$export$2e2bcd8739ae039));
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {Attribution|null} An attribution function (or null).
 */ function $b5891f8da53b2054$var$adaptAttributions(attributionLike) {
    if (!attributionLike) return null;
    if (Array.isArray(attributionLike)) return function(frameState) {
        return attributionLike;
    };
    if (typeof attributionLike === "function") return attributionLike;
    return function(frameState) {
        return [
            attributionLike
        ];
    };
}
var $b5891f8da53b2054$export$2e2bcd8739ae039 = $b5891f8da53b2054$var$Source;








/**
 * @module ol/tilegrid
 */ /**
 * @module ol/tilegrid/TileGrid
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");









/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */ var $01483cdc0dbbde31$var$tmpTileCoord = [
    0,
    0,
    0
];
/**
 * Number of decimal digits to consider in integer values when rounding.
 * @type {number}
 */ var $01483cdc0dbbde31$var$DECIMALS = 5;
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile~TileSource} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and downwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and downwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. If specified the values
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent
 * for which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<number|import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */ /**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */ var $01483cdc0dbbde31$var$TileGrid = /*#__PURE__*/ function() {
    "use strict";
    function TileGrid(options) {
        var _this = this;
        (0, $5sFFs._)(this, TileGrid);
        /**
     * @protected
     * @type {number}
     */ this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
        /**
     * @private
     * @type {!Array<number>}
     */ this.resolutions_ = options.resolutions;
        (0, $100b4414e338a711$export$a7a9523472993e97)((0, $edee3659e50a93f4$export$efa610630f9e181)(this.resolutions_, /**
         * @param {number} a First resolution
         * @param {number} b Second resolution
         * @return {number} Comparison result
         */ function(a, b) {
            return b - a;
        }, true), "`resolutions` must be sorted in descending order");
        // check if we've got a consistent zoom factor and origin
        var zoomFactor;
        if (!options.origins) for(var i = 0, ii = this.resolutions_.length - 1; i < ii; ++i){
            if (!zoomFactor) zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
            else if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
                zoomFactor = undefined;
                break;
            }
        }
        /**
     * @private
     * @type {number|undefined}
     */ this.zoomFactor_ = zoomFactor;
        /**
     * @protected
     * @type {number}
     */ this.maxZoom = this.resolutions_.length - 1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.origin_ = options.origin !== undefined ? options.origin : null;
        /**
     * @private
     * @type {Array<import("../coordinate.js").Coordinate>}
     */ this.origins_ = null;
        if (options.origins !== undefined) {
            this.origins_ = options.origins;
            (0, $100b4414e338a711$export$a7a9523472993e97)(this.origins_.length == this.resolutions_.length, "Number of `origins` and `resolutions` must be equal");
        }
        var extent = options.extent;
        if (extent !== undefined && !this.origin_ && !this.origins_) this.origin_ = (0, $e86e0aa087890eb8$export$cb1538b07e6964ff)(extent);
        (0, $100b4414e338a711$export$a7a9523472993e97)(!this.origin_ && this.origins_ || this.origin_ && !this.origins_, "Either `origin` or `origins` must be configured, never both");
        /**
     * @private
     * @type {Array<number|import("../size.js").Size>}
     */ this.tileSizes_ = null;
        if (options.tileSizes !== undefined) {
            this.tileSizes_ = options.tileSizes;
            (0, $100b4414e338a711$export$a7a9523472993e97)(this.tileSizes_.length == this.resolutions_.length, "Number of `tileSizes` and `resolutions` must be equal");
        }
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.tileSize_ = options.tileSize !== undefined ? options.tileSize : !this.tileSizes_ ? (0, $bb7a9ac0b1791714$export$6b8cb5cd370bd90c) : null;
        (0, $100b4414e338a711$export$a7a9523472993e97)(!this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_, "Either `tileSize` or `tileSizes` must be configured, never both");
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = extent !== undefined ? extent : null;
        /**
     * @private
     * @type {Array<import("../TileRange.js").default>}
     */ this.fullTileRanges_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.tmpSize_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = [
            0,
            0,
            0,
            0
        ];
        if (options.sizes !== undefined) this.fullTileRanges_ = options.sizes.map(function(size, z) {
            var tileRange = new (0, $020488f806cc53de$export$2e2bcd8739ae039)(Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
            if (extent) {
                var restrictedTileRange = _this.getTileRangeForExtentAndZ(extent, z);
                tileRange.minX = Math.max(restrictedTileRange.minX, tileRange.minX);
                tileRange.maxX = Math.min(restrictedTileRange.maxX, tileRange.maxX);
                tileRange.minY = Math.max(restrictedTileRange.minY, tileRange.minY);
                tileRange.maxY = Math.min(restrictedTileRange.maxY, tileRange.maxY);
            }
            return tileRange;
        });
        else if (extent) this.calculateTileRanges_(extent);
    }
    (0, $8O2fV._)(TileGrid, [
        {
            /**
   * Call a function with each tile coordinate for a given extent and zoom level.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} zoom Integer zoom level.
   * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
   * @api
   */ key: "forEachTileCoord",
            value: function forEachTileCoord(extent, zoom, callback) {
                var tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
                for(var i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i)for(var j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j)callback([
                    zoom,
                    i,
                    j
                ]);
            }
        },
        {
            /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {boolean} Callback succeeded.
   */ key: "forEachTileCoordParentTileRange",
            value: function forEachTileCoordParentTileRange(tileCoord, callback, tempTileRange, tempExtent) {
                var tileRange, x, y;
                var tileCoordExtent = null;
                var z = tileCoord[0] - 1;
                if (this.zoomFactor_ === 2) {
                    x = tileCoord[1];
                    y = tileCoord[2];
                } else tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent);
                while(z >= this.minZoom){
                    if (x !== undefined && y !== undefined) {
                        x = Math.floor(x / 2);
                        y = Math.floor(y / 2);
                        tileRange = (0, $020488f806cc53de$export$958e3e1a02eac4b6)(x, x, y, y, tempTileRange);
                    } else tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
                    if (callback(z, tileRange)) return true;
                    --z;
                }
                return false;
            }
        },
        {
            /**
   * Get the extent for this tile grid, if it was configured.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ key: "getExtent",
            value: function getExtent() {
                return this.extent_;
            }
        },
        {
            /**
   * Get the maximum zoom level for the grid.
   * @return {number} Max zoom.
   * @api
   */ key: "getMaxZoom",
            value: function getMaxZoom() {
                return this.maxZoom;
            }
        },
        {
            /**
   * Get the minimum zoom level for the grid.
   * @return {number} Min zoom.
   * @api
   */ key: "getMinZoom",
            value: function getMinZoom() {
                return this.minZoom;
            }
        },
        {
            /**
   * Get the origin for the grid at the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {import("../coordinate.js").Coordinate} Origin.
   * @api
   */ key: "getOrigin",
            value: function getOrigin(z) {
                if (this.origin_) return this.origin_;
                return this.origins_[z];
            }
        },
        {
            /**
   * Get the resolution for the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {number} Resolution.
   * @api
   */ key: "getResolution",
            value: function getResolution(z) {
                return this.resolutions_[z];
            }
        },
        {
            /**
   * Get the list of resolutions for the tile grid.
   * @return {Array<number>} Resolutions.
   * @api
   */ key: "getResolutions",
            value: function getResolutions() {
                return this.resolutions_;
            }
        },
        {
            /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ key: "getTileCoordChildTileRange",
            value: function getTileCoordChildTileRange(tileCoord, tempTileRange, tempExtent) {
                if (tileCoord[0] < this.maxZoom) {
                    if (this.zoomFactor_ === 2) {
                        var minX = tileCoord[1] * 2;
                        var minY = tileCoord[2] * 2;
                        return (0, $020488f806cc53de$export$958e3e1a02eac4b6)(minX, minX + 1, minY, minY + 1, tempTileRange);
                    }
                    var tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent || this.tmpExtent_);
                    return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, tempTileRange);
                }
                return null;
            }
        },
        {
            /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ key: "getTileRangeForTileCoordAndZ",
            value: function getTileRangeForTileCoordAndZ(tileCoord, z, tempTileRange) {
                if (z > this.maxZoom || z < this.minZoom) return null;
                var tileCoordZ = tileCoord[0];
                var tileCoordX = tileCoord[1];
                var tileCoordY = tileCoord[2];
                if (z === tileCoordZ) return (0, $020488f806cc53de$export$958e3e1a02eac4b6)(tileCoordX, tileCoordY, tileCoordX, tileCoordY, tempTileRange);
                if (this.zoomFactor_) {
                    var factor = Math.pow(this.zoomFactor_, z - tileCoordZ);
                    var minX = Math.floor(tileCoordX * factor);
                    var minY = Math.floor(tileCoordY * factor);
                    if (z < tileCoordZ) return (0, $020488f806cc53de$export$958e3e1a02eac4b6)(minX, minX, minY, minY, tempTileRange);
                    var maxX = Math.floor(factor * (tileCoordX + 1)) - 1;
                    var maxY = Math.floor(factor * (tileCoordY + 1)) - 1;
                    return (0, $020488f806cc53de$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
                }
                var tileCoordExtent = this.getTileCoordExtent(tileCoord, this.tmpExtent_);
                return this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
            }
        },
        {
            /**
   * Get a tile range for the given extent and integer zoom level.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary tile range object.
   * @return {import("../TileRange.js").default} Tile range.
   */ key: "getTileRangeForExtentAndZ",
            value: function getTileRangeForExtentAndZ(extent, z, tempTileRange) {
                this.getTileCoordForXYAndZ_(extent[0], extent[3], z, false, $01483cdc0dbbde31$var$tmpTileCoord);
                var minX = $01483cdc0dbbde31$var$tmpTileCoord[1];
                var minY = $01483cdc0dbbde31$var$tmpTileCoord[2];
                this.getTileCoordForXYAndZ_(extent[2], extent[1], z, true, $01483cdc0dbbde31$var$tmpTileCoord);
                var maxX = $01483cdc0dbbde31$var$tmpTileCoord[1];
                var maxY = $01483cdc0dbbde31$var$tmpTileCoord[2];
                return (0, $020488f806cc53de$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
            }
        },
        {
            /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {import("../coordinate.js").Coordinate} Tile center.
   */ key: "getTileCoordCenter",
            value: function getTileCoordCenter(tileCoord) {
                var origin = this.getOrigin(tileCoord[0]);
                var resolution = this.getResolution(tileCoord[0]);
                var tileSize = (0, $9fd3f8f53b8c7a01$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
                return [
                    origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
                    origin[1] - (tileCoord[2] + 0.5) * tileSize[1] * resolution
                ];
            }
        },
        {
            /**
   * Get the extent of a tile coordinate.
   *
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary extent object.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ key: "getTileCoordExtent",
            value: function getTileCoordExtent(tileCoord, tempExtent) {
                var origin = this.getOrigin(tileCoord[0]);
                var resolution = this.getResolution(tileCoord[0]);
                var tileSize = (0, $9fd3f8f53b8c7a01$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
                var minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
                var minY = origin[1] - (tileCoord[2] + 1) * tileSize[1] * resolution;
                var maxX = minX + tileSize[0] * resolution;
                var maxY = minY + tileSize[1] * resolution;
                return (0, $e86e0aa087890eb8$export$958e3e1a02eac4b6)(minX, minY, maxX, maxY, tempExtent);
            }
        },
        {
            /**
   * Get the tile coordinate for the given map coordinate and resolution.  This
   * method considers that coordinates that intersect tile boundaries should be
   * assigned the higher tile coordinate.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ key: "getTileCoordForCoordAndResolution",
            value: function getTileCoordForCoordAndResolution(coordinate, resolution, opt_tileCoord) {
                return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
            }
        },
        {
            /**
   * Note that this method should not be called for resolutions that correspond
   * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
   * @param {number} x X.
   * @param {number} y Y.
   * @param {number} resolution Resolution (for a non-integer zoom level).
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ key: "getTileCoordForXYAndResolution_",
            value: function getTileCoordForXYAndResolution_(x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
                var z = this.getZForResolution(resolution);
                var scale = resolution / this.getResolution(z);
                var origin = this.getOrigin(z);
                var tileSize = (0, $9fd3f8f53b8c7a01$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
                var tileCoordX = scale * (x - origin[0]) / resolution / tileSize[0];
                var tileCoordY = scale * (origin[1] - y) / resolution / tileSize[1];
                if (reverseIntersectionPolicy) {
                    tileCoordX = (0, $029c1e222d833501$export$803ce6b71a0a94b2)(tileCoordX, $01483cdc0dbbde31$var$DECIMALS) - 1;
                    tileCoordY = (0, $029c1e222d833501$export$803ce6b71a0a94b2)(tileCoordY, $01483cdc0dbbde31$var$DECIMALS) - 1;
                } else {
                    tileCoordX = (0, $029c1e222d833501$export$a3fe094919f356fd)(tileCoordX, $01483cdc0dbbde31$var$DECIMALS);
                    tileCoordY = (0, $029c1e222d833501$export$a3fe094919f356fd)(tileCoordY, $01483cdc0dbbde31$var$DECIMALS);
                }
                return (0, $da91b970cd82859b$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
            }
        },
        {
            /**
   * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
   * they should have separate implementations.  This method is for integer zoom
   * levels.  The other method should only be called for resolutions corresponding
   * to non-integer zoom levels.
   * @param {number} x Map x coordinate.
   * @param {number} y Map y coordinate.
   * @param {number} z Integer zoom level.
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ key: "getTileCoordForXYAndZ_",
            value: function getTileCoordForXYAndZ_(x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
                var origin = this.getOrigin(z);
                var resolution = this.getResolution(z);
                var tileSize = (0, $9fd3f8f53b8c7a01$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
                var tileCoordX = (x - origin[0]) / resolution / tileSize[0];
                var tileCoordY = (origin[1] - y) / resolution / tileSize[1];
                if (reverseIntersectionPolicy) {
                    tileCoordX = (0, $029c1e222d833501$export$803ce6b71a0a94b2)(tileCoordX, $01483cdc0dbbde31$var$DECIMALS) - 1;
                    tileCoordY = (0, $029c1e222d833501$export$803ce6b71a0a94b2)(tileCoordY, $01483cdc0dbbde31$var$DECIMALS) - 1;
                } else {
                    tileCoordX = (0, $029c1e222d833501$export$a3fe094919f356fd)(tileCoordX, $01483cdc0dbbde31$var$DECIMALS);
                    tileCoordY = (0, $029c1e222d833501$export$a3fe094919f356fd)(tileCoordY, $01483cdc0dbbde31$var$DECIMALS);
                }
                return (0, $da91b970cd82859b$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
            }
        },
        {
            /**
   * Get a tile coordinate given a map coordinate and zoom level.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} z Integer zoom level, e.g. the result of a `getZForResolution()` method call
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ key: "getTileCoordForCoordAndZ",
            value: function getTileCoordForCoordAndZ(coordinate, z, opt_tileCoord) {
                return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
            }
        },
        {
            /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {number} Tile resolution.
   */ key: "getTileCoordResolution",
            value: function getTileCoordResolution(tileCoord) {
                return this.resolutions_[tileCoord[0]];
            }
        },
        {
            /**
   * Get the tile size for a zoom level. The type of the return value matches the
   * `tileSize` or `tileSizes` that the tile grid was configured with. To always
   * get an {@link import("../size.js").Size}, run the result through {@link module:ol/size.toSize}.
   * @param {number} z Z.
   * @return {number|import("../size.js").Size} Tile size.
   * @api
   */ key: "getTileSize",
            value: function getTileSize(z) {
                if (this.tileSize_) return this.tileSize_;
                return this.tileSizes_[z];
            }
        },
        {
            /**
   * @param {number} z Zoom level.
   * @return {import("../TileRange.js").default|null} Extent tile range for the specified zoom level.
   */ key: "getFullTileRange",
            value: function getFullTileRange(z) {
                if (!this.fullTileRanges_) return this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, z) : null;
                return this.fullTileRanges_[z];
            }
        },
        {
            /**
   * @param {number} resolution Resolution.
   * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
   *     If 0, the nearest resolution will be used.
   *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
   *     nearest lower resolution (higher Z) will be used. Default is 0.
   *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
   *
   * For example to change tile Z at the midpoint of zoom levels
   * ```js
   * function(value, high, low) {
   *   return value - low * Math.sqrt(high / low);
   * }
   * ```
   * @return {number} Z.
   * @api
   */ key: "getZForResolution",
            value: function getZForResolution(resolution, opt_direction) {
                var z = (0, $edee3659e50a93f4$export$8a3786cc03fdb777)(this.resolutions_, resolution, opt_direction || 0);
                return (0, $029c1e222d833501$export$7d15b64cf5a3a4c4)(z, this.minZoom, this.maxZoom);
            }
        },
        {
            /**
   * The tile with the provided tile coordinate intersects the given viewport.
   * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coordinate.
   * @param {Array<number>} viewport Viewport as returned from {@link module:ol/extent.getRotatedViewport}.
   * @return {boolean} The tile with the provided tile coordinate intersects the given viewport.
   */ key: "tileCoordIntersectsViewport",
            value: function tileCoordIntersectsViewport(tileCoord, viewport) {
                return (0, $065e72ea2e35a5d2$export$830a0dafbb2ef1c5)(viewport, 0, viewport.length, 2, this.getTileCoordExtent(tileCoord));
            }
        },
        {
            /**
   * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
   * @private
   */ key: "calculateTileRanges_",
            value: function calculateTileRanges_(extent) {
                var length = this.resolutions_.length;
                var fullTileRanges = new Array(length);
                for(var z = this.minZoom; z < length; ++z)fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
                this.fullTileRanges_ = fullTileRanges;
            }
        }
    ]);
    return TileGrid;
}();
var $01483cdc0dbbde31$export$2e2bcd8739ae039 = $01483cdc0dbbde31$var$TileGrid;







function $75a6511995b1cb2c$export$1f4812384df8a9c5(projection) {
    var tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = $75a6511995b1cb2c$export$a251b12f5601c16f(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
function $75a6511995b1cb2c$export$39a9ce3624977b84(tileGrid, tileCoord, projection) {
    var z = tileCoord[0];
    var center = tileGrid.getTileCoordCenter(tileCoord);
    var projectionExtent = $75a6511995b1cb2c$export$7b5b6ef8fd55fac4(projection);
    if (!(0, $e86e0aa087890eb8$export$ac68c24d37ca240f)(projectionExtent, center)) {
        var worldWidth = (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(projectionExtent);
        var worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    }
    return tileCoord;
}
function $75a6511995b1cb2c$export$ce88871416242df8(extent, maxZoom, tileSize, corner) {
    corner = corner !== undefined ? corner : "top-left";
    var resolutions = $75a6511995b1cb2c$var$resolutionsFromExtent(extent, maxZoom, tileSize);
    return new (0, $01483cdc0dbbde31$export$2e2bcd8739ae039)({
        extent: extent,
        origin: (0, $e86e0aa087890eb8$export$a1cfd206661d0801)(extent, corner),
        resolutions: resolutions,
        tileSize: tileSize
    });
}
function $75a6511995b1cb2c$export$38500bbeccc864ff(options) {
    var xyzOptions = options || {};
    var extent = xyzOptions.extent || (0, $401a58d9dec354c1$export$3988ae62b71be9a3)("EPSG:3857").getExtent();
    var gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: $75a6511995b1cb2c$var$resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize, xyzOptions.maxResolution)
    };
    return new (0, $01483cdc0dbbde31$export$2e2bcd8739ae039)(gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {number} [maxResolution] Resolution at level zero.
 * @return {!Array<number>} Resolutions array.
 */ function $75a6511995b1cb2c$var$resolutionsFromExtent(extent, maxZoom, tileSize, maxResolution) {
    maxZoom = maxZoom !== undefined ? maxZoom : (0, $bb7a9ac0b1791714$export$e98a216cdcc847dc);
    tileSize = (0, $9fd3f8f53b8c7a01$export$a71a825ff42fb8e1)(tileSize !== undefined ? tileSize : (0, $bb7a9ac0b1791714$export$6b8cb5cd370bd90c));
    var height = (0, $e86e0aa087890eb8$export$c08559766941f856)(extent);
    var width = (0, $e86e0aa087890eb8$export$3c49c185de0c2bfc)(extent);
    maxResolution = maxResolution > 0 ? maxResolution : Math.max(width / tileSize[0], height / tileSize[1]);
    var length = maxZoom + 1;
    var resolutions = new Array(length);
    for(var z = 0; z < length; ++z)resolutions[z] = maxResolution / Math.pow(2, z);
    return resolutions;
}
function $75a6511995b1cb2c$export$a251b12f5601c16f(projection, maxZoom, tileSize, corner) {
    var extent = $75a6511995b1cb2c$export$7b5b6ef8fd55fac4(projection);
    return $75a6511995b1cb2c$export$ce88871416242df8(extent, maxZoom, tileSize, corner);
}
function $75a6511995b1cb2c$export$7b5b6ef8fd55fac4(projection) {
    projection = (0, $401a58d9dec354c1$export$3988ae62b71be9a3)(projection);
    var extent = projection.getExtent();
    if (!extent) {
        var half = 180 * (0, $264085f7209eb4a0$export$1482081eec883108).degrees / projection.getMetersPerUnit();
        extent = (0, $e86e0aa087890eb8$export$958e3e1a02eac4b6)(-half, -half, half, half);
    }
    return extent;
}



/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./TileEventType").TileSourceEventTypes, TileSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./TileEventType").TileSourceEventTypes, Return>} TileSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] CacheSize.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 * @abstract
 * @api
 */ var $31cc53513cb7f164$var$TileSource = /*#__PURE__*/ function(Source) {
    "use strict";
    (0, $kcqLc._)(TileSource, Source);
    var _super = (0, $4jYWU._)(TileSource);
    function TileSource(options) {
        (0, $5sFFs._)(this, TileSource);
        var _this;
        _this = _super.call(this, {
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX,
            interpolate: options.interpolate
        });
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ _this.on;
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ _this.once;
        /***
     * @type {TileSourceOnSignature<void>}
     */ _this.un;
        /**
     * @private
     * @type {boolean}
     */ _this.opaque_ = options.opaque !== undefined ? options.opaque : false;
        /**
     * @private
     * @type {number}
     */ _this.tilePixelRatio_ = options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
     * @type {import("../tilegrid/TileGrid.js").default|null}
     */ _this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        var tileSize = [
            256,
            256
        ];
        if (_this.tileGrid) (0, $9fd3f8f53b8c7a01$export$a71a825ff42fb8e1)(_this.tileGrid.getTileSize(_this.tileGrid.getMinZoom()), tileSize);
        /**
     * @protected
     * @type {import("../TileCache.js").default}
     */ _this.tileCache = new (0, $56867742ea2cf9ab$export$2e2bcd8739ae039)(options.cacheSize || 0);
        /**
     * @protected
     * @type {import("../size.js").Size}
     */ _this.tmpSize = [
            0,
            0
        ];
        /**
     * @private
     * @type {string}
     */ _this.key_ = options.key || "";
        /**
     * @protected
     * @type {import("../Tile.js").Options}
     */ _this.tileOptions = {
            transition: options.transition,
            interpolate: options.interpolate
        };
        /**
     * zDirection hint, read by the renderer. Indicates which resolution should be used
     * by a renderer if the views resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @type {number|import("../array.js").NearestDirectionFunction}
     */ _this.zDirection = options.zDirection ? options.zDirection : 0;
        return _this;
    }
    (0, $8O2fV._)(TileSource, [
        {
            /**
   * @return {boolean} Can expire cache.
   */ key: "canExpireCache",
            value: function canExpireCache() {
                return this.tileCache.canExpireCache();
            }
        },
        {
            /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */ key: "expireCache",
            value: function expireCache(projection, usedTiles) {
                var tileCache = this.getTileCacheForProjection(projection);
                if (tileCache) tileCache.expireCache(usedTiles);
            }
        },
        {
            /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {number} z Zoom level.
   * @param {import("../TileRange.js").default} tileRange Tile range.
   * @param {function(import("../Tile.js").default):(boolean|void)} callback Called with each
   *     loaded tile.  If the callback returns `false`, the tile will not be
   *     considered loaded.
   * @return {boolean} The tile range is fully covered with loaded tiles.
   */ key: "forEachLoadedTile",
            value: function forEachLoadedTile(projection, z, tileRange, callback) {
                var tileCache = this.getTileCacheForProjection(projection);
                if (!tileCache) return false;
                var covered = true;
                var tile, tileCoordKey, loaded;
                for(var x = tileRange.minX; x <= tileRange.maxX; ++x)for(var y = tileRange.minY; y <= tileRange.maxY; ++y){
                    tileCoordKey = (0, $da91b970cd82859b$export$92d0df0f1d25c63c)(z, x, y);
                    loaded = false;
                    if (tileCache.containsKey(tileCoordKey)) {
                        tile = /** @type {!import("../Tile.js").default} */ tileCache.get(tileCoordKey);
                        loaded = tile.getState() === (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADED;
                        if (loaded) loaded = callback(tile) !== false;
                    }
                    if (!loaded) covered = false;
                }
                return covered;
            }
        },
        {
            /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ key: "getGutterForProjection",
            value: function getGutterForProjection(projection) {
                return 0;
            }
        },
        {
            /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */ key: "getKey",
            value: function getKey() {
                return this.key_;
            }
        },
        {
            /**
   * Set the value to be used as the key for all tiles in the source.
   * @param {string} key The key for tiles.
   * @protected
   */ key: "setKey",
            value: function setKey(key) {
                if (this.key_ !== key) {
                    this.key_ = key;
                    this.changed();
                }
            }
        },
        {
            /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {boolean} Opaque.
   */ key: "getOpaque",
            value: function getOpaque(projection) {
                return this.opaque_;
            }
        },
        {
            /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */ key: "getResolutions",
            value: function getResolutions(projection) {
                var tileGrid = projection ? this.getTileGridForProjection(projection) : this.tileGrid;
                if (!tileGrid) return null;
                return tileGrid.getResolutions();
            }
        },
        {
            /**
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../Tile.js").default} Tile.
   */ key: "getTile",
            value: function getTile(z, x, y, pixelRatio, projection) {
                return (0, $8b32fff2376556ef$export$817eb92a8194bab0)();
            }
        },
        {
            /**
   * Return the tile grid of the tile source.
   * @return {import("../tilegrid/TileGrid.js").default|null} Tile grid.
   * @api
   */ key: "getTileGrid",
            value: function getTileGrid() {
                return this.tileGrid;
            }
        },
        {
            /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ key: "getTileGridForProjection",
            value: function getTileGridForProjection1(projection) {
                if (!this.tileGrid) return (0, $75a6511995b1cb2c$export$1f4812384df8a9c5)(projection);
                return this.tileGrid;
            }
        },
        {
            /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../TileCache.js").default} Tile cache.
   * @protected
   */ key: "getTileCacheForProjection",
            value: function getTileCacheForProjection(projection) {
                var sourceProjection = this.getProjection();
                (0, $100b4414e338a711$export$a7a9523472993e97)(sourceProjection === null || (0, $401a58d9dec354c1$export$fe091d73a555748b)(sourceProjection, projection), "A VectorTile source can only be rendered if it has a projection compatible with the view projection.");
                return this.tileCache;
            }
        },
        {
            /**
   * Get the tile pixel ratio for this source. Subclasses may override this
   * method, which is meant to return a supported pixel ratio that matches the
   * provided `pixelRatio` as close as possible.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */ key: "getTilePixelRatio",
            value: function getTilePixelRatio(pixelRatio) {
                return this.tilePixelRatio_;
            }
        },
        {
            /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */ key: "getTilePixelSize",
            value: function getTilePixelSize(z, pixelRatio, projection) {
                var tileGrid = this.getTileGridForProjection(projection);
                var tilePixelRatio = this.getTilePixelRatio(pixelRatio);
                var tileSize = (0, $9fd3f8f53b8c7a01$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z), this.tmpSize);
                if (tilePixelRatio == 1) return tileSize;
                return (0, $9fd3f8f53b8c7a01$export$dcdf75081b88279d)(tileSize, tilePixelRatio, this.tmpSize);
            }
        },
        {
            /**
   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
   * is outside the resolution and extent range of the tile grid, `null` will be
   * returned.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
   *     null if no tile URL should be created for the passed `tileCoord`.
   */ key: "getTileCoordForTileUrlFunction",
            value: function getTileCoordForTileUrlFunction(tileCoord, projection) {
                projection = projection !== undefined ? projection : this.getProjection();
                var tileGrid = this.getTileGridForProjection(projection);
                if (this.getWrapX() && projection.isGlobal()) tileCoord = (0, $75a6511995b1cb2c$export$39a9ce3624977b84)(tileGrid, tileCoord, projection);
                return (0, $da91b970cd82859b$export$60bedf8e3e3c3dbe)(tileCoord, tileGrid) ? tileCoord : null;
            }
        },
        {
            /**
   * Remove all cached tiles from the source. The next render cycle will fetch new tiles.
   * @api
   */ key: "clear",
            value: function clear() {
                this.tileCache.clear();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.clear();
                (0, $404BM._)((0, $cEF31._)(TileSource.prototype), "refresh", this).call(this);
            }
        },
        {
            /**
   * Increases the cache size if needed
   * @param {number} tileCount Minimum number of tiles needed.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ key: "updateCacheSize",
            value: function updateCacheSize(tileCount, projection) {
                var tileCache = this.getTileCacheForProjection(projection);
                if (tileCount > tileCache.highWaterMark) tileCache.highWaterMark = tileCount;
            }
        },
        {
            /**
   * Marks a tile coord as being used, without triggering a load.
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ key: "useTile",
            value: function useTile(z, x, y, projection) {}
        }
    ]);
    return TileSource;
}((0, $b5891f8da53b2054$export$2e2bcd8739ae039));
var $31cc53513cb7f164$export$c571855c51e6c4b6 = /*#__PURE__*/ function(Event) {
    "use strict";
    (0, $kcqLc._)(TileSourceEvent, Event);
    var _super = (0, $4jYWU._)(TileSourceEvent);
    function TileSourceEvent(type, tile) {
        (0, $5sFFs._)(this, TileSourceEvent);
        var _this;
        _this = _super.call(this, type);
        /**
     * The tile related to the event.
     * @type {import("../Tile.js").default}
     * @api
     */ _this.tile = tile;
        return _this;
    }
    return TileSourceEvent;
}((0, $aBSBL._)((0, $1a4702ad15857f9a$export$2e2bcd8739ae039)));
var $31cc53513cb7f164$export$2e2bcd8739ae039 = $31cc53513cb7f164$var$TileSource;



/**
 * @module ol/tileurlfunction
 */ 

function $a39dd4467ff7a6fa$export$f0ecb46e90798741(template, tileGrid) {
    var zRegEx = /\{z\}/g;
    var xRegEx = /\{x\}/g;
    var yRegEx = /\{y\}/g;
    var dashYRegEx = /\{-y\}/g;
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        return template.replace(zRegEx, tileCoord[0].toString()).replace(xRegEx, tileCoord[1].toString()).replace(yRegEx, tileCoord[2].toString()).replace(dashYRegEx, function() {
            var z = tileCoord[0];
            var range = tileGrid.getFullTileRange(z);
            if (!range) throw new Error("The {-y} placeholder requires a tile grid with extent");
            var y = range.getHeight() - tileCoord[2] - 1;
            return y.toString();
        });
    });
}
function $a39dd4467ff7a6fa$export$436f44dbcc31fea3(templates, tileGrid) {
    var len = templates.length;
    var tileUrlFunctions = new Array(len);
    for(var i = 0; i < len; ++i)tileUrlFunctions[i] = $a39dd4467ff7a6fa$export$f0ecb46e90798741(templates[i], tileGrid);
    return $a39dd4467ff7a6fa$export$4229b1d9af69b3be(tileUrlFunctions);
}
function $a39dd4467ff7a6fa$export$4229b1d9af69b3be(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) return tileUrlFunctions[0];
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        var h = (0, $da91b970cd82859b$export$d6af199866bfb566)(tileCoord);
        var index = (0, $029c1e222d833501$export$ba467bec01d66def)(h, tileUrlFunctions.length);
        return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
    });
}
function $a39dd4467ff7a6fa$export$fab585f002f634a1(tileCoord, pixelRatio, projection) {
    return undefined;
}
function $a39dd4467ff7a6fa$export$2a1fa079bfd73dde(url) {
    var urls = [];
    var match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        var startCharCode = match[1].charCodeAt(0);
        var stopCharCode = match[2].charCodeAt(0);
        var charCode;
        for(charCode = startCharCode; charCode <= stopCharCode; ++charCode)urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        return urls;
    }
    match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        var stop = parseInt(match[2], 10);
        for(var i = parseInt(match[1], 10); i <= stop; i++)urls.push(url.replace(match[0], i.toString()));
        return urls;
    }
    urls.push(url);
    return urls;
}




/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Cache size.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction TileLoadFunction.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] TileUrlFunction.
 * @property {string} [url] Url.
 * @property {Array<string>} [urls] Urls.
 * @property {boolean} [wrapX=true] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Base class for sources providing tiles divided into a tile grid over http.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */ var $abc42963d103a41f$var$UrlTile = /*#__PURE__*/ function(TileSource) {
    "use strict";
    (0, $kcqLc._)(UrlTile, TileSource);
    var _super = (0, $4jYWU._)(UrlTile);
    function UrlTile(options) {
        (0, $5sFFs._)(this, UrlTile);
        var _this;
        _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            opaque: options.opaque,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {boolean}
     */ _this.generateTileUrlFunction_ = _this.tileUrlFunction === UrlTile.prototype.tileUrlFunction;
        /**
     * @protected
     * @type {import("../Tile.js").LoadFunction}
     */ _this.tileLoadFunction = options.tileLoadFunction;
        if (options.tileUrlFunction) _this.tileUrlFunction = options.tileUrlFunction;
        /**
     * @protected
     * @type {!Array<string>|null}
     */ _this.urls = null;
        if (options.urls) _this.setUrls(options.urls);
        else if (options.url) _this.setUrl(options.url);
        /**
     * @private
     * @type {!Object<string, boolean>}
     */ _this.tileLoadingKeys_ = {};
        return _this;
    }
    (0, $8O2fV._)(UrlTile, [
        {
            /**
   * Return the tile load function of the source.
   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
   * @api
   */ key: "getTileLoadFunction",
            value: function getTileLoadFunction() {
                return this.tileLoadFunction;
            }
        },
        {
            /**
   * Return the tile URL function of the source.
   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
   * @api
   */ key: "getTileUrlFunction",
            value: function getTileUrlFunction() {
                return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
            }
        },
        {
            /**
   * Return the URLs used for this source.
   * When a tileUrlFunction is used instead of url or urls,
   * null will be returned.
   * @return {!Array<string>|null} URLs.
   * @api
   */ key: "getUrls",
            value: function getUrls() {
                return this.urls;
            }
        },
        {
            /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ key: "handleTileChange",
            value: function handleTileChange(event) {
                var tile = /** @type {import("../Tile.js").default} */ event.target;
                var uid = (0, $8b32fff2376556ef$export$5e82334337e0f204)(tile);
                var tileState = tile.getState();
                var type;
                if (tileState == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADING) {
                    this.tileLoadingKeys_[uid] = true;
                    type = (0, $5483f72e43e07814$export$2e2bcd8739ae039).TILELOADSTART;
                } else if (uid in this.tileLoadingKeys_) {
                    delete this.tileLoadingKeys_[uid];
                    type = tileState == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).ERROR ? (0, $5483f72e43e07814$export$2e2bcd8739ae039).TILELOADERROR : tileState == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).LOADED ? (0, $5483f72e43e07814$export$2e2bcd8739ae039).TILELOADEND : undefined;
                }
                if (type != undefined) this.dispatchEvent(new (0, $31cc53513cb7f164$export$c571855c51e6c4b6)(type, tile));
            }
        },
        {
            /**
   * Set the tile load function of the source.
   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @api
   */ key: "setTileLoadFunction",
            value: function setTileLoadFunction(tileLoadFunction) {
                this.tileCache.clear();
                this.tileLoadFunction = tileLoadFunction;
                this.changed();
            }
        },
        {
            /**
   * Set the tile URL function of the source.
   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
   * @param {string} [key] Optional new tile key for the source.
   * @api
   */ key: "setTileUrlFunction",
            value: function setTileUrlFunction(tileUrlFunction, key) {
                this.tileUrlFunction = tileUrlFunction;
                this.tileCache.pruneExceptNewestZ();
                if (typeof key !== "undefined") this.setKey(key);
                else this.changed();
            }
        },
        {
            /**
   * Set the URL to use for requests.
   * @param {string} url URL.
   * @api
   */ key: "setUrl",
            value: function setUrl(url) {
                var urls = (0, $a39dd4467ff7a6fa$export$2a1fa079bfd73dde)(url);
                this.urls = urls;
                this.setUrls(urls);
            }
        },
        {
            /**
   * Set the URLs to use for requests.
   * @param {Array<string>} urls URLs.
   * @api
   */ key: "setUrls",
            value: function setUrls(urls) {
                this.urls = urls;
                var key = urls.join("\n");
                if (this.generateTileUrlFunction_) this.setTileUrlFunction((0, $a39dd4467ff7a6fa$export$436f44dbcc31fea3)(urls, this.tileGrid), key);
                else this.setKey(key);
            }
        },
        {
            /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {string|undefined} Tile URL.
   */ key: "tileUrlFunction",
            value: function tileUrlFunction(tileCoord, pixelRatio, projection) {
                return undefined;
            }
        },
        {
            /**
   * Marks a tile coord as being used, without triggering a load.
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   */ key: "useTile",
            value: function useTile(z, x, y) {
                var tileCoordKey = (0, $da91b970cd82859b$export$92d0df0f1d25c63c)(z, x, y);
                if (this.tileCache.containsKey(tileCoordKey)) this.tileCache.get(tileCoordKey);
            }
        }
    ]);
    return UrlTile;
}((0, $31cc53513cb7f164$export$2e2bcd8739ae039));
var $abc42963d103a41f$export$2e2bcd8739ae039 = $abc42963d103a41f$var$UrlTile;






/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./Source.js").State} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get tile URL given a tile coordinate and the projection.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Base class for sources providing images divided into a tile grid.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */ var $36fa3a4e99594172$var$TileImage = /*#__PURE__*/ function(UrlTile) {
    "use strict";
    (0, $kcqLc._)(TileImage, UrlTile);
    var _super = (0, $4jYWU._)(TileImage);
    function TileImage(options) {
        (0, $5sFFs._)(this, TileImage);
        var _this;
        _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            opaque: options.opaque,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $36fa3a4e99594172$var$defaultTileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate !== undefined ? options.interpolate : true,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @protected
     * @type {?string}
     */ _this.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @protected
     * @type {typeof ImageTile}
     */ _this.tileClass = options.tileClass !== undefined ? options.tileClass : (0, $aa0bea3f7cc55e00$export$2e2bcd8739ae039);
        /**
     * @protected
     * @type {!Object<string, TileCache>}
     */ _this.tileCacheForProjection = {};
        /**
     * @protected
     * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
     */ _this.tileGridForProjection = {};
        /**
     * @private
     * @type {number|undefined}
     */ _this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
     * @private
     * @type {boolean}
     */ _this.renderReprojectionEdges_ = false;
        return _this;
    }
    (0, $8O2fV._)(TileImage, [
        {
            /**
   * @return {boolean} Can expire cache.
   */ key: "canExpireCache",
            value: function canExpireCache() {
                if (this.tileCache.canExpireCache()) return true;
                for(var key in this.tileCacheForProjection){
                    if (this.tileCacheForProjection[key].canExpireCache()) return true;
                }
                return false;
            }
        },
        {
            /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */ key: "expireCache",
            value: function expireCache(projection, usedTiles) {
                var usedTileCache = this.getTileCacheForProjection(projection);
                this.tileCache.expireCache(this.tileCache == usedTileCache ? usedTiles : {});
                for(var id in this.tileCacheForProjection){
                    var tileCache = this.tileCacheForProjection[id];
                    tileCache.expireCache(tileCache == usedTileCache ? usedTiles : {});
                }
            }
        },
        {
            /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ key: "getGutterForProjection",
            value: function getGutterForProjection(projection) {
                if (this.getProjection() && projection && !(0, $401a58d9dec354c1$export$fe091d73a555748b)(this.getProjection(), projection)) return 0;
                return this.getGutter();
            }
        },
        {
            /**
   * @return {number} Gutter.
   */ key: "getGutter",
            value: function getGutter() {
                return 0;
            }
        },
        {
            /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */ key: "getKey",
            value: function getKey() {
                var key = (0, $404BM._)((0, $cEF31._)(TileImage.prototype), "getKey", this).call(this);
                if (!this.getInterpolate()) key += ":disable-interpolation";
                return key;
            }
        },
        {
            /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {boolean} Opaque.
   */ key: "getOpaque",
            value: function getOpaque(projection) {
                if (this.getProjection() && projection && !(0, $401a58d9dec354c1$export$fe091d73a555748b)(this.getProjection(), projection)) return false;
                return (0, $404BM._)((0, $cEF31._)(TileImage.prototype), "getOpaque", this).call(this, projection);
            }
        },
        {
            /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ key: "getTileGridForProjection",
            value: function getTileGridForProjection1(projection) {
                var thisProj = this.getProjection();
                if (this.tileGrid && (!thisProj || (0, $401a58d9dec354c1$export$fe091d73a555748b)(thisProj, projection))) return this.tileGrid;
                var projKey = (0, $8b32fff2376556ef$export$5e82334337e0f204)(projection);
                if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = (0, $75a6511995b1cb2c$export$1f4812384df8a9c5)(projection);
                return this.tileGridForProjection[projKey];
            }
        },
        {
            /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../TileCache.js").default} Tile cache.
   */ key: "getTileCacheForProjection",
            value: function getTileCacheForProjection(projection) {
                var thisProj = this.getProjection();
                if (!thisProj || (0, $401a58d9dec354c1$export$fe091d73a555748b)(thisProj, projection)) return this.tileCache;
                var projKey = (0, $8b32fff2376556ef$export$5e82334337e0f204)(projection);
                if (!(projKey in this.tileCacheForProjection)) this.tileCacheForProjection[projKey] = new (0, $56867742ea2cf9ab$export$2e2bcd8739ae039)(this.tileCache.highWaterMark);
                return this.tileCacheForProjection[projKey];
            }
        },
        {
            /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {string} key The key set on the tile.
   * @return {!ImageTile} Tile.
   * @private
   */ key: "createTile_",
            value: function createTile_(z, x, y, pixelRatio, projection, key) {
                var tileCoord = [
                    z,
                    x,
                    y
                ];
                var urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
                var tileUrl = urlTileCoord ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
                var tile = new this.tileClass(tileCoord, tileUrl !== undefined ? (0, $4b81523a11dd716e$export$2e2bcd8739ae039).IDLE : (0, $4b81523a11dd716e$export$2e2bcd8739ae039).EMPTY, tileUrl !== undefined ? tileUrl : "", this.crossOrigin, this.tileLoadFunction, this.tileOptions);
                tile.key = key;
                tile.addEventListener((0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE, this.handleTileChange.bind(this));
                return tile;
            }
        },
        {
            /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!(ImageTile|ReprojTile)} Tile.
   */ key: "getTile",
            value: function getTile(z, x, y, pixelRatio, projection) {
                var _this = this;
                var sourceProjection = this.getProjection();
                if (!sourceProjection || !projection || (0, $401a58d9dec354c1$export$fe091d73a555748b)(sourceProjection, projection)) return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
                var cache = this.getTileCacheForProjection(projection);
                var tileCoord = [
                    z,
                    x,
                    y
                ];
                var tile;
                var tileCoordKey = (0, $da91b970cd82859b$export$a47fb462a08de82f)(tileCoord);
                if (cache.containsKey(tileCoordKey)) tile = cache.get(tileCoordKey);
                var key = this.getKey();
                if (tile && tile.key == key) return tile;
                var sourceTileGrid = this.getTileGridForProjection(sourceProjection);
                var targetTileGrid = this.getTileGridForProjection(projection);
                var wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
                var newTile = new (0, $7e1852452396cdfc$export$2e2bcd8739ae039)(sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), function(z, x, y, pixelRatio) {
                    return _this.getTileInternal(z, x, y, pixelRatio, sourceProjection);
                }, this.reprojectionErrorThreshold_, this.renderReprojectionEdges_, this.tileOptions);
                newTile.key = key;
                if (tile) {
                    newTile.interimTile = tile;
                    newTile.refreshInterimChain();
                    cache.replace(tileCoordKey, newTile);
                } else cache.set(tileCoordKey, newTile);
                return newTile;
            }
        },
        {
            /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {!import("../proj/Projection.js").default} projection Projection.
   * @return {!ImageTile} Tile.
   * @protected
   */ key: "getTileInternal",
            value: function getTileInternal(z, x, y, pixelRatio, projection) {
                var tile = null;
                var tileCoordKey = (0, $da91b970cd82859b$export$92d0df0f1d25c63c)(z, x, y);
                var key = this.getKey();
                if (!this.tileCache.containsKey(tileCoordKey)) {
                    tile = this.createTile_(z, x, y, pixelRatio, projection, key);
                    this.tileCache.set(tileCoordKey, tile);
                } else {
                    tile = this.tileCache.get(tileCoordKey);
                    if (tile.key != key) {
                        // The source's params changed. If the tile has an interim tile and if we
                        // can use it then we use it. Otherwise we create a new tile.  In both
                        // cases we attempt to assign an interim tile to the new tile.
                        var interimTile = tile;
                        tile = this.createTile_(z, x, y, pixelRatio, projection, key);
                        //make the new tile the head of the list,
                        if (interimTile.getState() == (0, $4b81523a11dd716e$export$2e2bcd8739ae039).IDLE) //the old tile hasn't begun loading yet, and is now outdated, so we can simply discard it
                        tile.interimTile = interimTile.interimTile;
                        else tile.interimTile = interimTile;
                        tile.refreshInterimChain();
                        this.tileCache.replace(tileCoordKey, tile);
                    }
                }
                return tile;
            }
        },
        {
            /**
   * Sets whether to render reprojection edges or not (usually for debugging).
   * @param {boolean} render Render the edges.
   * @api
   */ key: "setRenderReprojectionEdges",
            value: function setRenderReprojectionEdges(render) {
                if (this.renderReprojectionEdges_ == render) return;
                this.renderReprojectionEdges_ = render;
                for(var id in this.tileCacheForProjection)this.tileCacheForProjection[id].clear();
                this.changed();
            }
        },
        {
            /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */ key: "setTileGridForProjection",
            value: function setTileGridForProjection(projection, tilegrid) {
                var proj = (0, $401a58d9dec354c1$export$3988ae62b71be9a3)(projection);
                if (proj) {
                    var projKey = (0, $8b32fff2376556ef$export$5e82334337e0f204)(proj);
                    if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = tilegrid;
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                (0, $404BM._)((0, $cEF31._)(TileImage.prototype), "clear", this).call(this);
                for(var id in this.tileCacheForProjection)this.tileCacheForProjection[id].clear();
            }
        }
    ]);
    return TileImage;
}((0, $abc42963d103a41f$export$2e2bcd8739ae039));
/**
 * @param {ImageTile} imageTile Image tile.
 * @param {string} src Source.
 */ function $36fa3a4e99594172$var$defaultTileLoadFunction(imageTile, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ imageTile.getImage().src = src;
}
var $36fa3a4e99594172$export$2e2bcd8739ae039 = $36fa3a4e99594172$var$TileImage;







function $6fc27e650bb08eb8$export$fdbe9a381526a683(tileCoord) {
    var z = tileCoord[0];
    var digits = new Array(z);
    var mask = 1 << z - 1;
    var i, charCode;
    for(i = 0; i < z; ++i){
        // 48 is charCode for 0 - '0'.charCodeAt(0)
        charCode = 48;
        if (tileCoord[1] & mask) charCode += 1;
        if (tileCoord[2] & mask) charCode += 2;
        digits[i] = String.fromCharCode(charCode);
        mask >>= 1;
    }
    return digits.join("");
}
/**
 * The attribution containing a link to the Microsoft® Bing™ Maps Platform APIs’
 * Terms Of Use.
 * @const
 * @type {string}
 */ var $6fc27e650bb08eb8$var$TOS_ATTRIBUTION = '<a class="ol-attribution-bing-tos" href="https://www.microsoft.com/maps/product/terms.html" target="_blank">Terms of Use</a>';
/**
 * @typedef {Object} Options
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {boolean} [hidpi=false] If `true` hidpi tiles will be requested.
 * @property {string} [culture='en-us'] Culture code.
 * @property {string} key Bing Maps API key. Get yours at https://www.bingmapsportal.com/.
 * @property {string} imagerySet Type of imagery.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {number} [maxZoom=21] Max zoom. Default is what's advertized by the BingMaps service.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 * @property {boolean} [placeholderTiles] Whether to show BingMaps placeholder tiles when zoomed past the maximum level provided in an area. When `false`, requests beyond
 * the maximum zoom level will return no tile. When `true`, the placeholder tile will be returned. When not set, the default behaviour of the imagery set takes place,
 * which is unique for each imagery set in BingMaps.
 */ /**
 * @typedef {Object} BingMapsImageryMetadataResponse
 * @property {number} statusCode The response status code
 * @property {string} statusDescription The response status description
 * @property {string} authenticationResultCode The authentication result code
 * @property {Array<ResourceSet>} resourceSets The array of resource sets
 */ /**
 * @typedef {Object} ResourceSet
 * @property {Array<Resource>} resources Resources.
 */ /**
 * @typedef {Object} Resource
 * @property {number} imageHeight The image height
 * @property {number} imageWidth The image width
 * @property {number} zoomMin The minimum zoom level
 * @property {number} zoomMax The maximum zoom level
 * @property {string} imageUrl The image URL
 * @property {Array<string>} imageUrlSubdomains The image URL subdomains for rotation
 * @property {Array<ImageryProvider>} [imageryProviders] The array of ImageryProviders
 */ /**
 * @typedef {Object} ImageryProvider
 * @property {Array<CoverageArea>} coverageAreas The coverage areas
 * @property {string} [attribution] The attribution
 */ /**
 * @typedef {Object} CoverageArea
 * @property {number} zoomMin The minimum zoom
 * @property {number} zoomMax The maximum zoom
 * @property {Array<number>} bbox The coverage bounding box
 */ /**
 * @classdesc
 * Layer source for Bing Maps tile data.
 * @api
 */ var $6fc27e650bb08eb8$var$BingMaps = /*#__PURE__*/ function(TileImage) {
    "use strict";
    (0, $kcqLc._)(BingMaps, TileImage);
    var _super = (0, $4jYWU._)(BingMaps);
    function BingMaps(options) {
        (0, $5sFFs._)(this, BingMaps);
        var _this;
        var hidpi = options.hidpi !== undefined ? options.hidpi : false;
        _this = _super.call(this, {
            cacheSize: options.cacheSize,
            crossOrigin: "anonymous",
            interpolate: options.interpolate,
            opaque: true,
            projection: (0, $401a58d9dec354c1$export$3988ae62b71be9a3)("EPSG:3857"),
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            state: "loading",
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: hidpi ? 2 : 1,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {boolean}
     */ _this.hidpi_ = hidpi;
        /**
     * @private
     * @type {string}
     */ _this.culture_ = options.culture !== undefined ? options.culture : "en-us";
        /**
     * @private
     * @type {number}
     */ _this.maxZoom_ = options.maxZoom !== undefined ? options.maxZoom : -1;
        /**
     * @private
     * @type {string}
     */ _this.apiKey_ = options.key;
        /**
     * @private
     * @type {string}
     */ _this.imagerySet_ = options.imagerySet;
        /**
     * @private
     * @type {boolean|undefined}
     */ _this.placeholderTiles_ = options.placeholderTiles;
        var url = "https://dev.virtualearth.net/REST/v1/Imagery/Metadata/" + _this.imagerySet_ + "?uriScheme=https&include=ImageryProviders&key=" + _this.apiKey_ + "&c=" + _this.culture_;
        fetch(url).then(function(response) {
            return response.json();
        }).then(function(json) {
            return _this.handleImageryMetadataResponse(json);
        });
        return _this;
    }
    (0, $8O2fV._)(BingMaps, [
        {
            /**
   * Get the api key used for this source.
   *
   * @return {string} The api key.
   * @api
   */ key: "getApiKey",
            value: function getApiKey() {
                return this.apiKey_;
            }
        },
        {
            /**
   * Get the imagery set associated with this source.
   *
   * @return {string} The imagery set.
   * @api
   */ key: "getImagerySet",
            value: function getImagerySet() {
                return this.imagerySet_;
            }
        },
        {
            /**
   * @param {BingMapsImageryMetadataResponse} response Response.
   */ key: "handleImageryMetadataResponse",
            value: function handleImageryMetadataResponse(response) {
                var _this = this;
                if (response.statusCode != 200 || response.statusDescription != "OK" || response.authenticationResultCode != "ValidCredentials" || response.resourceSets.length != 1 || response.resourceSets[0].resources.length != 1) {
                    this.setState("error");
                    return;
                }
                var resource = response.resourceSets[0].resources[0];
                var maxZoom = this.maxZoom_ == -1 ? resource.zoomMax : this.maxZoom_;
                var sourceProjection = this.getProjection();
                var extent = (0, $75a6511995b1cb2c$export$7b5b6ef8fd55fac4)(sourceProjection);
                var scale = this.hidpi_ ? 2 : 1;
                var tileSize = resource.imageWidth == resource.imageHeight ? resource.imageWidth / scale : [
                    resource.imageWidth / scale,
                    resource.imageHeight / scale
                ];
                var tileGrid = (0, $75a6511995b1cb2c$export$38500bbeccc864ff)({
                    extent: extent,
                    minZoom: resource.zoomMin,
                    maxZoom: maxZoom,
                    tileSize: tileSize
                });
                this.tileGrid = tileGrid;
                var culture = this.culture_;
                var hidpi = this.hidpi_;
                var placeholderTiles = this.placeholderTiles_;
                this.tileUrlFunction = (0, $a39dd4467ff7a6fa$export$4229b1d9af69b3be)(resource.imageUrlSubdomains.map(function(subdomain) {
                    /** @type {import('../tilecoord.js').TileCoord} */ var quadKeyTileCoord = [
                        0,
                        0,
                        0
                    ];
                    var imageUrl = resource.imageUrl.replace("{subdomain}", subdomain).replace("{culture}", culture);
                    return(/**
           * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
           * @param {number} pixelRatio Pixel ratio.
           * @param {import("../proj/Projection.js").default} projection Projection.
           * @return {string|undefined} Tile URL.
           */ function(tileCoord, pixelRatio, projection) {
                        if (!tileCoord) return undefined;
                        (0, $da91b970cd82859b$export$958e3e1a02eac4b6)(tileCoord[0], tileCoord[1], tileCoord[2], quadKeyTileCoord);
                        var url = new URL(imageUrl.replace("{quadkey}", $6fc27e650bb08eb8$export$fdbe9a381526a683(quadKeyTileCoord)));
                        var params = url.searchParams;
                        if (hidpi) {
                            params.set("dpi", "d1");
                            params.set("device", "mobile");
                        }
                        if (placeholderTiles === true) params.delete("n");
                        else if (placeholderTiles === false) params.set("n", "z");
                        return url.toString();
                    });
                }));
                if (resource.imageryProviders) {
                    var transform = (0, $401a58d9dec354c1$export$e3c4995a701c26a3)((0, $401a58d9dec354c1$export$3988ae62b71be9a3)("EPSG:4326"), this.getProjection());
                    this.setAttributions(function(frameState) {
                        var attributions = [];
                        var viewState = frameState.viewState;
                        var tileGrid = _this.getTileGrid();
                        var z = tileGrid.getZForResolution(viewState.resolution, _this.zDirection);
                        var tileCoord = tileGrid.getTileCoordForCoordAndZ(viewState.center, z);
                        var zoom = tileCoord[0];
                        resource.imageryProviders.map(function(imageryProvider) {
                            var intersecting = false;
                            var coverageAreas = imageryProvider.coverageAreas;
                            for(var i = 0, ii = coverageAreas.length; i < ii; ++i){
                                var coverageArea = coverageAreas[i];
                                if (zoom >= coverageArea.zoomMin && zoom <= coverageArea.zoomMax) {
                                    var bbox = coverageArea.bbox;
                                    var epsg4326Extent = [
                                        bbox[1],
                                        bbox[0],
                                        bbox[3],
                                        bbox[2]
                                    ];
                                    var extent = (0, $e86e0aa087890eb8$export$9f9dcb98c894b623)(epsg4326Extent, transform);
                                    if ((0, $e86e0aa087890eb8$export$7b0a31e10bbff018)(extent, frameState.extent)) {
                                        intersecting = true;
                                        break;
                                    }
                                }
                            }
                            if (intersecting) attributions.push(imageryProvider.attribution);
                        });
                        attributions.push($6fc27e650bb08eb8$var$TOS_ATTRIBUTION);
                        return attributions;
                    });
                }
                this.setState("ready");
            }
        }
    ]);
    return BingMaps;
}((0, $36fa3a4e99594172$export$2e2bcd8739ae039));
var $6fc27e650bb08eb8$export$2e2bcd8739ae039 = $6fc27e650bb08eb8$var$BingMaps;

/**
 * @module ol/source/Vector
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $404BM = parcelRequire("404BM");

var $cEF31 = parcelRequire("cEF31");

var $kcqLc = parcelRequire("kcqLc");

var $fyztb = parcelRequire("fyztb");

var $aBSBL = parcelRequire("aBSBL");

var $4jYWU = parcelRequire("4jYWU");





/**
 * @module ol/structs/RBush
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");




/**
 * @typedef {Object} Entry
 * @property {number} minX MinX.
 * @property {number} minY MinY.
 * @property {number} maxX MaxX.
 * @property {number} maxY MaxY.
 * @property {Object} [value] Value.
 */ /**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template T
 */ var $efe39ba4adef2e95$var$RBush = /*#__PURE__*/ function() {
    "use strict";
    function RBush(maxEntries) {
        (0, $5sFFs._)(this, RBush);
        /**
     * @private
     */ this.rbush_ = new (0, (/*@__PURE__*/$parcel$interopDefault($82e0979b298e1815$exports)))(maxEntries);
        /**
     * A mapping between the objects added to this rbush wrapper
     * and the objects that are actually added to the internal rbush.
     * @private
     * @type {Object<string, Entry>}
     */ this.items_ = {};
    }
    (0, $8O2fV._)(RBush, [
        {
            /**
   * Insert a value into the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ key: "insert",
            value: function insert(extent, value) {
                /** @type {Entry} */ var item = {
                    minX: extent[0],
                    minY: extent[1],
                    maxX: extent[2],
                    maxY: extent[3],
                    value: value
                };
                this.rbush_.insert(item);
                this.items_[(0, $8b32fff2376556ef$export$5e82334337e0f204)(value)] = item;
            }
        },
        {
            /**
   * Bulk-insert values into the RBush.
   * @param {Array<import("../extent.js").Extent>} extents Extents.
   * @param {Array<T>} values Values.
   */ key: "load",
            value: function load(extents, values) {
                var items = new Array(values.length);
                for(var i = 0, l = values.length; i < l; i++){
                    var extent = extents[i];
                    var value = values[i];
                    /** @type {Entry} */ var item = {
                        minX: extent[0],
                        minY: extent[1],
                        maxX: extent[2],
                        maxY: extent[3],
                        value: value
                    };
                    items[i] = item;
                    this.items_[(0, $8b32fff2376556ef$export$5e82334337e0f204)(value)] = item;
                }
                this.rbush_.load(items);
            }
        },
        {
            /**
   * Remove a value from the RBush.
   * @param {T} value Value.
   * @return {boolean} Removed.
   */ key: "remove",
            value: function remove(value) {
                var uid = (0, $8b32fff2376556ef$export$5e82334337e0f204)(value);
                // get the object in which the value was wrapped when adding to the
                // internal rbush. then use that object to do the removal.
                var item = this.items_[uid];
                delete this.items_[uid];
                return this.rbush_.remove(item) !== null;
            }
        },
        {
            /**
   * Update the extent of a value in the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ key: "update",
            value: function update(extent, value) {
                var item = this.items_[(0, $8b32fff2376556ef$export$5e82334337e0f204)(value)];
                var bbox = [
                    item.minX,
                    item.minY,
                    item.maxX,
                    item.maxY
                ];
                if (!(0, $e86e0aa087890eb8$export$e9bab7fafb253603)(bbox, extent)) {
                    this.remove(value);
                    this.insert(extent, value);
                }
            }
        },
        {
            /**
   * Return all values in the RBush.
   * @return {Array<T>} All.
   */ key: "getAll",
            value: function getAll() {
                var items = this.rbush_.all();
                return items.map(function(item) {
                    return item.value;
                });
            }
        },
        {
            /**
   * Return all values in the given extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<T>} All in extent.
   */ key: "getInExtent",
            value: function getInExtent(extent) {
                /** @type {Entry} */ var bbox = {
                    minX: extent[0],
                    minY: extent[1],
                    maxX: extent[2],
                    maxY: extent[3]
                };
                var items = this.rbush_.search(bbox);
                return items.map(function(item) {
                    return item.value;
                });
            }
        },
        {
            /**
   * Calls a callback function with each value in the tree.
   * If the callback returns a truthy value, this value is returned without
   * checking the rest of the tree.
   * @param {function(T): *} callback Callback.
   * @return {*} Callback return value.
   */ key: "forEach",
            value: function forEach(callback) {
                return this.forEach_(this.getAll(), callback);
            }
        },
        {
            /**
   * Calls a callback function with each value in the provided extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(T): *} callback Callback.
   * @return {*} Callback return value.
   */ key: "forEachInExtent",
            value: function forEachInExtent(extent, callback) {
                return this.forEach_(this.getInExtent(extent), callback);
            }
        },
        {
            /**
   * @param {Array<T>} values Values.
   * @param {function(T): *} callback Callback.
   * @private
   * @return {*} Callback return value.
   */ key: "forEach_",
            value: function forEach_(values, callback) {
                var result;
                for(var i = 0, l = values.length; i < l; i++){
                    result = callback(values[i]);
                    if (result) return result;
                }
                return result;
            }
        },
        {
            /**
   * @return {boolean} Is empty.
   */ key: "isEmpty",
            value: function isEmpty1() {
                return (0, $29e93681307ffd1e$export$dd1bc94b04021eeb)(this.items_);
            }
        },
        {
            /**
   * Remove all values from the RBush.
   */ key: "clear",
            value: function clear() {
                this.rbush_.clear();
                this.items_ = {};
            }
        },
        {
            /**
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} Extent.
   */ key: "getExtent",
            value: function getExtent(extent) {
                var data = this.rbush_.toJSON();
                return (0, $e86e0aa087890eb8$export$958e3e1a02eac4b6)(data.minX, data.minY, data.maxX, data.maxY, extent);
            }
        },
        {
            /**
   * @param {RBush} rbush R-Tree.
   */ key: "concat",
            value: function concat(rbush) {
                this.rbush_.load(rbush.rbush_.all());
                for(var i in rbush.items_)this.items_[i] = rbush.items_[i];
            }
        }
    ]);
    return RBush;
}();
var $efe39ba4adef2e95$export$2e2bcd8739ae039 = $efe39ba4adef2e95$var$RBush;


/**
 * @module ol/render/Feature
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");
/**
 * @module ol/Feature
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");




/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */ /**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:geometry', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types
 *     |'change:geometry', Return>} FeatureOnSignature
 */ /***
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @typedef {Object<string, *> & { geometry?: Geometry }} ObjectWithGeometry
 */ /**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object~BaseObject} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature.js';
 * import Polygon from 'ol/geom/Polygon.js';
 * import Point from 'ol/geom/Point.js';
 *
 * const feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon',
 * });
 *
 * // get the polygon geometry
 * const poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * const point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 */ var $a0674ee7b31c3fe1$var$Feature = /*#__PURE__*/ function(BaseObject) {
    "use strict";
    (0, $kcqLc._)(Feature, BaseObject);
    var _super = (0, $4jYWU._)(Feature);
    function Feature(geometryOrProperties) {
        (0, $5sFFs._)(this, Feature);
        var _this;
        _this = _super.call(this);
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ _this.on;
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ _this.once;
        /***
     * @type {FeatureOnSignature<void>}
     */ _this.un;
        /**
     * @private
     * @type {number|string|undefined}
     */ _this.id_ = undefined;
        /**
     * @type {string}
     * @private
     */ _this.geometryName_ = "geometry";
        /**
     * User provided style.
     * @private
     * @type {import("./style/Style.js").StyleLike}
     */ _this.style_ = null;
        /**
     * @private
     * @type {import("./style/Style.js").StyleFunction|undefined}
     */ _this.styleFunction_ = undefined;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ _this.geometryChangeKey_ = null;
        _this.addChangeListener(_this.geometryName_, _this.handleGeometryChanged_);
        if (geometryOrProperties) {
            if (typeof /** @type {?} */ geometryOrProperties.getSimplifiedGeometry === "function") {
                var geometry = /** @type {Geometry} */ geometryOrProperties;
                _this.setGeometry(geometry);
            } else {
                /** @type {Object<string, *>} */ var properties = geometryOrProperties;
                _this.setProperties(properties);
            }
        }
        return _this;
    }
    (0, $8O2fV._)(Feature, [
        {
            /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature<Geometry>} The clone.
   * @api
   */ key: "clone",
            value: function clone() {
                var clone = /** @type {Feature<Geometry>} */ new Feature(this.hasProperties() ? this.getProperties() : null);
                clone.setGeometryName(this.getGeometryName());
                var geometry = this.getGeometry();
                if (geometry) clone.setGeometry(/** @type {Geometry} */ geometry.clone());
                var style = this.getStyle();
                if (style) clone.setStyle(style);
                return clone;
            }
        },
        {
            /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {Geometry|undefined} The default geometry for the feature.
   * @api
   * @observable
   */ key: "getGeometry",
            value: function getGeometry() {
                return /** @type {Geometry|undefined} */ this.get(this.geometryName_);
            }
        },
        {
            /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */ key: "getId",
            value: function getId() {
                return this.id_;
            }
        },
        {
            /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */ key: "getGeometryName",
            value: function getGeometryName() {
                return this.geometryName_;
            }
        },
        {
            /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
   * @api
   */ key: "getStyle",
            value: function getStyle() {
                return this.style_;
            }
        },
        {
            /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */ key: "getStyleFunction",
            value: function getStyleFunction() {
                return this.styleFunction_;
            }
        },
        {
            /**
   * @private
   */ key: "handleGeometryChange_",
            value: function handleGeometryChange_() {
                this.changed();
            }
        },
        {
            /**
   * @private
   */ key: "handleGeometryChanged_",
            value: function handleGeometryChanged_() {
                if (this.geometryChangeKey_) {
                    (0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921)(this.geometryChangeKey_);
                    this.geometryChangeKey_ = null;
                }
                var geometry = this.getGeometry();
                if (geometry) this.geometryChangeKey_ = (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(geometry, (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE, this.handleGeometryChange_, this);
                this.changed();
            }
        },
        {
            /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {Geometry|undefined} geometry The new geometry.
   * @api
   * @observable
   */ key: "setGeometry",
            value: function setGeometry(geometry) {
                this.set(this.geometryName_, geometry);
            }
        },
        {
            /**
   * Set the style for the feature to override the layer style.  This can be a
   * single style object, an array of styles, or a function that takes a
   * resolution and returns an array of styles. To unset the feature style, call
   * `setStyle()` without arguments or a falsey value.
   * @param {import("./style/Style.js").StyleLike} [style] Style for this feature.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ key: "setStyle",
            value: function setStyle(style) {
                this.style_ = style;
                this.styleFunction_ = !style ? undefined : $a0674ee7b31c3fe1$export$bb06ddfd5d66e02e(style);
                this.changed();
            }
        },
        {
            /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ key: "setId",
            value: function setId(id) {
                this.id_ = id;
                this.changed();
            }
        },
        {
            /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */ key: "setGeometryName",
            value: function setGeometryName(name) {
                this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_);
                this.geometryName_ = name;
                this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
                this.handleGeometryChanged_();
            }
        }
    ]);
    return Feature;
}((0, $7a8d25d40aa0de7f$export$2e2bcd8739ae039));
function $a0674ee7b31c3fe1$export$bb06ddfd5d66e02e(obj) {
    if (typeof obj === "function") return obj;
    /**
   * @type {Array<import("./style/Style.js").default>}
   */ var styles;
    if (Array.isArray(obj)) styles = obj;
    else {
        (0, $100b4414e338a711$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === "function", "Expected an `ol/style/Style` or an array of `ol/style/Style.js`");
        var style = /** @type {import("./style/Style.js").default} */ obj;
        styles = [
            style
        ];
    }
    return function() {
        return styles;
    };
}
var $a0674ee7b31c3fe1$export$2e2bcd8739ae039 = $a0674ee7b31c3fe1$var$Feature;


/**
 * @module ol/geom/LineString
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");








/**
 * @module ol/geom/flat/interpolate
 */ 

function $7ab9f917eb6f25a2$export$687ff82efd78795b(flatCoordinates, offset, end, stride, fraction, dest, dimension) {
    var o, t;
    var n = (end - offset) / stride;
    if (n === 1) o = offset;
    else if (n === 2) {
        o = offset;
        t = fraction;
    } else if (n !== 0) {
        var x1 = flatCoordinates[offset];
        var y1 = flatCoordinates[offset + 1];
        var length = 0;
        var cumulativeLengths = [
            0
        ];
        for(var i = offset + stride; i < end; i += stride){
            var x2 = flatCoordinates[i];
            var y2 = flatCoordinates[i + 1];
            length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length);
            x1 = x2;
            y1 = y2;
        }
        var target = fraction * length;
        var index = (0, $edee3659e50a93f4$export$2e0ae67339d5f1ac)(cumulativeLengths, target);
        if (index < 0) {
            t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            o = offset + (-index - 2) * stride;
        } else o = offset + index * stride;
    }
    dimension = dimension > 1 ? dimension : 2;
    dest = dest ? dest : new Array(dimension);
    for(var i1 = 0; i1 < dimension; ++i1)dest[i1] = o === undefined ? NaN : t === undefined ? flatCoordinates[o + i1] : (0, $029c1e222d833501$export$3a89f8d6f6bf6c9f)(flatCoordinates[o + i1], flatCoordinates[o + stride + i1], t);
    return dest;
}
function $7ab9f917eb6f25a2$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) return null;
    var coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) return flatCoordinates.slice(offset, offset + stride);
    var lo = offset / stride;
    var hi = end / stride;
    while(lo < hi){
        var mid = lo + hi >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) hi = mid;
        else lo = mid + 1;
    }
    var m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    var m1 = flatCoordinates[(lo + 1) * stride - 1];
    var t = (m - m0) / (m1 - m0);
    coordinate = [];
    for(var i = 0; i < stride - 1; ++i)coordinate.push((0, $029c1e222d833501$export$3a89f8d6f6bf6c9f)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    coordinate.push(m);
    return coordinate;
}
function $7ab9f917eb6f25a2$export$6a3300857e9ef453(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) return $7ab9f917eb6f25a2$export$8f44c3c220ef6f09(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    var coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    for(var i = 0, ii = ends.length; i < ii; ++i){
        var end = ends[i];
        if (offset == end) continue;
        if (m < flatCoordinates[offset + stride - 1]) return null;
        if (m <= flatCoordinates[end - 1]) return $7ab9f917eb6f25a2$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, false);
        offset = end;
    }
    return null;
}




/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */ var $537ebc1a5b36dd8c$var$LineString = /*#__PURE__*/ function(SimpleGeometry) {
    "use strict";
    (0, $kcqLc._)(LineString, SimpleGeometry);
    var _super = (0, $4jYWU._)(LineString);
    function LineString(coordinates, layout) {
        (0, $5sFFs._)(this, LineString);
        var _this;
        _this = _super.call(this);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ _this.flatMidpoint_ = null;
        /**
     * @private
     * @type {number}
     */ _this.flatMidpointRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ _this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ _this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) _this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else _this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
        return _this;
    }
    (0, $8O2fV._)(LineString, [
        {
            /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */ key: "appendCoordinate",
            value: function appendCoordinate(coordinate) {
                (0, $edee3659e50a93f4$export$8b58be045bf06082)(this.flatCoordinates, coordinate);
                this.changed();
            }
        },
        {
            /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @api
   */ key: "clone",
            value: function clone() {
                var lineString = new LineString(this.flatCoordinates.slice(), this.layout);
                lineString.applyProperties(this);
                return lineString;
            }
        },
        {
            /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ key: "closestPointXY",
            value: function closestPointXY(x, y, closestPoint, minSquaredDistance) {
                if (minSquaredDistance < (0, $e86e0aa087890eb8$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
                if (this.maxDeltaRevision_ != this.getRevision()) {
                    this.maxDelta_ = Math.sqrt((0, $7359464f07c6bbdb$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
                    this.maxDeltaRevision_ = this.getRevision();
                }
                return (0, $7359464f07c6bbdb$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
            }
        },
        {
            /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */ key: "forEachSegment",
            value: function forEachSegment1(callback) {
                return (0, $360ddee7ab6dd00c$export$4b80e395e36b5a56)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
            }
        },
        {
            /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ key: "getCoordinateAtM",
            value: function getCoordinateAtM(m, extrapolate) {
                if (this.layout != "XYM" && this.layout != "XYZM") return null;
                extrapolate = extrapolate !== undefined ? extrapolate : false;
                return (0, $7ab9f917eb6f25a2$export$8f44c3c220ef6f09)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
            }
        },
        {
            /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */ key: "getCoordinates",
            value: function getCoordinates() {
                return (0, $c51d6f1a0abb2d94$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
            }
        },
        {
            /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate} [dest] Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */ key: "getCoordinateAt",
            value: function getCoordinateAt(fraction, dest) {
                return (0, $7ab9f917eb6f25a2$export$687ff82efd78795b)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, dest, this.stride);
            }
        },
        {
            /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */ key: "getLength",
            value: function getLength() {
                return (0, $55ad3feb4c83fd65$export$153f8c6b4d8caebc)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
            }
        },
        {
            /**
   * @return {Array<number>} Flat midpoint.
   */ key: "getFlatMidpoint",
            value: function getFlatMidpoint() {
                if (this.flatMidpointRevision_ != this.getRevision()) {
                    var _this_flatMidpoint_;
                    this.flatMidpoint_ = this.getCoordinateAt(0.5, (_this_flatMidpoint_ = this.flatMidpoint_) !== null && _this_flatMidpoint_ !== void 0 ? _this_flatMidpoint_ : undefined);
                    this.flatMidpointRevision_ = this.getRevision();
                }
                return /** @type {Array<number>} */ this.flatMidpoint_;
            }
        },
        {
            /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} Simplified LineString.
   * @protected
   */ key: "getSimplifiedGeometryInternal",
            value: function getSimplifiedGeometryInternal(squaredTolerance) {
                /** @type {Array<number>} */ var simplifiedFlatCoordinates = [];
                simplifiedFlatCoordinates.length = (0, $a4f7faacf16083d1$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
                return new LineString(simplifiedFlatCoordinates, "XY");
            }
        },
        {
            /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ key: "getType",
            value: function getType() {
                return "LineString";
            }
        },
        {
            /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ key: "intersectsExtent",
            value: function intersectsExtent(extent) {
                return (0, $065e72ea2e35a5d2$export$40d8d71841a3d779)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
            }
        },
        {
            /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ key: "setCoordinates",
            value: function setCoordinates(coordinates, layout) {
                this.setLayout(layout, coordinates, 1);
                if (!this.flatCoordinates) this.flatCoordinates = [];
                this.flatCoordinates.length = (0, $619b917ada0c75a6$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
                this.changed();
            }
        }
    ]);
    return LineString;
}((0, $b8a34d748252df7d$export$2e2bcd8739ae039));
var $537ebc1a5b36dd8c$export$2e2bcd8739ae039 = $537ebc1a5b36dd8c$var$LineString;

/**
 * @module ol/geom/MultiLineString
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");










/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */ var $81a9b9a6cbf91c4e$var$MultiLineString = /*#__PURE__*/ function(SimpleGeometry) {
    "use strict";
    (0, $kcqLc._)(MultiLineString, SimpleGeometry);
    var _super = (0, $4jYWU._)(MultiLineString);
    function MultiLineString(coordinates, layout, ends) {
        (0, $5sFFs._)(this, MultiLineString);
        var _this;
        _this = _super.call(this);
        /**
     * @type {Array<number>}
     * @private
     */ _this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ _this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ _this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) _this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
        else if (layout !== undefined && ends) {
            _this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            _this.ends_ = ends;
        } else {
            var lineStrings = /** @type {Array<LineString>} */ coordinates;
            /** @type {Array<number>} */ var flatCoordinates = [];
            var _$ends = [];
            for(var i = 0, ii = lineStrings.length; i < ii; ++i){
                var lineString = lineStrings[i];
                (0, $edee3659e50a93f4$export$8b58be045bf06082)(flatCoordinates, lineString.getFlatCoordinates());
                _$ends.push(flatCoordinates.length);
            }
            var _$layout = lineStrings.length === 0 ? _this.getLayout() : lineStrings[0].getLayout();
            _this.setFlatCoordinates(_$layout, flatCoordinates);
            _this.ends_ = _$ends;
        }
        return _this;
    }
    (0, $8O2fV._)(MultiLineString, [
        {
            /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */ key: "appendLineString",
            value: function appendLineString(lineString) {
                (0, $edee3659e50a93f4$export$8b58be045bf06082)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
                this.ends_.push(this.flatCoordinates.length);
                this.changed();
            }
        },
        {
            /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @api
   */ key: "clone",
            value: function clone() {
                var multiLineString = new MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
                multiLineString.applyProperties(this);
                return multiLineString;
            }
        },
        {
            /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ key: "closestPointXY",
            value: function closestPointXY(x, y, closestPoint, minSquaredDistance) {
                if (minSquaredDistance < (0, $e86e0aa087890eb8$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
                if (this.maxDeltaRevision_ != this.getRevision()) {
                    this.maxDelta_ = Math.sqrt((0, $7359464f07c6bbdb$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
                    this.maxDeltaRevision_ = this.getRevision();
                }
                return (0, $7359464f07c6bbdb$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
            }
        },
        {
            /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @param {boolean} [interpolate] Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ key: "getCoordinateAtM",
            value: function getCoordinateAtM(m, extrapolate, interpolate) {
                if (this.layout != "XYM" && this.layout != "XYZM" || this.flatCoordinates.length === 0) return null;
                extrapolate = extrapolate !== undefined ? extrapolate : false;
                interpolate = interpolate !== undefined ? interpolate : false;
                return (0, $7ab9f917eb6f25a2$export$6a3300857e9ef453)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
            }
        },
        {
            /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   */ key: "getCoordinates",
            value: function getCoordinates() {
                return (0, $c51d6f1a0abb2d94$export$cbb9596fc0f40db2)(this.flatCoordinates, 0, this.ends_, this.stride);
            }
        },
        {
            /**
   * @return {Array<number>} Ends.
   */ key: "getEnds",
            value: function getEnds() {
                return this.ends_;
            }
        },
        {
            /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */ key: "getLineString",
            value: function getLineString(index) {
                if (index < 0 || this.ends_.length <= index) return null;
                return new (0, $537ebc1a5b36dd8c$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
            }
        },
        {
            /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */ key: "getLineStrings",
            value: function getLineStrings() {
                var flatCoordinates = this.flatCoordinates;
                var ends = this.ends_;
                var layout = this.layout;
                /** @type {Array<LineString>} */ var lineStrings = [];
                var offset = 0;
                for(var i = 0, ii = ends.length; i < ii; ++i){
                    var end = ends[i];
                    var lineString = new (0, $537ebc1a5b36dd8c$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
                    lineStrings.push(lineString);
                    offset = end;
                }
                return lineStrings;
            }
        },
        {
            /**
   * @return {Array<number>} Flat midpoints.
   */ key: "getFlatMidpoints",
            value: function getFlatMidpoints() {
                /** @type {Array<number>} */ var midpoints = [];
                var flatCoordinates = this.flatCoordinates;
                var offset = 0;
                var ends = this.ends_;
                var stride = this.stride;
                for(var i = 0, ii = ends.length; i < ii; ++i){
                    var end = ends[i];
                    var midpoint = (0, $7ab9f917eb6f25a2$export$687ff82efd78795b)(flatCoordinates, offset, end, stride, 0.5);
                    (0, $edee3659e50a93f4$export$8b58be045bf06082)(midpoints, midpoint);
                    offset = end;
                }
                return midpoints;
            }
        },
        {
            /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiLineString} Simplified MultiLineString.
   * @protected
   */ key: "getSimplifiedGeometryInternal",
            value: function getSimplifiedGeometryInternal(squaredTolerance) {
                /** @type {Array<number>} */ var simplifiedFlatCoordinates = [];
                /** @type {Array<number>} */ var simplifiedEnds = [];
                simplifiedFlatCoordinates.length = (0, $a4f7faacf16083d1$export$cedb9900c0b225c2)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
                return new MultiLineString(simplifiedFlatCoordinates, "XY", simplifiedEnds);
            }
        },
        {
            /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ key: "getType",
            value: function getType() {
                return "MultiLineString";
            }
        },
        {
            /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ key: "intersectsExtent",
            value: function intersectsExtent(extent) {
                return (0, $065e72ea2e35a5d2$export$fdb1d8e850bf7937)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
            }
        },
        {
            /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ key: "setCoordinates",
            value: function setCoordinates(coordinates, layout) {
                this.setLayout(layout, coordinates, 2);
                if (!this.flatCoordinates) this.flatCoordinates = [];
                var ends = (0, $619b917ada0c75a6$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
                this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
                this.changed();
            }
        }
    ]);
    return MultiLineString;
}((0, $b8a34d748252df7d$export$2e2bcd8739ae039));
var $81a9b9a6cbf91c4e$export$2e2bcd8739ae039 = $81a9b9a6cbf91c4e$var$MultiLineString;

/**
 * @module ol/geom/MultiPoint
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");







/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */ var $51f493e93d3b729a$var$MultiPoint = /*#__PURE__*/ function(SimpleGeometry) {
    "use strict";
    (0, $kcqLc._)(MultiPoint, SimpleGeometry);
    var _super = (0, $4jYWU._)(MultiPoint);
    function MultiPoint(coordinates, layout) {
        (0, $5sFFs._)(this, MultiPoint);
        var _this;
        _this = _super.call(this);
        if (layout && !Array.isArray(coordinates[0])) _this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else _this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
        return _this;
    }
    (0, $8O2fV._)(MultiPoint, [
        {
            /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */ key: "appendPoint",
            value: function appendPoint(point) {
                (0, $edee3659e50a93f4$export$8b58be045bf06082)(this.flatCoordinates, point.getFlatCoordinates());
                this.changed();
            }
        },
        {
            /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @api
   */ key: "clone",
            value: function clone() {
                var multiPoint = new MultiPoint(this.flatCoordinates.slice(), this.layout);
                multiPoint.applyProperties(this);
                return multiPoint;
            }
        },
        {
            /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ key: "closestPointXY",
            value: function closestPointXY(x, y, closestPoint, minSquaredDistance) {
                if (minSquaredDistance < (0, $e86e0aa087890eb8$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
                var flatCoordinates = this.flatCoordinates;
                var stride = this.stride;
                for(var i = 0, ii = flatCoordinates.length; i < ii; i += stride){
                    var squaredDistance = (0, $029c1e222d833501$export$88e6ebb4fe54f538)(x, y, flatCoordinates[i], flatCoordinates[i + 1]);
                    if (squaredDistance < minSquaredDistance) {
                        minSquaredDistance = squaredDistance;
                        for(var j = 0; j < stride; ++j)closestPoint[j] = flatCoordinates[i + j];
                        closestPoint.length = stride;
                    }
                }
                return minSquaredDistance;
            }
        },
        {
            /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   */ key: "getCoordinates",
            value: function getCoordinates() {
                return (0, $c51d6f1a0abb2d94$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
            }
        },
        {
            /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */ key: "getPoint",
            value: function getPoint(index) {
                var n = this.flatCoordinates.length / this.stride;
                if (index < 0 || n <= index) return null;
                return new (0, $b36c6ea9ae4054c8$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
            }
        },
        {
            /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */ key: "getPoints",
            value: function getPoints() {
                var flatCoordinates = this.flatCoordinates;
                var layout = this.layout;
                var stride = this.stride;
                /** @type {Array<Point>} */ var points = [];
                for(var i = 0, ii = flatCoordinates.length; i < ii; i += stride){
                    var point = new (0, $b36c6ea9ae4054c8$export$2e2bcd8739ae039)(flatCoordinates.slice(i, i + stride), layout);
                    points.push(point);
                }
                return points;
            }
        },
        {
            /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ key: "getType",
            value: function getType() {
                return "MultiPoint";
            }
        },
        {
            /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ key: "intersectsExtent",
            value: function intersectsExtent(extent) {
                var flatCoordinates = this.flatCoordinates;
                var stride = this.stride;
                for(var i = 0, ii = flatCoordinates.length; i < ii; i += stride){
                    var x = flatCoordinates[i];
                    var y = flatCoordinates[i + 1];
                    if ((0, $e86e0aa087890eb8$export$805bdfd6d6690e97)(extent, x, y)) return true;
                }
                return false;
            }
        },
        {
            /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ key: "setCoordinates",
            value: function setCoordinates(coordinates, layout) {
                this.setLayout(layout, coordinates, 1);
                if (!this.flatCoordinates) this.flatCoordinates = [];
                this.flatCoordinates.length = (0, $619b917ada0c75a6$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
                this.changed();
            }
        }
    ]);
    return MultiPoint;
}((0, $b8a34d748252df7d$export$2e2bcd8739ae039));
var $51f493e93d3b729a$export$2e2bcd8739ae039 = $51f493e93d3b729a$var$MultiPoint;

/**
 * @module ol/geom/MultiPolygon
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $4jYWU = parcelRequire("4jYWU");












/**
 * @module ol/geom/flat/center
 */ 
function $57a5bc1459094299$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    var flatCenters = [];
    var extent = (0, $e86e0aa087890eb8$export$fe201bb3bbe031e9)();
    for(var i = 0, ii = endss.length; i < ii; ++i){
        var ends = endss[i];
        extent = (0, $e86e0aa087890eb8$export$be0ab0bf96ca59ca)(flatCoordinates, offset, ends[0], stride);
        flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
        offset = ends[ends.length - 1];
    }
    return flatCenters;
}




/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */ var $33de805d38182bd6$var$MultiPolygon = /*#__PURE__*/ function(SimpleGeometry) {
    "use strict";
    (0, $kcqLc._)(MultiPolygon, SimpleGeometry);
    var _super = (0, $4jYWU._)(MultiPolygon);
    function MultiPolygon(coordinates, layout, endss) {
        (0, $5sFFs._)(this, MultiPolygon);
        var _this;
        _this = _super.call(this);
        /**
     * @type {Array<Array<number>>}
     * @private
     */ _this.endss_ = [];
        /**
     * @private
     * @type {number}
     */ _this.flatInteriorPointsRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ _this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {number}
     */ _this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ _this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ _this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ _this.orientedFlatCoordinates_ = null;
        if (!endss && !Array.isArray(coordinates[0])) {
            var polygons = /** @type {Array<Polygon>} */ coordinates;
            /** @type {Array<number>} */ var flatCoordinates = [];
            var thisEndss = [];
            for(var i = 0, ii = polygons.length; i < ii; ++i){
                var polygon = polygons[i];
                var offset = flatCoordinates.length;
                var ends = polygon.getEnds();
                for(var j = 0, jj = ends.length; j < jj; ++j)ends[j] += offset;
                (0, $edee3659e50a93f4$export$8b58be045bf06082)(flatCoordinates, polygon.getFlatCoordinates());
                thisEndss.push(ends);
            }
            layout = polygons.length === 0 ? _this.getLayout() : polygons[0].getLayout();
            coordinates = flatCoordinates;
            endss = thisEndss;
        }
        if (layout !== undefined && endss) {
            _this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            _this.endss_ = endss;
        } else _this.setCoordinates(/** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ coordinates, layout);
        return _this;
    }
    (0, $8O2fV._)(MultiPolygon, [
        {
            /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */ key: "appendPolygon",
            value: function appendPolygon(polygon) {
                /** @type {Array<number>} */ var ends;
                if (!this.flatCoordinates) {
                    this.flatCoordinates = polygon.getFlatCoordinates().slice();
                    ends = polygon.getEnds().slice();
                    this.endss_.push();
                } else {
                    var offset = this.flatCoordinates.length;
                    (0, $edee3659e50a93f4$export$8b58be045bf06082)(this.flatCoordinates, polygon.getFlatCoordinates());
                    ends = polygon.getEnds().slice();
                    for(var i = 0, ii = ends.length; i < ii; ++i)ends[i] += offset;
                }
                this.endss_.push(ends);
                this.changed();
            }
        },
        {
            /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @api
   */ key: "clone",
            value: function clone() {
                var len = this.endss_.length;
                var newEndss = new Array(len);
                for(var i = 0; i < len; ++i)newEndss[i] = this.endss_[i].slice();
                var multiPolygon = new MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
                multiPolygon.applyProperties(this);
                return multiPolygon;
            }
        },
        {
            /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ key: "closestPointXY",
            value: function closestPointXY(x, y, closestPoint, minSquaredDistance) {
                if (minSquaredDistance < (0, $e86e0aa087890eb8$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
                if (this.maxDeltaRevision_ != this.getRevision()) {
                    this.maxDelta_ = Math.sqrt((0, $7359464f07c6bbdb$export$37c18e6e7d50501a)(this.flatCoordinates, 0, this.endss_, this.stride, 0));
                    this.maxDeltaRevision_ = this.getRevision();
                }
                return (0, $7359464f07c6bbdb$export$60e067685eb8f9c4)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
            }
        },
        {
            /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ key: "containsXY",
            value: function containsXY(x, y) {
                return (0, $b261aa1bdd186388$export$c760d9d16cf92043)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
            }
        },
        {
            /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ key: "getArea",
            value: function getArea() {
                return (0, $d7e1f37d96190f57$export$78e139679ca7205)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
            }
        },
        {
            /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @api
   */ key: "getCoordinates",
            value: function getCoordinates(right) {
                var flatCoordinates;
                if (right !== undefined) {
                    flatCoordinates = this.getOrientedFlatCoordinates().slice();
                    (0, $a716268c87c20199$export$ea9ed55fc2a85010)(flatCoordinates, 0, this.endss_, this.stride, right);
                } else flatCoordinates = this.flatCoordinates;
                return (0, $c51d6f1a0abb2d94$export$915c7058aeb4dfeb)(flatCoordinates, 0, this.endss_, this.stride);
            }
        },
        {
            /**
   * @return {Array<Array<number>>} Endss.
   */ key: "getEndss",
            value: function getEndss() {
                return this.endss_;
            }
        },
        {
            /**
   * @return {Array<number>} Flat interior points.
   */ key: "getFlatInteriorPoints",
            value: function getFlatInteriorPoints() {
                if (this.flatInteriorPointsRevision_ != this.getRevision()) {
                    var flatCenters = (0, $57a5bc1459094299$export$78e139679ca7205)(this.flatCoordinates, 0, this.endss_, this.stride);
                    this.flatInteriorPoints_ = (0, $42d3f2f160e2d087$export$11463803eda8a372)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
                    this.flatInteriorPointsRevision_ = this.getRevision();
                }
                return /** @type {Array<number>} */ this.flatInteriorPoints_;
            }
        },
        {
            /**
   * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */ key: "getInteriorPoints",
            value: function getInteriorPoints() {
                return new (0, $51f493e93d3b729a$export$2e2bcd8739ae039)(this.getFlatInteriorPoints().slice(), "XYM");
            }
        },
        {
            /**
   * @return {Array<number>} Oriented flat coordinates.
   */ key: "getOrientedFlatCoordinates",
            value: function getOrientedFlatCoordinates() {
                if (this.orientedRevision_ != this.getRevision()) {
                    var flatCoordinates = this.flatCoordinates;
                    if ((0, $a716268c87c20199$export$a1d138f4bd85f4b4)(flatCoordinates, 0, this.endss_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
                    else {
                        this.orientedFlatCoordinates_ = flatCoordinates.slice();
                        this.orientedFlatCoordinates_.length = (0, $a716268c87c20199$export$ea9ed55fc2a85010)(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
                    }
                    this.orientedRevision_ = this.getRevision();
                }
                return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
            }
        },
        {
            /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiPolygon} Simplified MultiPolygon.
   * @protected
   */ key: "getSimplifiedGeometryInternal",
            value: function getSimplifiedGeometryInternal(squaredTolerance) {
                /** @type {Array<number>} */ var simplifiedFlatCoordinates = [];
                /** @type {Array<Array<number>>} */ var simplifiedEndss = [];
                simplifiedFlatCoordinates.length = (0, $a4f7faacf16083d1$export$b9acf67ef05cd17c)(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
                return new MultiPolygon(simplifiedFlatCoordinates, "XY", simplifiedEndss);
            }
        },
        {
            /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */ key: "getPolygon",
            value: function getPolygon(index) {
                if (index < 0 || this.endss_.length <= index) return null;
                var offset;
                if (index === 0) offset = 0;
                else {
                    var prevEnds = this.endss_[index - 1];
                    offset = prevEnds[prevEnds.length - 1];
                }
                var ends = this.endss_[index].slice();
                var end = ends[ends.length - 1];
                if (offset !== 0) for(var i = 0, ii = ends.length; i < ii; ++i)ends[i] -= offset;
                return new (0, $933385b05f7b89e7$export$2e2bcd8739ae039)(this.flatCoordinates.slice(offset, end), this.layout, ends);
            }
        },
        {
            /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */ key: "getPolygons",
            value: function getPolygons() {
                var layout = this.layout;
                var flatCoordinates = this.flatCoordinates;
                var endss = this.endss_;
                var polygons = [];
                var offset = 0;
                for(var i = 0, ii = endss.length; i < ii; ++i){
                    var ends = endss[i].slice();
                    var end = ends[ends.length - 1];
                    if (offset !== 0) for(var j = 0, jj = ends.length; j < jj; ++j)ends[j] -= offset;
                    var polygon = new (0, $933385b05f7b89e7$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout, ends);
                    polygons.push(polygon);
                    offset = end;
                }
                return polygons;
            }
        },
        {
            /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ key: "getType",
            value: function getType() {
                return "MultiPolygon";
            }
        },
        {
            /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ key: "intersectsExtent",
            value: function intersectsExtent(extent) {
                return (0, $065e72ea2e35a5d2$export$77b72fa3792f5bf0)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
            }
        },
        {
            /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ key: "setCoordinates",
            value: function setCoordinates(coordinates, layout) {
                this.setLayout(layout, coordinates, 3);
                if (!this.flatCoordinates) this.flatCoordinates = [];
                var endss = (0, $619b917ada0c75a6$export$f9f2bb59da4accd3)(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
                if (endss.length === 0) this.flatCoordinates.length = 0;
                else {
                    var lastEnds = endss[endss.length - 1];
                    this.flatCoordinates.length = lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
                }
                this.changed();
            }
        }
    ]);
    return MultiPolygon;
}((0, $b8a34d748252df7d$export$2e2bcd8739ae039));
var $33de805d38182bd6$export$2e2bcd8739ae039 = $33de805d38182bd6$var$MultiPolygon;













/**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'` or 'MultiLineString'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ var $151dd8d79e075f22$var$tmpTransform = (0, $afa6393b3817702c$export$185802fd694ee1f5)();
/**
 * Lightweight, read-only, {@link module:ol/Feature~Feature} and {@link module:ol/geom/Geometry~Geometry} like
 * structure, optimized for vector tile rendering and styling. Geometry access
 * through the API is limited to getting the type and extent of the geometry.
 */ var $151dd8d79e075f22$var$RenderFeature = /*#__PURE__*/ function() {
    "use strict";
    function RenderFeature(type, flatCoordinates, ends, stride, properties, id) {
        (0, $5sFFs._)(this, RenderFeature);
        /**
     * @type {import("../style/Style.js").StyleFunction|undefined}
     */ this.styleFunction;
        /**
     * @private
     * @type {import("../extent.js").Extent|undefined}
     */ this.extent_;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = id;
        /**
     * @private
     * @type {Type}
     */ this.type_ = type;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatCoordinates_ = flatCoordinates;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatMidpoints_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.ends_ = ends;
        /**
     * @private
     * @type {Object<string, *>}
     */ this.properties_ = properties;
        /**
     * @type {number}
     */ this.squaredTolerance_;
        /**
     * @type {number}
     */ this.stride_ = stride;
        /**
     * @private
     * @type {RenderFeature}
     */ this.simplifiedGeometry_;
    }
    (0, $8O2fV._)(RenderFeature, [
        {
            /**
   * Get a feature property by its key.
   * @param {string} key Key
   * @return {*} Value for the requested key.
   * @api
   */ key: "get",
            value: function get(key) {
                return this.properties_[key];
            }
        },
        {
            /**
   * Get the extent of this feature's geometry.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ key: "getExtent",
            value: function getExtent() {
                if (!this.extent_) this.extent_ = this.type_ === "Point" ? (0, $e86e0aa087890eb8$export$4838bf78d04a9440)(this.flatCoordinates_) : (0, $e86e0aa087890eb8$export$be0ab0bf96ca59ca)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2);
                return this.extent_;
            }
        },
        {
            /**
   * @return {Array<number>} Flat interior points.
   */ key: "getFlatInteriorPoint",
            value: function getFlatInteriorPoint() {
                if (!this.flatInteriorPoints_) {
                    var flatCenter = (0, $e86e0aa087890eb8$export$c91255cadecfe081)(this.getExtent());
                    this.flatInteriorPoints_ = (0, $42d3f2f160e2d087$export$50e3b25928a5e892)(this.flatCoordinates_, 0, /** @type {Array<number>} */ this.ends_, 2, flatCenter, 0);
                }
                return this.flatInteriorPoints_;
            }
        },
        {
            /**
   * @return {Array<number>} Flat interior points.
   */ key: "getFlatInteriorPoints",
            value: function getFlatInteriorPoints() {
                if (!this.flatInteriorPoints_) {
                    var ends = (0, $a716268c87c20199$export$cb72ae403d6e78e6)(this.flatCoordinates_, this.ends_);
                    var flatCenters = (0, $57a5bc1459094299$export$78e139679ca7205)(this.flatCoordinates_, 0, ends, 2);
                    this.flatInteriorPoints_ = (0, $42d3f2f160e2d087$export$11463803eda8a372)(this.flatCoordinates_, 0, ends, 2, flatCenters);
                }
                return this.flatInteriorPoints_;
            }
        },
        {
            /**
   * @return {Array<number>} Flat midpoint.
   */ key: "getFlatMidpoint",
            value: function getFlatMidpoint() {
                if (!this.flatMidpoints_) this.flatMidpoints_ = (0, $7ab9f917eb6f25a2$export$687ff82efd78795b)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, 0.5);
                return this.flatMidpoints_;
            }
        },
        {
            /**
   * @return {Array<number>} Flat midpoints.
   */ key: "getFlatMidpoints",
            value: function getFlatMidpoints() {
                if (!this.flatMidpoints_) {
                    this.flatMidpoints_ = [];
                    var flatCoordinates = this.flatCoordinates_;
                    var offset = 0;
                    var ends = /** @type {Array<number>} */ this.ends_;
                    for(var i = 0, ii = ends.length; i < ii; ++i){
                        var end = ends[i];
                        var midpoint = (0, $7ab9f917eb6f25a2$export$687ff82efd78795b)(flatCoordinates, offset, end, 2, 0.5);
                        (0, $edee3659e50a93f4$export$8b58be045bf06082)(this.flatMidpoints_, midpoint);
                        offset = end;
                    }
                }
                return this.flatMidpoints_;
            }
        },
        {
            /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is set when reading data from a remote source.
   * @return {number|string|undefined} Id.
   * @api
   */ key: "getId",
            value: function getId() {
                return this.id_;
            }
        },
        {
            /**
   * @return {Array<number>} Flat coordinates.
   */ key: "getOrientedFlatCoordinates",
            value: function getOrientedFlatCoordinates() {
                return this.flatCoordinates_;
            }
        },
        {
            /**
   * For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
   * determining the geometry type in style function (see {@link #getType}).
   * @return {RenderFeature} Feature.
   * @api
   */ key: "getGeometry",
            value: function getGeometry() {
                return this;
            }
        },
        {
            /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {RenderFeature} Simplified geometry.
   */ key: "getSimplifiedGeometry",
            value: function getSimplifiedGeometry(squaredTolerance) {
                return this;
            }
        },
        {
            /**
   * Get a transformed and simplified version of the geometry.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {RenderFeature} Simplified geometry.
   */ key: "simplifyTransformed",
            value: function simplifyTransformed(squaredTolerance, transform) {
                return this;
            }
        },
        {
            /**
   * Get the feature properties.
   * @return {Object<string, *>} Feature properties.
   * @api
   */ key: "getProperties",
            value: function getProperties() {
                return this.properties_;
            }
        },
        {
            /**
   * Get an object of all property names and values.  This has the same behavior as getProperties,
   * but is here to conform with the {@link module:ol/Feature~Feature} interface.
   * @return {Object<string, *>?} Object.
   */ key: "getPropertiesInternal",
            value: function getPropertiesInternal() {
                return this.properties_;
            }
        },
        {
            /**
   * @return {number} Stride.
   */ key: "getStride",
            value: function getStride() {
                return this.stride_;
            }
        },
        {
            /**
   * @return {import('../style/Style.js').StyleFunction|undefined} Style
   */ key: "getStyleFunction",
            value: function getStyleFunction() {
                return this.styleFunction;
            }
        },
        {
            /**
   * Get the type of this feature's geometry.
   * @return {Type} Geometry type.
   * @api
   */ key: "getType",
            value: function getType() {
                return this.type_;
            }
        },
        {
            /**
   * Transform geometry coordinates from tile pixel space to projected.
   *
   * @param {import("../proj.js").ProjectionLike} projection The data projection
   */ key: "transform",
            value: function transform(projection) {
                projection = (0, $401a58d9dec354c1$export$3988ae62b71be9a3)(projection);
                var pixelExtent = projection.getExtent();
                var projectedExtent = projection.getWorldExtent();
                if (pixelExtent && projectedExtent) {
                    var scale = (0, $e86e0aa087890eb8$export$c08559766941f856)(projectedExtent) / (0, $e86e0aa087890eb8$export$c08559766941f856)(pixelExtent);
                    (0, $afa6393b3817702c$export$f672e0b6f7222cd7)($151dd8d79e075f22$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
                    (0, $c8fb0baeba325f5c$export$b92b2dedcfff79de)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, $151dd8d79e075f22$var$tmpTransform, this.flatCoordinates_);
                }
            }
        },
        {
            /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   */ key: "applyTransform",
            value: function applyTransform(transformFn) {
                transformFn(this.flatCoordinates_, this.flatCoordinates_, this.stride_);
            }
        },
        {
            /**
   * @return {RenderFeature} A cloned render feature.
   */ key: "clone",
            value: function clone() {
                return new RenderFeature(this.type_, this.flatCoordinates_.slice(), this.ends_.slice(), this.stride_, Object.assign({}, this.properties_), this.id_);
            }
        },
        {
            /**
   * @return {Array<number>} Ends.
   */ key: "getEnds",
            value: function getEnds() {
                return this.ends_;
            }
        },
        {
            /**
   * Add transform and resolution based geometry simplification to this instance.
   * @return {RenderFeature} This render feature.
   */ key: "enableSimplifyTransformed",
            value: function enableSimplifyTransformed() {
                var _this = this;
                this.simplifyTransformed = (0, $d0c140d5afad5e7c$export$ff83df6f9971435f)(function(squaredTolerance, transform) {
                    if (squaredTolerance === _this.squaredTolerance_) return _this.simplifiedGeometry_;
                    _this.simplifiedGeometry_ = _this.clone();
                    if (transform) _this.simplifiedGeometry_.applyTransform(transform);
                    var simplifiedFlatCoordinates = _this.simplifiedGeometry_.getFlatCoordinates();
                    var simplifiedEnds;
                    switch(_this.type_){
                        case "LineString":
                            simplifiedFlatCoordinates.length = (0, $a4f7faacf16083d1$export$ef693d1572e64fb8)(simplifiedFlatCoordinates, 0, _this.simplifiedGeometry_.flatCoordinates_.length, _this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0);
                            simplifiedEnds = [
                                simplifiedFlatCoordinates.length
                            ];
                            break;
                        case "MultiLineString":
                            simplifiedEnds = [];
                            simplifiedFlatCoordinates.length = (0, $a4f7faacf16083d1$export$cedb9900c0b225c2)(simplifiedFlatCoordinates, 0, _this.simplifiedGeometry_.ends_, _this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
                            break;
                        case "Polygon":
                            simplifiedEnds = [];
                            simplifiedFlatCoordinates.length = (0, $a4f7faacf16083d1$export$60a9904b67f8d51b)(simplifiedFlatCoordinates, 0, _this.simplifiedGeometry_.ends_, _this.simplifiedGeometry_.stride_, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
                            break;
                        default:
                    }
                    if (simplifiedEnds) _this.simplifiedGeometry_ = new RenderFeature(_this.type_, simplifiedFlatCoordinates, simplifiedEnds, 2, _this.properties_, _this.id_);
                    _this.squaredTolerance_ = squaredTolerance;
                    return _this.simplifiedGeometry_;
                });
                return this;
            }
        }
    ]);
    return RenderFeature;
}();
/**
 * @return {Array<number>} Flat coordinates.
 */ $151dd8d79e075f22$var$RenderFeature.prototype.getFlatCoordinates = $151dd8d79e075f22$var$RenderFeature.prototype.getOrientedFlatCoordinates;
function $151dd8d79e075f22$export$b89ab3d1d30dec84(renderFeature) {
    var geometryType = renderFeature.getType();
    switch(geometryType){
        case "Point":
            return new (0, $b36c6ea9ae4054c8$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates());
        case "MultiPoint":
            return new (0, $51f493e93d3b729a$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), "XY");
        case "LineString":
            return new (0, $537ebc1a5b36dd8c$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), "XY");
        case "MultiLineString":
            return new (0, $81a9b9a6cbf91c4e$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), "XY", /** @type {Array<number>} */ renderFeature.getEnds());
        case "Polygon":
            var flatCoordinates = renderFeature.getFlatCoordinates();
            var ends = /** @type {Array<number>} */ renderFeature.getEnds();
            var endss = (0, $a716268c87c20199$export$cb72ae403d6e78e6)(flatCoordinates, ends);
            return endss.length > 1 ? new (0, $33de805d38182bd6$export$2e2bcd8739ae039)(flatCoordinates, "XY", endss) : new (0, $933385b05f7b89e7$export$2e2bcd8739ae039)(flatCoordinates, "XY", ends);
        default:
            throw new Error("Invalid geometry type:" + geometryType);
    }
}
function $151dd8d79e075f22$export$ab19ba60efd1c4b5(renderFeature, geometryName) {
    var id = renderFeature.getId();
    var geometry = $151dd8d79e075f22$export$b89ab3d1d30dec84(renderFeature);
    var properties = renderFeature.getProperties();
    var feature = new (0, $a0674ee7b31c3fe1$export$2e2bcd8739ae039)();
    if (geometryName !== undefined) feature.setGeometryName(geometryName);
    feature.setGeometry(geometry);
    if (id !== undefined) feature.setId(id);
    feature.setProperties(properties, true);
    return feature;
}
var $151dd8d79e075f22$export$2e2bcd8739ae039 = $151dd8d79e075f22$var$RenderFeature;



/**
 * @module ol/source/VectorEventType
 */ /**
 * @enum {string}
 */ var $5c35915412afad46$export$2e2bcd8739ae039 /**
 * @typedef {'addfeature'|'changefeature'|'clear'|'removefeature'|'featuresloadstart'|'featuresloadend'|'featuresloaderror'} VectorSourceEventTypes
 */  = {
    /**
   * Triggered when a feature is added to the source.
   * @event module:ol/source/Vector.VectorSourceEvent#addfeature
   * @api
   */ ADDFEATURE: "addfeature",
    /**
   * Triggered when a feature is updated.
   * @event module:ol/source/Vector.VectorSourceEvent#changefeature
   * @api
   */ CHANGEFEATURE: "changefeature",
    /**
   * Triggered when the clear method is called on the source.
   * @event module:ol/source/Vector.VectorSourceEvent#clear
   * @api
   */ CLEAR: "clear",
    /**
   * Triggered when a feature is removed from the source.
   * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
   * @event module:ol/source/Vector.VectorSourceEvent#removefeature
   * @api
   */ REMOVEFEATURE: "removefeature",
    /**
   * Triggered when features starts loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
   * @api
   */ FEATURESLOADSTART: "featuresloadstart",
    /**
   * Triggered when features finishes loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
   * @api
   */ FEATURESLOADEND: "featuresloadend",
    /**
   * Triggered if feature loading results in an error.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
   * @api
   */ FEATURESLOADERROR: "featuresloaderror"
};



/**
 * @module ol/loadingstrategy
 */ 
function $62239d03b7063ffc$export$84bf76cd7afc7469(extent, resolution) {
    return [
        [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ]
    ];
}
function $62239d03b7063ffc$export$bf67010aacbe66fa(extent, resolution) {
    return [
        extent
    ];
}
function $62239d03b7063ffc$export$3c17558da18e4d75(tileGrid) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj.js").Projection} projection Projection.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */ function(extent, resolution, projection) {
        var z = tileGrid.getZForResolution((0, $401a58d9dec354c1$export$bd1cd3b88140b906)(resolution, projection));
        var tileRange = tileGrid.getTileRangeForExtentAndZ((0, $401a58d9dec354c1$export$494be3a3a25689ca)(extent, projection), z);
        /** @type {Array<import("./extent.js").Extent>} */ var extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */ var tileCoord = [
            z,
            0,
            0
        ];
        for(tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1])for(tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2])extents.push((0, $401a58d9dec354c1$export$96bfd09e2cffb006)(tileGrid.getTileCoordExtent(tileCoord), projection));
        return extents;
    });
}








/**
 * @module ol/featureloader
 */ 
/**
 *
 * @type {boolean}
 * @private
 */ var $e8ea4f2976c6d18d$var$withCredentials = false;
function $e8ea4f2976c6d18d$export$441d7b57adab24d0(url, format, extent, resolution, projection, success, failure) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", typeof url === "function" ? url(extent, resolution, projection) : url, true);
    if (format.getType() == "arraybuffer") xhr.responseType = "arraybuffer";
    xhr.withCredentials = $e8ea4f2976c6d18d$var$withCredentials;
    /**
   * @param {Event} event Event.
   * @private
   */ xhr.onload = function(event) {
        // status will be 0 for file:// urls
        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
            var type = format.getType();
            /** @type {Document|Node|Object|string|undefined} */ var source;
            if (type == "json") source = JSON.parse(xhr.responseText);
            else if (type == "text") source = xhr.responseText;
            else if (type == "xml") {
                source = xhr.responseXML;
                if (!source) source = new DOMParser().parseFromString(xhr.responseText, "application/xml");
            } else if (type == "arraybuffer") source = /** @type {ArrayBuffer} */ xhr.response;
            if (source) success(/** @type {Array<import("./Feature.js").default>} */ format.readFeatures(source, {
                extent: extent,
                featureProjection: projection
            }), format.readProjection(source));
            else failure();
        } else failure();
    };
    /**
   * @private
   */ xhr.onerror = failure;
    xhr.send();
}
function $e8ea4f2976c6d18d$export$14cc81df70b6707e(url, format) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("./proj/Projection.js").default} projection Projection.
   * @param {function(Array<import("./Feature.js").default>): void} [success] Success
   *      Function called when loading succeeded.
   * @param {function(): void} [failure] Failure
   *      Function called when loading failed.
   */ return function(extent, resolution, projection, success, failure) {
        var source = /** @type {import("./source/Vector").default} */ this;
        $e8ea4f2976c6d18d$export$441d7b57adab24d0(url, format, extent, resolution, projection, /**
       * @param {Array<import("./Feature.js").default>} features The loaded features.
       * @param {import("./proj/Projection.js").default} dataProjection Data
       * projection.
       */ function(features, dataProjection) {
            source.addFeatures(features);
            if (success !== undefined) success(features);
        }, /* FIXME handle error */ failure ? failure : (0, $d0c140d5afad5e7c$export$1cd1943b3a73bbe8));
    };
}
function $e8ea4f2976c6d18d$export$36fa6977a6d0d8fe(xhrWithCredentials) {
    $e8ea4f2976c6d18d$var$withCredentials = xhrWithCredentials;
}


var $b683658cb5a35baa$export$d402fd02dc2b661c = /*#__PURE__*/ function(Event) {
    "use strict";
    (0, $kcqLc._)(VectorSourceEvent, Event);
    var _super = (0, $4jYWU._)(VectorSourceEvent);
    function VectorSourceEvent(type, feature, features) {
        (0, $5sFFs._)(this, VectorSourceEvent);
        var _this;
        _this = _super.call(this, type);
        /**
     * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
     * @type {FeatureClass|undefined}
     * @api
     */ _this.feature = feature;
        /**
     * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
     * @type {Array<FeatureClass>|undefined}
     * @api
     */ _this.features = features;
        return _this;
    }
    return VectorSourceEvent;
}((0, $aBSBL._)((0, $1a4702ad15857f9a$export$2e2bcd8739ae039)));
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./VectorEventType").VectorSourceEventTypes, VectorSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./VectorEventType").VectorSourceEventTypes, Return>} VectorSourceOnSignature
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureClass=import("../Feature.js").default]
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<FeatureClass>|Collection<FeatureClass>} [features]
 * Features. If provided as {@link module:ol/Collection~Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader. The `'featuresloadend'` and `'featuresloaderror'` events
 * will only fire if the `success` and `failure` callbacks are used.
 *
 * Example:
 *
 * ```js
 * import Vector from 'ol/source/Vector.js';
 * import GeoJSON from 'ol/format/GeoJSON.js';
 * import {bbox} from 'ol/loadingstrategy.js';
 *
 * const vectorSource = new Vector({
 *   format: new GeoJSON(),
 *   loader: function(extent, resolution, projection, success, failure) {
 *      const proj = projection.getCode();
 *      const url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json&srsname=' + proj + '&' +
 *          'bbox=' + extent.join(',') + ',' + proj;
 *      const xhr = new XMLHttpRequest();
 *      xhr.open('GET', url);
 *      const onError = function() {
 *        vectorSource.removeLoadedExtent(extent);
 *        failure();
 *      }
 *      xhr.onerror = onError;
 *      xhr.onload = function() {
 *        if (xhr.status == 200) {
 *          const features = vectorSource.getFormat().readFeatures(xhr.responseText);
 *          vectorSource.addFeatures(features);
 *          success(features);
 *        } else {
 *          onError();
 *        }
 *      }
 *      xhr.send();
 *    },
 *    strategy: bbox,
 *  });
 * ```
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy.all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader.xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy.all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection~Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */ /**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../Feature.js").FeatureLike} [FeatureClass=import("../Feature.js").default]
 */ var $b683658cb5a35baa$var$VectorSource = /*#__PURE__*/ function(Source) {
    "use strict";
    (0, $kcqLc._)(VectorSource, Source);
    var _super = (0, $4jYWU._)(VectorSource);
    function VectorSource(options) {
        (0, $5sFFs._)(this, VectorSource);
        var _this;
        options = options || {};
        _this = _super.call(this, {
            attributions: options.attributions,
            interpolate: true,
            projection: undefined,
            state: "ready",
            wrapX: options.wrapX !== undefined ? options.wrapX : true
        });
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey>}
     */ _this.on;
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey>}
     */ _this.once;
        /***
     * @type {VectorSourceOnSignature<void>}
     */ _this.un;
        /**
     * @private
     * @type {import("../featureloader.js").FeatureLoader}
     */ _this.loader_ = (0, $d0c140d5afad5e7c$export$1cd1943b3a73bbe8);
        /**
     * @private
     * @type {import("../format/Feature.js").default|undefined}
     */ _this.format_ = options.format;
        /**
     * @private
     * @type {boolean}
     */ _this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        /**
     * @private
     * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
     */ _this.url_ = options.url;
        if (options.loader !== undefined) _this.loader_ = options.loader;
        else if (_this.url_ !== undefined) {
            (0, $100b4414e338a711$export$a7a9523472993e97)(_this.format_, "`format` must be set when `url` is set");
            // create a XHR feature loader for "url" and "format"
            _this.loader_ = (0, $e8ea4f2976c6d18d$export$14cc81df70b6707e)(_this.url_, /** @type {import("../format/Feature.js").default} */ _this.format_);
        }
        /**
     * @private
     * @type {LoadingStrategy}
     */ _this.strategy_ = options.strategy !== undefined ? options.strategy : (0, $62239d03b7063ffc$export$84bf76cd7afc7469);
        var useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
     * @private
     * @type {RBush<FeatureClass>}
     */ _this.featuresRtree_ = useSpatialIndex ? new (0, $efe39ba4adef2e95$export$2e2bcd8739ae039)() : null;
        /**
     * @private
     * @type {RBush<{extent: import("../extent.js").Extent}>}
     */ _this.loadedExtentsRtree_ = new (0, $efe39ba4adef2e95$export$2e2bcd8739ae039)();
        /**
     * @type {number}
     * @private
     */ _this.loadingExtentsCount_ = 0;
        /**
     * @private
     * @type {!Object<string, FeatureClass>}
     */ _this.nullGeometryFeatures_ = {};
        /**
     * A lookup of features by id (the return from feature.getId()).
     * @private
     * @type {!Object<string, FeatureClass|Array<RenderFeature>>}
     */ _this.idIndex_ = {};
        /**
     * A lookup of features by uid (using getUid(feature)).
     * @private
     * @type {!Object<string, FeatureClass>}
     */ _this.uidIndex_ = {};
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ _this.featureChangeKeys_ = {};
        /**
     * @private
     * @type {Collection<FeatureClass>|null}
     */ _this.featuresCollection_ = null;
        /** @type {Collection<FeatureClass>} */ var collection;
        /** @type {Array<FeatureClass>} */ var features;
        if (Array.isArray(options.features)) features = options.features;
        else if (options.features) {
            collection = options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) collection = new (0, $4586ff11f2e741e8$export$2e2bcd8739ae039)(features);
        if (features !== undefined) _this.addFeaturesInternal(features);
        if (collection !== undefined) _this.bindFeaturesCollection_(collection);
        return _this;
    }
    (0, $8O2fV._)(VectorSource, [
        {
            /**
   * Add a single feature to the source.  If you want to add a batch of features
   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
   * instead. A feature will not be added to the source if feature with
   * the same id is already there. The reason for this behavior is to avoid
   * feature duplication when using bbox or tile loading strategies.
   * Note: this also applies if an {@link module:ol/Collection~Collection} is used for features,
   * meaning that if a feature with a duplicate id is added in the collection, it will
   * be removed from it right away.
   * @param {FeatureClass} feature Feature to add.
   * @api
   */ key: "addFeature",
            value: function addFeature(feature) {
                this.addFeatureInternal(feature);
                this.changed();
            }
        },
        {
            /**
   * Add a feature without firing a `change` event.
   * @param {FeatureClass} feature Feature.
   * @protected
   */ key: "addFeatureInternal",
            value: function addFeatureInternal(feature) {
                var featureKey = (0, $8b32fff2376556ef$export$5e82334337e0f204)(feature);
                if (!this.addToIndex_(featureKey, feature)) {
                    if (this.featuresCollection_) this.featuresCollection_.remove(feature);
                    return;
                }
                this.setupChangeEvents_(featureKey, feature);
                var geometry = feature.getGeometry();
                if (geometry) {
                    var extent = geometry.getExtent();
                    if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
                } else this.nullGeometryFeatures_[featureKey] = feature;
                this.dispatchEvent(new $b683658cb5a35baa$export$d402fd02dc2b661c((0, $5c35915412afad46$export$2e2bcd8739ae039).ADDFEATURE, feature));
            }
        },
        {
            /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureClass} feature The feature.
   * @private
   */ key: "setupChangeEvents_",
            value: function setupChangeEvents_(featureKey, feature) {
                if (feature instanceof (0, $151dd8d79e075f22$export$2e2bcd8739ae039)) return;
                this.featureChangeKeys_[featureKey] = [
                    (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(feature, (0, $f5ea4d8d74b7a514$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_, this),
                    (0, $5b08b5a7fd85a110$export$63174c828edd6ff8)(feature, (0, $feee417cd33a5f20$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_, this)
                ];
            }
        },
        {
            /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureClass} feature The feature.
   * @return {boolean} The feature is "valid", in the sense that it is also a
   *     candidate for insertion into the Rtree.
   * @private
   */ key: "addToIndex_",
            value: function addToIndex_(featureKey, feature) {
                var valid = true;
                if (feature.getId() !== undefined) {
                    var id = String(feature.getId());
                    if (!(id in this.idIndex_)) this.idIndex_[id] = feature;
                    else if (feature instanceof (0, $151dd8d79e075f22$export$2e2bcd8739ae039)) {
                        var indexedFeature = this.idIndex_[id];
                        if (!(indexedFeature instanceof (0, $151dd8d79e075f22$export$2e2bcd8739ae039))) valid = false;
                        else if (!Array.isArray(indexedFeature)) this.idIndex_[id] = [
                            indexedFeature,
                            feature
                        ];
                        else indexedFeature.push(feature);
                    } else valid = false;
                }
                if (valid) {
                    (0, $100b4414e338a711$export$a7a9523472993e97)(!(featureKey in this.uidIndex_), "The passed `feature` was already added to the source");
                    this.uidIndex_[featureKey] = feature;
                }
                return valid;
            }
        },
        {
            /**
   * Add a batch of features to the source.
   * @param {Array<FeatureClass>} features Features to add.
   * @api
   */ key: "addFeatures",
            value: function addFeatures(features) {
                this.addFeaturesInternal(features);
                this.changed();
            }
        },
        {
            /**
   * Add features without firing a `change` event.
   * @param {Array<FeatureClass>} features Features.
   * @protected
   */ key: "addFeaturesInternal",
            value: function addFeaturesInternal(features) {
                var extents = [];
                /** @type {Array<FeatureClass>} */ var newFeatures = [];
                /** @type Array<FeatureClass> */ var geometryFeatures = [];
                for(var i = 0, length = features.length; i < length; i++){
                    var feature = features[i];
                    var featureKey = (0, $8b32fff2376556ef$export$5e82334337e0f204)(feature);
                    if (this.addToIndex_(featureKey, feature)) newFeatures.push(feature);
                }
                for(var i1 = 0, length1 = newFeatures.length; i1 < length1; i1++){
                    var feature1 = newFeatures[i1];
                    var featureKey1 = (0, $8b32fff2376556ef$export$5e82334337e0f204)(feature1);
                    this.setupChangeEvents_(featureKey1, feature1);
                    var geometry = feature1.getGeometry();
                    if (geometry) {
                        var extent = geometry.getExtent();
                        extents.push(extent);
                        geometryFeatures.push(feature1);
                    } else this.nullGeometryFeatures_[featureKey1] = feature1;
                }
                if (this.featuresRtree_) this.featuresRtree_.load(extents, geometryFeatures);
                if (this.hasListener((0, $5c35915412afad46$export$2e2bcd8739ae039).ADDFEATURE)) for(var i2 = 0, length2 = newFeatures.length; i2 < length2; i2++)this.dispatchEvent(new $b683658cb5a35baa$export$d402fd02dc2b661c((0, $5c35915412afad46$export$2e2bcd8739ae039).ADDFEATURE, newFeatures[i2]));
            }
        },
        {
            /**
   * @param {!Collection<FeatureClass>} collection Collection.
   * @private
   */ key: "bindFeaturesCollection_",
            value: function bindFeaturesCollection_(collection) {
                var _this = this;
                var modifyingCollection = false;
                this.addEventListener((0, $5c35915412afad46$export$2e2bcd8739ae039).ADDFEATURE, /**
       * @param {VectorSourceEvent<FeatureClass>} evt The vector source event
       */ function(evt) {
                    if (!modifyingCollection) {
                        modifyingCollection = true;
                        collection.push(evt.feature);
                        modifyingCollection = false;
                    }
                });
                this.addEventListener((0, $5c35915412afad46$export$2e2bcd8739ae039).REMOVEFEATURE, /**
       * @param {VectorSourceEvent<FeatureClass>} evt The vector source event
       */ function(evt) {
                    if (!modifyingCollection) {
                        modifyingCollection = true;
                        collection.remove(evt.feature);
                        modifyingCollection = false;
                    }
                });
                collection.addEventListener((0, $521f555f87c855d9$export$2e2bcd8739ae039).ADD, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureClass>} evt The collection event
       */ function(evt) {
                    if (!modifyingCollection) {
                        modifyingCollection = true;
                        _this.addFeature(evt.element);
                        modifyingCollection = false;
                    }
                });
                collection.addEventListener((0, $521f555f87c855d9$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureClass>} evt The collection event
       */ function(evt) {
                    if (!modifyingCollection) {
                        modifyingCollection = true;
                        _this.removeFeature(evt.element);
                        modifyingCollection = false;
                    }
                });
                this.featuresCollection_ = collection;
            }
        },
        {
            /**
   * Remove all features from the source.
   * @param {boolean} [fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature} events.
   * @api
   */ key: "clear",
            value: function clear(fast) {
                var _this = this;
                if (fast) {
                    for(var featureId in this.featureChangeKeys_){
                        var keys = this.featureChangeKeys_[featureId];
                        keys.forEach((0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921));
                    }
                    if (!this.featuresCollection_) {
                        this.featureChangeKeys_ = {};
                        this.idIndex_ = {};
                        this.uidIndex_ = {};
                    }
                } else if (this.featuresRtree_) {
                    var removeAndIgnoreReturn = function(feature) {
                        _this.removeFeatureInternal(feature);
                    };
                    this.featuresRtree_.forEach(removeAndIgnoreReturn);
                    for(var id in this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
                }
                if (this.featuresCollection_) this.featuresCollection_.clear();
                if (this.featuresRtree_) this.featuresRtree_.clear();
                this.nullGeometryFeatures_ = {};
                var clearEvent = new $b683658cb5a35baa$export$d402fd02dc2b661c((0, $5c35915412afad46$export$2e2bcd8739ae039).CLEAR);
                this.dispatchEvent(clearEvent);
                this.changed();
            }
        },
        {
            /**
   * Iterate through all features on the source, calling the provided callback
   * with each one.  If the callback returns any "truthy" value, iteration will
   * stop and the function will return the same value.
   * Note: this function only iterate through the feature that have a defined geometry.
   *
   * @param {function(FeatureClass): T} callback Called with each feature
   *     on the source.  Return a truthy value to stop iteration.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ key: "forEachFeature",
            value: function forEachFeature(callback) {
                if (this.featuresRtree_) return this.featuresRtree_.forEach(callback);
                if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
            }
        },
        {
            /**
   * Iterate through all features whose geometries contain the provided
   * coordinate, calling the callback with each feature.  If the callback returns
   * a "truthy" value, iteration will stop and the function will return the same
   * value.
   *
   * For {@link module:ol/render/Feature~RenderFeature} features, the callback will be
   * called for all features.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureClass): T} callback Called with each feature
   *     whose goemetry contains the provided coordinate.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   */ key: "forEachFeatureAtCoordinateDirect",
            value: function forEachFeatureAtCoordinateDirect(coordinate, callback) {
                var extent = [
                    coordinate[0],
                    coordinate[1],
                    coordinate[0],
                    coordinate[1]
                ];
                return this.forEachFeatureInExtent(extent, function(feature) {
                    var geometry = feature.getGeometry();
                    if (geometry instanceof (0, $151dd8d79e075f22$export$2e2bcd8739ae039) || geometry.intersectsCoordinate(coordinate)) return callback(feature);
                    return undefined;
                });
            }
        },
        {
            /**
   * Iterate through all features whose bounding box intersects the provided
   * extent (note that the feature's geometry may not intersect the extent),
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you are interested in features whose geometry intersects an extent, call
   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
   *
   * When `useSpatialIndex` is set to false, this method will loop through all
   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureClass): T} callback Called with each feature
   *     whose bounding box intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ key: "forEachFeatureInExtent",
            value: function forEachFeatureInExtent(extent, callback) {
                if (this.featuresRtree_) return this.featuresRtree_.forEachInExtent(extent, callback);
                if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
            }
        },
        {
            /**
   * Iterate through all features whose geometry intersects the provided extent,
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you only want to test for bounding box intersection, call the
   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureClass): T} callback Called with each feature
   *     whose geometry intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ key: "forEachFeatureIntersectingExtent",
            value: function forEachFeatureIntersectingExtent(extent, callback) {
                return this.forEachFeatureInExtent(extent, /**
       * @param {FeatureClass} feature Feature.
       * @return {T|undefined} The return value from the last call to the callback.
       */ function(feature) {
                    var geometry = feature.getGeometry();
                    if (geometry instanceof (0, $151dd8d79e075f22$export$2e2bcd8739ae039) || geometry.intersectsExtent(extent)) {
                        var result = callback(feature);
                        if (result) return result;
                    }
                });
            }
        },
        {
            /**
   * Get the features collection associated with this source. Will be `null`
   * unless the source was configured with `useSpatialIndex` set to `false`, or
   * with an {@link module:ol/Collection~Collection} as `features`.
   * @return {Collection<FeatureClass>|null} The collection of features.
   * @api
   */ key: "getFeaturesCollection",
            value: function getFeaturesCollection() {
                return this.featuresCollection_;
            }
        },
        {
            /**
   * Get a snapshot of the features currently on the source in random order. The returned array
   * is a copy, the features are references to the features in the source.
   * @return {Array<FeatureClass>} Features.
   * @api
   */ key: "getFeatures",
            value: function getFeatures() {
                var features;
                if (this.featuresCollection_) features = this.featuresCollection_.getArray().slice(0);
                else if (this.featuresRtree_) {
                    features = this.featuresRtree_.getAll();
                    if (!(0, $29e93681307ffd1e$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_)) (0, $edee3659e50a93f4$export$8b58be045bf06082)(features, Object.values(this.nullGeometryFeatures_));
                }
                return features;
            }
        },
        {
            /**
   * Get all features whose geometry intersects the provided coordinate.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   */ key: "getFeaturesAtCoordinate",
            value: function getFeaturesAtCoordinate(coordinate) {
                var features = [];
                this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
                    features.push(feature);
                });
                return features;
            }
        },
        {
            /**
   * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
   * all features intersecting the given extent in random order (so it may include
   * features whose geometries do not intersect the extent).
   *
   * When `useSpatialIndex` is set to false, this method will return all
   * features.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {import("../proj/Projection.js").default} [projection] Include features
   * where `extent` exceeds the x-axis bounds of `projection` and wraps around the world.
   * @return {Array<FeatureClass>} Features.
   * @api
   */ key: "getFeaturesInExtent",
            value: function getFeaturesInExtent(extent, projection) {
                var _this = this;
                if (this.featuresRtree_) {
                    var _instance;
                    var multiWorld = projection && projection.canWrapX() && this.getWrapX();
                    if (!multiWorld) return this.featuresRtree_.getInExtent(extent);
                    var extents = (0, $e86e0aa087890eb8$export$9031237f01de0947)(extent, projection);
                    return (_instance = []).concat.apply(_instance, (0, $fyztb._)(extents.map(function(anExtent) {
                        return _this.featuresRtree_.getInExtent(anExtent);
                    })));
                }
                if (this.featuresCollection_) return this.featuresCollection_.getArray().slice(0);
                return [];
            }
        },
        {
            /**
   * Get the closest feature to the provided coordinate.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false` and the features in this source are of type
   * {@link module:ol/Feature~Feature}.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureClass):boolean} [filter] Feature filter function.
   *     The filter function will receive one argument, the {@link module:ol/Feature~Feature feature}
   *     and it should return a boolean value. By default, no filtering is made.
   * @return {FeatureClass} Closest feature.
   * @api
   */ key: "getClosestFeatureToCoordinate",
            value: function getClosestFeatureToCoordinate(coordinate, filter) {
                // Find the closest feature using branch and bound.  We start searching an
                // infinite extent, and find the distance from the first feature found.  This
                // becomes the closest feature.  We then compute a smaller extent which any
                // closer feature must intersect.  We continue searching with this smaller
                // extent, trying to find a closer feature.  Every time we find a closer
                // feature, we update the extent being searched so that any even closer
                // feature must intersect it.  We continue until we run out of features.
                var x = coordinate[0];
                var y = coordinate[1];
                var closestFeature = null;
                var closestPoint = [
                    NaN,
                    NaN
                ];
                var minSquaredDistance = Infinity;
                var extent = [
                    -Infinity,
                    -Infinity,
                    Infinity,
                    Infinity
                ];
                filter = filter ? filter : (0, $d0c140d5afad5e7c$export$22e23a2304399231);
                this.featuresRtree_.forEachInExtent(extent, /**
       * @param {FeatureClass} feature Feature.
       */ function(feature) {
                    if (filter(feature)) {
                        var geometry = feature.getGeometry();
                        var previousMinSquaredDistance = minSquaredDistance;
                        minSquaredDistance = geometry instanceof (0, $151dd8d79e075f22$export$2e2bcd8739ae039) ? 0 : geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                        if (minSquaredDistance < previousMinSquaredDistance) {
                            closestFeature = feature;
                            // This is sneaky.  Reduce the extent that it is currently being
                            // searched while the R-Tree traversal using this same extent object
                            // is still in progress.  This is safe because the new extent is
                            // strictly contained by the old extent.
                            var minDistance = Math.sqrt(minSquaredDistance);
                            extent[0] = x - minDistance;
                            extent[1] = y - minDistance;
                            extent[2] = x + minDistance;
                            extent[3] = y + minDistance;
                        }
                    }
                });
                return closestFeature;
            }
        },
        {
            /**
   * Get the extent of the features currently in the source.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent} [extent] Destination extent. If provided, no new extent
   *     will be created. Instead, that extent's coordinates will be overwritten.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ key: "getExtent",
            value: function getExtent(extent) {
                return this.featuresRtree_.getExtent(extent);
            }
        },
        {
            /**
   * Get a feature by its identifier (the value returned by feature.getId()). When `RenderFeature`s
   * are used, `getFeatureById()` can return an array of `RenderFeature`s. This allows for handling
   * of `GeometryCollection` geometries, where format readers create one `RenderFeature` per
   * `GeometryCollection` member.
   * Note that the index treats string and numeric identifiers as the same.  So
   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
   *
   * @param {string|number} id Feature identifier.
   * @return {FeatureClass|Array<RenderFeature>|null} The feature (or `null` if not found).
   * @api
   */ key: "getFeatureById",
            value: function getFeatureById(id) {
                var feature = this.idIndex_[id.toString()];
                return feature !== undefined ? feature : null;
            }
        },
        {
            /**
   * Get a feature by its internal unique identifier (using `getUid`).
   *
   * @param {string} uid Feature identifier.
   * @return {FeatureClass|null} The feature (or `null` if not found).
   */ key: "getFeatureByUid",
            value: function getFeatureByUid(uid) {
                var feature = this.uidIndex_[uid];
                return feature !== undefined ? feature : null;
            }
        },
        {
            /**
   * Get the format associated with this source.
   *
   * @return {import("../format/Feature.js").default|undefined} The feature format.
   * @api
   */ key: "getFormat",
            value: function getFormat() {
                return this.format_;
            }
        },
        {
            /**
   * @return {boolean} The source can have overlapping geometries.
   */ key: "getOverlaps",
            value: function getOverlaps() {
                return this.overlaps_;
            }
        },
        {
            /**
   * Get the url associated with this source.
   *
   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
   * @api
   */ key: "getUrl",
            value: function getUrl() {
                return this.url_;
            }
        },
        {
            /**
   * @param {Event} event Event.
   * @private
   */ key: "handleFeatureChange_",
            value: function handleFeatureChange_(event) {
                var feature = /** @type {FeatureClass} */ event.target;
                var featureKey = (0, $8b32fff2376556ef$export$5e82334337e0f204)(feature);
                var geometry = feature.getGeometry();
                if (!geometry) {
                    if (!(featureKey in this.nullGeometryFeatures_)) {
                        if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                        this.nullGeometryFeatures_[featureKey] = feature;
                    }
                } else {
                    var extent = geometry.getExtent();
                    if (featureKey in this.nullGeometryFeatures_) {
                        delete this.nullGeometryFeatures_[featureKey];
                        if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
                    } else if (this.featuresRtree_) this.featuresRtree_.update(extent, feature);
                }
                var id = feature.getId();
                if (id !== undefined) {
                    var sid = id.toString();
                    if (this.idIndex_[sid] !== feature) {
                        this.removeFromIdIndex_(feature);
                        this.idIndex_[sid] = feature;
                    }
                } else {
                    this.removeFromIdIndex_(feature);
                    this.uidIndex_[featureKey] = feature;
                }
                this.changed();
                this.dispatchEvent(new $b683658cb5a35baa$export$d402fd02dc2b661c((0, $5c35915412afad46$export$2e2bcd8739ae039).CHANGEFEATURE, feature));
            }
        },
        {
            /**
   * Returns true if the feature is contained within the source.
   * @param {FeatureClass} feature Feature.
   * @return {boolean} Has feature.
   * @api
   */ key: "hasFeature",
            value: function hasFeature(feature) {
                var id = feature.getId();
                if (id !== undefined) return id in this.idIndex_;
                return (0, $8b32fff2376556ef$export$5e82334337e0f204)(feature) in this.uidIndex_;
            }
        },
        {
            /**
   * @return {boolean} Is empty.
   */ key: "isEmpty",
            value: function isEmpty1() {
                if (this.featuresRtree_) return this.featuresRtree_.isEmpty() && (0, $29e93681307ffd1e$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_);
                if (this.featuresCollection_) return this.featuresCollection_.getLength() === 0;
                return true;
            }
        },
        {
            /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ key: "loadFeatures",
            value: function loadFeatures(extent, resolution, projection) {
                var _this = this, _loop = function(i, ii) {
                    var extentToLoad = extentsToLoad[i];
                    var alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, /**
         * @param {{extent: import("../extent.js").Extent}} object Object.
         * @return {boolean} Contains.
         */ function(object) {
                        return (0, $e86e0aa087890eb8$export$be866b1e0809b17e)(object.extent, extentToLoad);
                    });
                    if (!alreadyLoaded) {
                        ++_this.loadingExtentsCount_;
                        _this.dispatchEvent(new $b683658cb5a35baa$export$d402fd02dc2b661c((0, $5c35915412afad46$export$2e2bcd8739ae039).FEATURESLOADSTART));
                        _this.loader_.call(_this, extentToLoad, resolution, projection, function(features) {
                            --_this1.loadingExtentsCount_;
                            _this1.dispatchEvent(new $b683658cb5a35baa$export$d402fd02dc2b661c((0, $5c35915412afad46$export$2e2bcd8739ae039).FEATURESLOADEND, undefined, features));
                        }, function() {
                            --_this1.loadingExtentsCount_;
                            _this1.dispatchEvent(new $b683658cb5a35baa$export$d402fd02dc2b661c((0, $5c35915412afad46$export$2e2bcd8739ae039).FEATURESLOADERROR));
                        });
                        loadedExtentsRtree.insert(extentToLoad, {
                            extent: extentToLoad.slice()
                        });
                    }
                };
                var _this1 = this;
                var loadedExtentsRtree = this.loadedExtentsRtree_;
                var extentsToLoad = this.strategy_(extent, resolution, projection);
                for(var i = 0, ii = extentsToLoad.length; i < ii; ++i)_loop(i, ii);
                this.loading = this.loader_.length < 4 ? false : this.loadingExtentsCount_ > 0;
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.clear(true);
                this.loadedExtentsRtree_.clear();
                (0, $404BM._)((0, $cEF31._)(VectorSource.prototype), "refresh", this).call(this);
            }
        },
        {
            /**
   * Remove an extent from the list of loaded extents.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ key: "removeLoadedExtent",
            value: function removeLoadedExtent(extent) {
                var loadedExtentsRtree = this.loadedExtentsRtree_;
                var obj;
                loadedExtentsRtree.forEachInExtent(extent, function(object) {
                    if ((0, $e86e0aa087890eb8$export$e9bab7fafb253603)(object.extent, extent)) {
                        obj = object;
                        return true;
                    }
                });
                if (obj) loadedExtentsRtree.remove(obj);
            }
        },
        {
            /**
   * Remove a single feature from the source.  If you want to remove all features
   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
   * instead.
   * @param {FeatureClass} feature Feature to remove.
   * @api
   */ key: "removeFeature",
            value: function removeFeature(feature) {
                if (!feature) return;
                var featureKey = (0, $8b32fff2376556ef$export$5e82334337e0f204)(feature);
                if (featureKey in this.nullGeometryFeatures_) delete this.nullGeometryFeatures_[featureKey];
                else if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                var result = this.removeFeatureInternal(feature);
                if (result) this.changed();
            }
        },
        {
            /**
   * Remove feature without firing a `change` event.
   * @param {FeatureClass} feature Feature.
   * @return {FeatureClass|undefined} The removed feature
   *     (or undefined if the feature was not found).
   * @protected
   */ key: "removeFeatureInternal",
            value: function removeFeatureInternal(feature) {
                var featureKey = (0, $8b32fff2376556ef$export$5e82334337e0f204)(feature);
                var featureChangeKeys = this.featureChangeKeys_[featureKey];
                if (!featureChangeKeys) return;
                featureChangeKeys.forEach((0, $5b08b5a7fd85a110$export$b0a21c8b3c1c921));
                delete this.featureChangeKeys_[featureKey];
                var id = feature.getId();
                if (id !== undefined) delete this.idIndex_[id.toString()];
                delete this.uidIndex_[featureKey];
                this.dispatchEvent(new $b683658cb5a35baa$export$d402fd02dc2b661c((0, $5c35915412afad46$export$2e2bcd8739ae039).REMOVEFEATURE, feature));
                return feature;
            }
        },
        {
            /**
   * Remove a feature from the id index.  Called internally when the feature id
   * may have changed.
   * @param {FeatureClass} feature The feature.
   * @return {boolean} Removed the feature from the index.
   * @private
   */ key: "removeFromIdIndex_",
            value: function removeFromIdIndex_(feature) {
                var removed = false;
                for(var id in this.idIndex_){
                    var indexedFeature = this.idIndex_[id];
                    if (feature instanceof (0, $151dd8d79e075f22$export$2e2bcd8739ae039) && Array.isArray(indexedFeature) && indexedFeature.includes(feature)) indexedFeature.splice(indexedFeature.indexOf(feature), 1);
                    else if (this.idIndex_[id] === feature) {
                        delete this.idIndex_[id];
                        removed = true;
                        break;
                    }
                }
                return removed;
            }
        },
        {
            /**
   * Set the new loader of the source. The next render cycle will use the
   * new loader.
   * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
   * @api
   */ key: "setLoader",
            value: function setLoader(loader) {
                this.loader_ = loader;
            }
        },
        {
            /**
   * Points the source to a new url. The next render cycle will use the new url.
   * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
   * @api
   */ key: "setUrl",
            value: function setUrl(url) {
                (0, $100b4414e338a711$export$a7a9523472993e97)(this.format_, "`format` must be set when `url` is set");
                this.url_ = url;
                this.setLoader((0, $e8ea4f2976c6d18d$export$14cc81df70b6707e)(url, this.format_));
            }
        }
    ]);
    return VectorSource;
}((0, $b5891f8da53b2054$export$2e2bcd8739ae039));
var $b683658cb5a35baa$export$2e2bcd8739ae039 = $b683658cb5a35baa$var$VectorSource;








var $eccf418c59b0bff7$var$stroke = new (0, $f2ca0e669183cbd3$export$2e2bcd8739ae039)({
    color: "black",
    width: 2
});
var $eccf418c59b0bff7$var$fill = new (0, $3f3dc9dd8a85276f$export$2e2bcd8739ae039)({
    color: "red"
});
var $eccf418c59b0bff7$var$styles = {
    // 'square': new Style({
    //     image: new RegularShape({
    //         fill: fill,
    //         stroke: stroke,
    //         points: 4,
    //         radius: 10,
    //         angle: Math.PI / 4
    //     })
    // }),
    // 'triangle': new Style({
    //     image: new RegularShape({
    //         fill: fill,
    //         stroke: stroke,
    //         points: 3,
    //         radius: 10,
    //         rotation: Math.PI / 4,
    //         angle: 0
    //     })
    // }),
    // 'star': new Style({
    //     image: new RegularShape({
    //         fill: fill,
    //         stroke: stroke,
    //         points: 5,
    //         radius: 10,
    //         radius2: 4,
    //         angle: 0
    //     })
    // }),
    // 'cross': new Style({
    //     image: new RegularShape({
    //         fill: fill,
    //         stroke: stroke,
    //         points: 4,
    //         radius: 10,
    //         radius2: 0,
    //         angle: 0
    //     })
    // }),
    // 'x': new Style({
    //     image: new RegularShape({
    //         fill: fill,
    //         stroke: stroke,
    //         points: 4,
    //         radius: 10,
    //         radius2: 0,
    //         angle: Math.PI / 4
    //     })
    // }),
    "circle": new (0, $549a2342af29343f$export$2e2bcd8739ae039)({
        image: new (0, $957ba2f77c353f92$export$2e2bcd8739ae039)({
            radius: 10,
            displacement: [
                17,
                17
            ],
            fill: new (0, $3f3dc9dd8a85276f$export$2e2bcd8739ae039)({
                color: "red"
            })
        })
    }),
    "image": function(text) {
        return new (0, $549a2342af29343f$export$2e2bcd8739ae039)({
            image: new (0, $f18dd4c8d6d98b55$export$2e2bcd8739ae039)({
                anchor: [
                    0.5,
                    0.5
                ],
                anchorXUnits: "fraction",
                anchorYUnits: "fraction",
                opacity: 1,
                src: "/plant-icon.svg",
                zIndex: 1,
                scale: 0.15
            }),
            text: new (0, $049c95c34238c5a2$export$2e2bcd8739ae039)({
                text: text,
                scale: 1.3,
                offsetY: 40,
                padding: [
                    5,
                    5,
                    5,
                    5
                ],
                stroke: new (0, $f2ca0e669183cbd3$export$2e2bcd8739ae039)({
                    color: "#ffffff",
                    width: 2
                })
            })
        });
    }
};
function $eccf418c59b0bff7$var$makeInitialMap(onDeviceSelected) {
    var mapId = "map";
    // Don't make the map two times
    if (document.getElementById(mapId).children.length > 0) return;
    var map = new (0, $11907e309f89aeba$export$2e2bcd8739ae039)({
        controls: (0, $b49292dbcddf523e$export$ebe90cb607ad99e)(),
        target: mapId,
        layers: [
            new (0, $23aaf83eabeb7fa5$export$2e2bcd8739ae039)({
                source: new (0, $6fc27e650bb08eb8$export$2e2bcd8739ae039)({
                    key: "AiBw1v7ViMnbHBqIP9Jk72AYBLMC2CIGwdT6vkwhcbMswNURM6U7v1nl8XV2oQAr",
                    imagerySet: "Aerial"
                })
            })
        ],
        view: new (0, $2d5eedb534d9ecb2$export$2e2bcd8739ae039)({
            //center: props.center,
            center: (0, $401a58d9dec354c1$export$b15d9668511529b9)([
                85.45,
                -60.69
            ]),
            zoom: 17,
            maxZoom: 19
        })
    });
    var zoomslider = new (0, $d3d972a304380ffd$export$2e2bcd8739ae039)(null);
    map.addControl(zoomslider);
    return map;
}
var $eccf418c59b0bff7$var$clickHandler;
function $eccf418c59b0bff7$var$refreshCallback(map, onDeviceSelected) {
    // Workaround because for "reasons"
    // Map doesn't export the event management function
    if ($eccf418c59b0bff7$var$clickHandler) // @ts-ignore
    map.un("click", $eccf418c59b0bff7$var$clickHandler.listener);
    //console.log("Setting click handler", onDeviceSelected);
    $eccf418c59b0bff7$var$clickHandler = map.on("click", function(event) {
        var done = false;
        map.forEachFeatureAtPixel(event.pixel, function(feature, layer) {
            if (!done) {
                if (feature.deviceId) onDeviceSelected(feature.deviceId);
                done = true;
            }
        });
    });
}
function $eccf418c59b0bff7$var$computeExtent(devices) {
    if (devices.length < 2) {
        console.debug("I have only", devices.length, "devices, extent is null");
        return [
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ];
    }
    var maxLat = Math.max.apply(null, devices.map(function(d) {
        return d.gps[0];
    }));
    var maxLon = Math.max.apply(null, devices.map(function(d) {
        return d.gps[1];
    }));
    var minLat = Math.min.apply(null, devices.map(function(d) {
        return d.gps[0];
    }));
    var minLon = Math.min.apply(null, devices.map(function(d) {
        return d.gps[1];
    }));
    var result = (0, $401a58d9dec354c1$export$751c68e0e0efff79)([
        minLat,
        minLon,
        maxLat,
        maxLon
    ], "EPSG:4326", "EPSG:3857");
    //const result = fromLonLat([minLon, minLat,  maxLon, maxLat]);
    console.debug("Computed extent for devices is", result);
    return result;
}
function $eccf418c59b0bff7$var$makeSource(landmark) {
    var features = landmark.filter(function(d) {
        return d.gps;
    }).map(function(d) {
        var feature = new (0, $a0674ee7b31c3fe1$export$2e2bcd8739ae039)(new (0, $b36c6ea9ae4054c8$export$2e2bcd8739ae039)((0, $401a58d9dec354c1$export$b15d9668511529b9)(d.gps), null));
        if (d.type === "device") feature.deviceId = d.id;
        var st = [
            $eccf418c59b0bff7$var$styles.image(d.description)
        ];
        if (!d.connected) st.push($eccf418c59b0bff7$var$styles.circle);
        feature.setStyle(st);
        return feature;
    });
    var source = new (0, $b683658cb5a35baa$export$2e2bcd8739ae039)({
        features: features
    });
    return source;
}
function $eccf418c59b0bff7$var$makeMarkers(landmarks) {
    var source = $eccf418c59b0bff7$var$makeSource(landmarks);
    var layer = new (0, $938dc8312d6df4d4$export$2e2bcd8739ae039)({
        source: source,
        style: $eccf418c59b0bff7$var$styles.image("")
    });
    return {
        source: source,
        layer: layer
    };
}
function $eccf418c59b0bff7$var$setMousePointer(map) {
    map.on("pointermove", function(e) {
        var pixel = map.getEventPixel(e.originalEvent);
        var hit = map.hasFeatureAtPixel(pixel);
        map.getViewport().style.cursor = hit ? "pointer" : "";
    });
}
function $eccf418c59b0bff7$var$deviceToLandmark(device) {
    return {
        id: device.id,
        type: "device",
        description: device.description,
        gps: device.gps,
        connected: device.connected
    };
}
function $eccf418c59b0bff7$var$weatherLocationToLandmark(wl) {
    return {
        id: wl.id,
        description: wl.description,
        type: "weather-station",
        gps: wl.coordinates.split(" ").map(Number),
        connected: true
    };
}
function $eccf418c59b0bff7$export$a5c7b93649eaf8f8(props) {
    var _useState = (0, $52tJv._)((0, $17VE6.useState)(null), 2), map = _useState[0], setMap = _useState[1];
    var _useState1 = (0, $52tJv._)((0, $17VE6.useState)(null), 2), featureLayer = _useState1[0], setFeatureLayer = _useState1[1];
    var landmarks = (0, $fyztb._)(props.devices.map($eccf418c59b0bff7$var$deviceToLandmark)).concat((0, $fyztb._)(props.weatherStations.map($eccf418c59b0bff7$var$weatherLocationToLandmark)));
    var _useState2 = (0, $52tJv._)((0, $17VE6.useState)(landmarks), 2), visibleDevices = _useState2[0], setVisibleLandmarks = _useState2[1];
    console.log("Visible devices:", visibleDevices);
    // Initial load of the map
    (0, $17VE6.useEffect)(function() {
        console.log("Setting up initial map centered");
        if (!map && props.devices.length > 0) {
            var m = $eccf418c59b0bff7$var$makeInitialMap(props.onDeviceSelected);
            $eccf418c59b0bff7$var$setMousePointer(m);
            setMap(m);
        }
    }, [
        props.onDeviceSelected,
        props.devices.length,
        props.weatherStations.length,
        map
    ]);
    if (map) $eccf418c59b0bff7$var$refreshCallback(map, props.onDeviceSelected);
    (0, $17VE6.useEffect)(function() {
        var _document_getElementById;
        console.log("Refilter devices");
        var filter = ((_document_getElementById = document.getElementById("map-device-filter")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.nodeValue) || "";
        console.log("Setting visible landmarks to", landmarks);
        setVisibleLandmarks(applyFilter(filter, landmarks));
    }, [
        props.devices,
        props.weatherStations
    ]);
    // Update the markers
    (0, $17VE6.useEffect)(function() {
        if (map) {
            console.log("Refresh markers");
            // remove previous device layer, if needed
            if (featureLayer) {
                // we already have a feature layer, use it
                var source = $eccf418c59b0bff7$var$makeSource(visibleDevices);
                featureLayer.setSource(source);
            } else {
                var newLayer = $eccf418c59b0bff7$var$makeMarkers(visibleDevices);
                setFeatureLayer(newLayer.layer);
                map.addLayer(newLayer.layer);
            }
            var center = (0, $401a58d9dec354c1$export$b15d9668511529b9)(props.center);
            // console.log(`Centering map on ${props.center} (${center})`);
            map.getView().setCenter(center);
            if (visibleDevices.length > 1) {
                console.log("Visible devices", visibleDevices);
                var extent = $eccf418c59b0bff7$var$computeExtent(props.devices);
                console.log("Extent", extent);
                if (props.devices.length > 1) map.getView().fit(extent, map.getSize());
            }
        }
    });
    function applyFilter(text, landmarks) {
        console.log("Apply filter ".concat(text));
        return landmarks.filter(function(l) {
            return l.description.toLowerCase().indexOf(text.toLowerCase()) >= 0;
        });
    }
    function onFilterChanged(event) {
        var filter = event.target.value;
        setVisibleLandmarks(applyFilter(filter, landmarks));
    }
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        className: "map-container",
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                className: "map-filter",
                placeholder: "Filter devices...",
                id: "map-device-filter",
                type: "text",
                onChange: onFilterChanged
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                id: "map"
            })
        ]
    });
}




parcelRequire("17VE6");

parcelRequire("17VE6");
function $c73b41bb9d1ad603$export$1081d70813d107d1(props) {
    var rangeById = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = props.ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var range = _step.value;
            rangeById[range.id] = range;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("select", {
        value: props.selectedRangeId,
        onChange: function(event) {
            return props.onRangeSelected(rangeById[event.target.value]);
        },
        children: props.ranges.map(function(range) {
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("option", {
                value: range.id,
                children: range.description
            }, range.id);
        })
    });
}



var $9NSsB = parcelRequire("9NSsB");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $9NSsB = parcelRequire("9NSsB");
var $5e17167db9d238bf$var$DateService = /*#__PURE__*/ function() {
    "use strict";
    function DateService() {
        (0, $5sFFs._)(this, DateService);
    }
    (0, $8O2fV._)(DateService, [
        {
            key: "getBeginningOfDay",
            value: function getBeginningOfDay(date) {
                var instant = (0, $9NSsB.Instant).ofEpochMilli(date.getTime());
                var zonedDateTime = instant.atZone((0, $9NSsB.ZoneId).systemDefault());
                var day = (0, $9NSsB.convert)(zonedDateTime.toLocalDate()).toDate();
                return day;
            }
        },
        {
            key: "getEndOfDay",
            value: function getEndOfDay(date) {
                var instant = (0, $9NSsB.Instant).ofEpochMilli(date.getTime());
                var zonedDateTime = instant.atZone((0, $9NSsB.ZoneId).systemDefault());
                var day = (0, $9NSsB.convert)(zonedDateTime.toLocalDate().plusDays(1)).toDate();
                return day;
            }
        },
        {
            key: "formatDate",
            value: function formatDate(date) {
                var instant = (0, $9NSsB.Instant).ofEpochMilli(date.getTime());
                var zonedDateTime = instant.atZone((0, $9NSsB.ZoneId).systemDefault());
                var localDate = zonedDateTime.toLocalDate();
                return localDate.toString();
            }
        },
        {
            key: "getStartDate",
            value: function getStartDate(endDate, rangeWidth) {
                return this.getBeginningOfDay(new Date(endDate.getTime() - rangeWidth.durationSec * 1000));
            }
        }
    ]);
    return DateService;
}();
var $5e17167db9d238bf$export$ae0dacc307e0ed75 = new $5e17167db9d238bf$var$DateService();


function $a980346064516d53$export$d9b273488cd8ce6f(props) {
    function dateChangeHandler(e) {
        var date = (0, $9NSsB.convert)((0, $9NSsB.LocalDate).parse(e.target.value)).toDate();
        props.onDateSelected(date);
    }
    function filterLuminosityChangeHandler(e) {
        var value = Boolean(e.target.value);
        console.debug("Changing luminosity filter to", value);
        props.onFilterLuminosityToggled(value);
    }
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
        className: "option-menu",
        children: props.selectedDate === null ? null : /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("span", {
                    children: [
                        "Filter luminosity: ",
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                            type: "checkbox",
                            checked: props.filterLuminosity,
                            onChange: filterLuminosityChangeHandler
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: "Date:"
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                    type: "date",
                    value: (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).formatDate(props.selectedDate),
                    onChange: dateChangeHandler
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: "Charts width:"
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $c73b41bb9d1ad603$export$1081d70813d107d1), {
                    ranges: props.ranges,
                    onRangeSelected: props.onRangeSelected,
                    selectedRangeId: props.selectedRangeId
                })
            ]
        })
    });
}




parcelRequire("17VE6");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");


var $17VE6 = parcelRequire("17VE6");

var $7hBys = parcelRequire("7hBys");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $ajhIL = parcelRequire("ajhIL");

/**
 * Promisified version of setTimeout
 */ 
var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $52tJv = parcelRequire("52tJv");

var $ajhIL = parcelRequire("ajhIL");



var $17VE6 = parcelRequire("17VE6");
function $1f82f0133d3f4ee2$export$e772c8ff12451969(ms) {
    return $1f82f0133d3f4ee2$var$_sleep.apply(this, arguments);
}
function $1f82f0133d3f4ee2$var$_sleep() {
    $1f82f0133d3f4ee2$var$_sleep = (0, $7hBys._)(function(ms) {
        var p;
        return (0, $ajhIL.__generator)(this, function(_state) {
            p = new Promise(function(resolve, reject) {
                setTimeout(function() {
                    return resolve();
                }, ms);
            });
            return [
                2,
                p
            ];
        });
    });
    return $1f82f0133d3f4ee2$var$_sleep.apply(this, arguments);
}
function $1f82f0133d3f4ee2$export$8a97150c436e861e(input, init) {
    return $1f82f0133d3f4ee2$var$_requestOld.apply(this, arguments);
}
function $1f82f0133d3f4ee2$var$_requestOld() {
    $1f82f0133d3f4ee2$var$_requestOld = (0, $7hBys._)(function(input, init) {
        var jwt, headers, result;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!init) init = {
                        headers: {}
                    };
                    if (!init.headers) init.headers = {};
                    jwt = localStorage.jwt;
                    headers = init.headers;
                    headers["Authorization"] = "Bearer ".concat(jwt);
                    if (init.body) {
                        init.body = JSON.stringify(init.body);
                        headers["Content-Type"] = "application/json";
                    }
                    return [
                        4,
                        fetch(input, init)
                    ];
                case 1:
                    result = _state.sent();
                    if (!result.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(result);
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $1f82f0133d3f4ee2$var$_requestOld.apply(this, arguments);
}
function $1f82f0133d3f4ee2$export$b5fe3f66a567bec0(input, init) {
    return $1f82f0133d3f4ee2$var$_request.apply(this, arguments);
}
function $1f82f0133d3f4ee2$var$_request() {
    $1f82f0133d3f4ee2$var$_request = (0, $7hBys._)(function(input, init) {
        var headers, result;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!init) init = {
                        headers: {}
                    };
                    headers = (0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)(), init.headers);
                    if (init.body) {
                        init.body = JSON.stringify(init.body);
                        headers["Content-Type"] = "application/json";
                    }
                    return [
                        4,
                        fetch(input, init)
                    ];
                case 1:
                    result = _state.sent();
                    if (!result.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(result);
                    if (result.status === 200) return [
                        2,
                        result.json()
                    ];
                    else return [
                        2,
                        undefined
                    ];
                    return [
                        2
                    ];
            }
        });
    });
    return $1f82f0133d3f4ee2$var$_request.apply(this, arguments);
}
/**
 * Alphanumeric sort, see https://stackoverflow.com/questions/4340227/sort-mixed-alpha-numeric-array
 */ var $1f82f0133d3f4ee2$var$reA = /[^a-zA-Z]/g;
var $1f82f0133d3f4ee2$var$reN = /[^0-9]/g;
function $1f82f0133d3f4ee2$export$44c040ce524a6dac(a, b) {
    a = String(a);
    b = String(b);
    var aA = a.replace($1f82f0133d3f4ee2$var$reA, "");
    var bA = b.replace($1f82f0133d3f4ee2$var$reA, "");
    if (aA === bA) {
        var aN = parseInt(a.replace($1f82f0133d3f4ee2$var$reN, ""), 10);
        var bN = parseInt(b.replace($1f82f0133d3f4ee2$var$reN, ""), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
    } else return aA > bA ? 1 : -1;
}
function $1f82f0133d3f4ee2$export$756e1e7707954007(data, field, order) {
    if (order === "asc") data.sort(function(a, b) {
        return $1f82f0133d3f4ee2$export$44c040ce524a6dac(a[field], b[field]);
    });
    else data.sort(function(a, b) {
        return -$1f82f0133d3f4ee2$export$44c040ce524a6dac(a[field], b[field]);
    });
}
function $1f82f0133d3f4ee2$export$281ad3752a540efe(params) {
    return new URLSearchParams(params).toString();
}
function $1f82f0133d3f4ee2$export$e620e98009814b79(items, key) {
    var result = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var k = String(item[key]);
            result[k] = item;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function $1f82f0133d3f4ee2$export$3f063810d7bf01bd(items, key) {
    var result = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var k = String(item[key]);
            if (result[k] === undefined) result[k] = [];
            result[k].push(item);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
// Issues with import Timeout here...
var $1f82f0133d3f4ee2$var$INITIAL_STATE = undefined;
function $1f82f0133d3f4ee2$export$f4b266cd2aae9cb1(callback, interval) {
    console.log("useInterval", callback, interval);
    var _useState = (0, $52tJv._)((0, $17VE6.useState)($1f82f0133d3f4ee2$var$INITIAL_STATE), 2), state = _useState[0], setState = _useState[1];
    (0, $17VE6.useEffect)(function() {
        if (state) {
            console.log("Clearing interval", state);
            clearInterval(state);
        }
        if (interval) {
            var timer = setInterval(callback, interval);
            setState(timer);
        } else setState(undefined);
        return function() {
            if (state) clearInterval(state);
        };
    }, [
        interval
    ]);
}


var $2d43067f24bd2fb9$var$ENDPOINT = "/api/v2/leaf-sensor";
var $2d43067f24bd2fb9$var$LeafSensorService = /*#__PURE__*/ function() {
    "use strict";
    function LeafSensorService() {
        (0, $5sFFs._)(this, LeafSensorService);
    }
    (0, $8O2fV._)(LeafSensorService, [
        {
            key: "getLeafSensorsByCustomerId",
            value: function getLeafSensorsByCustomerId(customerId) {
                var addIndirect = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, addPlants = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, hidden = arguments.length > 3 ? arguments[3] : void 0;
                return (0, $7hBys._)(function() {
                    var jwt, searchParams, url, response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                jwt = localStorage.jwt;
                                searchParams = new URLSearchParams();
                                searchParams.append("customer", customerId);
                                if (addIndirect) searchParams.append("indirect", "true");
                                if (addPlants) searchParams.append("add-plant", "true");
                                if (hidden !== undefined) searchParams.append("hidden", hidden + "");
                                url = "".concat($2d43067f24bd2fb9$var$ENDPOINT, "/?").concat(searchParams);
                                return [
                                    4,
                                    fetch(url.toString(), {
                                        headers: {
                                            "Authorization": "Bearer ".concat(jwt)
                                        },
                                        method: "get"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMyLeafSensors",
            value: function getMyLeafSensors() {
                var addIndirect = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, addPlants = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                return (0, $7hBys._)(function() {
                    var jwt, searchParams, url, response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                jwt = localStorage.jwt;
                                searchParams = new URLSearchParams();
                                if (addIndirect) searchParams.append("indirect", "true");
                                if (addPlants) searchParams.append("add-plant", "true");
                                console.log(searchParams.toString());
                                url = "".concat($2d43067f24bd2fb9$var$ENDPOINT, "/mine?").concat(searchParams);
                                console.log("URL", url);
                                return [
                                    4,
                                    fetch(url.toString(), {
                                        headers: {
                                            "Authorization": "Bearer ".concat(jwt)
                                        },
                                        method: "get"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAllLeafSensors",
            value: function getAllLeafSensors() {
                return (0, $7hBys._)(function() {
                    var jwt, response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                jwt = localStorage.jwt;
                                return [
                                    4,
                                    fetch("".concat($2d43067f24bd2fb9$var$ENDPOINT), {
                                        headers: {
                                            "Authorization": "Bearer ".concat(jwt)
                                        },
                                        method: "get"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setNotificationFlag",
            value: function setNotificationFlag(leafSensorId, notificationEnabled) {
                return (0, $7hBys._)(function() {
                    var jwt, response;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                jwt = localStorage.jwt;
                                return [
                                    4,
                                    fetch("".concat($2d43067f24bd2fb9$var$ENDPOINT, "/").concat(leafSensorId, "/notification"), {
                                        headers: {
                                            "Authorization": "Bearer ".concat(jwt),
                                            "Content-Type": "application/json"
                                        },
                                        method: "post",
                                        body: JSON.stringify({
                                            notificationEnabled: notificationEnabled
                                        })
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPlantsByLeafSensorId",
            value: function getPlantsByLeafSensorId(leafSensorId) {
                return (0, $7hBys._)(function() {
                    var response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $1f82f0133d3f4ee2$export$8a97150c436e861e)("".concat($2d43067f24bd2fb9$var$ENDPOINT, "/").concat(leafSensorId, "/plants"))
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "register",
            value: function register(leafSensor) {
                return (0, $7hBys._)(function() {
                    var response;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $1f82f0133d3f4ee2$export$8a97150c436e861e)("".concat($2d43067f24bd2fb9$var$ENDPOINT), {
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        method: "post",
                                        body: JSON.stringify(leafSensor)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return LeafSensorService;
}();
var $2d43067f24bd2fb9$export$846a5da018e5aa64 = new $2d43067f24bd2fb9$var$LeafSensorService();



parcelRequire("17VE6");
function $c04429fc8341b90f$export$138bb0d2d2cd3c6(props) {
    var xy = props.coordinates.split(" ");
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("span", {
        children: [
            xy[1],
            ", ",
            xy[0]
        ]
    });
}


function $36d89c61f6df1b55$var$renderLine(label, content) {
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        className: "pf-label",
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                className: "pf-big pf-left",
                children: label
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                className: "pf-big pf-right",
                children: content
            })
        ]
    });
}
function $36d89c61f6df1b55$var$renderWeatherStation(plant, onWeatherStationShow) {
    var _plant_weatherLocation;
    function onChange(event) {
        if (event.target.checked) onWeatherStationShow(plant.weatherLocation);
        else onWeatherStationShow(undefined);
    }
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        className: "pf-label",
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                className: "pf-big pf-left",
                children: "Weather Station:"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("span", {
                className: "pf-big pf-right",
                children: [
                    (_plant_weatherLocation = plant.weatherLocation) === null || _plant_weatherLocation === void 0 ? void 0 : _plant_weatherLocation.description,
                    plant.weatherLocation ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $c04429fc8341b90f$export$138bb0d2d2cd3c6), {
                        coordinates: plant.weatherLocation.coordinates
                    }) : null,
                    "(",
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("small", {
                        children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                                    onChange: onChange,
                                    type: "checkbox"
                                }),
                                "Show on map"
                            ]
                        })
                    }),
                    ")"
                ]
            })
        ]
    });
}
function $36d89c61f6df1b55$var$renderHistoricalData(currentPlantId, plants, onPlantSelected) {
    function callback(id) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = plants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var p = _step.value;
                if (p.id === id) onPlantSelected(p);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    plants.sort(function(a, b) {
        return new Date(b.regDate).getTime() - new Date(a.regDate).getTime();
    });
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        className: "pf-label",
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                className: "pf-big pf-left",
                children: "Historical data:"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                className: "pf-big pf-right",
                children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("select", {
                    value: currentPlantId,
                    onChange: function(event) {
                        return callback(event.target.value);
                    },
                    children: plants.map(function(p) {
                        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("option", {
                            value: p.id,
                            children: [
                                p.description,
                                " - ",
                                p.regDate
                            ]
                        }, p.id);
                    })
                })
            })
        ]
    });
}
var $36d89c61f6df1b55$var$INITIAL_STATE = {
    plants: []
};
function $36d89c61f6df1b55$export$1e97dca3e3a103ef(props) {
    var plant = props.plant, profile = props.profile, status = props.status, scrollReference = props.scrollReference, device = props.device, onPlantSelected = props.onPlantSelected;
    var _useState = (0, $52tJv._)((0, $17VE6.useState)($36d89c61f6df1b55$var$INITIAL_STATE), 2), state = _useState[0], setState = _useState[1];
    (0, $17VE6.useEffect)(function() {
        if (props.device && props.device.id) (0, $2d43067f24bd2fb9$export$846a5da018e5aa64).getPlantsByLeafSensorId(props.device.id).then(function(plants) {
            setState(function(state) {
                return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                    plants: plants
                });
            });
        });
    }, [
        props.device
    ]);
    if (!plant || !device) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {});
    function setWeatherStationVisibility(show) {}
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("section", {
        className: "pf-box",
        ref: scrollReference,
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("h2", {
                children: plant.description
            }),
            status ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                className: "pf-labels",
                children: [
                    $36d89c61f6df1b55$var$renderLine("Profile", (profile === null || profile === void 0 ? void 0 : profile.description) || ""),
                    $36d89c61f6df1b55$var$renderLine("Position", device.gps[1] + " " + device.gps[0]),
                    profile === null || profile === void 0 ? void 0 : profile.sensors.map(function(s) {
                        return $36d89c61f6df1b55$var$renderLine(s.description, status[s.id] + " " + (s.uom || ""));
                    }),
                    $36d89c61f6df1b55$var$renderHistoricalData(plant.id, state.plants, onPlantSelected),
                    $36d89c61f6df1b55$var$renderWeatherStation(plant, props.onWeatherStationShow),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {})
                ]
            }) : /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                className: "pf-labels",
                children: [
                    $36d89c61f6df1b55$var$renderLine("Position", device.gps[1] + ", " + device.gps[0]),
                    $36d89c61f6df1b55$var$renderHistoricalData(plant.id, state.plants, onPlantSelected),
                    $36d89c61f6df1b55$var$renderWeatherStation(plant, props.onWeatherStationShow)
                ]
            })
        ]
    });
}



var $52tJv = parcelRequire("52tJv");


var $17VE6 = parcelRequire("17VE6");

var $17VE6 = parcelRequire("17VE6");
function $7f344446f1cbebc3$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $7f344446f1cbebc3$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $7f344446f1cbebc3$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $7f344446f1cbebc3$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $7f344446f1cbebc3$export$2e2bcd8739ae039 = $7f344446f1cbebc3$export$4f5d2d50c9deca37;



var $17VE6 = parcelRequire("17VE6");

var $51RYA = parcelRequire("51RYA");
var $2b504fb5b10af08d$exports = {};
(function(global, factory) {
    factory($2b504fb5b10af08d$exports);
})($2b504fb5b10af08d$exports, function(exports1) {
    "use strict";
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== "object" || typeof b !== "object") return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a || b ? a === b : a === b || a !== a && b !== b;
    }
    var OWNER = "_owner";
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.entries();
        var index = 0;
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                var _a = aResult.value, aKey = _a[0], aValue = _a[1];
                var _b = bResult.value, bKey = _b[0], bValue = _b[1];
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aKey, bKey, index, matchIndex, a, b, state) && state.equals(aValue, bValue, aKey, bKey, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        var property;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property) || !state.equals(a[property], b[property], property, property, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property)) return false;
            if (!state.equals(a[property], b[property], property, property, a, b, state)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    var ARGUMENTS_TAG = "[object Arguments]";
    var BOOLEAN_TAG = "[object Boolean]";
    var DATE_TAG = "[object Date]";
    var MAP_TAG = "[object Map]";
    var NUMBER_TAG = "[object Number]";
    var OBJECT_TAG = "[object Object]";
    var REG_EXP_TAG = "[object RegExp]";
    var SET_TAG = "[object Set]";
    var STRING_TAG = "[object String]";
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (a == null || b == null || typeof a !== "object" || typeof b !== "object") return a !== a && b !== b;
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== "function" && typeof b.then !== "function" && areObjectsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _$_a = createState(), _b = _$_a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _$_a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function createInternalComparator() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function createInternalComparator() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function createInternalComparator() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function createInternalComparator() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $89baf7b72e28ca01$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== "undefined") requestAnimationFrame(callback);
}
function $89baf7b72e28ca01$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $89baf7b72e28ca01$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $44576c0560ddc367$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $44576c0560ddc367$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $44576c0560ddc367$var$_typeof(obj);
}
function $44576c0560ddc367$var$_toArray(arr) {
    return $44576c0560ddc367$var$_arrayWithHoles(arr) || $44576c0560ddc367$var$_iterableToArray(arr) || $44576c0560ddc367$var$_unsupportedIterableToArray(arr) || $44576c0560ddc367$var$_nonIterableRest();
}
function $44576c0560ddc367$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $44576c0560ddc367$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $44576c0560ddc367$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $44576c0560ddc367$var$_arrayLikeToArray(o, minLen);
}
function $44576c0560ddc367$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $44576c0560ddc367$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $44576c0560ddc367$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $44576c0560ddc367$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $44576c0560ddc367$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === "number") {
                (0, $89baf7b72e28ca01$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $89baf7b72e28ca01$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($44576c0560ddc367$var$_typeof(_style) === "object") {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === "function") _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $f9553aca757d2dbc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f9553aca757d2dbc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f9553aca757d2dbc$var$_typeof(obj);
}
function $f9553aca757d2dbc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f9553aca757d2dbc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f9553aca757d2dbc$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f9553aca757d2dbc$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f9553aca757d2dbc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f9553aca757d2dbc$var$_defineProperty(obj, key, value) {
    key = $f9553aca757d2dbc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f9553aca757d2dbc$var$_toPropertyKey(arg) {
    var key = $f9553aca757d2dbc$var$_toPrimitive(arg, "string");
    return $f9553aca757d2dbc$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f9553aca757d2dbc$var$_toPrimitive(input, hint) {
    if ($f9553aca757d2dbc$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f9553aca757d2dbc$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/* eslint no-console: 0 */ var $f9553aca757d2dbc$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $f9553aca757d2dbc$var$IN_LINE_PREFIX_LIST = [
    "-webkit-",
    "-moz-",
    "-o-",
    "-ms-"
];
var $f9553aca757d2dbc$var$IN_COMPATIBLE_PROPERTY = [
    "transform",
    "transformOrigin",
    "transition"
];
var $f9553aca757d2dbc$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $f9553aca757d2dbc$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $f9553aca757d2dbc$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $f9553aca757d2dbc$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if ($f9553aca757d2dbc$var$IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) return $f9553aca757d2dbc$var$_defineProperty({}, name, Number.isNaN(value) ? 0 : value);
    var isTransition = name === "transition";
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var styleVal = value;
    return $f9553aca757d2dbc$var$PREFIX_LIST.reduce(function(result, property, i) {
        if (isTransition) styleVal = value.replace(/(transform|transform-origin)/gim, "".concat($f9553aca757d2dbc$var$IN_LINE_PREFIX_LIST[i], "$1"));
        return $f9553aca757d2dbc$var$_objectSpread($f9553aca757d2dbc$var$_objectSpread({}, result), {}, $f9553aca757d2dbc$var$_defineProperty({}, property + camelName, styleVal));
    }, {});
};
var $f9553aca757d2dbc$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $f9553aca757d2dbc$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $f9553aca757d2dbc$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $f9553aca757d2dbc$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || "anonymous function";
        var argNames = "(".concat(args.map(JSON.stringify).join(", "), ")");
        $f9553aca757d2dbc$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $f9553aca757d2dbc$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $f9553aca757d2dbc$var$_objectSpread($f9553aca757d2dbc$var$_objectSpread({}, res), {}, $f9553aca757d2dbc$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $f9553aca757d2dbc$export$ff9926a5d1daa67c = function translateStyle(style) {
    return Object.keys(style).reduce(function(res, key) {
        return $f9553aca757d2dbc$var$_objectSpread($f9553aca757d2dbc$var$_objectSpread({}, res), $f9553aca757d2dbc$export$4a9169b65825efee(key, res[key]));
    }, style);
};
var $f9553aca757d2dbc$export$f672e0b6f7222cd7 = function compose() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (!args.length) return $f9553aca757d2dbc$export$f0954fd7d5368655;
    var fns = args.reverse();
    // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $f9553aca757d2dbc$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($f9553aca757d2dbc$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(",");
};
var $f9553aca757d2dbc$var$isDev = false;
var $f9553aca757d2dbc$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($f9553aca757d2dbc$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $1790572b33a3f433$var$_slicedToArray(arr, i) {
    return $1790572b33a3f433$var$_arrayWithHoles(arr) || $1790572b33a3f433$var$_iterableToArrayLimit(arr, i) || $1790572b33a3f433$var$_unsupportedIterableToArray(arr, i) || $1790572b33a3f433$var$_nonIterableRest();
}
function $1790572b33a3f433$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1790572b33a3f433$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $1790572b33a3f433$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1790572b33a3f433$var$_toConsumableArray(arr) {
    return $1790572b33a3f433$var$_arrayWithoutHoles(arr) || $1790572b33a3f433$var$_iterableToArray(arr) || $1790572b33a3f433$var$_unsupportedIterableToArray(arr) || $1790572b33a3f433$var$_nonIterableSpread();
}
function $1790572b33a3f433$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1790572b33a3f433$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1790572b33a3f433$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1790572b33a3f433$var$_arrayLikeToArray(o, minLen);
}
function $1790572b33a3f433$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1790572b33a3f433$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1790572b33a3f433$var$_arrayLikeToArray(arr);
}
function $1790572b33a3f433$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $1790572b33a3f433$var$ACCURACY = 1e-4;
var $1790572b33a3f433$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $1790572b33a3f433$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $1790572b33a3f433$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $1790572b33a3f433$var$cubicBezierFactor(c1, c2);
        return $1790572b33a3f433$var$multyTime(params, t);
    };
};
var $1790572b33a3f433$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $1790572b33a3f433$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($1790572b33a3f433$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $1790572b33a3f433$var$multyTime(newParams, t);
    };
};
var $1790572b33a3f433$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case "linear":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease":
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case "ease-in":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease-out":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case "ease-in-out":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split("(");
            if (easing[0] === "cubic-bezier" && easing[1].split(")")[0].split(",").length === 4) {
                var _easing$1$split$0$spl = easing[1].split(")")[0].split(",").map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $1790572b33a3f433$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $f9553aca757d2dbc$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $f9553aca757d2dbc$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === "number" && num >= 0 && num <= 1;
    }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", args);
    var curveX = $1790572b33a3f433$var$cubicBezier(x1, x2);
    var curveY = $1790572b33a3f433$var$cubicBezier(y1, y2);
    var derCurveX = $1790572b33a3f433$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $1790572b33a3f433$var$ACCURACY || derVal < $1790572b33a3f433$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $1790572b33a3f433$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $1790572b33a3f433$var$ACCURACY && Math.abs(newV) < $1790572b33a3f433$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $1790572b33a3f433$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === "string") switch(easing){
        case "ease":
        case "ease-in-out":
        case "ease-out":
        case "ease-in":
        case "linear":
            return $1790572b33a3f433$export$56c51296f72f0592(easing);
        case "spring":
            return $1790572b33a3f433$export$12fc25daf62b865a();
        default:
            if (easing.split("(")[0] === "cubic-bezier") return $1790572b33a3f433$export$56c51296f72f0592(easing);
            (0, $f9553aca757d2dbc$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === "function") return easing;
    (0, $f9553aca757d2dbc$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument type should be function or string, instead received %s", args);
    return null;
};



function $8306c86393833e34$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8306c86393833e34$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8306c86393833e34$var$_typeof(obj);
}
function $8306c86393833e34$var$_toConsumableArray(arr) {
    return $8306c86393833e34$var$_arrayWithoutHoles(arr) || $8306c86393833e34$var$_iterableToArray(arr) || $8306c86393833e34$var$_unsupportedIterableToArray(arr) || $8306c86393833e34$var$_nonIterableSpread();
}
function $8306c86393833e34$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8306c86393833e34$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8306c86393833e34$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8306c86393833e34$var$_arrayLikeToArray(arr);
}
function $8306c86393833e34$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8306c86393833e34$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8306c86393833e34$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8306c86393833e34$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8306c86393833e34$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8306c86393833e34$var$_defineProperty(obj, key, value) {
    key = $8306c86393833e34$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8306c86393833e34$var$_toPropertyKey(arg) {
    var key = $8306c86393833e34$var$_toPrimitive(arg, "string");
    return $8306c86393833e34$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8306c86393833e34$var$_toPrimitive(input, hint) {
    if ($8306c86393833e34$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8306c86393833e34$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8306c86393833e34$var$_slicedToArray(arr, i) {
    return $8306c86393833e34$var$_arrayWithHoles(arr) || $8306c86393833e34$var$_iterableToArrayLimit(arr, i) || $8306c86393833e34$var$_unsupportedIterableToArray(arr, i) || $8306c86393833e34$var$_nonIterableRest();
}
function $8306c86393833e34$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8306c86393833e34$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8306c86393833e34$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8306c86393833e34$var$_arrayLikeToArray(o, minLen);
}
function $8306c86393833e34$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8306c86393833e34$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $8306c86393833e34$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $8306c86393833e34$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $8306c86393833e34$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $8306c86393833e34$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $f9553aca757d2dbc$export$d6051a0f7a227332)(function(key, val) {
        if ($8306c86393833e34$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $8306c86393833e34$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $8306c86393833e34$var$_objectSpread($8306c86393833e34$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $f9553aca757d2dbc$export$d6051a0f7a227332)(function(key, val) {
        if ($8306c86393833e34$var$needContinue(val)) return $8306c86393833e34$var$_objectSpread($8306c86393833e34$var$_objectSpread({}, val), {}, {
            velocity: $8306c86393833e34$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $8306c86393833e34$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$8306c86393833e34$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $f9553aca757d2dbc$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $8306c86393833e34$var$_objectSpread($8306c86393833e34$var$_objectSpread({}, res), {}, $8306c86393833e34$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $8306c86393833e34$var$_objectSpread($8306c86393833e34$var$_objectSpread({}, res), {}, $8306c86393833e34$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $f9553aca757d2dbc$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($8306c86393833e34$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $8306c86393833e34$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($8306c86393833e34$var$_objectSpread($8306c86393833e34$var$_objectSpread($8306c86393833e34$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $f9553aca757d2dbc$export$d6051a0f7a227332)(function(key, val) {
            return $8306c86393833e34$var$alpha.apply(void 0, $8306c86393833e34$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($8306c86393833e34$var$_objectSpread($8306c86393833e34$var$_objectSpread($8306c86393833e34$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $f9553aca757d2dbc$export$d6051a0f7a227332)(function(key, val) {
                return $8306c86393833e34$var$alpha.apply(void 0, $8306c86393833e34$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($8306c86393833e34$var$_objectSpread($8306c86393833e34$var$_objectSpread($8306c86393833e34$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $ce3f8316a03a4ded$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ce3f8316a03a4ded$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ce3f8316a03a4ded$var$_typeof(obj);
}
var $ce3f8316a03a4ded$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $ce3f8316a03a4ded$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ce3f8316a03a4ded$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ce3f8316a03a4ded$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ce3f8316a03a4ded$var$_toConsumableArray(arr) {
    return $ce3f8316a03a4ded$var$_arrayWithoutHoles(arr) || $ce3f8316a03a4ded$var$_iterableToArray(arr) || $ce3f8316a03a4ded$var$_unsupportedIterableToArray(arr) || $ce3f8316a03a4ded$var$_nonIterableSpread();
}
function $ce3f8316a03a4ded$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ce3f8316a03a4ded$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ce3f8316a03a4ded$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ce3f8316a03a4ded$var$_arrayLikeToArray(o, minLen);
}
function $ce3f8316a03a4ded$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ce3f8316a03a4ded$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ce3f8316a03a4ded$var$_arrayLikeToArray(arr);
}
function $ce3f8316a03a4ded$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ce3f8316a03a4ded$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ce3f8316a03a4ded$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ce3f8316a03a4ded$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ce3f8316a03a4ded$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ce3f8316a03a4ded$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ce3f8316a03a4ded$var$_defineProperty(obj, key, value) {
    key = $ce3f8316a03a4ded$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ce3f8316a03a4ded$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ce3f8316a03a4ded$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ce3f8316a03a4ded$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ce3f8316a03a4ded$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ce3f8316a03a4ded$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ce3f8316a03a4ded$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ce3f8316a03a4ded$var$_toPropertyKey(arg) {
    var key = $ce3f8316a03a4ded$var$_toPrimitive(arg, "string");
    return $ce3f8316a03a4ded$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ce3f8316a03a4ded$var$_toPrimitive(input, hint) {
    if ($ce3f8316a03a4ded$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ce3f8316a03a4ded$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ce3f8316a03a4ded$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ce3f8316a03a4ded$var$_setPrototypeOf(subClass, superClass);
}
function $ce3f8316a03a4ded$var$_setPrototypeOf(o, p) {
    $ce3f8316a03a4ded$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ce3f8316a03a4ded$var$_setPrototypeOf(o, p);
}
function $ce3f8316a03a4ded$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ce3f8316a03a4ded$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ce3f8316a03a4ded$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ce3f8316a03a4ded$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ce3f8316a03a4ded$var$_possibleConstructorReturn(this, result);
    };
}
function $ce3f8316a03a4ded$var$_possibleConstructorReturn(self, call) {
    if (call && ($ce3f8316a03a4ded$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ce3f8316a03a4ded$var$_assertThisInitialized(self);
}
function $ce3f8316a03a4ded$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ce3f8316a03a4ded$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ce3f8316a03a4ded$var$_getPrototypeOf(o) {
    $ce3f8316a03a4ded$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ce3f8316a03a4ded$var$_getPrototypeOf(o);
}
var $ce3f8316a03a4ded$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $ce3f8316a03a4ded$var$_inherits(Animate, _PureComponent);
    var _super = $ce3f8316a03a4ded$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $ce3f8316a03a4ded$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($ce3f8316a03a4ded$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($ce3f8316a03a4ded$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === "function") _this.state = {
                style: to
            };
            return $ce3f8316a03a4ded$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === "function") {
                _this.state = {
                    style: from
                };
                return $ce3f8316a03a4ded$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $ce3f8316a03a4ded$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $ce3f8316a03a4ded$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $ce3f8316a03a4ded$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $2b504fb5b10af08d$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $ce3f8316a03a4ded$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && [
                        attributeName
                    ] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($ce3f8316a03a4ded$var$_objectSpread($ce3f8316a03a4ded$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $8306c86393833e34$export$2e2bcd8739ae039)(from, to, (0, $1790572b33a3f433$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? "ease" : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === "function" || easing === "spring") return [].concat($ce3f8316a03a4ded$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $f9553aca757d2dbc$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $ce3f8316a03a4ded$var$_objectSpread($ce3f8316a03a4ded$var$_objectSpread($ce3f8316a03a4ded$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($ce3f8316a03a4ded$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $f9553aca757d2dbc$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($ce3f8316a03a4ded$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $44576c0560ddc367$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === "function" || typeof children === "function" || easing === "spring") {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $ce3f8316a03a4ded$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $f9553aca757d2dbc$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $ce3f8316a03a4ded$var$_objectSpread($ce3f8316a03a4ded$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $ce3f8316a03a4ded$var$_objectWithoutProperties(_this$props4, $ce3f8316a03a4ded$var$_excluded);
                var count = (0, $17VE6.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = (0, $f9553aca757d2dbc$export$ff9926a5d1daa67c)(this.state.style);
                if (typeof children === "function") return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $17VE6.cloneElement)(container, $ce3f8316a03a4ded$var$_objectSpread($ce3f8316a03a4ded$var$_objectSpread({}, others), {}, {
                        style: $ce3f8316a03a4ded$var$_objectSpread($ce3f8316a03a4ded$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $17VE6.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("div", null, (0, $17VE6.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $17VE6.PureComponent));
$ce3f8316a03a4ded$var$Animate.displayName = "Animate";
$ce3f8316a03a4ded$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: "",
    to: "",
    attributeName: "",
    easing: "ease",
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$ce3f8316a03a4ded$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOf([
                "ease",
                "ease-in",
                "ease-out",
                "ease-in-out",
                "linear"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).arrayOf("string"),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func
};
var $ce3f8316a03a4ded$export$2e2bcd8739ae039 = $ce3f8316a03a4ded$var$Animate;





var $17VE6 = parcelRequire("17VE6");
var $63a62aa8096646df$exports = {};
"use strict";

var $63a62aa8096646df$var$_CSSTransition = $63a62aa8096646df$var$_interopRequireDefault((parcelRequire("jJQsa")));

var $63a62aa8096646df$var$_ReplaceTransition = $63a62aa8096646df$var$_interopRequireDefault((parcelRequire("5aUss")));

var $63a62aa8096646df$var$_TransitionGroup = $63a62aa8096646df$var$_interopRequireDefault((parcelRequire("1UgPG")));

var $63a62aa8096646df$var$_Transition = $63a62aa8096646df$var$_interopRequireDefault((parcelRequire("gTgWg")));
function $63a62aa8096646df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$63a62aa8096646df$exports = {
    Transition: $63a62aa8096646df$var$_Transition.default,
    TransitionGroup: $63a62aa8096646df$var$_TransitionGroup.default,
    ReplaceTransition: $63a62aa8096646df$var$_ReplaceTransition.default,
    CSSTransition: $63a62aa8096646df$var$_CSSTransition.default
};



var $51RYA = parcelRequire("51RYA");

var $17VE6 = parcelRequire("17VE6");


var $51RYA = parcelRequire("51RYA");

var $51f26994e9dbaf9f$var$_excluded = [
    "children",
    "appearOptions",
    "enterOptions",
    "leaveOptions"
];
function $51f26994e9dbaf9f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $51f26994e9dbaf9f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $51f26994e9dbaf9f$var$_typeof(obj);
}
function $51f26994e9dbaf9f$var$_extends() {
    $51f26994e9dbaf9f$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $51f26994e9dbaf9f$var$_extends.apply(this, arguments);
}
function $51f26994e9dbaf9f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $51f26994e9dbaf9f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $51f26994e9dbaf9f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $51f26994e9dbaf9f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $51f26994e9dbaf9f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $51f26994e9dbaf9f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $51f26994e9dbaf9f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $51f26994e9dbaf9f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $51f26994e9dbaf9f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $51f26994e9dbaf9f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $51f26994e9dbaf9f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $51f26994e9dbaf9f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $51f26994e9dbaf9f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $51f26994e9dbaf9f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $51f26994e9dbaf9f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $51f26994e9dbaf9f$var$_setPrototypeOf(subClass, superClass);
}
function $51f26994e9dbaf9f$var$_setPrototypeOf(o, p) {
    $51f26994e9dbaf9f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $51f26994e9dbaf9f$var$_setPrototypeOf(o, p);
}
function $51f26994e9dbaf9f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $51f26994e9dbaf9f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $51f26994e9dbaf9f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $51f26994e9dbaf9f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $51f26994e9dbaf9f$var$_possibleConstructorReturn(this, result);
    };
}
function $51f26994e9dbaf9f$var$_possibleConstructorReturn(self, call) {
    if (call && ($51f26994e9dbaf9f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $51f26994e9dbaf9f$var$_assertThisInitialized(self);
}
function $51f26994e9dbaf9f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $51f26994e9dbaf9f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $51f26994e9dbaf9f$var$_getPrototypeOf(o) {
    $51f26994e9dbaf9f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $51f26994e9dbaf9f$var$_getPrototypeOf(o);
}
function $51f26994e9dbaf9f$var$_defineProperty(obj, key, value) {
    key = $51f26994e9dbaf9f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $51f26994e9dbaf9f$var$_toPropertyKey(arg) {
    var key = $51f26994e9dbaf9f$var$_toPrimitive(arg, "string");
    return $51f26994e9dbaf9f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $51f26994e9dbaf9f$var$_toPrimitive(input, hint) {
    if ($51f26994e9dbaf9f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($51f26994e9dbaf9f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
if (Number.isFinite === undefined) Number.isFinite = function(value) {
    return typeof value === "number" && isFinite(value);
};
var $51f26994e9dbaf9f$var$parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var $51f26994e9dbaf9f$var$AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    $51f26994e9dbaf9f$var$_inherits(AnimateGroupChild, _Component);
    var _super = $51f26994e9dbaf9f$var$_createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        $51f26994e9dbaf9f$var$_classCallCheck(this, AnimateGroupChild);
        _this = _super.call(this);
        $51f26994e9dbaf9f$var$_defineProperty($51f26994e9dbaf9f$var$_assertThisInitialized(_this), "handleEnter", function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        });
        $51f26994e9dbaf9f$var$_defineProperty($51f26994e9dbaf9f$var$_assertThisInitialized(_this), "handleExit", function() {
            var leaveOptions = _this.props.leaveOptions;
            _this.handleStyleActive(leaveOptions);
        });
        _this.state = {
            isActive: false
        };
        return _this;
    }
    $51f26994e9dbaf9f$var$_createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function onAnimationEnd() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState($51f26994e9dbaf9f$var$_objectSpread($51f26994e9dbaf9f$var$_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return $51f26994e9dbaf9f$var$parseDurationOfSingleTransition(appearOptions) + $51f26994e9dbaf9f$var$parseDurationOfSingleTransition(enterOptions) + $51f26994e9dbaf9f$var$parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = $51f26994e9dbaf9f$var$_objectWithoutProperties(_this$props3, $51f26994e9dbaf9f$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $63a62aa8096646df$exports.Transition), $51f26994e9dbaf9f$var$_extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $ce3f8316a03a4ded$export$2e2bcd8739ae039), _this2.state, (0, $17VE6.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, $17VE6.Component));
$51f26994e9dbaf9f$var$AnimateGroupChild.propTypes = {
    appearOptions: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).object,
    enterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).object,
    leaveOptions: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).element
};
var $51f26994e9dbaf9f$export$2e2bcd8739ae039 = $51f26994e9dbaf9f$var$AnimateGroupChild;


function $618afc59f9cdbaea$var$AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $63a62aa8096646df$exports.TransitionGroup), {
        component: component
    }, (0, $17VE6.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $51f26994e9dbaf9f$export$2e2bcd8739ae039), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
$618afc59f9cdbaea$var$AnimateGroup.propTypes = {
    appear: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).object,
    enter: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).object,
    leave: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).element
    ]),
    component: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).any
};
$618afc59f9cdbaea$var$AnimateGroup.defaultProps = {
    component: "span"
};
var $618afc59f9cdbaea$export$2e2bcd8739ae039 = $618afc59f9cdbaea$var$AnimateGroup;


var $19c5e74eae47b177$export$2e2bcd8739ae039 = (0, $ce3f8316a03a4ded$export$2e2bcd8739ae039);


var $f0e834f6a857d7b3$exports = {};
var $9e270036c231d6af$exports = {};
var $71992159aec129a5$exports = {};

var $lOsGe = parcelRequire("lOsGe");
/** Built-in value references. */ var $71992159aec129a5$var$Symbol = $lOsGe.Symbol;
$71992159aec129a5$exports = $71992159aec129a5$var$Symbol;


var $732d182b83b416e4$exports = {};

/** Used for built-in method references. */ var $732d182b83b416e4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $732d182b83b416e4$var$hasOwnProperty = $732d182b83b416e4$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $732d182b83b416e4$var$nativeObjectToString = $732d182b83b416e4$var$objectProto.toString;
/** Built-in value references. */ var $732d182b83b416e4$var$symToStringTag = $71992159aec129a5$exports ? $71992159aec129a5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $732d182b83b416e4$var$getRawTag(value) {
    var isOwn = $732d182b83b416e4$var$hasOwnProperty.call(value, $732d182b83b416e4$var$symToStringTag), tag = value[$732d182b83b416e4$var$symToStringTag];
    try {
        value[$732d182b83b416e4$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $732d182b83b416e4$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$732d182b83b416e4$var$symToStringTag] = tag;
        else delete value[$732d182b83b416e4$var$symToStringTag];
    }
    return result;
}
$732d182b83b416e4$exports = $732d182b83b416e4$var$getRawTag;


var $821d3e279082c0bf$exports = {};
/** Used for built-in method references. */ var $821d3e279082c0bf$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $821d3e279082c0bf$var$nativeObjectToString = $821d3e279082c0bf$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $821d3e279082c0bf$var$objectToString(value) {
    return $821d3e279082c0bf$var$nativeObjectToString.call(value);
}
$821d3e279082c0bf$exports = $821d3e279082c0bf$var$objectToString;


/** `Object#toString` result references. */ var $9e270036c231d6af$var$nullTag = "[object Null]", $9e270036c231d6af$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $9e270036c231d6af$var$symToStringTag = $71992159aec129a5$exports ? $71992159aec129a5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $9e270036c231d6af$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $9e270036c231d6af$var$undefinedTag : $9e270036c231d6af$var$nullTag;
    return $9e270036c231d6af$var$symToStringTag && $9e270036c231d6af$var$symToStringTag in Object(value) ? $732d182b83b416e4$exports(value) : $821d3e279082c0bf$exports(value);
}
$9e270036c231d6af$exports = $9e270036c231d6af$var$baseGetTag;


var $f380900e8541e270$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
var $l6pW7 = parcelRequire("l6pW7");
function $f380900e8541e270$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $l6pW7._)(value);
    return value != null && (type == "object" || type == "function");
}
$f380900e8541e270$exports = $f380900e8541e270$var$isObject;


/** `Object#toString` result references. */ var $f0e834f6a857d7b3$var$asyncTag = "[object AsyncFunction]", $f0e834f6a857d7b3$var$funcTag = "[object Function]", $f0e834f6a857d7b3$var$genTag = "[object GeneratorFunction]", $f0e834f6a857d7b3$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $f0e834f6a857d7b3$var$isFunction(value) {
    if (!$f380900e8541e270$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $9e270036c231d6af$exports(value);
    return tag == $f0e834f6a857d7b3$var$funcTag || tag == $f0e834f6a857d7b3$var$genTag || tag == $f0e834f6a857d7b3$var$asyncTag || tag == $f0e834f6a857d7b3$var$proxyTag;
}
$f0e834f6a857d7b3$exports = $f0e834f6a857d7b3$var$isFunction;


var $0b5bf9df70f4d7fd$exports = {};
var $2380c7ba8a434844$exports = {};
var $cb0f03c9c78ae357$exports = {};

var $l6pW7 = parcelRequire("l6pW7");

var $a32d462304244b19$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $a32d462304244b19$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$a32d462304244b19$exports = $a32d462304244b19$var$isObjectLike;


/** `Object#toString` result references. */ var $cb0f03c9c78ae357$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $cb0f03c9c78ae357$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $l6pW7._)(value)) == "symbol" || $a32d462304244b19$exports(value) && $9e270036c231d6af$exports(value) == $cb0f03c9c78ae357$var$symbolTag;
}
$cb0f03c9c78ae357$exports = $cb0f03c9c78ae357$var$isSymbol;


/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $2380c7ba8a434844$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$cb0f03c9c78ae357$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$2380c7ba8a434844$exports = $2380c7ba8a434844$var$baseExtremum;


var $c58a29a385801a5b$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $c58a29a385801a5b$var$baseGt(value, other) {
    return value > other;
}
$c58a29a385801a5b$exports = $c58a29a385801a5b$var$baseGt;


var $cce66a01738bac69$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $cce66a01738bac69$var$identity(value) {
    return value;
}
$cce66a01738bac69$exports = $cce66a01738bac69$var$identity;


/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $0b5bf9df70f4d7fd$var$max(array) {
    return array && array.length ? $2380c7ba8a434844$exports(array, $cce66a01738bac69$exports, $c58a29a385801a5b$exports) : undefined;
}
$0b5bf9df70f4d7fd$exports = $0b5bf9df70f4d7fd$var$max;


var $6ab57f7722177cda$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $6ab57f7722177cda$var$isNil(value) {
    return value == null;
}
$6ab57f7722177cda$exports = $6ab57f7722177cda$var$isNil;


var $d13e95156e78f92e$exports = {};
var $559e72ee1c5e4e7a$exports = {};


/** `Object#toString` result references. */ var $559e72ee1c5e4e7a$var$numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $559e72ee1c5e4e7a$var$isNumber(value) {
    return typeof value == "number" || $a32d462304244b19$exports(value) && $9e270036c231d6af$exports(value) == $559e72ee1c5e4e7a$var$numberTag;
}
$559e72ee1c5e4e7a$exports = $559e72ee1c5e4e7a$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $d13e95156e78f92e$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $559e72ee1c5e4e7a$exports(value) && value != +value;
}
$d13e95156e78f92e$exports = $d13e95156e78f92e$var$isNaN;


var $c65581b1798022be$exports = {};
var $65941e528e4658cd$exports = {};
var $424320998f1e3631$exports = {};
var $2c3262e24cd34715$exports = {};
var $f6698c83afc01cf2$exports = {};
var $f814a5072d712a1c$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $f814a5072d712a1c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$f814a5072d712a1c$exports = $f814a5072d712a1c$var$listCacheClear;


var $e7ce8eb29a4287c0$exports = {};
var $afd574a8f2e943ee$exports = {};
var $6b3186e18fa15b95$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $6b3186e18fa15b95$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$6b3186e18fa15b95$exports = $6b3186e18fa15b95$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $afd574a8f2e943ee$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6b3186e18fa15b95$exports(array[length][0], key)) return length;
    }
    return -1;
}
$afd574a8f2e943ee$exports = $afd574a8f2e943ee$var$assocIndexOf;


/** Used for built-in method references. */ var $e7ce8eb29a4287c0$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $e7ce8eb29a4287c0$var$splice = $e7ce8eb29a4287c0$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e7ce8eb29a4287c0$var$listCacheDelete(key) {
    var data = this.__data__, index = $afd574a8f2e943ee$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $e7ce8eb29a4287c0$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$e7ce8eb29a4287c0$exports = $e7ce8eb29a4287c0$var$listCacheDelete;


var $429d2ba6fb4559a1$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $429d2ba6fb4559a1$var$listCacheGet(key) {
    var data = this.__data__, index = $afd574a8f2e943ee$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$429d2ba6fb4559a1$exports = $429d2ba6fb4559a1$var$listCacheGet;


var $deac0d0a063c7421$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $deac0d0a063c7421$var$listCacheHas(key) {
    return $afd574a8f2e943ee$exports(this.__data__, key) > -1;
}
$deac0d0a063c7421$exports = $deac0d0a063c7421$var$listCacheHas;


var $b7754c1a108854ce$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b7754c1a108854ce$var$listCacheSet(key, value) {
    var data = this.__data__, index = $afd574a8f2e943ee$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$b7754c1a108854ce$exports = $b7754c1a108854ce$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f6698c83afc01cf2$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f6698c83afc01cf2$var$ListCache.prototype.clear = $f814a5072d712a1c$exports;
$f6698c83afc01cf2$var$ListCache.prototype["delete"] = $e7ce8eb29a4287c0$exports;
$f6698c83afc01cf2$var$ListCache.prototype.get = $429d2ba6fb4559a1$exports;
$f6698c83afc01cf2$var$ListCache.prototype.has = $deac0d0a063c7421$exports;
$f6698c83afc01cf2$var$ListCache.prototype.set = $b7754c1a108854ce$exports;
$f6698c83afc01cf2$exports = $f6698c83afc01cf2$var$ListCache;


var $bf66f4cb953d41bf$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $bf66f4cb953d41bf$var$stackClear() {
    this.__data__ = new $f6698c83afc01cf2$exports;
    this.size = 0;
}
$bf66f4cb953d41bf$exports = $bf66f4cb953d41bf$var$stackClear;


var $a614893a437c094b$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a614893a437c094b$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$a614893a437c094b$exports = $a614893a437c094b$var$stackDelete;


var $73819fb5d1295bcd$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $73819fb5d1295bcd$var$stackGet(key) {
    return this.__data__.get(key);
}
$73819fb5d1295bcd$exports = $73819fb5d1295bcd$var$stackGet;


var $e46516fbaa2b8abe$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e46516fbaa2b8abe$var$stackHas(key) {
    return this.__data__.has(key);
}
$e46516fbaa2b8abe$exports = $e46516fbaa2b8abe$var$stackHas;


var $b46a3c3e95a59167$exports = {};

var $d15e53f870973922$exports = {};
var $6df30fd6a8cb9aaf$exports = {};
var $216ccdde6715afc5$exports = {};

var $4dcabaf1f2ab1ff5$exports = {};
var $024b68dd946bacb7$exports = {};

var $lOsGe = parcelRequire("lOsGe");
/** Used to detect overreaching core-js shims. */ var $024b68dd946bacb7$var$coreJsData = $lOsGe["__core-js_shared__"];
$024b68dd946bacb7$exports = $024b68dd946bacb7$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $4dcabaf1f2ab1ff5$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($024b68dd946bacb7$exports && $024b68dd946bacb7$exports.keys && $024b68dd946bacb7$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $4dcabaf1f2ab1ff5$var$isMasked(func) {
    return !!$4dcabaf1f2ab1ff5$var$maskSrcKey && $4dcabaf1f2ab1ff5$var$maskSrcKey in func;
}
$4dcabaf1f2ab1ff5$exports = $4dcabaf1f2ab1ff5$var$isMasked;



var $22b039b4752cdf0b$exports = {};
/** Used for built-in method references. */ var $22b039b4752cdf0b$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $22b039b4752cdf0b$var$funcToString = $22b039b4752cdf0b$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $22b039b4752cdf0b$var$toSource(func) {
    if (func != null) {
        try {
            return $22b039b4752cdf0b$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$22b039b4752cdf0b$exports = $22b039b4752cdf0b$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $216ccdde6715afc5$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $216ccdde6715afc5$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $216ccdde6715afc5$var$funcProto = Function.prototype, $216ccdde6715afc5$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $216ccdde6715afc5$var$funcToString = $216ccdde6715afc5$var$funcProto.toString;
/** Used to check objects for own properties. */ var $216ccdde6715afc5$var$hasOwnProperty = $216ccdde6715afc5$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $216ccdde6715afc5$var$reIsNative = RegExp("^" + $216ccdde6715afc5$var$funcToString.call($216ccdde6715afc5$var$hasOwnProperty).replace($216ccdde6715afc5$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $216ccdde6715afc5$var$baseIsNative(value) {
    if (!$f380900e8541e270$exports(value) || $4dcabaf1f2ab1ff5$exports(value)) return false;
    var pattern = $f0e834f6a857d7b3$exports(value) ? $216ccdde6715afc5$var$reIsNative : $216ccdde6715afc5$var$reIsHostCtor;
    return pattern.test($22b039b4752cdf0b$exports(value));
}
$216ccdde6715afc5$exports = $216ccdde6715afc5$var$baseIsNative;


var $ed15fe77dbdb1948$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $ed15fe77dbdb1948$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$ed15fe77dbdb1948$exports = $ed15fe77dbdb1948$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $6df30fd6a8cb9aaf$var$getNative(object, key) {
    var value = $ed15fe77dbdb1948$exports(object, key);
    return $216ccdde6715afc5$exports(value) ? value : undefined;
}
$6df30fd6a8cb9aaf$exports = $6df30fd6a8cb9aaf$var$getNative;



var $lOsGe = parcelRequire("lOsGe");
/* Built-in method references that are verified to be native. */ var $d15e53f870973922$var$Map = $6df30fd6a8cb9aaf$exports($lOsGe, "Map");
$d15e53f870973922$exports = $d15e53f870973922$var$Map;


var $636eaac3516f8d10$exports = {};
var $4aa72f5e66937fbc$exports = {};
var $d58a97c4288d7d68$exports = {};
var $123f22eebe546a3e$exports = {};
var $878a784678d92d9c$exports = {};

/* Built-in method references that are verified to be native. */ var $878a784678d92d9c$var$nativeCreate = $6df30fd6a8cb9aaf$exports(Object, "create");
$878a784678d92d9c$exports = $878a784678d92d9c$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $123f22eebe546a3e$var$hashClear() {
    this.__data__ = $878a784678d92d9c$exports ? $878a784678d92d9c$exports(null) : {};
    this.size = 0;
}
$123f22eebe546a3e$exports = $123f22eebe546a3e$var$hashClear;


var $6164f17f6327ccb7$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6164f17f6327ccb7$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$6164f17f6327ccb7$exports = $6164f17f6327ccb7$var$hashDelete;


var $f294f031fb288058$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $f294f031fb288058$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $f294f031fb288058$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f294f031fb288058$var$hasOwnProperty = $f294f031fb288058$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f294f031fb288058$var$hashGet(key) {
    var data = this.__data__;
    if ($878a784678d92d9c$exports) {
        var result = data[key];
        return result === $f294f031fb288058$var$HASH_UNDEFINED ? undefined : result;
    }
    return $f294f031fb288058$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$f294f031fb288058$exports = $f294f031fb288058$var$hashGet;


var $c10ef8c7795a77bc$exports = {};

/** Used for built-in method references. */ var $c10ef8c7795a77bc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c10ef8c7795a77bc$var$hasOwnProperty = $c10ef8c7795a77bc$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c10ef8c7795a77bc$var$hashHas(key) {
    var data = this.__data__;
    return $878a784678d92d9c$exports ? data[key] !== undefined : $c10ef8c7795a77bc$var$hasOwnProperty.call(data, key);
}
$c10ef8c7795a77bc$exports = $c10ef8c7795a77bc$var$hashHas;


var $6dc07d8f999f472a$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $6dc07d8f999f472a$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $6dc07d8f999f472a$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $878a784678d92d9c$exports && value === undefined ? $6dc07d8f999f472a$var$HASH_UNDEFINED : value;
    return this;
}
$6dc07d8f999f472a$exports = $6dc07d8f999f472a$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d58a97c4288d7d68$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$d58a97c4288d7d68$var$Hash.prototype.clear = $123f22eebe546a3e$exports;
$d58a97c4288d7d68$var$Hash.prototype["delete"] = $6164f17f6327ccb7$exports;
$d58a97c4288d7d68$var$Hash.prototype.get = $f294f031fb288058$exports;
$d58a97c4288d7d68$var$Hash.prototype.has = $c10ef8c7795a77bc$exports;
$d58a97c4288d7d68$var$Hash.prototype.set = $6dc07d8f999f472a$exports;
$d58a97c4288d7d68$exports = $d58a97c4288d7d68$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $4aa72f5e66937fbc$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $d58a97c4288d7d68$exports,
        "map": new ($d15e53f870973922$exports || $f6698c83afc01cf2$exports),
        "string": new $d58a97c4288d7d68$exports
    };
}
$4aa72f5e66937fbc$exports = $4aa72f5e66937fbc$var$mapCacheClear;


var $f6f22c3fd3440c2a$exports = {};
var $c7c2dcb3fc10abf2$exports = {};
var $cc76e26c12b37b67$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ 
var $l6pW7 = parcelRequire("l6pW7");
function $cc76e26c12b37b67$var$isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $l6pW7._)(value);
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$cc76e26c12b37b67$exports = $cc76e26c12b37b67$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c7c2dcb3fc10abf2$var$getMapData(map, key) {
    var data = map.__data__;
    return $cc76e26c12b37b67$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$c7c2dcb3fc10abf2$exports = $c7c2dcb3fc10abf2$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f6f22c3fd3440c2a$var$mapCacheDelete(key) {
    var result = $c7c2dcb3fc10abf2$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$f6f22c3fd3440c2a$exports = $f6f22c3fd3440c2a$var$mapCacheDelete;


var $eeeba4c206647761$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $eeeba4c206647761$var$mapCacheGet(key) {
    return $c7c2dcb3fc10abf2$exports(this, key).get(key);
}
$eeeba4c206647761$exports = $eeeba4c206647761$var$mapCacheGet;


var $c035a3b9dddd4d11$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c035a3b9dddd4d11$var$mapCacheHas(key) {
    return $c7c2dcb3fc10abf2$exports(this, key).has(key);
}
$c035a3b9dddd4d11$exports = $c035a3b9dddd4d11$var$mapCacheHas;


var $047b86fb283595e2$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $047b86fb283595e2$var$mapCacheSet(key, value) {
    var data = $c7c2dcb3fc10abf2$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$047b86fb283595e2$exports = $047b86fb283595e2$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $636eaac3516f8d10$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$636eaac3516f8d10$var$MapCache.prototype.clear = $4aa72f5e66937fbc$exports;
$636eaac3516f8d10$var$MapCache.prototype["delete"] = $f6f22c3fd3440c2a$exports;
$636eaac3516f8d10$var$MapCache.prototype.get = $eeeba4c206647761$exports;
$636eaac3516f8d10$var$MapCache.prototype.has = $c035a3b9dddd4d11$exports;
$636eaac3516f8d10$var$MapCache.prototype.set = $047b86fb283595e2$exports;
$636eaac3516f8d10$exports = $636eaac3516f8d10$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $b46a3c3e95a59167$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $b46a3c3e95a59167$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $f6698c83afc01cf2$exports) {
        var pairs = data.__data__;
        if (!$d15e53f870973922$exports || pairs.length < $b46a3c3e95a59167$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $636eaac3516f8d10$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$b46a3c3e95a59167$exports = $b46a3c3e95a59167$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2c3262e24cd34715$var$Stack(entries) {
    var data = this.__data__ = new $f6698c83afc01cf2$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$2c3262e24cd34715$var$Stack.prototype.clear = $bf66f4cb953d41bf$exports;
$2c3262e24cd34715$var$Stack.prototype["delete"] = $a614893a437c094b$exports;
$2c3262e24cd34715$var$Stack.prototype.get = $73819fb5d1295bcd$exports;
$2c3262e24cd34715$var$Stack.prototype.has = $e46516fbaa2b8abe$exports;
$2c3262e24cd34715$var$Stack.prototype.set = $b46a3c3e95a59167$exports;
$2c3262e24cd34715$exports = $2c3262e24cd34715$var$Stack;


var $fa004b4c2c17cd67$exports = {};
var $6d3c890c87187d82$exports = {};

var $4c86aadd2253c871$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $4c86aadd2253c871$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $4c86aadd2253c871$var$setCacheAdd(value) {
    this.__data__.set(value, $4c86aadd2253c871$var$HASH_UNDEFINED);
    return this;
}
$4c86aadd2253c871$exports = $4c86aadd2253c871$var$setCacheAdd;


var $0a94080650a296a0$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $0a94080650a296a0$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$0a94080650a296a0$exports = $0a94080650a296a0$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $6d3c890c87187d82$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $636eaac3516f8d10$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$6d3c890c87187d82$var$SetCache.prototype.add = $6d3c890c87187d82$var$SetCache.prototype.push = $4c86aadd2253c871$exports;
$6d3c890c87187d82$var$SetCache.prototype.has = $0a94080650a296a0$exports;
$6d3c890c87187d82$exports = $6d3c890c87187d82$var$SetCache;


var $8f9734db711cbf53$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $8f9734db711cbf53$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$8f9734db711cbf53$exports = $8f9734db711cbf53$var$arraySome;


var $796b0066cf0256f0$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $796b0066cf0256f0$var$cacheHas(cache, key) {
    return cache.has(key);
}
$796b0066cf0256f0$exports = $796b0066cf0256f0$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $fa004b4c2c17cd67$var$COMPARE_PARTIAL_FLAG = 1, $fa004b4c2c17cd67$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $fa004b4c2c17cd67$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $fa004b4c2c17cd67$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $fa004b4c2c17cd67$var$COMPARE_UNORDERED_FLAG ? new $6d3c890c87187d82$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$8f9734db711cbf53$exports(other, function(othValue, othIndex) {
                if (!$796b0066cf0256f0$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$fa004b4c2c17cd67$exports = $fa004b4c2c17cd67$var$equalArrays;


var $990a695e7609cc2c$exports = {};

var $76423deb56513841$exports = {};

var $lOsGe = parcelRequire("lOsGe");
/** Built-in value references. */ var $76423deb56513841$var$Uint8Array = $lOsGe.Uint8Array;
$76423deb56513841$exports = $76423deb56513841$var$Uint8Array;




var $d461571891868e4f$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $d461571891868e4f$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$d461571891868e4f$exports = $d461571891868e4f$var$mapToArray;


var $faaf31b1e98288a5$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $faaf31b1e98288a5$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$faaf31b1e98288a5$exports = $faaf31b1e98288a5$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $990a695e7609cc2c$var$COMPARE_PARTIAL_FLAG = 1, $990a695e7609cc2c$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $990a695e7609cc2c$var$boolTag = "[object Boolean]", $990a695e7609cc2c$var$dateTag = "[object Date]", $990a695e7609cc2c$var$errorTag = "[object Error]", $990a695e7609cc2c$var$mapTag = "[object Map]", $990a695e7609cc2c$var$numberTag = "[object Number]", $990a695e7609cc2c$var$regexpTag = "[object RegExp]", $990a695e7609cc2c$var$setTag = "[object Set]", $990a695e7609cc2c$var$stringTag = "[object String]", $990a695e7609cc2c$var$symbolTag = "[object Symbol]";
var $990a695e7609cc2c$var$arrayBufferTag = "[object ArrayBuffer]", $990a695e7609cc2c$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $990a695e7609cc2c$var$symbolProto = $71992159aec129a5$exports ? $71992159aec129a5$exports.prototype : undefined, $990a695e7609cc2c$var$symbolValueOf = $990a695e7609cc2c$var$symbolProto ? $990a695e7609cc2c$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $990a695e7609cc2c$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $990a695e7609cc2c$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $990a695e7609cc2c$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $76423deb56513841$exports(object), new $76423deb56513841$exports(other))) return false;
            return true;
        case $990a695e7609cc2c$var$boolTag:
        case $990a695e7609cc2c$var$dateTag:
        case $990a695e7609cc2c$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6b3186e18fa15b95$exports(+object, +other);
        case $990a695e7609cc2c$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $990a695e7609cc2c$var$regexpTag:
        case $990a695e7609cc2c$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $990a695e7609cc2c$var$mapTag:
            var convert = $d461571891868e4f$exports;
        case $990a695e7609cc2c$var$setTag:
            var isPartial = bitmask & $990a695e7609cc2c$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $faaf31b1e98288a5$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $990a695e7609cc2c$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $fa004b4c2c17cd67$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $990a695e7609cc2c$var$symbolTag:
            if ($990a695e7609cc2c$var$symbolValueOf) return $990a695e7609cc2c$var$symbolValueOf.call(object) == $990a695e7609cc2c$var$symbolValueOf.call(other);
    }
    return false;
}
$990a695e7609cc2c$exports = $990a695e7609cc2c$var$equalByTag;


var $e7d44cf5556750b1$exports = {};
var $72d4d7abe5584704$exports = {};
var $8220d9fb92f17173$exports = {};
var $0235ed4d78598c5a$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $0235ed4d78598c5a$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$0235ed4d78598c5a$exports = $0235ed4d78598c5a$var$arrayPush;


var $09ea814803501f1d$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $09ea814803501f1d$var$isArray = Array.isArray;
$09ea814803501f1d$exports = $09ea814803501f1d$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $8220d9fb92f17173$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $09ea814803501f1d$exports(object) ? result : $0235ed4d78598c5a$exports(result, symbolsFunc(object));
}
$8220d9fb92f17173$exports = $8220d9fb92f17173$var$baseGetAllKeys;


var $38b031be7b99dbb8$exports = {};
var $139f7ab3072cbb3e$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $139f7ab3072cbb3e$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$139f7ab3072cbb3e$exports = $139f7ab3072cbb3e$var$arrayFilter;


var $39e18b2c06965b19$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $39e18b2c06965b19$var$stubArray() {
    return [];
}
$39e18b2c06965b19$exports = $39e18b2c06965b19$var$stubArray;


/** Used for built-in method references. */ var $38b031be7b99dbb8$var$objectProto = Object.prototype;
/** Built-in value references. */ var $38b031be7b99dbb8$var$propertyIsEnumerable = $38b031be7b99dbb8$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $38b031be7b99dbb8$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $38b031be7b99dbb8$var$getSymbols = !$38b031be7b99dbb8$var$nativeGetSymbols ? $39e18b2c06965b19$exports : function getSymbols(object) {
    if (object == null) return [];
    object = Object(object);
    return $139f7ab3072cbb3e$exports($38b031be7b99dbb8$var$nativeGetSymbols(object), function(symbol) {
        return $38b031be7b99dbb8$var$propertyIsEnumerable.call(object, symbol);
    });
};
$38b031be7b99dbb8$exports = $38b031be7b99dbb8$var$getSymbols;


var $3dc1c18e15bcdad3$exports = {};
var $96f56017c1bfb930$exports = {};
var $dcefed75561d04ee$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $dcefed75561d04ee$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$dcefed75561d04ee$exports = $dcefed75561d04ee$var$baseTimes;


var $8b610a525d3474a7$exports = {};
var $92c2b5b5fa4b8e1f$exports = {};


/** `Object#toString` result references. */ var $92c2b5b5fa4b8e1f$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $92c2b5b5fa4b8e1f$var$baseIsArguments(value) {
    return $a32d462304244b19$exports(value) && $9e270036c231d6af$exports(value) == $92c2b5b5fa4b8e1f$var$argsTag;
}
$92c2b5b5fa4b8e1f$exports = $92c2b5b5fa4b8e1f$var$baseIsArguments;



/** Used for built-in method references. */ var $8b610a525d3474a7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8b610a525d3474a7$var$hasOwnProperty = $8b610a525d3474a7$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $8b610a525d3474a7$var$propertyIsEnumerable = $8b610a525d3474a7$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $8b610a525d3474a7$var$isArguments = $92c2b5b5fa4b8e1f$exports(function() {
    return arguments;
}()) ? $92c2b5b5fa4b8e1f$exports : function isArguments(value) {
    return $a32d462304244b19$exports(value) && $8b610a525d3474a7$var$hasOwnProperty.call(value, "callee") && !$8b610a525d3474a7$var$propertyIsEnumerable.call(value, "callee");
};
$8b610a525d3474a7$exports = $8b610a525d3474a7$var$isArguments;




var $ACrt1 = parcelRequire("ACrt1");
var $5ccb7c184c2fbd64$exports = {};
/** Used as references for various `Number` constants. */ 
var $l6pW7 = parcelRequire("l6pW7");
var $5ccb7c184c2fbd64$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $5ccb7c184c2fbd64$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $5ccb7c184c2fbd64$var$isIndex(value, length) {
    var type = typeof value === "undefined" ? "undefined" : (0, $l6pW7._)(value);
    length = length == null ? $5ccb7c184c2fbd64$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $5ccb7c184c2fbd64$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$5ccb7c184c2fbd64$exports = $5ccb7c184c2fbd64$var$isIndex;


var $400cb33ea5f84dba$exports = {};
var $d0023c020f93f849$exports = {};

var $b31c57ec47457aa7$exports = {};
/** Used as references for various `Number` constants. */ var $b31c57ec47457aa7$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $b31c57ec47457aa7$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $b31c57ec47457aa7$var$MAX_SAFE_INTEGER;
}
$b31c57ec47457aa7$exports = $b31c57ec47457aa7$var$isLength;



/** `Object#toString` result references. */ var $d0023c020f93f849$var$argsTag = "[object Arguments]", $d0023c020f93f849$var$arrayTag = "[object Array]", $d0023c020f93f849$var$boolTag = "[object Boolean]", $d0023c020f93f849$var$dateTag = "[object Date]", $d0023c020f93f849$var$errorTag = "[object Error]", $d0023c020f93f849$var$funcTag = "[object Function]", $d0023c020f93f849$var$mapTag = "[object Map]", $d0023c020f93f849$var$numberTag = "[object Number]", $d0023c020f93f849$var$objectTag = "[object Object]", $d0023c020f93f849$var$regexpTag = "[object RegExp]", $d0023c020f93f849$var$setTag = "[object Set]", $d0023c020f93f849$var$stringTag = "[object String]", $d0023c020f93f849$var$weakMapTag = "[object WeakMap]";
var $d0023c020f93f849$var$arrayBufferTag = "[object ArrayBuffer]", $d0023c020f93f849$var$dataViewTag = "[object DataView]", $d0023c020f93f849$var$float32Tag = "[object Float32Array]", $d0023c020f93f849$var$float64Tag = "[object Float64Array]", $d0023c020f93f849$var$int8Tag = "[object Int8Array]", $d0023c020f93f849$var$int16Tag = "[object Int16Array]", $d0023c020f93f849$var$int32Tag = "[object Int32Array]", $d0023c020f93f849$var$uint8Tag = "[object Uint8Array]", $d0023c020f93f849$var$uint8ClampedTag = "[object Uint8ClampedArray]", $d0023c020f93f849$var$uint16Tag = "[object Uint16Array]", $d0023c020f93f849$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $d0023c020f93f849$var$typedArrayTags = {};
$d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$float32Tag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$float64Tag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$int8Tag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$int16Tag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$int32Tag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$uint8Tag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$uint8ClampedTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$uint16Tag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$uint32Tag] = true;
$d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$argsTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$arrayTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$arrayBufferTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$boolTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$dataViewTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$dateTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$errorTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$funcTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$mapTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$numberTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$objectTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$regexpTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$setTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$stringTag] = $d0023c020f93f849$var$typedArrayTags[$d0023c020f93f849$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $d0023c020f93f849$var$baseIsTypedArray(value) {
    return $a32d462304244b19$exports(value) && $b31c57ec47457aa7$exports(value.length) && !!$d0023c020f93f849$var$typedArrayTags[$9e270036c231d6af$exports(value)];
}
$d0023c020f93f849$exports = $d0023c020f93f849$var$baseIsTypedArray;


var $e0967f0998236dc9$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $e0967f0998236dc9$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$e0967f0998236dc9$exports = $e0967f0998236dc9$var$baseUnary;



var $lvXVP = parcelRequire("lvXVP");
/* Node.js helper references. */ var $400cb33ea5f84dba$var$nodeIsTypedArray = $lvXVP && $lvXVP.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $400cb33ea5f84dba$var$isTypedArray = $400cb33ea5f84dba$var$nodeIsTypedArray ? $e0967f0998236dc9$exports($400cb33ea5f84dba$var$nodeIsTypedArray) : $d0023c020f93f849$exports;
$400cb33ea5f84dba$exports = $400cb33ea5f84dba$var$isTypedArray;


/** Used for built-in method references. */ var $96f56017c1bfb930$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $96f56017c1bfb930$var$hasOwnProperty = $96f56017c1bfb930$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $96f56017c1bfb930$var$arrayLikeKeys(value, inherited) {
    var isArr = $09ea814803501f1d$exports(value), isArg = !isArr && $8b610a525d3474a7$exports(value), isBuff = !isArr && !isArg && $ACrt1(value), isType = !isArr && !isArg && !isBuff && $400cb33ea5f84dba$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $dcefed75561d04ee$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $96f56017c1bfb930$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $5ccb7c184c2fbd64$exports(key, length)))) result.push(key);
    return result;
}
$96f56017c1bfb930$exports = $96f56017c1bfb930$var$arrayLikeKeys;


var $343f8da4a93b7ccb$exports = {};
var $34dafb34080c2a11$exports = {};
/** Used for built-in method references. */ var $34dafb34080c2a11$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $34dafb34080c2a11$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $34dafb34080c2a11$var$objectProto;
    return value === proto;
}
$34dafb34080c2a11$exports = $34dafb34080c2a11$var$isPrototype;


var $cbe92b985fdac29a$exports = {};
var $c78791449524217e$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $c78791449524217e$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$c78791449524217e$exports = $c78791449524217e$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $cbe92b985fdac29a$var$nativeKeys = $c78791449524217e$exports(Object.keys, Object);
$cbe92b985fdac29a$exports = $cbe92b985fdac29a$var$nativeKeys;


/** Used for built-in method references. */ var $343f8da4a93b7ccb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $343f8da4a93b7ccb$var$hasOwnProperty = $343f8da4a93b7ccb$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $343f8da4a93b7ccb$var$baseKeys(object) {
    if (!$34dafb34080c2a11$exports(object)) return $cbe92b985fdac29a$exports(object);
    var result = [];
    for(var key in Object(object))if ($343f8da4a93b7ccb$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$343f8da4a93b7ccb$exports = $343f8da4a93b7ccb$var$baseKeys;


var $a69fe579d8ce5bee$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $a69fe579d8ce5bee$var$isArrayLike(value) {
    return value != null && $b31c57ec47457aa7$exports(value.length) && !$f0e834f6a857d7b3$exports(value);
}
$a69fe579d8ce5bee$exports = $a69fe579d8ce5bee$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $3dc1c18e15bcdad3$var$keys(object) {
    return $a69fe579d8ce5bee$exports(object) ? $96f56017c1bfb930$exports(object) : $343f8da4a93b7ccb$exports(object);
}
$3dc1c18e15bcdad3$exports = $3dc1c18e15bcdad3$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $72d4d7abe5584704$var$getAllKeys(object) {
    return $8220d9fb92f17173$exports(object, $3dc1c18e15bcdad3$exports, $38b031be7b99dbb8$exports);
}
$72d4d7abe5584704$exports = $72d4d7abe5584704$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $e7d44cf5556750b1$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $e7d44cf5556750b1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e7d44cf5556750b1$var$hasOwnProperty = $e7d44cf5556750b1$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e7d44cf5556750b1$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $e7d44cf5556750b1$var$COMPARE_PARTIAL_FLAG, objProps = $72d4d7abe5584704$exports(object), objLength = objProps.length, othProps = $72d4d7abe5584704$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $e7d44cf5556750b1$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$e7d44cf5556750b1$exports = $e7d44cf5556750b1$var$equalObjects;


var $f5332b23299bf215$exports = {};
var $a12a94b9083264cf$exports = {};


var $lOsGe = parcelRequire("lOsGe");
/* Built-in method references that are verified to be native. */ var $a12a94b9083264cf$var$DataView = $6df30fd6a8cb9aaf$exports($lOsGe, "DataView");
$a12a94b9083264cf$exports = $a12a94b9083264cf$var$DataView;



var $d7f7a419ae939fcd$exports = {};


var $lOsGe = parcelRequire("lOsGe");
/* Built-in method references that are verified to be native. */ var $d7f7a419ae939fcd$var$Promise = $6df30fd6a8cb9aaf$exports($lOsGe, "Promise");
$d7f7a419ae939fcd$exports = $d7f7a419ae939fcd$var$Promise;


var $ccc09482cb2f0d3b$exports = {};


var $lOsGe = parcelRequire("lOsGe");
/* Built-in method references that are verified to be native. */ var $ccc09482cb2f0d3b$var$Set = $6df30fd6a8cb9aaf$exports($lOsGe, "Set");
$ccc09482cb2f0d3b$exports = $ccc09482cb2f0d3b$var$Set;


var $92d4551e000937ac$exports = {};


var $lOsGe = parcelRequire("lOsGe");
/* Built-in method references that are verified to be native. */ var $92d4551e000937ac$var$WeakMap = $6df30fd6a8cb9aaf$exports($lOsGe, "WeakMap");
$92d4551e000937ac$exports = $92d4551e000937ac$var$WeakMap;




/** `Object#toString` result references. */ var $f5332b23299bf215$var$mapTag = "[object Map]", $f5332b23299bf215$var$objectTag = "[object Object]", $f5332b23299bf215$var$promiseTag = "[object Promise]", $f5332b23299bf215$var$setTag = "[object Set]", $f5332b23299bf215$var$weakMapTag = "[object WeakMap]";
var $f5332b23299bf215$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $f5332b23299bf215$var$dataViewCtorString = $22b039b4752cdf0b$exports($a12a94b9083264cf$exports), $f5332b23299bf215$var$mapCtorString = $22b039b4752cdf0b$exports($d15e53f870973922$exports), $f5332b23299bf215$var$promiseCtorString = $22b039b4752cdf0b$exports($d7f7a419ae939fcd$exports), $f5332b23299bf215$var$setCtorString = $22b039b4752cdf0b$exports($ccc09482cb2f0d3b$exports), $f5332b23299bf215$var$weakMapCtorString = $22b039b4752cdf0b$exports($92d4551e000937ac$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $f5332b23299bf215$var$getTag = $9e270036c231d6af$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($a12a94b9083264cf$exports && $f5332b23299bf215$var$getTag(new $a12a94b9083264cf$exports(new ArrayBuffer(1))) != $f5332b23299bf215$var$dataViewTag || $d15e53f870973922$exports && $f5332b23299bf215$var$getTag(new $d15e53f870973922$exports) != $f5332b23299bf215$var$mapTag || $d7f7a419ae939fcd$exports && $f5332b23299bf215$var$getTag($d7f7a419ae939fcd$exports.resolve()) != $f5332b23299bf215$var$promiseTag || $ccc09482cb2f0d3b$exports && $f5332b23299bf215$var$getTag(new $ccc09482cb2f0d3b$exports) != $f5332b23299bf215$var$setTag || $92d4551e000937ac$exports && $f5332b23299bf215$var$getTag(new $92d4551e000937ac$exports) != $f5332b23299bf215$var$weakMapTag) $f5332b23299bf215$var$getTag = function getTag(value) {
    var result = $9e270036c231d6af$exports(value), Ctor = result == $f5332b23299bf215$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $22b039b4752cdf0b$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $f5332b23299bf215$var$dataViewCtorString:
            return $f5332b23299bf215$var$dataViewTag;
        case $f5332b23299bf215$var$mapCtorString:
            return $f5332b23299bf215$var$mapTag;
        case $f5332b23299bf215$var$promiseCtorString:
            return $f5332b23299bf215$var$promiseTag;
        case $f5332b23299bf215$var$setCtorString:
            return $f5332b23299bf215$var$setTag;
        case $f5332b23299bf215$var$weakMapCtorString:
            return $f5332b23299bf215$var$weakMapTag;
    }
    return result;
};
$f5332b23299bf215$exports = $f5332b23299bf215$var$getTag;




var $ACrt1 = parcelRequire("ACrt1");

/** Used to compose bitmasks for value comparisons. */ var $424320998f1e3631$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $424320998f1e3631$var$argsTag = "[object Arguments]", $424320998f1e3631$var$arrayTag = "[object Array]", $424320998f1e3631$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $424320998f1e3631$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $424320998f1e3631$var$hasOwnProperty = $424320998f1e3631$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $424320998f1e3631$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $09ea814803501f1d$exports(object), othIsArr = $09ea814803501f1d$exports(other), objTag = objIsArr ? $424320998f1e3631$var$arrayTag : $f5332b23299bf215$exports(object), othTag = othIsArr ? $424320998f1e3631$var$arrayTag : $f5332b23299bf215$exports(other);
    objTag = objTag == $424320998f1e3631$var$argsTag ? $424320998f1e3631$var$objectTag : objTag;
    othTag = othTag == $424320998f1e3631$var$argsTag ? $424320998f1e3631$var$objectTag : othTag;
    var objIsObj = objTag == $424320998f1e3631$var$objectTag, othIsObj = othTag == $424320998f1e3631$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $ACrt1(object)) {
        if (!$ACrt1(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $2c3262e24cd34715$exports);
        return objIsArr || $400cb33ea5f84dba$exports(object) ? $fa004b4c2c17cd67$exports(object, other, bitmask, customizer, equalFunc, stack) : $990a695e7609cc2c$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $424320998f1e3631$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $424320998f1e3631$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $424320998f1e3631$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $2c3262e24cd34715$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $2c3262e24cd34715$exports);
    return $e7d44cf5556750b1$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$424320998f1e3631$exports = $424320998f1e3631$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $65941e528e4658cd$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$a32d462304244b19$exports(value) && !$a32d462304244b19$exports(other)) return value !== value && other !== other;
    return $424320998f1e3631$exports(value, other, bitmask, customizer, $65941e528e4658cd$var$baseIsEqual, stack);
}
$65941e528e4658cd$exports = $65941e528e4658cd$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $c65581b1798022be$var$isEqual(value, other) {
    return $65941e528e4658cd$exports(value, other);
}
$c65581b1798022be$exports = $c65581b1798022be$var$isEqual;



var $17VE6 = parcelRequire("17VE6");
var $ebe4f7e7e65faefa$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$ebe4f7e7e65faefa$exports = (parcelRequire("8ZUGY"));


var $ac051388b37cf998$exports = {};
var $4524cb163de875f3$exports = {};
var $eb4382aea2eeb5e3$exports = {};
var $ed48b268a6341e54$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $ed48b268a6341e54$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$ed48b268a6341e54$exports = $ed48b268a6341e54$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $eb4382aea2eeb5e3$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $ed48b268a6341e54$exports(array, start, end);
}
$eb4382aea2eeb5e3$exports = $eb4382aea2eeb5e3$var$castSlice;


var $030a46a30a14b18d$exports = {};
/** Used to compose unicode character classes. */ var $030a46a30a14b18d$var$rsAstralRange = "\ud800-\udfff", $030a46a30a14b18d$var$rsComboMarksRange = "\\u0300-\\u036f", $030a46a30a14b18d$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $030a46a30a14b18d$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $030a46a30a14b18d$var$rsComboRange = $030a46a30a14b18d$var$rsComboMarksRange + $030a46a30a14b18d$var$reComboHalfMarksRange + $030a46a30a14b18d$var$rsComboSymbolsRange, $030a46a30a14b18d$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $030a46a30a14b18d$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $030a46a30a14b18d$var$reHasUnicode = RegExp("[" + $030a46a30a14b18d$var$rsZWJ + $030a46a30a14b18d$var$rsAstralRange + $030a46a30a14b18d$var$rsComboRange + $030a46a30a14b18d$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $030a46a30a14b18d$var$hasUnicode(string) {
    return $030a46a30a14b18d$var$reHasUnicode.test(string);
}
$030a46a30a14b18d$exports = $030a46a30a14b18d$var$hasUnicode;


var $f1b6a830a10d8cc8$exports = {};
var $b0181ccc746f2750$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $b0181ccc746f2750$var$asciiToArray(string) {
    return string.split("");
}
$b0181ccc746f2750$exports = $b0181ccc746f2750$var$asciiToArray;



var $ea8b19dc62ce1cbb$exports = {};
/** Used to compose unicode character classes. */ var $ea8b19dc62ce1cbb$var$rsAstralRange = "\ud800-\udfff", $ea8b19dc62ce1cbb$var$rsComboMarksRange = "\\u0300-\\u036f", $ea8b19dc62ce1cbb$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $ea8b19dc62ce1cbb$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $ea8b19dc62ce1cbb$var$rsComboRange = $ea8b19dc62ce1cbb$var$rsComboMarksRange + $ea8b19dc62ce1cbb$var$reComboHalfMarksRange + $ea8b19dc62ce1cbb$var$rsComboSymbolsRange, $ea8b19dc62ce1cbb$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $ea8b19dc62ce1cbb$var$rsAstral = "[" + $ea8b19dc62ce1cbb$var$rsAstralRange + "]", $ea8b19dc62ce1cbb$var$rsCombo = "[" + $ea8b19dc62ce1cbb$var$rsComboRange + "]", $ea8b19dc62ce1cbb$var$rsFitz = "\ud83c[\udffb-\udfff]", $ea8b19dc62ce1cbb$var$rsModifier = "(?:" + $ea8b19dc62ce1cbb$var$rsCombo + "|" + $ea8b19dc62ce1cbb$var$rsFitz + ")", $ea8b19dc62ce1cbb$var$rsNonAstral = "[^" + $ea8b19dc62ce1cbb$var$rsAstralRange + "]", $ea8b19dc62ce1cbb$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $ea8b19dc62ce1cbb$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $ea8b19dc62ce1cbb$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $ea8b19dc62ce1cbb$var$reOptMod = $ea8b19dc62ce1cbb$var$rsModifier + "?", $ea8b19dc62ce1cbb$var$rsOptVar = "[" + $ea8b19dc62ce1cbb$var$rsVarRange + "]?", $ea8b19dc62ce1cbb$var$rsOptJoin = "(?:" + $ea8b19dc62ce1cbb$var$rsZWJ + "(?:" + [
    $ea8b19dc62ce1cbb$var$rsNonAstral,
    $ea8b19dc62ce1cbb$var$rsRegional,
    $ea8b19dc62ce1cbb$var$rsSurrPair
].join("|") + ")" + $ea8b19dc62ce1cbb$var$rsOptVar + $ea8b19dc62ce1cbb$var$reOptMod + ")*", $ea8b19dc62ce1cbb$var$rsSeq = $ea8b19dc62ce1cbb$var$rsOptVar + $ea8b19dc62ce1cbb$var$reOptMod + $ea8b19dc62ce1cbb$var$rsOptJoin, $ea8b19dc62ce1cbb$var$rsSymbol = "(?:" + [
    $ea8b19dc62ce1cbb$var$rsNonAstral + $ea8b19dc62ce1cbb$var$rsCombo + "?",
    $ea8b19dc62ce1cbb$var$rsCombo,
    $ea8b19dc62ce1cbb$var$rsRegional,
    $ea8b19dc62ce1cbb$var$rsSurrPair,
    $ea8b19dc62ce1cbb$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $ea8b19dc62ce1cbb$var$reUnicode = RegExp($ea8b19dc62ce1cbb$var$rsFitz + "(?=" + $ea8b19dc62ce1cbb$var$rsFitz + ")|" + $ea8b19dc62ce1cbb$var$rsSymbol + $ea8b19dc62ce1cbb$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $ea8b19dc62ce1cbb$var$unicodeToArray(string) {
    return string.match($ea8b19dc62ce1cbb$var$reUnicode) || [];
}
$ea8b19dc62ce1cbb$exports = $ea8b19dc62ce1cbb$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $f1b6a830a10d8cc8$var$stringToArray(string) {
    return $030a46a30a14b18d$exports(string) ? $ea8b19dc62ce1cbb$exports(string) : $b0181ccc746f2750$exports(string);
}
$f1b6a830a10d8cc8$exports = $f1b6a830a10d8cc8$var$stringToArray;


var $07b734b92fde5de2$exports = {};
var $200b91e93388b213$exports = {};

var $75629505681205b2$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $75629505681205b2$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$75629505681205b2$exports = $75629505681205b2$var$arrayMap;




/** Used as references for various `Number` constants. */ var $200b91e93388b213$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $200b91e93388b213$var$symbolProto = $71992159aec129a5$exports ? $71992159aec129a5$exports.prototype : undefined, $200b91e93388b213$var$symbolToString = $200b91e93388b213$var$symbolProto ? $200b91e93388b213$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $200b91e93388b213$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($09ea814803501f1d$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $75629505681205b2$exports(value, $200b91e93388b213$var$baseToString) + "";
    if ($cb0f03c9c78ae357$exports(value)) return $200b91e93388b213$var$symbolToString ? $200b91e93388b213$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$200b91e93388b213$var$INFINITY ? "-0" : result;
}
$200b91e93388b213$exports = $200b91e93388b213$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $07b734b92fde5de2$var$toString(value) {
    return value == null ? "" : $200b91e93388b213$exports(value);
}
$07b734b92fde5de2$exports = $07b734b92fde5de2$var$toString;


/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $4524cb163de875f3$var$createCaseFirst(methodName) {
    return function(string) {
        string = $07b734b92fde5de2$exports(string);
        var strSymbols = $030a46a30a14b18d$exports(string) ? $f1b6a830a10d8cc8$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $eb4382aea2eeb5e3$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$4524cb163de875f3$exports = $4524cb163de875f3$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $ac051388b37cf998$var$upperFirst = $4524cb163de875f3$exports("toUpperCase");
$ac051388b37cf998$exports = $ac051388b37cf998$var$upperFirst;





var $17VE6 = parcelRequire("17VE6");

function $afad468d030baba8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $afad468d030baba8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $afad468d030baba8$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $afad468d030baba8$var$SVGContainerPropKeys = [
    "viewBox",
    "children"
];
var $afad468d030baba8$export$190f430946f96110 = [
    "aria-activedescendant",
    "aria-atomic",
    "aria-autocomplete",
    "aria-busy",
    "aria-checked",
    "aria-colcount",
    "aria-colindex",
    "aria-colspan",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    "aria-disabled",
    "aria-errormessage",
    "aria-expanded",
    "aria-flowto",
    "aria-haspopup",
    "aria-hidden",
    "aria-invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-level",
    "aria-live",
    "aria-modal",
    "aria-multiline",
    "aria-multiselectable",
    "aria-orientation",
    "aria-owns",
    "aria-placeholder",
    "aria-posinset",
    "aria-pressed",
    "aria-readonly",
    "aria-relevant",
    "aria-required",
    "aria-roledescription",
    "aria-rowcount",
    "aria-rowindex",
    "aria-rowspan",
    "aria-selected",
    "aria-setsize",
    "aria-sort",
    "aria-valuemax",
    "aria-valuemin",
    "aria-valuenow",
    "aria-valuetext",
    "className",
    "color",
    "height",
    "id",
    "lang",
    "max",
    "media",
    "method",
    "min",
    "name",
    "style",
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    "target",
    "width",
    "role",
    "tabIndex",
    "accentHeight",
    "accumulate",
    "additive",
    "alignmentBaseline",
    "allowReorder",
    "alphabetic",
    "amplitude",
    "arabicForm",
    "ascent",
    "attributeName",
    "attributeType",
    "autoReverse",
    "azimuth",
    "baseFrequency",
    "baselineShift",
    "baseProfile",
    "bbox",
    "begin",
    "bias",
    "by",
    "calcMode",
    "capHeight",
    "clip",
    "clipPath",
    "clipPathUnits",
    "clipRule",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorProfile",
    "colorRendering",
    "contentScriptType",
    "contentStyleType",
    "cursor",
    "cx",
    "cy",
    "d",
    "decelerate",
    "descent",
    "diffuseConstant",
    "direction",
    "display",
    "divisor",
    "dominantBaseline",
    "dur",
    "dx",
    "dy",
    "edgeMode",
    "elevation",
    "enableBackground",
    "end",
    "exponent",
    "externalResourcesRequired",
    "fill",
    "fillOpacity",
    "fillRule",
    "filter",
    "filterRes",
    "filterUnits",
    "floodColor",
    "floodOpacity",
    "focusable",
    "fontFamily",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "format",
    "from",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyphName",
    "glyphOrientationHorizontal",
    "glyphOrientationVertical",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "hanging",
    "horizAdvX",
    "horizOriginX",
    "href",
    "ideographic",
    "imageRendering",
    "in2",
    "in",
    "intercept",
    "k1",
    "k2",
    "k3",
    "k4",
    "k",
    "kernelMatrix",
    "kernelUnitLength",
    "kerning",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "letterSpacing",
    "lightingColor",
    "limitingConeAngle",
    "local",
    "markerEnd",
    "markerHeight",
    "markerMid",
    "markerStart",
    "markerUnits",
    "markerWidth",
    "mask",
    "maskContentUnits",
    "maskUnits",
    "mathematical",
    "mode",
    "numOctaves",
    "offset",
    "opacity",
    "operator",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "overlinePosition",
    "overlineThickness",
    "paintOrder",
    "panose1",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointerEvents",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "r",
    "radius",
    "refX",
    "refY",
    "renderingIntent",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "restart",
    "result",
    "rotate",
    "rx",
    "ry",
    "seed",
    "shapeRendering",
    "slope",
    "spacing",
    "specularConstant",
    "specularExponent",
    "speed",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stemh",
    "stemv",
    "stitchTiles",
    "stopColor",
    "stopOpacity",
    "strikethroughPosition",
    "strikethroughThickness",
    "string",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textAnchor",
    "textDecoration",
    "textLength",
    "textRendering",
    "to",
    "transform",
    "u1",
    "u2",
    "underlinePosition",
    "underlineThickness",
    "unicode",
    "unicodeBidi",
    "unicodeRange",
    "unitsPerEm",
    "vAlphabetic",
    "values",
    "vectorEffect",
    "version",
    "vertAdvY",
    "vertOriginX",
    "vertOriginY",
    "vHanging",
    "vIdeographic",
    "viewTarget",
    "visibility",
    "vMathematical",
    "widths",
    "wordSpacing",
    "writingMode",
    "x1",
    "x2",
    "x",
    "xChannelSelector",
    "xHeight",
    "xlinkActuate",
    "xlinkArcrole",
    "xlinkHref",
    "xlinkRole",
    "xlinkShow",
    "xlinkTitle",
    "xlinkType",
    "xmlBase",
    "xmlLang",
    "xmlns",
    "xmlnsXlink",
    "xmlSpace",
    "y1",
    "y2",
    "y",
    "yChannelSelector",
    "z",
    "zoomAndPan",
    "ref",
    "key",
    "angle"
];
var $afad468d030baba8$var$PolyElementKeys = [
    "points",
    "pathLength"
];
var $afad468d030baba8$export$2b22758266a6fa48 = {
    svg: $afad468d030baba8$var$SVGContainerPropKeys,
    polygon: $afad468d030baba8$var$PolyElementKeys,
    polyline: $afad468d030baba8$var$PolyElementKeys
};
var $afad468d030baba8$export$f30789245f2c4d11 = [
    "dangerouslySetInnerHTML",
    "onCopy",
    "onCopyCapture",
    "onCut",
    "onCutCapture",
    "onPaste",
    "onPasteCapture",
    "onCompositionEnd",
    "onCompositionEndCapture",
    "onCompositionStart",
    "onCompositionStartCapture",
    "onCompositionUpdate",
    "onCompositionUpdateCapture",
    "onFocus",
    "onFocusCapture",
    "onBlur",
    "onBlurCapture",
    "onChange",
    "onChangeCapture",
    "onBeforeInput",
    "onBeforeInputCapture",
    "onInput",
    "onInputCapture",
    "onReset",
    "onResetCapture",
    "onSubmit",
    "onSubmitCapture",
    "onInvalid",
    "onInvalidCapture",
    "onLoad",
    "onLoadCapture",
    "onError",
    "onErrorCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyPress",
    "onKeyPressCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onAbort",
    "onAbortCapture",
    "onCanPlay",
    "onCanPlayCapture",
    "onCanPlayThrough",
    "onCanPlayThroughCapture",
    "onDurationChange",
    "onDurationChangeCapture",
    "onEmptied",
    "onEmptiedCapture",
    "onEncrypted",
    "onEncryptedCapture",
    "onEnded",
    "onEndedCapture",
    "onLoadedData",
    "onLoadedDataCapture",
    "onLoadedMetadata",
    "onLoadedMetadataCapture",
    "onLoadStart",
    "onLoadStartCapture",
    "onPause",
    "onPauseCapture",
    "onPlay",
    "onPlayCapture",
    "onPlaying",
    "onPlayingCapture",
    "onProgress",
    "onProgressCapture",
    "onRateChange",
    "onRateChangeCapture",
    "onSeeked",
    "onSeekedCapture",
    "onSeeking",
    "onSeekingCapture",
    "onStalled",
    "onStalledCapture",
    "onSuspend",
    "onSuspendCapture",
    "onTimeUpdate",
    "onTimeUpdateCapture",
    "onVolumeChange",
    "onVolumeChangeCapture",
    "onWaiting",
    "onWaitingCapture",
    "onAuxClick",
    "onAuxClickCapture",
    "onClick",
    "onClickCapture",
    "onContextMenu",
    "onContextMenuCapture",
    "onDoubleClick",
    "onDoubleClickCapture",
    "onDrag",
    "onDragCapture",
    "onDragEnd",
    "onDragEndCapture",
    "onDragEnter",
    "onDragEnterCapture",
    "onDragExit",
    "onDragExitCapture",
    "onDragLeave",
    "onDragLeaveCapture",
    "onDragOver",
    "onDragOverCapture",
    "onDragStart",
    "onDragStartCapture",
    "onDrop",
    "onDropCapture",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseMoveCapture",
    "onMouseOut",
    "onMouseOutCapture",
    "onMouseOver",
    "onMouseOverCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onSelect",
    "onSelectCapture",
    "onTouchCancel",
    "onTouchCancelCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onTouchMove",
    "onTouchMoveCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerMove",
    "onPointerMoveCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onPointerCancel",
    "onPointerCancelCapture",
    "onPointerEnter",
    "onPointerEnterCapture",
    "onPointerLeave",
    "onPointerLeaveCapture",
    "onPointerOver",
    "onPointerOverCapture",
    "onPointerOut",
    "onPointerOutCapture",
    "onGotPointerCapture",
    "onGotPointerCaptureCapture",
    "onLostPointerCapture",
    "onLostPointerCaptureCapture",
    "onScroll",
    "onScrollCapture",
    "onWheel",
    "onWheelCapture",
    "onAnimationStart",
    "onAnimationStartCapture",
    "onAnimationEnd",
    "onAnimationEndCapture",
    "onAnimationIteration",
    "onAnimationIterationCapture",
    "onTransitionEnd",
    "onTransitionEndCapture"
];
var $afad468d030baba8$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $17VE6.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f380900e8541e270$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($afad468d030baba8$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $afad468d030baba8$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $afad468d030baba8$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f380900e8541e270$exports)))(props) || $afad468d030baba8$var$_typeof(props) !== "object") return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($afad468d030baba8$export$f30789245f2c4d11.includes(key) && typeof item === "function") {
            if (!out) out = {};
            out[key] = $afad468d030baba8$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $c3944f5a36163d07$exports = {};
var $0273e061927621cf$exports = {};
var $d6d398228a578f41$exports = {};

var $1e9e0203d83b32d3$exports = {};

var $l6pW7 = parcelRequire("l6pW7");


/** Used to match property names within property paths. */ var $1e9e0203d83b32d3$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $1e9e0203d83b32d3$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $1e9e0203d83b32d3$var$isKey(value, object) {
    if ($09ea814803501f1d$exports(value)) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, $l6pW7._)(value);
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $cb0f03c9c78ae357$exports(value)) return true;
    return $1e9e0203d83b32d3$var$reIsPlainProp.test(value) || !$1e9e0203d83b32d3$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$1e9e0203d83b32d3$exports = $1e9e0203d83b32d3$var$isKey;


var $a37194095c65da10$exports = {};
var $a436804f022135fe$exports = {};
var $3f0994af3bbef3a3$exports = {};

/** Error message constants. */ var $3f0994af3bbef3a3$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $3f0994af3bbef3a3$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($3f0994af3bbef3a3$var$FUNC_ERROR_TEXT);
    var memoized = function memoized1() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($3f0994af3bbef3a3$var$memoize.Cache || $636eaac3516f8d10$exports);
    return memoized;
}
// Expose `MapCache`.
$3f0994af3bbef3a3$var$memoize.Cache = $636eaac3516f8d10$exports;
$3f0994af3bbef3a3$exports = $3f0994af3bbef3a3$var$memoize;


/** Used as the maximum memoize cache size. */ var $a436804f022135fe$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $a436804f022135fe$var$memoizeCapped(func) {
    var result = $3f0994af3bbef3a3$exports(func, function(key) {
        if (cache.size === $a436804f022135fe$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$a436804f022135fe$exports = $a436804f022135fe$var$memoizeCapped;


/** Used to match property names within property paths. */ var $a37194095c65da10$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $a37194095c65da10$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $a37194095c65da10$var$stringToPath = $a436804f022135fe$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($a37194095c65da10$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($a37194095c65da10$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$a37194095c65da10$exports = $a37194095c65da10$var$stringToPath;



/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $d6d398228a578f41$var$castPath(value, object) {
    if ($09ea814803501f1d$exports(value)) return value;
    return $1e9e0203d83b32d3$exports(value, object) ? [
        value
    ] : $a37194095c65da10$exports($07b734b92fde5de2$exports(value));
}
$d6d398228a578f41$exports = $d6d398228a578f41$var$castPath;


var $2a4fcf84d5deb3b1$exports = {};

/** Used as references for various `Number` constants. */ var $2a4fcf84d5deb3b1$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $2a4fcf84d5deb3b1$var$toKey(value) {
    if (typeof value == "string" || $cb0f03c9c78ae357$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$2a4fcf84d5deb3b1$var$INFINITY ? "-0" : result;
}
$2a4fcf84d5deb3b1$exports = $2a4fcf84d5deb3b1$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $0273e061927621cf$var$baseGet(object, path) {
    path = $d6d398228a578f41$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$2a4fcf84d5deb3b1$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$0273e061927621cf$exports = $0273e061927621cf$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $c3944f5a36163d07$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $0273e061927621cf$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$c3944f5a36163d07$exports = $c3944f5a36163d07$var$get;



var $1224e4f23052ea6c$exports = {};



/** `Object#toString` result references. */ var $1224e4f23052ea6c$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $1224e4f23052ea6c$var$isString(value) {
    return typeof value == "string" || !$09ea814803501f1d$exports(value) && $a32d462304244b19$exports(value) && $9e270036c231d6af$exports(value) == $1224e4f23052ea6c$var$stringTag;
}
$1224e4f23052ea6c$exports = $1224e4f23052ea6c$var$isString;





var $17VE6 = parcelRequire("17VE6");
var $a2a9beb1a93f26ed$exports = {};
"use strict";

$a2a9beb1a93f26ed$exports = (parcelRequire("d6uHB"));






var $411b8d52505ff75c$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $411b8d52505ff75c$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1224e4f23052ea6c$exports)))(value) && value.indexOf("%") === value.length - 1;
};
var $411b8d52505ff75c$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($559e72ee1c5e4e7a$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($d13e95156e78f92e$exports)))(value);
};
var $411b8d52505ff75c$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $411b8d52505ff75c$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($1224e4f23052ea6c$exports)))(value);
};
var $411b8d52505ff75c$var$idCounter = 0;
var $411b8d52505ff75c$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$411b8d52505ff75c$var$idCounter;
    return "".concat(prefix || "").concat(id);
};
var $411b8d52505ff75c$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$411b8d52505ff75c$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($1224e4f23052ea6c$exports)))(percent)) return defaultValue;
    var value;
    if ($411b8d52505ff75c$export$e50269385c77c348(percent)) {
        var index = percent.indexOf("%");
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($d13e95156e78f92e$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $411b8d52505ff75c$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $411b8d52505ff75c$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $411b8d52505ff75c$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($411b8d52505ff75c$export$7e4aa119212bc614(numberA) && $411b8d52505ff75c$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $411b8d52505ff75c$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === "function" ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($c3944f5a36163d07$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $411b8d52505ff75c$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};


function $fa893b10298a8cae$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}



var $bb4a0676cae5de7b$var$_excluded = [
    "children"
], $bb4a0676cae5de7b$var$_excluded2 = [
    "children"
];
function $bb4a0676cae5de7b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bb4a0676cae5de7b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bb4a0676cae5de7b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bb4a0676cae5de7b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bb4a0676cae5de7b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bb4a0676cae5de7b$var$_typeof(o);
}
var $bb4a0676cae5de7b$var$REACT_BROWSER_EVENT_MAP = {
    click: "onClick",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mousemove: "onMouseMove",
    mouseout: "onMouseOut",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    touchcancel: "onTouchCancel",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchstart: "onTouchStart"
};
var $bb4a0676cae5de7b$export$e65e0ff8d3882b46 = [
    "auto",
    "linear",
    "pow",
    "sqrt",
    "log",
    "identity",
    "time",
    "band",
    "point",
    "ordinal",
    "quantile",
    "quantize",
    "utc",
    "sequential",
    "threshold"
];
var $bb4a0676cae5de7b$export$84dbd3b52ff06578 = [
    "plainline",
    "line",
    "square",
    "rect",
    "circle",
    "cross",
    "diamond",
    "star",
    "triangle",
    "wye",
    "none"
];
var $bb4a0676cae5de7b$export$59a4d7d024cf1025 = [
    "none"
];
var $bb4a0676cae5de7b$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === "string") return Comp;
    if (!Comp) return "";
    return Comp.displayName || Comp.name || "Component";
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $bb4a0676cae5de7b$var$lastChildren = null;
var $bb4a0676cae5de7b$var$lastResult = null;
var $bb4a0676cae5de7b$export$45b10814cc054894 = function toArray(children) {
    if (children === $bb4a0676cae5de7b$var$lastChildren && Array.isArray($bb4a0676cae5de7b$var$lastResult)) return $bb4a0676cae5de7b$var$lastResult;
    var result = [];
    (0, $17VE6.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(child)) return;
        if ((0, $a2a9beb1a93f26ed$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else result.push(child);
    });
    $bb4a0676cae5de7b$var$lastResult = result;
    $bb4a0676cae5de7b$var$lastChildren = children;
    return result;
};
function $bb4a0676cae5de7b$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $bb4a0676cae5de7b$export$be63e0664592e141(t);
    });
    else types = [
        $bb4a0676cae5de7b$export$be63e0664592e141(type)
    ];
    $bb4a0676cae5de7b$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($c3944f5a36163d07$exports)))(child, "type.displayName") || (0, (/*@__PURE__*/$parcel$interopDefault($c3944f5a36163d07$exports)))(child, "type.name");
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $bb4a0676cae5de7b$export$64c61536a2b72e0f(children, type) {
    var result = $bb4a0676cae5de7b$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $bb4a0676cae5de7b$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $bb4a0676cae5de7b$export$be63e0664592e141(t);
    });
    else types = [
        $bb4a0676cae5de7b$export$be63e0664592e141(type)
    ];
    $bb4a0676cae5de7b$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($c3944f5a36163d07$exports)))(child, "type.displayName");
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $bb4a0676cae5de7b$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $411b8d52505ff75c$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $bb4a0676cae5de7b$var$SVG_TAGS = [
    "a",
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColormatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-url",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "lineGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "script",
    "set",
    "stop",
    "style",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "title",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
];
var $bb4a0676cae5de7b$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($1224e4f23052ea6c$exports)))(child.type) && $bb4a0676cae5de7b$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $bb4a0676cae5de7b$export$e78c5929b986eef9 = function isDotProps(dot) {
    return dot && $bb4a0676cae5de7b$var$_typeof(dot) === "object" && "cx" in dot && "cy" in dot && "r" in dot;
};
var $bb4a0676cae5de7b$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $afad468d030baba8$export$2b22758266a6fa48) === null || (0, $afad468d030baba8$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $afad468d030baba8$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return !(0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $afad468d030baba8$export$190f430946f96110).includes(key)) || includeEvents && (0, $afad468d030baba8$export$f30789245f2c4d11).includes(key);
};
var $bb4a0676cae5de7b$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $bb4a0676cae5de7b$export$45b10814cc054894(children).forEach(function(entry) {
        if ($bb4a0676cae5de7b$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $bb4a0676cae5de7b$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $17VE6.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f380900e8541e270$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($bb4a0676cae5de7b$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $bb4a0676cae5de7b$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $17VE6.Children).count(nextChildren);
    if (count !== (0, $17VE6.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $bb4a0676cae5de7b$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$bb4a0676cae5de7b$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $bb4a0676cae5de7b$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $bb4a0676cae5de7b$var$_objectWithoutProperties(_ref, $bb4a0676cae5de7b$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $bb4a0676cae5de7b$var$_objectWithoutProperties(_ref2, $bb4a0676cae5de7b$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $fa893b10298a8cae$export$d36bdfa510afb180)(nextProps, prevProps) && $bb4a0676cae5de7b$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $fa893b10298a8cae$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $bb4a0676cae5de7b$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $bb4a0676cae5de7b$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($bb4a0676cae5de7b$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $bb4a0676cae5de7b$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $bb4a0676cae5de7b$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $bb4a0676cae5de7b$var$REACT_BROWSER_EVENT_MAP[type]) return $bb4a0676cae5de7b$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $bb4a0676cae5de7b$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $bb4a0676cae5de7b$export$45b10814cc054894(children).indexOf(child);
};



function $ea5067ec5be00d2e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ea5067ec5be00d2e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ea5067ec5be00d2e$var$_typeof(o);
}
function $ea5067ec5be00d2e$var$_extends() {
    $ea5067ec5be00d2e$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ea5067ec5be00d2e$var$_extends.apply(this, arguments);
}
function $ea5067ec5be00d2e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea5067ec5be00d2e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea5067ec5be00d2e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ea5067ec5be00d2e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea5067ec5be00d2e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ea5067ec5be00d2e$var$_defineProperty(obj, key, value) {
    key = $ea5067ec5be00d2e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ea5067ec5be00d2e$var$_toPropertyKey(arg) {
    var key = $ea5067ec5be00d2e$var$_toPrimitive(arg, "string");
    return $ea5067ec5be00d2e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ea5067ec5be00d2e$var$_toPrimitive(input, hint) {
    if ($ea5067ec5be00d2e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ea5067ec5be00d2e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $ea5067ec5be00d2e$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $ebe4f7e7e65faefa$exports.curveBasisClosed),
    curveBasisOpen: (0, $ebe4f7e7e65faefa$exports.curveBasisOpen),
    curveBasis: (0, $ebe4f7e7e65faefa$exports.curveBasis),
    curveBumpX: (0, $ebe4f7e7e65faefa$exports.curveBumpX),
    curveBumpY: (0, $ebe4f7e7e65faefa$exports.curveBumpY),
    curveLinearClosed: (0, $ebe4f7e7e65faefa$exports.curveLinearClosed),
    curveLinear: (0, $ebe4f7e7e65faefa$exports.curveLinear),
    curveMonotoneX: (0, $ebe4f7e7e65faefa$exports.curveMonotoneX),
    curveMonotoneY: (0, $ebe4f7e7e65faefa$exports.curveMonotoneY),
    curveNatural: (0, $ebe4f7e7e65faefa$exports.curveNatural),
    curveStep: (0, $ebe4f7e7e65faefa$exports.curveStep),
    curveStepAfter: (0, $ebe4f7e7e65faefa$exports.curveStepAfter),
    curveStepBefore: (0, $ebe4f7e7e65faefa$exports.curveStepBefore)
};
var $ea5067ec5be00d2e$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $ea5067ec5be00d2e$var$getX = function getX(p) {
    return p.x;
};
var $ea5067ec5be00d2e$var$getY = function getY(p) {
    return p.y;
};
var $ea5067ec5be00d2e$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($ac051388b37cf998$exports)))(type));
    if ((name === "curveMonotone" || name === "curveBump") && layout) return $ea5067ec5be00d2e$var$CURVE_FACTORIES["".concat(name).concat(layout === "vertical" ? "Y" : "X")];
    return $ea5067ec5be00d2e$var$CURVE_FACTORIES[name] || (0, $ebe4f7e7e65faefa$exports.curveLinear);
};
/**
 * Calculate the path of curve
 * @return {String} path
 */ var $ea5067ec5be00d2e$var$getPath = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "linear" : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $ea5067ec5be00d2e$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $ea5067ec5be00d2e$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $ea5067ec5be00d2e$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $ea5067ec5be00d2e$var$_objectSpread($ea5067ec5be00d2e$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === "vertical") lineFunction = (0, $ebe4f7e7e65faefa$exports.area)().y($ea5067ec5be00d2e$var$getY).x1($ea5067ec5be00d2e$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $ebe4f7e7e65faefa$exports.area)().x($ea5067ec5be00d2e$var$getX).y1($ea5067ec5be00d2e$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($ea5067ec5be00d2e$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === "vertical" && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $ebe4f7e7e65faefa$exports.area)().y($ea5067ec5be00d2e$var$getY).x1($ea5067ec5be00d2e$var$getX).x0(baseLine);
    else if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $ebe4f7e7e65faefa$exports.area)().x($ea5067ec5be00d2e$var$getX).y1($ea5067ec5be00d2e$var$getY).y0(baseLine);
    else lineFunction = (0, $ebe4f7e7e65faefa$exports.line)().x($ea5067ec5be00d2e$var$getX).y($ea5067ec5be00d2e$var$getY);
    lineFunction.defined($ea5067ec5be00d2e$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $ea5067ec5be00d2e$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $ea5067ec5be00d2e$var$getPath(props) : path;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("path", $ea5067ec5be00d2e$var$_extends({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(props), (0, $afad468d030baba8$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-curve", className),
        d: realPath,
        ref: pathRef
    }));
};



var $17VE6 = parcelRequire("17VE6");



function $0ea73b33a67b7ee8$var$_extends() {
    $0ea73b33a67b7ee8$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0ea73b33a67b7ee8$var$_extends.apply(this, arguments);
}
var $0ea73b33a67b7ee8$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-dot", className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("circle", $0ea73b33a67b7ee8$var$_extends({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(props), (0, $afad468d030baba8$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};



var $17VE6 = parcelRequire("17VE6");


var $72b5a0127ea89e65$var$_excluded = [
    "children",
    "className"
];
function $72b5a0127ea89e65$var$_extends() {
    $72b5a0127ea89e65$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $72b5a0127ea89e65$var$_extends.apply(this, arguments);
}
function $72b5a0127ea89e65$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $72b5a0127ea89e65$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $72b5a0127ea89e65$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $72b5a0127ea89e65$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $72b5a0127ea89e65$var$_objectWithoutProperties(props, $72b5a0127ea89e65$var$_excluded);
    var layerClass = (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-layer", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("g", $72b5a0127ea89e65$var$_extends({
        className: layerClass
    }, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $17VE6 = parcelRequire("17VE6");



var $8ec337cccebd6fba$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $8ec337cccebd6fba$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$8ec337cccebd6fba$exports = $8ec337cccebd6fba$var$last;



var $17VE6 = parcelRequire("17VE6");





var $17VE6 = parcelRequire("17VE6");



var $e72696708fbb4da9$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== "undefined" && window.document && window.document.createElement && window.setTimeout);
};
var $e72696708fbb4da9$export$98f03c5d19621d70 = {
    isSsr: $e72696708fbb4da9$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $e72696708fbb4da9$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === "string") $e72696708fbb4da9$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $e72696708fbb4da9$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $4e3fcb7d26d9032b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4e3fcb7d26d9032b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4e3fcb7d26d9032b$var$_typeof(o);
}
function $4e3fcb7d26d9032b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4e3fcb7d26d9032b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4e3fcb7d26d9032b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4e3fcb7d26d9032b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4e3fcb7d26d9032b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4e3fcb7d26d9032b$var$_defineProperty(obj, key, value) {
    key = $4e3fcb7d26d9032b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4e3fcb7d26d9032b$var$_toPropertyKey(arg) {
    var key = $4e3fcb7d26d9032b$var$_toPrimitive(arg, "string");
    return $4e3fcb7d26d9032b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4e3fcb7d26d9032b$var$_toPrimitive(input, hint) {
    if ($4e3fcb7d26d9032b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4e3fcb7d26d9032b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4e3fcb7d26d9032b$var$_toConsumableArray(arr) {
    return $4e3fcb7d26d9032b$var$_arrayWithoutHoles(arr) || $4e3fcb7d26d9032b$var$_iterableToArray(arr) || $4e3fcb7d26d9032b$var$_unsupportedIterableToArray(arr) || $4e3fcb7d26d9032b$var$_nonIterableSpread();
}
function $4e3fcb7d26d9032b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4e3fcb7d26d9032b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4e3fcb7d26d9032b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4e3fcb7d26d9032b$var$_arrayLikeToArray(o, minLen);
}
function $4e3fcb7d26d9032b$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $4e3fcb7d26d9032b$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4e3fcb7d26d9032b$var$_arrayLikeToArray(arr);
}
function $4e3fcb7d26d9032b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $4e3fcb7d26d9032b$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $4e3fcb7d26d9032b$var$MAX_CACHE_NUM = 2000;
var $4e3fcb7d26d9032b$var$SPAN_STYLE = {
    position: "absolute",
    top: "-20000px",
    left: 0,
    padding: 0,
    margin: 0,
    border: "none",
    whiteSpace: "pre"
};
var $4e3fcb7d26d9032b$var$STYLE_LIST = [
    "minWidth",
    "maxWidth",
    "width",
    "minHeight",
    "maxHeight",
    "height",
    "top",
    "left",
    "fontSize",
    "lineHeight",
    "padding",
    "margin",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "paddingBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBottom"
];
var $4e3fcb7d26d9032b$var$MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function $4e3fcb7d26d9032b$var$autoCompleteStyle(name, value) {
    if ($4e3fcb7d26d9032b$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $4e3fcb7d26d9032b$var$camelToMiddleLine(text) {
    var strs = text.split("");
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($4e3fcb7d26d9032b$var$_toConsumableArray(result), [
            "-",
            entry.toLowerCase()
        ]);
        return [].concat($4e3fcb7d26d9032b$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join("");
}
var $4e3fcb7d26d9032b$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($4e3fcb7d26d9032b$var$camelToMiddleLine(s), ":").concat($4e3fcb7d26d9032b$var$autoCompleteStyle(s, style[s]), ";");
    }, "");
};
function $4e3fcb7d26d9032b$var$removeInvalidKeys(obj) {
    var copyObj = $4e3fcb7d26d9032b$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $4e3fcb7d26d9032b$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $e72696708fbb4da9$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $4e3fcb7d26d9032b$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($4e3fcb7d26d9032b$var$stringCache.widthCache[cacheKey]) return $4e3fcb7d26d9032b$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($4e3fcb7d26d9032b$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement("span");
            measurementSpan.setAttribute("id", $4e3fcb7d26d9032b$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute("aria-hidden", "true");
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $4e3fcb7d26d9032b$var$_objectSpread($4e3fcb7d26d9032b$var$_objectSpread({}, $4e3fcb7d26d9032b$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $4e3fcb7d26d9032b$var$stringCache.widthCache[cacheKey] = result;
        if (++$4e3fcb7d26d9032b$var$stringCache.cacheCount > $4e3fcb7d26d9032b$var$MAX_CACHE_NUM) {
            $4e3fcb7d26d9032b$var$stringCache.cacheCount = 0;
            $4e3fcb7d26d9032b$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $4e3fcb7d26d9032b$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};


function $0479f0d31e1309b9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0479f0d31e1309b9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0479f0d31e1309b9$var$_typeof(o);
}
function $0479f0d31e1309b9$var$_slicedToArray(arr, i) {
    return $0479f0d31e1309b9$var$_arrayWithHoles(arr) || $0479f0d31e1309b9$var$_iterableToArrayLimit(arr, i) || $0479f0d31e1309b9$var$_unsupportedIterableToArray(arr, i) || $0479f0d31e1309b9$var$_nonIterableRest();
}
function $0479f0d31e1309b9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0479f0d31e1309b9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0479f0d31e1309b9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0479f0d31e1309b9$var$_arrayLikeToArray(o, minLen);
}
function $0479f0d31e1309b9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0479f0d31e1309b9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0479f0d31e1309b9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0479f0d31e1309b9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0479f0d31e1309b9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0479f0d31e1309b9$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0479f0d31e1309b9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0479f0d31e1309b9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0479f0d31e1309b9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0479f0d31e1309b9$var$_toPropertyKey(arg) {
    var key = $0479f0d31e1309b9$var$_toPrimitive(arg, "string");
    return $0479f0d31e1309b9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0479f0d31e1309b9$var$_toPrimitive(input, hint) {
    if ($0479f0d31e1309b9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0479f0d31e1309b9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $0479f0d31e1309b9$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $0479f0d31e1309b9$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $0479f0d31e1309b9$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $0479f0d31e1309b9$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $0479f0d31e1309b9$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $0479f0d31e1309b9$var$FIXED_CSS_LENGTH_UNITS = Object.keys($0479f0d31e1309b9$var$CONVERSION_RATES);
var $0479f0d31e1309b9$var$STR_NAN = "NaN";
function $0479f0d31e1309b9$var$convertToPx(value, unit) {
    return value * $0479f0d31e1309b9$var$CONVERSION_RATES[unit];
}
var $0479f0d31e1309b9$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $0479f0d31e1309b9$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = "";
        if (unit !== "" && !$0479f0d31e1309b9$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = "";
        }
        if ($0479f0d31e1309b9$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $0479f0d31e1309b9$var$convertToPx(num, unit);
            this.unit = "px";
        }
    }
    $0479f0d31e1309b9$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $0479f0d31e1309b9$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $0479f0d31e1309b9$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : "");
            }
        }
    ]);
    return DecimalCSS;
}();
function $0479f0d31e1309b9$var$calculateArithmetic(expr) {
    if (expr.includes($0479f0d31e1309b9$var$STR_NAN)) return $0479f0d31e1309b9$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes("*") || newExpr.includes("/")){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $0479f0d31e1309b9$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $0479f0d31e1309b9$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $0479f0d31e1309b9$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : "");
        var rTs = $0479f0d31e1309b9$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : "");
        var result = operator === "*" ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $0479f0d31e1309b9$var$STR_NAN;
        newExpr = newExpr.replace($0479f0d31e1309b9$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes("+") || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $0479f0d31e1309b9$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $0479f0d31e1309b9$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $0479f0d31e1309b9$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : "");
        var _rTs = $0479f0d31e1309b9$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : "");
        var _result = _operator === "+" ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $0479f0d31e1309b9$var$STR_NAN;
        newExpr = newExpr.replace($0479f0d31e1309b9$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $0479f0d31e1309b9$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $0479f0d31e1309b9$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes("(")){
        var _PARENTHESES_REGEX$ex = $0479f0d31e1309b9$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $0479f0d31e1309b9$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($0479f0d31e1309b9$var$PARENTHESES_REGEX, $0479f0d31e1309b9$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $0479f0d31e1309b9$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, "");
    newExpr = $0479f0d31e1309b9$var$calculateParentheses(newExpr);
    newExpr = $0479f0d31e1309b9$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $0479f0d31e1309b9$export$c891f73c9c6d00c9(expression) {
    try {
        return $0479f0d31e1309b9$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $0479f0d31e1309b9$var$STR_NAN;
    }
}
function $0479f0d31e1309b9$export$254eac204f89fd7d(expression) {
    var result = $0479f0d31e1309b9$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $0479f0d31e1309b9$var$STR_NAN) // notify the user
    return "";
    return result;
}


var $b5bb411b2159255d$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $b5bb411b2159255d$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $b5bb411b2159255d$var$_extends() {
    $b5bb411b2159255d$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b5bb411b2159255d$var$_extends.apply(this, arguments);
}
function $b5bb411b2159255d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b5bb411b2159255d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b5bb411b2159255d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b5bb411b2159255d$var$_slicedToArray(arr, i) {
    return $b5bb411b2159255d$var$_arrayWithHoles(arr) || $b5bb411b2159255d$var$_iterableToArrayLimit(arr, i) || $b5bb411b2159255d$var$_unsupportedIterableToArray(arr, i) || $b5bb411b2159255d$var$_nonIterableRest();
}
function $b5bb411b2159255d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b5bb411b2159255d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b5bb411b2159255d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b5bb411b2159255d$var$_arrayLikeToArray(o, minLen);
}
function $b5bb411b2159255d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b5bb411b2159255d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b5bb411b2159255d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $b5bb411b2159255d$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $b5bb411b2159255d$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(children)) {
            if (breakAll) words = children.toString().split("");
            else words = children.toString().split($b5bb411b2159255d$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $4e3fcb7d26d9032b$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $4e3fcb7d26d9032b$export$e5560531f057ad5d)("\xa0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $b5bb411b2159255d$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $411b8d52505ff75c$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $b5bb411b2159255d$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $b5bb411b2159255d$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $b5bb411b2159255d$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $b5bb411b2159255d$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(children) ? children.toString().split($b5bb411b2159255d$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $b5bb411b2159255d$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $e72696708fbb4da9$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $b5bb411b2159255d$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $b5bb411b2159255d$var$getWordsWithoutCalculate(children);
        return $b5bb411b2159255d$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $b5bb411b2159255d$var$getWordsWithoutCalculate(children);
};
var $b5bb411b2159255d$var$DEFAULT_FILL = "#808080";
var $b5bb411b2159255d$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? "1em" : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? "0.71em" : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? "start" : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? "end" : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $b5bb411b2159255d$var$DEFAULT_FILL : _ref5$fill, props = $b5bb411b2159255d$var$_objectWithoutProperties(_ref5, $b5bb411b2159255d$var$_excluded);
    var wordsByLines = (0, $17VE6.useMemo)(function() {
        return $b5bb411b2159255d$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $b5bb411b2159255d$var$_objectWithoutProperties(props, $b5bb411b2159255d$var$_excluded2);
    if (!(0, $411b8d52505ff75c$export$402a499e1ea44294)(propsX) || !(0, $411b8d52505ff75c$export$402a499e1ea44294)(propsY)) return null;
    var x = propsX + ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = propsY + ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case "start":
            startDy = (0, $0479f0d31e1309b9$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case "middle":
            startDy = (0, $0479f0d31e1309b9$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $0479f0d31e1309b9$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $411b8d52505ff75c$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(" ");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("text", $b5bb411b2159255d$var$_extends({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-text", className),
        textAnchor: textAnchor,
        fill: fill.includes("url") ? $b5bb411b2159255d$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? "" : " ");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: words
        }, words);
    }));
};






var $8b8a6f16bc14962f$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$8b8a6f16bc14962f$exports = (parcelRequire("594Hr"));




var $8a46ec213ac99d96$exports = {};

var $a8915990441732a0$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $a8915990441732a0$var$baseLt(value, other) {
    return value < other;
}
$a8915990441732a0$exports = $a8915990441732a0$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $8a46ec213ac99d96$var$min(array) {
    return array && array.length ? $2380c7ba8a434844$exports(array, $cce66a01738bac69$exports, $a8915990441732a0$exports) : undefined;
}
$8a46ec213ac99d96$exports = $8a46ec213ac99d96$var$min;






var $2d67a83e9aac965a$exports = {};
var $c191e0f0a9a42f5b$exports = {};

var $8c8129a802606c7b$exports = {};



/** Built-in value references. */ var $8c8129a802606c7b$var$spreadableSymbol = $71992159aec129a5$exports ? $71992159aec129a5$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $8c8129a802606c7b$var$isFlattenable(value) {
    return $09ea814803501f1d$exports(value) || $8b610a525d3474a7$exports(value) || !!($8c8129a802606c7b$var$spreadableSymbol && value && value[$8c8129a802606c7b$var$spreadableSymbol]);
}
$8c8129a802606c7b$exports = $8c8129a802606c7b$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $c191e0f0a9a42f5b$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $8c8129a802606c7b$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $c191e0f0a9a42f5b$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $0235ed4d78598c5a$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$c191e0f0a9a42f5b$exports = $c191e0f0a9a42f5b$var$baseFlatten;


var $03e02222f5659024$exports = {};

var $e55fc84590a72f7a$exports = {};
var $cd68bcff5ef82655$exports = {};
var $d2f7e00821e1336c$exports = {};


/** Used to compose bitmasks for value comparisons. */ var $d2f7e00821e1336c$var$COMPARE_PARTIAL_FLAG = 1, $d2f7e00821e1336c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $d2f7e00821e1336c$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $2c3262e24cd34715$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $65941e528e4658cd$exports(srcValue, objValue, $d2f7e00821e1336c$var$COMPARE_PARTIAL_FLAG | $d2f7e00821e1336c$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$d2f7e00821e1336c$exports = $d2f7e00821e1336c$var$baseIsMatch;


var $11a938aabfefd669$exports = {};
var $e2acba0f20b56f90$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $e2acba0f20b56f90$var$isStrictComparable(value) {
    return value === value && !$f380900e8541e270$exports(value);
}
$e2acba0f20b56f90$exports = $e2acba0f20b56f90$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $11a938aabfefd669$var$getMatchData(object) {
    var result = $3dc1c18e15bcdad3$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $e2acba0f20b56f90$exports(value)
        ];
    }
    return result;
}
$11a938aabfefd669$exports = $11a938aabfefd669$var$getMatchData;


var $f4fd9e54e832387e$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $f4fd9e54e832387e$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$f4fd9e54e832387e$exports = $f4fd9e54e832387e$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $cd68bcff5ef82655$var$baseMatches(source) {
    var matchData = $11a938aabfefd669$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $f4fd9e54e832387e$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $d2f7e00821e1336c$exports(object, source, matchData);
    };
}
$cd68bcff5ef82655$exports = $cd68bcff5ef82655$var$baseMatches;


var $5f0b2baccf8a560f$exports = {};


var $38f5261d81e61454$exports = {};
var $3e93cb4fb9d2b099$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $3e93cb4fb9d2b099$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$3e93cb4fb9d2b099$exports = $3e93cb4fb9d2b099$var$baseHasIn;


var $5ed094a0d6d7b7ac$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $5ed094a0d6d7b7ac$var$hasPath(object, path, hasFunc) {
    path = $d6d398228a578f41$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $2a4fcf84d5deb3b1$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $b31c57ec47457aa7$exports(length) && $5ccb7c184c2fbd64$exports(key, length) && ($09ea814803501f1d$exports(object) || $8b610a525d3474a7$exports(object));
}
$5ed094a0d6d7b7ac$exports = $5ed094a0d6d7b7ac$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $38f5261d81e61454$var$hasIn(object, path) {
    return object != null && $5ed094a0d6d7b7ac$exports(object, path, $3e93cb4fb9d2b099$exports);
}
$38f5261d81e61454$exports = $38f5261d81e61454$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $5f0b2baccf8a560f$var$COMPARE_PARTIAL_FLAG = 1, $5f0b2baccf8a560f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $5f0b2baccf8a560f$var$baseMatchesProperty(path, srcValue) {
    if ($1e9e0203d83b32d3$exports(path) && $e2acba0f20b56f90$exports(srcValue)) return $f4fd9e54e832387e$exports($2a4fcf84d5deb3b1$exports(path), srcValue);
    return function(object) {
        var objValue = $c3944f5a36163d07$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $38f5261d81e61454$exports(object, path) : $65941e528e4658cd$exports(srcValue, objValue, $5f0b2baccf8a560f$var$COMPARE_PARTIAL_FLAG | $5f0b2baccf8a560f$var$COMPARE_UNORDERED_FLAG);
    };
}
$5f0b2baccf8a560f$exports = $5f0b2baccf8a560f$var$baseMatchesProperty;




var $e3c4ccc7d5879697$exports = {};
var $9148e90fb12ceda0$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $9148e90fb12ceda0$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$9148e90fb12ceda0$exports = $9148e90fb12ceda0$var$baseProperty;


var $ef3947071c59bf84$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $ef3947071c59bf84$var$basePropertyDeep(path) {
    return function(object) {
        return $0273e061927621cf$exports(object, path);
    };
}
$ef3947071c59bf84$exports = $ef3947071c59bf84$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $e3c4ccc7d5879697$var$property(path) {
    return $1e9e0203d83b32d3$exports(path) ? $9148e90fb12ceda0$exports($2a4fcf84d5deb3b1$exports(path)) : $ef3947071c59bf84$exports(path);
}
$e3c4ccc7d5879697$exports = $e3c4ccc7d5879697$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $e55fc84590a72f7a$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $cce66a01738bac69$exports;
    if (typeof value == "object") return $09ea814803501f1d$exports(value) ? $5f0b2baccf8a560f$exports(value[0], value[1]) : $cd68bcff5ef82655$exports(value);
    return $e3c4ccc7d5879697$exports(value);
}
$e55fc84590a72f7a$exports = $e55fc84590a72f7a$var$baseIteratee;


var $d14854ab18784b12$exports = {};
var $69aeb3380d6cbc9d$exports = {};
var $960b1d8c3b840d7c$exports = {};
var $3e1e0da16b97afc3$exports = {};
var $38a98580a9f20086$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $38a98580a9f20086$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$38a98580a9f20086$exports = $38a98580a9f20086$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $3e1e0da16b97afc3$var$baseFor = $38a98580a9f20086$exports();
$3e1e0da16b97afc3$exports = $3e1e0da16b97afc3$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $960b1d8c3b840d7c$var$baseForOwn(object, iteratee) {
    return object && $3e1e0da16b97afc3$exports(object, iteratee, $3dc1c18e15bcdad3$exports);
}
$960b1d8c3b840d7c$exports = $960b1d8c3b840d7c$var$baseForOwn;


var $95002b3bdf7a9826$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $95002b3bdf7a9826$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$a69fe579d8ce5bee$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$95002b3bdf7a9826$exports = $95002b3bdf7a9826$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $69aeb3380d6cbc9d$var$baseEach = $95002b3bdf7a9826$exports($960b1d8c3b840d7c$exports);
$69aeb3380d6cbc9d$exports = $69aeb3380d6cbc9d$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d14854ab18784b12$var$baseMap(collection, iteratee) {
    var index = -1, result = $a69fe579d8ce5bee$exports(collection) ? Array(collection.length) : [];
    $69aeb3380d6cbc9d$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$d14854ab18784b12$exports = $d14854ab18784b12$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $03e02222f5659024$var$map(collection, iteratee) {
    var func = $09ea814803501f1d$exports(collection) ? $75629505681205b2$exports : $d14854ab18784b12$exports;
    return func(collection, $e55fc84590a72f7a$exports(iteratee, 3));
}
$03e02222f5659024$exports = $03e02222f5659024$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $2d67a83e9aac965a$var$flatMap(collection, iteratee) {
    return $c191e0f0a9a42f5b$exports($03e02222f5659024$exports(collection, iteratee), 1);
}
$2d67a83e9aac965a$exports = $2d67a83e9aac965a$var$flatMap;





var $2d5f4b2fac16794e$exports = {};

var $5f143e2acd5a0e8a$exports = {};




var $958d05bdde4276a7$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $958d05bdde4276a7$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$958d05bdde4276a7$exports = $958d05bdde4276a7$var$baseSortBy;



var $255e5dc51c5d621e$exports = {};
var $8cb6493819feec2a$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $8cb6493819feec2a$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $cb0f03c9c78ae357$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $cb0f03c9c78ae357$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$8cb6493819feec2a$exports = $8cb6493819feec2a$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $255e5dc51c5d621e$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $8cb6493819feec2a$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$255e5dc51c5d621e$exports = $255e5dc51c5d621e$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $5f143e2acd5a0e8a$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $75629505681205b2$exports(iteratees, function(iteratee) {
        if ($09ea814803501f1d$exports(iteratee)) return function(value) {
            return $0273e061927621cf$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $cce66a01738bac69$exports
    ];
    var index = -1;
    iteratees = $75629505681205b2$exports(iteratees, $e0967f0998236dc9$exports($e55fc84590a72f7a$exports));
    var result = $d14854ab18784b12$exports(collection, function(value, key, collection) {
        var criteria = $75629505681205b2$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $958d05bdde4276a7$exports(result, function(object, other) {
        return $255e5dc51c5d621e$exports(object, other, orders);
    });
}
$5f143e2acd5a0e8a$exports = $5f143e2acd5a0e8a$var$baseOrderBy;


var $523c4ac6f4946d94$exports = {};

var $cc5341603bf9c54e$exports = {};
var $1962507fdc27c205$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $1962507fdc27c205$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$1962507fdc27c205$exports = $1962507fdc27c205$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $cc5341603bf9c54e$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $cc5341603bf9c54e$var$overRest(func, start, transform) {
    start = $cc5341603bf9c54e$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $cc5341603bf9c54e$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $1962507fdc27c205$exports(func, this, otherArgs);
    };
}
$cc5341603bf9c54e$exports = $cc5341603bf9c54e$var$overRest;


var $6616fc9635d3ca3a$exports = {};
var $b50a85e0e39ad92a$exports = {};
var $f7ff57a37a445433$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $f7ff57a37a445433$var$constant(value) {
    return function() {
        return value;
    };
}
$f7ff57a37a445433$exports = $f7ff57a37a445433$var$constant;


var $6c27db4d2965d33f$exports = {};

var $6c27db4d2965d33f$var$defineProperty = function() {
    try {
        var func = $6df30fd6a8cb9aaf$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$6c27db4d2965d33f$exports = $6c27db4d2965d33f$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $b50a85e0e39ad92a$var$baseSetToString = !$6c27db4d2965d33f$exports ? $cce66a01738bac69$exports : function baseSetToString(func, string) {
    return $6c27db4d2965d33f$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $f7ff57a37a445433$exports(string),
        "writable": true
    });
};
$b50a85e0e39ad92a$exports = $b50a85e0e39ad92a$var$baseSetToString;


var $5070aade182c9f6e$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5070aade182c9f6e$var$HOT_COUNT = 800, $5070aade182c9f6e$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5070aade182c9f6e$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5070aade182c9f6e$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5070aade182c9f6e$var$nativeNow(), remaining = $5070aade182c9f6e$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5070aade182c9f6e$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$5070aade182c9f6e$exports = $5070aade182c9f6e$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $6616fc9635d3ca3a$var$setToString = $5070aade182c9f6e$exports($b50a85e0e39ad92a$exports);
$6616fc9635d3ca3a$exports = $6616fc9635d3ca3a$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $523c4ac6f4946d94$var$baseRest(func, start) {
    return $6616fc9635d3ca3a$exports($cc5341603bf9c54e$exports(func, start, $cce66a01738bac69$exports), func + "");
}
$523c4ac6f4946d94$exports = $523c4ac6f4946d94$var$baseRest;


var $a4ed4c5e9ebf8672$exports = {};

var $l6pW7 = parcelRequire("l6pW7");




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $a4ed4c5e9ebf8672$var$isIterateeCall(value, index, object) {
    if (!$f380900e8541e270$exports(object)) return false;
    var type = typeof index === "undefined" ? "undefined" : (0, $l6pW7._)(index);
    if (type == "number" ? $a69fe579d8ce5bee$exports(object) && $5ccb7c184c2fbd64$exports(index, object.length) : type == "string" && index in object) return $6b3186e18fa15b95$exports(object[index], value);
    return false;
}
$a4ed4c5e9ebf8672$exports = $a4ed4c5e9ebf8672$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $2d5f4b2fac16794e$var$sortBy = $523c4ac6f4946d94$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $a4ed4c5e9ebf8672$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $a4ed4c5e9ebf8672$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $5f143e2acd5a0e8a$exports(collection, $c191e0f0a9a42f5b$exports(iteratees, 1), []);
});
$2d5f4b2fac16794e$exports = $2d5f4b2fac16794e$var$sortBy;


var $39282e672ecf6630$exports = {};
(function(globalScope) {
    "use strict";
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", exponentOutOfRange = decimalError + "Exponent out of range: ", mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + "NaN");
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + "NaN");
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + "NaN");
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != "9999") break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + "Infinity");
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + "NaN");
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + "Division by zero");
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + "LN10 precision limit exceeded");
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = ln(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (e < 0 ? "e" : "e+") + e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === "number") {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== "string") throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                "precision",
                "rounding",
                "toExpNeg",
                "toExpPos",
                "LN10"
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -1 / 0,
            0,
            "toExpPos",
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ": " + v);
        }
        if ((v = obj[p = "LN10"]) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $39282e672ecf6630$exports) $39282e672ecf6630$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : Function("return this")();
        globalScope.Decimal = Decimal;
    }
})($39282e672ecf6630$exports);


function $5db96029a59ffd7c$var$_toConsumableArray(arr) {
    return $5db96029a59ffd7c$var$_arrayWithoutHoles(arr) || $5db96029a59ffd7c$var$_iterableToArray(arr) || $5db96029a59ffd7c$var$_unsupportedIterableToArray(arr) || $5db96029a59ffd7c$var$_nonIterableSpread();
}
function $5db96029a59ffd7c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5db96029a59ffd7c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5db96029a59ffd7c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5db96029a59ffd7c$var$_arrayLikeToArray(o, minLen);
}
function $5db96029a59ffd7c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $5db96029a59ffd7c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5db96029a59ffd7c$var$_arrayLikeToArray(arr);
}
function $5db96029a59ffd7c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $5db96029a59ffd7c$var$identity = function identity(i) {
    return i;
};
var $5db96029a59ffd7c$export$ca73b6d700d0505 = {
    "@@functional/placeholder": true
};
var $5db96029a59ffd7c$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $5db96029a59ffd7c$export$ca73b6d700d0505;
};
var $5db96029a59ffd7c$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $5db96029a59ffd7c$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $5db96029a59ffd7c$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $5db96029a59ffd7c$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $5db96029a59ffd7c$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $5db96029a59ffd7c$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $5db96029a59ffd7c$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $5db96029a59ffd7c$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $5db96029a59ffd7c$export$c3095a23b368d1f2 = function curry(fn) {
    return $5db96029a59ffd7c$var$curryN(fn.length, fn);
};
var $5db96029a59ffd7c$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $5db96029a59ffd7c$export$871de8747c9eaa88 = $5db96029a59ffd7c$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $5db96029a59ffd7c$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $5db96029a59ffd7c$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $5db96029a59ffd7c$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split("").reverse.join("");
};
var $5db96029a59ffd7c$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $8e65abc1f6898865$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $8e65abc1f6898865$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $8e65abc1f6898865$var$interpolateNumber = (0, $5db96029a59ffd7c$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $8e65abc1f6898865$var$uninterpolateNumber = (0, $5db96029a59ffd7c$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $8e65abc1f6898865$var$uninterpolateTruncation = (0, $5db96029a59ffd7c$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $8e65abc1f6898865$export$2e2bcd8739ae039 = {
    rangeStep: $8e65abc1f6898865$var$rangeStep,
    getDigitCount: $8e65abc1f6898865$var$getDigitCount,
    interpolateNumber: $8e65abc1f6898865$var$interpolateNumber,
    uninterpolateNumber: $8e65abc1f6898865$var$uninterpolateNumber,
    uninterpolateTruncation: $8e65abc1f6898865$var$uninterpolateTruncation
};


function $ea79d95d5102e8f1$var$_toConsumableArray(arr) {
    return $ea79d95d5102e8f1$var$_arrayWithoutHoles(arr) || $ea79d95d5102e8f1$var$_iterableToArray(arr) || $ea79d95d5102e8f1$var$_unsupportedIterableToArray(arr) || $ea79d95d5102e8f1$var$_nonIterableSpread();
}
function $ea79d95d5102e8f1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ea79d95d5102e8f1$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $ea79d95d5102e8f1$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ea79d95d5102e8f1$var$_arrayLikeToArray(arr);
}
function $ea79d95d5102e8f1$var$_slicedToArray(arr, i) {
    return $ea79d95d5102e8f1$var$_arrayWithHoles(arr) || $ea79d95d5102e8f1$var$_iterableToArrayLimit(arr, i) || $ea79d95d5102e8f1$var$_unsupportedIterableToArray(arr, i) || $ea79d95d5102e8f1$var$_nonIterableRest();
}
function $ea79d95d5102e8f1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ea79d95d5102e8f1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ea79d95d5102e8f1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ea79d95d5102e8f1$var$_arrayLikeToArray(o, minLen);
}
function $ea79d95d5102e8f1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ea79d95d5102e8f1$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ea79d95d5102e8f1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $ea79d95d5102e8f1$var$getValidInterval(_ref) {
    var _ref2 = $ea79d95d5102e8f1$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $ea79d95d5102e8f1$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(0);
    var digitCount = (0, $8e65abc1f6898865$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $ea79d95d5102e8f1$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(10).pow((0, $8e65abc1f6898865$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $5db96029a59ffd7c$export$f672e0b6f7222cd7)((0, $5db96029a59ffd7c$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $5db96029a59ffd7c$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $ea79d95d5102e8f1$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $ea79d95d5102e8f1$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $ea79d95d5102e8f1$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $ea79d95d5102e8f1$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $ea79d95d5102e8f1$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $ea79d95d5102e8f1$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $ea79d95d5102e8f1$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($ea79d95d5102e8f1$var$_toConsumableArray((0, $5db96029a59ffd7c$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($ea79d95d5102e8f1$var$_toConsumableArray((0, $5db96029a59ffd7c$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $5db96029a59ffd7c$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $ea79d95d5102e8f1$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $ea79d95d5102e8f1$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $8e65abc1f6898865$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $5db96029a59ffd7c$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $ea79d95d5102e8f1$var$getTickValuesFn(_ref5) {
    var _ref6 = $ea79d95d5102e8f1$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $ea79d95d5102e8f1$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $ea79d95d5102e8f1$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $ea79d95d5102e8f1$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $ea79d95d5102e8f1$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $5db96029a59ffd7c$export$f672e0b6f7222cd7)((0, $5db96029a59ffd7c$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(n).mul(step)).toNumber();
    }), (0, $5db96029a59ffd7c$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $5db96029a59ffd7c$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $ea79d95d5102e8f1$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $ea79d95d5102e8f1$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $ea79d95d5102e8f1$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $ea79d95d5102e8f1$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $ea79d95d5102e8f1$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($ea79d95d5102e8f1$var$_toConsumableArray((0, $8e65abc1f6898865$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($39282e672ecf6630$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $5db96029a59ffd7c$export$66c1ae025e96b4bc)(values) : values;
}
var $ea79d95d5102e8f1$export$b84e75ccbfe6a612 = (0, $5db96029a59ffd7c$export$fc10aeed3a532e2a)($ea79d95d5102e8f1$var$getNiceTickValuesFn);
var $ea79d95d5102e8f1$export$4cc7a216492b1f53 = (0, $5db96029a59ffd7c$export$fc10aeed3a532e2a)($ea79d95d5102e8f1$var$getTickValuesFn);
var $ea79d95d5102e8f1$export$e9d28da780436e98 = (0, $5db96029a59ffd7c$export$fc10aeed3a532e2a)($ea79d95d5102e8f1$var$getTickValuesFixedDomainFn);





var $17VE6 = parcelRequire("17VE6");


var $94870e2ce3bf43ff$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $94870e2ce3bf43ff$var$_extends() {
    $94870e2ce3bf43ff$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $94870e2ce3bf43ff$var$_extends.apply(this, arguments);
}
function $94870e2ce3bf43ff$var$_slicedToArray(arr, i) {
    return $94870e2ce3bf43ff$var$_arrayWithHoles(arr) || $94870e2ce3bf43ff$var$_iterableToArrayLimit(arr, i) || $94870e2ce3bf43ff$var$_unsupportedIterableToArray(arr, i) || $94870e2ce3bf43ff$var$_nonIterableRest();
}
function $94870e2ce3bf43ff$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $94870e2ce3bf43ff$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $94870e2ce3bf43ff$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $94870e2ce3bf43ff$var$_arrayLikeToArray(o, minLen);
}
function $94870e2ce3bf43ff$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $94870e2ce3bf43ff$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $94870e2ce3bf43ff$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $94870e2ce3bf43ff$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $94870e2ce3bf43ff$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $94870e2ce3bf43ff$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $94870e2ce3bf43ff$export$4f4d7676bdf949e5(props) {
    var offset = props.offset, layout = props.layout, width = props.width, dataKey = props.dataKey, data = props.data, dataPointFormatter = props.dataPointFormatter, xAxis = props.xAxis, yAxis = props.yAxis, others = $94870e2ce3bf43ff$var$_objectWithoutProperties(props, $94870e2ce3bf43ff$var$_excluded);
    var svgProps = (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(others);
    var errorBars = data.map(function(entry) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) return null;
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
            var _errorVal = $94870e2ce3bf43ff$var$_slicedToArray(errorVal, 2);
            lowBound = _errorVal[0];
            highBound = _errorVal[1];
        } else lowBound = highBound = errorVal;
        if (layout === "vertical") {
            // error bar for horizontal charts, the y is fixed, x is a range value
            var scale = xAxis.scale;
            var yMid = y + offset;
            var yMin = yMid + width;
            var yMax = yMid - width;
            var xMin = scale(value - lowBound);
            var xMax = scale(value + highBound);
            // the right line of |--|
            lineCoordinates.push({
                x1: xMax,
                y1: yMin,
                x2: xMax,
                y2: yMax
            });
            // the middle line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMid,
                x2: xMax,
                y2: yMid
            });
            // the left line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMin,
                x2: xMin,
                y2: yMax
            });
        } else if (layout === "horizontal") {
            // error bar for horizontal charts, the x is fixed, y is a range value
            var _scale = yAxis.scale;
            var xMid = x + offset;
            var _xMin = xMid - width;
            var _xMax = xMid + width;
            var _yMin = _scale(value - lowBound);
            var _yMax = _scale(value + highBound);
            // the top line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMax,
                x2: _xMax,
                y2: _yMax
            });
            // the middle line
            lineCoordinates.push({
                x1: xMid,
                y1: _yMin,
                x2: xMid,
                y2: _yMax
            });
            // the bottom line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMin,
                x2: _xMax,
                y2: _yMin
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), $94870e2ce3bf43ff$var$_extends({
            className: "recharts-errorBar",
            key: "bar-".concat(lineCoordinates.map(function(c) {
                return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
            }))
        }, svgProps), lineCoordinates.map(function(coordinates) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("line", $94870e2ce3bf43ff$var$_extends({}, coordinates, {
                key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
            }));
        }));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
        className: "recharts-errorBars"
    }, errorBars);
}
$94870e2ce3bf43ff$export$4f4d7676bdf949e5.defaultProps = {
    stroke: "black",
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: "horizontal"
};
$94870e2ce3bf43ff$export$4f4d7676bdf949e5.displayName = "ErrorBar";





var $17VE6 = parcelRequire("17VE6");

var $17VE6 = parcelRequire("17VE6");


/* eslint no-console: 0 */ var $24beccc7a8850989$var$isDev = false;
var $24beccc7a8850989$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($24beccc7a8850989$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



var $17VE6 = parcelRequire("17VE6");


var $e9a3c85e4a9c1357$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $e9a3c85e4a9c1357$var$_extends() {
    $e9a3c85e4a9c1357$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e9a3c85e4a9c1357$var$_extends.apply(this, arguments);
}
function $e9a3c85e4a9c1357$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e9a3c85e4a9c1357$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e9a3c85e4a9c1357$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e9a3c85e4a9c1357$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $e9a3c85e4a9c1357$var$_objectWithoutProperties(props, $e9a3c85e4a9c1357$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-surface", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("svg", $e9a3c85e4a9c1357$var$_extends({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(others, true, "svg"), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("desc", null, desc), children);
}



var $17VE6 = parcelRequire("17VE6");




function $e1e6d14e40931cd1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e1e6d14e40931cd1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e1e6d14e40931cd1$var$_typeof(o);
}
var $e1e6d14e40931cd1$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $e1e6d14e40931cd1$var$_extends() {
    $e1e6d14e40931cd1$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e1e6d14e40931cd1$var$_extends.apply(this, arguments);
}
function $e1e6d14e40931cd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e1e6d14e40931cd1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e1e6d14e40931cd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e1e6d14e40931cd1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e1e6d14e40931cd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e1e6d14e40931cd1$var$_defineProperty(obj, key, value) {
    key = $e1e6d14e40931cd1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e1e6d14e40931cd1$var$_toPropertyKey(arg) {
    var key = $e1e6d14e40931cd1$var$_toPrimitive(arg, "string");
    return $e1e6d14e40931cd1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e1e6d14e40931cd1$var$_toPrimitive(input, hint) {
    if ($e1e6d14e40931cd1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e1e6d14e40931cd1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e1e6d14e40931cd1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e1e6d14e40931cd1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e1e6d14e40931cd1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e1e6d14e40931cd1$var$symbolFactories = {
    symbolCircle: (0, $ebe4f7e7e65faefa$exports.symbolCircle),
    symbolCross: (0, $ebe4f7e7e65faefa$exports.symbolCross),
    symbolDiamond: (0, $ebe4f7e7e65faefa$exports.symbolDiamond),
    symbolSquare: (0, $ebe4f7e7e65faefa$exports.symbolSquare),
    symbolStar: (0, $ebe4f7e7e65faefa$exports.symbolStar),
    symbolTriangle: (0, $ebe4f7e7e65faefa$exports.symbolTriangle),
    symbolWye: (0, $ebe4f7e7e65faefa$exports.symbolWye)
};
var $e1e6d14e40931cd1$var$RADIAN = Math.PI / 180;
var $e1e6d14e40931cd1$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($ac051388b37cf998$exports)))(type));
    return $e1e6d14e40931cd1$var$symbolFactories[name] || (0, $ebe4f7e7e65faefa$exports.symbolCircle);
};
var $e1e6d14e40931cd1$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === "area") return size;
    switch(type){
        case "cross":
            return 5 * size * size / 9;
        case "diamond":
            return 0.5 * size * size / Math.sqrt(3);
        case "square":
            return size * size;
        case "star":
            var angle = 18 * $e1e6d14e40931cd1$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case "triangle":
            return Math.sqrt(3) * size * size / 4;
        case "wye":
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $e1e6d14e40931cd1$var$registerSymbol = function registerSymbol(key, factory) {
    $e1e6d14e40931cd1$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($ac051388b37cf998$exports)))(key))] = factory;
};
var $e1e6d14e40931cd1$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "circle" : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? "area" : _ref$sizeType, rest = $e1e6d14e40931cd1$var$_objectWithoutProperties(_ref, $e1e6d14e40931cd1$var$_excluded);
    var props = $e1e6d14e40931cd1$var$_objectSpread($e1e6d14e40931cd1$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $e1e6d14e40931cd1$var$getSymbolFactory(type);
        var symbol = (0, $ebe4f7e7e65faefa$exports.symbol)().type(symbolFactory).size($e1e6d14e40931cd1$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("path", $e1e6d14e40931cd1$var$_extends({}, filteredProps, {
        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-symbols", className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$e1e6d14e40931cd1$export$fa456266707bf4e4.registerSymbol = $e1e6d14e40931cd1$var$registerSymbol;



function $572eed34350546f7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $572eed34350546f7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $572eed34350546f7$var$_typeof(o);
}
function $572eed34350546f7$var$_extends() {
    $572eed34350546f7$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $572eed34350546f7$var$_extends.apply(this, arguments);
}
function $572eed34350546f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $572eed34350546f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $572eed34350546f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $572eed34350546f7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $572eed34350546f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $572eed34350546f7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $572eed34350546f7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $572eed34350546f7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $572eed34350546f7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $572eed34350546f7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $572eed34350546f7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $572eed34350546f7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $572eed34350546f7$var$_setPrototypeOf(subClass, superClass);
}
function $572eed34350546f7$var$_setPrototypeOf(o, p) {
    $572eed34350546f7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $572eed34350546f7$var$_setPrototypeOf(o, p);
}
function $572eed34350546f7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $572eed34350546f7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $572eed34350546f7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $572eed34350546f7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $572eed34350546f7$var$_possibleConstructorReturn(this, result);
    };
}
function $572eed34350546f7$var$_possibleConstructorReturn(self, call) {
    if (call && ($572eed34350546f7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $572eed34350546f7$var$_assertThisInitialized(self);
}
function $572eed34350546f7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $572eed34350546f7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $572eed34350546f7$var$_getPrototypeOf(o) {
    $572eed34350546f7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $572eed34350546f7$var$_getPrototypeOf(o);
}
function $572eed34350546f7$var$_defineProperty(obj, key, value) {
    key = $572eed34350546f7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $572eed34350546f7$var$_toPropertyKey(arg) {
    var key = $572eed34350546f7$var$_toPrimitive(arg, "string");
    return $572eed34350546f7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $572eed34350546f7$var$_toPrimitive(input, hint) {
    if ($572eed34350546f7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($572eed34350546f7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $572eed34350546f7$var$SIZE = 32;
var $572eed34350546f7$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    $572eed34350546f7$var$_inherits(DefaultLegendContent, _PureComponent);
    var _super = $572eed34350546f7$var$_createSuper(DefaultLegendContent);
    function DefaultLegendContent() {
        $572eed34350546f7$var$_classCallCheck(this, DefaultLegendContent);
        return _super.apply(this, arguments);
    }
    $572eed34350546f7$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $572eed34350546f7$var$SIZE / 2;
                var sixthSize = $572eed34350546f7$var$SIZE / 6;
                var thirdSize = $572eed34350546f7$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === "plainline") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $572eed34350546f7$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === "line") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($572eed34350546f7$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === "rect") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($572eed34350546f7$var$SIZE / 8, "h").concat($572eed34350546f7$var$SIZE, "v").concat($572eed34350546f7$var$SIZE * 3 / 4, "h").concat(-$572eed34350546f7$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).isValidElement(data.legendIcon)) {
                    var iconProps = $572eed34350546f7$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $e1e6d14e40931cd1$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $572eed34350546f7$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $572eed34350546f7$var$SIZE,
                    height: $572eed34350546f7$var$SIZE
                };
                var itemStyle = {
                    display: layout === "horizontal" ? "inline-block" : "block",
                    marginRight: 10
                };
                var svgStyle = {
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var _clsx;
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)((_clsx = {
                        "recharts-legend-item": true
                    }, $572eed34350546f7$var$_defineProperty(_clsx, "legend-item-".concat(i), true), $572eed34350546f7$var$_defineProperty(_clsx, "inactive", entry.inactive), _clsx));
                    if (entry.type === "none") return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(entry.value) ? entry.value : null;
                    (0, $24beccc7a8850989$export$c106dd0671a0fc2d)(!(0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(entry.value), 'The name property is also required when using a function for the dataKey of a chart\'s cartesian components. Ex: <Bar name="Name of my Data"/>' // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("li", $572eed34350546f7$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, $afad468d030baba8$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $e9a3c85e4a9c1357$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === "horizontal" ? align : "left"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
    return DefaultLegendContent;
}((0, $17VE6.PureComponent));
$572eed34350546f7$var$_defineProperty($572eed34350546f7$export$99f8d96ed0cededa, "displayName", "Legend");
$572eed34350546f7$var$_defineProperty($572eed34350546f7$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "middle",
    inactiveColor: "#ccc"
});



var $a94a49255119a6c7$exports = {};

var $c85eefee5dc550c4$exports = {};

var $1b3dccbdd3f54998$exports = {};
var $287feb753af3b7ab$exports = {};
var $31733f626e69c1a2$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $31733f626e69c1a2$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$31733f626e69c1a2$exports = $31733f626e69c1a2$var$baseFindIndex;


var $f74d07ca403c0d69$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $f74d07ca403c0d69$var$baseIsNaN(value) {
    return value !== value;
}
$f74d07ca403c0d69$exports = $f74d07ca403c0d69$var$baseIsNaN;


var $6f382e5e4946fe25$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6f382e5e4946fe25$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$6f382e5e4946fe25$exports = $6f382e5e4946fe25$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $287feb753af3b7ab$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $6f382e5e4946fe25$exports(array, value, fromIndex) : $31733f626e69c1a2$exports(array, $f74d07ca403c0d69$exports, fromIndex);
}
$287feb753af3b7ab$exports = $287feb753af3b7ab$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $1b3dccbdd3f54998$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $287feb753af3b7ab$exports(array, value, 0) > -1;
}
$1b3dccbdd3f54998$exports = $1b3dccbdd3f54998$var$arrayIncludes;


var $1e969cec5998c492$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $1e969cec5998c492$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$1e969cec5998c492$exports = $1e969cec5998c492$var$arrayIncludesWith;



var $0d8c5f3707852de6$exports = {};

var $43f69044b845ad01$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $43f69044b845ad01$var$noop() {
// No operation performed.
}
$43f69044b845ad01$exports = $43f69044b845ad01$var$noop;



/** Used as references for various `Number` constants. */ var $0d8c5f3707852de6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $0d8c5f3707852de6$var$createSet = !($ccc09482cb2f0d3b$exports && 1 / $faaf31b1e98288a5$exports(new $ccc09482cb2f0d3b$exports([
    ,
    -0
]))[1] == $0d8c5f3707852de6$var$INFINITY) ? $43f69044b845ad01$exports : function createSet(values) {
    return new $ccc09482cb2f0d3b$exports(values);
};
$0d8c5f3707852de6$exports = $0d8c5f3707852de6$var$createSet;



/** Used as the size to enable large array optimizations. */ var $c85eefee5dc550c4$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $c85eefee5dc550c4$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $1b3dccbdd3f54998$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $1e969cec5998c492$exports;
    } else if (length >= $c85eefee5dc550c4$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $0d8c5f3707852de6$exports(array);
        if (set) return $faaf31b1e98288a5$exports(set);
        isCommon = false;
        includes = $796b0066cf0256f0$exports;
        seen = new $6d3c890c87187d82$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$c85eefee5dc550c4$exports = $c85eefee5dc550c4$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $a94a49255119a6c7$var$uniqBy(array, iteratee) {
    return array && array.length ? $c85eefee5dc550c4$exports(array, $e55fc84590a72f7a$exports(iteratee, 2)) : [];
}
$a94a49255119a6c7$exports = $a94a49255119a6c7$var$uniqBy;



function $23a02c7a4ad0b004$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($a94a49255119a6c7$exports)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($a94a49255119a6c7$exports)))(payload, option);
    return payload;
}


function $16246b7a18e9bbb1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $16246b7a18e9bbb1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $16246b7a18e9bbb1$var$_typeof(o);
}
var $16246b7a18e9bbb1$var$_excluded = [
    "ref"
];
function $16246b7a18e9bbb1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16246b7a18e9bbb1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16246b7a18e9bbb1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $16246b7a18e9bbb1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16246b7a18e9bbb1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $16246b7a18e9bbb1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $16246b7a18e9bbb1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $16246b7a18e9bbb1$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $16246b7a18e9bbb1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $16246b7a18e9bbb1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $16246b7a18e9bbb1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $16246b7a18e9bbb1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $16246b7a18e9bbb1$var$_setPrototypeOf(subClass, superClass);
}
function $16246b7a18e9bbb1$var$_setPrototypeOf(o, p) {
    $16246b7a18e9bbb1$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $16246b7a18e9bbb1$var$_setPrototypeOf(o, p);
}
function $16246b7a18e9bbb1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $16246b7a18e9bbb1$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $16246b7a18e9bbb1$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $16246b7a18e9bbb1$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $16246b7a18e9bbb1$var$_possibleConstructorReturn(this, result);
    };
}
function $16246b7a18e9bbb1$var$_possibleConstructorReturn(self, call) {
    if (call && ($16246b7a18e9bbb1$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $16246b7a18e9bbb1$var$_assertThisInitialized(self);
}
function $16246b7a18e9bbb1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $16246b7a18e9bbb1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $16246b7a18e9bbb1$var$_getPrototypeOf(o) {
    $16246b7a18e9bbb1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $16246b7a18e9bbb1$var$_getPrototypeOf(o);
}
function $16246b7a18e9bbb1$var$_defineProperty(obj, key, value) {
    key = $16246b7a18e9bbb1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $16246b7a18e9bbb1$var$_toPropertyKey(arg) {
    var key = $16246b7a18e9bbb1$var$_toPrimitive(arg, "string");
    return $16246b7a18e9bbb1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $16246b7a18e9bbb1$var$_toPrimitive(input, hint) {
    if ($16246b7a18e9bbb1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($16246b7a18e9bbb1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $16246b7a18e9bbb1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $16246b7a18e9bbb1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $16246b7a18e9bbb1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $16246b7a18e9bbb1$var$defaultUniqBy(entry) {
    return entry.value;
}
function $16246b7a18e9bbb1$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).cloneElement(content, props);
    if (typeof content === "function") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement(content, props);
    var ref = props.ref, otherProps = $16246b7a18e9bbb1$var$_objectWithoutProperties(props, $16246b7a18e9bbb1$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $572eed34350546f7$export$99f8d96ed0cededa), otherProps);
}
var $16246b7a18e9bbb1$var$EPS = 1;
var $16246b7a18e9bbb1$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    $16246b7a18e9bbb1$var$_inherits(Legend, _PureComponent);
    var _super = $16246b7a18e9bbb1$var$_createSuper(Legend);
    function Legend() {
        var _this;
        $16246b7a18e9bbb1$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $16246b7a18e9bbb1$var$_defineProperty($16246b7a18e9bbb1$var$_assertThisInitialized(_this), "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $16246b7a18e9bbb1$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) return this.wrapperNode.getBoundingClientRect();
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var _box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(_box.width - this.lastBoundingBox.width) > $16246b7a18e9bbb1$var$EPS || Math.abs(_box.height - this.lastBoundingBox.height) > $16246b7a18e9bbb1$var$EPS) {
                        this.lastBoundingBox.width = _box.width;
                        this.lastBoundingBox.height = _box.height;
                        if (onBBoxUpdate) onBBoxUpdate(_box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $16246b7a18e9bbb1$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === "center" && layout === "vertical") {
                        var _box2 = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - _box2.width) / 2
                        };
                    } else hPos = align === "right" ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === "middle") {
                        var _box3 = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box3.height) / 2
                        };
                    } else vPos = verticalAlign === "bottom" ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $16246b7a18e9bbb1$var$_objectSpread($16246b7a18e9bbb1$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $16246b7a18e9bbb1$var$_objectSpread($16246b7a18e9bbb1$var$_objectSpread({
                    position: "absolute",
                    width: width || "auto",
                    height: height || "auto"
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $16246b7a18e9bbb1$var$renderContent(content, $16246b7a18e9bbb1$var$_objectSpread($16246b7a18e9bbb1$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $23a02c7a4ad0b004$export$b67e33c2fb1535fa)(payload, payloadUniqBy, $16246b7a18e9bbb1$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var layout = item.props.layout;
                if (layout === "vertical" && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === "horizontal") return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
    return Legend;
}((0, $17VE6.PureComponent));
$16246b7a18e9bbb1$var$_defineProperty($16246b7a18e9bbb1$export$ed247974535929c7, "displayName", "Legend");
$16246b7a18e9bbb1$var$_defineProperty($16246b7a18e9bbb1$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom"
});




function $11a07a73a1c11287$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $11a07a73a1c11287$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $11a07a73a1c11287$var$_typeof(o);
}
function $11a07a73a1c11287$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $11a07a73a1c11287$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $11a07a73a1c11287$var$ownKeys(Object(t), !0).forEach(function(r) {
            $11a07a73a1c11287$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $11a07a73a1c11287$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $11a07a73a1c11287$var$_defineProperty(obj, key, value) {
    key = $11a07a73a1c11287$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $11a07a73a1c11287$var$_toPropertyKey(arg) {
    var key = $11a07a73a1c11287$var$_toPrimitive(arg, "string");
    return $11a07a73a1c11287$var$_typeof(key) === "symbol" ? key : String(key);
}
function $11a07a73a1c11287$var$_toPrimitive(input, hint) {
    if ($11a07a73a1c11287$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($11a07a73a1c11287$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $11a07a73a1c11287$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $bb4a0676cae5de7b$export$64c61536a2b72e0f)(children, (0, $16246b7a18e9bbb1$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === "children") legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var _item$props = item.props, dataKey = _item$props.dataKey, name = _item$props.name, legendType = _item$props.legendType, hide = _item$props.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendItem.props.iconType || legendType || "square",
            color: (0, $5ef2e400865c36d4$export$ec6cab5a7a3b93bf)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: item.props
        };
    });
    return $11a07a73a1c11287$var$_objectSpread($11a07a73a1c11287$var$_objectSpread($11a07a73a1c11287$var$_objectSpread({}, legendItem.props), (0, $16246b7a18e9bbb1$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};


function $5ef2e400865c36d4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5ef2e400865c36d4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5ef2e400865c36d4$var$_typeof(o);
}
function $5ef2e400865c36d4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5ef2e400865c36d4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5ef2e400865c36d4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5ef2e400865c36d4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5ef2e400865c36d4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5ef2e400865c36d4$var$_defineProperty(obj, key, value) {
    key = $5ef2e400865c36d4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5ef2e400865c36d4$var$_toPropertyKey(arg) {
    var key = $5ef2e400865c36d4$var$_toPrimitive(arg, "string");
    return $5ef2e400865c36d4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5ef2e400865c36d4$var$_toPrimitive(input, hint) {
    if ($5ef2e400865c36d4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5ef2e400865c36d4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5ef2e400865c36d4$var$_toConsumableArray(arr) {
    return $5ef2e400865c36d4$var$_arrayWithoutHoles(arr) || $5ef2e400865c36d4$var$_iterableToArray(arr) || $5ef2e400865c36d4$var$_unsupportedIterableToArray(arr) || $5ef2e400865c36d4$var$_nonIterableSpread();
}
function $5ef2e400865c36d4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5ef2e400865c36d4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5ef2e400865c36d4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5ef2e400865c36d4$var$_arrayLikeToArray(o, minLen);
}
function $5ef2e400865c36d4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $5ef2e400865c36d4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5ef2e400865c36d4$var$_arrayLikeToArray(arr);
}
function $5ef2e400865c36d4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5ef2e400865c36d4$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(dataKey)) return defaultValue;
    if ((0, $411b8d52505ff75c$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($c3944f5a36163d07$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $5ef2e400865c36d4$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($2d67a83e9aac965a$exports)))(data, function(entry) {
        return $5ef2e400865c36d4$export$f97fc4a450f29a(entry, key);
    });
    if (type === "number") {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $411b8d52505ff75c$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($8a46ec213ac99d96$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($0b5bf9df70f4d7fd$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $411b8d52505ff75c$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : "";
    });
}
var $5ef2e400865c36d4$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === "angleAxis" && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $411b8d52505ff75c$export$9d334328eb75e624)(cur - before) !== (0, $411b8d52505ff75c$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $411b8d52505ff75c$export$9d334328eb75e624)(after - cur) === (0, $411b8d52505ff75c$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $5ef2e400865c36d4$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var _item$props = item.props, stroke = _item$props.stroke, fill = _item$props.fill;
    var result;
    switch(displayName){
        case "Line":
            result = stroke;
            break;
        case "Area":
        case "Radar":
            result = stroke && stroke !== "none" ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $5ef2e400865c36d4$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $bb4a0676cae5de7b$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            });
            if (barItems && barItems.length) {
                var selfSize = barItems[0].props.barSize;
                var cateId = barItems[0].props[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(selfSize) ? globalSize : selfSize
                });
            }
        }
    }
    return result;
};
var $5ef2e400865c36d4$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $411b8d52505ff75c$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($5ef2e400865c36d4$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $411b8d52505ff75c$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($5ef2e400865c36d4$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $5ef2e400865c36d4$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $11a07a73a1c11287$export$8f9424d123c36aa)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === "vertical" || layout === "horizontal" && verticalAlign === "middle") && align !== "center" && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(offset[align])) return $5ef2e400865c36d4$var$_objectSpread($5ef2e400865c36d4$var$_objectSpread({}, offset), {}, $5ef2e400865c36d4$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === "horizontal" || layout === "vertical" && align === "center") && verticalAlign !== "middle" && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(offset[verticalAlign])) return $5ef2e400865c36d4$var$_objectSpread($5ef2e400865c36d4$var$_objectSpread({}, offset), {}, $5ef2e400865c36d4$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $5ef2e400865c36d4$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(axisType)) return true;
    if (layout === "horizontal") return axisType === "yAxis";
    if (layout === "vertical") return axisType === "xAxis";
    if (direction === "x") return axisType === "xAxis";
    if (direction === "y") return axisType === "yAxis";
    return true;
};
var $5ef2e400865c36d4$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $bb4a0676cae5de7b$export$fdd5e64c0e8495bb)(children, (0, $94870e2ce3bf43ff$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $5ef2e400865c36d4$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $5ef2e400865c36d4$export$f97fc4a450f29a(entry, dataKey, 0);
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($8a46ec213ac99d96$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($0b5bf9df70f4d7fd$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $5ef2e400865c36d4$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $5ef2e400865c36d4$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $5ef2e400865c36d4$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $5ef2e400865c36d4$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === "number" && dataKey) return $5ef2e400865c36d4$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $5ef2e400865c36d4$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $5ef2e400865c36d4$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === "number") // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $5ef2e400865c36d4$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === "horizontal" && axisType === "xAxis" || layout === "vertical" && axisType === "yAxis" || layout === "centric" && axisType === "angleAxis" || layout === "radial" && axisType === "radiusAxis";
};
var $5ef2e400865c36d4$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $5ef2e400865c36d4$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === "scaleBand" ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === "category" && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === "angleAxis" && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $411b8d52505ff75c$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($d13e95156e78f92e$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $5ef2e400865c36d4$var$handlerWeakMap = new WeakMap();
var $5ef2e400865c36d4$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== "function") return defaultHandler;
    if (!$5ef2e400865c36d4$var$handlerWeakMap.has(defaultHandler)) $5ef2e400865c36d4$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $5ef2e400865c36d4$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $5ef2e400865c36d4$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === "auto") {
        if (layout === "radial" && axisType === "radiusAxis") return {
            scale: $8b8a6f16bc14962f$exports.scaleBand(),
            realScaleType: "band"
        };
        if (layout === "radial" && axisType === "angleAxis") return {
            scale: $8b8a6f16bc14962f$exports.scaleLinear(),
            realScaleType: "linear"
        };
        if (type === "category" && chartType && (chartType.indexOf("LineChart") >= 0 || chartType.indexOf("AreaChart") >= 0 || chartType.indexOf("ComposedChart") >= 0 && !hasBar)) return {
            scale: $8b8a6f16bc14962f$exports.scalePoint(),
            realScaleType: "point"
        };
        if (type === "category") return {
            scale: $8b8a6f16bc14962f$exports.scaleBand(),
            realScaleType: "band"
        };
        return {
            scale: $8b8a6f16bc14962f$exports.scaleLinear(),
            realScaleType: "linear"
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1224e4f23052ea6c$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($ac051388b37cf998$exports)))(scale));
        return {
            scale: ($8b8a6f16bc14962f$exports[name] || $8b8a6f16bc14962f$exports.scalePoint)(),
            realScaleType: $8b8a6f16bc14962f$exports[name] ? name : "point"
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $8b8a6f16bc14962f$exports.scalePoint(),
        realScaleType: "point"
    };
};
var $5ef2e400865c36d4$var$EPS = 1e-4;
var $5ef2e400865c36d4$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $5ef2e400865c36d4$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $5ef2e400865c36d4$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $5ef2e400865c36d4$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $5ef2e400865c36d4$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(domain[0]) || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $411b8d52505ff75c$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $411b8d52505ff75c$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $5ef2e400865c36d4$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($d13e95156e78f92e$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $5ef2e400865c36d4$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($d13e95156e78f92e$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $5ef2e400865c36d4$var$STACK_OFFSET_MAP = {
    sign: $5ef2e400865c36d4$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $ebe4f7e7e65faefa$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $ebe4f7e7e65faefa$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $ebe4f7e7e65faefa$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $ebe4f7e7e65faefa$exports.stackOffsetWiggle),
    positive: $5ef2e400865c36d4$export$9f2c6ead70935022
};
var $5ef2e400865c36d4$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $5ef2e400865c36d4$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $ebe4f7e7e65faefa$exports.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$5ef2e400865c36d4$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $ebe4f7e7e65faefa$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $5ef2e400865c36d4$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$props2 = item.props, stackId = _item$props2.stackId, hide = _item$props2.hide;
        if (hide) return result;
        var axisId = item.props[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $411b8d52505ff75c$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $411b8d52505ff75c$export$8b15d37bc3f197d4)("_stackId_")] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $5ef2e400865c36d4$var$_objectSpread($5ef2e400865c36d4$var$_objectSpread({}, result), {}, $5ef2e400865c36d4$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $5ef2e400865c36d4$var$_objectSpread($5ef2e400865c36d4$var$_objectSpread({}, res), {}, $5ef2e400865c36d4$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $5ef2e400865c36d4$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $5ef2e400865c36d4$var$_objectSpread($5ef2e400865c36d4$var$_objectSpread({}, result), {}, $5ef2e400865c36d4$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $5ef2e400865c36d4$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== "auto" && scaleType !== "linear") return null;
    if (tickCount && type === "number" && originalDomain && (originalDomain[0] === "auto" || originalDomain[1] === "auto")) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $ea79d95d5102e8f1$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($8a46ec213ac99d96$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($0b5bf9df70f4d7fd$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === "number") {
        var _domain = scale.domain();
        var _tickValues = (0, $ea79d95d5102e8f1$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
var $5ef2e400865c36d4$export$6e87f3defb83c3f = function getCateCoordinateOfLine(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === "category") {
        // find coordinate of category axis by the value of category
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(entry[axis.dataKey])) {
            var matchedTick = (0, $411b8d52505ff75c$export$66950d3869f5cc67)(ticks, "value", entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $5ef2e400865c36d4$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(value) ? axis.scale(value) : null;
};
var $5ef2e400865c36d4$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === "category") return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $5ef2e400865c36d4$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $5ef2e400865c36d4$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $5ef2e400865c36d4$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var stackId = item.props.stackId;
    if ((0, $411b8d52505ff75c$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $5ef2e400865c36d4$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($8a46ec213ac99d96$exports)))(entry.concat([
                result[0]
            ]).filter((0, $411b8d52505ff75c$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($0b5bf9df70f4d7fd$exports)))(entry.concat([
                result[1]
            ]).filter((0, $411b8d52505ff75c$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $5ef2e400865c36d4$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $5ef2e400865c36d4$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $5ef2e400865c36d4$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $5ef2e400865c36d4$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $5ef2e400865c36d4$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($5ef2e400865c36d4$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$5ef2e400865c36d4$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($5ef2e400865c36d4$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$5ef2e400865c36d4$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $5ef2e400865c36d4$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($2d5f4b2fac16794e$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $5ef2e400865c36d4$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($c65581b1798022be$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($c3944f5a36163d07$exports)))(axisChild, "type.defaultProps.domain"))) return calculatedDomain;
    return specifiedDomain;
};
var $5ef2e400865c36d4$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name = _graphicalItem$props.name, unit = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType;
    return $5ef2e400865c36d4$var$_objectSpread($5ef2e400865c36d4$var$_objectSpread({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(graphicalItem)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $5ef2e400865c36d4$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $5ef2e400865c36d4$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType
    });
};


function $f004b8ab2664ad8d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f004b8ab2664ad8d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f004b8ab2664ad8d$var$_typeof(o);
}
function $f004b8ab2664ad8d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f004b8ab2664ad8d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f004b8ab2664ad8d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f004b8ab2664ad8d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f004b8ab2664ad8d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f004b8ab2664ad8d$var$_defineProperty(obj, key, value) {
    key = $f004b8ab2664ad8d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f004b8ab2664ad8d$var$_toPropertyKey(arg) {
    var key = $f004b8ab2664ad8d$var$_toPrimitive(arg, "string");
    return $f004b8ab2664ad8d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f004b8ab2664ad8d$var$_toPrimitive(input, hint) {
    if ($f004b8ab2664ad8d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f004b8ab2664ad8d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f004b8ab2664ad8d$var$_slicedToArray(arr, i) {
    return $f004b8ab2664ad8d$var$_arrayWithHoles(arr) || $f004b8ab2664ad8d$var$_iterableToArrayLimit(arr, i) || $f004b8ab2664ad8d$var$_unsupportedIterableToArray(arr, i) || $f004b8ab2664ad8d$var$_nonIterableRest();
}
function $f004b8ab2664ad8d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f004b8ab2664ad8d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f004b8ab2664ad8d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f004b8ab2664ad8d$var$_arrayLikeToArray(o, minLen);
}
function $f004b8ab2664ad8d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f004b8ab2664ad8d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f004b8ab2664ad8d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $f004b8ab2664ad8d$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $f004b8ab2664ad8d$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $f004b8ab2664ad8d$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $f004b8ab2664ad8d$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$f004b8ab2664ad8d$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$f004b8ab2664ad8d$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $f004b8ab2664ad8d$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $f004b8ab2664ad8d$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $411b8d52505ff75c$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $411b8d52505ff75c$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $f004b8ab2664ad8d$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $411b8d52505ff75c$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $411b8d52505ff75c$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(axis.range)) {
            if (axisType === "angleAxis") range = [
                startAngle,
                endAngle
            ];
            else if (axisType === "radiusAxis") range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $f004b8ab2664ad8d$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $5ef2e400865c36d4$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $5ef2e400865c36d4$export$9d80152e23bae434)(scale);
        var ticks = (0, $5ef2e400865c36d4$export$ac086aaa4358d590)(scale, $f004b8ab2664ad8d$var$_objectSpread($f004b8ab2664ad8d$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $f004b8ab2664ad8d$var$_objectSpread($f004b8ab2664ad8d$var$_objectSpread($f004b8ab2664ad8d$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $f004b8ab2664ad8d$var$_objectSpread($f004b8ab2664ad8d$var$_objectSpread({}, result), {}, $f004b8ab2664ad8d$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $f004b8ab2664ad8d$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $f004b8ab2664ad8d$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $f004b8ab2664ad8d$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $f004b8ab2664ad8d$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $f004b8ab2664ad8d$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $f004b8ab2664ad8d$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $f004b8ab2664ad8d$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $f004b8ab2664ad8d$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $f004b8ab2664ad8d$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $f004b8ab2664ad8d$var$_objectSpread($f004b8ab2664ad8d$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $f004b8ab2664ad8d$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};


function $af8b9f0e73fbde03$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $af8b9f0e73fbde03$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $af8b9f0e73fbde03$var$_typeof(o);
}
var $af8b9f0e73fbde03$var$_excluded = [
    "offset"
];
function $af8b9f0e73fbde03$var$_toConsumableArray(arr) {
    return $af8b9f0e73fbde03$var$_arrayWithoutHoles(arr) || $af8b9f0e73fbde03$var$_iterableToArray(arr) || $af8b9f0e73fbde03$var$_unsupportedIterableToArray(arr) || $af8b9f0e73fbde03$var$_nonIterableSpread();
}
function $af8b9f0e73fbde03$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $af8b9f0e73fbde03$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $af8b9f0e73fbde03$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $af8b9f0e73fbde03$var$_arrayLikeToArray(o, minLen);
}
function $af8b9f0e73fbde03$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $af8b9f0e73fbde03$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $af8b9f0e73fbde03$var$_arrayLikeToArray(arr);
}
function $af8b9f0e73fbde03$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $af8b9f0e73fbde03$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $af8b9f0e73fbde03$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $af8b9f0e73fbde03$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $af8b9f0e73fbde03$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $af8b9f0e73fbde03$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $af8b9f0e73fbde03$var$ownKeys(Object(t), !0).forEach(function(r) {
            $af8b9f0e73fbde03$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $af8b9f0e73fbde03$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $af8b9f0e73fbde03$var$_defineProperty(obj, key, value) {
    key = $af8b9f0e73fbde03$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $af8b9f0e73fbde03$var$_toPropertyKey(arg) {
    var key = $af8b9f0e73fbde03$var$_toPrimitive(arg, "string");
    return $af8b9f0e73fbde03$var$_typeof(key) === "symbol" ? key : String(key);
}
function $af8b9f0e73fbde03$var$_toPrimitive(input, hint) {
    if ($af8b9f0e73fbde03$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($af8b9f0e73fbde03$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $af8b9f0e73fbde03$var$_extends() {
    $af8b9f0e73fbde03$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $af8b9f0e73fbde03$var$_extends.apply(this, arguments);
}
var $af8b9f0e73fbde03$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(formatter)) return formatter(label);
    return label;
};
var $af8b9f0e73fbde03$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $411b8d52505ff75c$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $af8b9f0e73fbde03$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $af8b9f0e73fbde03$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === "insideStart") {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === "insideEnd") {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === "end") {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(labelProps.id) ? (0, $411b8d52505ff75c$export$8b15d37bc3f197d4)("recharts-radial-line-") : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("text", $af8b9f0e73fbde03$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-radial-bar-label", className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $af8b9f0e73fbde03$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === "outside") {
        var _polarToCartesian = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? "start" : "end",
            verticalAnchor: "middle"
        };
    }
    if (position === "center") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
    if (position === "centerTop") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "start"
    };
    if (position === "centerBottom") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "end"
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
};
var $af8b9f0e73fbde03$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? "end" : "start";
    var verticalStart = verticalSign > 0 ? "start" : "end";
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? "end" : "start";
    var horizontalStart = horizontalSign > 0 ? "start" : "end";
    if (position === "top") {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: "middle",
            verticalAnchor: verticalEnd
        };
        return $af8b9f0e73fbde03$var$_objectSpread($af8b9f0e73fbde03$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === "bottom") {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: "middle",
            verticalAnchor: verticalStart
        };
        return $af8b9f0e73fbde03$var$_objectSpread($af8b9f0e73fbde03$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === "left") {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: "middle"
        };
        return $af8b9f0e73fbde03$var$_objectSpread($af8b9f0e73fbde03$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === "right") {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: "middle"
        };
        return $af8b9f0e73fbde03$var$_objectSpread($af8b9f0e73fbde03$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === "insideLeft") return $af8b9f0e73fbde03$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideRight") return $af8b9f0e73fbde03$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideTop") return $af8b9f0e73fbde03$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottom") return $af8b9f0e73fbde03$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideTopLeft") return $af8b9f0e73fbde03$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideTopRight") return $af8b9f0e73fbde03$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottomLeft") return $af8b9f0e73fbde03$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideBottomRight") return $af8b9f0e73fbde03$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f380900e8541e270$exports)))(position) && ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(position.x) || (0, $411b8d52505ff75c$export$e50269385c77c348)(position.x)) && ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(position.y) || (0, $411b8d52505ff75c$export$e50269385c77c348)(position.y))) return $af8b9f0e73fbde03$var$_objectSpread({
        x: x + (0, $411b8d52505ff75c$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $411b8d52505ff75c$export$476354dbf49bdff6)(position.y, height),
        textAnchor: "end",
        verticalAnchor: "end"
    }, sizeAttrs);
    return $af8b9f0e73fbde03$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: "middle",
        verticalAnchor: "middle"
    }, sizeAttrs);
};
var $af8b9f0e73fbde03$var$isPolar = function isPolar(viewBox) {
    return "cx" in viewBox && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(viewBox.cx);
};
function $af8b9f0e73fbde03$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $af8b9f0e73fbde03$var$_objectWithoutProperties(_ref4, $af8b9f0e73fbde03$var$_excluded);
    var props = $af8b9f0e73fbde03$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(children) && !/*#__PURE__*/ (0, $17VE6.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $17VE6.isValidElement)(content)) return /*#__PURE__*/ (0, $17VE6.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(content)) {
        label = /*#__PURE__*/ (0, $17VE6.createElement)(content, props);
        if (/*#__PURE__*/ (0, $17VE6.isValidElement)(label)) return label;
    } else label = $af8b9f0e73fbde03$var$getLabel(props);
    var isPolarLabel = $af8b9f0e73fbde03$var$isPolar(viewBox);
    var attrs = (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === "insideStart" || position === "insideEnd" || position === "end")) return $af8b9f0e73fbde03$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $af8b9f0e73fbde03$var$getAttrsOfPolarLabel(props) : $af8b9f0e73fbde03$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $b5bb411b2159255d$export$5f1af8db9871e1d6), $af8b9f0e73fbde03$var$_extends({
        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-label", className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$af8b9f0e73fbde03$export$b04be29aa201d4f5.displayName = "Label";
var $af8b9f0e73fbde03$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(width) && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(height)) {
        if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(x) && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(top) && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(x) && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(cx) && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $af8b9f0e73fbde03$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement($af8b9f0e73fbde03$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $411b8d52505ff75c$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement($af8b9f0e73fbde03$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $17VE6.isValidElement)(label)) {
        if (label.type === $af8b9f0e73fbde03$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $17VE6.cloneElement)(label, {
            key: "label-implicit",
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement($af8b9f0e73fbde03$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement($af8b9f0e73fbde03$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f380900e8541e270$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement($af8b9f0e73fbde03$export$b04be29aa201d4f5, $af8b9f0e73fbde03$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $af8b9f0e73fbde03$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $af8b9f0e73fbde03$var$parseViewBox(parentProps);
    var explicitChildren = (0, $bb4a0676cae5de7b$export$fdd5e64c0e8495bb)(children, $af8b9f0e73fbde03$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $17VE6.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $af8b9f0e73fbde03$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($af8b9f0e73fbde03$var$_toConsumableArray(explicitChildren));
};
$af8b9f0e73fbde03$export$b04be29aa201d4f5.parseViewBox = $af8b9f0e73fbde03$var$parseViewBox;
$af8b9f0e73fbde03$export$b04be29aa201d4f5.renderCallByParent = $af8b9f0e73fbde03$var$renderCallByParent;





function $ba005ed395c74bd1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ba005ed395c74bd1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ba005ed395c74bd1$var$_typeof(o);
}
var $ba005ed395c74bd1$var$_excluded = [
    "valueAccessor"
], $ba005ed395c74bd1$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $ba005ed395c74bd1$var$_toConsumableArray(arr) {
    return $ba005ed395c74bd1$var$_arrayWithoutHoles(arr) || $ba005ed395c74bd1$var$_iterableToArray(arr) || $ba005ed395c74bd1$var$_unsupportedIterableToArray(arr) || $ba005ed395c74bd1$var$_nonIterableSpread();
}
function $ba005ed395c74bd1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ba005ed395c74bd1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ba005ed395c74bd1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ba005ed395c74bd1$var$_arrayLikeToArray(o, minLen);
}
function $ba005ed395c74bd1$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ba005ed395c74bd1$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ba005ed395c74bd1$var$_arrayLikeToArray(arr);
}
function $ba005ed395c74bd1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ba005ed395c74bd1$var$_extends() {
    $ba005ed395c74bd1$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ba005ed395c74bd1$var$_extends.apply(this, arguments);
}
function $ba005ed395c74bd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba005ed395c74bd1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba005ed395c74bd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ba005ed395c74bd1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba005ed395c74bd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ba005ed395c74bd1$var$_defineProperty(obj, key, value) {
    key = $ba005ed395c74bd1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ba005ed395c74bd1$var$_toPropertyKey(arg) {
    var key = $ba005ed395c74bd1$var$_toPrimitive(arg, "string");
    return $ba005ed395c74bd1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ba005ed395c74bd1$var$_toPrimitive(input, hint) {
    if ($ba005ed395c74bd1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ba005ed395c74bd1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ba005ed395c74bd1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ba005ed395c74bd1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ba005ed395c74bd1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ba005ed395c74bd1$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($8ec337cccebd6fba$exports)))(entry.value) : entry.value;
};
function $ba005ed395c74bd1$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $ba005ed395c74bd1$var$defaultAccessor : _ref$valueAccessor, restProps = $ba005ed395c74bd1$var$_objectWithoutProperties(_ref, $ba005ed395c74bd1$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $ba005ed395c74bd1$var$_objectWithoutProperties(restProps, $ba005ed395c74bd1$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $5ef2e400865c36d4$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $af8b9f0e73fbde03$export$b04be29aa201d4f5), $ba005ed395c74bd1$var$_extends({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $af8b9f0e73fbde03$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(clockWise) ? entry : $ba005ed395c74bd1$var$_objectSpread($ba005ed395c74bd1$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$ba005ed395c74bd1$export$835fcf23ab7bf88.displayName = "LabelList";
function $ba005ed395c74bd1$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement($ba005ed395c74bd1$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement($ba005ed395c74bd1$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f380900e8541e270$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement($ba005ed395c74bd1$export$835fcf23ab7bf88, $ba005ed395c74bd1$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $ba005ed395c74bd1$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $bb4a0676cae5de7b$export$fdd5e64c0e8495bb)(children, $ba005ed395c74bd1$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $17VE6.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $ba005ed395c74bd1$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($ba005ed395c74bd1$var$_toConsumableArray(explicitChildren));
}
$ba005ed395c74bd1$export$835fcf23ab7bf88.renderCallByParent = $ba005ed395c74bd1$var$renderCallByParent;






var $014dbbe445859826$var$_excluded = [
    "layout",
    "type",
    "stroke",
    "connectNulls",
    "isRange",
    "ref"
];
var $014dbbe445859826$var$_class;
function $014dbbe445859826$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $014dbbe445859826$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $014dbbe445859826$var$_typeof(o);
}
function $014dbbe445859826$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $014dbbe445859826$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $014dbbe445859826$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $014dbbe445859826$var$_extends() {
    $014dbbe445859826$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $014dbbe445859826$var$_extends.apply(this, arguments);
}
function $014dbbe445859826$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $014dbbe445859826$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $014dbbe445859826$var$ownKeys(Object(t), !0).forEach(function(r) {
            $014dbbe445859826$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $014dbbe445859826$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $014dbbe445859826$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $014dbbe445859826$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $014dbbe445859826$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $014dbbe445859826$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $014dbbe445859826$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $014dbbe445859826$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $014dbbe445859826$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $014dbbe445859826$var$_setPrototypeOf(subClass, superClass);
}
function $014dbbe445859826$var$_setPrototypeOf(o, p) {
    $014dbbe445859826$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $014dbbe445859826$var$_setPrototypeOf(o, p);
}
function $014dbbe445859826$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $014dbbe445859826$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $014dbbe445859826$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $014dbbe445859826$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $014dbbe445859826$var$_possibleConstructorReturn(this, result);
    };
}
function $014dbbe445859826$var$_possibleConstructorReturn(self, call) {
    if (call && ($014dbbe445859826$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $014dbbe445859826$var$_assertThisInitialized(self);
}
function $014dbbe445859826$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $014dbbe445859826$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $014dbbe445859826$var$_getPrototypeOf(o) {
    $014dbbe445859826$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $014dbbe445859826$var$_getPrototypeOf(o);
}
function $014dbbe445859826$var$_defineProperty(obj, key, value) {
    key = $014dbbe445859826$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $014dbbe445859826$var$_toPropertyKey(arg) {
    var key = $014dbbe445859826$var$_toPrimitive(arg, "string");
    return $014dbbe445859826$var$_typeof(key) === "symbol" ? key : String(key);
}
function $014dbbe445859826$var$_toPrimitive(input, hint) {
    if ($014dbbe445859826$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($014dbbe445859826$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $014dbbe445859826$export$ea1a111407f37557 = /*#__PURE__*/ function(_PureComponent) {
    $014dbbe445859826$var$_inherits(Area, _PureComponent);
    var _super = $014dbbe445859826$var$_createSuper(Area);
    function Area() {
        var _this;
        $014dbbe445859826$var$_classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $014dbbe445859826$var$_defineProperty($014dbbe445859826$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: true
        });
        $014dbbe445859826$var$_defineProperty($014dbbe445859826$var$_assertThisInitialized(_this), "id", (0, $411b8d52505ff75c$export$8b15d37bc3f197d4)("recharts-area-"));
        $014dbbe445859826$var$_defineProperty($014dbbe445859826$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $014dbbe445859826$var$_defineProperty($014dbbe445859826$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    $014dbbe445859826$var$_createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(this.props);
                var customDotProps = (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $014dbbe445859826$var$_objectSpread($014dbbe445859826$var$_objectSpread($014dbbe445859826$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        value: entry.value,
                        payload: entry.payload
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? "" : "dots-").concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), $014dbbe445859826$var$_extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, (/*@__PURE__*/$parcel$interopDefault($0b5bf9df70f4d7fd$exports)))(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") maxY = Math.max(baseLine, maxY);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxY = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($0b5bf9df70f4d7fd$exports)))(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(maxY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, (/*@__PURE__*/$parcel$interopDefault($0b5bf9df70f4d7fd$exports)))(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") maxX = Math.max(baseLine, maxX);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxX = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($0b5bf9df70f4d7fd$exports)))(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(maxX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === "vertical") return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = $014dbbe445859826$var$_objectWithoutProperties(_this$props4, $014dbbe445859826$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $ea5067ec5be00d2e$export$b0e83c3ef8d2db1), $014dbbe445859826$var$_extends({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== "none" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $ea5067ec5be00d2e$export$b0e83c3ef8d2db1), $014dbbe445859826$var$_extends({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== "none" && isRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $ea5067ec5be00d2e$export$b0e83c3ef8d2db1), $014dbbe445859826$var$_extends({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
                // const clipPathId = isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $19c5e74eae47b177$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $411b8d52505ff75c$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $411b8d52505ff75c$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $014dbbe445859826$var$_objectSpread($014dbbe445859826$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") {
                            var interpolator = (0, $411b8d52505ff75c$export$d871d53bd7eeb390)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(baseLine) || (0, (/*@__PURE__*/$parcel$interopDefault($d13e95156e78f92e$exports)))(baseLine)) {
                            var _interpolator = (0, $411b8d52505ff75c$export$d871d53bd7eeb390)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, $411b8d52505ff75c$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $411b8d52505ff75c$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $014dbbe445859826$var$_objectSpread($014dbbe445859826$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($c65581b1798022be$exports)))(prevPoints, points) || !(0, (/*@__PURE__*/$parcel$interopDefault($c65581b1798022be$exports)))(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-area", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(dot)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $bb4a0676cae5de7b$export$e78c5929b986eef9)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $ba005ed395c74bd1$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
    return Area;
}((0, $17VE6.PureComponent));
$014dbbe445859826$var$_class = $014dbbe445859826$export$ea1a111407f37557;
$014dbbe445859826$var$_defineProperty($014dbbe445859826$export$ea1a111407f37557, "displayName", "Area");
$014dbbe445859826$var$_defineProperty($014dbbe445859826$export$ea1a111407f37557, "defaultProps", {
    stroke: "#3182bd",
    fill: "#3182bd",
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: "line",
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, $e72696708fbb4da9$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
});
$014dbbe445859826$var$_defineProperty($014dbbe445859826$export$ea1a111407f37557, "getBaseValue", function(props, item, xAxis, yAxis) {
    var layout = props.layout, chartBaseValue = props.baseValue;
    var itemBaseValue = item.props.baseValue;
    // The baseValue can be defined both on the AreaChart as well as on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(baseValue) && typeof baseValue === "number") return baseValue;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var domainMax = Math.max(domain[0], domain[1]);
        var domainMin = Math.min(domain[0], domain[1]);
        if (baseValue === "dataMin") return domainMin;
        if (baseValue === "dataMax") return domainMax;
        return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === "dataMin") return domain[0];
    if (baseValue === "dataMax") return domain[1];
    return domain[0];
});
$014dbbe445859826$var$_defineProperty($014dbbe445859826$export$ea1a111407f37557, "getComposedData", function(_ref4) {
    var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $014dbbe445859826$var$_class.getBaseValue(props, item, xAxis, yAxis);
    var isHorizontalLayout = layout === "horizontal";
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = (0, $5ef2e400865c36d4$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = value[1] == null || hasStack && (0, $5ef2e400865c36d4$export$f97fc4a450f29a)(entry, dataKey) == null;
        if (isHorizontalLayout) return {
            x: (0, $5ef2e400865c36d4$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, $5ef2e400865c36d4$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        var x = Array.isArray(entry.value) ? entry.value[0] : null;
        if (isHorizontalLayout) return {
            x: entry.x,
            y: x != null && entry.y != null ? yAxis.scale(x) : null
        };
        return {
            x: x != null ? xAxis.scale(x) : null,
            y: entry.y
        };
    });
    else baseLine = isHorizontalLayout ? yAxis.scale(baseValue) : xAxis.scale(baseValue);
    return $014dbbe445859826$var$_objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
});
$014dbbe445859826$var$_defineProperty($014dbbe445859826$export$ea1a111407f37557, "renderDotItem", function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(option)) dotItem = option(props);
    else dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $0ea73b33a67b7ee8$export$d046b3c4a416f60d), $014dbbe445859826$var$_extends({}, props, {
        className: "recharts-area-dot"
    }));
    return dotItem;
});

/**
 * @fileOverview Area Chart
 */ 
var $17VE6 = parcelRequire("17VE6");


var $dc48ba0e6e0a6001$exports = {};
var $3b3ad53d27084505$exports = {};
var $939c9517cb984fa6$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $939c9517cb984fa6$var$nativeCeil = Math.ceil, $939c9517cb984fa6$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $939c9517cb984fa6$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $939c9517cb984fa6$var$nativeMax($939c9517cb984fa6$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$939c9517cb984fa6$exports = $939c9517cb984fa6$var$baseRange;



var $aaf730a68ab7df12$exports = {};
var $32ec1e56c9fc6b6a$exports = {};
var $ef69f59d104b2e0e$exports = {};
var $27632cb43cd3b654$exports = {};
/** Used to match a single whitespace character. */ var $27632cb43cd3b654$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $27632cb43cd3b654$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $27632cb43cd3b654$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$27632cb43cd3b654$exports = $27632cb43cd3b654$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $ef69f59d104b2e0e$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $ef69f59d104b2e0e$var$baseTrim(string) {
    return string ? string.slice(0, $27632cb43cd3b654$exports(string) + 1).replace($ef69f59d104b2e0e$var$reTrimStart, "") : string;
}
$ef69f59d104b2e0e$exports = $ef69f59d104b2e0e$var$baseTrim;




/** Used as references for various `Number` constants. */ var $32ec1e56c9fc6b6a$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $32ec1e56c9fc6b6a$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $32ec1e56c9fc6b6a$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $32ec1e56c9fc6b6a$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $32ec1e56c9fc6b6a$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $32ec1e56c9fc6b6a$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($cb0f03c9c78ae357$exports(value)) return $32ec1e56c9fc6b6a$var$NAN;
    if ($f380900e8541e270$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $f380900e8541e270$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $ef69f59d104b2e0e$exports(value);
    var isBinary = $32ec1e56c9fc6b6a$var$reIsBinary.test(value);
    return isBinary || $32ec1e56c9fc6b6a$var$reIsOctal.test(value) ? $32ec1e56c9fc6b6a$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $32ec1e56c9fc6b6a$var$reIsBadHex.test(value) ? $32ec1e56c9fc6b6a$var$NAN : +value;
}
$32ec1e56c9fc6b6a$exports = $32ec1e56c9fc6b6a$var$toNumber;


/** Used as references for various `Number` constants. */ var $aaf730a68ab7df12$var$INFINITY = 1 / 0, $aaf730a68ab7df12$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $aaf730a68ab7df12$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $32ec1e56c9fc6b6a$exports(value);
    if (value === $aaf730a68ab7df12$var$INFINITY || value === -$aaf730a68ab7df12$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $aaf730a68ab7df12$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$aaf730a68ab7df12$exports = $aaf730a68ab7df12$var$toFinite;


/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $3b3ad53d27084505$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && $a4ed4c5e9ebf8672$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $aaf730a68ab7df12$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $aaf730a68ab7df12$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $aaf730a68ab7df12$exports(step);
        return $939c9517cb984fa6$exports(start, end, step, fromRight);
    };
}
$3b3ad53d27084505$exports = $3b3ad53d27084505$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $dc48ba0e6e0a6001$var$range = $3b3ad53d27084505$exports();
$dc48ba0e6e0a6001$exports = $dc48ba0e6e0a6001$var$range;




var $a01f45a78bb58511$exports = {};
var $ad5a2991289fd50e$exports = {};

var $03fa0e75920e01c5$exports = {};

var $lOsGe = parcelRequire("lOsGe");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $03fa0e75920e01c5$var$now = function now() {
    return $lOsGe.Date.now();
};
$03fa0e75920e01c5$exports = $03fa0e75920e01c5$var$now;



/** Error message constants. */ var $ad5a2991289fd50e$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ad5a2991289fd50e$var$nativeMax = Math.max, $ad5a2991289fd50e$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ad5a2991289fd50e$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($ad5a2991289fd50e$var$FUNC_ERROR_TEXT);
    wait = $32ec1e56c9fc6b6a$exports(wait) || 0;
    if ($f380900e8541e270$exports(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $ad5a2991289fd50e$var$nativeMax($32ec1e56c9fc6b6a$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $ad5a2991289fd50e$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $03fa0e75920e01c5$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($03fa0e75920e01c5$exports());
    }
    function debounced() {
        var time = $03fa0e75920e01c5$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$ad5a2991289fd50e$exports = $ad5a2991289fd50e$var$debounce;



/** Error message constants. */ var $a01f45a78bb58511$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $a01f45a78bb58511$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($a01f45a78bb58511$var$FUNC_ERROR_TEXT);
    if ($f380900e8541e270$exports(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $ad5a2991289fd50e$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$a01f45a78bb58511$exports = $a01f45a78bb58511$var$throttle;


var $fbf97b3464744f2c$exports = {};
var $1824c7bdcbb36ef8$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $1824c7bdcbb36ef8$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$a69fe579d8ce5bee$exports(collection)) {
            var iteratee = $e55fc84590a72f7a$exports(predicate, 3);
            collection = $3dc1c18e15bcdad3$exports(collection);
            predicate = function predicate(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$1824c7bdcbb36ef8$exports = $1824c7bdcbb36ef8$var$createFind;


var $da9cc64af13759e1$exports = {};


var $40f68e0440c130cc$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $40f68e0440c130cc$var$toInteger(value) {
    var result = $aaf730a68ab7df12$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$40f68e0440c130cc$exports = $40f68e0440c130cc$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $da9cc64af13759e1$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $da9cc64af13759e1$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $40f68e0440c130cc$exports(fromIndex);
    if (index < 0) index = $da9cc64af13759e1$var$nativeMax(length + index, 0);
    return $31733f626e69c1a2$exports(array, $e55fc84590a72f7a$exports(predicate, 3), index);
}
$da9cc64af13759e1$exports = $da9cc64af13759e1$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $fbf97b3464744f2c$var$find = $1824c7bdcbb36ef8$exports($da9cc64af13759e1$exports);
$fbf97b3464744f2c$exports = $fbf97b3464744f2c$var$find;


var $c1a364db45d21380$exports = {};
var $2635a978ce8234eb$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $2635a978ce8234eb$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$2635a978ce8234eb$exports = $2635a978ce8234eb$var$arrayEvery;


var $786cfa63e215feba$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $786cfa63e215feba$var$baseEvery(collection, predicate) {
    var result = true;
    $69aeb3380d6cbc9d$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$786cfa63e215feba$exports = $786cfa63e215feba$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $c1a364db45d21380$var$every(collection, predicate, guard) {
    var func = $09ea814803501f1d$exports(collection) ? $2635a978ce8234eb$exports : $786cfa63e215feba$exports;
    if (guard && $a4ed4c5e9ebf8672$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $e55fc84590a72f7a$exports(predicate, 3));
}
$c1a364db45d21380$exports = $c1a364db45d21380$var$every;



var $986f3a016cffd215$var$isProduction = true;
var $986f3a016cffd215$var$prefix = "Invariant failed";
function $986f3a016cffd215$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($986f3a016cffd215$var$isProduction) throw new Error($986f3a016cffd215$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($986f3a016cffd215$var$prefix, ": ").concat(provided) : $986f3a016cffd215$var$prefix;
    throw new Error(value);
}






var $4e1f077889aeb787$exports = {};
var $7c51d8bbc5eb11fb$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7c51d8bbc5eb11fb$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $6c27db4d2965d33f$exports) $6c27db4d2965d33f$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$7c51d8bbc5eb11fb$exports = $7c51d8bbc5eb11fb$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $4e1f077889aeb787$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $e55fc84590a72f7a$exports(iteratee, 3);
    $960b1d8c3b840d7c$exports(object, function(value, key, object) {
        $7c51d8bbc5eb11fb$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$4e1f077889aeb787$exports = $4e1f077889aeb787$var$mapValues;







var $17VE6 = parcelRequire("17VE6");






/**
 * @fileOverview Cross
 */ var $71e230cd1bdbe2b0$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$71e230cd1bdbe2b0$export$f6f0c3fe4ec306ea.displayName = "Cell";









var $17VE6 = parcelRequire("17VE6");

var $17VE6 = parcelRequire("17VE6");

var $ea9511701acb6d78$exports = {};

var $6da28088938266fc$exports = {};

/** Built-in value references. */ var $6da28088938266fc$var$getPrototype = $c78791449524217e$exports(Object.getPrototypeOf, Object);
$6da28088938266fc$exports = $6da28088938266fc$var$getPrototype;



/** `Object#toString` result references. */ var $ea9511701acb6d78$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $ea9511701acb6d78$var$funcProto = Function.prototype, $ea9511701acb6d78$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ea9511701acb6d78$var$funcToString = $ea9511701acb6d78$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ea9511701acb6d78$var$hasOwnProperty = $ea9511701acb6d78$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $ea9511701acb6d78$var$objectCtorString = $ea9511701acb6d78$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $ea9511701acb6d78$var$isPlainObject(value) {
    if (!$a32d462304244b19$exports(value) || $9e270036c231d6af$exports(value) != $ea9511701acb6d78$var$objectTag) return false;
    var proto = $6da28088938266fc$exports(value);
    if (proto === null) return true;
    var Ctor = $ea9511701acb6d78$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $ea9511701acb6d78$var$funcToString.call(Ctor) == $ea9511701acb6d78$var$objectCtorString;
}
$ea9511701acb6d78$exports = $ea9511701acb6d78$var$isPlainObject;


var $a39f93d46856a85c$exports = {};


/** `Object#toString` result references. */ var $a39f93d46856a85c$var$boolTag = "[object Boolean]";
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $a39f93d46856a85c$var$isBoolean(value) {
    return value === true || value === false || $a32d462304244b19$exports(value) && $9e270036c231d6af$exports(value) == $a39f93d46856a85c$var$boolTag;
}
$a39f93d46856a85c$exports = $a39f93d46856a85c$var$isBoolean;




var $17VE6 = parcelRequire("17VE6");



function $4b79e7e1164e764d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4b79e7e1164e764d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4b79e7e1164e764d$var$_typeof(o);
}
function $4b79e7e1164e764d$var$_extends() {
    $4b79e7e1164e764d$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4b79e7e1164e764d$var$_extends.apply(this, arguments);
}
function $4b79e7e1164e764d$var$_slicedToArray(arr, i) {
    return $4b79e7e1164e764d$var$_arrayWithHoles(arr) || $4b79e7e1164e764d$var$_iterableToArrayLimit(arr, i) || $4b79e7e1164e764d$var$_unsupportedIterableToArray(arr, i) || $4b79e7e1164e764d$var$_nonIterableRest();
}
function $4b79e7e1164e764d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4b79e7e1164e764d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4b79e7e1164e764d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4b79e7e1164e764d$var$_arrayLikeToArray(o, minLen);
}
function $4b79e7e1164e764d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4b79e7e1164e764d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $4b79e7e1164e764d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $4b79e7e1164e764d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4b79e7e1164e764d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4b79e7e1164e764d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4b79e7e1164e764d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4b79e7e1164e764d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4b79e7e1164e764d$var$_defineProperty(obj, key, value) {
    key = $4b79e7e1164e764d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4b79e7e1164e764d$var$_toPropertyKey(arg) {
    var key = $4b79e7e1164e764d$var$_toPrimitive(arg, "string");
    return $4b79e7e1164e764d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4b79e7e1164e764d$var$_toPrimitive(input, hint) {
    if ($4b79e7e1164e764d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4b79e7e1164e764d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $4b79e7e1164e764d$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += "Z";
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $4b79e7e1164e764d$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $4b79e7e1164e764d$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};
var $4b79e7e1164e764d$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $4b79e7e1164e764d$var$_objectSpread($4b79e7e1164e764d$var$_objectSpread({}, $4b79e7e1164e764d$var$defaultProps), rectangleProps);
    var pathRef = (0, $17VE6.useRef)();
    var _useState = (0, $17VE6.useState)(-1), _useState2 = $4b79e7e1164e764d$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $17VE6.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-rectangle", className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("path", $4b79e7e1164e764d$var$_extends({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $4b79e7e1164e764d$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $19c5e74eae47b177$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $19c5e74eae47b177$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("path", $4b79e7e1164e764d$var$_extends({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $4b79e7e1164e764d$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};



var $17VE6 = parcelRequire("17VE6");



function $21d8da37f7c35b77$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $21d8da37f7c35b77$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $21d8da37f7c35b77$var$_typeof(o);
}
function $21d8da37f7c35b77$var$_extends() {
    $21d8da37f7c35b77$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $21d8da37f7c35b77$var$_extends.apply(this, arguments);
}
function $21d8da37f7c35b77$var$_slicedToArray(arr, i) {
    return $21d8da37f7c35b77$var$_arrayWithHoles(arr) || $21d8da37f7c35b77$var$_iterableToArrayLimit(arr, i) || $21d8da37f7c35b77$var$_unsupportedIterableToArray(arr, i) || $21d8da37f7c35b77$var$_nonIterableRest();
}
function $21d8da37f7c35b77$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $21d8da37f7c35b77$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $21d8da37f7c35b77$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $21d8da37f7c35b77$var$_arrayLikeToArray(o, minLen);
}
function $21d8da37f7c35b77$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $21d8da37f7c35b77$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $21d8da37f7c35b77$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $21d8da37f7c35b77$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $21d8da37f7c35b77$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $21d8da37f7c35b77$var$ownKeys(Object(t), !0).forEach(function(r) {
            $21d8da37f7c35b77$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $21d8da37f7c35b77$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $21d8da37f7c35b77$var$_defineProperty(obj, key, value) {
    key = $21d8da37f7c35b77$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21d8da37f7c35b77$var$_toPropertyKey(arg) {
    var key = $21d8da37f7c35b77$var$_toPrimitive(arg, "string");
    return $21d8da37f7c35b77$var$_typeof(key) === "symbol" ? key : String(key);
}
function $21d8da37f7c35b77$var$_toPrimitive(input, hint) {
    if ($21d8da37f7c35b77$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($21d8da37f7c35b77$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $21d8da37f7c35b77$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $21d8da37f7c35b77$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};
var $21d8da37f7c35b77$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $21d8da37f7c35b77$var$_objectSpread($21d8da37f7c35b77$var$_objectSpread({}, $21d8da37f7c35b77$var$defaultProps), props);
    var pathRef = (0, $17VE6.useRef)();
    var _useState = (0, $17VE6.useState)(-1), _useState2 = $21d8da37f7c35b77$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $17VE6.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-trapezoid", className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("path", $21d8da37f7c35b77$var$_extends({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(trapezoidProps, true), {
        className: layerClass,
        d: $21d8da37f7c35b77$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $19c5e74eae47b177$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $19c5e74eae47b177$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("path", $21d8da37f7c35b77$var$_extends({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(trapezoidProps, true), {
            className: layerClass,
            d: $21d8da37f7c35b77$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};



var $17VE6 = parcelRequire("17VE6");




function $c8d5fc89b7f29d4a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c8d5fc89b7f29d4a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c8d5fc89b7f29d4a$var$_typeof(o);
}
function $c8d5fc89b7f29d4a$var$_extends() {
    $c8d5fc89b7f29d4a$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c8d5fc89b7f29d4a$var$_extends.apply(this, arguments);
}
function $c8d5fc89b7f29d4a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c8d5fc89b7f29d4a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c8d5fc89b7f29d4a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c8d5fc89b7f29d4a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c8d5fc89b7f29d4a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c8d5fc89b7f29d4a$var$_defineProperty(obj, key, value) {
    key = $c8d5fc89b7f29d4a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c8d5fc89b7f29d4a$var$_toPropertyKey(arg) {
    var key = $c8d5fc89b7f29d4a$var$_toPrimitive(arg, "string");
    return $c8d5fc89b7f29d4a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c8d5fc89b7f29d4a$var$_toPrimitive(input, hint) {
    if ($c8d5fc89b7f29d4a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c8d5fc89b7f29d4a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $c8d5fc89b7f29d4a$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $411b8d52505ff75c$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $c8d5fc89b7f29d4a$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $f004b8ab2664ad8d$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $f004b8ab2664ad8d$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $c8d5fc89b7f29d4a$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $c8d5fc89b7f29d4a$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $c8d5fc89b7f29d4a$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $411b8d52505ff75c$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $c8d5fc89b7f29d4a$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $c8d5fc89b7f29d4a$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $c8d5fc89b7f29d4a$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $c8d5fc89b7f29d4a$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $c8d5fc89b7f29d4a$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $c8d5fc89b7f29d4a$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $c8d5fc89b7f29d4a$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $c8d5fc89b7f29d4a$var$_objectSpread($c8d5fc89b7f29d4a$var$_objectSpread({}, $c8d5fc89b7f29d4a$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-sector", className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $411b8d52505ff75c$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $c8d5fc89b7f29d4a$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $c8d5fc89b7f29d4a$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("path", $c8d5fc89b7f29d4a$var$_extends({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};




var $e76ae290db1e26a6$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $e76ae290db1e26a6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e76ae290db1e26a6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e76ae290db1e26a6$var$_typeof(o);
}
function $e76ae290db1e26a6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e76ae290db1e26a6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e76ae290db1e26a6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e76ae290db1e26a6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e76ae290db1e26a6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e76ae290db1e26a6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e76ae290db1e26a6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e76ae290db1e26a6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e76ae290db1e26a6$var$_defineProperty(obj, key, value) {
    key = $e76ae290db1e26a6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e76ae290db1e26a6$var$_toPropertyKey(arg) {
    var key = $e76ae290db1e26a6$var$_toPrimitive(arg, "string");
    return $e76ae290db1e26a6$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e76ae290db1e26a6$var$_toPrimitive(input, hint) {
    if ($e76ae290db1e26a6$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e76ae290db1e26a6$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $e76ae290db1e26a6$var$defaultPropTransformer(option, props) {
    return $e76ae290db1e26a6$var$_objectSpread($e76ae290db1e26a6$var$_objectSpread({}, props), option);
}
function $e76ae290db1e26a6$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === "symbols";
}
function $e76ae290db1e26a6$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case "rectangle":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $4b79e7e1164e764d$export$4617fb02663045ef), elementProps);
        case "trapezoid":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $21d8da37f7c35b77$export$d1ed33dc592f5337), elementProps);
        case "sector":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $c8d5fc89b7f29d4a$export$e98c2c7eb2b14f45), elementProps);
        case "symbols":
            if ($e76ae290db1e26a6$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $e1e6d14e40931cd1$export$fa456266707bf4e4), elementProps);
            break;
        default:
            return null;
    }
}
function $e76ae290db1e26a6$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $17VE6.isValidElement)(option)) return option.props;
    return option;
}
function $e76ae290db1e26a6$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $e76ae290db1e26a6$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? "recharts-active-shape" : _ref2$activeClassName, isActive = _ref2.isActive, props = $e76ae290db1e26a6$var$_objectWithoutProperties(_ref2, $e76ae290db1e26a6$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $17VE6.isValidElement)(option)) shape = /*#__PURE__*/ (0, $17VE6.cloneElement)(option, $e76ae290db1e26a6$var$_objectSpread($e76ae290db1e26a6$var$_objectSpread({}, props), $e76ae290db1e26a6$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($ea9511701acb6d78$exports)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($a39f93d46856a85c$exports)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement($e76ae290db1e26a6$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement($e76ae290db1e26a6$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}
function $e76ae290db1e26a6$export$4b83e8415af38a18(graphicalItem, _item) {
    return _item != null && "trapezoids" in graphicalItem.props;
}
function $e76ae290db1e26a6$export$f722d7e63cc07b(graphicalItem, _item) {
    return _item != null && "sectors" in graphicalItem.props;
}
function $e76ae290db1e26a6$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return _item != null && "points" in graphicalItem.props;
}
function $e76ae290db1e26a6$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $e76ae290db1e26a6$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $e76ae290db1e26a6$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $e76ae290db1e26a6$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($e76ae290db1e26a6$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $e76ae290db1e26a6$export$7c9a98b3f068686f;
    else if ($e76ae290db1e26a6$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $e76ae290db1e26a6$export$b356b51e8337a02f;
    else if ($e76ae290db1e26a6$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $e76ae290db1e26a6$export$559c3a78b4889350;
    return comparison;
}
function $e76ae290db1e26a6$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($e76ae290db1e26a6$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = "trapezoids";
    else if ($e76ae290db1e26a6$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = "sectors";
    else if ($e76ae290db1e26a6$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = "points";
    return shapeKey;
}
function $e76ae290db1e26a6$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($e76ae290db1e26a6$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($e76ae290db1e26a6$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($e76ae290db1e26a6$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $e76ae290db1e26a6$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $e76ae290db1e26a6$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $e76ae290db1e26a6$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($c65581b1798022be$exports)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $e76ae290db1e26a6$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}


function $8a60ae8a601f16cc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8a60ae8a601f16cc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8a60ae8a601f16cc$var$_typeof(o);
}
var $8a60ae8a601f16cc$var$_excluded = [
    "x",
    "y"
];
function $8a60ae8a601f16cc$var$_extends() {
    $8a60ae8a601f16cc$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8a60ae8a601f16cc$var$_extends.apply(this, arguments);
}
function $8a60ae8a601f16cc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a60ae8a601f16cc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a60ae8a601f16cc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8a60ae8a601f16cc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a60ae8a601f16cc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8a60ae8a601f16cc$var$_defineProperty(obj, key, value) {
    key = $8a60ae8a601f16cc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8a60ae8a601f16cc$var$_toPropertyKey(arg) {
    var key = $8a60ae8a601f16cc$var$_toPrimitive(arg, "string");
    return $8a60ae8a601f16cc$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8a60ae8a601f16cc$var$_toPrimitive(input, hint) {
    if ($8a60ae8a601f16cc$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8a60ae8a601f16cc$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8a60ae8a601f16cc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8a60ae8a601f16cc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8a60ae8a601f16cc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, numbe, number, number]
function $8a60ae8a601f16cc$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $8a60ae8a601f16cc$var$_objectWithoutProperties(_ref, $8a60ae8a601f16cc$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $8a60ae8a601f16cc$var$_objectSpread($8a60ae8a601f16cc$var$_objectSpread($8a60ae8a601f16cc$var$_objectSpread($8a60ae8a601f16cc$var$_objectSpread($8a60ae8a601f16cc$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $8a60ae8a601f16cc$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $e76ae290db1e26a6$export$6428a7f2611ef1fa), $8a60ae8a601f16cc$var$_extends({
        shapeType: "rectangle",
        propTransformer: $8a60ae8a601f16cc$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}


var $bae038dbd8688307$var$_excluded = [
    "value",
    "background"
];
function $bae038dbd8688307$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bae038dbd8688307$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bae038dbd8688307$var$_typeof(o);
}
function $bae038dbd8688307$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bae038dbd8688307$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bae038dbd8688307$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bae038dbd8688307$var$_extends() {
    $bae038dbd8688307$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bae038dbd8688307$var$_extends.apply(this, arguments);
}
function $bae038dbd8688307$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bae038dbd8688307$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bae038dbd8688307$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bae038dbd8688307$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bae038dbd8688307$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bae038dbd8688307$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bae038dbd8688307$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $bae038dbd8688307$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $bae038dbd8688307$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bae038dbd8688307$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bae038dbd8688307$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bae038dbd8688307$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $bae038dbd8688307$var$_setPrototypeOf(subClass, superClass);
}
function $bae038dbd8688307$var$_setPrototypeOf(o, p) {
    $bae038dbd8688307$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bae038dbd8688307$var$_setPrototypeOf(o, p);
}
function $bae038dbd8688307$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bae038dbd8688307$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $bae038dbd8688307$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bae038dbd8688307$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bae038dbd8688307$var$_possibleConstructorReturn(this, result);
    };
}
function $bae038dbd8688307$var$_possibleConstructorReturn(self, call) {
    if (call && ($bae038dbd8688307$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $bae038dbd8688307$var$_assertThisInitialized(self);
}
function $bae038dbd8688307$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bae038dbd8688307$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bae038dbd8688307$var$_getPrototypeOf(o) {
    $bae038dbd8688307$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bae038dbd8688307$var$_getPrototypeOf(o);
}
function $bae038dbd8688307$var$_defineProperty(obj, key, value) {
    key = $bae038dbd8688307$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bae038dbd8688307$var$_toPropertyKey(arg) {
    var key = $bae038dbd8688307$var$_toPrimitive(arg, "string");
    return $bae038dbd8688307$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bae038dbd8688307$var$_toPrimitive(input, hint) {
    if ($bae038dbd8688307$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bae038dbd8688307$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $bae038dbd8688307$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    $bae038dbd8688307$var$_inherits(Bar, _PureComponent);
    var _super = $bae038dbd8688307$var$_createSuper(Bar);
    function Bar() {
        var _this;
        $bae038dbd8688307$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $bae038dbd8688307$var$_defineProperty($bae038dbd8688307$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $bae038dbd8688307$var$_defineProperty($bae038dbd8688307$var$_assertThisInitialized(_this), "id", (0, $411b8d52505ff75c$export$8b15d37bc3f197d4)("recharts-bar-"));
        $bae038dbd8688307$var$_defineProperty($bae038dbd8688307$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $bae038dbd8688307$var$_defineProperty($bae038dbd8688307$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $bae038dbd8688307$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(this.props);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $bae038dbd8688307$var$_objectSpread($bae038dbd8688307$var$_objectSpread($bae038dbd8688307$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), $bae038dbd8688307$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $afad468d030baba8$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $8a60ae8a601f16cc$export$f19074a6842f9217), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $19c5e74eae47b177$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $411b8d52505ff75c$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $411b8d52505ff75c$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $411b8d52505ff75c$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $411b8d52505ff75c$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $bae038dbd8688307$var$_objectSpread($bae038dbd8688307$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === "horizontal") {
                            var _interpolatorHeight = (0, $411b8d52505ff75c$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $bae038dbd8688307$var$_objectSpread($bae038dbd8688307$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $411b8d52505ff75c$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $bae038dbd8688307$var$_objectSpread($bae038dbd8688307$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($c65581b1798022be$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(this.props.background);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $bae038dbd8688307$var$_objectWithoutProperties(entry, $bae038dbd8688307$var$_excluded);
                    if (!background) return null;
                    var props = $bae038dbd8688307$var$_objectSpread($bae038dbd8688307$var$_objectSpread($bae038dbd8688307$var$_objectSpread($bae038dbd8688307$var$_objectSpread($bae038dbd8688307$var$_objectSpread({}, rest), {}, {
                        fill: "#eee"
                    }, background), backgroundProps), (0, $afad468d030baba8$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        key: "background-bar-".concat(i),
                        className: "recharts-bar-background-rectangle"
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $8a60ae8a601f16cc$export$f19074a6842f9217), $bae038dbd8688307$var$_extends({
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $bb4a0676cae5de7b$export$fdd5e64c0e8495bb)(children, (0, $94870e2ce3bf43ff$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === "vertical" ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $5ef2e400865c36d4$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-bar", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $ba005ed395c74bd1$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
    return Bar;
}((0, $17VE6.PureComponent));
$bae038dbd8688307$var$_defineProperty($bae038dbd8688307$export$bbc6c6369b38e3d1, "displayName", "Bar");
$bae038dbd8688307$var$_defineProperty($bae038dbd8688307$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: "rect",
    minPointSize: 0,
    hide: false,
    data: [],
    layout: "vertical",
    activeBar: true,
    isAnimationActive: !(0, $e72696708fbb4da9$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: "ease"
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $bae038dbd8688307$var$_defineProperty($bae038dbd8688307$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $5ef2e400865c36d4$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var _item$props = item.props, dataKey = _item$props.dataKey, children = _item$props.children, minPointSize = _item$props.minPointSize;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $5ef2e400865c36d4$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $bb4a0676cae5de7b$export$fdd5e64c0e8495bb)(children, (0, $71e230cd1bdbe2b0$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $5ef2e400865c36d4$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $5ef2e400865c36d4$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        if (layout === "horizontal") {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $5ef2e400865c36d4$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $411b8d52505ff75c$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $5ef2e400865c36d4$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $411b8d52505ff75c$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $bae038dbd8688307$var$_objectSpread($bae038dbd8688307$var$_objectSpread($bae038dbd8688307$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $5ef2e400865c36d4$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $bae038dbd8688307$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});


function $99f80a34797eff25$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $99f80a34797eff25$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $99f80a34797eff25$var$_typeof(o);
}
function $99f80a34797eff25$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $99f80a34797eff25$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $99f80a34797eff25$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $99f80a34797eff25$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $99f80a34797eff25$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $99f80a34797eff25$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $99f80a34797eff25$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $99f80a34797eff25$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $99f80a34797eff25$var$ownKeys(Object(t), !0).forEach(function(r) {
            $99f80a34797eff25$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $99f80a34797eff25$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $99f80a34797eff25$var$_defineProperty(obj, key, value) {
    key = $99f80a34797eff25$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $99f80a34797eff25$var$_toPropertyKey(arg) {
    var key = $99f80a34797eff25$var$_toPrimitive(arg, "string");
    return $99f80a34797eff25$var$_typeof(key) === "symbol" ? key : String(key);
}
function $99f80a34797eff25$var$_toPrimitive(input, hint) {
    if ($99f80a34797eff25$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($99f80a34797eff25$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $99f80a34797eff25$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $bb4a0676cae5de7b$export$64c61536a2b72e0f)(children, (0, $bae038dbd8688307$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? "Mirror" : "");
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === "number" && (axis.padding === "gap" || axis.padding === "no-gap")) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
            var rangeWidth = axis.layout === "vertical" ? offset.height : offset.width;
            if (axis.padding === "gap") calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
            if (axis.padding === "no-gap") {
                var gap = (0, $411b8d52505ff75c$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
            }
        }
        if (axisType === "xAxis") range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === "yAxis") range = layout === "horizontal" ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $5ef2e400865c36d4$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $5ef2e400865c36d4$export$9d80152e23bae434)(scale);
        var ticks = (0, $5ef2e400865c36d4$export$ac086aaa4358d590)(scale, $99f80a34797eff25$var$_objectSpread($99f80a34797eff25$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === "xAxis") {
            needSpace = orientation === "top" && !mirror || orientation === "bottom" && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === "yAxis") {
            needSpace = orientation === "left" && !mirror || orientation === "right" && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $99f80a34797eff25$var$_objectSpread($99f80a34797eff25$var$_objectSpread($99f80a34797eff25$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === "xAxis" ? offset.width : axis.width,
            height: axisType === "yAxis" ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $5ef2e400865c36d4$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === "xAxis") steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $99f80a34797eff25$var$_objectSpread($99f80a34797eff25$var$_objectSpread({}, result), {}, $99f80a34797eff25$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $99f80a34797eff25$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $99f80a34797eff25$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $99f80a34797eff25$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $99f80a34797eff25$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $99f80a34797eff25$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    $99f80a34797eff25$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case "start":
                        return this.scale(value);
                    case "middle":
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case "end":
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
    return ScaleHelper;
}();
$99f80a34797eff25$var$_defineProperty($99f80a34797eff25$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $99f80a34797eff25$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $99f80a34797eff25$var$_objectSpread($99f80a34797eff25$var$_objectSpread({}, res), {}, $99f80a34797eff25$var$_defineProperty({}, key, $99f80a34797eff25$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $99f80a34797eff25$var$_objectSpread($99f80a34797eff25$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($4e1f077889aeb787$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($c1a364db45d21380$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $99f80a34797eff25$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $99f80a34797eff25$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $99f80a34797eff25$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};


/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $8f97286ea50e88e9$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}


function $3f4863a80bf1acbb$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $99f80a34797eff25$export$3ee78d51cffc2b68)(size, angle);
}
function $3f4863a80bf1acbb$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === "width";
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $3f4863a80bf1acbb$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $3f4863a80bf1acbb$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $8f97286ea50e88e9$export$41514b9f058a6886)(ticks, interval + 1);
}




function $8b55134afb7791bd$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $8f97286ea50e88e9$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $3f4863a80bf1acbb$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $f9f1500193d895c1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f9f1500193d895c1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f9f1500193d895c1$var$_typeof(o);
}
function $f9f1500193d895c1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f9f1500193d895c1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f9f1500193d895c1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f9f1500193d895c1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f9f1500193d895c1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f9f1500193d895c1$var$_defineProperty(obj, key, value) {
    key = $f9f1500193d895c1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f9f1500193d895c1$var$_toPropertyKey(arg) {
    var key = $f9f1500193d895c1$var$_toPrimitive(arg, "string");
    return $f9f1500193d895c1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f9f1500193d895c1$var$_toPrimitive(input, hint) {
    if ($f9f1500193d895c1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f9f1500193d895c1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f9f1500193d895c1$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $f9f1500193d895c1$var$_objectSpread($f9f1500193d895c1$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $f9f1500193d895c1$var$_objectSpread($f9f1500193d895c1$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $3f4863a80bf1acbb$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $f9f1500193d895c1$var$_objectSpread($f9f1500193d895c1$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $f9f1500193d895c1$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $f9f1500193d895c1$var$_objectSpread($f9f1500193d895c1$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $3f4863a80bf1acbb$export$795910f5f15a9633)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $f9f1500193d895c1$var$_objectSpread($f9f1500193d895c1$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $f9f1500193d895c1$var$_objectSpread($f9f1500193d895c1$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $f9f1500193d895c1$var$_objectSpread($f9f1500193d895c1$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $3f4863a80bf1acbb$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $f9f1500193d895c1$var$_objectSpread($f9f1500193d895c1$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $f9f1500193d895c1$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(interval) || (0, $e72696708fbb4da9$export$98f03c5d19621d70).isSsr) return (0, $3f4863a80bf1acbb$export$beeebbe3ff1b306b)(ticks, typeof interval === "number" && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height";
    var unitSize = unit && sizeKey === "width" ? (0, $4e3fcb7d26d9032b$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === "width" ? (0, $3f4863a80bf1acbb$export$a1966f4ad955c82b)((0, $4e3fcb7d26d9032b$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $4e3fcb7d26d9032b$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $411b8d52505ff75c$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $3f4863a80bf1acbb$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === "equidistantPreserveStart") return (0, $8b55134afb7791bd$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === "preserveStart" || interval === "preserveStartEnd") candidates = $f9f1500193d895c1$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === "preserveStartEnd");
    else candidates = $f9f1500193d895c1$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}





var $17VE6 = parcelRequire("17VE6");

var $17VE6 = parcelRequire("17VE6");




function $e68a2f509ed67a6c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e68a2f509ed67a6c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e68a2f509ed67a6c$var$_typeof(o);
}
function $e68a2f509ed67a6c$var$_slicedToArray(arr, i) {
    return $e68a2f509ed67a6c$var$_arrayWithHoles(arr) || $e68a2f509ed67a6c$var$_iterableToArrayLimit(arr, i) || $e68a2f509ed67a6c$var$_unsupportedIterableToArray(arr, i) || $e68a2f509ed67a6c$var$_nonIterableRest();
}
function $e68a2f509ed67a6c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e68a2f509ed67a6c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e68a2f509ed67a6c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e68a2f509ed67a6c$var$_arrayLikeToArray(o, minLen);
}
function $e68a2f509ed67a6c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e68a2f509ed67a6c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e68a2f509ed67a6c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e68a2f509ed67a6c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e68a2f509ed67a6c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e68a2f509ed67a6c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e68a2f509ed67a6c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e68a2f509ed67a6c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e68a2f509ed67a6c$var$_defineProperty(obj, key, value) {
    key = $e68a2f509ed67a6c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e68a2f509ed67a6c$var$_toPropertyKey(arg) {
    var key = $e68a2f509ed67a6c$var$_toPrimitive(arg, "string");
    return $e68a2f509ed67a6c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e68a2f509ed67a6c$var$_toPrimitive(input, hint) {
    if ($e68a2f509ed67a6c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e68a2f509ed67a6c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e68a2f509ed67a6c$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $411b8d52505ff75c$export$402a499e1ea44294)(value[0]) && (0, $411b8d52505ff75c$export$402a499e1ea44294)(value[1]) ? value.join(" ~ ") : value;
}
var $e68a2f509ed67a6c$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? " : " : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($2d5f4b2fac16794e$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === "none") return null;
                var finalItemStyle = $e68a2f509ed67a6c$var$_objectSpread({
                    display: "block",
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || "#000"
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $e68a2f509ed67a6c$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $e68a2f509ed67a6c$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $411b8d52505ff75c$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $411b8d52505ff75c$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || "")));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $e68a2f509ed67a6c$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        whiteSpace: "nowrap"
    }, contentStyle);
    var finalLabelStyle = $e68a2f509ed67a6c$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(label);
    var finalLabel = hasLabel ? label : "";
    var wrapperCN = (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-default-tooltip", wrapperClassName);
    var labelCN = (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-tooltip-label", labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("div", {
        className: wrapperCN,
        style: finalStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $17VE6 = parcelRequire("17VE6");




function $c1595577bcb2024a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c1595577bcb2024a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c1595577bcb2024a$var$_typeof(o);
}
function $c1595577bcb2024a$var$_defineProperty(obj, key, value) {
    key = $c1595577bcb2024a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c1595577bcb2024a$var$_toPropertyKey(arg) {
    var key = $c1595577bcb2024a$var$_toPrimitive(arg, "string");
    return $c1595577bcb2024a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c1595577bcb2024a$var$_toPrimitive(input, hint) {
    if ($c1595577bcb2024a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c1595577bcb2024a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $c1595577bcb2024a$var$CSS_CLASS_PREFIX = "recharts-tooltip-wrapper";
var $c1595577bcb2024a$var$TOOLTIP_HIDDEN = {
    visibility: "hidden"
};
function $c1595577bcb2024a$export$46aee7ef09f78756(_ref) {
    var _clsx;
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)($c1595577bcb2024a$var$CSS_CLASS_PREFIX, (_clsx = {}, $c1595577bcb2024a$var$_defineProperty(_clsx, "".concat($c1595577bcb2024a$var$CSS_CLASS_PREFIX, "-right"), (0, $411b8d52505ff75c$export$7e4aa119212bc614)(translateX) && coordinate && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), $c1595577bcb2024a$var$_defineProperty(_clsx, "".concat($c1595577bcb2024a$var$CSS_CLASS_PREFIX, "-left"), (0, $411b8d52505ff75c$export$7e4aa119212bc614)(translateX) && coordinate && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), $c1595577bcb2024a$var$_defineProperty(_clsx, "".concat($c1595577bcb2024a$var$CSS_CLASS_PREFIX, "-bottom"), (0, $411b8d52505ff75c$export$7e4aa119212bc614)(translateY) && coordinate && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), $c1595577bcb2024a$var$_defineProperty(_clsx, "".concat($c1595577bcb2024a$var$CSS_CLASS_PREFIX, "-top"), (0, $411b8d52505ff75c$export$7e4aa119212bc614)(translateY) && coordinate && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y), _clsx));
}
function $c1595577bcb2024a$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $c1595577bcb2024a$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return (0, $f9553aca757d2dbc$export$ff9926a5d1daa67c)({
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    });
}
function $c1595577bcb2024a$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $c1595577bcb2024a$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: "x",
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $c1595577bcb2024a$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: "y",
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $c1595577bcb2024a$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $c1595577bcb2024a$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $c1595577bcb2024a$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $2b27ce750a76dd49$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2b27ce750a76dd49$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2b27ce750a76dd49$var$_typeof(o);
}
function $2b27ce750a76dd49$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2b27ce750a76dd49$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2b27ce750a76dd49$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2b27ce750a76dd49$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2b27ce750a76dd49$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2b27ce750a76dd49$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2b27ce750a76dd49$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2b27ce750a76dd49$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2b27ce750a76dd49$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2b27ce750a76dd49$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2b27ce750a76dd49$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2b27ce750a76dd49$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2b27ce750a76dd49$var$_setPrototypeOf(subClass, superClass);
}
function $2b27ce750a76dd49$var$_setPrototypeOf(o, p) {
    $2b27ce750a76dd49$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2b27ce750a76dd49$var$_setPrototypeOf(o, p);
}
function $2b27ce750a76dd49$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2b27ce750a76dd49$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $2b27ce750a76dd49$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $2b27ce750a76dd49$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2b27ce750a76dd49$var$_possibleConstructorReturn(this, result);
    };
}
function $2b27ce750a76dd49$var$_possibleConstructorReturn(self, call) {
    if (call && ($2b27ce750a76dd49$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2b27ce750a76dd49$var$_assertThisInitialized(self);
}
function $2b27ce750a76dd49$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2b27ce750a76dd49$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2b27ce750a76dd49$var$_getPrototypeOf(o) {
    $2b27ce750a76dd49$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2b27ce750a76dd49$var$_getPrototypeOf(o);
}
function $2b27ce750a76dd49$var$_defineProperty(obj, key, value) {
    key = $2b27ce750a76dd49$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2b27ce750a76dd49$var$_toPropertyKey(arg) {
    var key = $2b27ce750a76dd49$var$_toPrimitive(arg, "string");
    return $2b27ce750a76dd49$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2b27ce750a76dd49$var$_toPrimitive(input, hint) {
    if ($2b27ce750a76dd49$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2b27ce750a76dd49$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2b27ce750a76dd49$var$EPSILON = 1;
var $2b27ce750a76dd49$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    $2b27ce750a76dd49$var$_inherits(TooltipBoundingBox, _PureComponent);
    var _super = $2b27ce750a76dd49$var$_createSuper(TooltipBoundingBox);
    function TooltipBoundingBox() {
        var _this;
        $2b27ce750a76dd49$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $2b27ce750a76dd49$var$_defineProperty($2b27ce750a76dd49$var$_assertThisInitialized(_this), "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            }
        });
        $2b27ce750a76dd49$var$_defineProperty($2b27ce750a76dd49$var$_assertThisInitialized(_this), "lastBoundingBox", {
            width: -1,
            height: -1
        });
        $2b27ce750a76dd49$var$_defineProperty($2b27ce750a76dd49$var$_assertThisInitialized(_this), "handleKeyDown", function(event) {
            if (event.key === "Escape") {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $2b27ce750a76dd49$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $2b27ce750a76dd49$var$EPSILON || Math.abs(box.height - this.lastBoundingBox.height) > $2b27ce750a76dd49$var$EPSILON) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener("keydown", this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("keydown", this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $c1595577bcb2024a$export$25e3b0ae21503056)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: {
                        height: this.lastBoundingBox.height,
                        width: this.lastBoundingBox.width
                    },
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $2b27ce750a76dd49$var$_objectSpread($2b27ce750a76dd49$var$_objectSpread($2b27ce750a76dd49$var$_objectSpread({}, isAnimationActive && active && (0, $f9553aca757d2dbc$export$ff9926a5d1daa67c)({
                    transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
                })), cssProperties), {}, {
                    pointerEvents: "none",
                    visibility: !this.state.dismissed && active && hasPayload ? "visible" : "hidden",
                    position: "absolute",
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("div", {
                    tabIndex: -1,
                    role: "dialog",
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
    return TooltipBoundingBox;
}((0, $17VE6.PureComponent));




function $c4a063a58f2c0c69$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c4a063a58f2c0c69$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c4a063a58f2c0c69$var$_typeof(o);
}
function $c4a063a58f2c0c69$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c4a063a58f2c0c69$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c4a063a58f2c0c69$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c4a063a58f2c0c69$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c4a063a58f2c0c69$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c4a063a58f2c0c69$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c4a063a58f2c0c69$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c4a063a58f2c0c69$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c4a063a58f2c0c69$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c4a063a58f2c0c69$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c4a063a58f2c0c69$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c4a063a58f2c0c69$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c4a063a58f2c0c69$var$_setPrototypeOf(subClass, superClass);
}
function $c4a063a58f2c0c69$var$_setPrototypeOf(o, p) {
    $c4a063a58f2c0c69$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c4a063a58f2c0c69$var$_setPrototypeOf(o, p);
}
function $c4a063a58f2c0c69$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c4a063a58f2c0c69$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c4a063a58f2c0c69$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c4a063a58f2c0c69$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c4a063a58f2c0c69$var$_possibleConstructorReturn(this, result);
    };
}
function $c4a063a58f2c0c69$var$_possibleConstructorReturn(self, call) {
    if (call && ($c4a063a58f2c0c69$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c4a063a58f2c0c69$var$_assertThisInitialized(self);
}
function $c4a063a58f2c0c69$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c4a063a58f2c0c69$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c4a063a58f2c0c69$var$_getPrototypeOf(o) {
    $c4a063a58f2c0c69$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c4a063a58f2c0c69$var$_getPrototypeOf(o);
}
function $c4a063a58f2c0c69$var$_defineProperty(obj, key, value) {
    key = $c4a063a58f2c0c69$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c4a063a58f2c0c69$var$_toPropertyKey(arg) {
    var key = $c4a063a58f2c0c69$var$_toPrimitive(arg, "string");
    return $c4a063a58f2c0c69$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c4a063a58f2c0c69$var$_toPrimitive(input, hint) {
    if ($c4a063a58f2c0c69$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c4a063a58f2c0c69$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c4a063a58f2c0c69$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $c4a063a58f2c0c69$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).cloneElement(content, props);
    if (typeof content === "function") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $e68a2f509ed67a6c$export$6fe33945eebf9ac8), props);
}
var $c4a063a58f2c0c69$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    $c4a063a58f2c0c69$var$_inherits(Tooltip, _PureComponent);
    var _super = $c4a063a58f2c0c69$var$_createSuper(Tooltip);
    function Tooltip() {
        $c4a063a58f2c0c69$var$_classCallCheck(this, Tooltip);
        return _super.apply(this, arguments);
    }
    $c4a063a58f2c0c69$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $23a02c7a4ad0b004$export$b67e33c2fb1535fa)(payload.filter(function(entry) {
                    return entry.value != null;
                }), payloadUniqBy, $c4a063a58f2c0c69$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $2b27ce750a76dd49$export$9e6cee7b86551b9c), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $c4a063a58f2c0c69$var$renderContent(content, $c4a063a58f2c0c69$var$_objectSpread($c4a063a58f2c0c69$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
    return Tooltip;
}((0, $17VE6.PureComponent));
$c4a063a58f2c0c69$var$_defineProperty($c4a063a58f2c0c69$export$28c660c63b792dea, "displayName", "Tooltip");
$c4a063a58f2c0c69$var$_defineProperty($c4a063a58f2c0c69$export$28c660c63b792dea, "defaultProps", {
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: "ease",
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $e72696708fbb4da9$export$98f03c5d19621d70).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: " : ",
    trigger: "hover",
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});







var $17VE6 = parcelRequire("17VE6");











var $4d62e5cd5a5a9c48$var$_excluded = [
    "viewBox"
], $4d62e5cd5a5a9c48$var$_excluded2 = [
    "viewBox"
], $4d62e5cd5a5a9c48$var$_excluded3 = [
    "ticks"
];
function $4d62e5cd5a5a9c48$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4d62e5cd5a5a9c48$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4d62e5cd5a5a9c48$var$_typeof(o);
}
function $4d62e5cd5a5a9c48$var$_extends() {
    $4d62e5cd5a5a9c48$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4d62e5cd5a5a9c48$var$_extends.apply(this, arguments);
}
function $4d62e5cd5a5a9c48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4d62e5cd5a5a9c48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4d62e5cd5a5a9c48$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4d62e5cd5a5a9c48$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4d62e5cd5a5a9c48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4d62e5cd5a5a9c48$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4d62e5cd5a5a9c48$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4d62e5cd5a5a9c48$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4d62e5cd5a5a9c48$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4d62e5cd5a5a9c48$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4d62e5cd5a5a9c48$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4d62e5cd5a5a9c48$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4d62e5cd5a5a9c48$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4d62e5cd5a5a9c48$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4d62e5cd5a5a9c48$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $4d62e5cd5a5a9c48$var$_setPrototypeOf(subClass, superClass);
}
function $4d62e5cd5a5a9c48$var$_setPrototypeOf(o, p) {
    $4d62e5cd5a5a9c48$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4d62e5cd5a5a9c48$var$_setPrototypeOf(o, p);
}
function $4d62e5cd5a5a9c48$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4d62e5cd5a5a9c48$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $4d62e5cd5a5a9c48$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $4d62e5cd5a5a9c48$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4d62e5cd5a5a9c48$var$_possibleConstructorReturn(this, result);
    };
}
function $4d62e5cd5a5a9c48$var$_possibleConstructorReturn(self, call) {
    if (call && ($4d62e5cd5a5a9c48$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4d62e5cd5a5a9c48$var$_assertThisInitialized(self);
}
function $4d62e5cd5a5a9c48$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4d62e5cd5a5a9c48$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4d62e5cd5a5a9c48$var$_getPrototypeOf(o) {
    $4d62e5cd5a5a9c48$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4d62e5cd5a5a9c48$var$_getPrototypeOf(o);
}
function $4d62e5cd5a5a9c48$var$_defineProperty(obj, key, value) {
    key = $4d62e5cd5a5a9c48$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4d62e5cd5a5a9c48$var$_toPropertyKey(arg) {
    var key = $4d62e5cd5a5a9c48$var$_toPrimitive(arg, "string");
    return $4d62e5cd5a5a9c48$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4d62e5cd5a5a9c48$var$_toPrimitive(input, hint) {
    if ($4d62e5cd5a5a9c48$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4d62e5cd5a5a9c48$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $4d62e5cd5a5a9c48$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    $4d62e5cd5a5a9c48$var$_inherits(CartesianAxis, _Component);
    var _super = $4d62e5cd5a5a9c48$var$_createSuper(CartesianAxis);
    function CartesianAxis(props) {
        var _this;
        $4d62e5cd5a5a9c48$var$_classCallCheck(this, CartesianAxis);
        _this = _super.call(this, props);
        _this.state = {
            fontSize: "",
            letterSpacing: ""
        };
        return _this;
    }
    $4d62e5cd5a5a9c48$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $4d62e5cd5a5a9c48$var$_objectWithoutProperties(_ref, $4d62e5cd5a5a9c48$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $4d62e5cd5a5a9c48$var$_objectWithoutProperties(_this$props, $4d62e5cd5a5a9c48$var$_excluded2);
                return !(0, $fa893b10298a8cae$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $fa893b10298a8cae$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $fa893b10298a8cae$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $411b8d52505ff75c$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case "top":
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case "left":
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case "right":
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case "left":
                        textAnchor = mirror ? "start" : "end";
                        break;
                    case "right":
                        textAnchor = mirror ? "end" : "start";
                        break;
                    default:
                        textAnchor = "middle";
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = "end";
                switch(orientation){
                    case "left":
                    case "right":
                        verticalAnchor = "middle";
                        break;
                    case "top":
                        verticalAnchor = mirror ? "start" : "end";
                        break;
                    default:
                        verticalAnchor = mirror ? "end" : "start";
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $4d62e5cd5a5a9c48$var$_objectSpread($4d62e5cd5a5a9c48$var$_objectSpread($4d62e5cd5a5a9c48$var$_objectSpread({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(this.props)), (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(axisLine)), {}, {
                    fill: "none"
                });
                if (orientation === "top" || orientation === "bottom") {
                    var needHeight = +(orientation === "top" && !mirror || orientation === "bottom" && mirror);
                    props = $4d62e5cd5a5a9c48$var$_objectSpread($4d62e5cd5a5a9c48$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === "left" && !mirror || orientation === "right" && mirror);
                    props = $4d62e5cd5a5a9c48$var$_objectSpread($4d62e5cd5a5a9c48$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("line", $4d62e5cd5a5a9c48$var$_extends({}, props, {
                    className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-cartesian-axis-line", (0, (/*@__PURE__*/$parcel$interopDefault($c3944f5a36163d07$exports)))(axisLine, "className"))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $f9f1500193d895c1$export$3d27d42b1034de5c)($4d62e5cd5a5a9c48$var$_objectSpread($4d62e5cd5a5a9c48$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(this.props);
                var customTickProps = (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(tick);
                var tickLineProps = $4d62e5cd5a5a9c48$var$_objectSpread($4d62e5cd5a5a9c48$var$_objectSpread({}, axisProps), {}, {
                    fill: "none"
                }, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(tickLine));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $4d62e5cd5a5a9c48$var$_objectSpread($4d62e5cd5a5a9c48$var$_objectSpread($4d62e5cd5a5a9c48$var$_objectSpread($4d62e5cd5a5a9c48$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: "none",
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), $4d62e5cd5a5a9c48$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, $afad468d030baba8$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("line", $4d62e5cd5a5a9c48$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-cartesian-axis-tick-line", (0, (/*@__PURE__*/$parcel$interopDefault($c3944f5a36163d07$exports)))(tickLine, "className"))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || "")));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $4d62e5cd5a5a9c48$var$_objectWithoutProperties(_this$props8, $4d62e5cd5a5a9c48$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
                    className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-cartesian-axis", className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $af8b9f0e73fbde03$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $b5bb411b2159255d$export$5f1af8db9871e1d6), $4d62e5cd5a5a9c48$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return CartesianAxis;
}((0, $17VE6.Component));
$4d62e5cd5a5a9c48$var$_defineProperty($4d62e5cd5a5a9c48$export$bdd99f2cdf352bae, "displayName", "CartesianAxis");
$4d62e5cd5a5a9c48$var$_defineProperty($4d62e5cd5a5a9c48$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: "bottom",
    // The ticks
    ticks: [],
    stroke: "#666",
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: "preserveEnd"
});



var $17VE6 = parcelRequire("17VE6");








function $ad35652de195fb6c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ad35652de195fb6c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ad35652de195fb6c$var$_typeof(o);
}
function $ad35652de195fb6c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad35652de195fb6c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad35652de195fb6c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ad35652de195fb6c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad35652de195fb6c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ad35652de195fb6c$var$_defineProperty(obj, key, value) {
    key = $ad35652de195fb6c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ad35652de195fb6c$var$_toPropertyKey(arg) {
    var key = $ad35652de195fb6c$var$_toPrimitive(arg, "string");
    return $ad35652de195fb6c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ad35652de195fb6c$var$_toPrimitive(input, hint) {
    if ($ad35652de195fb6c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ad35652de195fb6c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $ad35652de195fb6c$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $ad35652de195fb6c$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $ad35652de195fb6c$var$PREFIX_LIST.reduce(function(res, entry) {
        return $ad35652de195fb6c$var$_objectSpread($ad35652de195fb6c$var$_objectSpread({}, res), {}, $ad35652de195fb6c$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $64c17983a418d5be$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $64c17983a418d5be$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $64c17983a418d5be$var$_typeof(o);
}
function $64c17983a418d5be$var$_extends() {
    $64c17983a418d5be$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $64c17983a418d5be$var$_extends.apply(this, arguments);
}
function $64c17983a418d5be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $64c17983a418d5be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $64c17983a418d5be$var$ownKeys(Object(t), !0).forEach(function(r) {
            $64c17983a418d5be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $64c17983a418d5be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $64c17983a418d5be$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $64c17983a418d5be$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $64c17983a418d5be$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $64c17983a418d5be$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $64c17983a418d5be$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $64c17983a418d5be$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $64c17983a418d5be$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $64c17983a418d5be$var$_setPrototypeOf(subClass, superClass);
}
function $64c17983a418d5be$var$_setPrototypeOf(o, p) {
    $64c17983a418d5be$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $64c17983a418d5be$var$_setPrototypeOf(o, p);
}
function $64c17983a418d5be$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $64c17983a418d5be$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $64c17983a418d5be$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $64c17983a418d5be$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $64c17983a418d5be$var$_possibleConstructorReturn(this, result);
    };
}
function $64c17983a418d5be$var$_possibleConstructorReturn(self, call) {
    if (call && ($64c17983a418d5be$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $64c17983a418d5be$var$_assertThisInitialized(self);
}
function $64c17983a418d5be$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $64c17983a418d5be$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $64c17983a418d5be$var$_getPrototypeOf(o) {
    $64c17983a418d5be$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $64c17983a418d5be$var$_getPrototypeOf(o);
}
function $64c17983a418d5be$var$_defineProperty(obj, key, value) {
    key = $64c17983a418d5be$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $64c17983a418d5be$var$_toPropertyKey(arg) {
    var key = $64c17983a418d5be$var$_toPrimitive(arg, "string");
    return $64c17983a418d5be$var$_typeof(key) === "symbol" ? key : String(key);
}
function $64c17983a418d5be$var$_toPrimitive(input, hint) {
    if ($64c17983a418d5be$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($64c17983a418d5be$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $64c17983a418d5be$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $8b8a6f16bc14962f$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($dc48ba0e6e0a6001$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $64c17983a418d5be$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $64c17983a418d5be$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    $64c17983a418d5be$var$_inherits(Brush, _PureComponent);
    var _super = $64c17983a418d5be$var$_createSuper(Brush);
    function Brush(props) {
        var _this;
        $64c17983a418d5be$var$_classCallCheck(this, Brush);
        _this = _super.call(this, props);
        $64c17983a418d5be$var$_defineProperty($64c17983a418d5be$var$_assertThisInitialized(_this), "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $64c17983a418d5be$var$_defineProperty($64c17983a418d5be$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $64c17983a418d5be$var$_defineProperty($64c17983a418d5be$var$_assertThisInitialized(_this), "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $64c17983a418d5be$var$_defineProperty($64c17983a418d5be$var$_assertThisInitialized(_this), "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $64c17983a418d5be$var$_defineProperty($64c17983a418d5be$var$_assertThisInitialized(_this), "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $64c17983a418d5be$var$_defineProperty($64c17983a418d5be$var$_assertThisInitialized(_this), "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $64c17983a418d5be$var$_defineProperty($64c17983a418d5be$var$_assertThisInitialized(_this), "handleSlideDragStart", function(e) {
            var event = $64c17983a418d5be$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind($64c17983a418d5be$var$_assertThisInitialized(_this), "startX"),
            endX: _this.handleTravellerDragStart.bind($64c17983a418d5be$var$_assertThisInitialized(_this), "endX")
        };
        _this.state = {};
        return _this;
    }
    $64c17983a418d5be$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $5ef2e400865c36d4$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener("mouseup", this.handleDragEnd, true);
                window.addEventListener("touchend", this.handleDragEnd, true);
                window.addEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener("mouseup", this.handleDragEnd, true);
                window.removeEventListener("touchend", this.handleDragEnd, true);
                window.removeEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $64c17983a418d5be$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$setState;
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === "startX" && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === "endX" && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState((_this$setState = {}, $64c17983a418d5be$var$_defineProperty(_this$setState, movingTravellerId, prevValue + delta), $64c17983a418d5be$var$_defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === "startX" && newScaleValue >= endX || id === "endX" && newScaleValue <= startX) return;
                this.setState($64c17983a418d5be$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $17VE6.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $64c17983a418d5be$var$_objectSpread($64c17983a418d5be$var$_objectSpread({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(this.props)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat(data[startIndex].name, ", Max value: ").concat(data[endIndex].name);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            "ArrowLeft",
                            "ArrowRight"
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === "ArrowRight" ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: "col-resize"
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: "move"
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: "none",
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $b5bb411b2159255d$export$5f1af8db9871e1d6), $64c17983a418d5be$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $b5bb411b2159255d$export$5f1af8db9871e1d6), $64c17983a418d5be$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(x) || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(y) || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(width) || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-brush", className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).Children.count(children) === 1;
                var style = (0, $ad35652de195fb6c$export$4a9169b65825efee)("userSelect", "none");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, "startX"), this.renderTravellerLayer(endX, "endX"), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $64c17983a418d5be$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $64c17983a418d5be$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
    return Brush;
}((0, $17VE6.PureComponent));
$64c17983a418d5be$var$_defineProperty($64c17983a418d5be$export$59bc2e3533b384a0, "displayName", "Brush");
$64c17983a418d5be$var$_defineProperty($64c17983a418d5be$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: "#fff",
    stroke: "#666",
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});






var $17VE6 = parcelRequire("17VE6");






var $44eb13e3adc3d32f$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = "extendDomain";
    return ifOverflow === value;
};





function $8c6c268895d01898$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8c6c268895d01898$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8c6c268895d01898$var$_typeof(o);
}
function $8c6c268895d01898$var$_extends() {
    $8c6c268895d01898$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8c6c268895d01898$var$_extends.apply(this, arguments);
}
function $8c6c268895d01898$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c6c268895d01898$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c6c268895d01898$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8c6c268895d01898$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c6c268895d01898$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8c6c268895d01898$var$_defineProperty(obj, key, value) {
    key = $8c6c268895d01898$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8c6c268895d01898$var$_toPropertyKey(arg) {
    var key = $8c6c268895d01898$var$_toPrimitive(arg, "string");
    return $8c6c268895d01898$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8c6c268895d01898$var$_toPrimitive(input, hint) {
    if ($8c6c268895d01898$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8c6c268895d01898$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $8c6c268895d01898$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $99f80a34797eff25$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $44eb13e3adc3d32f$export$3fb112445eb31879)(props, "discard") && !scales.isInRange(result)) return null;
    return result;
};
function $8c6c268895d01898$export$aa7f0b0106bff39(props) {
    var x = props.x, y = props.y, r = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    var isX = (0, $411b8d52505ff75c$export$402a499e1ea44294)(x);
    var isY = (0, $411b8d52505ff75c$export$402a499e1ea44294)(y);
    (0, $24beccc7a8850989$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    if (!isX || !isY) return null;
    var coordinate = $8c6c268895d01898$var$getCoordinate(props);
    if (!coordinate) return null;
    var cx = coordinate.x, cy = coordinate.y;
    var shape = props.shape, className = props.className;
    var clipPath = (0, $44eb13e3adc3d32f$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var dotProps = $8c6c268895d01898$var$_objectSpread($8c6c268895d01898$var$_objectSpread({
        clipPath: clipPath
    }, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(props, true)), {}, {
        cx: cx,
        cy: cy
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-reference-dot", className)
    }, $8c6c268895d01898$export$aa7f0b0106bff39.renderDot(shape, dotProps), (0, $af8b9f0e73fbde03$export$b04be29aa201d4f5).renderCallByParent(props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
    }));
}
$8c6c268895d01898$export$aa7f0b0106bff39.displayName = "ReferenceDot";
$8c6c268895d01898$export$aa7f0b0106bff39.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#fff",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1
};
$8c6c268895d01898$export$aa7f0b0106bff39.renderDot = function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $0ea73b33a67b7ee8$export$d046b3c4a416f60d), $8c6c268895d01898$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
};



var $17VE6 = parcelRequire("17VE6");

var $d785e9002d6a8e2d$exports = {};


var $fecd6b048cdfce6a$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $fecd6b048cdfce6a$var$baseSome(collection, predicate) {
    var result;
    $69aeb3380d6cbc9d$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$fecd6b048cdfce6a$exports = $fecd6b048cdfce6a$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $d785e9002d6a8e2d$var$some(collection, predicate, guard) {
    var func = $09ea814803501f1d$exports(collection) ? $8f9734db711cbf53$exports : $fecd6b048cdfce6a$exports;
    if (guard && $a4ed4c5e9ebf8672$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $e55fc84590a72f7a$exports(predicate, 3));
}
$d785e9002d6a8e2d$exports = $d785e9002d6a8e2d$var$some;










function $3dc4cef909b0d264$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3dc4cef909b0d264$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3dc4cef909b0d264$var$_typeof(o);
}
function $3dc4cef909b0d264$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3dc4cef909b0d264$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3dc4cef909b0d264$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3dc4cef909b0d264$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3dc4cef909b0d264$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3dc4cef909b0d264$var$_defineProperty(obj, key, value) {
    key = $3dc4cef909b0d264$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3dc4cef909b0d264$var$_toPropertyKey(arg) {
    var key = $3dc4cef909b0d264$var$_toPrimitive(arg, "string");
    return $3dc4cef909b0d264$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3dc4cef909b0d264$var$_toPrimitive(input, hint) {
    if ($3dc4cef909b0d264$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3dc4cef909b0d264$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $3dc4cef909b0d264$var$_slicedToArray(arr, i) {
    return $3dc4cef909b0d264$var$_arrayWithHoles(arr) || $3dc4cef909b0d264$var$_iterableToArrayLimit(arr, i) || $3dc4cef909b0d264$var$_unsupportedIterableToArray(arr, i) || $3dc4cef909b0d264$var$_nonIterableRest();
}
function $3dc4cef909b0d264$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3dc4cef909b0d264$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3dc4cef909b0d264$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3dc4cef909b0d264$var$_arrayLikeToArray(o, minLen);
}
function $3dc4cef909b0d264$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3dc4cef909b0d264$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3dc4cef909b0d264$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3dc4cef909b0d264$var$_extends() {
    $3dc4cef909b0d264$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3dc4cef909b0d264$var$_extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var $3dc4cef909b0d264$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("line", $3dc4cef909b0d264$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var $3dc4cef909b0d264$export$f273d496b213b6da = function getEndPoints(scales, isFixedX, isFixedY, isSegment, props) {
    var _props$viewBox = props.viewBox, x = _props$viewBox.x, y = _props$viewBox.y, width = _props$viewBox.width, height = _props$viewBox.height, position = props.position;
    if (isFixedY) {
        var yCoord = props.y, orientation = props.yAxis.orientation;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $44eb13e3adc3d32f$export$3fb112445eb31879)(props, "discard") && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return orientation === "left" ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x, _orientation = props.xAxis.orientation;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $44eb13e3adc3d32f$export$3fb112445eb31879)(props, "discard") && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return _orientation === "top" ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $44eb13e3adc3d32f$export$3fb112445eb31879)(props, "discard") && (0, (/*@__PURE__*/$parcel$interopDefault($d785e9002d6a8e2d$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $3dc4cef909b0d264$export$b2f28e248e7838eb(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxis = props.xAxis, yAxis = props.yAxis, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $24beccc7a8850989$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $99f80a34797eff25$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $411b8d52505ff75c$export$402a499e1ea44294)(fixedX);
    var isY = (0, $411b8d52505ff75c$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $3dc4cef909b0d264$export$f273d496b213b6da(scales, isX, isY, isSegment, props);
    if (!endPoints) return null;
    var _endPoints = $3dc4cef909b0d264$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $44eb13e3adc3d32f$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $3dc4cef909b0d264$var$_objectSpread($3dc4cef909b0d264$var$_objectSpread({
        clipPath: clipPath
    }, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-reference-line", className)
    }, $3dc4cef909b0d264$var$renderLine(shape, lineProps), (0, $af8b9f0e73fbde03$export$b04be29aa201d4f5).renderCallByParent(props, (0, $99f80a34797eff25$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
$3dc4cef909b0d264$export$b2f28e248e7838eb.displayName = "ReferenceLine";
$3dc4cef909b0d264$export$b2f28e248e7838eb.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    fill: "none",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1,
    position: "middle"
};



var $17VE6 = parcelRequire("17VE6");










function $3907a930bb9f2424$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3907a930bb9f2424$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3907a930bb9f2424$var$_typeof(o);
}
function $3907a930bb9f2424$var$_extends() {
    $3907a930bb9f2424$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3907a930bb9f2424$var$_extends.apply(this, arguments);
}
function $3907a930bb9f2424$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3907a930bb9f2424$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3907a930bb9f2424$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3907a930bb9f2424$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3907a930bb9f2424$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3907a930bb9f2424$var$_defineProperty(obj, key, value) {
    key = $3907a930bb9f2424$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3907a930bb9f2424$var$_toPropertyKey(arg) {
    var key = $3907a930bb9f2424$var$_toPrimitive(arg, "string");
    return $3907a930bb9f2424$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3907a930bb9f2424$var$_toPrimitive(input, hint) {
    if ($3907a930bb9f2424$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3907a930bb9f2424$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $3907a930bb9f2424$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $99f80a34797eff25$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: "start"
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: "start"
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: "end"
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: "end"
        }) : scales.y.rangeMax
    };
    if ((0, $44eb13e3adc3d32f$export$3fb112445eb31879)(props, "discard") && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $99f80a34797eff25$export$c7964a5b9439ae62)(p1, p2);
};
function $3907a930bb9f2424$export$b4ec4f050ce240b9(props) {
    var x1 = props.x1, x2 = props.x2, y1 = props.y1, y2 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $24beccc7a8850989$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var hasX1 = (0, $411b8d52505ff75c$export$402a499e1ea44294)(x1);
    var hasX2 = (0, $411b8d52505ff75c$export$402a499e1ea44294)(x2);
    var hasY1 = (0, $411b8d52505ff75c$export$402a499e1ea44294)(y1);
    var hasY2 = (0, $411b8d52505ff75c$export$402a499e1ea44294)(y2);
    var shape = props.shape;
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = $3907a930bb9f2424$var$getRect(hasX1, hasX2, hasY1, hasY2, props);
    if (!rect && !shape) return null;
    var clipPath = (0, $44eb13e3adc3d32f$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-reference-area", className)
    }, $3907a930bb9f2424$export$b4ec4f050ce240b9.renderRect(shape, $3907a930bb9f2424$var$_objectSpread($3907a930bb9f2424$var$_objectSpread({
        clipPath: clipPath
    }, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(props, true)), rect)), (0, $af8b9f0e73fbde03$export$b04be29aa201d4f5).renderCallByParent(props, rect));
}
$3907a930bb9f2424$export$b4ec4f050ce240b9.displayName = "ReferenceArea";
$3907a930bb9f2424$export$b4ec4f050ce240b9.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#ccc",
    fillOpacity: 0.5,
    stroke: "none",
    strokeWidth: 1
};
$3907a930bb9f2424$export$b4ec4f050ce240b9.renderRect = function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $4b79e7e1164e764d$export$4617fb02663045ef), $3907a930bb9f2424$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};





function $987487ccfdbd9f3a$var$_toConsumableArray(arr) {
    return $987487ccfdbd9f3a$var$_arrayWithoutHoles(arr) || $987487ccfdbd9f3a$var$_iterableToArray(arr) || $987487ccfdbd9f3a$var$_unsupportedIterableToArray(arr) || $987487ccfdbd9f3a$var$_nonIterableSpread();
}
function $987487ccfdbd9f3a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $987487ccfdbd9f3a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $987487ccfdbd9f3a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $987487ccfdbd9f3a$var$_arrayLikeToArray(o, minLen);
}
function $987487ccfdbd9f3a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $987487ccfdbd9f3a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $987487ccfdbd9f3a$var$_arrayLikeToArray(arr);
}
function $987487ccfdbd9f3a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $987487ccfdbd9f3a$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $bb4a0676cae5de7b$export$fdd5e64c0e8495bb)(children, (0, $3dc4cef909b0d264$export$b2f28e248e7838eb));
    var dots = (0, $bb4a0676cae5de7b$export$fdd5e64c0e8495bb)(children, (0, $8c6c268895d01898$export$aa7f0b0106bff39));
    var elements = [].concat($987487ccfdbd9f3a$var$_toConsumableArray(lines), $987487ccfdbd9f3a$var$_toConsumableArray(dots));
    var areas = (0, $bb4a0676cae5de7b$export$fdd5e64c0e8495bb)(children, (0, $3907a930bb9f2424$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $44eb13e3adc3d32f$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $44eb13e3adc3d32f$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(el.props[key1]) && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $411b8d52505ff75c$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $5cb281bf333b8ade$exports = {};
"use strict";
var $5cb281bf333b8ade$var$has = Object.prototype.hasOwnProperty, $5cb281bf333b8ade$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $5cb281bf333b8ade$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $5cb281bf333b8ade$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $5cb281bf333b8ade$var$Events().__proto__) $5cb281bf333b8ade$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $5cb281bf333b8ade$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $5cb281bf333b8ade$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $5cb281bf333b8ade$var$EE(fn, context || emitter, once), evt = $5cb281bf333b8ade$var$prefix ? $5cb281bf333b8ade$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $5cb281bf333b8ade$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $5cb281bf333b8ade$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $5cb281bf333b8ade$var$EventEmitter() {
    this._events = new $5cb281bf333b8ade$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $5cb281bf333b8ade$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($5cb281bf333b8ade$var$has.call(events, name)) names.push($5cb281bf333b8ade$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $5cb281bf333b8ade$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $5cb281bf333b8ade$var$prefix ? $5cb281bf333b8ade$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $5cb281bf333b8ade$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $5cb281bf333b8ade$var$prefix ? $5cb281bf333b8ade$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $5cb281bf333b8ade$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $5cb281bf333b8ade$var$prefix ? $5cb281bf333b8ade$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $5cb281bf333b8ade$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $5cb281bf333b8ade$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $5cb281bf333b8ade$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $5cb281bf333b8ade$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $5cb281bf333b8ade$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $5cb281bf333b8ade$var$prefix ? $5cb281bf333b8ade$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $5cb281bf333b8ade$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $5cb281bf333b8ade$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $5cb281bf333b8ade$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $5cb281bf333b8ade$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $5cb281bf333b8ade$var$prefix ? $5cb281bf333b8ade$var$prefix + event : event;
        if (this._events[evt]) $5cb281bf333b8ade$var$clearEvent(this, evt);
    } else {
        this._events = new $5cb281bf333b8ade$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$5cb281bf333b8ade$var$EventEmitter.prototype.off = $5cb281bf333b8ade$var$EventEmitter.prototype.removeListener;
$5cb281bf333b8ade$var$EventEmitter.prototype.addListener = $5cb281bf333b8ade$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$5cb281bf333b8ade$var$EventEmitter.prefixed = $5cb281bf333b8ade$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$5cb281bf333b8ade$var$EventEmitter.EventEmitter = $5cb281bf333b8ade$var$EventEmitter;
$5cb281bf333b8ade$exports = $5cb281bf333b8ade$var$EventEmitter;


var $5573b25aee6931e5$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($5cb281bf333b8ade$exports)))();
var $5573b25aee6931e5$export$ff9a08f6d0c38b8f = "recharts.syncMouseEvents";



function $e7c5ff319303b793$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e7c5ff319303b793$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e7c5ff319303b793$var$_typeof(o);
}
function $e7c5ff319303b793$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e7c5ff319303b793$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e7c5ff319303b793$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e7c5ff319303b793$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e7c5ff319303b793$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e7c5ff319303b793$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e7c5ff319303b793$var$_defineProperty(obj, key, value) {
    key = $e7c5ff319303b793$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e7c5ff319303b793$var$_toPropertyKey(arg) {
    var key = $e7c5ff319303b793$var$_toPrimitive(arg, "string");
    return $e7c5ff319303b793$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e7c5ff319303b793$var$_toPrimitive(input, hint) {
    if ($e7c5ff319303b793$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e7c5ff319303b793$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $e7c5ff319303b793$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $e7c5ff319303b793$var$_classCallCheck(this, AccessibilityManager);
        $e7c5ff319303b793$var$_defineProperty(this, "activeIndex", 0);
        $e7c5ff319303b793$var$_defineProperty(this, "coordinateList", []);
        $e7c5ff319303b793$var$_defineProperty(this, "layout", "horizontal");
    }
    $e7c5ff319303b793$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? [] : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList;
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case "ArrowRight":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case "ArrowLeft":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== "horizontal") return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
    return AccessibilityManager;
}();



function $3c28e77361640552$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === "number" && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(domainStart) && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}




var $17VE6 = parcelRequire("17VE6");


var $17VE6 = parcelRequire("17VE6");



function $546e1e890dfe0931$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $546e1e890dfe0931$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $546e1e890dfe0931$var$_typeof(o);
}
var $546e1e890dfe0931$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $546e1e890dfe0931$var$_extends() {
    $546e1e890dfe0931$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $546e1e890dfe0931$var$_extends.apply(this, arguments);
}
function $546e1e890dfe0931$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $546e1e890dfe0931$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $546e1e890dfe0931$var$ownKeys(Object(t), !0).forEach(function(r) {
            $546e1e890dfe0931$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $546e1e890dfe0931$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $546e1e890dfe0931$var$_defineProperty(obj, key, value) {
    key = $546e1e890dfe0931$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $546e1e890dfe0931$var$_toPropertyKey(arg) {
    var key = $546e1e890dfe0931$var$_toPrimitive(arg, "string");
    return $546e1e890dfe0931$var$_typeof(key) === "symbol" ? key : String(key);
}
function $546e1e890dfe0931$var$_toPrimitive(input, hint) {
    if ($546e1e890dfe0931$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($546e1e890dfe0931$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $546e1e890dfe0931$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $546e1e890dfe0931$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $546e1e890dfe0931$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $546e1e890dfe0931$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $546e1e890dfe0931$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $546e1e890dfe0931$var$_objectWithoutProperties(_ref, $546e1e890dfe0931$var$_excluded);
    var props = $546e1e890dfe0931$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $411b8d52505ff75c$export$7e4aa119212bc614)(x) || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(y) || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(width) || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(height) || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(top) || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("path", $546e1e890dfe0931$var$_extends({}, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(props, true), {
        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-cross", className),
        d: $546e1e890dfe0931$var$getPath(x, y, width, height, top, left)
    }));
};


function $dd9ac439bf08e27a$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: "none",
        fill: "#ccc",
        x: layout === "horizontal" ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === "horizontal" ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === "horizontal" ? tooltipAxisBandSize : offset.width - 1,
        height: layout === "horizontal" ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $a756b7ad93cd6dec$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}





function $62dc1929050f9b63$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === "horizontal") {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === "vertical") {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === "centric") {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $a756b7ad93cd6dec$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}



function $a47b87c3acfa40ba$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a47b87c3acfa40ba$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a47b87c3acfa40ba$var$_typeof(o);
}
function $a47b87c3acfa40ba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a47b87c3acfa40ba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a47b87c3acfa40ba$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a47b87c3acfa40ba$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a47b87c3acfa40ba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a47b87c3acfa40ba$var$_defineProperty(obj, key, value) {
    key = $a47b87c3acfa40ba$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a47b87c3acfa40ba$var$_toPropertyKey(arg) {
    var key = $a47b87c3acfa40ba$var$_toPrimitive(arg, "string");
    return $a47b87c3acfa40ba$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a47b87c3acfa40ba$var$_toPrimitive(input, hint) {
    if ($a47b87c3acfa40ba$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a47b87c3acfa40ba$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a47b87c3acfa40ba$export$b6a79797ad180576(props) {
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    if (!element || !element.props.cursor || !isActive || !activeCoordinate || chartName !== "ScatterChart" && tooltipEventType !== "axis") return null;
    var restProps;
    var cursorComp = (0, $ea5067ec5be00d2e$export$b0e83c3ef8d2db1);
    if (chartName === "ScatterChart") {
        restProps = activeCoordinate;
        cursorComp = (0, $546e1e890dfe0931$export$3c877bb842c36952);
    } else if (chartName === "BarChart") {
        restProps = (0, $dd9ac439bf08e27a$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $4b79e7e1164e764d$export$4617fb02663045ef);
    } else if (layout === "radial") {
        var _getRadialCursorPoint = (0, $a756b7ad93cd6dec$export$ad661ef85a042a4f)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $c8d5fc89b7f29d4a$export$e98c2c7eb2b14f45);
    } else {
        restProps = {
            points: (0, $62dc1929050f9b63$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $ea5067ec5be00d2e$export$b0e83c3ef8d2db1);
    }
    var cursorProps = $a47b87c3acfa40ba$var$_objectSpread($a47b87c3acfa40ba$var$_objectSpread($a47b87c3acfa40ba$var$_objectSpread($a47b87c3acfa40ba$var$_objectSpread({
        stroke: "#ccc",
        pointerEvents: "none"
    }, offset), restProps), (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(element.props.cursor)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: "recharts-tooltip-cursor"
    });
    return /*#__PURE__*/ (0, $17VE6.isValidElement)(element.props.cursor) ? /*#__PURE__*/ (0, $17VE6.cloneElement)(element.props.cursor, cursorProps) : /*#__PURE__*/ (0, $17VE6.createElement)(cursorComp, cursorProps);
}


var $0a5334e5d4da77f0$var$_excluded = [
    "item"
], $0a5334e5d4da77f0$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $0a5334e5d4da77f0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0a5334e5d4da77f0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0a5334e5d4da77f0$var$_typeof(o);
}
function $0a5334e5d4da77f0$var$_slicedToArray(arr, i) {
    return $0a5334e5d4da77f0$var$_arrayWithHoles(arr) || $0a5334e5d4da77f0$var$_iterableToArrayLimit(arr, i) || $0a5334e5d4da77f0$var$_unsupportedIterableToArray(arr, i) || $0a5334e5d4da77f0$var$_nonIterableRest();
}
function $0a5334e5d4da77f0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0a5334e5d4da77f0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0a5334e5d4da77f0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0a5334e5d4da77f0$var$_extends() {
    $0a5334e5d4da77f0$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0a5334e5d4da77f0$var$_extends.apply(this, arguments);
}
function $0a5334e5d4da77f0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0a5334e5d4da77f0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0a5334e5d4da77f0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0a5334e5d4da77f0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0a5334e5d4da77f0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0a5334e5d4da77f0$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0a5334e5d4da77f0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0a5334e5d4da77f0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0a5334e5d4da77f0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0a5334e5d4da77f0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $0a5334e5d4da77f0$var$_setPrototypeOf(subClass, superClass);
}
function $0a5334e5d4da77f0$var$_setPrototypeOf(o, p) {
    $0a5334e5d4da77f0$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0a5334e5d4da77f0$var$_setPrototypeOf(o, p);
}
function $0a5334e5d4da77f0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0a5334e5d4da77f0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $0a5334e5d4da77f0$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $0a5334e5d4da77f0$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $0a5334e5d4da77f0$var$_possibleConstructorReturn(this, result);
    };
}
function $0a5334e5d4da77f0$var$_possibleConstructorReturn(self, call) {
    if (call && ($0a5334e5d4da77f0$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0a5334e5d4da77f0$var$_assertThisInitialized(self);
}
function $0a5334e5d4da77f0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0a5334e5d4da77f0$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $0a5334e5d4da77f0$var$_getPrototypeOf(o) {
    $0a5334e5d4da77f0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0a5334e5d4da77f0$var$_getPrototypeOf(o);
}
function $0a5334e5d4da77f0$var$_toConsumableArray(arr) {
    return $0a5334e5d4da77f0$var$_arrayWithoutHoles(arr) || $0a5334e5d4da77f0$var$_iterableToArray(arr) || $0a5334e5d4da77f0$var$_unsupportedIterableToArray(arr) || $0a5334e5d4da77f0$var$_nonIterableSpread();
}
function $0a5334e5d4da77f0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0a5334e5d4da77f0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0a5334e5d4da77f0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0a5334e5d4da77f0$var$_arrayLikeToArray(o, minLen);
}
function $0a5334e5d4da77f0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $0a5334e5d4da77f0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $0a5334e5d4da77f0$var$_arrayLikeToArray(arr);
}
function $0a5334e5d4da77f0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0a5334e5d4da77f0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a5334e5d4da77f0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a5334e5d4da77f0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0a5334e5d4da77f0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a5334e5d4da77f0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0a5334e5d4da77f0$var$_defineProperty(obj, key, value) {
    key = $0a5334e5d4da77f0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0a5334e5d4da77f0$var$_toPropertyKey(arg) {
    var key = $0a5334e5d4da77f0$var$_toPrimitive(arg, "string");
    return $0a5334e5d4da77f0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0a5334e5d4da77f0$var$_toPrimitive(input, hint) {
    if ($0a5334e5d4da77f0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0a5334e5d4da77f0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $0a5334e5d4da77f0$var$ORIENT_MAP = {
    xAxis: [
        "bottom",
        "top"
    ],
    yAxis: [
        "left",
        "right"
    ]
};
var $0a5334e5d4da77f0$var$FULL_WIDTH_AND_HEIGHT = {
    width: "100%",
    height: "100%"
};
var $0a5334e5d4da77f0$var$originCoordinate = {
    x: 0,
    y: 0
};
var $0a5334e5d4da77f0$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === "horizontal") return rangeObj.x;
    if (layout === "vertical") return rangeObj.y;
    if (layout === "centric") return rangeObj.angle;
    return rangeObj.radius;
};
var $0a5334e5d4da77f0$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === "horizontal") return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === "vertical") return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === "centric") {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, rangeObj), (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, rangeObj), (0, $f004b8ab2664ad8d$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $0a5334e5d4da77f0$var$originCoordinate;
};
var $0a5334e5d4da77f0$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($0a5334e5d4da77f0$var$_toConsumableArray(result), $0a5334e5d4da77f0$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(dataStartIndex) && (0, $411b8d52505ff75c$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $0a5334e5d4da77f0$var$getDefaultDomainByAxisType(axisType) {
    return axisType === "number" ? [
        0,
        "auto"
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $0a5334e5d4da77f0$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $0a5334e5d4da77f0$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        var hide = child.props.hide;
        if (hide) return result;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $411b8d52505ff75c$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($0a5334e5d4da77f0$var$_toConsumableArray(result), [
            (0, $5ef2e400865c36d4$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $0a5334e5d4da77f0$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $0a5334e5d4da77f0$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $5ef2e400865c36d4$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $0a5334e5d4da77f0$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $0a5334e5d4da77f0$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $0a5334e5d4da77f0$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $5ef2e400865c36d4$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _child$props$domain2;
        var _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale = _child$props.scale, ticks = _child$props.ticks, includeHidden = _child$props.includeHidden;
        var axisId = child.props[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $0a5334e5d4da77f0$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $3c28e77361640552$export$33279f645a5831b7)(child.props.domain, allowDataOverflow, type)) {
            domain = (0, $5ef2e400865c36d4$export$a0bc8660980558a0)(child.props.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $5ef2e400865c36d4$export$6a1e7873444c95a7)(displayedData, dataKey, "category");
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $0a5334e5d4da77f0$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _child$props$domain;
            var childDomain = (_child$props$domain = child.props.domain) !== null && _child$props$domain !== void 0 ? _child$props$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $5ef2e400865c36d4$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === "category" && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $411b8d52505ff75c$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($dc48ba0e6e0a6001$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $5ef2e400865c36d4$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($0a5334e5d4da77f0$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === "category") {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $5ef2e400865c36d4$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === "" || (0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(entry) ? finalDomain : [].concat($0a5334e5d4da77f0$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== "" && !(0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(entry);
                    });
                } else if (type === "number") {
                    // the field type is numerical
                    var errorBarsDomain = (0, $5ef2e400865c36d4$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $5ef2e400865c36d4$export$6a1e7873444c95a7)(displayedData, dataKey, "category");
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($dc48ba0e6e0a6001$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === "number") // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === "expand" ? [
                0,
                1
            ] : (0, $5ef2e400865c36d4$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $5ef2e400865c36d4$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
            }), type, layout, true);
            if (type === "number") {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $987487ccfdbd9f3a$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $5ef2e400865c36d4$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === "category" && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, result), {}, $0a5334e5d4da77f0$var$_defineProperty({}, axisId, $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, child.props), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_child$props$domain2 = child.props.domain) !== null && _child$props$domain2 !== void 0 ? _child$props$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $0a5334e5d4da77f0$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $0a5334e5d4da77f0$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $5ef2e400865c36d4$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var axisId = child.props[axisIdKey];
        var originalDomain = $0a5334e5d4da77f0$var$getDefaultDomainByAxisType("number");
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($dc48ba0e6e0a6001$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $5ef2e400865c36d4$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $987487ccfdbd9f3a$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $5ef2e400865c36d4$export$a0bc8660980558a0)(originalDomain, (0, $5ef2e400865c36d4$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    return item.props[axisIdKey] === axisId && !item.props.hide;
                }), "number", layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $987487ccfdbd9f3a$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, result), {}, $0a5334e5d4da77f0$var$_defineProperty({}, axisId, $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c3944f5a36163d07$exports)))($0a5334e5d4da77f0$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $0a5334e5d4da77f0$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? "xAxis" : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $bb4a0676cae5de7b$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $0a5334e5d4da77f0$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $0a5334e5d4da77f0$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $0a5334e5d4da77f0$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $411b8d52505ff75c$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $5ef2e400865c36d4$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($2d5f4b2fac16794e$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $5ef2e400865c36d4$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
var $0a5334e5d4da77f0$export$e5182fb58612e577 = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $bb4a0676cae5de7b$export$64c61536a2b72e0f)(children, (0, $64c17983a418d5be$export$59bc2e3533b384a0));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $0a5334e5d4da77f0$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $bb4a0676cae5de7b$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf("Bar") >= 0;
    });
};
var $0a5334e5d4da77f0$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === "horizontal") return {
        numericAxisName: "yAxis",
        cateAxisName: "xAxis"
    };
    if (layout === "vertical") return {
        numericAxisName: "xAxis",
        cateAxisName: "yAxis"
    };
    if (layout === "centric") return {
        numericAxisName: "radiusAxis",
        cateAxisName: "angleAxis"
    };
    return {
        numericAxisName: "angleAxis",
        cateAxisName: "radiusAxis"
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $0a5334e5d4da77f0$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $bb4a0676cae5de7b$export$64c61536a2b72e0f)(children, (0, $64c17983a418d5be$export$59bc2e3533b384a0));
    var legendItem = (0, $bb4a0676cae5de7b$export$64c61536a2b72e0f)(children, (0, $16246b7a18e9bbb1$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, result), {}, $0a5334e5d4da77f0$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, result), {}, $0a5334e5d4da77f0$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($c3944f5a36163d07$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $64c17983a418d5be$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $5ef2e400865c36d4$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
var $0a5334e5d4da77f0$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var _class;
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? "axis" : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        "axis"
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $0a5334e5d4da77f0$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $0a5334e5d4da77f0$var$hasGraphicalBarItem(graphicalItems);
        var sizeList = hasBar && (0, $5ef2e400865c36d4$export$570d306bee26c748)({
            barSize: barSize,
            stackGroups: stackGroups
        });
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $0a5334e5d4da77f0$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = item.props["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = item.props["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type, _objectSpread6;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = item.props["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === "zAxis") && (0, $986f3a016cffd215$export$2e2bcd8739ae039)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, result), {}, (_objectSpread6 = {}, $0a5334e5d4da77f0$var$_defineProperty(_objectSpread6, entry.axisType, axis), $0a5334e5d4da77f0$var$_defineProperty(_objectSpread6, "".concat(entry.axisType, "Ticks"), (0, $5ef2e400865c36d4$export$c829ee42daf7f66d)(axis)), _objectSpread6));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $5ef2e400865c36d4$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $bb4a0676cae5de7b$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            var bandSize = (0, $5ef2e400865c36d4$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // 如果是bar，计算bar的位置
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $5ef2e400865c36d4$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $5ef2e400865c36d4$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, pos), {}, {
                        position: $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) {
                var _objectSpread7;
                formattedItems.push({
                    props: $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, composedFn($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, axisObj), {}, {
                        displayedData: displayedData,
                        props: props,
                        dataKey: dataKey,
                        item: item,
                        bandSize: bandSize,
                        barPosition: barPosition,
                        offset: offset,
                        stackedData: stackedData,
                        layout: layout,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }))), {}, (_objectSpread7 = {
                        key: item.key || "item-".concat(index)
                    }, $0a5334e5d4da77f0$var$_defineProperty(_objectSpread7, numericAxisName, axisObj[numericAxisName]), $0a5334e5d4da77f0$var$_defineProperty(_objectSpread7, cateAxisName, axisObj[cateAxisName]), $0a5334e5d4da77f0$var$_defineProperty(_objectSpread7, "animationId", updateId), _objectSpread7)),
                    childIndex: (0, $bb4a0676cae5de7b$export$857ca101f741953)(item, props.children),
                    item: item
                });
            }
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $bb4a0676cae5de7b$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $0a5334e5d4da77f0$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $bb4a0676cae5de7b$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $5ef2e400865c36d4$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, result), {}, $0a5334e5d4da77f0$var$_defineProperty({}, name, $0a5334e5d4da77f0$var$getAxisMap(props, $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $0a5334e5d4da77f0$var$calculateOffset($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace("Map", ""), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $0a5334e5d4da77f0$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    return _class = /*#__PURE__*/ function(_Component) {
        $0a5334e5d4da77f0$var$_inherits(CategoricalChartWrapper, _Component);
        var _super = $0a5334e5d4da77f0$var$_createSuper(CategoricalChartWrapper);
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $0a5334e5d4da77f0$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = _super.call(this, _props);
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "eventEmitterSymbol", Symbol("rechartsEventEmitter"));
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "accessibilityManager", new (0, $e7c5ff319303b793$export$a2c2de1efa8671eb)());
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($0a5334e5d4da77f0$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== "function") return;
                    _this.applySyncEvent(data);
                }
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $0a5334e5d4da77f0$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleMouseLeave", function(e) {
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleOuterEvent", function(e) {
                var eventName = (0, $bb4a0676cae5de7b$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($c3944f5a36163d07$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $5573b25aee6931e5$export$9bcdfe5f29bb33).emit((0, $5573b25aee6931e5$export$ff9a08f6d0c38b8f), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($0a5334e5d4da77f0$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === "function") // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === "value") {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $0a5334e5d4da77f0$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === "horizontal" ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === "horizontal" ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $0a5334e5d4da77f0$var$originCoordinate;
                    _this.setState($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "verticalCoordinatesGenerator", function(_ref10, syncWithTicks) {
                var xAxis = _ref10.xAxis, width = _ref10.width, height = _ref10.height, offset = _ref10.offset;
                return (0, $5ef2e400865c36d4$export$846dc5ac5fecff74)((0, $f9f1500193d895c1$export$3d27d42b1034de5c)($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, (0, $4d62e5cd5a5a9c48$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
                    ticks: (0, $5ef2e400865c36d4$export$c829ee42daf7f66d)(xAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.left, offset.left + offset.width, syncWithTicks);
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "horizontalCoordinatesGenerator", function(_ref11, syncWithTicks) {
                var yAxis = _ref11.yAxis, width = _ref11.width, height = _ref11.height, offset = _ref11.offset;
                return (0, $5ef2e400865c36d4$export$846dc5ac5fecff74)((0, $f9f1500193d895c1$export$3d27d42b1034de5c)($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, (0, $4d62e5cd5a5a9c48$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
                    ticks: (0, $5ef2e400865c36d4$export$c829ee42daf7f66d)(yAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.top, offset.top + offset.height, syncWithTicks);
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "axesTicksGenerator", function(axis) {
                return (0, $5ef2e400865c36d4$export$c829ee42daf7f66d)(axis, true);
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || "_recharts-cursor";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $a47b87c3acfa40ba$export$b6a79797ad180576), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($c3944f5a36163d07$exports)))(element, "type.axisType");
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($c3944f5a36163d07$exports)))(_this.state, "".concat(axisType, "Map"));
                var axisOption = axisMap && axisMap[element.props["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $17VE6.cloneElement)(element, $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, axisOption), {}, {
                    className: axisType,
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $5ef2e400865c36d4$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "renderXAxis", function(element, displayName, index) {
                var xAxisMap = _this.state.xAxisMap;
                var axisObj = xAxisMap[element.props.xAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "renderYAxis", function(element, displayName, index) {
                var yAxisMap = _this.state.yAxisMap;
                var axisObj = yAxisMap[element.props.yAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            /**
       * Draw grid
       * @param  {ReactElement} element the grid item
       * @return {ReactElement} The instance of grid
       */ $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "renderGrid", function(element) {
                var _this$state4 = _this.state, xAxisMap = _this$state4.xAxisMap, yAxisMap = _this$state4.yAxisMap, offset = _this$state4.offset;
                var _this$props2 = _this.props, width = _this$props2.width, height = _this$props2.height;
                var xAxis = (0, $411b8d52505ff75c$export$b88993f0aa0bf776)(xAxisMap);
                var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($fbf97b3464744f2c$exports)))(yAxisMap, function(axis) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c1a364db45d21380$exports)))(axis.domain, Number.isFinite);
                });
                var yAxis = yAxisWithFiniteDomain || (0, $411b8d52505ff75c$export$b88993f0aa0bf776)(yAxisMap);
                var props = element.props || {};
                return /*#__PURE__*/ (0, $17VE6.cloneElement)(element, {
                    key: element.key || "grid",
                    x: (0, $411b8d52505ff75c$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
                    y: (0, $411b8d52505ff75c$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
                    width: (0, $411b8d52505ff75c$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
                    height: (0, $411b8d52505ff75c$export$7e4aa119212bc614)(props.height) ? props.height : offset.height,
                    xAxis: xAxis,
                    yAxis: yAxis,
                    offset: offset,
                    chartWidth: width,
                    chartHeight: height,
                    verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
                    horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
                });
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state5 = _this.state, radiusAxisMap = _this$state5.radiusAxisMap, angleAxisMap = _this$state5.angleAxisMap;
                var radiusAxis = (0, $411b8d52505ff75c$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $411b8d52505ff75c$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $17VE6.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $5ef2e400865c36d4$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $5ef2e400865c36d4$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || "polar-grid",
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props3 = _this.props, children = _this$props3.children, width = _this$props3.width, height = _this$props3.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $11a07a73a1c11287$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $0a5334e5d4da77f0$var$_objectWithoutProperties(props, $0a5334e5d4da77f0$var$_excluded);
                return /*#__PURE__*/ (0, $17VE6.cloneElement)(item, $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var children = _this.props.children;
                var tooltipItem = (0, $bb4a0676cae5de7b$export$64c61536a2b72e0f)(children, (0, $c4a063a58f2c0c69$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state6 = _this.state, isTooltipActive = _this$state6.isTooltipActive, activeCoordinate = _this$state6.activeCoordinate, activePayload = _this$state6.activePayload, activeLabel = _this$state6.activeLabel, offset = _this$state6.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $17VE6.cloneElement)(tooltipItem, {
                    viewBox: $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate
                });
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state7 = _this.state, offset = _this$state7.offset, dataStartIndex = _this$state7.dataStartIndex, dataEndIndex = _this$state7.dataEndIndex, updateId = _this$state7.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $17VE6.cloneElement)(element, {
                    key: element.key || "_recharts-brush",
                    onChange: (0, $5ef2e400865c36d4$export$760ec406ba47bace)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $411b8d52505ff75c$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $411b8d52505ff75c$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $411b8d52505ff75c$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _assertThisInitialize = $0a5334e5d4da77f0$var$_assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId;
                var _this$state8 = _this.state, xAxisMap = _this$state8.xAxisMap, yAxisMap = _this$state8.yAxisMap, offset = _this$state8.offset;
                var _element$props2 = element.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
                return /*#__PURE__*/ (0, $17VE6.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "renderActivePoints", function(_ref12) {
                var item = _ref12.item, activePoint = _ref12.activePoint, basePoint = _ref12.basePoint, childIndex = _ref12.childIndex, isRange = _ref12.isRange;
                var result = [];
                var key = item.props.key;
                var _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey;
                var dotProps = $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $5ef2e400865c36d4$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: "#fff",
                    payload: activePoint.payload,
                    value: activePoint.value,
                    key: "".concat(key, "-activePoint-").concat(childIndex)
                }, (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(activeDot)), (0, $afad468d030baba8$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: "".concat(key, "-basePoint-").concat(childIndex)
                })));
                else if (isRange) result.push(null);
                return result;
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state9 = _this.state, isTooltipActive = _this$state9.isTooltipActive, tooltipAxis = _this$state9.tooltipAxis, activeTooltipIndex = _this$state9.activeTooltipIndex, activeLabel = _this$state9.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $bb4a0676cae5de7b$export$64c61536a2b72e0f)(children, (0, $c4a063a58f2c0c69$export$28c660c63b792dea));
                var _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine;
                var _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide, activeBar = _item$item$props2.activeBar, activeShape = _item$item$props2.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== "axis" && tooltipItem && tooltipItem.props.trigger === "click") itemEvents = {
                    onClick: (0, $5ef2e400865c36d4$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== "axis") itemEvents = {
                    onMouseLeave: (0, $5ef2e400865c36d4$export$760ec406ba47bace)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $5ef2e400865c36d4$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $17VE6.cloneElement)(element, $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === "function" ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === "function" ? findWithPayload : "payload.".concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $411b8d52505ff75c$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $411b8d52505ff75c$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $17VE6.cloneElement)(element, $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(activePoint)) return [
                            graphicalItem
                        ].concat($0a5334e5d4da77f0$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref13 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref13$graphicalItem = _ref13.graphicalItem, _ref13$graphicalItem$ = _ref13$graphicalItem.item, xyItem = _ref13$graphicalItem$ === void 0 ? element : _ref13$graphicalItem$, childIndex = _ref13$graphicalItem.childIndex;
                        var elementProps = $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $17VE6.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $17VE6.cloneElement)(element, $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $0a5334e5d4da77f0$var$_defineProperty($0a5334e5d4da77f0$var$_assertThisInitialized(_this), "renderMap", {
                CartesianGrid: {
                    handler: _this.renderGrid,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: _this.renderReferenceElement
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: _this.renderXAxis
                },
                YAxis: {
                    handler: _this.renderYAxis
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $411b8d52505ff75c$export$8b15d37bc3f197d4)("recharts"), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($a01f45a78bb58511$exports)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $0a5334e5d4da77f0$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: // eslint-disable-next-line @typescript-eslint/no-empty-function
                function componentDidUpdate() {}
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $bb4a0676cae5de7b$export$64c61536a2b72e0f)(this.props.children, (0, $c4a063a58f2c0c69$export$28c660c63b792dea));
                    if (tooltipItem && typeof tooltipItem.props.shared === "boolean") {
                        var eventType = tooltipItem.props.shared ? "axis" : "item";
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $4e3fcb7d26d9032b$export$622cea445a1c5b7d)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state10 = this.state, xAxisMap = _this$state10.xAxisMap, yAxisMap = _this$state10.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== "axis" && xAxisMap && yAxisMap) {
                        var xScale = (0, $411b8d52505ff75c$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $411b8d52505ff75c$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = $0a5334e5d4da77f0$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === "horizontal" || layout === "vertical") {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state11 = this.state, angleAxisMap = _this$state11.angleAxisMap, radiusAxisMap = _this$state11.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $411b8d52505ff75c$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $f004b8ab2664ad8d$export$e85a2bf8cd31c504)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $bb4a0676cae5de7b$export$64c61536a2b72e0f)(children, (0, $c4a063a58f2c0c69$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === "axis") {
                        if (tooltipItem.props.trigger === "click") tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $afad468d030baba8$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $5573b25aee6931e5$export$9bcdfe5f29bb33).on((0, $5573b25aee6931e5$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $5573b25aee6931e5$export$9bcdfe5f29bb33).removeListener((0, $5573b25aee6931e5$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $bb4a0676cae5de7b$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderAxis",
                value: /**
       * Draw axis
       * @param {Object} axisOptions The options of axis
       * @param {Object} element      The axis element
       * @param {String} displayName  The display name of axis
       * @param {Number} index        The index of element
       * @return {ReactElement}       The instance of x-axes
       */ function renderAxis(axisOptions, element, displayName, index) {
                    var _this$props5 = this.props, width = _this$props5.width, height = _this$props5.height;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $4d62e5cd5a5a9c48$export$bdd99f2cdf352bae), $0a5334e5d4da77f0$var$_extends({}, axisOptions, {
                        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
                        key: element.key || "".concat(displayName, "-").concat(index),
                        viewBox: {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        },
                        ticksGenerator: this.axesTicksGenerator
                    }));
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref14) {
                        var _ref15 = $0a5334e5d4da77f0$var$_slicedToArray(_ref14, 2), axisId = _ref15[0], axisProps = _ref15[1];
                        return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, res), {}, $0a5334e5d4da77f0$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref16) {
                        var _ref17 = $0a5334e5d4da77f0$var$_slicedToArray(_ref16, 2), axisId = _ref17[0], axisProps = _ref17[1];
                        return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, res), {}, $0a5334e5d4da77f0$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state12 = this.state, formattedGraphicalItems = _this$state12.formattedGraphicalItems, activeItem = _this$state12.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemDisplayName = (0, $bb4a0676cae5de7b$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === "Bar") {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $4b79e7e1164e764d$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === "RadialBar") {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $f004b8ab2664ad8d$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $e76ae290db1e26a6$export$4b83e8415af38a18)(graphicalItem, activeItem) || (0, $e76ae290db1e26a6$export$f722d7e63cc07b)(graphicalItem, activeItem) || (0, $e76ae290db1e26a6$export$f62b21bcfd1a733e)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $e76ae290db1e26a6$export$bd5d63c57ca4468)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: item.props.data
                            });
                            var childIndex = item.props.activeIndex === undefined ? activeIndex : item.props.activeIndex;
                            return {
                                graphicalItem: $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $e76ae290db1e26a6$export$f62b21bcfd1a733e)(graphicalItem, activeItem) ? item.props.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    if (!(0, $bb4a0676cae5de7b$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $0a5334e5d4da77f0$var$_objectWithoutProperties(_this$props6, $0a5334e5d4da77f0$var$_excluded2);
                    var attrs = (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(others);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $e9a3c85e4a9c1357$export$7b92b459e668cb21), $0a5334e5d4da77f0$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $bb4a0676cae5de7b$export$a98d6da55570cb82)(children, this.renderMap));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : "img";
                        attrs.onKeyDown = function(e) {
                            _this2.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this2.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("div", $0a5334e5d4da77f0$var$_extends({
                        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-wrapper", className),
                        style: $0a5334e5d4da77f0$var$_objectSpread({
                            position: "relative",
                            cursor: "default",
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this2.container = node;
                        },
                        role: "region"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $e9a3c85e4a9c1357$export$7b92b459e668cb21), $0a5334e5d4da77f0$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $0a5334e5d4da77f0$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $bb4a0676cae5de7b$export$a98d6da55570cb82)(children, this.renderMap)), this.renderLegend(), this.renderTooltip());
                }
            }
        ]);
        return CategoricalChartWrapper;
    }((0, $17VE6.Component)), $0a5334e5d4da77f0$var$_defineProperty(_class, "displayName", chartName), $0a5334e5d4da77f0$var$_defineProperty(_class, "defaultProps", $0a5334e5d4da77f0$var$_objectSpread({
        layout: "horizontal",
        stackOffset: "none",
        barCategoryGap: "10%",
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: "index"
    }, defaultProps)), $0a5334e5d4da77f0$var$_defineProperty(_class, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = $0a5334e5d4da77f0$export$e5182fb58612e577(nextProps);
            return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $fa893b10298a8cae$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $0a5334e5d4da77f0$export$e5182fb58612e577(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, $0a5334e5d4da77f0$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($0a5334e5d4da77f0$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $bb4a0676cae5de7b$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, $bb4a0676cae5de7b$export$64c61536a2b72e0f)(children, (0, $64c17983a418d5be$export$59bc2e3533b384a0));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($6ab57f7722177cda$exports)))(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return $0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($0a5334e5d4da77f0$var$_objectSpread($0a5334e5d4da77f0$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    }), $0a5334e5d4da77f0$var$_defineProperty(_class, "renderActiveDot", function(option, props) {
        var dot;
        if (/*#__PURE__*/ (0, $17VE6.isValidElement)(option)) dot = /*#__PURE__*/ (0, $17VE6.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $0ea73b33a67b7ee8$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $72b5a0127ea89e65$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: props.key
        }, dot);
    }), _class;
};



/**
 * @fileOverview X Axis
 */ /** Define of XAxis props */ var $158242af61505ff8$export$ea77231de273b52d = function XAxis() {
    return null;
};
$158242af61505ff8$export$ea77231de273b52d.displayName = "XAxis";
$158242af61505ff8$export$ea77231de273b52d.defaultProps = {
    allowDecimals: true,
    hide: false,
    orientation: "bottom",
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: "category",
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false,
    allowDuplicatedCategory: true
};


/**
 * @fileOverview Y Axis
 */ var $c91532a7678bb6b8$export$f96c4024c52de8f4 = function YAxis() {
    return null;
};
$c91532a7678bb6b8$export$f96c4024c52de8f4.displayName = "YAxis";
$c91532a7678bb6b8$export$f96c4024c52de8f4.defaultProps = {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: "left",
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: "number",
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false
};



var $2f23af152231b861$export$f510429275d6f1a8 = (0, $0a5334e5d4da77f0$export$77871aede60e6838)({
    chartName: "AreaChart",
    GraphicalChild: (0, $014dbbe445859826$export$ea1a111407f37557),
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, $158242af61505ff8$export$ea77231de273b52d)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, $c91532a7678bb6b8$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $99f80a34797eff25$export$ece7de1383db5ac)
});


var $17VE6 = parcelRequire("17VE6");



var $7955eeb80a63f070$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $7955eeb80a63f070$var$_excluded2 = [
    "offset"
];
function $7955eeb80a63f070$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7955eeb80a63f070$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7955eeb80a63f070$var$_typeof(o);
}
function $7955eeb80a63f070$var$_extends() {
    $7955eeb80a63f070$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7955eeb80a63f070$var$_extends.apply(this, arguments);
}
function $7955eeb80a63f070$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7955eeb80a63f070$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7955eeb80a63f070$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7955eeb80a63f070$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7955eeb80a63f070$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7955eeb80a63f070$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7955eeb80a63f070$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7955eeb80a63f070$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7955eeb80a63f070$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7955eeb80a63f070$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7955eeb80a63f070$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7955eeb80a63f070$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7955eeb80a63f070$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7955eeb80a63f070$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7955eeb80a63f070$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7955eeb80a63f070$var$_setPrototypeOf(subClass, superClass);
}
function $7955eeb80a63f070$var$_setPrototypeOf(o, p) {
    $7955eeb80a63f070$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7955eeb80a63f070$var$_setPrototypeOf(o, p);
}
function $7955eeb80a63f070$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7955eeb80a63f070$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7955eeb80a63f070$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7955eeb80a63f070$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7955eeb80a63f070$var$_possibleConstructorReturn(this, result);
    };
}
function $7955eeb80a63f070$var$_possibleConstructorReturn(self, call) {
    if (call && ($7955eeb80a63f070$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7955eeb80a63f070$var$_assertThisInitialized(self);
}
function $7955eeb80a63f070$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7955eeb80a63f070$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7955eeb80a63f070$var$_getPrototypeOf(o) {
    $7955eeb80a63f070$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7955eeb80a63f070$var$_getPrototypeOf(o);
}
function $7955eeb80a63f070$var$_defineProperty(obj, key, value) {
    key = $7955eeb80a63f070$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7955eeb80a63f070$var$_toPropertyKey(arg) {
    var key = $7955eeb80a63f070$var$_toPrimitive(arg, "string");
    return $7955eeb80a63f070$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7955eeb80a63f070$var$_toPrimitive(input, hint) {
    if ($7955eeb80a63f070$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7955eeb80a63f070$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $7955eeb80a63f070$export$6440e27b9f186856 = /*#__PURE__*/ function(_PureComponent) {
    $7955eeb80a63f070$var$_inherits(CartesianGrid, _PureComponent);
    var _super = $7955eeb80a63f070$var$_createSuper(CartesianGrid);
    function CartesianGrid() {
        $7955eeb80a63f070$var$_classCallCheck(this, CartesianGrid);
        return _super.apply(this, arguments);
    }
    $7955eeb80a63f070$var$_createClass(CartesianGrid, [
        {
            key: "renderHorizontal",
            value: /**
     * Draw the horizontal grid lines
     * @param {Array} horizontalPoints either passed in as props or generated from function
     * @return {Group} Horizontal lines
     */ function renderHorizontal(horizontalPoints) {
                var _this = this;
                var _this$props = this.props, x = _this$props.x, width = _this$props.width, horizontal = _this$props.horizontal;
                if (!horizontalPoints || !horizontalPoints.length) return null;
                var items = horizontalPoints.map(function(entry, i) {
                    var props = $7955eeb80a63f070$var$_objectSpread($7955eeb80a63f070$var$_objectSpread({}, _this.props), {}, {
                        x1: x,
                        y1: entry,
                        x2: x + width,
                        y2: entry,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(horizontal, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("g", {
                    className: "recharts-cartesian-grid-horizontal"
                }, items);
            }
        },
        {
            key: "renderVertical",
            value: function renderVertical(verticalPoints) {
                var _this2 = this;
                var _this$props2 = this.props, y = _this$props2.y, height = _this$props2.height, vertical = _this$props2.vertical;
                if (!verticalPoints || !verticalPoints.length) return null;
                var items = verticalPoints.map(function(entry, i) {
                    var props = $7955eeb80a63f070$var$_objectSpread($7955eeb80a63f070$var$_objectSpread({}, _this2.props), {}, {
                        x1: entry,
                        y1: y,
                        x2: entry,
                        y2: y + height,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(vertical, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("g", {
                    className: "recharts-cartesian-grid-vertical"
                }, items);
            }
        },
        {
            key: "renderVerticalStripes",
            value: function renderVerticalStripes(verticalPoints) {
                var verticalFill = this.props.verticalFill;
                if (!verticalFill || !verticalFill.length) return null;
                var _this$props3 = this.props, fillOpacity = _this$props3.fillOpacity, x = _this$props3.x, y = _this$props3.y, width = _this$props3.width, height = _this$props3.height;
                var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
                    return Math.round(e + x - x);
                }).sort(function(a, b) {
                    return a - b;
                });
                if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
                var items = roundedSortedVerticalPoints.map(function(entry, i) {
                    var lastStripe = !roundedSortedVerticalPoints[i + 1];
                    var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
                    if (lineWidth <= 0) return null;
                    var colorIndex = i % verticalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        x: entry,
                        y: y,
                        width: lineWidth,
                        height: height,
                        stroke: "none",
                        fill: verticalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-vertical"
                }, items);
            }
        },
        {
            key: "renderHorizontalStripes",
            value: function renderHorizontalStripes(horizontalPoints) {
                var horizontalFill = this.props.horizontalFill;
                if (!horizontalFill || !horizontalFill.length) return null;
                var _this$props4 = this.props, fillOpacity = _this$props4.fillOpacity, x = _this$props4.x, y = _this$props4.y, width = _this$props4.width, height = _this$props4.height;
                var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
                    return Math.round(e + y - y);
                }).sort(function(a, b) {
                    return a - b;
                });
                if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
                var items = roundedSortedHorizontalPoints.map(function(entry, i) {
                    var lastStripe = !roundedSortedHorizontalPoints[i + 1];
                    var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
                    if (lineHeight <= 0) return null;
                    var colorIndex = i % horizontalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        y: entry,
                        x: x,
                        height: lineHeight,
                        width: width,
                        stroke: "none",
                        fill: horizontalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-horizontal"
                }, items);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var fill = this.props.fill;
                if (!fill || fill === "none") return null;
                var _this$props5 = this.props, fillOpacity = _this$props5.fillOpacity, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    stroke: "none",
                    fill: fill,
                    fillOpacity: fillOpacity,
                    className: "recharts-cartesian-grid-bg"
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, horizontal = _this$props6.horizontal, vertical = _this$props6.vertical, horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator, verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, offset = _this$props6.offset, chartWidth = _this$props6.chartWidth, chartHeight = _this$props6.chartHeight, syncWithTicks = _this$props6.syncWithTicks, horizontalValues = _this$props6.horizontalValues, verticalValues = _this$props6.verticalValues;
                if (!(0, $411b8d52505ff75c$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(x) || x !== +x || !(0, $411b8d52505ff75c$export$7e4aa119212bc614)(y) || y !== +y) return null;
                var _this$props7 = this.props, horizontalPoints = _this$props7.horizontalPoints, verticalPoints = _this$props7.verticalPoints;
                // No horizontal points are specified
                if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(horizontalCoordinatesGenerator)) {
                    var isHorizontalValues = horizontalValues && horizontalValues.length;
                    horizontalPoints = horizontalCoordinatesGenerator({
                        yAxis: yAxis ? $7955eeb80a63f070$var$_objectSpread($7955eeb80a63f070$var$_objectSpread({}, yAxis), {}, {
                            ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
                        }) : undefined,
                        width: chartWidth,
                        height: chartHeight,
                        offset: offset
                    }, isHorizontalValues ? true : syncWithTicks);
                }
                // No vertical points are specified
                if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(verticalCoordinatesGenerator)) {
                    var isVerticalValues = verticalValues && verticalValues.length;
                    verticalPoints = verticalCoordinatesGenerator({
                        xAxis: xAxis ? $7955eeb80a63f070$var$_objectSpread($7955eeb80a63f070$var$_objectSpread({}, xAxis), {}, {
                            ticks: isVerticalValues ? verticalValues : xAxis.ticks
                        }) : undefined,
                        width: chartWidth,
                        height: chartHeight,
                        offset: offset
                    }, isVerticalValues ? true : syncWithTicks);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("g", {
                    className: "recharts-cartesian-grid"
                }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
            }
        }
    ], [
        {
            key: "renderLineItem",
            value: function renderLineItem(option, props) {
                var lineItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).isValidElement(option)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e834f6a857d7b3$exports)))(option)) lineItem = option(props);
                else {
                    var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $7955eeb80a63f070$var$_objectWithoutProperties(props, $7955eeb80a63f070$var$_excluded);
                    var _filterProps = (0, $bb4a0676cae5de7b$export$d697c39a2985a4c)(others), __ = _filterProps.offset, restOfFilteredProps = $7955eeb80a63f070$var$_objectWithoutProperties(_filterProps, $7955eeb80a63f070$var$_excluded2);
                    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("line", $7955eeb80a63f070$var$_extends({}, restOfFilteredProps, {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2,
                        fill: "none",
                        key: key
                    }));
                }
                return lineItem;
            }
        }
    ]);
    return CartesianGrid;
}((0, $17VE6.PureComponent));
$7955eeb80a63f070$var$_defineProperty($7955eeb80a63f070$export$6440e27b9f186856, "displayName", "CartesianGrid");
$7955eeb80a63f070$var$_defineProperty($7955eeb80a63f070$export$6440e27b9f186856, "defaultProps", {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: "#ccc",
    fill: "none",
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
});



var $17VE6 = parcelRequire("17VE6");





function $6b4d870d788b1cfb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6b4d870d788b1cfb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6b4d870d788b1cfb$var$_typeof(o);
}
function $6b4d870d788b1cfb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6b4d870d788b1cfb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6b4d870d788b1cfb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6b4d870d788b1cfb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6b4d870d788b1cfb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6b4d870d788b1cfb$var$_defineProperty(obj, key, value) {
    key = $6b4d870d788b1cfb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6b4d870d788b1cfb$var$_toPropertyKey(arg) {
    var key = $6b4d870d788b1cfb$var$_toPrimitive(arg, "string");
    return $6b4d870d788b1cfb$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6b4d870d788b1cfb$var$_toPrimitive(input, hint) {
    if ($6b4d870d788b1cfb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6b4d870d788b1cfb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6b4d870d788b1cfb$var$_slicedToArray(arr, i) {
    return $6b4d870d788b1cfb$var$_arrayWithHoles(arr) || $6b4d870d788b1cfb$var$_iterableToArrayLimit(arr, i) || $6b4d870d788b1cfb$var$_unsupportedIterableToArray(arr, i) || $6b4d870d788b1cfb$var$_nonIterableRest();
}
function $6b4d870d788b1cfb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6b4d870d788b1cfb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6b4d870d788b1cfb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6b4d870d788b1cfb$var$_arrayLikeToArray(o, minLen);
}
function $6b4d870d788b1cfb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6b4d870d788b1cfb$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6b4d870d788b1cfb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $6b4d870d788b1cfb$export$e60a4704009a0009 = /*#__PURE__*/ (0, $17VE6.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? "100%" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "100%" : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, $17VE6.useRef)(null);
    var onResizeRef = (0, $17VE6.useRef)();
    onResizeRef.current = onResize;
    (0, $17VE6.useImperativeHandle)(ref, function() {
        return Object.assign(containerRef.current, {
            get current () {
                // eslint-disable-next-line no-console
                console.warn("The usage of ref.current.current is deprecated and will no longer be supported.");
                return containerRef.current;
            }
        });
    });
    var _useState = (0, $17VE6.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $6b4d870d788b1cfb$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $17VE6.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $17VE6.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($a01f45a78bb58511$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, $17VE6.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $24beccc7a8850989$export$c106dd0671a0fc2d)((0, $411b8d52505ff75c$export$e50269385c77c348)(width) || (0, $411b8d52505ff75c$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $24beccc7a8850989$export$c106dd0671a0fc2d)(!aspect || aspect > 0, "The aspect(%s) must be greater than zero.", aspect);
        var calculatedWidth = (0, $411b8d52505ff75c$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $411b8d52505ff75c$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $24beccc7a8850989$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, $a2a9beb1a93f26ed$exports.isElement)(children) && (0, $bb4a0676cae5de7b$export$be63e0664592e141)(children.type).endsWith("Chart");
        return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).Children.map(children, function(child) {
            if ((0, $a2a9beb1a93f26ed$exports.isElement)(child)) return /*#__PURE__*/ (0, $17VE6.cloneElement)(child, $6b4d870d788b1cfb$var$_objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: $6b4d870d788b1cfb$var$_objectSpread({
                    height: "100%",
                    width: "100%",
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("recharts-responsive-container", className),
        style: $6b4d870d788b1cfb$var$_objectSpread($6b4d870d788b1cfb$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});



var $9NSsB = parcelRequire("9NSsB");
var $b18f0790ad5a1950$exports = {};

//! @version @js-joda/timezone - 2.18.2-2023c
//! @copyright (c) 2015-present, Philipp Thürwächter, Pattrick Hüper & js-joda contributors
//! @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
//! @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
(function(global, factory) {
    factory((parcelRequire("9NSsB")));
})($b18f0790ad5a1950$exports, function(core) {
    "use strict";
    var version = "2023c";
    var zones$1 = [
        "Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
        "Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5",
        "Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
        "Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6",
        "Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
        "Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
        "Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6",
        "Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5",
        "Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3",
        "Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4",
        "Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5",
        "Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|",
        "Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
        "Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5",
        "Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
        "Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|",
        "Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
        "Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
        "Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
        "America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
        "America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
        "America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5",
        "America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
        "America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
        "America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
        "America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
        "America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
        "America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
        "America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
        "America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
        "America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
        "America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
        "America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
        "America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
        "America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
        "America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
        "America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5",
        "America/Bahia_Banderas|LMT MST CST MDT PST CDT|71 70 60 60 80 50|0121312141313131313131313131313131313152525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3",
        "America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
        "America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
        "America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
        "America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3",
        "America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
        "America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5",
        "America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
        "America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
        "America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
        "America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
        "America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5",
        "America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
        "America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
        "America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
        "America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|",
        "America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
        "America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
        "America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
        "America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
        "America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
        "America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2",
        "America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
        "America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
        "America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
        "America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
        "America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
        "America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
        "America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
        "America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
        "America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
        "America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3",
        "America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
        "America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
        "America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
        "America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5",
        "America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4",
        "America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
        "America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
        "America/Hermosillo|LMT MST CST MDT PST|7n.Q 70 60 60 80|0121312141313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
        "America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|01212134121212121212121212121512121212121212121212125212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|01212134121212121212121212121212156565212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
        "America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
        "America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
        "America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
        "America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5",
        "America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
        "America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
        "America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
        "America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
        "America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
        "America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4",
        "America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
        "America/Mazatlan|LMT MST CST MDT PST|75.E 70 60 60 80|0121312141313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4",
        "America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
        "America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5",
        "America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
        "America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
        "America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
        "America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
        "America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5",
        "America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
        "America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
        "America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
        "America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
        "America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
        "America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|012121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0|",
        "America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
        "America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
        "America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
        "America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
        "America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
        "America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
        "America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
        "America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
        "America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
        "America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
        "America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
        "America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
        "America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5",
        "America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
        "America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
        "America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452",
        "America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
        "America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
        "America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
        "America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
        "America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
        "America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
        "America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
        "America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
        "Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10",
        "Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
        "Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4",
        "Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
        "Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
        "Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5",
        "Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
        "Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
        "Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
        "Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40",
        "Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
        "Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5",
        "Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
        "Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5",
        "Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
        "Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
        "Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
        "Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
        "Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
        "Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
        "Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
        "Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
        "Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6",
        "Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
        "Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5",
        "Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
        "Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4",
        "Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6",
        "Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
        "Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
        "Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
        "Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
        "Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
        "Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
        "Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
        "Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
        "Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
        "Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
        "Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|01212121212121212121212121212121212343434343434343434343434343434312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 e10 2L0 WN0 14n0 gN0 5z0 11B0 WL0 e10 bb0 11B0 TX0 e10 dX0 11B0 On0 gN0 gL0 11B0 Lz0 e10 pb0 WN0 IL0 e10 rX0 WN0 Db0 gN0 uL0 11B0 xz0 e10 An0 11B0 rX0 gN0 Db0 11B0 pb0 e10 Lz0 WN0 mn0 e10 On0 WN0 gL0 gN0 Rb0 11B0 bb0 e10 WL0 11B0 5z0 gN0 11z0 11B0 2L0 gN0 14n0 1fB0 1cL0 1a10 1fz0 14p0 1lb0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 e10 28L0 e10 25X0 gN0 25X0 e10 gL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5",
        "Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 e10 2L0 WN0 14n0 gN0 5z0 11B0 WL0 e10 bb0 11B0 TX0 e10 dX0 11B0 On0 gN0 gL0 11B0 Lz0 e10 pb0 WN0 IL0 e10 rX0 WN0 Db0 gN0 uL0 11B0 xz0 e10 An0 11B0 rX0 gN0 Db0 11B0 pb0 e10 Lz0 WN0 mn0 e10 On0 WN0 gL0 gN0 Rb0 11B0 bb0 e10 WL0 11B0 5z0 gN0 11z0 11B0 2L0 gN0 14n0 1fB0 1cL0 1a10 1fz0 14p0 1lb0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 e10 28L0 e10 25X0 gN0 25X0 e10 gL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4",
        "Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
        "Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
        "Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
        "Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
        "Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
        "Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
        "Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
        "Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4",
        "Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5",
        "Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
        "Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
        "Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
        "Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
        "Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
        "Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5",
        "Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
        "Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
        "Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
        "Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
        "Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4",
        "Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
        "Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
        "Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
        "Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
        "Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
        "Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
        "Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
        "Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
        "Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5",
        "Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
        "Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
        "Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
        "Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
        "Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
        "Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
        "Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
        "Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
        "Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
        "Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
        "Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
        "Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
        "Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
        "Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
        "Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
        "Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
        "Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
        "Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4",
        "Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
        "Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
        "Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
        "Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3",
        "Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4",
        "Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30",
        "Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
        "Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5",
        "Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5",
        "Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
        "Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3",
        "Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4",
        "Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4",
        "Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
        "Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347",
        "Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
        "Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5",
        "Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
        "CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
        "Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2",
        "CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
        "Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
        "EST|EST|50|0||",
        "EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "Etc/GMT-0|GMT|0|0||",
        "Etc/GMT-1|+01|-10|0||",
        "Etc/GMT-10|+10|-a0|0||",
        "Etc/GMT-11|+11|-b0|0||",
        "Etc/GMT-12|+12|-c0|0||",
        "Etc/GMT-13|+13|-d0|0||",
        "Etc/GMT-14|+14|-e0|0||",
        "Etc/GMT-2|+02|-20|0||",
        "Etc/GMT-3|+03|-30|0||",
        "Etc/GMT-4|+04|-40|0||",
        "Etc/GMT-5|+05|-50|0||",
        "Etc/GMT-6|+06|-60|0||",
        "Etc/GMT-7|+07|-70|0||",
        "Etc/GMT-8|+08|-80|0||",
        "Etc/GMT-9|+09|-90|0||",
        "Etc/GMT+1|-01|10|0||",
        "Etc/GMT+10|-10|a0|0||",
        "Etc/GMT+11|-11|b0|0||",
        "Etc/GMT+12|-12|c0|0||",
        "Etc/GMT+2|-02|20|0||",
        "Etc/GMT+3|-03|30|0||",
        "Etc/GMT+4|-04|40|0||",
        "Etc/GMT+5|-05|50|0||",
        "Etc/GMT+6|-06|60|0||",
        "Etc/GMT+7|-07|70|0||",
        "Etc/GMT+8|-08|80|0||",
        "Etc/GMT+9|-09|90|0||",
        "Etc/UCT|UTC|0|0||",
        "Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5",
        "Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3",
        "Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
        "Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5",
        "Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6",
        "Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
        "Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5",
        "Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5",
        "Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
        "Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4",
        "Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4",
        "Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3",
        "Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
        "Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
        "Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5",
        "Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
        "Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
        "Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5",
        "Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
        "Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
        "Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6",
        "Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
        "Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4",
        "Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5",
        "Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
        "Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
        "Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
        "Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
        "Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4",
        "Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
        "Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
        "Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5",
        "Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
        "Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5",
        "Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
        "HST|HST|a0|0||",
        "Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
        "Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4",
        "Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
        "Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3",
        "MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
        "MST|MST|70|0||",
        "MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600",
        "Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3",
        "Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4",
        "Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
        "Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1",
        "Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483",
        "Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4",
        "Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3",
        "Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
        "Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
        "Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
        "Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
        "Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4",
        "Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2",
        "Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
        "Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
        "Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2",
        "Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
        "Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2",
        "Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4",
        "Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
        "Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3",
        "Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56",
        "Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
        "Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
        "Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
        "PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
        "WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|"
    ];
    var links$1 = [
        "Africa/Abidjan|Africa/Accra",
        "Africa/Abidjan|Africa/Bamako",
        "Africa/Abidjan|Africa/Banjul",
        "Africa/Abidjan|Africa/Conakry",
        "Africa/Abidjan|Africa/Dakar",
        "Africa/Abidjan|Africa/Freetown",
        "Africa/Abidjan|Africa/Lome",
        "Africa/Abidjan|Africa/Nouakchott",
        "Africa/Abidjan|Africa/Ouagadougou",
        "Africa/Abidjan|Africa/Timbuktu",
        "Africa/Abidjan|Atlantic/Reykjavik",
        "Africa/Abidjan|Atlantic/St_Helena",
        "Africa/Abidjan|Iceland",
        "Africa/Cairo|Egypt",
        "Africa/Johannesburg|Africa/Maseru",
        "Africa/Johannesburg|Africa/Mbabane",
        "Africa/Lagos|Africa/Bangui",
        "Africa/Lagos|Africa/Brazzaville",
        "Africa/Lagos|Africa/Douala",
        "Africa/Lagos|Africa/Kinshasa",
        "Africa/Lagos|Africa/Libreville",
        "Africa/Lagos|Africa/Luanda",
        "Africa/Lagos|Africa/Malabo",
        "Africa/Lagos|Africa/Niamey",
        "Africa/Lagos|Africa/Porto-Novo",
        "Africa/Maputo|Africa/Blantyre",
        "Africa/Maputo|Africa/Bujumbura",
        "Africa/Maputo|Africa/Gaborone",
        "Africa/Maputo|Africa/Harare",
        "Africa/Maputo|Africa/Kigali",
        "Africa/Maputo|Africa/Lubumbashi",
        "Africa/Maputo|Africa/Lusaka",
        "Africa/Nairobi|Africa/Addis_Ababa",
        "Africa/Nairobi|Africa/Asmara",
        "Africa/Nairobi|Africa/Asmera",
        "Africa/Nairobi|Africa/Dar_es_Salaam",
        "Africa/Nairobi|Africa/Djibouti",
        "Africa/Nairobi|Africa/Kampala",
        "Africa/Nairobi|Africa/Mogadishu",
        "Africa/Nairobi|Indian/Antananarivo",
        "Africa/Nairobi|Indian/Comoro",
        "Africa/Nairobi|Indian/Mayotte",
        "Africa/Tripoli|Libya",
        "America/Adak|America/Atka",
        "America/Adak|US/Aleutian",
        "America/Anchorage|US/Alaska",
        "America/Argentina/Buenos_Aires|America/Buenos_Aires",
        "America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
        "America/Argentina/Catamarca|America/Catamarca",
        "America/Argentina/Cordoba|America/Cordoba",
        "America/Argentina/Cordoba|America/Rosario",
        "America/Argentina/Jujuy|America/Jujuy",
        "America/Argentina/Mendoza|America/Mendoza",
        "America/Chicago|US/Central",
        "America/Denver|America/Shiprock",
        "America/Denver|Navajo",
        "America/Denver|US/Mountain",
        "America/Detroit|US/Michigan",
        "America/Edmonton|America/Yellowknife",
        "America/Edmonton|Canada/Mountain",
        "America/Fort_Wayne|America/Indiana/Indianapolis",
        "America/Fort_Wayne|America/Indianapolis",
        "America/Fort_Wayne|US/East-Indiana",
        "America/Godthab|America/Nuuk",
        "America/Halifax|Canada/Atlantic",
        "America/Havana|Cuba",
        "America/Indiana/Knox|America/Knox_IN",
        "America/Indiana/Knox|US/Indiana-Starke",
        "America/Iqaluit|America/Pangnirtung",
        "America/Jamaica|Jamaica",
        "America/Kentucky/Louisville|America/Louisville",
        "America/Los_Angeles|US/Pacific",
        "America/Manaus|Brazil/West",
        "America/Mazatlan|Mexico/BajaSur",
        "America/Mexico_City|Mexico/General",
        "America/New_York|US/Eastern",
        "America/Noronha|Brazil/DeNoronha",
        "America/Panama|America/Atikokan",
        "America/Panama|America/Cayman",
        "America/Panama|America/Coral_Harbour",
        "America/Phoenix|America/Creston",
        "America/Phoenix|US/Arizona",
        "America/Puerto_Rico|America/Anguilla",
        "America/Puerto_Rico|America/Antigua",
        "America/Puerto_Rico|America/Aruba",
        "America/Puerto_Rico|America/Blanc-Sablon",
        "America/Puerto_Rico|America/Curacao",
        "America/Puerto_Rico|America/Dominica",
        "America/Puerto_Rico|America/Grenada",
        "America/Puerto_Rico|America/Guadeloupe",
        "America/Puerto_Rico|America/Kralendijk",
        "America/Puerto_Rico|America/Lower_Princes",
        "America/Puerto_Rico|America/Marigot",
        "America/Puerto_Rico|America/Montserrat",
        "America/Puerto_Rico|America/Port_of_Spain",
        "America/Puerto_Rico|America/St_Barthelemy",
        "America/Puerto_Rico|America/St_Kitts",
        "America/Puerto_Rico|America/St_Lucia",
        "America/Puerto_Rico|America/St_Thomas",
        "America/Puerto_Rico|America/St_Vincent",
        "America/Puerto_Rico|America/Tortola",
        "America/Puerto_Rico|America/Virgin",
        "America/Regina|Canada/Saskatchewan",
        "America/Rio_Branco|America/Porto_Acre",
        "America/Rio_Branco|Brazil/Acre",
        "America/Santiago|Chile/Continental",
        "America/Sao_Paulo|Brazil/East",
        "America/St_Johns|Canada/Newfoundland",
        "America/Tijuana|America/Ensenada",
        "America/Tijuana|America/Santa_Isabel",
        "America/Tijuana|Mexico/BajaNorte",
        "America/Toronto|America/Montreal",
        "America/Toronto|America/Nassau",
        "America/Toronto|America/Nipigon",
        "America/Toronto|America/Thunder_Bay",
        "America/Toronto|Canada/Eastern",
        "America/Vancouver|Canada/Pacific",
        "America/Whitehorse|Canada/Yukon",
        "America/Winnipeg|America/Rainy_River",
        "America/Winnipeg|Canada/Central",
        "Asia/Ashgabat|Asia/Ashkhabad",
        "Asia/Bangkok|Asia/Phnom_Penh",
        "Asia/Bangkok|Asia/Vientiane",
        "Asia/Bangkok|Indian/Christmas",
        "Asia/Brunei|Asia/Kuching",
        "Asia/Dhaka|Asia/Dacca",
        "Asia/Dubai|Asia/Muscat",
        "Asia/Dubai|Indian/Mahe",
        "Asia/Dubai|Indian/Reunion",
        "Asia/Ho_Chi_Minh|Asia/Saigon",
        "Asia/Hong_Kong|Hongkong",
        "Asia/Jerusalem|Asia/Tel_Aviv",
        "Asia/Jerusalem|Israel",
        "Asia/Kathmandu|Asia/Katmandu",
        "Asia/Kolkata|Asia/Calcutta",
        "Asia/Kuala_Lumpur|Asia/Singapore",
        "Asia/Kuala_Lumpur|Singapore",
        "Asia/Macau|Asia/Macao",
        "Asia/Makassar|Asia/Ujung_Pandang",
        "Asia/Nicosia|Europe/Nicosia",
        "Asia/Qatar|Asia/Bahrain",
        "Asia/Rangoon|Asia/Yangon",
        "Asia/Rangoon|Indian/Cocos",
        "Asia/Riyadh|Antarctica/Syowa",
        "Asia/Riyadh|Asia/Aden",
        "Asia/Riyadh|Asia/Kuwait",
        "Asia/Seoul|ROK",
        "Asia/Shanghai|Asia/Chongqing",
        "Asia/Shanghai|Asia/Chungking",
        "Asia/Shanghai|Asia/Harbin",
        "Asia/Shanghai|PRC",
        "Asia/Taipei|ROC",
        "Asia/Tehran|Iran",
        "Asia/Thimphu|Asia/Thimbu",
        "Asia/Tokyo|Japan",
        "Asia/Ulaanbaatar|Asia/Ulan_Bator",
        "Asia/Urumqi|Antarctica/Vostok",
        "Asia/Urumqi|Asia/Kashgar",
        "Atlantic/Faroe|Atlantic/Faeroe",
        "Australia/Adelaide|Australia/South",
        "Australia/Brisbane|Australia/Queensland",
        "Australia/Broken_Hill|Australia/Yancowinna",
        "Australia/Darwin|Australia/North",
        "Australia/Hobart|Australia/Currie",
        "Australia/Hobart|Australia/Tasmania",
        "Australia/Lord_Howe|Australia/LHI",
        "Australia/Melbourne|Australia/Victoria",
        "Australia/Perth|Australia/West",
        "Australia/Sydney|Australia/ACT",
        "Australia/Sydney|Australia/Canberra",
        "Australia/Sydney|Australia/NSW",
        "Etc/GMT-0|Etc/GMT",
        "Etc/GMT-0|Etc/GMT+0",
        "Etc/GMT-0|Etc/GMT0",
        "Etc/GMT-0|Etc/Greenwich",
        "Etc/GMT-0|GMT",
        "Etc/GMT-0|GMT+0",
        "Etc/GMT-0|GMT-0",
        "Etc/GMT-0|GMT0",
        "Etc/GMT-0|Greenwich",
        "Etc/UCT|Etc/UTC",
        "Etc/UCT|Etc/Universal",
        "Etc/UCT|Etc/Zulu",
        "Etc/UCT|UCT",
        "Etc/UCT|UTC",
        "Etc/UCT|Universal",
        "Etc/UCT|Zulu",
        "Europe/Belgrade|Europe/Ljubljana",
        "Europe/Belgrade|Europe/Podgorica",
        "Europe/Belgrade|Europe/Sarajevo",
        "Europe/Belgrade|Europe/Skopje",
        "Europe/Belgrade|Europe/Zagreb",
        "Europe/Berlin|Arctic/Longyearbyen",
        "Europe/Berlin|Atlantic/Jan_Mayen",
        "Europe/Berlin|Europe/Copenhagen",
        "Europe/Berlin|Europe/Oslo",
        "Europe/Berlin|Europe/Stockholm",
        "Europe/Brussels|Europe/Amsterdam",
        "Europe/Brussels|Europe/Luxembourg",
        "Europe/Chisinau|Europe/Tiraspol",
        "Europe/Dublin|Eire",
        "Europe/Helsinki|Europe/Mariehamn",
        "Europe/Istanbul|Asia/Istanbul",
        "Europe/Istanbul|Turkey",
        "Europe/Kiev|Europe/Kyiv",
        "Europe/Kiev|Europe/Uzhgorod",
        "Europe/Kiev|Europe/Zaporozhye",
        "Europe/Lisbon|Portugal",
        "Europe/London|Europe/Belfast",
        "Europe/London|Europe/Guernsey",
        "Europe/London|Europe/Isle_of_Man",
        "Europe/London|Europe/Jersey",
        "Europe/London|GB",
        "Europe/London|GB-Eire",
        "Europe/Moscow|W-SU",
        "Europe/Paris|Europe/Monaco",
        "Europe/Prague|Europe/Bratislava",
        "Europe/Rome|Europe/San_Marino",
        "Europe/Rome|Europe/Vatican",
        "Europe/Warsaw|Poland",
        "Europe/Zurich|Europe/Busingen",
        "Europe/Zurich|Europe/Vaduz",
        "Indian/Maldives|Indian/Kerguelen",
        "Pacific/Auckland|Antarctica/McMurdo",
        "Pacific/Auckland|Antarctica/South_Pole",
        "Pacific/Auckland|NZ",
        "Pacific/Chatham|NZ-CHAT",
        "Pacific/Easter|Chile/EasterIsland",
        "Pacific/Enderbury|Pacific/Kanton",
        "Pacific/Guadalcanal|Pacific/Pohnpei",
        "Pacific/Guadalcanal|Pacific/Ponape",
        "Pacific/Guam|Pacific/Saipan",
        "Pacific/Honolulu|Pacific/Johnston",
        "Pacific/Honolulu|US/Hawaii",
        "Pacific/Kwajalein|Kwajalein",
        "Pacific/Pago_Pago|Pacific/Midway",
        "Pacific/Pago_Pago|Pacific/Samoa",
        "Pacific/Pago_Pago|US/Samoa",
        "Pacific/Port_Moresby|Antarctica/DumontDUrville",
        "Pacific/Port_Moresby|Pacific/Chuuk",
        "Pacific/Port_Moresby|Pacific/Truk",
        "Pacific/Port_Moresby|Pacific/Yap",
        "Pacific/Tarawa|Pacific/Funafuti",
        "Pacific/Tarawa|Pacific/Majuro",
        "Pacific/Tarawa|Pacific/Wake",
        "Pacific/Tarawa|Pacific/Wallis"
    ];
    var countries = [
        "AD|Europe/Andorra",
        "AE|Asia/Dubai",
        "AF|Asia/Kabul",
        "AG|America/Puerto_Rico America/Antigua",
        "AI|America/Puerto_Rico America/Anguilla",
        "AL|Europe/Tirane",
        "AM|Asia/Yerevan",
        "AO|Africa/Lagos Africa/Luanda",
        "AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Asia/Urumqi Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa Antarctica/Vostok",
        "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
        "AS|Pacific/Pago_Pago",
        "AT|Europe/Vienna",
        "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
        "AW|America/Puerto_Rico America/Aruba",
        "AX|Europe/Helsinki Europe/Mariehamn",
        "AZ|Asia/Baku",
        "BA|Europe/Belgrade Europe/Sarajevo",
        "BB|America/Barbados",
        "BD|Asia/Dhaka",
        "BE|Europe/Brussels",
        "BF|Africa/Abidjan Africa/Ouagadougou",
        "BG|Europe/Sofia",
        "BH|Asia/Qatar Asia/Bahrain",
        "BI|Africa/Maputo Africa/Bujumbura",
        "BJ|Africa/Lagos Africa/Porto-Novo",
        "BL|America/Puerto_Rico America/St_Barthelemy",
        "BM|Atlantic/Bermuda",
        "BN|Asia/Kuching Asia/Brunei",
        "BO|America/La_Paz",
        "BQ|America/Puerto_Rico America/Kralendijk",
        "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
        "BS|America/Toronto America/Nassau",
        "BT|Asia/Thimphu",
        "BW|Africa/Maputo Africa/Gaborone",
        "BY|Europe/Minsk",
        "BZ|America/Belize",
        "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston",
        "CC|Asia/Yangon Indian/Cocos",
        "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
        "CF|Africa/Lagos Africa/Bangui",
        "CG|Africa/Lagos Africa/Brazzaville",
        "CH|Europe/Zurich",
        "CI|Africa/Abidjan",
        "CK|Pacific/Rarotonga",
        "CL|America/Santiago America/Punta_Arenas Pacific/Easter",
        "CM|Africa/Lagos Africa/Douala",
        "CN|Asia/Shanghai Asia/Urumqi",
        "CO|America/Bogota",
        "CR|America/Costa_Rica",
        "CU|America/Havana",
        "CV|Atlantic/Cape_Verde",
        "CW|America/Puerto_Rico America/Curacao",
        "CX|Asia/Bangkok Indian/Christmas",
        "CY|Asia/Nicosia Asia/Famagusta",
        "CZ|Europe/Prague",
        "DE|Europe/Zurich Europe/Berlin Europe/Busingen",
        "DJ|Africa/Nairobi Africa/Djibouti",
        "DK|Europe/Berlin Europe/Copenhagen",
        "DM|America/Puerto_Rico America/Dominica",
        "DO|America/Santo_Domingo",
        "DZ|Africa/Algiers",
        "EC|America/Guayaquil Pacific/Galapagos",
        "EE|Europe/Tallinn",
        "EG|Africa/Cairo",
        "EH|Africa/El_Aaiun",
        "ER|Africa/Nairobi Africa/Asmara",
        "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
        "ET|Africa/Nairobi Africa/Addis_Ababa",
        "FI|Europe/Helsinki",
        "FJ|Pacific/Fiji",
        "FK|Atlantic/Stanley",
        "FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei",
        "FO|Atlantic/Faroe",
        "FR|Europe/Paris",
        "GA|Africa/Lagos Africa/Libreville",
        "GB|Europe/London",
        "GD|America/Puerto_Rico America/Grenada",
        "GE|Asia/Tbilisi",
        "GF|America/Cayenne",
        "GG|Europe/London Europe/Guernsey",
        "GH|Africa/Abidjan Africa/Accra",
        "GI|Europe/Gibraltar",
        "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
        "GM|Africa/Abidjan Africa/Banjul",
        "GN|Africa/Abidjan Africa/Conakry",
        "GP|America/Puerto_Rico America/Guadeloupe",
        "GQ|Africa/Lagos Africa/Malabo",
        "GR|Europe/Athens",
        "GS|Atlantic/South_Georgia",
        "GT|America/Guatemala",
        "GU|Pacific/Guam",
        "GW|Africa/Bissau",
        "GY|America/Guyana",
        "HK|Asia/Hong_Kong",
        "HN|America/Tegucigalpa",
        "HR|Europe/Belgrade Europe/Zagreb",
        "HT|America/Port-au-Prince",
        "HU|Europe/Budapest",
        "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
        "IE|Europe/Dublin",
        "IL|Asia/Jerusalem",
        "IM|Europe/London Europe/Isle_of_Man",
        "IN|Asia/Kolkata",
        "IO|Indian/Chagos",
        "IQ|Asia/Baghdad",
        "IR|Asia/Tehran",
        "IS|Africa/Abidjan Atlantic/Reykjavik",
        "IT|Europe/Rome",
        "JE|Europe/London Europe/Jersey",
        "JM|America/Jamaica",
        "JO|Asia/Amman",
        "JP|Asia/Tokyo",
        "KE|Africa/Nairobi",
        "KG|Asia/Bishkek",
        "KH|Asia/Bangkok Asia/Phnom_Penh",
        "KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati",
        "KM|Africa/Nairobi Indian/Comoro",
        "KN|America/Puerto_Rico America/St_Kitts",
        "KP|Asia/Pyongyang",
        "KR|Asia/Seoul",
        "KW|Asia/Riyadh Asia/Kuwait",
        "KY|America/Panama America/Cayman",
        "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
        "LA|Asia/Bangkok Asia/Vientiane",
        "LB|Asia/Beirut",
        "LC|America/Puerto_Rico America/St_Lucia",
        "LI|Europe/Zurich Europe/Vaduz",
        "LK|Asia/Colombo",
        "LR|Africa/Monrovia",
        "LS|Africa/Johannesburg Africa/Maseru",
        "LT|Europe/Vilnius",
        "LU|Europe/Brussels Europe/Luxembourg",
        "LV|Europe/Riga",
        "LY|Africa/Tripoli",
        "MA|Africa/Casablanca",
        "MC|Europe/Paris Europe/Monaco",
        "MD|Europe/Chisinau",
        "ME|Europe/Belgrade Europe/Podgorica",
        "MF|America/Puerto_Rico America/Marigot",
        "MG|Africa/Nairobi Indian/Antananarivo",
        "MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro",
        "MK|Europe/Belgrade Europe/Skopje",
        "ML|Africa/Abidjan Africa/Bamako",
        "MM|Asia/Yangon",
        "MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
        "MO|Asia/Macau",
        "MP|Pacific/Guam Pacific/Saipan",
        "MQ|America/Martinique",
        "MR|Africa/Abidjan Africa/Nouakchott",
        "MS|America/Puerto_Rico America/Montserrat",
        "MT|Europe/Malta",
        "MU|Indian/Mauritius",
        "MV|Indian/Maldives",
        "MW|Africa/Maputo Africa/Blantyre",
        "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana",
        "MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur",
        "MZ|Africa/Maputo",
        "NA|Africa/Windhoek",
        "NC|Pacific/Noumea",
        "NE|Africa/Lagos Africa/Niamey",
        "NF|Pacific/Norfolk",
        "NG|Africa/Lagos",
        "NI|America/Managua",
        "NL|Europe/Brussels Europe/Amsterdam",
        "NO|Europe/Berlin Europe/Oslo",
        "NP|Asia/Kathmandu",
        "NR|Pacific/Nauru",
        "NU|Pacific/Niue",
        "NZ|Pacific/Auckland Pacific/Chatham",
        "OM|Asia/Dubai Asia/Muscat",
        "PA|America/Panama",
        "PE|America/Lima",
        "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
        "PG|Pacific/Port_Moresby Pacific/Bougainville",
        "PH|Asia/Manila",
        "PK|Asia/Karachi",
        "PL|Europe/Warsaw",
        "PM|America/Miquelon",
        "PN|Pacific/Pitcairn",
        "PR|America/Puerto_Rico",
        "PS|Asia/Gaza Asia/Hebron",
        "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
        "PW|Pacific/Palau",
        "PY|America/Asuncion",
        "QA|Asia/Qatar",
        "RE|Asia/Dubai Indian/Reunion",
        "RO|Europe/Bucharest",
        "RS|Europe/Belgrade",
        "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
        "RW|Africa/Maputo Africa/Kigali",
        "SA|Asia/Riyadh",
        "SB|Pacific/Guadalcanal",
        "SC|Asia/Dubai Indian/Mahe",
        "SD|Africa/Khartoum",
        "SE|Europe/Berlin Europe/Stockholm",
        "SG|Asia/Singapore",
        "SH|Africa/Abidjan Atlantic/St_Helena",
        "SI|Europe/Belgrade Europe/Ljubljana",
        "SJ|Europe/Berlin Arctic/Longyearbyen",
        "SK|Europe/Prague Europe/Bratislava",
        "SL|Africa/Abidjan Africa/Freetown",
        "SM|Europe/Rome Europe/San_Marino",
        "SN|Africa/Abidjan Africa/Dakar",
        "SO|Africa/Nairobi Africa/Mogadishu",
        "SR|America/Paramaribo",
        "SS|Africa/Juba",
        "ST|Africa/Sao_Tome",
        "SV|America/El_Salvador",
        "SX|America/Puerto_Rico America/Lower_Princes",
        "SY|Asia/Damascus",
        "SZ|Africa/Johannesburg Africa/Mbabane",
        "TC|America/Grand_Turk",
        "TD|Africa/Ndjamena",
        "TF|Asia/Dubai Indian/Maldives Indian/Kerguelen",
        "TG|Africa/Abidjan Africa/Lome",
        "TH|Asia/Bangkok",
        "TJ|Asia/Dushanbe",
        "TK|Pacific/Fakaofo",
        "TL|Asia/Dili",
        "TM|Asia/Ashgabat",
        "TN|Africa/Tunis",
        "TO|Pacific/Tongatapu",
        "TR|Europe/Istanbul",
        "TT|America/Puerto_Rico America/Port_of_Spain",
        "TV|Pacific/Tarawa Pacific/Funafuti",
        "TW|Asia/Taipei",
        "TZ|Africa/Nairobi Africa/Dar_es_Salaam",
        "UA|Europe/Simferopol Europe/Kyiv",
        "UG|Africa/Nairobi Africa/Kampala",
        "UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake",
        "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
        "UY|America/Montevideo",
        "UZ|Asia/Samarkand Asia/Tashkent",
        "VA|Europe/Rome Europe/Vatican",
        "VC|America/Puerto_Rico America/St_Vincent",
        "VE|America/Caracas",
        "VG|America/Puerto_Rico America/Tortola",
        "VI|America/Puerto_Rico America/St_Thomas",
        "VN|Asia/Bangkok Asia/Ho_Chi_Minh",
        "VU|Pacific/Efate",
        "WF|Pacific/Tarawa Pacific/Wallis",
        "WS|Pacific/Apia",
        "YE|Asia/Riyadh Asia/Aden",
        "YT|Africa/Nairobi Indian/Mayotte",
        "ZA|Africa/Johannesburg",
        "ZM|Africa/Maputo Africa/Lusaka",
        "ZW|Africa/Maputo Africa/Harare"
    ];
    var latest = {
        version: version,
        zones: zones$1,
        links: links$1,
        countries: countries
    };
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _createForOfIteratorHelperLoose(o, allowArrayLike) {
        var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
        if (it) return (it = it.call(o)).next.bind(it);
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var MomentZoneRules = function(_ZoneRules) {
        _inheritsLoose(MomentZoneRules, _ZoneRules);
        function MomentZoneRules(tzdbInfo) {
            var _this;
            _this = _ZoneRules.call(this) || this;
            _this._tzdbInfo = tzdbInfo;
            _this._ldtUntils = new LDTUntils(_this._tzdbInfo.untils, _this._tzdbInfo.offsets);
            return _this;
        }
        var _proto = MomentZoneRules.prototype;
        _proto.isFixedOffset = function isFixedOffset() {
            return this._tzdbInfo.offsets.length === 1;
        };
        _proto.offsetOfInstant = function offsetOfInstant(instant) {
            var epochMilli = instant.toEpochMilli();
            return this.offsetOfEpochMilli(epochMilli);
        };
        _proto.offsetOfEpochMilli = function offsetOfEpochMilli(epochMilli) {
            var index = binarySearch(this._tzdbInfo.untils, epochMilli);
            return core.ZoneOffset.ofTotalSeconds(this._offsetByIndexInSeconds(index));
        };
        _proto.offsetOfLocalDateTime = function offsetOfLocalDateTime(localDateTime) {
            var info = this._offsetInfo(localDateTime);
            if (info instanceof core.ZoneOffsetTransition) return info.offsetBefore();
            return info;
        };
        _proto._offsetInfo = function _offsetInfo(localDateTime) {
            var index = ldtBinarySearch(this._ldtUntils, localDateTime);
            var offsetIndex = index >> 1;
            if (index % 2 === 1) {
                var ldtBefore = this._ldtUntils.get(Math.max(index - 1, 0));
                var ldtAfter = this._ldtUntils.get(Math.min(index, this._ldtUntils.size - 1));
                var offsetBefore = core.ZoneOffset.ofTotalSeconds(this._offsetByIndexInSeconds(offsetIndex));
                var offsetAfter = core.ZoneOffset.ofTotalSeconds(this._offsetByIndexInSeconds(Math.min(offsetIndex + 1, this._tzdbInfo.offsets.length - 1)));
                if (offsetBefore.compareTo(offsetAfter) > 0) return core.ZoneOffsetTransition.of(ldtBefore, offsetBefore, offsetAfter);
                else return core.ZoneOffsetTransition.of(ldtAfter, offsetBefore, offsetAfter);
            }
            return core.ZoneOffset.ofTotalSeconds(this._offsetByIndexInSeconds(offsetIndex));
        };
        _proto._offsetByIndexInSeconds = function _offsetByIndexInSeconds(index) {
            return -offsetInSeconds(this._tzdbInfo.offsets[index]);
        };
        _proto.validOffsets = function validOffsets(localDateTime) {
            var info = this._offsetInfo(localDateTime);
            if (info instanceof core.ZoneOffsetTransition) return info.validOffsets();
            return [
                info
            ];
        };
        _proto.transition = function transition(localDateTime) {
            var info = this._offsetInfo(localDateTime);
            if (info instanceof core.ZoneOffsetTransition) return info;
            return null;
        };
        _proto.standardOffset = function standardOffset(instant) {
            notSupported("ZoneRules.standardOffset");
        };
        _proto.daylightSavings = function daylightSavings(instant) {
            notSupported("ZoneRules.daylightSavings");
        };
        _proto.isDaylightSavings = function isDaylightSavings(instant) {
            notSupported("ZoneRules.isDaylightSavings");
        };
        _proto.isValidOffset = function isValidOffset(localDateTime, offset) {
            return this.validOffsets(localDateTime).some(function(o) {
                return o.equals(offset);
            });
        };
        _proto.nextTransition = function nextTransition(instant) {
            notSupported("ZoneRules.nextTransition");
        };
        _proto.previousTransition = function previousTransition(instant) {
            notSupported("ZoneRules.previousTransition");
        };
        _proto.transitions = function transitions() {
            notSupported("ZoneRules.transitions");
        };
        _proto.transitionRules = function transitionRules() {
            notSupported("ZoneRules.transitionRules");
        };
        _proto.equals = function equals(other) {
            if (this === other) return true;
            if (other instanceof MomentZoneRules) return this._tzdbInfo === other._tzdbInfo;
            return false;
        };
        _proto.toString = function toString() {
            return this._tzdbInfo.name;
        };
        return MomentZoneRules;
    }(core.ZoneRules);
    var LDTUntils = function() {
        function LDTUntils(_tzdbUntils, tzdbOffsets) {
            this._tzdbUntils = _tzdbUntils;
            this._tzdbOffsets = tzdbOffsets;
            this._ldtUntils = [];
            this.size = this._tzdbUntils.length * 2;
        }
        var _proto2 = LDTUntils.prototype;
        _proto2._generateTupple = function _generateTupple(index) {
            var epochMillis = this._tzdbUntils[index];
            if (epochMillis === Infinity) return [
                core.LocalDateTime.MAX,
                core.LocalDateTime.MAX
            ];
            var instant = core.Instant.ofEpochMilli(epochMillis);
            var offset1 = offsetInSeconds(this._tzdbOffsets[index]);
            var zone1 = core.ZoneOffset.ofTotalSeconds(-offset1);
            var ldt1 = core.LocalDateTime.ofInstant(instant, zone1);
            var nextIndex = Math.min(index + 1, this._tzdbOffsets.length - 1);
            var offset2 = offsetInSeconds(this._tzdbOffsets[nextIndex]);
            var zone2 = core.ZoneOffset.ofTotalSeconds(-offset2);
            var ldt2 = core.LocalDateTime.ofInstant(instant, zone2);
            if (offset1 > offset2) return [
                ldt1,
                ldt2
            ];
            else return [
                ldt2,
                ldt1
            ];
        };
        _proto2._getTupple = function _getTupple(index) {
            if (this._ldtUntils[index] == null) this._ldtUntils[index] = this._generateTupple(index);
            return this._ldtUntils[index];
        };
        _proto2.get = function get(index) {
            var ldtTupple = this._getTupple(index >> 1);
            return ldtTupple[index % 2];
        };
        return LDTUntils;
    }();
    function ldtBinarySearch(array, value) {
        var hi = array.size - 1, lo = -1, mid;
        while(hi - lo > 1)if (!value.isBefore(array.get(mid = hi + lo >> 1))) lo = mid;
        else hi = mid;
        return hi;
    }
    function offsetInSeconds(tzdbOffset) {
        return roundDown(+tzdbOffset * 60);
    }
    function roundDown(r) {
        if (r < 0) return Math.ceil(r);
        else return Math.floor(r);
    }
    function binarySearch(array, value) {
        var hi = array.length - 1, lo = -1, mid;
        while(hi - lo > 1)if (array[mid = hi + lo >> 1] <= value) lo = mid;
        else hi = mid;
        return hi;
    }
    function notSupported(msg) {
        throw new Error("not supported: " + msg);
    }
    function charCodeToInt(charCode) {
        if (charCode > 96) return charCode - 87;
        else if (charCode > 64) return charCode - 29;
        return charCode - 48;
    }
    function unpackBase60(string) {
        var i = 0, parts = string.split("."), whole = parts[0], fractional = parts[1] || "", multiplier = 1, num, out = 0, sign = 1;
        if (string.charCodeAt(0) === 45) {
            i = 1;
            sign = -1;
        }
        for(i; i < whole.length; i++){
            num = charCodeToInt(whole.charCodeAt(i));
            out = 60 * out + num;
        }
        for(i = 0; i < fractional.length; i++){
            multiplier = multiplier / 60;
            num = charCodeToInt(fractional.charCodeAt(i));
            out += num * multiplier;
        }
        return out * sign;
    }
    function arrayToInt(array) {
        for(var i = 0; i < array.length; i++)array[i] = unpackBase60(array[i]);
    }
    function intToUntil(array, length) {
        for(var i = 0; i < length; i++)array[i] = Math.round((array[i - 1] || 0) + array[i] * 60000);
        array[length - 1] = Infinity;
    }
    function mapIndices(source, indices) {
        var out = [], i;
        for(i = 0; i < indices.length; i++)out[i] = source[indices[i]];
        return out;
    }
    function unpack(string) {
        var data = string.split("|"), offsets = data[2].split(" "), indices = data[3].split(""), untils = data[4].split(" ");
        arrayToInt(offsets);
        arrayToInt(indices);
        arrayToInt(untils);
        intToUntil(untils, indices.length);
        return {
            name: data[0],
            abbrs: mapIndices(data[1].split(" "), indices),
            offsets: mapIndices(offsets, indices),
            untils: untils,
            population: data[5] | 0
        };
    }
    var TZDB_DATA;
    var TZDB_VERSION;
    var AVAILABLE_ZONE_IDS = [];
    var zones = {};
    var links = {};
    var MomentZoneRulesProvider = function(_ZoneRulesProvider) {
        _inheritsLoose(MomentZoneRulesProvider, _ZoneRulesProvider);
        function MomentZoneRulesProvider() {
            return _ZoneRulesProvider.apply(this, arguments) || this;
        }
        MomentZoneRulesProvider.getRules = function getRules(zoneId) {
            var tzdbZoneInfo = zones[links[zoneId]];
            if (tzdbZoneInfo == null) throw new core.DateTimeException("Unknown time-zone ID: " + zoneId);
            return new MomentZoneRules(tzdbZoneInfo);
        };
        MomentZoneRulesProvider.getAvailableZoneIds = function getAvailableZoneIds() {
            return AVAILABLE_ZONE_IDS;
        };
        MomentZoneRulesProvider.getVersion = function getVersion() {
            return TZDB_VERSION;
        };
        MomentZoneRulesProvider.getTzdbData = function getTzdbData() {
            return TZDB_DATA;
        };
        MomentZoneRulesProvider.loadTzdbData = function loadTzdbData(packedJson) {
            TZDB_DATA = packedJson;
            TZDB_VERSION = packedJson.version;
            for(var _iterator = _createForOfIteratorHelperLoose(packedJson.zones), _step; !(_step = _iterator()).done;){
                var packedZoneInfo = _step.value;
                var tzdbZoneInfo = unpack(packedZoneInfo);
                AVAILABLE_ZONE_IDS.push(tzdbZoneInfo.name);
                zones[tzdbZoneInfo.name] = tzdbZoneInfo;
                links[tzdbZoneInfo.name] = tzdbZoneInfo.name;
            }
            for(var _iterator2 = _createForOfIteratorHelperLoose(packedJson.links), _step2; !(_step2 = _iterator2()).done;){
                var packedLink = _step2.value;
                var link = packedLink.split("|");
                AVAILABLE_ZONE_IDS.push(link[1]);
                links[link[1]] = link[0];
            }
        };
        return MomentZoneRulesProvider;
    }(core.ZoneRulesProvider);
    function getResolvedZoneId(ZoneId) {
        try {
            var resolvedTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            return ZoneId.of(resolvedTimeZone);
        } catch (err) {}
        return null;
    }
    function extendSystemDefaultZoneId(ZoneId) {
        var resolvedZoneId = getResolvedZoneId(ZoneId);
        if (resolvedZoneId == null) return;
        ZoneId.systemDefault = function() {
            return resolvedZoneId;
        };
    }
    /*
	 * @copyright (c) 2016-present, Philipp Thürwächter, Pattrick Hüper
	 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
	 */ function plug(jsJoda) {
        jsJoda.ZoneRulesProvider.getRules = MomentZoneRulesProvider.getRules;
        jsJoda.ZoneRulesProvider.getAvailableZoneIds = MomentZoneRulesProvider.getAvailableZoneIds;
        jsJoda.ZoneRulesProvider.getTzdbData = MomentZoneRulesProvider.getTzdbData;
        jsJoda.ZoneRulesProvider.loadTzdbData = MomentZoneRulesProvider.loadTzdbData;
        extendSystemDefaultZoneId(jsJoda.ZoneId);
        return jsJoda;
    }
    /*
	 * @copyright (c) 2016-present, Philipp Thürwächter, Pattrick Hüper
	 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
	 */ function autoPlug() {
        core.use(plug);
    }
    /*
	 * @copyright (c) 2016-present, Philipp Thürwächter, Pattrick Hüper
	 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
	 */ MomentZoneRulesProvider.loadTzdbData(latest);
    autoPlug();
});



parcelRequire("17VE6");

function $7b9669d2f6a40ed5$export$bea8ebba691c5813(props) {
    if (props.toggled) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("small", {
        className: "toggle clickable",
        onClick: props.onToggle,
        children: "[-]"
    });
    else return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("small", {
        className: "toggle clickable",
        onClick: props.onToggle,
        children: "[+]"
    });
}



function $4618214019942db6$var$labelFormatter(date) {
    var zdt = (0, $9NSsB.ZonedDateTime).ofInstant((0, $9NSsB.Instant).ofEpochSecond(date), (0, $9NSsB.ZoneId).of("Europe/Rome"));
    return zdt.format((0, $9NSsB.DateTimeFormatter).ofPattern("dd/MM HH:mm"));
}
function $4618214019942db6$var$tickFormatter(d) {
    var zdt = (0, $9NSsB.ZonedDateTime).ofInstant((0, $9NSsB.Instant).ofEpochSecond(d), (0, $9NSsB.ZoneId).of("Europe/Rome"));
    return zdt.format((0, $9NSsB.DateTimeFormatter).ofPattern("dd/MM HH:mm"));
}
function $4618214019942db6$var$roundToDigits(n, d) {
    var txt = "" + n;
    if (txt.indexOf(".") >= 0) d += 1;
    var relevant = txt.substr(0, d);
    return Number(relevant);
}
function $4618214019942db6$export$acaa6426d77a227e(props) {
    var data = props.data, title = props.title, syncId = props.syncId;
    var xMin = props.xMin || "auto";
    var xMax = props.xMax || "auto";
    var yMin = 0;
    var yMax = 0;
    if (data.length > 0) {
        yMin = data.reduce(function(a, b) {
            return a.value < b.value ? a : b;
        }).value;
        yMax = data.reduce(function(a, b) {
            return a.value > b.value ? a : b;
        }).value;
        yMin -= (yMax - yMin) * 0.05;
        if (props.yMin) yMin = Math.max(yMin, props.yMin);
        yMin = Number(yMin.toFixed(3));
    }
    yMax += (yMax - yMin) * 0.05;
    if (props.yMax) yMax = Math.min(yMax, props.yMax);
    yMax = Number(yMax.toFixed(3));
    if (props.yMin !== undefined && props.yMin > yMin) yMin = props.yMin;
    if (props.yMax !== undefined && props.yMax < yMax) yMax = props.yMax;
    var _useState = (0, $52tJv._)((0, $17VE6.useState)(true), 2), visible = _useState[0], setState = _useState[1];
    if (props.data.length === 0) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("h2", {
                children: [
                    title,
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $7b9669d2f6a40ed5$export$bea8ebba691c5813), {
                        toggled: visible,
                        onToggle: function() {
                            return setState(!visible);
                        }
                    })
                ]
            }),
            visible ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("h4", {
                children: "No data for the selected interval"
            }) : null
        ]
    });
    console.log("prerounded:", yMin, yMax);
    // now, the values for yMin and yMax suck because they have plenty of decimals.
    // keep just 5 relevant digits
    yMin = $4618214019942db6$var$roundToDigits(yMin, 3);
    yMax = $4618214019942db6$var$roundToDigits(yMax, 3);
    console.log("post rounded:", yMin, yMax);
    var referenceLine = yMin < 0 && yMax > 0 ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $3dc4cef909b0d264$export$b2f28e248e7838eb), {
        y: 0,
        stroke: "lightgrey"
    }) : null;
    var baselineWarning = props.hasBaseline ? null : /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("text", {
        x: "6em",
        y: "1em",
        className: "baseline-warning",
        children: "Baseline not yet computed, data may change in the future"
    });
    // baselineWarning = null;
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("h2", {
                children: [
                    title,
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $7b9669d2f6a40ed5$export$bea8ebba691c5813), {
                        toggled: visible,
                        onToggle: function() {
                            return setState(!visible);
                        }
                    })
                ]
            }),
            visible ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $6b4d870d788b1cfb$export$e60a4704009a0009), {
                width: "100%",
                height: 250,
                children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)((0, $2f23af152231b861$export$f510429275d6f1a8), {
                    syncId: syncId,
                    data: data,
                    margin: {
                        top: 10,
                        right: 30,
                        left: 0,
                        bottom: 0
                    },
                    children: [
                        baselineWarning,
                        referenceLine,
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $7955eeb80a63f070$export$6440e27b9f186856), {
                            strokeDasharray: "3 3"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $158242af61505ff8$export$ea77231de273b52d), {
                            domain: [
                                xMin,
                                xMax
                            ],
                            dataKey: "timestamp",
                            type: "number",
                            tickFormatter: $4618214019942db6$var$tickFormatter
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $c91532a7678bb6b8$export$f96c4024c52de8f4), {
                            width: 80,
                            domain: [
                                yMin,
                                yMax
                            ],
                            reversed: props.reversed
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $c4a063a58f2c0c69$export$28c660c63b792dea), {
                            labelFormatter: $4618214019942db6$var$labelFormatter,
                            isAnimationActive: false
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $014dbbe445859826$export$ea1a111407f37557), {
                            type: "monotone",
                            dataKey: "value",
                            stroke: "#000",
                            fill: "url(#splitColor)",
                            isAnimationActive: false
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {})
        ]
    });
}



parcelRequire("17VE6");

function $2a3c76bca61762ad$export$6acba1054332af71(props) {
    var weatherData = props.weatherData, xMin = props.xMin, xMax = props.xMax, label = props.label;
    // const rainAmount = weatherData.map(wd => wd.rainAmount3h);
    // const rainMin = rainAmount.reduce((a, b) => Math.min(a, b), 0);
    // const rainMax = rainAmount.reduce((a, b) => Math.max(a, b), 0);
    var rainData = weatherData.map(function(wd) {
        return {
            value: wd.rainAmount1h || 0,
            timestamp: wd.date.toEpochSecond()
        };
    });
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
        className: "charts",
        children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $4618214019942db6$export$acaa6426d77a227e), {
            title: label,
            data: rainData,
            xMin: xMin.toEpochSecond(),
            xMax: xMax.toEpochSecond(),
            hasBaseline: true
        })
    }, "weather");
}



parcelRequire("17VE6");

var $9NSsB = parcelRequire("9NSsB");
function $2216542a8a9ffea4$var$renderRow(profile, data) {
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("td", {
                children: data.id
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("td", {
                children: data.timestamp.format((0, $9NSsB.DateTimeFormatter).ISO_LOCAL_DATE_TIME)
            }),
            profile.sensors.map(function(s) {
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("td", {
                    children: data[s.id]
                });
            })
        ]
    }, data.id);
}
function $2216542a8a9ffea4$var$renderHeader(profile) {
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("th", {
                children: "ID"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("th", {
                children: "Date"
            }),
            profile.sensors.map(function(s) {
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("th", {
                    children: s.description
                }, s.id);
            })
        ]
    });
}
function $2216542a8a9ffea4$export$bd5a08469a13dac6(props) {
    var _props_plant;
    var data = props.data, jwt = props.jwt, onlyDownload = props.onlyDownload;
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("h2", {
                children: [
                    "Device Data ",
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("small", {
                        children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("a", {
                            href: "/api/v2/download/csv?plantId=".concat((_props_plant = props.plant) === null || _props_plant === void 0 ? void 0 : _props_plant.id, "&jwt=").concat(jwt),
                            download: true,
                            children: "download"
                        })
                    })
                ]
            }),
            onlyDownload ? null : /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("thead", {
                        children: $2216542a8a9ffea4$var$renderHeader(props.profile)
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("tbody", {
                        children: data.map(function(d) {
                            return $2216542a8a9ffea4$var$renderRow(props.profile, d);
                        })
                    })
                ]
            })
        ]
    });
}



parcelRequire("17VE6");

function $32a599b303037869$export$f0151e6cbaeae1f0(props) {
    var data = props.data, from = props.from, to = props.to;
    data.forEach(function(d) {
        d.timestamp = d.date.toEpochSecond();
        d.value = 1;
    });
    function renderWeatherIcon(data) {
        var position = (data.date.toEpochSecond() - from.toEpochSecond()) / (to.toEpochSecond() - from.toEpochSecond());
        var style = {
            left: "calc(".concat(position * 100, "% - 12px)")
        };
        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("img", {
            alt: data.icon,
            className: "weather-icon",
            src: data.icon,
            style: style
        }, data.id);
    }
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("h2", {
                children: "Weather Status"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                className: "weather-line",
                children: data.map(renderWeatherIcon)
            })
        ]
    });
}



function $91439d58f294a2c2$var$renderCharts(data, weatherData, profile, chartData, xMin, xMax, isAdmin, plant) {
    var _sensors_rain1h;
    var sensors = (0, $1f82f0133d3f4ee2$export$e620e98009814b79)(profile.sensors, "id");
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $2a3c76bca61762ad$export$6acba1054332af71), {
                weatherData: weatherData,
                xMin: xMin,
                xMax: xMax,
                label: (_sensors_rain1h = sensors["rain1h"]) === null || _sensors_rain1h === void 0 ? void 0 : _sensors_rain1h.description
            }),
            profile.sensors.map(function(sensor) {
                var fieldData = chartData[sensor.id];
                if (fieldData !== undefined) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                    className: "charts",
                    children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $4618214019942db6$export$acaa6426d77a227e), {
                        title: sensor.description,
                        data: fieldData,
                        syncId: "chartSyncId",
                        xMin: xMin.toEpochSecond(),
                        xMax: xMax.toEpochSecond(),
                        yMin: sensor.yMin,
                        yMax: sensor.yMax,
                        hasBaseline: plant.baselineCalculated || sensor.description.toLowerCase().startsWith("dehydration") === false
                    })
                }, sensor.id);
                else {
                    console.error("Data for field ".concat(sensor.id, " is missing!"), chartData);
                    return null;
                }
            })
        ]
    });
}
function $91439d58f294a2c2$var$renderDeviceData(plant, profile, device, data, isAdmin, jwt) {
    if (isAdmin) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $2216542a8a9ffea4$export$bd5a08469a13dac6), {
        plant: plant,
        profile: profile,
        data: data,
        jwt: jwt,
        onlyDownload: false
    });
    else return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $2216542a8a9ffea4$export$bd5a08469a13dac6), {
        plant: plant,
        profile: profile,
        data: data,
        jwt: jwt,
        onlyDownload: true
    });
}
function $91439d58f294a2c2$export$766e52e91ce27fc2(props) {
    var plant = props.plant, device = props.device, leafSensorData = props.leafSensorData, weatherData = props.weatherData, from = props.from, to = props.to, jwt = props.jwt, isAdmin = props.isAdmin, chartData = props.chartData, scrollReference = props.scrollReference;
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $36d89c61f6df1b55$export$1e97dca3e3a103ef), {
                plant: plant,
                status: leafSensorData[0],
                scrollReference: scrollReference,
                onPlantSelected: props.onPlantSelected,
                profile: props.profile,
                onWeatherStationShow: props.onWeatherStationShow,
                device: device
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $32a599b303037869$export$f0151e6cbaeae1f0), {
                data: weatherData,
                from: from,
                to: to
            }),
            $91439d58f294a2c2$var$renderCharts(leafSensorData, weatherData, props.profile, chartData, from, to, isAdmin, plant),
            $91439d58f294a2c2$var$renderDeviceData(plant, props.profile, device, leafSensorData, isAdmin, jwt)
        ]
    });
}



var $9NSsB = parcelRequire("9NSsB");

var $17VE6 = parcelRequire("17VE6");

var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $ajhIL = parcelRequire("ajhIL");
function $23ce44f11e94d9bd$var$mean(values) {
    if (values.length === 0) return 0;
    var result = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var v = _step.value;
            result += v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result / values.length;
}
function $23ce44f11e94d9bd$var$smooth(dataset, key, nElements) {
    var result = [];
    var lastValues = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = dataset[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var row = _step.value;
            var value = row[key];
            if (value === undefined || value === null || value === false) continue;
            lastValues.push(value);
            if (lastValues.length > nElements) lastValues.shift();
            var item = {
                value: $23ce44f11e94d9bd$var$mean(lastValues),
                timestamp: row.timestamp.toEpochSecond()
            };
            result.push(item);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function $23ce44f11e94d9bd$export$74882a11127e2404(data, profile, filterLuminosity) {
    if (filterLuminosity) data = data.filter(function(d) {
        return d.lux <= 10;
    });
    var result = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = profile.sensors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var sensor = _step.value;
            result[sensor.id] = $23ce44f11e94d9bd$var$smooth(data, sensor.id, 5);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}



var $7hBys = parcelRequire("7hBys");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $ajhIL = parcelRequire("ajhIL");

var $9NSsB = parcelRequire("9NSsB");



var $d9e006fac7ba41ad$var$ENDPOINT = "/api/v2/plant";
var $d9e006fac7ba41ad$var$PlantService = /*#__PURE__*/ function() {
    "use strict";
    function PlantService() {
        (0, $5sFFs._)(this, PlantService);
    }
    (0, $8O2fV._)(PlantService, [
        {
            key: "getById",
            value: function getById(plantId) {
                return (0, $7hBys._)(function() {
                    var response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat($d9e006fac7ba41ad$var$ENDPOINT, "/").concat(plantId), {
                                        headers: (0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()),
                                        method: "get"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                result.regDate = new Date(result.regDate);
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getWeatherDataByPlantId",
            value: function getWeatherDataByPlantId(plantId, from) {
                return (0, $7hBys._)(function() {
                    var response, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, row;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat($d9e006fac7ba41ad$var$ENDPOINT, "/").concat(plantId, "/weather?from=").concat(from.toISOString()), {
                                        headers: (0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()),
                                        method: "get"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = result[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        row = _step.value;
                                        // Change strings to date objects
                                        row.date = (0, $9NSsB.ZonedDateTime).parse(row.date);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPlantData",
            value: function getPlantData(plantId, from, to) {
                return (0, $7hBys._)(function() {
                    var response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat($d9e006fac7ba41ad$var$ENDPOINT, "/").concat(plantId, "/data?from=").concat(from.toISOString(), "&to=").concat(to.toISOString()), {
                                        headers: (0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()),
                                        method: "get"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                result = result.map(function(row) {
                                    return (0, $bqLxK._)((0, $lwFY2._)({}, row), {
                                        timestamp: (0, $9NSsB.ZonedDateTime).parse(row.timestamp)
                                    });
                                });
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "savePlant",
            value: function savePlant(plant) {
                return (0, $7hBys._)(function() {
                    var response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat($d9e006fac7ba41ad$var$ENDPOINT), {
                                        headers: (0, $bqLxK._)((0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()), {
                                            "Content-Type": "application/json"
                                        }),
                                        method: "post",
                                        body: JSON.stringify(plant)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                result.regDate = new Date(result.regDate);
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLastDate",
            value: function getLastDate(plantId) {
                return (0, $7hBys._)(function() {
                    var response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $1f82f0133d3f4ee2$export$8a97150c436e861e)("".concat($d9e006fac7ba41ad$var$ENDPOINT, "/").concat(plantId, "/last-date"), {
                                        method: "get"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                if (result) return [
                                    2,
                                    new Date(result)
                                ];
                                else return [
                                    2,
                                    null
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "movePlant",
            value: function movePlant(plantId, customerId) {
                return (0, $7hBys._)(function() {
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $1f82f0133d3f4ee2$export$8a97150c436e861e)("".concat($d9e006fac7ba41ad$var$ENDPOINT, "/").concat(plantId, "/move/").concat(customerId), {
                                        method: "post"
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                //await  response.json();
                })();
            }
        },
        {
            key: "getByCustomerId",
            value: function getByCustomerId(customerId) {
                return (0, $7hBys._)(function() {
                    var result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $1f82f0133d3f4ee2$export$b5fe3f66a567bec0)("".concat($d9e006fac7ba41ad$var$ENDPOINT, "/?customer=").concat(customerId))
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result || []
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PlantService;
}();
var $d9e006fac7ba41ad$export$567d99ad22f1b14f = new $d9e006fac7ba41ad$var$PlantService();




var $7hBys = parcelRequire("7hBys");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $ajhIL = parcelRequire("ajhIL");



var $a9fd84e20f6f5fba$var$ENDPOINT = "/api/v2/profile";
var $a9fd84e20f6f5fba$var$profileCache = {};
var $a9fd84e20f6f5fba$var$ProfileService = /*#__PURE__*/ function() {
    "use strict";
    function ProfileService() {
        (0, $5sFFs._)(this, ProfileService);
    }
    (0, $8O2fV._)(ProfileService, [
        {
            key: "getProfileById",
            value: function getProfileById(id) {
                return (0, $7hBys._)(function() {
                    var response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if ($a9fd84e20f6f5fba$var$profileCache[id]) return [
                                    2,
                                    $a9fd84e20f6f5fba$var$profileCache[id]
                                ];
                                return [
                                    4,
                                    fetch("".concat($a9fd84e20f6f5fba$var$ENDPOINT, "/").concat(id), {
                                        headers: (0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()),
                                        method: "get"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                $a9fd84e20f6f5fba$var$profileCache[id] = result;
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getProfilesByParentOfCustomerId",
            value: function getProfilesByParentOfCustomerId(customerId) {
                return (0, $7hBys._)(function() {
                    var response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat($a9fd84e20f6f5fba$var$ENDPOINT, "?").concat((0, $1f82f0133d3f4ee2$export$281ad3752a540efe)({
                                        "parent-customer": customerId
                                    })), {
                                        headers: (0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()),
                                        method: "get"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getProfilesByChildCustomerId",
            value: function getProfilesByChildCustomerId(customerId) {
                return (0, $7hBys._)(function() {
                    var response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat($a9fd84e20f6f5fba$var$ENDPOINT, "?").concat((0, $1f82f0133d3f4ee2$export$281ad3752a540efe)({
                                        "child-customer": customerId,
                                        "generic": true
                                    })), {
                                        headers: (0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()),
                                        method: "get"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMyProfiles",
            value: function getMyProfiles() {
                return (0, $7hBys._)(function() {
                    var response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat($a9fd84e20f6f5fba$var$ENDPOINT, "/mine"), {
                                        headers: (0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()),
                                        method: "get"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getProfilesByUserId",
            value: function getProfilesByUserId(userId) {
                return (0, $7hBys._)(function() {
                    var response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat($a9fd84e20f6f5fba$var$ENDPOINT, "?").concat((0, $1f82f0133d3f4ee2$export$281ad3752a540efe)({
                                        user: userId
                                    })), {
                                        headers: (0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()),
                                        method: "get"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "saveProfile",
            value: function saveProfile(profile) {
                return (0, $7hBys._)(function() {
                    var response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat($a9fd84e20f6f5fba$var$ENDPOINT), {
                                        headers: (0, $bqLxK._)((0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()), {
                                            "Content-Type": "application/json"
                                        }),
                                        method: "post",
                                        body: JSON.stringify(profile)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteProfile",
            value: function deleteProfile(profile) {
                return (0, $7hBys._)(function() {
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat($a9fd84e20f6f5fba$var$ENDPOINT, "/").concat(profile.id), {
                                        headers: (0, $bqLxK._)((0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()), {
                                            "Content-Type": "application/json"
                                        }),
                                        method: "delete"
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ProfileService;
}();
var $a9fd84e20f6f5fba$export$d1da43634a05a45d = new $a9fd84e20f6f5fba$var$ProfileService();


function $d95195c43769bcd5$export$debb0e12c58b7ba6(devices) {
    if (devices.length === 0) return {
        initialZoom: 4,
        center: [
            0,
            0
        ]
    };
    // ignore devices without position
    devices = devices.filter(function(d) {
        return d.gps !== null && d.gps.length === 2;
    });
    var longitude = devices.map(function(d) {
        return d.gps[0];
    }).reduce(function(x, y) {
        return x + y;
    }, 0) / devices.length;
    var latitude = devices.map(function(d) {
        return d.gps[1];
    }).reduce(function(x, y) {
        return x + y;
    }, 0) / devices.length;
    return {
        initialZoom: 4,
        center: [
            longitude,
            latitude
        ]
    };
}
var $d95195c43769bcd5$export$855522aced0b7596 = {
    devices: [],
    chartData: {},
    currentData: null,
    mapConfiguration: {
        center: [
            0,
            0
        ],
        initialZoom: 10
    },
    weatherStations: [],
    filterLuminosity: false
};
function $d95195c43769bcd5$export$70067fe532af8a10() {
    return $d95195c43769bcd5$var$_getUserPageInitialState.apply(this, arguments);
}
function $d95195c43769bcd5$var$_getUserPageInitialState() {
    $d95195c43769bcd5$var$_getUserPageInitialState = (0, $7hBys._)(function() {
        var devices, mapConfiguration;
        return (0, $ajhIL.__generator)(this, function(_state) {
            devices = [];
            try {
                devices = [];
            } catch (e) {
                console.log("Unable to get my devices:", e);
            }
            mapConfiguration = $d95195c43769bcd5$export$debb0e12c58b7ba6(devices);
            return [
                2,
                (0, $bqLxK._)((0, $lwFY2._)({}, $d95195c43769bcd5$export$855522aced0b7596), {
                    devices: devices,
                    mapConfiguration: mapConfiguration
                })
            ];
        });
    });
    return $d95195c43769bcd5$var$_getUserPageInitialState.apply(this, arguments);
}
function $d95195c43769bcd5$export$95e5190f671ee08c(state, date, rangeWidth) {
    if (state.currentData === null) return state;
    var to = (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getEndOfDay(date);
    var from = (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getStartDate(to, rangeWidth);
    var currentData = (0, $bqLxK._)((0, $lwFY2._)({}, state.currentData), {
        from: from,
        to: to,
        selectedDate: (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getBeginningOfDay(date)
    });
    return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
        currentData: currentData
    });
}
function $d95195c43769bcd5$export$947f3aa1651bc59c(userPageState, device, plantId, rangeWidth) {
    return $d95195c43769bcd5$var$_loadPlantData.apply(this, arguments);
}
function $d95195c43769bcd5$var$_loadPlantData() {
    $d95195c43769bcd5$var$_loadPlantData = (0, $7hBys._)(function(userPageState, device, plantId, rangeWidth) {
        var selectedDate, to, from, data, weatherData, plant, profileId, profile, chartData, plantData, newState;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    selectedDate = new Date();
                    if (userPageState.currentData) selectedDate = userPageState.currentData.selectedDate;
                    selectedDate = (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getBeginningOfDay(selectedDate);
                    to = (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getEndOfDay(selectedDate);
                    from = (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getStartDate(to, rangeWidth);
                    console.log("Loading data from", from, "to", to);
                    data = [];
                    weatherData = [];
                    plant = null;
                    if (!plantId) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (0, $d9e006fac7ba41ad$export$567d99ad22f1b14f).getPlantData(plantId, from, to)
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        4,
                        (0, $d9e006fac7ba41ad$export$567d99ad22f1b14f).getWeatherDataByPlantId(plantId, from)
                    ];
                case 2:
                    weatherData = _state.sent();
                    return [
                        4,
                        (0, $d9e006fac7ba41ad$export$567d99ad22f1b14f).getById(plantId)
                    ];
                case 3:
                    plant = _state.sent();
                    _state.label = 4;
                case 4:
                    // FIXME: I know we have this. but first we should remove all the rain gauge related stuff
                    profileId = plant === null || plant === void 0 ? void 0 : plant.deviceProfileId;
                    return [
                        4,
                        (0, $a9fd84e20f6f5fba$export$d1da43634a05a45d).getProfileById(profileId)
                    ];
                case 5:
                    profile = _state.sent();
                    chartData = (0, $23ce44f11e94d9bd$export$74882a11127e2404)(data, profile, userPageState.filterLuminosity);
                    plantData = {
                        currentDevice: device,
                        currentPlant: plant,
                        leafSensorData: data,
                        weatherData: weatherData,
                        selectedDate: selectedDate,
                        from: from,
                        to: to
                    };
                    newState = $d95195c43769bcd5$export$95e5190f671ee08c((0, $bqLxK._)((0, $lwFY2._)({}, userPageState), {
                        currentData: plantData,
                        chartData: chartData
                    }), selectedDate, rangeWidth);
                    return [
                        2,
                        newState
                    ];
            }
        });
    });
    return $d95195c43769bcd5$var$_loadPlantData.apply(this, arguments);
}
function $d95195c43769bcd5$export$f6e0c4ba062fb4cc(state, profile, filterLuminosity) {
    if (state.currentData) {
        var chartData = (0, $23ce44f11e94d9bd$export$74882a11127e2404)(state.currentData.leafSensorData, profile, filterLuminosity);
        return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
            filterLuminosity: filterLuminosity,
            chartData: chartData
        });
    } else return state;
}







var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");

var $17VE6 = parcelRequire("17VE6");
function $b61d063c6ac5efce$export$cdf1dc76b55502e3(options) {
    function reload() {
        setState(function(state) {
            return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                reload: true
            });
        });
    }
    // function update(newState: T) {
    //     setState( state => ({...state, data: newState}));
    // }
    function override(t) {
        setState(function(state) {
            return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                data: t
            });
        });
    }
    function makeResult(state) {
        switch(state.status){
            case "fulfilled":
                var fulfilledResult = {
                    status: "fulfilled",
                    data: state.data,
                    reload: reload,
                    override: override
                };
                return fulfilledResult;
            case "rejected":
                var rejectedResult = {
                    status: "rejected",
                    error: state.error,
                    reload: reload
                };
                return rejectedResult;
            default:
                return {
                    status: state.status,
                    reload: reload
                };
        }
    }
    //    console.log("UseAsync", options.watch);
    var initialState = {
        promiseFn: options.promiseFn,
        status: "initial"
    };
    var _useState = (0, $52tJv._)((0, $17VE6.useState)(initialState), 2), state = _useState[0], setState = _useState[1];
    if (state.status === "initial" && !options.waitChange || options.watch !== state.previousWatch || state.reload) {
        //        console.log("useAsync Changed !");
        var promise = options.promiseFn();
        var newState = (0, $bqLxK._)((0, $lwFY2._)({}, state), {
            promise: promise,
            status: "pending",
            previousWatch: options.watch,
            reload: false
        });
        promise.then(function(result) {
            setState(function(oldState) {
                //                console.log(oldState.promise, promise);
                // If the promise in state has changed, it means that 'watch' property triggered another call fo 'promiseFn'
                // so we should ignore this result
                if (oldState.promise === promise) //                    console.log("useAsync updating state with result");
                return (0, $bqLxK._)((0, $lwFY2._)({}, oldState), {
                    status: "fulfilled",
                    data: result,
                    error: undefined
                });
                else //                    console.log("useAsync promise changed, not updating state");
                return oldState;
            });
        }).catch(function(error) {
            // Same as above
            setState(function(oldState) {
                if (oldState.promise === promise) //                    console.log('useAsync updating state with error');
                return (0, $bqLxK._)((0, $lwFY2._)({}, oldState), {
                    status: "rejected",
                    data: undefined,
                    error: error
                });
                else //                    console.log('useAsync promise changed, not updating state with error');
                return oldState;
            });
        });
        setState(newState);
        return makeResult(newState);
    } else if (options.watch !== state.previousWatch) setState(function(oldState) {
        return (0, $bqLxK._)((0, $lwFY2._)({}, oldState), {
            previousWatch: options.watch
        });
    });
    return makeResult(state);
}



var $7hBys = parcelRequire("7hBys");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $ajhIL = parcelRequire("ajhIL");

var $0d5e64ed83326035$var$ENDPOINT = "/api/v2/device";
var $0d5e64ed83326035$var$DeviceService = /*#__PURE__*/ function() {
    "use strict";
    function DeviceService() {
        (0, $5sFFs._)(this, DeviceService);
    }
    (0, $8O2fV._)(DeviceService, [
        {
            key: "getByCustomerId",
            value: function getByCustomerId(customerId, addPlant, hidden) {
                return (0, $7hBys._)(function() {
                    var jwt, params, response, result;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                jwt = localStorage.jwt;
                                params = new URLSearchParams();
                                params.append("customer", customerId);
                                if (addPlant) params.append("add-plant", "");
                                if (hidden !== undefined) params.append("hidden", hidden + "");
                                return [
                                    4,
                                    fetch("".concat($0d5e64ed83326035$var$ENDPOINT, "?").concat(params), {
                                        headers: {
                                            "Authorization": "Bearer ".concat(jwt)
                                        },
                                        method: "get"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return DeviceService;
}();
var $0d5e64ed83326035$export$74bf59fd8e732238 = new $0d5e64ed83326035$var$DeviceService();


function $4e91cb12bb296069$export$2e2bcd8739ae039(props) {
    var _userPageState_currentData_currentPlant, _userPageState_currentData;
    var dataStartRef = props.dataStartRef;
    var state = props.state;
    var _useState = (0, $52tJv._)((0, $17VE6.useState)((0, $d95195c43769bcd5$export$855522aced0b7596)), 2), userPageState = _useState[0], setState = _useState[1];
    (0, $17VE6.useEffect)(function() {
        (0, $d95195c43769bcd5$export$70067fe532af8a10)().then(function(state) {
            setState(state);
        });
    }, []);
    (0, $17VE6.useEffect)(function() {
        console.log("Customer ID:", props.selectedCustomerId);
        if (props.selectedCustomerId) (0, $0d5e64ed83326035$export$74bf59fd8e732238).getByCustomerId(props.selectedCustomerId, true, false).then(function(devices) {
            console.log("DEVICES:", devices);
            setState(function(state) {
                return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                    devices: devices
                });
            });
        });
        else setState(function(state) {
            return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                devices: []
            });
        });
    }, [
        props.selectedCustomerId
    ]);
    var xMin;
    var xMax;
    var to = new Date();
    var from = (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getStartDate(to, state.rangeWidth);
    if (userPageState.currentData) {
        from = userPageState.currentData.from;
        to = userPageState.currentData.to;
    }
    from = (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getBeginningOfDay(from);
    to = (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getBeginningOfDay(to);
    xMin = (0, $9NSsB.ZonedDateTime).parse(from.toISOString());
    xMax = (0, $9NSsB.ZonedDateTime).parse(to.toISOString());
    var profileId = (_userPageState_currentData = userPageState.currentData) === null || _userPageState_currentData === void 0 ? void 0 : (_userPageState_currentData_currentPlant = _userPageState_currentData.currentPlant) === null || _userPageState_currentData_currentPlant === void 0 ? void 0 : _userPageState_currentData_currentPlant.deviceProfileId;
    function loadProfile() {
        return _loadProfile.apply(this, arguments);
    }
    function _loadProfile() {
        _loadProfile = (0, $7hBys._)(function() {
            var _userPageState_currentData_currentPlant, _userPageState_currentData, profileId;
            return (0, $ajhIL.__generator)(this, function(_state) {
                profileId = (_userPageState_currentData = userPageState.currentData) === null || _userPageState_currentData === void 0 ? void 0 : (_userPageState_currentData_currentPlant = _userPageState_currentData.currentPlant) === null || _userPageState_currentData_currentPlant === void 0 ? void 0 : _userPageState_currentData_currentPlant.deviceProfileId;
                if (profileId) return [
                    2,
                    (0, $a9fd84e20f6f5fba$export$d1da43634a05a45d).getProfileById(profileId)
                ];
                else return [
                    2,
                    undefined
                ];
                return [
                    2
                ];
            });
        });
        return _loadProfile.apply(this, arguments);
    }
    var profileAsync = (0, $b61d063c6ac5efce$export$cdf1dc76b55502e3)({
        promiseFn: loadProfile,
        waitChange: true,
        watch: profileId
    });
    var profile;
    switch(profileAsync.status){
        case "initial":
        case "pending":
        case "rejected":
            profile = undefined;
            break;
        case "fulfilled":
            profile = profileAsync.data;
    }
    function loadData(userPageState, device, rangeWidth, focus) {
        return _loadData.apply(this, arguments);
    }
    function _loadData() {
        _loadData = (0, $7hBys._)(function(userPageState, device, rangeWidth, focus) {
            var _userPageState_currentData, _userPageState_currentData1, sameDevice, plant, plantId, newState;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sameDevice = ((_userPageState_currentData = userPageState.currentData) === null || _userPageState_currentData === void 0 ? void 0 : _userPageState_currentData.currentDevice.id) === device.id;
                        plant = userPageState === null || userPageState === void 0 ? void 0 : (_userPageState_currentData1 = userPageState.currentData) === null || _userPageState_currentData1 === void 0 ? void 0 : _userPageState_currentData1.currentPlant;
                        if (plant && sameDevice) plantId = plant.id;
                        else plantId = device.plantId;
                        console.log("Loading data for", plantId);
                        return [
                            4,
                            (0, $d95195c43769bcd5$export$947f3aa1651bc59c)(userPageState, device, plantId, rangeWidth)
                        ];
                    case 1:
                        newState = _state.sent();
                        setState(newState);
                        if (dataStartRef.current !== null && focus) dataStartRef.current.scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                        return [
                            2,
                            newState
                        ];
                }
            });
        });
        return _loadData.apply(this, arguments);
    }
    function onPlantSelected(plant) {
        return _onPlantSelected.apply(this, arguments);
    }
    function _onPlantSelected() {
        _onPlantSelected = (0, $7hBys._)(function(plant) {
            var lastDate, currentData, newState;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("Selected plant", plant);
                        if (!plant.id) {
                            console.warn("Using plant without id");
                            return [
                                2
                            ];
                        }
                        if (!userPageState.currentData) return [
                            2
                        ];
                        return [
                            4,
                            (0, $d9e006fac7ba41ad$export$567d99ad22f1b14f).getLastDate(plant.id)
                        ];
                    case 1:
                        lastDate = _state.sent();
                        console.log('Most recent data for plants "'.concat(plant.description, " is at ").concat(lastDate));
                        currentData = (0, $bqLxK._)((0, $lwFY2._)({}, userPageState.currentData), {
                            currentPlant: plant,
                            selectedDate: lastDate || new Date()
                        });
                        newState = (0, $bqLxK._)((0, $lwFY2._)({}, userPageState), {
                            currentData: currentData
                        });
                        if (!newState.currentData) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            loadData(newState, newState.currentData.currentDevice, state.rangeWidth, false)
                        ];
                    case 2:
                        // we know it is always true, but TS doesn't
                        newState = _state.sent();
                        if (lastDate) setState((0, $d95195c43769bcd5$export$95e5190f671ee08c)(newState, (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getBeginningOfDay(lastDate), state.rangeWidth));
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _onPlantSelected.apply(this, arguments);
    }
    function toggleWeatherStationVisibility(wl) {
        // Fixme, what if we have more than one ?
        if (wl) {
            console.log("Showing weather station", wl);
            setState(function(s) {
                return (0, $bqLxK._)((0, $lwFY2._)({}, s), {
                    weatherStations: [
                        wl
                    ]
                });
            });
        } else {
            setState(function(s) {
                return (0, $bqLxK._)((0, $lwFY2._)({}, s), {
                    weatherStations: []
                });
            });
            console.log("Hiding weather station location");
        }
    }
    function renderData(plantData, chartData) {
        if (plantData === null || xMin === undefined || xMax === undefined || profile === undefined) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("h2", {
            children: "No Device Selected"
        });
        else if (plantData.currentPlant != null) {
            var currentPlant = plantData.currentPlant, currentDevice = plantData.currentDevice, leafSensorData = plantData.leafSensorData, weatherData = plantData.weatherData;
            var isAdmin = state.login.hasRole("admin");
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $91439d58f294a2c2$export$766e52e91ce27fc2), {
                profile: profile,
                device: currentDevice,
                plant: currentPlant,
                from: xMin,
                to: xMax,
                isAdmin: isAdmin,
                leafSensorData: leafSensorData,
                weatherData: weatherData,
                chartData: chartData,
                scrollReference: dataStartRef,
                onPlantSelected: onPlantSelected,
                onWeatherStationShow: toggleWeatherStationVisibility,
                jwt: state.login.jwt
            });
        } else return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
            children: "No data for the selected range"
        });
    }
    function onDeviceSelected(deviceId) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // FIXME maybe optimize this ...
            for(var _iterator = userPageState.devices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var device = _step.value;
                if (device.id === deviceId) {
                    console.debug("Device selected", device);
                    loadData(userPageState, device, state.rangeWidth, true).then();
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function onRangeSelected(range) {
        return _onRangeSelected.apply(this, arguments);
    }
    function _onRangeSelected() {
        _onRangeSelected = (0, $7hBys._)(function(range) {
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("Selected range", range);
                        if (!(userPageState.currentData && userPageState.currentData.currentDevice)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            loadData(userPageState, userPageState.currentData.currentDevice, range, false)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        props.onRangeSelected(range);
                        return [
                            2
                        ];
                }
            });
        });
        return _onRangeSelected.apply(this, arguments);
    }
    function onDateSelected(date) {
        return _onDateSelected.apply(this, arguments);
    }
    function _onDateSelected() {
        _onDateSelected = (0, $7hBys._)(function(date) {
            var newState;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.info("Setting new date to", date);
                        newState = (0, $d95195c43769bcd5$export$95e5190f671ee08c)(userPageState, date, state.rangeWidth);
                        if (!newState.currentData) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            loadData(newState, newState.currentData.currentDevice, state.rangeWidth, false)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setState(newState);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _onDateSelected.apply(this, arguments);
    }
    function onFilterLuminosityToggled(filter) {
        return _onFilterLuminosityToggled.apply(this, arguments);
    }
    function _onFilterLuminosityToggled() {
        _onFilterLuminosityToggled = (0, $7hBys._)(function(filter) {
            var _userPageState_currentData_currentPlant, _userPageState_currentData, profile;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((_userPageState_currentData = userPageState.currentData) === null || _userPageState_currentData === void 0 ? void 0 : (_userPageState_currentData_currentPlant = _userPageState_currentData.currentPlant) === null || _userPageState_currentData_currentPlant === void 0 ? void 0 : _userPageState_currentData_currentPlant.deviceProfileId)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $a9fd84e20f6f5fba$export$d1da43634a05a45d).getProfileById(userPageState.currentData.currentPlant.deviceProfileId)
                        ];
                    case 1:
                        profile = _state.sent();
                        setState((0, $d95195c43769bcd5$export$f6e0c4ba062fb4cc)(userPageState, profile, !userPageState.filterLuminosity));
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return _onFilterLuminosityToggled.apply(this, arguments);
    }
    var selectedDate = null;
    if (userPageState.currentData) selectedDate = userPageState.currentData.selectedDate;
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
        className: "user-page",
        children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
            className: "top",
            children: [
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $eccf418c59b0bff7$export$a5c7b93649eaf8f8), {
                    devices: userPageState.devices,
                    center: userPageState.mapConfiguration.center,
                    weatherStations: userPageState.weatherStations,
                    onDeviceSelected: onDeviceSelected,
                    zoom: userPageState.mapConfiguration.initialZoom
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $a980346064516d53$export$d9b273488cd8ce6f), {
                    ranges: (0, $da28a2330eaa34fb$export$d9183a4079b5f34b),
                    onRangeSelected: onRangeSelected,
                    onDateSelected: onDateSelected,
                    onFilterLuminosityToggled: onFilterLuminosityToggled,
                    selectedDate: selectedDate,
                    filterLuminosity: userPageState.filterLuminosity,
                    selectedRangeId: state.rangeWidth.id
                }),
                renderData(userPageState.currentData, userPageState.chartData)
            ]
        })
    });
}



var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");

var $ajhIL = parcelRequire("ajhIL");



var $17VE6 = parcelRequire("17VE6");

var $52tJv = parcelRequire("52tJv");


var $17VE6 = parcelRequire("17VE6");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");


var $17VE6 = parcelRequire("17VE6");

function $5409b0de208954d5$export$6940b0d9c820eca7(props) {
    var _useState = (0, $52tJv._)((0, $17VE6.useState)({
        expanded: false
    }), 2), state = _useState[0], setState = _useState[1];
    function toggleExpanded() {
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            expanded: !state.expanded
        }));
    }
    function renderNodeExpander(node, state) {
        if (node.children.length === 0) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
            className: "clickable tree-expander",
            children: "\xa0"
        });
        else if (state.expanded) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
            className: "clickable tree-expander",
            onClick: toggleExpanded,
            children: "\u229F"
        });
        else return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
            className: "clickable tree-expander",
            onClick: toggleExpanded,
            children: "\u229E"
        });
    }
    function renderNodeHeader(node) {
        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
            className: "tree-header",
            children: [
                renderNodeExpander(node, state),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("label", {
                    className: "clickable",
                    children: [
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                            type: "checkbox",
                            onChange: function() {
                                return props.onClick(node);
                            },
                            checked: node.selected
                        }),
                        node.label,
                        " "
                    ]
                })
            ]
        });
    }
    function renderChildren(node) {
        if (!state.expanded) return null;
        else return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("ol", {
            children: props.node.children.map(function(child) {
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("li", {
                    className: "tree-node",
                    children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)($5409b0de208954d5$export$6940b0d9c820eca7, {
                        node: child,
                        onClick: props.onClick
                    })
                }, child.id);
            })
        });
    }
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        className: "tree-view",
        children: [
            renderNodeHeader(props.node),
            renderChildren(props.node)
        ]
    });
}



var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $ajhIL = parcelRequire("ajhIL");





function $b0f4f73eaa8ac95b$export$388250afe88c1783(device, sensor) {
    return "@" + device.id + "-@" + sensor.id;
}
function $b0f4f73eaa8ac95b$export$12c43e276378540e(pageState, selectedItems, rangeWidth) {
    return $b0f4f73eaa8ac95b$var$_loadMissingData.apply(this, arguments);
}
function $b0f4f73eaa8ac95b$var$_loadMissingData() {
    $b0f4f73eaa8ac95b$var$_loadMissingData = (0, $7hBys._)(function(pageState, selectedItems, rangeWidth) {
        var deviceData, deviceById, to, from, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, deviceId, missingData, device, data, plant, profile, err;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.info("checking for missing data");
                    deviceData = (0, $lwFY2._)({}, pageState.deviceData);
                    deviceById = (0, $1f82f0133d3f4ee2$export$e620e98009814b79)(pageState.devices, "id");
                    to = (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getEndOfDay(pageState.selectedDate);
                    from = (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getBeginningOfDay(new Date(to.getTime() - rangeWidth.durationSec * 1000));
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        9
                    ]);
                    _iterator = Object.values(selectedItems)[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        6
                    ];
                    deviceId = _step.value;
                    missingData = !deviceData[deviceId];
                    console.log("Missing data for device ".concat(deviceId, ": ").concat(missingData));
                    console.info("Data for ".concat(deviceId, " missing, loading"));
                    if (!missingData) return [
                        3,
                        5
                    ];
                    device = deviceById[deviceId];
                    if (!device) // This is an inner node
                    return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $d9e006fac7ba41ad$export$567d99ad22f1b14f).getPlantData(device.plantId, from, to)
                    ];
                case 3:
                    data = _state.sent();
                    return [
                        4,
                        (0, $d9e006fac7ba41ad$export$567d99ad22f1b14f).getById(device.plantId)
                    ];
                case 4:
                    plant = _state.sent();
                    profile = pageState.profilesById[plant.deviceProfileId];
                    deviceData[deviceId] = (0, $23ce44f11e94d9bd$export$74882a11127e2404)(data, profile, false);
                    return [
                        3,
                        6
                    ];
                case 5:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        (0, $bqLxK._)((0, $lwFY2._)({}, pageState), {
                            selectedItems: selectedItems,
                            deviceData: deviceData
                        })
                    ];
            }
        });
    });
    return $b0f4f73eaa8ac95b$var$_loadMissingData.apply(this, arguments);
}
function $b0f4f73eaa8ac95b$export$61400971ccde43d5(pageState, rangeWidth, item) {
    return $b0f4f73eaa8ac95b$var$_toggleEntry.apply(this, arguments);
}
function $b0f4f73eaa8ac95b$var$_toggleEntry() {
    $b0f4f73eaa8ac95b$var$_toggleEntry = (0, $7hBys._)(function(pageState, rangeWidth, item) {
        var selectedItems, enabled, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, device, plant, profile, dataFields, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, field, err, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, device1, plant1, profile1, dataFields1, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, field1, err, device2, plant2, profile2, deviceId, enabled1, dataFields2, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, field2, dataFields3, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, field3, id;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    selectedItems = (0, $lwFY2._)({}, pageState.selectedItems);
                    if (!(item.device === null)) return [
                        3,
                        20
                    ];
                    // toggle all devices
                    console.log("Toggling all devices");
                    enabled = !selectedItems[$b0f4f73eaa8ac95b$export$af4548964e371194];
                    if (!enabled) return [
                        3,
                        10
                    ];
                    selectedItems[$b0f4f73eaa8ac95b$export$af4548964e371194] = $b0f4f73eaa8ac95b$export$af4548964e371194;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        9
                    ]);
                    _iterator = pageState.devices[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        6
                    ];
                    device = _step.value;
                    return [
                        4,
                        (0, $d9e006fac7ba41ad$export$567d99ad22f1b14f).getById(device.plantId)
                    ];
                case 3:
                    plant = _state.sent();
                    return [
                        4,
                        (0, $a9fd84e20f6f5fba$export$d1da43634a05a45d).getProfileById(plant.deviceProfileId)
                    ];
                case 4:
                    profile = _state.sent();
                    dataFields = profile.sensors;
                    selectedItems[$b0f4f73eaa8ac95b$export$acbf75c35387a224(device)] = device.id;
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = dataFields[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            field = _step1.value;
                            selectedItems[$b0f4f73eaa8ac95b$export$388250afe88c1783(device, field)] = device.id;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    _state.label = 5;
                case 5:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        3,
                        19
                    ];
                case 10:
                    delete selectedItems[$b0f4f73eaa8ac95b$export$af4548964e371194];
                    _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    _state.label = 11;
                case 11:
                    _state.trys.push([
                        11,
                        17,
                        18,
                        19
                    ]);
                    _iterator2 = pageState.devices[Symbol.iterator]();
                    _state.label = 12;
                case 12:
                    if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                        3,
                        16
                    ];
                    device1 = _step2.value;
                    return [
                        4,
                        (0, $d9e006fac7ba41ad$export$567d99ad22f1b14f).getById(device1.plantId)
                    ];
                case 13:
                    plant1 = _state.sent();
                    return [
                        4,
                        (0, $a9fd84e20f6f5fba$export$d1da43634a05a45d).getProfileById(plant1.deviceProfileId)
                    ];
                case 14:
                    profile1 = _state.sent();
                    dataFields1 = profile1.sensors;
                    delete selectedItems[$b0f4f73eaa8ac95b$export$acbf75c35387a224(device1)];
                    _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(_iterator3 = dataFields1[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            field1 = _step3.value;
                            delete selectedItems[$b0f4f73eaa8ac95b$export$388250afe88c1783(device1, field1)];
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                    _state.label = 15;
                case 15:
                    _iteratorNormalCompletion2 = true;
                    return [
                        3,
                        12
                    ];
                case 16:
                    return [
                        3,
                        19
                    ];
                case 17:
                    err = _state.sent();
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                    return [
                        3,
                        19
                    ];
                case 18:
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                    return [
                        7
                    ];
                case 19:
                    return [
                        3,
                        24
                    ];
                case 20:
                    if (!(item.field === null)) return [
                        3,
                        23
                    ];
                    // flag whole device
                    console.log("Toggling device", item.device.description);
                    device2 = item.device;
                    return [
                        4,
                        (0, $d9e006fac7ba41ad$export$567d99ad22f1b14f).getById(device2.plantId)
                    ];
                case 21:
                    plant2 = _state.sent();
                    return [
                        4,
                        (0, $a9fd84e20f6f5fba$export$d1da43634a05a45d).getProfileById(plant2.deviceProfileId)
                    ];
                case 22:
                    profile2 = _state.sent();
                    deviceId = $b0f4f73eaa8ac95b$export$acbf75c35387a224(device2);
                    enabled1 = !selectedItems[deviceId];
                    if (enabled1) {
                        dataFields2 = profile2.sensors;
                        selectedItems[deviceId] = device2.id;
                        _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                        try {
                            for(_iterator4 = dataFields2[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                field2 = _step4.value;
                                selectedItems[$b0f4f73eaa8ac95b$export$388250afe88c1783(device2, field2)] = device2.id;
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                    _iterator4.return();
                                }
                            } finally{
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }
                    } else {
                        dataFields3 = profile2.sensors;
                        delete selectedItems[deviceId];
                        _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                        try {
                            for(_iterator5 = dataFields3[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                                field3 = _step5.value;
                                delete selectedItems[$b0f4f73eaa8ac95b$export$388250afe88c1783(device2, field3)];
                            }
                        } catch (err) {
                            _didIteratorError5 = true;
                            _iteratorError5 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                    _iterator5.return();
                                }
                            } finally{
                                if (_didIteratorError5) {
                                    throw _iteratorError5;
                                }
                            }
                        }
                    }
                    return [
                        3,
                        24
                    ];
                case 23:
                    id = $b0f4f73eaa8ac95b$export$388250afe88c1783(item.device, item.field);
                    console.log("Toggling field", id);
                    if (selectedItems[id]) {
                        console.log("Deselecting");
                        delete selectedItems[id];
                    } else {
                        console.log("Selecting");
                        selectedItems[id] = item.device.id;
                    }
                    _state.label = 24;
                case 24:
                    return [
                        4,
                        $b0f4f73eaa8ac95b$export$12c43e276378540e(pageState, selectedItems, rangeWidth)
                    ];
                case 25:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $b0f4f73eaa8ac95b$var$_toggleEntry.apply(this, arguments);
}
var $b0f4f73eaa8ac95b$export$af4548964e371194 = "root";
function $b0f4f73eaa8ac95b$export$acbf75c35387a224(device) {
    return "@" + device.id;
}
var $b0f4f73eaa8ac95b$export$dc7d116a2ac90f34 = {
    devices: [],
    deviceData: {},
    profilesById: {},
    plants: [],
    plantsById: {},
    selectedItems: {},
    selectedDate: (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getBeginningOfDay(new Date()),
    loadingStatus: "pending"
};






var $9NSsB = parcelRequire("9NSsB");

parcelRequire("17VE6");

function $ba001461d3497aae$export$7f7cbe89f1eacd2() {
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
        className: "spinner-container",
        children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
            className: "spinner"
        })
    });
}



parcelRequire("17VE6");
function $bb8043f30c8e9f0f$export$ae4b40d9fa099989(props) {
    if (props.on) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
        children: "\uD83D\uDFE2"
    });
    else return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
        children: "\uD83D\uDD34"
    });
}


function $5a813be960faa0f6$var$mapDeviceToNode(device, profile, selectedItems) {
    var children = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (profile) try {
        for(var _iterator = profile.sensors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var field = _step.value;
            var id = (0, $b0f4f73eaa8ac95b$export$388250afe88c1783)(device, field);
            children.push({
                id: id,
                label: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: field.description
                }),
                selected: !!selectedItems[id],
                children: [],
                payload: {
                    device: device,
                    field: field
                }
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var deviceId = (0, $b0f4f73eaa8ac95b$export$acbf75c35387a224)(device);
    return {
        id: deviceId,
        label: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)((0, $2a471062978a40a2$exports.Fragment), {
            children: [
                device.description,
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $bb8043f30c8e9f0f$export$ae4b40d9fa099989), {
                    on: device.connected
                })
            ]
        }),
        selected: !!selectedItems[deviceId],
        children: children,
        payload: {
            device: device,
            field: null
        }
    };
}
function $5a813be960faa0f6$export$3507889dee46013e(props) {
    function dateChangeHandler(e) {
        var date = (0, $9NSsB.convert)((0, $9NSsB.LocalDate).parse(e.target.value)).toDate();
        props.onDateSelected(date);
    }
    var _useState = (0, $52tJv._)((0, $17VE6.useState)(""), 2), filter = _useState[0], setFilter = _useState[1];
    var trees = [];
    var filteredDevices = filter ? applyFilter(filter, props.devices) : props.devices;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    //    const filteredDevices = props.devices;
    if (props.plants.length === props.devices.length) try {
        for(var _iterator = filteredDevices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var device = _step.value;
            var plant = device.plant;
            trees.push($5a813be960faa0f6$var$mapDeviceToNode(device, props.profilesById[plant.deviceProfileId], props.selectedItems));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var root = {
        children: trees,
        id: (0, $b0f4f73eaa8ac95b$export$af4548964e371194),
        label: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
            children: "All Devices"
        }),
        selected: props.selectedItems[0, $b0f4f73eaa8ac95b$export$af4548964e371194] !== undefined,
        payload: {
            device: null,
            field: null
        }
    };
    function applyFilter(text, devices) {
        console.log("Apply filter ".concat(text));
        return devices.filter(function(d) {
            return d.description.toLowerCase().indexOf(text.toLowerCase()) >= 0;
        });
    }
    function onFilterChanged(event) {
        setFilter(event.target.value);
    }
    switch(props.loadingStatus){
        case "resolved":
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                className: "side-menu",
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $c73b41bb9d1ad603$export$1081d70813d107d1), {
                        ranges: props.ranges,
                        selectedRangeId: props.selectedRangeId,
                        onRangeSelected: props.onRangeSelected
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                        type: "date",
                        value: (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).formatDate(props.selectedDate),
                        onChange: dateChangeHandler
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                        placeholder: "Filter devices...",
                        id: "tree-device-filter",
                        type: "text",
                        onChange: onFilterChanged
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $5409b0de208954d5$export$6940b0d9c820eca7), {
                        node: root,
                        onClick: function(node) {
                            return props.onEntryToggled(node.payload);
                        }
                    })
                ]
            });
        case "pending":
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $ba001461d3497aae$export$7f7cbe89f1eacd2), {});
        case "rejected":
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                children: "Cannot load data!"
            });
    }
}










function $177a8208e5f52a24$var$findRange(dashboardPageState, rangeWidth) {
    var xMin;
    var xMax;
    xMax = (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getEndOfDay(dashboardPageState.selectedDate).getTime() / 1000;
    xMin = (0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getEndOfDay((0, $5e17167db9d238bf$export$ae0dacc307e0ed75).getStartDate(dashboardPageState.selectedDate, rangeWidth)).getTime() / 1000;
    return {
        xMin: xMin,
        xMax: xMax
    };
}
function $177a8208e5f52a24$var$getDeviceById(pageState, deviceId) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = pageState.devices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var device = _step.value;
            if (device.id === deviceId) return device;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function $177a8208e5f52a24$var$loadProfiles() {
    return $177a8208e5f52a24$var$_loadProfiles.apply(this, arguments);
}
function $177a8208e5f52a24$var$_loadProfiles() {
    $177a8208e5f52a24$var$_loadProfiles = (0, $7hBys._)(function() {
        var customerId, profiles, profilesById;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    customerId = (0, $d426a3f2c6fbebd8$export$9aa0815bbb7f01f0).getLoginInformation().customerId;
                    return [
                        4,
                        (0, $a9fd84e20f6f5fba$export$d1da43634a05a45d).getProfilesByParentOfCustomerId(customerId)
                    ];
                case 1:
                    profiles = _state.sent();
                    profilesById = (0, $1f82f0133d3f4ee2$export$e620e98009814b79)(profiles, "id");
                    return [
                        2,
                        profilesById
                    ];
            }
        });
    });
    return $177a8208e5f52a24$var$_loadProfiles.apply(this, arguments);
}
function $177a8208e5f52a24$export$2e2bcd8739ae039(props) {
    var state = props.state;
    var _useState = (0, $52tJv._)((0, $17VE6.useState)((0, $b0f4f73eaa8ac95b$export$dc7d116a2ac90f34)), 2), pageState = _useState[0], setState = _useState[1];
    (0, $17VE6.useEffect)(function() {
        $177a8208e5f52a24$var$loadProfiles().then(function(profilesById) {
            setState(function(pageState) {
                return (0, $bqLxK._)((0, $lwFY2._)({}, pageState), {
                    profilesById: profilesById
                });
            });
        });
    }, []);
    (0, $17VE6.useEffect)(function() {
        (0, $0d5e64ed83326035$export$74bf59fd8e732238).getByCustomerId(props.customerId, true, false).then(function(devices) {
            console.info("Device list loaded");
            setState(function(pageState) {
                return (0, $bqLxK._)((0, $lwFY2._)({}, pageState), {
                    devices: devices,
                    loadingStatus: "resolved"
                });
            });
        }).catch(function(error) {
            console.error("Unable to load device list");
            setState(function(pageState) {
                return (0, $bqLxK._)((0, $lwFY2._)({}, pageState), {
                    loadingStatus: "rejected"
                });
            });
        });
    }, [
        props.customerId
    ]);
    (0, $17VE6.useEffect)(function() {
        var plants = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var device = _step.value;
                plants.push(device.plant);
                var plantsById = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = plants[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var plant = _step1.value;
                        var id = plant.id;
                        plantsById[id] = plant;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                setState(function(pageState) {
                    return (0, $bqLxK._)((0, $lwFY2._)({}, pageState), {
                        plants: plants,
                        plantsById: plantsById
                    });
                });
            };
            for(var _iterator = pageState.devices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, [
        pageState.devices
    ]);
    function renderItem(item, deviceId) {
        var fieldName = item.split("@")[2];
        if (!fieldName) return;
        var device = $177a8208e5f52a24$var$getDeviceById(pageState, deviceId);
        if (!device) return;
        var profile = pageState.profilesById[pageState.plantsById[device.plantId].deviceProfileId];
        if (!profile) return;
        var sensors = (0, $1f82f0133d3f4ee2$export$e620e98009814b79)(profile.sensors, "id");
        var chartData = pageState.deviceData[deviceId];
        var title = device.description + " - " + sensors[fieldName].description;
        var sensor = sensors[fieldName];
        var fieldChartData = chartData[fieldName];
        // if (sensor.chartFormula && fieldChartData) {
        //     fieldChartData = sensor.chartFormula(fieldChartData);
        // }
        if (sensor === undefined) console.error("Missing field data for field ".concat(fieldName), sensors);
        else if (fieldChartData === undefined) console.error("Missing chart data for field ".concat(fieldName), pageState.deviceData);
        else switch(sensor.chartType){
            case "bars":
                console.log("FIXME: Unimplemented");
                break;
            case "line":
            default:
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                    className: "charts",
                    children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $4618214019942db6$export$acaa6426d77a227e), {
                        title: title,
                        data: fieldChartData,
                        syncId: "chartSyncId",
                        xMin: xMin,
                        xMax: xMax,
                        yMin: sensor.yMin,
                        yMax: sensor.yMax,
                        hasBaseline: true
                    })
                }, item);
        }
    }
    var _findRange = $177a8208e5f52a24$var$findRange(pageState, state.rangeWidth), xMin = _findRange.xMin, xMax = _findRange.xMax;
    function onEntryToggled(entry) {
        return _onEntryToggled.apply(this, arguments);
    }
    function _onEntryToggled() {
        _onEntryToggled = (0, $7hBys._)(function(entry) {
            var daf, newState;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("Entry toggled:", entry);
                        daf = {
                            device: entry.device,
                            field: entry.field
                        };
                        return [
                            4,
                            (0, $b0f4f73eaa8ac95b$export$61400971ccde43d5)(pageState, state.rangeWidth, daf)
                        ];
                    case 1:
                        newState = _state.sent();
                        setState(newState);
                        return [
                            2
                        ];
                }
            });
        });
        return _onEntryToggled.apply(this, arguments);
    }
    function onRangeSelected(range) {
        return _onRangeSelected.apply(this, arguments);
    }
    function _onRangeSelected() {
        _onRangeSelected = (0, $7hBys._)(function(range) {
            var newDeviceData, newState;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("Selecting range", range);
                        newDeviceData = {};
                        newState = (0, $bqLxK._)((0, $lwFY2._)({}, pageState), {
                            deviceData: newDeviceData
                        });
                        return [
                            4,
                            (0, $b0f4f73eaa8ac95b$export$12c43e276378540e)(newState, pageState.selectedItems, range)
                        ];
                    case 1:
                        newState = _state.sent();
                        setState(newState);
                        props.onRangeSelected(range);
                        return [
                            2
                        ];
                }
            });
        });
        return _onRangeSelected.apply(this, arguments);
    }
    function onDateSelected(date) {
        return _onDateSelected.apply(this, arguments);
    }
    function _onDateSelected() {
        _onDateSelected = (0, $7hBys._)(function(date) {
            var newDeviceData, newState;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("Selecting date", date);
                        newDeviceData = {};
                        newState = (0, $bqLxK._)((0, $lwFY2._)({}, pageState), {
                            selectedDate: date,
                            deviceData: newDeviceData
                        });
                        return [
                            4,
                            (0, $b0f4f73eaa8ac95b$export$12c43e276378540e)(newState, pageState.selectedItems, state.rangeWidth)
                        ];
                    case 1:
                        newState = _state.sent();
                        setState(newState);
                        return [
                            2
                        ];
                }
            });
        });
        return _onDateSelected.apply(this, arguments);
    }
    if (pageState.loadingStatus === "pending") console.log(pageState);
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        className: "dashboard-container",
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                className: "dashboard-menu",
                children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $5a813be960faa0f6$export$3507889dee46013e), {
                    onCustomerSelected: props.onCustomerSelected,
                    customers: [],
                    selectedCustomerId: "",
                    profilesById: pageState.profilesById,
                    devices: pageState.devices,
                    plants: pageState.plants,
                    onDateSelected: onDateSelected,
                    ranges: (0, $da28a2330eaa34fb$export$d9183a4079b5f34b),
                    onRangeSelected: onRangeSelected,
                    selectedRangeId: state.rangeWidth.id,
                    selectedItems: pageState.selectedItems,
                    selectedDate: pageState.selectedDate,
                    loadingStatus: pageState.loadingStatus,
                    onEntryToggled: onEntryToggled
                })
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                className: "dashboard-body",
                children: Object.entries(pageState.selectedItems).map(function(param) {
                    var _param = (0, $52tJv._)(param, 2), item = _param[0], deviceId = _param[1];
                    return renderItem(item, deviceId);
                })
            })
        ]
    });
}



parcelRequire("17VE6");
/**
 * React Router DOM v6.21.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7hBys = parcelRequire("7hBys");

var $5sFFs = parcelRequire("5sFFs");

var $52tJv = parcelRequire("52tJv");

var $ajhIL = parcelRequire("ajhIL");

var $17VE6 = parcelRequire("17VE6");

var $62qDs = parcelRequire("62qDs");
/**
 * @remix-run/router v1.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7hBys = parcelRequire("7hBys");

var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $iCQyW = parcelRequire("iCQyW");

var $kcqLc = parcelRequire("kcqLc");

var $52tJv = parcelRequire("52tJv");

var $km0OT = parcelRequire("km0OT");

var $iBN6B = parcelRequire("iBN6B");

var $8PKT5 = parcelRequire("8PKT5");

var $ayuXN = parcelRequire("ayuXN");
function $c917b27ef8892059$export$e62c166da838fa3(arr) {
    return (0, $km0OT._array_with_holes)(arr) || (0, $iBN6B._iterable_to_array)(arr) || (0, $ayuXN._unsupported_iterable_to_array)(arr) || (0, $8PKT5._non_iterable_rest)();
}



var $fyztb = parcelRequire("fyztb");

var $aBSBL = parcelRequire("aBSBL");

var $4jYWU = parcelRequire("4jYWU");

var $ajhIL = parcelRequire("ajhIL");

var $ajhIL = parcelRequire("ajhIL");
function $95c0513fdc022f99$var$_extends() {
    $95c0513fdc022f99$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $95c0513fdc022f99$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $95c0513fdc022f99$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($95c0513fdc022f99$export$e19cd5f9376f8cee || ($95c0513fdc022f99$export$e19cd5f9376f8cee = {}));
var $95c0513fdc022f99$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $95c0513fdc022f99$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $95c0513fdc022f99$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $95c0513fdc022f99$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $95c0513fdc022f99$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $95c0513fdc022f99$export$fe53371bee54353d(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $95c0513fdc022f99$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $95c0513fdc022f99$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $95c0513fdc022f99$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $95c0513fdc022f99$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $95c0513fdc022f99$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $95c0513fdc022f99$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $95c0513fdc022f99$export$fe53371bee54353d(to);
    }
    return $95c0513fdc022f99$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $95c0513fdc022f99$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = $95c0513fdc022f99$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $95c0513fdc022f99$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $95c0513fdc022f99$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $95c0513fdc022f99$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $95c0513fdc022f99$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $95c0513fdc022f99$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $95c0513fdc022f99$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $95c0513fdc022f99$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $95c0513fdc022f99$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $95c0513fdc022f99$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $95c0513fdc022f99$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $95c0513fdc022f99$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $95c0513fdc022f99$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $95c0513fdc022f99$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $95c0513fdc022f99$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $95c0513fdc022f99$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $95c0513fdc022f99$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($95c0513fdc022f99$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $95c0513fdc022f99$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $95c0513fdc022f99$export$e19cd5f9376f8cee.Push;
        var location = $95c0513fdc022f99$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $95c0513fdc022f99$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $95c0513fdc022f99$export$e19cd5f9376f8cee.Replace;
        var location = $95c0513fdc022f99$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $95c0513fdc022f99$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $95c0513fdc022f99$export$fe53371bee54353d(to);
        $95c0513fdc022f99$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($95c0513fdc022f99$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($95c0513fdc022f99$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $95c0513fdc022f99$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($95c0513fdc022f99$var$ResultType || ($95c0513fdc022f99$var$ResultType = {}));
var $95c0513fdc022f99$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $95c0513fdc022f99$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $95c0513fdc022f99$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $fyztb._)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $95c0513fdc022f99$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $95c0513fdc022f99$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($95c0513fdc022f99$var$isIndexRoute(route)) {
            var indexRoute = $95c0513fdc022f99$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $95c0513fdc022f99$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $95c0513fdc022f99$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $95c0513fdc022f99$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? $95c0513fdc022f99$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $95c0513fdc022f99$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $95c0513fdc022f99$var$flattenRoutes(routes);
    $95c0513fdc022f99$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i)matches = $95c0513fdc022f99$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $95c0513fdc022f99$var$safelyDecodeURI(pathname));
    return matches;
}
function $95c0513fdc022f99$export$b3fac024fad9e8ff(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $95c0513fdc022f99$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $95c0513fdc022f99$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $95c0513fdc022f99$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $95c0513fdc022f99$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $95c0513fdc022f99$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $95c0513fdc022f99$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $95c0513fdc022f99$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $95c0513fdc022f99$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $c917b27ef8892059$export$e62c166da838fa3)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $95c0513fdc022f99$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $fyztb._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $fyztb._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $95c0513fdc022f99$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $95c0513fdc022f99$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $95c0513fdc022f99$var$paramRe = /^:[\w-]+$/;
var $95c0513fdc022f99$var$dynamicSegmentValue = 3;
var $95c0513fdc022f99$var$indexRouteValue = 2;
var $95c0513fdc022f99$var$emptySegmentValue = 1;
var $95c0513fdc022f99$var$staticSegmentValue = 10;
var $95c0513fdc022f99$var$splatPenalty = -2;
var $95c0513fdc022f99$var$isSplat = function(s) {
    return s === "*";
};
function $95c0513fdc022f99$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($95c0513fdc022f99$var$isSplat)) initialScore += $95c0513fdc022f99$var$splatPenalty;
    if (index) initialScore += $95c0513fdc022f99$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$95c0513fdc022f99$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($95c0513fdc022f99$var$paramRe.test(segment) ? $95c0513fdc022f99$var$dynamicSegmentValue : segment === "" ? $95c0513fdc022f99$var$emptySegmentValue : $95c0513fdc022f99$var$staticSegmentValue);
    }, initialScore);
}
function $95c0513fdc022f99$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $95c0513fdc022f99$var$matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $95c0513fdc022f99$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $95c0513fdc022f99$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $95c0513fdc022f99$export$a5c6d149b50c1d86($95c0513fdc022f99$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $95c0513fdc022f99$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $95c0513fdc022f99$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $95c0513fdc022f99$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $52tJv._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $95c0513fdc022f99$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $95c0513fdc022f99$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $52tJv._)($95c0513fdc022f99$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $95c0513fdc022f99$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $95c0513fdc022f99$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $95c0513fdc022f99$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $95c0513fdc022f99$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $95c0513fdc022f99$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $95c0513fdc022f99$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $95c0513fdc022f99$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $95c0513fdc022f99$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $95c0513fdc022f99$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $95c0513fdc022f99$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $95c0513fdc022f99$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $95c0513fdc022f99$var$normalizeSearch(search),
        hash: $95c0513fdc022f99$var$normalizeHash(hash)
    };
}
function $95c0513fdc022f99$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $95c0513fdc022f99$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $95c0513fdc022f99$var$getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $95c0513fdc022f99$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    var pathMatches = $95c0513fdc022f99$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === matches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function $95c0513fdc022f99$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $95c0513fdc022f99$export$8ccf933b0513f8d0(toArg);
    else {
        to = $95c0513fdc022f99$var$_extends({}, toArg);
        $95c0513fdc022f99$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $95c0513fdc022f99$var$getInvalidPathError("?", "pathname", "search", to));
        $95c0513fdc022f99$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $95c0513fdc022f99$var$getInvalidPathError("#", "pathname", "hash", to));
        $95c0513fdc022f99$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $95c0513fdc022f99$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $95c0513fdc022f99$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $95c0513fdc022f99$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $95c0513fdc022f99$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $95c0513fdc022f99$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $95c0513fdc022f99$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $95c0513fdc022f99$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $95c0513fdc022f99$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $95c0513fdc022f99$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $95c0513fdc022f99$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $95c0513fdc022f99$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $kcqLc._)(AbortedDeferredError, Error1);
    var _super = (0, $4jYWU._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $5sFFs._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $aBSBL._)(Error));
var $95c0513fdc022f99$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $5sFFs._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $95c0513fdc022f99$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $95c0513fdc022f99$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $52tJv._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $iCQyW._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $8O2fV._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $95c0513fdc022f99$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $7hBys._)(function() {
                    var aborted, onAbort;
                    return (0, $ajhIL.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $95c0513fdc022f99$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $52tJv._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $iCQyW._)({}, key, $95c0513fdc022f99$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $95c0513fdc022f99$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $95c0513fdc022f99$var$unwrapTrackedPromise(value) {
    if (!$95c0513fdc022f99$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $95c0513fdc022f99$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $95c0513fdc022f99$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $95c0513fdc022f99$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $95c0513fdc022f99$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $95c0513fdc022f99$export$a6cd19cd1951a23c = function(url, init) {
    var response = $95c0513fdc022f99$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var $95c0513fdc022f99$export$6c6580e81da25755 = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $5sFFs._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $95c0513fdc022f99$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $95c0513fdc022f99$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $95c0513fdc022f99$var$validMutationMethods = new Set($95c0513fdc022f99$var$validMutationMethodsArr);
var $95c0513fdc022f99$var$validRequestMethodsArr = [
    "get"
].concat((0, $fyztb._)($95c0513fdc022f99$var$validMutationMethodsArr));
var $95c0513fdc022f99$var$validRequestMethods = new Set($95c0513fdc022f99$var$validRequestMethodsArr);
var $95c0513fdc022f99$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $95c0513fdc022f99$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $95c0513fdc022f99$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $95c0513fdc022f99$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $95c0513fdc022f99$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $95c0513fdc022f99$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $95c0513fdc022f99$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var $95c0513fdc022f99$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $95c0513fdc022f99$export$baddd0131ee8c05b(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $95c0513fdc022f99$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $95c0513fdc022f99$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $95c0513fdc022f99$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    // Config driven behavior flags
    var future = $95c0513fdc022f99$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $95c0513fdc022f99$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $95c0513fdc022f99$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $95c0513fdc022f99$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $iCQyW._)({}, route.id, error);
    }
    var initialized;
    var hasLazyRoutes = initialMatches.some(function(m) {
        return m.route.lazy;
    });
    var hasLoaders = initialMatches.some(function(m) {
        return m.route.loader;
    });
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every(function(m) {
            return m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined);
        });
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $95c0513fdc022f99$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $95c0513fdc022f99$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $95c0513fdc022f99$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $95c0513fdc022f99$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $95c0513fdc022f99$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return $95c0513fdc022f99$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($95c0513fdc022f99$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $95c0513fdc022f99$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $fyztb._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $95c0513fdc022f99$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $95c0513fdc022f99$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $95c0513fdc022f99$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $95c0513fdc022f99$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $95c0513fdc022f99$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $95c0513fdc022f99$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $95c0513fdc022f99$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $95c0513fdc022f99$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($95c0513fdc022f99$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $95c0513fdc022f99$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $95c0513fdc022f99$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $7hBys._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $95c0513fdc022f99$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $95c0513fdc022f99$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $95c0513fdc022f99$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $95c0513fdc022f99$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $95c0513fdc022f99$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $95c0513fdc022f99$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $95c0513fdc022f99$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $95c0513fdc022f99$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.unstable_flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $95c0513fdc022f99$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.unstable_viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $7hBys._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionData, pendingError, actionOutput, _ref, shortCircuited, loaderData, errors;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $95c0513fdc022f99$export$2708184779ceb39d(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = $95c0513fdc022f99$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = $95c0513fdc022f99$var$getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $iCQyW._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $95c0513fdc022f99$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $95c0513fdc022f99$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $95c0513fdc022f99$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingError = (0, $iCQyW._)({}, $95c0513fdc022f99$var$findNearestBoundary(matches).route.id, opts.pendingError);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $95c0513fdc022f99$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionOutput = _state.sent();
                        if (actionOutput.shortCircuited) return [
                            2
                        ];
                        pendingActionData = actionOutput.pendingActionData;
                        pendingError = actionOutput.pendingActionError;
                        loadingNavigation = $95c0513fdc022f99$var$getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // Create a GET request for the loaders
                        request = new Request(request.url, {
                            signal: request.signal
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $95c0513fdc022f99$var$_extends({
                            matches: matches
                        }, pendingActionData ? {
                            actionData: pendingActionData
                        } : {}, {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $7hBys._)(function(request, location, submission, matches, opts) {
            var navigation, result, actionMatch, replace, boundaryMatch;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = $95c0513fdc022f99$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        actionMatch = $95c0513fdc022f99$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: $95c0513fdc022f99$var$ResultType.error,
                            error: $95c0513fdc022f99$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $95c0513fdc022f99$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!$95c0513fdc022f99$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else // If the user didn't explicity indicate replace behavior, replace if
                        // we redirected to the exact same location we're currently at to avoid
                        // double back-buttons
                        replace = result.location === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(state, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if ($95c0513fdc022f99$var$isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = $95c0513fdc022f99$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = $95c0513fdc022f99$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    // Send back an empty object we can use to clear out any prior actionData
                                    pendingActionData: {},
                                    pendingActionError: (0, $iCQyW._)({}, boundaryMatch.route.id, result.error)
                                }
                            ];
                        }
                        if ($95c0513fdc022f99$var$isDeferredResult(result)) throw $95c0513fdc022f99$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        return [
                            2,
                            {
                                pendingActionData: (0, $iCQyW._)({}, actionMatch.route.id, result.data)
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $7hBys._)(function(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
            var loadingNavigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, actionData, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || $95c0513fdc022f99$var$getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || $95c0513fdc022f99$var$getSubmissionFromNavigation(loadingNavigation);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $52tJv._)($95c0513fdc022f99$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $95c0513fdc022f99$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingError || null
                            }, pendingActionData ? {
                                actionData: pendingActionData
                            } : {}, updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since iot's not a "navigation"
                        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = $95c0513fdc022f99$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            actionData = pendingActionData || state.actionData;
                            updateState($95c0513fdc022f99$var$_extends({
                                navigation: loadingNavigation
                            }, actionData ? Object.keys(actionData).length === 0 ? {
                                actionData: null
                            } : {
                                actionData: actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = $95c0513fdc022f99$var$findRedirect(results);
                        if (!redirect) return [
                            3,
                            3
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(state, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        // Process and commit output from loaders
                        _processLoaderData = $95c0513fdc022f99$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $95c0513fdc022f99$var$_extends({
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var flushSync = (opts && opts.unstable_flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $95c0513fdc022f99$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = $95c0513fdc022f99$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $95c0513fdc022f99$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = $95c0513fdc022f99$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = $95c0513fdc022f99$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $95c0513fdc022f99$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $7hBys._)(function(key, routeId, path, match, requestMatches, flushSync, submission) {
            var error, existingFetcher, abortController, fetchRequest, originatingLoadId, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!match.route.action && !match.route.lazy) {
                            error = $95c0513fdc022f99$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $95c0513fdc022f99$var$getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        // Call the action for the fetcher
                        abortController = new AbortController();
                        fetchRequest = $95c0513fdc022f99$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $95c0513fdc022f99$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)
                        ];
                    case 1:
                        actionResult = _state.sent();
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if ($95c0513fdc022f99$var$isRedirectResult(actionResult) || $95c0513fdc022f99$var$isErrorResult(actionResult)) {
                                updateFetcherState(key, $95c0513fdc022f99$var$getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if ($95c0513fdc022f99$var$isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, $95c0513fdc022f99$var$getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, $95c0513fdc022f99$var$getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(state, actionResult, {
                                            fetcherSubmission: submission
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if ($95c0513fdc022f99$var$isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if ($95c0513fdc022f99$var$isDeferredResult(actionResult)) throw $95c0513fdc022f99$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $95c0513fdc022f99$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $95c0513fdc022f99$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $95c0513fdc022f99$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $95c0513fdc022f99$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $52tJv._)($95c0513fdc022f99$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, (0, $iCQyW._)({}, match.route.id, actionResult.data), undefined // No need to send through errors since we short circuit above
                        ), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $95c0513fdc022f99$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = $95c0513fdc022f99$var$findRedirect(results);
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                // If this redirect came from a fetcher make sure we mark it in
                                // fetchRedirectIds so it doesn't get revalidated on the next set of
                                // loader executions
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(state, redirect.result)
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = $95c0513fdc022f99$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = $95c0513fdc022f99$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $95c0513fdc022f99$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: $95c0513fdc022f99$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $7hBys._)(function(key, routeId, path, match, matches, flushSync, submission) {
            var existingFetcher, abortController, fetchRequest, originatingLoadId, result;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $95c0513fdc022f99$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        // Call the loader for this fetcher route match
                        abortController = new AbortController();
                        fetchRequest = $95c0513fdc022f99$var$createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $95c0513fdc022f99$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!$95c0513fdc022f99$var$isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $95c0513fdc022f99$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, $95c0513fdc022f99$var$getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!$95c0513fdc022f99$var$isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, $95c0513fdc022f99$var$getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(state, result)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        // Process any non-redirect errors thrown
                        if ($95c0513fdc022f99$var$isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        $95c0513fdc022f99$export$3e9cee6b33872309(!$95c0513fdc022f99$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, $95c0513fdc022f99$var$getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(state, redirect, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $7hBys._)(function(state, redirect, _temp2) {
            var _ref, submission, fetcherSubmission, replace, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, replace = _ref.replace;
                        if (redirect.revalidate) isRevalidationRequired = true;
                        redirectLocation = $95c0513fdc022f99$var$createLocation(state.location, redirect.location, {
                            _isRedirect: true
                        });
                        $95c0513fdc022f99$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if ($95c0513fdc022f99$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                                url = init.history.createURL(redirect.location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                $95c0513fdc022f99$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(redirect.location);
                                else routerWindow.location.assign(redirect.location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $95c0513fdc022f99$export$e19cd5f9376f8cee.Replace : $95c0513fdc022f99$export$e19cd5f9376f8cee.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $95c0513fdc022f99$var$getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!($95c0513fdc022f99$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $95c0513fdc022f99$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $95c0513fdc022f99$var$_extends({}, activeSubmission, {
                                    formAction: redirect.location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = $95c0513fdc022f99$var$getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $7hBys._)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var results, loaderResults, fetcherResults;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all((0, $fyztb._)(matchesToLoad.map(function(match) {
                                return $95c0513fdc022f99$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                            })).concat((0, $fyztb._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) return $95c0513fdc022f99$var$callLoaderOrAction("loader", $95c0513fdc022f99$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                                else {
                                    var error = {
                                        type: $95c0513fdc022f99$var$ResultType.error,
                                        error: $95c0513fdc022f99$var$getInternalRouterError(404, {
                                            pathname: f.path
                                        })
                                    };
                                    return error;
                                }
                            }))))
                        ];
                    case 1:
                        results = _state.sent();
                        loaderResults = results.slice(0, matchesToLoad.length);
                        fetcherResults = results.slice(matchesToLoad.length);
                        return [
                            4,
                            Promise.all([
                                $95c0513fdc022f99$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $95c0513fdc022f99$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                results: results,
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $fyztb._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = $95c0513fdc022f99$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $iCQyW._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $95c0513fdc022f99$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            var count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $95c0513fdc022f99$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $95c0513fdc022f99$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $95c0513fdc022f99$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $52tJv._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $95c0513fdc022f99$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $95c0513fdc022f99$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $95c0513fdc022f99$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $95c0513fdc022f99$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $95c0513fdc022f99$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $52tJv._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $95c0513fdc022f99$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $95c0513fdc022f99$export$b3fac024fad9e8ff(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $95c0513fdc022f99$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $95c0513fdc022f99$export$4d0306f8f6a4585b = Symbol("deferred");
function $95c0513fdc022f99$export$3336b097a6fbc59a(routes, opts) {
    $95c0513fdc022f99$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $95c0513fdc022f99$var$defaultMapRouteProperties;
    // Config driven behavior flags
    var future = $95c0513fdc022f99$var$_extends({
        v7_relativeSplatPath: false
    }, opts ? opts.future : null);
    var dataRoutes = $95c0513fdc022f99$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ (0, $7hBys._)(function(request, _temp3) {
            var requestContext, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestContext = (_temp3 === void 0 ? {} : _temp3).requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $95c0513fdc022f99$var$createLocation("", $95c0513fdc022f99$export$fe53371bee54353d(url), null, "default");
                        matches = $95c0513fdc022f99$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$95c0513fdc022f99$var$isValidMethod(method) && method !== "HEAD") {
                            error = $95c0513fdc022f99$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $95c0513fdc022f99$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $iCQyW._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $95c0513fdc022f99$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $95c0513fdc022f99$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $iCQyW._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($95c0513fdc022f99$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $95c0513fdc022f99$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ (0, $7hBys._)(function(request, _temp4) {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $95c0513fdc022f99$var$createLocation("", $95c0513fdc022f99$export$fe53371bee54353d(url), null, "default");
                        matches = $95c0513fdc022f99$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$95c0513fdc022f99$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $95c0513fdc022f99$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $95c0513fdc022f99$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $95c0513fdc022f99$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $95c0513fdc022f99$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $95c0513fdc022f99$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($95c0513fdc022f99$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$95c0513fdc022f99$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $7hBys._)(function(request, location, matches, requestContext, routeMatch) {
            var result, result1, e;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $95c0513fdc022f99$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$95c0513fdc022f99$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $95c0513fdc022f99$var$getTargetMatch(matches, location), requestContext, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $95c0513fdc022f99$var$isResponse(result1) ? result1 : $95c0513fdc022f99$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction, we throw
                        // it to bail out and then return or throw here based on whether the user
                        // returned or threw
                        if ($95c0513fdc022f99$var$isQueryRouteResponse(e)) {
                            if (e.type === $95c0513fdc022f99$var$ResultType.error) throw e.response;
                            return [
                                2,
                                e.response
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($95c0513fdc022f99$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $7hBys._)(function(request, matches, actionMatch, requestContext, isRouteRequest) {
            var result, error, method, error1, boundaryMatch, context, loaderRequest, context1;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $95c0513fdc022f99$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $95c0513fdc022f99$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $95c0513fdc022f99$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                                isStaticRequest: true,
                                isRouteRequest: isRouteRequest,
                                requestContext: requestContext
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
                        }
                        _state.label = 3;
                    case 3:
                        if ($95c0513fdc022f99$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.status,
                            headers: {
                                Location: result.location
                            }
                        });
                        if ($95c0513fdc022f99$var$isDeferredResult(result)) {
                            error1 = $95c0513fdc022f99$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $95c0513fdc022f99$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($95c0513fdc022f99$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $iCQyW._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        if (!$95c0513fdc022f99$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = $95c0513fdc022f99$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, undefined, (0, $iCQyW._)({}, boundaryMatch.route.id, result.error))
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $95c0513fdc022f99$var$_extends({}, context, {
                                statusCode: $95c0513fdc022f99$export$972111febbeef05b(result.error) ? result.error.status : 500,
                                actionData: null,
                                actionHeaders: $95c0513fdc022f99$var$_extends({}, result.headers ? (0, $iCQyW._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $95c0513fdc022f99$var$_extends({}, context1, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionData: (0, $iCQyW._)({}, actionMatch.route.id, result.data),
                                actionHeaders: $95c0513fdc022f99$var$_extends({}, result.headers ? (0, $iCQyW._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $7hBys._)(function(request, matches, requestContext, routeMatch, pendingActionError) {
            var isRouteRequest, requestMatches, matchesToLoad, results, method, activeDeferreds, context, executedLoaders;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $95c0513fdc022f99$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : $95c0513fdc022f99$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $iCQyW._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionError || null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            Promise.all((0, $fyztb._)(matchesToLoad.map(function(match) {
                                return $95c0513fdc022f99$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                                    isStaticRequest: true,
                                    isRouteRequest: isRouteRequest,
                                    requestContext: requestContext
                                });
                            })))
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
                        }
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = $95c0513fdc022f99$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $95c0513fdc022f99$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $95c0513fdc022f99$export$fec11da027c70692(routes, context, error) {
    var newContext = $95c0513fdc022f99$var$_extends({}, context, {
        statusCode: 500,
        errors: (0, $iCQyW._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $95c0513fdc022f99$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $95c0513fdc022f99$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $95c0513fdc022f99$export$cae722b0cc860f13(to ? to : ".", $95c0513fdc022f99$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $95c0513fdc022f99$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$95c0513fdc022f99$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $95c0513fdc022f99$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $95c0513fdc022f99$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $95c0513fdc022f99$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$95c0513fdc022f99$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$95c0513fdc022f99$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $95c0513fdc022f99$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $95c0513fdc022f99$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $95c0513fdc022f99$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$95c0513fdc022f99$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $52tJv._)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$95c0513fdc022f99$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $95c0513fdc022f99$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $95c0513fdc022f99$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $95c0513fdc022f99$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $95c0513fdc022f99$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $95c0513fdc022f99$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($95c0513fdc022f99$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $95c0513fdc022f99$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $95c0513fdc022f99$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $95c0513fdc022f99$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $95c0513fdc022f99$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $95c0513fdc022f99$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    var actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    var boundaryMatches = $95c0513fdc022f99$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($95c0513fdc022f99$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $95c0513fdc022f99$var$shouldRevalidateLoader(match, $95c0513fdc022f99$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $95c0513fdc022f99$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = $95c0513fdc022f99$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = $95c0513fdc022f99$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $95c0513fdc022f99$var$shouldRevalidateLoader(fetcherMatch, $95c0513fdc022f99$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $95c0513fdc022f99$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $95c0513fdc022f99$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $95c0513fdc022f99$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $95c0513fdc022f99$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $95c0513fdc022f99$var$_loadLazyRouteModule.apply(this, arguments);
}
function $95c0513fdc022f99$var$_loadLazyRouteModule() {
    $95c0513fdc022f99$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $7hBys._)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $95c0513fdc022f99$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $95c0513fdc022f99$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$95c0513fdc022f99$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $95c0513fdc022f99$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $95c0513fdc022f99$var$_loadLazyRouteModule.apply(this, arguments);
}
function $95c0513fdc022f99$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    return $95c0513fdc022f99$var$_callLoaderOrAction.apply(this, arguments);
}
function $95c0513fdc022f99$var$_callLoaderOrAction() {
    $95c0513fdc022f99$var$_callLoaderOrAction = (0, $7hBys._)(function(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
        var resultType, result, onReject, runHandler, handler, handlerError, values, url, pathname, url1, pathname1, e, status, location, currentUrl, url2, isSameBasename, queryRouteResponse, data, contentType, e1, _result$init, _result$init2;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (opts === void 0) opts = {};
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        return Promise.race([
                            handler({
                                request: request,
                                params: match.params,
                                context: opts.requestContext
                            }),
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            $95c0513fdc022f99$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    values = _state.sent();
                    if (handlerError) throw handlerError;
                    result = values[0];
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $95c0513fdc022f99$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still run even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $95c0513fdc022f99$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $95c0513fdc022f99$var$ResultType.data,
                            data: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $95c0513fdc022f99$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $95c0513fdc022f99$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    resultType = $95c0513fdc022f99$var$ResultType.error;
                    result = e;
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    if (!$95c0513fdc022f99$var$isResponse(result)) return [
                        3,
                        24
                    ];
                    status = result.status;
                    // Process redirects
                    if ($95c0513fdc022f99$var$redirectStatusCodes.has(status)) {
                        location = result.headers.get("Location");
                        $95c0513fdc022f99$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
                        // Support relative routing in internal redirects
                        if (!$95c0513fdc022f99$var$ABSOLUTE_URL_REGEX.test(location)) location = $95c0513fdc022f99$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
                        else if (!opts.isStaticRequest) {
                            // Strip off the protocol+origin for same-origin + same-basename absolute
                            // redirects. If this is a static request, we can let it go back to the
                            // browser as-is
                            currentUrl = new URL(request.url);
                            url2 = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                            isSameBasename = $95c0513fdc022f99$export$b69e3301ce081aa3(url2.pathname, basename) != null;
                            if (url2.origin === currentUrl.origin && isSameBasename) location = url2.pathname + url2.search + url2.hash;
                        }
                        // Don't process redirects in the router during static requests requests.
                        // Instead, throw the Response and let the server handle it with an HTTP
                        // redirect.  We also update the Location header in place in this flow so
                        // basename and relative routing is taken into account
                        if (opts.isStaticRequest) {
                            result.headers.set("Location", location);
                            throw result;
                        }
                        return [
                            2,
                            {
                                type: $95c0513fdc022f99$var$ResultType.redirect,
                                status: status,
                                location: location,
                                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
                            }
                        ];
                    }
                    // For SSR single-route requests, we want to hand Responses back directly
                    // without unwrapping.  We do this with the QueryRouteResponse wrapper
                    // interface so we can know whether it was returned or thrown
                    if (opts.isRouteRequest) {
                        queryRouteResponse = {
                            type: resultType === $95c0513fdc022f99$var$ResultType.error ? $95c0513fdc022f99$var$ResultType.error : $95c0513fdc022f99$var$ResultType.data,
                            response: result
                        };
                        throw queryRouteResponse;
                    }
                    _state.label = 15;
                case 15:
                    _state.trys.push([
                        15,
                        22,
                        ,
                        23
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        19
                    ];
                    if (!(result.body == null)) return [
                        3,
                        16
                    ];
                    data = null;
                    return [
                        3,
                        18
                    ];
                case 16:
                    return [
                        4,
                        result.json()
                    ];
                case 17:
                    data = _state.sent();
                    _state.label = 18;
                case 18:
                    return [
                        3,
                        21
                    ];
                case 19:
                    return [
                        4,
                        result.text()
                    ];
                case 20:
                    data = _state.sent();
                    _state.label = 21;
                case 21:
                    return [
                        3,
                        23
                    ];
                case 22:
                    e1 = _state.sent();
                    return [
                        2,
                        {
                            type: $95c0513fdc022f99$var$ResultType.error,
                            error: e1
                        }
                    ];
                case 23:
                    if (resultType === $95c0513fdc022f99$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: new $95c0513fdc022f99$export$6c6580e81da25755(status, result.statusText, data),
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $95c0513fdc022f99$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 24:
                    if (resultType === $95c0513fdc022f99$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: result
                        }
                    ];
                    if ($95c0513fdc022f99$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $95c0513fdc022f99$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $95c0513fdc022f99$var$ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return $95c0513fdc022f99$var$_callLoaderOrAction.apply(this, arguments);
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $95c0513fdc022f99$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($95c0513fdc022f99$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $95c0513fdc022f99$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $95c0513fdc022f99$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $95c0513fdc022f99$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $52tJv._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $95c0513fdc022f99$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $52tJv._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $95c0513fdc022f99$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $95c0513fdc022f99$export$3e9cee6b33872309(!$95c0513fdc022f99$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($95c0513fdc022f99$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            var boundaryMatch = $95c0513fdc022f99$var$findNearestBoundary(matches, id);
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $95c0513fdc022f99$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($95c0513fdc022f99$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $95c0513fdc022f99$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $95c0513fdc022f99$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $95c0513fdc022f99$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($95c0513fdc022f99$var$isErrorResult(result)) {
            var boundaryMatch = $95c0513fdc022f99$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $95c0513fdc022f99$var$_extends({}, errors, (0, $iCQyW._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if ($95c0513fdc022f99$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $95c0513fdc022f99$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($95c0513fdc022f99$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $95c0513fdc022f99$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $95c0513fdc022f99$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $95c0513fdc022f99$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $95c0513fdc022f99$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $95c0513fdc022f99$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $fyztb._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $95c0513fdc022f99$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $95c0513fdc022f99$var$getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $95c0513fdc022f99$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $95c0513fdc022f99$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($95c0513fdc022f99$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $95c0513fdc022f99$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $95c0513fdc022f99$export$8ccf933b0513f8d0(path) : path;
    return $95c0513fdc022f99$export$fe53371bee54353d($95c0513fdc022f99$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $95c0513fdc022f99$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $95c0513fdc022f99$var$isDeferredResult(result) {
    return result.type === $95c0513fdc022f99$var$ResultType.deferred;
}
function $95c0513fdc022f99$var$isErrorResult(result) {
    return result.type === $95c0513fdc022f99$var$ResultType.error;
}
function $95c0513fdc022f99$var$isRedirectResult(result) {
    return (result && result.type) === $95c0513fdc022f99$var$ResultType.redirect;
}
function $95c0513fdc022f99$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $95c0513fdc022f99$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $95c0513fdc022f99$var$isRedirectResponse(result) {
    if (!$95c0513fdc022f99$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $95c0513fdc022f99$var$isQueryRouteResponse(obj) {
    return obj && $95c0513fdc022f99$var$isResponse(obj.response) && (obj.type === $95c0513fdc022f99$var$ResultType.data || obj.type === $95c0513fdc022f99$var$ResultType.error);
}
function $95c0513fdc022f99$var$isValidMethod(method) {
    return $95c0513fdc022f99$var$validRequestMethods.has(method.toLowerCase());
}
function $95c0513fdc022f99$var$isMutationMethod(method) {
    return $95c0513fdc022f99$var$validMutationMethods.has(method.toLowerCase());
}
function $95c0513fdc022f99$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $95c0513fdc022f99$var$_resolveDeferredResults.apply(this, arguments);
}
function $95c0513fdc022f99$var$_resolveDeferredResults() {
    $95c0513fdc022f99$var$_resolveDeferredResults = (0, $7hBys._)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $ajhIL.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$95c0513fdc022f99$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($95c0513fdc022f99$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    signal = signals[index];
                                    $95c0513fdc022f99$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $95c0513fdc022f99$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $ajhIL.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $95c0513fdc022f99$var$_resolveDeferredResults.apply(this, arguments);
}
function $95c0513fdc022f99$var$resolveDeferredData(result, signal, unwrap) {
    return $95c0513fdc022f99$var$_resolveDeferredData.apply(this, arguments);
}
function $95c0513fdc022f99$var$_resolveDeferredData() {
    $95c0513fdc022f99$var$_resolveDeferredData = (0, $7hBys._)(function(result, signal, unwrap) {
        var aborted;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $95c0513fdc022f99$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $95c0513fdc022f99$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $95c0513fdc022f99$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $95c0513fdc022f99$var$_resolveDeferredData.apply(this, arguments);
}
function $95c0513fdc022f99$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function $95c0513fdc022f99$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $95c0513fdc022f99$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $95c0513fdc022f99$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $95c0513fdc022f99$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $95c0513fdc022f99$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $95c0513fdc022f99$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $95c0513fdc022f99$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $95c0513fdc022f99$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function $95c0513fdc022f99$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $95c0513fdc022f99$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $95c0513fdc022f99$var$restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem($95c0513fdc022f99$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $52tJv._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $95c0513fdc022f99$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $52tJv._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $fyztb._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem($95c0513fdc022f99$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $95c0513fdc022f99$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.21.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $kcqLc = parcelRequire("kcqLc");

var $52tJv = parcelRequire("52tJv");

var $fyztb = parcelRequire("fyztb");

var $4jYWU = parcelRequire("4jYWU");

var $17VE6 = parcelRequire("17VE6");

function $00b7b35226fb1bf3$var$_extends() {
    $00b7b35226fb1bf3$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $00b7b35226fb1bf3$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $00b7b35226fb1bf3$export$3add0d5dce533e2e = /*#__PURE__*/ $17VE6.createContext(null);
var $00b7b35226fb1bf3$export$145dfa71566a64dc = /*#__PURE__*/ $17VE6.createContext(null);
var $00b7b35226fb1bf3$var$AwaitContext = /*#__PURE__*/ $17VE6.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $00b7b35226fb1bf3$export$26749e8557646306 = /*#__PURE__*/ $17VE6.createContext(null);
var $00b7b35226fb1bf3$export$c7914228fb69b0f5 = /*#__PURE__*/ $17VE6.createContext(null);
var $00b7b35226fb1bf3$export$9072aa6dd1f93057 = /*#__PURE__*/ $17VE6.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $00b7b35226fb1bf3$var$RouteErrorContext = /*#__PURE__*/ $17VE6.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $00b7b35226fb1bf3$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$00b7b35226fb1bf3$export$9c954a9d03d32f4a() && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    var _React_useContext = $17VE6.useContext($00b7b35226fb1bf3$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $00b7b35226fb1bf3$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $95c0513fdc022f99$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $00b7b35226fb1bf3$export$9c954a9d03d32f4a() {
    return $17VE6.useContext($00b7b35226fb1bf3$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $00b7b35226fb1bf3$export$45d76561a5302f2b() {
    !$00b7b35226fb1bf3$export$9c954a9d03d32f4a() && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    return $17VE6.useContext($00b7b35226fb1bf3$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $00b7b35226fb1bf3$export$1b3f31771c5d07c() {
    return $17VE6.useContext($00b7b35226fb1bf3$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $00b7b35226fb1bf3$export$6c330e8992e8a295(pattern) {
    !$00b7b35226fb1bf3$export$9c954a9d03d32f4a() && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    var pathname = $00b7b35226fb1bf3$export$45d76561a5302f2b().pathname;
    return $17VE6.useMemo(function() {
        return (0, $95c0513fdc022f99$export$81336c211d5ff295)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $00b7b35226fb1bf3$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $00b7b35226fb1bf3$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $17VE6.useContext($00b7b35226fb1bf3$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $17VE6.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $00b7b35226fb1bf3$export$9770f232ac06a008() {
    var isDataRoute = $17VE6.useContext($00b7b35226fb1bf3$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $00b7b35226fb1bf3$var$useNavigateStable() : $00b7b35226fb1bf3$var$useNavigateUnstable();
}
function $00b7b35226fb1bf3$var$useNavigateUnstable() {
    !$00b7b35226fb1bf3$export$9c954a9d03d32f4a() && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    var dataRouterContext = $17VE6.useContext($00b7b35226fb1bf3$export$3add0d5dce533e2e);
    var _React_useContext = $17VE6.useContext($00b7b35226fb1bf3$export$26749e8557646306), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = $17VE6.useContext($00b7b35226fb1bf3$export$9072aa6dd1f93057).matches;
    var _useLocation = $00b7b35226fb1bf3$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $95c0513fdc022f99$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    var activeRef = $17VE6.useRef(false);
    $00b7b35226fb1bf3$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $17VE6.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $95c0513fdc022f99$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $95c0513fdc022f99$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $00b7b35226fb1bf3$var$OutletContext = /*#__PURE__*/ $17VE6.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $00b7b35226fb1bf3$export$4138103a3ae699cc() {
    return $17VE6.useContext($00b7b35226fb1bf3$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $00b7b35226fb1bf3$export$a3be3530d8e40d0b(context) {
    var outlet = $17VE6.useContext($00b7b35226fb1bf3$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $00b7b35226fb1bf3$export$99eaa27ddbbb95ef() {
    var matches = $17VE6.useContext($00b7b35226fb1bf3$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $00b7b35226fb1bf3$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = $17VE6.useContext($00b7b35226fb1bf3$export$26749e8557646306).future;
    var matches = $17VE6.useContext($00b7b35226fb1bf3$export$9072aa6dd1f93057).matches;
    var _useLocation = $00b7b35226fb1bf3$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $95c0513fdc022f99$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $17VE6.useMemo(function() {
        return (0, $95c0513fdc022f99$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $00b7b35226fb1bf3$export$5d3fca4a98652595(routes, locationArg) {
    return $00b7b35226fb1bf3$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $00b7b35226fb1bf3$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$00b7b35226fb1bf3$export$9c954a9d03d32f4a() && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    var navigator = $17VE6.useContext($00b7b35226fb1bf3$export$26749e8557646306).navigator;
    var _React_useContext = $17VE6.useContext($00b7b35226fb1bf3$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $00b7b35226fb1bf3$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $95c0513fdc022f99$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    var matches = (0, $95c0513fdc022f99$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $00b7b35226fb1bf3$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $95c0513fdc022f99$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $95c0513fdc022f99$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $00b7b35226fb1bf3$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $95c0513fdc022f99$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $00b7b35226fb1bf3$var$DefaultErrorComponent() {
    var error = $00b7b35226fb1bf3$export$ed527bf60f6e05f2();
    var message = (0, $95c0513fdc022f99$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $17VE6.createElement($17VE6.Fragment, null, /*#__PURE__*/ $17VE6.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $17VE6.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $17VE6.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $00b7b35226fb1bf3$var$defaultErrorElement = /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$var$DefaultErrorComponent, null);
var $00b7b35226fb1bf3$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $kcqLc._)(RenderErrorBoundary, _React_Component);
    var _super = (0, $4jYWU._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $5sFFs._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $8O2fV._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($17VE6.Component);
function $00b7b35226fb1bf3$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $17VE6.useContext($00b7b35226fb1bf3$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $00b7b35226fb1bf3$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]);
        });
        !(errorIndex >= 0) && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $00b7b35226fb1bf3$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $00b7b35226fb1bf3$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $17VE6.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $00b7b35226fb1bf3$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($00b7b35226fb1bf3$var$DataRouterHook || {});
var $00b7b35226fb1bf3$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($00b7b35226fb1bf3$var$DataRouterStateHook || {});
function $00b7b35226fb1bf3$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $00b7b35226fb1bf3$var$useDataRouterContext(hookName) {
    var ctx = $17VE6.useContext($00b7b35226fb1bf3$export$3add0d5dce533e2e);
    !ctx && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    return ctx;
}
function $00b7b35226fb1bf3$var$useDataRouterState(hookName) {
    var state = $17VE6.useContext($00b7b35226fb1bf3$export$145dfa71566a64dc);
    !state && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    return state;
}
function $00b7b35226fb1bf3$var$useRouteContext(hookName) {
    var route = $17VE6.useContext($00b7b35226fb1bf3$export$9072aa6dd1f93057);
    !route && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $00b7b35226fb1bf3$var$useCurrentRouteId(hookName) {
    var route = $00b7b35226fb1bf3$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $00b7b35226fb1bf3$export$5fc8298006ad9e58() {
    return $00b7b35226fb1bf3$var$useCurrentRouteId($00b7b35226fb1bf3$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $00b7b35226fb1bf3$export$d0fd4b7106de2769() {
    var state = $00b7b35226fb1bf3$var$useDataRouterState($00b7b35226fb1bf3$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $00b7b35226fb1bf3$export$600dc272ed516c15() {
    var dataRouterContext = $00b7b35226fb1bf3$var$useDataRouterContext($00b7b35226fb1bf3$var$DataRouterHook.UseRevalidator);
    var state = $00b7b35226fb1bf3$var$useDataRouterState($00b7b35226fb1bf3$var$DataRouterStateHook.UseRevalidator);
    return $17VE6.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $00b7b35226fb1bf3$export$2378eb7f5ff86053() {
    var _useDataRouterState = $00b7b35226fb1bf3$var$useDataRouterState($00b7b35226fb1bf3$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $17VE6.useMemo(function() {
        return matches.map(function(m) {
            return (0, $95c0513fdc022f99$export$b3fac024fad9e8ff)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $00b7b35226fb1bf3$export$1448a5050d252c4d() {
    var state = $00b7b35226fb1bf3$var$useDataRouterState($00b7b35226fb1bf3$var$DataRouterStateHook.UseLoaderData);
    var routeId = $00b7b35226fb1bf3$var$useCurrentRouteId($00b7b35226fb1bf3$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $00b7b35226fb1bf3$export$fd5d37484eab868d(routeId) {
    var state = $00b7b35226fb1bf3$var$useDataRouterState($00b7b35226fb1bf3$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $00b7b35226fb1bf3$export$fdc00f3f26066d5e() {
    var state = $00b7b35226fb1bf3$var$useDataRouterState($00b7b35226fb1bf3$var$DataRouterStateHook.UseActionData);
    var routeId = $00b7b35226fb1bf3$var$useCurrentRouteId($00b7b35226fb1bf3$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $00b7b35226fb1bf3$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $17VE6.useContext($00b7b35226fb1bf3$var$RouteErrorContext);
    var state = $00b7b35226fb1bf3$var$useDataRouterState($00b7b35226fb1bf3$var$DataRouterStateHook.UseRouteError);
    var routeId = $00b7b35226fb1bf3$var$useCurrentRouteId($00b7b35226fb1bf3$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $00b7b35226fb1bf3$export$78a72ddb39bdd145() {
    var value = $17VE6.useContext($00b7b35226fb1bf3$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $00b7b35226fb1bf3$export$17f53340677d5831() {
    var value = $17VE6.useContext($00b7b35226fb1bf3$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $00b7b35226fb1bf3$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $00b7b35226fb1bf3$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $00b7b35226fb1bf3$var$useDataRouterContext($00b7b35226fb1bf3$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $00b7b35226fb1bf3$var$useDataRouterState($00b7b35226fb1bf3$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $52tJv._)($17VE6.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $17VE6.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $00b7b35226fb1bf3$var$_extends({}, currentLocation, {
                pathname: (0, $95c0513fdc022f99$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $00b7b35226fb1bf3$var$_extends({}, nextLocation, {
                pathname: (0, $95c0513fdc022f99$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $17VE6.useEffect(function() {
        var key = String(++$00b7b35226fb1bf3$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $17VE6.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $95c0513fdc022f99$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $00b7b35226fb1bf3$var$useNavigateStable() {
    var router = $00b7b35226fb1bf3$var$useDataRouterContext($00b7b35226fb1bf3$var$DataRouterHook.UseNavigateStable).router;
    var id = $00b7b35226fb1bf3$var$useCurrentRouteId($00b7b35226fb1bf3$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $17VE6.useRef(false);
    $00b7b35226fb1bf3$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $17VE6.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $00b7b35226fb1bf3$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $00b7b35226fb1bf3$var$alreadyWarned = {};
function $00b7b35226fb1bf3$var$warningOnce(key, cond, message) {
    if (!cond && !$00b7b35226fb1bf3$var$alreadyWarned[key]) $00b7b35226fb1bf3$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $00b7b35226fb1bf3$var$START_TRANSITION = "startTransition";
var $00b7b35226fb1bf3$var$startTransitionImpl = $17VE6[$00b7b35226fb1bf3$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $00b7b35226fb1bf3$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $52tJv._)($17VE6.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $17VE6.useCallback(function(newState) {
        if (v7_startTransition && $00b7b35226fb1bf3$var$startTransitionImpl) $00b7b35226fb1bf3$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $17VE6.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $17VE6.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $17VE6.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $17VE6.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $17VE6.createElement($17VE6.Fragment, null, /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $00b7b35226fb1bf3$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return $00b7b35226fb1bf3$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $00b7b35226fb1bf3$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $17VE6.useRef();
    if (historyRef.current == null) historyRef.current = (0, $95c0513fdc022f99$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $52tJv._)($17VE6.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $17VE6.useCallback(function(newState) {
        v7_startTransition && $00b7b35226fb1bf3$var$startTransitionImpl ? $00b7b35226fb1bf3$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $17VE6.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $00b7b35226fb1bf3$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$00b7b35226fb1bf3$export$9c954a9d03d32f4a() && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    var _React_useContext = $17VE6.useContext($00b7b35226fb1bf3$export$26749e8557646306), future = _React_useContext.future, isStatic = _React_useContext.static;
    var matches = $17VE6.useContext($00b7b35226fb1bf3$export$9072aa6dd1f93057).matches;
    var _useLocation = $00b7b35226fb1bf3$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $00b7b35226fb1bf3$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $95c0513fdc022f99$export$cae722b0cc860f13)(to, (0, $95c0513fdc022f99$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $17VE6.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $00b7b35226fb1bf3$export$910ae8079b2c2852(props) {
    return $00b7b35226fb1bf3$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $00b7b35226fb1bf3$export$e7b0ac011bb776c6(_props) {
    (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $00b7b35226fb1bf3$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $95c0513fdc022f99$export$e19cd5f9376f8cee).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!$00b7b35226fb1bf3$export$9c954a9d03d32f4a() && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $17VE6.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $00b7b35226fb1bf3$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $95c0513fdc022f99$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $17VE6.useMemo(function() {
        var trailingPathname = (0, $95c0513fdc022f99$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $00b7b35226fb1bf3$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $00b7b35226fb1bf3$export$5d3fca4a98652595($00b7b35226fb1bf3$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $00b7b35226fb1bf3$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$var$ResolveAwait, null, children));
}
var $00b7b35226fb1bf3$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($00b7b35226fb1bf3$var$AwaitRenderStatus || {});
var $00b7b35226fb1bf3$var$neverSettledPromise = new Promise(function() {});
var $00b7b35226fb1bf3$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $kcqLc._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $4jYWU._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $5sFFs._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $8O2fV._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $00b7b35226fb1bf3$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $00b7b35226fb1bf3$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $00b7b35226fb1bf3$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? $00b7b35226fb1bf3$var$AwaitRenderStatus.error : promise._data !== undefined ? $00b7b35226fb1bf3$var$AwaitRenderStatus.success : $00b7b35226fb1bf3$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $00b7b35226fb1bf3$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $00b7b35226fb1bf3$var$AwaitRenderStatus.error && promise._error instanceof (0, $95c0513fdc022f99$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $00b7b35226fb1bf3$var$neverSettledPromise;
                if (status === $00b7b35226fb1bf3$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $00b7b35226fb1bf3$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $00b7b35226fb1bf3$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $17VE6.createElement($00b7b35226fb1bf3$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($17VE6.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $00b7b35226fb1bf3$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $00b7b35226fb1bf3$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $17VE6.createElement($17VE6.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $00b7b35226fb1bf3$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $17VE6.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $17VE6.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $fyztb._)(parentPath).concat([
            index
        ]);
        if (element.type === $17VE6.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $00b7b35226fb1bf3$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $00b7b35226fb1bf3$export$e7b0ac011bb776c6) && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $00b7b35226fb1bf3$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $00b7b35226fb1bf3$export$daf73786167a7f72(matches) {
    return $00b7b35226fb1bf3$var$_renderMatches(matches);
}
function $00b7b35226fb1bf3$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $17VE6.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $17VE6.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $17VE6.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $00b7b35226fb1bf3$export$f30f7e456d254e83(routes, opts) {
    return (0, $95c0513fdc022f99$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $00b7b35226fb1bf3$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $95c0513fdc022f99$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $00b7b35226fb1bf3$export$52b333d321859367
    }).initialize();
}



function $fed91b90a22b2b22$var$_extends() {
    $fed91b90a22b2b22$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fed91b90a22b2b22$var$_extends.apply(this, arguments);
}
function $fed91b90a22b2b22$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $fed91b90a22b2b22$var$defaultMethod = "get";
var $fed91b90a22b2b22$var$defaultEncType = "application/x-www-form-urlencoded";
function $fed91b90a22b2b22$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $fed91b90a22b2b22$var$isButtonElement(object) {
    return $fed91b90a22b2b22$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $fed91b90a22b2b22$var$isFormElement(object) {
    return $fed91b90a22b2b22$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $fed91b90a22b2b22$var$isInputElement(object) {
    return $fed91b90a22b2b22$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $fed91b90a22b2b22$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $fed91b90a22b2b22$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$fed91b90a22b2b22$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $fed91b90a22b2b22$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $fed91b90a22b2b22$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $fed91b90a22b2b22$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $fed91b90a22b2b22$var$_formDataSupportsSubmitter = null;
function $fed91b90a22b2b22$var$isFormDataSubmitterSupported() {
    if ($fed91b90a22b2b22$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $fed91b90a22b2b22$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $fed91b90a22b2b22$var$_formDataSupportsSubmitter = true;
    }
    return $fed91b90a22b2b22$var$_formDataSupportsSubmitter;
}
var $fed91b90a22b2b22$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $fed91b90a22b2b22$var$getFormEncType(encType) {
    if (encType != null && !$fed91b90a22b2b22$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $fed91b90a22b2b22$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($fed91b90a22b2b22$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $95c0513fdc022f99$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $fed91b90a22b2b22$var$defaultMethod;
        encType = $fed91b90a22b2b22$var$getFormEncType(target.getAttribute("enctype")) || $fed91b90a22b2b22$var$defaultEncType;
        formData = new FormData(target);
    } else if ($fed91b90a22b2b22$var$isButtonElement(target) || $fed91b90a22b2b22$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $95c0513fdc022f99$export$b69e3301ce081aa3)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $fed91b90a22b2b22$var$defaultMethod;
        encType = $fed91b90a22b2b22$var$getFormEncType(target.getAttribute("formenctype")) || $fed91b90a22b2b22$var$getFormEncType(form.getAttribute("enctype")) || $fed91b90a22b2b22$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$fed91b90a22b2b22$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($fed91b90a22b2b22$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $fed91b90a22b2b22$var$defaultMethod;
        action = null;
        encType = $fed91b90a22b2b22$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $fed91b90a22b2b22$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $fed91b90a22b2b22$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $fed91b90a22b2b22$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $fed91b90a22b2b22$export$1f3f55432a00e06d(routes, opts) {
    return (0, $95c0513fdc022f99$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fed91b90a22b2b22$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $95c0513fdc022f99$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fed91b90a22b2b22$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $00b7b35226fb1bf3$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fed91b90a22b2b22$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $95c0513fdc022f99$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fed91b90a22b2b22$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $95c0513fdc022f99$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fed91b90a22b2b22$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $00b7b35226fb1bf3$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fed91b90a22b2b22$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $fed91b90a22b2b22$var$_extends({}, state, {
        errors: $fed91b90a22b2b22$var$deserializeErrors(state.errors)
    });
    return state;
}
function $fed91b90a22b2b22$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $52tJv._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $95c0513fdc022f99$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $fed91b90a22b2b22$export$7ad602f0e94e62d1 = /*#__PURE__*/ $17VE6.createContext({
    isTransitioning: false
});
var $fed91b90a22b2b22$export$148fd98d095596d4 = /*#__PURE__*/ $17VE6.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $fed91b90a22b2b22$var$START_TRANSITION = "startTransition";
var $fed91b90a22b2b22$var$startTransitionImpl = $17VE6[$fed91b90a22b2b22$var$START_TRANSITION];
var $fed91b90a22b2b22$var$FLUSH_SYNC = "flushSync";
var $fed91b90a22b2b22$var$flushSyncImpl = $62qDs[$fed91b90a22b2b22$var$FLUSH_SYNC];
var $fed91b90a22b2b22$var$USE_ID = "useId";
var $fed91b90a22b2b22$var$useIdImpl = $17VE6[$fed91b90a22b2b22$var$USE_ID];
function $fed91b90a22b2b22$var$startTransitionSafe(cb) {
    if ($fed91b90a22b2b22$var$startTransitionImpl) $fed91b90a22b2b22$var$startTransitionImpl(cb);
    else cb();
}
function $fed91b90a22b2b22$var$flushSyncSafe(cb) {
    if ($fed91b90a22b2b22$var$flushSyncImpl) $fed91b90a22b2b22$var$flushSyncImpl(cb);
    else cb();
}
var $fed91b90a22b2b22$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $5sFFs._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $fed91b90a22b2b22$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $52tJv._)($17VE6.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $52tJv._)($17VE6.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $52tJv._)($17VE6.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $52tJv._)($17VE6.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $52tJv._)($17VE6.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $52tJv._)($17VE6.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $17VE6.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $17VE6.useCallback(function(cb) {
        if (v7_startTransition) $fed91b90a22b2b22$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $17VE6.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.unstable_flushSync, viewTransitionOpts = _ref2.unstable_viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        var isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $fed91b90a22b2b22$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $fed91b90a22b2b22$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $fed91b90a22b2b22$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished.finally(function() {
                $fed91b90a22b2b22$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $fed91b90a22b2b22$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $17VE6.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $17VE6.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $fed91b90a22b2b22$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $17VE6.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $7hBys._)(function() {
                return (0, $ajhIL.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $17VE6.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $17VE6.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $17VE6.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $17VE6.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $17VE6.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $17VE6.createElement($17VE6.Fragment, null, /*#__PURE__*/ $17VE6.createElement((0, $00b7b35226fb1bf3$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $17VE6.createElement((0, $00b7b35226fb1bf3$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $17VE6.createElement($fed91b90a22b2b22$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $17VE6.createElement($fed91b90a22b2b22$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $17VE6.createElement((0, $00b7b35226fb1bf3$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $17VE6.createElement($fed91b90a22b2b22$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $fed91b90a22b2b22$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, $00b7b35226fb1bf3$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $fed91b90a22b2b22$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $17VE6.useRef();
    if (historyRef.current == null) historyRef.current = (0, $95c0513fdc022f99$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $52tJv._)($17VE6.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $17VE6.useCallback(function(newState) {
        v7_startTransition && $fed91b90a22b2b22$var$startTransitionImpl ? $fed91b90a22b2b22$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $17VE6.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $17VE6.createElement((0, $00b7b35226fb1bf3$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $fed91b90a22b2b22$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $17VE6.useRef();
    if (historyRef.current == null) historyRef.current = (0, $95c0513fdc022f99$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $52tJv._)($17VE6.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $17VE6.useCallback(function(newState) {
        v7_startTransition && $fed91b90a22b2b22$var$startTransitionImpl ? $fed91b90a22b2b22$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $17VE6.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $17VE6.createElement((0, $00b7b35226fb1bf3$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $fed91b90a22b2b22$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $52tJv._)($17VE6.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $17VE6.useCallback(function(newState) {
        v7_startTransition && $fed91b90a22b2b22$var$startTransitionImpl ? $fed91b90a22b2b22$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $17VE6.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $17VE6.createElement((0, $00b7b35226fb1bf3$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var $fed91b90a22b2b22$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $fed91b90a22b2b22$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $fed91b90a22b2b22$export$a6c7ac8248d6e38a = /*#__PURE__*/ $17VE6.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, unstable_viewTransition = _ref7.unstable_viewTransition, rest = $fed91b90a22b2b22$var$_objectWithoutPropertiesLoose(_ref7, $fed91b90a22b2b22$var$_excluded);
    var basename = $17VE6.useContext((0, $00b7b35226fb1bf3$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $fed91b90a22b2b22$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($fed91b90a22b2b22$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $95c0513fdc022f99$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $00b7b35226fb1bf3$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $fed91b90a22b2b22$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $17VE6.createElement("a", $fed91b90a22b2b22$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $fed91b90a22b2b22$export$b0d92dbee9b5b60d = /*#__PURE__*/ $17VE6.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, unstable_viewTransition = _ref8.unstable_viewTransition, children = _ref8.children, rest = $fed91b90a22b2b22$var$_objectWithoutPropertiesLoose(_ref8, $fed91b90a22b2b22$var$_excluded2);
    var path = (0, $00b7b35226fb1bf3$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $00b7b35226fb1bf3$export$45d76561a5302f2b)();
    var routerState = $17VE6.useContext((0, $00b7b35226fb1bf3$export$145dfa71566a64dc));
    var _React_useContext = $17VE6.useContext((0, $00b7b35226fb1bf3$export$26749e8557646306)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fed91b90a22b2b22$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $95c0513fdc022f99$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $17VE6.createElement($fed91b90a22b2b22$export$a6c7ac8248d6e38a, $fed91b90a22b2b22$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $fed91b90a22b2b22$export$a7fed597f4b8afd8 = /*#__PURE__*/ $17VE6.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $fed91b90a22b2b22$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, unstable_viewTransition = _ref9.unstable_viewTransition, props = $fed91b90a22b2b22$var$_objectWithoutPropertiesLoose(_ref9, $fed91b90a22b2b22$var$_excluded3);
    var submit = $fed91b90a22b2b22$export$47c85c6e3a081d3();
    var formAction = $fed91b90a22b2b22$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $17VE6.createElement("form", $fed91b90a22b2b22$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $fed91b90a22b2b22$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $fed91b90a22b2b22$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $fed91b90a22b2b22$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($fed91b90a22b2b22$var$DataRouterHook || ($fed91b90a22b2b22$var$DataRouterHook = {}));
var $fed91b90a22b2b22$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($fed91b90a22b2b22$var$DataRouterStateHook || ($fed91b90a22b2b22$var$DataRouterStateHook = {}));
// Internal hooks
function $fed91b90a22b2b22$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $fed91b90a22b2b22$var$useDataRouterContext(hookName) {
    var ctx = $17VE6.useContext((0, $00b7b35226fb1bf3$export$3add0d5dce533e2e));
    !ctx && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    return ctx;
}
function $fed91b90a22b2b22$var$useDataRouterState(hookName) {
    var state = $17VE6.useContext((0, $00b7b35226fb1bf3$export$145dfa71566a64dc));
    !state && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $fed91b90a22b2b22$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, unstable_viewTransition = _ref.unstable_viewTransition;
    var navigate = (0, $00b7b35226fb1bf3$export$9770f232ac06a008)();
    var location = (0, $00b7b35226fb1bf3$export$45d76561a5302f2b)();
    var path = (0, $00b7b35226fb1bf3$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $17VE6.useCallback(function(event) {
        if ($fed91b90a22b2b22$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $95c0513fdc022f99$export$fe53371bee54353d)(location) === (0, $95c0513fdc022f99$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $fed91b90a22b2b22$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $17VE6.useRef($fed91b90a22b2b22$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $17VE6.useRef(false);
    var location = (0, $00b7b35226fb1bf3$export$45d76561a5302f2b)();
    var searchParams = $17VE6.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $fed91b90a22b2b22$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $00b7b35226fb1bf3$export$9770f232ac06a008)();
    var setSearchParams = $17VE6.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $fed91b90a22b2b22$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $fed91b90a22b2b22$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $fed91b90a22b2b22$var$fetcherId = 0;
var $fed91b90a22b2b22$var$getUniqueFetcherId = function() {
    return "__" + String(++$fed91b90a22b2b22$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $fed91b90a22b2b22$export$47c85c6e3a081d3() {
    var router = $fed91b90a22b2b22$var$useDataRouterContext($fed91b90a22b2b22$var$DataRouterHook.UseSubmit).router;
    var basename = $17VE6.useContext((0, $00b7b35226fb1bf3$export$26749e8557646306)).basename;
    var currentRouteId = (0, $00b7b35226fb1bf3$export$5fc8298006ad9e58)();
    return $17VE6.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $fed91b90a22b2b22$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $fed91b90a22b2b22$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $fed91b90a22b2b22$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $fed91b90a22b2b22$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $17VE6.useContext((0, $00b7b35226fb1bf3$export$26749e8557646306)).basename;
    var routeContext = $17VE6.useContext((0, $00b7b35226fb1bf3$export$9072aa6dd1f93057));
    !routeContext && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $52tJv._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $fed91b90a22b2b22$var$_extends({}, (0, $00b7b35226fb1bf3$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $00b7b35226fb1bf3$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $95c0513fdc022f99$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $95c0513fdc022f99$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $fed91b90a22b2b22$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $fed91b90a22b2b22$var$useDataRouterContext($fed91b90a22b2b22$var$DataRouterHook.UseFetcher).router;
    var state = $fed91b90a22b2b22$var$useDataRouterState($fed91b90a22b2b22$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $17VE6.useContext($fed91b90a22b2b22$export$148fd98d095596d4);
    var route = $17VE6.useContext((0, $00b7b35226fb1bf3$export$9072aa6dd1f93057));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    !route && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = $fed91b90a22b2b22$var$useIdImpl ? $fed91b90a22b2b22$var$useIdImpl() : "";
    var _React_useState = (0, $52tJv._)($17VE6.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($fed91b90a22b2b22$var$getUniqueFetcherId());
    // Registration/cleanup
    $17VE6.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $17VE6.useCallback(function(href, opts) {
        !routeId && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $fed91b90a22b2b22$export$47c85c6e3a081d3();
    var submit = $17VE6.useCallback(function(target, opts) {
        submitImpl(target, $fed91b90a22b2b22$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $17VE6.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $17VE6.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $17VE6.createElement($fed91b90a22b2b22$export$a7fed597f4b8afd8, $fed91b90a22b2b22$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $95c0513fdc022f99$export$52eace9c284d3585);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $17VE6.useMemo(function() {
        return $fed91b90a22b2b22$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $fed91b90a22b2b22$export$fa996778a3a31087() {
    var state = $fed91b90a22b2b22$var$useDataRouterState($fed91b90a22b2b22$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $52tJv._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $fed91b90a22b2b22$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $fed91b90a22b2b22$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $fed91b90a22b2b22$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $fed91b90a22b2b22$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $fed91b90a22b2b22$var$useDataRouterContext($fed91b90a22b2b22$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $fed91b90a22b2b22$var$useDataRouterState($fed91b90a22b2b22$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $17VE6.useContext((0, $00b7b35226fb1bf3$export$26749e8557646306)).basename;
    var location = (0, $00b7b35226fb1bf3$export$45d76561a5302f2b)();
    var matches = (0, $00b7b35226fb1bf3$export$2378eb7f5ff86053)();
    var navigation = (0, $00b7b35226fb1bf3$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $17VE6.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $fed91b90a22b2b22$var$usePageHide($17VE6.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $fed91b90a22b2b22$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $fed91b90a22b2b22$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($fed91b90a22b2b22$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $17VE6.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $fed91b90a22b2b22$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $fed91b90a22b2b22$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $17VE6.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($fed91b90a22b2b22$var$_extends({}, location, {
                    pathname: (0, $95c0513fdc022f99$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($fed91b90a22b2b22$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $17VE6.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fed91b90a22b2b22$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $17VE6.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fed91b90a22b2b22$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $17VE6.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $fed91b90a22b2b22$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $00b7b35226fb1bf3$export$b273b3273281a049)(when);
    $17VE6.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $17VE6.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $fed91b90a22b2b22$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $17VE6.useContext($fed91b90a22b2b22$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $95c0513fdc022f99$export$3e9cee6b33872309)(false);
    var basename = $fed91b90a22b2b22$var$useDataRouterContext($fed91b90a22b2b22$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $00b7b35226fb1bf3$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $95c0513fdc022f99$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $95c0513fdc022f99$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $95c0513fdc022f99$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $95c0513fdc022f99$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



function $2aa0ce2ffd0dd16f$var$renderEntry(entry, roles, location) {
    if (entry.requiredRole && roles.indexOf(entry.requiredRole) < 0) return null;
    var isSelected = entry.destination === location;
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("li", {
        className: isSelected ? "selected" : "",
        children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $fed91b90a22b2b22$export$a6c7ac8248d6e38a), {
            to: entry.destination,
            children: entry.description
        })
    }, entry.destination);
}
function $2aa0ce2ffd0dd16f$var$renderElement(element) {
    return element.element;
}
function $2aa0ce2ffd0dd16f$var$renderItem(item, roles, location) {
    switch(item.type){
        case "entry":
            return $2aa0ce2ffd0dd16f$var$renderEntry(item, roles, location);
        case "spacer":
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("li", {
                className: "spacer"
            }, item.id);
        case "element":
            return $2aa0ce2ffd0dd16f$var$renderElement(item);
    }
}
function $2aa0ce2ffd0dd16f$export$b8a61e5c71402559(props) {
    var location = (0, $00b7b35226fb1bf3$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
        className: "navigation",
        children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("ul", {
            children: props.items.map(function(e) {
                return $2aa0ce2ffd0dd16f$var$renderItem(e, props.loginInformation.roles, location.pathname);
            })
        })
    });
}





var $17VE6 = parcelRequire("17VE6");


function $e2b1ce6c051eec73$export$cad1a703886b4e3a(props) {
    var navigate = (0, $00b7b35226fb1bf3$export$9770f232ac06a008)();
    function logout() {
        navigate("/");
        (0, $d426a3f2c6fbebd8$export$9aa0815bbb7f01f0).logout().then(props.onLogout);
    }
    (0, $17VE6.useEffect)(logout);
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {});
}



var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");

var $ajhIL = parcelRequire("ajhIL");


var $17VE6 = parcelRequire("17VE6");

var $7hBys = parcelRequire("7hBys");

var $ajhIL = parcelRequire("ajhIL");

var $b14ccf452957c7e7$export$9773195e8aca97e = {
    leafSensors: [],
    plantByLeafSensorId: {},
    loadingStatus: "pending",
    showHidden: false,
    showDisconnected: true
};
function $b14ccf452957c7e7$export$4db9746bd1cb7417(customerId) {
    return $b14ccf452957c7e7$var$_getInitialAdminPageState.apply(this, arguments);
}
function $b14ccf452957c7e7$var$_getInitialAdminPageState() {
    $b14ccf452957c7e7$var$_getInitialAdminPageState = (0, $7hBys._)(function(customerId) {
        var leafSensors, plantByLeafSensorId, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, leafSensor;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $2d43067f24bd2fb9$export$846a5da018e5aa64).getLeafSensorsByCustomerId(customerId, false, true)
                    ];
                case 1:
                    leafSensors = _state.sent();
                    plantByLeafSensorId = {};
                    console.log("LEAF", leafSensors);
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = leafSensors[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            leafSensor = _step.value;
                            //console.log("PLANT", leafSensor.plant);
                            plantByLeafSensorId[leafSensor.id] = leafSensor.plant;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        2,
                        {
                            leafSensors: leafSensors,
                            plantByLeafSensorId: plantByLeafSensorId,
                            loadingStatus: "resolved",
                            showHidden: false,
                            showDisconnected: true
                        }
                    ];
            }
        });
    });
    return $b14ccf452957c7e7$var$_getInitialAdminPageState.apply(this, arguments);
}




var $7hBys = parcelRequire("7hBys");

var $iCQyW = parcelRequire("iCQyW");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");

var $ajhIL = parcelRequire("ajhIL");


var $17VE6 = parcelRequire("17VE6");

parcelRequire("17VE6");

function $cbb9e6c9a362a987$export$60332b2344f7fe41(props) {
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
        className: "card",
        children: props.children
    });
}


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $4e4a6c4fb4c1a2b7$var$getRandomValues;
var $4e4a6c4fb4c1a2b7$var$rnds8 = new Uint8Array(16);
function $4e4a6c4fb4c1a2b7$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$4e4a6c4fb4c1a2b7$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $4e4a6c4fb4c1a2b7$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$4e4a6c4fb4c1a2b7$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $4e4a6c4fb4c1a2b7$var$getRandomValues($4e4a6c4fb4c1a2b7$var$rnds8);
}


var $777274702c95dd84$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $0416bbcfc5caae50$var$validate(uuid) {
    return typeof uuid === "string" && (0, $777274702c95dd84$export$2e2bcd8739ae039).test(uuid);
}
var $0416bbcfc5caae50$export$2e2bcd8739ae039 = $0416bbcfc5caae50$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $e4469f51740885ef$var$byteToHex = [];
for(var $e4469f51740885ef$var$i = 0; $e4469f51740885ef$var$i < 256; ++$e4469f51740885ef$var$i)$e4469f51740885ef$var$byteToHex.push(($e4469f51740885ef$var$i + 0x100).toString(16).substr(1));
function $e4469f51740885ef$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($e4469f51740885ef$var$byteToHex[arr[offset + 0]] + $e4469f51740885ef$var$byteToHex[arr[offset + 1]] + $e4469f51740885ef$var$byteToHex[arr[offset + 2]] + $e4469f51740885ef$var$byteToHex[arr[offset + 3]] + "-" + $e4469f51740885ef$var$byteToHex[arr[offset + 4]] + $e4469f51740885ef$var$byteToHex[arr[offset + 5]] + "-" + $e4469f51740885ef$var$byteToHex[arr[offset + 6]] + $e4469f51740885ef$var$byteToHex[arr[offset + 7]] + "-" + $e4469f51740885ef$var$byteToHex[arr[offset + 8]] + $e4469f51740885ef$var$byteToHex[arr[offset + 9]] + "-" + $e4469f51740885ef$var$byteToHex[arr[offset + 10]] + $e4469f51740885ef$var$byteToHex[arr[offset + 11]] + $e4469f51740885ef$var$byteToHex[arr[offset + 12]] + $e4469f51740885ef$var$byteToHex[arr[offset + 13]] + $e4469f51740885ef$var$byteToHex[arr[offset + 14]] + $e4469f51740885ef$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $0416bbcfc5caae50$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $e4469f51740885ef$export$2e2bcd8739ae039 = $e4469f51740885ef$var$stringify;


function $2e8af8223c9b3a6c$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $4e4a6c4fb4c1a2b7$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $e4469f51740885ef$export$2e2bcd8739ae039)(rnds);
}
var $2e8af8223c9b3a6c$export$2e2bcd8739ae039 = $2e8af8223c9b3a6c$var$v4;




var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $fyztb = parcelRequire("fyztb");

var $ajhIL = parcelRequire("ajhIL");


var $6e638e6a04d37fe2$var$ENDPOINT = "/api/v2/customer";
function $6e638e6a04d37fe2$export$920afcb8e253d75b() {
    return $6e638e6a04d37fe2$var$_getCustomers.apply(this, arguments);
}
function $6e638e6a04d37fe2$var$_getCustomers() {
    $6e638e6a04d37fe2$var$_getCustomers = (0, $7hBys._)(function() {
        var jwt, response, result;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    jwt = (0, $d426a3f2c6fbebd8$export$dd7587c4f6d92d8d)();
                    return [
                        4,
                        fetch("".concat($6e638e6a04d37fe2$var$ENDPOINT, "/"), {
                            headers: {
                                "Authorization": "Bearer ".concat(jwt)
                            },
                            method: "get"
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $6e638e6a04d37fe2$var$_getCustomers.apply(this, arguments);
}
function $6e638e6a04d37fe2$export$e6e17dabe8760570(customerId) {
    return $6e638e6a04d37fe2$var$_getCustomerById.apply(this, arguments);
}
function $6e638e6a04d37fe2$var$_getCustomerById() {
    $6e638e6a04d37fe2$var$_getCustomerById = (0, $7hBys._)(function(customerId) {
        var response, result;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("".concat($6e638e6a04d37fe2$var$ENDPOINT, "/").concat(customerId), {
                            headers: (0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()),
                            method: "get"
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $6e638e6a04d37fe2$var$_getCustomerById.apply(this, arguments);
}
function $6e638e6a04d37fe2$export$fbfdec3fcd74f506(customerId) {
    return $6e638e6a04d37fe2$var$_getCustomersByAncestorId.apply(this, arguments);
}
function $6e638e6a04d37fe2$var$_getCustomersByAncestorId() {
    $6e638e6a04d37fe2$var$_getCustomersByAncestorId = (0, $7hBys._)(function(customerId) {
        var response, result;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!customerId) return [
                        2,
                        []
                    ];
                    return [
                        4,
                        fetch("".concat($6e638e6a04d37fe2$var$ENDPOINT, "?ancestor=").concat(customerId), {
                            headers: (0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()),
                            method: "get"
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    result = _state.sent();
                    result.sort(function(a, b) {
                        return a.description.localeCompare(b.description);
                    });
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $6e638e6a04d37fe2$var$_getCustomersByAncestorId.apply(this, arguments);
}
function $6e638e6a04d37fe2$export$a0a7df6ab38f2b5b(customer) {
    return $6e638e6a04d37fe2$var$_saveCustomer.apply(this, arguments);
}
function $6e638e6a04d37fe2$var$_saveCustomer() {
    $6e638e6a04d37fe2$var$_saveCustomer = (0, $7hBys._)(function(customer) {
        var response, result;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("".concat($6e638e6a04d37fe2$var$ENDPOINT, "/"), {
                            method: "post",
                            headers: (0, $bqLxK._)((0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()), {
                                "content-type": "application/json"
                            }),
                            body: JSON.stringify(customer)
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $6e638e6a04d37fe2$var$_saveCustomer.apply(this, arguments);
}
function $6e638e6a04d37fe2$var$recSort(customers, customerByParent, depth) {
    if (!customers) return [];
    var result = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = customers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var customer = _step.value;
            var label = customer.description;
            for(var n = 0; n < depth; ++n)label = "\xa0\xa0\xa0\xa0" + label;
            var cust = customer;
            cust.treeLabel = label;
            cust.depth = depth;
            result.push(cust);
            // Note we are passing actual Customers, but we will add the missing data later
            // @ts-ignore
            result = (0, $fyztb._)(result).concat((0, $fyztb._)($6e638e6a04d37fe2$var$recSort(customerByParent[customer.id], customerByParent, depth + 1)));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function $6e638e6a04d37fe2$export$78878d36f2f215d(customers) {
    var validOwners = (0, $fyztb._)(new Set(customers.map(function(c) {
        return c.id;
    })));
    var customerByParent = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = customers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var customer = _step.value;
            if (customer.owner === customer.id || !validOwners.includes(customer.owner)) continue;
            if (!customerByParent[customer.owner]) customerByParent[customer.owner] = [];
            // Note that we don't have a customer, but we will add the missing information later
            customerByParent[customer.owner].push(customer);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var initial = customers.filter(function(c) {
        return c.owner === c.id || !validOwners.includes(c.owner);
    });
    return $6e638e6a04d37fe2$var$recSort(initial, customerByParent, 0);
}



function $4ac3b97fc29e10df$var$makePlant() {
    return {
        id: undefined,
        calibrationData: {},
        description: "",
        name: "",
        regDate: new Date(),
        weatherLocationId: undefined,
        devId: null,
        uuid: (0, $2e8af8223c9b3a6c$export$2e2bcd8739ae039)(),
        gps: {
            x: 0,
            y: 0
        },
        deviceProfileId: "",
        baselineCalculationDuration: 4320,
        baselineCalculated: false,
        hidden: false
    };
}
function $4ac3b97fc29e10df$var$header(leafSensor, plant, showHistory, history, onShowHistory, onPlantSelected) {
    var label = plant ? plant.name : leafSensor.name;
    function getPlant(id) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = history[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var p = _step.value;
                if (p.id === id) return p;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        throw new Error("Internal error");
    }
    if (showHistory) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("select", {
        onChange: function(event) {
            return onPlantSelected(getPlant(event.target.value));
        },
        children: history.map(function(p) {
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("option", {
                selected: plant && p.id === plant.id,
                value: String(p.id),
                children: p.description
            }, String(p.id));
        })
    });
    else {
        var _leafSensor_plant;
        var style = {
            display: "flex",
            flexDirection: "row"
        };
        if ((_leafSensor_plant = leafSensor.plant) === null || _leafSensor_plant === void 0 ? void 0 : _leafSensor_plant.hidden) style.opacity = 0.4;
        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
            style: style,
            children: [
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: label
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    onClick: onShowHistory,
                    title: "Show History",
                    className: "clickable fa fa-history"
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    style: {
                        flexGrow: 1
                    }
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $bb8043f30c8e9f0f$export$ae4b40d9fa099989), {
                        on: leafSensor.connected
                    })
                })
            ]
        });
    }
}
function $4ac3b97fc29e10df$var$body(leafSensor, plant, onNotificationEnabledChange) {
    var checkboxId = "leaf-sensor-notification-enabled-" + leafSensor.id;
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        className: "grid",
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                children: "Description:"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                children: plant ? plant.description : null
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                children: "Device id:"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                children: [
                    " ",
                    leafSensor.id
                ]
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                children: "Mac Address:"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                children: leafSensor.macAddress
            }),
            plant ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                children: "Location: "
            }) : null,
            plant ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                children: [
                    plant.gps.y,
                    ", ",
                    plant.gps.x
                ]
            }) : null,
            plant && plant.regDate ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                children: "Registration date:"
            }) : null,
            plant && plant.regDate ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                children: plant.regDate.toDateString()
            }) : null,
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                children: "Baseline calculation period (minutes):"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                children: plant === null || plant === void 0 ? void 0 : plant.baselineCalculationDuration
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                className: "form-row columns-2",
                style: {
                    display: "contents"
                },
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("label", {
                        htmlFor: checkboxId,
                        children: "Notifications:"
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                        name: checkboxId,
                        type: "checkbox",
                        onChange: onNotificationEnabledChange,
                        checked: leafSensor.notificationEnabled
                    })
                ]
            })
        ]
    });
}
function $4ac3b97fc29e10df$var$plantEdit(editedPlant, onNewPlantClicked, onPlantSave, onPlantChanged, onCancelClicked) {
    function onCalibrationChanged(field, value) {
        var ed = editedPlant;
        var calibrationData = (0, $bqLxK._)((0, $lwFY2._)({}, editedPlant === null || editedPlant === void 0 ? void 0 : editedPlant.calibrationData), (0, $iCQyW._)({}, field, Number(value)));
        var newPlant = (0, $bqLxK._)((0, $lwFY2._)({}, ed), {
            calibrationData: calibrationData
        });
        onPlantChanged(newPlant);
    }
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        className: "grid",
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("label", {
                children: "Name:"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                onChange: function(event) {
                    return onPlantChanged((0, $bqLxK._)((0, $lwFY2._)({}, editedPlant), {
                        name: event.target.value
                    }));
                },
                value: editedPlant.name
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("label", {
                children: "Description:"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                onChange: function(event) {
                    return onPlantChanged((0, $bqLxK._)((0, $lwFY2._)({}, editedPlant), {
                        description: event.target.value
                    }));
                },
                value: editedPlant.description
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("label", {
                children: "Lat:"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                type: "number",
                min: "-90",
                max: "90",
                onChange: function(event) {
                    return onPlantChanged((0, $bqLxK._)((0, $lwFY2._)({}, editedPlant), {
                        gps: {
                            x: editedPlant.gps.x,
                            y: Number(event.target.value)
                        }
                    }));
                },
                value: editedPlant.gps.y
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("label", {
                children: "Lon:"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                type: "number",
                min: "-180",
                max: "180",
                onChange: function(event) {
                    return onPlantChanged((0, $bqLxK._)((0, $lwFY2._)({}, editedPlant), {
                        gps: {
                            y: editedPlant.gps.y,
                            x: Number(event.target.value)
                        }
                    }));
                },
                value: editedPlant.gps.x
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("label", {
                children: "BCP (min):"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                type: "number",
                min: "0",
                onChange: function(event) {
                    return onPlantChanged((0, $bqLxK._)((0, $lwFY2._)({}, editedPlant), {
                        baselineCalculationDuration: Number(event.target.value)
                    }));
                },
                value: editedPlant.baselineCalculationDuration
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("strong", {
                children: "Calibration values"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {}),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                children: "PDT1"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                onChange: function(event) {
                    return onCalibrationChanged("pdt1", event.target.value);
                },
                value: editedPlant.calibrationData.pdt1
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                children: "PDT2"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                onChange: function(event) {
                    return onCalibrationChanged("pdt2", event.target.value);
                },
                value: editedPlant.calibrationData.pdt2
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                children: "PDT3"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                onChange: function(event) {
                    return onCalibrationChanged("pdt3", event.target.value);
                },
                value: editedPlant.calibrationData.pdt3
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                children: "PDR1"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                onChange: function(event) {
                    return onCalibrationChanged("pdr1", event.target.value);
                },
                value: editedPlant.calibrationData.pdr1
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                children: "PDR2"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                onChange: function(event) {
                    return onCalibrationChanged("pdr2", event.target.value);
                },
                value: editedPlant.calibrationData.pdr2
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                children: "PDR3"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                onChange: function(event) {
                    return onCalibrationChanged("pdr3", event.target.value);
                },
                value: editedPlant.calibrationData.pdr3
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                className: "button-row",
                style: {
                    gridColumn: "span 2"
                },
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                        onClick: onCancelClicked,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                        onClick: onPlantSave,
                        children: "Save"
                    })
                ]
            })
        ]
    });
}
function $4ac3b97fc29e10df$var$plantMove(plant, customerId, customers, onCustomerSelected, onCancelClicked, onConfirmClicked) {
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                children: "Choose a new customer"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("select", {
                value: customerId,
                onChange: function(event) {
                    return onCustomerSelected(event.target.value);
                },
                children: customers.map(function(customer) {
                    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("option", {
                        value: customer.id,
                        children: customer.description
                    }, customer.id);
                })
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                className: "button-row",
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                        onClick: onCancelClicked,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                        onClick: onConfirmClicked,
                        children: "Confirm"
                    })
                ]
            })
        ]
    });
}
var $4ac3b97fc29e10df$var$INITIAL_STATE = {
    state: "initial",
    customers: undefined,
    editedPlant: undefined,
    movingToCustomerId: undefined,
    isNewPlant: false,
    showHistory: false,
    plantHistory: [],
    selectedHistory: undefined
};
function $4ac3b97fc29e10df$export$a99e49aeba14a2bf(props) {
    var leafSensor = props.leafSensor, plant = props.plant;
    var _useState = (0, $52tJv._)((0, $17VE6.useState)($4ac3b97fc29e10df$var$INITIAL_STATE), 2), state = _useState[0], setState = _useState[1];
    function onNotificationChange(event) {
        props.onNotificationFlagToggled(leafSensor.id, !leafSensor.notificationEnabled);
    }
    (0, $17VE6.useEffect)(function() {
        if (state.state === "moving") (0, $6e638e6a04d37fe2$export$920afcb8e253d75b)().then(function(customers) {
            setState(function(state) {
                var newState = (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                    customers: customers
                });
                return newState;
            });
        });
    }, [
        state.state
    ]);
    function onNewPlantClicked(event) {
        var editedPlant = $4ac3b97fc29e10df$var$makePlant();
        editedPlant.devId = leafSensor.id;
        if (!editedPlant.calibrationData) editedPlant.calibrationData = {};
        editedPlant.deviceProfileId = (plant === null || plant === void 0 ? void 0 : plant.deviceProfileId) || "";
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            state: "editing",
            editedPlant: editedPlant,
            isNewPlant: true
        }));
    }
    function onEditClicked(event) {
        var editedPlant = (0, $lwFY2._)({}, plant);
        if (!editedPlant.devId) editedPlant.devId = leafSensor.id;
        if (!editedPlant.calibrationData) editedPlant.calibrationData = {};
        editedPlant.gps = (0, $lwFY2._)({}, editedPlant.gps);
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            state: "editing",
            editedPlant: editedPlant,
            isNewPlant: false
        }));
    }
    function onPlantSave(event) {
        return _onPlantSave.apply(this, arguments);
    }
    function _onPlantSave() {
        _onPlantSave = (0, $7hBys._)(function(event) {
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!state.editedPlant) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            props.onPlantSave(leafSensor, state.editedPlant)
                        ];
                    case 1:
                        _state.sent();
                        setState($4ac3b97fc29e10df$var$INITIAL_STATE);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return _onPlantSave.apply(this, arguments);
    }
    function onPlantChanged(editedPlant) {
        if (!editedPlant.calibrationData) editedPlant.calibrationData = {};
        console.log("Edited plant", editedPlant);
        setState(function(state) {
            return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                editedPlant: editedPlant
            });
        });
    }
    function onShowHistory() {
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            showHistory: true
        }));
    }
    function onPlantSelected(plant) {
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            selectedHistory: plant
        }));
    }
    function onCustomerSelected(customerId) {
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            movingToCustomerId: customerId
        }));
    }
    function onChangeCustomerClicked() {
        var loginInformation = (0, $d426a3f2c6fbebd8$export$9aa0815bbb7f01f0).getLoginInformation();
        var editedPlant = (0, $lwFY2._)({}, plant);
        // FIXME
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            state: "moving",
            editedPlant: editedPlant,
            movingToCustomerId: loginInformation.customerId
        }));
    }
    var canMovePlant = false;
    function onCancelClicked() {
        setState($4ac3b97fc29e10df$var$INITIAL_STATE);
    }
    function onMoveConfirmClicked() {}
    function onHideClicked() {
        // Hide button is enabled only when we are NOT editing
        var plant = leafSensor.plant;
        var updatedPlant = (0, $bqLxK._)((0, $lwFY2._)({}, plant), {
            hidden: !plant.hidden
        });
        props.onPlantSave(leafSensor, updatedPlant);
    }
    function renderPlantState() {
        var _leafSensor_plant;
        var label = ((_leafSensor_plant = leafSensor.plant) === null || _leafSensor_plant === void 0 ? void 0 : _leafSensor_plant.hidden) ? "Show" : "Hide";
        switch(state.state){
            case "initial":
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                    className: "button-row",
                    children: [
                        leafSensor.plant ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                            onClick: onHideClicked,
                            children: label
                        }) : null,
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                            onClick: onEditClicked,
                            children: "Edit"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                            onClick: onNewPlantClicked,
                            children: "Move to a new plant"
                        }),
                        canMovePlant ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                            onClick: onChangeCustomerClicked,
                            children: "Move to a different customer"
                        }) : null
                    ]
                });
            case "editing":
                return $4ac3b97fc29e10df$var$plantEdit(state.editedPlant, onNewPlantClicked, onPlantSave, onPlantChanged, onCancelClicked);
            case "moving":
                return $4ac3b97fc29e10df$var$plantMove(state.editedPlant, state.movingToCustomerId, state.customers || [], onCustomerSelected, onCancelClicked, onMoveConfirmClicked);
            default:
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                    children: "Unknown state"
                });
        }
    }
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)((0, $cbb9e6c9a362a987$export$60332b2344f7fe41), {
        children: [
            $4ac3b97fc29e10df$var$header(leafSensor, state.selectedHistory || plant, state.showHistory, state.plantHistory, onShowHistory, onPlantSelected),
            $4ac3b97fc29e10df$var$body(leafSensor, plant, onNotificationChange),
            renderPlantState()
        ]
    });
}





function $8a9c826e4807238d$export$b25f57c16f88d7e0(props) {
    var _useState = (0, $52tJv._)((0, $17VE6.useState)((0, $b14ccf452957c7e7$export$9773195e8aca97e)), 2), state = _useState[0], setState = _useState[1];
    (0, $17VE6.useEffect)(function() {
        (0, $b14ccf452957c7e7$export$4db9746bd1cb7417)(props.customerId).then(function(newState) {
            setState(newState);
        });
    }, [
        props.customerId
    ]);
    function toggleNotificationStatus(leafSensorId, notificationEnabled) {
        return _toggleNotificationStatus.apply(this, arguments);
    }
    function _toggleNotificationStatus() {
        _toggleNotificationStatus = (0, $7hBys._)(function(leafSensorId, notificationEnabled) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, leafSensor;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $2d43067f24bd2fb9$export$846a5da018e5aa64).setNotificationFlag(leafSensorId, notificationEnabled)
                        ];
                    case 1:
                        _state.sent();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = state.leafSensors[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                leafSensor = _step.value;
                                if (leafSensor.id === leafSensorId) {
                                    leafSensor.notificationEnabled = notificationEnabled;
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        setState((0, $lwFY2._)({}, state));
                        return [
                            2
                        ];
                }
            });
        });
        return _toggleNotificationStatus.apply(this, arguments);
    }
    function onShowHiddenToggled() {
        return _onShowHiddenToggled.apply(this, arguments);
    }
    function _onShowHiddenToggled() {
        _onShowHiddenToggled = (0, $7hBys._)(function() {
            return (0, $ajhIL.__generator)(this, function(_state) {
                setState(function(state) {
                    return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                        showHidden: !state.showHidden
                    });
                });
                return [
                    2
                ];
            });
        });
        return _onShowHiddenToggled.apply(this, arguments);
    }
    function onShowDisconnectedToggled() {
        return _onShowDisconnectedToggled.apply(this, arguments);
    }
    function _onShowDisconnectedToggled() {
        _onShowDisconnectedToggled = (0, $7hBys._)(function() {
            return (0, $ajhIL.__generator)(this, function(_state) {
                console.log("Show disconnected", state);
                setState(function(state) {
                    return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                        showDisconnected: !state.showDisconnected
                    });
                });
                return [
                    2
                ];
            });
        });
        return _onShowDisconnectedToggled.apply(this, arguments);
    }
    function savePlant(leafSensor, plant) {
        return _savePlant.apply(this, arguments);
    }
    function _savePlant() {
        _savePlant = (0, $7hBys._)(function(leafSensor, plant) {
            var savedPlant, newState, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, leafSensor1;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("Saving plant", plant);
                        return [
                            4,
                            (0, $d9e006fac7ba41ad$export$567d99ad22f1b14f).savePlant(plant)
                        ];
                    case 1:
                        savedPlant = _state.sent();
                        newState = (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                            leafSensors: []
                        });
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = state.leafSensors[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                leafSensor1 = _step.value;
                                if (savedPlant.devId && leafSensor1.id === savedPlant.devId.toString()) {
                                    leafSensor1 = (0, $lwFY2._)({}, leafSensor1);
                                    if (savedPlant.id) leafSensor1.plantId = savedPlant.id.toString();
                                    leafSensor1.description = savedPlant.description;
                                    leafSensor1.name = savedPlant.name;
                                    leafSensor1.plant = savedPlant;
                                    newState.plantByLeafSensorId[leafSensor1.id] = savedPlant;
                                }
                                newState.leafSensors.push(leafSensor1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        setState(newState);
                        return [
                            2
                        ];
                }
            });
        });
        return _savePlant.apply(this, arguments);
    }
    if (state.loadingStatus === "pending") return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $ba001461d3497aae$export$7f7cbe89f1eacd2), {});
    var leafSensors = state.showHidden ? state.leafSensors : state.leafSensors.map(function(d) {
        return !d.plant.hidden;
    });
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("h2", {
                children: "Leaf Sensors"
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                                type: "checkbox",
                                onChange: onShowHiddenToggled,
                                checked: state.showHidden
                            }),
                            "Show hidden"
                        ]
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                                type: "checkbox",
                                checked: state.showDisconnected,
                                onChange: onShowDisconnectedToggled
                            }),
                            "Show disconnected"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                className: "admin-page-device-list",
                children: state.leafSensors.filter(function(ls) {
                    var _ls_plant;
                    return state.showHidden || !((_ls_plant = ls.plant) === null || _ls_plant === void 0 ? void 0 : _ls_plant.hidden);
                }).filter(function(ls) {
                    return state.showDisconnected || ls.connected;
                }).map(function(ls) {
                    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $4ac3b97fc29e10df$export$a99e49aeba14a2bf), {
                        leafSensor: ls,
                        plant: state.plantByLeafSensorId[ls.id],
                        onPlantSave: savePlant,
                        onNotificationFlagToggled: toggleNotificationStatus
                    }, ls.id);
                })
            })
        ]
    });
}



parcelRequire("17VE6");





var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");

var $ajhIL = parcelRequire("ajhIL");


var $17VE6 = parcelRequire("17VE6");

var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");

var $ajhIL = parcelRequire("ajhIL");


var $17VE6 = parcelRequire("17VE6");


var $7hBys = parcelRequire("7hBys");

var $iCQyW = parcelRequire("iCQyW");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");

var $fyztb = parcelRequire("fyztb");

var $ajhIL = parcelRequire("ajhIL");


var $17VE6 = parcelRequire("17VE6");
function $8506212daa6d35ae$var$getInitialState(user, startEditing) {
    if (startEditing) return {
        editing: true,
        editedUser: user
    };
    else return {
        editing: false,
        editedUser: undefined
    };
}
function $8506212daa6d35ae$export$1f44aaf2ec115b54(props) {
    var _useState = (0, $52tJv._)((0, $17VE6.useState)($8506212daa6d35ae$var$getInitialState(props.user, props.startEditing)), 2), state = _useState[0], setState = _useState[1];
    function onEditClicked() {
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            editing: true,
            editedUser: props.user
        }));
    }
    function onCancelClicked() {
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            editing: false,
            editedUser: undefined
        }));
    }
    function onSaveClicked() {
        return _onSaveClicked.apply(this, arguments);
    }
    function _onSaveClicked() {
        _onSaveClicked = (0, $7hBys._)(function() {
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!state.editedUser) return [
                            2
                        ];
                        return [
                            4,
                            props.onSave(state.editedUser)
                        ];
                    case 1:
                        _state.sent();
                        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
                            editedUser: undefined,
                            editing: false
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _onSaveClicked.apply(this, arguments);
    }
    function onFieldChanged(field, value) {
        var editedUser = (0, $bqLxK._)((0, $lwFY2._)({}, state.editedUser), (0, $iCQyW._)({}, field, value));
        console.log("Changing field", field, "to", value);
        console.log("New user:", editedUser);
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            editedUser: editedUser
        }));
    }
    function toggleActive() {
        var editedUser = (0, $lwFY2._)({}, state.editedUser);
        editedUser.active = !editedUser.active;
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            editedUser: editedUser
        }));
    }
    function hasRole(user, role) {
        return user.roles.indexOf(role) >= 0;
    }
    function toggleRole(role) {
        var editedUser = (0, $lwFY2._)({}, state.editedUser);
        if (hasRole(editedUser, role)) editedUser.roles = editedUser.roles.filter(function(r) {
            return r !== role;
        });
        else editedUser.roles = (0, $fyztb._)(editedUser.roles).concat([
            role
        ]);
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            editedUser: editedUser
        }));
    }
    if (state.editing && state.editedUser) {
        var user = state.editedUser;
        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
            className: props.className,
            children: [
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: user.id
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                    onChange: function(e) {
                        return onFieldChanged("email", e.target.value);
                    },
                    value: user.email
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                    onChange: function(e) {
                        return onFieldChanged("name", e.target.value);
                    },
                    value: user.name
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                    onChange: function(e) {
                        return onFieldChanged("surname", e.target.value);
                    },
                    value: user.surname
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                    type: "checkbox",
                    checked: user.active,
                    onChange: toggleActive
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                            onChange: function() {
                                return toggleRole("admin");
                            },
                            name: "role-admin",
                            type: "checkbox",
                            checked: hasRole(user, "admin")
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("label", {
                            htmlFor: "role-admin",
                            children: "admin"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                            onChange: function() {
                                return toggleRole("user");
                            },
                            name: "role-user",
                            type: "checkbox",
                            checked: hasRole(user, "user")
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("label", {
                            htmlFor: "role-user",
                            children: "user"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                            onChange: function() {
                                return toggleRole("backoffice");
                            },
                            name: "role-backoffice",
                            type: "checkbox",
                            checked: hasRole(user, "backoffice")
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("label", {
                            htmlFor: "role-backoffice",
                            children: "backoffice"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                    onChange: function(e) {
                        return onFieldChanged("password", e.target.value);
                    },
                    placeholder: "new password"
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                    type: "date",
                    onChange: function(e) {
                        return onFieldChanged("endDate", e.target.value);
                    },
                    placeholder: "expire date"
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                            onClick: onCancelClicked,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                            onClick: onSaveClicked,
                            children: "Save"
                        })
                    ]
                })
            ]
        });
    } else {
        var user1 = props.user;
        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
            className: props.className,
            children: [
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: user1.id
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: user1.email
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: user1.name
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: user1.surname
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: user1.active ? "\u2713" : ""
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: (user1.roles || []).join(", ")
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {}),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: user1.endDate && new Date(user1.endDate).toLocaleDateString()
                }),
                props.editingEnabled ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                    onClick: onEditClicked,
                    children: "Edit"
                }) : /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {})
            ]
        });
    }
}


function $dcc3850f0c8387a4$export$aa093906ffb6389d(props) {
    var customer = props.customer, startEditing = props.startEditing;
    var initialState = {
        editedCustomer: startEditing ? (0, $lwFY2._)({}, customer) : undefined
    };
    var _useState = (0, $52tJv._)((0, $17VE6.useState)(initialState), 2), state = _useState[0], setState = _useState[1];
    var editedCustomer = state.editedCustomer, editedUser = state.editedUser;
    function onUserSaveClicked(user) {
        return _onUserSaveClicked.apply(this, arguments);
    }
    function _onUserSaveClicked() {
        _onUserSaveClicked = (0, $7hBys._)(function(user) {
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            props.onUserSaveClicked(user)
                        ];
                    case 1:
                        _state.sent();
                        setState({
                            editedUser: undefined,
                            editedCustomer: editedCustomer
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _onUserSaveClicked.apply(this, arguments);
    }
    function updateDescription(description) {
        if (!editedCustomer) return;
        var newCustomer = (0, $bqLxK._)((0, $lwFY2._)({}, editedCustomer), {
            description: description
        });
        var newState = {
            editedCustomer: newCustomer,
            editedUser: editedUser
        };
        setState(newState);
    }
    function toggleActive(active) {
        if (!editedCustomer) return;
        var newCustomer = (0, $bqLxK._)((0, $lwFY2._)({}, editedCustomer), {
            active: active
        });
        setState({
            editedCustomer: newCustomer,
            editedUser: editedUser
        });
    }
    function onAddUserClicked() {
        if (!editedUser) {
            var roles = [];
            var newUser = {
                customerId: customer.id,
                roles: roles
            };
            setState({
                editedUser: newUser,
                editedCustomer: editedCustomer
            });
        }
    }
    function onSaveClicked() {
        return _onSaveClicked.apply(this, arguments);
    }
    function _onSaveClicked() {
        _onSaveClicked = (0, $7hBys._)(function() {
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!state.editedCustomer) return [
                            3,
                            1
                        ];
                        return [
                            2
                        ];
                    case 1:
                        return [
                            4,
                            props.onSaveClicked(state.editedCustomer)
                        ];
                    case 2:
                        _state.sent();
                        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
                            editedCustomer: undefined
                        }));
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _onSaveClicked.apply(this, arguments);
    }
    function renderUsers() {
        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
            className: "backoffice-user-list",
            children: [
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                    className: "backoffice-row",
                    children: [
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("b", {
                            children: "ID"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("b", {
                            children: "Login"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("b", {
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("b", {
                            children: "Surname"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("b", {
                            children: "Active"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("b", {
                            children: "Roles"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("b", {
                            children: "Password"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("b", {
                            children: "Expire"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {})
                    ]
                }),
                editedUser ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $8506212daa6d35ae$export$1f44aaf2ec115b54), {
                    className: "backoffice-row",
                    startEditing: true,
                    editingEnabled: true,
                    user: editedUser,
                    onSave: onUserSaveClicked
                }) : null,
                props.users.map(function(user) {
                    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $8506212daa6d35ae$export$1f44aaf2ec115b54), {
                        className: "backoffice-row",
                        editingEnabled: customer.active,
                        user: user,
                        onSave: onUserSaveClicked
                    }, user.id);
                })
            ]
        });
    }
    function onEditClicked() {
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            editedCustomer: (0, $lwFY2._)({}, customer)
        }));
    }
    function onCancelClicked() {
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            editedCustomer: undefined
        }));
    }
    function renderHeader() {
        var className = "row";
        if (!customer.active) className += " disabled";
        if (editedCustomer) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
            className: className,
            children: [
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                    placeholder: "Description",
                    value: editedCustomer.description,
                    onChange: function(event) {
                        return updateDescription(event.target.value);
                    }
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                    type: "checkbox",
                    checked: editedCustomer.active,
                    onChange: function(event) {
                        return toggleActive(event.target.checked);
                    }
                }),
                "  Active",
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    className: "spacer"
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                    onClick: function() {
                        return onCancelClicked();
                    },
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                    onClick: function() {
                        return onSaveClicked();
                    },
                    children: "Save"
                })
            ]
        });
        else return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
            className: className,
            children: [
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: customer.description
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    className: "spacer"
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                    onClick: onAddUserClicked,
                    children: "New User"
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                    onClick: function() {
                        return onEditClicked();
                    },
                    children: "Edit"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)((0, $cbb9e6c9a362a987$export$60332b2344f7fe41), {
        children: [
            renderHeader(),
            renderUsers()
        ]
    });
}





var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $ajhIL = parcelRequire("ajhIL");


var $893c5724a35f1f3e$var$ENDPOINT = "/api/v2/user";
function $893c5724a35f1f3e$export$925a4945a6cd0f3e() {
    return $893c5724a35f1f3e$var$_getUsers.apply(this, arguments);
}
function $893c5724a35f1f3e$var$_getUsers() {
    $893c5724a35f1f3e$var$_getUsers = (0, $7hBys._)(function() {
        var jwt, response, result;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    jwt = (0, $d426a3f2c6fbebd8$export$dd7587c4f6d92d8d)();
                    return [
                        4,
                        fetch("".concat($893c5724a35f1f3e$var$ENDPOINT, "/"), {
                            headers: {
                                "Authorization": "Bearer ".concat(jwt)
                            },
                            method: "get"
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $893c5724a35f1f3e$var$_getUsers.apply(this, arguments);
}
function $893c5724a35f1f3e$export$ca0e1882e225378b(user) {
    return $893c5724a35f1f3e$var$_saveUser.apply(this, arguments);
}
function $893c5724a35f1f3e$var$_saveUser() {
    $893c5724a35f1f3e$var$_saveUser = (0, $7hBys._)(function(user) {
        var response, result;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("".concat($893c5724a35f1f3e$var$ENDPOINT, "/"), {
                            method: "post",
                            headers: (0, $bqLxK._)((0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()), {
                                "content-type": "application/json"
                            }),
                            body: JSON.stringify(user)
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $893c5724a35f1f3e$var$_saveUser.apply(this, arguments);
}


function $394f8273019a9a9b$var$sortOn(data, key) {
    data.sort(function(a, b) {
        var ak = a[key];
        var bk = b[key];
        if (ak < bk) return -1;
        else if (ak > bk) return 1;
        return 0;
    });
}
var $394f8273019a9a9b$var$INITIAL_STATE = {
    customers: [],
    filteredCustomers: [],
    usersByCustomerId: {},
    editedCustomer: undefined,
    initDone: false,
    showInactiveUsers: false
};
function $394f8273019a9a9b$var$filterCustomers(customers, filter) {
    return customers.filter(function(c) {
        return c.description.toLowerCase().indexOf(filter) >= 0;
    });
}
function $394f8273019a9a9b$var$reorderCustomers(customers) {
    var result = [];
    var tree = (0, $6e638e6a04d37fe2$export$78878d36f2f215d)(customers);
    return tree;
}
function $394f8273019a9a9b$export$19984adfcae348ea(props) {
    var _useState = (0, $52tJv._)((0, $17VE6.useState)($394f8273019a9a9b$var$INITIAL_STATE), 2), state = _useState[0], setState = _useState[1];
    (0, $17VE6.useEffect)(function() {
        function loadCustomers() {
            return _loadCustomers.apply(this, arguments);
        }
        function _loadCustomers() {
            _loadCustomers = (0, $7hBys._)(function() {
                var unsortedCustomers, customers, users, usersByCustomerId, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, user, customerId;
                return (0, $ajhIL.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0, $6e638e6a04d37fe2$export$fbfdec3fcd74f506)(props.customerId)
                            ];
                        case 1:
                            unsortedCustomers = _state.sent();
                            //sortOn(unsortedCustomers, 'id');
                            customers = $394f8273019a9a9b$var$reorderCustomers(unsortedCustomers);
                            return [
                                4,
                                (0, $893c5724a35f1f3e$export$925a4945a6cd0f3e)()
                            ];
                        case 2:
                            users = _state.sent();
                            usersByCustomerId = {};
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = users[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    user = _step.value;
                                    customerId = user.customerId;
                                    if (!usersByCustomerId[customerId]) usersByCustomerId[customerId] = [];
                                    usersByCustomerId[customerId].push(user);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            setState(function(s) {
                                return (0, $bqLxK._)((0, $lwFY2._)({}, s), {
                                    customers: customers,
                                    filteredCustomers: customers,
                                    initDone: true,
                                    usersByCustomerId: usersByCustomerId
                                });
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return _loadCustomers.apply(this, arguments);
        }
        console.log("Checking customers...");
        if (props.customerId || !state.initDone) {
            console.info("Loading customers");
            loadCustomers().then();
        }
    }, [
        state.initDone,
        props.customerId
    ]);
    function onNewCustomerClicked() {
        var editedCustomer = {
            description: "",
            active: true,
            id: "",
            owner: props.customerId
        };
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            editedCustomer: editedCustomer
        }));
    }
    function onSaveClicked(customer) {
        return _onSaveClicked.apply(this, arguments);
    }
    function _onSaveClicked() {
        _onSaveClicked = (0, $7hBys._)(function(customer) {
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.info("Saving customer", customer);
                        return [
                            4,
                            (0, $6e638e6a04d37fe2$export$a0a7df6ab38f2b5b)(customer)
                        ];
                    case 1:
                        _state.sent();
                        setState(function(s) {
                            return (0, $bqLxK._)((0, $lwFY2._)({}, s), {
                                initDone: false
                            });
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _onSaveClicked.apply(this, arguments);
    }
    function onSaveNewClicked(customer) {
        return _onSaveNewClicked.apply(this, arguments);
    }
    function _onSaveNewClicked() {
        _onSaveNewClicked = (0, $7hBys._)(function(customer) {
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSaveClicked(customer)
                        ];
                    case 1:
                        _state.sent();
                        setState(function(s) {
                            return (0, $bqLxK._)((0, $lwFY2._)({}, s), {
                                editedCustomer: undefined
                            });
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _onSaveNewClicked.apply(this, arguments);
    }
    function onUserSaveClicked(user) {
        return _onUserSaveClicked.apply(this, arguments);
    }
    function _onUserSaveClicked() {
        _onUserSaveClicked = (0, $7hBys._)(function(user) {
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.info("Saving user", user);
                        return [
                            4,
                            (0, $893c5724a35f1f3e$export$ca0e1882e225378b)(user)
                        ];
                    case 1:
                        _state.sent();
                        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
                            initDone: false
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _onUserSaveClicked.apply(this, arguments);
    }
    function unFilterChanged(event) {
        var filteredCustomers = $394f8273019a9a9b$var$filterCustomers(state.customers, event.target.value);
        setState(function(state) {
            return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                filteredCustomers: filteredCustomers
            });
        });
        console.log("event", event);
    }
    function getCustomerUsers(customerId) {
        var result = state.usersByCustomerId[customerId] || [];
        if (state.showInactiveUsers) return result;
        else return result.filter(function(user) {
            return user.active;
        });
    }
    function toggleInactiveUsers(e) {
        console.log("E");
        setState(function(s) {
            return (0, $bqLxK._)((0, $lwFY2._)({}, s), {
                showInactiveUsers: !s.showInactiveUsers
            });
        });
    }
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                style: {
                    "margin": "1em"
                },
                className: "row",
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                        type: "search",
                        placeholder: "Filter customers",
                        onChange: unFilterChanged
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                                type: "checkbox",
                                onClick: toggleInactiveUsers
                            }),
                            "Show inactive users "
                        ]
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                        className: "spacer"
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                        onClick: onNewCustomerClicked,
                        children: "New Customer"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                className: "backoffice-customer-list",
                children: [
                    state.editedCustomer ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $dcc3850f0c8387a4$export$aa093906ffb6389d), {
                        onSaveClicked: onSaveNewClicked,
                        onUserSaveClicked: onUserSaveClicked,
                        customer: state.editedCustomer,
                        startEditing: true,
                        users: []
                    }) : null,
                    state.filteredCustomers.map(function(c) {
                        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                            className: "indent-".concat(c.depth),
                            style: {
                                "display": "contents"
                            },
                            children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $dcc3850f0c8387a4$export$aa093906ffb6389d), {
                                onSaveClicked: onSaveClicked,
                                onUserSaveClicked: onUserSaveClicked,
                                customer: c,
                                startEditing: false,
                                users: getCustomerUsers(c.id)
                            }, c.id)
                        });
                    })
                ]
            })
        ]
    });
}



var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");

var $fyztb = parcelRequire("fyztb");

var $ajhIL = parcelRequire("ajhIL");


var $17VE6 = parcelRequire("17VE6");




var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");

var $ajhIL = parcelRequire("ajhIL");


var $17VE6 = parcelRequire("17VE6");
function $83f498fca7e759b7$var$defaultMakeId(entry) {
    return String(entry.id);
}
var $83f498fca7e759b7$var$initialState = {
    editing: {}
};
function $83f498fca7e759b7$export$54ec01a60f47d33d(props) {
    var _useState = (0, $52tJv._)((0, $17VE6.useState)($83f498fca7e759b7$var$initialState), 2), state = _useState[0], setState = _useState[1];
    var makeId = props.makeId || $83f498fca7e759b7$var$defaultMakeId;
    function onEdit(entry) {
        var id = makeId(entry);
        var editing = (0, $lwFY2._)({}, state.editing);
        editing[id] = (0, $lwFY2._)({}, entry);
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            editing: editing
        }));
    }
    function onCancel(entry) {
        var id = makeId(entry);
        var editing = (0, $lwFY2._)({}, state.editing);
        delete editing[id];
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            editing: editing
        }));
    }
    // function onDelete(entry: T) {
    //     if (props.onEntryDelete) {
    //         props.onEntryDelete(entry);
    //     }
    // }
    function renderColumnHeader(columnId) {
        var _props_sortBy, _props_sortBy1;
        var columnKey = columnId;
        var columnInfo = props.columns[columnId];
        function clickHandler(e) {
            var _props_sortBy;
            if (((_props_sortBy = props.sortBy) === null || _props_sortBy === void 0 ? void 0 : _props_sortBy.column) === columnKey) props.onSortChanged({
                column: columnKey,
                order: props.sortBy.order === "asc" ? "desc" : "asc"
            });
            else props.onSortChanged({
                column: columnKey,
                order: "asc"
            });
        }
        var sortIcon = "";
        if (columnId === ((_props_sortBy = props.sortBy) === null || _props_sortBy === void 0 ? void 0 : _props_sortBy.column)) sortIcon = ((_props_sortBy1 = props.sortBy) === null || _props_sortBy1 === void 0 ? void 0 : _props_sortBy1.order) === "asc" ? "\u25B2" : "\u25BC";
        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("b", {
            onClick: clickHandler,
            className: "clickable",
            children: [
                columnInfo.description,
                sortIcon
            ]
        }, columnId);
    }
    function onRowChanged(row) {
        console.log("Row changed to", row);
        var id = makeId(row);
        var editing = (0, $lwFY2._)({}, state.editing);
        editing[id] = row;
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            editing: editing
        }));
    }
    function isRowEditable(entry, editable) {
        if (editable === true) return true;
        if (editable === false || editable === undefined) return false;
        return editable(entry);
    }
    function renderRow(entry, columns) {
        var id = makeId(entry);
        var editing = !!state.editing[id];
        var row = state.editing[id] || entry;
        function renderCell(c) {
            var key = c;
            var info = columns[c];
            if (editing && isRowEditable(entry, info === null || info === void 0 ? void 0 : info.editable)) {
                var renderer = info.editRenderer;
                if (renderer) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: renderer(row, onRowChanged)
                }, key);
                else return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: row[c]
                }, key);
            } else {
                var renderer1 = info.renderer;
                if (renderer1) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: renderer1(row)
                }, key);
                else return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: row[c]
                }, key);
            }
        }
        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
            className: "backoffice-row",
            children: [
                Object.keys(columns).map(function(c) {
                    return renderCell(c);
                }),
                isRowEditable(entry, props.editable) ? renderEdit(row, editing) : /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {})
            ]
        }, makeId(entry));
    }
    var nColumns = Object.keys(props.columns).length + (props.editable ? 1 : 0);
    function onSave(row) {
        return _onSave.apply(this, arguments);
    }
    function _onSave() {
        _onSave = (0, $7hBys._)(function(row) {
            var editing;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        editing = (0, $lwFY2._)({}, state.editing);
                        delete editing[makeId(row)];
                        setState(function(state) {
                            return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                                editing: editing
                            });
                        });
                        if (!props.onEntrySave) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            props.onEntrySave(row)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return _onSave.apply(this, arguments);
    }
    function renderEdit(row, editing) {
        if (editing) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                    onClick: function() {
                        return onSave(row);
                    },
                    children: "Save"
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                    onClick: function() {
                        return onCancel(row);
                    },
                    children: "Cancel"
                })
            ]
        });
        else return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
            children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                onClick: function() {
                    return onEdit(row);
                },
                children: "Edit"
            })
        });
    }
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "repeat( ".concat(nColumns, ", auto)"),
            gridColumnGap: "1em",
            gridRowGap: "0.5em"
        },
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                className: "backoffice-row",
                children: [
                    Object.keys(props.columns).map(function(c) {
                        return renderColumnHeader(c);
                    }),
                    props.editable ? /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {}) : null
                ]
            }),
            props.values.map(function(v) {
                return renderRow(v, props.columns);
            })
        ]
    });
}








function $981271094a3256c5$var$mapLeafSensor(leafSensor, customerName) {
    return {
        id: leafSensor.id,
        name: leafSensor.name,
        customer: customerName,
        customerId: leafSensor.customerId,
        gps: leafSensor.gps,
        description: leafSensor.description,
        notificationEnabled: leafSensor.notificationEnabled,
        regDate: leafSensor.regDate,
        plantId: leafSensor.plantId,
        connected: leafSensor.connected,
        profileId: leafSensor.plant.deviceProfileId,
        hidden: leafSensor.plant.hidden,
        move: function() {
            return undefined;
        }
    };
}
function $981271094a3256c5$var$getProfiles(customerId) {
    return $981271094a3256c5$var$_getProfiles.apply(this, arguments);
}
function $981271094a3256c5$var$_getProfiles() {
    $981271094a3256c5$var$_getProfiles = (0, $7hBys._)(function(customerId) {
        var result, profiles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, profile;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = {};
                    return [
                        4,
                        (0, $a9fd84e20f6f5fba$export$d1da43634a05a45d).getProfilesByChildCustomerId(customerId)
                    ];
                case 1:
                    profiles = _state.sent();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = profiles[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            profile = _step.value;
                            // we know we have the ID
                            result[profile.id] = profile;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $981271094a3256c5$var$_getProfiles.apply(this, arguments);
}
function $981271094a3256c5$var$getLeafSensors() {
    return $981271094a3256c5$var$_getLeafSensors.apply(this, arguments);
}
function $981271094a3256c5$var$_getLeafSensors() {
    $981271094a3256c5$var$_getLeafSensors = (0, $7hBys._)(function() {
        var sensors, result, customers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, sensor, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, sensor1, customer, description, err;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log("Loading leaf sensors");
                    return [
                        4,
                        (0, $2d43067f24bd2fb9$export$846a5da018e5aa64).getMyLeafSensors(true, true)
                    ];
                case 1:
                    sensors = _state.sent();
                    result = [];
                    customers = {};
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = sensors[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            sensor = _step.value;
                            if (sensor.customerId && !customers[sensor.customerId]) customers[sensor.customerId] = (0, $6e638e6a04d37fe2$export$e6e17dabe8760570)(sensor.customerId);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _iterator1 = sensors[Symbol.iterator]();
                    _state.label = 3;
                case 3:
                    if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                        3,
                        6
                    ];
                    sensor1 = _step1.value;
                    return [
                        4,
                        customers[sensor1.customerId]
                    ];
                case 4:
                    customer = _state.sent();
                    description = sensor1.customerId ? customer.description : "";
                    result.push($981271094a3256c5$var$mapLeafSensor(sensor1, description));
                    _state.label = 5;
                case 5:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $981271094a3256c5$var$_getLeafSensors.apply(this, arguments);
}
var $981271094a3256c5$var$initialState = {
    showHidden: false,
    devices: []
};
function $981271094a3256c5$export$d31853d218981a41(props) {
    var _useState = (0, $52tJv._)((0, $17VE6.useState)($981271094a3256c5$var$initialState), 2), state = _useState[0], setState = _useState[1];
    function handleSortChanged(sortEvent) {
        var cmp = function(a, b) {
            return (0, $1f82f0133d3f4ee2$export$44c040ce524a6dac)(a[sortEvent.column], b[sortEvent.column]);
        };
        state.devices.sort(cmp);
        if (sortEvent.order === "desc") state.devices.reverse();
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            devices: (0, $fyztb._)(state.devices),
            sort: sortEvent
        }));
    }
    var leafSensorsAsync = (0, $b61d063c6ac5efce$export$cdf1dc76b55502e3)({
        promiseFn: $981271094a3256c5$var$getLeafSensors
    });
    var customersAsync = (0, $b61d063c6ac5efce$export$cdf1dc76b55502e3)({
        promiseFn: function() {
            return (0, $6e638e6a04d37fe2$export$fbfdec3fcd74f506)(props.customerId);
        }
    });
    var profilesAsync = (0, $b61d063c6ac5efce$export$cdf1dc76b55502e3)({
        promiseFn: function() {
            return $981271094a3256c5$var$getProfiles(props.customerId);
        }
    });
    switch(leafSensorsAsync.status){
        case "initial":
        case "pending":
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $ba001461d3497aae$export$7f7cbe89f1eacd2), {});
        case "rejected":
            return null;
        default:
    }
    switch(customersAsync.status){
        case "initial":
        case "pending":
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $ba001461d3497aae$export$7f7cbe89f1eacd2), {});
        case "rejected":
            return null;
        default:
    }
    switch(profilesAsync.status){
        case "initial":
        case "pending":
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $ba001461d3497aae$export$7f7cbe89f1eacd2), {});
        case "rejected":
            return null;
        default:
    }
    var devices = leafSensorsAsync.data;
    var customers = customersAsync.data;
    var profiles = profilesAsync.data;
    if (state.devices !== devices) setState(function(state) {
        return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
            devices: devices
        });
    });
    var columnInfo = {
        id: {
            description: "ID"
        },
        description: {
            description: "Description"
        },
        name: {
            description: "Name"
        },
        profileId: {
            description: "Profile",
            editable: true,
            renderer: function(row) {
                var _profiles_row_profileId;
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: (_profiles_row_profileId = profiles[row.profileId]) === null || _profiles_row_profileId === void 0 ? void 0 : _profiles_row_profileId.description
                });
            },
            editRenderer: function(value, onEntryChanged) {
                function onChange(event) {
                    var profileId = event.target.value;
                    console.log("PROFILES", profileId, profiles);
                    onEntryChanged((0, $bqLxK._)((0, $lwFY2._)({}, value), {
                        profileId: profileId
                    }));
                }
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("select", {
                    onChange: onChange,
                    value: value.profileId,
                    children: Object.values(profiles).map(function(p) {
                        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("option", {
                            value: p.id,
                            children: p.description
                        }, p.id);
                    })
                });
            }
        },
        customer: {
            description: "Customer",
            editable: true,
            editRenderer: function(value, onEntryChanged) {
                function getCustomerById(id) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = customers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var c = _step.value;
                            if (c.id === id) return c;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // we never arrive here.
                    return customers[0];
                }
                function onChange(event) {
                    var customerId = event.target.value;
                    console.log("CUSTOMERS", customers);
                    onEntryChanged((0, $bqLxK._)((0, $lwFY2._)({}, value), {
                        customerId: customerId,
                        customer: getCustomerById(customerId).description
                    }));
                }
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("select", {
                    onChange: onChange,
                    value: value.customerId,
                    children: customers.map(function(c) {
                        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("option", {
                            value: c.id,
                            children: c.description
                        }, c.id);
                    })
                });
            }
        },
        gps: {
            description: "Gps",
            renderer: function(row) {
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: row.gps && row.gps[0] + " - " + row.gps[1]
                });
            }
        },
        plantId: {
            description: "Plant ID"
        },
        connected: {
            description: "Connected",
            renderer: function(row) {
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $bb8043f30c8e9f0f$export$ae4b40d9fa099989), {
                    on: row.connected
                });
            }
        },
        hidden: {
            description: "Hidden",
            renderer: function(row) {
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                    children: row.hidden ? "\u2713" : ""
                });
            },
            // editable: true,
            editRenderer: function(value, onEntryChanged) {
                function onChange(event) {
                    onEntryChanged((0, $bqLxK._)((0, $lwFY2._)({}, value), {
                        hidden: event.target.checked
                    }));
                }
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                    type: "checkbox",
                    checked: value.hidden,
                    onChange: onChange
                });
            }
        }
    };
    function onDeviceSave(device) {
        return _onDeviceSave.apply(this, arguments);
    }
    function _onDeviceSave() {
        _onDeviceSave = (0, $7hBys._)(function(device) {
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("Moving plant", device);
                        return [
                            4,
                            (0, $d9e006fac7ba41ad$export$567d99ad22f1b14f).movePlant(device.plantId, device.customerId)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            leafSensorsAsync.reload()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _onDeviceSave.apply(this, arguments);
    }
    function onShowHiddenToggled(event) {
        setState(function(s) {
            return (0, $bqLxK._)((0, $lwFY2._)({}, s), {
                showHidden: event.target.checked
            });
        });
    }
    var filteredDevices = state.showHidden ? state.devices : state.devices.filter(function(d) {
        return !d.hidden;
    });
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)((0, $cbb9e6c9a362a987$export$60332b2344f7fe41), {
            children: [
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                    children: [
                        "Leaf Sensors  ",
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("small", {
                            children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                                        type: "checkbox",
                                        onChange: onShowHiddenToggled
                                    }),
                                    "Show hidden"
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $83f498fca7e759b7$export$54ec01a60f47d33d), {
                    values: filteredDevices,
                    columns: columnInfo,
                    sortBy: state.sort,
                    editable: true,
                    onEntrySave: onDeviceSave,
                    onSortChanged: handleSortChanged
                })
            ]
        })
    });
}



var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $fyztb = parcelRequire("fyztb");

var $ajhIL = parcelRequire("ajhIL");

parcelRequire("17VE6");





var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

parcelRequire("17VE6");

function $68a6e5153532b69b$export$4031132d73e44e5e(props) {
    function onIdChanged(sensor, id) {
        console.log("ID changed to", id);
        props.onSensorChanged(sensor, (0, $bqLxK._)((0, $lwFY2._)({}, sensor), {
            id: id
        }));
    }
    function onDescriptionChanged(sensor, description) {
        console.log("description changed to", description);
        props.onSensorChanged(sensor, (0, $bqLxK._)((0, $lwFY2._)({}, sensor), {
            description: description
        }));
    }
    function onFormulaChanged(sensor, formula) {
        console.log("formula changed to", formula);
        props.onSensorChanged(sensor, (0, $bqLxK._)((0, $lwFY2._)({}, sensor), {
            formula: formula
        }));
    }
    function onUomChanged(sensor, uom) {
        console.log("uom changed to", uom);
        props.onSensorChanged(sensor, (0, $bqLxK._)((0, $lwFY2._)({}, sensor), {
            uom: uom
        }));
    }
    function onSensorAdded() {
        props.onSensorAdded({
            formula: undefined,
            description: "",
            id: "",
            chartType: "line"
        });
    }
    function onSensorDeleted(sensor) {
        console.log("on sensor", sensor, "deleted");
        props.onSensorDeleted(sensor);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = props.sensors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var sensor = _step.value;
            var s = sensor;
            if (!s.uuid) s.uuid = (0, $2e8af8223c9b3a6c$export$2e2bcd8739ae039)();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "auto auto auto auto auto"
        },
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                style: {
                    display: "contents"
                },
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("b", {
                        children: "Name"
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("b", {
                        children: "Description"
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("b", {
                        children: "Formula"
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("b", {
                        children: "Uom"
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                        children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                            onClick: onSensorAdded,
                            children: "Add"
                        })
                    })
                ]
            }, "header"),
            props.sensors.map(function(s) {
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                    style: {
                        display: "contents"
                    },
                    children: [
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                            value: s.id,
                            onChange: function(e) {
                                return onIdChanged(s, e.target.value);
                            }
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                            value: s.description,
                            onChange: function(e) {
                                return onDescriptionChanged(s, e.target.value);
                            }
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                            value: s.formula,
                            onChange: function(e) {
                                return onFormulaChanged(s, e.target.value);
                            }
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                            value: s.uom,
                            onChange: function(e) {
                                return onUomChanged(s, e.target.value);
                            }
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                            children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                                onClick: function() {
                                    return onSensorDeleted(s);
                                },
                                children: "Delete"
                            })
                        })
                    ]
                }, s.uuid);
            })
        ]
    });
}



parcelRequire("17VE6");
function $58c70bfa5fc802d6$export$1883f9ce2492c911(props) {
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "auto auto"
        },
        children: props.sensors.map(function(s) {
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                style: {
                    display: "contents"
                },
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                        children: s.id
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                        children: s.description
                    })
                ]
            }, s.id);
        })
    });
}



function $68e6748707829622$var$getColumnInfo() {
    return {
        id: {
            description: "ID"
        },
        description: {
            description: "Description",
            editable: true,
            editRenderer: function(x, onEntryChanged) {
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                    value: x.description,
                    onChange: function(e) {
                        return onEntryChanged((0, $bqLxK._)((0, $lwFY2._)({}, x), {
                            description: e.target.value
                        }));
                    }
                });
            }
        },
        sensors: {
            description: "Sensors",
            editable: true,
            renderer: function(profile) {
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)((0, $cbb9e6c9a362a987$export$60332b2344f7fe41), {
                    children: [
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {}),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $58c70bfa5fc802d6$export$1883f9ce2492c911), {
                            sensors: profile.sensors
                        })
                    ]
                });
            },
            editRenderer: function(profile, onEntryChanged) {
                function onSensorAdded(sensor) {
                    var sensors = (0, $fyztb._)(profile.sensors);
                    sensors.push(sensor);
                    onEntryChanged((0, $bqLxK._)((0, $lwFY2._)({}, profile), {
                        sensors: sensors
                    }));
                }
                function onSensorDeleted(sensor) {
                    console.log(sensor, profile.sensors);
                    var sensors = profile.sensors.filter(function(s) {
                        return s != sensor;
                    });
                    onEntryChanged((0, $bqLxK._)((0, $lwFY2._)({}, profile), {
                        sensors: sensors
                    }));
                }
                function onSensorChanged(previous, current) {
                    var sensors = (0, $fyztb._)(profile.sensors);
                    for(var i = 0; i < profile.sensors.length; ++i)if (profile.sensors[i] === previous) sensors[i] = current;
                    onEntryChanged((0, $bqLxK._)((0, $lwFY2._)({}, profile), {
                        sensors: sensors
                    }));
                }
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)((0, $cbb9e6c9a362a987$export$60332b2344f7fe41), {
                    children: [
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {}),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $68a6e5153532b69b$export$4031132d73e44e5e), {
                            sensors: profile.sensors,
                            onSensorAdded: onSensorAdded,
                            onSensorChanged: onSensorChanged,
                            onSensorDeleted: onSensorDeleted
                        }),
                        " "
                    ]
                });
            }
        }
    };
}
var $68e6748707829622$var$initialState = {};
function $68e6748707829622$export$120c0e7b1bef3ec7(props) {
    var state = $68e6748707829622$var$initialState;
    var profilesAsync = (0, $b61d063c6ac5efce$export$cdf1dc76b55502e3)({
        promiseFn: function() {
            return (0, $a9fd84e20f6f5fba$export$d1da43634a05a45d).getProfilesByParentOfCustomerId(props.customerId);
        },
        watch: props.customerId
    });
    switch(profilesAsync.status){
        case "pending":
        case "initial":
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $ba001461d3497aae$export$7f7cbe89f1eacd2), {});
        case "rejected":
            return null;
        default:
    }
    function onProfileSave(profile) {
        return _onProfileSave.apply(this, arguments);
    }
    function _onProfileSave() {
        _onProfileSave = (0, $7hBys._)(function(profile) {
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $a9fd84e20f6f5fba$export$d1da43634a05a45d).saveProfile(profile)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            profilesAsync.reload()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _onProfileSave.apply(this, arguments);
    }
    function onProfileDelete(profile) {
        return _onProfileDelete.apply(this, arguments);
    }
    function _onProfileDelete() {
        _onProfileDelete = (0, $7hBys._)(function(profile) {
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $a9fd84e20f6f5fba$export$d1da43634a05a45d).deleteProfile(profile)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            profilesAsync.reload()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _onProfileDelete.apply(this, arguments);
    }
    function handleSortChanged() {}
    function onProfileAdd() {
        var newProfile = {
            customerId: props.customerId || "",
            description: "New Profile",
            sensors: []
        };
        if (profilesAsync.status === "fulfilled") profilesAsync.override((0, $fyztb._)(profilesAsync.data).concat([
            newProfile
        ]));
    }
    var values = profilesAsync.data;
    function isRowEditable(row) {
        return row.customerId === props.customerId;
    }
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)((0, $cbb9e6c9a362a987$export$60332b2344f7fe41), {
            children: [
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                            children: "Profiles"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("span", {
                            className: "spacer"
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                            onClick: onProfileAdd,
                            children: "New Profile"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $83f498fca7e759b7$export$54ec01a60f47d33d), {
                    values: values,
                    columns: $68e6748707829622$var$getColumnInfo(),
                    sortBy: state.sort,
                    editable: isRowEditable,
                    onEntrySave: onProfileSave,
                    onEntryDelete: onProfileDelete,
                    onSortChanged: handleSortChanged
                })
            ]
        })
    });
}


function $d351e14f5518ea11$export$7926de67b19c0929(props) {
    var loginInformation = (0, $d426a3f2c6fbebd8$export$9aa0815bbb7f01f0).getLoginInformation();
    var backofficeItems = [
        {
            type: "entry",
            destination: "/backoffice/customer",
            description: "Customers",
            requiredRole: undefined
        },
        {
            type: "entry",
            destination: "/backoffice/device",
            description: "Devices",
            requiredRole: undefined
        },
        {
            type: "entry",
            destination: "/backoffice/profile",
            description: "Profiles",
            requiredRole: undefined
        },
        {
            id: "spacer",
            type: "spacer"
        }
    ];
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $2aa0ce2ffd0dd16f$export$b8a61e5c71402559), {
                loginInformation: loginInformation,
                items: backofficeItems
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                className: "backoffice",
                children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)((0, $00b7b35226fb1bf3$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $00b7b35226fb1bf3$export$e7b0ac011bb776c6), {
                            path: "/customer",
                            element: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $394f8273019a9a9b$export$19984adfcae348ea), {
                                customerId: props.customerId
                            })
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $00b7b35226fb1bf3$export$e7b0ac011bb776c6), {
                            path: "/device",
                            element: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $981271094a3256c5$export$d31853d218981a41), {
                                customerId: props.customerId
                            })
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $00b7b35226fb1bf3$export$e7b0ac011bb776c6), {
                            path: "/profile",
                            element: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $68e6748707829622$export$120c0e7b1bef3ec7), {
                                customerId: props.customerId
                            })
                        })
                    ]
                })
            }),
            ";"
        ]
    });
}


/**
 * Render the given content only if the role is the one specified
 */ 


var $17VE6 = parcelRequire("17VE6");
function $683b65030ff82d62$export$69e659ab1e82910f(props) {
    var login = (0, $d426a3f2c6fbebd8$export$9aa0815bbb7f01f0).getLoginInformation();
    if (login === null || login === void 0 ? void 0 : login.hasRole(props.role)) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)($17VE6.Fragment, {
        children: props.children
    });
    else return null;
}





var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $bqLxK = parcelRequire("bqLxK");

var $52tJv = parcelRequire("52tJv");

var $fyztb = parcelRequire("fyztb");

var $ajhIL = parcelRequire("ajhIL");


var $17VE6 = parcelRequire("17VE6");

var $7hBys = parcelRequire("7hBys");

var $lwFY2 = parcelRequire("lwFY2");

var $ajhIL = parcelRequire("ajhIL");


var $94375f0c99140c92$var$ENDPOINT = "/api/v2/analysis";
function $94375f0c99140c92$export$616a7e2208f6895b(files) {
    return $94375f0c99140c92$var$_uploadFilesForAnalysis.apply(this, arguments);
}
function $94375f0c99140c92$var$_uploadFilesForAnalysis() {
    $94375f0c99140c92$var$_uploadFilesForAnalysis = (0, $7hBys._)(function(files) {
        var formData, i, file, response, result;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    formData = new FormData();
                    for(i = 0; i < files.length; ++i){
                        file = files[i];
                        formData.append("csv", file);
                    }
                    return [
                        4,
                        fetch("".concat($94375f0c99140c92$var$ENDPOINT, "/enqueue"), {
                            headers: (0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)()),
                            method: "post",
                            body: formData
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $94375f0c99140c92$var$_uploadFilesForAnalysis.apply(this, arguments);
}
function $94375f0c99140c92$export$95a16b4a58010891() {
    return $94375f0c99140c92$var$_getTaskList.apply(this, arguments);
}
function $94375f0c99140c92$var$_getTaskList() {
    $94375f0c99140c92$var$_getTaskList = (0, $7hBys._)(function() {
        var loginInformation, response, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, r;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loginInformation = (0, $d426a3f2c6fbebd8$export$9aa0815bbb7f01f0).getLoginInformation();
                    return [
                        4,
                        fetch("".concat($94375f0c99140c92$var$ENDPOINT, "/task?user=").concat(loginInformation.username), {
                            headers: (0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)())
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    result = _state.sent();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = result[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            r = _step.value;
                            r.creationDate = new Date(r.creationDate);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    console.log("RES", result);
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $94375f0c99140c92$var$_getTaskList.apply(this, arguments);
}
function $94375f0c99140c92$export$769aba8c64cf56b7(taskId) {
    return $94375f0c99140c92$var$_getTask.apply(this, arguments);
}
function $94375f0c99140c92$var$_getTask() {
    $94375f0c99140c92$var$_getTask = (0, $7hBys._)(function(taskId) {
        var response, result;
        return (0, $ajhIL.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("".concat($94375f0c99140c92$var$ENDPOINT, "/task/").concat(taskId), {
                            headers: (0, $lwFY2._)({}, (0, $d426a3f2c6fbebd8$export$280f25a5a6782e3d)())
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new (0, $c654d78c2f990604$export$d5dc6a7bc778a961)(response);
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $94375f0c99140c92$var$_getTask.apply(this, arguments);
}






var $iCQyW = parcelRequire("iCQyW");

var $52tJv = parcelRequire("52tJv");

var $ajhIL = parcelRequire("ajhIL");

var $17VE6 = parcelRequire("17VE6");

var $51RYA = parcelRequire("51RYA");
var $3fb715c8242b9f15$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $3fb715c8242b9f15$export$84fe03429ed1b6d6 = [
    "onCopy",
    "onCut",
    "onPaste"
];
var $3fb715c8242b9f15$export$dbc46161504615f7 = [
    "onCompositionEnd",
    "onCompositionStart",
    "onCompositionUpdate"
];
var $3fb715c8242b9f15$export$fb6351c2666f0875 = [
    "onFocus",
    "onBlur"
];
var $3fb715c8242b9f15$export$4e58c1a9761ed81a = [
    "onInput",
    "onInvalid",
    "onReset",
    "onSubmit"
];
var $3fb715c8242b9f15$export$3bf7402f2a4eb3af = [
    "onLoad",
    "onError"
];
var $3fb715c8242b9f15$export$409c4891d97f97cf = [
    "onKeyDown",
    "onKeyPress",
    "onKeyUp"
];
var $3fb715c8242b9f15$export$6be5aa2386088264 = [
    "onAbort",
    "onCanPlay",
    "onCanPlayThrough",
    "onDurationChange",
    "onEmptied",
    "onEncrypted",
    "onEnded",
    "onError",
    "onLoadedData",
    "onLoadedMetadata",
    "onLoadStart",
    "onPause",
    "onPlay",
    "onPlaying",
    "onProgress",
    "onRateChange",
    "onSeeked",
    "onSeeking",
    "onStalled",
    "onSuspend",
    "onTimeUpdate",
    "onVolumeChange",
    "onWaiting"
];
var $3fb715c8242b9f15$export$3a6e2b8954613992 = [
    "onClick",
    "onContextMenu",
    "onDoubleClick",
    "onMouseDown",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseOut",
    "onMouseOver",
    "onMouseUp"
];
var $3fb715c8242b9f15$export$6c96379d5b8a2df7 = [
    "onDrag",
    "onDragEnd",
    "onDragEnter",
    "onDragExit",
    "onDragLeave",
    "onDragOver",
    "onDragStart",
    "onDrop"
];
var $3fb715c8242b9f15$export$d93346aa7735a637 = [
    "onSelect"
];
var $3fb715c8242b9f15$export$fa367689c659e65c = [
    "onTouchCancel",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart"
];
var $3fb715c8242b9f15$export$c731eab7619e00a0 = [
    "onPointerDown",
    "onPointerMove",
    "onPointerUp",
    "onPointerCancel",
    "onGotPointerCapture",
    "onLostPointerCapture",
    "onPointerEnter",
    "onPointerLeave",
    "onPointerOver",
    "onPointerOut"
];
var $3fb715c8242b9f15$export$bac3087b5cb826f6 = [
    "onScroll"
];
var $3fb715c8242b9f15$export$28298837799e00e8 = [
    "onWheel"
];
var $3fb715c8242b9f15$export$6ff45424014e7407 = [
    "onAnimationStart",
    "onAnimationEnd",
    "onAnimationIteration"
];
var $3fb715c8242b9f15$export$78878fc7bd50dc3e = [
    "onTransitionEnd"
];
var $3fb715c8242b9f15$export$477a88c5b93a108d = [
    "onToggle"
];
var $3fb715c8242b9f15$export$7212b61f9f58bd1 = [
    "onChange"
];
var $3fb715c8242b9f15$export$59ef7197c4d7b9dc = $3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray($3fb715c8242b9f15$var$__spreadArray([], $3fb715c8242b9f15$export$84fe03429ed1b6d6, true), $3fb715c8242b9f15$export$dbc46161504615f7, true), $3fb715c8242b9f15$export$fb6351c2666f0875, true), $3fb715c8242b9f15$export$4e58c1a9761ed81a, true), $3fb715c8242b9f15$export$3bf7402f2a4eb3af, true), $3fb715c8242b9f15$export$409c4891d97f97cf, true), $3fb715c8242b9f15$export$6be5aa2386088264, true), $3fb715c8242b9f15$export$3a6e2b8954613992, true), $3fb715c8242b9f15$export$6c96379d5b8a2df7, true), $3fb715c8242b9f15$export$d93346aa7735a637, true), $3fb715c8242b9f15$export$fa367689c659e65c, true), $3fb715c8242b9f15$export$c731eab7619e00a0, true), $3fb715c8242b9f15$export$bac3087b5cb826f6, true), $3fb715c8242b9f15$export$28298837799e00e8, true), $3fb715c8242b9f15$export$6ff45424014e7407, true), $3fb715c8242b9f15$export$78878fc7bd50dc3e, true), $3fb715c8242b9f15$export$7212b61f9f58bd1, true), $3fb715c8242b9f15$export$477a88c5b93a108d, true);
function $3fb715c8242b9f15$export$2e2bcd8739ae039(props, getArgs) {
    var eventProps = {};
    $3fb715c8242b9f15$export$59ef7197c4d7b9dc.forEach(function(eventName) {
        var eventHandler = props[eventName];
        if (!eventHandler) return;
        if (getArgs) eventProps[eventName] = function(event) {
            return eventHandler(event, getArgs(eventName));
        };
        else eventProps[eventName] = eventHandler;
    });
    return eventProps;
}


function $c6cc3944041b35b4$export$2e2bcd8739ae039(promise) {
    var isCancelled = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(value) {
            return !isCancelled && resolve(value);
        }).catch(function(error) {
            return !isCancelled && reject(error);
        });
    });
    return {
        promise: wrappedPromise,
        cancel: function cancel() {
            isCancelled = true;
        }
    };
}




var $6a34d81ce2b9929e$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $6a34d81ce2b9929e$var$__DEV__ = false;
var $6a34d81ce2b9929e$var$warning = function warning() {};
if ($6a34d81ce2b9929e$var$__DEV__) {
    var $6a34d81ce2b9929e$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $6a34d81ce2b9929e$var$warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $6a34d81ce2b9929e$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$6a34d81ce2b9929e$exports = $6a34d81ce2b9929e$var$warning;


var $96b709aeeb56ba9f$var$has = Object.prototype.hasOwnProperty;
function $96b709aeeb56ba9f$var$find(iter, tar, key) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iter.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            key = _step.value;
            if ($96b709aeeb56ba9f$export$de8294bb3be0322f(key, tar)) return key;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $96b709aeeb56ba9f$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $96b709aeeb56ba9f$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = foo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    len = _step.value;
                    tmp = len;
                    if (tmp && typeof tmp === "object") {
                        tmp = $96b709aeeb56ba9f$var$find(bar, tmp);
                        if (!tmp) return false;
                    }
                    if (!bar.has(tmp)) return false;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = foo[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    len = _step1.value;
                    tmp = len[0];
                    if (tmp && typeof tmp === "object") {
                        tmp = $96b709aeeb56ba9f$var$find(bar, tmp);
                        if (!tmp) return false;
                    }
                    if (!$96b709aeeb56ba9f$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === "object") {
            len = 0;
            for(ctor in foo){
                if ($96b709aeeb56ba9f$var$has.call(foo, ctor) && ++len && !$96b709aeeb56ba9f$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$96b709aeeb56ba9f$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $9t9wG = parcelRequire("9t9wG");
var $60b77cc7ba7556cf$var$pdfjs = "default" in $9t9wG ? $9t9wG["default"] : $9t9wG;
var $60b77cc7ba7556cf$export$2e2bcd8739ae039 = $60b77cc7ba7556cf$var$pdfjs;



var $17VE6 = parcelRequire("17VE6");
"use client";
var $edc808c79701ea35$export$2e2bcd8739ae039 = (0, $17VE6.createContext)(null);



var $17VE6 = parcelRequire("17VE6");
function $64a6721c4e4a20e2$export$2e2bcd8739ae039(param) {
    var children = param.children, type = param.type;
    return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("div", {
        className: "react-pdf__message react-pdf__message--".concat(type)
    }, children);
}


/* Copyright 2015 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $5sFFs = parcelRequire("5sFFs");

var $8O2fV = parcelRequire("8O2fV");

var $289ed46ca5f719de$var$DEFAULT_LINK_REL = "noopener noreferrer nofollow";
var $289ed46ca5f719de$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function LinkService() {
        (0, $5sFFs._)(this, LinkService);
        this.externalLinkEnabled = true;
        this.externalLinkRel = undefined;
        this.externalLinkTarget = undefined;
        this.isInPresentationMode = false;
        this.pdfDocument = undefined;
        this.pdfViewer = undefined;
    }
    (0, $8O2fV._)(LinkService, [
        {
            key: "setDocument",
            value: function setDocument(pdfDocument) {
                this.pdfDocument = pdfDocument;
            }
        },
        {
            key: "setViewer",
            value: function setViewer(pdfViewer) {
                this.pdfViewer = pdfViewer;
            }
        },
        {
            key: "setExternalLinkRel",
            value: function setExternalLinkRel(externalLinkRel) {
                this.externalLinkRel = externalLinkRel;
            }
        },
        {
            key: "setExternalLinkTarget",
            value: function setExternalLinkTarget(externalLinkTarget) {
                this.externalLinkTarget = externalLinkTarget;
            }
        },
        {
            key: "setHistory",
            value: function setHistory() {
            // Intentionally empty
            }
        },
        {
            key: "pagesCount",
            get: function get() {
                return this.pdfDocument ? this.pdfDocument.numPages : 0;
            }
        },
        {
            key: "page",
            get: function get() {
                (0, $986f3a016cffd215$export$2e2bcd8739ae039)(this.pdfViewer, "PDF viewer is not initialized.");
                return this.pdfViewer.currentPageNumber || 0;
            },
            set: function set(value) {
                (0, $986f3a016cffd215$export$2e2bcd8739ae039)(this.pdfViewer, "PDF viewer is not initialized.");
                this.pdfViewer.currentPageNumber = value;
            }
        },
        {
            key: "rotation",
            get: // eslint-disable-next-line @typescript-eslint/class-literal-property-style
            function get() {
                return 0;
            },
            set: function set(value) {
            // Intentionally empty
            }
        },
        {
            key: "goToDestination",
            value: function goToDestination(dest) {
                var _this = this;
                return new Promise(function(resolve) {
                    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(_this.pdfDocument, "PDF document not loaded.");
                    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(dest, "Destination is not specified.");
                    if (typeof dest === "string") _this.pdfDocument.getDestination(dest).then(resolve);
                    else if (Array.isArray(dest)) resolve(dest);
                    else dest.then(resolve);
                }).then(function(explicitDest) {
                    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(Array.isArray(explicitDest), '"'.concat(explicitDest, '" is not a valid destination array.'));
                    var destRef = explicitDest[0];
                    new Promise(function(resolve) {
                        (0, $986f3a016cffd215$export$2e2bcd8739ae039)(_this.pdfDocument, "PDF document not loaded.");
                        if (destRef instanceof Object) _this.pdfDocument.getPageIndex(destRef).then(function(pageIndex) {
                            resolve(pageIndex);
                        }).catch(function() {
                            (0, $986f3a016cffd215$export$2e2bcd8739ae039)(false, '"'.concat(destRef, '" is not a valid page reference.'));
                        });
                        else if (typeof destRef === "number") resolve(destRef);
                        else (0, $986f3a016cffd215$export$2e2bcd8739ae039)(false, '"'.concat(destRef, '" is not a valid destination reference.'));
                    }).then(function(pageIndex) {
                        var pageNumber = pageIndex + 1;
                        (0, $986f3a016cffd215$export$2e2bcd8739ae039)(_this.pdfViewer, "PDF viewer is not initialized.");
                        (0, $986f3a016cffd215$export$2e2bcd8739ae039)(pageNumber >= 1 && pageNumber <= _this.pagesCount, '"'.concat(pageNumber, '" is not a valid page number.'));
                        _this.pdfViewer.scrollPageIntoView({
                            dest: explicitDest,
                            pageIndex: pageIndex,
                            pageNumber: pageNumber
                        });
                    });
                });
            }
        },
        {
            key: "navigateTo",
            value: function navigateTo(dest) {
                this.goToDestination(dest);
            }
        },
        {
            key: "goToPage",
            value: function goToPage(pageNumber) {
                var pageIndex = pageNumber - 1;
                (0, $986f3a016cffd215$export$2e2bcd8739ae039)(this.pdfViewer, "PDF viewer is not initialized.");
                (0, $986f3a016cffd215$export$2e2bcd8739ae039)(pageNumber >= 1 && pageNumber <= this.pagesCount, '"'.concat(pageNumber, '" is not a valid page number.'));
                this.pdfViewer.scrollPageIntoView({
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
            }
        },
        {
            key: "addLinkAttributes",
            value: function addLinkAttributes(link, url, newWindow) {
                link.href = url;
                link.rel = this.externalLinkRel || $289ed46ca5f719de$var$DEFAULT_LINK_REL;
                link.target = newWindow ? "_blank" : this.externalLinkTarget || "";
            }
        },
        {
            key: "getDestinationHash",
            value: function getDestinationHash() {
                return "#";
            }
        },
        {
            key: "getAnchorUrl",
            value: function getAnchorUrl() {
                return "#";
            }
        },
        {
            key: "setHash",
            value: function setHash() {
            // Intentionally empty
            }
        },
        {
            key: "executeNamedAction",
            value: function executeNamedAction() {
            // Intentionally empty
            }
        },
        {
            key: "cachePageRef",
            value: function cachePageRef() {
            // Intentionally empty
            }
        },
        {
            key: "isPageVisible",
            value: function isPageVisible() {
                return true;
            }
        },
        {
            key: "isPageCached",
            value: function isPageCached() {
                return true;
            }
        },
        {
            key: "executeSetOCGState",
            value: function executeSetOCGState() {
            // Intentionally empty
            }
        }
    ]);
    return LinkService;
}();


// As defined in https://github.com/mozilla/pdf.js/blob/d9fac3459609a807be6506fb3441b5da4b154d14/src/shared/util.js#L371-L374
var $3ea932c32458d212$var$PasswordResponses = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
var $3ea932c32458d212$export$2e2bcd8739ae039 = $3ea932c32458d212$var$PasswordResponses;



var $52tJv = parcelRequire("52tJv");


var $d7d31a0ec2d25666$export$4e09c449d6c407f7 = typeof document !== "undefined";
var $d7d31a0ec2d25666$export$d528e4159a0e221e = $d7d31a0ec2d25666$export$4e09c449d6c407f7 && window.location.protocol === "file:";
function $d7d31a0ec2d25666$export$4e62c701997796c1(variable) {
    return typeof variable !== "undefined";
}
function $d7d31a0ec2d25666$export$ef8866826b0b1f6d(variable) {
    return $d7d31a0ec2d25666$export$4e62c701997796c1(variable) && variable !== null;
}
function $d7d31a0ec2d25666$export$844ec244b1367d54(variable) {
    return typeof variable === "string";
}
function $d7d31a0ec2d25666$export$9dd3754ae86f0017(variable) {
    return variable instanceof ArrayBuffer;
}
function $d7d31a0ec2d25666$export$5bcd6e94ed871c88(variable) {
    (0, $986f3a016cffd215$export$2e2bcd8739ae039)($d7d31a0ec2d25666$export$4e09c449d6c407f7, "isBlob can only be used in a browser environment");
    return variable instanceof Blob;
}
function $d7d31a0ec2d25666$export$4d82193ef6a8d75c(variable) {
    return $d7d31a0ec2d25666$export$844ec244b1367d54(variable) && /^data:/.test(variable);
}
function $d7d31a0ec2d25666$export$c1553384119518c3(dataURI) {
    (0, $986f3a016cffd215$export$2e2bcd8739ae039)($d7d31a0ec2d25666$export$4d82193ef6a8d75c(dataURI), "Invalid data URI.");
    var _dataURI_split = (0, $52tJv._)(dataURI.split(","), 2), tmp = _dataURI_split[0], headersString = tmp === void 0 ? "" : tmp, tmp1 = _dataURI_split[1], dataString = tmp1 === void 0 ? "" : tmp1;
    var headers = headersString.split(";");
    if (headers.indexOf("base64") !== -1) return atob(dataString);
    return unescape(dataString);
}
function $d7d31a0ec2d25666$export$cf4a949e5ad681d() {
    return $d7d31a0ec2d25666$export$4e09c449d6c407f7 && window.devicePixelRatio || 1;
}
var $d7d31a0ec2d25666$var$allowFileAccessFromFilesTip = "On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.";
function $d7d31a0ec2d25666$export$84884c3182d1bdda() {
    (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(!$d7d31a0ec2d25666$export$d528e4159a0e221e, "Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ".concat($d7d31a0ec2d25666$var$allowFileAccessFromFilesTip));
}
function $d7d31a0ec2d25666$export$e7ec4a9e2d586a77() {
    (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(!$d7d31a0ec2d25666$export$d528e4159a0e221e, "Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ".concat($d7d31a0ec2d25666$var$allowFileAccessFromFilesTip));
}
function $d7d31a0ec2d25666$export$b8c3f1dffc289352(runningTask) {
    if (runningTask && runningTask.cancel) runningTask.cancel();
}
function $d7d31a0ec2d25666$export$8cc3f6b8d58bdda0(page, scale) {
    Object.defineProperty(page, "width", {
        get: function() {
            return this.view[2] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, "height", {
        get: function() {
            return this.view[3] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, "originalWidth", {
        get: function() {
            return this.view[2];
        },
        configurable: true
    });
    Object.defineProperty(page, "originalHeight", {
        get: function() {
            return this.view[3];
        },
        configurable: true
    });
    return page;
}
function $d7d31a0ec2d25666$export$99075c4d008e6ab1(error) {
    return error.name === "RenderingCancelledException";
}
function $d7d31a0ec2d25666$export$21fedb3a7a137f3d(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() {
            if (!reader.result) return reject(new Error("Error while reading a file."));
            resolve(reader.result);
        };
        reader.onerror = function(event) {
            if (!event.target) return reject(new Error("Error while reading a file."));
            var error = event.target.error;
            if (!error) return reject(new Error("Error while reading a file."));
            switch(error.code){
                case error.NOT_FOUND_ERR:
                    return reject(new Error("Error while reading a file: File not found."));
                case error.SECURITY_ERR:
                    return reject(new Error("Error while reading a file: Security error."));
                case error.ABORT_ERR:
                    return reject(new Error("Error while reading a file: Aborted."));
                default:
                    return reject(new Error("Error while reading a file."));
            }
        };
        reader.readAsArrayBuffer(file);
    });
}



var $17VE6 = parcelRequire("17VE6");
function $cdec58f753f8259b$var$reducer(state, action) {
    switch(action.type){
        case "RESOLVE":
            return {
                value: action.value,
                error: undefined
            };
        case "REJECT":
            return {
                value: false,
                error: action.error
            };
        case "RESET":
            return {
                value: undefined,
                error: undefined
            };
        default:
            return state;
    }
}
function $cdec58f753f8259b$export$2e2bcd8739ae039() {
    return (0, $17VE6.useReducer)($cdec58f753f8259b$var$reducer, {
        value: undefined,
        error: undefined
    });
}



var $l6pW7 = parcelRequire("l6pW7");

var $51RYA = parcelRequire("51RYA");




var $fc608904b0e9bd41$var$PDFDataRangeTransport = (0, $60b77cc7ba7556cf$export$2e2bcd8739ae039).PDFDataRangeTransport;
var $fc608904b0e9bd41$export$1e08905474334888 = function() {
    var result = {};
    (0, $3fb715c8242b9f15$export$59ef7197c4d7b9dc).forEach(function(eventName) {
        result[eventName] = (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func;
    });
    return result;
}();
var $fc608904b0e9bd41$var$isTypedArray = (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).instanceOf(Int8Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).instanceOf(Uint8Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).instanceOf(Uint8ClampedArray),
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).instanceOf(Int16Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).instanceOf(Uint16Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).instanceOf(Int32Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).instanceOf(Uint32Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).instanceOf(Float32Array),
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).instanceOf(Float64Array)
]);
var $fc608904b0e9bd41$var$fileTypes = [
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).instanceOf(ArrayBuffer),
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).shape({
        data: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).instanceOf(ArrayBuffer),
            (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).number.isRequired),
            $fc608904b0e9bd41$var$isTypedArray
        ]).isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).shape({
        range: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).instanceOf($fc608904b0e9bd41$var$PDFDataRangeTransport).isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).shape({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string.isRequired
    })
];
if (typeof Blob !== "undefined") $fc608904b0e9bd41$var$fileTypes.push((0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).instanceOf(Blob));
var $fc608904b0e9bd41$export$d53f3db2f43345df = (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string)
]);
var $fc608904b0e9bd41$export$be78b3111c50efdd = (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOfType($fc608904b0e9bd41$var$fileTypes);
var $fc608904b0e9bd41$export$836c1083c8eb7ae = (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).instanceOf((0, $289ed46ca5f719de$export$2e2bcd8739ae039));
var $fc608904b0e9bd41$export$4d23df922dd97db8 = (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOf([
    "_self",
    "_blank",
    "_parent",
    "_top"
]);
var $fc608904b0e9bd41$export$61d82a1ff85c609a = (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).shape({
    commonObjs: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).shape({}).isRequired,
    getAnnotations: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func.isRequired,
    getTextContent: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func.isRequired,
    getViewport: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func.isRequired,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func.isRequired
});
var $fc608904b0e9bd41$export$7b4c8bd6e6871332 = function isPageIndex(props, propName, componentName) {
    var pageIndex = props[propName], pageNumber = props.pageNumber, pdf = props.pdf;
    if (!(0, $d7d31a0ec2d25666$export$4e62c701997796c1)(pdf)) return null;
    if ((0, $d7d31a0ec2d25666$export$4e62c701997796c1)(pageIndex)) {
        if (typeof pageIndex !== "number") return new Error("`".concat(propName, "` of type `").concat(typeof pageIndex === "undefined" ? "undefined" : (0, $l6pW7._)(pageIndex), "` supplied to `").concat(componentName, "`, expected `number`."));
        if (pageIndex < 0) return new Error("Expected `".concat(propName, "` to be greater or equal to 0."));
        var numPages = pdf.numPages;
        if (pageIndex + 1 > numPages) return new Error("Expected `".concat(propName, "` to be less or equal to ").concat(numPages - 1, "."));
    } else if (!(0, $d7d31a0ec2d25666$export$4e62c701997796c1)(pageNumber)) return new Error("`".concat(propName, "` not supplied. Either pageIndex or pageNumber must be supplied to `").concat(componentName, "`."));
    // Everything is fine
    return null;
};
var $fc608904b0e9bd41$export$973e710208ddd50f = function isPageNumber(props, propName, componentName) {
    var pageNumber = props[propName], pageIndex = props.pageIndex, pdf = props.pdf;
    if (!(0, $d7d31a0ec2d25666$export$4e62c701997796c1)(pdf)) return null;
    if ((0, $d7d31a0ec2d25666$export$4e62c701997796c1)(pageNumber)) {
        if (typeof pageNumber !== "number") return new Error("`".concat(propName, "` of type `").concat(typeof pageNumber === "undefined" ? "undefined" : (0, $l6pW7._)(pageNumber), "` supplied to `").concat(componentName, "`, expected `number`."));
        if (pageNumber < 1) return new Error("Expected `".concat(propName, "` to be greater or equal to 1."));
        var numPages = pdf.numPages;
        if (pageNumber > numPages) return new Error("Expected `".concat(propName, "` to be less or equal to ").concat(numPages, "."));
    } else if (!(0, $d7d31a0ec2d25666$export$4e62c701997796c1)(pageIndex)) return new Error("`".concat(propName, "` not supplied. Either pageIndex or pageNumber must be supplied to `").concat(componentName, "`."));
    // Everything is fine
    return null;
};
var $fc608904b0e9bd41$export$d22001c6ab8dd37 = (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOfType([
    // Ideally, this would be `PropTypes.instanceOf(PDFDocumentProxy)`, but it can't be imported.
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).any,
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOf([
        false
    ])
]);
var $fc608904b0e9bd41$export$4f9f5282de18fc69 = (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).exact({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).any
    })
]);
var $fc608904b0e9bd41$export$70f0c3edbd58f82c = (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOf([
    "canvas",
    "custom",
    "none",
    "svg"
]);
var $fc608904b0e9bd41$export$10b2580337f7e7c1 = (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOf([
    0,
    90,
    180,
    270
]);


"use client";
var $262be8f2403ec17e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $262be8f2403ec17e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $262be8f2403ec17e$var$PDFDataRangeTransport = (0, $60b77cc7ba7556cf$export$2e2bcd8739ae039).PDFDataRangeTransport;
var $262be8f2403ec17e$var$defaultOnPassword = function(callback, reason) {
    switch(reason){
        case (0, $3ea932c32458d212$export$2e2bcd8739ae039).NEED_PASSWORD:
            {
                // eslint-disable-next-line no-alert
                var password = prompt("Enter the password to open this PDF file.");
                callback(password);
                break;
            }
        case (0, $3ea932c32458d212$export$2e2bcd8739ae039).INCORRECT_PASSWORD:
            {
                // eslint-disable-next-line no-alert
                var password1 = prompt("Invalid password. Please try again.");
                callback(password1);
                break;
            }
        default:
    }
};
function $262be8f2403ec17e$var$isParameterObject(file) {
    return typeof file === "object" && file !== null && ("data" in file || "range" in file || "url" in file);
}
/**
 * Loads a document passed using `file` prop.
 */ var $262be8f2403ec17e$var$Document = (0, $17VE6.forwardRef)(function Document(_a, ref) {
    var _this = this;
    var children = _a.children, className = _a.className, _a_error = _a.error, error = _a_error === void 0 ? "Failed to load PDF file." : _a_error, externalLinkRel = _a.externalLinkRel, externalLinkTarget = _a.externalLinkTarget, file = _a.file, inputRef = _a.inputRef, imageResourcesPath = _a.imageResourcesPath, _a_loading = _a.loading, loading = _a_loading === void 0 ? "Loading PDF\u2026" : _a_loading, _a_noData = _a.noData, noData = _a_noData === void 0 ? "No PDF file specified." : _a_noData, onItemClick = _a.onItemClick, onLoadErrorProps = _a.onLoadError, onLoadProgress = _a.onLoadProgress, onLoadSuccessProps = _a.onLoadSuccess, _a_onPassword = _a.onPassword, onPassword = _a_onPassword === void 0 ? $262be8f2403ec17e$var$defaultOnPassword : _a_onPassword, onSourceErrorProps = _a.onSourceError, onSourceSuccessProps = _a.onSourceSuccess, options = _a.options, renderMode = _a.renderMode, rotate = _a.rotate, otherProps = $262be8f2403ec17e$var$__rest(_a, [
        "children",
        "className",
        "error",
        "externalLinkRel",
        "externalLinkTarget",
        "file",
        "inputRef",
        "imageResourcesPath",
        "loading",
        "noData",
        "onItemClick",
        "onLoadError",
        "onLoadProgress",
        "onLoadSuccess",
        "onPassword",
        "onSourceError",
        "onSourceSuccess",
        "options",
        "renderMode",
        "rotate"
    ]);
    var _useResolver = (0, $52tJv._)((0, $cdec58f753f8259b$export$2e2bcd8739ae039)(), 2), sourceState = _useResolver[0], sourceDispatch = _useResolver[1];
    var source = sourceState.value, sourceError = sourceState.error;
    var _useResolver1 = (0, $52tJv._)((0, $cdec58f753f8259b$export$2e2bcd8739ae039)(), 2), pdfState = _useResolver1[0], pdfDispatch = _useResolver1[1];
    var pdf = pdfState.value, pdfError = pdfState.error;
    var linkService = (0, $17VE6.useRef)(new (0, $289ed46ca5f719de$export$2e2bcd8739ae039)());
    var pages = (0, $17VE6.useRef)([]);
    var prevFile = (0, $17VE6.useRef)();
    var prevOptions = (0, $17VE6.useRef)();
    (0, $17VE6.useEffect)(function() {
        if (file && file !== prevFile.current && $262be8f2403ec17e$var$isParameterObject(file)) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(!(0, $96b709aeeb56ba9f$export$de8294bb3be0322f)(file, prevFile.current), 'File prop passed to <Document /> changed, but it\'s equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "file" prop.');
            prevFile.current = file;
        }
    }, [
        file
    ]);
    // Detect non-memoized changes in options prop
    (0, $17VE6.useEffect)(function() {
        if (options && options !== prevOptions.current) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(!(0, $96b709aeeb56ba9f$export$de8294bb3be0322f)(options, prevOptions.current), 'Options prop passed to <Document /> changed, but it\'s equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "options" prop.');
            prevOptions.current = options;
        }
    }, [
        options
    ]);
    var viewer = (0, $17VE6.useRef)({
        // Handling jumping to internal links target
        scrollPageIntoView: function(args) {
            var dest = args.dest, pageNumber = args.pageNumber, _args_pageIndex = args.pageIndex, pageIndex = _args_pageIndex === void 0 ? pageNumber - 1 : _args_pageIndex;
            // First, check if custom handling of onItemClick was provided
            if (onItemClick) {
                onItemClick({
                    dest: dest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
                return;
            }
            // If not, try to look for target page within the <Document>.
            var page = pages.current[pageIndex];
            if (page) {
                // Scroll to the page automatically
                page.scrollIntoView();
                return;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(false, "An internal link leading to page ".concat(pageNumber, " was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>."));
        }
    });
    (0, $17VE6.useImperativeHandle)(ref, function() {
        return {
            linkService: linkService,
            pages: pages,
            viewer: viewer
        };
    }, []);
    /**
     * Called when a document source is resolved correctly
     */ function onSourceSuccess() {
        if (onSourceSuccessProps) onSourceSuccessProps();
    }
    /**
     * Called when a document source failed to be resolved correctly
     */ function onSourceError() {
        if (!sourceError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(false, sourceError.toString());
        if (onSourceErrorProps) onSourceErrorProps(sourceError);
    }
    function resetSource() {
        sourceDispatch({
            type: "RESET"
        });
    }
    (0, $17VE6.useEffect)(resetSource, [
        file,
        sourceDispatch
    ]);
    var findDocumentSource = (0, $17VE6.useCallback)(function() {
        return $262be8f2403ec17e$var$__awaiter(_this, void 0, void 0, function() {
            var fileByteString, data, url, otherParams, fileByteString1;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!file) return [
                            2,
                            null
                        ];
                        // File is a string
                        if (typeof file === "string") {
                            if ((0, $d7d31a0ec2d25666$export$4d82193ef6a8d75c)(file)) {
                                fileByteString = (0, $d7d31a0ec2d25666$export$c1553384119518c3)(file);
                                return [
                                    2,
                                    {
                                        data: fileByteString
                                    }
                                ];
                            }
                            (0, $d7d31a0ec2d25666$export$84884c3182d1bdda)();
                            return [
                                2,
                                {
                                    url: file
                                }
                            ];
                        }
                        // File is PDFDataRangeTransport
                        if (file instanceof $262be8f2403ec17e$var$PDFDataRangeTransport) return [
                            2,
                            {
                                range: file
                            }
                        ];
                        // File is an ArrayBuffer
                        if ((0, $d7d31a0ec2d25666$export$9dd3754ae86f0017)(file)) return [
                            2,
                            {
                                data: file
                            }
                        ];
                        if (!(0, $d7d31a0ec2d25666$export$4e09c449d6c407f7)) return [
                            3,
                            2
                        ];
                        if (!(0, $d7d31a0ec2d25666$export$5bcd6e94ed871c88)(file)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $d7d31a0ec2d25666$export$21fedb3a7a137f3d)(file)
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            2,
                            {
                                data: data
                            }
                        ];
                    case 2:
                        // At this point, file must be an object
                        (0, $986f3a016cffd215$export$2e2bcd8739ae039)(typeof file === "object", "Invalid parameter in file, need either Uint8Array, string or a parameter object");
                        (0, $986f3a016cffd215$export$2e2bcd8739ae039)($262be8f2403ec17e$var$isParameterObject(file), "Invalid parameter object: need either .data, .range or .url");
                        // File .url is a string
                        if ("url" in file && typeof file.url === "string") {
                            if ((0, $d7d31a0ec2d25666$export$4d82193ef6a8d75c)(file.url)) {
                                url = file.url, otherParams = $262be8f2403ec17e$var$__rest(file, [
                                    "url"
                                ]);
                                fileByteString1 = (0, $d7d31a0ec2d25666$export$c1553384119518c3)(url);
                                return [
                                    2,
                                    Object.assign({
                                        data: fileByteString1
                                    }, otherParams)
                                ];
                            }
                            (0, $d7d31a0ec2d25666$export$84884c3182d1bdda)();
                        }
                        return [
                            2,
                            file
                        ];
                }
            });
        });
    }, [
        file
    ]);
    (0, $17VE6.useEffect)(function() {
        var cancellable = (0, $c6cc3944041b35b4$export$2e2bcd8739ae039)(findDocumentSource());
        cancellable.promise.then(function(nextSource) {
            sourceDispatch({
                type: "RESOLVE",
                value: nextSource
            });
        }).catch(function(error) {
            sourceDispatch({
                type: "REJECT",
                error: error
            });
        });
        return function() {
            (0, $d7d31a0ec2d25666$export$b8c3f1dffc289352)(cancellable);
        };
    }, [
        findDocumentSource,
        sourceDispatch
    ]);
    (0, $17VE6.useEffect)(function() {
        if (typeof source === "undefined") return;
        if (source === false) {
            onSourceError();
            return;
        }
        onSourceSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        source
    ]);
    /**
     * Called when a document is read successfully
     */ function onLoadSuccess() {
        if (!pdf) // Impossible, but TypeScript doesn't know that
        return;
        if (onLoadSuccessProps) onLoadSuccessProps(pdf);
        pages.current = new Array(pdf.numPages);
        linkService.current.setDocument(pdf);
    }
    /**
     * Called when a document failed to read successfully
     */ function onLoadError() {
        if (!pdfError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(false, pdfError.toString());
        if (onLoadErrorProps) onLoadErrorProps(pdfError);
    }
    function resetDocument() {
        pdfDispatch({
            type: "RESET"
        });
    }
    (0, $17VE6.useEffect)(resetDocument, [
        pdfDispatch,
        source
    ]);
    function loadDocument() {
        if (!source) return;
        var documentInitParams = options ? Object.assign(Object.assign({}, source), options) : source;
        var destroyable = (0, $60b77cc7ba7556cf$export$2e2bcd8739ae039).getDocument(documentInitParams);
        if (onLoadProgress) destroyable.onProgress = onLoadProgress;
        if (onPassword) destroyable.onPassword = onPassword;
        var loadingTask = destroyable;
        loadingTask.promise.then(function(nextPdf) {
            pdfDispatch({
                type: "RESOLVE",
                value: nextPdf
            });
        }).catch(function(error) {
            if (loadingTask.destroyed) return;
            pdfDispatch({
                type: "REJECT",
                error: error
            });
        });
        return function() {
            loadingTask.destroy();
        };
    }
    (0, $17VE6.useEffect)(loadDocument, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        options,
        pdfDispatch,
        source
    ]);
    (0, $17VE6.useEffect)(function() {
        if (typeof pdf === "undefined") return;
        if (pdf === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        pdf
    ]);
    function setupLinkService() {
        linkService.current.setViewer(viewer.current);
        linkService.current.setExternalLinkRel(externalLinkRel);
        linkService.current.setExternalLinkTarget(externalLinkTarget);
    }
    (0, $17VE6.useEffect)(setupLinkService, [
        externalLinkRel,
        externalLinkTarget
    ]);
    function registerPage(pageIndex, ref) {
        pages.current[pageIndex] = ref;
    }
    function unregisterPage(pageIndex) {
        delete pages.current[pageIndex];
    }
    var childContext = (0, $17VE6.useMemo)(function() {
        return {
            imageResourcesPath: imageResourcesPath,
            linkService: linkService.current,
            onItemClick: onItemClick,
            pdf: pdf,
            registerPage: registerPage,
            renderMode: renderMode,
            rotate: rotate,
            unregisterPage: unregisterPage
        };
    }, [
        imageResourcesPath,
        onItemClick,
        pdf,
        renderMode,
        rotate
    ]);
    var _$eventProps = (0, $17VE6.useMemo)(function() {
        return (0, $3fb715c8242b9f15$export$2e2bcd8739ae039)(otherProps, function() {
            return pdf;
        });
    }, [
        otherProps,
        pdf
    ]);
    function renderChildren() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $edc808c79701ea35$export$2e2bcd8739ae039).Provider, {
            value: childContext
        }, children);
    }
    function renderContent() {
        if (!file) return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $64a6721c4e4a20e2$export$2e2bcd8739ae039), {
            type: "no-data"
        }, typeof noData === "function" ? noData() : noData);
        if (pdf === undefined || pdf === null) return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $64a6721c4e4a20e2$export$2e2bcd8739ae039), {
            type: "loading"
        }, typeof loading === "function" ? loading() : loading);
        if (pdf === false) return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $64a6721c4e4a20e2$export$2e2bcd8739ae039), {
            type: "error"
        }, typeof error === "function" ? error() : error);
        return renderChildren();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("div", Object.assign({
        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("react-pdf__Document", className),
        ref: inputRef,
        style: (0, $iCQyW._)({}, "--scale-factor", "1")
    }, _$eventProps), renderContent());
});
var $262be8f2403ec17e$var$isFunctionOrNode = (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).node
]);
$262be8f2403ec17e$var$Document.propTypes = Object.assign(Object.assign({}, (0, $fc608904b0e9bd41$export$1e08905474334888)), {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).node,
    className: (0, $fc608904b0e9bd41$export$d53f3db2f43345df),
    error: $262be8f2403ec17e$var$isFunctionOrNode,
    externalLinkRel: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string,
    externalLinkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOf([
        "_self",
        "_blank",
        "_parent",
        "_top"
    ]),
    file: (0, $fc608904b0e9bd41$export$be78b3111c50efdd),
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string,
    inputRef: (0, $fc608904b0e9bd41$export$4f9f5282de18fc69),
    loading: $262be8f2403ec17e$var$isFunctionOrNode,
    noData: $262be8f2403ec17e$var$isFunctionOrNode,
    onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    onLoadProgress: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    onPassword: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    onSourceError: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    onSourceSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).shape({
        canvasFactory: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).any,
        canvasMaxAreaInBytes: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).number,
        cMapPacked: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
        CMapReaderFactory: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).any,
        cMapUrl: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string,
        disableAutoFetch: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
        disableFontFace: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
        disableRange: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
        disableStream: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
        docBaseUrl: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string,
        enableXfa: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
        filterFactory: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).any,
        fontExtraProperties: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
        httpHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).object,
        isEvalSupported: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
        isOffscreenCanvasSupported: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
        length: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).number,
        maxImageSize: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).number,
        ownerDocument: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).any,
        password: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string,
        pdfBug: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
        rangeChunkSize: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).number,
        StandardFontDataFactory: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).any,
        standardFontDataUrl: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string,
        stopAtErrors: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
        useSystemFonts: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
        useWorkerFetch: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
        verbosity: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).number,
        withCredentials: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
        worker: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).any
    }),
    rotate: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).number
});
var $262be8f2403ec17e$export$2e2bcd8739ae039 = $262be8f2403ec17e$var$Document;


var $iCQyW = parcelRequire("iCQyW");

var $52tJv = parcelRequire("52tJv");

var $17VE6 = parcelRequire("17VE6");

var $51RYA = parcelRequire("51RYA");



/**
 * A function that merges React refs into one.
 * Supports both functions and ref objects created using createRef() and useRef().
 *
 * Usage:
 * ```tsx
 * <div ref={mergeRefs(ref1, ref2, ref3)} />
 * ```
 *
 * @param {(React.Ref<T> | undefined)[]} inputRefs Array of refs
 * @returns {React.Ref<T> | React.RefCallback<T>} Merged refs
 */ function $8244e4c3cb207d50$export$2e2bcd8739ae039() {
    var inputRefs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputRefs[_i] = arguments[_i];
    var filteredInputRefs = inputRefs.filter(Boolean);
    if (filteredInputRefs.length <= 1) {
        var firstRef = filteredInputRefs[0];
        return firstRef || null;
    }
    return function mergedRefs(ref) {
        filteredInputRefs.forEach(function(inputRef) {
            if (typeof inputRef === "function") inputRef(ref);
            else if (inputRef) inputRef.current = ref;
        });
    };
}





var $17VE6 = parcelRequire("17VE6");
"use client";
var $db3d4292dfcddbeb$export$2e2bcd8739ae039 = (0, $17VE6.createContext)(null);




var $17VE6 = parcelRequire("17VE6");





var $52tJv = parcelRequire("52tJv");

var $17VE6 = parcelRequire("17VE6");




var $17VE6 = parcelRequire("17VE6");

var $52tJv = parcelRequire("52tJv");
// From pdfjs-dist/lib/web/struct_tree_layer_builder.js
var $8131a7e3323848f9$export$789cd800273ee71a = {
    // Document level structure types
    Document: null,
    DocumentFragment: null,
    // Grouping level structure types
    Part: "group",
    Sect: "group",
    Div: "group",
    Aside: "note",
    NonStruct: "none",
    // Block level structure types
    P: null,
    // H<n>,
    H: "heading",
    Title: null,
    FENote: "note",
    // Sub-block level structure type
    Sub: "group",
    // General inline level structure types
    Lbl: null,
    Span: null,
    Em: null,
    Strong: null,
    Link: "link",
    Annot: "note",
    Form: "form",
    // Ruby and Warichu structure types
    Ruby: null,
    RB: null,
    RT: null,
    RP: null,
    Warichu: null,
    WT: null,
    WP: null,
    // List standard structure types
    L: "list",
    LI: "listitem",
    LBody: null,
    // Table standard structure types
    Table: "table",
    TR: "row",
    TH: "columnheader",
    TD: "cell",
    THead: "columnheader",
    TBody: null,
    TFoot: null,
    // Standard structure type Caption
    Caption: null,
    // Standard structure type Figure
    Figure: "figure",
    // Standard structure type Formula
    Formula: null,
    // standard structure type Artifact
    Artifact: null
};
var $8131a7e3323848f9$export$4921bbe0701579e4 = /^H(\d+)$/;


function $6b15b056db5012c9$export$80a007e7cc9dad0d(role) {
    return role in (0, $8131a7e3323848f9$export$789cd800273ee71a);
}
function $6b15b056db5012c9$export$9eeaf208d22fae4f(node) {
    return "children" in node;
}
function $6b15b056db5012c9$export$3b7840712ba182f3(node) {
    if (!$6b15b056db5012c9$export$9eeaf208d22fae4f(node)) return false;
    return node.children.length === 1 && 0 in node.children && "id" in node.children[0];
}
function $6b15b056db5012c9$export$aa440a09c67191c2(node) {
    var attributes = {};
    if ($6b15b056db5012c9$export$9eeaf208d22fae4f(node)) {
        var role = node.role;
        var matches = role.match((0, $8131a7e3323848f9$export$4921bbe0701579e4));
        if (matches) {
            attributes.role = "heading";
            attributes["aria-level"] = Number(matches[1]);
        } else if ($6b15b056db5012c9$export$80a007e7cc9dad0d(role)) {
            var htmlRole = (0, $8131a7e3323848f9$export$789cd800273ee71a)[role];
            if (htmlRole) attributes.role = htmlRole;
        }
    }
    return attributes;
}
function $6b15b056db5012c9$export$e86e6c9c68c5154c(node) {
    var attributes = {};
    if ($6b15b056db5012c9$export$9eeaf208d22fae4f(node)) {
        if (node.alt !== undefined) attributes["aria-label"] = node.alt;
        if (node.lang !== undefined) attributes.lang = node.lang;
        if ($6b15b056db5012c9$export$3b7840712ba182f3(node)) {
            var _node_children = (0, $52tJv._)(node.children, 1), child = _node_children[0];
            if (child) {
                var childAttributes = $6b15b056db5012c9$export$e86e6c9c68c5154c(child);
                return Object.assign(Object.assign({}, attributes), childAttributes);
            }
        }
    } else if ("id" in node) attributes["aria-owns"] = node.id;
    return attributes;
}
function $6b15b056db5012c9$export$fe94072fee8a6976(node) {
    if (!node) return null;
    return Object.assign(Object.assign({}, $6b15b056db5012c9$export$aa440a09c67191c2(node)), $6b15b056db5012c9$export$e86e6c9c68c5154c(node));
}


function $ba0f43553a32fa36$export$2e2bcd8739ae039(param) {
    var className = param.className, node = param.node;
    var attributes = (0, $17VE6.useMemo)(function() {
        return (0, $6b15b056db5012c9$export$fe94072fee8a6976)(node);
    }, [
        node
    ]);
    var children = (0, $17VE6.useMemo)(function() {
        if (!(0, $6b15b056db5012c9$export$9eeaf208d22fae4f)(node)) return null;
        if ((0, $6b15b056db5012c9$export$3b7840712ba182f3)(node)) return null;
        return node.children.map(function(child, index) {
            return(// eslint-disable-next-line react/no-array-index-key
            (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement($ba0f43553a32fa36$export$2e2bcd8739ae039, {
                key: index,
                node: child
            }));
        });
    }, [
        node
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("span", Object.assign({
        className: className
    }, attributes), children);
}



var $17VE6 = parcelRequire("17VE6");

function $fe3e3f21898ca54e$export$2e2bcd8739ae039() {
    return (0, $17VE6.useContext)((0, $db3d4292dfcddbeb$export$2e2bcd8739ae039));
}




function $190e8b44167c1a23$export$2e2bcd8739ae039() {
    var pageContext = (0, $fe3e3f21898ca54e$export$2e2bcd8739ae039)();
    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    var onGetStructTreeErrorProps = pageContext.onGetStructTreeError, onGetStructTreeSuccessProps = pageContext.onGetStructTreeSuccess;
    var _useResolver = (0, $52tJv._)((0, $cdec58f753f8259b$export$2e2bcd8739ae039)(), 2), structTreeState = _useResolver[0], structTreeDispatch = _useResolver[1];
    var structTree = structTreeState.value, structTreeError = structTreeState.error;
    var customTextRenderer = pageContext.customTextRenderer, page = pageContext.page;
    function onLoadSuccess() {
        if (!structTree) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetStructTreeSuccessProps) onGetStructTreeSuccessProps(structTree);
    }
    function onLoadError() {
        if (!structTreeError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(false, structTreeError.toString());
        if (onGetStructTreeErrorProps) onGetStructTreeErrorProps(structTreeError);
    }
    function resetAnnotations() {
        structTreeDispatch({
            type: "RESET"
        });
    }
    (0, $17VE6.useEffect)(resetAnnotations, [
        structTreeDispatch,
        page
    ]);
    function loadStructTree() {
        if (customTextRenderer) // TODO: Document why this is necessary
        return;
        if (!page) return;
        var cancellable = (0, $c6cc3944041b35b4$export$2e2bcd8739ae039)(page.getStructTree());
        var runningTask = cancellable;
        cancellable.promise.then(function(nextStructTree) {
            structTreeDispatch({
                type: "RESOLVE",
                value: nextStructTree
            });
        }).catch(function(error) {
            structTreeDispatch({
                type: "REJECT",
                error: error
            });
        });
        return function() {
            return (0, $d7d31a0ec2d25666$export$b8c3f1dffc289352)(runningTask);
        };
    }
    (0, $17VE6.useEffect)(loadStructTree, [
        customTextRenderer,
        page,
        structTreeDispatch
    ]);
    (0, $17VE6.useEffect)(function() {
        if (structTree === undefined) return;
        if (structTree === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        structTree
    ]);
    if (!structTree) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $ba0f43553a32fa36$export$2e2bcd8739ae039), {
        className: "react-pdf__Page__structTree structTree",
        node: structTree
    });
}




"use client";
var $364bda6f52638522$var$ANNOTATION_MODE = (0, $60b77cc7ba7556cf$export$2e2bcd8739ae039).AnnotationMode;
function $364bda6f52638522$export$2e2bcd8739ae039(props) {
    var pageContext = (0, $fe3e3f21898ca54e$export$2e2bcd8739ae039)();
    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    var mergedProps = Object.assign(Object.assign({}, pageContext), props);
    var _className = mergedProps._className, canvasBackground = mergedProps.canvasBackground, _mergedProps_devicePixelRatio = mergedProps.devicePixelRatio, devicePixelRatio = _mergedProps_devicePixelRatio === void 0 ? (0, $d7d31a0ec2d25666$export$cf4a949e5ad681d)() : _mergedProps_devicePixelRatio, onRenderErrorProps = mergedProps.onRenderError, onRenderSuccessProps = mergedProps.onRenderSuccess, page = mergedProps.page, renderForms = mergedProps.renderForms, renderTextLayer = mergedProps.renderTextLayer, rotate = mergedProps.rotate, scale = mergedProps.scale;
    var canvasRef = props.canvasRef;
    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(page, "Attempted to render page canvas, but no page was specified.");
    var canvasElement = (0, $17VE6.useRef)(null);
    /**
     * Called when a page is rendered successfully.
     */ function onRenderSuccess() {
        if (!page) // Impossible, but TypeScript doesn't know that
        return;
        if (onRenderSuccessProps) onRenderSuccessProps((0, $d7d31a0ec2d25666$export$8cc3f6b8d58bdda0)(page, scale));
    }
    /**
     * Called when a page fails to render.
     */ function onRenderError(error) {
        if ((0, $d7d31a0ec2d25666$export$99075c4d008e6ab1)(error)) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(false, error.toString());
        if (onRenderErrorProps) onRenderErrorProps(error);
    }
    var renderViewport = (0, $17VE6.useMemo)(function() {
        return page.getViewport({
            scale: scale * devicePixelRatio,
            rotation: rotate
        });
    }, [
        devicePixelRatio,
        page,
        rotate,
        scale
    ]);
    var viewport = (0, $17VE6.useMemo)(function() {
        return page.getViewport({
            scale: scale,
            rotation: rotate
        });
    }, [
        page,
        rotate,
        scale
    ]);
    function drawPageOnCanvas() {
        if (!page) return;
        // Ensures the canvas will be re-rendered from scratch. Otherwise all form data will stay.
        page.cleanup();
        var canvas = canvasElement.current;
        if (!canvas) return;
        canvas.width = renderViewport.width;
        canvas.height = renderViewport.height;
        canvas.style.width = "".concat(Math.floor(viewport.width), "px");
        canvas.style.height = "".concat(Math.floor(viewport.height), "px");
        canvas.style.visibility = "hidden";
        var renderContext = {
            annotationMode: renderForms ? $364bda6f52638522$var$ANNOTATION_MODE.ENABLE_FORMS : $364bda6f52638522$var$ANNOTATION_MODE.ENABLE,
            canvasContext: canvas.getContext("2d", {
                alpha: false
            }),
            viewport: renderViewport
        };
        if (canvasBackground) renderContext.background = canvasBackground;
        var cancellable = page.render(renderContext);
        var runningTask = cancellable;
        cancellable.promise.then(function() {
            canvas.style.visibility = "";
            onRenderSuccess();
        }).catch(onRenderError);
        return function() {
            return (0, $d7d31a0ec2d25666$export$b8c3f1dffc289352)(runningTask);
        };
    }
    (0, $17VE6.useEffect)(drawPageOnCanvas, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        canvasBackground,
        canvasElement,
        devicePixelRatio,
        page,
        renderForms,
        renderViewport,
        viewport
    ]);
    var cleanup = (0, $17VE6.useCallback)(function() {
        var canvas = canvasElement.current;
        /**
         * Zeroing the width and height cause most browsers to release graphics
         * resources immediately, which can greatly reduce memory consumption.
         */ if (canvas) {
            canvas.width = 0;
            canvas.height = 0;
        }
    }, [
        canvasElement
    ]);
    (0, $17VE6.useEffect)(function() {
        return cleanup;
    }, [
        cleanup
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("canvas", {
        className: "".concat(_className, "__canvas"),
        dir: "ltr",
        ref: (0, $8244e4c3cb207d50$export$2e2bcd8739ae039)(canvasRef, canvasElement),
        style: {
            display: "block",
            userSelect: "none"
        }
    }, renderTextLayer ? (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $190e8b44167c1a23$export$2e2bcd8739ae039), null) : null);
}



var $52tJv = parcelRequire("52tJv");

var $17VE6 = parcelRequire("17VE6");







function $a575a469d6b1384a$export$2e2bcd8739ae039() {
    var pageContext = (0, $fe3e3f21898ca54e$export$2e2bcd8739ae039)();
    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    var _className = pageContext._className, onRenderSuccessProps = pageContext.onRenderSuccess, onRenderErrorProps = pageContext.onRenderError, page = pageContext.page, rotate = pageContext.rotate, scale = pageContext.scale;
    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(page, "Attempted to render page SVG, but no page was specified.");
    var _useResolver = (0, $52tJv._)((0, $cdec58f753f8259b$export$2e2bcd8739ae039)(), 2), svgState = _useResolver[0], svgDispatch = _useResolver[1];
    var svg = svgState.value, svgError = svgState.error;
    /**
     * Called when a page is rendered successfully
     */ function onRenderSuccess() {
        if (!page) // Impossible, but TypeScript doesn't know that
        return;
        if (onRenderSuccessProps) onRenderSuccessProps((0, $d7d31a0ec2d25666$export$8cc3f6b8d58bdda0)(page, scale));
    }
    /**
     * Called when a page fails to render
     */ function onRenderError() {
        if (!svgError) // Impossible, but TypeScript doesn't know that
        return;
        if ((0, $d7d31a0ec2d25666$export$99075c4d008e6ab1)(svgError)) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(false, svgError.toString());
        if (onRenderErrorProps) onRenderErrorProps(svgError);
    }
    var viewport = (0, $17VE6.useMemo)(function() {
        return page.getViewport({
            scale: scale,
            rotation: rotate
        });
    }, [
        page,
        rotate,
        scale
    ]);
    function resetSVG() {
        svgDispatch({
            type: "RESET"
        });
    }
    (0, $17VE6.useEffect)(resetSVG, [
        page,
        svgDispatch,
        viewport
    ]);
    function renderSVG() {
        if (!page) return;
        var cancellable = (0, $c6cc3944041b35b4$export$2e2bcd8739ae039)(page.getOperatorList());
        cancellable.promise.then(function(operatorList) {
            var svgGfx = new (0, $60b77cc7ba7556cf$export$2e2bcd8739ae039).SVGGraphics(page.commonObjs, page.objs);
            svgGfx.getSVG(operatorList, viewport).then(function(nextSvg) {
                // See https://github.com/mozilla/pdf.js/issues/16745
                if (!(nextSvg instanceof SVGElement)) throw new Error("getSVG returned unexpected result.");
                svgDispatch({
                    type: "RESOLVE",
                    value: nextSvg
                });
            }).catch(function(error) {
                svgDispatch({
                    type: "REJECT",
                    error: error
                });
            });
        }).catch(function(error) {
            svgDispatch({
                type: "REJECT",
                error: error
            });
        });
        return function() {
            return (0, $d7d31a0ec2d25666$export$b8c3f1dffc289352)(cancellable);
        };
    }
    (0, $17VE6.useEffect)(renderSVG, [
        page,
        svgDispatch,
        viewport
    ]);
    (0, $17VE6.useEffect)(function() {
        if (svg === undefined) return;
        if (svg === false) {
            onRenderError();
            return;
        }
        onRenderSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        svg
    ]);
    function drawPageOnContainer(element) {
        if (!element || !svg) return;
        // Append SVG element to the main container, if this hasn't been done already
        if (!element.firstElementChild) element.appendChild(svg);
        var width = viewport.width, height = viewport.height;
        svg.setAttribute("width", "".concat(width));
        svg.setAttribute("height", "".concat(height));
    }
    var width = viewport.width, height = viewport.height;
    return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("div", {
        className: "".concat(_className, "__svg"),
        // Note: This cannot be shortened, as we need this function to be called with each render.
        ref: function(ref) {
            return drawPageOnContainer(ref);
        },
        style: {
            display: "block",
            backgroundColor: "white",
            overflow: "hidden",
            width: width,
            height: height,
            userSelect: "none"
        }
    });
}



var $52tJv = parcelRequire("52tJv");

var $17VE6 = parcelRequire("17VE6");








"use client";
function $c460024295812cdf$var$isTextItem(item) {
    return "str" in item;
}
function $c460024295812cdf$export$2e2bcd8739ae039() {
    var pageContext = (0, $fe3e3f21898ca54e$export$2e2bcd8739ae039)();
    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    var customTextRenderer = pageContext.customTextRenderer, onGetTextError = pageContext.onGetTextError, onGetTextSuccess = pageContext.onGetTextSuccess, onRenderTextLayerError = pageContext.onRenderTextLayerError, onRenderTextLayerSuccess = pageContext.onRenderTextLayerSuccess, page = pageContext.page, pageIndex = pageContext.pageIndex, pageNumber = pageContext.pageNumber, rotate = pageContext.rotate, scale = pageContext.scale;
    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(page, "Attempted to load page text content, but no page was specified.");
    var _useResolver = (0, $52tJv._)((0, $cdec58f753f8259b$export$2e2bcd8739ae039)(), 2), textContentState = _useResolver[0], textContentDispatch = _useResolver[1];
    var textContent = textContentState.value, textContentError = textContentState.error;
    var layerElement = (0, $17VE6.useRef)(null);
    var endElement = (0, $17VE6.useRef)();
    (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(parseInt(window.getComputedStyle(document.body).getPropertyValue("--react-pdf-text-layer"), 10) === 1, "TextLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-text-layer");
    /**
     * Called when a page text content is read successfully
     */ function onLoadSuccess() {
        if (!textContent) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetTextSuccess) onGetTextSuccess(textContent);
    }
    /**
     * Called when a page text content failed to read successfully
     */ function onLoadError() {
        if (!textContentError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(false, textContentError.toString());
        if (onGetTextError) onGetTextError(textContentError);
    }
    function resetTextContent() {
        textContentDispatch({
            type: "RESET"
        });
    }
    (0, $17VE6.useEffect)(resetTextContent, [
        page,
        textContentDispatch
    ]);
    function loadTextContent() {
        if (!page) return;
        var cancellable = (0, $c6cc3944041b35b4$export$2e2bcd8739ae039)(page.getTextContent());
        var runningTask = cancellable;
        cancellable.promise.then(function(nextTextContent) {
            textContentDispatch({
                type: "RESOLVE",
                value: nextTextContent
            });
        }).catch(function(error) {
            textContentDispatch({
                type: "REJECT",
                error: error
            });
        });
        return function() {
            return (0, $d7d31a0ec2d25666$export$b8c3f1dffc289352)(runningTask);
        };
    }
    (0, $17VE6.useEffect)(loadTextContent, [
        page,
        textContentDispatch
    ]);
    (0, $17VE6.useEffect)(function() {
        if (textContent === undefined) return;
        if (textContent === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        textContent
    ]);
    /**
     * Called when a text layer is rendered successfully
     */ var onRenderSuccess = (0, $17VE6.useCallback)(function() {
        if (onRenderTextLayerSuccess) onRenderTextLayerSuccess();
    }, [
        onRenderTextLayerSuccess
    ]);
    /**
     * Called when a text layer failed to render successfully
     */ var onRenderError = (0, $17VE6.useCallback)(function(error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(false, error.toString());
        if (onRenderTextLayerError) onRenderTextLayerError(error);
    }, [
        onRenderTextLayerError
    ]);
    function onMouseDown() {
        var end = endElement.current;
        if (!end) return;
        end.classList.add("active");
    }
    function onMouseUp() {
        var end = endElement.current;
        if (!end) return;
        end.classList.remove("active");
    }
    var viewport = (0, $17VE6.useMemo)(function() {
        return page.getViewport({
            scale: scale,
            rotation: rotate
        });
    }, [
        page,
        rotate,
        scale
    ]);
    function renderTextLayer() {
        if (!page || !textContent) return;
        var layer = layerElement.current;
        if (!layer) return;
        layer.innerHTML = "";
        var textContentSource = page.streamTextContent({
            includeMarkedContent: true
        });
        var parameters = {
            container: layer,
            textContentSource: textContentSource,
            viewport: viewport
        };
        var cancellable = (0, $60b77cc7ba7556cf$export$2e2bcd8739ae039).renderTextLayer(parameters);
        var runningTask = cancellable;
        cancellable.promise.then(function() {
            var end = document.createElement("div");
            end.className = "endOfContent";
            layer.append(end);
            endElement.current = end;
            var layerChildren = layer.querySelectorAll('[role="presentation"]');
            if (customTextRenderer) {
                var index = 0;
                textContent.items.forEach(function(item, itemIndex) {
                    if (!$c460024295812cdf$var$isTextItem(item)) return;
                    var child = layerChildren[index];
                    if (!child) return;
                    var content = customTextRenderer(Object.assign({
                        pageIndex: pageIndex,
                        pageNumber: pageNumber,
                        itemIndex: itemIndex
                    }, item));
                    child.innerHTML = content;
                    index += item.str && item.hasEOL ? 2 : 1;
                });
            }
            // Intentional immediate callback
            onRenderSuccess();
        }).catch(onRenderError);
        return function() {
            return (0, $d7d31a0ec2d25666$export$b8c3f1dffc289352)(runningTask);
        };
    }
    (0, $17VE6.useLayoutEffect)(renderTextLayer, [
        customTextRenderer,
        onRenderError,
        onRenderSuccess,
        page,
        pageIndex,
        pageNumber,
        textContent,
        viewport
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("div", {
        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("react-pdf__Page__textContent", "textLayer"),
        onMouseUp: onMouseUp,
        onMouseDown: onMouseDown,
        ref: layerElement
    }));
}



var $52tJv = parcelRequire("52tJv");

var $17VE6 = parcelRequire("17VE6");






var $17VE6 = parcelRequire("17VE6");

function $d52cfc0c7f9e4057$export$2e2bcd8739ae039() {
    return (0, $17VE6.useContext)((0, $edc808c79701ea35$export$2e2bcd8739ae039));
}





"use client";
function $fde94a5541d7f2fd$export$2e2bcd8739ae039() {
    var documentContext = (0, $d52cfc0c7f9e4057$export$2e2bcd8739ae039)();
    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(documentContext, "Unable to find Document context. Did you wrap <Page /> in <Document />?");
    var pageContext = (0, $fe3e3f21898ca54e$export$2e2bcd8739ae039)();
    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(pageContext, "Unable to find Page context.");
    var mergedProps = Object.assign(Object.assign({}, documentContext), pageContext);
    var imageResourcesPath = mergedProps.imageResourcesPath, linkService = mergedProps.linkService, onGetAnnotationsErrorProps = mergedProps.onGetAnnotationsError, onGetAnnotationsSuccessProps = mergedProps.onGetAnnotationsSuccess, onRenderAnnotationLayerErrorProps = mergedProps.onRenderAnnotationLayerError, onRenderAnnotationLayerSuccessProps = mergedProps.onRenderAnnotationLayerSuccess, page = mergedProps.page, pdf = mergedProps.pdf, renderForms = mergedProps.renderForms, rotate = mergedProps.rotate, _mergedProps_scale = mergedProps.scale, scale = _mergedProps_scale === void 0 ? 1 : _mergedProps_scale;
    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(page, "Attempted to load page annotations, but no page was specified.");
    var _useResolver = (0, $52tJv._)((0, $cdec58f753f8259b$export$2e2bcd8739ae039)(), 2), annotationsState = _useResolver[0], annotationsDispatch = _useResolver[1];
    var annotations = annotationsState.value, annotationsError = annotationsState.error;
    var layerElement = (0, $17VE6.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(parseInt(window.getComputedStyle(document.body).getPropertyValue("--react-pdf-annotation-layer"), 10) === 1, "AnnotationLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-annotations");
    function onLoadSuccess() {
        if (!annotations) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetAnnotationsSuccessProps) onGetAnnotationsSuccessProps(annotations);
    }
    function onLoadError() {
        if (!annotationsError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(false, annotationsError.toString());
        if (onGetAnnotationsErrorProps) onGetAnnotationsErrorProps(annotationsError);
    }
    function resetAnnotations() {
        annotationsDispatch({
            type: "RESET"
        });
    }
    (0, $17VE6.useEffect)(resetAnnotations, [
        annotationsDispatch,
        page
    ]);
    function loadAnnotations() {
        if (!page) return;
        var cancellable = (0, $c6cc3944041b35b4$export$2e2bcd8739ae039)(page.getAnnotations());
        var runningTask = cancellable;
        cancellable.promise.then(function(nextAnnotations) {
            annotationsDispatch({
                type: "RESOLVE",
                value: nextAnnotations
            });
        }).catch(function(error) {
            annotationsDispatch({
                type: "REJECT",
                error: error
            });
        });
        return function() {
            (0, $d7d31a0ec2d25666$export$b8c3f1dffc289352)(runningTask);
        };
    }
    (0, $17VE6.useEffect)(loadAnnotations, [
        annotationsDispatch,
        page,
        renderForms
    ]);
    (0, $17VE6.useEffect)(function() {
        if (annotations === undefined) return;
        if (annotations === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        annotations
    ]);
    function onRenderSuccess() {
        if (onRenderAnnotationLayerSuccessProps) onRenderAnnotationLayerSuccessProps();
    }
    function onRenderError(error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(false, "".concat(error));
        if (onRenderAnnotationLayerErrorProps) onRenderAnnotationLayerErrorProps(error);
    }
    var viewport = (0, $17VE6.useMemo)(function() {
        return page.getViewport({
            scale: scale,
            rotation: rotate
        });
    }, [
        page,
        rotate,
        scale
    ]);
    function renderAnnotationLayer() {
        if (!pdf || !page || !annotations) return;
        var layer = layerElement.current;
        if (!layer) return;
        var clonedViewport = viewport.clone({
            dontFlip: true
        });
        var annotationLayerParameters = {
            accessibilityManager: null,
            annotationCanvasMap: null,
            div: layer,
            l10n: null,
            page: page,
            viewport: clonedViewport
        };
        var renderParameters = {
            annotations: annotations,
            annotationStorage: pdf.annotationStorage,
            div: layer,
            // See https://github.com/mozilla/pdf.js/issues/17029
            downloadManager: null,
            imageResourcesPath: imageResourcesPath,
            linkService: linkService,
            page: page,
            renderForms: renderForms,
            viewport: clonedViewport
        };
        layer.innerHTML = "";
        try {
            new (0, $60b77cc7ba7556cf$export$2e2bcd8739ae039).AnnotationLayer(annotationLayerParameters).render(renderParameters);
            // Intentional immediate callback
            onRenderSuccess();
        } catch (error) {
            onRenderError(error);
        }
        return function() {
        // TODO: Cancel running task?
        };
    }
    (0, $17VE6.useEffect)(renderAnnotationLayer, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        annotations,
        imageResourcesPath,
        linkService,
        page,
        renderForms,
        viewport
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("div", {
        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)("react-pdf__Page__annotations", "annotationLayer"),
        ref: layerElement
    });
}






"use client";
var $31f66682bff1f8fc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $31f66682bff1f8fc$var$defaultScale = 1;
/**
 * Displays a page.
 *
 * Should be placed inside `<Document />`. Alternatively, it can have `pdf` prop passed, which can be obtained from `<Document />`'s `onLoadSuccess` callback function, however some advanced functions like linking between pages inside a document may not be working correctly.
 */ var $31f66682bff1f8fc$var$Page = function Page(props) {
    var documentContext = (0, $d52cfc0c7f9e4057$export$2e2bcd8739ae039)();
    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(documentContext, "Unable to find Document context. Did you wrap <Page /> in <Document />?");
    var mergedProps = Object.assign(Object.assign({}, documentContext), props);
    var _mergedProps__className = mergedProps._className, _className = _mergedProps__className === void 0 ? "react-pdf__Page" : _mergedProps__className, _mergedProps__enableRegisterUnregisterPage = mergedProps._enableRegisterUnregisterPage, _enableRegisterUnregisterPage = _mergedProps__enableRegisterUnregisterPage === void 0 ? true : _mergedProps__enableRegisterUnregisterPage, canvasBackground = mergedProps.canvasBackground, canvasRef = mergedProps.canvasRef, children = mergedProps.children, className = mergedProps.className, CustomRenderer = mergedProps.customRenderer, customTextRenderer = mergedProps.customTextRenderer, devicePixelRatio = mergedProps.devicePixelRatio, _mergedProps_error = mergedProps.error, error = _mergedProps_error === void 0 ? "Failed to load the page." : _mergedProps_error, height = mergedProps.height, inputRef = mergedProps.inputRef, _mergedProps_loading = mergedProps.loading, loading = _mergedProps_loading === void 0 ? "Loading page\u2026" : _mergedProps_loading, _mergedProps_noData = mergedProps.noData, noData = _mergedProps_noData === void 0 ? "No page specified." : _mergedProps_noData, onGetAnnotationsErrorProps = mergedProps.onGetAnnotationsError, onGetAnnotationsSuccessProps = mergedProps.onGetAnnotationsSuccess, onGetStructTreeErrorProps = mergedProps.onGetStructTreeError, onGetStructTreeSuccessProps = mergedProps.onGetStructTreeSuccess, onGetTextErrorProps = mergedProps.onGetTextError, onGetTextSuccessProps = mergedProps.onGetTextSuccess, onLoadErrorProps = mergedProps.onLoadError, onLoadSuccessProps = mergedProps.onLoadSuccess, onRenderAnnotationLayerErrorProps = mergedProps.onRenderAnnotationLayerError, onRenderAnnotationLayerSuccessProps = mergedProps.onRenderAnnotationLayerSuccess, onRenderErrorProps = mergedProps.onRenderError, onRenderSuccessProps = mergedProps.onRenderSuccess, onRenderTextLayerErrorProps = mergedProps.onRenderTextLayerError, onRenderTextLayerSuccessProps = mergedProps.onRenderTextLayerSuccess, pageIndexProps = mergedProps.pageIndex, pageNumberProps = mergedProps.pageNumber, pdf = mergedProps.pdf, registerPage = mergedProps.registerPage, tmp = mergedProps.renderAnnotationLayer, renderAnnotationLayerProps = tmp === void 0 ? true : tmp, _mergedProps_renderForms = mergedProps.renderForms, renderForms = _mergedProps_renderForms === void 0 ? false : _mergedProps_renderForms, _mergedProps_renderMode = mergedProps.renderMode, renderMode = _mergedProps_renderMode === void 0 ? "canvas" : _mergedProps_renderMode, tmp1 = mergedProps.renderTextLayer, renderTextLayerProps = tmp1 === void 0 ? true : tmp1, rotateProps = mergedProps.rotate, tmp2 = mergedProps.scale, scaleProps = tmp2 === void 0 ? $31f66682bff1f8fc$var$defaultScale : tmp2, unregisterPage = mergedProps.unregisterPage, width = mergedProps.width, otherProps = $31f66682bff1f8fc$var$__rest(mergedProps, [
        "_className",
        "_enableRegisterUnregisterPage",
        "canvasBackground",
        "canvasRef",
        "children",
        "className",
        "customRenderer",
        "customTextRenderer",
        "devicePixelRatio",
        "error",
        "height",
        "inputRef",
        "loading",
        "noData",
        "onGetAnnotationsError",
        "onGetAnnotationsSuccess",
        "onGetStructTreeError",
        "onGetStructTreeSuccess",
        "onGetTextError",
        "onGetTextSuccess",
        "onLoadError",
        "onLoadSuccess",
        "onRenderAnnotationLayerError",
        "onRenderAnnotationLayerSuccess",
        "onRenderError",
        "onRenderSuccess",
        "onRenderTextLayerError",
        "onRenderTextLayerSuccess",
        "pageIndex",
        "pageNumber",
        "pdf",
        "registerPage",
        "renderAnnotationLayer",
        "renderForms",
        "renderMode",
        "renderTextLayer",
        "rotate",
        "scale",
        "unregisterPage",
        "width"
    ]);
    var _useResolver = (0, $52tJv._)((0, $cdec58f753f8259b$export$2e2bcd8739ae039)(), 2), pageState = _useResolver[0], pageDispatch = _useResolver[1];
    var page = pageState.value, pageError = pageState.error;
    var pageElement = (0, $17VE6.useRef)(null);
    (0, $986f3a016cffd215$export$2e2bcd8739ae039)(pdf, "Attempted to load a page, but no document was specified.");
    var pageIndex = (0, $d7d31a0ec2d25666$export$ef8866826b0b1f6d)(pageNumberProps) ? pageNumberProps - 1 : pageIndexProps !== null && pageIndexProps !== void 0 ? pageIndexProps : null;
    var pageNumber = pageNumberProps !== null && pageNumberProps !== void 0 ? pageNumberProps : (0, $d7d31a0ec2d25666$export$ef8866826b0b1f6d)(pageIndexProps) ? pageIndexProps + 1 : null;
    var rotate = rotateProps !== null && rotateProps !== void 0 ? rotateProps : page ? page.rotate : null;
    var scale = (0, $17VE6.useMemo)(function() {
        if (!page) return null;
        // Be default, we'll render page at 100% * scale width.
        var pageScale = 1;
        // Passing scale explicitly null would cause the page not to render
        var scaleWithDefault = scaleProps !== null && scaleProps !== void 0 ? scaleProps : $31f66682bff1f8fc$var$defaultScale;
        // If width/height is defined, calculate the scale of the page so it could be of desired width.
        if (width || height) {
            var viewport = page.getViewport({
                scale: 1,
                rotation: rotate
            });
            if (width) pageScale = width / viewport.width;
            else if (height) pageScale = height / viewport.height;
        }
        return scaleWithDefault * pageScale;
    }, [
        height,
        page,
        rotate,
        scaleProps,
        width
    ]);
    function hook() {
        return function() {
            if (!(0, $d7d31a0ec2d25666$export$ef8866826b0b1f6d)(pageIndex)) // Impossible, but TypeScript doesn't know that
            return;
            if (_enableRegisterUnregisterPage && unregisterPage) unregisterPage(pageIndex);
        };
    }
    (0, $17VE6.useEffect)(hook, [
        _enableRegisterUnregisterPage,
        pdf,
        pageIndex,
        unregisterPage
    ]);
    /**
     * Called when a page is loaded successfully
     */ function onLoadSuccess() {
        if (onLoadSuccessProps) {
            if (!page || !scale) // Impossible, but TypeScript doesn't know that
            return;
            onLoadSuccessProps((0, $d7d31a0ec2d25666$export$8cc3f6b8d58bdda0)(page, scale));
        }
        if (_enableRegisterUnregisterPage && registerPage) {
            if (!(0, $d7d31a0ec2d25666$export$ef8866826b0b1f6d)(pageIndex) || !pageElement.current) // Impossible, but TypeScript doesn't know that
            return;
            registerPage(pageIndex, pageElement.current);
        }
    }
    /**
     * Called when a page failed to load
     */ function onLoadError() {
        if (!pageError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($6a34d81ce2b9929e$exports)))(false, pageError.toString());
        if (onLoadErrorProps) onLoadErrorProps(pageError);
    }
    function resetPage() {
        pageDispatch({
            type: "RESET"
        });
    }
    (0, $17VE6.useEffect)(resetPage, [
        pageDispatch,
        pdf,
        pageIndex
    ]);
    function loadPage() {
        if (!pdf || !pageNumber) return;
        var cancellable = (0, $c6cc3944041b35b4$export$2e2bcd8739ae039)(pdf.getPage(pageNumber));
        var runningTask = cancellable;
        cancellable.promise.then(function(nextPage) {
            pageDispatch({
                type: "RESOLVE",
                value: nextPage
            });
        }).catch(function(error) {
            pageDispatch({
                type: "REJECT",
                error: error
            });
        });
        return function() {
            return (0, $d7d31a0ec2d25666$export$b8c3f1dffc289352)(runningTask);
        };
    }
    (0, $17VE6.useEffect)(loadPage, [
        pageDispatch,
        pdf,
        pageIndex,
        pageNumber,
        registerPage
    ]);
    (0, $17VE6.useEffect)(function() {
        if (page === undefined) return;
        if (page === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        page,
        scale
    ]);
    var childContext = (0, $17VE6.useMemo)(function() {
        return(// Technically there cannot be page without pageIndex, pageNumber, rotate and scale, but TypeScript doesn't know that
        page && (0, $d7d31a0ec2d25666$export$ef8866826b0b1f6d)(pageIndex) && pageNumber && (0, $d7d31a0ec2d25666$export$ef8866826b0b1f6d)(rotate) && (0, $d7d31a0ec2d25666$export$ef8866826b0b1f6d)(scale) ? {
            _className: _className,
            canvasBackground: canvasBackground,
            customTextRenderer: customTextRenderer,
            devicePixelRatio: devicePixelRatio,
            onGetAnnotationsError: onGetAnnotationsErrorProps,
            onGetAnnotationsSuccess: onGetAnnotationsSuccessProps,
            onGetStructTreeError: onGetStructTreeErrorProps,
            onGetStructTreeSuccess: onGetStructTreeSuccessProps,
            onGetTextError: onGetTextErrorProps,
            onGetTextSuccess: onGetTextSuccessProps,
            onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps,
            onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps,
            onRenderError: onRenderErrorProps,
            onRenderSuccess: onRenderSuccessProps,
            onRenderTextLayerError: onRenderTextLayerErrorProps,
            onRenderTextLayerSuccess: onRenderTextLayerSuccessProps,
            page: page,
            pageIndex: pageIndex,
            pageNumber: pageNumber,
            renderForms: renderForms,
            renderTextLayer: renderTextLayerProps,
            rotate: rotate,
            scale: scale
        } : null);
    }, [
        _className,
        canvasBackground,
        customTextRenderer,
        devicePixelRatio,
        onGetAnnotationsErrorProps,
        onGetAnnotationsSuccessProps,
        onGetStructTreeErrorProps,
        onGetStructTreeSuccessProps,
        onGetTextErrorProps,
        onGetTextSuccessProps,
        onRenderAnnotationLayerErrorProps,
        onRenderAnnotationLayerSuccessProps,
        onRenderErrorProps,
        onRenderSuccessProps,
        onRenderTextLayerErrorProps,
        onRenderTextLayerSuccessProps,
        page,
        pageIndex,
        pageNumber,
        renderForms,
        renderTextLayerProps,
        rotate,
        scale
    ]);
    var _$eventProps = (0, $17VE6.useMemo)(function() {
        return (0, $3fb715c8242b9f15$export$2e2bcd8739ae039)(otherProps, function() {
            return page ? scale ? (0, $d7d31a0ec2d25666$export$8cc3f6b8d58bdda0)(page, scale) : undefined : page;
        });
    }, [
        otherProps,
        page,
        scale
    ]);
    var pageKey = "".concat(pageIndex, "@").concat(scale, "/").concat(rotate);
    var pageKeyNoScale = "".concat(pageIndex, "/").concat(rotate);
    function renderMainLayer() {
        switch(renderMode){
            case "custom":
                (0, $986f3a016cffd215$export$2e2bcd8739ae039)(CustomRenderer, 'renderMode was set to "custom", but no customRenderer was passed.');
                return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement(CustomRenderer, {
                    key: "".concat(pageKey, "_custom")
                });
            case "none":
                return null;
            case "svg":
                return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $a575a469d6b1384a$export$2e2bcd8739ae039), {
                    key: "".concat(pageKeyNoScale, "_svg")
                });
            case "canvas":
            default:
                return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $364bda6f52638522$export$2e2bcd8739ae039), {
                    key: "".concat(pageKey, "_canvas"),
                    canvasRef: canvasRef
                });
        }
    }
    function renderTextLayer() {
        if (!renderTextLayerProps) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $c460024295812cdf$export$2e2bcd8739ae039), {
            key: "".concat(pageKey, "_text")
        });
    }
    function renderAnnotationLayer() {
        if (!renderAnnotationLayerProps) return null;
        /**
         * As of now, PDF.js 2.0.943 returns warnings on unimplemented annotations in SVG mode.
         * Therefore, as a fallback, we render "traditional" AnnotationLayer component.
         */ return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $fde94a5541d7f2fd$export$2e2bcd8739ae039), {
            key: "".concat(pageKey, "_annotations")
        });
    }
    function renderChildren() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $db3d4292dfcddbeb$export$2e2bcd8739ae039).Provider, {
            value: childContext
        }, renderMainLayer(), renderTextLayer(), renderAnnotationLayer(), children);
    }
    function renderContent() {
        if (!pageNumber) return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $64a6721c4e4a20e2$export$2e2bcd8739ae039), {
            type: "no-data"
        }, typeof noData === "function" ? noData() : noData);
        if (pdf === null || page === undefined || page === null) return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $64a6721c4e4a20e2$export$2e2bcd8739ae039), {
            type: "loading"
        }, typeof loading === "function" ? loading() : loading);
        if (pdf === false || page === false) return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement((0, $64a6721c4e4a20e2$export$2e2bcd8739ae039), {
            type: "error"
        }, typeof error === "function" ? error() : error);
        return renderChildren();
    }
    var _obj;
    return (0, (/*@__PURE__*/$parcel$interopDefault($17VE6))).createElement("div", Object.assign({
        className: (0, $7f344446f1cbebc3$export$2e2bcd8739ae039)(_className, className),
        "data-page-number": pageNumber,
        ref: (0, $8244e4c3cb207d50$export$2e2bcd8739ae039)(inputRef, pageElement),
        style: (_obj = {}, (0, $iCQyW._)(_obj, "--scale-factor", "".concat(scale)), (0, $iCQyW._)(_obj, "backgroundColor", canvasBackground || "white"), (0, $iCQyW._)(_obj, "position", "relative"), (0, $iCQyW._)(_obj, "minWidth", "min-content"), (0, $iCQyW._)(_obj, "minHeight", "min-content"), _obj)
    }, _$eventProps), renderContent());
};
var $31f66682bff1f8fc$var$isFunctionOrNode = (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).node
]);
$31f66682bff1f8fc$var$Page.propTypes = Object.assign(Object.assign({}, (0, $fc608904b0e9bd41$export$1e08905474334888)), {
    canvasBackground: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string,
    canvasRef: (0, $fc608904b0e9bd41$export$4f9f5282de18fc69),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).node,
    className: (0, $fc608904b0e9bd41$export$d53f3db2f43345df),
    customRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    customTextRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    devicePixelRatio: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).number,
    error: $31f66682bff1f8fc$var$isFunctionOrNode,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).number,
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).string,
    inputRef: (0, $fc608904b0e9bd41$export$4f9f5282de18fc69),
    loading: $31f66682bff1f8fc$var$isFunctionOrNode,
    noData: $31f66682bff1f8fc$var$isFunctionOrNode,
    onGetTextError: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    onGetTextSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    onRenderError: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    onRenderSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    onRenderTextLayerError: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    onRenderTextLayerSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).func,
    pageIndex: (0, $fc608904b0e9bd41$export$7b4c8bd6e6871332),
    pageNumber: (0, $fc608904b0e9bd41$export$973e710208ddd50f),
    pdf: (0, $fc608904b0e9bd41$export$d22001c6ab8dd37),
    renderAnnotationLayer: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
    renderForms: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
    renderMode: (0, $fc608904b0e9bd41$export$70f0c3edbd58f82c),
    renderTextLayer: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).bool,
    rotate: (0, $fc608904b0e9bd41$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).number,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($51RYA))).number
});
var $31f66682bff1f8fc$export$2e2bcd8739ae039 = $31f66682bff1f8fc$var$Page;











(0, $d7d31a0ec2d25666$export$e7ec4a9e2d586a77)();
(0, $60b77cc7ba7556cf$export$2e2bcd8739ae039).GlobalWorkerOptions.workerSrc = "pdf.worker.js";




var $d61d4e53d2ce7150$exports = {};

$d61d4e53d2ce7150$exports = (parcelRequire("cEHVf")).getBundleURL("cF0cK") + "pdf.worker.min.16d764dc.js";


(0, $60b77cc7ba7556cf$export$2e2bcd8739ae039).GlobalWorkerOptions.workerSrc = new URL($d61d4e53d2ce7150$exports).toString();
var $9ef14a9ba7c8350a$var$INITIAL_STATE = {
    status: "initial",
    files: [],
    tasks: [],
    task: undefined,
    outputFiles: []
};
function $9ef14a9ba7c8350a$var$renderTaskOutputFileLink(file) {
    var loginInformation = (0, $d426a3f2c6fbebd8$export$9aa0815bbb7f01f0).getLoginInformation();
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("a", {
        href: "/api/v2/storage/".concat(file.id, "?jwt=").concat(loginInformation.jwt),
        target: "_blank",
        children: file.name
    });
}
// function renderOutputFiles2(files: TaskOutputFileDto[] | undefined) {
//     if (!files) {
//         return null;
//     }
//     return <ul>
//         {files.map(f => <li key={f.id}>{renderTaskOutputFileLink(f)}</li>)}
//     </ul>
// }
function $9ef14a9ba7c8350a$var$renderTaskOutputFilePdf(file) {
    var loginInformation = (0, $d426a3f2c6fbebd8$export$9aa0815bbb7f01f0).getLoginInformation();
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("span", {
        className: "card",
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                children: file.name
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $262be8f2403ec17e$export$2e2bcd8739ae039), {
                file: "/api/v2/storage/".concat(file.id, "?jwt=").concat(loginInformation.jwt),
                children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $31f66682bff1f8fc$export$2e2bcd8739ae039), {
                    pageNumber: 1
                })
            })
        ]
    }, file.id);
}
function $9ef14a9ba7c8350a$var$renderOutputFiles(files) {
    if (!files) return null;
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
        children: files.map(function(f) {
            return $9ef14a9ba7c8350a$var$renderTaskOutputFilePdf(f);
        })
    });
}
function $9ef14a9ba7c8350a$var$renderTaskList(tasks, onTaskClicked) {
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
            className: "card",
            style: {
                "width": " 100%"
            },
            children: [
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                    children: "Executions"
                }),
                /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("th", {
                                        children: "id"
                                    }),
                                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("th", {
                                        children: "Date"
                                    }),
                                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("th", {
                                        children: "Result"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("tbody", {
                            children: tasks.map(function(t) {
                                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("tr", {
                                    className: "clickable",
                                    onClick: function() {
                                        return onTaskClicked(t);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("td", {
                                            children: t.id
                                        }),
                                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("td", {
                                            children: t.creationDate.toLocaleString()
                                        }),
                                        /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("td", {
                                            children: t.status
                                        })
                                    ]
                                }, t.id);
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function $9ef14a9ba7c8350a$var$renderTaskResult(task, backToList) {
    if (!task) return null;
    var loginInformation = (0, $d426a3f2c6fbebd8$export$9aa0815bbb7f01f0).getLoginInformation();
    return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                className: "card",
                style: {
                    "width": " 100%"
                },
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                        children: "Processing results"
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                        children: [
                            "Task Id: ",
                            task.id
                        ]
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                        children: [
                            "Status: ",
                            task.status
                        ]
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                                    children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("a", {
                                        href: "/api/v2/storage/task/".concat(task.id, "?jwt=").concat(loginInformation.jwt),
                                        target: "_blank",
                                        children: "Download Zip"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                                    href: "#",
                                    onClick: backToList,
                                    children: "Back to the list"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                children: $9ef14a9ba7c8350a$var$renderOutputFiles(task.outputFiles)
            })
        ]
    });
}
function $9ef14a9ba7c8350a$export$3999c93ac52694ba(props) {
    var _useState = (0, $52tJv._)((0, $17VE6.useState)($9ef14a9ba7c8350a$var$INITIAL_STATE), 2), state = _useState[0], setState = _useState[1];
    //    const interval = state.status === 'started' ? 5000 : null;
    var interval = 2000;
    var tasksAsync = (0, $b61d063c6ac5efce$export$cdf1dc76b55502e3)({
        promiseFn: (0, $94375f0c99140c92$export$95a16b4a58010891)
    });
    if (tasksAsync.status === "fulfilled") {
        console.log("Got data, check if it changed");
        var tasks = tasksAsync.data;
        tasks.sort(function(a, b) {
            return b.creationDate.getTime() - a.creationDate.getTime();
        });
        if (state.tasks.length !== tasks.length) {
            console.log("Number of tasks changed from", tasks.length, "to", state.tasks.length);
            setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
                tasks: tasks
            }));
            return;
        }
        for(var i = 0; i < tasks.length; ++i)if (tasks[i].id !== state.tasks[i].id || tasks[i].status !== state.tasks[i].status) {
            console.log(tasks[i].id, tasks[i].status);
            setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
                tasks: tasks
            }));
            break;
        }
    }
    (0, $17VE6.useEffect)(function() {
        var timer = setTimeout(function() {
            console.log("TIMER");
            if (tasksAsync.status === "fulfilled") {
                console.log("Task is", tasksAsync.status);
                if (tasksAsync.data.filter(function(t) {
                    return t.status == "started";
                }).length > 0) {
                    console.log("Checking for new data");
                    tasksAsync.reload();
                }
            }
            console.log("Forcing update");
            setState(function(s) {
                return (0, $lwFY2._)({}, s);
            });
        }, 1000);
        return function() {
            return clearTimeout(timer);
        };
    });
    // useInterval(async () => {
    //     console.log("INTERVAL");
    //     setState(s => { return {...s} ;});
    //     tasksAsync.reload();
    //     // if (tasksAsync.status == "fulfilled") {
    //     //     if (tasksAsync.data.filter(t => t.status == "started").length > 0) {
    //     //         tasksAsync.reload();
    //     //     }
    //     // }
    //     // if (state.task) {
    //     //     console.log("Checking task status");
    //     //     const task = await getTask(state.task.id);
    //     //     console.log("Task:", task);
    //     //     if (task.status !== state.status) {
    //     //         setState(state => {
    //     //             return {...state, status: task.status};
    //     //         })
    //     //     }
    //     // }
    // }, interval);
    function updateFileList(event) {
        var files = event.target.files || [];
        setState(function(state) {
            return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                files: (0, $fyztb._)(files)
            });
        });
        console.log(state);
    }
    function backToList() {
        setState(function(state) {
            return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                status: "initial"
            });
        });
    }
    function uploadFiles() {
        return _uploadFiles.apply(this, arguments);
    }
    function _uploadFiles() {
        _uploadFiles = (0, $7hBys._)(function() {
            var e;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, $94375f0c99140c92$export$616a7e2208f6895b)(state.files)
                        ];
                    case 1:
                        _state.sent();
                        tasksAsync.reload();
                        setState(function(state) {
                            return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                                status: "initial"
                            });
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        setState(function(state) {
                            return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                                status: "failed",
                                errorMessage: e.toString()
                            });
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _uploadFiles.apply(this, arguments);
    }
    function showTask(task) {
        setState(function(state) {
            return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                task: task,
                status: "showing"
            });
        });
    }
    switch(state.status){
        case "initial":
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("h1", {
                        children: "Data Analysis"
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                        children: [
                            "Upload the files the files to analyze.",
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("p", {}),
                            "You can either upload CSV files or a Zip file containing the CSVs",
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("p", {}),
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("input", {
                                type: "file",
                                name: "file",
                                accept: ".csv, .zip",
                                multiple: true,
                                onChange: updateFileList
                            }),
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("button", {
                                onClick: uploadFiles,
                                children: "Process"
                            }),
                            $9ef14a9ba7c8350a$var$renderTaskList(state.tasks, showTask)
                        ]
                    })
                ]
            });
        case "started":
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("h1", {
                        children: "Data Analysis"
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                        children: "Waiting for processing..."
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $ba001461d3497aae$export$7f7cbe89f1eacd2), {})
                ]
            });
        case "failed":
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("h1", {
                        children: "Data Analysis"
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("div", {
                        children: [
                            "Error occurred: ",
                            state.errorMessage
                        ]
                    })
                ]
            });
        case "completed":
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("h1", {
                        children: "Data Analysis"
                    }),
                    $9ef14a9ba7c8350a$var$renderTaskResult(state.task, backToList)
                ]
            });
        case "showing":
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("h1", {
                        children: "Data Analysis"
                    }),
                    $9ef14a9ba7c8350a$var$renderTaskResult(state.task, backToList)
                ]
            });
        default:
            return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("h1", {
                        children: "Data Analysis"
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
                        children: "Internal Error - Please contact administration"
                    })
                ]
            });
    }
}


function $e035fc650e643577$var$getCustomerSelector(customers, selectedCustomerId, onCustomerChanged) {
    var selectedCustomer = customers.find(function(c) {
        return c.id === selectedCustomerId;
    });
    if (customers.length === 1) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("li", {
        children: selectedCustomer === null || selectedCustomer === void 0 ? void 0 : selectedCustomer.description
    }, "customer-selector");
    else {
        var tree = (0, $6e638e6a04d37fe2$export$78878d36f2f215d)(customers);
        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("select", {
            value: selectedCustomerId,
            onChange: function(event) {
                return onCustomerChanged(event.target.value);
            },
            children: tree.map(function(c) {
                return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("option", {
                    value: c.id,
                    children: c.treeLabel
                }, c.id);
            })
        }, "customer-selector");
    }
}
function $e035fc650e643577$var$makeTopNavigation(customers, selectedCustomerId, onCustomerChanged) {
    return [
        {
            type: "entry",
            requiredRole: "user",
            description: "Map View",
            destination: "/"
        },
        {
            type: "entry",
            requiredRole: "user",
            description: "Dashboard",
            destination: "/dashboard"
        },
        {
            type: "entry",
            requiredRole: "admin",
            description: "Admin",
            destination: "/admin"
        },
        {
            type: "entry",
            requiredRole: "backoffice",
            description: "Backoffice",
            destination: "/backoffice"
        },
        {
            type: "entry",
            requiredRole: "analyst",
            description: "Data Analysis",
            destination: "/analysis"
        },
        {
            type: "spacer",
            id: "1"
        },
        {
            type: "element",
            element: $e035fc650e643577$var$getCustomerSelector(customers, selectedCustomerId, onCustomerChanged)
        },
        {
            type: "entry",
            requiredRole: undefined,
            description: "Logout",
            destination: "/logout"
        }
    ];
}
var $e035fc650e643577$var$App = function() {
    var _state_error;
    var _useState = (0, $52tJv._)((0, $17VE6.useState)((0, $e7dcbc6197905a97$export$d4c72bab9d6cc13a)()), 2), state = _useState[0], setState = _useState[1];
    var loginInformation = (0, $d426a3f2c6fbebd8$export$9aa0815bbb7f01f0).getLoginInformation();
    var customersAsync = (0, $b61d063c6ac5efce$export$cdf1dc76b55502e3)({
        promiseFn: function() {
            return (0, $6e638e6a04d37fe2$export$fbfdec3fcd74f506)(state.selectedCustomerId);
        },
        watch: loginInformation === null || loginInformation === void 0 ? void 0 : loginInformation.username,
        waitChange: true
    });
    function login(username, password) {
        return _login.apply(this, arguments);
    }
    function _login() {
        _login = (0, $7hBys._)(function(username, password) {
            var loginInformation, ex, e, message, error;
            return (0, $ajhIL.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, $d426a3f2c6fbebd8$export$9aa0815bbb7f01f0).login(username, password, {})
                        ];
                    case 1:
                        loginInformation = _state.sent();
                        console.log("Login successful");
                        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
                            login: loginInformation,
                            selectedCustomerId: loginInformation.customerId,
                            error: null
                        }));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        ex = _state.sent();
                        e = ex;
                        console.log(e);
                        message = "";
                        if (e.code === 401) message = "Invalid credentials";
                        else if (e.code >= 500 && e.code < 600) message = "Internal server error";
                        else message = "Unrecognized error (code ".concat(e.code, ")");
                        error = {
                            message: message
                        };
                        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
                            login: null,
                            error: error
                        }));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _login.apply(this, arguments);
    }
    function logout() {
        return _logout.apply(this, arguments);
    }
    function _logout() {
        _logout = (0, $7hBys._)(function() {
            return (0, $ajhIL.__generator)(this, function(_state) {
                setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
                    login: null,
                    selectedCustomerId: undefined
                }));
                return [
                    2
                ];
            });
        });
        return _logout.apply(this, arguments);
    }
    var dataStartRef = (0, $17VE6.useRef)(null);
    function changeRangeWidth(rangeWidth) {
        console.log("Changing range to ", rangeWidth);
        setState((0, $bqLxK._)((0, $lwFY2._)({}, state), {
            rangeWidth: rangeWidth
        }));
    }
    function changeCustomer(customer) {
        console.info("Changing customer to", customer);
        setState(function(state) {
            return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                selectedCustomerId: customer.id
            });
        });
    }
    function onCustomerChanged(customerId) {
        console.info("Changing customer to", customerId);
        setState(function(state) {
            return (0, $bqLxK._)((0, $lwFY2._)({}, state), {
                selectedCustomerId: customerId
            });
        });
    }
    if (!state.login) return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $51f1e577e583f24c$export$21a94553ffa41578), {
        onSubmit: login,
        error: (_state_error = state.error) === null || _state_error === void 0 ? void 0 : _state_error.message
    });
    else {
        var customers = customersAsync.status === "fulfilled" ? customersAsync.data : [];
        var navigationItems = $e035fc650e643577$var$makeTopNavigation(customers, state.selectedCustomerId, onCustomerChanged);
        return /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)("div", {
            className: "app",
            children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)((0, $fed91b90a22b2b22$export$9ba4e89fdfa1fc54), {
                children: [
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $2aa0ce2ffd0dd16f$export$b8a61e5c71402559), {
                        items: navigationItems,
                        loginInformation: state.login
                    }),
                    /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsxs)((0, $00b7b35226fb1bf3$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $00b7b35226fb1bf3$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $683b65030ff82d62$export$69e659ab1e82910f), {
                                    role: "user",
                                    children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $4e91cb12bb296069$export$2e2bcd8739ae039), {
                                        onRangeSelected: changeRangeWidth,
                                        selectedCustomerId: state.selectedCustomerId,
                                        dataStartRef: dataStartRef,
                                        state: state
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $00b7b35226fb1bf3$export$e7b0ac011bb776c6), {
                                path: "/dashboard",
                                element: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $683b65030ff82d62$export$69e659ab1e82910f), {
                                    role: "user",
                                    children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $177a8208e5f52a24$export$2e2bcd8739ae039), {
                                        onRangeSelected: changeRangeWidth,
                                        onCustomerSelected: changeCustomer,
                                        customerId: state.selectedCustomerId,
                                        dataStartRef: dataStartRef,
                                        state: state
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $00b7b35226fb1bf3$export$e7b0ac011bb776c6), {
                                path: "/admin",
                                element: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $683b65030ff82d62$export$69e659ab1e82910f), {
                                    role: "admin",
                                    children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $8a9c826e4807238d$export$b25f57c16f88d7e0), {
                                        onRangeSelected: changeRangeWidth,
                                        customerId: state.selectedCustomerId,
                                        state: state
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $00b7b35226fb1bf3$export$e7b0ac011bb776c6), {
                                path: "/backoffice/*",
                                element: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $683b65030ff82d62$export$69e659ab1e82910f), {
                                    role: "backoffice",
                                    children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $d351e14f5518ea11$export$7926de67b19c0929), {
                                        customerId: state.selectedCustomerId
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $00b7b35226fb1bf3$export$e7b0ac011bb776c6), {
                                path: "/analysis",
                                element: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $683b65030ff82d62$export$69e659ab1e82910f), {
                                    role: "analyst",
                                    children: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $9ef14a9ba7c8350a$export$3999c93ac52694ba), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $00b7b35226fb1bf3$export$e7b0ac011bb776c6), {
                                path: "/logout",
                                element: /*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $e2b1ce6c051eec73$export$cad1a703886b4e3a), {
                                    onLogout: logout
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
};
var $e035fc650e643577$export$2e2bcd8739ae039 = $e035fc650e643577$var$App;


// This optional code is used to register a service worker.
// register() is not called by default.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.
// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA

var $kTBk6 = parcelRequire("kTBk6");
var $e433fa7aecce38e8$var$isLocalhost = Boolean(window.location.hostname === "localhost" || // [::1] is the IPv6 localhost address.
window.location.hostname === "[::1]" || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function $e433fa7aecce38e8$export$6503ec6e8aabbaf(config) {
    if ("serviceWorker" in navigator) {
        // The URL constructor is available in all browsers that support SW.
        var publicUrl = new URL($kTBk6.env.PUBLIC_URL, window.location.href);
        if (publicUrl.origin !== window.location.origin) // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        return;
        window.addEventListener("load", function() {
            var swUrl = "".concat(undefined, "/service-worker.js");
            if ($e433fa7aecce38e8$var$isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                $e433fa7aecce38e8$var$checkValidServiceWorker(swUrl, config);
                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(function() {
                    console.log("This web app is being served cache-first by a service worker. To learn more, visit https://bit.ly/CRA-PWA");
                });
            } else // Is not localhost. Just register service worker
            $e433fa7aecce38e8$var$registerValidSW(swUrl, config);
        });
    }
}
function $e433fa7aecce38e8$var$registerValidSW(swUrl, config) {
    navigator.serviceWorker.register(swUrl).then(function(registration) {
        registration.onupdatefound = function() {
            var installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = function() {
                if (installingWorker.state === "installed") {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the updated precached content has been fetched,
                        // but the previous service worker will still serve the older
                        // content until all client tabs are closed.
                        console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");
                        // Execute callback
                        if (config && config.onUpdate) config.onUpdate(registration);
                    } else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log("Content is cached for offline use.");
                        // Execute callback
                        if (config && config.onSuccess) config.onSuccess(registration);
                    }
                }
            };
        };
    }).catch(function(error) {
        console.error("Error during service worker registration:", error);
    });
}
function $e433fa7aecce38e8$var$checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl).then(function(response) {
        // Ensure service worker exists, and that we really are getting a JS file.
        var contentType = response.headers.get("content-type");
        if (response.status === 404 || contentType != null && contentType.indexOf("javascript") === -1) // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(function(registration) {
            registration.unregister().then(function() {
                window.location.reload();
            });
        });
        else // Service worker found. Proceed as normal.
        $e433fa7aecce38e8$var$registerValidSW(swUrl, config);
    }).catch(function() {
        console.log("No internet connection found. App is running in offline mode.");
    });
}
function $e433fa7aecce38e8$export$d07f55d4c15c0440() {
    if ("serviceWorker" in navigator) navigator.serviceWorker.ready.then(function(registration) {
        registration.unregister();
    });
}


console.log("Starting ".concat((0, (/*@__PURE__*/$parcel$interopDefault($87f43e692fc6da61$exports))).name, " version ").concat((0, (/*@__PURE__*/$parcel$interopDefault($87f43e692fc6da61$exports))).version));
(0, (/*@__PURE__*/$parcel$interopDefault($62qDs))).render(/*#__PURE__*/ (0, $2a471062978a40a2$exports.jsx)((0, $e035fc650e643577$export$2e2bcd8739ae039), {}), document.getElementById("root"));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
$e433fa7aecce38e8$export$d07f55d4c15c0440();

})();
//# sourceMappingURL=index.62fba4de.js.map
